webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/*!******************************!*\
  !*** ./src/helpers/index.js ***!
  \******************************/
/*! exports provided: StoreDefaultSchemaHelper, StoreDefaultMetafieldsHelper, FieldLiquidGenerateHeleper, FileDownloadHelper, FileUploadHelper, mapFields, pushMinRepeaterInstances, videoEmbedHelper, scrollTo, reformatRepeaterKeys, prepareSavePayload, generateUuid, requestAnimation, windowConfirm, confirmBrowserQuit, getSearchbarPlaceholder, focusElement, parseBooleanValue, logger, checkLocalStorage, isShopifyEmbedded, isShopifyContext, getSessionToken, isValidShopDomain, buildAdminAppUrl */
/*! exports used: FieldLiquidGenerateHeleper, FileDownloadHelper, FileUploadHelper, StoreDefaultMetafieldsHelper, StoreDefaultSchemaHelper, confirmBrowserQuit, focusElement, generateUuid, getSearchbarPlaceholder, getSessionToken, isShopifyEmbedded, logger, mapFields, parseBooleanValue, prepareSavePayload, pushMinRepeaterInstances, reformatRepeaterKeys, requestAnimation, scrollTo, videoEmbedHelper, windowConfirm */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_default_schema_helper__ = __webpack_require__(/*! ./store-default-schema-helper */ 502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_default_metafields_helper__ = __webpack_require__(/*! ./store-default-metafields-helper */ 503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_liquid_generate_helper__ = __webpack_require__(/*! ./field-liquid-generate-helper */ 504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__file_download_helper__ = __webpack_require__(/*! ./file-download-helper */ 505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__file_upload_helper__ = __webpack_require__(/*! ./file-upload-helper */ 506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__map_fields__ = __webpack_require__(/*! ./map-fields */ 507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__push_min_repeater_instances__ = __webpack_require__(/*! ./push-min-repeater-instances */ 508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_embed_helper__ = __webpack_require__(/*! ./video-embed-helper */ 509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_embed_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__video_embed_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scroll_to__ = __webpack_require__(/*! ./scroll-to */ 510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reformat_repeater_keys__ = __webpack_require__(/*! ./reformat-repeater-keys */ 511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prepare_save_payload__ = __webpack_require__(/*! ./prepare-save-payload */ 512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generate_uuid__ = __webpack_require__(/*! ./generate-uuid */ 513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__request_animation__ = __webpack_require__(/*! ./request-animation */ 514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__window_confirm__ = __webpack_require__(/*! ./window-confirm */ 515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__confirm_browser_quit__ = __webpack_require__(/*! ./confirm-browser-quit */ 516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__get_searchbar_placeholder__ = __webpack_require__(/*! ./get-searchbar-placeholder */ 517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__focus_element__ = __webpack_require__(/*! ./focus-element */ 518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__parse_boolean_value__ = __webpack_require__(/*! ./parse-boolean-value */ 519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__logger__ = __webpack_require__(/*! ./logger */ 125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__check_storage__ = __webpack_require__(/*! ./check-storage */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__is_shopify_embedded__ = __webpack_require__(/*! ./is-shopify-embedded */ 126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__session_token__ = __webpack_require__(/*! ./session-token */ 521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__admin_url__ = __webpack_require__(/*! ./admin-url */ 127);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__store_default_schema_helper__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__store_default_metafields_helper__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__field_liquid_generate_helper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__file_download_helper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__file_upload_helper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__map_fields__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__push_min_repeater_instances__["a"]; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_7__video_embed_helper___default.a; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__scroll_to__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__reformat_repeater_keys__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_10__prepare_save_payload__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__generate_uuid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_12__request_animation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_13__window_confirm__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_14__confirm_browser_quit__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_15__get_searchbar_placeholder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_16__focus_element__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_17__parse_boolean_value__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_18__logger__["a"]; });
/* unused harmony reexport checkLocalStorage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_20__is_shopify_embedded__["b"]; });
/* unused harmony reexport isShopifyContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_21__session_token__["a"]; });
/* unused harmony reexport isValidShopDomain */
/* unused harmony reexport buildAdminAppUrl */
/*
 * File: /src/helpers/index.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:03:43 pm
 * Last Modified: Tuesday, 14th August 2018 11:55:06 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


























/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/*!**********************************************************!*\
  !*** ./src/mixins/metafields-changed-detection.mixin.js ***!
  \**********************************************************/
/*! exports provided: forSingleMetafield, forMetafieldsContainer */
/*! exports used: forMetafieldsContainer, forSingleMetafield */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = forSingleMetafield;
/* harmony export (immutable) */ __webpack_exports__["a"] = forMetafieldsContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);



function compare(_ref) {
    var newVal = _ref.newVal,
        self = _ref.self;

    var changed = void 0;

    // CUSTOM OBJECT
    if (self.field.type === 'custom-object') {
        var convertValue = function convertValue(val) {
            if (Array.isArray(val)) {
                if (val.length && val[0].key) {
                    return val.map(function (item) {
                        return item.key;
                    });
                } else {
                    return val;
                }
            } else {
                return [];
            }
        };

        changed = !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(convertValue(newVal), convertValue(self.lastSavedValue));

        // RELATION
    } else if (self.field.type === 'relation') {
        if (self.field.subForm.relateTo === 'variant') {
            var _convertValue = function _convertValue(val) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isPlainObject"])(val)) {
                    val = val.variants;
                    if (val.length && val[0].id) {
                        return val.map(function (item) {
                            return item.id;
                        });
                    } else {
                        return val;
                    }
                } else {
                    return [];
                }
            };

            changed = !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(_convertValue(newVal), _convertValue(self.lastSavedValue));
        } else {
            var _convertValue2 = function _convertValue2(val) {
                if (Array.isArray(val)) {
                    if (val.length && val[0].handle) {
                        return val.map(function (item) {
                            return item.handle;
                        });
                    } else {
                        return val;
                    }
                } else {
                    return [];
                }
            };

            changed = !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(_convertValue2(newVal), _convertValue2(self.lastSavedValue));
        }

        // BOOLEAN
    } else if (self.field.type === 'boolean') {
        var _prev = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["n" /* parseBooleanValue */])(self.lastSavedValue);
        var _new = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["n" /* parseBooleanValue */])(newVal);

        if (_prev === _new) {
            changed = false;
        } else {
            changed = true;
        }

        // OTHERS
    } else {
        changed = newVal != self.lastSavedValue; // IMPORTRANT, I USE LOOSE INEQUALITY ( != ) ON PURPOSE!!
    }

    self.$emit('valueChanged', changed);
}

function forSingleMetafield(watchDeep) {
    return {
        props: {
            field: Object
        },

        data: function data() {
            return {
                lastSavedValue: null
            };
        },


        watch: {
            value: {
                handler: function handler(newVal) {
                    compare({ newVal: newVal, self: this });
                },

                deep: !!watchDeep
            }
        },

        methods: {
            setLastSavedValue: function setLastSavedValue(value) {
                this.lastSavedValue = value;
            },
            afterSaveHandler: function afterSaveHandler() {
                this.setLastSavedValue(this.value);
                this.$store.commit('unsavedChanges/RESET_STATE');
            }
        },

        created: function created() {
            this.setLastSavedValue(this.value);
            this.$eventBus.$on('AFTER_METAFIELDS_SUCCESS_SAVE', this.afterSaveHandler);
        },
        beforeDestroy: function beforeDestroy() {
            this.$eventBus.$off('AFTER_METAFIELDS_SUCCESS_SAVE', this.afterSaveHandler);
        }
    };
}

function forMetafieldsContainer() {
    return {
        props: {
            parentTheRepeater: Object,
            parentTheGroup: Object,
            groupTheRepeaterContainer: Object
        },

        methods: {
            findIfGroupChanged: function findIfGroupChanged(group) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(group._childChanges)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        var item = group._childChanges[key];
                        if (item) {
                            group.hasChanged = true;
                            break;
                        } else {
                            group.hasChanged = false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('\uD83D\uDD0B hasChanged - GROUP ' + (group.key, group.hasChanged), 'DEV');
            },
            setGroupChildChanged: function setGroupChildChanged(bool, child) {
                var group = this.groupTheRepeaterContainer || this.parentTheGroup;
                if (!group) return;
                if (!group._childChanges) {
                    group._childChanges = {};
                }

                group._childChanges[child.key] = bool;

                this.findIfGroupChanged(group);
            },
            setRepeaterChanged: function setRepeaterChanged(repeater) {
                if (repeater.repeaterChildrenChanged || repeater.repeaterReorganized) {
                    repeater.hasChanged = true;
                    this.setGroupChildChanged(true, repeater);
                } else {
                    repeater.hasChanged = false;
                    this.setGroupChildChanged(false, repeater);
                }

                this.$store.commit('unsavedChanges/REGISTER_CHANGE', {
                    key: repeater.key,
                    bool: repeater.hasChanged
                });

                Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('\uD83D\uDD0B hasChanged - REPEATER ' + (repeater.key, repeater.hasChanged), 'DEV');
            },
            setRepeaterChildrenChanged: function setRepeaterChildrenChanged(bool) {
                this.parentTheRepeater.repeaterChildrenChanged = bool;
                this.setRepeaterChanged(this.parentTheRepeater);
            },
            setRepeaterReorganized: function setRepeaterReorganized(bool, repeater) {
                repeater.repeaterReorganized = bool;
                this.setRepeaterChanged(repeater);
            },
            setFieldChanged: function setFieldChanged(bool, field) {
                field.hasChanged = bool;

                if (this.parentTheRepeater) {
                    if (!this.parentTheRepeater._childChanges) {
                        this.parentTheRepeater._childChanges = {};
                    }

                    this.parentTheRepeater._childChanges[field.key] = bool;

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Object.keys(this.parentTheRepeater._childChanges)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var key = _step2.value;

                            if (this.parentTheRepeater._childChanges[key]) {
                                this.setRepeaterChildrenChanged(true);
                                break;
                            } else {
                                this.setRepeaterChildrenChanged(false);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else {
                    this.setGroupChildChanged(bool, field);
                }

                this.$store.commit('unsavedChanges/REGISTER_CHANGE', {
                    key: field.key,
                    bool: field.hasChanged
                });

                Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('\uD83D\uDD0B hasChanged - FIELD ' + (field.key, field.hasChanged), 'DEV');
            }
        }
    };
}

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/*!********************************************!*\
  !*** ./src/models/modal-datasets.model.js ***!
  \********************************************/
/*! exports provided: MDSModalContainer, MDSModalConfirmDecisionModel, MDSModalEditFieldModel, MDSModalFieldCodeModel, MDSModalHintModel, MDSModalIframeModel, MDSModalNewCustomObjectModel, MDSModalNewFieldModel */
/*! exports used: MDSModalConfirmDecisionModel, MDSModalEditFieldModel, MDSModalFieldCodeModel, MDSModalHintModel, MDSModalIframeModel, MDSModalNewCustomObjectModel, MDSModalNewFieldModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MDSModalContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MDSModalConfirmDecisionModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MDSModalEditFieldModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MDSModalFieldCodeModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MDSModalHintModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MDSModalIframeModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MDSModalNewCustomObjectModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MDSModalNewFieldModel; });
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// MDS - acronym for Modal Data Set

var MDSModalContainer = function MDSModalContainer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$disableCloseEven = _ref.disableCloseEventsOnContainer,
        disableCloseEventsOnContainer = _ref$disableCloseEven === undefined ? false : _ref$disableCloseEven;

    _classCallCheck(this, MDSModalContainer);

    this.disableCloseEventsOnContainer = disableCloseEventsOnContainer;
};

var MDSModalConfirmDecisionModel = function (_MDSModalContainer) {
    _inherits(MDSModalConfirmDecisionModel, _MDSModalContainer);

    function MDSModalConfirmDecisionModel(props) {
        _classCallCheck(this, MDSModalConfirmDecisionModel);

        var confirmationHandler = props.confirmationHandler,
            _props$title = props.title,
            title = _props$title === undefined ? 'Are you sure?' : _props$title,
            _props$description = props.description,
            description = _props$description === undefined ? '' : _props$description,
            _props$btnTextCancel = props.btnTextCancel,
            btnTextCancel = _props$btnTextCancel === undefined ? 'Cancel' : _props$btnTextCancel,
            _props$btnTextConfirm = props.btnTextConfirm,
            btnTextConfirm = _props$btnTextConfirm === undefined ? 'Delete it' : _props$btnTextConfirm,
            _props$closeOnlyByCon = props.closeOnlyByConfirmButton,
            closeOnlyByConfirmButton = _props$closeOnlyByCon === undefined ? false : _props$closeOnlyByCon;

        var _this = _possibleConstructorReturn(this, (MDSModalConfirmDecisionModel.__proto__ || Object.getPrototypeOf(MDSModalConfirmDecisionModel)).call(this, {
            disableCloseEventsOnContainer: closeOnlyByConfirmButton
        }));

        _this.confirmationHandler = confirmationHandler;
        _this.title = title;
        _this.description = description;
        _this.btnTextCancel = btnTextCancel;
        _this.btnTextConfirm = btnTextConfirm;
        _this.closeOnlyByConfirmButton = closeOnlyByConfirmButton;
        return _this;
    }

    return MDSModalConfirmDecisionModel;
}(MDSModalContainer);

var MDSModalEditFieldModel = function (_MDSModalContainer2) {
    _inherits(MDSModalEditFieldModel, _MDSModalContainer2);

    function MDSModalEditFieldModel(props) {
        _classCallCheck(this, MDSModalEditFieldModel);

        var field = props.field,
            parent = props.parent,
            scope = props.scope,
            usedKeys = props.usedKeys;

        var _this2 = _possibleConstructorReturn(this, (MDSModalEditFieldModel.__proto__ || Object.getPrototypeOf(MDSModalEditFieldModel)).call(this));

        _this2.field = field;
        _this2.parent = parent;
        _this2.scope = scope;
        _this2.usedKeys = usedKeys;
        return _this2;
    }

    return MDSModalEditFieldModel;
}(MDSModalContainer);

var MDSModalFieldCodeModel = function (_MDSModalContainer3) {
    _inherits(MDSModalFieldCodeModel, _MDSModalContainer3);

    function MDSModalFieldCodeModel(props) {
        _classCallCheck(this, MDSModalFieldCodeModel);

        var field = props.field,
            scope = props.scope;

        var _this3 = _possibleConstructorReturn(this, (MDSModalFieldCodeModel.__proto__ || Object.getPrototypeOf(MDSModalFieldCodeModel)).call(this));

        _this3.field = field;
        _this3.scope = scope;
        return _this3;
    }

    return MDSModalFieldCodeModel;
}(MDSModalContainer);

var MDSModalHintModel = function (_MDSModalContainer4) {
    _inherits(MDSModalHintModel, _MDSModalContainer4);

    function MDSModalHintModel(props) {
        _classCallCheck(this, MDSModalHintModel);

        var message = props.message;

        var _this4 = _possibleConstructorReturn(this, (MDSModalHintModel.__proto__ || Object.getPrototypeOf(MDSModalHintModel)).call(this));

        _this4.message = message;
        return _this4;
    }

    return MDSModalHintModel;
}(MDSModalContainer);

var MDSModalIframeModel = function (_MDSModalContainer5) {
    _inherits(MDSModalIframeModel, _MDSModalContainer5);

    function MDSModalIframeModel(props) {
        _classCallCheck(this, MDSModalIframeModel);

        var src = props.src;

        var _this5 = _possibleConstructorReturn(this, (MDSModalIframeModel.__proto__ || Object.getPrototypeOf(MDSModalIframeModel)).call(this));

        _this5.src = src;
        return _this5;
    }

    return MDSModalIframeModel;
}(MDSModalContainer);

var MDSModalNewCustomObjectModel = function (_MDSModalContainer6) {
    _inherits(MDSModalNewCustomObjectModel, _MDSModalContainer6);

    function MDSModalNewCustomObjectModel(props) {
        _classCallCheck(this, MDSModalNewCustomObjectModel);

        var _props$usedKeys = props.usedKeys,
            usedKeys = _props$usedKeys === undefined ? [] : _props$usedKeys;

        var _this6 = _possibleConstructorReturn(this, (MDSModalNewCustomObjectModel.__proto__ || Object.getPrototypeOf(MDSModalNewCustomObjectModel)).call(this));

        _this6.usedKeys = usedKeys;
        return _this6;
    }

    return MDSModalNewCustomObjectModel;
}(MDSModalContainer);

var MDSModalNewFieldModel = function (_MDSModalContainer7) {
    _inherits(MDSModalNewFieldModel, _MDSModalContainer7);

    function MDSModalNewFieldModel(props) {
        _classCallCheck(this, MDSModalNewFieldModel);

        var parent = props.parent,
            scope = props.scope,
            usedKeys = props.usedKeys;

        var _this7 = _possibleConstructorReturn(this, (MDSModalNewFieldModel.__proto__ || Object.getPrototypeOf(MDSModalNewFieldModel)).call(this));

        _this7.parent = parent;
        _this7.scope = scope;
        _this7.usedKeys = usedKeys;
        return _this7;
    }

    return MDSModalNewFieldModel;
}(MDSModalContainer);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/*!**************************************!*\
  !*** ./src/mixins/sub-form.mixin.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  props: {
    value: Object
  },
  watch: {
    'value': {
      handler: function handler(val) {
        if (val) {
          Object.assign(this.form, val);
        }
      },

      immediate: true
    },
    'form': {
      handler: function handler(val) {
        this.$emit('input', val);
      },

      deep: true,
      immediate: true
    }
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/*!*****************************!*\
  !*** ./src/stores/index.js ***!
  \*****************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var modules = {};

// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 500);

requireComponent.keys().forEach(function (fileName) {
  var moduleConfig = requireComponent(fileName);

  // TODO: REMOVE CAMELCASE IT CONFUSES STORE NAMES
  var moduleName = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["camelCase"])(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'));

  modules = Object.assign({}, modules, _defineProperty({}, moduleName, moduleConfig.default || moduleConfig));
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: modules
}));

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/*!*******************************************!*\
  !*** ./src/components/base/BaseInput.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInput_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseInput.vue */ 352);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c624a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInput_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-75c624a6","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseInput.vue */ 838);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-75c624a6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseInput.vue */ 837)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c624a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/*!************************************!*\
  !*** ./src/components/Section.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Section_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Section.vue */ 261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f4f9be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Section_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-39f4f9be","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Section.vue */ 591);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-39f4f9be","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Section.vue */ 590)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Section_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f4f9be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/*!****************************************!*\
  !*** ./src/components/SectionInfo.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionInfo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionInfo.vue */ 262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f1d3e33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionInfo_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4f1d3e33","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionInfo.vue */ 593);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4f1d3e33","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SectionInfo.vue */ 592)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f1d3e33_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/*!*******************************************!*\
  !*** ./src/components/NewFieldButton.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NewFieldButton_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewFieldButton.vue */ 266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640627b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFieldButton_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-640627b8","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewFieldButton.vue */ 600);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-640627b8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewFieldButton.vue */ 599)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NewFieldButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640627b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFieldButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */,
/* 69 */
/*!********************************************!*\
  !*** ./src/components/forms/FormField.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormField_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FormField.vue */ 316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6086a7cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormField_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6086a7cd","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FormField.vue */ 774);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6086a7cd","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FormField.vue */ 735)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FormField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6086a7cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/*!**************************************!*\
  !*** ./src/helpers/check-storage.js ***!
  \**************************************/
/*! exports provided: checkLocalStorage, checkSessionStorage */
/*! exports used: checkLocalStorage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkLocalStorage;
/* unused harmony export checkSessionStorage */
function checkLocalStorage() {
    try {
        window.localStorage;
        return true;
    } catch (error) {
        return false;
    }
}

function checkSessionStorage() {
    try {
        window.sessionStorage;
        return true;
    } catch (error) {
        return false;
    }
}

/***/ }),
/* 95 */,
/* 96 */
/*!*******************************************!*\
  !*** ./src/components/RelationSetter.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RelationSetter_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RelationSetter.vue */ 274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1633b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelationSetter_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4a1633b2","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RelationSetter.vue */ 629);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4a1633b2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RelationSetter.vue */ 619)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RelationSetter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1633b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelationSetter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/*!******************************************!*\
  !*** ./src/models/popover-data.model.js ***!
  \******************************************/
/*! exports provided: PopoverDataModel */
/*! exports used: PopoverDataModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverDataModel; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopoverDataModel = function PopoverDataModel(props) {
    _classCallCheck(this, PopoverDataModel);

    var label = props.label,
        id = props.id,
        handle = props.handle,
        description = props.description;


    this.label = label;
    this.id = id;
    this.handle = handle;
    this.description = description;
};

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/*!********************************!*\
  !*** ./src/translations/en.js ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'UNSAVED_CHANGES_MESSAGE': 'Leave site? Changes that you made may not be saved.'
});

/***/ }),
/* 125 */
/*!*******************************!*\
  !*** ./src/helpers/logger.js ***!
  \*******************************/
/*! exports provided: logger */
/*! exports used: logger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_dev_env__ = __webpack_require__(/*! ./is-dev-env */ 520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__check_storage__ = __webpack_require__(/*! ./check-storage */ 94);



var showLogs = Object(__WEBPACK_IMPORTED_MODULE_1__check_storage__["a" /* checkLocalStorage */])() ? window.localStorage.getItem('af-show-logs') === 'true' : false;

function logger() {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_dev_env__["a" /* isDevEnv */])() || showLogs) {
        var _console;

        for (var _len = arguments.length, message = Array(_len), _key = 0; _key < _len; _key++) {
            message[_key] = arguments[_key];
        }

        (_console = console).log.apply(_console, ['📋 '].concat(message));
    }
}

/***/ }),
/* 126 */
/*!********************************************!*\
  !*** ./src/helpers/is-shopify-embedded.js ***!
  \********************************************/
/*! exports provided: isShopifyEmbedded, isShopifyContext, default */
/*! exports used: isShopifyContext, isShopifyEmbedded */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isShopifyEmbedded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isShopifyContext; });
/*
 * File: /src/helpers/is-shopify-embedded.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 21st October 2025
 * -
 * @description: Helper to detect if app is running embedded in Shopify Admin
 * Replaces @shopify/app-bridge-utils isShopifyEmbedded function
 */

/**
 * Check if the app is running inside Shopify Admin (embedded in an iframe)
 * @returns {boolean} True if embedded, false otherwise
 */
var isShopifyEmbedded = function isShopifyEmbedded() {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
        return false;
    }

    // App is embedded if it's running in an iframe (window.self !== window.top)
    try {
        return window.self !== window.top;
    } catch (e) {
        // If we get a security error accessing window.top, we're likely in an iframe
        return true;
    }
};

/**
 * Check whether the page was opened by Shopify, even without an iframe.
 * Shopify Mobile loads embedded apps in a top-level WebView, so
 * isShopifyEmbedded() is false there. Use this together with it.
 * @param {Object} query - The route query (`to.query`)
 * @returns {boolean} True if any Shopify context signal is present
 */
var isShopifyContext = function isShopifyContext(query) {
    var q = query || {};

    if (q.embedded === '1' || q.host) {
        return true;
    }

    if (typeof window === 'undefined') {
        return false;
    }

    var environment = window.shopify && window.shopify.environment;
    return !!(environment && (environment.embedded || environment.mobile));
};

/* unused harmony default export */ var _unused_webpack_default_export = (isShopifyEmbedded);

/***/ }),
/* 127 */
/*!**********************************!*\
  !*** ./src/helpers/admin-url.js ***!
  \**********************************/
/*! exports provided: isValidShopDomain, buildAdminAppUrl */
/*! exports used: buildAdminAppUrl, isValidShopDomain */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidShopDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildAdminAppUrl; });
var SHOP_DOMAIN_REGEX = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;

var STRIPPED_QUERY_KEYS = ['shop', 'host', 'embedded', 'hmac', 'id_token', 'session', 'timestamp', 'locale'];

var isValidShopDomain = function isValidShopDomain(shop) {
    return typeof shop === 'string' && SHOP_DOMAIN_REGEX.test(shop);
};

var buildAdminAppUrl = function buildAdminAppUrl(_ref) {
    var shop = _ref.shop,
        apiKey = _ref.apiKey,
        path = _ref.path,
        query = _ref.query;

    var params = Object.keys(query || {}).filter(function (key) {
        return !STRIPPED_QUERY_KEYS.includes(key);
    }).reduce(function (acc, key) {
        var values = Array.isArray(query[key]) ? query[key] : [query[key]];

        values.forEach(function (value) {
            if (value === null || value === undefined) {
                acc.push(encodeURIComponent(key));
            } else {
                acc.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            }
        });

        return acc;
    }, []).join('&');

    var base = 'https://' + shop + '/admin/apps/' + apiKey + (path === '/' ? '' : path || '');

    return params ? base + '?' + params : base;
};

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/error.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 257 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/install/install-payment.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        inIframe: function inIframe() {
            try {
                return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* isShopifyEmbedded */])();
            } catch (e) {
                return true;
            }
        }
    },
    mounted: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _this = this;

            var redirectInt, _ref2, confirmation_url;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            redirectInt = void 0;
                            _context.prev = 1;
                            _context.next = 4;
                            return this.$store.dispatch('shop/CHARGE_CREATE');

                        case 4:
                            _ref2 = _context.sent;
                            confirmation_url = _ref2.confirmation_url;


                            if (this.inIframe()) {
                                redirectInt = setInterval(function () {
                                    var ready = _this.$store.getters['shopifyBar/ready'];

                                    if (ready && window.shopify) {
                                        clearInterval(redirectInt);
                                        Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('window.open confirmation_url', { confirmation_url: confirmation_url });
                                        // For payment/OAuth redirects in embedded apps
                                        // window.top.location.href fails due to cross-origin security restrictions
                                        // Use window.open with _top to navigate the parent window
                                        window.open(confirmation_url, '_top');
                                    }
                                }, 2000);
                            } else {
                                Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('window.location = confirmation_url', { confirmation_url: confirmation_url });
                                window.location = confirmation_url;
                            }
                            _context.next = 14;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            console.error('Couldn\'t get payment redirect url', _context.t0);
                            clearInterval(redirectInt);
                            this.$router.push({ name: 'error' });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9]]);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 258 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/install/install-payment-confirm.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    mounted: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var _ref2, status;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return this.$store.dispatch('shop/CHARGE_CONFIRM', { chargeId: this.$route.query.charge_id });

                        case 3:
                            _ref2 = _context.sent;
                            status = _ref2.status;


                            if (status === 'active') {
                                this.$store.commit('modals/SET_MODAL_TO_FORCE', { modal: 'ModalTutorial' });
                                this.$router.push({ name: 'home' });
                            } else {
                                console.error('Payment declined');
                                this.$router.push({ name: 'install.payment.decline' });
                            }
                            _context.next = 12;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            console.error('Couldn\'t get payment redirect url', _context.t0);
                            this.$router.push({ name: 'error' });

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 259 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/install/install-payment-decline.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 16);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            status: 'default',
            contentData: {
                declined: {
                    title: "You've declined payment",
                    content: "Please notice that there's a 7 day trial where you won't be charged.<br/>Maybe it's a good idea to give us a try?<br/><br/>You can renew your payment bellow or uninstall app.",
                    allowRenew: true,
                    theme: 'danger'
                },
                pending: {
                    title: 'Payment is pending',
                    content: 'Your payment is pending, in a few cases it can take up to two days to fully verify payment. Please try again later.',
                    allowRenew: true,
                    theme: 'default'
                },
                expired: {
                    title: 'Payment was not accepted and is expired',
                    content: 'Payment was not accepted within 2 days. You can renew your payment or uninstall app.',
                    allowRenew: true,
                    theme: 'danger'
                },
                frozen: {
                    title: 'Payment is frozen',
                    content: 'Payment is on hold due to a shop subscription non-payment. The charge will re-activate once subscription payments resume.',
                    allowRenew: false,
                    theme: 'default'
                },
                cancelled: {
                    title: 'Payment is cancelled by us',
                    content: 'Please renew the payment or contact with us at support@airfields.io.',
                    allowRenew: true,
                    theme: 'default'
                },
                default: {
                    title: '',
                    content: '',
                    allowRenew: false
                }
            }
        };
    },

    computed: Object.assign({
        theme: function theme() {
            return this.contentData[this.status].theme;
        },
        title: function title() {
            return this.contentData[this.status].title;
        },
        content: function content() {
            return this.contentData[this.status].content;
        },
        allowRenew: function allowRenew() {
            return this.contentData[this.status].allowRenew;
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('shop', ['charge'])),
    methods: {
        onRenew: function onRenew() {
            this.$router.push({ name: 'install.payment' });
        }
    },
    mounted: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var status;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            try {
                                status = this.$store.getters['shop/charge'].status;

                                Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])(status, 'DEV');

                                this.status = status;
                            } catch (error) {
                                console.error('Couldn\'t get payment status', error);
                                this.$router.push({ name: 'error' });
                            }

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),
/* 260 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-home.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(/*! @/stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Section__ = __webpack_require__(/*! @/components/Section */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__ = __webpack_require__(/*! @/components/SectionInfo */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SectionCategories__ = __webpack_require__(/*! @/components/SectionCategories */ 263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SectionCustomObjectsGroups__ = __webpack_require__(/*! @/components/SectionCustomObjectsGroups */ 596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewFieldButton__ = __webpack_require__(/*! @/components/NewFieldButton */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_homepage__ = __webpack_require__(/*! @/data/homepage */ 601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Section: __WEBPACK_IMPORTED_MODULE_2__components_Section__["a" /* default */],
    SectionInfo: __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__["a" /* default */],
    SectionCategories: __WEBPACK_IMPORTED_MODULE_4__components_SectionCategories__["a" /* default */],
    SectionCustomObjectsGroups: __WEBPACK_IMPORTED_MODULE_5__components_SectionCustomObjectsGroups__["a" /* default */],
    NewFieldButton: __WEBPACK_IMPORTED_MODULE_6__components_NewFieldButton__["a" /* default */]
  },

  data: function data() {
    return {
      baseSections: __WEBPACK_IMPORTED_MODULE_9__data_homepage__["a" /* baseSections */],
      customObjSection: __WEBPACK_IMPORTED_MODULE_9__data_homepage__["b" /* customObjSection */],
      settingsSection: __WEBPACK_IMPORTED_MODULE_9__data_homepage__["c" /* settingsSection */]
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('shop', ['chargeDaysLeft', 'isPlanDev']), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('shopCustomobjectsgroupsList', ['customObjectsGroupsMapped'])),

  methods: {
    onAddNewObjectGroup: function onAddNewObjectGroup() {
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewCustomObjectGroup' });
    },
    exportGlobalSchema: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$store.dispatch('shopifyApi/SCHEMA_EXPORT');

              case 3:
                result = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function exportGlobalSchema() {
        return _ref.apply(this, arguments);
      }

      return exportGlobalSchema;
    }(),
    importGlobalSchema: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$store.commit('modals/OPEN_MODAL', { name: 'ModalImportWarning' });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function importGlobalSchema() {
        return _ref2.apply(this, arguments);
      }

      return importGlobalSchema;
    }(),
    showTutorialModal: function showTutorialModal() {
      var canOpen = !this.$store.getters['modals/modals'].find(function (item) {
        return item.name === 'ModalIframe';
      });
      if (!canOpen) return;

      var props = new __WEBPACK_IMPORTED_MODULE_8__models_modal_datasets_model__["e" /* MDSModalIframeModel */]({
        src: 'https://www.airfields.io/tutorial'
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalIframe', props: props });
    }
  },

  beforeRouteEnter: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(to, from, next) {
      return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.prev = 1;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__stores__["default"].dispatch('shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS');

            case 4:
              next();
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](1);

              console.error('Couldn\'t resolve ' + to.name + ' beforeRouteEnter requests', { error: _context3.t0 });
              next({
                name: 'app.error',
                query: { type: 'API' }
              });

            case 11:

              next();
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t1 = _context3['catch'](0);

              console.error('Couldn\'t resolve index.vue/home beforeRouteEnter requests', { error: _context3.t1 });
              next({
                name: 'app.error',
                query: {
                  type: 'API'
                }
              });

            case 18:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 14], [1, 7]]);
    }));

    function beforeRouteEnter(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    }

    return beforeRouteEnter;
  }(),
  created: function created() {
    Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["l" /* logger */])('this.baseSections:', this.baseSections);

    if (this.isPlanDev) {
      this.$store.commit('banners/SHOW_BANNER', {
        title: 'Play around as much as you like while being on any development store.',
        message: "Explore every feature for free while being on a development store. Your 7-day trial will start once you install Airfields on a production store.",
        // buttonLabel: "Subscribe in Advance",
        status: "info"
      });
    } else if (this.chargeDaysLeft > 0) {
      this.$store.commit('banners/SHOW_BANNER', {
        title: 'You have ' + this.chargeDaysLeft + ' days left until your trial expires',
        message: "Thanks for giving us a try. We hope that Airfields has everything you need. If you have any outstanding questions contact us at support@airfields.io.",
        // buttonLabel: "Subscribe in Advance",
        status: "info"
      });
    }
  },
  mounted: function mounted() {
    var modalToForce = this.$store.getters['modals/forceModal'];
    if (modalToForce && modalToForce === 'ModalTutorial') {
      this.showTutorialModal();
      this.$store.commit('modals/SET_MODAL_TO_FORCE', { modal: null });
    }
    window.addEventListener('schema_import', this.importGlobalSchema, false);
    window.addEventListener('schema_export', this.exportGlobalSchema, false);
    window.addEventListener('show_tutorial', this.showTutorialModal, false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('schema_import', this.importGlobalSchema);
    window.removeEventListener('schema_export', this.exportGlobalSchema);
    window.removeEventListener('show_tutorial', this.showTutorialModal);
    this.$store.commit('banners/CLOSE_BANNER');
  }
});

/***/ }),
/* 261 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Section.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator']
});

/***/ }),
/* 262 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionInfo.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    text: String,
    linkUrl: String,
    linkLabel: {
      type: String,
      default: 'Learn&nbsp;more.'
    }
  }
});

/***/ }),
/* 263 */
/*!**********************************************!*\
  !*** ./src/components/SectionCategories.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCategories_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionCategories.vue */ 264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8c36e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCategories_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4a8c36e6","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionCategories.vue */ 595);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4a8c36e6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SectionCategories.vue */ 594)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8c36e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 264 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionCategories.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        categories: Array,
        listLayout: Boolean
    }
});

/***/ }),
/* 265 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionCustomObjectsGroups.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    categories: Array,
    listLayout: Boolean
  },

  methods: {
    onDelete: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('shopCustomobjectsgroupsList/REMOVE_CUSTOM_OBJECT_GROUP', { id: id });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDelete(_x) {
        return _ref.apply(this, arguments);
      }

      return onDelete;
    }(),
    openConfirmDeleteModal: function openConfirmDeleteModal(id) {
      var _this = this;

      var props = new __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        confirmationHandler: function confirmationHandler() {
          return _this.onDelete(id);
        }
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props: props });
    }
  }
});

/***/ }),
/* 266 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NewFieldButton.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: { default: 'Add a field' },
    titleStrong: String,
    data: Object,
    store: Object
  },
  methods: {
    parentLabel: function parentLabel() {
      return this.data ? this.data.label : null;
    }
  }
});

/***/ }),
/* 267 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/dummy-router-view.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 268 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-edit.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_metafields_edit_MetafieldsEditContainer__ = __webpack_require__(/*! @/components/metafields-edit/MetafieldsEditContainer */ 607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Section__ = __webpack_require__(/*! @/components/Section */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__ = __webpack_require__(/*! @/components/SectionInfo */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores__ = __webpack_require__(/*! @/stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Section: __WEBPACK_IMPORTED_MODULE_2__components_Section__["a" /* default */],
        SectionInfo: __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__["a" /* default */],
        MetafieldsEditContainer: __WEBPACK_IMPORTED_MODULE_1__components_metafields_edit_MetafieldsEditContainer__["a" /* default */]
    },

    data: function data() {
        return {
            store: this.$route.meta.store
        };
    },


    computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('unsavedChanges', ['areChangesUnsaved']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('shopifyApi', ['openedHTTPs']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('loaders', ['areMetafieldsSaving']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])('settingsIntegrations', ['integrations']), {
        upscribeMetafields: function upscribeMetafields() {
            return this.$store.getters['shopProductsIntegrationsUpscribe/metafields'];
        },
        metafields: function metafields() {
            return this.$store.getters[this.store + '/metafields'];
        },
        id: function id() {
            return this.$store.getters[this.store + '/id'];
        },
        scope: function scope() {
            return this.$store.getters[this.store + '/scope'];
        },
        item: function item() {
            return this.$store.getters[this.store + '/item'] || {};
        },
        showBackBtn: function showBackBtn() {
            return this.store === 'shopGlobalsEdit' || this.store === 'shopCustomobjectsEdit' || this.item['back_url'];
        }
    }),

    methods: {
        accordionsToOpen: function accordionsToOpen(el) {
            var arr = [];

            do {
                if (el.classList.length && el.classList.contains('js-base-accordion')) {
                    arr.push(el.__vue__._uid);
                }
                el = el.parentNode;
            } while (el.id !== 'js-metafields-ROOT');

            return arr;
        },
        scrollToInvaildForms: function scrollToInvaildForms() {
            var _this = this;

            var firstError = this.$validator.errors.items.length ? this.$validator.errors.items[0] : null;
            var elWithError = firstError ? document.getElementById(firstError.field) : null;

            if (!elWithError) {
                console.warn('elWithError not found', elWithError);
                return;
            }

            for (var i = 0; i < this.accordionsToOpen.length; i++) {
                var uid = this.accordionsToOpen[i];
                this.$eventBus.$emit('openBaseAccordion', uid);
            }

            this.$nextTick(function () {
                _this.$scrollTo(elWithError, 1000);
            });
        },
        showLoadingWarningBanner: function showLoadingWarningBanner(_ref) {
            var _this2 = this;

            var message = _ref.message;

            this.$store.commit('banners/CLOSE_BANNER');
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'warning',
                title: message
            });

            var unwatch = this.$watch('openedHTTPs', function (newVal) {
                if (newVal === 0) {
                    _this2.$store.commit('banners/CLOSE_BANNER');
                    unwatch();
                }
            });
        },
        sendMetafieldsRelatedRequests: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _this3 = this;

                var usedEndpoints, usedKeys, relationRequests, customObjRequests, _collectRelationRequest, _collectCustomObjRequest, _searchForRequests, relations, customObjs, i, rel, endpoint, payload, _i, obj, groupId, _payload;

                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                // TODO: 1. Add loading state for MetafieldEditRelation when relations are not fetched yet
                                // TODO: 2. Add empty message to MetafieldEditRelation when there are no items
                                usedEndpoints = [];
                                usedKeys = [];
                                relationRequests = [];
                                customObjRequests = [];

                                _collectRelationRequest = function _collectRelationRequest(_ref3) {
                                    var endpoint = _ref3.endpoint;

                                    if (endpoint === 'variant') {
                                        endpoint = 'product';
                                    }

                                    if (!usedEndpoints.includes(endpoint)) {
                                        _this3.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                            key: endpoint,
                                            bool: true
                                        });
                                        usedEndpoints.push(endpoint);
                                        relationRequests.push(_this3.$store.dispatch('shopifyApi/REQUEST', { endpoint: 'item/' + endpoint }));
                                    }
                                };

                                _collectCustomObjRequest = function _collectCustomObjRequest(_ref4) {
                                    var groupId = _ref4.groupId;

                                    if (!usedKeys.includes(groupId)) {
                                        _this3.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                            key: groupId,
                                            bool: true
                                        });
                                        usedKeys.push(groupId);
                                        customObjRequests.push(_this3.$store.dispatch('shopCustomobjectsList/GET_CUSTOM_OBJECTS', {
                                            groupId: groupId
                                        }));
                                    }
                                };

                                _searchForRequests = function _searchForRequests(fields) {
                                    for (var i = 0; i < fields.length; i++) {
                                        var item = fields[i];

                                        switch (item.type) {
                                            case 'relation':
                                                _collectRelationRequest({ endpoint: item.subForm.relateTo });
                                                break;

                                            case 'custom-object':
                                                _collectCustomObjRequest({ groupId: item.subForm.groupID });
                                                break;

                                            case 'repeater':
                                                _searchForRequests(item.schema);
                                                break;

                                            case 'group':
                                                _searchForRequests(item.children);
                                                break;

                                            default:
                                                break;
                                        }
                                    }
                                };

                                _searchForRequests(this.metafields);
                                _context3.next = 10;
                                return Promise.all(relationRequests.map(function () {
                                    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(request, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.prev = 0;
                                                        _context.next = 3;
                                                        return request;

                                                    case 3:
                                                        _context.t0 = _context.sent;
                                                        return _context.abrupt('return', {
                                                            result: _context.t0
                                                        });

                                                    case 7:
                                                        _context.prev = 7;
                                                        _context.t1 = _context['catch'](0);
                                                        return _context.abrupt('return', { error: _context.t1 });

                                                    case 10:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this3, [[0, 7]]);
                                    }));

                                    return function (_x, _x2) {
                                        return _ref5.apply(this, arguments);
                                    };
                                }()));

                            case 10:
                                relations = _context3.sent;
                                _context3.next = 13;
                                return Promise.all(customObjRequests.map(function () {
                                    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(request, i) {
                                        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                        _context2.prev = 0;
                                                        _context2.next = 3;
                                                        return request;

                                                    case 3:
                                                        _context2.t0 = _context2.sent;
                                                        return _context2.abrupt('return', {
                                                            result: _context2.t0
                                                        });

                                                    case 7:
                                                        _context2.prev = 7;
                                                        _context2.t1 = _context2['catch'](0);
                                                        return _context2.abrupt('return', { error: _context2.t1 });

                                                    case 10:
                                                        _context2.prev = 10;
                                                        return _context2.finish(10);

                                                    case 12:
                                                    case 'end':
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _callee2, _this3, [[0, 7, 10, 12]]);
                                    }));

                                    return function (_x3, _x4) {
                                        return _ref6.apply(this, arguments);
                                    };
                                }()));

                            case 13:
                                customObjs = _context3.sent;
                                i = 0;

                            case 15:
                                if (!(i < relations.length)) {
                                    _context3.next = 27;
                                    break;
                                }

                                rel = relations[i];
                                endpoint = usedEndpoints[i];

                                if (!(!rel || rel.error)) {
                                    _context3.next = 21;
                                    break;
                                }

                                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                    key: endpoint,
                                    bool: false
                                });
                                return _context3.abrupt('continue', 24);

                            case 21:
                                payload = {
                                    key: endpoint,
                                    data: rel.result.items
                                };

                                this.$store.commit('cacheMetafields/SET_RELATIONS', payload);
                                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                    key: endpoint,
                                    bool: false
                                });

                            case 24:
                                i++;
                                _context3.next = 15;
                                break;

                            case 27:
                                _i = 0;

                            case 28:
                                if (!(_i < customObjs.length)) {
                                    _context3.next = 40;
                                    break;
                                }

                                obj = customObjs[_i];
                                groupId = usedKeys[_i];

                                if (!(!obj || obj.error)) {
                                    _context3.next = 34;
                                    break;
                                }

                                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                    key: groupId,
                                    bool: false
                                });
                                return _context3.abrupt('continue', 37);

                            case 34:
                                _payload = {
                                    key: groupId,
                                    data: obj.result
                                };

                                this.$store.commit('cacheMetafields/SET_CUSTOM_OBJS', _payload);
                                this.$store.commit('cacheMetafields/SET_REQUEST_PENDING', {
                                    key: groupId,
                                    bool: false
                                });

                            case 37:
                                _i++;
                                _context3.next = 28;
                                break;

                            case 40:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function sendMetafieldsRelatedRequests() {
                return _ref2.apply(this, arguments);
            }

            return sendMetafieldsRelatedRequests;
        }(),
        saveEventHandlerWrapper: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.save({
                                    iterations: [{
                                        store: this.store,
                                        metafields: this.metafields
                                    }, {
                                        store: 'shopProductsIntegrationsUpscribe',
                                        metafields: this.upscribeMetafields
                                    }]
                                });

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function saveEventHandlerWrapper() {
                return _ref7.apply(this, arguments);
            }

            return saveEventHandlerWrapper;
        }(),
        save: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(options) {
                var defaultOptions, isValid, error, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref9, store, metafields, reformatted, splittedPayload, promises, i, payload, _ref10, _metafields;

                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                defaultOptions = {
                                    iterations: [{
                                        store: this.store,
                                        metafields: this.metafields
                                    }]
                                };

                                options = options || defaultOptions;

                                this.$store.commit('banners/CLOSE_BANNER'); // i.e. closes opened banner ('Fields saved') new banner may show after 30seconds

                                if (!this.areMetafieldsSaving) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return', this.showLoadingWarningBanner({
                                    message: 'Wait until saving process will be finished.'
                                }));

                            case 5:
                                if (!(this.openedHTTPs > 0)) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt('return', this.showLoadingWarningBanner({
                                    message: 'Wait for Airfields to be fully loaded.'
                                }));

                            case 7:

                                this.$store.commit('loaders/SET_METAFIELDS_SAVING', true);

                                _context5.next = 10;
                                return this.$validator.validateAll();

                            case 10:
                                isValid = _context5.sent;

                                if (isValid) {
                                    _context5.next = 17;
                                    break;
                                }

                                if (!this.$validator.errors.items.length) {
                                    _context5.next = 17;
                                    break;
                                }

                                this.$store.commit('banners/SHOW_BANNER', {
                                    status: 'warning',
                                    title: 'There is invalid data in the form. Please check the form again.'
                                });
                                this.scrollToInvaildForms();

                                this.$store.commit('loaders/SET_METAFIELDS_SAVING', false);
                                return _context5.abrupt('return');

                            case 17:
                                error = false;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context5.prev = 21;
                                _iterator = options.iterations[Symbol.iterator]();

                            case 23:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context5.next = 53;
                                    break;
                                }

                                _ref9 = _step.value;
                                store = _ref9.store, metafields = _ref9.metafields;

                                if (!(!metafields || !metafields.length)) {
                                    _context5.next = 28;
                                    break;
                                }

                                return _context5.abrupt('continue', 50);

                            case 28:
                                reformatted = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["q" /* reformatRepeaterKeys */])(metafields);
                                splittedPayload = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["o" /* prepareSavePayload */])(reformatted);

                                // If user changed nothing show success save banner :)

                                if (splittedPayload.length) {
                                    _context5.next = 34;
                                    break;
                                }

                                this.showSuccessSaveBanner();
                                this.$store.commit('loaders/SET_METAFIELDS_SAVING', false);
                                return _context5.abrupt('continue', 50);

                            case 34:
                                promises = [];

                                for (i = 0; i < splittedPayload.length; i++) {
                                    payload = splittedPayload[i];

                                    promises.push(this.$store.dispatch(store + '/SAVE_METAFIELDS', payload));
                                }

                                _context5.prev = 36;
                                _context5.next = 39;
                                return Promise.all(promises);

                            case 39:
                                _context5.next = 41;
                                return this.$store.dispatch(store + '/GET_METAFIELDS');

                            case 41:
                                _ref10 = _context5.sent;
                                _metafields = _ref10.metafields;

                                if (_metafields) {
                                    this.$store.commit(store + '/SET_METAFIELDS', {
                                        metafields: _metafields,
                                        isRefetch: true
                                    });
                                }
                                // After success save trigger reset of hasChanged flags and show success banner
                                this.$eventBus.$emit('AFTER_METAFIELDS_SUCCESS_SAVE');
                                _context5.next = 50;
                                break;

                            case 47:
                                _context5.prev = 47;
                                _context5.t0 = _context5['catch'](36);

                                error = true;

                            case 50:
                                _iteratorNormalCompletion = true;
                                _context5.next = 23;
                                break;

                            case 53:
                                _context5.next = 59;
                                break;

                            case 55:
                                _context5.prev = 55;
                                _context5.t1 = _context5['catch'](21);
                                _didIteratorError = true;
                                _iteratorError = _context5.t1;

                            case 59:
                                _context5.prev = 59;
                                _context5.prev = 60;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 62:
                                _context5.prev = 62;

                                if (!_didIteratorError) {
                                    _context5.next = 65;
                                    break;
                                }

                                throw _iteratorError;

                            case 65:
                                return _context5.finish(62);

                            case 66:
                                return _context5.finish(59);

                            case 67:

                                if (error) {
                                    this.$store.commit('banners/SHOW_BANNER', {
                                        status: 'warning',
                                        title: 'Save failed.',
                                        message: 'There was a problem with connection.</br>Please try again.'
                                    });
                                } else {
                                    this.showSuccessSaveBanner();
                                }

                                this.$store.commit('loaders/SET_METAFIELDS_SAVING', false);

                            case 69:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[21, 55, 59, 67], [36, 47], [60,, 62, 66]]);
            }));

            function save(_x5) {
                return _ref8.apply(this, arguments);
            }

            return save;
        }(),
        backToItem: function backToItem() {
            if (this.store === 'shopGlobalsEdit') {
                this.$router.push('/');
            } else if (this.store === 'shopCustomobjectsEdit') {
                this.$router.push('/customobjects/manage?id=' + this.$route.query.id);
            } else {
                if (!window.shopify) {
                    return console.error('window.shopify is not available');
                }
                // Use new App Bridge navigation API
                // Migration guide line 488: Redirect.Action.APP -> shopify.navigation.navigate()
                window.shopify.navigation.navigate('/admin' + this.item['back_url']);
            }
        },
        showSuccessSaveBanner: function showSuccessSaveBanner() {
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'success',
                title: 'Fields saved.'
            });
        }
    },

    watch: {
        areChangesUnsaved: function areChangesUnsaved(val) {
            if (val) {
                Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["f" /* confirmBrowserQuit */])(this.$translations['UNSAVED_CHANGES_MESSAGE']);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["f" /* confirmBrowserQuit */])('', true);
            }
        }
    },

    beforeRouteEnter: function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(to, from, next) {
            var shop, missingId, pagesToRedirect, stores, integrations, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, store, _ref12, metafields;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            /*
                                Shopify bug workaround: redirect to the resource selector if there is no id.
                                Shopify randomly deletes id from the url.
                            */
                            shop = to.query.shop;
                            missingId = to.query.id === undefined;
                            pagesToRedirect = ['/products/edit', '/collections/edit', '/variants/edit', '/pages/edit', '/blogs/edit', '/articles/edit'];

                            if (!(missingId && pagesToRedirect.includes(to.path))) {
                                _context6.next = 7;
                                break;
                            }

                            Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["l" /* logger */])('confirmation_url: ', {
                                path: '/select-resource',
                                query: { shop: shop, redirect: to.path }
                            });
                            next({ path: '/select-resource', query: { shop: shop, redirect: to.path } });
                            return _context6.abrupt('return');

                        case 7:
                            _context6.prev = 7;
                            stores = [to.meta.store];

                            if (!to.meta.integrations) {
                                _context6.next = 14;
                                break;
                            }

                            _context6.next = 12;
                            return __WEBPACK_IMPORTED_MODULE_4__stores__["default"].dispatch('settingsIntegrations/GET_SETTINGS');

                        case 12:
                            integrations = __WEBPACK_IMPORTED_MODULE_4__stores__["default"].getters['settingsIntegrations/integrations'];

                            if (integrations && integrations.upscribe.settings.enabled === 'true') {
                                stores.push('shopProductsIntegrationsUpscribe');
                            }

                        case 14:
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context6.prev = 17;
                            _iterator2 = stores[Symbol.iterator]();

                        case 19:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context6.next = 31;
                                break;
                            }

                            store = _step2.value;

                            if (to.query.id) {
                                __WEBPACK_IMPORTED_MODULE_4__stores__["default"].commit(store + '/SET_ID', { id: to.query.id });
                            }

                            if (to.query.key) {
                                __WEBPACK_IMPORTED_MODULE_4__stores__["default"].commit(store + '/SET_KEY', { key: to.query.key });
                            }

                            _context6.next = 25;
                            return __WEBPACK_IMPORTED_MODULE_4__stores__["default"].dispatch(store + '/GET_METAFIELDS');

                        case 25:
                            _ref12 = _context6.sent;
                            metafields = _ref12.metafields;


                            if (metafields) {
                                __WEBPACK_IMPORTED_MODULE_4__stores__["default"].commit(store + '/SET_METAFIELDS', { metafields: metafields });
                            }

                        case 28:
                            _iteratorNormalCompletion2 = true;
                            _context6.next = 19;
                            break;

                        case 31:
                            _context6.next = 37;
                            break;

                        case 33:
                            _context6.prev = 33;
                            _context6.t0 = _context6['catch'](17);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context6.t0;

                        case 37:
                            _context6.prev = 37;
                            _context6.prev = 38;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 40:
                            _context6.prev = 40;

                            if (!_didIteratorError2) {
                                _context6.next = 43;
                                break;
                            }

                            throw _iteratorError2;

                        case 43:
                            return _context6.finish(40);

                        case 44:
                            return _context6.finish(37);

                        case 45:
                            _context6.next = 51;
                            break;

                        case 47:
                            _context6.prev = 47;
                            _context6.t1 = _context6['catch'](7);

                            console.error('Couldn\'t resolve ' + to.name + ' beforeRouteEnter requests', { error: _context6.t1 });
                            next({
                                name: 'app.error',
                                query: { type: 'API' }
                            });

                        case 51:
                            if (!(to.name !== 'globals.edit')) {
                                _context6.next = 54;
                                break;
                            }

                            _context6.next = 54;
                            return __WEBPACK_IMPORTED_MODULE_4__stores__["default"].dispatch(to.meta.store + '/GET_ITEM', {
                                id: to.query.id,
                                collectionType: to.query.type
                            });

                        case 54:

                            next();

                        case 55:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[7, 47], [17, 33, 37, 45], [38,, 40, 44]]);
        }));

        function beforeRouteEnter(_x6, _x7, _x8) {
            return _ref11.apply(this, arguments);
        }

        return beforeRouteEnter;
    }(),
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var _this4 = this;

        var _next = function _next() {
            _this4.$store.commit('unsavedChanges/RESET_STATE');
            next();
        };
        var _stay = function _stay() {
            next(false);
        };

        if (this.areChangesUnsaved) {
            var answer = Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["u" /* windowConfirm */])(this.$translations['UNSAVED_CHANGES_MESSAGE']);

            if (answer) {
                _next();
            } else {
                _stay();
            }
        } else {
            _next();
        }
    },
    created: function created() {
        this.sendMetafieldsRelatedRequests();
        window.addEventListener('save', this.saveEventHandlerWrapper, false);

        if (!this.metafields.length) {
            this.$store.commit('banners/SHOW_BANNER', {
                status: 'warning',
                title: 'There are no Airfields yet.',
                message: 'Please add Airfields to ' + this.scope + ' first to be able to edit this item.'
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('save', this.saveEventHandlerWrapper);
        this.$store.commit('banners/CLOSE_BANNER');
    }
});

/***/ }),
/* 269 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/MetafieldsEditContainer.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metafields__ = __webpack_require__(/*! ./metafields */ 270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NewFieldButton__ = __webpack_require__(/*! @/components/NewFieldButton */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_draggable_nested_tree__ = __webpack_require__(/*! vue-draggable-nested-tree */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_forms_field_types__ = __webpack_require__(/*! @/components/forms/field-types */ 299);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  name: 'MetafieldsEditContainer',
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__mixins_metafields_changed_detection_mixin__["a" /* forMetafieldsContainer */])()],
  components: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__metafields__["a" /* default */], {
    NewFieldButton: __WEBPACK_IMPORTED_MODULE_1__components_NewFieldButton__["a" /* default */],
    DraggableTree: __WEBPACK_IMPORTED_MODULE_2_vue_draggable_nested_tree__["a" /* DraggableTree */]
  }),
  props: {
    root: { type: Boolean, default: true },
    metafields: {
      type: Array,
      required: true
    },
    loading: Boolean
  },
  data: function data() {
    return {
      blockDrop: false,
      dragging: false
    };
  },

  computed: {
    className: function className() {
      return {
        'metafields-edit-container--drop-blocked': this.blockDrop,
        'metafields-edit-container--dragging': this.dragging,
        'metafields-edit-container--loading': this.loading
      };
    }
  },
  methods: {
    generateWarning: function generateWarning(field) {
      if (field.type === 'repeater' && !field.schema.length) {
        return 'Repeater has no fields.';
      } else if (field.type === 'group' && !field.children.length) {
        return 'Group is empty.';
      }
    },
    rootID: function rootID() {
      return this.root ? 'js-metafields-ROOT' : '';
    },
    dragHandler: function dragHandler(nodeVm) {
      return nodeVm.$el.firstChild.querySelector('.js-drag-handle');
    },
    draggableRulesTest: function draggableRulesTest(_ref) {
      var draggingField = _ref.draggingField,
          destinationNode = _ref.destinationNode,
          trueCallback = _ref.trueCallback,
          falseCallback = _ref.falseCallback;


      if (!destinationNode.isRoot) {
        return falseCallback();
      } else if (trueCallback) {
        trueCallback();
      }

      return true;
    },
    onDragMoving: function onDragMoving() {
      var _this = this;

      var destinationNode = this.$refs.repeaterTree[0].dplh.parent;

      this.draggableRulesTest({
        destinationNode: destinationNode,
        trueCallback: function trueCallback() {
          _this.blockDrop = false;
        },
        falseCallback: function falseCallback() {
          _this.blockDrop = true;
        }
      });
    },
    onDragEnd: function onDragEnd() {
      this.dragging = false;
      var destinationNode = this.$refs.repeaterTree[0].dplh.parent;

      var test = this.draggableRulesTest({
        destinationNode: destinationNode,
        falseCallback: function falseCallback() {
          return false;
        }
      });

      return test;
    },
    basedOnMetafieldType: function basedOnMetafieldType(type) {
      return 'MetafieldEdit' + Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["camelCase"])(type));
    },
    repeaterLabelByField: function repeaterLabelByField(field, data) {
      var labelFieldKey = field.subForm.labelFieldKey;

      var output = { willBeLabeled: false, label: '' };

      if (labelFieldKey) {
        output.willBeLabeled = true;
        var labelField = data.find(function (item) {
          return labelFieldKey === item.key.substr(0, item.key.lastIndexOf('_'));
        });

        if (labelField && __WEBPACK_IMPORTED_MODULE_6__components_forms_field_types__["a" /* FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL */].includes(labelField.type)) {
          output.label = labelField.value ? String(labelField.value) : '';
        }
      }

      return output;
    },
    repeaterGroupName: function repeaterGroupName(field, i) {
      return (field.subForm.title || 'Item') + ' ' + i;
    },
    handleAddGroupRepeater: function handleAddGroupRepeater(repeater) {
      if (repeater.subForm.max != 0 && repeater.children.length == repeater.subForm.max) {
        var props = new __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__["d" /* MDSModalHintModel */]({
          message: 'You reached maximum repeater instances specified in your schema.'
        });

        this.$store.commit('modals/OPEN_MODAL', { name: 'ModalHint', props: props });

        return;
      }

      var _repeater = Object.assign({}, repeater);
      var _newGroup = [].concat(_toConsumableArray(_repeater.schema));

      _newGroup = _newGroup.map(function (item, i) {
        var _item = Object.assign({}, item);
        _item.key = _item.key + '_[i]' + '__' + repeater.children.length;

        return _item;
      });

      repeater.children.push(_newGroup);

      this.setRepeaterReorganized(true, repeater);
    },
    handleRemoveGroupRepeater: function handleRemoveGroupRepeater(_ref2) {
      var repeater = _ref2.repeater,
          groupIndex = _ref2.groupIndex;

      if (repeater.children.length == repeater.subForm.min) {
        console.warn('You reached MIN amount of instances specified in field management.');
        return;
      }

      var _children = repeater.children.slice();
      _children.splice(groupIndex, 1);

      repeater.children = _children;

      this.setRepeaterReorganized(true, repeater);
    },
    openConfirmDeleteModal: function openConfirmDeleteModal(e, _ref3) {
      var _this2 = this;

      var repeater = _ref3.repeater,
          groupIndex = _ref3.groupIndex;

      e.target.blur();
      e.target.parentNode.blur();

      var props = void 0,
          name = void 0;

      if (repeater.children.length == repeater.subForm.min) {
        props = new __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__["d" /* MDSModalHintModel */]({
          message: 'You reached minimum repeater instances specified in your schema.'
        });
        name = 'ModalHint';
      } else {
        props = new __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
          confirmationHandler: function confirmationHandler() {
            return _this2.handleRemoveGroupRepeater({ repeater: repeater, groupIndex: groupIndex });
          }
        });
        name = 'ModalConfirmDecision';
      }

      this.$store.commit('modals/OPEN_MODAL', { name: name, props: props });
    }
  }
});

/***/ }),
/* 270 */
/*!************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/index.js ***!
  \************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allComponents = {};

// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 609);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Strip the leading `'./` and extension from the filename
  var componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');

  allComponents = Object.assign({}, allComponents, _defineProperty({}, componentName, componentConfig.default || componentConfig));
});

/* harmony default export */ __webpack_exports__["a"] = (allComponents);

/***/ }),
/* 271 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditBoolean.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    value: [Boolean, String],
    field: Object,
    subFormData: Object,
    hint: String
  },
  computed: {
    valueParsed: function valueParsed() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["n" /* parseBooleanValue */])(this.value);
    }
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', String(val));
    }
  }
});

/***/ }),
/* 272 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditColor.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(/*! vue-color */ 615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  components: {
    ColorPicker: __WEBPACK_IMPORTED_MODULE_0_vue_color__["Chrome"]
  },
  props: {
    value: {
      type: String,
      default: '#000000'
    },
    field: Object,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val.hex);
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value || '#000000');
  }
});

/***/ }),
/* 273 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditCustomObject.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_RelationSetter__ = __webpack_require__(/*! @/components/RelationSetter */ 96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_3__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  components: {
    RelationSetter: __WEBPACK_IMPORTED_MODULE_0__components_RelationSetter__["a" /* default */]
  },
  props: {
    field: Object,
    value: { default: function _default() {
        return [];
      } },
    hint: String,
    subFormData: Object
  },
  data: function data() {
    return {
      loading: true,
      customObjects: null,
      groupKey: null
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('cacheMetafields', ['cachedCustomObjs', 'isRequestPending']), {
    showLoader: function showLoader() {
      return this.isRequestPending[this.groupKey] || this.loading;
    }
  }),
  watch: {
    cachedCustomObjs: {
      handler: function handler() {
        this.initData();
      },

      immediate: true,
      deep: true
    }
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val);
    },
    linkUrl: function linkUrl(item) {
      var item_id = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["last"])(item.key.split(this.groupKey));
      return '/customobjects/edit?key=' + item_id + '&id=' + this.subFormData.groupID;
    },
    initData: function initData() {
      var groupID = this.subFormData.groupID;


      if (this.cachedCustomObjs && this.cachedCustomObjs[groupID] && !this.customObjects) {
        var _cachedCustomObjs$gro = this.cachedCustomObjs[groupID],
            groupKey = _cachedCustomObjs$gro.groupKey,
            customObjects = _cachedCustomObjs$gro.customObjects;

        this.groupKey = groupKey;
        this.customObjects = customObjects;
        this.loading = false;
      }
    }
  }
});

/***/ }),
/* 274 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RelationSetter.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RelationListItem__ = __webpack_require__(/*! @/components/RelationListItem */ 275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LazyList__ = __webpack_require__(/*! @/components/LazyList */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_popover_data_model__ = __webpack_require__(/*! @/models/popover-data.model */ 97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(/*! vuedraggable */ 627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RelationListItem: __WEBPACK_IMPORTED_MODULE_1__components_RelationListItem__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,
    LazyList: __WEBPACK_IMPORTED_MODULE_2__components_LazyList__["a" /* default */]
  },

  props: {
    items: Array,
    value: Array,
    unselectedLabel: { type: String, default: 'Select similar products' },
    selectedLabel: { type: String, default: 'Selected products' },
    loading: Boolean,
    linkUrl: {
      type: [String, Function],
      default: '#'
    },
    key_uid: { type: String, default: 'key' },
    key_img: { type: String, default: 'featured_image' },
    key_label: { type: String, default: 'label' },
    key_img_second: { type: String, default: '' }
  },

  data: function data() {
    return {
      searchQuery: '',
      scrollAreaClassName: __WEBPACK_IMPORTED_MODULE_1__components_RelationListItem__["b" /* scrollAreaClassName */]
    };
  },


  computed: {
    className: function className() {
      return {
        'relation-setter--loading': this.loading
      };
    },
    isValueExists: function isValueExists() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.value, 'length');
    },
    isItemsExists: function isItemsExists() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.items, 'length');
    },
    itemsForSearch: function itemsForSearch() {
      if (Array.isArray(this.items)) {
        var res = [];
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          var str = (item.handle || '') + ' ' + (item.id || '') + ' ' + (item[this.key_label] || '') + ' ' + (item.description || '');
          res.push(str.toLowerCase());
        }
        return res;
      } else {
        return [];
      }
    },
    queriedItems: function queriedItems() {
      if (this.searchQuery) {
        var results = [];
        var query = this.searchQuery.toLowerCase().trim();
        var indexes = [];

        for (var i = 0; i < this.itemsForSearch.length; i++) {
          if (this.itemsForSearch[i].indexOf(query) > -1) {
            indexes.push(i);
          }
        }

        for (var _i = 0; _i < indexes.length; _i++) {
          var idx = indexes[_i];
          results.push(this.items[idx]);
        }

        return results;
      } else {
        return this.items || [];
      }
    },
    unselected: function unselected() {
      var _this = this;

      if (this.isValueExists) {
        var _value = [].concat(_toConsumableArray(this.value));

        return this.queriedItems.filter(function (a) {
          var findIndex = _this.value.findIndex(function (b) {
            return a[_this.key_uid] === b[_this.key_uid];
          });

          if (findIndex > -1) {
            // Remove finded item from _value for optimization
            _value.splice(findIndex, 1);
            return false;
          }

          return true;
        });
      } else {
        return this.queriedItems;
      }
    },
    placeholder: function placeholder() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["i" /* getSearchbarPlaceholder */])({ item: (this.items || [])[0] });
    },
    showNoItemsMsg: function showNoItemsMsg() {
      return !this.loading && (!this.unselected || !this.unselected.length);
    }
  },

  methods: {
    handleSelection: function handleSelection(el) {
      var payload = void 0;

      if (this.isValueExists) {
        payload = [].concat(_toConsumableArray(this.value), [el]);
      } else {
        payload = [el];
      }

      this.$emit('input', payload);
    },
    handleDeselection: function handleDeselection(el) {
      var _this2 = this;

      var payload = this.value.filter(function (item) {
        return item[_this2.key_uid] !== el[_this2.key_uid];
      });
      this.$emit('input', payload);
    },
    url: function url(item) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"])(this.linkUrl) ? this.linkUrl(item) : this.linkUrl;
    },
    convertValue: function convertValue() {
      var _this3 = this;

      // This function converts value from <Array of String/Numbers> to <Array of Objects>.
      if (!this.isValueExists || !this.isItemsExists) return;
      // Run only if value is array of strings
      if (_typeof(this.value[0]) === 'object') return;

      var filteredItems = this.items.filter(function (item) {
        return _this3.value.includes(item[_this3.key_uid]);
      });

      var payload = this.value.map(function (handle) {
        return filteredItems.find(function (item) {
          return item[_this3.key_uid] === handle;
        });
      }).filter(Boolean);

      this.$emit('input', payload);
    },
    getItemImage: function getItemImage(item) {
      if (item[this.key_img] && !this.key_img_second) {
        return item[this.key_img];
      } else if (item[this.key_img] && this.key_img_second) {
        return item[this.key_img][this.key_img_second];
      } else {
        return '';
      }
    },
    getPopoverData: function getPopoverData(item) {
      return new __WEBPACK_IMPORTED_MODULE_3__models_popover_data_model__["a" /* PopoverDataModel */]({
        label: item[this.key_label],
        id: item.id,
        handle: item.handle,
        description: item.description
      });
    }
  },

  watch: {
    value: {
      handler: function handler() {
        this.convertValue();
      },

      immediate: true
    },
    items: {
      handler: function handler() {
        this.convertValue();
      },

      immediate: true
    }
  }
});

/***/ }),
/* 275 */
/*!*********************************************!*\
  !*** ./src/components/RelationListItem.vue ***!
  \*********************************************/
/*! exports provided: default, scrollAreaClassName */
/*! exports used: default, scrollAreaClassName */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RelationListItem_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RelationListItem.vue */ 276);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RelationListItem_vue__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1e9246_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelationListItem_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ff1e9246","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RelationListItem.vue */ 624);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ff1e9246","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RelationListItem.vue */ 620)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_RelationListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff1e9246_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelationListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RelationListItem.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: scrollAreaClassName, default */
/*! exports used: default, scrollAreaClassName */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollAreaClassName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Popover__ = __webpack_require__(/*! @/components/Popover */ 621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_popover_data_model__ = __webpack_require__(/*! @/models/popover-data.model */ 97);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var scrollAreaClassName = 'js-relation-list-item-scroll-area';



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Popover: __WEBPACK_IMPORTED_MODULE_1__components_Popover__["a" /* default */]
    },

    props: {
        tag: { type: String, default: 'li' },
        label: String,
        image: [String, Object],
        popoverData: { type: __WEBPACK_IMPORTED_MODULE_2__models_popover_data_model__["a" /* PopoverDataModel */], required: true },
        showDragHandle: Boolean
    },

    data: function data() {
        return {
            isItemPopovered: false,
            isTriggerInFrame: true,
            scrollArea: null
        };
    },


    methods: {
        handleScroll: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["r" /* requestAnimation */])(function (e) {
            if (!this.isItemPopovered) return;
            this.positionPopover();
            this.observePopoverVisibility();
        }),
        addListeners: function addListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleScroll);
            this.scrollArea.addEventListener('scroll', this.handleScroll);
        },
        removeListeners: function removeListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleScroll);
            this.scrollArea.removeEventListener('scroll', this.handleScroll);
        },
        positionPopover: function positionPopover() {
            var popoverTrigger = this.$refs.popoverTrigger.$el;
            var item = this.$refs.listItem;
            var rect = popoverTrigger.getBoundingClientRect();
            var popoverEl = this.$refs.popover.$el;
            var offset = 10;
            item.style = "";
            Object.assign(popoverEl.style, {
                top: rect.top + rect.height + offset + 'px',
                left: rect.left + rect.width / 2 - popoverEl.offsetWidth / 2 + 'px',
                position: 'fixed'
            });
        },
        showPopover: function showPopover() {
            var _this = this;

            setTimeout(function () {
                _this.positionPopover();
                _this.addListeners();
                _this.isItemPopovered = true;
                _this.isTriggerInFrame = true;
            }, 0);
        },
        hidePopover: function hidePopover() {
            this.isItemPopovered = false;
            this.removeListeners();
        },
        observePopoverVisibility: function observePopoverVisibility() {
            var popoverTrigger = this.$refs.popoverTrigger.$el;
            var triggerRect = popoverTrigger.getBoundingClientRect();
            var frameRect = this.scrollArea.getBoundingClientRect();
            var offset = 0;
            var isTriggerOverFrame = triggerRect.bottom + offset < frameRect.top;
            var isTriggerBelowFrame = triggerRect.top + offset > frameRect.bottom;

            if (isTriggerOverFrame || isTriggerBelowFrame) {
                this.isTriggerInFrame = false;
            } else {
                this.isTriggerInFrame = true;
            }
        }
    },

    mounted: function mounted() {
        this.scrollArea = this.$refs.popoverTrigger.$el.closest('.' + scrollAreaClassName);
    },
    beforeDestroy: function beforeDestroy() {
        this.removeListeners();
    }
});

/***/ }),
/* 277 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Popover.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 278 */
/*!*************************************!*\
  !*** ./src/components/LazyList.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LazyList_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LazyList.vue */ 279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9209c10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LazyList_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c9209c10","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LazyList.vue */ 626);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c9209c10","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LazyList.vue */ 625)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LazyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9209c10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LazyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 279 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LazyList.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: Array,
    scrollTopKey: [String, Number]
  },

  data: function data() {
    return {
      renderedItemsNum: 10
    };
  },


  computed: {
    renderedItems: function renderedItems() {
      if (this.items && this.items.length) {
        return this.items.slice(0, this.renderedItemsNum);
      }

      return [];
    }
  },

  methods: {
    handleScroll: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["r" /* requestAnimation */])(function () {
      var allItemsRendered = this.renderedItemsNum >= this.items.length;

      if (allItemsRendered) return;

      var target = this.$el;

      if (target) {
        var scrollTop = target.scrollTop,
            scrollHeight = target.scrollHeight,
            offsetHeight = target.offsetHeight;

        var percentageScrolled = (scrollTop + offsetHeight) / scrollHeight;

        if (percentageScrolled > 0.8) {
          this.renderedItemsNum += 10;
        }
      }
    })
  },

  watch: {
    scrollTopKey: function scrollTopKey() {
      this.renderedItemsNum = 10;
      this.$el.scrollTop = 0;
    }
  }
});

/***/ }),
/* 280 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditDate.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(/*! vuejs-datepicker */ 633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(/*! moment */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */]
  },
  props: {
    value: [String, Number],
    subFormData: Object,
    field: Object,
    hint: String
  },
  data: function data() {
    return {
      form: {
        date: null,
        hour: null,
        minute: null,
        isAm: null
      },
      test: '',
      dateFormat: 'YYYY-MM-DD'
    };
  },


  computed: {
    formattedDate: function formattedDate() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.value);
    }
  },

  mounted: function mounted() {
    this.setFormToEdit(this.value);
  },


  methods: {
    setFormToEdit: function setFormToEdit(val) {
      var hoursFormat = this.subFormData.format12h ? 'h' : 'H';
      var _value = val ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(val)) : __WEBPACK_IMPORTED_MODULE_1_moment___default()();

      this.form = {
        date: _value.format(this.dateFormat),
        hour: this.subFormData.onlyDate ? 0 : _value.format(hoursFormat),
        minute: this.subFormData.onlyDate ? 0 : _value.format('m'),
        isAm: val && this.subFormData.format12h && val.includes('am')
      };
    },
    getDateAsString: function getDateAsString() {
      var am = '';
      if (this.subFormData.format12h) {
        am = this.form.isAm ? 'am' : 'pm';
      }

      if (this.subFormData.onlyDate) {
        return '' + this.form.date;
      }

      return this.form.date + ' ' + this.form.hour + ':' + this.form.minute + ' ' + am;
    },
    handleAm: function handleAm(val) {
      this.form.isAm = val;
      this.emit();
    },
    handleDate: function handleDate(val) {
      this.form.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(val).format(this.dateFormat), this.emit();
    },
    handleHours: function handleHours(val) {
      this.form.hour = val;
      this.emit();
    },
    handleMinutes: function handleMinutes(val) {
      this.form.minute = val;
      this.emit();
    },
    emit: function emit() {
      var _val = this.getDateAsString();
      this.$emit('input', '' + _val);
    }
  }
});

/***/ }),
/* 281 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditEmail.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 282 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditGroup.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupName: String,
    groupNameOnceRender: { type: Boolean, default: true },
    hint: String,
    warning: String
  },

  data: function data() {
    return {
      onceGroupName: ''
    };
  },


  computed: {
    renderedGroupName: function renderedGroupName() {
      return this.groupNameOnceRender ? this.onceGroupName : this.groupName;
    }
  },

  created: function created() {
    this.onceGroupName = this.groupName;
  }
});

/***/ }),
/* 283 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditHtml.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 284 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditImage.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],

  props: {
    field: Object,
    value: String,
    hint: String
  },

  computed: {
    scopeId: function scopeId() {
      return this.$store.getters[this.$route.meta.store + '/id'];
    }
  },

  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 285 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditInteger.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    subFormData: Object,
    value: [Number, String],
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? 0 : val);
    },
    validator: function validator() {
      return 'integer|min_value:' + +this.subFormData.min + '|max_value:' + (+this.subFormData.max || Infinity);
    }
  },
  created: function created() {
    if (this.value === null) {
      this.$emit('input', 0);
    }
  }
});

/***/ }),
/* 286 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditJson.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 287 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditLiquidTemplate.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {}
});

/***/ }),
/* 288 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditNumber.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: [String, Number],
    subFormData: Object,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    },
    validator: function validator() {
      return 'decimal|min_value:' + (+this.subFormData.min || -Infinity) + '|max_value:' + (+this.subFormData.max || Infinity);
    }
  }
});

/***/ }),
/* 289 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditPhone.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 290 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditRelation.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RelationSetter__ = __webpack_require__(/*! @/components/RelationSetter */ 96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductSearch__ = __webpack_require__(/*! @/components/ProductSearch */ 664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  components: {
    RelationSetter: __WEBPACK_IMPORTED_MODULE_1__components_RelationSetter__["a" /* default */],
    ProductSearch: __WEBPACK_IMPORTED_MODULE_2__components_ProductSearch__["a" /* default */]
  },
  props: {
    field: Object,
    value: { type: [Object, Array] },
    hint: String,
    subFormData: Object
  },
  data: function data() {
    return {
      selectedProduct: null,
      checkboxProducts: null,
      loading: true,
      relationProducts: null,
      groupKey: null,
      variantValue: {
        productId: null,
        productHandle: null,
        variants: null
      },
      endpoint: null
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('cacheMetafields', ['cachedRelations', 'isRequestPending']), {
    keyUid: function keyUid() {
      return this.isVariant ? 'id' : 'handle';
    },
    isVariant: function isVariant() {
      return this.subFormData.relateTo === 'variant';
    },
    mappedValue: function mappedValue() {
      if (this.isVariant) {
        return this.value ? this.value.variants : null;
      } else {
        return this.value;
      }
    },
    unselectedLabel: function unselectedLabel() {
      return 'Select ' + this.subFormData.relateTo + 's';
    },
    selectedLabel: function selectedLabel() {
      return 'Selected ' + this.subFormData.relateTo + 's';
    },
    showLoader: function showLoader() {
      return this.isRequestPending[this.endpoint] || this.loading;
    }
  }),
  watch: {
    cachedRelations: {
      handler: function handler() {
        this.prepareProducts();
      },

      deep: true
    }
  },
  methods: {
    handleRelationSet: function handleRelationSet(val) {
      if (!this.isVariant) {
        this.$emit('input', val);
      } else {
        this.variantValue.variants = val;
        this.$emit('input', this.variantValue);
      }
    },
    handleSelectProductForVariants: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(val, isInitLoad) {
        var _ref2, product;

        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.variantValue.productId = val;
                this.loading = true;
                _context.next = 4;
                return this.$store.dispatch('shopifyApi/REQUEST', {
                  endpoint: 'item/product/' + val + '/variants'
                });

              case 4:
                _ref2 = _context.sent;
                product = _ref2.product;

                this.loading = false;
                this.variantValue.productHandle = product.handle;
                this.relationProducts = product.variants;

                if (!isInitLoad) {
                  // Reset relation setter value after checking different product for variants
                  this.variantValue.variants = [];
                  this.$emit('input', this.variantValue);
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSelectProductForVariants(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleSelectProductForVariants;
    }(),
    prepareVariants: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.relationProducts || !this.relationProducts.length)) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 1;

                if (!this.isVariant) {
                  _context2.next = 7;
                  break;
                }

                if (!(this.value && this.value.productId)) {
                  _context2.next = 7;
                  break;
                }

                this.selectedProduct = this.value.productId;
                _context2.next = 7;
                return this.handleSelectProductForVariants(this.selectedProduct, true);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);

              case 12:
                _context2.prev = 12;

                this.loading = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9, 12, 15]]);
      }));

      function prepareVariants() {
        return _ref3.apply(this, arguments);
      }

      return prepareVariants;
    }(),
    prepareProducts: function prepareProducts() {
      if (this.cachedRelations && this.cachedRelations[this.endpoint]) {

        if (this.isVariant) {
          this.checkboxProducts = this.cachedRelations[this.endpoint];
        } else {
          this.relationProducts = this.cachedRelations[this.endpoint];
        }
        this.loading = false;
      }
    }
  },
  created: function created() {
    this.endpoint = this.isVariant ? 'product' : this.subFormData.relateTo;
    this.prepareProducts(); // immediate on watch doesnt worked.
    this.prepareVariants();
  }
});

/***/ }),
/* 291 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductSearch.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LazyList__ = __webpack_require__(/*! @/components/LazyList */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RelationListItem__ = __webpack_require__(/*! @/components/RelationListItem */ 275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_popover_data_model__ = __webpack_require__(/*! @/models/popover-data.model */ 97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RelationListItem: __WEBPACK_IMPORTED_MODULE_2__components_RelationListItem__["a" /* default */],
    LazyList: __WEBPACK_IMPORTED_MODULE_0__components_LazyList__["a" /* default */]
  },

  props: {
    items: Array,
    value: [String, Number],
    title: String,
    loading: Boolean,

    key_uid: { default: 'key' },
    key_img: { default: 'featured_image' },
    key_label: { default: 'label' },
    key_img_second: { default: null },
    key_value: { default: 'id' }
  },
  data: function data() {
    return {
      searchQuery: '',
      scrollAreaClassName: __WEBPACK_IMPORTED_MODULE_2__components_RelationListItem__["b" /* scrollAreaClassName */]
    };
  },

  computed: {
    className: function className() {
      return {
        'product-search--loading': this.loading
      };
    },
    itemsForSearch: function itemsForSearch() {
      if (Array.isArray(this.items)) {
        var res = [];
        for (var i = 0; i < this.items.length; i++) {
          var item = this.items[i];
          var str = (item.handle || '') + ' ' + (item.id || '') + ' ' + (item[this.key_label] || '') + ' ' + (item.description || '');
          res.push(str.toLowerCase());
        }
        return res;
      } else {
        return [];
      }
    },
    filteredItems: function filteredItems() {
      if (this.searchQuery) {
        var results = [];
        var query = this.searchQuery.toLowerCase().trim();
        var indexes = [];

        for (var i = 0; i < this.itemsForSearch.length; i++) {
          if (this.itemsForSearch[i].indexOf(query) > -1) {
            indexes.push(i);
          }
        }

        for (var _i = 0; _i < indexes.length; _i++) {
          var idx = indexes[_i];
          results.push(this.items[idx]);
        }

        return results;
      } else {
        return this.items || [];
      }
    },
    placeholder: function placeholder() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["i" /* getSearchbarPlaceholder */])({ item: (this.items || [])[0] });
    }
  },
  methods: {
    select: function select(item) {
      if (item[this.key_value] !== this.value) {
        this.$emit('input', item[this.key_value]);
      }
    },
    getItemImage: function getItemImage(item) {
      if (item[this.key_img] && !this.key_img_second) {
        return item[this.key_img];
      } else if (item[this.key_img] && this.key_img_second) {
        return item[this.key_img][this.key_img_second];
      } else {
        return '';
      }
    },
    getPopoverData: function getPopoverData(item) {
      return new __WEBPACK_IMPORTED_MODULE_3__models_popover_data_model__["a" /* PopoverDataModel */]({
        label: item[this.key_label],
        id: item.id,
        handle: item.handle,
        description: item.description
      });
    }
  }
});

/***/ }),
/* 292 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditRepeater.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    groupName: String,
    hint: String,
    warning: String
  }
});

/***/ }),
/* 293 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditSelection.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: [Array, String],
    subFormData: Object,
    hint: String
  },
  computed: {
    title: function title() {
      var map = {
        'checkboxes': '(checkbox)',
        'select-list': '(list)',
        'radioboxes': '(radiobox)'
      };

      return map[this.subFormData.display];
    },
    className: function className() {
      return {
        'metafield-edit-selection--horizontal-layout': !this.subFormData.verticalLayout
      };
    }
  },
  methods: {
    filterOutDeprecatedValues: function filterOutDeprecatedValues(val) {
      var _this = this;

      return val.filter(function (v) {
        return (_this.subFormData.options || []).some(function (o) {
          return o.value === v;
        });
      });
    },
    onInput: function onInput(val) {
      var emitValue = Array.isArray(val) ? this.filterOutDeprecatedValues(val) : val;
      this.$emit('input', emitValue);
    }
  }
});

/***/ }),
/* 294 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditText.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    },
    validator: function validator() {
      return 'min:' + this.subFormData.min + '|max:' + (+this.subFormData.max || Infinity);
    }
  }
});

/***/ }),
/* 295 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditTextarea.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    },
    validator: function validator() {
      return 'min:' + this.subFormData.min + '|max:' + (+this.subFormData.max || Infinity);
    }
  }
});

/***/ }),
/* 296 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditUrl.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 297 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditVideo.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  data: function data() {
    return {
      url: null,
      showInput: !this.value,
      embedPreviewCode: null,
      embedCode: null
    };
  },

  methods: {
    onInput: function onInput(val) {

      if (!val) {
        this.url = null;
        this.embedCode = null;
        this.embedPreviewCode = null;
        this.showInput = true;
        return this.$emit('input', this.embedCode);
      }

      this.url = val;
      this.embedCode = this.getEmbedCode();
      this.embedPreviewCode = this.getEmbedPreviewCode();
      this.$emit('input', this.embedCode);

      if (this.embedPreviewCode) {
        this.showInput = false;
      }
    },
    getEmbedPreviewCode: function getEmbedPreviewCode() {
      if (!this.embedCode) {
        return null;
      }

      var _codePreview = this.embedCode;
      _codePreview = _codePreview.replace('autoplay=true', 'autoplay=0');

      return _codePreview;
    },
    getEmbedCode: function getEmbedCode() {
      return __WEBPACK_IMPORTED_MODULE_0__helpers__["t" /* videoEmbedHelper */].getEmbedCode({
        link: this.url,
        params: {
          width: this.subFormData.width,
          height: this.subFormData.height,
          autoplay: this.subFormData.autoplay,
          allowFullScreen: this.subFormData.allowFullScreen
        }
      });
    }
  },

  mounted: function mounted() {
    if (this.value) {

      var _newValue = this.value;
      var iframeFullscreenParams = __WEBPACK_IMPORTED_MODULE_0__helpers__["t" /* videoEmbedHelper */].iframeFullscreenParams;

      // Update value according to this.subFormData.autoplay and this.subFormData.allowFullScreen

      _newValue = _newValue.replace(/autoplay=([^"]*)/, 'autoplay=' + this.subFormData.autoplay);

      if (this.subFormData.allowFullScreen) {
        if (!_newValue.includes(iframeFullscreenParams)) {
          var separator = '></iframe>';
          var strArr = _newValue.split(separator);
          _newValue = strArr[0] + ' ' + iframeFullscreenParams + separator;
        }
      } else {
        if (_newValue.includes(iframeFullscreenParams)) {
          _newValue = _newValue.replace(iframeFullscreenParams, '');
        }
      }

      this.embedCode = _newValue;
      this.$emit('input', this.embedCode);
      this.embedPreviewCode = this.getEmbedPreviewCode();
    }
  }
});

/***/ }),
/* 298 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/metafields-edit/metafields/MetafieldEditWysiwyg.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_metafields_changed_detection_mixin__["b" /* forSingleMetafield */])(true)],
  props: {
    field: Object,
    value: String,
    hint: String
  },
  methods: {
    onInput: function onInput(val) {
      this.$emit('input', val === '' ? null : val);
    }
  }
});

/***/ }),
/* 299 */
/*!*********************************************!*\
  !*** ./src/components/forms/field-types.js ***!
  \*********************************************/
/*! exports provided: FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL, SELECT_OPTIONS, TYPES_DATA */
/*! exports used: FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL, SELECT_OPTIONS, TYPES_DATA */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TYPES_DATA; });
var FIELD_TYPES_ALLOWED_FOR_REPEATER_LABEL = ['number', 'integer', 'text', 'textarea', 'email', 'phone', 'url', 'date', 'color'];

var SELECT_OPTIONS = [{
  label: 'Grouping',
  options: [{
    value: 'group',
    label: 'Group'
  },
  // {
  //   value: 'repeater',
  //   label: 'Repeater'
  // },
  {
    value: 'repeater_json',
    label: 'Repeater'
  }]
}, {
  label: 'Simple fields',
  options: [{
    value: 'number',
    label: 'Number'
  }, {
    value: 'integer',
    label: 'Integer'
  }, {
    value: 'boolean',
    label: 'Boolean'
  }, {
    value: 'text',
    label: 'Text'
  }, {
    value: 'textarea',
    label: 'TextArea'
  }, {
    value: 'selection',
    label: 'Selection'
  }]
}, {
  label: 'Advanced fields',
  options: [{
    value: 'email',
    label: 'Email'
  }, {
    value: 'phone',
    label: 'Phone'
  }, {
    value: 'url',
    label: 'URL'
  }, {
    value: 'date',
    label: 'Date'
  }, {
    value: 'color',
    label: 'Color'
  }, {
    value: 'wysiwyg',
    label: 'WYSIWYG'
  }, {
    value: 'relation',
    label: 'Relation'
  }]
}, {
  label: 'Code',
  options: [{
    value: 'html',
    label: 'HTML'
  }, {
    value: 'json',
    label: 'JSON'
  }]
}, {
  label: 'Media',
  options: [{
    value: 'image',
    label: 'Image'
  }, {
    value: 'video',
    label: 'Video (Vimeo, YT)'
  }]
}, {
  label: 'Other',
  options: [{
    value: 'custom-object',
    label: 'Custom Object'
  }]
}];

var TYPES_DATA = {
  boolean: {
    hint: 'Common use case would be an on / off switcher.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corrupti a, doloremque voluptatem necessitatibus molestias accusamus, natus ad veritatis explicabo dolor consequatur praesentium sit repellat, qui exercitationem tenetur voluptates? Quae, ullam!'
  },
  color: {
    hint: 'Shows a color picker widget.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique non fuga velit ea, officia, ullam illum incidunt architecto molestiae asperiores nobis? Nihil dicta voluptates qui velit vel iste consequuntur magnam.'
  },
  date: {
    hint: 'Shows a date picker widget.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit commodi a assumenda architecto necessitatibus. Iste nam molestias soluta perferendis placeat vitae veritatis facere. Quae vel deleniti, culpa ratione, sed deserunt!'
  },
  email: {
    hint: 'Accepts only correct email addresses.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ut, delectus alias voluptate ratione recusandae voluptatibus debitis culpa earum rem necessitatibus voluptas sequi eos, ab dicta. Ipsum voluptatibus dolore saepe fugit!'
  },
  group: {
    hint: 'Used for grouping other fields.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto, atque sint, beatae cumque excepturi asperiores molestias natus quaerat cupiditate quis omnis. Corporis, fugit! Exercitationem unde ab nesciunt. Iure explicabo, unde.'
  },
  html: {
    hint: 'Used to paste any HTML code.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium ex voluptatibus obcaecati, eligendi voluptate nostrum hic perspiciatis, optio velit, assumenda cum officia nam itaque quaerat. Aut sit laboriosam cum alias.'
  },
  image: {
    hint: 'Used to add extra images.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque qui libero itaque, quod at totam aspernatur repellat facilis mollitia, esse non? Impedit, pariatur accusamus. Dolorem accusamus doloremque, commodi nostrum natus!'
  },
  integer: {
    hint: 'Accepts only integers.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates, porro iste a, aut adipisci aliquid doloremque facere laudantium qui cupiditate quas consequuntur, dolorem saepe nisi velit ab mollitia nemo ipsa!'
  },
  liquidTemplate: {
    hint: 'Used to paste any Liquid code.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit perspiciatis placeat eius, dolore repudiandae a nesciunt, cupiditate corporis unde tempora sequi exercitationem ex odit ipsam nam eligendi eveniet dolor animi.'
  },
  number: {
    hint: 'Accepts any number.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatum facere numquam perspiciatis, asperiores adipisci praesentium accusantium, expedita exercitationem quas omnis cum reiciendis vitae laboriosam fuga ut. Non odio totam nostrum.'
  },
  phone: {
    hint: 'Accepts up to 16 digits, “-“, “+”, “(“ and “)”.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae dignissimos maxime sunt beatae sed labore cum voluptatum illo blanditiis, quaerat dicta culpa quo nulla ex recusandae provident eius ut earum.'
  },
  relation: {
    hint: '',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam nobis, cum veritatis incidunt quas adipisci et obcaecati quia quisquam voluptate similique nihil ut, fuga hic beatae recusandae velit accusamus doloribus?'
  },
  repeater: {
    hint: 'Used to create a set of fields dynamically while editing content.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi assumenda ratione cum omnis tenetur dignissimos laboriosam eveniet quod labore, ea, iste nisi molestiae, harum ipsum nostrum veniam asperiores ipsam deleniti?'
  },
  repeater_json: {
    hint: 'Used to create a set of fields dynamically while editing content.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi assumenda ratione cum omnis tenetur dignissimos laboriosam eveniet quod labore, ea, iste nisi molestiae, harum ipsum nostrum veniam asperiores ipsam deleniti?'
  },
  selection: {
    hint: 'Accepts only integers.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam perspiciatis delectus dolores modi illo velit esse odio quisquam eligendi corporis qui, earum cupiditate, amet cumque minus iure distinctio repellat sapiente.'
  },
  text: {
    hint: 'Regular Text input.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos, maiores magnam accusamus nam. Alias obcaecati natus culpa porro, quis fuga quos quisquam itaque autem laudantium architecto perspiciatis sapiente veniam et.'
  },
  textarea: {
    hint: 'Regular TextArea input.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae illo quas nostrum, voluptates unde libero. Quidem maiores, tempora aliquid ratione itaque totam nesciunt nobis illo ipsam eos ab quia laudantium?'
  },
  url: {
    hint: 'Accepts only correct URL links eg. https://airnauts.com',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus voluptatem laudantium iusto, consequatur error suscipit numquam praesentium neque! Deserunt voluptatibus saepe veritatis unde quasi sequi animi asperiores ut labore iste.'
  },
  video: {
    hint: 'Accepts only links from Vimeo.com or YouTube.com.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur quae veniam saepe, et nisi, iure reiciendis recusandae in nulla eligendi doloribus unde quas commodi possimus. Rem harum eaque rerum, minima.'
  },
  wysiwyg: {
    hint: 'Shows a TinyMCE editor.',
    help: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eius molestiae iusto saepe perferendis, corporis, unde iure quidem beatae minima doloremque debitis ipsam eligendi vitae quia natus repellendus facere dolores at.'
  }
};

/***/ }),
/* 300 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-manage.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(/*! @/stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_schema_change_detector__ = __webpack_require__(/*! @/plugins/schema-change-detector */ 301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SchemaTreeContainer__ = __webpack_require__(/*! @/components/SchemaTreeContainer */ 696);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SchemaTreeContainer: __WEBPACK_IMPORTED_MODULE_4__components_SchemaTreeContainer__["a" /* default */]
    },

    data: function data() {
        return {
            store: this.$route.meta.store,
            scope: this.$route.meta.scope,
            loading: false
        };
    },


    computed: {
        linkScope: function linkScope() {
            var _scope = void 0;

            switch (this.scope) {
                case 'shop':
                    _scope = null;
                    break;
                case 'variants':
                    _scope = 'products';
                    break;
                default:
                    _scope = this.scope;
            }

            return _scope;
        },

        schema: {
            get: function get() {
                return Object.assign({}, this.$store.getters[this.store + '/schema']);
            }
            // set (schema) {
            //     this.$store.commit(`${this.store}/SET_SCHEMA`, { schema })
            // }

        }
    },
    methods: {
        save: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$store.commit(this.store + '/MAP_AND_SET_SCHEMA', { schema: this.schema });
                                _context.prev = 1;

                                this.loading = true;
                                _context.next = 5;
                                return this.$store.dispatch(this.store + '/SAVE_SCHEMA');

                            case 5:

                                this.$store.commit('banners/SHOW_BANNER', {
                                    status: 'success',
                                    title: 'Fields saved.'
                                });
                                this.$eventBus.$emit('AFTER_SAVE_SCHEMA');
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                this.$store.commit('banners/SHOW_BANNER', {
                                    status: 'warning',
                                    title: 'Fields save failed.'
                                });

                            case 12:
                                _context.prev = 12;

                                this.loading = false;
                                return _context.finish(12);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 9, 12, 15]]);
            }));

            function save() {
                return _ref.apply(this, arguments);
            }

            return save;
        }(),
        handleWidnowEvent: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.save();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function handleWidnowEvent(_x) {
                return _ref2.apply(this, arguments);
            }

            return handleWidnowEvent;
        }(),
        linkAction: function linkAction() {
            if (!window.shopify) {
                return console.error('window.shopify is not available');
            }
            // Use new App Bridge navigation API
            // Migration guide line 488: Redirect.Action.APP -> shopify.navigation.navigate()
            window.shopify.navigation.navigate('/admin/' + this.linkScope);
        }
    },

    beforeRouteEnter: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(to, from, next) {
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;

                            if (to.query.id) {
                                __WEBPACK_IMPORTED_MODULE_1__stores__["default"].commit(to.meta.store + '/SET_ID', { id: to.query.id });
                            }
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_1__stores__["default"].dispatch(to.meta.store + '/GET_SCHEMA_METAFIELD');

                        case 4:
                            next();
                            _context3.next = 11;
                            break;

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](0);

                            console.error('Couldn\'t resolve ' + to.name + ' beforeRouteEnter requests', { error: _context3.t0 });
                            next({
                                name: 'app.error',
                                query: { type: 'API' }
                            });

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 7]]);
        }));

        function beforeRouteEnter(_x2, _x3, _x4) {
            return _ref3.apply(this, arguments);
        }

        return beforeRouteEnter;
    }(),
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var stay = function stay() {
            next(false);
        };

        if (new __WEBPACK_IMPORTED_MODULE_3__plugins_schema_change_detector__["a" /* default */]().areChangesUnsaved) {
            var answer = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["u" /* windowConfirm */])(this.$translations['UNSAVED_CHANGES_MESSAGE']);

            if (answer) {
                next();
            } else {
                stay();
            }
        } else {
            next();
        }
    },
    mounted: function mounted() {
        window.addEventListener('save', this.handleWidnowEvent, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('save', this.handleWidnowEvent);
        this.$store.commit('banners/CLOSE_BANNER');
    }
});

/***/ }),
/* 301 */
/*!***********************************************!*\
  !*** ./src/plugins/schema-change-detector.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaChangeDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_schema_field_model__ = __webpack_require__(/*! @/models/schema-field.model */ 302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations_en__ = __webpack_require__(/*! @/translations/en */ 124);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






// Singleton

var SchemaChangeDetector = function () {
    function SchemaChangeDetector() {
        _classCallCheck(this, SchemaChangeDetector);

        if (!!SchemaChangeDetector.instance) {
            return SchemaChangeDetector.instance;
        }

        SchemaChangeDetector.instance = this;

        this.lastSavedKeys = [];
        this.lastSavedFields = {};
        this.registeredChanges = {};

        return this;
    }

    _createClass(SchemaChangeDetector, [{
        key: 'registerChange',
        value: function registerChange(_ref) {
            var name = _ref.name,
                bool = _ref.bool;

            this.registeredChanges[name] = bool;
            Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* logger */])('\uD83D\uDD0B this.registeredChanges ' + this.registeredChanges, 'DEV');

            if (this.areChangesUnsaved) {
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* confirmBrowserQuit */])(__WEBPACK_IMPORTED_MODULE_3__translations_en__["a" /* default */]['UNSAVED_CHANGES_MESSAGE']);
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* confirmBrowserQuit */])('', true);
            }
        }
    }, {
        key: 'checkUsedKeys',
        value: function checkUsedKeys(newUsedKeys) {
            var hasChanged = false;

            if (newUsedKeys.length !== this.lastSavedKeys.length) {
                hasChanged = true;
            } else {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.lastSavedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;

                        if (newUsedKeys.indexOf(key) === -1) {
                            hasChanged = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            this.registerChange({ name: 'usedKeys', bool: hasChanged });

            Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* logger */])('\uD83D\uDD0B hasChanged - USED_KEYS ' + hasChanged, 'DEV');

            return hasChanged;
        }
    }, {
        key: 'checkFieldData',
        value: function checkFieldData(newData) {
            if (!(newData instanceof __WEBPACK_IMPORTED_MODULE_1__models_schema_field_model__["a" /* SchemaFieldModel */])) {
                return console.error('In file: schema-change-detector.js\nnewData is not instance of SchemaFieldModel');
            }

            var hasChanged = !Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"])(newData, this.lastSavedFields[newData.key]);

            this.registerChange({ name: newData.key, bool: hasChanged });

            Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* logger */])('\uD83D\uDD0B hasChanged - FIELD ' + newData.key + ' ' + hasChanged, 'DEV');
            return hasChanged;
        }
    }, {
        key: 'resetLastSavedFields',
        value: function resetLastSavedFields() {
            this.lastSavedFields = {};
        }
    }, {
        key: 'resetRegisteredChanges',
        value: function resetRegisteredChanges() {
            this.registeredChanges = {};
            Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* confirmBrowserQuit */])('', true);
        }
    }, {
        key: 'lastSavedUsedKeys',
        set: function set(keys) {
            this.lastSavedKeys = [].concat(_toConsumableArray(keys));
        }
    }, {
        key: 'lastSavedField',
        set: function set(field) {
            if (this.lastSavedFields.hasOwnProperty(field.key)) {
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* logger */])('🔋 BREAK setLastSavedFields', 'DEV');
                return;
            }

            Object.assign(this.lastSavedFields, _defineProperty({}, field.key, new __WEBPACK_IMPORTED_MODULE_1__models_schema_field_model__["a" /* SchemaFieldModel */](Object.assign({}, field, {
                subForm: Object.assign({}, field.subForm)
            }))));
        }
    }, {
        key: 'areChangesUnsaved',
        get: function get() {
            var result = false;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.values(this.registeredChanges)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var value = _step2.value;

                    if (value) {
                        result = true;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return result;
        }
    }]);

    return SchemaChangeDetector;
}();



/***/ }),
/* 302 */
/*!******************************************!*\
  !*** ./src/models/schema-field.model.js ***!
  \******************************************/
/*! exports provided: SchemaFieldModel */
/*! exports used: SchemaFieldModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaFieldModel; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchemaFieldModel = function SchemaFieldModel(props) {
    _classCallCheck(this, SchemaFieldModel);

    var key = props.key,
        label = props.label,
        description = props.description,
        type = props.type,
        subType = props.subType,
        subForm = props.subForm;


    this.key = key;
    this.label = label;
    this.description = description;
    this.type = type;
    this.subType = subType || null;
    this.subForm = subForm;
};

/***/ }),
/* 303 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SchemaTreeContainer.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_draggable_nested_tree__ = __webpack_require__(/*! vue-draggable-nested-tree */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyTree__ = __webpack_require__(/*! @/components/MyTree */ 698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Field__ = __webpack_require__(/*! @/components/Field */ 704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_schema_field_model__ = __webpack_require__(/*! @/models/schema-field.model */ 302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_schema_change_detector__ = __webpack_require__(/*! @/plugins/schema-change-detector */ 301);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Tree: __WEBPACK_IMPORTED_MODULE_0_vue_draggable_nested_tree__["a" /* DraggableTree */], Field: __WEBPACK_IMPORTED_MODULE_2__components_Field__["a" /* default */], MyTree: __WEBPACK_IMPORTED_MODULE_1__components_MyTree__["a" /* default */] },
  props: {
    value: Object,
    scope: String,
    customNamespace: String
  },
  data: function data() {
    return {
      dragging: false,
      blockDrop: false,
      changeDetector: new __WEBPACK_IMPORTED_MODULE_6__plugins_schema_change_detector__["a" /* default */]()
    };
  },

  computed: {
    className: function className() {
      return {
        'my-tree-container--dragging': this.dragging,
        'my-tree-container--drop-blocked': this.blockDrop
      };
    }
  },
  methods: {
    showToggleBtn: function showToggleBtn(data) {
      if (data.type !== 'repeater' && data.type !== 'group' && data.children.length === 1 && data.children[0].isDragPlaceHolder) {
        return false;
      } else {
        return data.children && data.children.length || data.type === 'repeater' || data.type === 'group';
      }
    },
    draggableRulesTest: function draggableRulesTest(_ref) {
      var draggingField = _ref.draggingField,
          destinationNode = _ref.destinationNode,
          trueCallback = _ref.trueCallback,
          falseCallback = _ref.falseCallback;

      if (destinationNode.parent && destinationNode.parent.type === 'repeater') {
        // console.warn("🎟 You can't nest repeater fields")
        return falseCallback();
      } else if (draggingField.parent.type === 'repeater' && destinationNode.type !== 'repeater') {
        // console.warn("🎟 You can't drag field out of repeater")
        return falseCallback();
      } else if (destinationNode.type === 'repeater' && draggingField.parent.type !== 'repeater') {
        // console.warn("🎟 You can't drag field into repeater children")
        return falseCallback();
      } else if (destinationNode.type === 'repeater' && draggingField.parent.type === 'repeater' && destinationNode._id !== draggingField.parent._id) {
        // console.warn("🎟 You can't move foreign repeater field below another repeater")
        return falseCallback();
      } else if (destinationNode.type !== 'group' && destinationNode.type !== 'repeater' && !destinationNode.isRoot) {
        // console.warn("🎟 You can nest only under group type")
        return falseCallback();
      } else if (draggingField.type === 'group' && destinationNode.type === 'group') {
        // console.warn("🎟 You can't nest groups")
        return falseCallback();
      } else if (trueCallback) {
        trueCallback();
      }

      return true;
    },
    dragHandler: function dragHandler(nodeVm) {
      return nodeVm.$el.firstChild.querySelector('.js-drag-handle');
    },
    onDragStart: function onDragStart(node, nodeVm, store, event) {
      this.dragging = true;
    },
    onDragMoving: function onDragMoving(node, nodeVm, store, event) {
      var _this = this;

      var draggingField = node;
      var destinationNode = this.$refs.myTree.dplh.parent;

      this.draggableRulesTest({
        draggingField: draggingField,
        destinationNode: destinationNode,
        trueCallback: function trueCallback() {
          _this.blockDrop = false;
        },
        falseCallback: function falseCallback() {
          _this.blockDrop = true;
        }
      });
    },
    onDragEnd: function onDragEnd(node, nodeVm, store, event) {
      this.dragging = false;

      var draggingField = node;
      var destinationNode = this.$refs.myTree.dplh.parent;

      var isDragPossible = this.draggableRulesTest({
        draggingField: draggingField,
        destinationNode: destinationNode,
        falseCallback: function falseCallback() {
          return false;
        }
      });

      if (isDragPossible) {
        this.changeDetector.registerChange({ name: 'TreeDragging', bool: true });
      }

      return isDragPossible;
    },
    ADD_FIELD: function ADD_FIELD(_ref2) {
      var field = _ref2.field,
          parent = _ref2.parent;


      // --> Check if key exists
      if (this.value.usedKeys.indexOf(field.key) > -1) {
        console.error('Key ' + field.key + ' already used');
        return;
      }

      // --> Add key to used keys
      this.value.usedKeys.push(field.key);

      // --> Add field to schema
      if (parent) {
        // -> Add children
        if (!parent.children) {
          parent.children = [];
        }

        parent.children.push(field);
      } else {
        // -> Add root
        this.value.fields.push(field);
      }

      this.value.fields = Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["m" /* mapFields */])(this.value.fields);
      this.changeDetector.checkUsedKeys(this.value.usedKeys);
    },
    PATCH_FIELD: function PATCH_FIELD(_ref3) {
      var editedField = _ref3.editedField,
          form = _ref3.form;

      var keyIndex = this.value.usedKeys.indexOf(editedField.key);
      this.value.usedKeys[keyIndex] = form.key;

      this.changeDetector.lastSavedField = editedField;

      var _newData = new __WEBPACK_IMPORTED_MODULE_5__models_schema_field_model__["a" /* SchemaFieldModel */](Object.assign({}, form, {
        subForm: Object.assign({}, form.subForm)
      }));
      // Check before Object.assign(editedField, form)
      this.changeDetector.checkFieldData(_newData);

      Object.assign(editedField, form);

      this.changeDetector.checkUsedKeys(this.value.usedKeys);
    },
    REMOVE_FIELD: function REMOVE_FIELD(_ref4) {
      var field = _ref4.field,
          parent = _ref4.parent;


      // --> Get indexes
      var fieldIndex = parent ? parent.children.indexOf(field) : this.value.fields.indexOf(field);

      // --> Remove field from schema
      if (parent) {
        // -> Remove children
        parent.children.splice(fieldIndex, 1);
      } else {
        // -> Remove root
        this.value.fields.splice(fieldIndex, 1);
      }

      // --> remove children keys froms schema
      if (field.children && field.children.length) {
        var childKeyIndex = void 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = field.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            childKeyIndex = this.value.usedKeys.indexOf(child.key);

            if (childKeyIndex > -1) {
              this.value.usedKeys.splice(childKeyIndex, 1);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      // --> remove key from used
      var keyIndex = this.value.usedKeys.indexOf(field.key);
      this.value.usedKeys.splice(keyIndex, 1);
      this.changeDetector.checkUsedKeys(this.value.usedKeys);
    },
    openConfirmDeleteModal: function openConfirmDeleteModal(payload) {
      var _this2 = this;

      var props = new __WEBPACK_IMPORTED_MODULE_4__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        confirmationHandler: function confirmationHandler() {
          return _this2.REMOVE_FIELD(payload);
        }
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props: props });
    },
    afterSaveHandler: function afterSaveHandler() {
      this.changeDetector.lastSavedUsedKeys = this.value.usedKeys;
      this.changeDetector.resetLastSavedFields();
      this.changeDetector.resetRegisteredChanges();
    }
  },
  created: function created() {
    this.$eventBus.$on('ADD_NEW_FIELD', this.ADD_FIELD);
    this.$eventBus.$on('ModalNewField/ADD_NEW_FIELD', this.ADD_FIELD);
    this.$eventBus.$on('ModalNewField/PATCH_FIELD', this.PATCH_FIELD);
    this.changeDetector.lastSavedUsedKeys = this.value.usedKeys;
    this.$eventBus.$on('AFTER_SAVE_SCHEMA', this.afterSaveHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('ADD_NEW_FIELD', this.ADD_FIELD);
    this.$eventBus.$off('ModalNewField/ADD_NEW_FIELD', this.ADD_FIELD);
    this.$eventBus.$off('ModalNewField/PATCH_FIELD', this.PATCH_FIELD);
    this.$eventBus.$off('AFTER_SAVE_SCHEMA', this.afterSaveHandler);
  }
});

/***/ }),
/* 304 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyTree.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_draggable_nested_tree__ = __webpack_require__(/*! vue-draggable-nested-tree */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyTreeNode_vue__ = __webpack_require__(/*! @/components/MyTreeNode.vue */ 700);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MyTreeNode: __WEBPACK_IMPORTED_MODULE_1__components_MyTreeNode_vue__["a" /* default */]
  },
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_draggable_nested_tree__["a" /* DraggableTree */],
  props: {
    scope: String,
    usedKeys: Array
  }
});

/***/ }),
/* 305 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MyTreeNode.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NewFieldButton__ = __webpack_require__(/*! @/components/NewFieldButton */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_draggable_nested_tree__ = __webpack_require__(/*! vue-draggable-nested-tree */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyTreeNode',
  components: {
    NewFieldButton: __WEBPACK_IMPORTED_MODULE_0__components_NewFieldButton__["a" /* default */]
  },
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_draggable_nested_tree__["b" /* DraggableTreeNode */],
  props: {
    indent: {
      type: Number,
      default: 0
    },
    scope: String,
    usedKeys: Array
  },
  computed: {
    childsVisible: function childsVisible() {
      var data = this.data;

      return data.children.length === 1 && data.children[0]._id === 'draggable_tree_drag_placeHolder' ? false : this.isRoot || data.children && data.children.length && data.open;
    },
    newFieldButtonVisible: function newFieldButtonVisible() {
      var data = this.data;

      return this.childsVisible || this.data.type === 'repeater' && data.open || this.data.type === 'group' && data.open;
    }
  },
  methods: {
    handleAddNewField: function handleAddNewField() {
      var props = new __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__["g" /* MDSModalNewFieldModel */]({
        parent: this.data,
        scope: this.scope,
        usedKeys: this.usedKeys
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewField', props: props });
    },
    newFieldButtonStyle: function newFieldButtonStyle() {
      var lvl = this.data.level;
      return {
        paddingLeft: lvl * this.indent + 'px'
      };
    }
  }
});

/***/ }),
/* 306 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Field.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isCollapsed: true
    };
  },

  props: {
    field: Object,
    scope: String,
    usedKeys: Array
  },
  computed: {
    hasChildrens: function hasChildrens() {
      return this.field.children.length;
    },
    showCodeIcon: function showCodeIcon() {
      return !(this.field.parent.type === 'repeater' || this.field.type === 'group' || this.scope === 'customobjectsgroups');
    }
  },
  methods: {
    toggleCollapse: function toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    onEdit: function onEdit() {
      var props = new __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__["b" /* MDSModalEditFieldModel */]({
        field: this.field,
        parent: this.field.parent,
        scope: this.scope,
        usedKeys: this.usedKeys
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalEditField', props: props });
    },
    onDelete: function onDelete() {
      this.$emit('onDelete', { field: this.field, parent: this.field.parent });
    },
    onShowCode: function onShowCode() {
      var props = new __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__["c" /* MDSModalFieldCodeModel */]({
        field: this.field,
        scope: this.scope
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalFieldCode', props: props });
    }
  }
});

/***/ }),
/* 307 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-manage-customobjects.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(/*! @/stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Section__ = __webpack_require__(/*! @/components/Section */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__ = __webpack_require__(/*! @/components/SectionInfo */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SectionCategories__ = __webpack_require__(/*! @/components/SectionCategories */ 263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SectionCustomObjects__ = __webpack_require__(/*! @/components/SectionCustomObjects */ 710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewFieldButton__ = __webpack_require__(/*! @/components/NewFieldButton */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Section: __WEBPACK_IMPORTED_MODULE_2__components_Section__["a" /* default */],
    SectionInfo: __WEBPACK_IMPORTED_MODULE_3__components_SectionInfo__["a" /* default */],
    SectionCategories: __WEBPACK_IMPORTED_MODULE_4__components_SectionCategories__["a" /* default */],
    SectionCustomObjects: __WEBPACK_IMPORTED_MODULE_5__components_SectionCustomObjects__["a" /* default */],
    NewFieldButton: __WEBPACK_IMPORTED_MODULE_6__components_NewFieldButton__["a" /* default */]
  },

  data: function data() {
    return {
      section: {
        info: {
          title: 'Custom objects',
          text: '',
          url: ''
        },
        listLayout: true
      }
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('shopCustomobjectsgroupsManage', ['customObjectsMapped', 'usedObjectsKeys'])),

  methods: {
    onAddNewObject: function onAddNewObject() {
      var props = new __WEBPACK_IMPORTED_MODULE_8__models_modal_datasets_model__["f" /* MDSModalNewCustomObjectModel */]({
        usedKeys: this.usedObjectsKeys
      });

      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewCustomObject', props: props });
    },
    backToHomepage: function backToHomepage() {
      this.$router.push('/');
    }
  },

  beforeRouteEnter: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var metafield;
      return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (to.query.id) {
                __WEBPACK_IMPORTED_MODULE_1__stores__["default"].commit('shopCustomobjectsgroupsManage/SET_ID', { id: to.query.id });
              }
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__stores__["default"].dispatch('shopCustomobjectsgroupsManage/GET_SCHEMA_METAFIELD');

            case 4:
              metafield = _context.sent;

              __WEBPACK_IMPORTED_MODULE_1__stores__["default"].commit('shopCustomobjectsgroupsManage/SET_CUSTOM_OBJECTS_FROM_METAFIELD', { metafield: metafield });
              next();
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              console.error('Couldn\'t resolve ' + to.name + ' beforeRouteEnter requests', { error: _context.t0 });
              next({
                name: 'app.error',
                query: { type: 'API' }
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeRouteEnter;
  }()
});

/***/ }),
/* 308 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionCustomObjects.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    categories: Array,
    listLayout: Boolean
  },

  methods: {
    onDelete: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(key) {
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$store.commit('shopCustomobjectsgroupsManage/REMOVE_CUSTOM_OBJECT', { key: key });
                _context.next = 3;
                return this.$store.dispatch('shopCustomobjectsgroupsManage/SAVE_CUSTOM_OBJECT');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDelete(_x) {
        return _ref.apply(this, arguments);
      }

      return onDelete;
    }(),
    openConfirmDeleteModal: function openConfirmDeleteModal(key) {
      var _this = this;

      var props = new __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        confirmationHandler: function confirmationHandler() {
          return _this.onDelete(key);
        }
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props: props });
    }
  }
});

/***/ }),
/* 309 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-manage-integrations.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores__ = __webpack_require__(/*! @/stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Section__ = __webpack_require__(/*! @/components/Section */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SectionInfo__ = __webpack_require__(/*! @/components/SectionInfo */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SectionSettings__ = __webpack_require__(/*! @/components/SectionSettings */ 716);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Section: __WEBPACK_IMPORTED_MODULE_3__components_Section__["a" /* default */],
        SectionInfo: __WEBPACK_IMPORTED_MODULE_4__components_SectionInfo__["a" /* default */],
        SectionSettings: __WEBPACK_IMPORTED_MODULE_5__components_SectionSettings__["a" /* default */]
    },

    data: function data() {
        return {
            store: this.$route.meta.store,
            loading: false
        };
    },


    computed: {
        integrations: {
            get: function get() {
                return Object.assign({}, this.$store.getters[this.store + '/integrations']);
            }
        },
        sections: function sections() {
            return {
                upscribe: {
                    key: 'upscribe',
                    title: 'Enable Upscribe integration',
                    settings: [{
                        key: 'enabled',
                        label: 'Enabled',
                        title: 'Enable Upscribe integration',
                        type: 'boolean',
                        value: this.integrations.upscribe.settings.enabled,
                        subForm: {
                            onVal: "Yes",
                            offVal: "No"
                        }
                    }]
                }
            };
        }
    },
    methods: {
        onInput: function onInput(val, key) {
            var integrations = this.mapValToIntegrations(val, key);
            this.$store.commit(this.store + '/SET_INTEGRATIONS', { integrations: integrations });
        },
        mapValToIntegrations: function mapValToIntegrations(settings, key) {
            var integrations = Object.assign({}, this.integrations);
            var integrationObj = Object.assign({}, this.integrations[key]);

            settings.forEach(function (item) {
                integrationObj.settings[item.key] = item.value;
            });

            integrations[key] = integrationObj;
            return integrations;
        },
        save: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.loading = true;
                                _context.next = 4;
                                return this.$store.dispatch(this.store + '/SAVE_SETTINGS');

                            case 4:

                                this.$store.commit('banners/SHOW_BANNER', {
                                    status: 'success',
                                    title: 'Settings saved.'
                                });
                                this.$eventBus.$emit('AFTER_SAVE_SETTINGS');
                                _context.next = 12;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["l" /* logger */])(_context.t0, 'DEV');

                                this.$store.commit('banners/SHOW_BANNER', {
                                    status: 'warning',
                                    title: 'Settings save failed.'
                                });

                            case 12:
                                _context.prev = 12;

                                this.loading = false;
                                return _context.finish(12);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 8, 12, 15]]);
            }));

            function save() {
                return _ref.apply(this, arguments);
            }

            return save;
        }(),
        handleWidnowEvent: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.save();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function handleWidnowEvent(_x) {
                return _ref2.apply(this, arguments);
            }

            return handleWidnowEvent;
        }(),
        backToDashboard: function backToDashboard() {
            this.$router.push('/');
        }
    },

    beforeRouteEnter: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(to, from, next) {
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_1__stores__["default"].dispatch(to.meta.store + '/GET_SETTINGS');

                        case 3:
                            next();
                            _context3.next = 10;
                            break;

                        case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3['catch'](0);

                            console.error('Couldn\'t resolve ' + to.name + ' beforeRouteEnter requests', { error: _context3.t0 });
                            next({
                                name: 'app.error',
                                query: { type: 'API' }
                            });

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 6]]);
        }));

        function beforeRouteEnter(_x2, _x3, _x4) {
            return _ref3.apply(this, arguments);
        }

        return beforeRouteEnter;
    }(),
    mounted: function mounted() {
        window.addEventListener('save', this.handleWidnowEvent, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('save', this.handleWidnowEvent);
        this.$store.commit('banners/CLOSE_BANNER');
    }
});

/***/ }),
/* 310 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SectionSettings.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metafields_edit_metafields__ = __webpack_require__(/*! ./metafields-edit/metafields */ 270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_metafields_changed_detection_mixin__ = __webpack_require__(/*! @/mixins/metafields-changed-detection.mixin */ 8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    settings: Array
  },
  mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_metafields_changed_detection_mixin__["a" /* forMetafieldsContainer */])()],

  components: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__metafields_edit_metafields__["a" /* default */]),

  methods: {
    basedOnMetafieldType: function basedOnMetafieldType(type) {
      return 'MetafieldEdit' + Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["camelCase"])(type));
    },
    onInput: function onInput(val) {
      this.$emit('input', this.settings);
    }
  }
});

/***/ }),
/* 311 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/page-select.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RelationSetter__ = __webpack_require__(/*! @/components/RelationSetter */ 96);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        RelationSetter: __WEBPACK_IMPORTED_MODULE_1__components_RelationSetter__["a" /* default */]
    },
    data: function data() {
        return {
            typeLabel: '',
            resourceType: null,
            items: [],
            selectedItems: [],
            loadingItems: false
        };
    },

    computed: {
        buttonLabel: function buttonLabel() {
            return 'Select ' + this.typeLabel + ' to edit';
        },
        resourceConfig: function resourceConfig() {
            var configs = {
                page: {
                    endpoint: 'item/page',
                    unselectedLabel: 'Available pages',
                    selectedLabel: 'Selected page'
                },
                blog: {
                    endpoint: 'item/blog',
                    unselectedLabel: 'Available blogs',
                    selectedLabel: 'Selected blog'
                },
                article: {
                    endpoint: 'item/articles',
                    unselectedLabel: 'Available articles',
                    selectedLabel: 'Selected article'
                }
            };
            return configs[this.resourceType] || null;
        },
        useRelationSetter: function useRelationSetter() {
            return ['page', 'blog', 'article'].includes(this.resourceType);
        }
    },
    mounted: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
            var resourceTypeLabel;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            resourceTypeLabel = '';

                            if (!this.$route.query.redirect) {
                                _context.next = 25;
                                break;
                            }

                            _context.t0 = this.$route.query.redirect;
                            _context.next = _context.t0 === '/products/edit' ? 5 : _context.t0 === '/collections/edit' ? 8 : _context.t0 === '/variants/edit' ? 11 : _context.t0 === '/pages/edit' ? 14 : _context.t0 === '/blogs/edit' ? 17 : _context.t0 === '/articles/edit' ? 20 : 23;
                            break;

                        case 5:
                            this.resourceType = 'product';
                            resourceTypeLabel = 'product';
                            return _context.abrupt('break', 25);

                        case 8:
                            this.resourceType = 'collection';
                            resourceTypeLabel = 'collection';
                            return _context.abrupt('break', 25);

                        case 11:
                            this.resourceType = 'variant';
                            resourceTypeLabel = 'variant';
                            return _context.abrupt('break', 25);

                        case 14:
                            this.resourceType = 'page';
                            resourceTypeLabel = 'page';
                            return _context.abrupt('break', 25);

                        case 17:
                            this.resourceType = 'blog';
                            resourceTypeLabel = 'blog';
                            return _context.abrupt('break', 25);

                        case 20:
                            this.resourceType = 'article';
                            resourceTypeLabel = 'article';
                            return _context.abrupt('break', 25);

                        case 23:
                            this.resourceType = 'product';
                            resourceTypeLabel = 'product';

                        case 25:

                            this.typeLabel = resourceTypeLabel;

                            this.$store.commit('banners/SHOW_BANNER', {
                                title: 'Select ' + resourceTypeLabel,
                                message: 'Please select a ' + resourceTypeLabel + ' again to edit metafields. You are seeing this screen due to an unexpected problem with Shopify that is not related to Airfields app.',
                                status: 'warning'
                            });

                            // For RelationSetter types (page, blog, article), fetch items
                            if (this.useRelationSetter) {
                                this.fetchItems();
                            }

                        case 28:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }(),

    methods: {
        openPicker: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var pickerConfig, selection, selectedResource, resourceId, selectedVariant, regex, match, _regex, _match, redirect, shop;

                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (window.shopify) {
                                    _context2.next = 3;
                                    break;
                                }

                                console.error('window.shopify is not available');
                                return _context2.abrupt('return');

                            case 3:
                                _context2.prev = 3;

                                // For variant selection, use 'product' type with variant selection enabled
                                pickerConfig = {
                                    type: this.resourceType === 'variant' ? 'product' : this.resourceType,
                                    multiple: false

                                    // Enable variant selection for variant route
                                };
                                if (this.resourceType === 'variant') {
                                    pickerConfig.action = 'select';
                                }

                                _context2.next = 8;
                                return window.shopify.resourcePicker(pickerConfig);

                            case 8:
                                selection = _context2.sent;

                                if (!(selection && selection.length > 0)) {
                                    _context2.next = 26;
                                    break;
                                }

                                selectedResource = selection[0];
                                resourceId = null;

                                // Handle variant selection specifically

                                if (!(this.resourceType === 'variant')) {
                                    _context2.next = 22;
                                    break;
                                }

                                if (!(!selectedResource.variants || selectedResource.variants.length === 0)) {
                                    _context2.next = 16;
                                    break;
                                }

                                // Show error banner - user must select a variant
                                this.$store.commit('banners/SHOW_BANNER', {
                                    title: 'Variant Required',
                                    message: 'Please select a specific variant from the product, not just the product itself. Click "Select variant to edit" again and choose a variant option.',
                                    status: 'critical'
                                });
                                return _context2.abrupt('return');

                            case 16:

                                // Extract variant ID from the variants array
                                selectedVariant = selectedResource.variants[0];
                                regex = /\/(\d+)$/;
                                match = selectedVariant.id.match(regex);


                                if (match && match[1]) {
                                    resourceId = match[1];
                                }
                                _context2.next = 25;
                                break;

                            case 22:
                                // For product, collection, etc. - extract ID normally
                                _regex = /\/(\d+)$/;
                                _match = selectedResource.id.match(_regex);


                                if (_match && _match[1]) {
                                    resourceId = _match[1];
                                }

                            case 25:

                                // Proceed with redirect if we have a valid resource ID
                                if (resourceId) {
                                    redirect = this.$route.query.redirect;
                                    shop = this.$route.query.shop;


                                    this.$router.push({
                                        path: redirect,
                                        query: {
                                            id: resourceId,
                                            shop: shop
                                        }
                                    });
                                }

                            case 26:
                                _context2.next = 31;
                                break;

                            case 28:
                                _context2.prev = 28;
                                _context2.t0 = _context2['catch'](3);

                                console.error('ResourcePicker error:', _context2.t0);

                            case 31:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[3, 28]]);
            }));

            function openPicker() {
                return _ref2.apply(this, arguments);
            }

            return openPicker;
        }(),
        fetchItems: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this.resourceConfig) {
                                    _context3.next = 2;
                                    break;
                                }

                                return _context3.abrupt('return');

                            case 2:

                                this.loadingItems = true;
                                _context3.prev = 3;
                                _context3.next = 6;
                                return this.$store.dispatch('shopifyApi/REQUEST', {
                                    endpoint: this.resourceConfig.endpoint
                                });

                            case 6:
                                response = _context3.sent;

                                this.items = response.items || [];
                                _context3.next = 13;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3['catch'](3);

                                this.items = [];

                            case 13:
                                _context3.prev = 13;

                                this.loadingItems = false;
                                return _context3.finish(13);

                            case 16:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[3, 10, 13, 16]]);
            }));

            function fetchItems() {
                return _ref3.apply(this, arguments);
            }

            return fetchItems;
        }(),
        handleItemSelection: function handleItemSelection(items) {
            this.selectedItems = items;
        },
        proceedWithSelection: function proceedWithSelection() {
            if (this.selectedItems.length > 0) {
                var selectedItem = this.selectedItems[0];
                var redirect = this.$route.query.redirect;
                var shop = this.$route.query.shop;

                this.$router.push({
                    path: redirect,
                    query: {
                        id: selectedItem.id,
                        shop: shop
                    }
                });
            }
        },
        goBack: function goBack() {
            this.$router.go(-1);
        }
    }
});

/***/ }),
/* 312 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/root.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_ModalContainer__ = __webpack_require__(/*! @/components/modals/ModalContainer */ 726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Banner__ = __webpack_require__(/*! @/components/Banner */ 804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ShopifyPage__ = __webpack_require__(/*! @/components/ShopifyPage */ 807);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ModalContainer: __WEBPACK_IMPORTED_MODULE_0__components_modals_ModalContainer__["a" /* default */],
    Banner: __WEBPACK_IMPORTED_MODULE_1__components_Banner__["a" /* default */],
    ShopifyPage: __WEBPACK_IMPORTED_MODULE_2__components_ShopifyPage__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Airfields Shopify',
      // Note: shopify-api-key meta and app-bridge.js script are now in index.ejs
      // to ensure App Bridge loads before any other scripts (Shopify requirement)
      htmlAttrs: {
        lang: 'en-US'
      },
      link: [
        //{ rel: 'icon', type: 'image/png', href: '/assets/images/logo_new.png' }
      ]
    };
  }
});

/***/ }),
/* 313 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/ModalContainer.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_content__ = __webpack_require__(/*! ./modals-content */ 728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__ = __webpack_require__(/*! body-scroll-lock */ 802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__modals_content__["a" /* default */]),
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('modals', ['modals'])),
  watch: {
    'modals': {
      handler: function handler(val) {
        var _this = this;

        this.handleBodyScroll(val);

        this.$nextTick(function () {
          _this.focusModal();
        });
      }
    },
    deep: true
  },
  methods: {
    closeModal: function closeModal() {
      var isCloseEventDisabled = this.modals.length && this.modals[this.modals.length - 1].props.disableCloseEventsOnContainer;

      if (isCloseEventDisabled) return;

      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    },
    className: function className(modal) {
      return {
        'modals-container--solid-bg': modal.name === 'ModalIframe'
      };
    },
    handleBodyScroll: function handleBodyScroll(modals) {
      var modalsContainer = this.$refs.modalsContainer;

      modals.length ? Object(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])(modalsContainer) : Object(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["clearAllBodyScrollLocks"])(modalsContainer);
    },
    focusModal: function focusModal() {
      var modalsContent = this.$refs.modalsContent;


      if (modalsContent && modalsContent.length) {
        var modalOnTheTop = modalsContent[modalsContent.length - 1];
        Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["g" /* focusElement */])(modalOnTheTop.$el);

        return modalOnTheTop;
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 314 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalConfirmDecision.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]
  },
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleConfirmation: function handleConfirmation() {
      this.closeModal();
      this.modalData.confirmationHandler();
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 13) {
        this.handleConfirmation();
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 315 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalEditField.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__ = __webpack_require__(/*! @/components/forms/FormField */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormField: __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__["a" /* default */]
  },
  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__["b" /* MDSModalEditFieldModel */]
  },
  data: function data() {
    return {
      title: null,
      form: null
    };
  },

  computed: {
    forbiddenKeys: function forbiddenKeys() {
      var _this = this;

      return this.form && this.form.key ? this.modalData.usedKeys.filter(function (k) {
        return k !== _this.form.key;
      }) : this.usedKeys;
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                console.warn('Invalid form');
                return _context.abrupt('return');

              case 6:

                this.$eventBus.$emit('ModalNewField/PATCH_FIELD', { form: this.form, editedField: this.modalData.field });
                this.closeModal();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    setTitle: function setTitle() {
      var label = this.modalData.field.label;

      this.title = 'Edit field ' + (label ? '<strong>' + label + '</strong>' : '');
    },
    initForm: function initForm() {
      var _modalData$field = this.modalData.field,
          key = _modalData$field.key,
          label = _modalData$field.label,
          description = _modalData$field.description,
          type = _modalData$field.type,
          subForm = _modalData$field.subForm;

      this.form = { key: key, label: label, description: description, type: type, subForm: subForm };
    },
    handleKeyEvent: function handleKeyEvent(e) {
      // Dont add ENTER listener, for now enter is reservered for textarea to make newline!!!
      // if (e.keyCode === 13) {
      //   this.handleSubmit()
      // }
    }
  },
  created: function created() {
    this.setTitle();
    this.initForm();
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 316 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/FormField.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_sub_forms__ = __webpack_require__(/*! @/components/forms/sub-forms */ 736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__field_types_js__ = __webpack_require__(/*! ./field-types.js */ 299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  components: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__components_forms_sub_forms__["a" /* default */]),
  props: {
    value: Object,
    scope: String,
    forbiddenKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showTypeSelect: {
      type: Boolean,
      default: true
    },
    showKey: {
      type: Boolean,
      default: true
    },
    showKeyHint: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      doUpdate: false,
      selectDisabled: false,
      keyTouched: false,
      keyValidation: {
        required: true,
        excluded: this.forbiddenKeys,
        min: 3,
        max: 10
      },
      form: {
        key: null,
        label: null,
        description: null,
        type: null,
        subForm: {}
      },
      isKeyFieldLocked: false,
      SELECT_OPTIONS: Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_1__field_types_js__["b" /* SELECT_OPTIONS */]),
      TYPES_DATA: Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["cloneDeep"])(__WEBPACK_IMPORTED_MODULE_1__field_types_js__["c" /* TYPES_DATA */]),
      savedInDatabaseData: {
        fieldType: '',
        subForm: {}
      }
    };
  },

  watch: {
    'value': {
      handler: function handler(val) {
        if (val) {
          this.keyTouched = true;
          Object.assign(this.form, val);
        }
      },

      immediate: true
    },
    'form': {
      handler: function handler(val) {
        this.$emit('input', val);
      },

      deep: true
    },
    'form.type': {
      handler: function handler(val) {
        if (val === this.savedInDatabaseData.fieldType) {
          this.restoreDatabaseBackup();
        } else {
          this.resetSubForm();
        }
      }
    },
    subFormComponent: function subFormComponent() {
      this.onUpdate();
    }
  },
  computed: {
    metaKey: function metaKey() {
      if (!this.showKeyHint) {
        return '';
      }

      var key = this.form.key;

      var scope = this.scope.replace(/s$/, '');
      var namespace = "airf";

      switch (scope) {
        case 'variant':
          scope = 'product.selected_variant';
          break;
        case 'customobjectsgroup':
          scope = 'shop';
          namespace += '_co_groups';
          break;
      }

      return scope + '.metafields.' + namespace + (key ? '.<strong>' + key + '</strong>' : '');
    },
    subFormComponent: function subFormComponent() {
      var mapping = {
        SubFormRepeaterJson: 'SubFormRepeater'
      };
      var componentName = 'SubForm' + Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["camelCase"])(this.form.type));

      return mapping[componentName] || componentName;
    },
    subFormExists: function subFormExists() {
      return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.$options.components, this.subFormComponent);
    },
    learnUrl: function learnUrl() {
      return this.form.type ? 'https://airfields.io/article/field-type-' + Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["kebabCase"])(this.form.type) : '';
    },
    selectedTypeLabel: function selectedTypeLabel() {
      var type = this.form.type;

      for (var i = 0, len = this.SELECT_OPTIONS.length; i < len; i++) {
        var found = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["keyBy"])(this.SELECT_OPTIONS[i].options, 'value')[type], 'label');
        if (found) return found;
      }
    }
  },
  methods: {
    formatKey: function formatKey(str) {
      return str.toLowerCase().replace(/\s/g, '_');
    },
    autocompleteKeyform: function autocompleteKeyform(str) {
      if (!this.keyTouched) {
        this.form.key = this.formatKey(str).slice(0, this.keyValidation.max);
      }
    },
    onKeyInput: function onKeyInput(str) {
      this.keyTouched = true;
      this.form.key = this.formatKey(str);
      // Key field validate on 'input instead of default 'blur' > for better user experience
      this.$validator.validate('key');
    },
    formatAllowedOptions: function formatAllowedOptions() {
      var _this = this;

      if (this.form.type && (this.form.type === 'group' || this.form.type === 'repeater')) {
        this.selectDisabled = true;
      }

      this.SELECT_OPTIONS[0].options = this.SELECT_OPTIONS[0].options.map(function (item) {
        if ((_this.parent.type === 'repeater' || _this.parent.type === 'repeater_json') && (item.value === 'repeater' || item.value === 'repeater_json' || item.value === 'group')) {
          item.disabled = true;
        } else if (_this.parent.type === 'group' && item.value === 'group') {
          item.disabled = true;
        }

        return item;
      });
    },
    resetSubForm: function resetSubForm() {
      this.form.subForm = {};
    },
    onUpdate: function onUpdate() {
      this.doUpdate = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["h" /* generateUuid */])();
    },
    showLearnModal: function showLearnModal() {
      var props = new __WEBPACK_IMPORTED_MODULE_3__models_modal_datasets_model__["e" /* MDSModalIframeModel */]({
        src: this.learnUrl
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalIframe', props: props });
    },
    findIfKeyExistsInDatabase: function findIfKeyExistsInDatabase() {
      if (this.value) {
        this.isKeyFieldLocked = !!this.value.key;
      }
    },
    unlockField: function unlockField() {
      this.isKeyFieldLocked = false;
    },
    onLockedFieldClick: function onLockedFieldClick() {
      if (!this.isKeyFieldLocked) return;

      var props = new __WEBPACK_IMPORTED_MODULE_3__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        confirmationHandler: this.unlockField,
        title: 'Edit field key',
        description: 'Changing the <strong>key</strong> of a published field will interrupt the delivery of your content to applications that currently display it. Change the field <strong>key</strong> only if you plan to update your client applications as well.',
        btnTextConfirm: 'Edit field key'
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props: props });
    },
    backupSavedInDatabaseData: function backupSavedInDatabaseData() {
      Object.assign(this.savedInDatabaseData, {
        fieldType: this.form.type,
        subForm: this.form.subForm
      });
    },
    restoreDatabaseBackup: function restoreDatabaseBackup() {
      Object.assign(this.form.subForm, this.savedInDatabaseData.subForm);
    }
  },
  created: function created() {
    this.formatAllowedOptions();
    this.findIfKeyExistsInDatabase();
    this.backupSavedInDatabaseData();
  }
});

/***/ }),
/* 317 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormBoolean.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        onVal: 'On',
        offVal: 'Off'
      }
    };
  }
});

/***/ }),
/* 318 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormCustomObject.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 16);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      doRender: false,
      form: {
        groupID: ''
      }
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('shopCustomobjectsgroupsList', {
    customObjects: 'customObjectsGroupsMapped'
  })),
  created: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.customObjects.length) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$store.dispatch('shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS');

            case 3:
              this.doRender = true;
              this.$emit('update');

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }()
});

/***/ }),
/* 319 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormDate.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        onlyDate: false,
        format12h: true
      }
    };
  }
});

/***/ }),
/* 320 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormGroup.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        opened: false
      }
    };
  },

  methods: {
    setView: function setView(val) {
      this.form.opened = val;
    }
  }
});

/***/ }),
/* 321 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormInteger.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        min: '0',
        max: '200',
        prefix: '',
        suffix: ''
      }
    };
  },

  computed: {
    minValidator: function minValidator() {
      return 'required|integer|min_value:0' + (this.form.max == 0 ? '' : '|max_value:' + this.form.max);
    }
  }
});

/***/ }),
/* 322 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormNumber.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        min: '0',
        max: '200'
      }
    };
  },

  computed: {
    minValidator: function minValidator() {
      return 'required|decimal' + (this.form.max == 0 ? '' : '|max_value:' + this.form.max);
    }
  }
});

/***/ }),
/* 323 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormRelation.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        relateTo: 'product'
      }
    };
  }
});

/***/ }),
/* 324 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormRepeater.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        min: 1,
        max: 10,
        title: '',
        labelFieldKey: ''
      }
    };
  },

  computed: {
    minValidator: function minValidator() {
      return 'required|integer|min_value:0' + (this.form.max == 0 ? '' : '|max_value:' + this.form.max);
    },
    maxValidator: function maxValidator() {
      return 'required|integer|min_value:0';
    }
  }
  // created () {
  //   this.$validator.extend('maxRange', {
  //     getMessage: field => `The ${field} field must be ${this.form.min} or more.`,
  //     validate: val => {
  //       return val == 0 || val >= this.form.min
  //     }
  //   })
  // },
});

/***/ }),
/* 325 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormSelection.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      isOptionsFieldLocked: false,
      optionsStr: '',
      selectOptions: Object.freeze([{
        value: 'select-list',
        label: 'Select list'
      }, {
        value: 'checkboxes',
        label: 'Checkboxes'
      }, {
        value: 'radioboxes',
        label: 'Radioboxes'
      }]),
      form: {
        display: 'select-list',
        options: [{ value: 'value_1', label: 'Option 1' }, { value: 'value_2', label: 'Option 2' }, { value: 'value_3', label: 'Option 3' }],
        verticalLayout: true
      }
    };
  },

  computed: {
    showSwitcher: function showSwitcher() {
      return ['checkboxes', 'radioboxes'].includes(this.form.display);
    }
  },
  methods: {
    recieveOptions: function recieveOptions(val) {
      this.optionsStr = val;

      var _options = val.split('\n');
      var _formOptions = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item === '' || item === '') {
            continue;
          }

          item = item.replace(' : ', ':');
          var _itemParams = item.split(':');

          if (_itemParams.length > 1) {
            _formOptions.push({ value: _itemParams[0], label: _itemParams[1] });
          } else {
            _formOptions.push({ value: _itemParams[0], label: _itemParams[0] });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.form.options = _formOptions;
    },
    initialOptionsStr: function initialOptionsStr() {
      var _str = '';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.form.options[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;


          _str += option.value + ' : ' + option.label + '\n';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return _str;
    },
    findIfOptionsExistsInDatabase: function findIfOptionsExistsInDatabase() {
      if (this.value && this.value.options) {
        this.isOptionsFieldLocked = true;
      }
    },
    unlockOptions: function unlockOptions() {
      this.isOptionsFieldLocked = false;
    },
    onLockedFieldClick: function onLockedFieldClick() {
      if (!this.isOptionsFieldLocked) return;

      var props = new __WEBPACK_IMPORTED_MODULE_1__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        confirmationHandler: this.unlockOptions,
        title: 'Edit select options',
        description: 'Changing the <strong>options</strong> of a published field will interrupt the delivery of your content to applications that currentyly display it. Change the <strong>options</strong> only if you plan to update your client applications as well.',
        btnTextConfirm: 'Edit options'
      });
      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalConfirmDecision', props: props });
    }
  },

  created: function created() {
    this.findIfOptionsExistsInDatabase();
    this.optionsStr = this.initialOptionsStr();
  }
});

/***/ }),
/* 326 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormText.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        min: '0',
        max: '200'
      }
    };
  },

  computed: {
    minValidator: function minValidator() {
      return 'required|integer|min_value:0|' + (this.form.max == 0 ? '' : '|max_value:' + this.form.max);
    }
  }
});

/***/ }),
/* 327 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormTextarea.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        min: '0',
        max: '0',
        rows: '5'
      }
    };
  },

  computed: {
    minValidator: function minValidator() {
      return 'required|integer|min_value:0|' + (this.form.max == 0 ? '' : '|max_value:' + this.form.max);
    }
  }
});

/***/ }),
/* 328 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forms/sub-forms/SubFormVideo.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__ = __webpack_require__(/*! @/mixins/sub-form.mixin */ 19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_sub_form_mixin__["a" /* default */]],
  data: function data() {
    return {
      form: {
        width: 480,
        height: 270,
        autoplay: true,
        allowFullScreen: true
      }
    };
  }
});

/***/ }),
/* 329 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalFieldCode.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs__ = __webpack_require__(/*! prismjs */ 778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css__ = __webpack_require__(/*! prismjs/themes/prism.css */ 779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_prism_component__ = __webpack_require__(/*! vue-prism-component */ 780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_prism_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_prism_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Prism: __WEBPACK_IMPORTED_MODULE_4_vue_prism_component___default.a
  },
  data: function data() {
    return {
      title: null,
      copyButtonText: 'Copy',
      schema: null
    };
  },

  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_5__models_modal_datasets_model__["c" /* MDSModalFieldCodeModel */]
  },
  computed: {
    liquidCode: function liquidCode() {
      var field = this.modalData.field;
      var scope = this.modalData.scope;
      var schema = this.schema;

      return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* FieldLiquidGenerateHeleper */])({ field: field, scope: scope, schema: schema });
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleCopy: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$refs.code.select();
                document.execCommand('copy');

                this.copyButtonText = 'Copied to clipboard!';

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCopy() {
        return _ref.apply(this, arguments);
      }

      return handleCopy;
    }(),
    setSchema: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        var customObjects, customObject;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.modalData.field.type === 'custom-object')) {
                  _context2.next = 10;
                  break;
                }

                customObjects = this.$store.getters['shopCustomobjectsgroupsList/customObjectsGroupsMapped'];

                if (customObjects.length) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return this.$store.dispatch('shopCustomobjectsgroupsList/GET_CUSTOM_OBJECTS_GROUPS');

              case 5:
                customObjects = this.$store.getters['shopCustomobjectsgroupsList/customObjectsGroupsMapped'];

              case 6:
                customObject = customObjects.find(function (item) {
                  return item.id === parseInt(_this.modalData.field.subForm.groupID);
                });


                if (customObject.schema) {
                  this.schema = customObject.schema;
                }
                _context2.next = 11;
                break;

              case 10:
                if (this.modalData.field.type === 'relation') {
                  this.schema = this.modalData.field.subForm;
                }

              case 11:
                return _context2.abrupt('return');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setSchema() {
        return _ref2.apply(this, arguments);
      }

      return setSchema;
    }(),
    setTitle: function setTitle() {
      var label = this.modalData.field.label;

      this.title = 'Liquid code for <strong>' + label + '</strong>';
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 13) {
        this.handleSubmit();
      }
    },
    collectForm: function collectForm(form) {
      this.form = form;
    }
  },
  created: function created() {
    this.setTitle();
    __webpack_require__(/*! ./prism-liquid-html */ 781); // if imported at top, there is collision with 'codeflask' from BaseHtml.vue
  },
  mounted: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.setSchema();

            case 2:
              document.addEventListener('keydown', this.handleKeyEvent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 330 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalHint.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__["d" /* MDSModalHintModel */]
  },
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 13) {
        this.closeModal();
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 331 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalIframe.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_0__models_modal_datasets_model__["e" /* MDSModalIframeModel */]
  },
  data: function data() {
    return {
      loading: true
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    }
  }
});

/***/ }),
/* 332 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalImportWarning.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Warning!',
      form: null,
      loading: false
    };
  },

  computed: {
    className: function className() {
      return this.loading ? 'modal-field__close-btn--disabled' : '';
    }
  },
  methods: {
    closeModal: function closeModal() {
      if (this.loading) {
        return;
      }
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var content, result;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* FileUploadHelper */])();

              case 3:
                content = _context.sent;

                this.loading = true;
                _context.next = 7;
                return this.$store.dispatch('shopifyApi/SCHEMA_IMPORT', { content: content });

              case 7:
                result = _context.sent;


                this.$store.commit('banners/SHOW_BANNER', {
                  status: 'success',
                  title: 'Fields Schema imported.'
                });

                this.loading = false;
                this.closeModal();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    collectForm: function collectForm(form) {
      this.form = form;
    }
  }
});

/***/ }),
/* 333 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalNewCustomObject.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__ = __webpack_require__(/*! @/components/forms/FormField */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormField: __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__["a" /* default */]
  },
  data: function data() {
    return {
      title: 'Add a <strong>custom object</strong>',
      form: null,
      loading: {
        save: false
      }
    };
  },

  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__["f" /* MDSModalNewCustomObjectModel */]
  },
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                console.warn('Invalid form');
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;

                this.loading.save = true;
                this.$store.commit('shopCustomobjectsgroupsManage/ADD_CUSTOM_OBJECT', { customObject: this.form });
                _context.next = 11;
                return this.$store.dispatch('shopCustomobjectsgroupsManage/SAVE_CUSTOM_OBJECT');

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](6);

                console.error(_context.t0);

              case 16:
                _context.prev = 16;

                this.loading.save = false;
                return _context.finish(16);

              case 19:

                this.closeModal();

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13, 16, 19]]);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    collectForm: function collectForm(form) {
      this.form = form;
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 13) {
        this.handleSubmit();
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 334 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalNewCustomObjectGroup.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__ = __webpack_require__(/*! @/components/forms/FormField */ 69);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormField: __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__["a" /* default */]
  },
  data: function data() {
    return {
      title: 'Add a <strong>custom object</strong>',
      form: null,
      loading: {
        save: false
      }
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                console.warn('Invalid form');
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;

                this.loading.save = true;
                _context.next = 10;
                return this.$store.dispatch('shopCustomobjectsgroupsList/SAVE_CUSTOM_OBJECT_GROUP', { customObjectGroup: this.form });

              case 10:
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                console.error(_context.t0);

              case 15:
                _context.prev = 15;

                this.loading.save = false;
                return _context.finish(15);

              case 18:

                this.closeModal();

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12, 15, 18]]);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    collectForm: function collectForm(form) {
      this.form = form;
    },
    handleKeyEvent: function handleKeyEvent(e) {
      if (e.keyCode === 13) {
        this.handleSubmit();
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 335 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/modals-content/ModalNewField.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__ = __webpack_require__(/*! @/components/forms/FormField */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormField: __WEBPACK_IMPORTED_MODULE_1__components_forms_FormField__["a" /* default */]
  },
  props: {
    modalData: __WEBPACK_IMPORTED_MODULE_2__models_modal_datasets_model__["g" /* MDSModalNewFieldModel */]
  },
  data: function data() {
    return {
      title: null,
      form: null
    };
  },

  methods: {
    closeModal: function closeModal() {
      this.$store.commit('modals/CLOSE_LAST_MODAL');
    },
    handleSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isValid;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$validator.validateAll();

              case 2:
                isValid = _context.sent;

                if (isValid) {
                  _context.next = 6;
                  break;
                }

                console.warn('Invalid form');
                return _context.abrupt('return');

              case 6:

                if (this.form.type === 'repeater_json') {
                  this.form.type = 'repeater';
                  this.form.subType = 'repeater_json';
                }

                this.$eventBus.$emit('ModalNewField/ADD_NEW_FIELD', { field: this.form, parent: this.modalData.parent });
                this.closeModal();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit() {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }(),
    setTitle: function setTitle() {
      var label = this.modalData.parent.label;

      this.title = 'Add a field ' + (label ? 'to <strong>' + label + '</strong>' : '');
    },
    collectForm: function collectForm(form) {
      this.form = form;
    },
    handleKeyEvent: function handleKeyEvent(e) {
      // Dont add ENTER listener, for now enter is reservered for textarea to make newline!!!
      // if (e.keyCode === 13) {
      //   this.handleSubmit()
      // }
    }
  },
  created: function created() {
    this.setTitle();
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyEvent);
  }
});

/***/ }),
/* 336 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Banner.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 16);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('banners', ['banners'])),
  methods: {
    className: function className(status) {
      return _defineProperty({}, 'banner--' + status, status);
    }
  }
});

/***/ }),
/* 337 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ShopifyPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShopifyPage',

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapState */])('shopifyBar', ['pageTitle', 'buttonsSet', 'visible']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('shopifyBar', ['ready']), {
    shouldShow: function shouldShow() {
      // Only show if:
      // 1. window.shopify is ready
      // 2. Visible flag is true
      return this.ready && this.visible;
    },
    showBreadcrumb: function showBreadcrumb() {
      return this.pageTitle !== 'Dashboard';
    }
  }),

  methods: {
    goHome: function goHome() {
      this.$router.push('/');
    },
    handleSave: function handleSave() {
      // Dispatch window event for backward compatibility with existing page listeners
      window.dispatchEvent(new Event('save'));
    },
    handleImport: function handleImport() {
      window.dispatchEvent(new Event('schema_import'));
    },
    handleExport: function handleExport() {
      window.dispatchEvent(new Event('schema_export'));
    },
    handleTutorial: function handleTutorial() {
      window.dispatchEvent(new Event('show_tutorial'));
    },
    handleHelp: function handleHelp() {
      window.open('https://www.airfields.io/', '_blank', 'noopener');
    },
    handleReview: function handleReview() {
      window.open('https://apps.shopify.com/airfields#modal-show=ReviewListingModal', '_blank', 'noopener');
    }
  }
});

/***/ }),
/* 338 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseAccordion.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      opened: false
    };
  },

  methods: {
    onCollapse: function onCollapse() {
      this.opened = !this.opened;
    },
    open: function open(uid) {
      if (uid === this._uid) {
        this.opened = true;
      }
    }
  },
  created: function created() {
    this.$eventBus.$on('openBaseAccordion', this.open);
    this.opened = this.value;
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off('openBaseAccordion', this.open);
  }
});

/***/ }),
/* 339 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseButton.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    icon: String,
    disabled: Boolean,
    theme: String,
    loading: Boolean,
    useImgNotSvg: Boolean
  },
  computed: {
    className: function className() {
      return [this.disabled ? 'base-button--disabled' : '', this.loading ? 'base-button--loading' : '', this.theme ? 'base-button--' + this.theme : ''];
    }
  }
});

/***/ }),
/* 340 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseButtonBack.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        goBack: function goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        }
    }
});

/***/ }),
/* 341 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseCheckBox.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//



var CUSTOM_EVENTS = {
  input: 'input'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionValue: {
      type: String,
      required: true
    },
    value: Array,
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    checked: function checked() {
      return this.value.includes(this.optionValue);
    },
    listeners: function listeners() {
      var _this = this;

      var filteredListeners = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(this.$listeners, Object.values(CUSTOM_EVENTS));

      return Object.assign({}, filteredListeners, {
        change: function change(e) {
          var value = [].concat(_toConsumableArray(_this.value));
          if (_this.checked) {
            value.splice(value.indexOf(_this.optionValue), 1);
          } else {
            value.push(_this.optionValue);
          }

          _this.$emit(CUSTOM_EVENTS.input, value);
        }
      });
    },
    iconName: function iconName() {
      return this.checked ? 'checkbox-selected' : 'checkbox-unselected';
    }
  }
});

/***/ }),
/* 342 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseCollapse.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(/*! gsap */ 827);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  props: {
    collapse: Boolean,
    changeHeight: [String, Array, Object, Boolean, Number],
    transitionDuration: {
      type: Number,
      default: 0.3 // [seconds]
    }
  },
  watch: {
    collapse: function collapse(val) {
      this.setCollapse(val);
    },
    changeHeight: function changeHeight(val) {
      this.setCollapse(false);
    }
  },
  methods: {
    mHeight: function mHeight() {
      var calcWrapper = this.$refs.calcWrapper;


      if (!calcWrapper) {
        return;
      }

      calcWrapper.style.position = 'absolute';
      calcWrapper.style.display = 'block';
      calcWrapper.style.height = 'auto';
      calcWrapper.style.visibility = 'hidden';

      var h = calcWrapper.clientHeight;

      calcWrapper.style.position = null;
      calcWrapper.style.display = null;
      calcWrapper.style.visibility = null;

      return h;
    },
    expandContent: function expandContent() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenLite */].to(this.$refs.baseCollapse, this.transitionDuration, {
        height: function height() {
          return _this.mHeight() + 'px';
        },
        onStart: function onStart() {
          _this.$refs.baseCollapse.style.opacity = '1';
        }
      });
    },
    collapseContent: function collapseContent() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenLite */].to(this.$refs.baseCollapse, this.transitionDuration, {
        height: '0px',
        onComplete: function onComplete() {
          return _this2.$refs.baseCollapse.style.opacity = '0';
        }
      });
    },
    setCollapse: function setCollapse(val) {
      if (!val) {
        this.expandContent();
      } else {
        this.collapseContent();
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.collapse === true) {
      this.$refs.baseCollapse.style.height = '0px';
    }
    this.setCollapse(this.collapse);
  }
});

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseHelpButton.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    icon: {
      type: String,
      default: 'help'
    },
    text: String,
    linkLabel: String,
    linkUrl: String,
    linkAction: Function
  }
});

/***/ }),
/* 351 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseHtml.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseInput__ = __webpack_require__(/*! ./BaseInput */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_codeflask__ = __webpack_require__(/*! codeflask */ 353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseInput__["default"],
  props: {
    minHeight: { default: 250 }
  },

  data: function data() {
    return {
      flask: null,
      uuid: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* generateUuid */])()
    };
  },


  methods: {
    handleCodeUpdate: function handleCodeUpdate(code) {
      this.$emit('input', code);
    }
  },

  mounted: function mounted() {
    this.flask = new __WEBPACK_IMPORTED_MODULE_1_codeflask__["a" /* default */]('.html-editor-' + this.uuid, { language: 'html', lineNumbers: false, defaultTheme: false });
    if (this.value) {
      this.flask.updateCode(this.value);
    }
    this.flask.onUpdate(this.handleCodeUpdate);
  }
});

/***/ }),
/* 352 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseInput.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['$validator'],
  props: {
    theme: String, // disabled, grayed
    label: String,
    value: { default: '' },
    hint: String,
    meta: String,
    validate: {
      type: [String, Object],
      default: ''
    },
    formatNum: String,
    minVal: [String, Number, Boolean],
    maxVal: [String, Number, Boolean],
    prefix: String,
    suffix: String,
    isLocked: Boolean
  },
  data: function data() {
    return {
      id: null,
      focus: false
    };
  },
  mounted: function mounted() {
    this.id = this._uid;
  },

  computed: {
    hintId: function hintId() {
      return this._uid + "-hint";
    },
    errorMessageId: function errorMessageId() {
      return this._uid + "-error";
    },
    describedBy: function describedBy() {
      if (this.hint) {
        return this.hintId;
      }

      return "";
    },
    errorMessage: function errorMessage() {
      if (this.hasErrors) {
        return this.errorMessageId;
      }

      return "";
    },
    hasErrors: function hasErrors() {
      return this.errors.has(this.$attrs.name);
    },
    className: function className() {
      var _ref;

      return ['base-input', (_ref = {
        'base-input--error': this.hasErrors,
        'base-input--focus': this.focus
      }, _defineProperty(_ref, 'base-input--' + this.theme, this.theme), _defineProperty(_ref, 'base-input--locked', this.isLocked), _ref)];
    },
    listeners: function listeners() {
      var _this = this;

      return Object.assign({}, this.$listeners, {
        input: function input(e) {
          return _this.$emit('input', e.target.value);
        },
        blur: function blur() {
          return _this.onFocus(false);
        },
        focus: function focus() {
          return _this.onFocus(true);
        }
      });
    },
    isFieldDisabled: function isFieldDisabled() {
      return this.theme === 'disabled' || this.isLocked;
    }
  },
  filters: {
    formatVal: function formatVal(val, format) {
      if (!format) return val;

      var prefix = '0'.repeat(format.length - 1);

      if (val <= -10 || val >= 10) {
        return val;
      } else if (val < 0) {
        return '-' + prefix + Math.abs(val);
      } else if (val >= 0) {
        return prefix + val;
      }
    }
  },
  methods: {
    min: function min() {
      var v = this.minVal;
      if (v === false || v === true || v === undefined || v === null) {
        return -Infinity;
      } else {
        return +v;
      }
    },
    max: function max() {
      var v = this.maxVal;
      if (v === false || v === true || v === undefined || v === null) {
        return Infinity;
      } else {
        return +v;
      }
    },
    increaseVal: function increaseVal() {
      var incVal = +this.value + 1;
      var emitVal = incVal > this.max() ? this.max() : incVal < this.min() ? this.min() : incVal;
      this.$emit('input', emitVal);
    },
    decreaseVal: function decreaseVal() {
      var deVal = +this.value - 1;
      var emitVal = deVal < this.min() ? this.min() : deVal > this.max() ? this.max() : deVal;
      this.$emit('input', emitVal);
    },
    onFocus: function onFocus(val) {
      this.focus = val;
    }
  }
});

/***/ }),
/* 353 */,
/* 354 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseIcon.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_index_js__ = __webpack_require__(/*! ./icons/index.js */ 842);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: true
    },
    useImgNotSvg: Boolean
  },

  components: Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__icons_index_js__["a" /* default */]),

  computed: {
    className: function className() {
      return ['icon', 'icon-' + this.name];
    },
    svgComponent: function svgComponent() {
      return __WEBPACK_IMPORTED_MODULE_0__icons_index_js__["a" /* default */]['ico-' + this.name];
    }
  }
});

/***/ }),
/* 355 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseImage.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        image: {
            type: [Object, String]
        },
        placeholder: {
            type: String,
            default: '/images/img-placeholder.svg'
        },
        objectFit: String,
        lazy: {
            type: Boolean,
            default: true
        },
        aspectRatio: Number
    },

    data: function data() {
        return {
            imageData: {},
            sourceLoaded: false,
            lazySrc: ''
        };
    },


    computed: {
        className: function className() {
            return {
                '-object-fit': this.objectFit,
                '-aspect-ratio': this.aspectRatio
            };
        },
        alt: function alt() {
            return this.imageData ? this.imageData.alt || this.imageData.title || '' : '';
        },
        src: function src() {
            return this.imageData && this.imageData.src ? this.imageData.src : this.placeholder;
        }
    },

    watch: {
        image: function image() {
            this.setImageData();
            this.bindSrc();
        }
    },

    methods: {
        onSourceLoaded: function onSourceLoaded() {
            this.sourceLoaded = true;
        },
        bindSrc: function bindSrc() {
            this.lazySrc = this.src;
        },
        initObserver: function initObserver() {
            var _this = this;

            var observer = new IntersectionObserver(function (changes) {
                for (var i = 0; i < changes.length; i++) {
                    var change = changes[i];
                    if (change.isIntersecting) {
                        _this.bindSrc();
                        observer.unobserve(_this.$el);
                    }
                }
            });

            observer.observe(this.$el);
        },
        setImageData: function setImageData() {
            this.imageData = typeof this.image === 'string' ? { src: this.image } : this.image;
        }
    },

    created: function created() {
        this.setImageData();
    },
    mounted: function mounted() {
        if (this.lazy) {
            this.initObserver();
        }
    }
});

/***/ }),
/* 356 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseJson.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseInput__ = __webpack_require__(/*! ./BaseInput */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_codeflask__ = __webpack_require__(/*! codeflask */ 353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseInput__["default"],
  props: {
    minHeight: { default: 250 }
  },

  data: function data() {
    return {
      flask: null,
      uuid: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* generateUuid */])(),
      jsonError: null
    };
  },


  methods: {
    handleError: function handleError(message) {
      this.jsonError = message;
    },
    isJsonString: function isJsonString(str) {
      if (str && str.length) {
        try {
          JSON.parse(str);
        } catch (e) {
          return { ok: false, message: e.message };
        }
      }
      return { ok: true, message: null };
    },
    handleCodeUpdate: function handleCodeUpdate(code) {
      var _isJsonString = this.isJsonString(code),
          ok = _isJsonString.ok,
          message = _isJsonString.message;

      if (!ok) {
        return this.handleError(message);
      }

      this.jsonError = null;
      this.$emit('input', code);
    }
  },

  mounted: function mounted() {
    this.flask = new __WEBPACK_IMPORTED_MODULE_1_codeflask__["a" /* default */]('.json-editor-' + this.uuid, { language: 'js', lineNumbers: false, defaultTheme: false });
    if (this.value) {
      this.flask.updateCode(this.value);
    }
    this.flask.onUpdate(this.handleCodeUpdate);
  }
});

/***/ }),
/* 357 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseLink.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    blank: Boolean,
    to: {
      type: [String, Object],
      reqired: true
    }
  }
});

/***/ }),
/* 358 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BasePictureInput.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_vue_picture_input__ = __webpack_require__(/*! @/packages/vue-picture-input */ 930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ["$validator"],
    props: {
        label: String,
        value: { type: String, default: "" },
        hint: String,
        meta: String,
        fieldKey: [String, Number],
        scopeId: [String, Number]
    },
    data: function data() {
        return {
            error: null
        };
    },

    components: {
        PictureInput: __WEBPACK_IMPORTED_MODULE_1__packages_vue_picture_input__["a" /* default */]
    },
    computed: {
        className: function className() {
            return ["base-picture-input", {
                "base-picture-input--error": this.hasErrors
            }];
        },
        hasErrors: function hasErrors() {
            return this.error;
        }
    },
    methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('shopifyApi', ['REQUEST']), {
        onChange: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(image) {
                var splittedName, filename, extension, finalName, url;
                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (image) {
                                    _context.next = 3;
                                    break;
                                }

                                this.error = 'FileReader API not supported: use the <form>, Luke!';
                                return _context.abrupt('return');

                            case 3:

                                this.error = null;

                                _context.prev = 4;
                                splittedName = this.$refs.pictureInput.file.name.replace(/\s/g, '-').split('.');
                                filename = splittedName.slice(0, -1).join('.');
                                extension = splittedName[splittedName.length - 1];

                                // Don't pass this.fieldKey to finalName, if so there will be an error during image saving to Shopify CDN in situation when:
                                // Picture inputs are in repeater and you create new instances of repeater. New instances fieldKey includes string `[i]`,
                                // Shopify CDN doesn't accept square brackets in file names, so error occurs and images don't save.

                                finalName = filename + new Date().getTime() + Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["h" /* generateUuid */])() + '.' + extension;
                                _context.next = 11;
                                return this.uploadHandler({
                                    base64: image,
                                    filename: finalName
                                });

                            case 11:
                                url = _context.sent;

                                this.$emit('input', url);
                                _context.next = 19;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](4);

                                console.error('Cannot upload image', _context.t0);
                                this.error = 'Cannot upload image';

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 15]]);
            }));

            function onChange(_x) {
                return _ref.apply(this, arguments);
            }

            return onChange;
        }(),
        onRemove: function onRemove() {
            this.$emit('input', null);
        },
        uploadHandler: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
                var base64 = _ref2.base64,
                    filename = _ref2.filename;

                var _ref4, url;

                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                base64 = base64.substr(base64.indexOf(',') + 1);
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.REQUEST({
                                    endpoint: 'image',
                                    method: 'POST',
                                    data: {
                                        filename: filename,
                                        base64: base64
                                    }
                                });

                            case 4:
                                _ref4 = _context2.sent;
                                url = _ref4.url;
                                return _context2.abrupt('return', url);

                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2['catch'](1);
                                throw _context2.t0;

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 9]]);
            }));

            function uploadHandler(_x2) {
                return _ref3.apply(this, arguments);
            }

            return uploadHandler;
        }()
    })
});

/***/ }),
/* 359 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/packages/vue-picture-input/PictureInput.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: Number.MAX_SAFE_INTEGER
    },
    height: {
      type: [String, Number],
      default: Number.MAX_SAFE_INTEGER
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: Number.MAX_SAFE_INTEGER
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    hideChangeButton: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    changeOnClick: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    alertOnError: {
      type: Boolean,
      default: true
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;

    this.$on('error', this.onError);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.$off('error', this.onError);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onClick: function onClick() {
      if (!this.imageSelected) {
        this.selectImage();
        return;
      }

      if (this.changeOnClick) {
        this.selectImage();
      }

      this.$emit('click');
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e, prefill) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        this.$emit('error', {
          type: 'fileSize',
          fileSize: files[0].size,
          fileType: files[0].type,
          fileName: files[0].name,
          message: this.strings.fileSize + ' (' + this.size + 'MB)'
        });
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;

      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          this.$emit('error', {
            type: 'fileType',
            fileSize: files[0].size,
            fileType: files[0].type,
            fileName: files[0].name,
            message: this.strings.fileType
          });
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0], prefill || false);
      } else {
        if (prefill) {
          this.$emit('prefill');
        } else {
          this.$emit('change', this.image);
        }
      }
    },
    onError: function onError(error) {
      if (this.alertOnError) {
        alert(error.message);
      }
    },
    loadImage: function loadImage(file, prefill) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          if (prefill) {
            _this2.$emit('prefill');
          } else {
            _this2.$emit('change', _this2.image);
          }
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);
              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }
            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      var previewRatio = this.previewWidth / this.previewHeight;
      if (this.crop) {
        if (this.imageRatio >= previewRatio) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio >= previewRatio) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      if (!this.$refs.container) return;
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this4 = this;

      // ie 11 support
      var File = window.File;
      try {
        new File([], ''); // eslint-disable-line
      } catch (e) {
        File = function (_Blob) {
          _inherits(File, _Blob);

          function File(chunks, filename) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            _classCallCheck(this, File);

            var _this3 = _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).call(this, chunks, opts));

            _this3.lastModifiedDate = new Date();
            _this3.lastModified = +_this3.lastModifiedDate;
            _this3.name = filename;
            return _this3;
          }

          return File;
        }(Blob);
      }
      options = Object.assign({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source, true);
        } else {
          this.$emit('prefill');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');

        if (mediaType.includes('svg')) {
          mediaType = 'image/svg+xml';
        }

        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this4.onFileChange(e, true);
      }).catch(function (err) {
        _this4.$emit('error', {
          type: 'failedPrefill',
          message: 'Failed loading prefill image: ' + err
        });
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),
/* 360 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseRadioBox.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//



var CUSTOM_EVENTS = {
  input: 'input'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionValue: String,
    value: String,
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    listeners: function listeners() {
      var _this = this;

      var filteredListeners = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["omit"])(this.$listeners, Object.values(CUSTOM_EVENTS));

      return Object.assign({}, filteredListeners, {
        change: function change(e) {
          return _this.$emit(CUSTOM_EVENTS.input, e.target.value);
        }
      });
    },
    checked: function checked() {
      return this.optionValue === this.value;
    },
    iconName: function iconName() {
      return this.checked ? 'radio-selected' : 'radio-unselected';
    }
  }
});

/***/ }),
/* 361 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseSelect.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseInput__ = __webpack_require__(/*! ./BaseInput */ 50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseInput__["default"],
  props: {
    options: Array, // [ {label, value} ]
    labelKey: { default: 'label' },
    valueKey: { default: 'value' },
    placeholder: String,
    learnAction: Function,
    learnLabel: String,
    groupedOptions: Boolean,
    showNullOption: Boolean
  },
  data: function data() {
    return {
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this._uid;
  },

  computed: {
    hintId: function hintId() {
      return this._uid + "-hint";
    },
    errorMessageId: function errorMessageId() {
      return this._uid + "-error";
    },
    describedBy: function describedBy() {
      if (this.hint) {
        return this.hintId;
      }

      return "";
    },
    errorMessage: function errorMessage() {
      if (this.hasErrors) {
        return this.errorMessageId;
      }

      return "";
    }
  }
});

/***/ }),
/* 362 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseSpinnerBig.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 363 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseSwitcher.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: [Boolean, String],
    trueLabel: { default: 'OPEN' },
    falseLabel: { default: 'CLOSED' },
    label: String,
    hint: String,
    fillSpace: Boolean
  },
  data: function data() {
    return {
      bool: false
    };
  },

  computed: {
    className: function className() {
      return {
        'base-switcher--fill-space': this.fillSpace
      };
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.bool = !!val;
      },

      immediate: true
    },
    bool: function bool(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 364 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseTextarea.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseInput__ = __webpack_require__(/*! ./BaseInput */ 50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseInput__["default"],
  props: {
    minHeight: { default: 150 }
  }
});

/***/ }),
/* 365 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/BaseWysiwyg.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseInput__ = __webpack_require__(/*! ./BaseInput */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_vue_tinymce_editor_src_components_TinymceVue__ = __webpack_require__(/*! @/packages/vue-tinymce-editor/src/components/TinymceVue */ 949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(/*! vuex */ 16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__BaseInput__["default"],

  components: {
    tinymce: __WEBPACK_IMPORTED_MODULE_1__packages_vue_tinymce_editor_src_components_TinymceVue__["a" /* default */]
  },

  data: function data() {
    return {
      id: Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["h" /* generateUuid */])(),
      valueModel: this.value || '',
      options: {
        images_upload_handler: this.uploadHandler,
        branding: false,
        convert_urls: false
      }
    };
  },


  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('shopifyApi', ['REQUEST']), {
    uploadHandler: function uploadHandler(blobInfo, success, failure) {
      this.REQUEST({
        endpoint: 'image',
        method: 'POST',
        data: {
          filename: blobInfo.filename(),
          base64: blobInfo.base64()
        }
      }).then(function (data) {
        success(data.url);
      }).catch(function (error) {
        console.error('Cannot upload image', error);
        failure('Cannot upload image');
      });
    }
  }),

  computed: {
    listeners: function listeners() {
      var _this = this;

      return {
        input: function input(e) {
          return _this.$emit('input', _this.valueModel);
        },
        editorInit: function editorInit(editor) {
          return editor.setContent(_this.valueModel);
        }
      };
    }
  }
});

/***/ }),
/* 366 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/packages/vue-tinymce-editor/src/components/TinymceVue.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tinymce_tinymce__ = __webpack_require__(/*! ../../../tinymce/tinymce */ 951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tinymce_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tinymce_themes_modern_theme__ = __webpack_require__(/*! ../../../tinymce/themes/modern/theme */ 952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tinymce_themes_modern_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tinymce_themes_modern_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_plugins_advlist__ = __webpack_require__(/*! ../../../tinymce/plugins/advlist */ 953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_plugins_advlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tinymce_plugins_advlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tinymce_plugins_wordcount__ = __webpack_require__(/*! ../../../tinymce/plugins/wordcount */ 955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tinymce_plugins_wordcount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tinymce_plugins_wordcount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tinymce_plugins_autolink__ = __webpack_require__(/*! ../../../tinymce/plugins/autolink */ 957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tinymce_plugins_autolink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tinymce_plugins_autolink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tinymce_plugins_autosave__ = __webpack_require__(/*! ../../../tinymce/plugins/autosave */ 959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tinymce_plugins_autosave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tinymce_plugins_autosave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tinymce_plugins_charmap__ = __webpack_require__(/*! ../../../tinymce/plugins/charmap */ 961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tinymce_plugins_charmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tinymce_plugins_charmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tinymce_plugins_codesample__ = __webpack_require__(/*! ../../../tinymce/plugins/codesample */ 963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tinymce_plugins_codesample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tinymce_plugins_codesample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tinymce_plugins_contextmenu__ = __webpack_require__(/*! ../../../tinymce/plugins/contextmenu */ 965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tinymce_plugins_contextmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tinymce_plugins_contextmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tinymce_plugins_emoticons__ = __webpack_require__(/*! ../../../tinymce/plugins/emoticons */ 967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tinymce_plugins_emoticons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tinymce_plugins_emoticons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tinymce_plugins_fullscreen__ = __webpack_require__(/*! ../../../tinymce/plugins/fullscreen */ 969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tinymce_plugins_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tinymce_plugins_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tinymce_plugins_hr__ = __webpack_require__(/*! ../../../tinymce/plugins/hr */ 971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tinymce_plugins_hr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__tinymce_plugins_hr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tinymce_plugins_imagetools__ = __webpack_require__(/*! ../../../tinymce/plugins/imagetools */ 973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__tinymce_plugins_imagetools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__tinymce_plugins_imagetools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tinymce_plugins_insertdatetime__ = __webpack_require__(/*! ../../../tinymce/plugins/insertdatetime */ 975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tinymce_plugins_insertdatetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__tinymce_plugins_insertdatetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tinymce_plugins_link__ = __webpack_require__(/*! ../../../tinymce/plugins/link */ 977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tinymce_plugins_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__tinymce_plugins_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tinymce_plugins_media__ = __webpack_require__(/*! ../../../tinymce/plugins/media */ 979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tinymce_plugins_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__tinymce_plugins_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tinymce_plugins_noneditable__ = __webpack_require__(/*! ../../../tinymce/plugins/noneditable */ 981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tinymce_plugins_noneditable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__tinymce_plugins_noneditable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tinymce_plugins_paste__ = __webpack_require__(/*! ../../../tinymce/plugins/paste */ 983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tinymce_plugins_paste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__tinymce_plugins_paste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tinymce_plugins_print__ = __webpack_require__(/*! ../../../tinymce/plugins/print */ 985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tinymce_plugins_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__tinymce_plugins_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__tinymce_plugins_searchreplace__ = __webpack_require__(/*! ../../../tinymce/plugins/searchreplace */ 987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__tinymce_plugins_searchreplace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__tinymce_plugins_searchreplace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tinymce_plugins_tabfocus__ = __webpack_require__(/*! ../../../tinymce/plugins/tabfocus */ 989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tinymce_plugins_tabfocus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__tinymce_plugins_tabfocus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tinymce_plugins_template__ = __webpack_require__(/*! ../../../tinymce/plugins/template */ 991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tinymce_plugins_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__tinymce_plugins_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tinymce_plugins_textpattern__ = __webpack_require__(/*! ../../../tinymce/plugins/textpattern */ 993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tinymce_plugins_textpattern___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__tinymce_plugins_textpattern__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tinymce_plugins_visualblocks__ = __webpack_require__(/*! ../../../tinymce/plugins/visualblocks */ 995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tinymce_plugins_visualblocks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__tinymce_plugins_visualblocks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tinymce_plugins_anchor__ = __webpack_require__(/*! ../../../tinymce/plugins/anchor */ 997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tinymce_plugins_anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__tinymce_plugins_anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__tinymce_plugins_autoresize__ = __webpack_require__(/*! ../../../tinymce/plugins/autoresize */ 999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__tinymce_plugins_autoresize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__tinymce_plugins_autoresize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__tinymce_plugins_bbcode__ = __webpack_require__(/*! ../../../tinymce/plugins/bbcode */ 1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__tinymce_plugins_bbcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__tinymce_plugins_bbcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__tinymce_plugins_code__ = __webpack_require__(/*! ../../../tinymce/plugins/code */ 1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__tinymce_plugins_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__tinymce_plugins_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tinymce_plugins_colorpicker__ = __webpack_require__(/*! ../../../tinymce/plugins/colorpicker */ 1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tinymce_plugins_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__tinymce_plugins_colorpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tinymce_plugins_directionality__ = __webpack_require__(/*! ../../../tinymce/plugins/directionality */ 1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tinymce_plugins_directionality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__tinymce_plugins_directionality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__tinymce_plugins_fullpage__ = __webpack_require__(/*! ../../../tinymce/plugins/fullpage */ 1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__tinymce_plugins_fullpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__tinymce_plugins_fullpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__tinymce_plugins_help__ = __webpack_require__(/*! ../../../tinymce/plugins/help */ 1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__tinymce_plugins_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__tinymce_plugins_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__tinymce_plugins_image__ = __webpack_require__(/*! ../../../tinymce/plugins/image */ 1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__tinymce_plugins_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__tinymce_plugins_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__tinymce_plugins_importcss__ = __webpack_require__(/*! ../../../tinymce/plugins/importcss */ 1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__tinymce_plugins_importcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__tinymce_plugins_importcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tinymce_plugins_legacyoutput__ = __webpack_require__(/*! ../../../tinymce/plugins/legacyoutput */ 1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tinymce_plugins_legacyoutput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__tinymce_plugins_legacyoutput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tinymce_plugins_lists__ = __webpack_require__(/*! ../../../tinymce/plugins/lists */ 1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tinymce_plugins_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__tinymce_plugins_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__tinymce_plugins_nonbreaking__ = __webpack_require__(/*! ../../../tinymce/plugins/nonbreaking */ 1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__tinymce_plugins_nonbreaking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__tinymce_plugins_nonbreaking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__tinymce_plugins_pagebreak__ = __webpack_require__(/*! ../../../tinymce/plugins/pagebreak */ 1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__tinymce_plugins_pagebreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__tinymce_plugins_pagebreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__tinymce_plugins_preview__ = __webpack_require__(/*! ../../../tinymce/plugins/preview */ 1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__tinymce_plugins_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__tinymce_plugins_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tinymce_plugins_save__ = __webpack_require__(/*! ../../../tinymce/plugins/save */ 1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tinymce_plugins_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__tinymce_plugins_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__tinymce_plugins_spellchecker__ = __webpack_require__(/*! ../../../tinymce/plugins/spellchecker */ 1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__tinymce_plugins_spellchecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__tinymce_plugins_spellchecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__tinymce_plugins_table__ = __webpack_require__(/*! ../../../tinymce/plugins/table */ 1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__tinymce_plugins_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__tinymce_plugins_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tinymce_plugins_textcolor__ = __webpack_require__(/*! ../../../tinymce/plugins/textcolor */ 1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tinymce_plugins_textcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__tinymce_plugins_textcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__tinymce_plugins_toc__ = __webpack_require__(/*! ../../../tinymce/plugins/toc */ 1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__tinymce_plugins_toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__tinymce_plugins_toc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tinymce_plugins_visualchars__ = __webpack_require__(/*! ../../../tinymce/plugins/visualchars */ 1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__tinymce_plugins_visualchars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__tinymce_plugins_visualchars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__tinymce_skins_lightgray_skin_min_css__ = __webpack_require__(/*! ../../../tinymce/skins/lightgray/skin.min.css */ 1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__tinymce_skins_lightgray_skin_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__tinymce_skins_lightgray_skin_min_css__);
//
//
//
//
//
//

// Import TinyMCE


// A theme is also required


// Any plugins you want to use has to be imported














































/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tinymce',
    props: {
        id: {
            type: String,
            required: true
        },
        htmlClass: { default: '', type: String },
        value: { default: '' },
        plugins: { default: function _default() {
                return ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample'];
            }, type: Array
        },
        toolbar1: { default: 'formatselect | bold italic  strikethrough  forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat', type: String },
        toolbar2: { default: '', type: String },
        other_options: { default: function _default() {
                return {};
            }, type: Object },
        readonly: { default: false, type: Boolean }
    },
    data: function data() {
        return {
            content: '',
            editor: null,
            cTinyMce: null,
            checkerTimeout: null,
            isTyping: false
        };
    },
    mounted: function mounted() {
        this.content = this.value;
        this.init();
    },
    beforeDestroy: function beforeDestroy() {
        this.editor.destroy();
    },

    watch: {
        value: function value(newValue) {
            if (!this.isTyping) {
                if (this.editor !== null) this.editor.setContent(newValue);else this.content = newValue;
            }
        },
        readonly: function readonly(value) {
            if (value) {
                this.editor.setMode('readonly');
            } else {
                this.editor.setMode('design');
            }
        }
    },
    methods: {
        init: function init() {
            var options = {
                selector: '#' + this.id,
                skin: false,
                toolbar1: this.toolbar1,
                toolbar2: this.toolbar2,
                plugins: this.plugins,
                init_instance_callback: this.initEditor
            };
            __WEBPACK_IMPORTED_MODULE_0__tinymce_tinymce___default.a.init(this.concatAssciativeArrays(options, this.other_options));
        },
        initEditor: function initEditor(editor) {
            var _this = this;

            this.editor = editor;
            editor.on('KeyUp', function (e) {
                _this.submitNewContent();
            });
            editor.on('Change', function (e) {
                if (_this.editor.getContent() !== _this.value) {
                    _this.submitNewContent();
                }
                _this.$emit('editorChange', e);
            });
            editor.on('init', function (e) {
                editor.setContent(_this.content);
                _this.$emit('input', _this.content);
            });
            if (this.readonly) {
                this.editor.setMode('readonly');
            } else {
                this.editor.setMode('design');
            }

            this.$emit('editorInit', editor);
        },
        concatAssciativeArrays: function concatAssciativeArrays(array1, array2) {
            if (array2.length === 0) return array1;
            if (array1.length === 0) return array2;
            var dest = [];
            for (var key in array1) {
                dest[key] = array1[key];
            }for (var _key in array2) {
                dest[_key] = array2[_key];
            }return dest;
        },
        submitNewContent: function submitNewContent() {
            var _this2 = this;

            this.isTyping = true;
            if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
            this.checkerTimeout = setTimeout(function () {
                _this2.isTyping = false;
            }, 300);

            this.$emit('input', this.editor.getContent());
        }
    }
});

/***/ }),
/* 367 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/typography/TypographyInputError.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String
    },
    tag: {
      type: String,
      default: 'p'
    }
  }
});

/***/ }),
/* 368 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/typography/TypographyInputHint.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String
    },
    tag: {
      type: String,
      default: 'p'
    },
    isDanger: Boolean
  },

  computed: {
    className: function className() {
      return {
        '-danger': this.isDanger
      };
    }
  }
});

/***/ }),
/* 369 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/typography/TypographyMeta.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tag: {
      type: String,
      default: 'p'
    }
  }
});

/***/ }),
/* 370 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/src/index.js */371);


/***/ }),
/* 371 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins__ = __webpack_require__(/*! ./plugins */ 374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores__ = __webpack_require__(/*! ./stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta__ = __webpack_require__(/*! vue-meta */ 723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root_vue__ = __webpack_require__(/*! ./root.vue */ 724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_main_scss__ = __webpack_require__(/*! @/assets/styles/_main.scss */ 810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_nprogress_css__ = __webpack_require__(/*! @/assets/styles/nprogress.css */ 811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_styles_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_base__ = __webpack_require__(/*! @/components/base */ 812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_typography__ = __webpack_require__(/*! @/components/typography */ 1042);


var initApp = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
    var isMobile, resizeTimer, appInstance;
    return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isMobile = function isMobile() {
              return window.innerWidth <= 1045;
            };

            __WEBPACK_IMPORTED_MODULE_4__stores__["default"].commit('ui/SET_IS_MOBILE', { value: isMobile() });

            window.addEventListener('resize', function (ev) {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_4__stores__["default"].commit('ui/SET_IS_MOBILE', { value: isMobile() });
              }, 100);
            });

            appInstance = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
              store: __WEBPACK_IMPORTED_MODULE_4__stores__["default"],
              router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* router */],
              render: function render(createElement) {
                return createElement(__WEBPACK_IMPORTED_MODULE_6__root_vue__["a" /* default */]);
              }
            }).$mount('#app');


            appInstance.$validator.localize('en');

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function initApp() {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










// Global components >>>


// <<< Global components
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_meta___default.a);

// Configure Vue to ignore Shopify App Bridge web components
// These are native custom elements provided by the App Bridge CDN script, not Vue components
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.ignoredElements = ['s-page', // Shopify Page component (title bar)
's-button', // Shopify Button component
's-link' // Shopify Link component
];

initApp();

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */
/*!******************************!*\
  !*** ./src/plugins/index.js ***!
  \******************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(/*! ./polyfills */ 375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vee_validate__ = __webpack_require__(/*! ./vee-validate */ 487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_router__ = __webpack_require__(/*! ./vue-router */ 489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__(/*! ./event-bus */ 490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_scrollto__ = __webpack_require__(/*! ./vue-scrollto */ 491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__v_click_outside__ = __webpack_require__(/*! ./v-click-outside */ 493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_visible__ = __webpack_require__(/*! ./vue-visible */ 495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__(/*! ./filters */ 497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations__ = __webpack_require__(/*! ./translations */ 498);










/***/ }),
/* 375 */
/*!**********************************!*\
  !*** ./src/plugins/polyfills.js ***!
  \**********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(/*! core-js/modules/es6.typed.array-buffer */ 376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(/*! core-js/modules/es6.typed.data-view */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int8-array */ 378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-array */ 383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-clamped-array */ 384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int16-array */ 385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint16-array */ 386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int32-array */ 387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint32-array */ 388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float32-array */ 389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float64-array */ 390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(/*! core-js/modules/es6.map */ 391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(/*! core-js/modules/es6.set */ 393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(/*! core-js/modules/es6.weak-map */ 394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(/*! core-js/modules/es6.weak-set */ 395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(/*! core-js/modules/es6.reflect.apply */ 396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(/*! core-js/modules/es6.reflect.construct */ 397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.define-property */ 399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.delete-property */ 400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(/*! core-js/modules/es6.reflect.get */ 401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-own-property-descriptor */ 402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-prototype-of */ 403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(/*! core-js/modules/es6.reflect.has */ 404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.reflect.is-extensible */ 405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(/*! core-js/modules/es6.reflect.own-keys */ 406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.reflect.prevent-extensions */ 407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(/*! core-js/modules/es6.reflect.set */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.set-prototype-of */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(/*! core-js/modules/es6.promise */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(/*! core-js/modules/es6.symbol */ 414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(/*! core-js/modules/es6.object.freeze */ 417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(/*! core-js/modules/es6.object.seal */ 418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.object.prevent-extensions */ 419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(/*! core-js/modules/es6.object.is-frozen */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(/*! core-js/modules/es6.object.is-sealed */ 421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.object.is-extensible */ 422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-descriptor */ 423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.get-prototype-of */ 424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(/*! core-js/modules/es6.object.keys */ 425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-names */ 426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(/*! core-js/modules/es6.object.assign */ 427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(/*! core-js/modules/es6.object.is */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ 430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(/*! core-js/modules/es6.function.name */ 431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(/*! core-js/modules/es6.string.raw */ 432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(/*! core-js/modules/es6.string.from-code-point */ 433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(/*! core-js/modules/es6.string.code-point-at */ 434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(/*! core-js/modules/es6.string.repeat */ 436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(/*! core-js/modules/es6.string.starts-with */ 437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(/*! core-js/modules/es6.string.ends-with */ 438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(/*! core-js/modules/es6.string.includes */ 439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(/*! core-js/modules/es6.regexp.flags */ 440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(/*! core-js/modules/es6.regexp.match */ 442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(/*! core-js/modules/es6.regexp.replace */ 443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(/*! core-js/modules/es6.regexp.split */ 444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(/*! core-js/modules/es6.regexp.search */ 445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(/*! core-js/modules/es6.array.from */ 446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(/*! core-js/modules/es6.array.of */ 447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(/*! core-js/modules/es6.array.copy-within */ 448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(/*! core-js/modules/es6.array.find */ 449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(/*! core-js/modules/es6.array.find-index */ 450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(/*! core-js/modules/es6.array.fill */ 451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */ 84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(/*! core-js/modules/es6.number.is-finite */ 452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-integer */ 453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-safe-integer */ 454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(/*! core-js/modules/es6.number.is-nan */ 455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(/*! core-js/modules/es6.number.epsilon */ 456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.min-safe-integer */ 457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.max-safe-integer */ 458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(/*! core-js/modules/es6.math.acosh */ 459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(/*! core-js/modules/es6.math.asinh */ 460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(/*! core-js/modules/es6.math.atanh */ 461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(/*! core-js/modules/es6.math.cbrt */ 462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(/*! core-js/modules/es6.math.clz32 */ 463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(/*! core-js/modules/es6.math.cosh */ 464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(/*! core-js/modules/es6.math.expm1 */ 465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(/*! core-js/modules/es6.math.fround */ 466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(/*! core-js/modules/es6.math.hypot */ 468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(/*! core-js/modules/es6.math.imul */ 469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(/*! core-js/modules/es6.math.log1p */ 470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(/*! core-js/modules/es6.math.log10 */ 471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(/*! core-js/modules/es6.math.log2 */ 472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(/*! core-js/modules/es6.math.sign */ 473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(/*! core-js/modules/es6.math.sinh */ 474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(/*! core-js/modules/es6.math.tanh */ 475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(/*! core-js/modules/es6.math.trunc */ 476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(/*! core-js/modules/es7.array.includes */ 477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(/*! core-js/modules/es7.object.values */ 478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(/*! core-js/modules/es7.object.entries */ 479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ 480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(/*! core-js/modules/es7.string.pad-start */ 481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(/*! core-js/modules/es7.string.pad-end */ 482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(/*! core-js/modules/web.timers */ 483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(/*! core-js/modules/web.immediate */ 484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(/*! core-js/modules/web.dom.iterable */ 485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(/*! regenerator-runtime/runtime */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_smoothscroll_polyfill__ = __webpack_require__(/*! smoothscroll-polyfill */ 486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_smoothscroll_polyfill__);




































































































// kick off the polyfill!
__WEBPACK_IMPORTED_MODULE_97_smoothscroll_polyfill___default.a.polyfill();

/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/*!*************************************!*\
  !*** ./src/plugins/vee-validate.js ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(/*! vee-validate */ 488);



__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('max16digit', {
  getMessage: function getMessage(field) {
    return 'The ' + field + ' field may contain up to 16 digits.';
  },
  validate: function validate(value) {
    var test = value.match(/\d+/g);

    if (test) {
      return test.join('').length <= 16;
    } else {
      return true;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('phone', {
  getMessage: function getMessage(field) {
    return 'The ' + field + ' field accepts up to 16 digits, \u201C-\u201C, \u201C+\u201D, \u201C(\u201C and \u201C)\u201D.';
  },
  validate: function validate(value) {
    return !/[^\d\(\)\-\+\s]/.test(value);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('excluded', {
  validate: function validate(value, args) {
    if (args.length) {
      return args.indexOf(value) === -1;
    } else {
      return true;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */], {
  events: 'blur',
  delay: 100,
  fieldsBagName: 'inputs',
  dictionary: {
    en: {
      // messages: {
      //   required: () => 'Field is required',
      //   numeric: () => 'Field may only contain numeric characters',
      //   integer: () => 'Field must be an integer'
      // },
      custom: {
        key: {
          excluded: 'Key already used.'
        }
      }
    }
  }
});

/***/ }),
/* 488 */,
/* 489 */
/*!***********************************!*\
  !*** ./src/plugins/vue-router.js ***!
  \***********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 123);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/***/ }),
/* 490 */
/*!**********************************!*\
  !*** ./src/plugins/event-bus.js ***!
  \**********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);


var eventBus = {
  install: function install() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(eventBus);

/***/ }),
/* 491 */
/*!*************************************!*\
  !*** ./src/plugins/vue-scrollto.js ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(/*! vue-scrollto */ 492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

/***/ }),
/* 492 */,
/* 493 */
/*!****************************************!*\
  !*** ./src/plugins/v-click-outside.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_click_outside__ = __webpack_require__(/*! v-click-outside */ 494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_click_outside__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_v_click_outside___default.a);

/***/ }),
/* 494 */,
/* 495 */
/*!************************************!*\
  !*** ./src/plugins/vue-visible.js ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_visible__ = __webpack_require__(/*! vue-visible */ 496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_visible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_visible__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_visible___default.a);

/***/ }),
/* 496 */,
/* 497 */
/*!********************************!*\
  !*** ./src/plugins/filters.js ***!
  \********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('sentenceCase', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["lowerCase"])(value.slice(1));
});

/***/ }),
/* 498 */
/*!*************************************!*\
  !*** ./src/plugins/translations.js ***!
  \*************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translations_en__ = __webpack_require__(/*! @/translations/en */ 124);



var translations = {
    install: function install() {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$translations = __WEBPACK_IMPORTED_MODULE_1__translations_en__["a" /* default */];
    }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(translations);

/***/ }),
/* 499 */
/*!***********************!*\
  !*** ./src/router.js ***!
  \***********************/
/*! exports provided: router, routes */
/*! exports used: router */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores__ = __webpack_require__(/*! ./stores */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_error__ = __webpack_require__(/*! ./pages/error */ 576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_install_install__ = __webpack_require__(/*! ./pages/install/install */ 579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_install_install_payment__ = __webpack_require__(/*! ./pages/install/install-payment */ 582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_install_install_payment_confirm__ = __webpack_require__(/*! ./pages/install/install-payment-confirm */ 584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_install_install_payment_decline__ = __webpack_require__(/*! ./pages/install/install-payment-decline */ 586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_page_home__ = __webpack_require__(/*! ./pages/page-home */ 589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__ = __webpack_require__(/*! ./pages/dummy-router-view */ 603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_logger__ = __webpack_require__(/*! ./helpers/logger */ 125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_is_shopify_embedded__ = __webpack_require__(/*! ./helpers/is-shopify-embedded */ 126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_admin_url__ = __webpack_require__(/*! ./helpers/admin-url */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__ = __webpack_require__(/*! ./pages/page-edit */ 605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__ = __webpack_require__(/*! ./pages/page-manage */ 694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_page_manage_customobjects__ = __webpack_require__(/*! ./pages/page-manage-customobjects */ 709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_page_manage_integrations__ = __webpack_require__(/*! ./pages/page-manage-integrations */ 714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_page_select__ = __webpack_require__(/*! ./pages/page-select */ 720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__models_modal_datasets_model__ = __webpack_require__(/*! @/models/modal-datasets.model */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_check_storage__ = __webpack_require__(/*! ./helpers/check-storage */ 94);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






















var routes = [{
    name: 'error',
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_error__["a" /* default */]
}, {
    name: 'install',
    path: '/install',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_install_install__["a" /* default */],
    children: [{
        name: 'install.payment',
        path: 'payment',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_install_install_payment__["a" /* default */]
    }, {
        name: 'install.payment.confirm',
        path: 'payment/confirm',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_install_install_payment_confirm__["a" /* default */]
    }, {
        name: 'install.payment.decline',
        path: 'payment/decline',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_install_install_payment_decline__["a" /* default */],
        meta: { no_spinner: true }
    }]
}, {
    name: 'home',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_page_home__["a" /* default */],
    meta: {
        title: 'Dashboard',
        buttonsSet: 'dashboard',
        store: 'shopCustomobjectsgroupsList',
        scope: 'customobjects'
    }
}, {
    name: 'select',
    path: '/select-resource',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_page_select__["a" /* default */],
    meta: {
        title: 'Select Resource'
    }
}, {
    name: 'customobjectsgroups',
    path: '/customobjectsgroups',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'customobjectsgroups.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Custom objects groups Manage',
            store: 'shopCustomobjectsgroupsManage',
            scope: 'customobjectsgroups'
        }
    }]
}, {
    name: 'customobjects',
    path: '/customobjects',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'customobjects.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_15__pages_page_manage_customobjects__["a" /* default */],
        meta: {
            title: 'Custom objects Manage',
            store: 'shopCustomobjectsgroupsManage',
            scope: 'customobjectsgroups'
        }
    }, {
        name: 'customobjects.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Custom objects',
            store: 'shopCustomobjectsEdit',
            scope: 'customobjects'
        }
    }]
}, {
    name: 'articles',
    path: '/articles',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'articles.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Articles Manage',
            store: 'shopArticlesManage',
            scope: 'articles'
        }
    }, {
        name: 'articles.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Articles Manage',
            store: 'shopArticlesEdit',
            scope: 'articles'
        }
    }]
}, {
    name: 'blogs',
    path: '/blogs',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'blogs.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Blogs Manage',
            store: 'shopBlogsManage',
            scope: 'blogs'
        }
    }, {
        name: 'blogs.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Blogs Edit',
            store: 'shopBlogsEdit',
            scope: 'blogs'
        }
    }]
}, {
    name: 'collections',
    path: '/collections',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'collections.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Collections Manage',
            store: 'shopCollectionsManage',
            scope: 'collections'
        }
    }, {
        name: 'collections.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Collections Edit',
            store: 'shopCollectionsEdit',
            scope: 'collections'
        }
    }]
}, {
    name: 'customers',
    path: '/customers',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'customers.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Customers Manage',
            store: 'shopCustomersManage',
            scope: 'customers'
        }
    }, {
        name: 'customers.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Customers Edit',
            store: 'shopCustomersEdit',
            scope: 'customers'
        }
    }]
}, {
    name: 'globals',
    path: '/globals',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'globals.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Globals Manage',
            store: 'shopGlobalsManage',
            scope: 'shop'
        }
    }, {
        name: 'globals.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Globals Edit',
            store: 'shopGlobalsEdit',
            scope: 'shop'
        }
    }]
}, {
    name: 'orders',
    path: '/orders',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'orders.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Orders Manage',
            store: 'shopOrdersManage',
            scope: 'orders'
        }
    }, {
        name: 'orders.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Orders Edit',
            store: 'shopOrdersEdit',
            scope: 'orders'
        }
    }]
}, {
    name: 'pages',
    path: '/pages',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'pages.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Pages Manage',
            store: 'shopPagesManage',
            scope: 'pages'
        }
    }, {
        name: 'pages.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Pages Edit',
            store: 'shopPagesEdit',
            scope: 'pages'
        }
    }]
}, {
    name: 'products',
    path: '/products',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'products.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Products Manage',
            store: 'shopProductsManage',
            scope: 'products'
        }
    }, {
        name: 'products.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Products Edit',
            store: 'shopProductsEdit',
            scope: 'products',
            integrations: true
        }
    }]
}, {
    name: 'variants',
    path: '/variants',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'variants.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_page_manage__["a" /* default */],
        meta: {
            title: 'Variants Manage',
            store: 'shopVariantsManage',
            scope: 'variants'
        }
    }, {
        name: 'variants.edit',
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_page_edit__["a" /* default */],
        meta: {
            title: 'Variants Edit',
            store: 'shopVariantsEdit',
            scope: 'variants'
        }
    }]
}, {
    name: 'integrations',
    path: '/integrations',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_dummy_router_view__["a" /* default */],
    children: [{
        name: 'integrations.manage',
        path: 'manage',
        component: __WEBPACK_IMPORTED_MODULE_16__pages_page_manage_integrations__["a" /* default */],
        meta: {
            title: 'Integrations Manage',
            store: 'settingsIntegrations'
        }
    }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: routes
});

var isAppCharged = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var charge, isActive;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        charge = __WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shop/charge'];


                        console.log('💳 Checking App Charge Status:', {
                            hasCachedCharge: !!charge,
                            cachedChargeStatus: charge
                        });

                        if (charge) {
                            _context.next = 15;
                            break;
                        }

                        console.log('🔄 Fetching charge from API...');
                        _context.prev = 4;
                        _context.next = 7;
                        return __WEBPACK_IMPORTED_MODULE_2__stores__["default"].dispatch('shop/GET_SHOP_CHARGE');

                    case 7:
                        charge = _context.sent;

                        console.log('✅ Charge retrieved from API:', { status: charge });
                        _context.next = 15;
                        break;

                    case 11:
                        _context.prev = 11;
                        _context.t0 = _context['catch'](4);

                        console.log('❌ Failed to get charge:', _context.t0);
                        return _context.abrupt('return', null);

                    case 15:
                        isActive = charge ? charge.status === 'active' : false;

                        console.log('💰 Final Charge Check:', {
                            chargeStatus: charge,
                            isActive: isActive,
                            chargeObject: charge
                        });

                        return _context.abrupt('return', isActive);

                    case 18:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this, [[4, 11]]);
    }));

    return function isAppCharged() {
        return _ref.apply(this, arguments);
    };
}();

var isShopDev = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var plan, isDev;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        plan = __WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shop/plan'];


                        console.log('🧪 Checking Dev Plan Status:', {
                            hasCachedPlan: !!plan,
                            cachedPlan: plan
                        });

                        if (plan) {
                            _context2.next = 15;
                            break;
                        }

                        console.log('🔄 Fetching plan from API...');
                        _context2.prev = 4;
                        _context2.next = 7;
                        return __WEBPACK_IMPORTED_MODULE_2__stores__["default"].dispatch('shop/GET_SHOP_PLAN');

                    case 7:
                        plan = _context2.sent;

                        console.log('✅ Plan retrieved from API:', { plan: plan });
                        _context2.next = 15;
                        break;

                    case 11:
                        _context2.prev = 11;
                        _context2.t0 = _context2['catch'](4);

                        console.error('❌ PLAN ERROR', _context2.t0);
                        return _context2.abrupt('return', null);

                    case 15:
                        isDev = plan && (plan === 'trial' || plan === 'affiliate' || plan === 'partner_test');

                        console.log('🔬 Final Dev Plan Check:', {
                            plan: plan,
                            isDev: isDev,
                            devPlans: ['trial', 'affiliate', 'partner_test']
                        });

                        return _context2.abrupt('return', isDev);

                    case 18:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this, [[4, 11]]);
    }));

    return function isShopDev() {
        return _ref2.apply(this, arguments);
    };
}();

var initShopifyBar = function initShopifyBar() {
    // Simplified - App Bridge now initializes automatically via script tag
    if (!__WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shopifyBar/init']) {
        Object(__WEBPACK_IMPORTED_MODULE_10__helpers_logger__["a" /* logger */])('init shopify bar');

        __WEBPACK_IMPORTED_MODULE_2__stores__["default"].dispatch('shopifyBar/INIT');
    }
};

var chargeApp = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref3) {
        var to = _ref3.to,
            from = _ref3.from,
            next = _ref3.next;
        var charge;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        if (!(to.name === 'install.payment.confirm' || to.name === 'install.payment' || to.name === 'install.payment.decline')) {
                            _context3.next = 2;
                            break;
                        }

                        return _context3.abrupt('return', next());

                    case 2:
                        charge = __WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shop/charge'];


                        Object(__WEBPACK_IMPORTED_MODULE_10__helpers_logger__["a" /* logger */])('charge');

                        if (!(charge && charge.status !== 'accepted' && charge.status !== 'cancelled')) {
                            _context3.next = 6;
                            break;
                        }

                        return _context3.abrupt('return', next({ name: 'install.payment.decline' }));

                    case 6:
                        return _context3.abrupt('return', next({ name: 'install.payment' }));

                    case 7:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    return function chargeApp(_x) {
        return _ref4.apply(this, arguments);
    };
}();

var initInstalledApp = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5) {
        var to = _ref5.to,
            from = _ref5.from,
            next = _ref5.next;
        var shopifyBarReady;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        console.log('🏁 INIT INSTALLED APP');

                        // --> Update title (using new web component approach)
                        shopifyBarReady = __WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shopifyBar/ready'];

                        console.log('📊 Updating Shopify bar:', {
                            shopifyBarReady: shopifyBarReady,
                            title: to.meta.title,
                            buttonsSet: to.meta.buttonsSet || 'item'
                        });

                        if (shopifyBarReady) {
                            __WEBPACK_IMPORTED_MODULE_2__stores__["default"].commit('shopifyBar/UPDATE_PAGE_CONFIG', {
                                title: to.meta.title,
                                buttonsSet: to.meta.buttonsSet || 'item',
                                visible: true
                            });
                        }

                        console.log('✅ Init installed app complete - proceeding to route');
                        return _context4.abrupt('return', next());

                    case 6:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function initInstalledApp(_x2) {
        return _ref6.apply(this, arguments);
    };
}();

var openCdnInformationModal = function openCdnInformationModal() {
    var url = 'https://www.airfields.io/article/airfields-cdn-theme';
    var props = new __WEBPACK_IMPORTED_MODULE_18__models_modal_datasets_model__["a" /* MDSModalConfirmDecisionModel */]({
        title: 'Information',
        description: 'Reminder: Airfields creates a new theme named "Airfields-Cdn-Theme" in your Shopify Online Store.<br>This theme is used to store uploaded images and should not be removed or renamed.<br>If you remove or rename this theme you will lose all your uploaded assets. You can find more details in the <a href="' + url + '" target="_blank" rel="noopener noreferrer">documentation.</a>',
        btnTextConfirm: 'I understand and want to proceed',
        btnTextCancel: '',
        closeOnlyByConfirmButton: true,
        confirmationHandler: function confirmationHandler() {
            if (Object(__WEBPACK_IMPORTED_MODULE_19__helpers_check_storage__["a" /* checkLocalStorage */])()) {
                window.localStorage.setItem('cdn-popup-accepted', 'true');
            }
        }
    });
    var name = 'ModalConfirmDecision';

    __WEBPACK_IMPORTED_MODULE_2__stores__["default"].commit('modals/OPEN_MODAL', { name: name, props: props });
};

router.beforeEach(function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(to, from, next) {
        var shop, dev, isCharged;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        Object(__WEBPACK_IMPORTED_MODULE_10__helpers_logger__["a" /* logger */])('route', to.path);

                        // Hide Shopify title bar on install/error pages
                        if (to.name && (to.name.startsWith('install') || to.name === 'error')) {
                            __WEBPACK_IMPORTED_MODULE_2__stores__["default"].commit('shopifyBar/SET_VISIBLE', { visible: false });
                        }

                        if (!(to.name === 'error')) {
                            _context5.next = 4;
                            break;
                        }

                        return _context5.abrupt('return', next());

                    case 4:
                        if (!(!__WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shop/domain'] && !Object(__WEBPACK_IMPORTED_MODULE_11__helpers_is_shopify_embedded__["b" /* isShopifyEmbedded */])() && !Object(__WEBPACK_IMPORTED_MODULE_11__helpers_is_shopify_embedded__["a" /* isShopifyContext */])(to.query))) {
                            _context5.next = 10;
                            break;
                        }

                        shop = to.query.shop;

                        if (!Object(__WEBPACK_IMPORTED_MODULE_12__helpers_admin_url__["b" /* isValidShopDomain */])(shop)) {
                            _context5.next = 9;
                            break;
                        }

                        window.location.assign(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_admin_url__["a" /* buildAdminAppUrl */])({
                            shop: shop,
                            apiKey: "a89733d855b1ddfac21a5822ede51c8b",
                            path: to.path,
                            query: to.query
                        }));
                        return _context5.abrupt('return', next(false));

                    case 9:
                        return _context5.abrupt('return', next({ name: 'error', query: { reason: 'open-from-admin' } }));

                    case 10:

                        initShopifyBar();

                        // --> Establish the session from the App Bridge ID token

                        if (__WEBPACK_IMPORTED_MODULE_2__stores__["default"].getters['shop/domain']) {
                            _context5.next = 20;
                            break;
                        }

                        _context5.prev = 12;
                        _context5.next = 15;
                        return __WEBPACK_IMPORTED_MODULE_2__stores__["default"].dispatch('shop/START_SESSION');

                    case 15:
                        _context5.next = 20;
                        break;

                    case 17:
                        _context5.prev = 17;
                        _context5.t0 = _context5['catch'](12);
                        return _context5.abrupt('return', next({ name: 'error' }));

                    case 20:
                        _context5.next = 22;
                        return isShopDev();

                    case 22:
                        dev = _context5.sent;
                        _context5.next = 25;
                        return isAppCharged();

                    case 25:
                        isCharged = _context5.sent;

                        Object(__WEBPACK_IMPORTED_MODULE_10__helpers_logger__["a" /* logger */])('process.env.FORCE_CHARGE:', undefined);

                        // 📊 DEBUG: App Status
                        console.log('📊 App Status Check:', {
                            isDev: dev,
                            isCharged: isCharged,
                            forceCharge: undefined
                        });

                        if (!((!dev || undefined && 'false' !== undefined) && !isCharged)) {
                            _context5.next = 31;
                            break;
                        }

                        console.log('💳 Redirecting to Charge App');
                        return _context5.abrupt('return', chargeApp({ to: to, from: from, next: next }));

                    case 31:

                        console.log('✅ Proceeding to Init Installed App');
                        return _context5.abrupt('return', initInstalledApp({ to: to, from: from, next: next }));

                    case 33:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this, [[12, 17]]);
    }));

    return function (_x3, _x4, _x5) {
        return _ref7.apply(this, arguments);
    };
}());

var popupAccepted = false;

router.afterEach(function (to) {
    window.scroll({
        top: 0,
        left: 0
    });

    if (to.name.indexOf('install') === -1 && to.name.indexOf('error') === -1) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_19__helpers_check_storage__["a" /* checkLocalStorage */])()) {
            if (!popupAccepted) {
                setTimeout(function () {
                    openCdnInformationModal();
                    popupAccepted = true;
                }, 500);
            }
        } else if (!window.localStorage.getItem('cdn-popup-accepted')) {
            setTimeout(function () {
                openCdnInformationModal();
                popupAccepted = true;
            }, 500);
        }
    }
});



/***/ }),
/* 500 */
/*!*************************************************!*\
  !*** ./src/stores nonrecursive [a-z]\w+\.(js)$ ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./banners.js": 501,
	"./cache-metafields.js": 522,
	"./index.js": 30,
	"./loaders.js": 523,
	"./modals.js": 524,
	"./settings-integrations.js": 525,
	"./shop-articles-edit.js": 526,
	"./shop-articles-manage.js": 527,
	"./shop-blogs-edit.js": 528,
	"./shop-blogs-manage.js": 529,
	"./shop-collections-edit.js": 530,
	"./shop-collections-manage.js": 531,
	"./shop-customers-edit.js": 532,
	"./shop-customers-manage.js": 533,
	"./shop-customobjects-edit.js": 534,
	"./shop-customobjects-list.js": 535,
	"./shop-customobjectsgroups-list.js": 536,
	"./shop-customobjectsgroups-manage.js": 537,
	"./shop-globals-edit.js": 538,
	"./shop-globals-manage.js": 539,
	"./shop-orders-edit.js": 540,
	"./shop-orders-manage.js": 541,
	"./shop-pages-edit.js": 542,
	"./shop-pages-manage.js": 543,
	"./shop-products-edit.js": 544,
	"./shop-products-integrations-upscribe.js": 545,
	"./shop-products-manage.js": 546,
	"./shop-variants-edit.js": 547,
	"./shop-variants-manage.js": 548,
	"./shop.js": 549,
	"./shopify-api.js": 551,
	"./shopify-bar.js": 573,
	"./ui.js": 574,
	"./unsaved-changes.js": 575
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 500;

/***/ }),
/* 501 */
/*!*******************************!*\
  !*** ./src/stores/banners.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);


var initialState = function initialState() {
    return {
        banners: []
    };
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: initialState(),
    mutations: {
        SHOW_BANNER: function SHOW_BANNER(state, _ref) {
            var status = _ref.status,
                title = _ref.title,
                message = _ref.message,
                buttonLabel = _ref.buttonLabel,
                buttonAction = _ref.buttonAction;

            // buttonLabel: String,
            // buttonAction: Function,
            // title: String,
            // message: String,
            // status: String // warning, success, info
            state.banners.pop(); // TODO: temp show only one banner

            state.banners.push({
                key: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["h" /* generateUuid */])(),
                status: status,
                title: title,
                message: message,
                buttonLabel: buttonLabel,
                buttonAction: buttonAction
            });

            Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["s" /* scrollTo */])('top');
        },
        CLOSE_BANNER: function CLOSE_BANNER(state) {
            state.banners.pop();
        }
    },
    getters: {
        banners: function banners(state) {
            return state.banners;
        }
    }
});

/***/ }),
/* 502 */
/*!****************************************************!*\
  !*** ./src/helpers/store-default-schema-helper.js ***!
  \****************************************************/
/*! exports provided: buildState, buildActions, buildMutations, buildGetters */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildState", function() { return buildState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildActions", function() { return buildActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildMutations", function() { return buildMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildGetters", function() { return buildGetters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/helpers/store-default-schema-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:03:39 pm
 * Last Modified: Thursday, 27th September 2018 3:35:09 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/**
 * field: {
 *  label,
 *  key,
 *  keyPrefix,
 *  keySuffix,
 *  description,
 *  type,
 * }
 */


var DEFAULT_NAMESPACE = "airf";

var DEFAULT_STATE = function DEFAULT_STATE() {
    return {
        schemaData: {
            schema: {
                fields: [],
                usedKeys: []
            },
            metafield: null
        }
    };
};

var DEFAULT_ACTIONS = {
    GET_SCHEMA_METAFIELD: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch;

            var params, _ref3, metafield;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            params = {
                                endpoint: state.id ? 'metafields/schema/' + state.scope + '/' + state.id : 'metafields/schema/' + state.scope
                            };
                            _context.prev = 1;
                            _context.next = 4;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 4:
                            _ref3 = _context.sent;
                            metafield = _ref3.metafield;

                            if (!metafield) {
                                _context.next = 10;
                                break;
                            }

                            commit('SET_SCHEMA_METAFIELD', { metafield: metafield });
                            commit('SET_SCHEMA_FROM_METAFIELD', { metafield: metafield });

                            return _context.abrupt('return', metafield);

                        case 10:
                            return _context.abrupt('return', null);

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](1);

                            console.error('GET_SCHEMA_METAFIELD_' + state.scope, _context.t0);
                            throw _context.t0;

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 13]]);
        }));

        function GET_SCHEMA_METAFIELD(_x) {
            return _ref2.apply(this, arguments);
        }

        return GET_SCHEMA_METAFIELD;
    }(),
    SAVE_SCHEMA: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
            var state = _ref4.state,
                commit = _ref4.commit,
                dispatch = _ref4.dispatch;

            var params, _ref6, metafield;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            params = {
                                method: 'POST',
                                endpoint: 'metafields/schema/' + state.scope,
                                data: state.schemaData
                            };
                            _context2.prev = 1;
                            _context2.next = 4;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 4:
                            _ref6 = _context2.sent;
                            metafield = _ref6.metafield;


                            if (metafield) {
                                commit('SET_SCHEMA_METAFIELD', { metafield: metafield });
                                commit('SET_SCHEMA_FROM_METAFIELD', { metafield: metafield });
                            }
                            _context2.next = 13;
                            break;

                        case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2['catch'](1);

                            console.error('SAVE_SCHEMA' + state.scope, _context2.t0);
                            throw _context2.t0;

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[1, 9]]);
        }));

        function SAVE_SCHEMA(_x2) {
            return _ref5.apply(this, arguments);
        }

        return SAVE_SCHEMA;
    }()
};

var DEFAULT_MUTATIONS = {
    SET_SCHEMA_METAFIELD: function SET_SCHEMA_METAFIELD(state, _ref7) {
        var metafield = _ref7.metafield;

        state.schemaData.metafield = metafield;
    },
    SET_SCHEMA_FROM_METAFIELD: function SET_SCHEMA_FROM_METAFIELD(state, _ref8) {
        var metafield = _ref8.metafield;

        if (metafield.value && metafield.value !== '') {
            state.schemaData.schema = JSON.parse(metafield.value);
        } else {
            state.schemaData.schema = {
                fields: [],
                usedKeys: []
            };
        }
    },
    SET_SCHEMA: function SET_SCHEMA(state, _ref9) {
        var schema = _ref9.schema;

        state.schemaData.schema = schema;
    },
    MAP_AND_SET_SCHEMA: function MAP_AND_SET_SCHEMA(state, _ref10) {
        var schema = _ref10.schema;

        var schemaCopy = Object.assign({}, schema);
        schemaCopy.fields = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["m" /* mapFields */])(schemaCopy.fields);
        state.schemaData.schema = schemaCopy;
    },
    ADD_FIELD_TO_SCHEMA: function ADD_FIELD_TO_SCHEMA(state, _ref11) {
        var field = _ref11.field,
            parent = _ref11.parent;


        // --> Check if key exists
        if (state.schemaData.schema.usedKeys.indexOf(field.key) > -1) {
            console.error('Key ' + field.key + ' already used');
            return;
        }

        // --> Add key to used keys
        state.schemaData.schema.usedKeys.push(field.key);

        // --> Add field to schema
        if (parent) {
            // -> Add children
            if (!parent.children) {
                parent.children = [];
            }

            parent.children.push(field);
        } else {
            // -> Add root
            state.schemaData.schema.fields.push(field);
        }
    },
    REMOVE_FIELD_FROM_SCHEMA: function REMOVE_FIELD_FROM_SCHEMA(state, _ref12) {
        var field = _ref12.field,
            parent = _ref12.parent;

        // --> Get indexes
        var fieldIndex = parent ? parent.children.indexOf(field) : state.schemaData.schema.fields.indexOf(field);
        var keyIndex = state.schemaData.schema.usedKeys.indexOf(field.key);

        // --> Remove field from schema
        if (parent) {
            // -> Remove children
            parent.children.splice(fieldIndex, 1);
        } else {
            // -> Remove root
            state.schemaData.schema.fields.splice(fieldIndex, 1);
        }

        // --> remove key from used
        state.schemaData.schema.usedKeys.splice(keyIndex, 1);
    }
};

var DEFAULT_GETTERS = {
    schemaData: function schemaData(state) {
        return state.schemaData;
    },
    schemaMetafield: function schemaMetafield(state) {
        return state.schemaData.metafield;
    },
    schema: function schema(state) {
        return state.schemaData.schema;
    },
    scope: function scope(state) {
        return state.scope;
    }
};

var buildState = function buildState(_ref13) {
    var state = _ref13.state;
    return Object.assign({}, DEFAULT_STATE(), state);
};
var buildActions = function buildActions(_ref14) {
    var actions = _ref14.actions;
    return Object.assign({}, DEFAULT_ACTIONS, actions);
};
var buildMutations = function buildMutations(_ref15) {
    var mutations = _ref15.mutations;
    return Object.assign({}, DEFAULT_MUTATIONS, mutations);
};
var buildGetters = function buildGetters(_ref16) {
    var getters = _ref16.getters;
    return Object.assign({}, DEFAULT_GETTERS, getters);
};

/***/ }),
/* 503 */
/*!********************************************************!*\
  !*** ./src/helpers/store-default-metafields-helper.js ***!
  \********************************************************/
/*! exports provided: buildState, buildActions, buildMutations, buildGetters */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildState", function() { return buildState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildActions", function() { return buildActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildMutations", function() { return buildMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildGetters", function() { return buildGetters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/helpers/store-default-metafields-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:03:39 pm
 * Last Modified: Thu Oct 03 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/**
 * field: {
 *  label,
 *  key,
 *  keyPrefix,
 *  keySuffix,
 *  description,
 *  type,
 * }
 */


var DEFAULT_NAMESPACE = "airf";

var DEFAULT_STATE = function DEFAULT_STATE() {
    return {
        id: null,
        metafields: [],
        item: {}
    };
};

var DEFAULT_ACTIONS = {
    GET_METAFIELDS: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch;

            var key, params, _ref3, metafields;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            key = state.key ? '?key=' + state.key : '';
                            params = {
                                endpoint: 'metafields/' + state.scope + '/' + state.id + key
                            };
                            _context.prev = 2;
                            _context.next = 5;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 5:
                            _ref3 = _context.sent;
                            metafields = _ref3.metafields;
                            return _context.abrupt('return', { metafields: metafields });

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](2);

                            console.error('GET_METAFIELDS_' + state.scope, _context.t0);
                            throw _context.t0;

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[2, 10]]);
        }));

        function GET_METAFIELDS(_x) {
            return _ref2.apply(this, arguments);
        }

        return GET_METAFIELDS;
    }(),
    SAVE_METAFIELDS: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
            var state = _ref4.state,
                commit = _ref4.commit,
                dispatch = _ref4.dispatch;
            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.metafields;
            var key, params;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            key = state.key ? '?key=' + state.key : '';
                            params = {
                                method: 'POST',
                                endpoint: state.scope === 'globals' ? 'metafields/' + state.scope + '/0' + key : 'metafields/' + state.scope + '/' + state.id + key,
                                data: { metafields: payload, key: state.key || null }
                            };
                            _context2.prev = 2;
                            _context2.next = 5;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 5:
                            _context2.next = 11;
                            break;

                        case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2['catch'](2);

                            console.error('SAVE_METAFIELDS ' + state.scope, _context2.t0);
                            throw _context2.t0;

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[2, 7]]);
        }));

        function SAVE_METAFIELDS(_x3) {
            return _ref5.apply(this, arguments);
        }

        return SAVE_METAFIELDS;
    }(),
    GET_ITEM: function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, _ref7) {
            var state = _ref6.state,
                commit = _ref6.commit,
                dispatch = _ref6.dispatch;
            var id = _ref7.id,
                collectionType = _ref7.collectionType;

            var query, endpoint, _ref9, item;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            query = collectionType ? '?collectionType=' + collectionType : '';
                            endpoint = 'items/' + state.scope + '/' + id + query;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return dispatch('shopifyApi/REQUEST', { endpoint: endpoint }, { root: true });

                        case 5:
                            _ref9 = _context3.sent;
                            item = _ref9.item;


                            commit('SET_ITEM', item);
                            _context3.next = 13;
                            break;

                        case 10:
                            _context3.prev = 10;
                            _context3.t0 = _context3['catch'](2);

                            console.error('GET_ITEM' + state.scope, _context3.t0);

                        case 13:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[2, 10]]);
        }));

        function GET_ITEM(_x4, _x5) {
            return _ref8.apply(this, arguments);
        }

        return GET_ITEM;
    }()
};

var DEFAULT_MUTATIONS = {
    SET_METAFIELDS: function SET_METAFIELDS(state, _ref10) {
        var metafields = _ref10.metafields,
            isRefetch = _ref10.isRefetch;

        // When isRefetch after save we dont need to pushMinRepeaterInstances
        var data = isRefetch ? Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["p" /* pushMinRepeaterInstances */])(metafields) : metafields;
        state.metafields = data;

        Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["l" /* logger */])('store-default-metafields-helper.js / SET_METAFIELDS ' + data, 'DEV');
    },
    SET_ID: function SET_ID(state, _ref11) {
        var id = _ref11.id;

        state.id = id;
    },
    SET_ITEM: function SET_ITEM(state, item) {
        state.item = item || {};
    }
};

var DEFAULT_GETTERS = {
    id: function id(state) {
        return state.id;
    },
    metafields: function metafields(state) {
        return state.metafields;
    },
    scope: function scope(state) {
        return state.scope;
    },
    item: function item(state) {
        return state.item;
    }
};

var buildState = function buildState(_ref12) {
    var state = _ref12.state;
    return Object.assign({}, DEFAULT_STATE(), state);
};
var buildActions = function buildActions(_ref13) {
    var actions = _ref13.actions;
    return Object.assign({}, DEFAULT_ACTIONS, actions);
};
var buildMutations = function buildMutations(_ref14) {
    var mutations = _ref14.mutations;
    return Object.assign({}, DEFAULT_MUTATIONS, mutations);
};
var buildGetters = function buildGetters(_ref15) {
    var getters = _ref15.getters;
    return Object.assign({}, DEFAULT_GETTERS, getters);
};

/***/ }),
/* 504 */
/*!*****************************************************!*\
  !*** ./src/helpers/field-liquid-generate-helper.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stores__ = __webpack_require__(/*! @/stores */ 30);
/*
 * File: /src/helpers/field-liquid-generate-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 25th July 2018 1:23:56 pm
 * Last Modified: Tue Oct 08 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var generateSimple = function generateSimple(_ref) {
    var field = _ref.field,
        scope = _ref.scope;

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != \'&nbsp\' %}\n    {{ ' + field.key + ' }}\n{% endif %}\n';
};

var generateImage = function generateImage(_ref2) {
    var field = _ref2.field,
        scope = _ref2.scope;

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != \'&nbsp\' %}\n    <img src="{{ ' + field.key + ' }}" />\n{% endif %}\n';
};

var generateBoolean = function generateBoolean(_ref3) {
    var field = _ref3.field,
        scope = _ref3.scope;

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' == "true" %}\n    true\n{% else %}\n    false\n{% endif %}\n';
};

var generateRepeaterChildCode = function generateRepeaterChildCode(_ref4) {
    var field = _ref4.field,
        child = _ref4.child,
        scope = _ref4.scope;

    var _key = child.key.replace('_[i]', '');
    var _inside = null;
    switch (child.type) {
        case 'relation':
            _inside = generateRelation({ field: child, scope: scope, schema: child.subForm, airfFieldKey: field.key + '_child_key' });
            break;
    }

    if (!_inside) {
        _inside = '<div class="' + child.type + '">{{ ' + scope + '.metafields.airf[' + field.key + '_child_key] }}</div>';
    }

    return '\n        {% if ' + field.key + '_child_key contains "' + _key + '" %}\n            ' + _inside + '\n        {% endif %}\n';
};

var generateRepeater = function generateRepeater(_ref5) {
    var field = _ref5.field,
        scope = _ref5.scope;

    var childCodes = '';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = field.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            childCodes += generateRepeaterChildCode({ field: field, child: child, scope: scope });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n    {% assign separator = "###" %}\n    {% assign ' + field.key + '_childs_keys = ' + field.key + ' | split: separator %}\n    {% for ' + field.key + '_child_key in ' + field.key + '_childs_keys %}\n        ' + childCodes + '\n    {% endfor %}\n{% endif %}\n';
};

var generateRepeaterJson = function generateRepeaterJson(_ref6) {
    var field = _ref6.field,
        scope = _ref6.scope;

    return '\n{% assign scope = ' + scope + '.metafields.airf %}\n{% assign ' + field.key + ' = scope.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n    {% for row in ' + field.key + '.rows %}\n        Row Data \n        {% for row_field in row %}\n            {% comment %} Show ech field in row {% endcomment %}\n            <div id="{{row_field.key}}">\n                <span>{{row_field.label}}: {{ scope[row_field.key] }}</span>\n            </div>\n\n            {% comment %} Conditional show items, for example you can decide which html tag to use {% endcomment %}\n            {% if row_field.key contains "XXX" %}\n                <h2 id="{{row_field.key}}">{{ scope[row_field.key] }}</h2>\n            {% endif %}\n        {% endfor %}\n    {% endfor %}\n{% endif %}\n';
};

var generateRelationVariant = function generateRelationVariant(_ref7) {
    var field = _ref7.field,
        scope = _ref7.scope,
        airfFieldKey = _ref7.airfFieldKey;

    airfFieldKey = airfFieldKey || '\'' + field.key + '\'';
    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf[' + airfFieldKey + '] %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n    {% assign data_separator = "/r###r/" %}\n    {% assign separator = "###" %}\n    {% assign related_data = ' + field.key + ' | split: data_separator %}\n    {% assign data_product = related_data[0] | split: separator %}\n    {% assign product_handle = data_product[1] %}\n    {% assign related_product = all_products[product_handle] %}\n    {% assign variant_ids = related_data[1] | split: separator %}\n    {% for product_variant in related_product.variants %}\n        {% assign current_id = product_variant.id | downcase %}\n        {% if variant_ids contains current_id %}\n\n            <!-- related variant // -->\n            {{ product_variant.title }}\n            <!-- // related variant -->\n\n        {% endif %}\n    {% endfor %}\n{% endif %}\n';
};

var generateRelation = function generateRelation(_ref8) {
    var field = _ref8.field,
        scope = _ref8.scope,
        schema = _ref8.schema,
        airfFieldKey = _ref8.airfFieldKey;

    var insideCode = '';
    airfFieldKey = airfFieldKey || '\'' + field.key + '\'';
    if (schema) {
        if (schema.relateTo === 'variant') {
            return generateRelationVariant({ field: field, scope: scope, schema: schema, airfFieldKey: airfFieldKey });
        }

        switch (schema.relateTo) {
            case 'product':
                insideCode = '\n            {% assign related_product = all_products[handle] %}\n            {% unless related_product.empty? %}\n                {{ related_product.title }}\n            {% endunless %}\n            ';
                break;
            case 'collection':
                insideCode = '\n            {% assign related_collection = collections[handle] %}\n            {% unless related_collection.empty? %}\n                {{ related_collection.title }}\n            {% endunless %}\n            ';
                break;
            case 'smart-collection':
                insideCode = '\n            {% assign related_collection = collections[handle] %}\n            {% unless related_collection.empty? %}\n                {{ related_collection.title }}\n            {% endunless %}\n            ';
                break;
            case 'page':
                insideCode = '\n            {% assign related_page = pages[handle] %}\n            {% unless related_page.empty? %}\n                {{ related_page.title }}\n            {% endunless %}\n            ';
                break;
            case 'blog-post':
                insideCode = '\n            {% assign related_article = articles[handle] %}\n            {% unless related_article.empty? %}\n                {{ related_article.title }}\n            {% endunless %}\n            ';
                break;
            case 'blog':
                insideCode = '\n            {% assign related_blog = blogs[handle] %}\n            {% unless related_blog.empty? %}\n                {{ related_blog.title }}\n            {% endunless %}\n            ';
                break;
        }
    }

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf[' + airfFieldKey + '] %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n    {% assign separator = "###" %}\n    {% assign ' + field.key + '_related_handles = ' + field.key + ' | split: separator %}\n    {% for handle in ' + field.key + '_related_handles %}\n        ' + insideCode + '\n    {% endfor %}\n{% endif %}\n    ';
};

var generateSelection = function generateSelection(_ref9) {
    var field = _ref9.field,
        scope = _ref9.scope;

    if (field.subForm.display !== 'checkboxes') {
        return generateSimple({ field: field, scope: scope });
    }

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' && ' + field.key + ' != blank %}\n    {% assign separator = "###" %}\n    {% assign ' + field.key + '_selected_options = ' + field.key + ' | split: separator %}\n    {% for ' + field.key + '_selected_option in ' + field.key + '_selected_options %}\n        {{ ' + field.key + '_selected_option }}\n    {% endfor %}\n{% endif %}\n';
};

var generateDate = function generateDate(_ref10) {
    var field = _ref10.field,
        scope = _ref10.scope;

    var dateFormat = '';
    if (field.subForm.onlyDate) {
        dateFormat = '%Y-%m-$d';
    } else if (field.subForm.format12h) {
        dateFormat = '%Y-%m-%d %I:%M %p';
    } else {
        dateFormat = '%Y-%m-%d %H:%M';
    }
    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' %}\n    {{ ' + field.key + ' | date: "' + dateFormat + '" }}\n{% endif %}\n';
};

var generateCoRepeater = function generateCoRepeater(_ref11) {
    var field = _ref11.field;

    var childCodes = '';

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = field.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var child = _step2.value;

            var _key = child.key.replace('_[i]', '');

            childCodes += '\n                {% if ' + field.key + '_child_key contains "' + _key + '" %}\n                    <div class="' + child.type + '">{{ custom_object[' + field.key + '_child_key] }}</div>\n                {% endif %}\n    ';
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' and ' + field.key + ' != blank %}\n            {% assign ' + field.key + '_childs_keys = ' + field.key + ' | split: separator %}\n            {% for ' + field.key + '_child_key in ' + field.key + '_childs_keys %}\n                ' + childCodes + '\n            {% endfor %}\n        {% endif %}\n';
};

var generateCoDate = function generateCoDate(_ref12) {
    var field = _ref12.field;

    var dateFormat = '';
    if (field.subForm.onlyDate) {
        dateFormat = '%Y-%m-$d';
    } else if (field.subForm.format12h) {
        dateFormat = '%Y-%m-%d %I:%M %p';
    } else {
        dateFormat = '%Y-%m-%d %H:%M';
    }
    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' %}\n            {{ ' + field.key + ' | date: "' + dateFormat + '" }}\n        {% endif %}\n';
};

var generateCoImage = function generateCoImage(_ref13) {
    var field = _ref13.field;

    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' and ' + field.key + ' != \'&nbsp\' %}\n            <img src="{{ ' + field.key + ' }}" />\n        {% endif %}\n';
};

var generateCoSelection = function generateCoSelection(_ref14) {
    var field = _ref14.field;

    if (field.subForm.display !== 'checkboxes') {
        return generateCoSimple({ field: field });
    }

    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' && ' + field.key + ' != blank %}\n            {% assign separator = "###" %}\n            {% assign ' + field.key + '_selected_options = ' + field.key + ' | split: separator %}\n            {% for ' + field.key + '_selected_option in ' + field.key + '_selected_options %}\n                {{ ' + field.key + '_selected_option }}\n            {% endfor %}\n        {% endif %}\n';
};

var generateCoBoolean = function generateCoBoolean(_ref15) {
    var field = _ref15.field;

    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' == "true" %}\n            true\n        {% else %}\n            false\n        {% endif %}\n';
};

var generateCoSimple = function generateCoSimple(_ref16) {
    var field = _ref16.field,
        scope = _ref16.scope;

    return '\n        {% assign ' + field.key + ' = custom_object[\'' + field.key + '\'] %}\n        {% if ' + field.key + ' and ' + field.key + ' != \'&nbsp\' %}\n            {{ ' + field.key + ' }}\n        {% endif %}\n';
};

var generateJson = function generateJson(_ref17) {
    var field = _ref17.field,
        scope = _ref17.scope;

    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n  \tValue by key: {{' + field.key + '[\'YOUR_KEY\']}}\n  \n  \tValues by loop:\n    {% for key_value in ' + field.key + ' %}\n       {{key_value[0]}}: {{key_value[1]}}\n    {% endfor %}\n{% endif %}\n';
};

var extraCoTypes = {
    repeater: generateCoRepeater,
    image: generateCoImage,
    selection: generateCoSelection,
    date: generateCoDate,
    boolean: generateCoBoolean
};

var generateCustomObject = function generateCustomObject(_ref18) {
    var field = _ref18.field,
        scope = _ref18.scope,
        schema = _ref18.schema;

    var coCodes = '';
    if (schema) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = schema.fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _field = _step3.value;

                if (!extraCoTypes[_field.type]) {
                    coCodes += generateCoSimple({ field: _field });
                } else {
                    coCodes += extraCoTypes[_field.type]({ field: _field });
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
    return '\n{% assign ' + field.key + ' = ' + scope + '.metafields.airf.' + field.key + ' %}\n{% if ' + field.key + ' and ' + field.key + ' != blank %}\n    {% assign separator = "###" %}\n    {% assign ' + field.key + '_namespaces = ' + field.key + ' | split: separator %}\n    {% for namespace in ' + field.key + '_namespaces %}\n        {% assign custom_object = shop.metafields[namespace] %}\n        ' + coCodes + '\n    {% endfor %}\n{% endif %}\n';
};

var extraTypes = {
    repeater: generateRepeater,
    repeater_json: generateRepeaterJson,
    image: generateImage,
    selection: generateSelection,
    date: generateDate,
    boolean: generateBoolean,
    'custom-object': generateCustomObject,
    relation: generateRelation,
    json: generateJson
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref19) {
    var field = _ref19.field,
        scope = _ref19.scope,
        schema = _ref19.schema;

    scope = scope.replace(/s$/, '');

    if (scope === 'variant') {
        scope = 'product.selected_variant';
    }

    // --> Simple types
    if (!extraTypes[field.type]) {
        return generateSimple({ field: field, scope: scope });
    }

    if (field.subType) {
        return extraTypes[field.subType]({ field: field, scope: scope, schema: schema });
    }

    return extraTypes[field.type]({ field: field, scope: scope, schema: schema });
});

/***/ }),
/* 505 */
/*!*********************************************!*\
  !*** ./src/helpers/file-download-helper.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * File: /src/helpers/file-download-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 8th August 2018 5:11:50 pm
 * Last Modified: Wednesday, 8th August 2018 5:12:36 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var data = _ref.data,
      filename = _ref.filename;

  var blob = new Blob([JSON.stringify(data)]);
  var link = document.createElement('a');
  var url = window.URL.createObjectURL(blob);
  link.href = url;
  link.download = filename;
  link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
});

/***/ }),
/* 506 */
/*!*******************************************!*\
  !*** ./src/helpers/file-upload-helper.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/helpers/file-download-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 8th August 2018 5:11:50 pm
 * Last Modified: Friday, 21st September 2018 1:20:55 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

/* harmony default export */ __webpack_exports__["a"] = (function () {
    return new Promise(function (resolve, reject) {
        var element = document.createElement('div');
        element.innerHTML = '<input type="file">';
        var fileInput = element.firstChild;

        fileInput.addEventListener('change', function () {
            var file = fileInput.files[0];

            if (file.name.match(/\.(json)$/)) {
                var reader = new FileReader();

                reader.onload = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    resolve(reader.result);

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                reader.readAsText(file);
            } else {
                reject('File not supported .json files only');
            }
        });

        fileInput.click();
    });
});

/***/ }),
/* 507 */
/*!***********************************!*\
  !*** ./src/helpers/map-fields.js ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function mapFields(arr) {
    return arr.map(function (item) {
        return {
            key: item.key,
            label: item.label,
            description: item.description,
            type: item.type,
            subType: item.subType || null,
            subForm: item.subForm,
            children: item.children && item.children.length ? mapFields(item.children) : []
        };
    });
}

/* harmony default export */ __webpack_exports__["a"] = (mapFields);

/***/ }),
/* 508 */
/*!****************************************************!*\
  !*** ./src/helpers/push-min-repeater-instances.js ***!
  \****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pushMinRepeaterInstances;
function pushMinRepeaterInstances(arr) {
    return arr.map(function (item) {

        if (item.schema && item.schema.length && item.subForm.min != 0 && !item.children.length) {
            var _loop = function _loop(i) {
                var schema = item.schema.map(function (item) {
                    var _item = Object.assign({}, item);
                    _item.key = _item.key + '_[i]' + '__' + i;

                    return _item;
                });

                item.children.push(schema);
            };

            for (var i = 0; i < +item.subForm.min; i++) {
                _loop(i);
            }
        }

        if (item.type === 'group' && item.children.length) {
            item.children = pushMinRepeaterInstances(item.children);

            return item;
        }

        return item;
    });
}

/***/ }),
/* 509 */
/*!*******************************************!*\
  !*** ./src/helpers/video-embed-helper.js ***!
  \*******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

/*
 * File: /src/helpers/video-embed-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 13th August 2018 9:25:20 am
 * Last Modified: Monday, 13th August 2018 12:45:29 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
var patterns = [{ regex: /youtu\.be\/([\w\-.]+)/, type: 'youtube', url: '//www.youtube.com/embed/', pos: 1 }, { regex: /youtube\.com(.+)v=([^&]+)/, type: 'youtube', url: '//www.youtube.com/embed/', pos: 2 }, { regex: /vimeo\.com\/([0-9]+)/, type: 'vimeo', url: '//player.vimeo.com/video/', pos: 1 }, { regex: /vimeo\.com\/(.*)\/([0-9]+)/, type: 'vimeo', url: '//player.vimeo.com/video/', pos: 2 }];

var embedCode = '<iframe src="{url}" {iframeParams} frameborder="0"></iframe>';

var paramsReservedForIframe = ['width', 'height', 'allowFullScreen', 'customClass'];

var iframeFullscreenParams = 'webkitallowfullscreen mozallowfullscreen allowfullscreen ';

var findPattern = function findPattern(_ref) {
    var link = _ref.link;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = patterns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var pattern = _step.value;

            if (match = link.match(pattern.regex)) {
                return { pattern: pattern, id: match[pattern.pos] };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { pattern: null, id: null };
};

var generateUrlFromPattern = function generateUrlFromPattern(_ref2) {
    var pattern = _ref2.pattern,
        id = _ref2.id,
        params = _ref2.params;

    var url = '' + pattern.url + id;

    if (!params) {
        return url;
    }

    // --> use ony params for query
    var _params = Object.assign({}, params);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = paramsReservedForIframe[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var keyString = _step2.value;

            delete _params[keyString];
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var queryString = Object.keys(_params).map(function (key) {
        return key + '=' + _params[key];
    }).join('&');

    return url + '?' + queryString;
};

var generateEmbedCode = function generateEmbedCode(_ref3) {
    var url = _ref3.url,
        params = _ref3.params,
        pattern = _ref3.pattern;

    params = params || {};

    var template = embedCode;
    var iframeParams = '';

    // --> Use only params for iframe
    if (params.width) {
        iframeParams += 'width="' + params.width + '" ';
    }
    if (params.height) {
        iframeParams += 'height="' + params.height + '" ';
    }
    if (params.allowFullScreen) {
        iframeParams += iframeFullscreenParams;
    }
    if (params.customClass) {
        iframeParams += 'class="' + params.customClass + '" ';
    }

    template = template.replace('{url}', url);
    template = template.replace('{iframeParams}', iframeParams);

    return template;
};

exports.getEmbedCode = function (_ref4) {
    var link = _ref4.link,
        params = _ref4.params;

    var _findPattern = findPattern({ link: link }),
        pattern = _findPattern.pattern,
        id = _findPattern.id;

    if (!pattern) {
        return null;
    }

    var url = generateUrlFromPattern({ pattern: pattern, id: id, params: params });
    var code = generateEmbedCode({ url: url, params: params, pattern: pattern });

    return code;
};

exports.iframeFullscreenParams = iframeFullscreenParams;

/***/ }),
/* 510 */
/*!**********************************!*\
  !*** ./src/helpers/scroll-to.js ***!
  \**********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
function scrollTo(to) {
  window.scroll({
    top: to === 'top' ? 0 : top,
    left: 0,
    behavior: 'smooth'
  });
}

/***/ }),
/* 511 */
/*!***********************************************!*\
  !*** ./src/helpers/reformat-repeater-keys.js ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reformatRepeaterKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flatted_esm__ = __webpack_require__(/*! flatted/esm */ 93);


function reformatRepeaterKeys(metafields) {

    var arr = Object(__WEBPACK_IMPORTED_MODULE_0_flatted_esm__["a" /* parse */])(Object(__WEBPACK_IMPORTED_MODULE_0_flatted_esm__["b" /* stringify */])(metafields));
    return arr.map(function (item) {

        if (item.type === 'repeater' && item.children.length) {

            item.children = item.children.map(function (item) {

                return item.map(function (subitem) {
                    if (subitem.key.includes('_[i]') && subitem.key.lastIndexOf('__') > -1) {
                        subitem.key = subitem.key.substr(0, subitem.key.lastIndexOf('__'));
                    }

                    return subitem;
                });
            });
        }

        if (item.type === 'group' && item.children.length) {
            item.children = reformatRepeaterKeys(item.children);

            return item;
        }

        return item;
    });
}

/***/ }),
/* 512 */
/*!*********************************************!*\
  !*** ./src/helpers/prepare-save-payload.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareSavePayload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_flatted_esm__ = __webpack_require__(/*! flatted/esm */ 93);



// That function splits payload into separate chunks, in order to send relations, repeaters, groups and the rest separetly.
// That function also filters out payload that hasn't changed.
function prepareSavePayload(metafieldsOriginal) {
  var metafields = Object(__WEBPACK_IMPORTED_MODULE_1_flatted_esm__["a" /* parse */])(Object(__WEBPACK_IMPORTED_MODULE_1_flatted_esm__["b" /* stringify */])(metafieldsOriginal)); // Do deep copy because we modify group.children
  var repeaters = [];
  var relations = [];
  var groups = [];
  var rest = [];
  var separatedGroups = [];

  for (var i = 0; i < metafields.length; i++) {
    var item = metafields[i];

    if (!item.hasChanged) {
      continue;
    }

    if (item.type === 'repeater') {
      repeaters.push(item);
    } else if (item.type === 'relation') {
      relations.push(item);
    } else if (item.type === 'group') {
      groups.push(Object.assign({}, item, {
        children: item.children.filter(function (item) {
          return item.hasChanged;
        })
      }));
    } else {
      rest.push(item);
    }
  }

  var _loop = function _loop(_i) {
    var group = groups[_i];
    var keysToSeparate = [];
    for (var _i2 = 0; _i2 < group.children.length; _i2++) {
      var child = group.children[_i2];

      if (child.type === 'repeater' || child.type === 'relation') {
        keysToSeparate.push(child.key);
      }
    }

    if (keysToSeparate.length) {
      var newChildren = group.children.filter(function (item) {
        return !keysToSeparate.includes(item.key);
      });
      var separatedChildren = group.children.filter(function (item) {
        return keysToSeparate.includes(item.key);
      });

      group.children = newChildren;

      for (var _i3 = 0; _i3 < separatedChildren.length; _i3++) {
        var sepChild = separatedChildren[_i3];

        if (sepChild.hasChanged) {
          var separatedGroup = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(group);
          separatedGroup.children = [sepChild];
          separatedGroups.push(separatedGroup);
        }
      }
    }
  };

  for (var _i = 0; _i < groups.length; _i++) {
    _loop(_i);
  }
  var res = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"])(repeaters, 1).concat([groups], [rest], Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"])(relations, 1));

  if (separatedGroups.length) {
    res = res.concat(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"])(separatedGroups, 1));
  }

  res = res.filter(function (item) {
    return item && item.length;
  });

  return res;
}

/***/ }),
/* 513 */
/*!**************************************!*\
  !*** ./src/helpers/generate-uuid.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var uid = 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  uid++;
  return uid;
});

/***/ }),
/* 514 */
/*!******************************************!*\
  !*** ./src/helpers/request-animation.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requestAnimation;
function requestAnimation(callback) {
    var wait, args, context;

    return function () {
        if (wait) return;
        wait = true;
        args = arguments;
        context = this;
        requestAnimationFrame(function () {
            wait = false;
            callback.apply(context, args);
        });
    };
}

/***/ }),
/* 515 */
/*!***************************************!*\
  !*** ./src/helpers/window-confirm.js ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windowConfirm;
function windowConfirm(message) {
    var scrollYPos = window.scrollY;
    var answer = window.confirm(message);

    setTimeout(function () {
        // Aborting confirm window caused scroll to top so this function restores position
        window.scroll(0, scrollYPos);
    }, 0);

    return answer;
}

/***/ }),
/* 516 */
/*!*********************************************!*\
  !*** ./src/helpers/confirm-browser-quit.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = confirmBrowserQuit;
function confirmBrowserQuit(message, destroyConfirmation) {
    if (destroyConfirmation) {
        window.onbeforeunload = null;
    } else {
        window.onbeforeunload = function (e) {
            // Cancel the event
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = message;
        };
    }
}

/***/ }),
/* 517 */
/*!**************************************************!*\
  !*** ./src/helpers/get-searchbar-placeholder.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSearchbarPlaceholder;
function getSearchbarPlaceholder(_ref) {
    var item = _ref.item;

    var res = 'Search';
    if (!item) return res;

    res += ' ( ';
    var map = {
        title: 'title',
        label: 'title',
        description: 'description',
        id: 'id',
        handle: 'handle'
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(map)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (item[key]) {
                res += map[key] + ', ';
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    res = res.slice(0, -2);
    res += ' )';

    return res;
}

/***/ }),
/* 518 */
/*!**************************************!*\
  !*** ./src/helpers/focus-element.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$resetTabIndex = _ref.resetTabIndex,
      resetTabIndex = _ref$resetTabIndex === undefined ? true : _ref$resetTabIndex;

  setTimeout(function () {
    var storedTabIndex = el.tabIndex;

    el.tabIndex = 0;
    el.focus();

    if (resetTabIndex) {
      el.tabIndex = storedTabIndex;

      if (storedTabIndex === -1) {
        el.removeAttribute('tabindex');
      }
    }
  }, 0);
});

/***/ }),
/* 519 */
/*!********************************************!*\
  !*** ./src/helpers/parse-boolean-value.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseBooleanValue;
function parseBooleanValue(value) {
    if (value === 'true') {
        return true;
    } else if (value === 'false') {
        return false;
    }

    return Boolean(value);
}

/***/ }),
/* 520 */
/*!***********************************!*\
  !*** ./src/helpers/is-dev-env.js ***!
  \***********************************/
/*! exports provided: isDevEnv */
/*! exports used: isDevEnv */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDevEnv;
function isDevEnv() {
    return "PRODUCTION" === 'DEV';
}

/***/ }),
/* 521 */
/*!**************************************!*\
  !*** ./src/helpers/session-token.js ***!
  \**************************************/
/*! exports provided: getSessionToken */
/*! exports used: getSessionToken */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSessionToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var POLL_INTERVAL_MS = 100;
var TIMEOUT_MS = 10000;

var waitForShopify = function waitForShopify() {
    return new Promise(function (resolve, reject) {
        if (window.shopify) {
            resolve(window.shopify);
            return;
        }

        var startedAt = Date.now();
        var timer = setInterval(function () {
            if (window.shopify) {
                clearInterval(timer);
                resolve(window.shopify);
            } else if (Date.now() - startedAt >= TIMEOUT_MS) {
                clearInterval(timer);
                reject(new Error('App Bridge not available'));
            }
        }, POLL_INTERVAL_MS);
    });
};

var getSessionToken = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var shopify;
        return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return waitForShopify();

                    case 2:
                        shopify = _context.sent;
                        return _context.abrupt('return', shopify.idToken());

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function getSessionToken() {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 522 */
/*!****************************************!*\
  !*** ./src/stores/cache-metafields.js ***!
  \****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);


var initialState = function initialState() {
  return {
    cachedRelations: {},
    cachedCustomObjs: {},
    isRequestPending: {}
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  namespaced: true,

  state: initialState(),

  mutations: {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    },
    SET_RELATIONS: function SET_RELATIONS(state, _ref) {
      var key = _ref.key,
          data = _ref.data;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.cachedRelations, key, data);
    },
    SET_CUSTOM_OBJS: function SET_CUSTOM_OBJS(state, _ref2) {
      var key = _ref2.key,
          data = _ref2.data;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.cachedCustomObjs, key, data);
    },
    SET_REQUEST_PENDING: function SET_REQUEST_PENDING(state, _ref3) {
      var key = _ref3.key,
          bool = _ref3.bool;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.isRequestPending, key, bool);
    }
  },

  getters: {
    cachedRelations: function cachedRelations(state) {
      return state.cachedRelations;
    },
    cachedCustomObjs: function cachedCustomObjs(state) {
      return state.cachedCustomObjs;
    },
    isRequestPending: function isRequestPending(state) {
      return state.isRequestPending;
    }
  }
});

/***/ }),
/* 523 */
/*!*******************************!*\
  !*** ./src/stores/loaders.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var initialState = function initialState() {
  return {
    areMetafieldsSaving: false
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  namespaced: true,
  state: initialState(),

  mutations: {
    SET_METAFIELDS_SAVING: function SET_METAFIELDS_SAVING(state, bool) {
      state.areMetafieldsSaving = bool;
    }
  }
});

/***/ }),
/* 524 */
/*!******************************!*\
  !*** ./src/stores/modals.js ***!
  \******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var initialState = function initialState() {
    return {
        modals: [],
        forceModal: null
    };
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: initialState(),
    mutations: {
        OPEN_MODAL: function OPEN_MODAL(state, _ref) {
            var name = _ref.name,
                props = _ref.props;

            state.modals.push({ name: name, props: props });
        },
        CLOSE_LAST_MODAL: function CLOSE_LAST_MODAL(state) {
            state.modals.pop();
        },
        SET_MODAL_TO_FORCE: function SET_MODAL_TO_FORCE(state, _ref2) {
            var modal = _ref2.modal;

            state.forceModal = modal;
        }
    },
    getters: {
        modals: function modals(state) {
            return state.modals;
        },
        forceModal: function forceModal(state) {
            return state.forceModal;
        }
    }
});

/***/ }),
/* 525 */
/*!*********************************************!*\
  !*** ./src/stores/settings-integrations.js ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 20th August 2018 11:52:12 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

var initialState = function initialState() {
    return {
        integrations: {
            upscribe: {
                settings: {
                    enabled: "false"
                }
            }
        }

    };
};

var state = function state() {
    return initialState();
};

var actions = {
    GET_SETTINGS: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch;

            var _ref3, integrations;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'settings/integrations'
                            }, { root: true });

                        case 3:
                            _ref3 = _context.sent;
                            integrations = _ref3.integrations;

                            if (!integrations) {
                                _context.next = 8;
                                break;
                            }

                            commit('SET_INTEGRATIONS', { integrations: integrations });

                            return _context.abrupt('return', integrations);

                        case 8:
                            return _context.abrupt('return', null);

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            console.error('GET_SETTINGS', _context.t0);
                            throw _context.t0;

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 11]]);
        }));

        function GET_SETTINGS(_x) {
            return _ref2.apply(this, arguments);
        }

        return GET_SETTINGS;
    }(),
    SAVE_SETTINGS: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
            var state = _ref4.state,
                commit = _ref4.commit,
                dispatch = _ref4.dispatch;

            var _ref6, integrations;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                method: 'POST',
                                endpoint: 'settings/integrations',
                                data: { integrations: state.integrations }
                            }, { root: true });

                        case 3:
                            _ref6 = _context2.sent;
                            integrations = _ref6.integrations;

                            if (!integrations) {
                                _context2.next = 8;
                                break;
                            }

                            commit('SET_INTEGRATIONS', { integrations: integrations });

                            return _context2.abrupt('return', integrations);

                        case 8:
                            return _context2.abrupt('return', null);

                        case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2['catch'](0);

                            console.error('SAVE_SETTINGS', _context2.t0);
                            throw _context2.t0;

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 11]]);
        }));

        function SAVE_SETTINGS(_x2) {
            return _ref5.apply(this, arguments);
        }

        return SAVE_SETTINGS;
    }()
};

var mutations = {
    SET_INTEGRATIONS: function SET_INTEGRATIONS(state, _ref7) {
        var integrations = _ref7.integrations;

        state.integrations = integrations;
    }
};

var getters = {
    integrations: function integrations(state) {
        return state.integrations;
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 526 */
/*!******************************************!*\
  !*** ./src/stores/shop-articles-edit.js ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 12:29:26 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'articles'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 527 */
/*!********************************************!*\
  !*** ./src/stores/shop-articles-manage.js ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Friday, 3rd August 2018 5:11:59 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'articles'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 528 */
/*!***************************************!*\
  !*** ./src/stores/shop-blogs-edit.js ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 12:43:04 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'blogs'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 529 */
/*!*****************************************!*\
  !*** ./src/stores/shop-blogs-manage.js ***!
  \*****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 23rd July 2018 5:26:19 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'blogs'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 530 */
/*!*********************************************!*\
  !*** ./src/stores/shop-collections-edit.js ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 12:52:05 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'collections'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 531 */
/*!***********************************************!*\
  !*** ./src/stores/shop-collections-manage.js ***!
  \***********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Friday, 10th August 2018 12:51:58 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'collections'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 532 */
/*!*******************************************!*\
  !*** ./src/stores/shop-customers-edit.js ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 1:00:33 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'customers'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 533 */
/*!*********************************************!*\
  !*** ./src/stores/shop-customers-manage.js ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 23rd July 2018 5:27:01 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'customers'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 534 */
/*!***********************************************!*\
  !*** ./src/stores/shop-customobjects-edit.js ***!
  \***********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 24th August 2018 11:20:53 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'customobjects',
        key: null
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {
        SET_KEY: function SET_KEY(state, _ref) {
            var key = _ref.key;

            state.key = key;
        }
    }
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 535 */
/*!***********************************************!*\
  !*** ./src/stores/shop-customobjects-list.js ***!
  \***********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shop-customobjectsgroups-list.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 23rd August 2018 11:42:46 am
 * Last Modified: Friday, 24th August 2018 5:03:43 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
var initialState = function initialState() {
    return {
        scope: 'customobjectsgroups'
    };
};

var state = initialState();

var actions = {
    GET_CUSTOM_OBJECTS: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, _ref2) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch;
            var groupId = _ref2.groupId;

            var params, _ref4, metafield, value, mappedCustomObjectKeys;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            params = {
                                endpoint: 'metafields/schema/' + state.scope + '/' + groupId
                            };
                            _context.prev = 1;
                            _context.next = 4;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 4:
                            _ref4 = _context.sent;
                            metafield = _ref4.metafield;

                            if (!metafield) {
                                _context.next = 11;
                                break;
                            }

                            value = JSON.parse(metafield.value);

                            if (!(value && value.customObjects && value.customObjects.objects)) {
                                _context.next = 11;
                                break;
                            }

                            mappedCustomObjectKeys = value.customObjects.objects.map(function (item) {
                                item.key = "airf" + '_' + metafield.key + item.key;
                                return item;
                            });
                            return _context.abrupt('return', { groupKey: metafield.key, customObjects: mappedCustomObjectKeys });

                        case 11:
                            return _context.abrupt('return', { groupKey: null, customObjects: null });

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context['catch'](1);

                            console.error('GET_SCHEMA_METAFIELD_' + state.scope, _context.t0);
                            throw _context.t0;

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 14]]);
        }));

        function GET_CUSTOM_OBJECTS(_x, _x2) {
            return _ref3.apply(this, arguments);
        }

        return GET_CUSTOM_OBJECTS;
    }()
};

var mutations = {};

var getters = {};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 536 */
/*!*****************************************************!*\
  !*** ./src/stores/shop-customobjectsgroups-list.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shop-customobjectsgroups-list.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 23rd August 2018 11:42:46 am
 * Last Modified: Monday, 27th August 2018 11:34:31 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
var initialState = function initialState() {
    return {
        scope: 'customobjectsgroups',
        metafields: [],
        usedKeys: []
    };
};

var state = initialState();

var actions = {
    GET_CUSTOM_OBJECTS_GROUPS: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch;

            var params, _ref3, metafields;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            params = {
                                endpoint: 'customobjectsgroups'
                            };
                            _context.prev = 1;
                            _context.next = 4;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 4:
                            _ref3 = _context.sent;
                            metafields = _ref3.metafields;


                            if (metafields) {
                                commit('SET_METAFIELDS', { metafields: metafields });
                                commit('SET_USED_KEYS', { metafields: metafields });
                            }
                            _context.next = 13;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            console.error('GET_CUSTOM_OBJECTS_GROUPS', _context.t0);
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9]]);
        }));

        function GET_CUSTOM_OBJECTS_GROUPS(_x) {
            return _ref2.apply(this, arguments);
        }

        return GET_CUSTOM_OBJECTS_GROUPS;
    }(),
    SAVE_CUSTOM_OBJECT_GROUP: function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, _ref5) {
            var state = _ref4.state,
                commit = _ref4.commit,
                dispatch = _ref4.dispatch;
            var customObjectGroup = _ref5.customObjectGroup;

            var groupsNumber, nextNumber, finalKey, testKey, params, _ref7, metafields;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            customObjectGroup.value = {
                                label: customObjectGroup.label
                            };

                            groupsNumber = state.metafields.length;
                            nextNumber = groupsNumber + 1;
                            finalKey = void 0;


                            while (!finalKey) {
                                testKey = 'g_' + nextNumber;

                                if (!state.usedKeys.includes(testKey)) {
                                    finalKey = testKey;
                                } else {
                                    nextNumber++;
                                }
                            }

                            customObjectGroup.key = finalKey;

                            params = {
                                endpoint: 'customobjectsgroups',
                                method: 'POST',
                                data: { customObjectGroup: customObjectGroup }
                            };
                            _context2.prev = 7;
                            _context2.next = 10;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 10:
                            _ref7 = _context2.sent;
                            metafields = _ref7.metafields;


                            if (metafields) {
                                commit('SET_METAFIELDS', { metafields: metafields });
                                commit('SET_USED_KEYS', { metafields: metafields });
                            }
                            _context2.next = 19;
                            break;

                        case 15:
                            _context2.prev = 15;
                            _context2.t0 = _context2['catch'](7);

                            console.error('SAVE_CUSTOM_OBJECT_GROUP', _context2.t0);
                            throw _context2.t0;

                        case 19:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[7, 15]]);
        }));

        function SAVE_CUSTOM_OBJECT_GROUP(_x2, _x3) {
            return _ref6.apply(this, arguments);
        }

        return SAVE_CUSTOM_OBJECT_GROUP;
    }(),
    REMOVE_CUSTOM_OBJECT_GROUP: function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8, _ref9) {
            var state = _ref8.state,
                commit = _ref8.commit,
                dispatch = _ref8.dispatch;
            var id = _ref9.id;

            var params, _ref11, metafields;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            params = {
                                endpoint: 'customobjectsgroups/' + id,
                                method: 'DELETE',
                                data: { id: id }
                            };
                            _context3.prev = 1;
                            _context3.next = 4;
                            return dispatch('shopifyApi/REQUEST', params, { root: true });

                        case 4:
                            _ref11 = _context3.sent;
                            metafields = _ref11.metafields;


                            if (metafields) {
                                commit('SET_METAFIELDS', { metafields: metafields });
                                commit('SET_USED_KEYS', { metafields: metafields });
                            }
                            _context3.next = 13;
                            break;

                        case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3['catch'](1);

                            console.error('REMOVE_CUSTOM_OBJECT_GROUP', _context3.t0);
                            throw _context3.t0;

                        case 13:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[1, 9]]);
        }));

        function REMOVE_CUSTOM_OBJECT_GROUP(_x4, _x5) {
            return _ref10.apply(this, arguments);
        }

        return REMOVE_CUSTOM_OBJECT_GROUP;
    }()
};

var mutations = {
    SET_METAFIELDS: function SET_METAFIELDS(state, _ref12) {
        var metafields = _ref12.metafields;

        state.metafields = metafields;
    },
    SET_USED_KEYS: function SET_USED_KEYS(state, _ref13) {
        var metafields = _ref13.metafields;

        state.usedKeys = metafields.map(function (item) {
            return item.key;
        });
    }
};

var getters = {
    customObjectsGroupsMapped: function customObjectsGroupsMapped(state) {
        if (!state.metafields) {
            return null;
        }

        return state.metafields.map(function (item) {
            return {
                id: item.id,
                name: item.value.label,
                schema: item.value.schema,
                to: { name: 'customobjectsgroups.manage', query: { id: item.id } },
                icon: 'text-block',
                editUrl: { name: 'customobjects.manage', query: { id: item.id } },
                editUrlPlacement: 'outer'
            };
        });
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 537 */
/*!*******************************************************!*\
  !*** ./src/stores/shop-customobjectsgroups-manage.js ***!
  \*******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(/*! @/helpers */ 3);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shop-customobjects-manage.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 17th August 2018 2:46:32 pm
 * Last Modified: Friday, 24th August 2018 1:15:35 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'customobjectsgroups',
        id: null,
        label: null,
        customObjects: {
            objects: [],
            usedKeys: []
        }
    };
};

var state = __WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {
        SAVE_CUSTOM_OBJECT: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
                var state = _ref.state,
                    commit = _ref.commit,
                    dispatch = _ref.dispatch;

                var customObjectGroup, value, params, _ref3, metafield;

                return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                customObjectGroup = state.schemaData.metafield;
                                value = JSON.parse(customObjectGroup.value);

                                value.customObjects = state.customObjects;
                                customObjectGroup.value = value;

                                params = {
                                    endpoint: 'customobjectsgroups',
                                    method: 'POST',
                                    data: { customObjectGroup: customObjectGroup, returnSelf: true }
                                };
                                _context.prev = 5;
                                _context.next = 8;
                                return dispatch('shopifyApi/REQUEST', params, { root: true });

                            case 8:
                                _ref3 = _context.sent;
                                metafield = _ref3.metafield;

                                if (!metafield) {
                                    _context.next = 16;
                                    break;
                                }

                                if (!metafield) {
                                    _context.next = 16;
                                    break;
                                }

                                commit('SET_SCHEMA_METAFIELD', { metafield: metafield });
                                commit('SET_SCHEMA_FROM_METAFIELD', { metafield: metafield });
                                commit('SET_CUSTOM_OBJECTS_FROM_METAFIELD', { metafield: metafield });
                                return _context.abrupt('return', metafield);

                            case 16:
                                _context.next = 22;
                                break;

                            case 18:
                                _context.prev = 18;
                                _context.t0 = _context['catch'](5);

                                console.error('SAVE_CUSTOM_OBJECT_GROUP', _context.t0);
                                throw _context.t0;

                            case 22:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[5, 18]]);
            }));

            function SAVE_CUSTOM_OBJECT(_x) {
                return _ref2.apply(this, arguments);
            }

            return SAVE_CUSTOM_OBJECT;
        }()
    }
});

var mutations = __WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {
        SET_ID: function SET_ID(state, _ref4) {
            var id = _ref4.id;

            state.id = id;
        },
        SET_SCHEMA_FROM_METAFIELD: function SET_SCHEMA_FROM_METAFIELD(state, _ref5) {
            var metafield = _ref5.metafield;

            if (metafield.value && metafield.value !== '') {
                var value = JSON.parse(metafield.value);

                if (value && value.schema) {
                    state.schemaData.schema = value.schema;
                } else {
                    state.schemaData.schema = {
                        fields: [],
                        usedKeys: []
                    };
                }
            }
        },
        SET_CUSTOM_OBJECTS_FROM_METAFIELD: function SET_CUSTOM_OBJECTS_FROM_METAFIELD(state, _ref6) {
            var metafield = _ref6.metafield;

            if (metafield.value && metafield.value !== '') {
                var value = JSON.parse(metafield.value);

                if (value && value.customObjects) {
                    state.customObjects = value.customObjects;
                } else {
                    state.customObjects = {
                        objects: [],
                        usedKeys: []
                    };
                }
            }
        },
        ADD_CUSTOM_OBJECT: function ADD_CUSTOM_OBJECT(state, _ref7) {
            var customObject = _ref7.customObject;

            state.customObjects.objects.push(customObject);
            state.customObjects.usedKeys.push(customObject.key);
        },
        REMOVE_CUSTOM_OBJECT: function REMOVE_CUSTOM_OBJECT(state, _ref8) {
            var key = _ref8.key;

            var coIndex = state.customObjects.objects.findIndex(function (item) {
                return item.key === key;
            });
            var keyIndex = state.customObjects.usedKeys.findIndex(function (item) {
                return item === key;
            });
            state.customObjects.objects.splice(coIndex, 1);
            state.customObjects.usedKeys.splice(keyIndex, 1);
        }
    }
});

var getters = __WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {
        id: function id(state) {
            return state.id;
        },
        customObjectsMapped: function customObjectsMapped(state) {
            if (!state.customObjects) {
                return null;
            }

            return state.customObjects.objects.map(function (item) {
                return {
                    key: item.key,
                    name: item.label,
                    to: { name: 'customobjects.edit', query: { key: item.key, id: state.id } },
                    icon: 'text-block',
                    editUrl: { name: 'customobjects.edit', query: { key: item.key, id: state.id } },
                    editUrlPlacement: 'outer'
                };
            });
        },
        usedObjectsKeys: function usedObjectsKeys(state) {
            return state.customObjects.usedKeys;
        }
    }
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 538 */
/*!*****************************************!*\
  !*** ./src/stores/shop-globals-edit.js ***!
  \*****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 21st August 2018 11:13:59 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'globals',
        id: 0
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 539 */
/*!*******************************************!*\
  !*** ./src/stores/shop-globals-manage.js ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Thursday, 19th July 2018 5:32:21 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'globals'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 540 */
/*!****************************************!*\
  !*** ./src/stores/shop-orders-edit.js ***!
  \****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 1:00:53 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'orders'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 541 */
/*!******************************************!*\
  !*** ./src/stores/shop-orders-manage.js ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 23rd July 2018 5:27:29 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'orders'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 542 */
/*!***************************************!*\
  !*** ./src/stores/shop-pages-edit.js ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 14th August 2018 3:52:09 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'pages'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 543 */
/*!*****************************************!*\
  !*** ./src/stores/shop-pages-manage.js ***!
  \*****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 23rd July 2018 5:27:46 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'pages'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 544 */
/*!******************************************!*\
  !*** ./src/stores/shop-products-edit.js ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 24th July 2018 11:17:14 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'products'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 545 */
/*!***********************************************************!*\
  !*** ./src/stores/shop-products-integrations-upscribe.js ***!
  \***********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 24th July 2018 11:17:14 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'products-integrations-upscribe'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 546 */
/*!********************************************!*\
  !*** ./src/stores/shop-products-manage.js ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-globals.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 19th July 2018 2:32:52 pm
 * Last Modified: Monday, 20th August 2018 11:52:12 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'products'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 547 */
/*!******************************************!*\
  !*** ./src/stores/shop-variants-edit.js ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 10th August 2018 1:01:28 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        scope: 'variants'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* StoreDefaultMetafieldsHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 548 */
/*!********************************************!*\
  !*** ./src/stores/shop-variants-manage.js ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);


var initialState = function initialState() {
    return {
        scope: 'variants'
    };
};

var state = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildState({
    state: initialState()
});

var actions = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildActions({
    actions: {}
});

var mutations = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildMutations({
    mutations: {}
});

var getters = __WEBPACK_IMPORTED_MODULE_0__helpers__["e" /* StoreDefaultSchemaHelper */].buildGetters({
    getters: {}
});

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 549 */
/*!****************************!*\
  !*** ./src/stores/shop.js ***!
  \****************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(/*! moment */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shop.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 1:51:25 pm
 * Last Modified: Wednesday, 21st November 2018 12:07:21 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */


var initialState = function initialState() {
    return {
        domain: null,
        charge: null,
        plan: null,
        id: null
    };
};

var state = function state() {
    return initialState();
};

var actions = {
    START_SESSION: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
            var commit = _ref.commit,
                dispatch = _ref.dispatch;

            var _ref3, shop;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'session'
                            }, { root: true });

                        case 3:
                            _ref3 = _context.sent;
                            shop = _ref3.shop;


                            commit('SET_DOMAIN', { domain: shop });
                            return _context.abrupt('return', shop);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            console.error('shop/START_SESSION', { error: _context.t0 });
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 9]]);
        }));

        function START_SESSION(_x) {
            return _ref2.apply(this, arguments);
        }

        return START_SESSION;
    }(),
    GET_SHOP_PLAN: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
            var commit = _ref4.commit,
                dispatch = _ref4.dispatch;

            var _ref6, plan, id;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'shop'
                            }, { root: true });

                        case 3:
                            _ref6 = _context2.sent;
                            plan = _ref6.plan;
                            id = _ref6.id;


                            commit('SET_PLAN', { plan: plan });
                            commit('SET_ID', { id: id });
                            return _context2.abrupt('return', plan);

                        case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2['catch'](0);

                            console.error('shop/GET_SHOP_PLAN', { error: _context2.t0 });
                            throw _context2.t0;

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 11]]);
        }));

        function GET_SHOP_PLAN(_x2) {
            return _ref5.apply(this, arguments);
        }

        return GET_SHOP_PLAN;
    }(),
    GET_SHOP_CHARGE: function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7) {
            var commit = _ref7.commit,
                dispatch = _ref7.dispatch;

            var _ref9, charge;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'payment'
                            }, { root: true });

                        case 3:
                            _ref9 = _context3.sent;
                            charge = _ref9.charge;


                            commit('SET_CHARGE', { charge: charge });
                            return _context3.abrupt('return', charge);

                        case 9:
                            _context3.prev = 9;
                            _context3.t0 = _context3['catch'](0);

                            console.error('shop/GET_SHOP_PAYMENT', { error: _context3.t0 });
                            throw _context3.t0;

                        case 13:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 9]]);
        }));

        function GET_SHOP_CHARGE(_x3) {
            return _ref8.apply(this, arguments);
        }

        return GET_SHOP_CHARGE;
    }(),
    CHARGE_CREATE: function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref10) {
            var commit = _ref10.commit,
                dispatch = _ref10.dispatch;

            var _ref12, charge;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'payment',
                                method: 'POST'
                            }, { root: true });

                        case 3:
                            _ref12 = _context4.sent;
                            charge = _ref12.charge;


                            commit('SET_CHARGE', { charge: charge });
                            return _context4.abrupt('return', charge);

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](0);

                            console.error('shop/GET_SHOP_PAYMENT', { error: _context4.t0 });
                            throw _context4.t0;

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 9]]);
        }));

        function CHARGE_CREATE(_x4) {
            return _ref11.apply(this, arguments);
        }

        return CHARGE_CREATE;
    }(),
    CHARGE_CONFIRM: function () {
        var _ref15 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(_ref13, _ref14) {
            var commit = _ref13.commit,
                dispatch = _ref13.dispatch;
            var chargeId = _ref14.chargeId;

            var _ref16, charge;

            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.prev = 0;
                            _context5.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'payment/confirm/' + chargeId,
                                method: 'POST'
                            }, { root: true });

                        case 3:
                            _ref16 = _context5.sent;
                            charge = _ref16.charge;


                            commit('SET_CHARGE', { charge: charge });
                            return _context5.abrupt('return', charge);

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](0);

                            console.error('shop/CHARGE_CONFIRM', { error: _context5.t0 });
                            throw _context5.t0;

                        case 13:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this, [[0, 9]]);
        }));

        function CHARGE_CONFIRM(_x5, _x6) {
            return _ref15.apply(this, arguments);
        }

        return CHARGE_CONFIRM;
    }(),
    GET_PRODUCTS: function () {
        var _ref18 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(_ref17) {
            var dispatch = _ref17.dispatch;
            var response;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.prev = 0;
                            _context6.next = 3;
                            return dispatch('shopifyApi/REQUEST', {
                                endpoint: 'products'
                            }, { root: true });

                        case 3:
                            response = _context6.sent;
                            return _context6.abrupt('return', response);

                        case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](0);

                            console.error('shop/GET_PRODUCTS', { error: _context6.t0 });
                            throw _context6.t0;

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this, [[0, 7]]);
        }));

        function GET_PRODUCTS(_x7) {
            return _ref18.apply(this, arguments);
        }

        return GET_PRODUCTS;
    }()
};

var mutations = {
    SET_DOMAIN: function SET_DOMAIN(state, _ref19) {
        var domain = _ref19.domain;

        console.log('🏪 Setting Domain:', {
            previousDomain: state.domain,
            newDomain: domain,
            isClearing: domain === null
        });
        state.domain = domain;
    },
    SET_CHARGE: function SET_CHARGE(state, _ref20) {
        var charge = _ref20.charge;

        console.log('💳 Setting Charge:', {
            previousCharge: state.charge,
            newCharge: charge
        });
        state.charge = charge;
    },
    SET_PLAN: function SET_PLAN(state, _ref21) {
        var plan = _ref21.plan;

        console.log('📋 Setting Plan:', {
            previousPlan: state.plan,
            newPlan: plan
        });
        state.plan = plan;
    },
    SET_ID: function SET_ID(state, _ref22) {
        var id = _ref22.id;

        console.log('🆔 Setting ID:', {
            previousId: state.id,
            newId: id
        });
        state.id = id;
    }
};

var getters = {
    domain: function domain(state) {
        return state.domain;
    },
    charge: function charge(state) {
        return state.charge;
    },
    plan: function plan(state) {
        return state.plan;
    },
    id: function id(state) {
        return state.id;
    },
    isPlanDev: function isPlanDev(state) {
        return state.plan && (state.plan === 'trial' || state.plan === 'affiliate' || state.plan === 'partner_test');
    },
    chargeDaysLeft: function chargeDaysLeft(state) {
        if (!state.charge || !state.charge.trial_ends_on) {
            return 0;
        }
        var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(state.charge.trial_ends_on).utc();
        var currentDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().utc();
        var diff = endDate.diff(currentDate, 'days') + 1;

        return diff;
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 550 */,
/* 551 */
/*!***********************************!*\
  !*** ./src/stores/shopify-api.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_path__ = __webpack_require__(/*! object-path */ 571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__(/*! nprogress */ 572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatted_esm__ = __webpack_require__(/*! flatted/esm */ 93);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*
 * File: /src/stores/shopifyApi.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 4:27:57 pm
 * Last Modified: Friday, 21st September 2018 1:30:35 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */






var apiBaseUrl = "https://server.airfields.io" + '/' + "api" + '/shopify/';

var initialState = function initialState() {
    return {
        apiBaseUrl: apiBaseUrl,
        openedHTTPs: 0
    };
};

var state = function state() {
    return initialState();
};

var actions = {
    REQUEST: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref, _ref2) {
            var _this = this;

            var commit = _ref.commit;
            var endpoint = _ref2.endpoint,
                shopifyEndpoint = _ref2.shopifyEndpoint,
                data = _ref2.data,
                params = _ref2.params,
                method = _ref2.method,
                headers = _ref2.headers;
            var send, shouldRetry, response;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            send = function () {
                                var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
                                    var token, _headers;

                                    return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["j" /* getSessionToken */])();

                                                case 2:
                                                    token = _context.sent;
                                                    _headers = Object.assign({
                                                        Authorization: 'Bearer ' + token
                                                    }, shopifyEndpoint ? { 'X-Shopify-Endpoint': shopifyEndpoint } : {}, headers);
                                                    return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                                                        method: method || 'GET',
                                                        // Get rid of circular structure
                                                        data: Object(__WEBPACK_IMPORTED_MODULE_5_flatted_esm__["a" /* parse */])(Object(__WEBPACK_IMPORTED_MODULE_5_flatted_esm__["b" /* stringify */])(data)),
                                                        url: '' + apiBaseUrl + endpoint,
                                                        headers: _headers,
                                                        params: params
                                                    }));

                                                case 5:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }));

                                return function send() {
                                    return _ref4.apply(this, arguments);
                                };
                            }();

                            shouldRetry = function shouldRetry(error) {
                                return !!(error.response && error.response.status === 401 && error.response.headers && error.response.headers['x-shopify-retry-invalid-session-request'] === '1');
                            };

                            commit('SET_OPENED_HTTPS', true);
                            _context2.prev = 3;
                            response = void 0;
                            _context2.prev = 5;
                            _context2.next = 8;
                            return send();

                        case 8:
                            response = _context2.sent;
                            _context2.next = 18;
                            break;

                        case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2['catch'](5);

                            if (shouldRetry(_context2.t0)) {
                                _context2.next = 15;
                                break;
                            }

                            throw _context2.t0;

                        case 15:
                            _context2.next = 17;
                            return send();

                        case 17:
                            response = _context2.sent;

                        case 18:
                            return _context2.abrupt('return', response.data);

                        case 19:
                            _context2.prev = 19;

                            commit('SET_OPENED_HTTPS', false);
                            return _context2.finish(19);

                        case 22:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[3,, 19, 22], [5, 11]]);
        }));

        function REQUEST(_x, _x2) {
            return _ref3.apply(this, arguments);
        }

        return REQUEST;
    }(),
    SCHEMA_EXPORT: function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
            var state = _ref5.state,
                dispatch = _ref5.dispatch;
            var data;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return dispatch('REQUEST', {
                                endpoint: 'metafields/export'
                            });

                        case 3:
                            data = _context3.sent;

                            Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* FileDownloadHelper */])({
                                data: data,
                                filename: 'airfields_schema_export.json'
                            });
                            _context3.next = 10;
                            break;

                        case 7:
                            _context3.prev = 7;
                            _context3.t0 = _context3['catch'](0);
                            throw _context3.t0;

                        case 10:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 7]]);
        }));

        function SCHEMA_EXPORT(_x3) {
            return _ref6.apply(this, arguments);
        }

        return SCHEMA_EXPORT;
    }(),
    SCHEMA_IMPORT: function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, _ref8) {
            var state = _ref7.state,
                dispatch = _ref7.dispatch;
            var content = _ref8.content;
            var metafields;
            return __WEBPACK_IMPORTED_MODULE_0__Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            // let content = await FileUploadHelper()
                            metafields = JSON.parse(content);
                            _context4.prev = 1;
                            _context4.next = 4;
                            return dispatch('REQUEST', {
                                method: 'POST',
                                endpoint: 'metafields/import',
                                data: metafields
                            });

                        case 4:
                            _context4.next = 9;
                            break;

                        case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4['catch'](1);
                            throw _context4.t0;

                        case 9:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[1, 6]]);
        }));

        function SCHEMA_IMPORT(_x4, _x5) {
            return _ref9.apply(this, arguments);
        }

        return SCHEMA_IMPORT;
    }()
};

var mutations = {
    SET_OPENED_HTTPS: function SET_OPENED_HTTPS(state, increament) {
        if (increament) {
            state.openedHTTPs++;
        } else {
            state.openedHTTPs--;
        }

        if (state.openedHTTPs) {
            __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.start();
            __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.set(0.2);
        } else {
            __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
        }
    }
};

var getters = {
    openedHTTPs: function openedHTTPs(state) {
        return state.openedHTTPs;
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/*!***********************************!*\
  !*** ./src/stores/shopify-bar.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(/*! @/helpers */ 3);
/*
 * File: /src/stores/shopify-bar.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Thursday, 2nd August 2018 5:16:42 pm
 * Last Modified: Wed Jun 05 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 *
 * Migrated to App Bridge web components - removed imperative TitleBar/Button APIs
 */


var initialState = function initialState() {
    return {
        init: null,
        ready: null,
        scope: null,
        // New properties for web component approach
        pageTitle: 'Dashboard',
        buttonsSet: null,
        visible: false
    };
};

var state = function state() {
    return initialState();
};

var actions = {
    INIT: function INIT(_ref) {
        var state = _ref.state,
            commit = _ref.commit;

        Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["l" /* logger */])('dispatch init shopify bar start');

        if (state.init) {
            return;
        }

        commit('SET_INIT', { init: true });

        // Wait for window.shopify to be available before setting ready
        var checkShopify = setInterval(function () {
            if (window.shopify) {
                clearInterval(checkShopify);
                commit('SET_READY', { ready: true });
                Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["l" /* logger */])('dispatch init shopify bar end - window.shopify is ready');
            }
        }, 100);

        // Timeout after 10 seconds if window.shopify never loads
        setTimeout(function () {
            clearInterval(checkShopify);
            if (!state.ready) {
                Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["l" /* logger */])('WARNING: window.shopify did not load within 10 seconds');
                commit('SET_READY', { ready: true }); // Set ready anyway to prevent blocking
            }
        }, 10000);
    }
};

var mutations = {
    SET_INIT: function SET_INIT(state, _ref2) {
        var init = _ref2.init;

        state.init = init;
    },
    SET_READY: function SET_READY(state, _ref3) {
        var ready = _ref3.ready;

        state.ready = ready;
    },
    UPDATE_PAGE_CONFIG: function UPDATE_PAGE_CONFIG(state, _ref4) {
        var title = _ref4.title,
            buttonsSet = _ref4.buttonsSet,
            _ref4$visible = _ref4.visible,
            visible = _ref4$visible === undefined ? true : _ref4$visible;

        state.pageTitle = title || 'Dashboard';
        state.buttonsSet = buttonsSet;
        state.visible = visible;
    },
    SET_VISIBLE: function SET_VISIBLE(state, _ref5) {
        var visible = _ref5.visible;

        state.visible = visible;
    }
};

var getters = {
    init: function init(state) {
        return state.init;
    },
    ready: function ready(state) {
        return state.ready;
    },
    pageTitle: function pageTitle(state) {
        return state.pageTitle;
    },
    buttonsSet: function buttonsSet(state) {
        return state.buttonsSet;
    },
    visible: function visible(state) {
        return state.visible;
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 574 */
/*!**************************!*\
  !*** ./src/stores/ui.js ***!
  \**************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var initialState = function initialState() {
  return {
    isMobile: null,
    isDesktop: null
  };
};

var state = function state() {
  return initialState();
};

var actions = {};

var mutations = {
  SET_IS_MOBILE: function SET_IS_MOBILE(state, _ref) {
    var value = _ref.value;

    state.isMobile = value;
    state.isDesktop = !value;
  },
  SET_IS_DESKTOP: function SET_IS_DESKTOP(state, _ref2) {
    var value = _ref2.value;

    state.isDesktop = value;
    state.isMobile = !value;
  }
};

var getters = {
  isMobile: function isMobile(state) {
    return state.isMobile;
  },
  isDesktop: function isDesktop(state) {
    return state.isDesktop;
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  namespaced: true,
  state: state, actions: actions, mutations: mutations, getters: getters
});

/***/ }),
/* 575 */
/*!***************************************!*\
  !*** ./src/stores/unsaved-changes.js ***!
  \***************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);


var initialState = function initialState() {
  return {
    changes: {}
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    },
    REGISTER_CHANGE: function REGISTER_CHANGE(state, _ref) {
      var key = _ref.key,
          bool = _ref.bool;

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.changes, key, bool);
    }
  },

  getters: {
    areChangesUnsaved: function areChangesUnsaved(state) {
      var result = false;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.values(state.changes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;

          if (value) {
            result = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    }
  }
});

/***/ }),
/* 576 */
/*!*****************************!*\
  !*** ./src/pages/error.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./error.vue */ 256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2384d50a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2384d50a","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./error.vue */ 578);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2384d50a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./error.vue */ 577)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2384d50a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 577 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2384d50a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/error.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2384d50a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"error-page"},[(_vm.$route.query.reason === 'open-from-admin')?_c('div',[_c('p',[_vm._v("Open Airfields from the Apps section of your Shopify admin.")])]):_c('div',[_c('p',[_vm._v("Something went wrong.")]),_vm._v(" "),_c('p',[_vm._v("Please try again.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/*!***************************************!*\
  !*** ./src/pages/install/install.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551f39e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-551f39e8","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./install.vue */ 581);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-551f39e8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./install.vue */ 580)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551f39e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-551f39e8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/install/install.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551f39e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/install/install.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install"},[(!_vm.$route.meta.no_spinner)?_c('BaseSpinnerBig'):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/*!***********************************************!*\
  !*** ./src/pages/install/install-payment.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./install-payment.vue */ 257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395b2784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-395b2784","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./install-payment.vue */ 583);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395b2784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395b2784","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/install/install-payment.vue ***!
  \************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"install-msg"},[_vm._v("\n    Payment in progress\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/*!*******************************************************!*\
  !*** ./src/pages/install/install-payment-confirm.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_confirm_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./install-payment-confirm.vue */ 258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f23766_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_confirm_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-06f23766","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./install-payment-confirm.vue */ 585);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06f23766_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f23766","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/install/install-payment-confirm.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"install-msg"},[_vm._v("\n    Payment confirmation\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/*!*******************************************************!*\
  !*** ./src/pages/install/install-payment-decline.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_decline_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./install-payment-decline.vue */ 259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b8a053_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_decline_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-65b8a053","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./install-payment-decline.vue */ 588);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-65b8a053","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./install-payment-decline.vue */ 587)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_install_payment_decline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b8a053_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_install_payment_decline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65b8a053","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/install/install-payment-decline.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b8a053","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/install/install-payment-decline.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"install-payment-decline container",class:("install-payment-decline--" + _vm.theme)},[_c('section',{staticClass:"head"},[_c('h2',{staticClass:"head__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"head__message",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.allowRenew)?_c('BaseButton',{staticClass:"head__button",attrs:{"title":"Renew payment","theme":"primary"},nativeOn:{"click":function($event){return _vm.onRenew($event)}}}):_vm._e()],1),_vm._v(" "),(_vm.status === 'pending' && _vm.charge && _vm.charge.confirmation_url)?_c('section',{staticClass:"head"},[_vm._m(0),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.charge.confirmation_url))])]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"head__message"},[_vm._v("Some browsers can block auto redirects from Shopify App. "),_c('br'),_vm._v("If button above doesn't work, copy the URL below and use it manually in a new browser tab.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"foot"},[_c('h3',{staticClass:"foot__title"},[_vm._v("Uninstalling app")]),_vm._v(" "),_c('p',[_vm._v("To uninstall app login to your Store, go to Apps, find Airfields and click Trash button.")]),_vm._v(" "),_c('p',[_vm._v("Sorry to see you go :(")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 589 */
/*!*********************************!*\
  !*** ./src/pages/page-home.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-home.vue */ 260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3e11be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6b3e11be","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-home.vue */ 602);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3e11be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 590 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39f4f9be","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Section.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f4f9be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Section.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',[_vm._t("info")],2),_vm._v(" "),_c('div',[_vm._t("categories")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f1d3e33","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionInfo.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1d3e33","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionInfo.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-info"},[_c('h1',{staticClass:"section-info__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"section-info__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.linkUrl)?_c('BaseLink',{attrs:{"to":_vm.linkUrl},domProps:{"innerHTML":_vm._s(_vm.linkLabel)}}):_vm._e()],1),_vm._v(" "),_vm._t("button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a8c36e6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionCategories.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8c36e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionCategories.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-categories",class:{ 'section-categories--list-layout': _vm.listLayout }},[_c('ul',{staticClass:"section-categories__list"},[_vm._l((_vm.categories),function(category){return (_vm.categories && _vm.categories.length)?_c('li',{staticClass:"li"},[_c('BaseLink',{staticClass:"category",attrs:{"to":category.to}},[_c('div',{staticClass:"category__icon"},[_c('BaseIcon',{attrs:{"name":category.icon}})],1),_vm._v(" "),_c('div',{staticClass:"category__text"},[_c('label',[_vm._v(_vm._s(category.name)+" ")]),_vm._v(" "),(category.editUrl && category.editUrlPlacement === 'inner')?_c('router-link',{staticClass:"edit-link-inner",attrs:{"to":category.editUrl}},[_vm._v("Edit values")]):_vm._e()],1)]),_vm._v(" "),(category.editUrl && category.editUrlPlacement !== 'inner')?_c('router-link',{staticClass:"edit-link",attrs:{"to":category.editUrl}},[_vm._v("Edit values")]):_vm._e()],1):_vm._e()}),_vm._v(" "),(!_vm.categories || !_vm.categories.length)?_c('li',[_c('h1',{staticClass:"alert alert__title"},[_vm._v("You don’t have any custom objects yet")]),_vm._v(" "),_c('h2',{staticClass:"alert alert__subtitle"},[_vm._v("Your custom objects will be shown here once you have created your first one.")])]):_vm._e()],2),_vm._v(" "),_vm._t("button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/*!*******************************************************!*\
  !*** ./src/components/SectionCustomObjectsGroups.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCustomObjectsGroups_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionCustomObjectsGroups.vue */ 265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d4a191_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCustomObjectsGroups_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-29d4a191","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionCustomObjectsGroups.vue */ 598);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-29d4a191","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SectionCustomObjectsGroups.vue */ 597)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCustomObjectsGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d4a191_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCustomObjectsGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29d4a191","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionCustomObjectsGroups.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d4a191","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionCustomObjectsGroups.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-categories",class:{ 'section-categories--list-layout': _vm.listLayout }},[(_vm.categories && _vm.categories.length)?_c('ul',{staticClass:"section-categories__list"},[_vm._l((_vm.categories),function(category){return _c('li',{key:category.id,staticClass:"li"},[_c('BaseLink',{staticClass:"category",attrs:{"to":category.to}},[_c('div',{staticClass:"category__icon"},[_c('BaseIcon',{attrs:{"name":category.icon}})],1),_vm._v(" "),_c('label',[_vm._v(_vm._s(category.name)+" ")])]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"edit-link",attrs:{"to":category.editUrl}},[_vm._v("Edit custom objects")]),_vm._v(" "),_c('BaseButton',{staticClass:"buttons__btn",attrs:{"icon":"trash"},nativeOn:{"click":function($event){_vm.openConfirmDeleteModal(category.id)}}})],1)],1)}),_vm._v(" "),(!_vm.categories || !_vm.categories.length)?_c('li',[_c('h1',{staticClass:"alert alert__title"},[_vm._v("You don’t have any custom objects yet")]),_vm._v(" "),_c('h2',{staticClass:"alert alert__subtitle"},[_vm._v("Your custom objects will be shown here once you have created your first one.")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._t("button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-640627b8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NewFieldButton.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640627b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewFieldButton.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"new-field-button"},[_c('BaseIcon',{staticClass:"new-field-button__ico-plus",attrs:{"name":"circle-plus"}}),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),(_vm.titleStrong)?_c('strong',[_vm._v("\n        "+_vm._s(_vm.titleStrong)+"\n      ")]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 601 */
/*!******************************!*\
  !*** ./src/data/homepage.js ***!
  \******************************/
/*! exports provided: baseSections, customObjSection, settingsSection */
/*! exports used: baseSections, customObjSection, settingsSection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseSections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customObjSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return settingsSection; });
var baseSections = Object.freeze([{
    info: {
        title: 'Catalog',
        text: 'Add metafields to item types that are related to your product catalog.',
        url: '#'
    },
    categories: [{
        name: 'Products',
        to: { name: 'products.manage' },
        icon: 'products',
        editUrl: { name: 'products.edit' },
        editUrlPlacement: 'inner'
    }, {
        name: 'Variants',
        to: { name: 'variants.manage' },
        icon: 'mobile-vertical-dots',
        editUrl: { name: 'variants.edit' },
        editUrlPlacement: 'inner'
    }, {
        name: 'Collections',
        to: { name: 'collections.manage' },
        icon: 'images',
        editUrl: { name: 'collections.edit' },
        editUrlPlacement: 'inner'
    }]
}, {
    info: {
        title: 'E-commerce',
        text: 'Add metafields to element types that are related to e-commerce.',
        url: '#'
    },
    categories: [{
        name: 'Customers',
        to: { name: 'customers.manage' },
        icon: 'customers'
    }, {
        name: 'Orders',
        to: { name: 'orders.manage' },
        icon: 'orders'
    }]
}, {
    info: {
        title: 'CMS',
        text: 'Add metafields to item types that are related to Pages, Blog posts or Blogs.',
        url: '#'
    },
    categories: [{
        name: 'Pages',
        to: { name: 'pages.manage' },
        icon: 'note',
        editUrl: { name: 'pages.edit' },
        editUrlPlacement: 'inner'
    }, {
        name: 'Blogs',
        to: { name: 'blogs.manage' },
        icon: 'text-block-2',
        editUrl: { name: 'blogs.edit' },
        editUrlPlacement: 'inner'
    }, {
        name: 'Blog posts',
        to: { name: 'articles.manage' },
        icon: 'text-block',
        editUrl: { name: 'articles.edit' },
        editUrlPlacement: 'inner'
    }]
}, {
    info: {
        title: 'Globals',
        text: 'You can add metafields that are global and accessible across the entire Store.',
        url: '#'
    },
    listLayout: true,
    categories: [{
        name: 'Globals',
        to: { name: 'globals.manage' },
        icon: 'tools',
        editUrl: { name: 'globals.edit' },
        editUrlPlacement: 'outer'
    }]
}]);

var customObjSection = Object.freeze({
    info: {
        title: 'Custom objects',
        text: 'Custom objects are reusable blocks of configurable data that you can fill once, and then include in any Airfields schema.',
        url: '#'
    },
    listLayout: true
});

var settingsSection = Object.freeze({
    info: {
        title: 'Settings',
        text: 'Manage your Airfields settings.',
        url: '#'
    },
    categories: [{
        name: 'Integrations',
        to: { name: 'integrations.manage' },
        icon: 'tools'
    }]
});



/***/ }),
/* 602 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b3e11be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-home.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._l((_vm.baseSections),function(section,index){return _c('Section',{key:index},[_c('SectionInfo',{attrs:{"slot":"info","title":section.info.title,"text":section.info.text},slot:"info"}),_vm._v(" "),_c('SectionCategories',{attrs:{"slot":"categories","listLayout":section.listLayout,"categories":section.categories},slot:"categories"})],1)}),_vm._v(" "),_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":_vm.customObjSection.info.title,"text":_vm.customObjSection.info.text},slot:"info"}),_vm._v(" "),_c('SectionCustomObjectsGroups',{attrs:{"slot":"categories","listLayout":_vm.customObjSection.listLayout,"allowDelete":true,"categories":_vm.customObjectsGroupsMapped},slot:"categories"},[_c('NewFieldButton',{attrs:{"slot":"button","title":"Add new custom object group"},nativeOn:{"click":function($event){return _vm.onAddNewObjectGroup($event)}},slot:"button"})],1)],1),_vm._v(" "),_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":_vm.settingsSection.info.title,"text":_vm.settingsSection.info.text},slot:"info"}),_vm._v(" "),_c('SectionCategories',{attrs:{"slot":"categories","listLayout":_vm.settingsSection.listLayout,"categories":_vm.settingsSection.categories},slot:"categories"})],1),_vm._v(" "),_c('BaseHelpButton',{attrs:{"text":"Learn more by reading our","icon":"help","linkUrl":"https://www.airfields.io","linkLabel":"documentation."}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 603 */
/*!*****************************************!*\
  !*** ./src/pages/dummy-router-view.vue ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_dummy_router_view_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./dummy-router-view.vue */ 267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaea272_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dummy_router_view_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5aaea272","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./dummy-router-view.vue */ 604);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_dummy_router_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaea272_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dummy_router_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 604 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aaea272","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dummy-router-view.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/*!*********************************!*\
  !*** ./src/pages/page-edit.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_edit_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-edit.vue */ 268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22719d18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_edit_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-22719d18","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-edit.vue */ 693);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-22719d18","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./page-edit.vue */ 606)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22719d18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22719d18","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/page-edit.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/*!********************************************************************!*\
  !*** ./src/components/metafields-edit/MetafieldsEditContainer.vue ***!
  \********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldsEditContainer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldsEditContainer.vue */ 269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcdeed5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldsEditContainer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-dcdeed5a","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldsEditContainer.vue */ 692);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-dcdeed5a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldsEditContainer.vue */ 608)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldsEditContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcdeed5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldsEditContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcdeed5a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/MetafieldsEditContainer.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/*!**********************************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields nonrecursive MetafieldEdit[A-Z]\w+\.(vue)$ ***!
  \**********************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./MetafieldEditBoolean.vue": 610,
	"./MetafieldEditColor.vue": 613,
	"./MetafieldEditCustomObject.vue": 617,
	"./MetafieldEditDate.vue": 631,
	"./MetafieldEditEmail.vue": 635,
	"./MetafieldEditGroup.vue": 638,
	"./MetafieldEditHtml.vue": 641,
	"./MetafieldEditImage.vue": 644,
	"./MetafieldEditInteger.vue": 647,
	"./MetafieldEditJson.vue": 650,
	"./MetafieldEditLiquidTemplate.vue": 653,
	"./MetafieldEditNumber.vue": 656,
	"./MetafieldEditPhone.vue": 659,
	"./MetafieldEditRelation.vue": 662,
	"./MetafieldEditRepeater.vue": 668,
	"./MetafieldEditSelection.vue": 671,
	"./MetafieldEditText.vue": 674,
	"./MetafieldEditTextarea.vue": 677,
	"./MetafieldEditUrl.vue": 680,
	"./MetafieldEditVideo.vue": 683,
	"./MetafieldEditWysiwyg.vue": 686
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;

/***/ }),
/* 610 */
/*!****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditBoolean.vue ***!
  \****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditBoolean_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditBoolean.vue */ 271);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7475d902_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditBoolean_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7475d902","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditBoolean.vue */ 612);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7475d902","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditBoolean.vue */ 611)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditBoolean_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7475d902_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditBoolean_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 611 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7475d902","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditBoolean.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7475d902","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditBoolean.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-boolean"},[_c('BaseSwitcher',{attrs:{"label":_vm.field.label,"value":_vm.valueParsed,"trueLabel":_vm.subFormData.onVal,"falseLabel":_vm.subFormData.offVal,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditColor.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditColor_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditColor.vue */ 272);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543c63a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditColor_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-543c63a1","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditColor.vue */ 616);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-543c63a1","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditColor.vue */ 614)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditColor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543c63a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditColor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 614 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-543c63a1","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditColor.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */,
/* 616 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543c63a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditColor.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-color"},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('ColorPicker',{attrs:{"value":_vm.value || '#000000',"disableAlpha":true},on:{"input":_vm.onInput}}),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/*!*********************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditCustomObject.vue ***!
  \*********************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditCustomObject_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditCustomObject.vue */ 273);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc50e81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditCustomObject_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0fc50e81","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditCustomObject.vue */ 630);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0fc50e81","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditCustomObject.vue */ 618)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditCustomObject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc50e81_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditCustomObject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 618 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fc50e81","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditCustomObject.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a1633b2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RelationSetter.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff1e9246","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RelationListItem.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/*!************************************!*\
  !*** ./src/components/Popover.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Popover_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Popover.vue */ 277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca3096a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popover_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ca3096a8","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Popover.vue */ 623);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ca3096a8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Popover.vue */ 622)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Popover_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca3096a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popover_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca3096a8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Popover.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca3096a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popover.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"af-popover"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 624 */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff1e9246","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RelationListItem.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"listItem",tag:"component",staticClass:"relation-list-item",class:{'-popovered': _vm.isItemPopovered}},[(_vm.showDragHandle)?_c('div',{staticClass:"js-drag-handle"},[_c('div',{staticClass:"relation-list-item__ico-drag"},[_c('BaseIcon',{attrs:{"name":"drag"}})],1)]):_vm._e(),_vm._v(" "),_c('BaseImage',{staticClass:"relation-list-item__img",attrs:{"image":_vm.image,"objectFit":"cover"}}),_vm._v(" "),_c('span',{staticClass:"relation-list-item__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('BaseButton',{ref:"popoverTrigger",staticClass:"relation-list-item__btn -info",attrs:{"icon":"circle-information"},nativeOn:{"click":function($event){return _vm.showPopover($event)}}}),_vm._v(" "),_vm._t("selectionHandler",[_c('BaseButton',{staticClass:"relation-list-item__btn",attrs:{"icon":"circle-plus-outline"}})]),_vm._v(" "),_c('Popover',{directives:[{name:"visible",rawName:"v-visible",value:(_vm.isItemPopovered && _vm.isTriggerInFrame),expression:"isItemPopovered && isTriggerInFrame"},{name:"click-outside",rawName:"v-click-outside",value:(_vm.hidePopover),expression:"hidePopover"}],ref:"popover",staticClass:"relation-list-item__popover"},[_c('h3',[_vm._v("Details")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Title: ")]),_vm._v(_vm._s(_vm.popoverData.label)+" ")]),_vm._v(" "),(_vm.popoverData.description)?_c('p',[_c('strong',[_vm._v("Description: ")]),_vm._v(_vm._s(_vm.popoverData.description))]):_vm._e(),_vm._v(" "),(_vm.popoverData.id)?_c('p',[_c('strong',[_vm._v("ID: ")]),_vm._v(_vm._s(_vm.popoverData.id))]):_vm._e(),_vm._v(" "),(_vm.popoverData.handle)?_c('p',[_c('strong',[_vm._v("Handle: ")]),_vm._v(_vm._s(_vm.popoverData.handle))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"popover__close buttonTouchArea",attrs:{"title":"Close popover"},on:{"click":_vm.hidePopover}},[_vm._v("✕")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9209c10","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LazyList.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9209c10","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LazyList.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderedItems.length)?_c('ul',{staticClass:"LazyList",on:{"scroll":_vm.handleScroll}},[_vm._t("default",null,{items:_vm.renderedItems})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */,
/* 628 */,
/* 629 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1633b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RelationSetter.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relation-setter rs-columns",class:_vm.className},[_c('div',{staticClass:"relation-setter__options rs-column"},[_c('label',[_vm._v(_vm._s(_vm._f("sentenceCase")(_vm.unselectedLabel)))]),_vm._v(" "),_c('div',{staticClass:"list-wrapper"},[_c('div',{staticClass:"search"},[_c('BaseIcon',{staticClass:"search__loupe",attrs:{"name":"loupe"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})],1),_vm._v(" "),_c('LazyList',{staticClass:"list list--with-search",class:_vm.scrollAreaClassName,attrs:{"items":_vm.unselected,"scrollTopKey":_vm.searchQuery},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.items),function(item){return _c('RelationListItem',{key:item[_vm.key_uid],attrs:{"label":item[_vm.key_label],"image":_vm.getItemImage(item),"popoverData":_vm.getPopoverData(item)}},[_c('BaseButton',{staticClass:"relation-list-item__btn",attrs:{"slot":"selectionHandler","icon":"circle-plus-outline","useImgNotSvg":true},nativeOn:{"click":function($event){_vm.handleSelection(item)}},slot:"selectionHandler"})],1)})}}])}),_vm._v(" "),(_vm.showNoItemsMsg)?_c('TypographyInputHint',{staticClass:"relation-setter__no-items"},[_vm._v("No items.")]):_vm._e()],1),_vm._v(" "),(_vm.loading)?_c('BaseSpinnerBig',{staticClass:"relation-setter__spinner"}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"relation-setter__selected rs-column"},[_c('label',[_vm._v(_vm._s(_vm._f("sentenceCase")(_vm.selectedLabel)))]),_vm._v(" "),_c('div',{staticClass:"list-wrapper"},[_c('ul',{staticClass:"list",class:_vm.scrollAreaClassName},[(_vm.value && _vm.value.length)?[_c('draggable',{attrs:{"list":_vm.value}},_vm._l((_vm.value),function(item){return _c('RelationListItem',{key:item[_vm.key_uid],attrs:{"label":item[_vm.key_label],"image":_vm.getItemImage(item),"popoverData":_vm.getPopoverData(item),"showDragHandle":true}},[_c('BaseButton',{staticClass:"relation-list-item__btn",attrs:{"slot":"selectionHandler","icon":"trash","useImgNotSvg":true},nativeOn:{"click":function($event){_vm.handleDeselection(item)}},slot:"selectionHandler"})],1)}))]:_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/*!**********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc50e81","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditCustomObject.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-custom-obj"},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('RelationSetter',{attrs:{"loading":_vm.loading,"items":_vm.customObjects,"value":_vm.value,"unselectedLabel":"Select custom object","selectedLabel":"Selected custom objects","linkUrl":_vm.linkUrl},on:{"input":_vm.onInput}}),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/*!*************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditDate.vue ***!
  \*************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditDate_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditDate.vue */ 280);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4827aeec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditDate_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4827aeec","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditDate.vue */ 634);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4827aeec","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditDate.vue */ 632)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4827aeec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 632 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4827aeec","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditDate.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */,
/* 634 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4827aeec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditDate.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-date"},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('datepicker',{staticClass:"metafield-edit-date__calendar",attrs:{"inline":true,"full-month-name":true,"value":_vm.form.date},on:{"input":_vm.handleDate}}),_vm._v(" "),(!_vm.subFormData.onlyDate)?_c('div',{staticClass:"metafield-edit-date__time"},[_c('BaseInput',{attrs:{"type":"number","label":"Hours","value":_vm.form.hour,"formatNum":"00","maxVal":(_vm.subFormData.format12h) ? 12 : 24,"minVal":"0"},on:{"input":_vm.handleHours}}),_vm._v(" "),_c('BaseInput',{attrs:{"type":"number","label":"Minutes","value":_vm.form.minute,"maxVal":"59","minVal":"0","formatNum":"00"},on:{"input":_vm.handleMinutes}}),_vm._v(" "),(_vm.subFormData.format12h)?_c('BaseSwitcher',{attrs:{"value":_vm.form.isAm,"trueLabel":"AM","falseLabel":"PM"},on:{"input":_vm.handleAm}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditEmail.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditEmail_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditEmail.vue */ 281);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36156022_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditEmail_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-36156022","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditEmail.vue */ 637);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-36156022","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditEmail.vue */ 636)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36156022_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 636 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36156022","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditEmail.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36156022","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditEmail.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-email"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":"email"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditGroup.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditGroup_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditGroup.vue */ 282);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77025a1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditGroup_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-77025a1d","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditGroup.vue */ 640);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-77025a1d","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditGroup.vue */ 639)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77025a1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 639 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77025a1d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditGroup.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77025a1d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditGroup.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-group"},[_vm._t("dragHandle"),_vm._v(" "),_vm._t("toggleBtn"),_vm._v(" "),_c('div',{staticClass:"metafield-edit-group__wrapper"},[_c('p',{staticClass:"metafield-edit-group__name",attrs:{"title":_vm.renderedGroupName,"aria-title":_vm.renderedGroupName}},[_vm._v(_vm._s(_vm.renderedGroupName))]),_vm._v(" "),(_vm.hint)?_vm._m(0):_vm._e(),_vm._v(" "),(_vm.warning)?_vm._m(1):_vm._e()],1),_vm._v(" "),_vm._t("removeBtn")],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypographyInputHint',{attrs:{"isDanger":true}},[_vm._v(_vm._s(_vm.warning))])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */
/*!*************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditHtml.vue ***!
  \*************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditHtml_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditHtml.vue */ 283);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c43116_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditHtml_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-20c43116","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditHtml.vue */ 643);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-20c43116","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditHtml.vue */ 642)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20c43116_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditHtml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 642 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20c43116","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditHtml.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c43116","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditHtml.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-html"},[_c('BaseHtml',{attrs:{"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditImage.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditImage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditImage.vue */ 284);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b09fdf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditImage_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63b09fdf","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditImage.vue */ 646);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63b09fdf","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditImage.vue */ 645)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63b09fdf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 645 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63b09fdf","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditImage.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b09fdf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditImage.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-image"},[_c('BasePictureInput',{attrs:{"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"fieldKey":_vm.field.key,"scopeId":_vm.scopeId},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/*!****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditInteger.vue ***!
  \****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditInteger_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditInteger.vue */ 285);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587d8fc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditInteger_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-587d8fc8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditInteger.vue */ 649);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-587d8fc8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditInteger.vue */ 648)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditInteger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587d8fc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditInteger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 648 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-587d8fc8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditInteger.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587d8fc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditInteger.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-integer"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"type":"number","step":"1","hint":_vm.hint,"validate":_vm.validator(),"prefix":_vm.subFormData.prefix,"suffix":_vm.subFormData.suffix,"minVal":+_vm.subFormData.min,"maxVal":+_vm.subFormData.max || Infinity},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/*!*************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditJson.vue ***!
  \*************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditJson_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditJson.vue */ 286);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff594110_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditJson_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ff594110","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditJson.vue */ 652);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ff594110","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditJson.vue */ 651)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditJson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff594110_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditJson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 651 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ff594110","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditJson.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff594110","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditJson.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-html"},[_c('BaseJson',{attrs:{"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/*!***********************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditLiquidTemplate.vue ***!
  \***********************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditLiquidTemplate_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditLiquidTemplate.vue */ 287);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeec5f88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditLiquidTemplate_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-eeec5f88","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditLiquidTemplate.vue */ 655);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-eeec5f88","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditLiquidTemplate.vue */ 654)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditLiquidTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeec5f88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditLiquidTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 654 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eeec5f88","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditLiquidTemplate.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/*!************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeec5f88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditLiquidTemplate.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-liquid-template"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("TODO!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/*!***************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditNumber.vue ***!
  \***************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditNumber_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditNumber.vue */ 288);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_586c36c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditNumber_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-586c36c8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditNumber.vue */ 658);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-586c36c8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditNumber.vue */ 657)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_586c36c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 657 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-586c36c8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditNumber.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586c36c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditNumber.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-number"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"type":"text","hint":_vm.hint,"validate":_vm.validator(),"minVal":+this.subFormData.min || -Infinity,"maxVal":+this.subFormData.max || Infinity},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditPhone.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditPhone_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditPhone.vue */ 289);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239530a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditPhone_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-239530a2","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditPhone.vue */ 661);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-239530a2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditPhone.vue */ 660)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditPhone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239530a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditPhone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 660 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-239530a2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditPhone.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239530a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditPhone.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-phone"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":"phone|max16digit"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/*!*****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditRelation.vue ***!
  \*****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditRelation_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditRelation.vue */ 290);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8673cc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditRelation_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d8673cc8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditRelation.vue */ 667);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d8673cc8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditRelation.vue */ 663)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditRelation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8673cc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditRelation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 663 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8673cc8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditRelation.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/*!******************************************!*\
  !*** ./src/components/ProductSearch.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSearch_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductSearch.vue */ 291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3359d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSearch_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3e3359d0","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductSearch.vue */ 666);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3e3359d0","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductSearch.vue */ 665)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3359d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e3359d0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductSearch.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3359d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductSearch.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-search",class:_vm.className},[_c('label',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"product-search__container"},[_c('div',{staticClass:"product-search__search"},[_c('BaseIcon',{staticClass:"search__loupe",attrs:{"name":"loupe"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})],1),_vm._v(" "),_c('LazyList',{staticClass:"product-search__list",class:_vm.scrollAreaClassName,attrs:{"items":_vm.filteredItems,"scrollTopKey":_vm.searchQuery},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.items),function(item){return _c('RelationListItem',{key:item[_vm.key_uid],staticClass:"list__item",class:{ '-selected': item[_vm.key_value] == _vm.value },attrs:{"label":item[_vm.key_label],"image":_vm.getItemImage(item),"popoverData":_vm.getPopoverData(item)}},[_c('button',{staticClass:"list__select-btn",attrs:{"slot":"selectionHandler"},on:{"click":function($event){_vm.select(item)}},slot:"selectionHandler"},[_c('BaseIcon',{attrs:{"name":item[_vm.key_value] == _vm.value ? 'radio-selected' : 'radio-unselected'}})],1)])})}}])}),_vm._v(" "),(_vm.loading)?_c('BaseSpinnerBig',{staticClass:"product-search__spinner"}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8673cc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditRelation.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-relation"},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),(_vm.isVariant)?_c('ProductSearch',{attrs:{"items":_vm.checkboxProducts,"loading":_vm.showLoader,"title":"Select product","key_uid":_vm.keyUid,"key_img":"image","key_img_second":"src","key_label":"title"},on:{"input":_vm.handleSelectProductForVariants},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}}):_vm._e(),_vm._v(" "),(_vm.subFormData.relateTo !== 'variant' || _vm.relationProducts)?_c('RelationSetter',{attrs:{"loading":_vm.showLoader,"items":_vm.relationProducts,"value":_vm.mappedValue,"unselectedLabel":_vm.unselectedLabel,"selectedLabel":_vm.selectedLabel,"key_uid":_vm.keyUid,"key_img":"image","key_img_second":"src","key_label":"title"},on:{"input":_vm.handleRelationSet}}):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 668 */
/*!*****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditRepeater.vue ***!
  \*****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditRepeater_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditRepeater.vue */ 292);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f0e5814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditRepeater_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8f0e5814","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditRepeater.vue */ 670);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8f0e5814","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditRepeater.vue */ 669)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditRepeater_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f0e5814_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditRepeater_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 669 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f0e5814","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditRepeater.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f0e5814","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditRepeater.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-repeater"},[_vm._t("toggleBtn"),_vm._v(" "),_c('div',{staticClass:"metafield-edit-repeater__wrapper"},[_c('p',{staticClass:"metafield-edit-repeater__name"},[_vm._v(_vm._s(_vm.groupName))]),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.warning)?_c('TypographyInputHint',{attrs:{"isDanger":true}},[_vm._v(_vm._s(_vm.warning))]):_vm._e()],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/*!******************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditSelection.vue ***!
  \******************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditSelection_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditSelection.vue */ 293);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092e95a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditSelection_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-092e95a3","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditSelection.vue */ 673);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-092e95a3","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditSelection.vue */ 672)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092e95a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 672 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-092e95a3","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditSelection.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092e95a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditSelection.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-selection",class:_vm.className},[_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label)+" "+_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"metafield-edit-selection__content"},[(_vm.subFormData.display === 'checkboxes')?_vm._l((_vm.subFormData.options),function(option){return _c('BaseCheckBox',{key:option.value,staticClass:"metafield-edit-selection__checkbox",attrs:{"value":_vm.value ? Array.isArray(_vm.value) ? _vm.value : [_vm.value] : [],"name":_vm.field.key,"optionValue":option.value},on:{"input":_vm.onInput}},[_vm._v(_vm._s(option.label))])}):(_vm.subFormData.display === 'radioboxes')?_vm._l((_vm.subFormData.options),function(option){return _c('BaseRadioBox',{key:option.value,staticClass:"metafield-edit-selection__radiobox",attrs:{"value":_vm.value ? _vm.value : '',"name":_vm.field.key,"optionValue":option.value},on:{"input":_vm.onInput}},[_vm._v(_vm._s(option.label))])}):(_vm.subFormData.display === 'select-list')?[_c('BaseSelect',{staticClass:"metafield-edit-selection__select",attrs:{"options":_vm.subFormData.options,"placeholder":"Select an option...","value":_vm.value,"name":_vm.field.key,"showNullOption":true},on:{"input":_vm.onInput}})]:_vm._e()],2),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/*!*************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditText.vue ***!
  \*************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditText_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditText.vue */ 294);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a183107_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditText_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a183107","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditText.vue */ 676);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3a183107","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditText.vue */ 675)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a183107_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 675 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a183107","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditText.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a183107","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditText.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-text"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":_vm.validator()},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/*!*****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditTextarea.vue ***!
  \*****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditTextarea_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditTextarea.vue */ 295);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d230f14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditTextarea_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5d230f14","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditTextarea.vue */ 679);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5d230f14","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditTextarea.vue */ 678)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d230f14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 678 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d230f14","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditTextarea.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d230f14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditTextarea.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-text"},[_c('BaseTextarea',{attrs:{"data-vv-as":_vm.field.type,"minHeight":_vm.subFormData.rows * 25,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":_vm.validator()},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */
/*!************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditUrl.vue ***!
  \************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditUrl_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditUrl.vue */ 296);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a882d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditUrl_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-78a882d6","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditUrl.vue */ 682);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-78a882d6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditUrl.vue */ 681)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a882d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 681 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78a882d6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditUrl.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a882d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditUrl.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-url"},[_c('BaseInput',{attrs:{"data-vv-as":_vm.field.type,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":"url"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/*!**************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditVideo.vue ***!
  \**************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditVideo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditVideo.vue */ 297);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0227c98e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditVideo_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0227c98e","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditVideo.vue */ 685);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0227c98e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditVideo.vue */ 684)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0227c98e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 684 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0227c98e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditVideo.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0227c98e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditVideo.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-video"},[(_vm.embedPreviewCode)?_c('p',{staticClass:"metafield__title"},[_vm._v(_vm._s(_vm.field.label))]):_vm._e(),_vm._v(" "),(_vm.embedPreviewCode)?_c('div',{staticClass:"metafield-edit-video__player",domProps:{"innerHTML":_vm._s(_vm.embedPreviewCode)}}):_vm._e(),_vm._v(" "),(!_vm.showInput)?_c('div',{staticClass:"metafield-edit-video__controls"},[_c('BaseButton',{attrs:{"title":"Change Video"},nativeOn:{"click":function($event){_vm.showInput = true}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Remove Video"},nativeOn:{"click":function($event){_vm.onInput(null)}}})],1):_vm._e(),_vm._v(" "),_c('BaseInput',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],attrs:{"data-vv-as":'video url',"name":_vm.$attrs.name,"label":"Video url","value":_vm.url,"hint":_vm.hint,"validate":"url"},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/*!****************************************************************************!*\
  !*** ./src/components/metafields-edit/metafields/MetafieldEditWysiwyg.vue ***!
  \****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditWysiwyg_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MetafieldEditWysiwyg.vue */ 298);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0549a749_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditWysiwyg_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0549a749","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MetafieldEditWysiwyg.vue */ 688);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0549a749","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MetafieldEditWysiwyg.vue */ 687)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MetafieldEditWysiwyg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0549a749_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MetafieldEditWysiwyg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 687 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0549a749","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/metafields-edit/metafields/MetafieldEditWysiwyg.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0549a749","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditWysiwyg.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-wysiwyg"},[_c('BaseWysiwyg',{attrs:{"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcdeed5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/MetafieldsEditContainer.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafields-edit-container",class:_vm.className,attrs:{"id":_vm.rootID()}},_vm._l((_vm.metafields),function(field,i){return _c('BaseAccordion',{key:field.id,class:{ 'metafields-edit-container__panel': _vm.root },attrs:{"id":field.key,"value":field.subForm && field.subForm.opened},scopedSlots:_vm._u([{key:"default",fn:function(BaseAccordion1st){return [_c(_vm.basedOnMetafieldType(field.type),{tag:"component",staticClass:"metafields-edit-container__field",attrs:{"field":field,"name":field.key,"groupName":field.label,"hint":field.description,"warning":_vm.generateWarning(field),"subFormData":field.subForm},on:{"valueChanged":function($event){_vm.setFieldChanged($event, field)}},nativeOn:{"click":function($event){return BaseAccordion1st.onCollapse($event)}},model:{value:(field.value),callback:function ($$v) {_vm.$set(field, "value", $$v)},expression:"field.value"}},[_c('button',{staticClass:"metafields-edit-container__toggle",class:{ 'metafields-edit-container__toggle--opened': BaseAccordion1st.opened },attrs:{"slot":"toggleBtn"},slot:"toggleBtn"},[(field.children && (field.children.length || field.type === 'repeater' || field.type === 'group'))?_c('BaseIcon',{attrs:{"name":"arrow"}}):_vm._e()],1)]),_vm._v(" "),(field.children && (field.children.length || field.type === 'repeater'))?_c('div',{staticClass:"metafields-edit-container__children",class:{ '-INVISIBLE': !BaseAccordion1st.opened }},[(field.type === 'repeater')?_c('DraggableTree',{ref:"repeaterTree",refInFor:true,attrs:{"data":field.children,"options":{ handle: '.js-drag-handle' },"indent":30,"crossTree":false,"draggable":"","space":0,"getTriggerEl":_vm.dragHandler,"ondragend":_vm.onDragEnd},on:{"drag":function($event){_vm.dragging = true},"drop":function($event){_vm.dragging = false},"moving":_vm.onDragMoving,"change":function($event){_vm.setRepeaterReorganized(true, field)}},scopedSlots:_vm._u([{key:"default",fn:function(TreeScope){return _c('div',{},[(!TreeScope.data.isDragPlaceHolder)?[_c('BaseAccordion',{staticClass:"metafields-edit-container__children__repeater-group",scopedSlots:_vm._u([{key:"default",fn:function(BaseAccordion2nd){return [_c('MetafieldEditGroup',{staticClass:"metafields-edit-container__field",attrs:{"groupNameOnceRender":!_vm.repeaterLabelByField(field, TreeScope.data).willBeLabeled,"groupName":_vm.repeaterLabelByField(field, TreeScope.data).label ? _vm.repeaterLabelByField(field, TreeScope.data).label : _vm.repeaterGroupName(field, TreeScope.index + 1, TreeScope.data)},nativeOn:{"click":function($event){return BaseAccordion2nd.onCollapse($event)}}},[_c('div',{staticClass:"js-drag-handle",attrs:{"slot":"dragHandle"},on:{"click":function($event){$event.stopPropagation();}},slot:"dragHandle"},[_c('div',{staticClass:"drag-handle"},[_c('BaseIcon',{attrs:{"name":"drag"}})],1)]),_vm._v(" "),_c('button',{staticClass:"metafields-edit-container__toggle",class:{ 'metafields-edit-container__toggle--opened': BaseAccordion2nd.opened },attrs:{"slot":"toggleBtn"},slot:"toggleBtn"},[(field.children && (field.children.length || field.type === 'repeater'))?_c('BaseIcon',{attrs:{"name":"arrow"}}):_vm._e()],1),_vm._v(" "),_c('BaseButton',{staticClass:"remove-group-button",attrs:{"slot":"removeBtn","icon":"trash","useImgNotSvg":true},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openConfirmDeleteModal($event, { repeater: field, groupIndex: TreeScope.index })}},slot:"removeBtn"})],1),_vm._v(" "),_c('div',{staticClass:"metafields-edit-container__children",class:{ '-INVISIBLE': !BaseAccordion2nd.opened }},[_c('MetafieldsEditContainer',{attrs:{"parentTheRepeater":field.type === 'repeater' ? field : null,"groupTheRepeaterContainer":_vm.parentTheGroup,"root":false,"metafields":TreeScope.data}})],1)]}}])})]:_vm._e()],2)}}])}):_vm._e(),_vm._v(" "),(field.type === 'repeater' && field.schema && field.schema.length)?_c('NewFieldButton',{staticClass:"repeater-new-instance-btn",attrs:{"data":field,"title":"Add a","titleStrong":field.subForm.title || 'Item'},nativeOn:{"click":function($event){_vm.handleAddGroupRepeater(field)}}}):_c('MetafieldsEditContainer',{attrs:{"root":false,"metafields":field.children,"parentTheGroup":field.type === 'group' ? field : null}})],1):_vm._e()]}}])})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22719d18","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-edit.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-edit container"},[_c('BaseButtonBack'),_vm._v(" "),(_vm.upscribeMetafields && _vm.upscribeMetafields.length)?_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":'Integration',"text":"Add your data on the right."},slot:"info"}),_vm._v(" "),_c('template',{slot:"categories"},[_c('MetafieldsEditContainer',{staticClass:"page-edit__tree",attrs:{"metafields":_vm.upscribeMetafields,"storeName":_vm.store,"loading":_vm.areMetafieldsSaving}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.upscribeMetafields.length)?_c('BaseButton',{staticClass:"page-edit__save-btn",attrs:{"theme":"primary","title":"Save","loading":_vm.areMetafieldsSaving},nativeOn:{"click":function($event){_vm.save({iterations: [{
                    store: 'shopProductsIntegrationsUpscribe',
                    metafields: _vm.upscribeMetafields
                }]})}}}):_vm._e()],1)],2):_vm._e(),_vm._v(" "),_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":_vm.item.title || 'Metafield values',"text":"Add your data on the right."},slot:"info"}),_vm._v(" "),_c('template',{slot:"categories"},[_c('MetafieldsEditContainer',{staticClass:"page-edit__tree",attrs:{"metafields":_vm.metafields,"storeName":_vm.store,"loading":_vm.areMetafieldsSaving}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.metafields.length)?_c('BaseButton',{staticClass:"page-edit__save-btn",attrs:{"theme":"primary","title":"Save","loading":_vm.areMetafieldsSaving},nativeOn:{"click":function($event){_vm.save(null)}}}):_vm._e()],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/*!***********************************!*\
  !*** ./src/pages/page-manage.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-manage.vue */ 300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e77924_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f1e77924","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-manage.vue */ 708);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f1e77924","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./page-manage.vue */ 695)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e77924_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f1e77924","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/page-manage.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/*!************************************************!*\
  !*** ./src/components/SchemaTreeContainer.vue ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SchemaTreeContainer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SchemaTreeContainer.vue */ 303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fded80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchemaTreeContainer_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-59fded80","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SchemaTreeContainer.vue */ 707);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-59fded80","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SchemaTreeContainer.vue */ 697)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SchemaTreeContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fded80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SchemaTreeContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 697 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59fded80","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SchemaTreeContainer.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/*!***********************************!*\
  !*** ./src/components/MyTree.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MyTree_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyTree.vue */ 304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c09fb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTree_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-36c09fb4","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyTree.vue */ 703);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-36c09fb4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyTree.vue */ 699)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MyTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c09fb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 699 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36c09fb4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyTree.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/*!***************************************!*\
  !*** ./src/components/MyTreeNode.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MyTreeNode_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyTreeNode.vue */ 305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ba21ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTreeNode_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-00ba21ee","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyTreeNode.vue */ 702);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-00ba21ee","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyTreeNode.vue */ 701)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_MyTreeNode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ba21ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyTreeNode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 701 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00ba21ee","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyTreeNode.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ba21ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyTreeNode.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-node",class:[_vm.data.active ? _vm.store.activatedClass : '', _vm.data.open ? _vm.store.openedClass : '', _vm.data.class],attrs:{"id":_vm.data._id,"data-level":_vm.data.level,"aria-expanded":_vm.data.open}},[(!_vm.isRoot)?_c('div',{staticClass:"tree-node-inner-back",class:[_vm.data.innerBackClass],style:([_vm.innerBackStyle, _vm.data.innerBackStyle])},[_c('div',{staticClass:"tree-node-inner",class:[_vm.data.innerClass],style:([_vm.data.innerStyle])},[_vm._t("default",null,{data:_vm.data,store:_vm.store,scope:_vm.scope})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tree-node-children"},[(_vm.childrenVisible)?_vm._l((_vm.data.children),function(child){return _c('MyTreeNode',{key:child._id,attrs:{"data":child,"store":_vm.store,"indent":_vm.indent,"scope":_vm.scope,"usedKeys":_vm.usedKeys},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._t("default",null,{data:props.data,store:props.store,scope:props.scope})]}}])})}):_vm._e(),_vm._v(" "),(_vm.newFieldButtonVisible)?_c('NewFieldButton',{staticClass:"tree-node__new-field-btn",style:(_vm.newFieldButtonStyle()),attrs:{"data":_vm.data,"title":("Add a field " + (_vm.data.label ? 'to ' : '')),"titleStrong":_vm.data.label || '',"store":_vm.store},nativeOn:{"click":function($event){return _vm.handleAddNewField($event)}}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c09fb4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyTree.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"he-tree tree"},[_c('MyTreeNode',{attrs:{"data":_vm.rootData,"store":_vm.store,"indent":_vm.indent,"scope":_vm.scope,"usedKeys":_vm.usedKeys},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._t("default",null,{data:props.data,store:_vm.store,scope:_vm.scope})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 704 */
/*!**********************************!*\
  !*** ./src/components/Field.vue ***!
  \**********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Field.vue */ 306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348dcbb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-348dcbb9","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Field.vue */ 706);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-348dcbb9","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Field.vue */ 705)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348dcbb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 705 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-348dcbb9","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Field.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348dcbb9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Field.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"field-dragging-ghost"},[_c('div',{staticClass:"js-drag-handle"},[_c('div',{staticClass:"field__ico-drag"},[_c('BaseIcon',{attrs:{"name":"drag"}})],1)]),_vm._v(" "),_vm._t("toggleBtn"),_vm._v(" "),_c('span',{staticClass:"field__label"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),(_vm.field.children.length)?_c('span',{staticClass:"ghost__counter"},[_vm._v(_vm._s(_vm.field.children.length))]):_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"field__key"},[_c('span',[_vm._v(_vm._s(_vm.field.key))])]),_vm._v(" "),_c('span',{staticClass:"field__type"},[_vm._v(" "+_vm._s(_vm.field.type)+" ")]),_vm._v(" "),_c('div',{staticClass:"field__buttons"},[_c('BaseButton',{staticClass:"buttons__btn",attrs:{"title":"Edit"},nativeOn:{"click":function($event){return _vm.onEdit($event)}}}),_vm._v(" "),_c('BaseButton',{staticClass:"buttons__btn",attrs:{"icon":"trash"},nativeOn:{"click":function($event){return _vm.onDelete($event)}}}),_vm._v(" "),(_vm.showCodeIcon)?_c('BaseButton',{staticClass:"buttons__btn",attrs:{"icon":"code"},nativeOn:{"click":function($event){return _vm.onShowCode($event)}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 707 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59fded80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchemaTreeContainer.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-tree-container",class:_vm.className},[_c('MyTree',{ref:"myTree",attrs:{"ondragend":_vm.onDragEnd,"data":_vm.value.fields,"scope":_vm.scope,"usedKeys":_vm.value.usedKeys,"draggable":"","crossTree":false,"space":0,"indent":30,"getTriggerEl":_vm.dragHandler},on:{"addField":_vm.ADD_FIELD,"drag":function($event){_vm.dragging = true},"drop":function($event){_vm.dragging = false},"moving":_vm.onDragMoving},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var store = ref.store;
var scope = ref.scope;
return _c('div',{},[(!data.isDragPlaceHolder)?[_c('Field',{attrs:{"field":data,"scope":scope,"usedKeys":_vm.value.usedKeys},on:{"onDelete":_vm.openConfirmDeleteModal}},[(_vm.showToggleBtn(data))?_c('button',{staticClass:"field__toggle-btn",class:{ 'field__toggle-btn--opened': data.open },attrs:{"slot":"toggleBtn"},on:{"click":function($event){store.toggleOpen(data)}},slot:"toggleBtn"},[_c('BaseIcon',{attrs:{"name":"arrow"}})],1):_vm._e()])]:_vm._e()],2)}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1e77924","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-manage.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-manage container"},[_c('BaseButtonBack'),_vm._v(" "),_c('SchemaTreeContainer',{staticClass:"page-manage__tree",attrs:{"value":_vm.schema,"scope":_vm.scope}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('BaseButton',{staticClass:"page-manage__save-btn",attrs:{"theme":"primary","title":"Save","loading":_vm.loading},nativeOn:{"click":function($event){return _vm.save($event)}}}),_vm._v(" "),(_vm.linkScope)?_c('BaseHelpButton',{attrs:{"text":"View your","icon":"help","linkAction":_vm.linkAction,"linkLabel":(_vm.linkScope + ".")}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/*!*************************************************!*\
  !*** ./src/pages/page-manage-customobjects.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_customobjects_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-manage-customobjects.vue */ 307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f930692_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_customobjects_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6f930692","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-manage-customobjects.vue */ 713);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_customobjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f930692_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_customobjects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/*!*************************************************!*\
  !*** ./src/components/SectionCustomObjects.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCustomObjects_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionCustomObjects.vue */ 308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d54618_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCustomObjects_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-04d54618","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionCustomObjects.vue */ 712);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-04d54618","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SectionCustomObjects.vue */ 711)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionCustomObjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d54618_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionCustomObjects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04d54618","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionCustomObjects.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d54618","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionCustomObjects.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-categories",class:{ 'section-categories--list-layout': _vm.listLayout }},[(_vm.categories && _vm.categories.length)?_c('ul',{staticClass:"section-categories__list"},[_vm._l((_vm.categories),function(category){return _c('li',{key:category.key,staticClass:"li"},[_c('BaseLink',{staticClass:"category",attrs:{"to":category.to}},[_c('div',{staticClass:"category__icon"},[_c('BaseIcon',{attrs:{"name":category.icon}})],1),_vm._v(" "),_c('label',[_vm._v(_vm._s(category.name)+" ")])]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"edit-link",attrs:{"to":category.editUrl}},[_vm._v("Edit values")]),_vm._v(" "),_c('BaseButton',{staticClass:"buttons__btn",attrs:{"icon":"trash"},nativeOn:{"click":function($event){_vm.openConfirmDeleteModal(category.key)}}})],1)],1)}),_vm._v(" "),(!_vm.categories || !_vm.categories.length)?_c('li',[_c('h1',{staticClass:"alert alert__title"},[_vm._v("You don’t have any custom objects yet")]),_vm._v(" "),_c('h2',{staticClass:"alert alert__subtitle"},[_vm._v("Your custom objects will be shown here once you have created your first one.")])]):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._t("button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f930692","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-manage-customobjects.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('BaseButtonBack'),_vm._v(" "),_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":_vm.section.info.title,"text":_vm.section.info.text,"linkUrl":_vm.section.info.url},slot:"info"}),_vm._v(" "),_c('SectionCustomObjects',{attrs:{"slot":"categories","listLayout":_vm.section.listLayout,"allowDelete":true,"categories":_vm.customObjectsMapped},slot:"categories"},[_c('NewFieldButton',{attrs:{"slot":"button","title":"Add new custom object"},nativeOn:{"click":function($event){return _vm.onAddNewObject($event)}},slot:"button"})],1)],1),_vm._v(" "),_c('BaseHelpButton',{attrs:{"text":"Learn more by reading our","icon":"help","linkUrl":"https://www.airfields.io/","linkLabel":"documentation."}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/*!************************************************!*\
  !*** ./src/pages/page-manage-integrations.vue ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_integrations_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-manage-integrations.vue */ 309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09976ec6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_integrations_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-09976ec6","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-manage-integrations.vue */ 719);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-09976ec6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./page-manage-integrations.vue */ 715)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_manage_integrations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09976ec6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_manage_integrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09976ec6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/page-manage-integrations.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/*!********************************************!*\
  !*** ./src/components/SectionSettings.vue ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionSettings_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionSettings.vue */ 310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bed88a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionSettings_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-67bed88a","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionSettings.vue */ 718);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-67bed88a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SectionSettings.vue */ 717)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SectionSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bed88a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67bed88a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionSettings.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67bed88a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionSettings.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-settings"},[_c('ul',{staticClass:"section-settings__list"},[_vm._l((_vm.settings),function(setting){return (_vm.settings && _vm.settings.length)?_c('li',{staticClass:"li setting-item"},[_c('p',{staticClass:"setting-item__title"},[_vm._v(_vm._s(setting.title))]),_vm._v(" "),_c(_vm.basedOnMetafieldType(setting.type),{tag:"component",staticClass:"setting-item__field",attrs:{"field":setting,"name":setting.key,"groupName":setting.label,"hint":setting.description,"subFormData":setting.subForm},on:{"input":_vm.onInput},model:{value:(setting.value),callback:function ($$v) {_vm.$set(setting, "value", $$v)},expression:"setting.value"}})],1):_vm._e()}),_vm._v(" "),(!_vm.settings || !_vm.settings.length)?_c('li',[_c('h1',{staticClass:"alert alert__title"},[_vm._v("You don’t have any settings yet")])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09976ec6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-manage-integrations.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-manage container"},[_c('BaseButtonBack'),_vm._v(" "),_c('Section',[_c('SectionInfo',{attrs:{"slot":"info","title":'Integrations',"text":"Setup your integrations"},slot:"info"}),_vm._v(" "),_c('template',{slot:"categories"},[_c('SectionSettings',{attrs:{"title":_vm.sections.upscribe.title,"settings":_vm.sections.upscribe.settings},on:{"input":function (val) { return ( _vm.onInput(val, _vm.sections.upscribe.key) ); }}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.integrations)?_c('BaseButton',{staticClass:"page-edit__save-btn",attrs:{"theme":"primary","title":"Save","loading":_vm.loading},nativeOn:{"click":function($event){return _vm.save($event)}}}):_vm._e()],1)],2),_vm._v(" "),_c('BaseHelpButton',{attrs:{"text":"Learn more by reading our","icon":"help","linkUrl":"https://www.airfields.io/","linkLabel":"documentation."}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/*!***********************************!*\
  !*** ./src/pages/page-select.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_select_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./page-select.vue */ 311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0fe52a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_select_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9a0fe52a","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./page-select.vue */ 722);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9a0fe52a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./page-select.vue */ 721)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_page_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a0fe52a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a0fe52a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/page-select.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a0fe52a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-select.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-select container"},[_c('BaseButton',{staticClass:"button-back",attrs:{"title":"< Back","theme":"link"},nativeOn:{"click":function($event){_vm.goBack()}}}),_vm._v(" "),(!_vm.useRelationSetter)?_c('BaseButton',{staticClass:"button-select",attrs:{"title":_vm.buttonLabel,"theme":"primary"},nativeOn:{"click":function($event){_vm.openPicker()}}}):_vm._e(),_vm._v(" "),(_vm.useRelationSetter && _vm.resourceConfig)?_c('div',{staticClass:"item-selection-container"},[_c('RelationSetter',{attrs:{"items":_vm.items,"value":_vm.selectedItems,"loading":_vm.loadingItems,"unselectedLabel":_vm.resourceConfig.unselectedLabel,"selectedLabel":_vm.resourceConfig.selectedLabel,"key_uid":"id","key_label":"title","key_img":"image","key_img_second":"src"},on:{"input":_vm.handleItemSelection}}),_vm._v(" "),(_vm.selectedItems.length > 0)?_c('BaseButton',{staticClass:"button-proceed",attrs:{"title":"Proceed to Edit","theme":"primary"},nativeOn:{"click":function($event){_vm.proceedWithSelection()}}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */,
/* 724 */
/*!**********************!*\
  !*** ./src/root.vue ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_root_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./root.vue */ 312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58295fd7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_root_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-58295fd7","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./root.vue */ 809);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-58295fd7","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./root.vue */ 725)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_root_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58295fd7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_root_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58295fd7","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/root.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/*!**************************************************!*\
  !*** ./src/components/modals/ModalContainer.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContainer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalContainer.vue */ 313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be3c17f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContainer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-be3c17f4","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalContainer.vue */ 803);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-be3c17f4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ModalContainer.vue */ 727)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be3c17f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be3c17f4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/ModalContainer.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/*!*******************************************************!*\
  !*** ./src/components/modals/modals-content/index.js ***!
  \*******************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allComponents = {};

// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 729);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Strip the leading `'./` and extension from the filename
  var componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');

  allComponents = Object.assign({}, allComponents, _defineProperty({}, componentName, componentConfig.default || componentConfig));
});

/* harmony default export */ __webpack_exports__["a"] = (allComponents);

/***/ }),
/* 729 */
/*!*********************************************************************************!*\
  !*** ./src/components/modals/modals-content nonrecursive Modal[A-Z]\w+\.(vue)$ ***!
  \*********************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ModalConfirmDecision.vue": 730,
	"./ModalEditField.vue": 733,
	"./ModalFieldCode.vue": 776,
	"./ModalHint.vue": 783,
	"./ModalIframe.vue": 786,
	"./ModalImportWarning.vue": 789,
	"./ModalNewCustomObject.vue": 793,
	"./ModalNewCustomObjectGroup.vue": 796,
	"./ModalNewField.vue": 799
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 729;

/***/ }),
/* 730 */
/*!***********************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalConfirmDecision.vue ***!
  \***********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirmDecision_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalConfirmDecision.vue */ 314);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41feba58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirmDecision_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-41feba58","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalConfirmDecision.vue */ 732);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-41feba58","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 731)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirmDecision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41feba58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirmDecision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 731 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41feba58","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41feba58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalConfirmDecision.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[(!_vm.modalData.closeOnlyByConfirmButton)?_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.modalData.title)}}),_vm._v(" "),(_vm.modalData.description)?_c('div',{staticClass:"modal-field__content"},[_c('p',{staticClass:"modal-field__description",domProps:{"innerHTML":_vm._s(_vm.modalData.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[(_vm.modalData.btnTextCancel)?_c('BaseButton',{attrs:{"title":_vm.modalData.btnTextCancel},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}):_vm._e(),_vm._v(" "),_c('BaseButton',{attrs:{"title":_vm.modalData.btnTextConfirm,"theme":"primary"},nativeOn:{"click":function($event){return _vm.handleConfirmation($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 733 */
/*!*****************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalEditField.vue ***!
  \*****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditField_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalEditField.vue */ 315);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2cabd9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditField_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4e2cabd9","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalEditField.vue */ 775);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4e2cabd9","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 734)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalEditField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2cabd9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalEditField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 734 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e2cabd9","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6086a7cd","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/FormField.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/*!*************************************************!*\
  !*** ./src/components/forms/sub-forms/index.js ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allComponents = {};

// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 737);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Strip the leading `'./` and extension from the filename
  var componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');

  allComponents = Object.assign({}, allComponents, _defineProperty({}, componentName, componentConfig.default || componentConfig));
});

/* harmony default export */ __webpack_exports__["a"] = (allComponents);

/***/ }),
/* 737 */
/*!********************************************************************************!*\
  !*** ./src/components/forms/sub-forms nonrecursive SubForm[A-Z]\w+\.(vue|js)$ ***!
  \********************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SubFormBoolean.vue": 738,
	"./SubFormCustomObject.vue": 741,
	"./SubFormDate.vue": 744,
	"./SubFormGroup.vue": 747,
	"./SubFormInteger.vue": 750,
	"./SubFormNumber.vue": 753,
	"./SubFormRelation.vue": 756,
	"./SubFormRepeater.vue": 759,
	"./SubFormSelection.vue": 762,
	"./SubFormText.vue": 765,
	"./SubFormTextarea.vue": 768,
	"./SubFormVideo.vue": 771
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 737;

/***/ }),
/* 738 */
/*!***********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormBoolean.vue ***!
  \***********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormBoolean_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormBoolean.vue */ 317);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd5019c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormBoolean_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2bd5019c","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormBoolean.vue */ 740);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2bd5019c","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormBoolean.vue */ 739)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormBoolean_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd5019c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormBoolean_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 739 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bd5019c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormBoolean.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd5019c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormBoolean.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-boolean sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"label":"True value","hint":"Value of true","validate":"required","name":"on value"},model:{value:(_vm.form.onVal),callback:function ($$v) {_vm.$set(_vm.form, "onVal", $$v)},expression:"form.onVal"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"label":"False value","hint":"Value of false","validate":"required","name":"off value"},model:{value:(_vm.form.offVal),callback:function ($$v) {_vm.$set(_vm.form, "offVal", $$v)},expression:"form.offVal"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 741 */
/*!****************************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormCustomObject.vue ***!
  \****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormCustomObject_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormCustomObject.vue */ 318);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448bf616_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormCustomObject_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-448bf616","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormCustomObject.vue */ 743);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-448bf616","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormCustomObject.vue */ 742)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormCustomObject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448bf616_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormCustomObject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 742 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-448bf616","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormCustomObject.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448bf616","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormCustomObject.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-custom-object"},[(_vm.doRender)?[(_vm.customObjects.length)?_c('BaseSelect',{attrs:{"options":_vm.customObjects,"valueKey":"id","labelKey":"name","label":"Custom object","name":"custom object","placeholder":"Select custom object...","validate":"required"},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}):_c('TypographyInputError',[_vm._v("You haven't any custom objects yet.")])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/*!********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormDate.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormDate_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormDate.vue */ 319);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0319bfc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormDate_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d0319bfc","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormDate.vue */ 746);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d0319bfc","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormDate.vue */ 745)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0319bfc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 745 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0319bfc","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormDate.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0319bfc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormDate.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-date sub-columns"},[_c('BaseSwitcher',{staticClass:"sub-col",attrs:{"trueLabel":"DATE","falseLabel":"DATE & TIME","label":"Options","fillSpace":""},model:{value:(_vm.form.onlyDate),callback:function ($$v) {_vm.$set(_vm.form, "onlyDate", $$v)},expression:"form.onlyDate"}}),_vm._v(" "),_c('BaseSwitcher',{staticClass:"sub-col",attrs:{"trueLabel":"12h","falseLabel":"24h","label":"Time format","fillSpace":""},model:{value:(_vm.form.format12h),callback:function ($$v) {_vm.$set(_vm.form, "format12h", $$v)},expression:"form.format12h"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/*!*********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormGroup.vue ***!
  \*********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormGroup_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormGroup.vue */ 320);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a71b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormGroup_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-23a71b76","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormGroup.vue */ 749);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-23a71b76","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormGroup.vue */ 748)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23a71b76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 748 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-23a71b76","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormGroup.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a71b76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormGroup.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-group"},[_c('BaseSwitcher',{attrs:{"value":_vm.form.opened,"label":"View group as","hint":"Set default view as open or closed"},on:{"input":_vm.setView}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 750 */
/*!***********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormInteger.vue ***!
  \***********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormInteger_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormInteger.vue */ 321);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009358fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormInteger_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-009358fc","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormInteger.vue */ 752);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-009358fc","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormInteger.vue */ 751)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormInteger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009358fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormInteger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 751 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-009358fc","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormInteger.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-009358fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormInteger.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-integer sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"min value","validate":_vm.minValidator,"label":"Min value"},model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"max value","validate":"required|integer","label":"Max value","hint":"0 = no max value"},model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"theme":!_vm.form.prefix ? 'grayed' : null,"label":"Prefix","hint":"Shown while adding data"},model:{value:(_vm.form.prefix),callback:function ($$v) {_vm.$set(_vm.form, "prefix", $$v)},expression:"form.prefix"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"theme":!_vm.form.suffix ? 'grayed' : null,"label":"Suffix","hint":"Shown while adding data"},model:{value:(_vm.form.suffix),callback:function ($$v) {_vm.$set(_vm.form, "suffix", $$v)},expression:"form.suffix"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/*!**********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormNumber.vue ***!
  \**********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormNumber_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormNumber.vue */ 322);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9d20068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormNumber_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b9d20068","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormNumber.vue */ 755);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b9d20068","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormNumber.vue */ 754)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9d20068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 754 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9d20068","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormNumber.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9d20068","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormNumber.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-number sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"min value","validate":_vm.minValidator,"label":"Min value"},model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"max value","validate":"required|decimal","label":"Max value","hint":"0 = no max value"},model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/*!************************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormRelation.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormRelation_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormRelation.vue */ 323);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c686b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormRelation_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-40c686b6","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormRelation.vue */ 758);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-40c686b6","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormRelation.vue */ 757)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormRelation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c686b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormRelation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 757 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40c686b6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormRelation.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c686b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormRelation.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-relation"},[_c('p',{staticClass:"sub-form-relation__title"},[_vm._v("Relate to")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"product"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Product")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"variant"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Variant")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"collection"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Collection")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"smart-collection"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Smart collection")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"page"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Page")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"blog"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Blog")]),_vm._v(" "),_c('BaseRadioBox',{attrs:{"name":"relation","optionValue":"blog-post"},model:{value:(_vm.form.relateTo),callback:function ($$v) {_vm.$set(_vm.form, "relateTo", $$v)},expression:"form.relateTo"}},[_vm._v("Blog post")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/*!************************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormRepeater.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormRepeater_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormRepeater.vue */ 324);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0738ff1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormRepeater_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0738ff1b","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormRepeater.vue */ 761);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0738ff1b","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormRepeater.vue */ 760)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormRepeater_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0738ff1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormRepeater_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 760 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0738ff1b","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormRepeater.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0738ff1b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormRepeater.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-repeater sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"min number","validate":_vm.minValidator,"label":"Min number of instances"},model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"max number","validate":_vm.maxValidator,"label":"Max number of instances","hint":"0 = unlimited number of instances"},model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-w100",attrs:{"label":"Single instance title","hint":"\"Slideshow\" could have a \"Slide\" title."},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-w100",attrs:{"label":"Key of title field","hint":"Single repeater instance can be labelled by text from other field."},model:{value:(_vm.form.labelFieldKey),callback:function ($$v) {_vm.$set(_vm.form, "labelFieldKey", $$v)},expression:"form.labelFieldKey"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/*!*************************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormSelection.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormSelection_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormSelection.vue */ 325);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e19501e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormSelection_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2e19501e","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormSelection.vue */ 764);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2e19501e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormSelection.vue */ 763)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e19501e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 763 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e19501e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormSelection.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e19501e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormSelection.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-selection"},[_c('div',{staticClass:"sub-form-selection__columns sub-columns"},[_c('BaseSelect',{staticClass:"sub-col",attrs:{"options":_vm.selectOptions,"label":"Display","name":"display","hint":"Ways of displaying options (Select list, Checkboxes, Radioboxes)."},model:{value:(_vm.form.display),callback:function ($$v) {_vm.$set(_vm.form, "display", $$v)},expression:"form.display"}}),_vm._v(" "),(_vm.showSwitcher)?_c('BaseSwitcher',{staticClass:"sub-col",attrs:{"label":"Options layout","trueLabel":"VERTICAL","falseLabel":"HORIZONTAL","fillSpace":""},model:{value:(_vm.form.verticalLayout),callback:function ($$v) {_vm.$set(_vm.form, "verticalLayout", $$v)},expression:"form.verticalLayout"}}):_vm._e()],1),_vm._v(" "),_c('BaseTextarea',{attrs:{"minHeight":"95","label":"Options","hint":"Add each option in a new line.","value":_vm.optionsStr,"isLocked":_vm.isOptionsFieldLocked},on:{"input":_vm.recieveOptions},nativeOn:{"click":function($event){return _vm.onLockedFieldClick($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/*!********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormText.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormText_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormText.vue */ 326);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c09602_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormText_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-06c09602","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormText.vue */ 767);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-06c09602","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormText.vue */ 766)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c09602_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 766 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06c09602","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormText.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c09602","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormText.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-text sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"type":"number","name":"min value","validate":_vm.minValidator,"label":"Min characters length"},model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"type":"number","name":"max value","validate":"required|integer|min_value:0","label":"Max characters length","hint":"0 = unlimited number of characters"},model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 768 */
/*!************************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormTextarea.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormTextarea_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormTextarea.vue */ 327);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248ea052_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormTextarea_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-248ea052","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormTextarea.vue */ 770);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-248ea052","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormTextarea.vue */ 769)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248ea052_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 769 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-248ea052","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormTextarea.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248ea052","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormTextarea.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-textarea sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"type":"number","name":"min value","validate":_vm.minValidator,"label":"Min characters length"},model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"type":"number","name":"max value","validate":"required|integer|min_value:0","label":"Max characters length","hint":"0 = unlimited number of characters"},model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-w100",attrs:{"label":"Number of rows","hint":"How tall this field should be while adding content."},model:{value:(_vm.form.rows),callback:function ($$v) {_vm.$set(_vm.form, "rows", $$v)},expression:"form.rows"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/*!*********************************************************!*\
  !*** ./src/components/forms/sub-forms/SubFormVideo.vue ***!
  \*********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormVideo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SubFormVideo.vue */ 328);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9766b9f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormVideo_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9766b9f0","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SubFormVideo.vue */ 773);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9766b9f0","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SubFormVideo.vue */ 772)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_SubFormVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9766b9f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubFormVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 772 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9766b9f0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/sub-forms/SubFormVideo.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9766b9f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/sub-forms/SubFormVideo.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-form-video sub-columns"},[_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"width","validate":"required|integer|min_value:1","suffix":"px","label":"Width value","hint":"Player width in pixels"},model:{value:(_vm.form.width),callback:function ($$v) {_vm.$set(_vm.form, "width", $$v)},expression:"form.width"}}),_vm._v(" "),_c('BaseInput',{staticClass:"sub-col",attrs:{"name":"height","validate":"required|integer|min_value:1","suffix":"px","label":"Height value","hint":"Player height in pixels"},model:{value:(_vm.form.height),callback:function ($$v) {_vm.$set(_vm.form, "height", $$v)},expression:"form.height"}}),_vm._v(" "),_c('BaseSwitcher',{staticClass:"sub-col",attrs:{"trueLabel":"ON","falseLabel":"OFF","label":"Autoplay","hint":"Autoplay video","fillSpace":""},model:{value:(_vm.form.autoplay),callback:function ($$v) {_vm.$set(_vm.form, "autoplay", $$v)},expression:"form.autoplay"}}),_vm._v(" "),_c('BaseSwitcher',{staticClass:"sub-col",attrs:{"trueLabel":"YES","falseLabel":"NO","label":"Allow full screen","hint":"Allow full screen for video","fillSpace":""},model:{value:(_vm.form.allowFullScreen),callback:function ($$v) {_vm.$set(_vm.form, "allowFullScreen", $$v)},expression:"form.allowFullScreen"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6086a7cd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormField.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-field",on:{"submit":function($event){$event.preventDefault();}}},[_c('BaseInput',{attrs:{"name":"label","validate":"required","label":"Label"},on:{"input":_vm.autocompleteKeyform},model:{value:(_vm.form.label),callback:function ($$v) {_vm.$set(_vm.form, "label", $$v)},expression:"form.label"}}),_vm._v(" "),_c('BaseInput',{attrs:{"label":"Description","hint":"Short hint to understand the purpose"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),(_vm.showKey)?_c('BaseInput',{class:{'form-field__repeater-indicator': _vm.parent && _vm.parent.type === 'repeater'},attrs:{"value":_vm.form.key,"label":"Key","meta":_vm.metaKey,"name":"key","validate":_vm.keyValidation,"isLocked":_vm.isKeyFieldLocked},on:{"input":_vm.onKeyInput},nativeOn:{"click":function($event){return _vm.onLockedFieldClick($event)}}}):_vm._e(),_vm._v(" "),(_vm.showTypeSelect)?_c('BaseSelect',{attrs:{"options":_vm.SELECT_OPTIONS,"groupedOptions":"","label":"Type","name":"type","placeholder":"Select...","hint":_vm.form.type && _vm.TYPES_DATA[_vm.form.type] ? _vm.TYPES_DATA[_vm.form.type].hint : null,"learnAction":_vm.showLearnModal,"learnLabel":_vm.selectedTypeLabel && ("Learn about " + _vm.selectedTypeLabel + " field"),"theme":_vm.selectDisabled ? 'disabled' : null,"validate":"required"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}}):_vm._e(),_vm._v(" "),_c('BaseCollapse',{attrs:{"changeHeight":_vm.doUpdate,"transitionDuration":0.6}},[(_vm.subFormExists)?_c(_vm.subFormComponent,{tag:"component",on:{"update":_vm.onUpdate},model:{value:(_vm.form.subForm),callback:function ($$v) {_vm.$set(_vm.form, "subForm", $$v)},expression:"form.subForm"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e2cabd9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalEditField.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('FormField',{staticClass:"modal-field__form modals-container__scroll-content",attrs:{"scope":_vm.modalData.scope,"forbiddenKeys":_vm.forbiddenKeys,"parent":_vm.modalData.parent,"showKeyHint":_vm.modalData.scope !== 'customobjectsgroups'},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Cancel"},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Save","theme":"primary"},nativeOn:{"click":function($event){return _vm.handleSubmit($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/*!*****************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalFieldCode.vue ***!
  \*****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalFieldCode_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalFieldCode.vue */ 329);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4828c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalFieldCode_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6f4828c4","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalFieldCode.vue */ 782);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6f4828c4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 777)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalFieldCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f4828c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalFieldCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 777 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f4828c4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/*!*******************************************************************!*\
  !*** ./src/components/modals/modals-content/prism-liquid-html.js ***!
  \*******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

Prism.languages['liquid-html'] = {
  'tag': {
    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
    greedy: true,
    inside: {
      'tag': {
        pattern: /^<\/?[^\s>\/]+/i,
        inside: {
          'punctuation': /^<\/?/,
          'namespace': /^[^\s>\/:]+:/
        }
      },
      'attr-value': {
        pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
        inside: {
          'punctuation': [/^=/, {
            pattern: /(^|[^\\])["']/,
            lookbehind: true
          }]
        }
      },
      'punctuation': /\/?>/,
      'attr-name': {
        pattern: /[^\s>\/]+/,
        inside: {
          'namespace': /^[^\s>\/:]+:/
        }
      }

    }
  },
  'keyword': /\b(?:comment|endcomment|if|elsif|else|endif|unless|endunless|for|endfor|case|endcase|when|in|break|assign|continue|limit|offset|range|reversed|raw|endraw|capture|endcapture|tablerow|endtablerow|contains|and)\b/,
  // 'number': /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp-]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?[df]?/i,
  'operator': {
    pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
    lookbehind: true
  },
  'function': {
    pattern: /(^|[\s;|&])(?:append|prepend|capitalize|cycle|cols|increment|decrement|abs|at_least|at_most|ceil|compact|concat|date|default|divided_by|downcase|escape|escape_once|first|floor|join|last|lstrip|map|minus|modulo|newline_to_br|plus|remove|remove_first|replace|replace_first|reverse|round|rstrip|size|slice|sort|sort_natural|split|strip|strip_html|strip_newlines|times|truncate|truncatewords|uniq|upcase|url_decode|url_encode|include|paginate)(?=$|[\s;|&])/,
    lookbehind: true
  },
  'comment': /<!--[\s\S]*?-->/,
  'prolog': /<\?[\s\S]+?\?>/,
  'doctype': /<!DOCTYPE[\s\S]+?>/i,
  'cdata': /<!\[CDATA\[[\s\S]*?]]>/i,
  'entity': /&#?[\da-z]{1,8};/i
};

Prism.hooks.add('wrap', function (env) {

  if (env.type === 'entity') {
    env.attributes['title'] = env.content.replace(/&amp;/, '&');
  }
});

/***/ }),
/* 782 */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4828c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalFieldCode.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('Prism',{staticClass:"modal-field__pre-code modals-container__scroll-content",attrs:{"language":"liquid-html"}},[_vm._v("\n    "+_vm._s(_vm.liquidCode)+"\n  ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.liquidCode),expression:"liquidCode"}],ref:"code",staticClass:"modal-field__textarea-code",domProps:{"value":(_vm.liquidCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.liquidCode=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Close"},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":_vm.copyButtonText,"theme":"primary"},nativeOn:{"click":function($event){return _vm.handleCopy($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/*!************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalHint.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalHint_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalHint.vue */ 330);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2513d2dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalHint_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2513d2dd","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalHint.vue */ 785);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2513d2dd","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 784)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalHint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2513d2dd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalHint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 784 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2513d2dd","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2513d2dd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalHint.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.modalData.message)}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"OK"},nativeOn:{"click":function($event){return _vm.closeModal($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/*!**************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalIframe.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalIframe_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalIframe.vue */ 331);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32687862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalIframe_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-32687862","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalIframe.vue */ 788);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-32687862","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ModalIframe.vue */ 787)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalIframe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32687862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalIframe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 787 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32687862","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/modals-content/ModalIframe.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32687862","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalIframe.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-tutorial"},[_c('button',{staticClass:"modal-tutorial__close",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"modal-tutorial-fade"}},[_c('iframe',{directives:[{name:"visible",rawName:"v-visible",value:(!_vm.loading),expression:"!loading"}],attrs:{"src":_vm.modalData.src,"width":"100%","height":"100%","frameborder":"0"},on:{"load":function($event){_vm.loading = false}}})]),_vm._v(" "),(_vm.loading)?_c('BaseSpinnerBig',{staticClass:"modal-tutorial__spinner"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/*!*********************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalImportWarning.vue ***!
  \*********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalImportWarning_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalImportWarning.vue */ 332);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8d6b8e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalImportWarning_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e8d6b8e2","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalImportWarning.vue */ 792);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e8d6b8e2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 790)
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e8d6b8e2","scoped":false,"hasInlineConfig":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./ModalImportWarning.vue */ 791)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalImportWarning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8d6b8e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalImportWarning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 790 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8d6b8e2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8d6b8e2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/modals/modals-content/ModalImportWarning.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/*!**********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8d6b8e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalImportWarning.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",class:_vm.className,on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title modal-field__title--warning",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"modal-field__content"},[_vm._v("You are about to import new data which will result in deleting everything you had till now.")]),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Cancel importing","theme":"cancel","disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Import and delete current data","loading":_vm.loading,"theme":"primary"},nativeOn:{"click":function($event){return _vm.handleSubmit($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/*!***********************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalNewCustomObject.vue ***!
  \***********************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewCustomObject_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalNewCustomObject.vue */ 333);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd6acf8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewCustomObject_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6bd6acf8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalNewCustomObject.vue */ 795);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6bd6acf8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 794)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewCustomObject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd6acf8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewCustomObject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 794 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bd6acf8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bd6acf8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalNewCustomObject.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('FormField',{staticClass:"modal-field__form modals-container__scroll-content",attrs:{"scope":"customobjects","forbiddenKeys":_vm.modalData.usedKeys,"showTypeSelect":false,"showKeyHint":false},on:{"input":_vm.collectForm}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Cancel","disabled":_vm.loading.save},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Add","theme":"primary","loading":_vm.loading.save},nativeOn:{"click":function($event){return _vm.handleSubmit($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 796 */
/*!****************************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalNewCustomObjectGroup.vue ***!
  \****************************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewCustomObjectGroup_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalNewCustomObjectGroup.vue */ 334);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d7f43a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewCustomObjectGroup_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-05d7f43a","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalNewCustomObjectGroup.vue */ 798);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-05d7f43a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 797)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewCustomObjectGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d7f43a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewCustomObjectGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 797 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05d7f43a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d7f43a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalNewCustomObjectGroup.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('FormField',{staticClass:"modal-field__form modals-container__scroll-content",attrs:{"scope":"customobjectsgroups","forbiddenKeys":[],"showTypeSelect":false,"showKey":false},on:{"input":_vm.collectForm}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Cancel","disabled":_vm.loading.save},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Add","theme":"primary","loading":_vm.loading.save},nativeOn:{"click":function($event){return _vm.handleSubmit($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 799 */
/*!****************************************************************!*\
  !*** ./src/components/modals/modals-content/ModalNewField.vue ***!
  \****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewField_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalNewField.vue */ 335);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ed43fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewField_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-06ed43fb","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalNewField.vue */ 801);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-06ed43fb","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!./modal-field.scss */ 800)
}
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNewField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ed43fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNewField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 800 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06ed43fb","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/modals/modals-content/modal-field.scss ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ed43fb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/modals-content/ModalNewField.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-field"},[_c('button',{staticClass:"modal-field__close-btn",on:{"click":_vm.closeModal}},[_c('BaseIcon',{attrs:{"name":"cross"}})],1),_vm._v(" "),_c('h1',{staticClass:"modal-field__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('FormField',{staticClass:"modal-field__form modals-container__scroll-content",attrs:{"scope":_vm.modalData.scope,"parent":_vm.modalData.parent,"forbiddenKeys":_vm.modalData.usedKeys,"showKeyHint":_vm.modalData.scope !== 'customobjectsgroups'},on:{"input":_vm.collectForm}}),_vm._v(" "),_c('div',{staticClass:"modal-field__buttons"},[_c('BaseButton',{attrs:{"title":"Cancel"},nativeOn:{"click":function($event){return _vm.closeModal($event)}}}),_vm._v(" "),_c('BaseButton',{attrs:{"title":"Add","theme":"primary"},nativeOn:{"click":function($event){return _vm.handleSubmit($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */,
/* 803 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3c17f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ModalContainer.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{ref:"modalsContainer",attrs:{"name":"modals-container","tag":"div"}},_vm._l((_vm.modals),function(modal){return _c('div',{key:modal.name,staticClass:"modals-container",class:_vm.className(modal)},[_c(modal.name,{ref:"modalsContent",refInFor:true,tag:"component",staticClass:"modals-container__content",attrs:{"modalData":modal.props}}),_vm._v(" "),_c('div',{staticClass:"modals-container__overlay",on:{"click":_vm.closeModal}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/*!***********************************!*\
  !*** ./src/components/Banner.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Banner.vue */ 336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d120b65_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1d120b65","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Banner.vue */ 806);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1d120b65","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Banner.vue */ 805)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d120b65_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 805 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d120b65","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Banner.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d120b65","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banners.length)?_c('div',{staticClass:"container banners-container"},_vm._l((_vm.banners),function(banner){return _c('div',{key:banner.key,staticClass:"banner",class:_vm.className(banner.status)},[_c('div',{staticClass:"banner__icon"},[_c('BaseIcon',{attrs:{"name":banner.status === 'info' ? 'warning' : banner.status}})],1),_vm._v(" "),_c('div',{staticClass:"banner__content"},[_c('h1',{staticClass:"content__title"},[_vm._v(_vm._s(banner.title))]),_vm._v(" "),_c('p',{staticClass:"content__message",domProps:{"innerHTML":_vm._s(banner.message)}}),_vm._v(" "),(banner.buttonAction)?_c('BaseButton',{staticClass:"content__button",attrs:{"title":banner.buttonLabel},nativeOn:{"click":function($event){return banner.buttonAction($event)}}}):_vm._e()],1)])})):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 807 */
/*!****************************************!*\
  !*** ./src/components/ShopifyPage.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ShopifyPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ShopifyPage.vue */ 337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c05cd95_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopifyPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6c05cd95","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ShopifyPage.vue */ 808);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ShopifyPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c05cd95_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopifyPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 808 */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c05cd95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopifyPage.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('s-page',{attrs:{"title":_vm.pageTitle}},[(_vm.showBreadcrumb)?_c('s-link',{attrs:{"slot":"breadcrumb-actions"},on:{"click":_vm.goHome},slot:"breadcrumb-actions"},[_vm._v("\n    Home\n  ")]):_vm._e(),_vm._v(" "),(_vm.buttonsSet === 'item')?_c('s-button',{attrs:{"slot":"primary-action","variant":"primary"},on:{"click":_vm.handleSave},slot:"primary-action"},[_vm._v("\n    Save\n  ")]):_vm._e(),_vm._v(" "),(_vm.buttonsSet === 'dashboard')?[_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleImport},slot:"secondary-actions"},[_vm._v("Import")]),_vm._v(" "),_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleExport},slot:"secondary-actions"},[_vm._v("Export")]),_vm._v(" "),_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleTutorial},slot:"secondary-actions"},[_vm._v("Tutorial")]),_vm._v(" "),_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleHelp},slot:"secondary-actions"},[_vm._v("Get help")]),_vm._v(" "),_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleReview},slot:"secondary-actions"},[_vm._v("Leave review")])]:(_vm.buttonsSet === 'item' || _vm.buttonsSet === 'helpOnly')?[_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleHelp},slot:"secondary-actions"},[_vm._v("Get help")]),_vm._v(" "),_c('s-button',{attrs:{"slot":"secondary-actions"},on:{"click":_vm.handleReview},slot:"secondary-actions"},[_vm._v("Leave review")])]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58295fd7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/root.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"af-root"},[_c('Banner'),_vm._v(" "),_c('ShopifyPage'),_vm._v(" "),(!_vm.$route.matched.length)?_c('BaseSpinnerBig'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('ModalContainer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/*!**************************************!*\
  !*** ./src/assets/styles/_main.scss ***!
  \**************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/*!*****************************************!*\
  !*** ./src/assets/styles/nprogress.css ***!
  \*****************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/*!**************************************!*\
  !*** ./src/components/base/index.js ***!
  \**************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 813);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  var componentName = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["camelCase"])(
  // Strip the leading `'./` and extension from the filename
  fileName.replace(/^\.\/(.*)\.\w+$/, '$1')));

  // Register component globally
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(componentName,
  // Look for the component options on `.default`, which will
  // exist if the component was exported with `export default`,
  // otherwise fall back to module's root.
  componentConfig.default || componentConfig);
});

/***/ }),
/* 813 */
/*!***************************************************************!*\
  !*** ./src/components/base nonrecursive Base[A-Z]\w+\.(vue)$ ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./BaseAccordion.vue": 814,
	"./BaseButton.vue": 817,
	"./BaseButtonBack.vue": 820,
	"./BaseCheckBox.vue": 823,
	"./BaseCollapse.vue": 826,
	"./BaseHelpButton.vue": 832,
	"./BaseHtml.vue": 835,
	"./BaseIcon.vue": 840,
	"./BaseImage.vue": 919,
	"./BaseInput.vue": 50,
	"./BaseJson.vue": 922,
	"./BaseLink.vue": 925,
	"./BasePictureInput.vue": 928,
	"./BaseRadioBox.vue": 934,
	"./BaseSelect.vue": 937,
	"./BaseSpinnerBig.vue": 939,
	"./BaseSwitcher.vue": 942,
	"./BaseTextarea.vue": 945,
	"./BaseWysiwyg.vue": 947
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813;

/***/ }),
/* 814 */
/*!***********************************************!*\
  !*** ./src/components/base/BaseAccordion.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseAccordion_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseAccordion.vue */ 338);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_904e4e88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseAccordion_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-904e4e88","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseAccordion.vue */ 816);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-904e4e88","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseAccordion.vue */ 815)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_904e4e88_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 815 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-904e4e88","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseAccordion.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-904e4e88","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseAccordion.vue ***!
  \************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-accordion js-base-accordion"},[_vm._t("default",null,{onCollapse:_vm.onCollapse,opened:_vm.opened})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 817 */
/*!********************************************!*\
  !*** ./src/components/base/BaseButton.vue ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButton_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseButton.vue */ 339);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29219f79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButton_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-29219f79","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseButton.vue */ 819);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-29219f79","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseButton.vue */ 818)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29219f79_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 818 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29219f79","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseButton.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29219f79","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseButton.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:_vm.className,attrs:{"disabled":_vm.disabled || _vm.loading}},[(_vm.title)?_c('span',{staticClass:"base-button__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.icon)?_c('BaseIcon',{staticClass:"base-button__icon",attrs:{"name":_vm.icon,"useImgNotSvg":_vm.useImgNotSvg}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"base-button__spinner"},[_c('BaseIcon',{attrs:{"name":"spinner"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/*!************************************************!*\
  !*** ./src/components/base/BaseButtonBack.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButtonBack_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseButtonBack.vue */ 340);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768cb0a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButtonBack_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-768cb0a2","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseButtonBack.vue */ 822);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-768cb0a2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseButtonBack.vue */ 821)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseButtonBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768cb0a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseButtonBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 821 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-768cb0a2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseButtonBack.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768cb0a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseButtonBack.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-back-wrapper"},[_c('BaseButton',{attrs:{"slot":"button","title":"Back"},nativeOn:{"click":function($event){return _vm.goBack($event)}},slot:"button"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/*!**********************************************!*\
  !*** ./src/components/base/BaseCheckBox.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCheckBox_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseCheckBox.vue */ 341);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1856bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCheckBox_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7e1856bb","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseCheckBox.vue */ 825);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7e1856bb","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseCheckBox.vue */ 824)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCheckBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1856bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCheckBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 824 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e1856bb","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseCheckBox.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1856bb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseCheckBox.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-check-box"},[_c('label',[_c('BaseIcon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),_c('input',_vm._g({attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.optionValue,"checked":_vm.checked}},_vm.listeners)),_vm._v(" "),_c('p',[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/*!**********************************************!*\
  !*** ./src/components/base/BaseCollapse.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCollapse_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseCollapse.vue */ 342);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6278a974_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCollapse_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6278a974","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseCollapse.vue */ 831);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCollapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6278a974_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCollapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6278a974","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseCollapse.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{ref:"baseCollapse",staticClass:"BaseCollapse",staticStyle:{"overflow":"hidden","will-change":"height"}},[_c('div',{ref:"calcWrapper"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 832 */
/*!************************************************!*\
  !*** ./src/components/base/BaseHelpButton.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHelpButton_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseHelpButton.vue */ 350);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e53585be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHelpButton_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e53585be","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseHelpButton.vue */ 834);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e53585be","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseHelpButton.vue */ 833)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHelpButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e53585be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHelpButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 833 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e53585be","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseHelpButton.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e53585be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseHelpButton.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-help-button"},[_c('div',{staticClass:"base-help-button__icon"},[_c('BaseIcon',{attrs:{"name":_vm.icon}})],1),_vm._v(" "),_c('span',{staticClass:"base-help-button__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.linkAction)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.linkAction()}}},[_vm._v(_vm._s(_vm.linkLabel))]):_c('a',{attrs:{"href":_vm.linkUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.linkLabel))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 835 */
/*!******************************************!*\
  !*** ./src/components/base/BaseHtml.vue ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHtml_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseHtml.vue */ 351);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185c176e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHtml_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-185c176e","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseHtml.vue */ 839);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-185c176e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseHtml.vue */ 836)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHtml_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185c176e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHtml_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 836 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-185c176e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseHtml.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75c624a6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseInput.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c624a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseInput.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',{attrs:{"for":_vm.id}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.isLocked)?_c('BaseIcon',{staticClass:"base-input__padlock",attrs:{"name":'locked-padlock'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"base-input__wrapper"},[(_vm.prefix)?_c('p',{staticClass:"wrapper__prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(" "),_c('input',_vm._g(_vm._b({directives:[{name:"validate",rawName:"v-validate",value:(_vm.validate),expression:"validate"}],attrs:{"aria-describedby":_vm.describedBy,"aria-errormessage":_vm.errorMessage,"id":_vm.id,"disabled":_vm.isFieldDisabled},domProps:{"value":_vm._f("formatVal")(_vm.value,_vm.formatNum)}},'input',_vm.$attrs,false),_vm.listeners)),_vm._v(" "),(_vm.suffix)?_c('p',{staticClass:"wrapper__suffix"},[_vm._v(_vm._s(_vm.suffix))]):_vm._e(),_vm._v(" "),(_vm.$attrs.type === 'number')?_c('div',{staticClass:"wrapper__arrows"},[_c('button',{on:{"click":_vm.increaseVal}},[_c('BaseIcon',{attrs:{"name":"arrow"}})],1),_vm._v(" "),_c('button',{on:{"click":_vm.decreaseVal}},[_c('BaseIcon',{attrs:{"name":"arrow"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',{attrs:{"id":_vm.errorMessageId}},[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',{attrs:{"id":_vm.hintId}},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 839 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185c176e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseHtml.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{class:("html-editor-" + _vm.uuid),style:({ minHeight: (_vm.minHeight + "px") })}),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e(),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/*!******************************************!*\
  !*** ./src/components/base/BaseIcon.vue ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseIcon_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseIcon.vue */ 354);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed2fae7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseIcon_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3ed2fae7","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseIcon.vue */ 918);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3ed2fae7","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseIcon.vue */ 841)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed2fae7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 841 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ed2fae7","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseIcon.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/*!********************************************!*\
  !*** ./src/components/base/icons/index.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var allComponents = {};

// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 843);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Strip the leading `'./` and extension from the filename
  var componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1');

  allComponents = Object.assign({}, allComponents, _defineProperty({}, componentName, componentConfig.default || componentConfig));
});

/* harmony default export */ __webpack_exports__["a"] = (allComponents);

/***/ }),
/* 843 */
/*!************************************************************!*\
  !*** ./src/components/base/icons nonrecursive \w+\.(vue)$ ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ico-arrow-right.vue": 844,
	"./ico-arrow.vue": 846,
	"./ico-checkbox-selected.vue": 848,
	"./ico-checkbox-unselected.vue": 850,
	"./ico-circle-cancel.vue": 852,
	"./ico-circle-information.vue": 854,
	"./ico-circle-plus-outline.vue": 856,
	"./ico-circle-plus.vue": 858,
	"./ico-code.vue": 860,
	"./ico-cross.vue": 862,
	"./ico-customers.vue": 864,
	"./ico-double-arrows.vue": 866,
	"./ico-drag.vue": 868,
	"./ico-export.vue": 870,
	"./ico-help.vue": 872,
	"./ico-hint.vue": 874,
	"./ico-icons.vue": 876,
	"./ico-images.vue": 878,
	"./ico-import.vue": 880,
	"./ico-locked-padlock.vue": 882,
	"./ico-loupe.vue": 884,
	"./ico-mobile-vertical-dots.vue": 886,
	"./ico-note.vue": 888,
	"./ico-notes.vue": 890,
	"./ico-orders.vue": 892,
	"./ico-products.vue": 894,
	"./ico-radio-selected.vue": 896,
	"./ico-radio-unselected.vue": 898,
	"./ico-spinner-big.vue": 900,
	"./ico-spinner.vue": 902,
	"./ico-success.vue": 904,
	"./ico-text-block-2.vue": 906,
	"./ico-text-block.vue": 908,
	"./ico-tools.vue": 910,
	"./ico-trash.vue": 912,
	"./ico-view.vue": 914,
	"./ico-warning.vue": 916
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 843;

/***/ }),
/* 844 */
/*!*******************************************************!*\
  !*** ./src/components/base/icons/ico-arrow-right.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605e9548_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_arrow_right_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-605e9548","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-arrow-right.vue */ 845);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605e9548_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_arrow_right_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 845 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605e9548","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-arrow-right.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"12","viewBox":"0 0 16 12"}},[_c('path',{attrs:{"fill":"currentColor","d":"M15.7722528,5.45658065 L11.0138885,0.295290323 C10.7235688,-0.0196129032 10.2527286,-0.0196129032 9.96240892,0.295290323 C9.67202974,0.610258065 9.67202974,1.12083871 9.96240892,1.43580645 L13.451539,5.2203871 L0.743494424,5.2203871 C0.332907063,5.2203871 0,5.58148387 0,6.02683871 C0,6.47212903 0.332907063,6.83329032 0.743494424,6.83329032 L13.451539,6.83329032 L9.96252788,10.617871 C9.6721487,10.9328387 9.6721487,11.4434194 9.96252788,11.7583871 C10.107658,11.9157419 10.2979926,11.9945806 10.4882677,11.9945806 C10.6785428,11.9945806 10.8688178,11.9157419 11.0140074,11.7583871 L15.7722528,6.59709677 C16.062632,6.28212903 16.062632,5.77154839 15.7722528,5.45658065 Z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-arrow.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa1f6d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_arrow_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4aa1f6d0","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-arrow.vue */ 847);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa1f6d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_arrow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 847 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa1f6d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-arrow.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"10","height":"5","viewBox":"0 0 10 5"}},[_c('defs',[_c('polygon',{attrs:{"id":"dropdown-a","points":"5 8 10 13 15 8"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-5 -8)"}},[_c('mask',{attrs:{"id":"dropdown-b","fill":"transparent"}},[_c('use',{attrs:{"xlink:href":"#dropdown-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#dropdown-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/*!*************************************************************!*\
  !*** ./src/components/base/icons/ico-checkbox-selected.vue ***!
  \*************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292c400d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_checkbox_selected_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-292c400d","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-checkbox-selected.vue */ 849);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_292c400d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_checkbox_selected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 849 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-292c400d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-checkbox-selected.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"01-default-c","x1":"50%","x2":"50%","y1":"3.117%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#617985"}})],1),_vm._v(" "),_c('rect',{attrs:{"id":"01-default-b","width":"16","height":"16","rx":"3"}}),_vm._v(" "),_c('filter',{attrs:{"id":"01-default-a","width":"137.5%","height":"137.5%","x":"-18.8%","y":"-6.2%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":".5"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"shadowBlurOuter1","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter1"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","result":"shadowMatrixOuter1","values":"0 0 0 0 0.251   0 0 0 0 0.3216   0 0 0 0 0.3451  0 0 0 0.032 0"}}),_vm._v(" "),_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter2"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter2","result":"shadowBlurOuter2","stdDeviation":".5"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"shadowBlurOuter2","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter2"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter2","result":"shadowMatrixOuter2","values":"0 0 0 0 0.3796   0 0 0 0 0.4755   0 0 0 0 0.52  0 0 0 0.0528 0"}}),_vm._v(" "),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter1"}}),_vm._v(" "),_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter2"}})],1)],1)],1),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#01-default-a)","xlink:href":"#01-default-b"}}),_vm._v(" "),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#01-default-b"}}),_vm._v(" "),_c('rect',{attrs:{"width":"15","height":"15","x":".5","y":".5","fill":"url(#01-default-c)","fill-opacity":".02","stroke":"#5C6AC4","stroke-linejoin":"square","rx":"3"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#5C6AC4","d":"M6.31475766,11.8585 L3.13295394,8.4415 C2.95568202,8.2535 2.95568202,7.9475 3.13295394,7.7575 L3.77567829,7.0745 C3.95295021,6.8865 4.24113072,6.8865 4.41840264,7.0745 L6.63657438,9.4665 L11.5810974,4.1415 C11.7583693,3.9535 12.0465498,3.9535 12.2238217,4.1415 L12.8665461,4.8255 C13.043818,5.0135 13.043818,5.3205 12.8665461,5.5075 L6.95748201,11.8585 C6.78021009,12.0465 6.49202958,12.0465 6.31475766,11.8585"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 850 */
/*!***************************************************************!*\
  !*** ./src/components/base/icons/ico-checkbox-unselected.vue ***!
  \***************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f27ded62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_checkbox_unselected_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f27ded62","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-checkbox-unselected.vue */ 851);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f27ded62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_checkbox_unselected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 851 */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f27ded62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-checkbox-unselected.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"01-default-c","x1":"50%","x2":"50%","y1":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F9FAFB"}})],1),_vm._v(" "),_c('rect',{attrs:{"id":"01-default-b","width":"16","height":"16","rx":"3"}}),_vm._v(" "),_c('filter',{attrs:{"id":"01-default-a","width":"106.2%","height":"112.5%","x":"-3.1%","y":"-3.1%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"shadowOffsetOuter1","in2":"SourceAlpha","operator":"out","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"shadowOffsetOuter1","values":"0 0 0 0 0.0863   0 0 0 0 0.1137   0 0 0 0 0.1451  0 0 0 0.05 0"}})],1)],1),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#01-default-a)","xlink:href":"#01-default-b"}}),_vm._v(" "),_c('rect',{attrs:{"width":"15","height":"15","x":".5","y":".5","fill":"url(#01-default-c)","stroke":"#C4CDD5","stroke-linejoin":"square","rx":"3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/*!*********************************************************!*\
  !*** ./src/components/base/icons/ico-circle-cancel.vue ***!
  \*********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8cbeb5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_cancel_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a8cbeb5","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-circle-cancel.vue */ 853);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8cbeb5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_cancel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 853 */
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8cbeb5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-circle-cancel.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.242 12.829l-1.414 1.414L10 11.413l-2.828 2.83-1.414-1.414 2.828-2.83-2.828-2.827 1.414-1.414L10 8.586l2.828-2.828 1.414 1.414L11.414 10l2.828 2.829zM10 1.999A8 8 0 1 0 10 18a8 8 0 0 0 0-16z","fill":"#31373D","fill-rule":"evenodd"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/*!**************************************************************!*\
  !*** ./src/components/base/icons/ico-circle-information.vue ***!
  \**************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7287bec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_information_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7287bec0","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-circle-information.vue */ 855);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7287bec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 855 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7287bec0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-circle-information.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("Monotone")]),_vm._v(" "),_c('desc',[_vm._v("Created with Sketch.")]),_vm._v(" "),_c('defs',[_c('path',{attrs:{"d":"M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M11,13 L11,10 C11,9.447 10.552,9 10,9 L9,9 C8.448,9 8,9.447 8,10 C8,10.553 8.448,11 9,11 L9,14 C9,14.553 9.448,15 10,15 L11,15 C11.552,15 12,14.553 12,14 C12,13.447 11.552,13 11,13 M10,7.0996 C10.607,7.0996 11.1,6.6076 11.1,5.9996 C11.1,5.3926 10.607,4.9006 10,4.9006 C9.393,4.9006 8.9,5.3926 8.9,5.9996 C8.9,6.6076 9.393,7.0996 10,7.0996","id":"path-1"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Polaris-Icons","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Major-Icons","transform":"translate(-440.000000, -1362.000000)"}},[_c('g',{attrs:{"id":"Stacked-Group-2","transform":"translate(430.000000, 152.000000)"}},[_c('g',{attrs:{"id":"Major/Circle-Information","transform":"translate(0.000000, 1200.000000)"}},[_c('g',{attrs:{"id":"Polaris-icon/Major/Mono/Circle-Information","transform":"translate(10.000000, 10.000000)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_vm._v(" "),_c('use',{attrs:{"id":"Icon","fill":"currentColor","fill-rule":"evenodd","xlink:href":"#path-1"}}),_vm._v(" "),_c('g',{attrs:{"id":"Color/Default","mask":"url(#mask-2)"}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 856 */
/*!***************************************************************!*\
  !*** ./src/components/base/icons/ico-circle-plus-outline.vue ***!
  \***************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b1d160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_plus_outline_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-59b1d160","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-circle-plus-outline.vue */ 857);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b1d160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_plus_outline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 857 */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b1d160","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-circle-plus-outline.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('path',{attrs:{"id":"circle-plus-outline-a","d":"M10,2 C5.589,2 2,5.589 2,10 C2,14.411 5.589,18 10,18 C14.411,18 18,14.411 18,10 C18,5.589 14.411,2 10,2 M10,16 C6.691,16 4,13.309 4,10 C4,6.691 6.691,4 10,4 C13.309,4 16,6.691 16,10 C16,13.309 13.309,16 10,16 M13,9 L11,9 L11,7 C11,6.448 10.553,6 10,6 C9.447,6 9,6.448 9,7 L9,9 L7,9 C6.447,9 6,9.448 6,10 C6,10.552 6.447,11 7,11 L9,11 9,13 C9,13.552 9.447,14 10,14 C10.553,14 11,13.552 11,13 L11,11 L13,11 C13.553,11 14,10.552 14,10 C14,9.448 13.553,9 13,9"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2 -2)"}},[_c('mask',{attrs:{"id":"circle-plus-outline-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#circle-plus-outline-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#circle-plus-outline-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/*!*******************************************************!*\
  !*** ./src/components/base/icons/ico-circle-plus.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1160152d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_plus_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1160152d","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-circle-plus.vue */ 859);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1160152d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_circle_plus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 859 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1160152d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-circle-plus.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('path',{attrs:{"id":"circle-plus-a","d":"M15,11 L11,11 L11,15 L9,15 L9,11 L5,11 L5,9 L9,9 L9,5 L11,5 L11,9 L15,9 L15,11 Z M10,2 C5.582,2 2,5.582 2,10 C2,14.418 5.582,18 10,18 C14.418,18 18,14.418 18,10 C18,5.582 14.418,2 10,2 L10,2 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2 -2)"}},[_c('mask',{attrs:{"id":"circle-plus-b","fill":"transparent"}},[_c('use',{attrs:{"xlink:href":"#circle-plus-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#circle-plus-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-code.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d701f4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_code_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0d701f4a","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-code.vue */ 861);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d701f4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_code_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 861 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d701f4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-code.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('path',{attrs:{"id":"code-a","d":"M17,13 C17.553,13 18,13.448 18,14 L18,17 C18,17.552 17.553,18 17,18 L3,18 C2.447,18 2,17.552 2,17 L2,14 C2,13.448 2.447,13 3,13 C3.553,13 4,13.448 4,14 L4,16 L16,16 L16,14 C16,13.448 16.447,13 17,13 Z M17,2 C17.553,2 18,2.448 18,3 L18,6 C18,6.552 17.553,7 17,7 C16.447,7 16,6.552 16,6 L16,4 L4,4 L4,6 C4,6.552 3.553,7 3,7 C2.447,7 2,6.552 2,6 L2,3 C2,2.448 2.447,2 3,2 L17,2 Z M17.5547,9.168 C17.8327,9.354 17.9997,9.666 17.9997,10 C17.9997,10.335 17.8327,10.647 17.5547,10.832 L14.5547,12.832 C14.3837,12.946 14.1917,13 14.0007,13 C13.6777,13 13.3607,12.844 13.1677,12.555 C12.8617,12.095 12.9857,11.474 13.4457,11.168 L15.1977,10 L13.4457,8.832 C12.9857,8.526 12.8617,7.905 13.1677,7.445 C13.4737,6.985 14.0927,6.861 14.5547,7.168 L17.5547,9.168 Z M6.832,7.4453 C7.139,7.9043 7.015,8.5263 6.555,8.8323 L4.803,10.0003 L6.555,11.1683 C7.015,11.4743 7.139,12.0953 6.832,12.5543 C6.64,12.8433 6.322,13.0003 5.999,13.0003 C5.809,13.0003 5.616,12.9453 5.445,12.8323 L2.445,10.8323 C2.167,10.6463 2,10.3343 2,10.0003 C2,9.6653 2.167,9.3533 2.445,9.1683 L5.445,7.1683 C5.905,6.8613 6.526,6.9853 6.832,7.4453 Z M9,14.0005 C8.896,14.0005 8.789,13.9835 8.684,13.9485 C8.16,13.7735 7.877,13.2075 8.052,12.6835 L10.052,6.6835 C10.227,6.1605 10.788,5.8745 11.316,6.0515 C11.84,6.2265 12.123,6.7925 11.948,7.3165 L9.948,13.3165 C9.809,13.7355 9.419,14.0005 9,14.0005 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2 -2)"}},[_c('use',{attrs:{"fill":"currentColor","xlink:href":"#code-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-cross.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfd3e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_cross_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-55cfd3e8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-cross.vue */ 863);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55cfd3e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_cross_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 863 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cfd3e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-cross.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('path',{attrs:{"id":"cancel-a","d":"M11.4141,10 L17.7071,3.707 C18.0981,3.316 18.0981,2.684 17.7071,2.293 C17.3161,1.902 16.6841,1.902 16.2931,2.293 L10.0001,8.586 L3.7071,2.293 C3.3161,1.902 2.6841,1.902 2.2931,2.293 C1.9021,2.684 1.9021,3.316 2.2931,3.707 L8.5861,10 L2.2931,16.293 C1.9021,16.684 1.9021,17.316 2.2931,17.707 C2.4881,17.902 2.7441,18 3.0001,18 C3.2561,18 3.5121,17.902 3.7071,17.707 L10.0001,11.414 L16.2931,17.707 C16.4881,17.902 16.7441,18 17.0001,18 C17.2561,18 17.5121,17.902 17.7071,17.707 C18.0981,17.316 18.0981,16.684 17.7071,16.293 L11.4141,10 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2 -2)"}},[_c('mask',{attrs:{"id":"cancel-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#cancel-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#cancel-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 864 */
/*!*****************************************************!*\
  !*** ./src/components/base/icons/ico-customers.vue ***!
  \*****************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0ce76ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_customers_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b0ce76ee","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-customers.vue */ 865);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0ce76ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 865 */
/*!******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ce76ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-customers.vue ***!
  \******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"20","viewBox":"0 0 16 20"}},[_c('defs',[_c('path',{attrs:{"id":"customers-a","d":"M15.7073,15.293 C15.9753,15.561 16.0683,15.957 15.9483,16.316 L14.9483,19.316 C14.8123,19.725 14.4303,20 14.0003,20 L2.0003,20 C1.5693,20 1.1873,19.725 1.0513,19.316 L0.0513,16.316 C-0.0687,15.957 0.0253,15.561 0.2933,15.293 C0.4273,15.158 3.6353,12 8.0003,12 C12.3643,12 15.5723,15.158 15.7073,15.293 Z M13.2793,18 L13.8413,16.313 C12.9213,15.561 10.6863,14 8.0003,14 C5.2973,14 3.0733,15.558 2.1573,16.31 L2.7203,18 L13.2793,18 Z M8,2 C9.654,2 11,3.346 11,5 C11,6.654 9.654,8 8,8 C6.346,8 5,6.654 5,5 C5,3.346 6.346,2 8,2 Z M8,10 C10.757,10 13,7.757 13,5 C13,2.243 10.757,0 8,0 C5.243,0 3,2.243 3,5 C3,7.757 5.243,10 8,10"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2)"}},[_c('path',{attrs:{"fill":"#FFF","d":"M10,12.99998 C6,12.99998 3,15.99998 3,15.99998 L4,18.99998 L16,18.99998 L17,15.99998 C17,15.99998 14,12.99998 10,12.99998"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(2)"}},[_c('mask',{attrs:{"id":"customers-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#customers-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#customers-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 866 */
/*!*********************************************************!*\
  !*** ./src/components/base/icons/ico-double-arrows.vue ***!
  \*********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295c73a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_double_arrows_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-295c73a6","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-double-arrows.vue */ 867);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_295c73a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_double_arrows_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 867 */
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-295c73a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-double-arrows.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"12","viewBox":"0 0 8 12"}},[_c('path',{attrs:{"fill-rule":"evenodd","fill":"currentColor","d":"M8,3.63636364 L4,0 L0,3.63636364 L8,3.63636364 Z M7.86666667,8.48484848 L4,12 L0.133333333,8.48484848 L7.86666667,8.48484848 Z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 868 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-drag.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0730ef28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_drag_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0730ef28","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-drag.vue */ 869);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0730ef28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_drag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 869 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0730ef28","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-drag.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"6","height":"10","viewBox":"0 0 6 10"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('circle',{attrs:{"cx":"1","cy":"1","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"1","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"1","cy":"5","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"5","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"1","cy":"9","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"9","r":"1"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/*!**************************************************!*\
  !*** ./src/components/base/icons/ico-export.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9de7d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_export_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7a9de7d3","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-export.vue */ 871);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9de7d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_export_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 871 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9de7d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-export.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 13.707l-3-3a.999.999 0 1 1 1.414-1.414L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.999.999 0 0 1-1.414 0zM17 16a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h14z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 872 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-help.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0870de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_help_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2d0870de","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-help.vue */ 873);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0870de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 873 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d0870de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-help.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('circle',{attrs:{"cx":"10","cy":"10","r":"9","fill":"transparent"}}),_c('path',{attrs:{"d":"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-10C8.346 4 7 5.346 7 7a1 1 0 1 0 2 0 1.001 1.001 0 1 1 1.591.808C9.58 8.548 9 9.616 9 10.737V11a1 1 0 1 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 13 7c0-1.654-1.346-3-3-3","fill":"currentColor"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 874 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-hint.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36665198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_hint_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-36665198","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-hint.vue */ 875);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36665198_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_hint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 875 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36665198","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-hint.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"hint-a","d":"M13.1071,6.0824 C11.9041,5.1264 10.3411,4.7824 8.8141,5.1374 C7.0251,5.5534 5.5881,6.9754 5.1511,8.7584 C4.7931,10.2234 5.0691,11.6904 5.9301,12.8884 C6.6301,13.8624 7.0001,14.9824 7.0001,16.1274 L7.0001,17.0004 C7.0001,18.6544 8.3461,20.0004 10.0001,20.0004 C11.6541,20.0004 13.0001,18.6544 13.0001,17.0004 L13.0001,16.1314 C13.0001,15.0324 13.3881,13.9014 14.1531,12.7694 C14.7071,11.9484 15.0001,10.9914 15.0001,10.0004 C15.0001,8.4654 14.3101,7.0384 13.1071,6.0824 L13.1071,6.0824 Z M19,9 L18,9 C17.447,9 17,9.447 17,10 C17,10.553 17.447,11 18,11 L19,11 C19.553,11 20,10.553 20,10 C20,9.447 19.553,9 19,9 M2,9 L1,9 C0.447,9 0,9.447 0,10 C0,10.553 0.447,11 1,11 L2,11 C2.553,11 3,10.553 3,10 C3,9.447 2.553,9 2,9 M10,3 C10.553,3 11,2.553 11,2 L11,1 C11,0.447 10.553,0 10,0 C9.447,0 9,0.447 9,1 L9,2 C9,2.553 9.447,3 10,3 M17.707,2.293 C17.316,1.902 16.684,1.902 16.293,2.293 L15.293,3.293 C14.902,3.684 14.902,4.316 15.293,4.707 C15.488,4.902 15.744,5 16,5 C16.256,5 16.512,4.902 16.707,4.707 L17.707,3.707 C18.098,3.316 18.098,2.684 17.707,2.293 M3.707,2.293 C3.316,1.902 2.684,1.902 2.293,2.293 C1.902,2.684 1.902,3.316 2.293,3.707 L3.293,4.707 C3.488,4.902 3.744,5 4,5 C4.256,5 4.512,4.902 4.707,4.707 C5.098,4.316 5.098,3.684 4.707,3.293 L3.707,2.293 Z M12.4961,11.6494 C11.9731,12.4234 11.5941,13.2094 11.3451,14.0004 L8.6731,14.0004 C8.4311,13.1984 8.0621,12.4284 7.5551,11.7214 C7.0401,11.0054 6.8771,10.1224 7.0951,9.2334 C7.3501,8.1924 8.2231,7.3284 9.2671,7.0854 C9.5171,7.0274 9.7641,6.9994 10.0071,6.9994 C10.6831,6.9994 11.3241,7.2204 11.8631,7.6484 C12.5861,8.2224 13.0001,9.0794 13.0001,10.0004 C13.0001,10.5904 12.8251,11.1614 12.4961,11.6494 L12.4961,11.6494 Z M11.0001,17.0004 C11.0001,17.5514 10.5521,18.0004 10.0001,18.0004 C9.4481,18.0004 9.0001,17.5514 9.0001,17.0004 L9.0001,16.1274 C9.0001,16.0844 8.9901,16.0434 8.9901,16.0004 L11.0111,16.0004 C11.0101,16.0444 11.0001,16.0874 11.0001,16.1314 L11.0001,17.0004 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M7.8906,14.99997 L12.1186,14.99997 C12.3146,14.00497 12.7456,13.06497 13.3246,12.20997 C13.7496,11.57897 13.9996,10.81997 13.9996,9.99997 C13.9996,7.47897 11.6656,5.50097 9.0406,6.11097 C7.6226,6.44097 6.4686,7.58197 6.1226,8.99597 C5.8186,10.24097 6.0996,11.40997 6.7426,12.30497 C7.3226,13.11197 7.7136,14.03297 7.8906,14.99997"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"hint-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#hint-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#hint-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 876 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-icons.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a727cb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_icons_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7a727cb9","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-icons.vue */ 877);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a727cb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 877 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a727cb9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-icons.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"customers-a","d":"M10.6182,18 L14.0002,11.236 L17.3822,18 L10.6182,18 Z M4.0002,16 L4.0002,9.899 C4.3232,9.965 4.6572,10 5.0002,10 C7.7572,10 10.0002,7.757 10.0002,5 C10.0002,4.657 9.9652,4.323 9.8982,4 L16.0002,4 L16.0002,10.764 L14.8942,8.553 C14.5552,7.875 13.4452,7.875 13.1052,8.553 L9.3822,16 L4.0002,16 Z M5.0002,2 C6.6542,2 8.0002,3.346 8.0002,5 C8.0002,6.654 6.6542,8 5.0002,8 C3.3462,8 2.0002,6.654 2.0002,5 C2.0002,3.346 3.3462,2 5.0002,2 L5.0002,2 Z M19.8942,18.553 L18.0002,14.764 L18.0002,3 C18.0002,2.447 17.5532,2 17.0002,2 L8.9742,2 C8.0602,0.793 6.6272,0 5.0002,0 C2.2432,0 0.0002,2.243 0.0002,5 C0.0002,6.627 0.7932,8.061 2.0002,8.975 L2.0002,17 C2.0002,17.553 2.4472,18 3.0002,18 L8.3822,18 L8.1052,18.553 C7.9502,18.862 7.9672,19.23 8.1492,19.525 C8.3322,19.82 8.6532,20 9.0002,20 L19.0002,20 C19.3472,20 19.6682,19.82 19.8502,19.525 C20.0332,19.23 20.0502,18.862 19.8942,18.553 L19.8942,18.553 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M5,9 C2.790861,9 1,7.209139 1,5 C1,2.790861 2.790861,1 5,1 C7.209139,1 9,2.790861 9,5 C9,7.209139 7.209139,9 5,9 Z M9,19 L14,9 L19,19 L9,19 Z"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"customers-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#customers-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#customers-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/*!**************************************************!*\
  !*** ./src/components/base/icons/ico-images.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38845165_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_images_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-38845165","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-images.vue */ 879);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38845165_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_images_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 879 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38845165","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-images.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"images-a","d":"M19,0 L5,0 C4.448,0 4,0.447 4,1 L4,4 L1,4 C0.448,4 0,4.447 0,5 L0,19 C0,19.553 0.448,20 1,20 L15,20 C15.552,20 16,19.553 16,19 L16,16 L19,16 C19.552,16 20,15.553 20,15 L20,1 C20,0.447 19.552,0 19,0 L19,0 Z M6,14 L6,11.535 L8,10.202 L10.445,11.832 C10.843,12.098 11.371,12.044 11.707,11.707 L16,7.414 L18,9.414 L18,14 L6,14 Z M14,18 L2,18 L2,6 L4,6 L4,15 C4,15.553 4.448,16 5,16 L14,16 L14,18 Z M6,2 L18,2 L18,6.586 L16.707,5.293 C16.316,4.902 15.684,4.902 15.293,5.293 L10.873,9.713 L8.555,8.168 C8.219,7.943 7.781,7.943 7.445,8.168 L6,9.132 L6,2 Z M10.5,7 C11.329,7 12,6.328 12,5.5 C12,4.672 11.329,4 10.5,4 C9.671,4 9,4.672 9,5.5 C9,6.328 9.671,7 10.5,7"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"fill":"#FFF","points":"16 6 11.001 11 8 9 5 11 5 15 19.001 15 19.001 9"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"images-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#images-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"#919EAC","xlink:href":"#images-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 880 */
/*!**************************************************!*\
  !*** ./src/components/base/icons/ico-import.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c889fc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_import_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7c889fc2","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-import.vue */ 881);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c889fc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_import_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 881 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c889fc2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-import.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M13.707 6.707a.997.997 0 0 1-1.414 0L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a.999.999 0 1 1-1.414-1.414l3-3a.999.999 0 0 1 1.414 0l3 3a.999.999 0 0 1 0 1.414zM17 18H3a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 882 */
/*!**********************************************************!*\
  !*** ./src/components/base/icons/ico-locked-padlock.vue ***!
  \**********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72472f2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_locked_padlock_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-72472f2b","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-locked-padlock.vue */ 883);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72472f2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_locked_padlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 883 */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72472f2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-locked-padlock.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 486.733 486.733"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 486.733 486.733","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M403.88,196.563h-9.484v-44.388c0-82.099-65.151-150.681-146.582-152.145c-2.225-0.04-6.671-0.04-8.895,0   C157.486,1.494,92.336,70.076,92.336,152.175v44.388h-9.485c-14.616,0-26.538,15.082-26.538,33.709v222.632   c0,18.606,11.922,33.829,26.539,33.829h321.028c14.616,0,26.539-15.223,26.539-33.829V230.272   C430.419,211.646,418.497,196.563,403.88,196.563z M273.442,341.362v67.271c0,7.703-6.449,14.222-14.158,14.222H227.45   c-7.71,0-14.159-6.519-14.159-14.222v-67.271c-7.477-7.36-11.83-17.537-11.83-28.795c0-21.334,16.491-39.666,37.459-40.513   c2.222-0.09,6.673-0.09,8.895,0c20.968,0.847,37.459,19.179,37.459,40.513C285.272,323.825,280.919,334.002,273.442,341.362z    M331.886,196.563h-84.072h-8.895h-84.072v-44.388c0-48.905,39.744-89.342,88.519-89.342c48.775,0,88.521,40.437,88.521,89.342   V196.563z","fill":"currentColor"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-loupe.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9a2ee4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_loupe_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4d9a2ee4","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-loupe.vue */ 885);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d9a2ee4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_loupe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 885 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d9a2ee4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-loupe.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 250.313 250.313"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 250.313 250.313","xml:space":"preserve"}},[_c('g',{attrs:{"id":"Search"}},[_c('path',{staticStyle:{"fill-rule":"evenodd","clip-rule":"evenodd"},attrs:{"fill":"currentColor","d":"M244.186,214.604l-54.379-54.378c-0.289-0.289-0.628-0.491-0.93-0.76\r\n\t\tc10.7-16.231,16.945-35.66,16.945-56.554C205.822,46.075,159.747,0,102.911,0S0,46.075,0,102.911\r\n\t\tc0,56.835,46.074,102.911,102.91,102.911c20.895,0,40.323-6.245,56.554-16.945c0.269,0.301,0.47,0.64,0.759,0.929l54.38,54.38\r\n\t\tc8.169,8.168,21.413,8.168,29.583,0C252.354,236.017,252.354,222.773,244.186,214.604z M102.911,170.146\r\n\t\tc-37.134,0-67.236-30.102-67.236-67.235c0-37.134,30.103-67.236,67.236-67.236c37.132,0,67.235,30.103,67.235,67.236\r\n\t\tC170.146,140.044,140.043,170.146,102.911,170.146z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 886 */
/*!****************************************************************!*\
  !*** ./src/components/base/icons/ico-mobile-vertical-dots.vue ***!
  \****************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5acbb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_mobile_vertical_dots_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1e5acbb6","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-mobile-vertical-dots.vue */ 887);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5acbb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_mobile_vertical_dots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 887 */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5acbb6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-mobile-vertical-dots.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"4","height":"16","viewBox":"0 0 4 16"}},[_c('defs',[_c('path',{attrs:{"id":"mobile-vertical-dots-a","d":"M2,4 C0.897,4 0,3.103 0,2 C0,0.897 0.897,0 2,0 C3.103,0 4,0.897 4,2 C4,3.103 3.103,4 2,4 Z M2,6 C3.103,6 4,6.897 4,8 C4,9.103 3.103,10 2,10 C0.897,10 0,9.103 0,8 C0,6.897 0.897,6 2,6 Z M2,12 C3.103,12 4,12.897 4,14 C4,15.103 3.103,16 2,16 C0.897,16 0,15.103 0,14 C0,12.897 0.897,12 2,12 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"mobile-vertical-dots-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#mobile-vertical-dots-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#mobile-vertical-dots-a"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 888 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-note.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aa15a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_note_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-04aa15a2","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-note.vue */ 889);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aa15a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_note_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 889 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04aa15a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-note.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"20","viewBox":"0 0 16 20"}},[_c('defs',[_c('path',{attrs:{"id":"note-a","d":"M15.707,4.293 L11.707,0.293 C11.52,0.105 11.265,0 11,0 L1,0 C0.448,0 0,0.448 0,1 L0,19 C0,19.552 0.448,20 1,20 L15,20 C15.552,20 16,19.552 16,19 L16,5 C16,4.735 15.895,4.48 15.707,4.293 L15.707,4.293 Z M14,18 L2,18 L2,2 L10.586,2 L14,5.414 L14,18 Z M11,13 L5,13 C4.448,13 4,13.448 4,14 C4,14.552 4.448,15 5,15 L11,15 C11.552,15 12,14.552 12,14 C12,13.448 11.552,13 11,13 M4,10 C4,10.552 4.448,11 5,11 L11,11 C11.552,11 12,10.552 12,10 C12,9.448 11.552,9 11,9 L5,9 C4.448,9 4,9.448 4,10 M5,7 L6,7 C6.552,7 7,6.552 7,6 C7,5.448 6.552,5 6,5 L5,5 C4.448,5 4,5.448 4,6 C4,6.552 4.448,7 5,7"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-2)"}},[_c('polygon',{attrs:{"fill":"#FFF","points":"3 19 17 19 17 5 13 1 3 1"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(2)"}},[_c('mask',{attrs:{"id":"note-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#note-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#note-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 890 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-notes.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13bd455e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_notes_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-13bd455e","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-notes.vue */ 891);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13bd455e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_notes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 891 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bd455e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-notes.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 11h8V9H6v2zm0 4h8v-2H6v2zm0-8h4V5H6v2zm9.707-1.707l-3-3A.996.996 0 0 0 12 2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a.997.997 0 0 0-.293-.707z","fill":"#31373D","fill-rule":"evenodd"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 892 */
/*!**************************************************!*\
  !*** ./src/components/base/icons/ico-orders.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a2351a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_orders_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-11a2351a","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-orders.vue */ 893);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a2351a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 893 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a2351a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-orders.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"orders-a","d":"M2,18 L2,14 L5.382,14 L6.105,15.447 C6.275,15.786 6.621,16 7,16 L13,16 C13.379,16 13.725,15.786 13.895,15.447 L14.618,14 L18,14 L18,18 L2,18 Z M19,1 C19.552,1 20,1.448 20,2 L20,19 C20,19.552 19.552,20 19,20 L1,20 C0.448,20 0,19.552 0,19 L0,2 C0,1.448 0.448,1 1,1 L5,1 C5.552,1 6,1.448 6,2 C6,2.552 5.552,3 5,3 L2,3 L2,12 L6,12 C6.379,12 6.725,12.214 6.895,12.553 L7.618,14 L12.382,14 L13.105,12.553 C13.275,12.214 13.621,12 14,12 L18,12 L18,3 L15,3 C14.448,3 14,2.552 14,2 C14,1.448 14.448,1 15,1 L19,1 Z M6.293,6.707 C5.902,6.316 5.902,5.684 6.293,5.293 C6.684,4.902 7.316,4.902 7.707,5.293 L9,6.586 L9,1 C9,0.448 9.448,0 10,0 C10.552,0 11,0.448 11,1 L11,6.586 L12.293,5.293 C12.684,4.902 13.316,4.902 13.707,5.293 C14.098,5.684 14.098,6.316 13.707,6.707 L10.707,9.707 C10.512,9.902 10.256,10 10,10 C9.744,10 9.488,9.902 9.293,9.707 L6.293,6.707 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"fill":"#FFF","points":"1 13 6 13 7 15 13 15 14 13 19 13 19 19 1 19"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"orders-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#orders-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#orders-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 894 */
/*!****************************************************!*\
  !*** ./src/components/base/icons/ico-products.vue ***!
  \****************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0167f31e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_products_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0167f31e","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-products.vue */ 895);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0167f31e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 895 */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0167f31e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-products.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"products-a","d":"M19,-0.0001 L10,-0.0001 C9.735,-0.0001 9.48,0.1059 9.293,0.2929 L0.293,9.2929 C-0.098,9.6839 -0.098,10.3159 0.293,10.7069 L9.293,19.7069 C9.488,19.9019 9.744,19.9999 10,19.9999 C10.256,19.9999 10.512,19.9019 10.707,19.7069 L19.707,10.7069 C19.895,10.5199 20,10.2649 20,9.9999 L20,0.9999 C20,0.4479 19.552,-0.0001 19,-0.0001 L19,-0.0001 Z M10,17.5859 L2.414,9.9999 L4,8.4139 L11.586,15.9999 L10,17.5859 Z M18,9.5859 L13,14.5859 L5.414,6.9999 L10.414,1.9999 L18,1.9999 L18,9.5859 Z M15,6 C15.552,6 16,5.552 16,5 C16,4.448 15.552,4 15,4 C14.448,4 14,4.448 14,5 C14,5.552 14.448,6 15,6"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"fill":"#FFF","points":"4 7 1 10 10 19 13 16"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"products-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#products-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#products-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 896 */
/*!**********************************************************!*\
  !*** ./src/components/base/icons/ico-radio-selected.vue ***!
  \**********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f8c404_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_radio_selected_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-a3f8c404","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-radio-selected.vue */ 897);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f8c404_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_radio_selected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 897 */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3f8c404","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-radio-selected.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"01-default-c","x1":"50%","x2":"50%","y1":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F9FAFB"}})],1),_vm._v(" "),_c('circle',{attrs:{"id":"01-default-b","cx":"8","cy":"8","r":"8"}}),_vm._v(" "),_c('filter',{attrs:{"id":"01-default-a","width":"106.2%","height":"112.5%","x":"-3.1%","y":"-3.1%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"shadowOffsetOuter1","in2":"SourceAlpha","operator":"out","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"shadowOffsetOuter1","values":"0 0 0 0 0.0863   0 0 0 0 0.1137   0 0 0 0 0.1451  0 0 0 0.05 0"}})],1)],1),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#01-default-a)","xlink:href":"#01-default-b"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","fill":"url(#01-default-c)","stroke":"#5C6AC4","stroke-linejoin":"square"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"8","r":"4","fill":"#5C6AC4"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 898 */
/*!************************************************************!*\
  !*** ./src/components/base/icons/ico-radio-unselected.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c7fa28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_radio_unselected_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f9c7fa28","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-radio-unselected.vue */ 899);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c7fa28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_radio_unselected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 899 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c7fa28","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-radio-unselected.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"01-default-c","x1":"50%","x2":"50%","y1":"0%","y2":"100%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFF"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":"#F9FAFB"}})],1),_vm._v(" "),_c('circle',{attrs:{"id":"01-default-b","cx":"8","cy":"8","r":"8"}}),_vm._v(" "),_c('filter',{attrs:{"id":"01-default-a","width":"106.2%","height":"112.5%","x":"-3.1%","y":"-3.1%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"1","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"shadowOffsetOuter1","in2":"SourceAlpha","operator":"out","result":"shadowOffsetOuter1"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"shadowOffsetOuter1","values":"0 0 0 0 0.0863   0 0 0 0 0.1137   0 0 0 0 0.1451  0 0 0 0.05 0"}})],1)],1),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#01-default-a)","xlink:href":"#01-default-b"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","fill":"url(#01-default-c)","stroke":"#C4CDD5","stroke-linejoin":"square"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 900 */
/*!*******************************************************!*\
  !*** ./src/components/base/icons/ico-spinner-big.vue ***!
  \*******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db696be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_spinner_big_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6db696be","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-spinner-big.vue */ 901);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db696be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_spinner_big_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 901 */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db696be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-spinner-big.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 44 44","role":"status"}},[_c('path',{attrs:{"fill":"currentColor","d":"M15.542 1.487A21.507 21.507 0 0 0 .5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 0 0-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 1 0-.9-2.863z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 902 */
/*!***************************************************!*\
  !*** ./src/components/base/icons/ico-spinner.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155d08fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_spinner_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-155d08fb","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-spinner.vue */ 903);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_155d08fb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 903 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-155d08fb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-spinner.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 20 20","aria-label":"Loading","role":"status"}},[_c('path',{attrs:{"d":"M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/*!***************************************************!*\
  !*** ./src/components/base/icons/ico-success.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f93feec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_success_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4f93feec","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-success.vue */ 905);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f93feec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 905 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f93feec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-success.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M256,0 C114.497,0 0,114.507 0,256 C0,397.503 114.507,512 256,512 C397.503,512 512,397.493 512,256 C512,114.497 397.493,0 256,0 Z M256,472 C136.607,472 40,375.385 40,256 C40,136.607 136.615,40 256,40 C375.393,40 472,136.615 472,256 C472,375.393 375.385,472 256,472 Z"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"256","cy":"256","r":"216","fill":"#FFF"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","d":"M352.234756,169.100765 L215.354742,305.974142 L160.023262,250.654607 C153.223791,243.863099 142.208992,243.859117 135.40952,250.658589 C128.607394,257.460715 128.607394,268.476841 135.40952,275.276313 L203.049862,342.906037 C206.448934,346.301128 210.901838,348 215.354742,348 C219.807646,348 224.272496,346.301128 227.670241,342.900728 C227.680858,342.886128 227.688822,342.871529 227.706076,342.854275 L376.847171,193.714507 C383.649297,186.919017 383.649297,175.894928 376.847171,169.099438 C370.049026,162.299966 359.026264,162.299966 352.234756,169.100765 Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/*!********************************************************!*\
  !*** ./src/components/base/icons/ico-text-block-2.vue ***!
  \********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed2fd99_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_text_block_2_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7ed2fd99","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-text-block-2.vue */ 907);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed2fd99_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_text_block_2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 907 */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed2fd99","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-text-block-2.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"text-block-a","d":"M1,0 C0.448,0 0,0.448 0,1 L0,15 C0,15.552 0.448,16 1,16 L15,16 C15.552,16 16,15.552 16,15 L16,1 C16,0.448 15.552,0 15,0 L1,0 Z M2,14 L14,14 L14,2 L2,2 L2,14 Z M11.3333333,11 C11.7013333,11 12,10.552 12,10 C12,9.448 11.7013333,9 11.3333333,9 L4.66666667,9 C4.29866667,9 4,9.448 4,10 C4,10.552 4.29866667,11 4.66666667,11 L11.3333333,11 Z M4.66666667,7 L11.3333333,7 C11.7013333,7 12,6.552 12,6 C12,5.448 11.7013333,5 11.3333333,5 L4.66666667,5 C4.29866667,5 4,5.448 4,6 C4,6.552 4.29866667,7 4.66666667,7"}}),_vm._v(" "),_c('path',{attrs:{"id":"text-block-c","d":"M1,0 C0.448,0 0,0.448 0,1 L0,17 C0,17.552 0.448,18 1,18 L17,18 C17.552,18 18,17.552 18,17 L18,1 C18,0.448 17.552,0 17,0 L1,0 Z M0,16 L16,16 L16,0 L0,0 L0,16 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"18","height":"18","x":"1","y":"1","fill":"#FFF"}}),_vm._v(" "),_c('mask',{attrs:{"id":"text-block-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#text-block-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#text-block-a"}}),_vm._v(" "),_c('g',{attrs:{"transform":"translate(2 2)"}},[_c('mask',{attrs:{"id":"text-block-d","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#text-block-c"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#text-block-c"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 908 */
/*!******************************************************!*\
  !*** ./src/components/base/icons/ico-text-block.vue ***!
  \******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715ce534_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_text_block_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-715ce534","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-text-block.vue */ 909);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715ce534_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_text_block_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 909 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715ce534","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-text-block.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"text-block-a","d":"M19,0 L1,0 C0.448,0 0,0.448 0,1 L0,19 C0,19.552 0.448,20 1,20 L19,20 C19.552,20 20,19.552 20,19 L20,1 C20,0.448 19.552,0 19,0 L19,0 Z M2,18 L18,18 L18,2 L2,2 L2,18 Z M5,11 L15,11 C15.552,11 16,10.552 16,10 C16,9.448 15.552,9 15,9 L5,9 C4.448,9 4,9.448 4,10 C4,10.552 4.448,11 5,11 M5,7 L15,7 C15.552,7 16,6.552 16,6 C16,5.448 15.552,5 15,5 L5,5 C4.448,5 4,5.448 4,6 C4,6.552 4.448,7 5,7 M10,13 L5,13 C4.448,13 4,13.448 4,14 C4,14.552 4.448,15 5,15 L9,15 C9.552,15 10,14.552 10,14 C10,13.448 9.552,13 9,13"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"18","height":"18","x":"1","y":"1","fill":"#FFF"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"text-block-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#text-block-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#text-block-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-tools.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d537bb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_tools_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0d537bb8","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-tools.vue */ 911);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d537bb8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_tools_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 911 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d537bb8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-tools.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('defs',[_c('path',{attrs:{"id":"tools-a","d":"M15.00025,17.58625 L13.91425,16.50025 L14.70725,15.70725 C15.09825,15.31625 15.09825,14.68425 14.70725,14.29325 C14.31625,13.90225 13.68425,13.90225 13.29325,14.29325 L12.50025,15.08625 L11.41425,14.00025 L14.00025,11.41425 L17.58625,15.00025 L15.00025,17.58625 Z M3.43725,14.85225 L5.14825,16.56325 L2.58125,17.41925 L3.43725,14.85225 Z M4.91425,7.50025 L5.70725,6.70725 C6.09825,6.31625 6.09825,5.68425 5.70725,5.29325 C5.31625,4.90225 4.68425,4.90225 4.29325,5.29325 L3.50025,6.08625 L2.41425,5.00025 L5.00025,2.41425 L8.58625,6.00025 L6.00025,8.58625 L4.91425,7.50025 Z M17.46525,2.53525 C18.17825,3.24825 18.17825,4.40825 17.46525,5.12125 L17.00025,5.58625 L14.41425,3.00025 L14.87925,2.53525 C15.59225,1.82225 16.75225,1.82225 17.46525,2.53525 L17.46525,2.53525 Z M4.41425,13.00025 L13.00025,4.41425 L15.58625,7.00025 L7.00025,15.58625 L4.41425,13.00025 Z M19.70725,14.29325 L15.41425,10.00025 L18.87925,6.53525 C20.37225,5.04325 20.37225,2.61325 18.87925,1.12125 C17.38725,-0.37075 14.95725,-0.37075 13.46525,1.12125 L10.00025,4.58625 L5.70725,0.29325 C5.31625,-0.09775 4.68425,-0.09775 4.29325,0.29325 L0.29325,4.29325 C-0.09775,4.68425 -0.09775,5.31625 0.29325,5.70725 L4.58625,10.00025 L2.29325,12.29325 C2.18425,12.40225 2.10125,12.53625 2.05225,12.68425 L0.05225,18.68425 C-0.06775,19.04325 0.02525,19.44025 0.29325,19.70725 C0.48325,19.89825 0.73925,20.00025 1.00025,20.00025 C1.10525,20.00025 1.21325,19.98325 1.31625,19.94825 L7.31625,17.94825 C7.46425,17.89925 7.59825,17.81625 7.70725,17.70725 L10.00025,15.41425 L14.29325,19.70725 C14.48825,19.90225 14.74425,20.00025 15.00025,20.00025 C15.25625,20.00025 15.51225,19.90225 15.70725,19.70725 L19.70725,15.70725 C20.09825,15.31625 20.09825,14.68425 19.70725,14.29325 L19.70725,14.29325 Z"}})]),_vm._v(" "),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('polygon',{attrs:{"fill":"#FFF","points":"13 3 3 13.001 7 17 17.001 7.001"}}),_vm._v(" "),_c('g',[_c('mask',{attrs:{"id":"tools-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#tools-a"}})]),_vm._v(" "),_c('use',{attrs:{"fill":"currentColor","xlink:href":"#tools-a"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/*!*************************************************!*\
  !*** ./src/components/base/icons/ico-trash.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05cc08c7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_trash_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-05cc08c7","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-trash.vue */ 913);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05cc08c7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_trash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 913 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cc08c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-trash.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"16","viewBox":"0 0 14 16"}},[_c('path',{attrs:{"d":"M13,4 C13.5522847,4 14,4.44771525 14,5 C14,5.55228475 13.5522847,6 13,6 L12,6 L12,15 C12,15.5522847 11.5522847,16 11,16 L3,16 C2.44771525,16 2,15.5522847 2,15 L2,6 L1,6 C0.44771525,6 0,5.55228475 0,5 C0,4.44771525 0.44771525,4 1,4 L13,4 Z M6,2 C5.44771525,2 5,1.55228475 5,1 C5,0.44771525 5.44771525,0 6,0 L8,0 C8.55228475,0 9,0.44771525 9,1 C9,1.55228475 8.55228475,2 8,2 L6,2 Z M8,14 L10,14 L10,6 L8,6 L8,14 Z M4,14 L6,14 L6,6 L4,6 L4,14 Z","fill":"currentColor"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/*!************************************************!*\
  !*** ./src/components/base/icons/ico-view.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd01e72_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_view_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0cd01e72","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-view.vue */ 915);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd01e72_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 915 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd01e72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-view.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20px","height":"16px","viewBox":"0 0 20 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M19.962,9.725 C19.939,9.648 17.666,2 10,2 C2.334,2 0.061,9.648 0.038,9.725 C-0.013,9.905 -0.013,10.095 0.038,10.275 C0.061,10.352 2.334,18 10,18 C17.666,18 19.939,10.352 19.962,10.275 C20.013,10.095 20.013,9.905 19.962,9.725 M10,16 C4.533,16 2.488,11.228 2.052,10 C2.488,8.772 4.533,4 10,4 C15.469,4 17.514,8.776 17.948,10 C17.513,11.228 15.467,16 10,16 M10,12 C8.897,12 8,11.103 8,10 C8,8.897 8.897,8 10,8 C11.103,8 12,8.897 12,10 C12,11.103 11.103,12 10,12 M10,6 C7.794,6 6,7.794 6,10 C6,12.206 7.794,14 10,14 C12.206,14 14,12.206 14,10 C14,7.794 12.206,6 10,6","id":"path-1"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Polaris-Icons","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Major-Icons","transform":"translate(-3080.000000, -1314.000000)"}},[_c('g',{attrs:{"id":"Stacked-Group-10","transform":"translate(3070.000000, 152.000000)"}},[_c('g',{attrs:{"id":"Major/View","transform":"translate(0.000000, 1150.000000)"}},[_c('g',{attrs:{"id":"Polaris-icon/Major/Mono/View","transform":"translate(10.000000, 10.000000)"}},[_c('mask',{attrs:{"id":"mask-2","fill":"white"}},[_c('use',{attrs:{"xlink:href":"#path-1"}})]),_vm._v(" "),_c('use',{attrs:{"id":"Icon","fill":"currentColor","fill-rule":"evenodd","xlink:href":"#path-1"}}),_vm._v(" "),_c('g',{attrs:{"id":"Color/Default","mask":"url(#mask-2)"}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/*!***************************************************!*\
  !*** ./src/components/base/icons/ico-warning.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c20fb56e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_warning_vue__ = __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c20fb56e","hasScoped":false,"buble":{"transforms":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ico-warning.vue */ 917);
var normalizeComponent = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c20fb56e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ico_warning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 917 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c20fb56e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/icons/ico-warning.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 512 512"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M256,0 C114.497,0 0,114.507 0,256 C0,397.503 114.507,512 256,512 C397.503,512 512,397.493 512,256 C512,114.497 397.493,0 256,0 Z M256,472 C136.607,472 40,375.385 40,256 C40,136.607 136.615,40 256,40 C375.393,40 472,136.615 472,256 C472,375.393 375.385,472 256,472 Z"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"256","cy":"256","r":"216","fill":"#FFF"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","d":"M256,128.877 C244.954,128.877 236,137.831 236,148.877 L236,277.67 C236,288.716 244.954,297.67 256,297.67 C267.046,297.67 276,288.716 276,277.67 L276,148.877 C276,137.831 267.046,128.877 256,128.877 Z"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"256","cy":"349.16","r":"27","fill":"currentColor"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 918 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed2fae7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseIcon.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.useImgNotSvg)?_c(_vm.svgComponent,{tag:"component",class:_vm.className}):_c('img',{class:_vm.className,attrs:{"src":("/images/" + _vm.name + ".svg")}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/*!*******************************************!*\
  !*** ./src/components/base/BaseImage.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseImage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseImage.vue */ 355);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c90e69f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseImage_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c90e69f4","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseImage.vue */ 921);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c90e69f4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseImage.vue */ 920)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c90e69f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 920 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c90e69f4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseImage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c90e69f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseImage.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-image",class:_vm.className},[_c('div',{style:({ paddingTop: _vm.aspectRatio * 100 + '%' })},[_c('Transition',{attrs:{"name":"base-image__transition"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.sourceLoaded),expression:"sourceLoaded"}],key:"img",staticClass:"base-image__img",style:({ objectFit: _vm.objectFit }),attrs:{"alt":_vm.alt,"src":_vm.lazy ? _vm.lazySrc : _vm.src},on:{"~load":function($event){return _vm.onSourceLoaded($event)}}})]),_vm._v(" "),(!_vm.lazySrc && !_vm.src)?_c('img',{key:"placeholder",staticClass:"base-image__placeholder",attrs:{"src":_vm.placeholder}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/*!******************************************!*\
  !*** ./src/components/base/BaseJson.vue ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseJson_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseJson.vue */ 356);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e47b9f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseJson_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5e47b9f4","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseJson.vue */ 924);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5e47b9f4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseJson.vue */ 923)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseJson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e47b9f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseJson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 923 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e47b9f4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseJson.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e47b9f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseJson.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{class:("json-editor-" + _vm.uuid),style:({ minHeight: (_vm.minHeight + "px") })}),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e(),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e(),_vm._v(" "),(_vm.jsonError)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.jsonError))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 925 */
/*!******************************************!*\
  !*** ./src/components/base/BaseLink.vue ***!
  \******************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLink_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseLink.vue */ 357);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7ca6a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLink_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1e7ca6a8","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseLink.vue */ 927);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1e7ca6a8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseLink.vue */ 926)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7ca6a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 926 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e7ca6a8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseLink.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7ca6a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseLink.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.blank)?_c('router-link',{staticClass:"base-link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{staticClass:"base-link",attrs:{"href":_vm.to,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/*!**************************************************!*\
  !*** ./src/components/base/BasePictureInput.vue ***!
  \**************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BasePictureInput_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BasePictureInput.vue */ 358);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8409c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasePictureInput_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5c8409c8","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BasePictureInput.vue */ 933);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5c8409c8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BasePictureInput.vue */ 929)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BasePictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8409c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BasePictureInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 929 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c8409c8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BasePictureInput.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/*!*********************************************************!*\
  !*** ./src/packages/vue-picture-input/PictureInput.vue ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PictureInput.vue */ 359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31eee9ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-31eee9ca","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PictureInput.vue */ 932);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-31eee9ca","scoped":true,"hasInlineConfig":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PictureInput.vue */ 931)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31eee9ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31eee9ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 931 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31eee9ca","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/vue-picture-input/PictureInput.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31eee9ca","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/vue-picture-input/PictureInput.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onFileDrop($event)},"click":function($event){$event.preventDefault();return _vm.onClick($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected && !_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),(!_vm.hideChangeButton)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();return _vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();return _vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 933 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8409c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePictureInput.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('picture-input',{ref:"pictureInput",attrs:{"width":"600","height":"600","margin":"16","accept":"image/*","size":"10","button-class":"btn","prefill":_vm.value,"removable":true,"crop":false},on:{"change":_vm.onChange,"remove":_vm.onRemove}}),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/*!**********************************************!*\
  !*** ./src/components/base/BaseRadioBox.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseRadioBox_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseRadioBox.vue */ 360);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba79440_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseRadioBox_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5ba79440","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseRadioBox.vue */ 936);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5ba79440","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseRadioBox.vue */ 935)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseRadioBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ba79440_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseRadioBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 935 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ba79440","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseRadioBox.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba79440","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseRadioBox.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-radio-box"},[_c('label',[_c('BaseIcon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),_c('input',_vm._g({attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.optionValue,"checked":_vm.checked}},_vm.listeners)),_vm._v(" "),_c('p',[_vm._t("default")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 937 */
/*!********************************************!*\
  !*** ./src/components/base/BaseSelect.vue ***!
  \********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSelect_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseSelect.vue */ 361);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc36b11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSelect_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0fc36b11","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseSelect.vue */ 938);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc36b11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 938 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc36b11","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSelect.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"base-input__select-wrap"},[_c('select',_vm._g(_vm._b({directives:[{name:"validate",rawName:"v-validate",value:(_vm.validate),expression:"validate"}],attrs:{"aria-describedby":_vm.describedBy,"aria-errormessage":_vm.errorMessage,"id":_vm.id,"name":_vm.$attrs.name,"type":"text","disabled":_vm.theme === 'disabled'},domProps:{"value":_vm.value}},'select',_vm.$attrs,false),_vm.listeners),[(_vm.groupedOptions)?[(_vm.placeholder)?_c('option',{attrs:{"hidden":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.showNullOption)?_c('option',{domProps:{"value":null}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(group,index){return _c('optgroup',{key:index,attrs:{"label":group.label}},[_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.placeholder),expression:"placeholder"}],attrs:{"hidden":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._v(" "),_vm._l((group.options),function(item){return _c('option',{key:item[_vm.valueKey],attrs:{"disabled":item.disabled},domProps:{"value":item[_vm.valueKey]}},[_vm._v(_vm._s(item[_vm.labelKey]))])})],2)})]:[(_vm.placeholder)?_c('option',{attrs:{"disabled":"","hidden":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.showNullOption)?_c('option',{domProps:{"value":null}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(item){return _c('option',{key:item[_vm.valueKey],attrs:{"disabled":item.disabled},domProps:{"value":item[_vm.valueKey]}},[_vm._v(_vm._s(item[_vm.labelKey]))])})]],2),_vm._v(" "),_c('BaseIcon',{attrs:{"name":"double-arrows"}})],1),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',{attrs:{"id":_vm.errorMessageId}},[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',{attrs:{"id":_vm.hintId}},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.learnLabel && _vm.learnAction)?_c('p',{staticClass:"base-input__learn",on:{"click":_vm.learnAction}},[_vm._v(_vm._s(_vm.learnLabel))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 939 */
/*!************************************************!*\
  !*** ./src/components/base/BaseSpinnerBig.vue ***!
  \************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSpinnerBig_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseSpinnerBig.vue */ 362);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c040c32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSpinnerBig_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4c040c32","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseSpinnerBig.vue */ 941);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4c040c32","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseSpinnerBig.vue */ 940)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSpinnerBig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c040c32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSpinnerBig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 940 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c040c32","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseSpinnerBig.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c040c32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSpinnerBig.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseIcon',{staticClass:"base-spinner-big",attrs:{"name":"spinner-big"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */
/*!**********************************************!*\
  !*** ./src/components/base/BaseSwitcher.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSwitcher_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseSwitcher.vue */ 363);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6145439a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSwitcher_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6145439a","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseSwitcher.vue */ 944);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6145439a","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseSwitcher.vue */ 943)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6145439a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 943 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6145439a","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseSwitcher.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6145439a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSwitcher.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-switcher",class:_vm.className},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"base-switcher__wrapper"},[_c('BaseButton',{staticClass:"base-switcher__btn",class:{ 'base-switcher__btn--selected': _vm.bool},attrs:{"title":_vm.trueLabel},nativeOn:{"click":function($event){_vm.bool = true}}}),_vm._v(" "),_c('BaseButton',{staticClass:"base-switcher__btn",class:{ 'base-switcher__btn--selected': !_vm.bool},attrs:{"title":_vm.falseLabel},nativeOn:{"click":function($event){_vm.bool = false}}})],1),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/*!**********************************************!*\
  !*** ./src/components/base/BaseTextarea.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTextarea_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseTextarea.vue */ 364);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687635ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTextarea_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-687635ab","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseTextarea.vue */ 946);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTextarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687635ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTextarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 946 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-687635ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseTextarea.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.isLocked)?_c('BaseIcon',{staticClass:"base-input__padlock",attrs:{"name":'locked-padlock'}}):_vm._e()],1),_vm._v(" "),_c('textarea',_vm._g(_vm._b({directives:[{name:"validate",rawName:"v-validate",value:(_vm.validate),expression:"validate"}],style:({ minHeight: (_vm.minHeight + "px") }),attrs:{"disabled":_vm.isFieldDisabled},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners)),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e(),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 947 */
/*!*********************************************!*\
  !*** ./src/components/base/BaseWysiwyg.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseWysiwyg_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BaseWysiwyg.vue */ 365);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225f273e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseWysiwyg_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-225f273e","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BaseWysiwyg.vue */ 1041);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-225f273e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BaseWysiwyg.vue */ 948)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BaseWysiwyg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225f273e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseWysiwyg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 948 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-225f273e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/BaseWysiwyg.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/*!***********************************************************************!*\
  !*** ./src/packages/vue-tinymce-editor/src/components/TinymceVue.vue ***!
  \***********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TinymceVue_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TinymceVue.vue */ 366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7670660b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TinymceVue_vue__ = __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7670660b","hasScoped":true,"buble":{"transforms":{}}}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TinymceVue.vue */ 1040);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7670660b","scoped":true,"hasInlineConfig":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TinymceVue.vue */ 950)
}
var normalizeComponent = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7670660b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TinymceVue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7670660b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TinymceVue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 950 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7670660b","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/vue-tinymce-editor/src/components/TinymceVue.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/*!*****************************************!*\
  !*** ./src/packages/tinymce/tinymce.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, module) {var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// 4.8.1 (2018-07-26)
(function(){(function(){'use strict';var noop=function noop(){var x=[];for(var _i=0;_i<arguments.length;_i++){x[_i]=arguments[_i];}};var compose=function compose(fa,fb){return function(){var x=[];for(var _i=0;_i<arguments.length;_i++){x[_i]=arguments[_i];}return fa(fb.apply(null,arguments));};};var constant=function constant(value){return function(){return value;};};var identity=function identity(x){return x;};var curry=function curry(f){var x=[];for(var _i=1;_i<arguments.length;_i++){x[_i-1]=arguments[_i];}var args=new Array(arguments.length-1);for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}return function(){var x=[];for(var _i=0;_i<arguments.length;_i++){x[_i]=arguments[_i];}var newArgs=new Array(arguments.length);for(var j=0;j<newArgs.length;j++){newArgs[j]=arguments[j];}var all=args.concat(newArgs);return f.apply(null,all);};};var die=function die(msg){return function(){throw new Error(msg);};};var never=constant(false);var always=constant(true);var never$1=never;var always$1=always;var none=function none(){return NONE;};var NONE=function(){var eq=function eq(o){return o.isNone();};var call$$1=function call$$1(thunk){return thunk();};var id=function id(n){return n;};var noop$$1=function noop$$1(){};var nul=function nul(){return null;};var undef=function undef(){return undefined;};var me={fold:function fold(n,s){return n();},is:never$1,isSome:never$1,isNone:always$1,getOr:id,getOrThunk:call$$1,getOrDie:function getOrDie(msg){throw new Error(msg||'error: getOrDie called on none.');},getOrNull:nul,getOrUndefined:undef,or:id,orThunk:call$$1,map:none,ap:none,each:noop$$1,bind:none,flatten:none,exists:never$1,forall:always$1,filter:none,equals:eq,equals_:eq,toArray:function toArray(){return[];},toString:constant('none()')};if(Object.freeze)Object.freeze(me);return me;}();var some=function some(a){var constant_a=function constant_a(){return a;};var self=function self(){return me;};var map=function map(f){return some(f(a));};var bind=function bind(f){return f(a);};var me={fold:function fold(n,s){return s(a);},is:function is(v){return a===v;},isSome:always$1,isNone:never$1,getOr:constant_a,getOrThunk:constant_a,getOrDie:constant_a,getOrNull:constant_a,getOrUndefined:constant_a,or:self,orThunk:self,map:map,ap:function ap(optfab){return optfab.fold(none,function(fab){return some(fab(a));});},each:function each(f){f(a);},bind:bind,flatten:constant_a,exists:bind,forall:bind,filter:function filter(f){return f(a)?me:NONE;},equals:function equals(o){return o.is(a);},equals_:function equals_(o,elementEq){return o.fold(never$1,function(b){return elementEq(a,b);});},toArray:function toArray(){return[a];},toString:function toString(){return'some('+a+')';}};return me;};var from=function from(value){return value===null||value===undefined?NONE:some(value);};var Option={some:some,none:none,from:from};var typeOf=function typeOf(x){if(x===null)return'null';var t=typeof x==='undefined'?'undefined':_typeof(x);if(t==='object'&&Array.prototype.isPrototypeOf(x))return'array';if(t==='object'&&String.prototype.isPrototypeOf(x))return'string';return t;};var isType=function isType(type){return function(value){return typeOf(value)===type;};};var isString=isType('string');var isObject=isType('object');var isArray=isType('array');var isNull=isType('null');var isBoolean=isType('boolean');var isFunction=isType('function');var isNumber=isType('number');var rawIndexOf=function(){var pIndexOf=Array.prototype.indexOf;var fastIndex=function fastIndex(xs,x){return pIndexOf.call(xs,x);};var slowIndex=function slowIndex(xs,x){return slowIndexOf(xs,x);};return pIndexOf===undefined?slowIndex:fastIndex;}();var indexOf=function indexOf(xs,x){var r=rawIndexOf(xs,x);return r===-1?Option.none():Option.some(r);};var contains=function contains(xs,x){return rawIndexOf(xs,x)>-1;};var exists=function exists(xs,pred){return findIndex(xs,pred).isSome();};var map=function map(xs,f){var len=xs.length;var r=new Array(len);for(var i=0;i<len;i++){var x=xs[i];r[i]=f(x,i,xs);}return r;};var each=function each(xs,f){for(var i=0,len=xs.length;i<len;i++){var x=xs[i];f(x,i,xs);}};var eachr=function eachr(xs,f){for(var i=xs.length-1;i>=0;i--){var x=xs[i];f(x,i,xs);}};var partition=function partition(xs,pred){var pass=[];var fail=[];for(var i=0,len=xs.length;i<len;i++){var x=xs[i];var arr=pred(x,i,xs)?pass:fail;arr.push(x);}return{pass:pass,fail:fail};};var filter=function filter(xs,pred){var r=[];for(var i=0,len=xs.length;i<len;i++){var x=xs[i];if(pred(x,i,xs)){r.push(x);}}return r;};var foldr=function foldr(xs,f,acc){eachr(xs,function(x){acc=f(acc,x);});return acc;};var foldl=function foldl(xs,f,acc){each(xs,function(x){acc=f(acc,x);});return acc;};var find=function find(xs,pred){for(var i=0,len=xs.length;i<len;i++){var x=xs[i];if(pred(x,i,xs)){return Option.some(x);}}return Option.none();};var findIndex=function findIndex(xs,pred){for(var i=0,len=xs.length;i<len;i++){var x=xs[i];if(pred(x,i,xs)){return Option.some(i);}}return Option.none();};var slowIndexOf=function slowIndexOf(xs,x){for(var i=0,len=xs.length;i<len;++i){if(xs[i]===x){return i;}}return-1;};var push=Array.prototype.push;var flatten=function flatten(xs){var r=[];for(var i=0,len=xs.length;i<len;++i){if(!Array.prototype.isPrototypeOf(xs[i]))throw new Error('Arr.flatten item '+i+' was not an array, input: '+xs);push.apply(r,xs[i]);}return r;};var bind=function bind(xs,f){var output=map(xs,f);return flatten(output);};var forall=function forall(xs,pred){for(var i=0,len=xs.length;i<len;++i){var x=xs[i];if(pred(x,i,xs)!==true){return false;}}return true;};var slice=Array.prototype.slice;var reverse=function reverse(xs){var r=slice.call(xs,0);r.reverse();return r;};var difference=function difference(a1,a2){return filter(a1,function(x){return!contains(a2,x);});};var mapToObject=function mapToObject(xs,f){var r={};for(var i=0,len=xs.length;i<len;i++){var x=xs[i];r[String(x)]=f(x,i);}return r;};var sort=function sort(xs,comparator){var copy=slice.call(xs,0);copy.sort(comparator);return copy;};var head=function head(xs){return xs.length===0?Option.none():Option.some(xs[0]);};var last=function last(xs){return xs.length===0?Option.none():Option.some(xs[xs.length-1]);};var from$1=isFunction(Array.from)?Array.from:function(x){return slice.call(x);};var Global=typeof window!=='undefined'?window:Function('return this;')();var path=function path(parts,scope){var o=scope!==undefined&&scope!==null?scope:Global;for(var i=0;i<parts.length&&o!==undefined&&o!==null;++i){o=o[parts[i]];}return o;};var resolve=function resolve(p,scope){var parts=p.split('.');return path(parts,scope);};var unsafe=function unsafe(name,scope){return resolve(name,scope);};var getOrDie=function getOrDie(name,scope){var actual=unsafe(name,scope);if(actual===undefined||actual===null)throw name+' not available on this browser';return actual;};var $_6d4d2bcjk26xeju={getOrDie:getOrDie};var url=function url(){return $_6d4d2bcjk26xeju.getOrDie('URL');};var createObjectURL=function createObjectURL(blob){return url().createObjectURL(blob);};var revokeObjectURL=function revokeObjectURL(u){url().revokeObjectURL(u);};var $_8l5cv7bjk26xejt={createObjectURL:createObjectURL,revokeObjectURL:revokeObjectURL};var nav=navigator;var userAgent=nav.userAgent;var opera;var webkit;var ie;var ie11;var ie12;var gecko;var mac;var iDevice;var android;var fileApi;var phone;var tablet;var windowsPhone;var matchMediaQuery=function matchMediaQuery(query){return'matchMedia'in window?matchMedia(query).matches:false;};opera=false;android=/Android/.test(userAgent);webkit=/WebKit/.test(userAgent);ie=!webkit&&!opera&&/MSIE/gi.test(userAgent)&&/Explorer/gi.test(nav.appName);ie=ie&&/MSIE (\w+)\./.exec(userAgent)[1];ie11=userAgent.indexOf('Trident/')!==-1&&(userAgent.indexOf('rv:')!==-1||nav.appName.indexOf('Netscape')!==-1)?11:false;ie12=userAgent.indexOf('Edge/')!==-1&&!ie&&!ie11?12:false;ie=ie||ie11||ie12;gecko=!webkit&&!ie11&&/Gecko/.test(userAgent);mac=userAgent.indexOf('Mac')!==-1;iDevice=/(iPad|iPhone)/.test(userAgent);fileApi='FormData'in window&&'FileReader'in window&&'URL'in window&&!!$_8l5cv7bjk26xejt.createObjectURL;phone=matchMediaQuery('only screen and (max-device-width: 480px)')&&(android||iDevice);tablet=matchMediaQuery('only screen and (min-width: 800px)')&&(android||iDevice);windowsPhone=userAgent.indexOf('Windows Phone')!==-1;if(ie12){webkit=false;}var contentEditable=!iDevice||fileApi||parseInt(userAgent.match(/AppleWebKit\/(\d*)/)[1],10)>=534;var $_ef6mqpajk26xejm={opera:opera,webkit:webkit,ie:ie,gecko:gecko,mac:mac,iOS:iDevice,android:android,contentEditable:contentEditable,transparentSrc:'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',caretAfter:ie!==8,range:window.getSelection&&'Range'in window,documentMode:ie&&!ie12?document.documentMode||7:10,fileApi:fileApi,ceFalse:ie===false||ie>8,cacheSuffix:null,container:null,overrideViewPort:null,experimentalShadowDom:false,canHaveCSP:ie===false||ie>11,desktop:!phone&&!tablet,windowsPhone:windowsPhone};var promise=function promise(){function bind(fn,thisArg){return function(){fn.apply(thisArg,arguments);};}var isArray=Array.isArray||function(value){return Object.prototype.toString.call(value)==='[object Array]';};var Promise=function Promise(fn){if(_typeof(this)!=='object'){throw new TypeError('Promises must be constructed via new');}if(typeof fn!=='function'){throw new TypeError('not a function');}this._state=null;this._value=null;this._deferreds=[];doResolve(fn,bind(resolve,this),bind(reject,this));};var asap=Promise.immediateFn||typeof setImmediate==='function'&&setImmediate||function(fn){setTimeout(fn,1);};function handle(deferred){var me=this;if(this._state===null){this._deferreds.push(deferred);return;}asap(function(){var cb=me._state?deferred.onFulfilled:deferred.onRejected;if(cb===null){(me._state?deferred.resolve:deferred.reject)(me._value);return;}var ret;try{ret=cb(me._value);}catch(e){deferred.reject(e);return;}deferred.resolve(ret);});}function resolve(newValue){try{if(newValue===this){throw new TypeError('A promise cannot be resolved with itself.');}if(newValue&&((typeof newValue==='undefined'?'undefined':_typeof(newValue))==='object'||typeof newValue==='function')){var then=newValue.then;if(typeof then==='function'){doResolve(bind(then,newValue),bind(resolve,this),bind(reject,this));return;}}this._state=true;this._value=newValue;finale.call(this);}catch(e){reject.call(this,e);}}function reject(newValue){this._state=false;this._value=newValue;finale.call(this);}function finale(){for(var i=0,len=this._deferreds.length;i<len;i++){handle.call(this,this._deferreds[i]);}this._deferreds=null;}function Handler(onFulfilled,onRejected,resolve,reject){this.onFulfilled=typeof onFulfilled==='function'?onFulfilled:null;this.onRejected=typeof onRejected==='function'?onRejected:null;this.resolve=resolve;this.reject=reject;}function doResolve(fn,onFulfilled,onRejected){var done=false;try{fn(function(value){if(done){return;}done=true;onFulfilled(value);},function(reason){if(done){return;}done=true;onRejected(reason);});}catch(ex){if(done){return;}done=true;onRejected(ex);}}Promise.prototype.catch=function(onRejected){return this.then(null,onRejected);};Promise.prototype.then=function(onFulfilled,onRejected){var me=this;return new Promise(function(resolve,reject){handle.call(me,new Handler(onFulfilled,onRejected,resolve,reject));});};Promise.all=function(){var args=Array.prototype.slice.call(arguments.length===1&&isArray(arguments[0])?arguments[0]:arguments);return new Promise(function(resolve,reject){if(args.length===0){return resolve([]);}var remaining=args.length;function res(i,val){try{if(val&&((typeof val==='undefined'?'undefined':_typeof(val))==='object'||typeof val==='function')){var then=val.then;if(typeof then==='function'){then.call(val,function(val){res(i,val);},reject);return;}}args[i]=val;if(--remaining===0){resolve(args);}}catch(ex){reject(ex);}}for(var i=0;i<args.length;i++){res(i,args[i]);}});};Promise.resolve=function(value){if(value&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'&&value.constructor===Promise){return value;}return new Promise(function(resolve){resolve(value);});};Promise.reject=function(value){return new Promise(function(resolve,reject){reject(value);});};Promise.race=function(values){return new Promise(function(resolve,reject){for(var i=0,len=values.length;i<len;i++){values[i].then(resolve,reject);}});};return Promise;};var promiseObj=window.Promise?window.Promise:promise();var requestAnimationFramePromise;var requestAnimationFrame$$1=function requestAnimationFrame$$1(callback,element){var i,requestAnimationFrameFunc=window.requestAnimationFrame;var vendors=['ms','moz','webkit'];var featurefill=function featurefill(callback){window.setTimeout(callback,0);};for(i=0;i<vendors.length&&!requestAnimationFrameFunc;i++){requestAnimationFrameFunc=window[vendors[i]+'RequestAnimationFrame'];}if(!requestAnimationFrameFunc){requestAnimationFrameFunc=featurefill;}requestAnimationFrameFunc(callback,element);};var wrappedSetTimeout=function wrappedSetTimeout(callback,time){if(typeof time!=='number'){time=0;}return setTimeout(callback,time);};var wrappedSetInterval=function wrappedSetInterval(callback,time){if(typeof time!=='number'){time=1;}return setInterval(callback,time);};var wrappedClearTimeout=function wrappedClearTimeout(id){return clearTimeout(id);};var wrappedClearInterval=function wrappedClearInterval(id){return clearInterval(id);};var debounce=function debounce(callback,time){var timer,func;func=function func(){var args=arguments;clearTimeout(timer);timer=wrappedSetTimeout(function(){callback.apply(this,args);},time);};func.stop=function(){clearTimeout(timer);};return func;};var $_3a7ompijk26xer0={requestAnimationFrame:function requestAnimationFrame(callback,element){if(requestAnimationFramePromise){requestAnimationFramePromise.then(callback);return;}requestAnimationFramePromise=new promiseObj(function(resolve){if(!element){element=document.body;}requestAnimationFrame$$1(resolve,element);}).then(callback);},setTimeout:wrappedSetTimeout,setInterval:wrappedSetInterval,setEditorTimeout:function setEditorTimeout(editor,callback,time){return wrappedSetTimeout(function(){if(!editor.removed){callback();}},time);},setEditorInterval:function setEditorInterval(editor,callback,time){var timer;timer=wrappedSetInterval(function(){if(!editor.removed){callback();}else{clearInterval(timer);}},time);return timer;},debounce:debounce,throttle:debounce,clearInterval:wrappedClearInterval,clearTimeout:wrappedClearTimeout};var eventExpandoPrefix='mce-data-';var mouseEventRe=/^(?:mouse|contextmenu)|click/;var deprecated={keyLocation:1,layerX:1,layerY:1,returnValue:1,webkitMovementX:1,webkitMovementY:1,keyIdentifier:1};var hasIsDefaultPrevented=function hasIsDefaultPrevented(event$$1){return event$$1.isDefaultPrevented===returnTrue||event$$1.isDefaultPrevented===returnFalse;};var returnFalse=function returnFalse(){return false;};var returnTrue=function returnTrue(){return true;};var addEvent=function addEvent(target,name$$1,callback,capture){if(target.addEventListener){target.addEventListener(name$$1,callback,capture||false);}else if(target.attachEvent){target.attachEvent('on'+name$$1,callback);}};var removeEvent=function removeEvent(target,name$$1,callback,capture){if(target.removeEventListener){target.removeEventListener(name$$1,callback,capture||false);}else if(target.detachEvent){target.detachEvent('on'+name$$1,callback);}};var getTargetFromShadowDom=function getTargetFromShadowDom(event$$1,defaultTarget){var path,target=defaultTarget;path=event$$1.path;if(path&&path.length>0){target=path[0];}if(event$$1.composedPath){path=event$$1.composedPath();if(path&&path.length>0){target=path[0];}}return target;};var fix=function fix(originalEvent,data){var name$$1;var event$$1=data||{};for(name$$1 in originalEvent){if(!deprecated[name$$1]){event$$1[name$$1]=originalEvent[name$$1];}}if(!event$$1.target){event$$1.target=event$$1.srcElement||document;}if($_ef6mqpajk26xejm.experimentalShadowDom){event$$1.target=getTargetFromShadowDom(originalEvent,event$$1.target);}if(originalEvent&&mouseEventRe.test(originalEvent.type)&&originalEvent.pageX===undefined&&originalEvent.clientX!==undefined){var eventDoc=event$$1.target.ownerDocument||document;var doc=eventDoc.documentElement;var body=eventDoc.body;event$$1.pageX=originalEvent.clientX+(doc&&doc.scrollLeft||body&&body.scrollLeft||0)-(doc&&doc.clientLeft||body&&body.clientLeft||0);event$$1.pageY=originalEvent.clientY+(doc&&doc.scrollTop||body&&body.scrollTop||0)-(doc&&doc.clientTop||body&&body.clientTop||0);}event$$1.preventDefault=function(){event$$1.isDefaultPrevented=returnTrue;if(originalEvent){if(originalEvent.preventDefault){originalEvent.preventDefault();}else{originalEvent.returnValue=false;}}};event$$1.stopPropagation=function(){event$$1.isPropagationStopped=returnTrue;if(originalEvent){if(originalEvent.stopPropagation){originalEvent.stopPropagation();}else{originalEvent.cancelBubble=true;}}};event$$1.stopImmediatePropagation=function(){event$$1.isImmediatePropagationStopped=returnTrue;event$$1.stopPropagation();};if(hasIsDefaultPrevented(event$$1)===false){event$$1.isDefaultPrevented=returnFalse;event$$1.isPropagationStopped=returnFalse;event$$1.isImmediatePropagationStopped=returnFalse;}if(typeof event$$1.metaKey==='undefined'){event$$1.metaKey=false;}return event$$1;};var bindOnReady=function bindOnReady(win,callback,eventUtils){var doc=win.document,event$$1={type:'ready'};if(eventUtils.domLoaded){callback(event$$1);return;}var isDocReady=function isDocReady(){return doc.readyState==='complete'||doc.readyState==='interactive'&&doc.body;};var readyHandler=function readyHandler(){if(!eventUtils.domLoaded){eventUtils.domLoaded=true;callback(event$$1);}};var waitForDomLoaded=function waitForDomLoaded(){if(isDocReady()){removeEvent(doc,'readystatechange',waitForDomLoaded);readyHandler();}};var tryScroll=function tryScroll(){try{doc.documentElement.doScroll('left');}catch(ex){$_3a7ompijk26xer0.setTimeout(tryScroll);return;}readyHandler();};if(doc.addEventListener&&!($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<11)){if(isDocReady()){readyHandler();}else{addEvent(win,'DOMContentLoaded',readyHandler);}}else{addEvent(doc,'readystatechange',waitForDomLoaded);if(doc.documentElement.doScroll&&win.self===win.top){tryScroll();}}addEvent(win,'load',readyHandler);};var EventUtils=function EventUtils(){var self$$1=this;var events={},count,expando,hasFocusIn,hasMouseEnterLeave,mouseEnterLeave;expando=eventExpandoPrefix+(+new Date()).toString(32);hasMouseEnterLeave='onmouseenter'in document.documentElement;hasFocusIn='onfocusin'in document.documentElement;mouseEnterLeave={mouseenter:'mouseover',mouseleave:'mouseout'};count=1;self$$1.domLoaded=false;self$$1.events=events;var executeHandlers=function executeHandlers(evt,id){var callbackList,i,l,callback;var container=events[id];callbackList=container&&container[evt.type];if(callbackList){for(i=0,l=callbackList.length;i<l;i++){callback=callbackList[i];if(callback&&callback.func.call(callback.scope,evt)===false){evt.preventDefault();}if(evt.isImmediatePropagationStopped()){return;}}}};self$$1.bind=function(target,names,callback,scope){var id,callbackList,i,name$$1,fakeName,nativeHandler,capture;var win=window;var defaultNativeHandler=function defaultNativeHandler(evt){executeHandlers(fix(evt||win.event),id);};if(!target||target.nodeType===3||target.nodeType===8){return;}if(!target[expando]){id=count++;target[expando]=id;events[id]={};}else{id=target[expando];}scope=scope||target;names=names.split(' ');i=names.length;while(i--){name$$1=names[i];nativeHandler=defaultNativeHandler;fakeName=capture=false;if(name$$1==='DOMContentLoaded'){name$$1='ready';}if(self$$1.domLoaded&&name$$1==='ready'&&target.readyState==='complete'){callback.call(scope,fix({type:name$$1}));continue;}if(!hasMouseEnterLeave){fakeName=mouseEnterLeave[name$$1];if(fakeName){nativeHandler=function nativeHandler(evt){var current,related;current=evt.currentTarget;related=evt.relatedTarget;if(related&&current.contains){related=current.contains(related);}else{while(related&&related!==current){related=related.parentNode;}}if(!related){evt=fix(evt||win.event);evt.type=evt.type==='mouseout'?'mouseleave':'mouseenter';evt.target=current;executeHandlers(evt,id);}};}}if(!hasFocusIn&&(name$$1==='focusin'||name$$1==='focusout')){capture=true;fakeName=name$$1==='focusin'?'focus':'blur';nativeHandler=function nativeHandler(evt){evt=fix(evt||win.event);evt.type=evt.type==='focus'?'focusin':'focusout';executeHandlers(evt,id);};}callbackList=events[id][name$$1];if(!callbackList){events[id][name$$1]=callbackList=[{func:callback,scope:scope}];callbackList.fakeName=fakeName;callbackList.capture=capture;callbackList.nativeHandler=nativeHandler;if(name$$1==='ready'){bindOnReady(target,nativeHandler,self$$1);}else{addEvent(target,fakeName||name$$1,nativeHandler,capture);}}else{if(name$$1==='ready'&&self$$1.domLoaded){callback({type:name$$1});}else{callbackList.push({func:callback,scope:scope});}}}target=callbackList=0;return callback;};self$$1.unbind=function(target,names,callback){var id,callbackList,i,ci,name$$1,eventMap;if(!target||target.nodeType===3||target.nodeType===8){return self$$1;}id=target[expando];if(id){eventMap=events[id];if(names){names=names.split(' ');i=names.length;while(i--){name$$1=names[i];callbackList=eventMap[name$$1];if(callbackList){if(callback){ci=callbackList.length;while(ci--){if(callbackList[ci].func===callback){var nativeHandler=callbackList.nativeHandler;var fakeName=callbackList.fakeName,capture=callbackList.capture;callbackList=callbackList.slice(0,ci).concat(callbackList.slice(ci+1));callbackList.nativeHandler=nativeHandler;callbackList.fakeName=fakeName;callbackList.capture=capture;eventMap[name$$1]=callbackList;}}}if(!callback||callbackList.length===0){delete eventMap[name$$1];removeEvent(target,callbackList.fakeName||name$$1,callbackList.nativeHandler,callbackList.capture);}}}}else{for(name$$1 in eventMap){callbackList=eventMap[name$$1];removeEvent(target,callbackList.fakeName||name$$1,callbackList.nativeHandler,callbackList.capture);}eventMap={};}for(name$$1 in eventMap){return self$$1;}delete events[id];try{delete target[expando];}catch(ex){target[expando]=null;}}return self$$1;};self$$1.fire=function(target,name$$1,args){var id;if(!target||target.nodeType===3||target.nodeType===8){return self$$1;}args=fix(null,args);args.type=name$$1;args.target=target;do{id=target[expando];if(id){executeHandlers(args,id);}target=target.parentNode||target.ownerDocument||target.defaultView||target.parentWindow;}while(target&&!args.isPropagationStopped());return self$$1;};self$$1.clean=function(target){var i,children;var unbind=self$$1.unbind;if(!target||target.nodeType===3||target.nodeType===8){return self$$1;}if(target[expando]){unbind(target);}if(!target.getElementsByTagName){target=target.document;}if(target&&target.getElementsByTagName){unbind(target);children=target.getElementsByTagName('*');i=children.length;while(i--){target=children[i];if(target[expando]){unbind(target);}}}return self$$1;};self$$1.destroy=function(){events={};};self$$1.cancel=function(e){if(e){e.preventDefault();e.stopImmediatePropagation();}return false;};};EventUtils.Event=new EventUtils();EventUtils.Event.bind(window,'ready',function(){});var i;var support;var Expr;var getText;var isXML;var tokenize;var compile;var select;var outermostContext;var sortInput;var hasDuplicate;var setDocument;var document$1;var docElem;var documentIsHTML;var rbuggyQSA;var rbuggyMatches;var matches;var contains$1;var expando='sizzle'+-new Date();var preferredDoc=window.document;var dirruns=0;var done=0;var classCache=createCache();var tokenCache=createCache();var compilerCache=createCache();var sortOrder=function sortOrder(a,b){if(a===b){hasDuplicate=true;}return 0;};var strundefined= true?'undefined':_typeof(undefined);var MAX_NEGATIVE=1<<31;var hasOwn={}.hasOwnProperty;var arr=[];var pop=arr.pop;var push_native=arr.push;var push$1=arr.push;var slice$1=arr.slice;var indexOf$1=arr.indexOf||function(elem){var i=0,len=this.length;for(;i<len;i++){if(this[i]===elem){return i;}}return-1;};var booleans='checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped';var whitespace='[\\x20\\t\\r\\n\\f]';var identifier='(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+';var attributes='\\['+whitespace+'*('+identifier+')(?:'+whitespace+'*([*^$|!~]?=)'+whitespace+'*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|('+identifier+'))|)'+whitespace+'*\\]';var pseudos=':('+identifier+')(?:\\(('+'(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|'+'((?:\\\\.|[^\\\\()[\\]]|'+attributes+')*)|'+'.*'+')\\)|)';var rtrim=new RegExp('^'+whitespace+'+|((?:^|[^\\\\])(?:\\\\.)*)'+whitespace+'+$','g');var rcomma=new RegExp('^'+whitespace+'*,'+whitespace+'*');var rcombinators=new RegExp('^'+whitespace+'*([>+~]|'+whitespace+')'+whitespace+'*');var rattributeQuotes=new RegExp('='+whitespace+'*([^\\]\'"]*?)'+whitespace+'*\\]','g');var rpseudo=new RegExp(pseudos);var ridentifier=new RegExp('^'+identifier+'$');var matchExpr={ID:new RegExp('^#('+identifier+')'),CLASS:new RegExp('^\\.('+identifier+')'),TAG:new RegExp('^('+identifier+'|[*])'),ATTR:new RegExp('^'+attributes),PSEUDO:new RegExp('^'+pseudos),CHILD:new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\('+whitespace+'*(even|odd|(([+-]|)(\\d*)n|)'+whitespace+'*(?:([+-]|)'+whitespace+'*(\\d+)|))'+whitespace+'*\\)|)','i'),bool:new RegExp('^(?:'+booleans+')$','i'),needsContext:new RegExp('^'+whitespace+'*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\('+whitespace+'*((?:-\\d)?\\d*)'+whitespace+'*\\)|)(?=[^-]|$)','i')};var rinputs=/^(?:input|select|textarea|button)$/i;var rheader=/^h\d$/i;var rnative=/^[^{]+\{\s*\[native \w/;var rquickExpr=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/;var rsibling=/[+~]/;var rescape=/'|\\/g;var runescape=new RegExp('\\\\([\\da-f]{1,6}'+whitespace+'?|('+whitespace+')|.)','ig');var funescape=function funescape(_,escaped,escapedWhitespace){var high='0x'+escaped-65536;return high!==high||escapedWhitespace?escaped:high<0?String.fromCharCode(high+65536):String.fromCharCode(high>>10|55296,high&1023|56320);};try{push$1.apply(arr=slice$1.call(preferredDoc.childNodes),preferredDoc.childNodes);arr[preferredDoc.childNodes.length].nodeType;}catch(e){push$1={apply:arr.length?function(target,els){push_native.apply(target,slice$1.call(els));}:function(target,els){var j=target.length,i=0;while(target[j++]=els[i++]){}target.length=j-1;}};}var Sizzle=function Sizzle(selector,context,results,seed){var match,elem,m,nodeType,i,groups,old,nid,newContext,newSelector;if((context?context.ownerDocument||context:preferredDoc)!==document$1){setDocument(context);}context=context||document$1;results=results||[];if(!selector||typeof selector!=='string'){return results;}if((nodeType=context.nodeType)!==1&&nodeType!==9){return[];}if(documentIsHTML&&!seed){if(match=rquickExpr.exec(selector)){if(m=match[1]){if(nodeType===9){elem=context.getElementById(m);if(elem&&elem.parentNode){if(elem.id===m){results.push(elem);return results;}}else{return results;}}else{if(context.ownerDocument&&(elem=context.ownerDocument.getElementById(m))&&contains$1(context,elem)&&elem.id===m){results.push(elem);return results;}}}else if(match[2]){push$1.apply(results,context.getElementsByTagName(selector));return results;}else if((m=match[3])&&support.getElementsByClassName){push$1.apply(results,context.getElementsByClassName(m));return results;}}if(support.qsa&&(!rbuggyQSA||!rbuggyQSA.test(selector))){nid=old=expando;newContext=context;newSelector=nodeType===9&&selector;if(nodeType===1&&context.nodeName.toLowerCase()!=='object'){groups=tokenize(selector);if(old=context.getAttribute('id')){nid=old.replace(rescape,'\\$&');}else{context.setAttribute('id',nid);}nid='[id=\''+nid+'\'] ';i=groups.length;while(i--){groups[i]=nid+toSelector(groups[i]);}newContext=rsibling.test(selector)&&testContext(context.parentNode)||context;newSelector=groups.join(',');}if(newSelector){try{push$1.apply(results,newContext.querySelectorAll(newSelector));return results;}catch(qsaError){}finally{if(!old){context.removeAttribute('id');}}}}}return select(selector.replace(rtrim,'$1'),context,results,seed);};function createCache(){var keys=[];function cache(key,value){if(keys.push(key+' ')>Expr.cacheLength){delete cache[keys.shift()];}return cache[key+' ']=value;}return cache;}function markFunction(fn){fn[expando]=true;return fn;}function siblingCheck(a,b){var cur=b&&a,diff=cur&&a.nodeType===1&&b.nodeType===1&&(~b.sourceIndex||MAX_NEGATIVE)-(~a.sourceIndex||MAX_NEGATIVE);if(diff){return diff;}if(cur){while(cur=cur.nextSibling){if(cur===b){return-1;}}}return a?1:-1;}function createInputPseudo(type){return function(elem){var name$$1=elem.nodeName.toLowerCase();return name$$1==='input'&&elem.type===type;};}function createButtonPseudo(type){return function(elem){var name$$1=elem.nodeName.toLowerCase();return(name$$1==='input'||name$$1==='button')&&elem.type===type;};}function createPositionalPseudo(fn){return markFunction(function(argument){argument=+argument;return markFunction(function(seed,matches){var j,matchIndexes=fn([],seed.length,argument),i=matchIndexes.length;while(i--){if(seed[j=matchIndexes[i]]){seed[j]=!(matches[j]=seed[j]);}}});});}function testContext(context){return context&&_typeof(context.getElementsByTagName)!==strundefined&&context;}support=Sizzle.support={};isXML=Sizzle.isXML=function(elem){var documentElement=elem&&(elem.ownerDocument||elem).documentElement;return documentElement?documentElement.nodeName!=='HTML':false;};setDocument=Sizzle.setDocument=function(node){var hasCompare,doc=node?node.ownerDocument||node:preferredDoc,parent$$1=doc.defaultView;function getTop(win){try{return win.top;}catch(ex){}return null;}if(doc===document$1||doc.nodeType!==9||!doc.documentElement){return document$1;}document$1=doc;docElem=doc.documentElement;documentIsHTML=!isXML(doc);if(parent$$1&&parent$$1!==getTop(parent$$1)){if(parent$$1.addEventListener){parent$$1.addEventListener('unload',function(){setDocument();},false);}else if(parent$$1.attachEvent){parent$$1.attachEvent('onunload',function(){setDocument();});}}support.attributes=true;support.getElementsByTagName=true;support.getElementsByClassName=rnative.test(doc.getElementsByClassName);support.getById=true;Expr.find.ID=function(id,context){if(_typeof(context.getElementById)!==strundefined&&documentIsHTML){var m=context.getElementById(id);return m&&m.parentNode?[m]:[];}};Expr.filter.ID=function(id){var attrId=id.replace(runescape,funescape);return function(elem){return elem.getAttribute('id')===attrId;};};Expr.find.TAG=support.getElementsByTagName?function(tag,context){if(_typeof(context.getElementsByTagName)!==strundefined){return context.getElementsByTagName(tag);}}:function(tag,context){var elem,tmp=[],i=0,results=context.getElementsByTagName(tag);if(tag==='*'){while(elem=results[i++]){if(elem.nodeType===1){tmp.push(elem);}}return tmp;}return results;};Expr.find.CLASS=support.getElementsByClassName&&function(className,context){if(documentIsHTML){return context.getElementsByClassName(className);}};rbuggyMatches=[];rbuggyQSA=[];support.disconnectedMatch=true;rbuggyQSA=rbuggyQSA.length&&new RegExp(rbuggyQSA.join('|'));rbuggyMatches=rbuggyMatches.length&&new RegExp(rbuggyMatches.join('|'));hasCompare=rnative.test(docElem.compareDocumentPosition);contains$1=hasCompare||rnative.test(docElem.contains)?function(a,b){var adown=a.nodeType===9?a.documentElement:a,bup=b&&b.parentNode;return a===bup||!!(bup&&bup.nodeType===1&&(adown.contains?adown.contains(bup):a.compareDocumentPosition&&a.compareDocumentPosition(bup)&16));}:function(a,b){if(b){while(b=b.parentNode){if(b===a){return true;}}}return false;};sortOrder=hasCompare?function(a,b){if(a===b){hasDuplicate=true;return 0;}var compare=!a.compareDocumentPosition-!b.compareDocumentPosition;if(compare){return compare;}compare=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1;if(compare&1||!support.sortDetached&&b.compareDocumentPosition(a)===compare){if(a===doc||a.ownerDocument===preferredDoc&&contains$1(preferredDoc,a)){return-1;}if(b===doc||b.ownerDocument===preferredDoc&&contains$1(preferredDoc,b)){return 1;}return sortInput?indexOf$1.call(sortInput,a)-indexOf$1.call(sortInput,b):0;}return compare&4?-1:1;}:function(a,b){if(a===b){hasDuplicate=true;return 0;}var cur,i=0,aup=a.parentNode,bup=b.parentNode,ap=[a],bp=[b];if(!aup||!bup){return a===doc?-1:b===doc?1:aup?-1:bup?1:sortInput?indexOf$1.call(sortInput,a)-indexOf$1.call(sortInput,b):0;}else if(aup===bup){return siblingCheck(a,b);}cur=a;while(cur=cur.parentNode){ap.unshift(cur);}cur=b;while(cur=cur.parentNode){bp.unshift(cur);}while(ap[i]===bp[i]){i++;}return i?siblingCheck(ap[i],bp[i]):ap[i]===preferredDoc?-1:bp[i]===preferredDoc?1:0;};return doc;};Sizzle.matches=function(expr,elements){return Sizzle(expr,null,null,elements);};Sizzle.matchesSelector=function(elem,expr){if((elem.ownerDocument||elem)!==document$1){setDocument(elem);}expr=expr.replace(rattributeQuotes,'=\'$1\']');if(support.matchesSelector&&documentIsHTML&&(!rbuggyMatches||!rbuggyMatches.test(expr))&&(!rbuggyQSA||!rbuggyQSA.test(expr))){try{var ret=matches.call(elem,expr);if(ret||support.disconnectedMatch||elem.document&&elem.document.nodeType!==11){return ret;}}catch(e){}}return Sizzle(expr,document$1,null,[elem]).length>0;};Sizzle.contains=function(context,elem){if((context.ownerDocument||context)!==document$1){setDocument(context);}return contains$1(context,elem);};Sizzle.attr=function(elem,name$$1){if((elem.ownerDocument||elem)!==document$1){setDocument(elem);}var fn=Expr.attrHandle[name$$1.toLowerCase()],val=fn&&hasOwn.call(Expr.attrHandle,name$$1.toLowerCase())?fn(elem,name$$1,!documentIsHTML):undefined;return val!==undefined?val:support.attributes||!documentIsHTML?elem.getAttribute(name$$1):(val=elem.getAttributeNode(name$$1))&&val.specified?val.value:null;};Sizzle.error=function(msg){throw new Error('Syntax error, unrecognized expression: '+msg);};Sizzle.uniqueSort=function(results){var elem,duplicates=[],j=0,i=0;hasDuplicate=!support.detectDuplicates;sortInput=!support.sortStable&&results.slice(0);results.sort(sortOrder);if(hasDuplicate){while(elem=results[i++]){if(elem===results[i]){j=duplicates.push(i);}}while(j--){results.splice(duplicates[j],1);}}sortInput=null;return results;};getText=Sizzle.getText=function(elem){var node,ret='',i=0,nodeType=elem.nodeType;if(!nodeType){while(node=elem[i++]){ret+=getText(node);}}else if(nodeType===1||nodeType===9||nodeType===11){if(typeof elem.textContent==='string'){return elem.textContent;}else{for(elem=elem.firstChild;elem;elem=elem.nextSibling){ret+=getText(elem);}}}else if(nodeType===3||nodeType===4){return elem.nodeValue;}return ret;};Expr=Sizzle.selectors={cacheLength:50,createPseudo:markFunction,match:matchExpr,attrHandle:{},find:{},relative:{'>':{dir:'parentNode',first:true},' ':{dir:'parentNode'},'+':{dir:'previousSibling',first:true},'~':{dir:'previousSibling'}},preFilter:{ATTR:function ATTR(match){match[1]=match[1].replace(runescape,funescape);match[3]=(match[3]||match[4]||match[5]||'').replace(runescape,funescape);if(match[2]==='~='){match[3]=' '+match[3]+' ';}return match.slice(0,4);},CHILD:function CHILD(match){match[1]=match[1].toLowerCase();if(match[1].slice(0,3)==='nth'){if(!match[3]){Sizzle.error(match[0]);}match[4]=+(match[4]?match[5]+(match[6]||1):2*(match[3]==='even'||match[3]==='odd'));match[5]=+(match[7]+match[8]||match[3]==='odd');}else if(match[3]){Sizzle.error(match[0]);}return match;},PSEUDO:function PSEUDO(match){var excess,unquoted=!match[6]&&match[2];if(matchExpr.CHILD.test(match[0])){return null;}if(match[3]){match[2]=match[4]||match[5]||'';}else if(unquoted&&rpseudo.test(unquoted)&&(excess=tokenize(unquoted,true))&&(excess=unquoted.indexOf(')',unquoted.length-excess)-unquoted.length)){match[0]=match[0].slice(0,excess);match[2]=unquoted.slice(0,excess);}return match.slice(0,3);}},filter:{TAG:function TAG(nodeNameSelector){var nodeName=nodeNameSelector.replace(runescape,funescape).toLowerCase();return nodeNameSelector==='*'?function(){return true;}:function(elem){return elem.nodeName&&elem.nodeName.toLowerCase()===nodeName;};},CLASS:function CLASS(className){var pattern=classCache[className+' '];return pattern||(pattern=new RegExp('(^|'+whitespace+')'+className+'('+whitespace+'|$)'))&&classCache(className,function(elem){return pattern.test(typeof elem.className==='string'&&elem.className||_typeof(elem.getAttribute)!==strundefined&&elem.getAttribute('class')||'');});},ATTR:function ATTR(name$$1,operator,check){return function(elem){var result=Sizzle.attr(elem,name$$1);if(result==null){return operator==='!=';}if(!operator){return true;}result+='';return operator==='='?result===check:operator==='!='?result!==check:operator==='^='?check&&result.indexOf(check)===0:operator==='*='?check&&result.indexOf(check)>-1:operator==='$='?check&&result.slice(-check.length)===check:operator==='~='?(' '+result+' ').indexOf(check)>-1:operator==='|='?result===check||result.slice(0,check.length+1)===check+'-':false;};},CHILD:function CHILD(type,what,argument,first,last){var simple=type.slice(0,3)!=='nth',forward=type.slice(-4)!=='last',ofType=what==='of-type';return first===1&&last===0?function(elem){return!!elem.parentNode;}:function(elem,context,xml){var cache,outerCache,node,diff,nodeIndex,start,dir=simple!==forward?'nextSibling':'previousSibling',parent$$1=elem.parentNode,name$$1=ofType&&elem.nodeName.toLowerCase(),useCache=!xml&&!ofType;if(parent$$1){if(simple){while(dir){node=elem;while(node=node[dir]){if(ofType?node.nodeName.toLowerCase()===name$$1:node.nodeType===1){return false;}}start=dir=type==='only'&&!start&&'nextSibling';}return true;}start=[forward?parent$$1.firstChild:parent$$1.lastChild];if(forward&&useCache){outerCache=parent$$1[expando]||(parent$$1[expando]={});cache=outerCache[type]||[];nodeIndex=cache[0]===dirruns&&cache[1];diff=cache[0]===dirruns&&cache[2];node=nodeIndex&&parent$$1.childNodes[nodeIndex];while(node=++nodeIndex&&node&&node[dir]||(diff=nodeIndex=0)||start.pop()){if(node.nodeType===1&&++diff&&node===elem){outerCache[type]=[dirruns,nodeIndex,diff];break;}}}else if(useCache&&(cache=(elem[expando]||(elem[expando]={}))[type])&&cache[0]===dirruns){diff=cache[1];}else{while(node=++nodeIndex&&node&&node[dir]||(diff=nodeIndex=0)||start.pop()){if((ofType?node.nodeName.toLowerCase()===name$$1:node.nodeType===1)&&++diff){if(useCache){(node[expando]||(node[expando]={}))[type]=[dirruns,diff];}if(node===elem){break;}}}}diff-=last;return diff===first||diff%first===0&&diff/first>=0;}};},PSEUDO:function PSEUDO(pseudo,argument){var args,fn=Expr.pseudos[pseudo]||Expr.setFilters[pseudo.toLowerCase()]||Sizzle.error('unsupported pseudo: '+pseudo);if(fn[expando]){return fn(argument);}if(fn.length>1){args=[pseudo,pseudo,'',argument];return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())?markFunction(function(seed,matches){var idx,matched=fn(seed,argument),i=matched.length;while(i--){idx=indexOf$1.call(seed,matched[i]);seed[idx]=!(matches[idx]=matched[i]);}}):function(elem){return fn(elem,0,args);};}return fn;}},pseudos:{not:markFunction(function(selector){var input=[],results=[],matcher=compile(selector.replace(rtrim,'$1'));return matcher[expando]?markFunction(function(seed,matches,context,xml){var elem,unmatched=matcher(seed,null,xml,[]),i=seed.length;while(i--){if(elem=unmatched[i]){seed[i]=!(matches[i]=elem);}}}):function(elem,context,xml){input[0]=elem;matcher(input,null,xml,results);return!results.pop();};}),has:markFunction(function(selector){return function(elem){return Sizzle(selector,elem).length>0;};}),contains:markFunction(function(text){text=text.replace(runescape,funescape);return function(elem){return(elem.textContent||elem.innerText||getText(elem)).indexOf(text)>-1;};}),lang:markFunction(function(lang){if(!ridentifier.test(lang||'')){Sizzle.error('unsupported lang: '+lang);}lang=lang.replace(runescape,funescape).toLowerCase();return function(elem){var elemLang;do{if(elemLang=documentIsHTML?elem.lang:elem.getAttribute('xml:lang')||elem.getAttribute('lang')){elemLang=elemLang.toLowerCase();return elemLang===lang||elemLang.indexOf(lang+'-')===0;}}while((elem=elem.parentNode)&&elem.nodeType===1);return false;};}),target:function target(elem){var hash=window.location&&window.location.hash;return hash&&hash.slice(1)===elem.id;},root:function root(elem){return elem===docElem;},focus:function focus(elem){return elem===document$1.activeElement&&(!document$1.hasFocus||document$1.hasFocus())&&!!(elem.type||elem.href||~elem.tabIndex);},enabled:function enabled(elem){return elem.disabled===false;},disabled:function disabled(elem){return elem.disabled===true;},checked:function checked(elem){var nodeName=elem.nodeName.toLowerCase();return nodeName==='input'&&!!elem.checked||nodeName==='option'&&!!elem.selected;},selected:function selected(elem){if(elem.parentNode){elem.parentNode.selectedIndex;}return elem.selected===true;},empty:function empty(elem){for(elem=elem.firstChild;elem;elem=elem.nextSibling){if(elem.nodeType<6){return false;}}return true;},parent:function parent(elem){return!Expr.pseudos.empty(elem);},header:function header(elem){return rheader.test(elem.nodeName);},input:function input(elem){return rinputs.test(elem.nodeName);},button:function button(elem){var name$$1=elem.nodeName.toLowerCase();return name$$1==='input'&&elem.type==='button'||name$$1==='button';},text:function text(elem){var attr;return elem.nodeName.toLowerCase()==='input'&&elem.type==='text'&&((attr=elem.getAttribute('type'))==null||attr.toLowerCase()==='text');},first:createPositionalPseudo(function(){return[0];}),last:createPositionalPseudo(function(matchIndexes,length$$1){return[length$$1-1];}),eq:createPositionalPseudo(function(matchIndexes,length$$1,argument){return[argument<0?argument+length$$1:argument];}),even:createPositionalPseudo(function(matchIndexes,length$$1){var i=0;for(;i<length$$1;i+=2){matchIndexes.push(i);}return matchIndexes;}),odd:createPositionalPseudo(function(matchIndexes,length$$1){var i=1;for(;i<length$$1;i+=2){matchIndexes.push(i);}return matchIndexes;}),lt:createPositionalPseudo(function(matchIndexes,length$$1,argument){var i=argument<0?argument+length$$1:argument;for(;--i>=0;){matchIndexes.push(i);}return matchIndexes;}),gt:createPositionalPseudo(function(matchIndexes,length$$1,argument){var i=argument<0?argument+length$$1:argument;for(;++i<length$$1;){matchIndexes.push(i);}return matchIndexes;})}};Expr.pseudos.nth=Expr.pseudos.eq;for(i in{radio:true,checkbox:true,file:true,password:true,image:true}){Expr.pseudos[i]=createInputPseudo(i);}for(i in{submit:true,reset:true}){Expr.pseudos[i]=createButtonPseudo(i);}function setFilters(){}setFilters.prototype=Expr.filters=Expr.pseudos;Expr.setFilters=new setFilters();tokenize=Sizzle.tokenize=function(selector,parseOnly){var matched,match,tokens,type,soFar,groups,preFilters,cached=tokenCache[selector+' '];if(cached){return parseOnly?0:cached.slice(0);}soFar=selector;groups=[];preFilters=Expr.preFilter;while(soFar){if(!matched||(match=rcomma.exec(soFar))){if(match){soFar=soFar.slice(match[0].length)||soFar;}groups.push(tokens=[]);}matched=false;if(match=rcombinators.exec(soFar)){matched=match.shift();tokens.push({value:matched,type:match[0].replace(rtrim,' ')});soFar=soFar.slice(matched.length);}for(type in Expr.filter){if((match=matchExpr[type].exec(soFar))&&(!preFilters[type]||(match=preFilters[type](match)))){matched=match.shift();tokens.push({value:matched,type:type,matches:match});soFar=soFar.slice(matched.length);}}if(!matched){break;}}return parseOnly?soFar.length:soFar?Sizzle.error(selector):tokenCache(selector,groups).slice(0);};function toSelector(tokens){var i=0,len=tokens.length,selector='';for(;i<len;i++){selector+=tokens[i].value;}return selector;}function addCombinator(matcher,combinator,base){var dir=combinator.dir,checkNonElements=base&&dir==='parentNode',doneName=done++;return combinator.first?function(elem,context,xml){while(elem=elem[dir]){if(elem.nodeType===1||checkNonElements){return matcher(elem,context,xml);}}}:function(elem,context,xml){var oldCache,outerCache,newCache=[dirruns,doneName];if(xml){while(elem=elem[dir]){if(elem.nodeType===1||checkNonElements){if(matcher(elem,context,xml)){return true;}}}}else{while(elem=elem[dir]){if(elem.nodeType===1||checkNonElements){outerCache=elem[expando]||(elem[expando]={});if((oldCache=outerCache[dir])&&oldCache[0]===dirruns&&oldCache[1]===doneName){return newCache[2]=oldCache[2];}else{outerCache[dir]=newCache;if(newCache[2]=matcher(elem,context,xml)){return true;}}}}}};}function elementMatcher(matchers){return matchers.length>1?function(elem,context,xml){var i=matchers.length;while(i--){if(!matchers[i](elem,context,xml)){return false;}}return true;}:matchers[0];}function multipleContexts(selector,contexts,results){var i=0,len=contexts.length;for(;i<len;i++){Sizzle(selector,contexts[i],results);}return results;}function condense(unmatched,map,filter,context,xml){var elem,newUnmatched=[],i=0,len=unmatched.length,mapped=map!=null;for(;i<len;i++){if(elem=unmatched[i]){if(!filter||filter(elem,context,xml)){newUnmatched.push(elem);if(mapped){map.push(i);}}}}return newUnmatched;}function setMatcher(preFilter,selector,matcher,postFilter,postFinder,postSelector){if(postFilter&&!postFilter[expando]){postFilter=setMatcher(postFilter);}if(postFinder&&!postFinder[expando]){postFinder=setMatcher(postFinder,postSelector);}return markFunction(function(seed,results,context,xml){var temp,i,elem,preMap=[],postMap=[],preexisting=results.length,elems=seed||multipleContexts(selector||'*',context.nodeType?[context]:context,[]),matcherIn=preFilter&&(seed||!selector)?condense(elems,preMap,preFilter,context,xml):elems,matcherOut=matcher?postFinder||(seed?preFilter:preexisting||postFilter)?[]:results:matcherIn;if(matcher){matcher(matcherIn,matcherOut,context,xml);}if(postFilter){temp=condense(matcherOut,postMap);postFilter(temp,[],context,xml);i=temp.length;while(i--){if(elem=temp[i]){matcherOut[postMap[i]]=!(matcherIn[postMap[i]]=elem);}}}if(seed){if(postFinder||preFilter){if(postFinder){temp=[];i=matcherOut.length;while(i--){if(elem=matcherOut[i]){temp.push(matcherIn[i]=elem);}}postFinder(null,matcherOut=[],temp,xml);}i=matcherOut.length;while(i--){if((elem=matcherOut[i])&&(temp=postFinder?indexOf$1.call(seed,elem):preMap[i])>-1){seed[temp]=!(results[temp]=elem);}}}}else{matcherOut=condense(matcherOut===results?matcherOut.splice(preexisting,matcherOut.length):matcherOut);if(postFinder){postFinder(null,results,matcherOut,xml);}else{push$1.apply(results,matcherOut);}}});}function matcherFromTokens(tokens){var checkContext,matcher,j,len=tokens.length,leadingRelative=Expr.relative[tokens[0].type],implicitRelative=leadingRelative||Expr.relative[' '],i=leadingRelative?1:0,matchContext=addCombinator(function(elem){return elem===checkContext;},implicitRelative,true),matchAnyContext=addCombinator(function(elem){return indexOf$1.call(checkContext,elem)>-1;},implicitRelative,true),matchers=[function(elem,context,xml){return!leadingRelative&&(xml||context!==outermostContext)||((checkContext=context).nodeType?matchContext(elem,context,xml):matchAnyContext(elem,context,xml));}];for(;i<len;i++){if(matcher=Expr.relative[tokens[i].type]){matchers=[addCombinator(elementMatcher(matchers),matcher)];}else{matcher=Expr.filter[tokens[i].type].apply(null,tokens[i].matches);if(matcher[expando]){j=++i;for(;j<len;j++){if(Expr.relative[tokens[j].type]){break;}}return setMatcher(i>1&&elementMatcher(matchers),i>1&&toSelector(tokens.slice(0,i-1).concat({value:tokens[i-2].type===' '?'*':''})).replace(rtrim,'$1'),matcher,i<j&&matcherFromTokens(tokens.slice(i,j)),j<len&&matcherFromTokens(tokens=tokens.slice(j)),j<len&&toSelector(tokens));}matchers.push(matcher);}}return elementMatcher(matchers);}function matcherFromGroupMatchers(elementMatchers,setMatchers){var bySet=setMatchers.length>0,byElement=elementMatchers.length>0,superMatcher=function superMatcher(seed,context,xml,results,outermost){var elem,j,matcher,matchedCount=0,i='0',unmatched=seed&&[],setMatched=[],contextBackup=outermostContext,elems=seed||byElement&&Expr.find.TAG('*',outermost),dirrunsUnique=dirruns+=contextBackup==null?1:Math.random()||0.1,len=elems.length;if(outermost){outermostContext=context!==document$1&&context;}for(;i!==len&&(elem=elems[i])!=null;i++){if(byElement&&elem){j=0;while(matcher=elementMatchers[j++]){if(matcher(elem,context,xml)){results.push(elem);break;}}if(outermost){dirruns=dirrunsUnique;}}if(bySet){if(elem=!matcher&&elem){matchedCount--;}if(seed){unmatched.push(elem);}}}matchedCount+=i;if(bySet&&i!==matchedCount){j=0;while(matcher=setMatchers[j++]){matcher(unmatched,setMatched,context,xml);}if(seed){if(matchedCount>0){while(i--){if(!(unmatched[i]||setMatched[i])){setMatched[i]=pop.call(results);}}}setMatched=condense(setMatched);}push$1.apply(results,setMatched);if(outermost&&!seed&&setMatched.length>0&&matchedCount+setMatchers.length>1){Sizzle.uniqueSort(results);}}if(outermost){dirruns=dirrunsUnique;outermostContext=contextBackup;}return unmatched;};return bySet?markFunction(superMatcher):superMatcher;}compile=Sizzle.compile=function(selector,match){var i,setMatchers=[],elementMatchers=[],cached=compilerCache[selector+' '];if(!cached){if(!match){match=tokenize(selector);}i=match.length;while(i--){cached=matcherFromTokens(match[i]);if(cached[expando]){setMatchers.push(cached);}else{elementMatchers.push(cached);}}cached=compilerCache(selector,matcherFromGroupMatchers(elementMatchers,setMatchers));cached.selector=selector;}return cached;};select=Sizzle.select=function(selector,context,results,seed){var i,tokens,token,type,find,compiled=typeof selector==='function'&&selector,match=!seed&&tokenize(selector=compiled.selector||selector);results=results||[];if(match.length===1){tokens=match[0]=match[0].slice(0);if(tokens.length>2&&(token=tokens[0]).type==='ID'&&support.getById&&context.nodeType===9&&documentIsHTML&&Expr.relative[tokens[1].type]){context=(Expr.find.ID(token.matches[0].replace(runescape,funescape),context)||[])[0];if(!context){return results;}else if(compiled){context=context.parentNode;}selector=selector.slice(tokens.shift().value.length);}i=matchExpr.needsContext.test(selector)?0:tokens.length;while(i--){token=tokens[i];if(Expr.relative[type=token.type]){break;}if(find=Expr.find[type]){if(seed=find(token.matches[0].replace(runescape,funescape),rsibling.test(tokens[0].type)&&testContext(context.parentNode)||context)){tokens.splice(i,1);selector=seed.length&&toSelector(tokens);if(!selector){push$1.apply(results,seed);return results;}break;}}}}(compiled||compile(selector,match))(seed,context,!documentIsHTML,results,rsibling.test(selector)&&testContext(context.parentNode)||context);return results;};support.sortStable=expando.split('').sort(sortOrder).join('')===expando;support.detectDuplicates=!!hasDuplicate;setDocument();support.sortDetached=true;var isArray$1=Array.isArray;var toArray=function toArray(obj){var array=obj,i,l;if(!isArray$1(obj)){array=[];for(i=0,l=obj.length;i<l;i++){array[i]=obj[i];}}return array;};var each$1=function each$1(o,cb,s){var n,l;if(!o){return 0;}s=s||o;if(o.length!==undefined){for(n=0,l=o.length;n<l;n++){if(cb.call(s,o[n],n,o)===false){return 0;}}}else{for(n in o){if(o.hasOwnProperty(n)){if(cb.call(s,o[n],n,o)===false){return 0;}}}}return 1;};var map$1=function map$1(array,callback){var out=[];each$1(array,function(item,index){out.push(callback(item,index,array));});return out;};var filter$1=function filter$1(a,f){var o=[];each$1(a,function(v,index){if(!f||f(v,index,a)){o.push(v);}});return o;};var indexOf$2=function indexOf$2(a,v){var i,l;if(a){for(i=0,l=a.length;i<l;i++){if(a[i]===v){return i;}}}return-1;};var reduce=function reduce(collection,iteratee,accumulator,thisArg){var i=0;if(arguments.length<3){accumulator=collection[0];}for(;i<collection.length;i++){accumulator=iteratee.call(thisArg,accumulator,collection[i],i);}return accumulator;};var findIndex$1=function findIndex$1(array,predicate,thisArg){var i,l;for(i=0,l=array.length;i<l;i++){if(predicate.call(thisArg,array[i],i,array)){return i;}}return-1;};var find$1=function find$1(array,predicate,thisArg){var idx=findIndex$1(array,predicate,thisArg);if(idx!==-1){return array[idx];}return undefined;};var last$1=function last$1(collection){return collection[collection.length-1];};var $_98exydmjk26xeto={isArray:isArray$1,toArray:toArray,each:each$1,map:map$1,filter:filter$1,indexOf:indexOf$2,reduce:reduce,findIndex:findIndex$1,find:find$1,last:last$1};var whiteSpaceRegExp=/^\s*|\s*$/g;var trim=function trim(str){return str===null||str===undefined?'':(''+str).replace(whiteSpaceRegExp,'');};var is=function is(obj,type){if(!type){return obj!==undefined;}if(type==='array'&&$_98exydmjk26xeto.isArray(obj)){return true;}return(typeof obj==='undefined'?'undefined':_typeof(obj))===type;};var makeMap=function makeMap(items,delim,map){var i;items=items||[];delim=delim||',';if(typeof items==='string'){items=items.split(delim);}map=map||{};i=items.length;while(i--){map[items[i]]={};}return map;};var hasOwnProperty=function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);};var create=function create(s,p,root){var self$$1=this;var sp,ns,cn,scn,c,de=0;s=/^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);cn=s[3].match(/(^|\.)(\w+)$/i)[2];ns=self$$1.createNS(s[3].replace(/\.\w+$/,''),root);if(ns[cn]){return;}if(s[2]==='static'){ns[cn]=p;if(this.onCreate){this.onCreate(s[2],s[3],ns[cn]);}return;}if(!p[cn]){p[cn]=function(){};de=1;}ns[cn]=p[cn];self$$1.extend(ns[cn].prototype,p);if(s[5]){sp=self$$1.resolve(s[5]).prototype;scn=s[5].match(/\.(\w+)$/i)[1];c=ns[cn];if(de){ns[cn]=function(){return sp[scn].apply(this,arguments);};}else{ns[cn]=function(){this.parent=sp[scn];return c.apply(this,arguments);};}ns[cn].prototype[cn]=ns[cn];self$$1.each(sp,function(f,n){ns[cn].prototype[n]=sp[n];});self$$1.each(p,function(f,n){if(sp[n]){ns[cn].prototype[n]=function(){this.parent=sp[n];return f.apply(this,arguments);};}else{if(n!==cn){ns[cn].prototype[n]=f;}}});}self$$1.each(p.static,function(f,n){ns[cn][n]=f;});};var extend=function extend(obj,ext){var x=[];for(var _i=2;_i<arguments.length;_i++){x[_i-2]=arguments[_i];}var i,l,name$$1;var args=arguments;var value;for(i=1,l=args.length;i<l;i++){ext=args[i];for(name$$1 in ext){if(ext.hasOwnProperty(name$$1)){value=ext[name$$1];if(value!==undefined){obj[name$$1]=value;}}}}return obj;};var walk=function walk(o,f,n,s){s=s||this;if(o){if(n){o=o[n];}$_98exydmjk26xeto.each(o,function(o,i){if(f.call(s,o,i,n)===false){return false;}walk(o,f,n,s);});}};var createNS=function createNS(n,o){var i,v;o=o||window;n=n.split('.');for(i=0;i<n.length;i++){v=n[i];if(!o[v]){o[v]={};}o=o[v];}return o;};var resolve$1=function resolve$1(n,o){var i,l;o=o||window;n=n.split('.');for(i=0,l=n.length;i<l;i++){o=o[n[i]];if(!o){break;}}return o;};var explode=function explode(s,d){if(!s||is(s,'array')){return s;}return $_98exydmjk26xeto.map(s.split(d||','),trim);};var _addCacheSuffix=function _addCacheSuffix(url){var cacheSuffix=$_ef6mqpajk26xejm.cacheSuffix;if(cacheSuffix){url+=(url.indexOf('?')===-1?'?':'&')+cacheSuffix;}return url;};var $_2ytxahljk26xetf={trim:trim,isArray:$_98exydmjk26xeto.isArray,is:is,toArray:$_98exydmjk26xeto.toArray,makeMap:makeMap,each:$_98exydmjk26xeto.each,map:$_98exydmjk26xeto.map,grep:$_98exydmjk26xeto.filter,inArray:$_98exydmjk26xeto.indexOf,hasOwn:hasOwnProperty,extend:extend,create:create,walk:walk,createNS:createNS,resolve:resolve$1,explode:explode,_addCacheSuffix:_addCacheSuffix};var doc=document;var push$2=Array.prototype.push;var slice$2=Array.prototype.slice;var rquickExpr$1=/^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;var Event$$1=EventUtils.Event;var skipUniques=$_2ytxahljk26xetf.makeMap('children,contents,next,prev');var isDefined=function isDefined(obj){return typeof obj!=='undefined';};var isString$1=function isString$1(obj){return typeof obj==='string';};var isWindow=function isWindow(obj){return obj&&obj===obj.window;};var createFragment=function createFragment(html,fragDoc){var frag,node,container;fragDoc=fragDoc||doc;container=fragDoc.createElement('div');frag=fragDoc.createDocumentFragment();container.innerHTML=html;while(node=container.firstChild){frag.appendChild(node);}return frag;};var domManipulate=function domManipulate(targetNodes,sourceItem,callback,reverse){var i;if(isString$1(sourceItem)){sourceItem=createFragment(sourceItem,getElementDocument(targetNodes[0]));}else if(sourceItem.length&&!sourceItem.nodeType){sourceItem=DomQuery.makeArray(sourceItem);if(reverse){for(i=sourceItem.length-1;i>=0;i--){domManipulate(targetNodes,sourceItem[i],callback,reverse);}}else{for(i=0;i<sourceItem.length;i++){domManipulate(targetNodes,sourceItem[i],callback,reverse);}}return targetNodes;}if(sourceItem.nodeType){i=targetNodes.length;while(i--){callback.call(targetNodes[i],sourceItem);}}return targetNodes;};var _hasClass=function _hasClass(node,className){return node&&className&&(' '+node.className+' ').indexOf(' '+className+' ')!==-1;};var _wrap=function _wrap(elements,wrapper,all){var lastParent,newWrapper;wrapper=DomQuery(wrapper)[0];elements.each(function(){var self$$1=this;if(!all||lastParent!==self$$1.parentNode){lastParent=self$$1.parentNode;newWrapper=wrapper.cloneNode(false);self$$1.parentNode.insertBefore(newWrapper,self$$1);newWrapper.appendChild(self$$1);}else{newWrapper.appendChild(self$$1);}});return elements;};var numericCssMap=$_2ytxahljk26xetf.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom',' ');var booleanMap=$_2ytxahljk26xetf.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected',' ');var propFix={for:'htmlFor',class:'className',readonly:'readOnly'};var cssFix={float:'cssFloat'};var attrHooks={};var cssHooks={};var DomQuery=function DomQuery(selector,context){return new DomQuery.fn.init(selector,context);};var inArray=function inArray(item,array){var i;if(array.indexOf){return array.indexOf(item);}i=array.length;while(i--){if(array[i]===item){return i;}}return-1;};var whiteSpaceRegExp$1=/^\s*|\s*$/g;var trim$1=function trim$1(str){return str===null||str===undefined?'':(''+str).replace(whiteSpaceRegExp$1,'');};var each$2=function each$2(obj,callback){var length$$1,key,i,value;if(obj){length$$1=obj.length;if(length$$1===undefined){for(key in obj){if(obj.hasOwnProperty(key)){value=obj[key];if(callback.call(value,key,value)===false){break;}}}}else{for(i=0;i<length$$1;i++){value=obj[i];if(callback.call(value,i,value)===false){break;}}}}return obj;};var grep=function grep(array,callback){var out=[];each$2(array,function(i,item){if(callback(item,i)){out.push(item);}});return out;};var getElementDocument=function getElementDocument(element){if(!element){return doc;}if(element.nodeType===9){return element;}return element.ownerDocument;};DomQuery.fn=DomQuery.prototype={constructor:DomQuery,selector:'',context:null,length:0,init:function init(selector,context){var self$$1=this;var match,node;if(!selector){return self$$1;}if(selector.nodeType){self$$1.context=self$$1[0]=selector;self$$1.length=1;return self$$1;}if(context&&context.nodeType){self$$1.context=context;}else{if(context){return DomQuery(selector).attr(context);}self$$1.context=context=document;}if(isString$1(selector)){self$$1.selector=selector;if(selector.charAt(0)==='<'&&selector.charAt(selector.length-1)==='>'&&selector.length>=3){match=[null,selector,null];}else{match=rquickExpr$1.exec(selector);}if(match){if(match[1]){node=createFragment(selector,getElementDocument(context)).firstChild;while(node){push$2.call(self$$1,node);node=node.nextSibling;}}else{node=getElementDocument(context).getElementById(match[2]);if(!node){return self$$1;}if(node.id!==match[2]){return self$$1.find(selector);}self$$1.length=1;self$$1[0]=node;}}else{return DomQuery(context).find(selector);}}else{this.add(selector,false);}return self$$1;},toArray:function toArray(){return $_2ytxahljk26xetf.toArray(this);},add:function add(items,sort){var self$$1=this;var nodes,i;if(isString$1(items)){return self$$1.add(DomQuery(items));}if(sort!==false){nodes=DomQuery.unique(self$$1.toArray().concat(DomQuery.makeArray(items)));self$$1.length=nodes.length;for(i=0;i<nodes.length;i++){self$$1[i]=nodes[i];}}else{push$2.apply(self$$1,DomQuery.makeArray(items));}return self$$1;},attr:function attr(name$$1,value){var self$$1=this;var hook;if((typeof name$$1==='undefined'?'undefined':_typeof(name$$1))==='object'){each$2(name$$1,function(name$$1,value){self$$1.attr(name$$1,value);});}else if(isDefined(value)){this.each(function(){var hook;if(this.nodeType===1){hook=attrHooks[name$$1];if(hook&&hook.set){hook.set(this,value);return;}if(value===null){this.removeAttribute(name$$1,2);}else{this.setAttribute(name$$1,value,2);}}});}else{if(self$$1[0]&&self$$1[0].nodeType===1){hook=attrHooks[name$$1];if(hook&&hook.get){return hook.get(self$$1[0],name$$1);}if(booleanMap[name$$1]){return self$$1.prop(name$$1)?name$$1:undefined;}value=self$$1[0].getAttribute(name$$1,2);if(value===null){value=undefined;}}return value;}return self$$1;},removeAttr:function removeAttr(name$$1){return this.attr(name$$1,null);},prop:function prop(name$$1,value){var self$$1=this;name$$1=propFix[name$$1]||name$$1;if((typeof name$$1==='undefined'?'undefined':_typeof(name$$1))==='object'){each$2(name$$1,function(name$$1,value){self$$1.prop(name$$1,value);});}else if(isDefined(value)){this.each(function(){if(this.nodeType===1){this[name$$1]=value;}});}else{if(self$$1[0]&&self$$1[0].nodeType&&name$$1 in self$$1[0]){return self$$1[0][name$$1];}return value;}return self$$1;},css:function css(name$$1,value){var self$$1=this;var elm,hook;var camel=function camel(name$$1){return name$$1.replace(/-(\D)/g,function(a,b){return b.toUpperCase();});};var dashed=function dashed(name$$1){return name$$1.replace(/[A-Z]/g,function(a){return'-'+a;});};if((typeof name$$1==='undefined'?'undefined':_typeof(name$$1))==='object'){each$2(name$$1,function(name$$1,value){self$$1.css(name$$1,value);});}else{if(isDefined(value)){name$$1=camel(name$$1);if(typeof value==='number'&&!numericCssMap[name$$1]){value=value.toString()+'px';}self$$1.each(function(){var style=this.style;hook=cssHooks[name$$1];if(hook&&hook.set){hook.set(this,value);return;}try{this.style[cssFix[name$$1]||name$$1]=value;}catch(ex){}if(value===null||value===''){if(style.removeProperty){style.removeProperty(dashed(name$$1));}else{style.removeAttribute(name$$1);}}});}else{elm=self$$1[0];hook=cssHooks[name$$1];if(hook&&hook.get){return hook.get(elm);}if(elm.ownerDocument.defaultView){try{return elm.ownerDocument.defaultView.getComputedStyle(elm,null).getPropertyValue(dashed(name$$1));}catch(ex){return undefined;}}else if(elm.currentStyle){return elm.currentStyle[camel(name$$1)];}else{return'';}}}return self$$1;},remove:function remove(){var self$$1=this;var node,i=this.length;while(i--){node=self$$1[i];Event$$1.clean(node);if(node.parentNode){node.parentNode.removeChild(node);}}return this;},empty:function empty(){var self$$1=this;var node,i=this.length;while(i--){node=self$$1[i];while(node.firstChild){node.removeChild(node.firstChild);}}return this;},html:function html(value){var self$$1=this;var i;if(isDefined(value)){i=self$$1.length;try{while(i--){self$$1[i].innerHTML=value;}}catch(ex){DomQuery(self$$1[i]).empty().append(value);}return self$$1;}return self$$1[0]?self$$1[0].innerHTML:'';},text:function text(value){var self$$1=this;var i;if(isDefined(value)){i=self$$1.length;while(i--){if('innerText'in self$$1[i]){self$$1[i].innerText=value;}else{self$$1[0].textContent=value;}}return self$$1;}return self$$1[0]?self$$1[0].innerText||self$$1[0].textContent:'';},append:function append(){return domManipulate(this,arguments,function(node){if(this.nodeType===1||this.host&&this.host.nodeType===1){this.appendChild(node);}});},prepend:function prepend(){return domManipulate(this,arguments,function(node){if(this.nodeType===1||this.host&&this.host.nodeType===1){this.insertBefore(node,this.firstChild);}},true);},before:function before(){var self$$1=this;if(self$$1[0]&&self$$1[0].parentNode){return domManipulate(self$$1,arguments,function(node){this.parentNode.insertBefore(node,this);});}return self$$1;},after:function after(){var self$$1=this;if(self$$1[0]&&self$$1[0].parentNode){return domManipulate(self$$1,arguments,function(node){this.parentNode.insertBefore(node,this.nextSibling);},true);}return self$$1;},appendTo:function appendTo(val){DomQuery(val).append(this);return this;},prependTo:function prependTo(val){DomQuery(val).prepend(this);return this;},replaceWith:function replaceWith(content){return this.before(content).remove();},wrap:function wrap(content){return _wrap(this,content);},wrapAll:function wrapAll(content){return _wrap(this,content,true);},wrapInner:function wrapInner(content){this.each(function(){DomQuery(this).contents().wrapAll(content);});return this;},unwrap:function unwrap(){return this.parent().each(function(){DomQuery(this).replaceWith(this.childNodes);});},clone:function clone(){var result=[];this.each(function(){result.push(this.cloneNode(true));});return DomQuery(result);},addClass:function addClass(className){return this.toggleClass(className,true);},removeClass:function removeClass(className){return this.toggleClass(className,false);},toggleClass:function toggleClass(className,state){var self$$1=this;if(typeof className!=='string'){return self$$1;}if(className.indexOf(' ')!==-1){each$2(className.split(' '),function(){self$$1.toggleClass(this,state);});}else{self$$1.each(function(index,node){var existingClassName,classState;classState=_hasClass(node,className);if(classState!==state){existingClassName=node.className;if(classState){node.className=trim$1((' '+existingClassName+' ').replace(' '+className+' ',' '));}else{node.className+=existingClassName?' '+className:className;}}});}return self$$1;},hasClass:function hasClass(className){return _hasClass(this[0],className);},each:function each(callback){return each$2(this,callback);},on:function on(name$$1,callback){return this.each(function(){Event$$1.bind(this,name$$1,callback);});},off:function off(name$$1,callback){return this.each(function(){Event$$1.unbind(this,name$$1,callback);});},trigger:function trigger(name$$1){return this.each(function(){if((typeof name$$1==='undefined'?'undefined':_typeof(name$$1))==='object'){Event$$1.fire(this,name$$1.type,name$$1);}else{Event$$1.fire(this,name$$1);}});},show:function show(){return this.css('display','');},hide:function hide(){return this.css('display','none');},slice:function slice(){return new DomQuery(slice$2.apply(this,arguments));},eq:function eq(index){return index===-1?this.slice(index):this.slice(index,+index+1);},first:function first(){return this.eq(0);},last:function last(){return this.eq(-1);},find:function find(selector){var i,l;var ret=[];for(i=0,l=this.length;i<l;i++){DomQuery.find(selector,this[i],ret);}return DomQuery(ret);},filter:function filter(selector){if(typeof selector==='function'){return DomQuery(grep(this.toArray(),function(item,i){return selector(i,item);}));}return DomQuery(DomQuery.filter(selector,this.toArray()));},closest:function closest(selector){var result=[];if(selector instanceof DomQuery){selector=selector[0];}this.each(function(i,node){while(node){if(typeof selector==='string'&&DomQuery(node).is(selector)){result.push(node);break;}else if(node===selector){result.push(node);break;}node=node.parentNode;}});return DomQuery(result);},offset:function offset(_offset){var elm,doc,docElm;var x=0,y=0,pos;if(!_offset){elm=this[0];if(elm){doc=elm.ownerDocument;docElm=doc.documentElement;if(elm.getBoundingClientRect){pos=elm.getBoundingClientRect();x=pos.left+(docElm.scrollLeft||doc.body.scrollLeft)-docElm.clientLeft;y=pos.top+(docElm.scrollTop||doc.body.scrollTop)-docElm.clientTop;}}return{left:x,top:y};}return this.css(_offset);},push:push$2,sort:[].sort,splice:[].splice};$_2ytxahljk26xetf.extend(DomQuery,{extend:$_2ytxahljk26xetf.extend,makeArray:function makeArray(object){if(isWindow(object)||object.nodeType){return[object];}return $_2ytxahljk26xetf.toArray(object);},inArray:inArray,isArray:$_2ytxahljk26xetf.isArray,each:each$2,trim:trim$1,grep:grep,find:Sizzle,expr:Sizzle.selectors,unique:Sizzle.uniqueSort,text:Sizzle.getText,contains:Sizzle.contains,filter:function filter(expr,elems,not){var i=elems.length;if(not){expr=':not('+expr+')';}while(i--){if(elems[i].nodeType!==1){elems.splice(i,1);}}if(elems.length===1){elems=DomQuery.find.matchesSelector(elems[0],expr)?[elems[0]]:[];}else{elems=DomQuery.find.matches(expr,elems);}return elems;}});var dir=function dir(el,prop,until){var matched=[];var cur=el[prop];if(typeof until!=='string'&&until instanceof DomQuery){until=until[0];}while(cur&&cur.nodeType!==9){if(until!==undefined){if(cur===until){break;}if(typeof until==='string'&&DomQuery(cur).is(until)){break;}}if(cur.nodeType===1){matched.push(cur);}cur=cur[prop];}return matched;};var sibling=function sibling(node,siblingName,nodeType,until){var result=[];if(until instanceof DomQuery){until=until[0];}for(;node;node=node[siblingName]){if(nodeType&&node.nodeType!==nodeType){continue;}if(until!==undefined){if(node===until){break;}if(typeof until==='string'&&DomQuery(node).is(until)){break;}}result.push(node);}return result;};var firstSibling=function firstSibling(node,siblingName,nodeType){for(node=node[siblingName];node;node=node[siblingName]){if(node.nodeType===nodeType){return node;}}return null;};each$2({parent:function parent(node){var parent$$1=node.parentNode;return parent$$1&&parent$$1.nodeType!==11?parent$$1:null;},parents:function parents(node){return dir(node,'parentNode');},next:function next(node){return firstSibling(node,'nextSibling',1);},prev:function prev(node){return firstSibling(node,'previousSibling',1);},children:function children(node){return sibling(node.firstChild,'nextSibling',1);},contents:function contents(node){return $_2ytxahljk26xetf.toArray((node.nodeName==='iframe'?node.contentDocument||node.contentWindow.document:node).childNodes);}},function(name$$1,fn){DomQuery.fn[name$$1]=function(selector){var self$$1=this;var result=[];self$$1.each(function(){var nodes=fn.call(result,this,selector,result);if(nodes){if(DomQuery.isArray(nodes)){result.push.apply(result,nodes);}else{result.push(nodes);}}});if(this.length>1){if(!skipUniques[name$$1]){result=DomQuery.unique(result);}if(name$$1.indexOf('parents')===0){result=result.reverse();}}result=DomQuery(result);if(selector){return result.filter(selector);}return result;};});each$2({parentsUntil:function parentsUntil(node,until){return dir(node,'parentNode',until);},nextUntil:function nextUntil(node,until){return sibling(node,'nextSibling',1,until).slice(1);},prevUntil:function prevUntil(node,until){return sibling(node,'previousSibling',1,until).slice(1);}},function(name$$1,fn){DomQuery.fn[name$$1]=function(selector,filter){var self$$1=this;var result=[];self$$1.each(function(){var nodes=fn.call(result,this,selector,result);if(nodes){if(DomQuery.isArray(nodes)){result.push.apply(result,nodes);}else{result.push(nodes);}}});if(this.length>1){result=DomQuery.unique(result);if(name$$1.indexOf('parents')===0||name$$1==='prevUntil'){result=result.reverse();}}result=DomQuery(result);if(filter){return result.filter(filter);}return result;};});DomQuery.fn.is=function(selector){return!!selector&&this.filter(selector).length>0;};DomQuery.fn.init.prototype=DomQuery.fn;DomQuery.overrideDefaults=function(callback){var defaults;var sub=function sub(selector,context){defaults=defaults||callback();if(arguments.length===0){selector=defaults.element;}if(!context){context=defaults.context;}return new sub.fn.init(selector,context);};DomQuery.extend(sub,this);return sub;};var appendHooks=function appendHooks(targetHooks,prop,hooks){each$2(hooks,function(name$$1,func){targetHooks[name$$1]=targetHooks[name$$1]||{};targetHooks[name$$1][prop]=func;});};if($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<8){appendHooks(attrHooks,'get',{maxlength:function maxlength(elm){var value=elm.maxLength;if(value===2147483647){return undefined;}return value;},size:function size(elm){var value=elm.size;if(value===20){return undefined;}return value;},class:function _class(elm){return elm.className;},style:function style(elm){var value=elm.style.cssText;if(value.length===0){return undefined;}return value;}});appendHooks(attrHooks,'set',{class:function _class(elm,value){elm.className=value;},style:function style(elm,value){elm.style.cssText=value;}});}if($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<9){cssFix.float='styleFloat';appendHooks(cssHooks,'set',{opacity:function opacity(elm,value){var style=elm.style;if(value===null||value===''){style.removeAttribute('filter');}else{style.zoom=1;style.filter='alpha(opacity='+value*100+')';}}});}DomQuery.attrHooks=attrHooks;DomQuery.cssHooks=cssHooks;var cached=function cached(f){var called=false;var r;return function(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}if(!called){called=true;r=f.apply(null,args);}return r;};};var firstMatch=function firstMatch(regexes,s){for(var i=0;i<regexes.length;i++){var x=regexes[i];if(x.test(s))return x;}return undefined;};var find$2=function find$2(regexes,agent){var r=firstMatch(regexes,agent);if(!r)return{major:0,minor:0};var group=function group(i){return Number(agent.replace(r,'$'+i));};return nu(group(1),group(2));};var detect=function detect(versionRegexes,agent){var cleanedAgent=String(agent).toLowerCase();if(versionRegexes.length===0)return unknown();return find$2(versionRegexes,cleanedAgent);};var unknown=function unknown(){return nu(0,0);};var nu=function nu(major,minor){return{major:major,minor:minor};};var $_w39pysjk26xeur={nu:nu,detect:detect,unknown:unknown};var edge='Edge';var chrome='Chrome';var ie$1='IE';var opera$1='Opera';var firefox='Firefox';var safari='Safari';var isBrowser=function isBrowser(name,current){return function(){return current===name;};};var unknown$1=function unknown$1(){return nu$1({current:undefined,version:$_w39pysjk26xeur.unknown()});};var nu$1=function nu$1(info){var current=info.current;var version=info.version;return{current:current,version:version,isEdge:isBrowser(edge,current),isChrome:isBrowser(chrome,current),isIE:isBrowser(ie$1,current),isOpera:isBrowser(opera$1,current),isFirefox:isBrowser(firefox,current),isSafari:isBrowser(safari,current)};};var $_2glg4rrjk26xeul={unknown:unknown$1,nu:nu$1,edge:constant(edge),chrome:constant(chrome),ie:constant(ie$1),opera:constant(opera$1),firefox:constant(firefox),safari:constant(safari)};var windows='Windows';var ios='iOS';var android$1='Android';var linux='Linux';var osx='OSX';var solaris='Solaris';var freebsd='FreeBSD';var isOS=function isOS(name,current){return function(){return current===name;};};var unknown$2=function unknown$2(){return nu$2({current:undefined,version:$_w39pysjk26xeur.unknown()});};var nu$2=function nu$2(info){var current=info.current;var version=info.version;return{current:current,version:version,isWindows:isOS(windows,current),isiOS:isOS(ios,current),isAndroid:isOS(android$1,current),isOSX:isOS(osx,current),isLinux:isOS(linux,current),isSolaris:isOS(solaris,current),isFreeBSD:isOS(freebsd,current)};};var $_9ayuewtjk26xeut={unknown:unknown$2,nu:nu$2,windows:constant(windows),ios:constant(ios),android:constant(android$1),linux:constant(linux),osx:constant(osx),solaris:constant(solaris),freebsd:constant(freebsd)};function DeviceType(os,browser,userAgent){var isiPad=os.isiOS()&&/ipad/i.test(userAgent)===true;var isiPhone=os.isiOS()&&!isiPad;var isAndroid3=os.isAndroid()&&os.version.major===3;var isAndroid4=os.isAndroid()&&os.version.major===4;var isTablet=isiPad||isAndroid3||isAndroid4&&/mobile/i.test(userAgent)===true;var isTouch=os.isiOS()||os.isAndroid();var isPhone=isTouch&&!isTablet;var iOSwebview=browser.isSafari()&&os.isiOS()&&/safari/i.test(userAgent)===false;return{isiPad:constant(isiPad),isiPhone:constant(isiPhone),isTablet:constant(isTablet),isPhone:constant(isPhone),isTouch:constant(isTouch),isAndroid:os.isAndroid,isiOS:os.isiOS,isWebView:constant(iOSwebview)};}var detect$1=function detect$1(candidates,userAgent){var agent=String(userAgent).toLowerCase();return find(candidates,function(candidate){return candidate.search(agent);});};var detectBrowser=function detectBrowser(browsers,userAgent){return detect$1(browsers,userAgent).map(function(browser){var version=$_w39pysjk26xeur.detect(browser.versionRegexes,userAgent);return{current:browser.name,version:version};});};var detectOs=function detectOs(oses,userAgent){return detect$1(oses,userAgent).map(function(os){var version=$_w39pysjk26xeur.detect(os.versionRegexes,userAgent);return{current:os.name,version:version};});};var $_d5x6xzvjk26xev2={detectBrowser:detectBrowser,detectOs:detectOs};var contains$2=function contains$2(str,substr){return str.indexOf(substr)!==-1;};var trim$2=function trim$2(str){return str.replace(/^\s+|\s+$/g,'');};var normalVersionRegex=/.*?version\/\ ?([0-9]+)\.([0-9]+).*/;var checkContains=function checkContains(target){return function(uastring){return contains$2(uastring,target);};};var browsers=[{name:'Edge',versionRegexes:[/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],search:function search(uastring){var monstrosity=contains$2(uastring,'edge/')&&contains$2(uastring,'chrome')&&contains$2(uastring,'safari')&&contains$2(uastring,'applewebkit');return monstrosity;}},{name:'Chrome',versionRegexes:[/.*?chrome\/([0-9]+)\.([0-9]+).*/,normalVersionRegex],search:function search(uastring){return contains$2(uastring,'chrome')&&!contains$2(uastring,'chromeframe');}},{name:'IE',versionRegexes:[/.*?msie\ ?([0-9]+)\.([0-9]+).*/,/.*?rv:([0-9]+)\.([0-9]+).*/],search:function search(uastring){return contains$2(uastring,'msie')||contains$2(uastring,'trident');}},{name:'Opera',versionRegexes:[normalVersionRegex,/.*?opera\/([0-9]+)\.([0-9]+).*/],search:checkContains('opera')},{name:'Firefox',versionRegexes:[/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],search:checkContains('firefox')},{name:'Safari',versionRegexes:[normalVersionRegex,/.*?cpu os ([0-9]+)_([0-9]+).*/],search:function search(uastring){return(contains$2(uastring,'safari')||contains$2(uastring,'mobile/'))&&contains$2(uastring,'applewebkit');}}];var oses=[{name:'Windows',search:checkContains('win'),versionRegexes:[/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]},{name:'iOS',search:function search(uastring){return contains$2(uastring,'iphone')||contains$2(uastring,'ipad');},versionRegexes:[/.*?version\/\ ?([0-9]+)\.([0-9]+).*/,/.*cpu os ([0-9]+)_([0-9]+).*/,/.*cpu iphone os ([0-9]+)_([0-9]+).*/]},{name:'Android',search:checkContains('android'),versionRegexes:[/.*?android\ ?([0-9]+)\.([0-9]+).*/]},{name:'OSX',search:checkContains('os x'),versionRegexes:[/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]},{name:'Linux',search:checkContains('linux'),versionRegexes:[]},{name:'Solaris',search:checkContains('sunos'),versionRegexes:[]},{name:'FreeBSD',search:checkContains('freebsd'),versionRegexes:[]}];var $_5exwsxwjk26xev8={browsers:constant(browsers),oses:constant(oses)};var detect$2=function detect$2(userAgent){var browsers=$_5exwsxwjk26xev8.browsers();var oses=$_5exwsxwjk26xev8.oses();var browser=$_d5x6xzvjk26xev2.detectBrowser(browsers,userAgent).fold($_2glg4rrjk26xeul.unknown,$_2glg4rrjk26xeul.nu);var os=$_d5x6xzvjk26xev2.detectOs(oses,userAgent).fold($_9ayuewtjk26xeut.unknown,$_9ayuewtjk26xeut.nu);var deviceType=DeviceType(os,browser,userAgent);return{browser:browser,os:os,deviceType:deviceType};};var $_56gwmhqjk26xeuk={detect:detect$2};var detect$3=cached(function(){var userAgent=navigator.userAgent;return $_56gwmhqjk26xeuk.detect(userAgent);});var $_8x4ci6ojk26xeuf={detect:detect$3};var fromHtml=function fromHtml(html,scope){var doc=scope||document;var div=doc.createElement('div');div.innerHTML=html;if(!div.hasChildNodes()||div.childNodes.length>1){console.error('HTML does not have a single root node',html);throw'HTML must have a single root node';}return fromDom(div.childNodes[0]);};var fromTag=function fromTag(tag,scope){var doc=scope||document;var node=doc.createElement(tag);return fromDom(node);};var fromText=function fromText(text,scope){var doc=scope||document;var node=doc.createTextNode(text);return fromDom(node);};var fromDom=function fromDom(node){if(node===null||node===undefined)throw new Error('Node cannot be null or undefined');return{dom:constant(node)};};var fromPoint=function fromPoint(docElm,x,y){var doc=docElm.dom();return Option.from(doc.elementFromPoint(x,y)).map(fromDom);};var Element$$1={fromHtml:fromHtml,fromTag:fromTag,fromText:fromText,fromDom:fromDom,fromPoint:fromPoint};var $_feh6fu12jk26xevz={ATTRIBUTE:Node.ATTRIBUTE_NODE,CDATA_SECTION:Node.CDATA_SECTION_NODE,COMMENT:Node.COMMENT_NODE,DOCUMENT:Node.DOCUMENT_NODE,DOCUMENT_TYPE:Node.DOCUMENT_TYPE_NODE,DOCUMENT_FRAGMENT:Node.DOCUMENT_FRAGMENT_NODE,ELEMENT:Node.ELEMENT_NODE,TEXT:Node.TEXT_NODE,PROCESSING_INSTRUCTION:Node.PROCESSING_INSTRUCTION_NODE,ENTITY_REFERENCE:Node.ENTITY_REFERENCE_NODE,ENTITY:Node.ENTITY_NODE,NOTATION:Node.NOTATION_NODE};var name=function name(element){var r=element.dom().nodeName;return r.toLowerCase();};var type=function type(element){return element.dom().nodeType;};var value=function value(element){return element.dom().nodeValue;};var isType$1=function isType$1(t){return function(element){return type(element)===t;};};var isComment=function isComment(element){return type(element)===$_feh6fu12jk26xevz.COMMENT||name(element)==='#comment';};var isElement=isType$1($_feh6fu12jk26xevz.ELEMENT);var isText=isType$1($_feh6fu12jk26xevz.TEXT);var isDocument=isType$1($_feh6fu12jk26xevz.DOCUMENT);var $_cl4rr911jk26xevy={name:name,type:type,value:value,isElement:isElement,isText:isText,isDocument:isDocument,isComment:isComment};var keys=Object.keys;var each$3=function each$3(obj,f){var props=keys(obj);for(var k=0,len=props.length;k<len;k++){var i=props[k];var x=obj[i];f(x,i,obj);}};var map$2=function map$2(obj,f){return tupleMap(obj,function(x,i,obj){return{k:i,v:f(x,i,obj)};});};var tupleMap=function tupleMap(obj,f){var r={};each$3(obj,function(x,i){var tuple=f(x,i,obj);r[tuple.k]=tuple.v;});return r;};var bifilter=function bifilter(obj,pred){var t={};var f={};each$3(obj,function(x,i){var branch=pred(x,i)?t:f;branch[i]=x;});return{t:t,f:f};};var rawSet=function rawSet(dom,key,value){if(isString(value)||isBoolean(value)||isNumber(value)){dom.setAttribute(key,value+'');}else{console.error('Invalid call to Attr.set. Key ',key,':: Value ',value,':: Element ',dom);throw new Error('Attribute value was not simple');}};var set=function set(element,key,value){rawSet(element.dom(),key,value);};var setAll=function setAll(element,attrs){var dom=element.dom();each$3(attrs,function(v,k){rawSet(dom,k,v);});};var get=function get(element,key){var v=element.dom().getAttribute(key);return v===null?undefined:v;};var has=function has(element,key){var dom=element.dom();return dom&&dom.hasAttribute?dom.hasAttribute(key):false;};var remove=function remove(element,key){element.dom().removeAttribute(key);};var hasNone=function hasNone(element){var attrs=element.dom().attributes;return attrs===undefined||attrs===null||attrs.length===0;};var clone=function clone(element){return foldl(element.dom().attributes,function(acc,attr){acc[attr.name]=attr.value;return acc;},{});};var transferOne=function transferOne(source,destination,attr){if(has(source,attr)&&!has(destination,attr))set(destination,attr,get(source,attr));};var transfer=function transfer(source,destination,attrs){if(!$_cl4rr911jk26xevy.isElement(source)||!$_cl4rr911jk26xevy.isElement(destination))return;each(attrs,function(attr){transferOne(source,destination,attr);});};var $_5xapbx15jk26xewz={clone:clone,set:set,setAll:setAll,get:get,has:has,remove:remove,hasNone:hasNone,transfer:transfer};var inBody=function inBody(element){var dom=$_cl4rr911jk26xevy.isText(element)?element.dom().parentNode:element.dom();return dom!==undefined&&dom!==null&&dom.ownerDocument.body.contains(dom);};var body=cached(function(){return getBody(Element$$1.fromDom(document));});var getBody=function getBody(doc){var body=doc.dom().body;if(body===null||body===undefined)throw'Body is not available yet';return Element$$1.fromDom(body);};var $_2n2rdw16jk26xex9={body:body,getBody:getBody,inBody:inBody};var isSupported=function isSupported(dom){return dom.style!==undefined;};var $_g446d717jk26xexg={isSupported:isSupported};var internalSet=function internalSet(dom,property,value){if(!isString(value)){console.error('Invalid call to CSS.set. Property ',property,':: Value ',value,':: Element ',dom);throw new Error('CSS value must be a string: '+value);}if($_g446d717jk26xexg.isSupported(dom))dom.style.setProperty(property,value);};var internalRemove=function internalRemove(dom,property){if($_g446d717jk26xexg.isSupported(dom))dom.style.removeProperty(property);};var set$1=function set$1(element,property,value){var dom=element.dom();internalSet(dom,property,value);};var setAll$1=function setAll$1(element,css){var dom=element.dom();each$3(css,function(v,k){internalSet(dom,k,v);});};var setOptions=function setOptions(element,css){var dom=element.dom();each$3(css,function(v,k){v.fold(function(){internalRemove(dom,k);},function(value){internalSet(dom,k,value);});});};var get$1=function get$1(element,property){var dom=element.dom();var styles=window.getComputedStyle(dom);var r=styles.getPropertyValue(property);var v=r===''&&!$_2n2rdw16jk26xex9.inBody(element)?getUnsafeProperty(dom,property):r;return v===null?undefined:v;};var getUnsafeProperty=function getUnsafeProperty(dom,property){return $_g446d717jk26xexg.isSupported(dom)?dom.style.getPropertyValue(property):'';};var getRaw=function getRaw(element,property){var dom=element.dom();var raw=getUnsafeProperty(dom,property);return Option.from(raw).filter(function(r){return r.length>0;});};var getAllRaw=function getAllRaw(element){var css={};var dom=element.dom();if($_g446d717jk26xexg.isSupported(dom)){for(var i=0;i<dom.style.length;i++){var ruleName=dom.style.item(i);css[ruleName]=dom.style[ruleName];}}return css;};var isValidValue=function isValidValue(tag,property,value){var element=Element$$1.fromTag(tag);set$1(element,property,value);var style=getRaw(element,property);return style.isSome();};var remove$1=function remove$1(element,property){var dom=element.dom();internalRemove(dom,property);if($_5xapbx15jk26xewz.has(element,'style')&&trim$2($_5xapbx15jk26xewz.get(element,'style'))===''){$_5xapbx15jk26xewz.remove(element,'style');}};var preserve=function preserve(element,f){var oldStyles=$_5xapbx15jk26xewz.get(element,'style');var result=f(element);var restore=oldStyles===undefined?$_5xapbx15jk26xewz.remove:$_5xapbx15jk26xewz.set;restore(element,'style',oldStyles);return result;};var copy=function copy(source,target){var sourceDom=source.dom();var targetDom=target.dom();if($_g446d717jk26xexg.isSupported(sourceDom)&&$_g446d717jk26xexg.isSupported(targetDom)){targetDom.style.cssText=sourceDom.style.cssText;}};var reflow=function reflow(e){return e.dom().offsetWidth;};var transferOne$1=function transferOne$1(source,destination,style){getRaw(source,style).each(function(value){if(getRaw(destination,style).isNone())set$1(destination,style,value);});};var transfer$1=function transfer$1(source,destination,styles){if(!$_cl4rr911jk26xevy.isElement(source)||!$_cl4rr911jk26xevy.isElement(destination))return;each(styles,function(style){transferOne$1(source,destination,style);});};var $_15rddx13jk26xew4={copy:copy,set:set$1,preserve:preserve,setAll:setAll$1,setOptions:setOptions,remove:remove$1,get:get$1,getRaw:getRaw,getAllRaw:getAllRaw,isValidValue:isValidValue,reflow:reflow,transfer:transfer$1};var Immutable=function Immutable(){var fields=[];for(var _i=0;_i<arguments.length;_i++){fields[_i]=arguments[_i];}return function(){var values=[];for(var _i=0;_i<arguments.length;_i++){values[_i]=arguments[_i];}if(fields.length!==values.length){throw new Error('Wrong number of arguments to struct. Expected "['+fields.length+']", got '+values.length+' arguments');}var struct={};each(fields,function(name,i){struct[name]=constant(values[i]);});return struct;};};var toArray$1=function toArray$1(target,f){var r=[];var recurse=function recurse(e){r.push(e);return f(e);};var cur=f(target);do{cur=cur.bind(recurse);}while(cur.isSome());return r;};var $_el9thv1djk26xeyf={toArray:toArray$1};var node=function node(){var f=$_6d4d2bcjk26xeju.getOrDie('Node');return f;};var compareDocumentPosition=function compareDocumentPosition(a,b,match){return(a.compareDocumentPosition(b)&match)!==0;};var documentPositionPreceding=function documentPositionPreceding(a,b){return compareDocumentPosition(a,b,node().DOCUMENT_POSITION_PRECEDING);};var documentPositionContainedBy=function documentPositionContainedBy(a,b){return compareDocumentPosition(a,b,node().DOCUMENT_POSITION_CONTAINED_BY);};var $_2iex8p1fjk26xeyr={documentPositionPreceding:documentPositionPreceding,documentPositionContainedBy:documentPositionContainedBy};var ELEMENT=$_feh6fu12jk26xevz.ELEMENT;var DOCUMENT=$_feh6fu12jk26xevz.DOCUMENT;var is$1=function is$1(element,selector){var elem=element.dom();if(elem.nodeType!==ELEMENT)return false;else if(elem.matches!==undefined)return elem.matches(selector);else if(elem.msMatchesSelector!==undefined)return elem.msMatchesSelector(selector);else if(elem.webkitMatchesSelector!==undefined)return elem.webkitMatchesSelector(selector);else if(elem.mozMatchesSelector!==undefined)return elem.mozMatchesSelector(selector);else throw new Error('Browser lacks native selectors');};var bypassSelector=function bypassSelector(dom){return dom.nodeType!==ELEMENT&&dom.nodeType!==DOCUMENT||dom.childElementCount===0;};var all=function all(selector,scope){var base=scope===undefined?document:scope.dom();return bypassSelector(base)?[]:map(base.querySelectorAll(selector),Element$$1.fromDom);};var one=function one(selector,scope){var base=scope===undefined?document:scope.dom();return bypassSelector(base)?Option.none():Option.from(base.querySelector(selector)).map(Element$$1.fromDom);};var $_95wtq21gjk26xeyv={all:all,is:is$1,one:one};var eq=function eq(e1,e2){return e1.dom()===e2.dom();};var isEqualNode=function isEqualNode(e1,e2){return e1.dom().isEqualNode(e2.dom());};var member=function member(element,elements){return exists(elements,curry(eq,element));};var regularContains=function regularContains(e1,e2){var d1=e1.dom(),d2=e2.dom();return d1===d2?false:d1.contains(d2);};var ieContains=function ieContains(e1,e2){return $_2iex8p1fjk26xeyr.documentPositionContainedBy(e1.dom(),e2.dom());};var browser=$_8x4ci6ojk26xeuf.detect().browser;var contains$3=browser.isIE()?ieContains:regularContains;var $_dzedg81ejk26xeyh={eq:eq,isEqualNode:isEqualNode,member:member,contains:contains$3,is:$_95wtq21gjk26xeyv.is};var owner=function owner(element){return Element$$1.fromDom(element.dom().ownerDocument);};var documentElement=function documentElement(element){return Element$$1.fromDom(element.dom().ownerDocument.documentElement);};var defaultView=function defaultView(element){var el=element.dom();var defaultView=el.ownerDocument.defaultView;return Element$$1.fromDom(defaultView);};var parent=function parent(element){var dom=element.dom();return Option.from(dom.parentNode).map(Element$$1.fromDom);};var findIndex$2=function findIndex$2(element){return parent(element).bind(function(p){var kin=children(p);return findIndex(kin,function(elem){return $_dzedg81ejk26xeyh.eq(element,elem);});});};var parents=function parents(element,isRoot){var stop=isFunction(isRoot)?isRoot:constant(false);var dom=element.dom();var ret=[];while(dom.parentNode!==null&&dom.parentNode!==undefined){var rawParent=dom.parentNode;var parent=Element$$1.fromDom(rawParent);ret.push(parent);if(stop(parent)===true)break;else dom=rawParent;}return ret;};var siblings=function siblings(element){var filterSelf=function filterSelf(elements){return filter(elements,function(x){return!$_dzedg81ejk26xeyh.eq(element,x);});};return parent(element).map(children).map(filterSelf).getOr([]);};var offsetParent=function offsetParent(element){var dom=element.dom();return Option.from(dom.offsetParent).map(Element$$1.fromDom);};var prevSibling=function prevSibling(element){var dom=element.dom();return Option.from(dom.previousSibling).map(Element$$1.fromDom);};var nextSibling=function nextSibling(element){var dom=element.dom();return Option.from(dom.nextSibling).map(Element$$1.fromDom);};var prevSiblings=function prevSiblings(element){return reverse($_el9thv1djk26xeyf.toArray(element,prevSibling));};var nextSiblings=function nextSiblings(element){return $_el9thv1djk26xeyf.toArray(element,nextSibling);};var children=function children(element){var dom=element.dom();return map(dom.childNodes,Element$$1.fromDom);};var child=function child(element,index){var children=element.dom().childNodes;return Option.from(children[index]).map(Element$$1.fromDom);};var firstChild=function firstChild(element){return child(element,0);};var lastChild=function lastChild(element){return child(element,element.dom().childNodes.length-1);};var childNodesCount=function childNodesCount(element){return element.dom().childNodes.length;};var hasChildNodes=function hasChildNodes(element){return element.dom().hasChildNodes();};var spot=Immutable('element','offset');var leaf=function leaf(element,offset){var cs=children(element);return cs.length>0&&offset<cs.length?spot(cs[offset],0):spot(element,offset);};var $_2i1q6518jk26xexk={owner:owner,defaultView:defaultView,documentElement:documentElement,parent:parent,findIndex:findIndex$2,parents:parents,siblings:siblings,prevSibling:prevSibling,offsetParent:offsetParent,prevSiblings:prevSiblings,nextSibling:nextSibling,nextSiblings:nextSiblings,children:children,child:child,firstChild:firstChild,lastChild:lastChild,childNodesCount:childNodesCount,hasChildNodes:hasChildNodes,leaf:leaf};var browser$1=$_8x4ci6ojk26xeuf.detect().browser;var firstElement=function firstElement(nodes){return find(nodes,$_cl4rr911jk26xevy.isElement);};var getTableCaptionDeltaY=function getTableCaptionDeltaY(elm){if(browser$1.isFirefox()&&$_cl4rr911jk26xevy.name(elm)==='table'){return firstElement($_2i1q6518jk26xexk.children(elm)).filter(function(elm){return $_cl4rr911jk26xevy.name(elm)==='caption';}).bind(function(caption){return firstElement($_2i1q6518jk26xexk.nextSiblings(caption)).map(function(body){var bodyTop=body.dom().offsetTop;var captionTop=caption.dom().offsetTop;var captionHeight=caption.dom().offsetHeight;return bodyTop<=captionTop?-captionHeight:0;});}).getOr(0);}else{return 0;}};var getPos=function getPos(body,elm,rootElm){var x=0,y=0,offsetParent;var doc=body.ownerDocument;var pos;rootElm=rootElm?rootElm:body;if(elm){if(rootElm===body&&elm.getBoundingClientRect&&$_15rddx13jk26xew4.get(Element$$1.fromDom(body),'position')==='static'){pos=elm.getBoundingClientRect();x=pos.left+(doc.documentElement.scrollLeft||body.scrollLeft)-doc.documentElement.clientLeft;y=pos.top+(doc.documentElement.scrollTop||body.scrollTop)-doc.documentElement.clientTop;return{x:x,y:y};}offsetParent=elm;while(offsetParent&&offsetParent!==rootElm&&offsetParent.nodeType){x+=offsetParent.offsetLeft||0;y+=offsetParent.offsetTop||0;offsetParent=offsetParent.offsetParent;}offsetParent=elm.parentNode;while(offsetParent&&offsetParent!==rootElm&&offsetParent.nodeType){x-=offsetParent.scrollLeft||0;y-=offsetParent.scrollTop||0;offsetParent=offsetParent.parentNode;}y+=getTableCaptionDeltaY(Element$$1.fromDom(elm));}return{x:x,y:y};};var $_3kfxvvnjk26xetu={getPos:getPos};var nu$3=function nu$3(baseFn){var data=Option.none();var callbacks=[];var map$$1=function map$$1(f){return nu$3(function(nCallback){get(function(data){nCallback(f(data));});});};var get=function get(nCallback){if(isReady())call(nCallback);else callbacks.push(nCallback);};var set=function set(x){data=Option.some(x);run(callbacks);callbacks=[];};var isReady=function isReady(){return data.isSome();};var run=function run(cbs){each(cbs,call);};var call=function call(cb){data.each(function(x){setTimeout(function(){cb(x);},0);});};baseFn(set);return{get:get,map:map$$1,isReady:isReady};};var pure$1=function pure$1(a){return nu$3(function(callback){callback(a);});};var LazyValue={nu:nu$3,pure:pure$1};var bounce=function bounce(f){return function(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}var me=this;setTimeout(function(){f.apply(me,args);},0);};};var nu$4=function nu$4(baseFn){var get=function get(callback){baseFn(bounce(callback));};var map=function map(fab){return nu$4(function(callback){get(function(a){var value=fab(a);callback(value);});});};var bind=function bind(aFutureB){return nu$4(function(callback){get(function(a){aFutureB(a).get(callback);});});};var anonBind=function anonBind(futureB){return nu$4(function(callback){get(function(a){futureB.get(callback);});});};var toLazy=function toLazy(){return LazyValue.nu(get);};return{map:map,bind:bind,anonBind:anonBind,toLazy:toLazy,get:get};};var pure$2=function pure$2(a){return nu$4(function(callback){callback(a);});};var Future={nu:nu$4,pure:pure$2};var par=function par(asyncValues,nu){return nu(function(callback){var r=[];var count=0;var cb=function cb(i){return function(value){r[i]=value;count++;if(count>=asyncValues.length){callback(r);}};};if(asyncValues.length===0){callback([]);}else{each(asyncValues,function(asyncValue,i){asyncValue.get(cb(i));});}});};var par$1=function par$1(futures){return par(futures,Future.nu);};var value$1=function value$1(o){var is=function is(v){return o===v;};var or=function or(opt){return value$1(o);};var orThunk=function orThunk(f){return value$1(o);};var map=function map(f){return value$1(f(o));};var each=function each(f){f(o);};var bind=function bind(f){return f(o);};var fold=function fold(_,onValue){return onValue(o);};var exists=function exists(f){return f(o);};var forall=function forall(f){return f(o);};var toOption=function toOption(){return Option.some(o);};return{is:is,isValue:always,isError:never,getOr:constant(o),getOrThunk:constant(o),getOrDie:constant(o),or:or,orThunk:orThunk,fold:fold,map:map,each:each,bind:bind,exists:exists,forall:forall,toOption:toOption};};var error=function error(message){var getOrThunk=function getOrThunk(f){return f();};var getOrDie=function getOrDie(){return die(String(message))();};var or=function or(opt){return opt;};var orThunk=function orThunk(f){return f();};var map=function map(f){return error(message);};var bind=function bind(f){return error(message);};var fold=function fold(onError,_){return onError(message);};return{is:never,isValue:never,isError:always,getOr:identity,getOrThunk:getOrThunk,getOrDie:getOrDie,or:or,orThunk:orThunk,fold:fold,map:map,each:noop,bind:bind,exists:never,forall:always,toOption:Option.none};};var Result={value:value$1,error:error};function StyleSheetLoader(document$$1,settings){var idCount=0;var loadedStates={};var maxLoadTime;settings=settings||{};maxLoadTime=settings.maxLoadTime||5000;var appendToHead=function appendToHead(node){document$$1.getElementsByTagName('head')[0].appendChild(node);};var load=function load(url,loadedCallback,errorCallback){var link,style,startTime,state;var passed=function passed(){var callbacks=state.passed;var i=callbacks.length;while(i--){callbacks[i]();}state.status=2;state.passed=[];state.failed=[];};var failed=function failed(){var callbacks=state.failed;var i=callbacks.length;while(i--){callbacks[i]();}state.status=3;state.passed=[];state.failed=[];};var isOldWebKit=function isOldWebKit(){var webKitChunks=navigator.userAgent.match(/WebKit\/(\d*)/);return!!(webKitChunks&&parseInt(webKitChunks[1],10)<536);};var wait=function wait(testCallback,waitCallback){if(!testCallback()){if(new Date().getTime()-startTime<maxLoadTime){$_3a7ompijk26xer0.setTimeout(waitCallback);}else{failed();}}};var waitForWebKitLinkLoaded=function waitForWebKitLinkLoaded(){wait(function(){var styleSheets=document$$1.styleSheets;var styleSheet,i=styleSheets.length,owner;while(i--){styleSheet=styleSheets[i];owner=styleSheet.ownerNode?styleSheet.ownerNode:styleSheet.owningElement;if(owner&&owner.id===link.id){passed();return true;}}},waitForWebKitLinkLoaded);};var waitForGeckoLinkLoaded=function waitForGeckoLinkLoaded(){wait(function(){try{var cssRules=style.sheet.cssRules;passed();return!!cssRules;}catch(ex){}},waitForGeckoLinkLoaded);};url=$_2ytxahljk26xetf._addCacheSuffix(url);if(!loadedStates[url]){state={passed:[],failed:[]};loadedStates[url]=state;}else{state=loadedStates[url];}if(loadedCallback){state.passed.push(loadedCallback);}if(errorCallback){state.failed.push(errorCallback);}if(state.status===1){return;}if(state.status===2){passed();return;}if(state.status===3){failed();return;}state.status=1;link=document$$1.createElement('link');link.rel='stylesheet';link.type='text/css';link.id='u'+idCount++;link.async=false;link.defer=false;startTime=new Date().getTime();if('onload'in link&&!isOldWebKit()){link.onload=waitForWebKitLinkLoaded;link.onerror=failed;}else{if(navigator.userAgent.indexOf('Firefox')>0){style=document$$1.createElement('style');style.textContent='@import "'+url+'"';waitForGeckoLinkLoaded();appendToHead(style);return;}waitForWebKitLinkLoaded();}appendToHead(link);link.href=url;};var loadF=function loadF(url){return Future.nu(function(resolve){load(url,compose(resolve,constant(Result.value(url))),compose(resolve,constant(Result.error(url))));});};var unbox=function unbox(result){return result.fold(identity,identity);};var loadAll=function loadAll(urls,success,failure){par$1(map(urls,loadF)).get(function(result){var parts=partition(result,function(r){return r.isValue();});if(parts.fail.length>0){failure(parts.fail.map(unbox));}else{success(parts.pass.map(unbox));}});};return{load:load,loadAll:loadAll};}function TreeWalker(startNode,rootNode){var node=startNode;var findSibling=function findSibling(node,startName,siblingName,shallow){var sibling,parent;if(node){if(!shallow&&node[startName]){return node[startName];}if(node!==rootNode){sibling=node[siblingName];if(sibling){return sibling;}for(parent=node.parentNode;parent&&parent!==rootNode;parent=parent.parentNode){sibling=parent[siblingName];if(sibling){return sibling;}}}}};var findPreviousNode=function findPreviousNode(node,startName,siblingName,shallow){var sibling,parent,child;if(node){sibling=node[siblingName];if(rootNode&&sibling===rootNode){return;}if(sibling){if(!shallow){for(child=sibling[startName];child;child=child[startName]){if(!child[startName]){return child;}}}return sibling;}parent=node.parentNode;if(parent&&parent!==rootNode){return parent;}}};this.current=function(){return node;};this.next=function(shallow){node=findSibling(node,'firstChild','nextSibling',shallow);return node;};this.prev=function(shallow){node=findSibling(node,'lastChild','previousSibling',shallow);return node;};this.prev2=function(shallow){node=findPreviousNode(node,'lastChild','previousSibling',shallow);return node;};}var blocks=['article','aside','details','div','dt','figcaption','footer','form','fieldset','header','hgroup','html','main','nav','section','summary','body','p','dl','multicol','dd','figure','address','center','blockquote','h1','h2','h3','h4','h5','h6','listing','xmp','pre','plaintext','menu','dir','ul','ol','li','hr','table','tbody','thead','tfoot','th','tr','td','caption'];var voids=['area','base','basefont','br','col','frame','hr','img','input','isindex','link','meta','param','embed','source','wbr','track'];var tableCells=['td','th'];var tableSections=['thead','tbody','tfoot'];var textBlocks=['h1','h2','h3','h4','h5','h6','p','div','address','pre','form','blockquote','center','dir','fieldset','header','footer','article','section','hgroup','aside','nav','figure'];var headings=['h1','h2','h3','h4','h5','h6'];var listItems=['li','dd','dt'];var lists=['ul','ol','dl'];var wsElements=['pre','script','textarea','style'];var lazyLookup=function lazyLookup(items){var lookup;return function(node){lookup=lookup?lookup:mapToObject(items,constant(true));return lookup.hasOwnProperty($_cl4rr911jk26xevy.name(node));};};var isHeading=lazyLookup(headings);var isBlock=lazyLookup(blocks);var isInline=function isInline(node){return $_cl4rr911jk26xevy.isElement(node)&&!isBlock(node);};var isBr=function isBr(node){return $_cl4rr911jk26xevy.isElement(node)&&$_cl4rr911jk26xevy.name(node)==='br';};var isTextBlock=lazyLookup(textBlocks);var isList=lazyLookup(lists);var isListItem=lazyLookup(listItems);var isVoid=lazyLookup(voids);var isTableSection=lazyLookup(tableSections);var isTableCell=lazyLookup(tableCells);var isWsPreserveElement=lazyLookup(wsElements);var isNodeType=function isNodeType(type){return function(node){return!!node&&node.nodeType===type;};};var isElement$1=isNodeType(1);var matchNodeNames=function matchNodeNames(names){var items=names.toLowerCase().split(' ');return function(node){var i,name;if(node&&node.nodeType){name=node.nodeName.toLowerCase();for(i=0;i<items.length;i++){if(name===items[i]){return true;}}}return false;};};var matchStyleValues=function matchStyleValues(name,values){var items=values.toLowerCase().split(' ');return function(node){var i,cssValue;if(isElement$1(node)){for(i=0;i<items.length;i++){var computed=node.ownerDocument.defaultView.getComputedStyle(node,null);cssValue=computed?computed.getPropertyValue(name):null;if(cssValue===items[i]){return true;}}}return false;};};var hasPropValue=function hasPropValue(propName,propValue){return function(node){return isElement$1(node)&&node[propName]===propValue;};};var hasAttribute=function hasAttribute(attrName,attrValue){return function(node){return isElement$1(node)&&node.hasAttribute(attrName);};};var hasAttributeValue=function hasAttributeValue(attrName,attrValue){return function(node){return isElement$1(node)&&node.getAttribute(attrName)===attrValue;};};var isBogus=function isBogus(node){return isElement$1(node)&&node.hasAttribute('data-mce-bogus');};var isBogusAll=function isBogusAll(node){return isElement$1(node)&&node.getAttribute('data-mce-bogus')==='all';};var isTable=function isTable(node){return isElement$1(node)&&node.tagName==='TABLE';};var hasContentEditableState=function hasContentEditableState(value){return function(node){if(isElement$1(node)){if(node.contentEditable===value){return true;}if(node.getAttribute('data-mce-contenteditable')===value){return true;}}return false;};};var isText$1=isNodeType(3);var isComment$1=isNodeType(8);var isDocument$1=isNodeType(9);var isBr$1=matchNodeNames('br');var isContentEditableTrue=hasContentEditableState('true');var isContentEditableFalse=hasContentEditableState('false');var $_fpgwqg1rjk26xf0n={isText:isText$1,isElement:isElement$1,isComment:isComment$1,isDocument:isDocument$1,isBr:isBr$1,isContentEditableTrue:isContentEditableTrue,isContentEditableFalse:isContentEditableFalse,matchNodeNames:matchNodeNames,hasPropValue:hasPropValue,hasAttribute:hasAttribute,hasAttributeValue:hasAttributeValue,matchStyleValues:matchStyleValues,isBogus:isBogus,isBogusAll:isBogusAll,isTable:isTable};var surroundedBySpans=function surroundedBySpans(node){var previousIsSpan=node.previousSibling&&node.previousSibling.nodeName==='SPAN';var nextIsSpan=node.nextSibling&&node.nextSibling.nodeName==='SPAN';return previousIsSpan&&nextIsSpan;};var isBookmarkNode=function isBookmarkNode(node){return node&&node.tagName==='SPAN'&&node.getAttribute('data-mce-type')==='bookmark';};var trimNode=function trimNode(dom,node){var i,children=node.childNodes;if($_fpgwqg1rjk26xf0n.isElement(node)&&isBookmarkNode(node)){return;}for(i=children.length-1;i>=0;i--){trimNode(dom,children[i]);}if($_fpgwqg1rjk26xf0n.isDocument(node)===false){if($_fpgwqg1rjk26xf0n.isText(node)&&node.nodeValue.length>0){var trimmedLength=$_2ytxahljk26xetf.trim(node.nodeValue).length;if(dom.isBlock(node.parentNode)||trimmedLength>0){return;}if(trimmedLength===0&&surroundedBySpans(node)){return;}}else if($_fpgwqg1rjk26xf0n.isElement(node)){children=node.childNodes;if(children.length===1&&isBookmarkNode(children[0])){node.parentNode.insertBefore(children[0],node);}if(children.length||isVoid(Element$$1.fromDom(node))){return;}}dom.remove(node);}return node;};var $_fpnhg1pjk26xf07={trimNode:trimNode};var makeMap$1=$_2ytxahljk26xetf.makeMap;var namedEntities;var baseEntities;var reverseEntities;var attrsCharsRegExp=/[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;var textCharsRegExp=/[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;var rawCharsRegExp=/[<>&\"\']/g;var entityRegExp=/&#([a-z0-9]+);?|&([a-z0-9]+);/gi;var asciiMap={128:'\u20AC',130:'\u201A',131:'\u0192',132:'\u201E',133:'\u2026',134:'\u2020',135:'\u2021',136:'\u02C6',137:'\u2030',138:'\u0160',139:'\u2039',140:'\u0152',142:'\u017D',145:'\u2018',146:'\u2019',147:'\u201C',148:'\u201D',149:'\u2022',150:'\u2013',151:'\u2014',152:'\u02DC',153:'\u2122',154:'\u0161',155:'\u203A',156:'\u0153',158:'\u017E',159:'\u0178'};baseEntities={'"':'&quot;','\'':'&#39;','<':'&lt;','>':'&gt;','&':'&amp;','`':'&#96;'};reverseEntities={'&lt;':'<','&gt;':'>','&amp;':'&','&quot;':'"','&apos;':'\''};var nativeDecode=function nativeDecode(text){var elm;elm=Element$$1.fromTag('div').dom();elm.innerHTML=text;return elm.textContent||elm.innerText||text;};var buildEntitiesLookup=function buildEntitiesLookup(items,radix){var i,chr,entity;var lookup={};if(items){items=items.split(',');radix=radix||10;for(i=0;i<items.length;i+=2){chr=String.fromCharCode(parseInt(items[i],radix));if(!baseEntities[chr]){entity='&'+items[i+1]+';';lookup[chr]=entity;lookup[entity]=chr;}}return lookup;}};namedEntities=buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,'+'5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,'+'5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,'+'5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,'+'68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,'+'6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,'+'6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,'+'75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,'+'7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,'+'7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,'+'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,'+'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,'+'t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,'+'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,'+'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,'+'81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,'+'8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,'+'8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,'+'8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,'+'8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,'+'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,'+'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,'+'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,'+'80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,'+'811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro',32);var encodeRaw=function encodeRaw(text,attr){return text.replace(attr?attrsCharsRegExp:textCharsRegExp,function(chr){return baseEntities[chr]||chr;});};var encodeAllRaw=function encodeAllRaw(text){return(''+text).replace(rawCharsRegExp,function(chr){return baseEntities[chr]||chr;});};var encodeNumeric=function encodeNumeric(text,attr){return text.replace(attr?attrsCharsRegExp:textCharsRegExp,function(chr){if(chr.length>1){return'&#'+((chr.charCodeAt(0)-55296)*1024+(chr.charCodeAt(1)-56320)+65536)+';';}return baseEntities[chr]||'&#'+chr.charCodeAt(0)+';';});};var encodeNamed=function encodeNamed(text,attr,entities){entities=entities||namedEntities;return text.replace(attr?attrsCharsRegExp:textCharsRegExp,function(chr){return baseEntities[chr]||entities[chr]||chr;});};var getEncodeFunc=function getEncodeFunc(name,entities){var entitiesMap=buildEntitiesLookup(entities)||namedEntities;var encodeNamedAndNumeric=function encodeNamedAndNumeric(text,attr){return text.replace(attr?attrsCharsRegExp:textCharsRegExp,function(chr){if(baseEntities[chr]!==undefined){return baseEntities[chr];}if(entitiesMap[chr]!==undefined){return entitiesMap[chr];}if(chr.length>1){return'&#'+((chr.charCodeAt(0)-55296)*1024+(chr.charCodeAt(1)-56320)+65536)+';';}return'&#'+chr.charCodeAt(0)+';';});};var encodeCustomNamed=function encodeCustomNamed(text,attr){return encodeNamed(text,attr,entitiesMap);};var nameMap=makeMap$1(name.replace(/\+/g,','));if(nameMap.named&&nameMap.numeric){return encodeNamedAndNumeric;}if(nameMap.named){if(entities){return encodeCustomNamed;}return encodeNamed;}if(nameMap.numeric){return encodeNumeric;}return encodeRaw;};var decode=function decode(text){return text.replace(entityRegExp,function(all,numeric){if(numeric){if(numeric.charAt(0).toLowerCase()==='x'){numeric=parseInt(numeric.substr(1),16);}else{numeric=parseInt(numeric,10);}if(numeric>65535){numeric-=65536;return String.fromCharCode(55296+(numeric>>10),56320+(numeric&1023));}return asciiMap[numeric]||String.fromCharCode(numeric);}return reverseEntities[all]||namedEntities[all]||nativeDecode(all);});};var $_8udjtn1sjk26xf0t={encodeRaw:encodeRaw,encodeAllRaw:encodeAllRaw,encodeNumeric:encodeNumeric,encodeNamed:encodeNamed,getEncodeFunc:getEncodeFunc,decode:decode};var mapCache={};var dummyObj={};var makeMap$2=$_2ytxahljk26xetf.makeMap;var each$4=$_2ytxahljk26xetf.each;var extend$1=$_2ytxahljk26xetf.extend;var explode$1=$_2ytxahljk26xetf.explode;var inArray$1=$_2ytxahljk26xetf.inArray;var split=function split(items,delim){items=$_2ytxahljk26xetf.trim(items);return items?items.split(delim||' '):[];};var compileSchema=function compileSchema(type){var schema={};var globalAttributes,blockContent;var phrasingContent,flowContent,html4BlockContent,html4PhrasingContent;var add=function add(name,attributes,children){var ni,attributesOrder,element;var arrayToMap=function arrayToMap(array,obj){var map={};var i,l;for(i=0,l=array.length;i<l;i++){map[array[i]]=obj||{};}return map;};children=children||[];attributes=attributes||'';if(typeof children==='string'){children=split(children);}name=split(name);ni=name.length;while(ni--){attributesOrder=split([globalAttributes,attributes].join(' '));element={attributes:arrayToMap(attributesOrder),attributesOrder:attributesOrder,children:arrayToMap(children,dummyObj)};schema[name[ni]]=element;}};var addAttrs=function addAttrs(name,attributes){var ni,schemaItem,i,l;name=split(name);ni=name.length;attributes=split(attributes);while(ni--){schemaItem=schema[name[ni]];for(i=0,l=attributes.length;i<l;i++){schemaItem.attributes[attributes[i]]={};schemaItem.attributesOrder.push(attributes[i]);}}};if(mapCache[type]){return mapCache[type];}globalAttributes='id accesskey class dir lang style tabindex title role';blockContent='address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';phrasingContent='a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd '+'label map noscript object q s samp script select small span strong sub sup '+'textarea u var #text #comment';if(type!=='html4'){globalAttributes+=' contenteditable contextmenu draggable dropzone '+'hidden spellcheck translate';blockContent+=' article aside details dialog figure header footer hgroup section nav';phrasingContent+=' audio canvas command datalist mark meter output picture '+'progress time wbr video ruby bdi keygen';}if(type!=='html5-strict'){globalAttributes+=' xml:lang';html4PhrasingContent='acronym applet basefont big font strike tt';phrasingContent=[phrasingContent,html4PhrasingContent].join(' ');each$4(split(html4PhrasingContent),function(name){add(name,'',phrasingContent);});html4BlockContent='center dir isindex noframes';blockContent=[blockContent,html4BlockContent].join(' ');flowContent=[blockContent,phrasingContent].join(' ');each$4(split(html4BlockContent),function(name){add(name,'',flowContent);});}flowContent=flowContent||[blockContent,phrasingContent].join(' ');add('html','manifest','head body');add('head','','base command link meta noscript script style title');add('title hr noscript br');add('base','href target');add('link','href rel media hreflang type sizes hreflang');add('meta','name http-equiv content charset');add('style','media type scoped');add('script','src async defer type charset');add('body','onafterprint onbeforeprint onbeforeunload onblur onerror onfocus '+'onhashchange onload onmessage onoffline ononline onpagehide onpageshow '+'onpopstate onresize onscroll onstorage onunload',flowContent);add('address dt dd div caption','',flowContent);add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn','',phrasingContent);add('blockquote','cite',flowContent);add('ol','reversed start type','li');add('ul','','li');add('li','value',flowContent);add('dl','','dt dd');add('a','href target rel media hreflang type',phrasingContent);add('q','cite',phrasingContent);add('ins del','cite datetime',flowContent);add('img','src sizes srcset alt usemap ismap width height');add('iframe','src name width height',flowContent);add('embed','src type width height');add('object','data type typemustmatch name usemap form width height',[flowContent,'param'].join(' '));add('param','name value');add('map','name',[flowContent,'area'].join(' '));add('area','alt coords shape href target rel media hreflang type');add('table','border','caption colgroup thead tfoot tbody tr'+(type==='html4'?' col':''));add('colgroup','span','col');add('col','span');add('tbody thead tfoot','','tr');add('tr','','td th');add('td','colspan rowspan headers',flowContent);add('th','colspan rowspan headers scope abbr',flowContent);add('form','accept-charset action autocomplete enctype method name novalidate target',flowContent);add('fieldset','disabled form name',[flowContent,'legend'].join(' '));add('label','form for',phrasingContent);add('input','accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate '+'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');add('button','disabled form formaction formenctype formmethod formnovalidate formtarget name type value',type==='html4'?flowContent:phrasingContent);add('select','disabled form multiple name required size','option optgroup');add('optgroup','disabled label','option');add('option','disabled label selected value');add('textarea','cols dirname disabled form maxlength name readonly required rows wrap');add('menu','type label',[flowContent,'li'].join(' '));add('noscript','',flowContent);if(type!=='html4'){add('wbr');add('ruby','',[phrasingContent,'rt rp'].join(' '));add('figcaption','',flowContent);add('mark rt rp summary bdi','',phrasingContent);add('canvas','width height',flowContent);add('video','src crossorigin poster preload autoplay mediagroup loop '+'muted controls width height buffered',[flowContent,'track source'].join(' '));add('audio','src crossorigin preload autoplay mediagroup loop muted controls '+'buffered volume',[flowContent,'track source'].join(' '));add('picture','','img source');add('source','src srcset type media sizes');add('track','kind src srclang label default');add('datalist','',[phrasingContent,'option'].join(' '));add('article section nav aside header footer','',flowContent);add('hgroup','','h1 h2 h3 h4 h5 h6');add('figure','',[flowContent,'figcaption'].join(' '));add('time','datetime',phrasingContent);add('dialog','open',flowContent);add('command','type label icon disabled checked radiogroup command');add('output','for form name',phrasingContent);add('progress','value max',phrasingContent);add('meter','value min max low high optimum',phrasingContent);add('details','open',[flowContent,'summary'].join(' '));add('keygen','autofocus challenge disabled form keytype name');}if(type!=='html5-strict'){addAttrs('script','language xml:space');addAttrs('style','xml:space');addAttrs('object','declare classid code codebase codetype archive standby align border hspace vspace');addAttrs('embed','align name hspace vspace');addAttrs('param','valuetype type');addAttrs('a','charset name rev shape coords');addAttrs('br','clear');addAttrs('applet','codebase archive code object alt name width height align hspace vspace');addAttrs('img','name longdesc align border hspace vspace');addAttrs('iframe','longdesc frameborder marginwidth marginheight scrolling align');addAttrs('font basefont','size color face');addAttrs('input','usemap align');addAttrs('select','onchange');addAttrs('textarea');addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption','align');addAttrs('ul','type compact');addAttrs('li','type');addAttrs('ol dl menu dir','compact');addAttrs('pre','width xml:space');addAttrs('hr','align noshade size width');addAttrs('isindex','prompt');addAttrs('table','summary width frame rules cellspacing cellpadding align bgcolor');addAttrs('col','width align char charoff valign');addAttrs('colgroup','width align char charoff valign');addAttrs('thead','align char charoff valign');addAttrs('tr','align char charoff valign bgcolor');addAttrs('th','axis align char charoff valign nowrap bgcolor width height');addAttrs('form','accept');addAttrs('td','abbr axis scope align char charoff valign nowrap bgcolor width height');addAttrs('tfoot','align char charoff valign');addAttrs('tbody','align char charoff valign');addAttrs('area','nohref');addAttrs('body','background bgcolor text link vlink alink');}if(type!=='html4'){addAttrs('input button select textarea','autofocus');addAttrs('input textarea','placeholder');addAttrs('a','download');addAttrs('link script img','crossorigin');addAttrs('iframe','sandbox seamless allowfullscreen');}each$4(split('a form meter progress dfn'),function(name){if(schema[name]){delete schema[name].children[name];}});delete schema.caption.children.table;delete schema.script;mapCache[type]=schema;return schema;};var compileElementMap=function compileElementMap(value,mode){var styles;if(value){styles={};if(typeof value==='string'){value={'*':value};}each$4(value,function(value,key){styles[key]=styles[key.toUpperCase()]=mode==='map'?makeMap$2(value,/[, ]/):explode$1(value,/[, ]/);});}return styles;};function Schema(settings){var elements={};var children={};var patternElements=[];var validStyles;var invalidStyles;var schemaItems;var whiteSpaceElementsMap,selfClosingElementsMap,shortEndedElementsMap,boolAttrMap,validClasses;var blockElementsMap,nonEmptyElementsMap,moveCaretBeforeOnEnterElementsMap,textBlockElementsMap,textInlineElementsMap;var customElementsMap={},specialElements={};var createLookupTable=function createLookupTable(option,defaultValue,extendWith){var value=settings[option];if(!value){value=mapCache[option];if(!value){value=makeMap$2(defaultValue,' ',makeMap$2(defaultValue.toUpperCase(),' '));value=extend$1(value,extendWith);mapCache[option]=value;}}else{value=makeMap$2(value,/[, ]/,makeMap$2(value.toUpperCase(),/[, ]/));}return value;};settings=settings||{};schemaItems=compileSchema(settings.schema);if(settings.verify_html===false){settings.valid_elements='*[*]';}validStyles=compileElementMap(settings.valid_styles);invalidStyles=compileElementMap(settings.invalid_styles,'map');validClasses=compileElementMap(settings.valid_classes,'map');whiteSpaceElementsMap=createLookupTable('whitespace_elements','pre script noscript style textarea video audio iframe object code');selfClosingElementsMap=createLookupTable('self_closing_elements','colgroup dd dt li option p td tfoot th thead tr');shortEndedElementsMap=createLookupTable('short_ended_elements','area base basefont br col frame hr img input isindex link '+'meta param embed source wbr track');boolAttrMap=createLookupTable('boolean_attributes','checked compact declare defer disabled ismap multiple nohref noresize '+'noshade nowrap readonly selected autoplay loop controls');nonEmptyElementsMap=createLookupTable('non_empty_elements','td th iframe video audio object '+'script pre code',shortEndedElementsMap);moveCaretBeforeOnEnterElementsMap=createLookupTable('move_caret_before_on_enter_elements','table',nonEmptyElementsMap);textBlockElementsMap=createLookupTable('text_block_elements','h1 h2 h3 h4 h5 h6 p div address pre form '+'blockquote center dir fieldset header footer article section hgroup aside nav figure');blockElementsMap=createLookupTable('block_elements','hr table tbody thead tfoot '+'th tr td li ol ul caption dl dt dd noscript menu isindex option '+'datalist select optgroup figcaption details summary',textBlockElementsMap);textInlineElementsMap=createLookupTable('text_inline_elements','span strong b em i font strike u var cite '+'dfn code mark q sup sub samp');each$4((settings.special||'script noscript noframes noembed title style textarea xmp').split(' '),function(name){specialElements[name]=new RegExp('</'+name+'[^>]*>','gi');});var patternToRegExp=function patternToRegExp(str){return new RegExp('^'+str.replace(/([?+*])/g,'.$1')+'$');};var addValidElements=function addValidElements(validElements){var ei,el,ai,al,matches,element,attr,attrData,elementName,attrName,attrType,attributes,attributesOrder,prefix,outputName,globalAttributes,globalAttributesOrder,key,value;var elementRuleRegExp=/^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/,attrRuleRegExp=/^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/,hasPatternsRegExp=/[*?+]/;if(validElements){validElements=split(validElements,',');if(elements['@']){globalAttributes=elements['@'].attributes;globalAttributesOrder=elements['@'].attributesOrder;}for(ei=0,el=validElements.length;ei<el;ei++){matches=elementRuleRegExp.exec(validElements[ei]);if(matches){prefix=matches[1];elementName=matches[2];outputName=matches[3];attrData=matches[5];attributes={};attributesOrder=[];element={attributes:attributes,attributesOrder:attributesOrder};if(prefix==='#'){element.paddEmpty=true;}if(prefix==='-'){element.removeEmpty=true;}if(matches[4]==='!'){element.removeEmptyAttrs=true;}if(globalAttributes){for(key in globalAttributes){attributes[key]=globalAttributes[key];}attributesOrder.push.apply(attributesOrder,globalAttributesOrder);}if(attrData){attrData=split(attrData,'|');for(ai=0,al=attrData.length;ai<al;ai++){matches=attrRuleRegExp.exec(attrData[ai]);if(matches){attr={};attrType=matches[1];attrName=matches[2].replace(/[\\:]:/g,':');prefix=matches[3];value=matches[4];if(attrType==='!'){element.attributesRequired=element.attributesRequired||[];element.attributesRequired.push(attrName);attr.required=true;}if(attrType==='-'){delete attributes[attrName];attributesOrder.splice(inArray$1(attributesOrder,attrName),1);continue;}if(prefix){if(prefix==='='){element.attributesDefault=element.attributesDefault||[];element.attributesDefault.push({name:attrName,value:value});attr.defaultValue=value;}if(prefix===':'){element.attributesForced=element.attributesForced||[];element.attributesForced.push({name:attrName,value:value});attr.forcedValue=value;}if(prefix==='<'){attr.validValues=makeMap$2(value,'?');}}if(hasPatternsRegExp.test(attrName)){element.attributePatterns=element.attributePatterns||[];attr.pattern=patternToRegExp(attrName);element.attributePatterns.push(attr);}else{if(!attributes[attrName]){attributesOrder.push(attrName);}attributes[attrName]=attr;}}}}if(!globalAttributes&&elementName==='@'){globalAttributes=attributes;globalAttributesOrder=attributesOrder;}if(outputName){element.outputName=elementName;elements[outputName]=element;}if(hasPatternsRegExp.test(elementName)){element.pattern=patternToRegExp(elementName);patternElements.push(element);}else{elements[elementName]=element;}}}}};var setValidElements=function setValidElements(validElements){elements={};patternElements=[];addValidElements(validElements);each$4(schemaItems,function(element,name){children[name]=element.children;});};var addCustomElements=function addCustomElements(customElements){var customElementRegExp=/^(~)?(.+)$/;if(customElements){mapCache.text_block_elements=mapCache.block_elements=null;each$4(split(customElements,','),function(rule){var matches=customElementRegExp.exec(rule),inline=matches[1]==='~',cloneName=inline?'span':'div',name=matches[2];children[name]=children[cloneName];customElementsMap[name]=cloneName;if(!inline){blockElementsMap[name.toUpperCase()]={};blockElementsMap[name]={};}if(!elements[name]){var customRule=elements[cloneName];customRule=extend$1({},customRule);delete customRule.removeEmptyAttrs;delete customRule.removeEmpty;elements[name]=customRule;}each$4(children,function(element,elmName){if(element[cloneName]){children[elmName]=element=extend$1({},children[elmName]);element[name]=element[cloneName];}});});}};var addValidChildren=function addValidChildren(validChildren){var childRuleRegExp=/^([+\-]?)(\w+)\[([^\]]+)\]$/;mapCache[settings.schema]=null;if(validChildren){each$4(split(validChildren,','),function(rule){var matches=childRuleRegExp.exec(rule);var parent,prefix;if(matches){prefix=matches[1];if(prefix){parent=children[matches[2]];}else{parent=children[matches[2]]={'#comment':{}};}parent=children[matches[2]];each$4(split(matches[3],'|'),function(child){if(prefix==='-'){delete parent[child];}else{parent[child]={};}});}});}};var getElementRule=function getElementRule(name){var element=elements[name],i;if(element){return element;}i=patternElements.length;while(i--){element=patternElements[i];if(element.pattern.test(name)){return element;}}};if(!settings.valid_elements){each$4(schemaItems,function(element,name){elements[name]={attributes:element.attributes,attributesOrder:element.attributesOrder};children[name]=element.children;});if(settings.schema!=='html5'){each$4(split('strong/b em/i'),function(item){item=split(item,'/');elements[item[1]].outputName=item[0];});}each$4(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'),function(name){if(elements[name]){elements[name].removeEmpty=true;}});each$4(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'),function(name){elements[name].paddEmpty=true;});each$4(split('span'),function(name){elements[name].removeEmptyAttrs=true;});}else{setValidElements(settings.valid_elements);}addCustomElements(settings.custom_elements);addValidChildren(settings.valid_children);addValidElements(settings.extended_valid_elements);addValidChildren('+ol[ul|ol],+ul[ul|ol]');each$4({dd:'dl',dt:'dl',li:'ul ol',td:'tr',th:'tr',tr:'tbody thead tfoot',tbody:'table',thead:'table',tfoot:'table',legend:'fieldset',area:'map',param:'video audio object'},function(parents,item){if(elements[item]){elements[item].parentsRequired=split(parents);}});if(settings.invalid_elements){each$4(explode$1(settings.invalid_elements),function(item){if(elements[item]){delete elements[item];}});}if(!getElementRule('span')){addValidElements('span[!data-mce-type|*]');}var getValidStyles=function getValidStyles(){return validStyles;};var getInvalidStyles=function getInvalidStyles(){return invalidStyles;};var getValidClasses=function getValidClasses(){return validClasses;};var getBoolAttrs=function getBoolAttrs(){return boolAttrMap;};var getBlockElements=function getBlockElements(){return blockElementsMap;};var getTextBlockElements=function getTextBlockElements(){return textBlockElementsMap;};var getTextInlineElements=function getTextInlineElements(){return textInlineElementsMap;};var getShortEndedElements=function getShortEndedElements(){return shortEndedElementsMap;};var getSelfClosingElements=function getSelfClosingElements(){return selfClosingElementsMap;};var getNonEmptyElements=function getNonEmptyElements(){return nonEmptyElementsMap;};var getMoveCaretBeforeOnEnterElements=function getMoveCaretBeforeOnEnterElements(){return moveCaretBeforeOnEnterElementsMap;};var getWhiteSpaceElements=function getWhiteSpaceElements(){return whiteSpaceElementsMap;};var getSpecialElements=function getSpecialElements(){return specialElements;};var isValidChild=function isValidChild(name,child){var parent=children[name.toLowerCase()];return!!(parent&&parent[child.toLowerCase()]);};var isValid=function isValid(name,attr){var attrPatterns,i;var rule=getElementRule(name);if(rule){if(attr){if(rule.attributes[attr]){return true;}attrPatterns=rule.attributePatterns;if(attrPatterns){i=attrPatterns.length;while(i--){if(attrPatterns[i].pattern.test(name)){return true;}}}}else{return true;}}return false;};var getCustomElements=function getCustomElements(){return customElementsMap;};return{children:children,elements:elements,getValidStyles:getValidStyles,getValidClasses:getValidClasses,getBlockElements:getBlockElements,getInvalidStyles:getInvalidStyles,getShortEndedElements:getShortEndedElements,getTextBlockElements:getTextBlockElements,getTextInlineElements:getTextInlineElements,getBoolAttrs:getBoolAttrs,getElementRule:getElementRule,getSelfClosingElements:getSelfClosingElements,getNonEmptyElements:getNonEmptyElements,getMoveCaretBeforeOnEnterElements:getMoveCaretBeforeOnEnterElements,getWhiteSpaceElements:getWhiteSpaceElements,getSpecialElements:getSpecialElements,isValidChild:isValidChild,isValid:isValid,getCustomElements:getCustomElements,addValidElements:addValidElements,setValidElements:setValidElements,addCustomElements:addCustomElements,addValidChildren:addValidChildren};}var _toHex=function _toHex(match,r,g,b){var hex=function hex(val){val=parseInt(val,10).toString(16);return val.length>1?val:'0'+val;};return'#'+hex(r)+hex(g)+hex(b);};function Styles(settings,schema){var rgbRegExp=/rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;var urlOrStrRegExp=/(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;var styleRegExp=/\s*([^:]+):\s*([^;]+);?/g;var trimRightRegExp=/\s+$/;var i;var encodingLookup={};var encodingItems;var validStyles;var invalidStyles;var invisibleChar='\uFEFF';settings=settings||{};if(schema){validStyles=schema.getValidStyles();invalidStyles=schema.getInvalidStyles();}encodingItems=('\\" \\\' \\; \\: ; : '+invisibleChar).split(' ');for(i=0;i<encodingItems.length;i++){encodingLookup[encodingItems[i]]=invisibleChar+i;encodingLookup[invisibleChar+i]=encodingItems[i];}return{toHex:function toHex(color){return color.replace(rgbRegExp,_toHex);},parse:function parse(css){var styles={};var matches,name,value,isEncoded;var urlConverter=settings.url_converter;var urlConverterScope=settings.url_converter_scope||this;var compress=function compress(prefix,suffix,noJoin){var top,right,bottom,left;top=styles[prefix+'-top'+suffix];if(!top){return;}right=styles[prefix+'-right'+suffix];if(!right){return;}bottom=styles[prefix+'-bottom'+suffix];if(!bottom){return;}left=styles[prefix+'-left'+suffix];if(!left){return;}var box=[top,right,bottom,left];i=box.length-1;while(i--){if(box[i]!==box[i+1]){break;}}if(i>-1&&noJoin){return;}styles[prefix+suffix]=i===-1?box[0]:box.join(' ');delete styles[prefix+'-top'+suffix];delete styles[prefix+'-right'+suffix];delete styles[prefix+'-bottom'+suffix];delete styles[prefix+'-left'+suffix];};var canCompress=function canCompress(key){var value=styles[key],i;if(!value){return;}value=value.split(' ');i=value.length;while(i--){if(value[i]!==value[0]){return false;}}styles[key]=value[0];return true;};var compress2=function compress2(target,a,b,c){if(!canCompress(a)){return;}if(!canCompress(b)){return;}if(!canCompress(c)){return;}styles[target]=styles[a]+' '+styles[b]+' '+styles[c];delete styles[a];delete styles[b];delete styles[c];};var encode=function encode(str){isEncoded=true;return encodingLookup[str];};var decode=function decode(str,keepSlashes){if(isEncoded){str=str.replace(/\uFEFF[0-9]/g,function(str){return encodingLookup[str];});}if(!keepSlashes){str=str.replace(/\\([\'\";:])/g,'$1');}return str;};var decodeSingleHexSequence=function decodeSingleHexSequence(escSeq){return String.fromCharCode(parseInt(escSeq.slice(1),16));};var decodeHexSequences=function decodeHexSequences(value){return value.replace(/\\[0-9a-f]+/gi,decodeSingleHexSequence);};var processUrl=function processUrl(match,url,url2,url3,str,str2){str=str||str2;if(str){str=decode(str);return'\''+str.replace(/\'/g,'\\\'')+'\'';}url=decode(url||url2||url3);if(!settings.allow_script_urls){var scriptUrl=url.replace(/[\s\r\n]+/g,'');if(/(java|vb)script:/i.test(scriptUrl)){return'';}if(!settings.allow_svg_data_urls&&/^data:image\/svg/i.test(scriptUrl)){return'';}}if(urlConverter){url=urlConverter.call(urlConverterScope,url,'style');}return'url(\''+url.replace(/\'/g,'\\\'')+'\')';};if(css){css=css.replace(/[\u0000-\u001F]/g,'');css=css.replace(/\\[\"\';:\uFEFF]/g,encode).replace(/\"[^\"]+\"|\'[^\']+\'/g,function(str){return str.replace(/[;:]/g,encode);});while(matches=styleRegExp.exec(css)){styleRegExp.lastIndex=matches.index+matches[0].length;name=matches[1].replace(trimRightRegExp,'').toLowerCase();value=matches[2].replace(trimRightRegExp,'');if(name&&value){name=decodeHexSequences(name);value=decodeHexSequences(value);if(name.indexOf(invisibleChar)!==-1||name.indexOf('"')!==-1){continue;}if(!settings.allow_script_urls&&(name==='behavior'||/expression\s*\(|\/\*|\*\//.test(value))){continue;}if(name==='font-weight'&&value==='700'){value='bold';}else if(name==='color'||name==='background-color'){value=value.toLowerCase();}value=value.replace(rgbRegExp,_toHex);value=value.replace(urlOrStrRegExp,processUrl);styles[name]=isEncoded?decode(value,true):value;}}compress('border','',true);compress('border','-width');compress('border','-color');compress('border','-style');compress('padding','');compress('margin','');compress2('border','border-width','border-style','border-color');if(styles.border==='medium none'){delete styles.border;}if(styles['border-image']==='none'){delete styles['border-image'];}}return styles;},serialize:function serialize(styles,elementName){var css='',name,value;var serializeStyles=function serializeStyles(name){var styleList,i,l,value;styleList=validStyles[name];if(styleList){for(i=0,l=styleList.length;i<l;i++){name=styleList[i];value=styles[name];if(value){css+=(css.length>0?' ':'')+name+': '+value+';';}}}};var isValid=function isValid(name,elementName){var styleMap;styleMap=invalidStyles['*'];if(styleMap&&styleMap[name]){return false;}styleMap=invalidStyles[elementName];if(styleMap&&styleMap[name]){return false;}return true;};if(elementName&&validStyles){serializeStyles('*');serializeStyles(elementName);}else{for(name in styles){value=styles[name];if(value&&(!invalidStyles||isValid(name,elementName))){css+=(css.length>0?' ':'')+name+': '+value+';';}}}return css;}};}var each$5=$_2ytxahljk26xetf.each;var grep$1=$_2ytxahljk26xetf.grep;var isIE=$_ef6mqpajk26xejm.ie;var simpleSelectorRe=/^([a-z0-9],?)+$/i;var whiteSpaceRegExp$2=/^[ \t\r\n]*$/;var setupAttrHooks=function setupAttrHooks(styles,settings,getContext){var attrHooks={};var keepValues=settings.keep_values;var keepUrlHook={set:function set($elm,value,name$$1){if(settings.url_converter){value=settings.url_converter.call(settings.url_converter_scope||getContext(),value,name$$1,$elm[0]);}$elm.attr('data-mce-'+name$$1,value).attr(name$$1,value);},get:function get($elm,name$$1){return $elm.attr('data-mce-'+name$$1)||$elm.attr(name$$1);}};attrHooks={style:{set:function set($elm,value){if(value!==null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object'){$elm.css(value);return;}if(keepValues){$elm.attr('data-mce-style',value);}$elm.attr('style',value);},get:function get($elm){var value=$elm.attr('data-mce-style')||$elm.attr('style');value=styles.serialize(styles.parse(value),$elm[0].nodeName);return value;}}};if(keepValues){attrHooks.href=attrHooks.src=keepUrlHook;}return attrHooks;};var updateInternalStyleAttr=function updateInternalStyleAttr(styles,$elm){var rawValue=$elm.attr('style');var value=styles.serialize(styles.parse(rawValue),$elm[0].nodeName);if(!value){value=null;}$elm.attr('data-mce-style',value);};var findNodeIndex=function findNodeIndex(node,normalized){var idx=0,lastNodeType,nodeType;if(node){for(lastNodeType=node.nodeType,node=node.previousSibling;node;node=node.previousSibling){nodeType=node.nodeType;if(normalized&&nodeType===3){if(nodeType===lastNodeType||!node.nodeValue.length){continue;}}idx++;lastNodeType=nodeType;}}return idx;};function DOMUtils(doc,settings){var _this=this;if(settings===void 0){settings={};}var attrHooks;var addedStyles={};var win=window;var files={};var counter=0;var stdMode=true;var boxModel=true;var styleSheetLoader=StyleSheetLoader(doc);var boundEvents=[];var schema=settings.schema?settings.schema:Schema({});var styles=Styles({url_converter:settings.url_converter,url_converter_scope:settings.url_converter_scope},settings.schema);var events=settings.ownEvents?new EventUtils(settings.proxy):EventUtils.Event;var blockElementsMap=schema.getBlockElements();var $=DomQuery.overrideDefaults(function(){return{context:doc,element:self$$1.getRoot()};});var isBlock=function isBlock(node){if(typeof node==='string'){return!!blockElementsMap[node];}else if(node){var type=node.nodeType;if(type){return!!(type===1&&blockElementsMap[node.nodeName]);}}return false;};var get=function get(elm){if(elm&&doc&&typeof elm==='string'){var node=doc.getElementById(elm);if(node&&node.id!==elm){return doc.getElementsByName(elm)[1];}else{return node;}}return elm;};var $$=function $$(elm){if(typeof elm==='string'){elm=get(elm);}return $(elm);};var getAttrib=function getAttrib(elm,name$$1,defaultVal){var hook,value;var $elm=$$(elm);if($elm.length){hook=attrHooks[name$$1];if(hook&&hook.get){value=hook.get($elm,name$$1);}else{value=$elm.attr(name$$1);}}if(typeof value==='undefined'){value=defaultVal||'';}return value;};var getAttribs=function getAttribs(elm){var node=get(elm);if(!node){return[];}return node.attributes;};var setAttrib=function setAttrib(elm,name$$1,value){var originalValue,hook;if(value===''){value=null;}var $elm=$$(elm);originalValue=$elm.attr(name$$1);if(!$elm.length){return;}hook=attrHooks[name$$1];if(hook&&hook.set){hook.set($elm,value,name$$1);}else{$elm.attr(name$$1,value);}if(originalValue!==value&&settings.onSetAttrib){settings.onSetAttrib({attrElm:$elm,attrName:name$$1,attrValue:value});}};var clone=function clone(node,deep){if(!isIE||node.nodeType!==1||deep){return node.cloneNode(deep);}if(!deep){var clone_1=doc.createElement(node.nodeName);each$5(getAttribs(node),function(attr){setAttrib(clone_1,attr.nodeName,getAttrib(node,attr.nodeName));});return clone_1;}return null;};var getRoot=function getRoot(){return settings.root_element||doc.body;};var getViewPort=function getViewPort(argWin){var actWin=!argWin?win:argWin;var doc=actWin.document;var rootElm=boxModel?doc.documentElement:doc.body;return{x:actWin.pageXOffset||rootElm.scrollLeft,y:actWin.pageYOffset||rootElm.scrollTop,w:actWin.innerWidth||rootElm.clientWidth,h:actWin.innerHeight||rootElm.clientHeight};};var getPos=function getPos(elm,rootElm){return $_3kfxvvnjk26xetu.getPos(doc.body,get(elm),rootElm);};var setStyle=function setStyle(elm,name$$1,value){var $elm=$$(elm).css(name$$1,value);if(settings.update_styles){updateInternalStyleAttr(styles,$elm);}};var setStyles=function setStyles(elm,stylesArg){var $elm=$$(elm).css(stylesArg);if(settings.update_styles){updateInternalStyleAttr(styles,$elm);}};var getStyle=function getStyle(elm,name$$1,computed){var $elm=$$(elm);if(computed){return $elm.css(name$$1);}name$$1=name$$1.replace(/-(\D)/g,function(a,b){return b.toUpperCase();});if(name$$1==='float'){name$$1=$_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<12?'styleFloat':'cssFloat';}return $elm[0]&&$elm[0].style?$elm[0].style[name$$1]:undefined;};var getSize=function getSize(elm){var w,h;elm=get(elm);w=getStyle(elm,'width');h=getStyle(elm,'height');if(w.indexOf('px')===-1){w=0;}if(h.indexOf('px')===-1){h=0;}return{w:parseInt(w,10)||elm.offsetWidth||elm.clientWidth,h:parseInt(h,10)||elm.offsetHeight||elm.clientHeight};};var getRect=function getRect(elm){var pos,size;elm=get(elm);pos=getPos(elm);size=getSize(elm);return{x:pos.x,y:pos.y,w:size.w,h:size.h};};var is=function is(elm,selector){var i;if(!elm){return false;}if(!Array.isArray(elm)){if(selector==='*'){return elm.nodeType===1;}if(simpleSelectorRe.test(selector)){var selectors=selector.toLowerCase().split(/,/);var elmName=elm.nodeName.toLowerCase();for(i=selectors.length-1;i>=0;i--){if(selectors[i]===elmName){return true;}}return false;}if(elm.nodeType&&elm.nodeType!==1){return false;}}var elms=!Array.isArray(elm)?[elm]:elm;return Sizzle(selector,elms[0].ownerDocument||elms[0],null,elms).length>0;};var getParents=function getParents(elm,selector,root,collect){var result=[];var selectorVal;var node=get(elm);collect=collect===undefined;root=root||(getRoot().nodeName!=='BODY'?getRoot().parentNode:null);if($_2ytxahljk26xetf.is(selector,'string')){selectorVal=selector;if(selector==='*'){selector=function selector(node){return node.nodeType===1;};}else{selector=function selector(node){return is(node,selectorVal);};}}while(node){if(node===root||!node.nodeType||node.nodeType===9){break;}if(!selector||typeof selector==='function'&&selector(node)){if(collect){result.push(node);}else{return[node];}}node=node.parentNode;}return collect?result:null;};var getParent=function getParent(node,selector,root){var parents=getParents(node,selector,root,false);return parents&&parents.length>0?parents[0]:null;};var _findSib=function _findSib(node,selector,name$$1){var func=selector;if(node){if(typeof selector==='string'){func=function func(node){return is(node,selector);};}for(node=node[name$$1];node;node=node[name$$1]){if(typeof func==='function'&&func(node)){return node;}}}return null;};var getNext=function getNext(node,selector){return _findSib(node,selector,'nextSibling');};var getPrev=function getPrev(node,selector){return _findSib(node,selector,'previousSibling');};var select=function select(selector,scope){return Sizzle(selector,get(scope)||settings.root_element||doc,[]);};var run=function run(elm,func,scope){var result;var node=typeof elm==='string'?get(elm):elm;if(!node){return false;}if($_2ytxahljk26xetf.isArray(node)&&(node.length||node.length===0)){result=[];each$5(node,function(elm,i){if(elm){if(typeof elm==='string'){elm=get(elm);}result.push(func.call(scope,elm,i));}});return result;}var context=scope?scope:_this;return func.call(context,node);};var setAttribs=function setAttribs(elm,attrs){$$(elm).each(function(i,node){each$5(attrs,function(value,name$$1){setAttrib(node,name$$1,value);});});};var setHTML=function setHTML(elm,html){var $elm=$$(elm);if(isIE){$elm.each(function(i,target){if(target.canHaveHTML===false){return;}while(target.firstChild){target.removeChild(target.firstChild);}try{target.innerHTML='<br>'+html;target.removeChild(target.firstChild);}catch(ex){DomQuery('<div></div>').html('<br>'+html).contents().slice(1).appendTo(target);}return html;});}else{$elm.html(html);}};var add=function add(parentElm,name$$1,attrs,html,create){return run(parentElm,function(parentElm){var newElm=typeof name$$1==='string'?doc.createElement(name$$1):name$$1;setAttribs(newElm,attrs);if(html){if(typeof html!=='string'&&html.nodeType){newElm.appendChild(html);}else if(typeof html==='string'){setHTML(newElm,html);}}return!create?parentElm.appendChild(newElm):newElm;});};var create=function create(name$$1,attrs,html){return add(doc.createElement(name$$1),name$$1,attrs,html,true);};var decode=$_8udjtn1sjk26xf0t.decode;var encode=$_8udjtn1sjk26xf0t.encodeAllRaw;var createHTML=function createHTML(name$$1,attrs,html){var outHtml='',key;outHtml+='<'+name$$1;for(key in attrs){if(attrs.hasOwnProperty(key)&&attrs[key]!==null&&typeof attrs[key]!=='undefined'){outHtml+=' '+key+'="'+encode(attrs[key])+'"';}}if(typeof html!=='undefined'){return outHtml+'>'+html+'</'+name$$1+'>';}return outHtml+' />';};var createFragment=function createFragment(html){var node;var container=doc.createElement('div');var frag=doc.createDocumentFragment();if(html){container.innerHTML=html;}while(node=container.firstChild){frag.appendChild(node);}return frag;};var remove=function remove(node,keepChildren){var $node=$$(node);if(keepChildren){$node.each(function(){var child;while(child=this.firstChild){if(child.nodeType===3&&child.data.length===0){this.removeChild(child);}else{this.parentNode.insertBefore(child,this);}}}).remove();}else{$node.remove();}return $node.length>1?$node.toArray():$node[0];};var removeAllAttribs=function removeAllAttribs(e){return run(e,function(e){var i;var attrs=e.attributes;for(i=attrs.length-1;i>=0;i--){e.removeAttributeNode(attrs.item(i));}});};var parseStyle=function parseStyle(cssText){return styles.parse(cssText);};var serializeStyle=function serializeStyle(stylesArg,name$$1){return styles.serialize(stylesArg,name$$1);};var addStyle=function addStyle(cssText){var head,styleElm;if(self$$1!==DOMUtils.DOM&&doc===document){if(addedStyles[cssText]){return;}addedStyles[cssText]=true;}styleElm=doc.getElementById('mceDefaultStyles');if(!styleElm){styleElm=doc.createElement('style');styleElm.id='mceDefaultStyles';styleElm.type='text/css';head=doc.getElementsByTagName('head')[0];if(head.firstChild){head.insertBefore(styleElm,head.firstChild);}else{head.appendChild(styleElm);}}if(styleElm.styleSheet){styleElm.styleSheet.cssText+=cssText;}else{styleElm.appendChild(doc.createTextNode(cssText));}};var loadCSS=function loadCSS(url){var head;if(self$$1!==DOMUtils.DOM&&doc===document){DOMUtils.DOM.loadCSS(url);return;}if(!url){url='';}head=doc.getElementsByTagName('head')[0];each$5(url.split(','),function(url){var link;url=$_2ytxahljk26xetf._addCacheSuffix(url);if(files[url]){return;}files[url]=true;link=create('link',{rel:'stylesheet',href:url});head.appendChild(link);});};var toggleClass=function toggleClass(elm,cls,state){$$(elm).toggleClass(cls,state).each(function(){if(this.className===''){DomQuery(this).attr('class',null);}});};var addClass=function addClass(elm,cls){$$(elm).addClass(cls);};var removeClass=function removeClass(elm,cls){toggleClass(elm,cls,false);};var hasClass=function hasClass(elm,cls){return $$(elm).hasClass(cls);};var show=function show(elm){$$(elm).show();};var hide=function hide(elm){$$(elm).hide();};var isHidden=function isHidden(elm){return $$(elm).css('display')==='none';};var uniqueId=function uniqueId(prefix){return(!prefix?'mce_':prefix)+counter++;};var getOuterHTML=function getOuterHTML(elm){var node=typeof elm==='string'?get(elm):elm;return $_fpgwqg1rjk26xf0n.isElement(node)?node.outerHTML:DomQuery('<div></div>').append(DomQuery(node).clone()).html();};var setOuterHTML=function setOuterHTML(elm,html){$$(elm).each(function(){try{if('outerHTML'in this){this.outerHTML=html;return;}}catch(ex){}remove(DomQuery(this).html(html),true);});};var insertAfter=function insertAfter(node,reference){var referenceNode=get(reference);return run(node,function(node){var parent$$1,nextSibling;parent$$1=referenceNode.parentNode;nextSibling=referenceNode.nextSibling;if(nextSibling){parent$$1.insertBefore(node,nextSibling);}else{parent$$1.appendChild(node);}return node;});};var replace=function replace(newElm,oldElm,keepChildren){return run(oldElm,function(oldElm){if($_2ytxahljk26xetf.is(oldElm,'array')){newElm=newElm.cloneNode(true);}if(keepChildren){each$5(grep$1(oldElm.childNodes),function(node){newElm.appendChild(node);});}return oldElm.parentNode.replaceChild(newElm,oldElm);});};var rename=function rename(elm,name$$1){var newElm;if(elm.nodeName!==name$$1.toUpperCase()){newElm=create(name$$1);each$5(getAttribs(elm),function(attrNode){setAttrib(newElm,attrNode.nodeName,getAttrib(elm,attrNode.nodeName));});replace(newElm,elm,true);}return newElm||elm;};var findCommonAncestor=function findCommonAncestor(a,b){var ps=a,pe;while(ps){pe=b;while(pe&&ps!==pe){pe=pe.parentNode;}if(ps===pe){break;}ps=ps.parentNode;}if(!ps&&a.ownerDocument){return a.ownerDocument.documentElement;}return ps;};var toHex=function toHex(rgbVal){return styles.toHex($_2ytxahljk26xetf.trim(rgbVal));};var isEmpty=function isEmpty(node,elements){var i,attributes,type,whitespace,walker,name$$1,brCount=0;node=node.firstChild;if(node){walker=new TreeWalker(node,node.parentNode);elements=elements||(schema?schema.getNonEmptyElements():null);whitespace=schema?schema.getWhiteSpaceElements():{};do{type=node.nodeType;if($_fpgwqg1rjk26xf0n.isElement(node)){var bogusVal=node.getAttribute('data-mce-bogus');if(bogusVal){node=walker.next(bogusVal==='all');continue;}name$$1=node.nodeName.toLowerCase();if(elements&&elements[name$$1]){if(name$$1==='br'){brCount++;node=walker.next();continue;}return false;}attributes=getAttribs(node);i=attributes.length;while(i--){name$$1=attributes[i].nodeName;if(name$$1==='name'||name$$1==='data-mce-bookmark'){return false;}}}if(type===8){return false;}if(type===3&&!whiteSpaceRegExp$2.test(node.nodeValue)){return false;}if(type===3&&node.parentNode&&whitespace[node.parentNode.nodeName]&&whiteSpaceRegExp$2.test(node.nodeValue)){return false;}node=walker.next();}while(node);}return brCount<=1;};var createRng=function createRng(){return doc.createRange();};var split=function split(parentElm,splitElm,replacementElm){var r=createRng(),bef,aft,pa;if(parentElm&&splitElm){r.setStart(parentElm.parentNode,findNodeIndex(parentElm));r.setEnd(splitElm.parentNode,findNodeIndex(splitElm));bef=r.extractContents();r=createRng();r.setStart(splitElm.parentNode,findNodeIndex(splitElm)+1);r.setEnd(parentElm.parentNode,findNodeIndex(parentElm)+1);aft=r.extractContents();pa=parentElm.parentNode;pa.insertBefore($_fpnhg1pjk26xf07.trimNode(self$$1,bef),parentElm);if(replacementElm){pa.insertBefore(replacementElm,parentElm);}else{pa.insertBefore(splitElm,parentElm);}pa.insertBefore($_fpnhg1pjk26xf07.trimNode(self$$1,aft),parentElm);remove(parentElm);return replacementElm||splitElm;}};var bind=function bind(target,name$$1,func,scope){if($_2ytxahljk26xetf.isArray(target)){var i=target.length;while(i--){target[i]=bind(target[i],name$$1,func,scope);}return target;}if(settings.collect&&(target===doc||target===win)){boundEvents.push([target,name$$1,func,scope]);}return events.bind(target,name$$1,func,scope||self$$1);};var unbind=function unbind(target,name$$1,func){var i;if($_2ytxahljk26xetf.isArray(target)){i=target.length;while(i--){target[i]=unbind(target[i],name$$1,func);}return target;}if(boundEvents&&(target===doc||target===win)){i=boundEvents.length;while(i--){var item=boundEvents[i];if(target===item[0]&&(!name$$1||name$$1===item[1])&&(!func||func===item[2])){events.unbind(item[0],item[1],item[2]);}}}return events.unbind(target,name$$1,func);};var fire=function fire(target,name$$1,evt){return events.fire(target,name$$1,evt);};var getContentEditable=function getContentEditable(node){if(node&&$_fpgwqg1rjk26xf0n.isElement(node)){var contentEditable=node.getAttribute('data-mce-contenteditable');if(contentEditable&&contentEditable!=='inherit'){return contentEditable;}return node.contentEditable!=='inherit'?node.contentEditable:null;}else{return null;}};var getContentEditableParent=function getContentEditableParent(node){var root=getRoot();var state=null;for(;node&&node!==root;node=node.parentNode){state=getContentEditable(node);if(state!==null){break;}}return state;};var destroy=function destroy(){if(boundEvents){var i=boundEvents.length;while(i--){var item=boundEvents[i];events.unbind(item[0],item[1],item[2]);}}if(Sizzle.setDocument){Sizzle.setDocument();}};var isChildOf=function isChildOf(node,parent$$1){while(node){if(parent$$1===node){return true;}node=node.parentNode;}return false;};var dumpRng=function dumpRng(r){return'startContainer: '+r.startContainer.nodeName+', startOffset: '+r.startOffset+', endContainer: '+r.endContainer.nodeName+', endOffset: '+r.endOffset;};var self$$1={doc:doc,settings:settings,win:win,files:files,stdMode:stdMode,boxModel:boxModel,styleSheetLoader:styleSheetLoader,boundEvents:boundEvents,styles:styles,schema:schema,events:events,isBlock:isBlock,$:$,$$:$$,root:null,clone:clone,getRoot:getRoot,getViewPort:getViewPort,getRect:getRect,getSize:getSize,getParent:getParent,getParents:getParents,get:get,getNext:getNext,getPrev:getPrev,select:select,is:is,add:add,create:create,createHTML:createHTML,createFragment:createFragment,remove:remove,setStyle:setStyle,getStyle:getStyle,setStyles:setStyles,removeAllAttribs:removeAllAttribs,setAttrib:setAttrib,setAttribs:setAttribs,getAttrib:getAttrib,getPos:getPos,parseStyle:parseStyle,serializeStyle:serializeStyle,addStyle:addStyle,loadCSS:loadCSS,addClass:addClass,removeClass:removeClass,hasClass:hasClass,toggleClass:toggleClass,show:show,hide:hide,isHidden:isHidden,uniqueId:uniqueId,setHTML:setHTML,getOuterHTML:getOuterHTML,setOuterHTML:setOuterHTML,decode:decode,encode:encode,insertAfter:insertAfter,replace:replace,rename:rename,findCommonAncestor:findCommonAncestor,toHex:toHex,run:run,getAttribs:getAttribs,isEmpty:isEmpty,createRng:createRng,nodeIndex:findNodeIndex,split:split,bind:bind,unbind:unbind,fire:fire,getContentEditable:getContentEditable,getContentEditableParent:getContentEditableParent,destroy:destroy,isChildOf:isChildOf,dumpRng:dumpRng};attrHooks=setupAttrHooks(styles,settings,function(){return self$$1;});return self$$1;}(function(DOMUtils){DOMUtils.DOM=DOMUtils(document);DOMUtils.nodeIndex=findNodeIndex;})(DOMUtils||(DOMUtils={}));var DOMUtils$1=DOMUtils;var DOM=DOMUtils$1.DOM;var each$6=$_2ytxahljk26xetf.each;var grep$2=$_2ytxahljk26xetf.grep;var isFunction$1=function isFunction$1(f){return typeof f==='function';};var ScriptLoader=function ScriptLoader(){var QUEUED=0;var LOADING=1;var LOADED=2;var FAILED=3;var states={};var queue=[];var scriptLoadedCallbacks={};var queueLoadedCallbacks=[];var loading=0;var loadScript=function loadScript(url,success,failure){var dom=DOM;var elm,id;var done=function done(){dom.remove(id);if(elm){elm.onreadystatechange=elm.onload=elm=null;}success();};var error=function error(){if(isFunction$1(failure)){failure();}else{if(typeof console!=='undefined'&&console.log){console.log('Failed to load script: '+url);}}};id=dom.uniqueId();elm=document.createElement('script');elm.id=id;elm.type='text/javascript';elm.src=$_2ytxahljk26xetf._addCacheSuffix(url);if('onreadystatechange'in elm){elm.onreadystatechange=function(){if(/loaded|complete/.test(elm.readyState)){done();}};}else{elm.onload=done;}elm.onerror=error;(document.getElementsByTagName('head')[0]||document.body).appendChild(elm);};this.isDone=function(url){return states[url]===LOADED;};this.markDone=function(url){states[url]=LOADED;};this.add=this.load=function(url,success,scope,failure){var state=states[url];if(state===undefined){queue.push(url);states[url]=QUEUED;}if(success){if(!scriptLoadedCallbacks[url]){scriptLoadedCallbacks[url]=[];}scriptLoadedCallbacks[url].push({success:success,failure:failure,scope:scope||this});}};this.remove=function(url){delete states[url];delete scriptLoadedCallbacks[url];};this.loadQueue=function(success,scope,failure){this.loadScripts(queue,success,scope,failure);};this.loadScripts=function(scripts,success,scope,failure){var _loadScripts;var failures=[];var execCallbacks=function execCallbacks(name$$1,url){each$6(scriptLoadedCallbacks[url],function(callback){if(isFunction$1(callback[name$$1])){callback[name$$1].call(callback.scope);}});scriptLoadedCallbacks[url]=undefined;};queueLoadedCallbacks.push({success:success,failure:failure,scope:scope||this});_loadScripts=function loadScripts(){var loadingScripts=grep$2(scripts);scripts.length=0;each$6(loadingScripts,function(url){if(states[url]===LOADED){execCallbacks('success',url);return;}if(states[url]===FAILED){execCallbacks('failure',url);return;}if(states[url]!==LOADING){states[url]=LOADING;loading++;loadScript(url,function(){states[url]=LOADED;loading--;execCallbacks('success',url);_loadScripts();},function(){states[url]=FAILED;loading--;failures.push(url);execCallbacks('failure',url);_loadScripts();});}});if(!loading){var notifyCallbacks=queueLoadedCallbacks.slice(0);queueLoadedCallbacks.length=0;each$6(notifyCallbacks,function(callback){if(failures.length===0){if(isFunction$1(callback.success)){callback.success.call(callback.scope);}}else{if(isFunction$1(callback.failure)){callback.failure.call(callback.scope,failures);}}});}};_loadScripts();};};ScriptLoader.ScriptLoader=new ScriptLoader();var each$7=$_2ytxahljk26xetf.each;function AddOnManager(){var _this=this;var items=[];var urls={};var lookup={};var _listeners=[];var get=function get(name){if(lookup[name]){return lookup[name].instance;}return undefined;};var dependencies=function dependencies(name){var result;if(lookup[name]){result=lookup[name].dependencies;}return result||[];};var requireLangPack=function requireLangPack(name,languages){var language=AddOnManager.language;if(language&&AddOnManager.languageLoad!==false){if(languages){languages=','+languages+',';if(languages.indexOf(','+language.substr(0,2)+',')!==-1){language=language.substr(0,2);}else if(languages.indexOf(','+language+',')===-1){return;}}ScriptLoader.ScriptLoader.add(urls[name]+'/langs/'+language+'.js');}};var add=function add(id,addOn,dependencies){items.push(addOn);lookup[id]={instance:addOn,dependencies:dependencies};var result=partition(_listeners,function(listener){return listener.name===id;});_listeners=result.fail;each$7(result.pass,function(listener){listener.callback();});return addOn;};var remove=function remove(name){delete urls[name];delete lookup[name];};var createUrl=function createUrl(baseUrl,dep){if((typeof dep==='undefined'?'undefined':_typeof(dep))==='object'){return dep;}return typeof baseUrl==='string'?{prefix:'',resource:dep,suffix:''}:{prefix:baseUrl.prefix,resource:dep,suffix:baseUrl.suffix};};var addComponents=function addComponents(pluginName,scripts){var pluginUrl=_this.urls[pluginName];each$7(scripts,function(script){ScriptLoader.ScriptLoader.add(pluginUrl+'/'+script);});};var loadDependencies=function loadDependencies(name,addOnUrl,success,scope){var deps=dependencies(name);each$7(deps,function(dep){var newUrl=createUrl(addOnUrl,dep);load(newUrl.resource,newUrl,undefined,undefined);});if(success){if(scope){success.call(scope);}else{success.call(ScriptLoader);}}};var load=function load(name,addOnUrl,success,scope,failure){if(urls[name]){return;}var urlString=typeof addOnUrl==='string'?addOnUrl:addOnUrl.prefix+addOnUrl.resource+addOnUrl.suffix;if(urlString.indexOf('/')!==0&&urlString.indexOf('://')===-1){urlString=AddOnManager.baseURL+'/'+urlString;}urls[name]=urlString.substring(0,urlString.lastIndexOf('/'));if(lookup[name]){loadDependencies(name,addOnUrl,success,scope);}else{ScriptLoader.ScriptLoader.add(urlString,function(){return loadDependencies(name,addOnUrl,success,scope);},scope,failure);}};var waitFor=function waitFor(name,callback){if(lookup.hasOwnProperty(name)){callback();}else{_listeners.push({name:name,callback:callback});}};return{items:items,urls:urls,lookup:lookup,_listeners:_listeners,get:get,dependencies:dependencies,requireLangPack:requireLangPack,add:add,remove:remove,createUrl:createUrl,addComponents:addComponents,load:load,waitFor:waitFor};}(function(AddOnManager){AddOnManager.PluginManager=AddOnManager();AddOnManager.ThemeManager=AddOnManager();})(AddOnManager||(AddOnManager={}));var before=function before(marker,element){var parent=$_2i1q6518jk26xexk.parent(marker);parent.each(function(v){v.dom().insertBefore(element.dom(),marker.dom());});};var after=function after(marker,element){var sibling=$_2i1q6518jk26xexk.nextSibling(marker);sibling.fold(function(){var parent=$_2i1q6518jk26xexk.parent(marker);parent.each(function(v){append(v,element);});},function(v){before(v,element);});};var prepend=function prepend(parent,element){var firstChild=$_2i1q6518jk26xexk.firstChild(parent);firstChild.fold(function(){append(parent,element);},function(v){parent.dom().insertBefore(element.dom(),v.dom());});};var append=function append(parent,element){parent.dom().appendChild(element.dom());};var appendAt=function appendAt(parent,element,index){$_2i1q6518jk26xexk.child(parent,index).fold(function(){append(parent,element);},function(v){before(v,element);});};var wrap$1=function wrap$1(element,wrapper){before(element,wrapper);append(wrapper,element);};var $_9t36rc1yjk26xf33={before:before,after:after,prepend:prepend,append:append,appendAt:appendAt,wrap:wrap$1};var before$1=function before$1(marker,elements){each(elements,function(x){$_9t36rc1yjk26xf33.before(marker,x);});};var after$1=function after$1(marker,elements){each(elements,function(x,i){var e=i===0?marker:elements[i-1];$_9t36rc1yjk26xf33.after(e,x);});};var prepend$1=function prepend$1(parent,elements){each(elements.slice().reverse(),function(x){$_9t36rc1yjk26xf33.prepend(parent,x);});};var append$1=function append$1(parent,elements){each(elements,function(x){$_9t36rc1yjk26xf33.append(parent,x);});};var $_2ykrq21xjk26xf2x={before:before$1,after:after$1,prepend:prepend$1,append:append$1};var empty=function empty(element){element.dom().textContent='';each($_2i1q6518jk26xexk.children(element),function(rogue){remove$2(rogue);});};var remove$2=function remove$2(element){var dom=element.dom();if(dom.parentNode!==null)dom.parentNode.removeChild(dom);};var unwrap=function unwrap(wrapper){var children=$_2i1q6518jk26xexk.children(wrapper);if(children.length>0)$_2ykrq21xjk26xf2x.before(wrapper,children);remove$2(wrapper);};var $_5ur14v1wjk26xf2q={empty:empty,remove:remove$2,unwrap:unwrap};var first$1=function first$1(fn,rate){var timer=null;var cancel=function cancel(){if(timer!==null){clearTimeout(timer);timer=null;}};var throttle=function throttle(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}if(timer===null){timer=setTimeout(function(){fn.apply(null,args);timer=null;},rate);}};return{cancel:cancel,throttle:throttle};};var last$3=function last$3(fn,rate){var timer=null;var cancel=function cancel(){if(timer!==null){clearTimeout(timer);timer=null;}};var throttle=function throttle(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}if(timer!==null)clearTimeout(timer);timer=setTimeout(function(){fn.apply(null,args);timer=null;},rate);};return{cancel:cancel,throttle:throttle};};var Cell=function Cell(initial){var value=initial;var get=function get(){return value;};var set=function set(v){value=v;};var clone=function clone(){return Cell(get());};return{get:get,set:set,clone:clone};};function Toggler(turnOff,turnOn,initial){var active=initial||false;var on=function on(){turnOn();active=true;};var off=function off(){turnOff();active=false;};var toggle=function toggle(){var f=active?off:on;f();};var isOn=function isOn(){return active;};return{on:on,off:off,toggle:toggle,isOn:isOn};}var read=function read(element,attr){var value=$_5xapbx15jk26xewz.get(element,attr);return value===undefined||value===''?[]:value.split(' ');};var add=function add(element,attr,id){var old=read(element,attr);var nu=old.concat([id]);$_5xapbx15jk26xewz.set(element,attr,nu.join(' '));return true;};var remove$3=function remove$3(element,attr,id){var nu=filter(read(element,attr),function(v){return v!==id;});if(nu.length>0)$_5xapbx15jk26xewz.set(element,attr,nu.join(' '));else $_5xapbx15jk26xewz.remove(element,attr);return false;};var $_nmx4k26jk26xf4k={read:read,add:add,remove:remove$3};var supports=function supports(element){return element.dom().classList!==undefined;};var get$2=function get$2(element){return $_nmx4k26jk26xf4k.read(element,'class');};var add$1=function add$1(element,clazz){return $_nmx4k26jk26xf4k.add(element,'class',clazz);};var remove$4=function remove$4(element,clazz){return $_nmx4k26jk26xf4k.remove(element,'class',clazz);};var toggle=function toggle(element,clazz){if(contains(get$2(element),clazz)){return remove$4(element,clazz);}else{return add$1(element,clazz);}};var $_296o5z25jk26xf47={get:get$2,add:add$1,remove:remove$4,toggle:toggle,supports:supports};var add$2=function add$2(element,clazz){if($_296o5z25jk26xf47.supports(element))element.dom().classList.add(clazz);else $_296o5z25jk26xf47.add(element,clazz);};var cleanClass=function cleanClass(element){var classList=$_296o5z25jk26xf47.supports(element)?element.dom().classList:$_296o5z25jk26xf47.get(element);if(classList.length===0){$_5xapbx15jk26xewz.remove(element,'class');}};var remove$5=function remove$5(element,clazz){if($_296o5z25jk26xf47.supports(element)){var classList=element.dom().classList;classList.remove(clazz);}else $_296o5z25jk26xf47.remove(element,clazz);cleanClass(element);};var toggle$1=function toggle$1(element,clazz){return $_296o5z25jk26xf47.supports(element)?element.dom().classList.toggle(clazz):$_296o5z25jk26xf47.toggle(element,clazz);};var toggler=function toggler(element,clazz){var hasClasslist=$_296o5z25jk26xf47.supports(element);var classList=element.dom().classList;var off=function off(){if(hasClasslist)classList.remove(clazz);else $_296o5z25jk26xf47.remove(element,clazz);};var on=function on(){if(hasClasslist)classList.add(clazz);else $_296o5z25jk26xf47.add(element,clazz);};return Toggler(off,on,has$1(element,clazz));};var has$1=function has$1(element,clazz){return $_296o5z25jk26xf47.supports(element)&&element.dom().classList.contains(clazz);};var $_38pgzm23jk26xf42={add:add$2,remove:remove$5,toggle:toggle$1,toggler:toggler,has:has$1};var all$1=function all$1(predicate){return descendants($_2n2rdw16jk26xex9.body(),predicate);};var ancestors=function ancestors(scope,predicate,isRoot){return filter($_2i1q6518jk26xexk.parents(scope,isRoot),predicate);};var siblings$1=function siblings$1(scope,predicate){return filter($_2i1q6518jk26xexk.siblings(scope),predicate);};var children$1=function children$1(scope,predicate){return filter($_2i1q6518jk26xexk.children(scope),predicate);};var descendants=function descendants(scope,predicate){var result=[];each($_2i1q6518jk26xexk.children(scope),function(x){if(predicate(x)){result=result.concat([x]);}result=result.concat(descendants(x,predicate));});return result;};var $_ak7yrb28jk26xf4q={all:all$1,ancestors:ancestors,siblings:siblings$1,children:children$1,descendants:descendants};var all$2=function all$2(selector){return $_95wtq21gjk26xeyv.all(selector);};var ancestors$1=function ancestors$1(scope,selector,isRoot){return $_ak7yrb28jk26xf4q.ancestors(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);},isRoot);};var siblings$2=function siblings$2(scope,selector){return $_ak7yrb28jk26xf4q.siblings(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);});};var children$2=function children$2(scope,selector){return $_ak7yrb28jk26xf4q.children(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);});};var descendants$1=function descendants$1(scope,selector){return $_95wtq21gjk26xeyv.all(selector,scope);};var $_bisgdu27jk26xf4o={all:all$2,ancestors:ancestors$1,siblings:siblings$2,children:children$2,descendants:descendants$1};function ClosestOrAncestor(is,ancestor,scope,a,isRoot){return is(scope,a)?Option.some(scope):isFunction(isRoot)&&isRoot(scope)?Option.none():ancestor(scope,a,isRoot);}var first$2=function first$2(predicate){return descendant($_2n2rdw16jk26xex9.body(),predicate);};var ancestor=function ancestor(scope,predicate,isRoot){var element=scope.dom();var stop=isFunction(isRoot)?isRoot:constant(false);while(element.parentNode){element=element.parentNode;var el=Element$$1.fromDom(element);if(predicate(el))return Option.some(el);else if(stop(el))break;}return Option.none();};var closest=function closest(scope,predicate,isRoot){var is=function is(scope){return predicate(scope);};return ClosestOrAncestor(is,ancestor,scope,predicate,isRoot);};var sibling$1=function sibling$1(scope,predicate){var element=scope.dom();if(!element.parentNode)return Option.none();return child$1(Element$$1.fromDom(element.parentNode),function(x){return!$_dzedg81ejk26xeyh.eq(scope,x)&&predicate(x);});};var child$1=function child$1(scope,predicate){var result=find(scope.dom().childNodes,compose(predicate,Element$$1.fromDom));return result.map(Element$$1.fromDom);};var descendant=function descendant(scope,predicate){var descend=function descend(node){for(var i=0;i<node.childNodes.length;i++){if(predicate(Element$$1.fromDom(node.childNodes[i])))return Option.some(Element$$1.fromDom(node.childNodes[i]));var res=descend(node.childNodes[i]);if(res.isSome())return res;}return Option.none();};return descend(scope.dom());};var $_am0h6a2ajk26xf4w={first:first$2,ancestor:ancestor,closest:closest,sibling:sibling$1,child:child$1,descendant:descendant};var first$3=function first$3(selector){return $_95wtq21gjk26xeyv.one(selector);};var ancestor$1=function ancestor$1(scope,selector,isRoot){return $_am0h6a2ajk26xf4w.ancestor(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);},isRoot);};var sibling$2=function sibling$2(scope,selector){return $_am0h6a2ajk26xf4w.sibling(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);});};var child$2=function child$2(scope,selector){return $_am0h6a2ajk26xf4w.child(scope,function(e){return $_95wtq21gjk26xeyv.is(e,selector);});};var descendant$1=function descendant$1(scope,selector){return $_95wtq21gjk26xeyv.one(selector,scope);};var closest$1=function closest$1(scope,selector,isRoot){return ClosestOrAncestor($_95wtq21gjk26xeyv.is,ancestor$1,scope,selector,isRoot);};var $_dbgjqa29jk26xf4u={first:first$3,ancestor:ancestor$1,sibling:sibling$2,child:child$2,descendant:descendant$1,closest:closest$1};var annotation=constant('mce-annotation');var dataAnnotation=constant('data-mce-annotation');var dataAnnotationId=constant('data-mce-annotation-uid');var identify=function identify(editor,annotationName){var rng=editor.selection.getRng();var start=Element$$1.fromDom(rng.startContainer);var root=Element$$1.fromDom(editor.getBody());var selector=annotationName.fold(function(){return'.'+annotation();},function(an){return'['+dataAnnotation()+'="'+an+'"]';});var newStart=$_2i1q6518jk26xexk.child(start,rng.startOffset).getOr(start);var closest=$_dbgjqa29jk26xf4u.closest(newStart,selector,function(n){return $_dzedg81ejk26xeyh.eq(n,root);});var getAttr=function getAttr(c,property){if($_5xapbx15jk26xewz.has(c,property)){return Option.some($_5xapbx15jk26xewz.get(c,property));}else{return Option.none();}};return closest.bind(function(c){return getAttr(c,''+dataAnnotationId()).bind(function(uid){return getAttr(c,''+dataAnnotation()).map(function(name){var elements=findMarkers(editor,uid);return{uid:uid,name:name,elements:elements};});});});};var isAnnotation=function isAnnotation(elem){return $_cl4rr911jk26xevy.isElement(elem)&&$_38pgzm23jk26xf42.has(elem,annotation());};var findMarkers=function findMarkers(editor,uid){var body=Element$$1.fromDom(editor.getBody());return $_bisgdu27jk26xf4o.descendants(body,'['+dataAnnotationId()+'="'+uid+'"]');};var findAll=function findAll(editor,name){var body=Element$$1.fromDom(editor.getBody());var markers=$_bisgdu27jk26xf4o.descendants(body,'['+dataAnnotation()+'="'+name+'"]');var directory={};each(markers,function(m){var uid=$_5xapbx15jk26xewz.get(m,dataAnnotationId());var nodesAlready=directory.hasOwnProperty(uid)?directory[uid]:[];directory[uid]=nodesAlready.concat([m]);});return directory;};var setup=function setup(editor,registry){var changeCallbacks=Cell({});var initData=function initData(){return{listeners:[],previous:Cell(Option.none())};};var withCallbacks=function withCallbacks(name,f){updateCallbacks(name,function(data){f(data);return data;});};var updateCallbacks=function updateCallbacks(name,f){var callbackMap=changeCallbacks.get();var data=callbackMap.hasOwnProperty(name)?callbackMap[name]:initData();var outputData=f(data);callbackMap[name]=outputData;changeCallbacks.set(callbackMap);};var fireCallbacks=function fireCallbacks(name,uid,elements){withCallbacks(name,function(data){each(data.listeners,function(f){return f(true,name,{uid:uid,nodes:map(elements,function(elem){return elem.dom();})});});});};var fireNoAnnotation=function fireNoAnnotation(name){withCallbacks(name,function(data){each(data.listeners,function(f){return f(false,name);});});};var onNodeChange=last$3(function(){var callbackMap=changeCallbacks.get();var annotations=sort(keys(callbackMap));each(annotations,function(name){updateCallbacks(name,function(data){var prev=data.previous.get();identify(editor,Option.some(name)).fold(function(){if(prev.isSome()){fireNoAnnotation(name);data.previous.set(Option.none());}},function(_a){var uid=_a.uid,name=_a.name,elements=_a.elements;if(!prev.is(uid)){fireCallbacks(name,uid,elements);data.previous.set(Option.some(uid));}});return{previous:data.previous,listeners:data.listeners};});});},30);editor.on('remove',function(){onNodeChange.cancel();});editor.on('nodeChange',function(){onNodeChange.throttle();});var addListener=function addListener(name,f){updateCallbacks(name,function(data){return{previous:data.previous,listeners:data.listeners.concat([f])};});};return{addListener:addListener};};var setup$1=function setup$1(editor,registry){var identifyParserNode=function identifyParserNode(span){var optAnnotation=Option.from(span.attributes.map[dataAnnotation()]);return optAnnotation.bind(registry.lookup);};editor.on('init',function(){editor.serializer.addNodeFilter('span',function(spans){each(spans,function(span){identifyParserNode(span).each(function(settings){if(settings.persistent===false){span.unwrap();}});});});});};var create$1=function create$1(){var annotations={};var register=function register(name,settings){annotations[name]={name:name,settings:settings};};var lookup=function lookup(name){return annotations.hasOwnProperty(name)?Option.from(annotations[name]).map(function(a){return a.settings;}):Option.none();};return{register:register,lookup:lookup};};var unique=0;var generate=function generate(prefix){var date=new Date();var time=date.getTime();var random=Math.floor(Math.random()*1000000000);unique++;return prefix+'_'+random+unique+String(time);};var add$3=function add$3(element,classes){each(classes,function(x){$_38pgzm23jk26xf42.add(element,x);});};var remove$6=function remove$6(element,classes){each(classes,function(x){$_38pgzm23jk26xf42.remove(element,x);});};var toggle$2=function toggle$2(element,classes){each(classes,function(x){$_38pgzm23jk26xf42.toggle(element,x);});};var hasAll=function hasAll(element,classes){return forall(classes,function(clazz){return $_38pgzm23jk26xf42.has(element,clazz);});};var hasAny=function hasAny(element,classes){return exists(classes,function(clazz){return $_38pgzm23jk26xf42.has(element,clazz);});};var getNative=function getNative(element){var classList=element.dom().classList;var r=new Array(classList.length);for(var i=0;i<classList.length;i++){r[i]=classList.item(i);}return r;};var get$3=function get$3(element){return $_296o5z25jk26xf47.supports(element)?getNative(element):$_296o5z25jk26xf47.get(element);};var $_gtb8a2hjk26xf6d={add:add$3,remove:remove$6,toggle:toggle$2,hasAll:hasAll,hasAny:hasAny,get:get$3};var clone$1=function clone$1(original,deep){return Element$$1.fromDom(original.dom().cloneNode(deep));};var shallow=function shallow(original){return clone$1(original,false);};var deep=function deep(original){return clone$1(original,true);};var shallowAs=function shallowAs(original,tag){var nu=Element$$1.fromTag(tag);var attributes=$_5xapbx15jk26xewz.clone(original);$_5xapbx15jk26xewz.setAll(nu,attributes);return nu;};var copy$1=function copy$1(original,tag){var nu=shallowAs(original,tag);var cloneChildren=$_2i1q6518jk26xexk.children(deep(original));$_2ykrq21xjk26xf2x.append(nu,cloneChildren);return nu;};var mutate=function mutate(original,tag){var nu=shallowAs(original,tag);$_9t36rc1yjk26xf33.before(original,nu);var children=$_2i1q6518jk26xexk.children(original);$_2ykrq21xjk26xf2x.append(nu,children);$_5ur14v1wjk26xf2q.remove(original);return nu;};var $_39bcz42ijk26xf6i={shallow:shallow,shallowAs:shallowAs,deep:deep,copy:copy$1,mutate:mutate};var slice$3=[].slice;var constant$1=function constant$1(value){return function(){return value;};};var negate=function negate(predicate){return function(x){return!predicate(x);};};var compose$2=function compose$2(f,g){return function(x){return f(g(x));};};var or=function or(){var x=[];for(var _i=0;_i<arguments.length;_i++){x[_i]=arguments[_i];}var args=slice$3.call(arguments);return function(x){for(var i=0;i<args.length;i++){if(args[i](x)){return true;}}return false;};};var and=function and(){var x=[];for(var _i=0;_i<arguments.length;_i++){x[_i]=arguments[_i];}var args=slice$3.call(arguments);return function(x){for(var i=0;i<args.length;i++){if(!args[i](x)){return false;}}return true;};};var curry$1=function curry$1(fn){var x=[];for(var _i=1;_i<arguments.length;_i++){x[_i-1]=arguments[_i];}var args=slice$3.call(arguments);if(args.length-1>=fn.length){return fn.apply(this,args.slice(1));}return function(){var tempArgs=args.concat([].slice.call(arguments));return curry$1.apply(this,tempArgs);};};var noop$1=function noop$1(){};var $_a86i182ljk26xf77={constant:constant$1,negate:negate,and:and,or:or,curry:curry$1,compose:compose$2,noop:noop$1};var ZWSP='\uFEFF';var isZwsp=function isZwsp(chr){return chr===ZWSP;};var trim$3=function trim$3(text){return text.replace(new RegExp(ZWSP,'g'),'');};var $_4osibw2pjk26xf83={isZwsp:isZwsp,ZWSP:ZWSP,trim:trim$3};var isElement$2=$_fpgwqg1rjk26xf0n.isElement;var isText$2=$_fpgwqg1rjk26xf0n.isText;var isCaretContainerBlock=function isCaretContainerBlock(node){if(isText$2(node)){node=node.parentNode;}return isElement$2(node)&&node.hasAttribute('data-mce-caret');};var isCaretContainerInline=function isCaretContainerInline(node){return isText$2(node)&&$_4osibw2pjk26xf83.isZwsp(node.data);};var isCaretContainer=function isCaretContainer(node){return isCaretContainerBlock(node)||isCaretContainerInline(node);};var hasContent=function hasContent(node){return node.firstChild!==node.lastChild||!$_fpgwqg1rjk26xf0n.isBr(node.firstChild);};var insertInline=function insertInline(node,before){var doc,sibling,textNode,parentNode;doc=node.ownerDocument;textNode=doc.createTextNode($_4osibw2pjk26xf83.ZWSP);parentNode=node.parentNode;if(!before){sibling=node.nextSibling;if(isText$2(sibling)){if(isCaretContainer(sibling)){return sibling;}if(startsWithCaretContainer(sibling)){sibling.splitText(1);return sibling;}}if(node.nextSibling){parentNode.insertBefore(textNode,node.nextSibling);}else{parentNode.appendChild(textNode);}}else{sibling=node.previousSibling;if(isText$2(sibling)){if(isCaretContainer(sibling)){return sibling;}if(endsWithCaretContainer(sibling)){return sibling.splitText(sibling.data.length-1);}}parentNode.insertBefore(textNode,node);}return textNode;};var isBeforeInline=function isBeforeInline(pos){var container=pos.container();return pos&&$_fpgwqg1rjk26xf0n.isText(container)&&container.data.charAt(pos.offset())===$_4osibw2pjk26xf83.ZWSP;};var isAfterInline=function isAfterInline(pos){var container=pos.container();return pos&&$_fpgwqg1rjk26xf0n.isText(container)&&container.data.charAt(pos.offset()-1)===$_4osibw2pjk26xf83.ZWSP;};var createBogusBr=function createBogusBr(){var br=document.createElement('br');br.setAttribute('data-mce-bogus','1');return br;};var insertBlock=function insertBlock(blockName,node,before){var doc,blockNode,parentNode;doc=node.ownerDocument;blockNode=doc.createElement(blockName);blockNode.setAttribute('data-mce-caret',before?'before':'after');blockNode.setAttribute('data-mce-bogus','all');blockNode.appendChild(createBogusBr());parentNode=node.parentNode;if(!before){if(node.nextSibling){parentNode.insertBefore(blockNode,node.nextSibling);}else{parentNode.appendChild(blockNode);}}else{parentNode.insertBefore(blockNode,node);}return blockNode;};var startsWithCaretContainer=function startsWithCaretContainer(node){return isText$2(node)&&node.data[0]===$_4osibw2pjk26xf83.ZWSP;};var endsWithCaretContainer=function endsWithCaretContainer(node){return isText$2(node)&&node.data[node.data.length-1]===$_4osibw2pjk26xf83.ZWSP;};var trimBogusBr=function trimBogusBr(elm){var brs=elm.getElementsByTagName('br');var lastBr=brs[brs.length-1];if($_fpgwqg1rjk26xf0n.isBogus(lastBr)){lastBr.parentNode.removeChild(lastBr);}};var showCaretContainerBlock=function showCaretContainerBlock(caretContainer){if(caretContainer&&caretContainer.hasAttribute('data-mce-caret')){trimBogusBr(caretContainer);caretContainer.removeAttribute('data-mce-caret');caretContainer.removeAttribute('data-mce-bogus');caretContainer.removeAttribute('style');caretContainer.removeAttribute('_moz_abspos');return caretContainer;}return null;};var isRangeInCaretContainerBlock=function isRangeInCaretContainerBlock(range){return isCaretContainerBlock(range.startContainer);};var isContentEditableTrue$1=$_fpgwqg1rjk26xf0n.isContentEditableTrue;var isContentEditableFalse$1=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isBr$2=$_fpgwqg1rjk26xf0n.isBr;var isText$3=$_fpgwqg1rjk26xf0n.isText;var isInvalidTextElement=$_fpgwqg1rjk26xf0n.matchNodeNames('script style textarea');var isAtomicInline=$_fpgwqg1rjk26xf0n.matchNodeNames('img input textarea hr iframe video audio object');var isTable$1=$_fpgwqg1rjk26xf0n.matchNodeNames('table');var isCaretContainer$1=isCaretContainer;var isCaretCandidate=function isCaretCandidate(node){if(isCaretContainer$1(node)){return false;}if(isText$3(node)){if(isInvalidTextElement(node.parentNode)){return false;}return true;}return isAtomicInline(node)||isBr$2(node)||isTable$1(node)||isNonUiContentEditableFalse(node);};var isUnselectable=function isUnselectable(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&node.getAttribute('unselectable')==='true';};var isNonUiContentEditableFalse=function isNonUiContentEditableFalse(node){return isUnselectable(node)===false&&isContentEditableFalse$1(node);};var isInEditable=function isInEditable(node,root){for(node=node.parentNode;node&&node!==root;node=node.parentNode){if(isNonUiContentEditableFalse(node)){return false;}if(isContentEditableTrue$1(node)){return true;}}return true;};var isAtomicContentEditableFalse=function isAtomicContentEditableFalse(node){if(!isNonUiContentEditableFalse(node)){return false;}return $_98exydmjk26xeto.reduce(node.getElementsByTagName('*'),function(result,elm){return result||isContentEditableTrue$1(elm);},false)!==true;};var isAtomic=function isAtomic(node){return isAtomicInline(node)||isAtomicContentEditableFalse(node);};var isEditableCaretCandidate=function isEditableCaretCandidate(node,root){return isCaretCandidate(node)&&isInEditable(node,root);};var round=Math.round;var clone$2=function clone$2(rect){if(!rect){return{left:0,top:0,bottom:0,right:0,width:0,height:0};}return{left:round(rect.left),top:round(rect.top),bottom:round(rect.bottom),right:round(rect.right),width:round(rect.width),height:round(rect.height)};};var collapse=function collapse(rect,toStart){rect=clone$2(rect);if(toStart){rect.right=rect.left;}else{rect.left=rect.left+rect.width;rect.right=rect.left;}rect.width=0;return rect;};var isEqual=function isEqual(rect1,rect2){return rect1.left===rect2.left&&rect1.top===rect2.top&&rect1.bottom===rect2.bottom&&rect1.right===rect2.right;};var isValidOverflow=function isValidOverflow(overflowY,rect1,rect2){return overflowY>=0&&overflowY<=Math.min(rect1.height,rect2.height)/2;};var isAbove=function isAbove(rect1,rect2){if(rect1.bottom-rect1.height/2<rect2.top){return true;}if(rect1.top>rect2.bottom){return false;}return isValidOverflow(rect2.top-rect1.bottom,rect1,rect2);};var isBelow=function isBelow(rect1,rect2){if(rect1.top>rect2.bottom){return true;}if(rect1.bottom<rect2.top){return false;}return isValidOverflow(rect2.bottom-rect1.top,rect1,rect2);};var containsXY=function containsXY(rect,clientX,clientY){return clientX>=rect.left&&clientX<=rect.right&&clientY>=rect.top&&clientY<=rect.bottom;};var overflowX=function overflowX(outer,inner){if(inner.left>outer.left&&inner.right<outer.right){return 0;}else{return inner.left<outer.left?inner.left-outer.left:inner.right-outer.right;}};var overflowY=function overflowY(outer,inner){if(inner.top>outer.top&&inner.bottom<outer.bottom){return 0;}else{return inner.top<outer.top?inner.top-outer.top:inner.bottom-outer.bottom;}};var getOverflow=function getOverflow(outer,inner){return{x:overflowX(outer,inner),y:overflowY(outer,inner)};};var getSelectedNode=function getSelectedNode(range){var startContainer=range.startContainer,startOffset=range.startOffset;if(startContainer.hasChildNodes()&&range.endOffset===startOffset+1){return startContainer.childNodes[startOffset];}return null;};var getNode=function getNode(container,offset){if(container.nodeType===1&&container.hasChildNodes()){if(offset>=container.childNodes.length){offset=container.childNodes.length-1;}container=container.childNodes[offset];}return container;};var extendingChars=new RegExp('[\u0300-\u036F\u0483-\u0487\u0488-\u0489\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A'+'\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0'+'\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C'+'\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2-\u09E3'+'\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC'+'\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B57'+'\u0B62-\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56'+'\u0C62-\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC-\u0CCD\u0CD5-\u0CD6\u0CE2-\u0CE3\u0D01\u0D3E\u0D41-\u0D44'+'\u0D4D\u0D57\u0D62-\u0D63\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9'+'\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97'+'\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074'+'\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5'+'\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18'+'\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABE\u1B00-\u1B03\u1B34'+'\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8-\u1BE9'+'\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8-\u1CF9'+'\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C-\u200D\u20D0-\u20DC\u20DD-\u20E0\u20E1\u20E2-\u20E4\u20E5-\u20F0\u2CEF-\u2CF1'+'\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u302E-\u302F\u3099-\u309A\uA66F\uA670-\uA672\uA674-\uA67D\uA69E-\uA69F\uA6F0-\uA6F1'+'\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC'+'\uA9E5\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1'+'\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E-\uFF9F]');var isExtendingChar=function isExtendingChar(ch){return typeof ch==='string'&&ch.charCodeAt(0)>=768&&extendingChars.test(ch);};var liftN=function liftN(arr,f){var r=[];for(var i=0;i<arr.length;i++){var x=arr[i];if(x.isSome()){r.push(x.getOrDie());}else{return Option.none();}}return Option.some(f.apply(null,r));};var isElement$3=$_fpgwqg1rjk26xf0n.isElement;var isCaretCandidate$1=isCaretCandidate;var isBlock$1=$_fpgwqg1rjk26xf0n.matchStyleValues('display','block table');var isFloated=$_fpgwqg1rjk26xf0n.matchStyleValues('float','left right');var isValidElementCaretCandidate=$_a86i182ljk26xf77.and(isElement$3,isCaretCandidate$1,$_a86i182ljk26xf77.negate(isFloated));var isNotPre=$_a86i182ljk26xf77.negate($_fpgwqg1rjk26xf0n.matchStyleValues('white-space','pre pre-line pre-wrap'));var isText$4=$_fpgwqg1rjk26xf0n.isText;var isBr$3=$_fpgwqg1rjk26xf0n.isBr;var nodeIndex=DOMUtils$1.nodeIndex;var resolveIndex=getNode;var createRange=function createRange(doc){return'createRange'in doc?doc.createRange():DOMUtils$1.DOM.createRng();};var isWhiteSpace=function isWhiteSpace(chr){return chr&&/[\r\n\t ]/.test(chr);};var isRange=function isRange(rng){return!!rng.setStart&&!!rng.setEnd;};var isHiddenWhiteSpaceRange=function isHiddenWhiteSpaceRange(range$$1){var container=range$$1.startContainer;var offset=range$$1.startOffset;var text;if(isWhiteSpace(range$$1.toString())&&isNotPre(container.parentNode)&&$_fpgwqg1rjk26xf0n.isText(container)){text=container.data;if(isWhiteSpace(text[offset-1])||isWhiteSpace(text[offset+1])){return true;}}return false;};var getBrClientRect=function getBrClientRect(brNode){var doc=brNode.ownerDocument;var rng=createRange(doc);var nbsp=doc.createTextNode('\xA0');var parentNode=brNode.parentNode;var clientRect;parentNode.insertBefore(nbsp,brNode);rng.setStart(nbsp,0);rng.setEnd(nbsp,1);clientRect=clone$2(rng.getBoundingClientRect());parentNode.removeChild(nbsp);return clientRect;};var getBoundingClientRectWebKitText=function getBoundingClientRectWebKitText(rng){var sc=rng.startContainer;var ec=rng.endContainer;var so=rng.startOffset;var eo=rng.endOffset;if(sc===ec&&$_fpgwqg1rjk26xf0n.isText(ec)&&so===0&&eo===1){var newRng=rng.cloneRange();newRng.setEndAfter(ec);return getBoundingClientRect(newRng);}else{return null;}};var isZeroRect=function isZeroRect(r){return r.left===0&&r.right===0&&r.top===0&&r.bottom===0;};var getBoundingClientRect=function getBoundingClientRect(item){var clientRect,clientRects;clientRects=item.getClientRects();if(clientRects.length>0){clientRect=clone$2(clientRects[0]);}else{clientRect=clone$2(item.getBoundingClientRect());}if(!isRange(item)&&isBr$3(item)&&isZeroRect(clientRect)){return getBrClientRect(item);}if(isZeroRect(clientRect)&&isRange(item)){return getBoundingClientRectWebKitText(item);}return clientRect;};var collapseAndInflateWidth=function collapseAndInflateWidth(clientRect,toStart){var newClientRect=collapse(clientRect,toStart);newClientRect.width=1;newClientRect.right=newClientRect.left+1;return newClientRect;};var getCaretPositionClientRects=function getCaretPositionClientRects(caretPosition){var clientRects=[];var beforeNode,node;var addUniqueAndValidRect=function addUniqueAndValidRect(clientRect){if(clientRect.height===0){return;}if(clientRects.length>0){if(isEqual(clientRect,clientRects[clientRects.length-1])){return;}}clientRects.push(clientRect);};var addCharacterOffset=function addCharacterOffset(container,offset){var range$$1=createRange(container.ownerDocument);if(offset<container.data.length){if(isExtendingChar(container.data[offset])){return clientRects;}if(isExtendingChar(container.data[offset-1])){range$$1.setStart(container,offset);range$$1.setEnd(container,offset+1);if(!isHiddenWhiteSpaceRange(range$$1)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range$$1),false));return clientRects;}}}if(offset>0){range$$1.setStart(container,offset-1);range$$1.setEnd(container,offset);if(!isHiddenWhiteSpaceRange(range$$1)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range$$1),false));}}if(offset<container.data.length){range$$1.setStart(container,offset);range$$1.setEnd(container,offset+1);if(!isHiddenWhiteSpaceRange(range$$1)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range$$1),true));}}};if(isText$4(caretPosition.container())){addCharacterOffset(caretPosition.container(),caretPosition.offset());return clientRects;}if(isElement$3(caretPosition.container())){if(caretPosition.isAtEnd()){node=resolveIndex(caretPosition.container(),caretPosition.offset());if(isText$4(node)){addCharacterOffset(node,node.data.length);}if(isValidElementCaretCandidate(node)&&!isBr$3(node)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node),false));}}else{node=resolveIndex(caretPosition.container(),caretPosition.offset());if(isText$4(node)){addCharacterOffset(node,0);}if(isValidElementCaretCandidate(node)&&caretPosition.isAtEnd()){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node),false));return clientRects;}beforeNode=resolveIndex(caretPosition.container(),caretPosition.offset()-1);if(isValidElementCaretCandidate(beforeNode)&&!isBr$3(beforeNode)){if(isBlock$1(beforeNode)||isBlock$1(node)||!isValidElementCaretCandidate(node)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode),false));}}if(isValidElementCaretCandidate(node)){addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node),true));}}}return clientRects;};function CaretPosition(container,offset,clientRects){var isAtStart=function isAtStart(){if(isText$4(container)){return offset===0;}return offset===0;};var isAtEnd=function isAtEnd(){if(isText$4(container)){return offset>=container.data.length;}return offset>=container.childNodes.length;};var toRange=function toRange(){var range$$1;range$$1=createRange(container.ownerDocument);range$$1.setStart(container,offset);range$$1.setEnd(container,offset);return range$$1;};var getClientRects=function getClientRects(){if(!clientRects){clientRects=getCaretPositionClientRects(CaretPosition(container,offset));}return clientRects;};var isVisible=function isVisible(){return getClientRects().length>0;};var isEqual$$1=function isEqual$$1(caretPosition){return caretPosition&&container===caretPosition.container()&&offset===caretPosition.offset();};var getNode$$1=function getNode$$1(before){return resolveIndex(container,before?offset-1:offset);};return{container:$_a86i182ljk26xf77.constant(container),offset:$_a86i182ljk26xf77.constant(offset),toRange:toRange,getClientRects:getClientRects,isVisible:isVisible,isAtStart:isAtStart,isAtEnd:isAtEnd,isEqual:isEqual$$1,getNode:getNode$$1};}(function(CaretPosition){CaretPosition.fromRangeStart=function(range$$1){return CaretPosition(range$$1.startContainer,range$$1.startOffset);};CaretPosition.fromRangeEnd=function(range$$1){return CaretPosition(range$$1.endContainer,range$$1.endOffset);};CaretPosition.after=function(node){return CaretPosition(node.parentNode,nodeIndex(node)+1);};CaretPosition.before=function(node){return CaretPosition(node.parentNode,nodeIndex(node));};CaretPosition.isAbove=function(pos1,pos2){return liftN([head(pos2.getClientRects()),last(pos1.getClientRects())],isAbove).getOr(false);};CaretPosition.isBelow=function(pos1,pos2){return liftN([last(pos2.getClientRects()),head(pos1.getClientRects())],isBelow).getOr(false);};CaretPosition.isAtStart=function(pos){return pos?pos.isAtStart():false;};CaretPosition.isAtEnd=function(pos){return pos?pos.isAtEnd():false;};CaretPosition.isTextPosition=function(pos){return pos?$_fpgwqg1rjk26xf0n.isText(pos.container()):false;};CaretPosition.isElementPosition=function(pos){return CaretPosition.isTextPosition(pos)===false;};})(CaretPosition||(CaretPosition={}));var CaretPosition$1=CaretPosition;var isText$5=$_fpgwqg1rjk26xf0n.isText;var isBogus$1=$_fpgwqg1rjk26xf0n.isBogus;var nodeIndex$1=DOMUtils$1.nodeIndex;var normalizedParent=function normalizedParent(node){var parentNode=node.parentNode;if(isBogus$1(parentNode)){return normalizedParent(parentNode);}return parentNode;};var getChildNodes=function getChildNodes(node){if(!node){return[];}return $_98exydmjk26xeto.reduce(node.childNodes,function(result,node){if(isBogus$1(node)&&node.nodeName!=='BR'){result=result.concat(getChildNodes(node));}else{result.push(node);}return result;},[]);};var normalizedTextOffset=function normalizedTextOffset(node,offset){while(node=node.previousSibling){if(!isText$5(node)){break;}offset+=node.data.length;}return offset;};var equal$1=function equal$1(a){return function(b){return a===b;};};var normalizedNodeIndex=function normalizedNodeIndex(node){var nodes,index,numTextFragments;nodes=getChildNodes(normalizedParent(node));index=$_98exydmjk26xeto.findIndex(nodes,equal$1(node),node);nodes=nodes.slice(0,index+1);numTextFragments=$_98exydmjk26xeto.reduce(nodes,function(result,node,i){if(isText$5(node)&&isText$5(nodes[i-1])){result++;}return result;},0);nodes=$_98exydmjk26xeto.filter(nodes,$_fpgwqg1rjk26xf0n.matchNodeNames(node.nodeName));index=$_98exydmjk26xeto.findIndex(nodes,equal$1(node),node);return index-numTextFragments;};var createPathItem=function createPathItem(node){var name;if(isText$5(node)){name='text()';}else{name=node.nodeName.toLowerCase();}return name+'['+normalizedNodeIndex(node)+']';};var parentsUntil=function parentsUntil(root,node,predicate){var parents=[];for(node=node.parentNode;node!==root;node=node.parentNode){if(predicate&&predicate(node)){break;}parents.push(node);}return parents;};var create$2=function create$2(root,caretPosition){var container,offset,path=[],outputOffset,childNodes,parents;container=caretPosition.container();offset=caretPosition.offset();if(isText$5(container)){outputOffset=normalizedTextOffset(container,offset);}else{childNodes=container.childNodes;if(offset>=childNodes.length){outputOffset='after';offset=childNodes.length-1;}else{outputOffset='before';}container=childNodes[offset];}path.push(createPathItem(container));parents=parentsUntil(root,container);parents=$_98exydmjk26xeto.filter(parents,$_a86i182ljk26xf77.negate($_fpgwqg1rjk26xf0n.isBogus));path=path.concat($_98exydmjk26xeto.map(parents,function(node){return createPathItem(node);}));return path.reverse().join('/')+','+outputOffset;};var resolvePathItem=function resolvePathItem(node,name,index){var nodes=getChildNodes(node);nodes=$_98exydmjk26xeto.filter(nodes,function(node,index){return!isText$5(node)||!isText$5(nodes[index-1]);});nodes=$_98exydmjk26xeto.filter(nodes,$_fpgwqg1rjk26xf0n.matchNodeNames(name));return nodes[index];};var findTextPosition=function findTextPosition(container,offset){var node=container,targetOffset=0,dataLen;while(isText$5(node)){dataLen=node.data.length;if(offset>=targetOffset&&offset<=targetOffset+dataLen){container=node;offset=offset-targetOffset;break;}if(!isText$5(node.nextSibling)){container=node;offset=dataLen;break;}targetOffset+=dataLen;node=node.nextSibling;}if(isText$5(container)&&offset>container.data.length){offset=container.data.length;}return CaretPosition$1(container,offset);};var resolve$2=function resolve$2(root,path){var parts,container,offset;if(!path){return null;}parts=path.split(',');path=parts[0].split('/');offset=parts.length>1?parts[1]:'before';container=$_98exydmjk26xeto.reduce(path,function(result,value){value=/([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);if(!value){return null;}if(value[1]==='text()'){value[1]='#text';}return resolvePathItem(result,value[1],parseInt(value[2],10));},root);if(!container){return null;}if(!isText$5(container)){if(offset==='after'){offset=nodeIndex$1(container)+1;}else{offset=nodeIndex$1(container);}return CaretPosition$1(container.parentNode,offset);}return findTextPosition(container,parseInt(offset,10));};var isContentEditableFalse$2=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var getNormalizedTextOffset=function getNormalizedTextOffset(trim,container,offset){var node,trimmedOffset;trimmedOffset=trim(container.data.slice(0,offset)).length;for(node=container.previousSibling;node&&$_fpgwqg1rjk26xf0n.isText(node);node=node.previousSibling){trimmedOffset+=trim(node.data).length;}return trimmedOffset;};var getPoint=function getPoint(dom,trim,normalized,rng,start){var container=rng[start?'startContainer':'endContainer'];var offset=rng[start?'startOffset':'endOffset'];var point=[];var childNodes,after=0;var root=dom.getRoot();if($_fpgwqg1rjk26xf0n.isText(container)){point.push(normalized?getNormalizedTextOffset(trim,container,offset):offset);}else{childNodes=container.childNodes;if(offset>=childNodes.length&&childNodes.length){after=1;offset=Math.max(0,childNodes.length-1);}point.push(dom.nodeIndex(childNodes[offset],normalized)+after);}for(;container&&container!==root;container=container.parentNode){point.push(dom.nodeIndex(container,normalized));}return point;};var getLocation=function getLocation(trim,selection,normalized,rng){var dom=selection.dom,bookmark={};bookmark.start=getPoint(dom,trim,normalized,rng,true);if(!selection.isCollapsed()){bookmark.end=getPoint(dom,trim,normalized,rng,false);}return bookmark;};var trimEmptyTextNode=function trimEmptyTextNode(node){if($_fpgwqg1rjk26xf0n.isText(node)&&node.data.length===0){node.parentNode.removeChild(node);}};var findIndex$3=function findIndex$3(dom,name,element){var count=0;$_2ytxahljk26xetf.each(dom.select(name),function(node){if(node.getAttribute('data-mce-bogus')==='all'){return;}if(node===element){return false;}count++;});return count;};var moveEndPoint=function moveEndPoint(rng,start){var container,offset,childNodes;var prefix=start?'start':'end';container=rng[prefix+'Container'];offset=rng[prefix+'Offset'];if($_fpgwqg1rjk26xf0n.isElement(container)&&container.nodeName==='TR'){childNodes=container.childNodes;container=childNodes[Math.min(start?offset:offset-1,childNodes.length-1)];if(container){offset=start?0:container.childNodes.length;rng['set'+(start?'Start':'End')](container,offset);}}};var normalizeTableCellSelection=function normalizeTableCellSelection(rng){moveEndPoint(rng,true);moveEndPoint(rng,false);return rng;};var findSibling=function findSibling(node,offset){var sibling;if($_fpgwqg1rjk26xf0n.isElement(node)){node=getNode(node,offset);if(isContentEditableFalse$2(node)){return node;}}if(isCaretContainer(node)){if($_fpgwqg1rjk26xf0n.isText(node)&&isCaretContainerBlock(node)){node=node.parentNode;}sibling=node.previousSibling;if(isContentEditableFalse$2(sibling)){return sibling;}sibling=node.nextSibling;if(isContentEditableFalse$2(sibling)){return sibling;}}};var findAdjacentContentEditableFalseElm=function findAdjacentContentEditableFalseElm(rng){return findSibling(rng.startContainer,rng.startOffset)||findSibling(rng.endContainer,rng.endOffset);};var getOffsetBookmark=function getOffsetBookmark(trim,normalized,selection){var element=selection.getNode();var name=element?element.nodeName:null;var rng=selection.getRng();if(isContentEditableFalse$2(element)||name==='IMG'){return{name:name,index:findIndex$3(selection.dom,name,element)};}var sibling=findAdjacentContentEditableFalseElm(rng);if(sibling){name=sibling.tagName;return{name:name,index:findIndex$3(selection.dom,name,sibling)};}return getLocation(trim,selection,normalized,rng);};var getCaretBookmark=function getCaretBookmark(selection){var rng=selection.getRng();return{start:create$2(selection.dom.getRoot(),CaretPosition$1.fromRangeStart(rng)),end:create$2(selection.dom.getRoot(),CaretPosition$1.fromRangeEnd(rng))};};var getRangeBookmark=function getRangeBookmark(selection){return{rng:selection.getRng()};};var createBookmarkSpan=function createBookmarkSpan(dom,id,filled){var args={'data-mce-type':'bookmark','id':id,'style':'overflow:hidden;line-height:0px'};return filled?dom.create('span',args,'&#xFEFF;'):dom.create('span',args);};var getPersistentBookmark=function getPersistentBookmark(selection,filled){var dom=selection.dom;var rng=selection.getRng();var id=dom.uniqueId();var collapsed=selection.isCollapsed();var element=selection.getNode();var name=element.nodeName;if(name==='IMG'){return{name:name,index:findIndex$3(dom,name,element)};}var rng2=normalizeTableCellSelection(rng.cloneRange());if(!collapsed){rng2.collapse(false);var endBookmarkNode=createBookmarkSpan(dom,id+'_end',filled);rng2.insertNode(endBookmarkNode);trimEmptyTextNode(endBookmarkNode.nextSibling);}rng=normalizeTableCellSelection(rng);rng.collapse(true);var startBookmarkNode=createBookmarkSpan(dom,id+'_start',filled);rng.insertNode(startBookmarkNode);trimEmptyTextNode(startBookmarkNode.previousSibling);selection.moveToBookmark({id:id,keep:1});return{id:id};};var getBookmark=function getBookmark(selection,type,normalized){if(type===2){return getOffsetBookmark($_4osibw2pjk26xf83.trim,normalized,selection);}else if(type===3){return getCaretBookmark(selection);}else if(type){return getRangeBookmark(selection);}else{return getPersistentBookmark(selection,false);}};var $_ci8rza2jjk26xf6s={getBookmark:getBookmark,getUndoBookmark:curry(getOffsetBookmark,identity,true),getPersistentBookmark:getPersistentBookmark};var CARET_ID='_mce_caret';var isCaretNode=function isCaretNode(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&node.id===CARET_ID;};var getParentCaretContainer=function getParentCaretContainer(body,node){while(node&&node!==body){if(node.id===CARET_ID){return node;}node=node.parentNode;}return null;};var isElement$4=$_fpgwqg1rjk26xf0n.isElement;var isText$6=$_fpgwqg1rjk26xf0n.isText;var removeNode=function removeNode(node){var parentNode=node.parentNode;if(parentNode){parentNode.removeChild(node);}};var getNodeValue=function getNodeValue(node){try{return node.nodeValue;}catch(ex){return'';}};var setNodeValue=function setNodeValue(node,text){if(text.length===0){removeNode(node);}else{node.nodeValue=text;}};var trimCount=function trimCount(text){var trimmedText=$_4osibw2pjk26xf83.trim(text);return{count:text.length-trimmedText.length,text:trimmedText};};var removeUnchanged=function removeUnchanged(caretContainer,pos){remove$7(caretContainer);return pos;};var removeTextAndReposition=function removeTextAndReposition(caretContainer,pos){var before=trimCount(caretContainer.data.substr(0,pos.offset()));var after=trimCount(caretContainer.data.substr(pos.offset()));var text=before.text+after.text;if(text.length>0){setNodeValue(caretContainer,text);return CaretPosition$1(caretContainer,pos.offset()-before.count);}else{return pos;}};var removeElementAndReposition=function removeElementAndReposition(caretContainer,pos){var parentNode=pos.container();var newPosition=indexOf(from$1(parentNode.childNodes),caretContainer).map(function(index){return index<pos.offset()?CaretPosition$1(parentNode,pos.offset()-1):pos;}).getOr(pos);remove$7(caretContainer);return newPosition;};var removeTextCaretContainer=function removeTextCaretContainer(caretContainer,pos){return isText$6(caretContainer)&&pos.container()===caretContainer?removeTextAndReposition(caretContainer,pos):removeUnchanged(caretContainer,pos);};var removeElementCaretContainer=function removeElementCaretContainer(caretContainer,pos){return pos.container()===caretContainer.parentNode?removeElementAndReposition(caretContainer,pos):removeUnchanged(caretContainer,pos);};var removeAndReposition=function removeAndReposition(container,pos){return CaretPosition$1.isTextPosition(pos)?removeTextCaretContainer(container,pos):removeElementCaretContainer(container,pos);};var remove$7=function remove$7(caretContainerNode){if(isElement$4(caretContainerNode)&&isCaretContainer(caretContainerNode)){if(hasContent(caretContainerNode)){caretContainerNode.removeAttribute('data-mce-caret');}else{removeNode(caretContainerNode);}}if(isText$6(caretContainerNode)){var text=$_4osibw2pjk26xf83.trim(getNodeValue(caretContainerNode));setNodeValue(caretContainerNode,text);}};var $_f7uyam31jk26xfaa={removeAndReposition:removeAndReposition,remove:remove$7};var isContentEditableTrue$2=$_fpgwqg1rjk26xf0n.isContentEditableTrue;var isContentEditableFalse$3=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var showCaret=function showCaret(direction,editor,node,before,scrollIntoView){return editor._selectionOverrides.showCaret(direction,node,before,scrollIntoView);};var getNodeRange=function getNodeRange(node){var rng=node.ownerDocument.createRange();rng.selectNode(node);return rng;};var selectNode=function selectNode(editor,node){var e=editor.fire('BeforeObjectSelected',{target:node});if(e.isDefaultPrevented()){return null;}return getNodeRange(node);};var renderCaretAtRange=function renderCaretAtRange(editor,range,scrollIntoView){var normalizedRange=normalizeRange(1,editor.getBody(),range);var caretPosition=CaretPosition$1.fromRangeStart(normalizedRange);var caretPositionNode=caretPosition.getNode();if(isContentEditableFalse$3(caretPositionNode)){return showCaret(1,editor,caretPositionNode,!caretPosition.isAtEnd(),false);}var caretPositionBeforeNode=caretPosition.getNode(true);if(isContentEditableFalse$3(caretPositionBeforeNode)){return showCaret(1,editor,caretPositionBeforeNode,false,false);}var ceRoot=editor.dom.getParent(caretPosition.getNode(),function(node){return isContentEditableFalse$3(node)||isContentEditableTrue$2(node);});if(isContentEditableFalse$3(ceRoot)){return showCaret(1,editor,ceRoot,false,scrollIntoView);}return null;};var renderRangeCaret=function renderRangeCaret(editor,range,scrollIntoView){if(!range||!range.collapsed){return range;}var caretRange=renderCaretAtRange(editor,range,scrollIntoView);if(caretRange){return caretRange;}return range;};var HDirection;(function(HDirection){HDirection[HDirection['Backwards']=-1]='Backwards';HDirection[HDirection['Forwards']=1]='Forwards';})(HDirection||(HDirection={}));var isContentEditableFalse$4=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isText$7=$_fpgwqg1rjk26xf0n.isText;var isElement$5=$_fpgwqg1rjk26xf0n.isElement;var isBr$4=$_fpgwqg1rjk26xf0n.isBr;var isCaretCandidate$2=isCaretCandidate;var isAtomic$1=isAtomic;var isEditableCaretCandidate$1=isEditableCaretCandidate;var getParents=function getParents(node,root){var parents=[];while(node&&node!==root){parents.push(node);node=node.parentNode;}return parents;};var nodeAtIndex=function nodeAtIndex(container,offset){if(container.hasChildNodes()&&offset<container.childNodes.length){return container.childNodes[offset];}return null;};var getCaretCandidatePosition=function getCaretCandidatePosition(direction,node){if(isForwards(direction)){if(isCaretCandidate$2(node.previousSibling)&&!isText$7(node.previousSibling)){return CaretPosition$1.before(node);}if(isText$7(node)){return CaretPosition$1(node,0);}}if(isBackwards(direction)){if(isCaretCandidate$2(node.nextSibling)&&!isText$7(node.nextSibling)){return CaretPosition$1.after(node);}if(isText$7(node)){return CaretPosition$1(node,node.data.length);}}if(isBackwards(direction)){if(isBr$4(node)){return CaretPosition$1.before(node);}return CaretPosition$1.after(node);}return CaretPosition$1.before(node);};var isBrBeforeBlock=function isBrBeforeBlock(node,root){var next;if(!$_fpgwqg1rjk26xf0n.isBr(node)){return false;}next=findCaretPosition(1,CaretPosition$1.after(node),root);if(!next){return false;}return!isInSameBlock(CaretPosition$1.before(node),CaretPosition$1.before(next),root);};var findCaretPosition=function findCaretPosition(direction,startPos,root){var node,nextNode,innerNode;var rootContentEditableFalseElm,caretPosition;if(!isElement$5(root)||!startPos){return null;}if(startPos.isEqual(CaretPosition$1.after(root))&&root.lastChild){caretPosition=CaretPosition$1.after(root.lastChild);if(isBackwards(direction)&&isCaretCandidate$2(root.lastChild)&&isElement$5(root.lastChild)){return isBr$4(root.lastChild)?CaretPosition$1.before(root.lastChild):caretPosition;}}else{caretPosition=startPos;}var container=caretPosition.container();var offset=caretPosition.offset();if(isText$7(container)){if(isBackwards(direction)&&offset>0){return CaretPosition$1(container,--offset);}if(isForwards(direction)&&offset<container.length){return CaretPosition$1(container,++offset);}node=container;}else{if(isBackwards(direction)&&offset>0){nextNode=nodeAtIndex(container,offset-1);if(isCaretCandidate$2(nextNode)){if(!isAtomic$1(nextNode)){innerNode=findNode(nextNode,direction,isEditableCaretCandidate$1,nextNode);if(innerNode){if(isText$7(innerNode)){return CaretPosition$1(innerNode,innerNode.data.length);}return CaretPosition$1.after(innerNode);}}if(isText$7(nextNode)){return CaretPosition$1(nextNode,nextNode.data.length);}return CaretPosition$1.before(nextNode);}}if(isForwards(direction)&&offset<container.childNodes.length){nextNode=nodeAtIndex(container,offset);if(isCaretCandidate$2(nextNode)){if(isBr$4(nextNode)&&root.lastChild===nextNode){return null;}if(isBrBeforeBlock(nextNode,root)){return findCaretPosition(direction,CaretPosition$1.after(nextNode),root);}if(!isAtomic$1(nextNode)){innerNode=findNode(nextNode,direction,isEditableCaretCandidate$1,nextNode);if(innerNode){if(isText$7(innerNode)){return CaretPosition$1(innerNode,0);}return CaretPosition$1.before(innerNode);}}if(isText$7(nextNode)){return CaretPosition$1(nextNode,0);}return CaretPosition$1.after(nextNode);}}node=nextNode?nextNode:caretPosition.getNode();}if(isForwards(direction)&&caretPosition.isAtEnd()||isBackwards(direction)&&caretPosition.isAtStart()){node=findNode(node,direction,$_a86i182ljk26xf77.constant(true),root,true);if(isEditableCaretCandidate$1(node,root)){return getCaretCandidatePosition(direction,node);}}nextNode=findNode(node,direction,isEditableCaretCandidate$1,root);rootContentEditableFalseElm=$_98exydmjk26xeto.last($_98exydmjk26xeto.filter(getParents(container,root),isContentEditableFalse$4));if(rootContentEditableFalseElm&&(!nextNode||!rootContentEditableFalseElm.contains(nextNode))){if(isForwards(direction)){caretPosition=CaretPosition$1.after(rootContentEditableFalseElm);}else{caretPosition=CaretPosition$1.before(rootContentEditableFalseElm);}return caretPosition;}if(nextNode){return getCaretCandidatePosition(direction,nextNode);}return null;};var CaretWalker=function CaretWalker(root){return{next:function next(caretPosition){return findCaretPosition(HDirection.Forwards,caretPosition,root);},prev:function prev(caretPosition){return findCaretPosition(HDirection.Backwards,caretPosition,root);}};};var BreakType;(function(BreakType){BreakType[BreakType['Br']=0]='Br';BreakType[BreakType['Block']=1]='Block';BreakType[BreakType['Wrap']=2]='Wrap';BreakType[BreakType['Eol']=3]='Eol';})(BreakType||(BreakType={}));var flip=function flip(direction,positions){return direction===HDirection.Backwards?positions.reverse():positions;};var walk$1=function walk$1(direction,caretWalker,pos){return direction===HDirection.Forwards?caretWalker.next(pos):caretWalker.prev(pos);};var getBreakType=function getBreakType(scope,direction,currentPos,nextPos){if($_fpgwqg1rjk26xf0n.isBr(nextPos.getNode(direction===HDirection.Forwards))){return BreakType.Br;}else if(isInSameBlock(currentPos,nextPos)===false){return BreakType.Block;}else{return BreakType.Wrap;}};var getPositionsUntil=function getPositionsUntil(predicate,direction,scope,start){var caretWalker=CaretWalker(scope);var currentPos=start,nextPos;var positions=[];while(currentPos){nextPos=walk$1(direction,caretWalker,currentPos);if(!nextPos){break;}if($_fpgwqg1rjk26xf0n.isBr(nextPos.getNode(false))){if(direction===HDirection.Forwards){return{positions:flip(direction,positions).concat([nextPos]),breakType:BreakType.Br,breakAt:Option.some(nextPos)};}else{return{positions:flip(direction,positions),breakType:BreakType.Br,breakAt:Option.some(nextPos)};}}if(!nextPos.isVisible()){currentPos=nextPos;continue;}if(predicate(currentPos,nextPos)){var breakType=getBreakType(scope,direction,currentPos,nextPos);return{positions:flip(direction,positions),breakType:breakType,breakAt:Option.some(nextPos)};}positions.push(nextPos);currentPos=nextPos;}return{positions:flip(direction,positions),breakType:BreakType.Eol,breakAt:Option.none()};};var getAdjacentLinePositions=function getAdjacentLinePositions(direction,getPositionsUntilBreak,scope,start){return getPositionsUntilBreak(scope,start).breakAt.map(function(pos){var positions=getPositionsUntilBreak(scope,pos).positions;return direction===HDirection.Backwards?positions.concat(pos):[pos].concat(positions);}).getOr([]);};var findClosestHorizontalPositionFromPoint=function findClosestHorizontalPositionFromPoint(positions,x){return foldl(positions,function(acc,newPos){return acc.fold(function(){return Option.some(newPos);},function(lastPos){return liftN([head(lastPos.getClientRects()),head(newPos.getClientRects())],function(lastRect,newRect){var lastDist=Math.abs(x-lastRect.left);var newDist=Math.abs(x-newRect.left);return newDist<=lastDist?newPos:lastPos;}).or(acc);});},Option.none());};var findClosestHorizontalPosition=function findClosestHorizontalPosition(positions,pos){return head(pos.getClientRects()).bind(function(targetRect){return findClosestHorizontalPositionFromPoint(positions,targetRect.left);});};var getPositionsUntilPreviousLine=curry(getPositionsUntil,CaretPosition.isAbove,-1);var getPositionsUntilNextLine=curry(getPositionsUntil,CaretPosition.isBelow,1);var getPositionsAbove=curry(getAdjacentLinePositions,-1,getPositionsUntilPreviousLine);var getPositionsBelow=curry(getAdjacentLinePositions,1,getPositionsUntilNextLine);var getFirstLinePositions=function getFirstLinePositions(scope){return $_bwopbb2yjk26xf9h.firstPositionIn(scope).map(function(pos){return[pos].concat(getPositionsUntilNextLine(scope,pos).positions);}).getOr([]);};var getLastLinePositions=function getLastLinePositions(scope){return $_bwopbb2yjk26xf9h.lastPositionIn(scope).map(function(pos){return getPositionsUntilPreviousLine(scope,pos).positions.concat(pos);}).getOr([]);};var deflate=function deflate(rect,delta){return{left:rect.left-delta,top:rect.top-delta,right:rect.right+delta*2,bottom:rect.bottom+delta*2,width:rect.width+delta,height:rect.height+delta};};var getCorners=function getCorners(getYAxisValue,tds){return bind(tds,function(td){var rect=deflate(td.getBoundingClientRect(),-1);return[{x:rect.left,y:getYAxisValue(rect),cell:td},{x:rect.right,y:getYAxisValue(rect),cell:td}];});};var findClosestCorner=function findClosestCorner(corners,x,y){return foldl(corners,function(acc,newCorner){return acc.fold(function(){return Option.some(newCorner);},function(oldCorner){var oldDist=Math.sqrt(Math.abs(oldCorner.x-x)+Math.abs(oldCorner.y-y));var newDist=Math.sqrt(Math.abs(newCorner.x-x)+Math.abs(newCorner.y-y));return Option.some(newDist<oldDist?newCorner:oldCorner);});},Option.none());};var getClosestCell=function getClosestCell(getYAxisValue,isTargetCorner,table,x,y){var cells=$_bisgdu27jk26xf4o.descendants(Element$$1.fromDom(table),'td,th').map(function(e){return e.dom();});var corners=filter(getCorners(getYAxisValue,cells),function(corner){return isTargetCorner(corner,y);});return findClosestCorner(corners,x,y).map(function(corner){return corner.cell;});};var getBottomValue=function getBottomValue(rect){return rect.bottom;};var getTopValue=function getTopValue(rect){return rect.top;};var isAbove$1=function isAbove$1(corner,y){return corner.y<y;};var isBelow$1=function isBelow$1(corner,y){return corner.y>y;};var getClosestCellAbove=curry(getClosestCell,getBottomValue,isAbove$1);var getClosestCellBelow=curry(getClosestCell,getTopValue,isBelow$1);var findClosestPositionInAboveCell=function findClosestPositionInAboveCell(table,pos){return head(pos.getClientRects()).bind(function(rect){return getClosestCellAbove(table,rect.left,rect.top);}).bind(function(cell){return findClosestHorizontalPosition(getLastLinePositions(cell),pos);});};var findClosestPositionInBelowCell=function findClosestPositionInBelowCell(table,pos){return last(pos.getClientRects()).bind(function(rect){return getClosestCellBelow(table,rect.left,rect.top);}).bind(function(cell){return findClosestHorizontalPosition(getFirstLinePositions(cell),pos);});};var getPos$1=function getPos$1(elm){var x=0,y=0;var offsetParent=elm;while(offsetParent&&offsetParent.nodeType){x+=offsetParent.offsetLeft||0;y+=offsetParent.offsetTop||0;offsetParent=offsetParent.offsetParent;}return{x:x,y:y};};var fireScrollIntoViewEvent=function fireScrollIntoViewEvent(editor,elm,alignToTop){var scrollEvent={elm:elm,alignToTop:alignToTop};editor.fire('scrollIntoView',scrollEvent);return scrollEvent.isDefaultPrevented();};var scrollElementIntoView=function scrollElementIntoView(editor,elm,alignToTop){var y,viewPort;var dom=editor.dom;var root=dom.getRoot();var viewPortY,viewPortH,offsetY=0;if(fireScrollIntoViewEvent(editor,elm,alignToTop)){return;}if(!$_fpgwqg1rjk26xf0n.isElement(elm)){return;}if(alignToTop===false){offsetY=elm.offsetHeight;}if(root.nodeName!=='BODY'){var scrollContainer=editor.selection.getScrollContainer();if(scrollContainer){y=getPos$1(elm).y-getPos$1(scrollContainer).y+offsetY;viewPortH=scrollContainer.clientHeight;viewPortY=scrollContainer.scrollTop;if(y<viewPortY||y+25>viewPortY+viewPortH){scrollContainer.scrollTop=y<viewPortY?y:y-viewPortH+25;}return;}}viewPort=dom.getViewPort(editor.getWin());y=dom.getPos(elm).y+offsetY;viewPortY=viewPort.y;viewPortH=viewPort.h;if(y<viewPort.y||y+25>viewPortY+viewPortH){editor.getWin().scrollTo(0,y<viewPortY?y:y-viewPortH+25);}};var getViewPortRect=function getViewPortRect(editor){if(editor.inline){return editor.getBody().getBoundingClientRect();}else{var win=editor.getWin();return{left:0,right:win.innerWidth,top:0,bottom:win.innerHeight,width:win.innerWidth,height:win.innerHeight};}};var scrollBy=function scrollBy(editor,dx,dy){if(editor.inline){editor.getBody().scrollLeft+=dx;editor.getBody().scrollTop+=dy;}else{editor.getWin().scrollBy(dx,dy);}};var scrollRangeIntoView=function scrollRangeIntoView(editor,rng){head(CaretPosition.fromRangeStart(rng).getClientRects()).each(function(rngRect){var bodyRect=getViewPortRect(editor);var overflow=getOverflow(bodyRect,rngRect);var margin=4;var dx=overflow.x>0?overflow.x+margin:overflow.x-margin;var dy=overflow.y>0?overflow.y+margin:overflow.y-margin;scrollBy(editor,overflow.x!==0?dx:0,overflow.y!==0?dy:0);});};var $_b4h82u37jk26xfc1={scrollElementIntoView:scrollElementIntoView,scrollRangeIntoView:scrollRangeIntoView};var getBodySetting=function getBodySetting(editor,name,defaultValue){var value=editor.getParam(name,defaultValue);if(value.indexOf('=')!==-1){var bodyObj=editor.getParam(name,'','hash');return bodyObj.hasOwnProperty(editor.id)?bodyObj[editor.id]:defaultValue;}else{return value;}};var getIframeAttrs=function getIframeAttrs(editor){return editor.getParam('iframe_attrs',{});};var getDocType=function getDocType(editor){return editor.getParam('doctype','<!DOCTYPE html>');};var getDocumentBaseUrl=function getDocumentBaseUrl(editor){return editor.getParam('document_base_url','');};var getBodyId=function getBodyId(editor){return getBodySetting(editor,'body_id','tinymce');};var getBodyClass=function getBodyClass(editor){return getBodySetting(editor,'body_class','');};var getContentSecurityPolicy=function getContentSecurityPolicy(editor){return editor.getParam('content_security_policy','');};var shouldPutBrInPre=function shouldPutBrInPre(editor){return editor.getParam('br_in_pre',true);};var getForcedRootBlock=function getForcedRootBlock(editor){if(editor.getParam('force_p_newlines',false)){return'p';}var block=editor.getParam('forced_root_block','p');return block===false?'':block;};var getForcedRootBlockAttrs=function getForcedRootBlockAttrs(editor){return editor.getParam('forced_root_block_attrs',{});};var getBrNewLineSelector=function getBrNewLineSelector(editor){return editor.getParam('br_newline_selector','.mce-toc h2,figcaption,caption');};var getNoNewLineSelector=function getNoNewLineSelector(editor){return editor.getParam('no_newline_selector','');};var shouldKeepStyles=function shouldKeepStyles(editor){return editor.getParam('keep_styles',true);};var shouldEndContainerOnEmptyBlock=function shouldEndContainerOnEmptyBlock(editor){return editor.getParam('end_container_on_empty_block',false);};var getFontStyleValues=function getFontStyleValues(editor){return $_2ytxahljk26xetf.explode(editor.getParam('font_size_style_values',''));};var getFontSizeClasses=function getFontSizeClasses(editor){return $_2ytxahljk26xetf.explode(editor.getParam('font_size_classes',''));};var $_8xhf1m38jk26xfc6={getIframeAttrs:getIframeAttrs,getDocType:getDocType,getDocumentBaseUrl:getDocumentBaseUrl,getBodyId:getBodyId,getBodyClass:getBodyClass,getContentSecurityPolicy:getContentSecurityPolicy,shouldPutBrInPre:shouldPutBrInPre,getForcedRootBlock:getForcedRootBlock,getForcedRootBlockAttrs:getForcedRootBlockAttrs,getBrNewLineSelector:getBrNewLineSelector,getNoNewLineSelector:getNoNewLineSelector,shouldKeepStyles:shouldKeepStyles,shouldEndContainerOnEmptyBlock:shouldEndContainerOnEmptyBlock,getFontStyleValues:getFontStyleValues,getFontSizeClasses:getFontSizeClasses};var browser$2=$_8x4ci6ojk26xeuf.detect().browser;var isFakeCaretTableBrowser=function isFakeCaretTableBrowser(){return browser$2.isIE()||browser$2.isEdge()||browser$2.isFirefox();};var moveToRange=function moveToRange(editor,rng){editor.selection.setRng(rng);$_b4h82u37jk26xfc1.scrollRangeIntoView(editor,rng);};var isAtTableCellLine=function isAtTableCellLine(getPositionsUntil,scope,pos){var lineInfo=getPositionsUntil(scope,pos);if(lineInfo.breakType===BreakType.Wrap&&lineInfo.positions.length===0){return lineInfo.breakAt.map(function(breakPos){return getPositionsUntil(scope,breakPos).breakAt.isNone();}).getOr(true);}else{return lineInfo.breakAt.isNone();}};var isAtFirstTableCellLine=$_a86i182ljk26xf77.curry(isAtTableCellLine,getPositionsUntilPreviousLine);var isAtLastTableCellLine=$_a86i182ljk26xf77.curry(isAtTableCellLine,getPositionsUntilNextLine);var isCaretAtStartOrEndOfTable=function isCaretAtStartOrEndOfTable(forward,rng,table){var caretPos=CaretPosition$1.fromRangeStart(rng);return $_bwopbb2yjk26xf9h.positionIn(!forward,table).map(function(pos){return pos.isEqual(caretPos);}).getOr(false);};var navigateHorizontally=function navigateHorizontally(editor,forward,table,td){var rng=editor.selection.getRng();var direction=forward?1:-1;if(isFakeCaretTableBrowser()&&isCaretAtStartOrEndOfTable(forward,rng,table)){var newRng=showCaret(direction,editor,table,!forward,true);moveToRange(editor,newRng);return true;}return false;};var getClosestAbovePosition=function getClosestAbovePosition(root,table,start){return findClosestPositionInAboveCell(table,start).orThunk(function(){return head(start.getClientRects()).bind(function(rect){return findClosestHorizontalPositionFromPoint(getPositionsAbove(root,CaretPosition$1.before(table)),rect.left);});}).getOr(CaretPosition$1.before(table));};var getClosestBelowPosition=function getClosestBelowPosition(root,table,start){return findClosestPositionInBelowCell(table,start).orThunk(function(){return head(start.getClientRects()).bind(function(rect){return findClosestHorizontalPositionFromPoint(getPositionsBelow(root,CaretPosition$1.after(table)),rect.left);});}).getOr(CaretPosition$1.after(table));};var getTable=function getTable(previous,pos){var node=pos.getNode(previous);return $_fpgwqg1rjk26xf0n.isElement(node)&&node.nodeName==='TABLE'?Option.some(node):Option.none();};var renderBlock=function renderBlock(down,editor,table,pos){var forcedRootBlock=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);if(forcedRootBlock){editor.undoManager.transact(function(){var element=Element$$1.fromTag(forcedRootBlock);$_5xapbx15jk26xewz.setAll(element,$_8xhf1m38jk26xfc6.getForcedRootBlockAttrs(editor));$_9t36rc1yjk26xf33.append(element,Element$$1.fromTag('br'));if(down){$_9t36rc1yjk26xf33.after(Element$$1.fromDom(table),element);}else{$_9t36rc1yjk26xf33.before(Element$$1.fromDom(table),element);}var rng=editor.dom.createRng();rng.setStart(element.dom(),0);rng.setEnd(element.dom(),0);moveToRange(editor,rng);});}else{moveToRange(editor,pos.toRange());}};var moveCaret=function moveCaret(editor,down,pos){var table=down?getTable(true,pos):getTable(false,pos);var last$$1=down===false;table.fold(function(){return moveToRange(editor,pos.toRange());},function(table){return $_bwopbb2yjk26xf9h.positionIn(last$$1,editor.getBody()).filter(function(lastPos){return lastPos.isEqual(pos);}).fold(function(){return moveToRange(editor,pos.toRange());},function(_){return renderBlock(down,editor,table,pos);});});};var navigateVertically=function navigateVertically(editor,down,table,td){var rng=editor.selection.getRng();var pos=CaretPosition$1.fromRangeStart(rng);var root=editor.getBody();if(!down&&isAtFirstTableCellLine(td,pos)){var newPos=getClosestAbovePosition(root,table,pos);moveCaret(editor,down,newPos);return true;}else if(down&&isAtLastTableCellLine(td,pos)){var newPos=getClosestBelowPosition(root,table,pos);moveCaret(editor,down,newPos);return true;}else{return false;}};var moveH=function moveH(editor,forward){return function(){return Option.from(editor.dom.getParent(editor.selection.getNode(),'td,th')).bind(function(td){return Option.from(editor.dom.getParent(td,'table')).map(function(table){return navigateHorizontally(editor,forward,table,td);});}).getOr(false);};};var moveV=function moveV(editor,forward){return function(){return Option.from(editor.dom.getParent(editor.selection.getNode(),'td,th')).bind(function(td){return Option.from(editor.dom.getParent(td,'table')).map(function(table){return navigateVertically(editor,forward,table,td);});}).getOr(false);};};var isContentEditableFalse$5=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isTableCell$1=function isTableCell$1(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&/^(TD|TH)$/i.test(node.tagName);};var getAbsoluteClientRect=function getAbsoluteClientRect(root,element,before){var clientRect=collapse(element.getBoundingClientRect(),before);var docElm,scrollX,scrollY,margin,rootRect;if(root.tagName==='BODY'){docElm=root.ownerDocument.documentElement;scrollX=root.scrollLeft||docElm.scrollLeft;scrollY=root.scrollTop||docElm.scrollTop;}else{rootRect=root.getBoundingClientRect();scrollX=root.scrollLeft-rootRect.left;scrollY=root.scrollTop-rootRect.top;}clientRect.left+=scrollX;clientRect.right+=scrollX;clientRect.top+=scrollY;clientRect.bottom+=scrollY;clientRect.width=1;margin=element.offsetWidth-element.clientWidth;if(margin>0){if(before){margin*=-1;}clientRect.left+=margin;clientRect.right+=margin;}return clientRect;};var trimInlineCaretContainers=function trimInlineCaretContainers(root){var contentEditableFalseNodes,node,sibling,i,data;contentEditableFalseNodes=DomQuery('*[contentEditable=false]',root);for(i=0;i<contentEditableFalseNodes.length;i++){node=contentEditableFalseNodes[i];sibling=node.previousSibling;if(endsWithCaretContainer(sibling)){data=sibling.data;if(data.length===1){sibling.parentNode.removeChild(sibling);}else{sibling.deleteData(data.length-1,1);}}sibling=node.nextSibling;if(startsWithCaretContainer(sibling)){data=sibling.data;if(data.length===1){sibling.parentNode.removeChild(sibling);}else{sibling.deleteData(0,1);}}}};var FakeCaret=function FakeCaret(root,isBlock,hasFocus){var lastVisualCaret=Cell(Option.none());var cursorInterval,caretContainerNode;var show=function show(before,element){var clientRect,rng;hide();if(isTableCell$1(element)){return null;}if(isBlock(element)){caretContainerNode=insertBlock('p',element,before);clientRect=getAbsoluteClientRect(root,element,before);DomQuery(caretContainerNode).css('top',clientRect.top);var caret=DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(root)[0];lastVisualCaret.set(Option.some({caret:caret,element:element,before:before}));lastVisualCaret.get().each(function(caretState){if(before){DomQuery(caretState.caret).addClass('mce-visual-caret-before');}});startBlink();rng=element.ownerDocument.createRange();rng.setStart(caretContainerNode,0);rng.setEnd(caretContainerNode,0);}else{caretContainerNode=insertInline(element,before);rng=element.ownerDocument.createRange();if(isContentEditableFalse$5(caretContainerNode.nextSibling)){rng.setStart(caretContainerNode,0);rng.setEnd(caretContainerNode,0);}else{rng.setStart(caretContainerNode,1);rng.setEnd(caretContainerNode,1);}return rng;}return rng;};var hide=function hide(){trimInlineCaretContainers(root);if(caretContainerNode){$_f7uyam31jk26xfaa.remove(caretContainerNode);caretContainerNode=null;}lastVisualCaret.get().each(function(caretState){DomQuery(caretState.caret).remove();lastVisualCaret.set(Option.none());});clearInterval(cursorInterval);};var startBlink=function startBlink(){cursorInterval=$_3a7ompijk26xer0.setInterval(function(){if(hasFocus()){DomQuery('div.mce-visual-caret',root).toggleClass('mce-visual-caret-hidden');}else{DomQuery('div.mce-visual-caret',root).addClass('mce-visual-caret-hidden');}},500);};var reposition=function reposition(){lastVisualCaret.get().each(function(caretState){var clientRect=getAbsoluteClientRect(root,caretState.element,caretState.before);DomQuery(caretState.caret).css(clientRect);});};var destroy=function destroy(){return $_3a7ompijk26xer0.clearInterval(cursorInterval);};var getCss=function getCss(){return'.mce-visual-caret {'+'position: absolute;'+'background-color: black;'+'background-color: currentcolor;'+'}'+'.mce-visual-caret-hidden {'+'display: none;'+'}'+'*[data-mce-caret] {'+'position: absolute;'+'left: -1000px;'+'right: auto;'+'top: 0;'+'margin: 0;'+'padding: 0;'+'}';};return{show:show,hide:hide,getCss:getCss,reposition:reposition,destroy:destroy};};var isFakeCaretTarget=function isFakeCaretTarget(node){return isContentEditableFalse$5(node)||$_fpgwqg1rjk26xf0n.isTable(node)&&isFakeCaretTableBrowser();};var isContentEditableFalse$6=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isBlockLike=$_fpgwqg1rjk26xf0n.matchStyleValues('display','block table table-cell table-caption list-item');var isCaretContainer$2=isCaretContainer;var isCaretContainerBlock$1=isCaretContainerBlock;var curry$2=$_a86i182ljk26xf77.curry;var isElement$6=$_fpgwqg1rjk26xf0n.isElement;var isCaretCandidate$3=isCaretCandidate;var isForwards=function isForwards(direction){return direction>0;};var isBackwards=function isBackwards(direction){return direction<0;};var skipCaretContainers=function skipCaretContainers(walk,shallow){var node;while(node=walk(shallow)){if(!isCaretContainerBlock$1(node)){return node;}}return null;};var findNode=function findNode(node,direction,predicateFn,rootNode,shallow){var walker=new TreeWalker(node,rootNode);if(isBackwards(direction)){if(isContentEditableFalse$6(node)||isCaretContainerBlock$1(node)){node=skipCaretContainers(walker.prev,true);if(predicateFn(node)){return node;}}while(node=skipCaretContainers(walker.prev,shallow)){if(predicateFn(node)){return node;}}}if(isForwards(direction)){if(isContentEditableFalse$6(node)||isCaretContainerBlock$1(node)){node=skipCaretContainers(walker.next,true);if(predicateFn(node)){return node;}}while(node=skipCaretContainers(walker.next,shallow)){if(predicateFn(node)){return node;}}}return null;};var getParentBlock=function getParentBlock(node,rootNode){while(node&&node!==rootNode){if(isBlockLike(node)){return node;}node=node.parentNode;}return null;};var isInSameBlock=function isInSameBlock(caretPosition1,caretPosition2,rootNode){return getParentBlock(caretPosition1.container(),rootNode)===getParentBlock(caretPosition2.container(),rootNode);};var getChildNodeAtRelativeOffset=function getChildNodeAtRelativeOffset(relativeOffset,caretPosition){var container,offset;if(!caretPosition){return null;}container=caretPosition.container();offset=caretPosition.offset();if(!isElement$6(container)){return null;}return container.childNodes[offset+relativeOffset];};var beforeAfter=function beforeAfter(before,node){var range=node.ownerDocument.createRange();if(before){range.setStartBefore(node);range.setEndBefore(node);}else{range.setStartAfter(node);range.setEndAfter(node);}return range;};var isNodesInSameBlock=function isNodesInSameBlock(root,node1,node2){return getParentBlock(node1,root)===getParentBlock(node2,root);};var lean=function lean(left,root,node){var sibling,siblingName;if(left){siblingName='previousSibling';}else{siblingName='nextSibling';}while(node&&node!==root){sibling=node[siblingName];if(isCaretContainer$2(sibling)){sibling=sibling[siblingName];}if(isContentEditableFalse$6(sibling)){if(isNodesInSameBlock(root,sibling,node)){return sibling;}break;}if(isCaretCandidate$3(sibling)){break;}node=node.parentNode;}return null;};var before$2=curry$2(beforeAfter,true);var after$2=curry$2(beforeAfter,false);var normalizeRange=function normalizeRange(direction,root,range){var node,container,offset,location;var leanLeft=curry$2(lean,true,root);var leanRight=curry$2(lean,false,root);container=range.startContainer;offset=range.startOffset;if(isCaretContainerBlock(container)){if(!isElement$6(container)){container=container.parentNode;}location=container.getAttribute('data-mce-caret');if(location==='before'){node=container.nextSibling;if(isFakeCaretTarget(node)){return before$2(node);}}if(location==='after'){node=container.previousSibling;if(isFakeCaretTarget(node)){return after$2(node);}}}if(!range.collapsed){return range;}if($_fpgwqg1rjk26xf0n.isText(container)){if(isCaretContainer$2(container)){if(direction===1){node=leanRight(container);if(node){return before$2(node);}node=leanLeft(container);if(node){return after$2(node);}}if(direction===-1){node=leanLeft(container);if(node){return after$2(node);}node=leanRight(container);if(node){return before$2(node);}}return range;}if(endsWithCaretContainer(container)&&offset>=container.data.length-1){if(direction===1){node=leanRight(container);if(node){return before$2(node);}}return range;}if(startsWithCaretContainer(container)&&offset<=1){if(direction===-1){node=leanLeft(container);if(node){return after$2(node);}}return range;}if(offset===container.data.length){node=leanRight(container);if(node){return before$2(node);}return range;}if(offset===0){node=leanLeft(container);if(node){return after$2(node);}return range;}}return range;};var isNextToContentEditableFalse=function isNextToContentEditableFalse(relativeOffset,caretPosition){var node=getChildNodeAtRelativeOffset(relativeOffset,caretPosition);return isContentEditableFalse$6(node)&&!$_fpgwqg1rjk26xf0n.isBogusAll(node);};var isNextToTable=function isNextToTable(relativeOffset,caretPosition){return $_fpgwqg1rjk26xf0n.isTable(getChildNodeAtRelativeOffset(relativeOffset,caretPosition));};var getRelativeCefElm=function getRelativeCefElm(forward,caretPosition){return Option.from(getChildNodeAtRelativeOffset(forward?0:-1,caretPosition)).filter(isContentEditableFalse$6);};var getNormalizedRangeEndPoint=function getNormalizedRangeEndPoint(direction,root,range){var normalizedRange=normalizeRange(direction,root,range);if(direction===-1){return CaretPosition.fromRangeStart(normalizedRange);}return CaretPosition.fromRangeEnd(normalizedRange);};var isBeforeContentEditableFalse=curry$2(isNextToContentEditableFalse,0);var isAfterContentEditableFalse=curry$2(isNextToContentEditableFalse,-1);var isBeforeTable=curry$2(isNextToTable,0);var isAfterTable=curry$2(isNextToTable,-1);var walkToPositionIn=function walkToPositionIn(forward,root,start){var position=forward?CaretPosition$1.before(start):CaretPosition$1.after(start);return fromPosition(forward,root,position);};var afterElement=function afterElement(node){return $_fpgwqg1rjk26xf0n.isBr(node)?CaretPosition$1.before(node):CaretPosition$1.after(node);};var isBeforeOrStart=function isBeforeOrStart(position){if(CaretPosition$1.isTextPosition(position)){return position.offset()===0;}else{return isCaretCandidate(position.getNode());}};var isAfterOrEnd=function isAfterOrEnd(position){if(CaretPosition$1.isTextPosition(position)){var container=position.container();return position.offset()===container.data.length;}else{return isCaretCandidate(position.getNode(true));}};var isBeforeAfterSameElement=function isBeforeAfterSameElement(from,to){return!CaretPosition$1.isTextPosition(from)&&!CaretPosition$1.isTextPosition(to)&&from.getNode()===to.getNode(true);};var isAtBr=function isAtBr(position){return!CaretPosition$1.isTextPosition(position)&&$_fpgwqg1rjk26xf0n.isBr(position.getNode());};var shouldSkipPosition=function shouldSkipPosition(forward,from,to){if(forward){return!isBeforeAfterSameElement(from,to)&&!isAtBr(from)&&isAfterOrEnd(from)&&isBeforeOrStart(to);}else{return!isBeforeAfterSameElement(to,from)&&isBeforeOrStart(from)&&isAfterOrEnd(to);}};var fromPosition=function fromPosition(forward,root,pos){var walker=CaretWalker(root);return Option.from(forward?walker.next(pos):walker.prev(pos));};var navigate=function navigate(forward,root,from){return fromPosition(forward,root,from).bind(function(to){if(isInSameBlock(from,to,root)&&shouldSkipPosition(forward,from,to)){return fromPosition(forward,root,to);}else{return Option.some(to);}});};var positionIn=function positionIn(forward,element){var startNode=forward?element.firstChild:element.lastChild;if($_fpgwqg1rjk26xf0n.isText(startNode)){return Option.some(CaretPosition$1(startNode,forward?0:startNode.data.length));}else if(startNode){if(isCaretCandidate(startNode)){return Option.some(forward?CaretPosition$1.before(startNode):afterElement(startNode));}else{return walkToPositionIn(forward,element,startNode);}}else{return Option.none();}};var $_bwopbb2yjk26xf9h={fromPosition:fromPosition,nextPosition:curry(fromPosition,true),prevPosition:curry(fromPosition,false),navigate:navigate,positionIn:positionIn,firstPositionIn:curry(positionIn,true),lastPositionIn:curry(positionIn,false)};var isStringPathBookmark=function isStringPathBookmark(bookmark){return typeof bookmark.start==='string';};var isRangeBookmark=function isRangeBookmark(bookmark){return bookmark.hasOwnProperty('rng');};var isIdBookmark=function isIdBookmark(bookmark){return bookmark.hasOwnProperty('id');};var isIndexBookmark=function isIndexBookmark(bookmark){return bookmark.hasOwnProperty('name');};var isPathBookmark=function isPathBookmark(bookmark){return $_2ytxahljk26xetf.isArray(bookmark.start);};var addBogus=function addBogus(dom,node){if(dom.isBlock(node)&&!node.innerHTML&&!$_ef6mqpajk26xejm.ie){node.innerHTML='<br data-mce-bogus="1" />';}return node;};var resolveCaretPositionBookmark=function resolveCaretPositionBookmark(dom,bookmark){var rng,pos;rng=dom.createRng();pos=resolve$2(dom.getRoot(),bookmark.start);rng.setStart(pos.container(),pos.offset());pos=resolve$2(dom.getRoot(),bookmark.end);rng.setEnd(pos.container(),pos.offset());return rng;};var insertZwsp=function insertZwsp(node,rng){var textNode=node.ownerDocument.createTextNode($_4osibw2pjk26xf83.ZWSP);node.appendChild(textNode);rng.setStart(textNode,0);rng.setEnd(textNode,0);};var isEmpty=function isEmpty(node){return node.hasChildNodes()===false;};var tryFindRangePosition=function tryFindRangePosition(node,rng){return $_bwopbb2yjk26xf9h.lastPositionIn(node).fold(function(){return false;},function(pos){rng.setStart(pos.container(),pos.offset());rng.setEnd(pos.container(),pos.offset());return true;});};var padEmptyCaretContainer=function padEmptyCaretContainer(root,node,rng){if(isEmpty(node)&&getParentCaretContainer(root,node)){insertZwsp(node,rng);return true;}else{return false;}};var setEndPoint=function setEndPoint(dom,start,bookmark,rng){var point=bookmark[start?'start':'end'];var i,node,offset,children;var root=dom.getRoot();if(point){offset=point[0];for(node=root,i=point.length-1;i>=1;i--){children=node.childNodes;if(padEmptyCaretContainer(root,node,rng)){return true;}if(point[i]>children.length-1){if(padEmptyCaretContainer(root,node,rng)){return true;}return tryFindRangePosition(node,rng);}node=children[point[i]];}if(node.nodeType===3){offset=Math.min(point[0],node.nodeValue.length);}if(node.nodeType===1){offset=Math.min(point[0],node.childNodes.length);}if(start){rng.setStart(node,offset);}else{rng.setEnd(node,offset);}}return true;};var isValidTextNode=function isValidTextNode(node){return $_fpgwqg1rjk26xf0n.isText(node)&&node.data.length>0;};var restoreEndPoint=function restoreEndPoint(dom,suffix,bookmark){var marker=dom.get(bookmark.id+'_'+suffix),node,idx,next,prev;var keep=bookmark.keep;var container,offset;if(marker){node=marker.parentNode;if(suffix==='start'){if(!keep){idx=dom.nodeIndex(marker);}else{if(marker.hasChildNodes()){node=marker.firstChild;idx=1;}else if(isValidTextNode(marker.nextSibling)){node=marker.nextSibling;idx=0;}else if(isValidTextNode(marker.previousSibling)){node=marker.previousSibling;idx=marker.previousSibling.data.length;}else{node=marker.parentNode;idx=dom.nodeIndex(marker)+1;}}container=node;offset=idx;}else{if(!keep){idx=dom.nodeIndex(marker);}else{if(marker.hasChildNodes()){node=marker.firstChild;idx=1;}else if(isValidTextNode(marker.previousSibling)){node=marker.previousSibling;idx=marker.previousSibling.data.length;}else{node=marker.parentNode;idx=dom.nodeIndex(marker);}}container=node;offset=idx;}if(!keep){prev=marker.previousSibling;next=marker.nextSibling;$_2ytxahljk26xetf.each($_2ytxahljk26xetf.grep(marker.childNodes),function(node){if($_fpgwqg1rjk26xf0n.isText(node)){node.nodeValue=node.nodeValue.replace(/\uFEFF/g,'');}});while(marker=dom.get(bookmark.id+'_'+suffix)){dom.remove(marker,true);}if(prev&&next&&prev.nodeType===next.nodeType&&$_fpgwqg1rjk26xf0n.isText(prev)&&!$_ef6mqpajk26xejm.opera){idx=prev.nodeValue.length;prev.appendData(next.nodeValue);dom.remove(next);if(suffix==='start'){container=prev;offset=idx;}else{container=prev;offset=idx;}}}return Option.some(CaretPosition$1(container,offset));}else{return Option.none();}};var alt=function alt(o1,o2){return o1.isSome()?o1:o2;};var resolvePaths=function resolvePaths(dom,bookmark){var rng=dom.createRng();if(setEndPoint(dom,true,bookmark,rng)&&setEndPoint(dom,false,bookmark,rng)){return Option.some(rng);}else{return Option.none();}};var resolveId=function resolveId(dom,bookmark){var startPos=restoreEndPoint(dom,'start',bookmark);var endPos=restoreEndPoint(dom,'end',bookmark);return liftN([startPos,alt(endPos,startPos)],function(spos,epos){var rng=dom.createRng();rng.setStart(addBogus(dom,spos.container()),spos.offset());rng.setEnd(addBogus(dom,epos.container()),epos.offset());return rng;});};var resolveIndex$1=function resolveIndex$1(dom,bookmark){return Option.from(dom.select(bookmark.name)[bookmark.index]).map(function(elm){var rng=dom.createRng();rng.selectNode(elm);return rng;});};var resolve$3=function resolve$3(selection,bookmark){var dom=selection.dom;if(bookmark){if(isPathBookmark(bookmark)){return resolvePaths(dom,bookmark);}else if(isStringPathBookmark(bookmark)){return Option.some(resolveCaretPositionBookmark(dom,bookmark));}else if(isIdBookmark(bookmark)){return resolveId(dom,bookmark);}else if(isIndexBookmark(bookmark)){return resolveIndex$1(dom,bookmark);}else if(isRangeBookmark(bookmark)){return Option.some(bookmark.rng);}}return Option.none();};var $_1lbqvq2wjk26xf8u={resolve:resolve$3};var getBookmark$1=function getBookmark$1(selection,type,normalized){return $_ci8rza2jjk26xf6s.getBookmark(selection,type,normalized);};var moveToBookmark=function moveToBookmark(selection,bookmark){$_1lbqvq2wjk26xf8u.resolve(selection,bookmark).each(function(rng){selection.setRng(rng);});};var isBookmarkNode$1=function isBookmarkNode$1(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&node.tagName==='SPAN'&&node.getAttribute('data-mce-type')==='bookmark';};var $_2wdci52vjk26xf8r={getBookmark:getBookmark$1,moveToBookmark:moveToBookmark,isBookmarkNode:isBookmarkNode$1};var isInlineBlock=function isInlineBlock(node){return node&&/^(IMG)$/.test(node.nodeName);};var moveStart=function moveStart(dom,selection,rng){var offset=rng.startOffset;var container=rng.startContainer,walker,node,nodes;if(rng.startContainer===rng.endContainer){if(isInlineBlock(rng.startContainer.childNodes[rng.startOffset])){return;}}if(container.nodeType===1){nodes=container.childNodes;if(offset<nodes.length){container=nodes[offset];walker=new TreeWalker(container,dom.getParent(container,dom.isBlock));}else{container=nodes[nodes.length-1];walker=new TreeWalker(container,dom.getParent(container,dom.isBlock));walker.next(true);}for(node=walker.current();node;node=walker.next()){if(node.nodeType===3&&!isWhiteSpaceNode(node)){rng.setStart(node,0);selection.setRng(rng);return;}}}};var getNonWhiteSpaceSibling=function getNonWhiteSpaceSibling(node,next,inc){if(node){next=next?'nextSibling':'previousSibling';for(node=inc?node:node[next];node;node=node[next]){if(node.nodeType===1||!isWhiteSpaceNode(node)){return node;}}}};var isTextBlock$1=function isTextBlock$1(editor,name){if(name.nodeType){name=name.nodeName;}return!!editor.schema.getTextBlockElements()[name.toLowerCase()];};var isValid=function isValid(ed,parent,child){return ed.schema.isValidChild(parent,child);};var isWhiteSpaceNode=function isWhiteSpaceNode(node){return node&&node.nodeType===3&&/^([\t \r\n]+|)$/.test(node.nodeValue);};var replaceVars=function replaceVars(value,vars){if(typeof value!=='string'){value=value(vars);}else if(vars){value=value.replace(/%(\w+)/g,function(str,name){return vars[name]||str;});}return value;};var isEq=function isEq(str1,str2){str1=str1||'';str2=str2||'';str1=''+(str1.nodeName||str1);str2=''+(str2.nodeName||str2);return str1.toLowerCase()===str2.toLowerCase();};var normalizeStyleValue=function normalizeStyleValue(dom,value,name){if(name==='color'||name==='backgroundColor'){value=dom.toHex(value);}if(name==='fontWeight'&&value===700){value='bold';}if(name==='fontFamily'){value=value.replace(/[\'\"]/g,'').replace(/,\s+/g,',');}return''+value;};var getStyle=function getStyle(dom,node,name){return normalizeStyleValue(dom,dom.getStyle(node,name),name);};var getTextDecoration=function getTextDecoration(dom,node){var decoration;dom.getParent(node,function(n){decoration=dom.getStyle(n,'text-decoration');return decoration&&decoration!=='none';});return decoration;};var getParents$1=function getParents$1(dom,node,selector){return dom.getParents(node,selector,dom.getRoot());};var $_a0f3y13ajk26xfcc={isInlineBlock:isInlineBlock,moveStart:moveStart,getNonWhiteSpaceSibling:getNonWhiteSpaceSibling,isTextBlock:isTextBlock$1,isValid:isValid,isWhiteSpaceNode:isWhiteSpaceNode,replaceVars:replaceVars,isEq:isEq,normalizeStyleValue:normalizeStyleValue,getStyle:getStyle,getTextDecoration:getTextDecoration,getParents:getParents$1};var isBookmarkNode$2=$_2wdci52vjk26xf8r.isBookmarkNode;var getParents$2=$_a0f3y13ajk26xfcc.getParents;var isWhiteSpaceNode$1=$_a0f3y13ajk26xfcc.isWhiteSpaceNode;var isTextBlock$2=$_a0f3y13ajk26xfcc.isTextBlock;var findLeaf=function findLeaf(node,offset){if(typeof offset==='undefined'){offset=node.nodeType===3?node.length:node.childNodes.length;}while(node&&node.hasChildNodes()){node=node.childNodes[offset];if(node){offset=node.nodeType===3?node.length:node.childNodes.length;}}return{node:node,offset:offset};};var excludeTrailingWhitespace=function excludeTrailingWhitespace(endContainer,endOffset){var leaf=findLeaf(endContainer,endOffset);if(leaf.node){while(leaf.node&&leaf.offset===0&&leaf.node.previousSibling){leaf=findLeaf(leaf.node.previousSibling);}if(leaf.node&&leaf.offset>0&&leaf.node.nodeType===3&&leaf.node.nodeValue.charAt(leaf.offset-1)===' '){if(leaf.offset>1){endContainer=leaf.node;endContainer.splitText(leaf.offset-1);}}}return endContainer;};var isBogusBr=function isBogusBr(node){return node.nodeName==='BR'&&node.getAttribute('data-mce-bogus')&&!node.nextSibling;};var findParentContentEditable=function findParentContentEditable(dom,node){var parent=node;while(parent){if(parent.nodeType===1&&dom.getContentEditable(parent)){return dom.getContentEditable(parent)==='false'?parent:node;}parent=parent.parentNode;}return node;};var findSpace=function findSpace(start,remove,node,offset){var pos,pos2;var str=node.nodeValue;if(typeof offset==='undefined'){offset=start?str.length:0;}if(start){pos=str.lastIndexOf(' ',offset);pos2=str.lastIndexOf('\xA0',offset);pos=pos>pos2?pos:pos2;if(pos!==-1&&!remove){pos++;}}else{pos=str.indexOf(' ',offset);pos2=str.indexOf('\xA0',offset);pos=pos!==-1&&(pos2===-1||pos<pos2)?pos:pos2;}return pos;};var findWordEndPoint=function findWordEndPoint(dom,body,container,offset,start,remove){var walker,node,pos,lastTextNode;if(container.nodeType===3){pos=findSpace(start,remove,container,offset);if(pos!==-1){return{container:container,offset:pos};}lastTextNode=container;}walker=new TreeWalker(container,dom.getParent(container,dom.isBlock)||body);while(node=walker[start?'prev':'next']()){if(node.nodeType===3){lastTextNode=node;pos=findSpace(start,remove,node);if(pos!==-1){return{container:node,offset:pos};}}else if(dom.isBlock(node)){break;}}if(lastTextNode){if(start){offset=0;}else{offset=lastTextNode.length;}return{container:lastTextNode,offset:offset};}};var findSelectorEndPoint=function findSelectorEndPoint(dom,format,rng,container,siblingName){var parents,i,y,curFormat;if(container.nodeType===3&&container.nodeValue.length===0&&container[siblingName]){container=container[siblingName];}parents=getParents$2(dom,container);for(i=0;i<parents.length;i++){for(y=0;y<format.length;y++){curFormat=format[y];if('collapsed'in curFormat&&curFormat.collapsed!==rng.collapsed){continue;}if(dom.is(parents[i],curFormat.selector)){return parents[i];}}}return container;};var findBlockEndPoint=function findBlockEndPoint(editor,format,container,siblingName){var node;var dom=editor.dom;var root=dom.getRoot();if(!format[0].wrapper){node=dom.getParent(container,format[0].block,root);}if(!node){var scopeRoot=dom.getParent(container,'LI,TD,TH');node=dom.getParent(container.nodeType===3?container.parentNode:container,function(node){return node!==root&&isTextBlock$2(editor,node);},scopeRoot);}if(node&&format[0].wrapper){node=getParents$2(dom,node,'ul,ol').reverse()[0]||node;}if(!node){node=container;while(node[siblingName]&&!dom.isBlock(node[siblingName])){node=node[siblingName];if($_a0f3y13ajk26xfcc.isEq(node,'br')){break;}}}return node||container;};var findParentContainer=function findParentContainer(dom,format,startContainer,startOffset,endContainer,endOffset,start){var container,parent,sibling,siblingName,root;container=parent=start?startContainer:endContainer;siblingName=start?'previousSibling':'nextSibling';root=dom.getRoot();if(container.nodeType===3&&!isWhiteSpaceNode$1(container)){if(start?startOffset>0:endOffset<container.nodeValue.length){return container;}}while(true){if(!format[0].block_expand&&dom.isBlock(parent)){return parent;}for(sibling=parent[siblingName];sibling;sibling=sibling[siblingName]){if(!isBookmarkNode$2(sibling)&&!isWhiteSpaceNode$1(sibling)&&!isBogusBr(sibling)){return parent;}}if(parent===root||parent.parentNode===root){container=parent;break;}parent=parent.parentNode;}return container;};var expandRng=function expandRng(editor,rng,format,remove){var endPoint,startContainer=rng.startContainer,startOffset=rng.startOffset,endContainer=rng.endContainer,endOffset=rng.endOffset;var dom=editor.dom;if(startContainer.nodeType===1&&startContainer.hasChildNodes()){startContainer=getNode(startContainer,startOffset);if(startContainer.nodeType===3){startOffset=0;}}if(endContainer.nodeType===1&&endContainer.hasChildNodes()){endContainer=getNode(endContainer,rng.collapsed?endOffset:endOffset-1);if(endContainer.nodeType===3){endOffset=endContainer.nodeValue.length;}}startContainer=findParentContentEditable(dom,startContainer);endContainer=findParentContentEditable(dom,endContainer);if(isBookmarkNode$2(startContainer.parentNode)||isBookmarkNode$2(startContainer)){startContainer=isBookmarkNode$2(startContainer)?startContainer:startContainer.parentNode;startContainer=startContainer.nextSibling||startContainer;if(startContainer.nodeType===3){startOffset=0;}}if(isBookmarkNode$2(endContainer.parentNode)||isBookmarkNode$2(endContainer)){endContainer=isBookmarkNode$2(endContainer)?endContainer:endContainer.parentNode;endContainer=endContainer.previousSibling||endContainer;if(endContainer.nodeType===3){endOffset=endContainer.length;}}if(format[0].inline){if(rng.collapsed){endPoint=findWordEndPoint(dom,editor.getBody(),startContainer,startOffset,true,remove);if(endPoint){startContainer=endPoint.container;startOffset=endPoint.offset;}endPoint=findWordEndPoint(dom,editor.getBody(),endContainer,endOffset,false,remove);if(endPoint){endContainer=endPoint.container;endOffset=endPoint.offset;}}endContainer=remove?endContainer:excludeTrailingWhitespace(endContainer,endOffset);}if(format[0].inline||format[0].block_expand){if(!format[0].inline||startContainer.nodeType!==3||startOffset===0){startContainer=findParentContainer(dom,format,startContainer,startOffset,endContainer,endOffset,true);}if(!format[0].inline||endContainer.nodeType!==3||endOffset===endContainer.nodeValue.length){endContainer=findParentContainer(dom,format,startContainer,startOffset,endContainer,endOffset,false);}}if(format[0].selector&&format[0].expand!==false&&!format[0].inline){startContainer=findSelectorEndPoint(dom,format,rng,startContainer,'previousSibling');endContainer=findSelectorEndPoint(dom,format,rng,endContainer,'nextSibling');}if(format[0].block||format[0].selector){startContainer=findBlockEndPoint(editor,format,startContainer,'previousSibling');endContainer=findBlockEndPoint(editor,format,endContainer,'nextSibling');if(format[0].block){if(!dom.isBlock(startContainer)){startContainer=findParentContainer(dom,format,startContainer,startOffset,endContainer,endOffset,true);}if(!dom.isBlock(endContainer)){endContainer=findParentContainer(dom,format,startContainer,startOffset,endContainer,endOffset,false);}}}if(startContainer.nodeType===1){startOffset=dom.nodeIndex(startContainer);startContainer=startContainer.parentNode;}if(endContainer.nodeType===1){endOffset=dom.nodeIndex(endContainer)+1;endContainer=endContainer.parentNode;}return{startContainer:startContainer,startOffset:startOffset,endContainer:endContainer,endOffset:endOffset};};var $_21lucf2ujk26xf8j={expandRng:expandRng};var each$8=$_2ytxahljk26xetf.each;var getEndChild=function getEndChild(container,index){var childNodes=container.childNodes;index--;if(index>childNodes.length-1){index=childNodes.length-1;}else if(index<0){index=0;}return childNodes[index]||container;};var walk$2=function walk$2(dom,rng,callback){var startContainer=rng.startContainer;var startOffset=rng.startOffset;var endContainer=rng.endContainer;var endOffset=rng.endOffset;var ancestor;var startPoint;var endPoint;var node;var parent;var siblings;var nodes;nodes=dom.select('td[data-mce-selected],th[data-mce-selected]');if(nodes.length>0){each$8(nodes,function(node){callback([node]);});return;}var exclude=function exclude(nodes){var node;node=nodes[0];if(node.nodeType===3&&node===startContainer&&startOffset>=node.nodeValue.length){nodes.splice(0,1);}node=nodes[nodes.length-1];if(endOffset===0&&nodes.length>0&&node===endContainer&&node.nodeType===3){nodes.splice(nodes.length-1,1);}return nodes;};var collectSiblings=function collectSiblings(node,name,endNode){var siblings=[];for(;node&&node!==endNode;node=node[name]){siblings.push(node);}return siblings;};var findEndPoint=function findEndPoint(node,root){do{if(node.parentNode===root){return node;}node=node.parentNode;}while(node);};var walkBoundary=function walkBoundary(startNode,endNode,next){var siblingName=next?'nextSibling':'previousSibling';for(node=startNode,parent=node.parentNode;node&&node!==endNode;node=parent){parent=node.parentNode;siblings=collectSiblings(node===startNode?node:node[siblingName],siblingName);if(siblings.length){if(!next){siblings.reverse();}callback(exclude(siblings));}}};if(startContainer.nodeType===1&&startContainer.hasChildNodes()){startContainer=startContainer.childNodes[startOffset];}if(endContainer.nodeType===1&&endContainer.hasChildNodes()){endContainer=getEndChild(endContainer,endOffset);}if(startContainer===endContainer){return callback(exclude([startContainer]));}ancestor=dom.findCommonAncestor(startContainer,endContainer);for(node=startContainer;node;node=node.parentNode){if(node===endContainer){return walkBoundary(startContainer,ancestor,true);}if(node===ancestor){break;}}for(node=endContainer;node;node=node.parentNode){if(node===startContainer){return walkBoundary(endContainer,ancestor);}if(node===ancestor){break;}}startPoint=findEndPoint(startContainer,ancestor)||startContainer;endPoint=findEndPoint(endContainer,ancestor)||endContainer;walkBoundary(startContainer,startPoint,true);siblings=collectSiblings(startPoint===startContainer?startPoint:startPoint.nextSibling,'nextSibling',endPoint===endContainer?endPoint.nextSibling:endPoint);if(siblings.length){callback(exclude(siblings));}walkBoundary(endContainer,endPoint);};var $_179pt43bjk26xfcg={walk:walk$2};var zeroWidth=function zeroWidth(){return'\uFEFF';};function NodeValue(is,name){var get=function get(element){if(!is(element))throw new Error('Can only get '+name+' value of a '+name+' node');return getOption(element).getOr('');};var getOptionIE10=function getOptionIE10(element){try{return getOptionSafe(element);}catch(e){return Option.none();}};var getOptionSafe=function getOptionSafe(element){return is(element)?Option.from(element.dom().nodeValue):Option.none();};var browser=$_8x4ci6ojk26xeuf.detect().browser;var getOption=browser.isIE()&&browser.version.major===10?getOptionIE10:getOptionSafe;var set=function set(element,value){if(!is(element))throw new Error('Can only set raw '+name+' value of a '+name+' node');element.dom().nodeValue=value;};return{get:get,getOption:getOption,set:set};}var api=NodeValue($_cl4rr911jk26xevy.isText,'text');var get$4=function get$4(element){return api.get(element);};var getOption=function getOption(element){return api.getOption(element);};var set$2=function set$2(element,value){api.set(element,value);};var $_30p3ln3ejk26xfct={get:get$4,getOption:getOption,set:set$2};var isZeroWidth=function isZeroWidth(elem){return $_cl4rr911jk26xevy.isText(elem)&&$_30p3ln3ejk26xfct.get(elem)===zeroWidth();};var context=function context(editor,elem,wrapName,nodeName){return $_2i1q6518jk26xexk.parent(elem).fold(function(){return'skipping';},function(parent){if(nodeName==='br'||isZeroWidth(elem)){return'skipping';}else if(isAnnotation(elem)){return'existing';}else if(isCaretNode(elem)){return'caret';}else if(!$_a0f3y13ajk26xfcc.isValid(editor,wrapName,nodeName)||!$_a0f3y13ajk26xfcc.isValid(editor,$_cl4rr911jk26xevy.name(parent),wrapName)){return'invalid-child';}else{return'valid';}});};var __rest=undefined&&undefined.__rest||function(s,e){var t={};for(var p in s){if(Object.prototype.hasOwnProperty.call(s,p)&&e.indexOf(p)<0)t[p]=s[p];}if(s!=null&&typeof Object.getOwnPropertySymbols==='function')for(var i=0,p=Object.getOwnPropertySymbols(s);i<p.length;i++){if(e.indexOf(p[i])<0)t[p[i]]=s[p[i]];}return t;};var applyWordGrab=function applyWordGrab(editor,rng){var r=$_21lucf2ujk26xf8j.expandRng(editor,rng,[{inline:true}],false);rng.setStart(r.startContainer,r.startOffset);rng.setEnd(r.endContainer,r.endOffset);editor.selection.setRng(rng);};var annotate=function annotate(editor,rng,annotationName,decorate,_a){var _b=_a.uid,uid=_b===void 0?generate('mce-annotation'):_b,data=__rest(_a,['uid']);var newWrappers=[];var master=Element$$1.fromTag('span');$_38pgzm23jk26xf42.add(master,annotation());$_5xapbx15jk26xewz.set(master,''+dataAnnotationId(),uid);$_5xapbx15jk26xewz.set(master,''+dataAnnotation(),annotationName);var _c=decorate(uid,data),_d=_c.attributes,attributes=_d===void 0?{}:_d,_e=_c.classes,classes=_e===void 0?[]:_e;$_5xapbx15jk26xewz.setAll(master,attributes);$_gtb8a2hjk26xf6d.add(master,classes);var wrapper=Cell(Option.none());var finishWrapper=function finishWrapper(){wrapper.set(Option.none());};var getOrOpenWrapper=function getOrOpenWrapper(){return wrapper.get().getOrThunk(function(){var nu=$_39bcz42ijk26xf6i.shallow(master);newWrappers.push(nu);wrapper.set(Option.some(nu));return nu;});};var processElements=function processElements(elems){each(elems,processElement);};var processElement=function processElement(elem){var ctx=context(editor,elem,'span',$_cl4rr911jk26xevy.name(elem));switch(ctx){case'invalid-child':{finishWrapper();var children=$_2i1q6518jk26xexk.children(elem);processElements(children);finishWrapper();break;}case'valid':{var w=getOrOpenWrapper();$_9t36rc1yjk26xf33.wrap(elem,w);break;}case'skipping':case'existing':case'caret':}};var processNodes=function processNodes(nodes){var elems=map(nodes,Element$$1.fromDom);processElements(elems);};$_179pt43bjk26xfcg.walk(editor.dom,rng,function(nodes){finishWrapper();processNodes(nodes);});return newWrappers;};var annotateWithBookmark=function annotateWithBookmark(editor,name,settings,data){editor.undoManager.transact(function(){var initialRng=editor.selection.getRng();if(initialRng.collapsed){applyWordGrab(editor,initialRng);}var bookmark=$_ci8rza2jjk26xf6s.getPersistentBookmark(editor.selection,true);var rng=editor.selection.getRng();annotate(editor,rng,name,settings.decorate,data);editor.selection.moveToBookmark(bookmark);});};function Annotator(editor){var registry=create$1();setup$1(editor,registry);var changes=setup(editor,registry);return{register:function register(name,settings){registry.register(name,settings);},annotate:function annotate(name,data){registry.lookup(name).each(function(settings){annotateWithBookmark(editor,name,settings,data);});},annotationChanged:function annotationChanged(name,callback){changes.addListener(name,callback);},remove:function remove(name){identify(editor,Option.some(name)).each(function(_a){var elements=_a.elements;each(elements,$_5ur14v1wjk26xf2q.unwrap);});},getAll:function getAll(name){var directory=findAll(editor,name);return map$2(directory,function(elems){return map(elems,function(elem){return elem.dom();});});}};}var hasOnlyOneChild=function hasOnlyOneChild(node){return node.firstChild&&node.firstChild===node.lastChild;};var isPaddingNode=function isPaddingNode(node){return node.name==='br'||node.value==='\xA0';};var isPaddedEmptyBlock=function isPaddedEmptyBlock(schema,node){var blockElements=schema.getBlockElements();return blockElements[node.name]&&hasOnlyOneChild(node)&&isPaddingNode(node.firstChild);};var isEmptyFragmentElement=function isEmptyFragmentElement(schema,node){var nonEmptyElements=schema.getNonEmptyElements();return node&&(node.isEmpty(nonEmptyElements)||isPaddedEmptyBlock(schema,node));};var isListFragment=function isListFragment(schema,fragment){var firstChild=fragment.firstChild;var lastChild=fragment.lastChild;if(firstChild&&firstChild.name==='meta'){firstChild=firstChild.next;}if(lastChild&&lastChild.attr('id')==='mce_marker'){lastChild=lastChild.prev;}if(isEmptyFragmentElement(schema,lastChild)){lastChild=lastChild.prev;}if(!firstChild||firstChild!==lastChild){return false;}return firstChild.name==='ul'||firstChild.name==='ol';};var cleanupDomFragment=function cleanupDomFragment(domFragment){var firstChild=domFragment.firstChild;var lastChild=domFragment.lastChild;if(firstChild&&firstChild.nodeName==='META'){firstChild.parentNode.removeChild(firstChild);}if(lastChild&&lastChild.id==='mce_marker'){lastChild.parentNode.removeChild(lastChild);}return domFragment;};var toDomFragment=function toDomFragment(dom,serializer,fragment){var html=serializer.serialize(fragment);var domFragment=dom.createFragment(html);return cleanupDomFragment(domFragment);};var listItems$1=function listItems$1(elm){return $_2ytxahljk26xetf.grep(elm.childNodes,function(child){return child.nodeName==='LI';});};var isPadding=function isPadding(node){return node.data==='\xA0'||$_fpgwqg1rjk26xf0n.isBr(node);};var isListItemPadded=function isListItemPadded(node){return node&&node.firstChild&&node.firstChild===node.lastChild&&isPadding(node.firstChild);};var isEmptyOrPadded=function isEmptyOrPadded(elm){return!elm.firstChild||isListItemPadded(elm);};var trimListItems=function trimListItems(elms){return elms.length>0&&isEmptyOrPadded(elms[elms.length-1])?elms.slice(0,-1):elms;};var getParentLi=function getParentLi(dom,node){var parentBlock=dom.getParent(node,dom.isBlock);return parentBlock&&parentBlock.nodeName==='LI'?parentBlock:null;};var isParentBlockLi=function isParentBlockLi(dom,node){return!!getParentLi(dom,node);};var getSplit=function getSplit(parentNode,rng){var beforeRng=rng.cloneRange();var afterRng=rng.cloneRange();beforeRng.setStartBefore(parentNode);afterRng.setEndAfter(parentNode);return[beforeRng.cloneContents(),afterRng.cloneContents()];};var findFirstIn=function findFirstIn(node,rootNode){var caretPos=CaretPosition$1.before(node);var caretWalker=CaretWalker(rootNode);var newCaretPos=caretWalker.next(caretPos);return newCaretPos?newCaretPos.toRange():null;};var findLastOf=function findLastOf(node,rootNode){var caretPos=CaretPosition$1.after(node);var caretWalker=CaretWalker(rootNode);var newCaretPos=caretWalker.prev(caretPos);return newCaretPos?newCaretPos.toRange():null;};var insertMiddle=function insertMiddle(target,elms,rootNode,rng){var parts=getSplit(target,rng);var parentElm=target.parentNode;parentElm.insertBefore(parts[0],target);$_2ytxahljk26xetf.each(elms,function(li){parentElm.insertBefore(li,target);});parentElm.insertBefore(parts[1],target);parentElm.removeChild(target);return findLastOf(elms[elms.length-1],rootNode);};var insertBefore=function insertBefore(target,elms,rootNode){var parentElm=target.parentNode;$_2ytxahljk26xetf.each(elms,function(elm){parentElm.insertBefore(elm,target);});return findFirstIn(target,rootNode);};var insertAfter=function insertAfter(target,elms,rootNode,dom){dom.insertAfter(elms.reverse(),target);return findLastOf(elms[0],rootNode);};var insertAtCaret=function insertAtCaret(serializer,dom,rng,fragment){var domFragment=toDomFragment(dom,serializer,fragment);var liTarget=getParentLi(dom,rng.startContainer);var liElms=trimListItems(listItems$1(domFragment.firstChild));var BEGINNING=1,END=2;var rootNode=dom.getRoot();var isAt=function isAt(location){var caretPos=CaretPosition$1.fromRangeStart(rng);var caretWalker=CaretWalker(dom.getRoot());var newPos=location===BEGINNING?caretWalker.prev(caretPos):caretWalker.next(caretPos);return newPos?getParentLi(dom,newPos.getNode())!==liTarget:true;};if(isAt(BEGINNING)){return insertBefore(liTarget,liElms,rootNode);}else if(isAt(END)){return insertAfter(liTarget,liElms,rootNode,dom);}return insertMiddle(liTarget,liElms,rootNode,rng);};var $_67dh113jjk26xfhy={isListFragment:isListFragment,insertAtCaret:insertAtCaret,isParentBlockLi:isParentBlockLi,trimListItems:trimListItems,listItems:listItems$1};var each$9=$_2ytxahljk26xetf.each;var ElementUtils=function ElementUtils(dom){this.compare=function(node1,node2){if(node1.nodeName!==node2.nodeName){return false;}var getAttribs=function getAttribs(node){var attribs={};each$9(dom.getAttribs(node),function(attr){var name=attr.nodeName.toLowerCase();if(name.indexOf('_')!==0&&name!=='style'&&name.indexOf('data-')!==0){attribs[name]=dom.getAttrib(node,name);}});return attribs;};var compareObjects=function compareObjects(obj1,obj2){var value,name;for(name in obj1){if(obj1.hasOwnProperty(name)){value=obj2[name];if(typeof value==='undefined'){return false;}if(obj1[name]!==value){return false;}delete obj2[name];}}for(name in obj2){if(obj2.hasOwnProperty(name)){return false;}}return true;};if(!compareObjects(getAttribs(node1),getAttribs(node2))){return false;}if(!compareObjects(dom.parseStyle(dom.getAttrib(node1,'style')),dom.parseStyle(dom.getAttrib(node2,'style')))){return false;}return!$_2wdci52vjk26xf8r.isBookmarkNode(node1)&&!$_2wdci52vjk26xf8r.isBookmarkNode(node2);};};var getLastChildren=function getLastChildren(elm){var children=[];var rawNode=elm.dom();while(rawNode){children.push(Element$$1.fromDom(rawNode));rawNode=rawNode.lastChild;}return children;};var removeTrailingBr=function removeTrailingBr(elm){var allBrs=$_bisgdu27jk26xf4o.descendants(elm,'br');var brs=filter(getLastChildren(elm).slice(-1),isBr);if(allBrs.length===brs.length){each(brs,$_5ur14v1wjk26xf2q.remove);}};var fillWithPaddingBr=function fillWithPaddingBr(elm){$_5ur14v1wjk26xf2q.empty(elm);$_9t36rc1yjk26xf33.append(elm,Element$$1.fromHtml('<br data-mce-bogus="1">'));};var isPaddingContents=function isPaddingContents(elm){return $_cl4rr911jk26xevy.isText(elm)?$_30p3ln3ejk26xfct.get(elm)==='\xA0':isBr(elm);};var isPaddedElement=function isPaddedElement(elm){return filter($_2i1q6518jk26xexk.children(elm),isPaddingContents).length===1;};var trimBlockTrailingBr=function trimBlockTrailingBr(elm){$_2i1q6518jk26xexk.lastChild(elm).each(function(lastChild){$_2i1q6518jk26xexk.prevSibling(lastChild).each(function(lastChildPrevSibling){if(isBlock(elm)&&isBr(lastChild)&&isBlock(lastChildPrevSibling)){$_5ur14v1wjk26xf2q.remove(lastChild);}});});};var $_bpbbqb3ljk26xfi6={removeTrailingBr:removeTrailingBr,fillWithPaddingBr:fillWithPaddingBr,isPaddedElement:isPaddedElement,trimBlockTrailingBr:trimBlockTrailingBr};var makeMap$3=$_2ytxahljk26xetf.makeMap;function Writer(settings){var html=[];var indent,indentBefore,indentAfter,encode,htmlOutput;settings=settings||{};indent=settings.indent;indentBefore=makeMap$3(settings.indent_before||'');indentAfter=makeMap$3(settings.indent_after||'');encode=$_8udjtn1sjk26xf0t.getEncodeFunc(settings.entity_encoding||'raw',settings.entities);htmlOutput=settings.element_format==='html';return{start:function start(name,attrs,empty){var i,l,attr,value;if(indent&&indentBefore[name]&&html.length>0){value=html[html.length-1];if(value.length>0&&value!=='\n'){html.push('\n');}}html.push('<',name);if(attrs){for(i=0,l=attrs.length;i<l;i++){attr=attrs[i];html.push(' ',attr.name,'="',encode(attr.value,true),'"');}}if(!empty||htmlOutput){html[html.length]='>';}else{html[html.length]=' />';}if(empty&&indent&&indentAfter[name]&&html.length>0){value=html[html.length-1];if(value.length>0&&value!=='\n'){html.push('\n');}}},end:function end(name){var value;html.push('</',name,'>');if(indent&&indentAfter[name]&&html.length>0){value=html[html.length-1];if(value.length>0&&value!=='\n'){html.push('\n');}}},text:function text(_text,raw){if(_text.length>0){html[html.length]=raw?_text:encode(_text);}},cdata:function cdata(text){html.push('<![CDATA[',text,']]>');},comment:function comment(text){html.push('<!--',text,'-->');},pi:function pi(name,text){if(text){html.push('<?',name,' ',encode(text),'?>');}else{html.push('<?',name,'?>');}if(indent){html.push('\n');}},doctype:function doctype(text){html.push('<!DOCTYPE',text,'>',indent?'\n':'');},reset:function reset(){html.length=0;},getContent:function getContent(){return html.join('').replace(/\n$/,'');}};}function HtmlSerializer(settings,schema){if(schema===void 0){schema=Schema();}var writer=Writer(settings);settings=settings||{};settings.validate='validate'in settings?settings.validate:true;var serialize=function serialize(node){var handlers,validate;validate=settings.validate;handlers={3:function _(node){writer.text(node.value,node.raw);},8:function _(node){writer.comment(node.value);},7:function _(node){writer.pi(node.name,node.value);},10:function _(node){writer.doctype(node.value);},4:function _(node){writer.cdata(node.value);},11:function _(node){if(node=node.firstChild){do{walk(node);}while(node=node.next);}}};writer.reset();var walk=function walk(node){var handler=handlers[node.type];var name,isEmpty,attrs,attrName,attrValue,sortedAttrs,i,l,elementRule;if(!handler){name=node.name;isEmpty=node.shortEnded;attrs=node.attributes;if(validate&&attrs&&attrs.length>1){sortedAttrs=[];sortedAttrs.map={};elementRule=schema.getElementRule(node.name);if(elementRule){for(i=0,l=elementRule.attributesOrder.length;i<l;i++){attrName=elementRule.attributesOrder[i];if(attrName in attrs.map){attrValue=attrs.map[attrName];sortedAttrs.map[attrName]=attrValue;sortedAttrs.push({name:attrName,value:attrValue});}}for(i=0,l=attrs.length;i<l;i++){attrName=attrs[i].name;if(!(attrName in sortedAttrs.map)){attrValue=attrs.map[attrName];sortedAttrs.map[attrName]=attrValue;sortedAttrs.push({name:attrName,value:attrValue});}}attrs=sortedAttrs;}}writer.start(node.name,attrs,isEmpty);if(!isEmpty){if(node=node.firstChild){do{walk(node);}while(node=node.next);}writer.end(name);}}else{handler(node);}};if(node.type===1&&!settings.inner){walk(node);}else{handlers[11](node);}return writer.getContent();};return{serialize:serialize};}var createRange$1=function createRange$1(sc,so,ec,eo){var rng=document.createRange();rng.setStart(sc,so);rng.setEnd(ec,eo);return rng;};var normalizeBlockSelectionRange=function normalizeBlockSelectionRange(rng){var startPos=CaretPosition$1.fromRangeStart(rng);var endPos=CaretPosition$1.fromRangeEnd(rng);var rootNode=rng.commonAncestorContainer;return $_bwopbb2yjk26xf9h.fromPosition(false,rootNode,endPos).map(function(newEndPos){if(!isInSameBlock(startPos,endPos,rootNode)&&isInSameBlock(startPos,newEndPos,rootNode)){return createRange$1(startPos.container(),startPos.offset(),newEndPos.container(),newEndPos.offset());}else{return rng;}}).getOr(rng);};var normalize=function normalize(rng){return rng.collapsed?rng:normalizeBlockSelectionRange(rng);};var $_9o204u3ojk26xfis={normalize:normalize};var isTableCell$2=$_fpgwqg1rjk26xf0n.matchNodeNames('td th');var validInsertion=function validInsertion(editor,value,parentNode){if(parentNode.getAttribute('data-mce-bogus')==='all'){parentNode.parentNode.insertBefore(editor.dom.createFragment(value),parentNode);}else{var node=parentNode.firstChild;var node2=parentNode.lastChild;if(!node||node===node2&&node.nodeName==='BR'){editor.dom.setHTML(parentNode,value);}else{editor.selection.setContent(value);}}};var trimBrsFromTableCell=function trimBrsFromTableCell(dom,elm){Option.from(dom.getParent(elm,'td,th')).map(Element$$1.fromDom).each($_bpbbqb3ljk26xfi6.trimBlockTrailingBr);};var insertHtmlAtCaret=function insertHtmlAtCaret(editor,value,details){var parser,serializer,parentNode,rootNode,fragment,args;var marker,rng,node,node2,bookmarkHtml,merge;var textInlineElements=editor.schema.getTextInlineElements();var selection=editor.selection,dom=editor.dom;var trimOrPaddLeftRight=function trimOrPaddLeftRight(html){var rng,container,offset;rng=selection.getRng();container=rng.startContainer;offset=rng.startOffset;var hasSiblingText=function hasSiblingText(siblingName){return container[siblingName]&&container[siblingName].nodeType===3;};if(container.nodeType===3){if(offset>0){html=html.replace(/^&nbsp;/,' ');}else if(!hasSiblingText('previousSibling')){html=html.replace(/^ /,'&nbsp;');}if(offset<container.length){html=html.replace(/&nbsp;(<br>|)$/,' ');}else if(!hasSiblingText('nextSibling')){html=html.replace(/(&nbsp;| )(<br>|)$/,'&nbsp;');}}return html;};var trimNbspAfterDeleteAndPaddValue=function trimNbspAfterDeleteAndPaddValue(){var rng,container,offset;rng=selection.getRng();container=rng.startContainer;offset=rng.startOffset;if(container.nodeType===3&&rng.collapsed){if(container.data[offset]==='\xA0'){container.deleteData(offset,1);if(!/[\u00a0| ]$/.test(value)){value+=' ';}}else if(container.data[offset-1]==='\xA0'){container.deleteData(offset-1,1);if(!/[\u00a0| ]$/.test(value)){value=' '+value;}}}};var reduceInlineTextElements=function reduceInlineTextElements(){if(merge){var root_1=editor.getBody(),elementUtils_1=new ElementUtils(dom);$_2ytxahljk26xetf.each(dom.select('*[data-mce-fragment]'),function(node){for(var testNode=node.parentNode;testNode&&testNode!==root_1;testNode=testNode.parentNode){if(textInlineElements[node.nodeName.toLowerCase()]&&elementUtils_1.compare(testNode,node)){dom.remove(node,true);}}});}};var markFragmentElements=function markFragmentElements(fragment){var node=fragment;while(node=node.walk()){if(node.type===1){node.attr('data-mce-fragment','1');}}};var umarkFragmentElements=function umarkFragmentElements(elm){$_2ytxahljk26xetf.each(elm.getElementsByTagName('*'),function(elm){elm.removeAttribute('data-mce-fragment');});};var isPartOfFragment=function isPartOfFragment(node){return!!node.getAttribute('data-mce-fragment');};var canHaveChildren=function canHaveChildren(node){return node&&!editor.schema.getShortEndedElements()[node.nodeName];};var moveSelectionToMarker=function moveSelectionToMarker(marker){var parentEditableFalseElm,parentBlock,nextRng;var getContentEditableFalseParent=function getContentEditableFalseParent(node){var root=editor.getBody();for(;node&&node!==root;node=node.parentNode){if(editor.dom.getContentEditable(node)==='false'){return node;}}return null;};if(!marker){return;}selection.scrollIntoView(marker);parentEditableFalseElm=getContentEditableFalseParent(marker);if(parentEditableFalseElm){dom.remove(marker);selection.select(parentEditableFalseElm);return;}rng=dom.createRng();node=marker.previousSibling;if(node&&node.nodeType===3){rng.setStart(node,node.nodeValue.length);if(!$_ef6mqpajk26xejm.ie){node2=marker.nextSibling;if(node2&&node2.nodeType===3){node.appendData(node2.data);node2.parentNode.removeChild(node2);}}}else{rng.setStartBefore(marker);rng.setEndBefore(marker);}var findNextCaretRng=function findNextCaretRng(rng){var caretPos=CaretPosition$1.fromRangeStart(rng);var caretWalker=CaretWalker(editor.getBody());caretPos=caretWalker.next(caretPos);if(caretPos){return caretPos.toRange();}};parentBlock=dom.getParent(marker,dom.isBlock);dom.remove(marker);if(parentBlock&&dom.isEmpty(parentBlock)){editor.$(parentBlock).empty();rng.setStart(parentBlock,0);rng.setEnd(parentBlock,0);if(!isTableCell$2(parentBlock)&&!isPartOfFragment(parentBlock)&&(nextRng=findNextCaretRng(rng))){rng=nextRng;dom.remove(parentBlock);}else{dom.add(parentBlock,dom.create('br',{'data-mce-bogus':'1'}));}}selection.setRng(rng);};if(/^ | $/.test(value)){value=trimOrPaddLeftRight(value);}parser=editor.parser;merge=details.merge;serializer=HtmlSerializer({validate:editor.settings.validate},editor.schema);bookmarkHtml='<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';args={content:value,format:'html',selection:true,paste:details.paste};args=editor.fire('BeforeSetContent',args);if(args.isDefaultPrevented()){editor.fire('SetContent',{content:args.content,format:'html',selection:true,paste:details.paste});return;}value=args.content;if(value.indexOf('{$caret}')===-1){value+='{$caret}';}value=value.replace(/\{\$caret\}/,bookmarkHtml);rng=selection.getRng();var caretElement=rng.startContainer||(rng.parentElement?rng.parentElement():null);var body=editor.getBody();if(caretElement===body&&selection.isCollapsed()){if(dom.isBlock(body.firstChild)&&canHaveChildren(body.firstChild)&&dom.isEmpty(body.firstChild)){rng=dom.createRng();rng.setStart(body.firstChild,0);rng.setEnd(body.firstChild,0);selection.setRng(rng);}}if(!selection.isCollapsed()){editor.selection.setRng($_9o204u3ojk26xfis.normalize(editor.selection.getRng()));editor.getDoc().execCommand('Delete',false,null);trimNbspAfterDeleteAndPaddValue();}parentNode=selection.getNode();var parserArgs={context:parentNode.nodeName.toLowerCase(),data:details.data,insert:true};fragment=parser.parse(value,parserArgs);if(details.paste===true&&$_67dh113jjk26xfhy.isListFragment(editor.schema,fragment)&&$_67dh113jjk26xfhy.isParentBlockLi(dom,parentNode)){rng=$_67dh113jjk26xfhy.insertAtCaret(serializer,dom,editor.selection.getRng(),fragment);editor.selection.setRng(rng);editor.fire('SetContent',args);return;}markFragmentElements(fragment);node=fragment.lastChild;if(node.attr('id')==='mce_marker'){marker=node;for(node=node.prev;node;node=node.walk(true)){if(node.type===3||!dom.isBlock(node.name)){if(editor.schema.isValidChild(node.parent.name,'span')){node.parent.insert(marker,node,node.name==='br');}break;}}}editor._selectionOverrides.showBlockCaretContainer(parentNode);if(!parserArgs.invalid){value=serializer.serialize(fragment);validInsertion(editor,value,parentNode);}else{selection.setContent(bookmarkHtml);parentNode=selection.getNode();rootNode=editor.getBody();if(parentNode.nodeType===9){parentNode=node=rootNode;}else{node=parentNode;}while(node!==rootNode){parentNode=node;node=node.parentNode;}value=parentNode===rootNode?rootNode.innerHTML:dom.getOuterHTML(parentNode);value=serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i,function(){return serializer.serialize(fragment);})));if(parentNode===rootNode){dom.setHTML(rootNode,value);}else{dom.setOuterHTML(parentNode,value);}}reduceInlineTextElements();moveSelectionToMarker(dom.get('mce_marker'));umarkFragmentElements(editor.getBody());trimBrsFromTableCell(editor.dom,editor.selection.getStart());editor.fire('SetContent',args);editor.addVisual();};var processValue=function processValue(value){var details;if(typeof value!=='string'){details=$_2ytxahljk26xetf.extend({paste:value.paste,data:{paste:value.paste}},value);return{content:value.content,details:details};}return{content:value,details:{}};};var insertAtCaret$1=function insertAtCaret$1(editor,value){var result=processValue(value);insertHtmlAtCaret(editor,result.content,result.details);};var $_4cdrcb3ijk26xfhi={insertAtCaret:insertAtCaret$1};var sectionResult=Immutable('sections','settings');var detection=$_8x4ci6ojk26xeuf.detect();var isTouch=detection.deviceType.isTouch();var mobilePlugins=['lists','autolink','autosave'];var defaultMobileSettings={theme:'mobile'};var normalizePlugins=function normalizePlugins(plugins){var pluginNames=isArray(plugins)?plugins.join(' '):plugins;var trimmedPlugins=map(isString(pluginNames)?pluginNames.split(' '):[],trim$2);return filter(trimmedPlugins,function(item){return item.length>0;});};var filterMobilePlugins=function filterMobilePlugins(plugins){return filter(plugins,curry(contains,mobilePlugins));};var extractSections=function extractSections(keys$$1,settings){var result=bifilter(settings,function(value,key){return contains(keys$$1,key);});return sectionResult(result.t,result.f);};var getSection=function getSection(sectionResult,name,defaults){var sections=sectionResult.sections();var sectionSettings=sections.hasOwnProperty(name)?sections[name]:{};return $_2ytxahljk26xetf.extend({},defaults,sectionSettings);};var hasSection=function hasSection(sectionResult,name){return sectionResult.sections().hasOwnProperty(name);};var getDefaultSettings=function getDefaultSettings(id,documentBaseUrl,editor){return{id:id,theme:'modern',delta_width:0,delta_height:0,popup_css:'',plugins:'',document_base_url:documentBaseUrl,add_form_submit_trigger:true,submit_patch:true,add_unload_trigger:true,convert_urls:true,relative_urls:true,remove_script_host:true,object_resizing:true,doctype:'<!DOCTYPE html>',visual:true,font_size_style_values:'xx-small,x-small,small,medium,large,x-large,xx-large',font_size_legacy_values:'xx-small,small,medium,large,x-large,xx-large,300%',forced_root_block:'p',hidden_input:true,render_ui:true,indentation:'30px',inline_styles:true,convert_fonts_to_spans:true,indent:'simple',indent_before:'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,'+'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',indent_after:'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,'+'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',entity_encoding:'named',url_converter:editor.convertURL,url_converter_scope:editor,ie7_compat:true};};var getExternalPlugins=function getExternalPlugins(overrideSettings,settings){var userDefinedExternalPlugins=settings.external_plugins?settings.external_plugins:{};if(overrideSettings&&overrideSettings.external_plugins){return $_2ytxahljk26xetf.extend({},overrideSettings.external_plugins,userDefinedExternalPlugins);}else{return userDefinedExternalPlugins;}};var combinePlugins=function combinePlugins(forcedPlugins,plugins){return[].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));};var processPlugins=function processPlugins(isTouchDevice,sectionResult,defaultOverrideSettings,settings){var forcedPlugins=normalizePlugins(defaultOverrideSettings.forced_plugins);var plugins=normalizePlugins(settings.plugins);var platformPlugins=isTouchDevice&&hasSection(sectionResult,'mobile')?filterMobilePlugins(plugins):plugins;var combinedPlugins=combinePlugins(forcedPlugins,platformPlugins);return $_2ytxahljk26xetf.extend(settings,{plugins:combinedPlugins.join(' ')});};var isOnMobile=function isOnMobile(isTouchDevice,sectionResult){var isInline=sectionResult.settings().inline;return isTouchDevice&&hasSection(sectionResult,'mobile')&&!isInline;};var combineSettings=function combineSettings(isTouchDevice,defaultSettings,defaultOverrideSettings,settings){var sectionResult=extractSections(['mobile'],settings);var extendedSettings=$_2ytxahljk26xetf.extend(defaultSettings,defaultOverrideSettings,sectionResult.settings(),isOnMobile(isTouchDevice,sectionResult)?getSection(sectionResult,'mobile',defaultMobileSettings):{},{validate:true,content_editable:sectionResult.settings().inline,external_plugins:getExternalPlugins(defaultOverrideSettings,sectionResult.settings())});return processPlugins(isTouchDevice,sectionResult,defaultOverrideSettings,extendedSettings);};var getEditorSettings=function getEditorSettings(editor,id,documentBaseUrl,defaultOverrideSettings,settings){var defaultSettings=getDefaultSettings(id,documentBaseUrl,editor);return combineSettings(isTouch,defaultSettings,defaultOverrideSettings,settings);};var getFiltered=function getFiltered(predicate,editor,name){return Option.from(editor.settings[name]).filter(predicate);};var getString=curry(getFiltered,isString);var getParamObject=function getParamObject(value){var output={};if(typeof value==='string'){each(value.indexOf('=')>0?value.split(/[;,](?![^=;,]*(?:[;,]|$))/):value.split(','),function(val){var arr=val.split('=');if(arr.length>1){output[$_2ytxahljk26xetf.trim(arr[0])]=$_2ytxahljk26xetf.trim(arr[1]);}else{output[$_2ytxahljk26xetf.trim(arr[0])]=$_2ytxahljk26xetf.trim(arr);}});}else{output=value;}return output;};var isArrayOf=function isArrayOf(p){return function(a){return isArray(a)&&forall(a,p);};};var _getParam=function _getParam(editor,name,defaultVal,type){var value=name in editor.settings?editor.settings[name]:defaultVal;if(type==='hash'){return getParamObject(value);}else if(type==='string'){return getFiltered(isString,editor,name).getOr(defaultVal);}else if(type==='number'){return getFiltered(isNumber,editor,name).getOr(defaultVal);}else if(type==='boolean'){return getFiltered(isBoolean,editor,name).getOr(defaultVal);}else if(type==='object'){return getFiltered(isObject,editor,name).getOr(defaultVal);}else if(type==='array'){return getFiltered(isArray,editor,name).getOr(defaultVal);}else if(type==='string[]'){return getFiltered(isArrayOf(isString),editor,name).getOr(defaultVal);}else if(type==='function'){return getFiltered(isFunction,editor,name).getOr(defaultVal);}else{return value;}};var strongRtl=/[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;var hasStrongRtl=function hasStrongRtl(text){return strongRtl.test(text);};var isInlineTarget=function isInlineTarget(editor,elm){var selector=getString(editor,'inline_boundaries_selector').getOr('a[href],code');return $_95wtq21gjk26xeyv.is(Element$$1.fromDom(elm),selector);};var isRtl=function isRtl(element){return DOMUtils$1.DOM.getStyle(element,'direction',true)==='rtl'||hasStrongRtl(element.textContent);};var findInlineParents=function findInlineParents(isInlineTarget,rootNode,pos){return filter(DOMUtils$1.DOM.getParents(pos.container(),'*',rootNode),isInlineTarget);};var findRootInline=function findRootInline(isInlineTarget,rootNode,pos){var parents=findInlineParents(isInlineTarget,rootNode,pos);return Option.from(parents[parents.length-1]);};var hasSameParentBlock=function hasSameParentBlock(rootNode,node1,node2){var block1=getParentBlock(node1,rootNode);var block2=getParentBlock(node2,rootNode);return block1&&block1===block2;};var isAtZwsp=function isAtZwsp(pos){return isBeforeInline(pos)||isAfterInline(pos);};var normalizePosition=function normalizePosition(forward,pos){var container=pos.container(),offset=pos.offset();if(forward){if(isCaretContainerInline(container)){if($_fpgwqg1rjk26xf0n.isText(container.nextSibling)){return CaretPosition$1(container.nextSibling,0);}else{return CaretPosition$1.after(container);}}else{return isBeforeInline(pos)?CaretPosition$1(container,offset+1):pos;}}else{if(isCaretContainerInline(container)){if($_fpgwqg1rjk26xf0n.isText(container.previousSibling)){return CaretPosition$1(container.previousSibling,container.previousSibling.data.length);}else{return CaretPosition$1.before(container);}}else{return isAfterInline(pos)?CaretPosition$1(container,offset-1):pos;}}};var normalizeForwards=curry(normalizePosition,true);var normalizeBackwards=curry(normalizePosition,false);var $_eegxt33tjk26xfjt={isInlineTarget:isInlineTarget,findRootInline:findRootInline,isRtl:isRtl,isAtZwsp:isAtZwsp,normalizePosition:normalizePosition,normalizeForwards:normalizeForwards,normalizeBackwards:normalizeBackwards,hasSameParentBlock:hasSameParentBlock};var isBeforeRoot=function isBeforeRoot(rootNode){return function(elm){return $_dzedg81ejk26xeyh.eq(rootNode,Element$$1.fromDom(elm.dom().parentNode));};};var getParentBlock$1=function getParentBlock$1(rootNode,elm){return $_dzedg81ejk26xeyh.contains(rootNode,elm)?$_am0h6a2ajk26xf4w.closest(elm,function(element){return isTextBlock(element)||isListItem(element);},isBeforeRoot(rootNode)):Option.none();};var placeCaretInEmptyBody=function placeCaretInEmptyBody(editor){var body=editor.getBody();var node=body.firstChild&&editor.dom.isBlock(body.firstChild)?body.firstChild:body;editor.selection.setCursorLocation(node,0);};var paddEmptyBody=function paddEmptyBody(editor){if(editor.dom.isEmpty(editor.getBody())){editor.setContent('');placeCaretInEmptyBody(editor);}};var willDeleteLastPositionInElement=function willDeleteLastPositionInElement(forward,fromPos,elm){return liftN([$_bwopbb2yjk26xf9h.firstPositionIn(elm),$_bwopbb2yjk26xf9h.lastPositionIn(elm)],function(firstPos,lastPos){var normalizedFirstPos=$_eegxt33tjk26xfjt.normalizePosition(true,firstPos);var normalizedLastPos=$_eegxt33tjk26xfjt.normalizePosition(false,lastPos);var normalizedFromPos=$_eegxt33tjk26xfjt.normalizePosition(false,fromPos);if(forward){return $_bwopbb2yjk26xf9h.nextPosition(elm,normalizedFromPos).map(function(nextPos){return nextPos.isEqual(normalizedLastPos)&&fromPos.isEqual(normalizedFirstPos);}).getOr(false);}else{return $_bwopbb2yjk26xf9h.prevPosition(elm,normalizedFromPos).map(function(prevPos){return prevPos.isEqual(normalizedFirstPos)&&fromPos.isEqual(normalizedLastPos);}).getOr(false);}}).getOr(true);};var $_pu1tq3sjk26xfjd={getParentBlock:getParentBlock$1,paddEmptyBody:paddEmptyBody,willDeleteLastPositionInElement:willDeleteLastPositionInElement};var any=function any(selector){return $_dbgjqa29jk26xf4u.first(selector).isSome();};var ancestor$2=function ancestor$2(scope,selector,isRoot){return $_dbgjqa29jk26xf4u.ancestor(scope,selector,isRoot).isSome();};var sibling$3=function sibling$3(scope,selector){return $_dbgjqa29jk26xf4u.sibling(scope,selector).isSome();};var child$3=function child$3(scope,selector){return $_dbgjqa29jk26xf4u.child(scope,selector).isSome();};var descendant$2=function descendant$2(scope,selector){return $_dbgjqa29jk26xf4u.descendant(scope,selector).isSome();};var closest$2=function closest$2(scope,selector,isRoot){return $_dbgjqa29jk26xf4u.closest(scope,selector,isRoot).isSome();};var $_1d9qqt3xjk26xfkr={any:any,ancestor:ancestor$2,sibling:sibling$3,child:child$3,descendant:descendant$2,closest:closest$2};var hasWhitespacePreserveParent=function hasWhitespacePreserveParent(rootNode,node){var rootElement=Element$$1.fromDom(rootNode);var startNode=Element$$1.fromDom(node);return $_1d9qqt3xjk26xfkr.ancestor(startNode,'pre,code',curry($_dzedg81ejk26xeyh.eq,rootElement));};var isWhitespace=function isWhitespace(rootNode,node){return $_fpgwqg1rjk26xf0n.isText(node)&&/^[ \t\r\n]*$/.test(node.data)&&hasWhitespacePreserveParent(rootNode,node)===false;};var isNamedAnchor=function isNamedAnchor(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&node.nodeName==='A'&&node.hasAttribute('name');};var isContent=function isContent(rootNode,node){return isCaretCandidate(node)&&isWhitespace(rootNode,node)===false||isNamedAnchor(node)||isBookmark(node);};var isBookmark=$_fpgwqg1rjk26xf0n.hasAttribute('data-mce-bookmark');var isBogus$2=$_fpgwqg1rjk26xf0n.hasAttribute('data-mce-bogus');var isBogusAll$1=$_fpgwqg1rjk26xf0n.hasAttributeValue('data-mce-bogus','all');var isEmptyNode=function isEmptyNode(targetNode){var walker,node,brCount=0;if(isContent(targetNode,targetNode)){return false;}else{node=targetNode.firstChild;if(!node){return true;}walker=new TreeWalker(node,targetNode);do{if(isBogusAll$1(node)){node=walker.next(true);continue;}if(isBogus$2(node)){node=walker.next();continue;}if($_fpgwqg1rjk26xf0n.isBr(node)){brCount++;node=walker.next();continue;}if(isContent(targetNode,node)){return false;}node=walker.next();}while(node);return brCount<=1;}};var isEmpty$1=function isEmpty$1(elm){return isEmptyNode(elm.dom());};var $_4w3a5a3wjk26xfkj={isEmpty:isEmpty$1};var BlockPosition=Immutable('block','position');var BlockBoundary=Immutable('from','to');var getBlockPosition=function getBlockPosition(rootNode,pos){var rootElm=Element$$1.fromDom(rootNode);var containerElm=Element$$1.fromDom(pos.container());return $_pu1tq3sjk26xfjd.getParentBlock(rootElm,containerElm).map(function(block){return BlockPosition(block,pos);});};var isDifferentBlocks=function isDifferentBlocks(blockBoundary){return $_dzedg81ejk26xeyh.eq(blockBoundary.from().block(),blockBoundary.to().block())===false;};var hasSameParent=function hasSameParent(blockBoundary){return $_2i1q6518jk26xexk.parent(blockBoundary.from().block()).bind(function(parent1){return $_2i1q6518jk26xexk.parent(blockBoundary.to().block()).filter(function(parent2){return $_dzedg81ejk26xeyh.eq(parent1,parent2);});}).isSome();};var isEditable=function isEditable(blockBoundary){return $_fpgwqg1rjk26xf0n.isContentEditableFalse(blockBoundary.from().block())===false&&$_fpgwqg1rjk26xf0n.isContentEditableFalse(blockBoundary.to().block())===false;};var skipLastBr=function skipLastBr(rootNode,forward,blockPosition){if($_fpgwqg1rjk26xf0n.isBr(blockPosition.position().getNode())&&$_4w3a5a3wjk26xfkj.isEmpty(blockPosition.block())===false){return $_bwopbb2yjk26xf9h.positionIn(false,blockPosition.block().dom()).bind(function(lastPositionInBlock){if(lastPositionInBlock.isEqual(blockPosition.position())){return $_bwopbb2yjk26xf9h.fromPosition(forward,rootNode,lastPositionInBlock).bind(function(to){return getBlockPosition(rootNode,to);});}else{return Option.some(blockPosition);}}).getOr(blockPosition);}else{return blockPosition;}};var readFromRange=function readFromRange(rootNode,forward,rng){var fromBlockPos=getBlockPosition(rootNode,CaretPosition$1.fromRangeStart(rng));var toBlockPos=fromBlockPos.bind(function(blockPos){return $_bwopbb2yjk26xf9h.fromPosition(forward,rootNode,blockPos.position()).bind(function(to){return getBlockPosition(rootNode,to).map(function(blockPos){return skipLastBr(rootNode,forward,blockPos);});});});return liftN([fromBlockPos,toBlockPos],BlockBoundary).filter(function(blockBoundary){return isDifferentBlocks(blockBoundary)&&hasSameParent(blockBoundary)&&isEditable(blockBoundary);});};var read$1=function read$1(rootNode,forward,rng){return rng.collapsed?readFromRange(rootNode,forward,rng):Option.none();};var $_dphc3f3rjk26xfj2={read:read$1};var dropLast=function dropLast(xs){return xs.slice(0,-1);};var parentsUntil$1=function parentsUntil$1(startNode,rootElm,predicate){if($_dzedg81ejk26xeyh.contains(rootElm,startNode)){return dropLast($_2i1q6518jk26xexk.parents(startNode,function(elm){return predicate(elm)||$_dzedg81ejk26xeyh.eq(elm,rootElm);}));}else{return[];}};var parents$1=function parents$1(startNode,rootElm){return parentsUntil$1(startNode,rootElm,constant(false));};var parentsAndSelf=function parentsAndSelf(startNode,rootElm){return[startNode].concat(parents$1(startNode,rootElm));};var $_du4do23zjk26xfl5={parentsUntil:parentsUntil$1,parents:parents$1,parentsAndSelf:parentsAndSelf};var getChildrenUntilBlockBoundary=function getChildrenUntilBlockBoundary(block){var children=$_2i1q6518jk26xexk.children(block);return findIndex(children,isBlock).fold(function(){return children;},function(index){return children.slice(0,index);});};var extractChildren=function extractChildren(block){var children=getChildrenUntilBlockBoundary(block);each(children,function(node){$_5ur14v1wjk26xf2q.remove(node);});return children;};var trimBr=function trimBr(first,block){$_bwopbb2yjk26xf9h.positionIn(first,block.dom()).each(function(position){var node=position.getNode();if($_fpgwqg1rjk26xf0n.isBr(node)){$_5ur14v1wjk26xf2q.remove(Element$$1.fromDom(node));}});};var removeEmptyRoot=function removeEmptyRoot(rootNode,block){var parents=$_du4do23zjk26xfl5.parentsAndSelf(block,rootNode);return find(parents.reverse(),$_4w3a5a3wjk26xfkj.isEmpty).each($_5ur14v1wjk26xf2q.remove);};var findParentInsertPoint=function findParentInsertPoint(toBlock,block){var parents=$_2i1q6518jk26xexk.parents(block,function(elm){return $_dzedg81ejk26xeyh.eq(elm,toBlock);});return Option.from(parents[parents.length-2]);};var getInsertionPoint=function getInsertionPoint(fromBlock,toBlock){if($_dzedg81ejk26xeyh.contains(toBlock,fromBlock)){return $_2i1q6518jk26xexk.parent(fromBlock).bind(function(parent){return $_dzedg81ejk26xeyh.eq(parent,toBlock)?Option.some(fromBlock):findParentInsertPoint(toBlock,fromBlock);});}else{return Option.none();}};var mergeBlockInto=function mergeBlockInto(rootNode,fromBlock,toBlock){if($_4w3a5a3wjk26xfkj.isEmpty(toBlock)){$_5ur14v1wjk26xf2q.remove(toBlock);if($_4w3a5a3wjk26xfkj.isEmpty(fromBlock)){$_bpbbqb3ljk26xfi6.fillWithPaddingBr(fromBlock);}return $_bwopbb2yjk26xf9h.firstPositionIn(fromBlock.dom());}else{trimBr(true,fromBlock);trimBr(false,toBlock);var children_1=extractChildren(fromBlock);return getInsertionPoint(fromBlock,toBlock).fold(function(){removeEmptyRoot(rootNode,fromBlock);var position=$_bwopbb2yjk26xf9h.lastPositionIn(toBlock.dom());each(children_1,function(node){$_9t36rc1yjk26xf33.append(toBlock,node);});return position;},function(target){var position=$_bwopbb2yjk26xf9h.prevPosition(toBlock.dom(),CaretPosition$1.before(target.dom()));each(children_1,function(node){$_9t36rc1yjk26xf33.before(target,node);});removeEmptyRoot(rootNode,fromBlock);return position;});}};var mergeBlocks=function mergeBlocks(rootNode,forward,block1,block2){return forward?mergeBlockInto(rootNode,block2,block1):mergeBlockInto(rootNode,block1,block2);};var $_tyapt3yjk26xfkt={mergeBlocks:mergeBlocks};var backspaceDelete=function backspaceDelete(editor,forward){var position;var rootNode=Element$$1.fromDom(editor.getBody());position=$_dphc3f3rjk26xfj2.read(rootNode.dom(),forward,editor.selection.getRng()).bind(function(blockBoundary){return $_tyapt3yjk26xfkt.mergeBlocks(rootNode,forward,blockBoundary.from().block(),blockBoundary.to().block());});position.each(function(pos){editor.selection.setRng(pos.toRange());});return position.isSome();};var $_45jqb13qjk26xfix={backspaceDelete:backspaceDelete};var deleteRangeMergeBlocks=function deleteRangeMergeBlocks(rootNode,selection){var rng=selection.getRng();return liftN([$_pu1tq3sjk26xfjd.getParentBlock(rootNode,Element$$1.fromDom(rng.startContainer)),$_pu1tq3sjk26xfjd.getParentBlock(rootNode,Element$$1.fromDom(rng.endContainer))],function(block1,block2){if($_dzedg81ejk26xeyh.eq(block1,block2)===false){rng.deleteContents();$_tyapt3yjk26xfkt.mergeBlocks(rootNode,true,block1,block2).each(function(pos){selection.setRng(pos.toRange());});return true;}else{return false;}}).getOr(false);};var isRawNodeInTable=function isRawNodeInTable(root,rawNode){var node=Element$$1.fromDom(rawNode);var isRoot=curry($_dzedg81ejk26xeyh.eq,root);return $_am0h6a2ajk26xf4w.ancestor(node,isTableCell,isRoot).isSome();};var isSelectionInTable=function isSelectionInTable(root,rng){return isRawNodeInTable(root,rng.startContainer)||isRawNodeInTable(root,rng.endContainer);};var isEverythingSelected=function isEverythingSelected(root,rng){var noPrevious=$_bwopbb2yjk26xf9h.prevPosition(root.dom(),CaretPosition$1.fromRangeStart(rng)).isNone();var noNext=$_bwopbb2yjk26xf9h.nextPosition(root.dom(),CaretPosition$1.fromRangeEnd(rng)).isNone();return!isSelectionInTable(root,rng)&&noPrevious&&noNext;};var emptyEditor=function emptyEditor(editor){editor.setContent('');editor.selection.setCursorLocation();return true;};var deleteRange=function deleteRange(editor){var rootNode=Element$$1.fromDom(editor.getBody());var rng=editor.selection.getRng();return isEverythingSelected(rootNode,rng)?emptyEditor(editor):deleteRangeMergeBlocks(rootNode,editor.selection);};var backspaceDelete$1=function backspaceDelete$1(editor,forward){return editor.selection.isCollapsed()?false:deleteRange(editor);};var $_7pr3gu40jk26xflb={backspaceDelete:backspaceDelete$1};var generate$1=function generate$1(cases){if(!isArray(cases)){throw new Error('cases must be an array');}if(cases.length===0){throw new Error('there must be at least one case');}var constructors=[];var adt={};each(cases,function(acase,count){var keys$$1=keys(acase);if(keys$$1.length!==1){throw new Error('one and only one name per case');}var key=keys$$1[0];var value=acase[key];if(adt[key]!==undefined){throw new Error('duplicate key detected:'+key);}else if(key==='cata'){throw new Error('cannot have a case named cata (sorry)');}else if(!isArray(value)){throw new Error('case arguments must be an array');}constructors.push(key);adt[key]=function(){var argLength=arguments.length;if(argLength!==value.length){throw new Error('Wrong number of arguments to case '+key+'. Expected '+value.length+' ('+value+'), got '+argLength);}var args=new Array(argLength);for(var i=0;i<args.length;i++){args[i]=arguments[i];}var match=function match(branches){var branchKeys=keys(branches);if(constructors.length!==branchKeys.length){throw new Error('Wrong number of arguments to match. Expected: '+constructors.join(',')+'\nActual: '+branchKeys.join(','));}var allReqd=forall(constructors,function(reqKey){return contains(branchKeys,reqKey);});if(!allReqd)throw new Error('Not all branches were specified when using match. Specified: '+branchKeys.join(', ')+'\nRequired: '+constructors.join(', '));return branches[key].apply(null,args);};return{fold:function fold(){if(arguments.length!==cases.length){throw new Error('Wrong number of arguments to fold. Expected '+cases.length+', got '+arguments.length);}var target=arguments[count];return target.apply(null,args);},match:match,log:function log(label){console.log(label,{constructors:constructors,constructor:key,params:args});}};};});return adt;};var Adt={generate:generate$1};var isCompoundElement=function isCompoundElement(node){return isTableCell(Element$$1.fromDom(node))||isListItem(Element$$1.fromDom(node));};var DeleteAction=Adt.generate([{remove:['element']},{moveToElement:['element']},{moveToPosition:['position']}]);var isAtContentEditableBlockCaret=function isAtContentEditableBlockCaret(forward,from){var elm=from.getNode(forward===false);var caretLocation=forward?'after':'before';return $_fpgwqg1rjk26xf0n.isElement(elm)&&elm.getAttribute('data-mce-caret')===caretLocation;};var isDeleteFromCefDifferentBlocks=function isDeleteFromCefDifferentBlocks(root,forward,from,to){var inSameBlock=function inSameBlock(elm){return isInline(Element$$1.fromDom(elm))&&!isInSameBlock(from,to,root);};return getRelativeCefElm(!forward,from).fold(function(){return getRelativeCefElm(forward,to).fold(constant(false),inSameBlock);},inSameBlock);};var deleteEmptyBlockOrMoveToCef=function deleteEmptyBlockOrMoveToCef(root,forward,from,to){var toCefElm=to.getNode(forward===false);return $_pu1tq3sjk26xfjd.getParentBlock(Element$$1.fromDom(root),Element$$1.fromDom(from.getNode())).map(function(blockElm){return $_4w3a5a3wjk26xfkj.isEmpty(blockElm)?DeleteAction.remove(blockElm.dom()):DeleteAction.moveToElement(toCefElm);}).orThunk(function(){return Option.some(DeleteAction.moveToElement(toCefElm));});};var findCefPosition=function findCefPosition(root,forward,from){return $_bwopbb2yjk26xf9h.fromPosition(forward,root,from).bind(function(to){if(isCompoundElement(to.getNode())){return Option.none();}else if(isDeleteFromCefDifferentBlocks(root,forward,from,to)){return Option.none();}else if(forward&&$_fpgwqg1rjk26xf0n.isContentEditableFalse(to.getNode())){return deleteEmptyBlockOrMoveToCef(root,forward,from,to);}else if(forward===false&&$_fpgwqg1rjk26xf0n.isContentEditableFalse(to.getNode(true))){return deleteEmptyBlockOrMoveToCef(root,forward,from,to);}else if(forward&&isAfterContentEditableFalse(from)){return Option.some(DeleteAction.moveToPosition(to));}else if(forward===false&&isBeforeContentEditableFalse(from)){return Option.some(DeleteAction.moveToPosition(to));}else{return Option.none();}});};var getContentEditableBlockAction=function getContentEditableBlockAction(forward,elm){if(forward&&$_fpgwqg1rjk26xf0n.isContentEditableFalse(elm.nextSibling)){return Option.some(DeleteAction.moveToElement(elm.nextSibling));}else if(forward===false&&$_fpgwqg1rjk26xf0n.isContentEditableFalse(elm.previousSibling)){return Option.some(DeleteAction.moveToElement(elm.previousSibling));}else{return Option.none();}};var skipMoveToActionFromInlineCefToContent=function skipMoveToActionFromInlineCefToContent(root,from,deleteAction){return deleteAction.fold(function(elm){return Option.some(DeleteAction.remove(elm));},function(elm){return Option.some(DeleteAction.moveToElement(elm));},function(to){if(isInSameBlock(from,to,root)){return Option.none();}else{return Option.some(DeleteAction.moveToPosition(to));}});};var getContentEditableAction=function getContentEditableAction(root,forward,from){if(isAtContentEditableBlockCaret(forward,from)){return getContentEditableBlockAction(forward,from.getNode(forward===false)).fold(function(){return findCefPosition(root,forward,from);},Option.some);}else{return findCefPosition(root,forward,from).bind(function(deleteAction){return skipMoveToActionFromInlineCefToContent(root,from,deleteAction);});}};var read$2=function read$2(root,forward,rng){var normalizedRange=normalizeRange(forward?1:-1,root,rng);var from=CaretPosition$1.fromRangeStart(normalizedRange);if(forward===false&&isAfterContentEditableFalse(from)){return Option.some(DeleteAction.remove(from.getNode(true)));}else if(forward&&isBeforeContentEditableFalse(from)){return Option.some(DeleteAction.remove(from.getNode()));}else{return getContentEditableAction(root,forward,from);}};var needsReposition=function needsReposition(pos,elm){var container=pos.container();var offset=pos.offset();return CaretPosition$1.isTextPosition(pos)===false&&container===elm.parentNode&&offset>CaretPosition$1.before(elm).offset();};var reposition=function reposition(elm,pos){return needsReposition(pos,elm)?CaretPosition$1(pos.container(),pos.offset()-1):pos;};var beforeOrStartOf=function beforeOrStartOf(node){return $_fpgwqg1rjk26xf0n.isText(node)?CaretPosition$1(node,0):CaretPosition$1.before(node);};var afterOrEndOf=function afterOrEndOf(node){return $_fpgwqg1rjk26xf0n.isText(node)?CaretPosition$1(node,node.data.length):CaretPosition$1.after(node);};var getPreviousSiblingCaretPosition=function getPreviousSiblingCaretPosition(elm){if(isCaretCandidate(elm.previousSibling)){return Option.some(afterOrEndOf(elm.previousSibling));}else{return elm.previousSibling?$_bwopbb2yjk26xf9h.lastPositionIn(elm.previousSibling):Option.none();}};var getNextSiblingCaretPosition=function getNextSiblingCaretPosition(elm){if(isCaretCandidate(elm.nextSibling)){return Option.some(beforeOrStartOf(elm.nextSibling));}else{return elm.nextSibling?$_bwopbb2yjk26xf9h.firstPositionIn(elm.nextSibling):Option.none();}};var findCaretPositionBackwardsFromElm=function findCaretPositionBackwardsFromElm(rootElement,elm){var startPosition=CaretPosition$1.before(elm.previousSibling?elm.previousSibling:elm.parentNode);return $_bwopbb2yjk26xf9h.prevPosition(rootElement,startPosition).fold(function(){return $_bwopbb2yjk26xf9h.nextPosition(rootElement,CaretPosition$1.after(elm));},Option.some);};var findCaretPositionForwardsFromElm=function findCaretPositionForwardsFromElm(rootElement,elm){return $_bwopbb2yjk26xf9h.nextPosition(rootElement,CaretPosition$1.after(elm)).fold(function(){return $_bwopbb2yjk26xf9h.prevPosition(rootElement,CaretPosition$1.before(elm));},Option.some);};var findCaretPositionBackwards=function findCaretPositionBackwards(rootElement,elm){return getPreviousSiblingCaretPosition(elm).orThunk(function(){return getNextSiblingCaretPosition(elm);}).orThunk(function(){return findCaretPositionBackwardsFromElm(rootElement,elm);});};var findCaretPositionForward=function findCaretPositionForward(rootElement,elm){return getNextSiblingCaretPosition(elm).orThunk(function(){return getPreviousSiblingCaretPosition(elm);}).orThunk(function(){return findCaretPositionForwardsFromElm(rootElement,elm);});};var findCaretPosition$1=function findCaretPosition$1(forward,rootElement,elm){return forward?findCaretPositionForward(rootElement,elm):findCaretPositionBackwards(rootElement,elm);};var findCaretPosOutsideElmAfterDelete=function findCaretPosOutsideElmAfterDelete(forward,rootElement,elm){return findCaretPosition$1(forward,rootElement,elm).map(curry(reposition,elm));};var setSelection=function setSelection(editor,forward,pos){pos.fold(function(){editor.focus();},function(pos){editor.selection.setRng(pos.toRange(),forward);});};var eqRawNode=function eqRawNode(rawNode){return function(elm){return elm.dom()===rawNode;};};var isBlock$2=function isBlock$2(editor,elm){return elm&&editor.schema.getBlockElements().hasOwnProperty($_cl4rr911jk26xevy.name(elm));};var paddEmptyBlock=function paddEmptyBlock(elm){if($_4w3a5a3wjk26xfkj.isEmpty(elm)){var br=Element$$1.fromHtml('<br data-mce-bogus="1">');$_5ur14v1wjk26xf2q.empty(elm);$_9t36rc1yjk26xf33.append(elm,br);return Option.some(CaretPosition$1.before(br.dom()));}else{return Option.none();}};var deleteNormalized=function deleteNormalized(elm,afterDeletePosOpt){return liftN([$_2i1q6518jk26xexk.prevSibling(elm),$_2i1q6518jk26xexk.nextSibling(elm),afterDeletePosOpt],function(prev,next,afterDeletePos){var offset;var prevNode=prev.dom();var nextNode=next.dom();if($_fpgwqg1rjk26xf0n.isText(prevNode)&&$_fpgwqg1rjk26xf0n.isText(nextNode)){offset=prevNode.data.length;prevNode.appendData(nextNode.data);$_5ur14v1wjk26xf2q.remove(next);$_5ur14v1wjk26xf2q.remove(elm);if(afterDeletePos.container()===nextNode){return CaretPosition$1(prevNode,offset);}else{return afterDeletePos;}}else{$_5ur14v1wjk26xf2q.remove(elm);return afterDeletePos;}}).orThunk(function(){$_5ur14v1wjk26xf2q.remove(elm);return afterDeletePosOpt;});};var deleteElement=function deleteElement(editor,forward,elm){var afterDeletePos=findCaretPosOutsideElmAfterDelete(forward,editor.getBody(),elm.dom());var parentBlock=$_am0h6a2ajk26xf4w.ancestor(elm,curry(isBlock$2,editor),eqRawNode(editor.getBody()));var normalizedAfterDeletePos=deleteNormalized(elm,afterDeletePos);if(editor.dom.isEmpty(editor.getBody())){editor.setContent('');editor.selection.setCursorLocation();}else{parentBlock.bind(paddEmptyBlock).fold(function(){setSelection(editor,forward,normalizedAfterDeletePos);},function(paddPos){setSelection(editor,forward,Option.some(paddPos));});}};var $_eqel1x44jk26xfmg={deleteElement:deleteElement};var deleteElement$1=function deleteElement$1(editor,forward){return function(element){editor._selectionOverrides.hideFakeCaret();$_eqel1x44jk26xfmg.deleteElement(editor,forward,Element$$1.fromDom(element));return true;};};var moveToElement=function moveToElement(editor,forward){return function(element){var pos=forward?CaretPosition$1.before(element):CaretPosition$1.after(element);editor.selection.setRng(pos.toRange());return true;};};var moveToPosition=function moveToPosition(editor){return function(pos){editor.selection.setRng(pos.toRange());return true;};};var backspaceDeleteCaret=function backspaceDeleteCaret(editor,forward){var result=read$2(editor.getBody(),forward,editor.selection.getRng()).map(function(deleteAction){return deleteAction.fold(deleteElement$1(editor,forward),moveToElement(editor,forward),moveToPosition(editor));});return result.getOr(false);};var deleteOffscreenSelection=function deleteOffscreenSelection(rootElement){each($_bisgdu27jk26xf4o.descendants(rootElement,'.mce-offscreen-selection'),$_5ur14v1wjk26xf2q.remove);};var backspaceDeleteRange=function backspaceDeleteRange(editor,forward){var selectedElement=editor.selection.getNode();if($_fpgwqg1rjk26xf0n.isContentEditableFalse(selectedElement)){deleteOffscreenSelection(Element$$1.fromDom(editor.getBody()));$_eqel1x44jk26xfmg.deleteElement(editor,forward,Element$$1.fromDom(editor.selection.getNode()));$_pu1tq3sjk26xfjd.paddEmptyBody(editor);return true;}else{return false;}};var getContentEditableRoot=function getContentEditableRoot(root,node){while(node&&node!==root){if($_fpgwqg1rjk26xf0n.isContentEditableTrue(node)||$_fpgwqg1rjk26xf0n.isContentEditableFalse(node)){return node;}node=node.parentNode;}return null;};var paddEmptyElement=function paddEmptyElement(editor){var br;var ceRoot=getContentEditableRoot(editor.getBody(),editor.selection.getNode());if($_fpgwqg1rjk26xf0n.isContentEditableTrue(ceRoot)&&editor.dom.isBlock(ceRoot)&&editor.dom.isEmpty(ceRoot)){br=editor.dom.create('br',{'data-mce-bogus':'1'});editor.dom.setHTML(ceRoot,'');ceRoot.appendChild(br);editor.selection.setRng(CaretPosition$1.before(br).toRange());}return true;};var backspaceDelete$2=function backspaceDelete$2(editor,forward){if(editor.selection.isCollapsed()){return backspaceDeleteCaret(editor,forward);}else{return backspaceDeleteRange(editor,forward);}};var $_94kdqm41jk26xfls={backspaceDelete:backspaceDelete$2,paddEmptyElement:paddEmptyElement};var isText$8=$_fpgwqg1rjk26xf0n.isText;var startsWithCaretContainer$1=function startsWithCaretContainer$1(node){return isText$8(node)&&node.data[0]===$_4osibw2pjk26xf83.ZWSP;};var endsWithCaretContainer$1=function endsWithCaretContainer$1(node){return isText$8(node)&&node.data[node.data.length-1]===$_4osibw2pjk26xf83.ZWSP;};var createZwsp=function createZwsp(node){return node.ownerDocument.createTextNode($_4osibw2pjk26xf83.ZWSP);};var insertBefore$1=function insertBefore$1(node){if(isText$8(node.previousSibling)){if(endsWithCaretContainer$1(node.previousSibling)){return node.previousSibling;}else{node.previousSibling.appendData($_4osibw2pjk26xf83.ZWSP);return node.previousSibling;}}else if(isText$8(node)){if(startsWithCaretContainer$1(node)){return node;}else{node.insertData(0,$_4osibw2pjk26xf83.ZWSP);return node;}}else{var newNode=createZwsp(node);node.parentNode.insertBefore(newNode,node);return newNode;}};var insertAfter$1=function insertAfter$1(node){if(isText$8(node.nextSibling)){if(startsWithCaretContainer$1(node.nextSibling)){return node.nextSibling;}else{node.nextSibling.insertData(0,$_4osibw2pjk26xf83.ZWSP);return node.nextSibling;}}else if(isText$8(node)){if(endsWithCaretContainer$1(node)){return node;}else{node.appendData($_4osibw2pjk26xf83.ZWSP);return node;}}else{var newNode=createZwsp(node);if(node.nextSibling){node.parentNode.insertBefore(newNode,node.nextSibling);}else{node.parentNode.appendChild(newNode);}return newNode;}};var insertInline$1=function insertInline$1(before,node){return before?insertBefore$1(node):insertAfter$1(node);};var insertInlineBefore=curry(insertInline$1,true);var insertInlineAfter=curry(insertInline$1,false);var insertInlinePos=function insertInlinePos(pos,before){if($_fpgwqg1rjk26xf0n.isText(pos.container())){return insertInline$1(before,pos.container());}else{return insertInline$1(before,pos.getNode());}};var isPosCaretContainer=function isPosCaretContainer(pos,caret){var caretNode=caret.get();return caretNode&&pos.container()===caretNode&&isCaretContainerInline(caretNode);};var renderCaret=function renderCaret(caret,location){return location.fold(function(element){$_f7uyam31jk26xfaa.remove(caret.get());var text=insertInlineBefore(element);caret.set(text);return Option.some(CaretPosition$1(text,text.length-1));},function(element){return $_bwopbb2yjk26xf9h.firstPositionIn(element).map(function(pos){if(!isPosCaretContainer(pos,caret)){$_f7uyam31jk26xfaa.remove(caret.get());var text=insertInlinePos(pos,true);caret.set(text);return CaretPosition$1(text,1);}else{return CaretPosition$1(caret.get(),1);}});},function(element){return $_bwopbb2yjk26xf9h.lastPositionIn(element).map(function(pos){if(!isPosCaretContainer(pos,caret)){$_f7uyam31jk26xfaa.remove(caret.get());var text=insertInlinePos(pos,false);caret.set(text);return CaretPosition$1(text,text.length-1);}else{return CaretPosition$1(caret.get(),caret.get().length-1);}});},function(element){$_f7uyam31jk26xfaa.remove(caret.get());var text=insertInlineAfter(element);caret.set(text);return Option.some(CaretPosition$1(text,1));});};var $_xdnqk46jk26xfn8={renderCaret:renderCaret};var evaluateUntil=function evaluateUntil(fns,args){for(var i=0;i<fns.length;i++){var result=fns[i].apply(null,args);if(result.isSome()){return result;}}return Option.none();};var $_2e2q5t49jk26xfnx={evaluateUntil:evaluateUntil};var Location=Adt.generate([{before:['element']},{start:['element']},{end:['element']},{after:['element']}]);var rescope=function rescope(rootNode,node){var parentBlock=getParentBlock(node,rootNode);return parentBlock?parentBlock:rootNode;};var before$3=function before$3(isInlineTarget,rootNode,pos){var nPos=$_eegxt33tjk26xfjt.normalizeForwards(pos);var scope=rescope(rootNode,nPos.container());return $_eegxt33tjk26xfjt.findRootInline(isInlineTarget,scope,nPos).fold(function(){return $_bwopbb2yjk26xf9h.nextPosition(scope,nPos).bind(curry($_eegxt33tjk26xfjt.findRootInline,isInlineTarget,scope)).map(function(inline){return Location.before(inline);});},Option.none);};var isNotInsideFormatCaretContainer=function isNotInsideFormatCaretContainer(rootNode,elm){return getParentCaretContainer(rootNode,elm)===null;};var findInsideRootInline=function findInsideRootInline(isInlineTarget,rootNode,pos){return $_eegxt33tjk26xfjt.findRootInline(isInlineTarget,rootNode,pos).filter(curry(isNotInsideFormatCaretContainer,rootNode));};var start=function start(isInlineTarget,rootNode,pos){var nPos=$_eegxt33tjk26xfjt.normalizeBackwards(pos);return findInsideRootInline(isInlineTarget,rootNode,nPos).bind(function(inline){var prevPos=$_bwopbb2yjk26xf9h.prevPosition(inline,nPos);return prevPos.isNone()?Option.some(Location.start(inline)):Option.none();});};var end=function end(isInlineTarget,rootNode,pos){var nPos=$_eegxt33tjk26xfjt.normalizeForwards(pos);return findInsideRootInline(isInlineTarget,rootNode,nPos).bind(function(inline){var nextPos=$_bwopbb2yjk26xf9h.nextPosition(inline,nPos);return nextPos.isNone()?Option.some(Location.end(inline)):Option.none();});};var after$3=function after$3(isInlineTarget,rootNode,pos){var nPos=$_eegxt33tjk26xfjt.normalizeBackwards(pos);var scope=rescope(rootNode,nPos.container());return $_eegxt33tjk26xfjt.findRootInline(isInlineTarget,scope,nPos).fold(function(){return $_bwopbb2yjk26xf9h.prevPosition(scope,nPos).bind(curry($_eegxt33tjk26xfjt.findRootInline,isInlineTarget,scope)).map(function(inline){return Location.after(inline);});},Option.none);};var isValidLocation=function isValidLocation(location){return $_eegxt33tjk26xfjt.isRtl(getElement(location))===false;};var readLocation=function readLocation(isInlineTarget,rootNode,pos){var location=$_2e2q5t49jk26xfnx.evaluateUntil([before$3,start,end,after$3],[isInlineTarget,rootNode,pos]);return location.filter(isValidLocation);};var getElement=function getElement(location){return location.fold(identity,identity,identity,identity);};var getName=function getName(location){return location.fold(constant('before'),constant('start'),constant('end'),constant('after'));};var outside=function outside(location){return location.fold(Location.before,Location.before,Location.after,Location.after);};var inside=function inside(location){return location.fold(Location.start,Location.start,Location.end,Location.end);};var isEq$1=function isEq$1(location1,location2){return getName(location1)===getName(location2)&&getElement(location1)===getElement(location2);};var betweenInlines=function betweenInlines(forward,isInlineTarget,rootNode,from,to,location){return liftN([$_eegxt33tjk26xfjt.findRootInline(isInlineTarget,rootNode,from),$_eegxt33tjk26xfjt.findRootInline(isInlineTarget,rootNode,to)],function(fromInline,toInline){if(fromInline!==toInline&&$_eegxt33tjk26xfjt.hasSameParentBlock(rootNode,fromInline,toInline)){return Location.after(forward?fromInline:toInline);}else{return location;}}).getOr(location);};var skipNoMovement=function skipNoMovement(fromLocation,toLocation){return fromLocation.fold(constant(true),function(fromLocation){return!isEq$1(fromLocation,toLocation);});};var findLocationTraverse=function findLocationTraverse(forward,isInlineTarget,rootNode,fromLocation,pos){var from=$_eegxt33tjk26xfjt.normalizePosition(forward,pos);var to=$_bwopbb2yjk26xf9h.fromPosition(forward,rootNode,from).map(curry($_eegxt33tjk26xfjt.normalizePosition,forward));var location=to.fold(function(){return fromLocation.map(outside);},function(to){return readLocation(isInlineTarget,rootNode,to).map(curry(betweenInlines,forward,isInlineTarget,rootNode,from,to)).filter(curry(skipNoMovement,fromLocation));});return location.filter(isValidLocation);};var findLocationSimple=function findLocationSimple(forward,location){if(forward){return location.fold(compose(Option.some,Location.start),Option.none,compose(Option.some,Location.after),Option.none);}else{return location.fold(Option.none,compose(Option.some,Location.before),Option.none,compose(Option.some,Location.end));}};var findLocation=function findLocation(forward,isInlineTarget,rootNode,pos){var from=$_eegxt33tjk26xfjt.normalizePosition(forward,pos);var fromLocation=readLocation(isInlineTarget,rootNode,from);return readLocation(isInlineTarget,rootNode,from).bind(curry(findLocationSimple,forward)).orThunk(function(){return findLocationTraverse(forward,isInlineTarget,rootNode,fromLocation,pos);});};var $_esp13i48jk26xfni={readLocation:readLocation,findLocation:findLocation,prevLocation:curry(findLocation,false),nextLocation:curry(findLocation,true),getElement:getElement,outside:outside,inside:inside};var hasSelectionModifyApi=function hasSelectionModifyApi(editor){return isFunction(editor.selection.getSel().modify);};var moveRel=function moveRel(forward,selection,pos){var delta=forward?1:-1;selection.setRng(CaretPosition$1(pos.container(),pos.offset()+delta).toRange());selection.getSel().modify('move',forward?'forward':'backward','word');return true;};var moveByWord=function moveByWord(forward,editor){var rng=editor.selection.getRng();var pos=forward?CaretPosition$1.fromRangeEnd(rng):CaretPosition$1.fromRangeStart(rng);if(!hasSelectionModifyApi(editor)){return false;}else if(forward&&isBeforeInline(pos)){return moveRel(true,editor.selection,pos);}else if(!forward&&isAfterInline(pos)){return moveRel(false,editor.selection,pos);}else{return false;}};var $_e8g5ue4bjk26xfo8={hasSelectionModifyApi:hasSelectionModifyApi,moveByWord:moveByWord};var setCaretPosition=function setCaretPosition(editor,pos){var rng=editor.dom.createRng();rng.setStart(pos.container(),pos.offset());rng.setEnd(pos.container(),pos.offset());editor.selection.setRng(rng);};var isFeatureEnabled=function isFeatureEnabled(editor){return editor.settings.inline_boundaries!==false;};var setSelected=function setSelected(state,elm){if(state){elm.setAttribute('data-mce-selected','inline-boundary');}else{elm.removeAttribute('data-mce-selected');}};var renderCaretLocation=function renderCaretLocation(editor,caret,location){return $_xdnqk46jk26xfn8.renderCaret(caret,location).map(function(pos){setCaretPosition(editor,pos);return location;});};var findLocation$1=function findLocation$1(editor,caret,forward){var rootNode=editor.getBody();var from=CaretPosition$1.fromRangeStart(editor.selection.getRng());var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);var location=$_esp13i48jk26xfni.findLocation(forward,isInlineTarget,rootNode,from);return location.bind(function(location){return renderCaretLocation(editor,caret,location);});};var toggleInlines=function toggleInlines(isInlineTarget,dom,elms){var selectedInlines=filter(dom.select('*[data-mce-selected="inline-boundary"]'),isInlineTarget);var targetInlines=filter(elms,isInlineTarget);each(difference(selectedInlines,targetInlines),curry(setSelected,false));each(difference(targetInlines,selectedInlines),curry(setSelected,true));};var safeRemoveCaretContainer=function safeRemoveCaretContainer(editor,caret){if(editor.selection.isCollapsed()&&editor.composing!==true&&caret.get()){var pos=CaretPosition$1.fromRangeStart(editor.selection.getRng());if(CaretPosition$1.isTextPosition(pos)&&$_eegxt33tjk26xfjt.isAtZwsp(pos)===false){setCaretPosition(editor,$_f7uyam31jk26xfaa.removeAndReposition(caret.get(),pos));caret.set(null);}}};var renderInsideInlineCaret=function renderInsideInlineCaret(isInlineTarget,editor,caret,elms){if(editor.selection.isCollapsed()){var inlines=filter(elms,isInlineTarget);each(inlines,function(inline){var pos=CaretPosition$1.fromRangeStart(editor.selection.getRng());$_esp13i48jk26xfni.readLocation(isInlineTarget,editor.getBody(),pos).bind(function(location){return renderCaretLocation(editor,caret,location);});});}};var move=function move(editor,caret,forward){return function(){return isFeatureEnabled(editor)?findLocation$1(editor,caret,forward).isSome():false;};};var moveWord=function moveWord(forward,editor,caret){return function(){return isFeatureEnabled(editor)?$_e8g5ue4bjk26xfo8.moveByWord(forward,editor):false;};};var setupSelectedState=function setupSelectedState(editor){var caret=Cell(null);var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);editor.on('NodeChange',function(e){if(isFeatureEnabled(editor)){toggleInlines(isInlineTarget,editor.dom,e.parents);safeRemoveCaretContainer(editor,caret);renderInsideInlineCaret(isInlineTarget,editor,caret,e.parents);}});return caret;};var moveNextWord=curry(moveWord,true);var movePrevWord=curry(moveWord,false);var $_74odh54ajk26xfo1={move:move,moveNextWord:moveNextWord,movePrevWord:movePrevWord,setupSelectedState:setupSelectedState,setCaretPosition:setCaretPosition};var isFeatureEnabled$1=function isFeatureEnabled$1(editor){return editor.settings.inline_boundaries!==false;};var rangeFromPositions=function rangeFromPositions(from,to){var range=document.createRange();range.setStart(from.container(),from.offset());range.setEnd(to.container(),to.offset());return range;};var hasOnlyTwoOrLessPositionsLeft=function hasOnlyTwoOrLessPositionsLeft(elm){return liftN([$_bwopbb2yjk26xf9h.firstPositionIn(elm),$_bwopbb2yjk26xf9h.lastPositionIn(elm)],function(firstPos,lastPos){var normalizedFirstPos=$_eegxt33tjk26xfjt.normalizePosition(true,firstPos);var normalizedLastPos=$_eegxt33tjk26xfjt.normalizePosition(false,lastPos);return $_bwopbb2yjk26xf9h.nextPosition(elm,normalizedFirstPos).map(function(pos){return pos.isEqual(normalizedLastPos);}).getOr(true);}).getOr(true);};var setCaretLocation=function setCaretLocation(editor,caret){return function(location$$1){return $_xdnqk46jk26xfn8.renderCaret(caret,location$$1).map(function(pos){$_74odh54ajk26xfo1.setCaretPosition(editor,pos);return true;}).getOr(false);};};var deleteFromTo=function deleteFromTo(editor,caret,from,to){var rootNode=editor.getBody();var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);editor.undoManager.ignore(function(){editor.selection.setRng(rangeFromPositions(from,to));editor.execCommand('Delete');$_esp13i48jk26xfni.readLocation(isInlineTarget,rootNode,CaretPosition$1.fromRangeStart(editor.selection.getRng())).map($_esp13i48jk26xfni.inside).map(setCaretLocation(editor,caret));});editor.nodeChanged();};var rescope$1=function rescope$1(rootNode,node){var parentBlock=getParentBlock(node,rootNode);return parentBlock?parentBlock:rootNode;};var backspaceDeleteCollapsed=function backspaceDeleteCollapsed(editor,caret,forward,from){var rootNode=rescope$1(editor.getBody(),from.container());var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);var fromLocation=$_esp13i48jk26xfni.readLocation(isInlineTarget,rootNode,from);return fromLocation.bind(function(location$$1){if(forward){return location$$1.fold(constant(Option.some($_esp13i48jk26xfni.inside(location$$1))),Option.none,constant(Option.some($_esp13i48jk26xfni.outside(location$$1))),Option.none);}else{return location$$1.fold(Option.none,constant(Option.some($_esp13i48jk26xfni.outside(location$$1))),Option.none,constant(Option.some($_esp13i48jk26xfni.inside(location$$1))));}}).map(setCaretLocation(editor,caret)).getOrThunk(function(){var toPosition=$_bwopbb2yjk26xf9h.navigate(forward,rootNode,from);var toLocation=toPosition.bind(function(pos){return $_esp13i48jk26xfni.readLocation(isInlineTarget,rootNode,pos);});if(fromLocation.isSome()&&toLocation.isSome()){return $_eegxt33tjk26xfjt.findRootInline(isInlineTarget,rootNode,from).map(function(elm){if(hasOnlyTwoOrLessPositionsLeft(elm)){$_eqel1x44jk26xfmg.deleteElement(editor,forward,Element$$1.fromDom(elm));return true;}else{return false;}}).getOr(false);}else{return toLocation.bind(function(_){return toPosition.map(function(to){if(forward){deleteFromTo(editor,caret,from,to);}else{deleteFromTo(editor,caret,to,from);}return true;});}).getOr(false);}});};var backspaceDelete$3=function backspaceDelete$3(editor,caret,forward){if(editor.selection.isCollapsed()&&isFeatureEnabled$1(editor)){var from=CaretPosition$1.fromRangeStart(editor.selection.getRng());return backspaceDeleteCollapsed(editor,caret,forward,from);}return false;};var $_e34aqn45jk26xfmy={backspaceDelete:backspaceDelete$3};var tableCellRng=Immutable('start','end');var tableSelection=Immutable('rng','table','cells');var deleteAction=Adt.generate([{removeTable:['element']},{emptyCells:['cells']}]);var isRootFromElement=function isRootFromElement(root){return curry($_dzedg81ejk26xeyh.eq,root);};var getClosestCell$1=function getClosestCell$1(container,isRoot){return $_dbgjqa29jk26xf4u.closest(Element$$1.fromDom(container),'td,th',isRoot);};var getClosestTable=function getClosestTable(cell,isRoot){return $_dbgjqa29jk26xf4u.ancestor(cell,'table',isRoot);};var isExpandedCellRng=function isExpandedCellRng(cellRng){return $_dzedg81ejk26xeyh.eq(cellRng.start(),cellRng.end())===false;};var getTableFromCellRng=function getTableFromCellRng(cellRng,isRoot){return getClosestTable(cellRng.start(),isRoot).bind(function(startParentTable){return getClosestTable(cellRng.end(),isRoot).bind(function(endParentTable){return $_dzedg81ejk26xeyh.eq(startParentTable,endParentTable)?Option.some(startParentTable):Option.none();});});};var getTableCells=function getTableCells(table){return $_bisgdu27jk26xf4o.descendants(table,'td,th');};var getCellRangeFromStartTable=function getCellRangeFromStartTable(cellRng,isRoot){return getClosestTable(cellRng.start(),isRoot).bind(function(table){return last(getTableCells(table)).map(function(endCell){return tableCellRng(cellRng.start(),endCell);});});};var partialSelection=function partialSelection(isRoot,rng){var startCell=getClosestCell$1(rng.startContainer,isRoot);var endCell=getClosestCell$1(rng.endContainer,isRoot);return rng.collapsed?Option.none():liftN([startCell,endCell],tableCellRng).fold(function(){return startCell.fold(function(){return endCell.bind(function(endCell){return getClosestTable(endCell,isRoot).bind(function(table){return head(getTableCells(table)).map(function(startCell){return tableCellRng(startCell,endCell);});});});},function(startCell){return getClosestTable(startCell,isRoot).bind(function(table){return last(getTableCells(table)).map(function(endCell){return tableCellRng(startCell,endCell);});});});},function(cellRng){return isWithinSameTable(isRoot,cellRng)?Option.none():getCellRangeFromStartTable(cellRng,isRoot);});};var isWithinSameTable=function isWithinSameTable(isRoot,cellRng){return getTableFromCellRng(cellRng,isRoot).isSome();};var getCellRng=function getCellRng(rng,isRoot){var startCell=getClosestCell$1(rng.startContainer,isRoot);var endCell=getClosestCell$1(rng.endContainer,isRoot);return liftN([startCell,endCell],tableCellRng).filter(isExpandedCellRng).filter(function(cellRng){return isWithinSameTable(isRoot,cellRng);}).orThunk(function(){return partialSelection(isRoot,rng);});};var getTableSelectionFromCellRng=function getTableSelectionFromCellRng(cellRng,isRoot){return getTableFromCellRng(cellRng,isRoot).map(function(table){return tableSelection(cellRng,table,getTableCells(table));});};var getTableSelectionFromRng=function getTableSelectionFromRng(root,rng){var isRoot=isRootFromElement(root);return getCellRng(rng,isRoot).bind(function(cellRng){return getTableSelectionFromCellRng(cellRng,isRoot);});};var getCellIndex=function getCellIndex(cells,cell){return findIndex(cells,function(x){return $_dzedg81ejk26xeyh.eq(x,cell);});};var getSelectedCells=function getSelectedCells(tableSelection){return liftN([getCellIndex(tableSelection.cells(),tableSelection.rng().start()),getCellIndex(tableSelection.cells(),tableSelection.rng().end())],function(startIndex,endIndex){return tableSelection.cells().slice(startIndex,endIndex+1);});};var getAction=function getAction(tableSelection){return getSelectedCells(tableSelection).map(function(selected){var cells=tableSelection.cells();return selected.length===cells.length?deleteAction.removeTable(tableSelection.table()):deleteAction.emptyCells(selected);});};var getActionFromCells=function getActionFromCells(cells){return deleteAction.emptyCells(cells);};var getActionFromRange=function getActionFromRange(root,rng){return getTableSelectionFromRng(root,rng).bind(getAction);};var $_8ldv9j4djk26xfos={getActionFromRange:getActionFromRange,getActionFromCells:getActionFromCells};var getRanges=function getRanges(selection){var ranges=[];if(selection){for(var i=0;i<selection.rangeCount;i++){ranges.push(selection.getRangeAt(i));}}return ranges;};var getSelectedNodes=function getSelectedNodes(ranges){return bind(ranges,function(range$$1){var node=getSelectedNode(range$$1);return node?[Element$$1.fromDom(node)]:[];});};var hasMultipleRanges=function hasMultipleRanges(selection){return getRanges(selection).length>1;};var $_18b2474fjk26xfpg={getRanges:getRanges,getSelectedNodes:getSelectedNodes,hasMultipleRanges:hasMultipleRanges};var getCellsFromRanges=function getCellsFromRanges(ranges){return filter($_18b2474fjk26xfpg.getSelectedNodes(ranges),isTableCell);};var getCellsFromElement=function getCellsFromElement(elm){var selectedCells=$_bisgdu27jk26xf4o.descendants(elm,'td[data-mce-selected],th[data-mce-selected]');return selectedCells;};var getCellsFromElementOrRanges=function getCellsFromElementOrRanges(ranges,element){var selectedCells=getCellsFromElement(element);var rangeCells=getCellsFromRanges(ranges);return selectedCells.length>0?selectedCells:rangeCells;};var getCellsFromEditor=function getCellsFromEditor(editor){return getCellsFromElementOrRanges($_18b2474fjk26xfpg.getRanges(editor.selection.getSel()),Element$$1.fromDom(editor.getBody()));};var $_d4teip4ejk26xfp9={getCellsFromRanges:getCellsFromRanges,getCellsFromElement:getCellsFromElement,getCellsFromElementOrRanges:getCellsFromElementOrRanges,getCellsFromEditor:getCellsFromEditor};var emptyCells=function emptyCells(editor,cells){each(cells,$_bpbbqb3ljk26xfi6.fillWithPaddingBr);editor.selection.setCursorLocation(cells[0].dom(),0);return true;};var deleteTableElement=function deleteTableElement(editor,table){$_eqel1x44jk26xfmg.deleteElement(editor,false,table);return true;};var deleteCellRange=function deleteCellRange(editor,rootElm,rng){return $_8ldv9j4djk26xfos.getActionFromRange(rootElm,rng).map(function(action){return action.fold(curry(deleteTableElement,editor),curry(emptyCells,editor));});};var deleteCaptionRange=function deleteCaptionRange(editor,caption){return emptyElement(editor,caption);};var deleteTableRange=function deleteTableRange(editor,rootElm,rng,startElm){return getParentCaption(rootElm,startElm).fold(function(){return deleteCellRange(editor,rootElm,rng);},function(caption){return deleteCaptionRange(editor,caption);}).getOr(false);};var deleteRange$1=function deleteRange$1(editor,startElm){var rootNode=Element$$1.fromDom(editor.getBody());var rng=editor.selection.getRng();var selectedCells=$_d4teip4ejk26xfp9.getCellsFromEditor(editor);return selectedCells.length!==0?emptyCells(editor,selectedCells):deleteTableRange(editor,rootNode,rng,startElm);};var getParentCell=function getParentCell(rootElm,elm){return find($_du4do23zjk26xfl5.parentsAndSelf(elm,rootElm),isTableCell);};var getParentCaption=function getParentCaption(rootElm,elm){return find($_du4do23zjk26xfl5.parentsAndSelf(elm,rootElm),function(elm){return $_cl4rr911jk26xevy.name(elm)==='caption';});};var deleteBetweenCells=function deleteBetweenCells(editor,rootElm,forward,fromCell,from){return $_bwopbb2yjk26xf9h.navigate(forward,editor.getBody(),from).bind(function(to){return getParentCell(rootElm,Element$$1.fromDom(to.getNode())).map(function(toCell){return $_dzedg81ejk26xeyh.eq(toCell,fromCell)===false;});});};var emptyElement=function emptyElement(editor,elm){$_bpbbqb3ljk26xfi6.fillWithPaddingBr(elm);editor.selection.setCursorLocation(elm.dom(),0);return Option.some(true);};var isDeleteOfLastCharPos=function isDeleteOfLastCharPos(fromCaption,forward,from,to){return $_bwopbb2yjk26xf9h.firstPositionIn(fromCaption.dom()).bind(function(first){return $_bwopbb2yjk26xf9h.lastPositionIn(fromCaption.dom()).map(function(last$$1){return forward?from.isEqual(first)&&to.isEqual(last$$1):from.isEqual(last$$1)&&to.isEqual(first);});}).getOr(true);};var emptyCaretCaption=function emptyCaretCaption(editor,elm){return emptyElement(editor,elm);};var validateCaretCaption=function validateCaretCaption(rootElm,fromCaption,to){return getParentCaption(rootElm,Element$$1.fromDom(to.getNode())).map(function(toCaption){return $_dzedg81ejk26xeyh.eq(toCaption,fromCaption)===false;});};var deleteCaretInsideCaption=function deleteCaretInsideCaption(editor,rootElm,forward,fromCaption,from){return $_bwopbb2yjk26xf9h.navigate(forward,editor.getBody(),from).bind(function(to){return isDeleteOfLastCharPos(fromCaption,forward,from,to)?emptyCaretCaption(editor,fromCaption):validateCaretCaption(rootElm,fromCaption,to);}).or(Option.some(true));};var deleteCaretCells=function deleteCaretCells(editor,forward,rootElm,startElm){var from=CaretPosition$1.fromRangeStart(editor.selection.getRng());return getParentCell(rootElm,startElm).bind(function(fromCell){return $_4w3a5a3wjk26xfkj.isEmpty(fromCell)?emptyElement(editor,fromCell):deleteBetweenCells(editor,rootElm,forward,fromCell,from);});};var deleteCaretCaption=function deleteCaretCaption(editor,forward,rootElm,fromCaption){var from=CaretPosition$1.fromRangeStart(editor.selection.getRng());return $_4w3a5a3wjk26xfkj.isEmpty(fromCaption)?emptyElement(editor,fromCaption):deleteCaretInsideCaption(editor,rootElm,forward,fromCaption,from);};var deleteCaret=function deleteCaret(editor,forward,startElm){var rootElm=Element$$1.fromDom(editor.getBody());return getParentCaption(rootElm,startElm).fold(function(){return deleteCaretCells(editor,forward,rootElm,startElm);},function(fromCaption){return deleteCaretCaption(editor,forward,rootElm,fromCaption);}).getOr(false);};var backspaceDelete$4=function backspaceDelete$4(editor,forward){var startElm=Element$$1.fromDom(editor.selection.getStart(true));var cells=$_d4teip4ejk26xfp9.getCellsFromEditor(editor);return editor.selection.isCollapsed()&&cells.length===0?deleteCaret(editor,forward,startElm):deleteRange$1(editor,startElm);};var $_9e12a34cjk26xfoe={backspaceDelete:backspaceDelete$4};var nativeCommand=function nativeCommand(editor,command){editor.getDoc().execCommand(command,false,null);};var deleteCommand=function deleteCommand(editor){if($_94kdqm41jk26xfls.backspaceDelete(editor,false)){return;}else if($_e34aqn45jk26xfmy.backspaceDelete(editor,false)){return;}else if($_45jqb13qjk26xfix.backspaceDelete(editor,false)){return;}else if($_9e12a34cjk26xfoe.backspaceDelete(editor)){return;}else if($_7pr3gu40jk26xflb.backspaceDelete(editor,false)){return;}else{nativeCommand(editor,'Delete');$_pu1tq3sjk26xfjd.paddEmptyBody(editor);}};var forwardDeleteCommand=function forwardDeleteCommand(editor){if($_94kdqm41jk26xfls.backspaceDelete(editor,true)){return;}else if($_e34aqn45jk26xfmy.backspaceDelete(editor,true)){return;}else if($_45jqb13qjk26xfix.backspaceDelete(editor,true)){return;}else if($_9e12a34cjk26xfoe.backspaceDelete(editor)){return;}else if($_7pr3gu40jk26xflb.backspaceDelete(editor,true)){return;}else{nativeCommand(editor,'ForwardDelete');}};var $_3oehq63pjk26xfiv={deleteCommand:deleteCommand,forwardDeleteCommand:forwardDeleteCommand};var getSpecifiedFontProp=function getSpecifiedFontProp(propName,rootElm,elm){var getProperty=function getProperty(elm){return $_15rddx13jk26xew4.getRaw(elm,propName);};var isRoot=function isRoot(elm){return $_dzedg81ejk26xeyh.eq(Element$$1.fromDom(rootElm),elm);};return $_am0h6a2ajk26xf4w.closest(Element$$1.fromDom(elm),function(elm){return getProperty(elm).isSome();},isRoot).bind(getProperty);};var round$1=function round$1(number,precision){var factor=Math.pow(10,precision);return Math.round(number*factor)/factor;};var toPt=function toPt(fontSize,precision){if(/[0-9.]+px$/.test(fontSize)){return round$1(parseInt(fontSize,10)*72/96,precision||0)+'pt';}return fontSize;};var normalizeFontFamily=function normalizeFontFamily(fontFamily){return fontFamily.replace(/[\'\"\\]/g,'').replace(/,\s+/g,',');};var getComputedFontProp=function getComputedFontProp(propName,elm){return Option.from(DOMUtils$1.DOM.getStyle(elm,propName,true));};var getFontProp=function getFontProp(propName){return function(rootElm,elm){return Option.from(elm).map(Element$$1.fromDom).filter($_cl4rr911jk26xevy.isElement).bind(function(element){return getSpecifiedFontProp(propName,rootElm,element.dom()).or(getComputedFontProp(propName,element.dom()));}).getOr('');};};var $_w9toh4hjk26xfpx={getFontSize:getFontProp('font-size'),getFontFamily:compose(normalizeFontFamily,getFontProp('font-family')),toPt:toPt};var findFirstCaretElement=function findFirstCaretElement(editor){return $_bwopbb2yjk26xf9h.firstPositionIn(editor.getBody()).map(function(caret){var container=caret.container();return $_fpgwqg1rjk26xf0n.isText(container)?container.parentNode:container;});};var isRangeAtStartOfNode=function isRangeAtStartOfNode(rng,root){return rng.startContainer===root&&rng.startOffset===0;};var getCaretElement=function getCaretElement(editor){return Option.from(editor.selection.getRng()).bind(function(rng){var root=editor.getBody();return isRangeAtStartOfNode(rng,root)?Option.none():Option.from(editor.selection.getStart(true));});};var fromFontSizeNumber=function fromFontSizeNumber(editor,value){if(/^[0-9\.]+$/.test(value)){var fontSizeNumber=parseInt(value,10);if(fontSizeNumber>=1&&fontSizeNumber<=7){var fontSizes=$_8xhf1m38jk26xfc6.getFontStyleValues(editor);var fontClasses=$_8xhf1m38jk26xfc6.getFontSizeClasses(editor);if(fontClasses){return fontClasses[fontSizeNumber-1]||value;}else{return fontSizes[fontSizeNumber-1]||value;}}else{return value;}}else{return value;}};var fontNameAction=function fontNameAction(editor,value){editor.formatter.toggle('fontname',{value:fromFontSizeNumber(editor,value)});editor.nodeChanged();};var fontNameQuery=function fontNameQuery(editor){return getCaretElement(editor).fold(function(){return findFirstCaretElement(editor).map(function(caretElement){return $_w9toh4hjk26xfpx.getFontFamily(editor.getBody(),caretElement);}).getOr('');},function(caretElement){return $_w9toh4hjk26xfpx.getFontFamily(editor.getBody(),caretElement);});};var fontSizeAction=function fontSizeAction(editor,value){editor.formatter.toggle('fontsize',{value:fromFontSizeNumber(editor,value)});editor.nodeChanged();};var fontSizeQuery=function fontSizeQuery(editor){return getCaretElement(editor).fold(function(){return findFirstCaretElement(editor).map(function(caretElement){return $_w9toh4hjk26xfpx.getFontSize(editor.getBody(),caretElement);}).getOr('');},function(caretElement){return $_w9toh4hjk26xfpx.getFontSize(editor.getBody(),caretElement);});};var isEq$2=function isEq$2(rng1,rng2){return rng1&&rng2&&rng1.startContainer===rng2.startContainer&&rng1.startOffset===rng2.startOffset&&rng1.endContainer===rng2.endContainer&&rng1.endOffset===rng2.endOffset;};var $_5rlzpq4kjk26xfqr={isEq:isEq$2};var findParent=function findParent(node,rootNode,predicate){while(node&&node!==rootNode){if(predicate(node)){return node;}node=node.parentNode;}return null;};var hasParent=function hasParent(node,rootNode,predicate){return findParent(node,rootNode,predicate)!==null;};var hasParentWithName=function hasParentWithName(node,rootNode,name){return hasParent(node,rootNode,function(node){return node.nodeName===name;});};var isTable$2=function isTable$2(node){return node&&node.nodeName==='TABLE';};var isTableCell$3=function isTableCell$3(node){return node&&/^(TD|TH|CAPTION)$/.test(node.nodeName);};var isCeFalseCaretContainer=function isCeFalseCaretContainer(node,rootNode){return isCaretContainer(node)&&hasParent(node,rootNode,isCaretNode)===false;};var hasBrBeforeAfter=function hasBrBeforeAfter(dom,node,left){var walker=new TreeWalker(node,dom.getParent(node.parentNode,dom.isBlock)||dom.getRoot());while(node=walker[left?'prev':'next']()){if($_fpgwqg1rjk26xf0n.isBr(node)){return true;}}};var isPrevNode=function isPrevNode(node,name){return node.previousSibling&&node.previousSibling.nodeName===name;};var hasContentEditableFalseParent=function hasContentEditableFalseParent(body,node){while(node&&node!==body){if($_fpgwqg1rjk26xf0n.isContentEditableFalse(node)){return true;}node=node.parentNode;}return false;};var findTextNodeRelative=function findTextNodeRelative(dom,isAfterNode,collapsed,left,startNode){var walker,lastInlineElement,parentBlockContainer;var body=dom.getRoot();var node;var nonEmptyElementsMap=dom.schema.getNonEmptyElements();parentBlockContainer=dom.getParent(startNode.parentNode,dom.isBlock)||body;if(left&&$_fpgwqg1rjk26xf0n.isBr(startNode)&&isAfterNode&&dom.isEmpty(parentBlockContainer)){return Option.some(CaretPosition(startNode.parentNode,dom.nodeIndex(startNode)));}walker=new TreeWalker(startNode,parentBlockContainer);while(node=walker[left?'prev':'next']()){if(dom.getContentEditableParent(node)==='false'||isCeFalseCaretContainer(node,body)){return Option.none();}if($_fpgwqg1rjk26xf0n.isText(node)&&node.nodeValue.length>0){if(hasParentWithName(node,body,'A')===false){return Option.some(CaretPosition(node,left?node.nodeValue.length:0));}return Option.none();}if(dom.isBlock(node)||nonEmptyElementsMap[node.nodeName.toLowerCase()]){return Option.none();}lastInlineElement=node;}if(collapsed&&lastInlineElement){return Option.some(CaretPosition(lastInlineElement,0));}return Option.none();};var normalizeEndPoint=function normalizeEndPoint(dom,collapsed,start,rng){var container,offset,walker;var body=dom.getRoot();var node,nonEmptyElementsMap;var directionLeft,isAfterNode,normalized=false;container=rng[(start?'start':'end')+'Container'];offset=rng[(start?'start':'end')+'Offset'];isAfterNode=$_fpgwqg1rjk26xf0n.isElement(container)&&offset===container.childNodes.length;nonEmptyElementsMap=dom.schema.getNonEmptyElements();directionLeft=start;if(isCaretContainer(container)){return Option.none();}if($_fpgwqg1rjk26xf0n.isElement(container)&&offset>container.childNodes.length-1){directionLeft=false;}if($_fpgwqg1rjk26xf0n.isDocument(container)){container=body;offset=0;}if(container===body){if(directionLeft){node=container.childNodes[offset>0?offset-1:0];if(node){if(isCaretContainer(node)){return Option.none();}if(nonEmptyElementsMap[node.nodeName]||isTable$2(node)){return Option.none();}}}if(container.hasChildNodes()){offset=Math.min(!directionLeft&&offset>0?offset-1:offset,container.childNodes.length-1);container=container.childNodes[offset];offset=$_fpgwqg1rjk26xf0n.isText(container)&&isAfterNode?container.data.length:0;if(!collapsed&&container===body.lastChild&&isTable$2(container)){return Option.none();}if(hasContentEditableFalseParent(body,container)||isCaretContainer(container)){return Option.none();}if(container.hasChildNodes()&&isTable$2(container)===false){node=container;walker=new TreeWalker(container,body);do{if($_fpgwqg1rjk26xf0n.isContentEditableFalse(node)||isCaretContainer(node)){normalized=false;break;}if($_fpgwqg1rjk26xf0n.isText(node)&&node.nodeValue.length>0){offset=directionLeft?0:node.nodeValue.length;container=node;normalized=true;break;}if(nonEmptyElementsMap[node.nodeName.toLowerCase()]&&!isTableCell$3(node)){offset=dom.nodeIndex(node);container=node.parentNode;if(!directionLeft){offset++;}normalized=true;break;}}while(node=directionLeft?walker.next():walker.prev());}}}if(collapsed){if($_fpgwqg1rjk26xf0n.isText(container)&&offset===0){findTextNodeRelative(dom,isAfterNode,collapsed,true,container).each(function(pos){container=pos.container();offset=pos.offset();normalized=true;});}if($_fpgwqg1rjk26xf0n.isElement(container)){node=container.childNodes[offset];if(!node){node=container.childNodes[offset-1];}if(node&&$_fpgwqg1rjk26xf0n.isBr(node)&&!isPrevNode(node,'A')&&!hasBrBeforeAfter(dom,node,false)&&!hasBrBeforeAfter(dom,node,true)){findTextNodeRelative(dom,isAfterNode,collapsed,true,node).each(function(pos){container=pos.container();offset=pos.offset();normalized=true;});}}}if(directionLeft&&!collapsed&&$_fpgwqg1rjk26xf0n.isText(container)&&offset===container.nodeValue.length){findTextNodeRelative(dom,isAfterNode,collapsed,false,container).each(function(pos){container=pos.container();offset=pos.offset();normalized=true;});}return normalized?Option.some(CaretPosition(container,offset)):Option.none();};var normalize$1=function normalize$1(dom,rng){var collapsed=rng.collapsed,normRng=rng.cloneRange();var startPos=CaretPosition.fromRangeStart(rng);normalizeEndPoint(dom,collapsed,true,normRng).each(function(pos){if(!collapsed||!CaretPosition.isAbove(startPos,pos)){normRng.setStart(pos.container(),pos.offset());}});if(!collapsed){normalizeEndPoint(dom,collapsed,false,normRng).each(function(pos){normRng.setEnd(pos.container(),pos.offset());});}if(collapsed){normRng.collapse(true);}return $_5rlzpq4kjk26xfqr.isEq(rng,normRng)?Option.none():Option.some(normRng);};var $_c8c6ki4jjk26xfqk={normalize:normalize$1};var hasRightSideContent=function hasRightSideContent(schema,container,parentBlock){var walker=new TreeWalker(container,parentBlock);var node;var nonEmptyElementsMap=schema.getNonEmptyElements();while(node=walker.next()){if(nonEmptyElementsMap[node.nodeName.toLowerCase()]||node.length>0){return true;}}};var scrollToBr=function scrollToBr(dom,selection,brElm){var marker=dom.create('span',{},'&nbsp;');brElm.parentNode.insertBefore(marker,brElm);selection.scrollIntoView(marker);dom.remove(marker);};var moveSelectionToBr=function moveSelectionToBr(dom,selection,brElm,extraBr){var rng=dom.createRng();if(!extraBr){rng.setStartAfter(brElm);rng.setEndAfter(brElm);}else{rng.setStartBefore(brElm);rng.setEndBefore(brElm);}selection.setRng(rng);};var insertBrAtCaret=function insertBrAtCaret(editor,evt){var selection=editor.selection,dom=editor.dom;var brElm,extraBr;var rng=selection.getRng();$_c8c6ki4jjk26xfqk.normalize(dom,rng).each(function(normRng){rng.setStart(normRng.startContainer,normRng.startOffset);rng.setEnd(normRng.endContainer,normRng.endOffset);});var offset=rng.startOffset;var container=rng.startContainer;if(container.nodeType===1&&container.hasChildNodes()){var isAfterLastNodeInContainer=offset>container.childNodes.length-1;container=container.childNodes[Math.min(offset,container.childNodes.length-1)]||container;if(isAfterLastNodeInContainer&&container.nodeType===3){offset=container.nodeValue.length;}else{offset=0;}}var parentBlock=dom.getParent(container,dom.isBlock);var containerBlock=parentBlock?dom.getParent(parentBlock.parentNode,dom.isBlock):null;var containerBlockName=containerBlock?containerBlock.nodeName.toUpperCase():'';var isControlKey=evt&&evt.ctrlKey;if(containerBlockName==='LI'&&!isControlKey){parentBlock=containerBlock;}if(container&&container.nodeType===3&&offset>=container.nodeValue.length){if(!hasRightSideContent(editor.schema,container,parentBlock)){brElm=dom.create('br');rng.insertNode(brElm);rng.setStartAfter(brElm);rng.setEndAfter(brElm);extraBr=true;}}brElm=dom.create('br');rng.insertNode(brElm);scrollToBr(dom,selection,brElm);moveSelectionToBr(dom,selection,brElm,extraBr);editor.undoManager.add();};var insertBrBefore=function insertBrBefore(editor,inline){var br=Element$$1.fromTag('br');$_9t36rc1yjk26xf33.before(Element$$1.fromDom(inline),br);editor.undoManager.add();};var insertBrAfter=function insertBrAfter(editor,inline){if(!hasBrAfter(editor.getBody(),inline)){$_9t36rc1yjk26xf33.after(Element$$1.fromDom(inline),Element$$1.fromTag('br'));}var br=Element$$1.fromTag('br');$_9t36rc1yjk26xf33.after(Element$$1.fromDom(inline),br);scrollToBr(editor.dom,editor.selection,br.dom());moveSelectionToBr(editor.dom,editor.selection,br.dom(),false);editor.undoManager.add();};var isBeforeBr=function isBeforeBr(pos){return $_fpgwqg1rjk26xf0n.isBr(pos.getNode());};var hasBrAfter=function hasBrAfter(rootNode,startNode){if(isBeforeBr(CaretPosition$1.after(startNode))){return true;}else{return $_bwopbb2yjk26xf9h.nextPosition(rootNode,CaretPosition$1.after(startNode)).map(function(pos){return $_fpgwqg1rjk26xf0n.isBr(pos.getNode());}).getOr(false);}};var isAnchorLink=function isAnchorLink(elm){return elm&&elm.nodeName==='A'&&'href'in elm;};var isInsideAnchor=function isInsideAnchor(location){return location.fold(constant(false),isAnchorLink,isAnchorLink,constant(false));};var readInlineAnchorLocation=function readInlineAnchorLocation(editor){var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);var position=CaretPosition$1.fromRangeStart(editor.selection.getRng());return $_esp13i48jk26xfni.readLocation(isInlineTarget,editor.getBody(),position).filter(isInsideAnchor);};var insertBrOutsideAnchor=function insertBrOutsideAnchor(editor,location){location.fold(noop,curry(insertBrBefore,editor),curry(insertBrAfter,editor),noop);};var insert=function insert(editor,evt){var anchorLocation=readInlineAnchorLocation(editor);if(anchorLocation.isSome()){anchorLocation.each(curry(insertBrOutsideAnchor,editor));}else{insertBrAtCaret(editor,evt);}};var $_e33zri4ijk26xfqa={insert:insert};var adt=Adt.generate([{'before':['element']},{'on':['element','offset']},{after:['element']}]);var cata=function cata(subject,onBefore,onOn,onAfter){return subject.fold(onBefore,onOn,onAfter);};var getStart=function getStart(situ){return situ.fold(identity,identity,identity);};var $_46b15z4njk26xfrf={before:adt.before,on:adt.on,after:adt.after,cata:cata,getStart:getStart};var type$1=Adt.generate([{domRange:['rng']},{relative:['startSitu','finishSitu']},{exact:['start','soffset','finish','foffset']}]);var range$1=Immutable('start','soffset','finish','foffset');var exactFromRange=function exactFromRange(simRange){return type$1.exact(simRange.start(),simRange.soffset(),simRange.finish(),simRange.foffset());};var getStart$1=function getStart$1(selection){return selection.match({domRange:function domRange(rng){return Element$$1.fromDom(rng.startContainer);},relative:function relative(startSitu,finishSitu){return $_46b15z4njk26xfrf.getStart(startSitu);},exact:function exact(start,soffset,finish,foffset){return start;}});};var getWin=function getWin(selection){var start=getStart$1(selection);return $_2i1q6518jk26xexk.defaultView(start);};var $_4zewwt4mjk26xfr8={domRange:type$1.domRange,relative:type$1.relative,exact:type$1.exact,exactFromRange:exactFromRange,range:range$1,getWin:getWin};var browser$3=$_8x4ci6ojk26xeuf.detect().browser;var clamp=function clamp(offset,element){var max=$_cl4rr911jk26xevy.isText(element)?$_30p3ln3ejk26xfct.get(element).length:$_2i1q6518jk26xexk.children(element).length+1;if(offset>max){return max;}else if(offset<0){return 0;}return offset;};var normalizeRng=function normalizeRng(rng){return $_4zewwt4mjk26xfr8.range(rng.start(),clamp(rng.soffset(),rng.start()),rng.finish(),clamp(rng.foffset(),rng.finish()));};var isOrContains=function isOrContains(root,elm){return $_dzedg81ejk26xeyh.contains(root,elm)||$_dzedg81ejk26xeyh.eq(root,elm);};var isRngInRoot=function isRngInRoot(root){return function(rng){return isOrContains(root,rng.start())&&isOrContains(root,rng.finish());};};var shouldStore=function shouldStore(editor){return editor.inline===true||browser$3.isIE();};var nativeRangeToSelectionRange=function nativeRangeToSelectionRange(r){return $_4zewwt4mjk26xfr8.range(Element$$1.fromDom(r.startContainer),r.startOffset,Element$$1.fromDom(r.endContainer),r.endOffset);};var readRange=function readRange(win){var selection=win.getSelection();var rng=!selection||selection.rangeCount===0?Option.none():Option.from(selection.getRangeAt(0));return rng.map(nativeRangeToSelectionRange);};var getBookmark$2=function getBookmark$2(root){var win=$_2i1q6518jk26xexk.defaultView(root);return readRange(win.dom()).filter(isRngInRoot(root));};var validate=function validate(root,bookmark){return Option.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);};var bookmarkToNativeRng=function bookmarkToNativeRng(bookmark){var rng=document.createRange();try{rng.setStart(bookmark.start().dom(),bookmark.soffset());rng.setEnd(bookmark.finish().dom(),bookmark.foffset());return Option.some(rng);}catch(_){return Option.none();}};var store=function store(editor){var newBookmark=shouldStore(editor)?getBookmark$2(Element$$1.fromDom(editor.getBody())):Option.none();editor.bookmark=newBookmark.isSome()?newBookmark:editor.bookmark;};var storeNative=function storeNative(editor,rng){var root=Element$$1.fromDom(editor.getBody());var range=shouldStore(editor)?Option.from(rng):Option.none();var newBookmark=range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));editor.bookmark=newBookmark.isSome()?newBookmark:editor.bookmark;};var getRng=function getRng(editor){var bookmark=editor.bookmark?editor.bookmark:Option.none();return bookmark.bind(curry(validate,Element$$1.fromDom(editor.getBody()))).bind(bookmarkToNativeRng);};var restore=function restore(editor){getRng(editor).each(function(rng){editor.selection.setRng(rng);});};var $_wwyx94ljk26xfqt={store:store,storeNative:storeNative,readRange:readRange,restore:restore,getRng:getRng,getBookmark:getBookmark$2,validate:validate};var indentElement=function indentElement(dom,command,useMargin,value,unit,element){if(dom.getContentEditable(element)==='false'){return;}if(element.nodeName!=='LI'){var indentStyleName=useMargin?'margin':'padding';indentStyleName=element.nodeName==='TABLE'?'margin':indentStyleName;indentStyleName+=dom.getStyle(element,'direction',true)==='rtl'?'Right':'Left';if(command==='outdent'){var styleValue=Math.max(0,parseInt(element.style[indentStyleName]||0,10)-value);dom.setStyle(element,indentStyleName,styleValue?styleValue+unit:'');}else{var styleValue=parseInt(element.style[indentStyleName]||0,10)+value+unit;dom.setStyle(element,indentStyleName,styleValue);}}};var handle=function handle(editor,command){var settings=editor.settings,dom=editor.dom,selection=editor.selection,formatter=editor.formatter;var indentUnit=/[a-z%]+$/i.exec(settings.indentation)[0];var indentValue=parseInt(settings.indentation,10);var useMargin=editor.getParam('indent_use_margin',false);if(!editor.queryCommandState('InsertUnorderedList')&&!editor.queryCommandState('InsertOrderedList')){if(!settings.forced_root_block&&!dom.getParent(selection.getNode(),dom.isBlock)){formatter.apply('div');}each(selection.getSelectedBlocks(),function(element){return indentElement(dom,command,useMargin,indentValue,indentUnit,element);});}};var each$10=$_2ytxahljk26xetf.each;var extend$2=$_2ytxahljk26xetf.extend;var map$3=$_2ytxahljk26xetf.map;var inArray$2=$_2ytxahljk26xetf.inArray;function EditorCommands(editor){var dom,selection,formatter;var commands={state:{},exec:{},value:{}};var settings=editor.settings,bookmark;editor.on('PreInit',function(){dom=editor.dom;selection=editor.selection;settings=editor.settings;formatter=editor.formatter;});var execCommand=function execCommand(command,ui,value,args){var func,customCommand,state=false;if(editor.removed){return;}if(!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command)&&(!args||!args.skip_focus)){editor.focus();}else{$_wwyx94ljk26xfqt.restore(editor);}args=editor.fire('BeforeExecCommand',{command:command,ui:ui,value:value});if(args.isDefaultPrevented()){return false;}customCommand=command.toLowerCase();if(func=commands.exec[customCommand]){func(customCommand,ui,value);editor.fire('ExecCommand',{command:command,ui:ui,value:value});return true;}each$10(editor.plugins,function(p){if(p.execCommand&&p.execCommand(command,ui,value)){editor.fire('ExecCommand',{command:command,ui:ui,value:value});state=true;return false;}});if(state){return state;}if(editor.theme&&editor.theme.execCommand&&editor.theme.execCommand(command,ui,value)){editor.fire('ExecCommand',{command:command,ui:ui,value:value});return true;}try{state=editor.getDoc().execCommand(command,ui,value);}catch(ex){}if(state){editor.fire('ExecCommand',{command:command,ui:ui,value:value});return true;}return false;};var queryCommandState=function queryCommandState(command){var func;if(editor.quirks.isHidden()||editor.removed){return;}command=command.toLowerCase();if(func=commands.state[command]){return func(command);}try{return editor.getDoc().queryCommandState(command);}catch(ex){}return false;};var queryCommandValue=function queryCommandValue(command){var func;if(editor.quirks.isHidden()||editor.removed){return;}command=command.toLowerCase();if(func=commands.value[command]){return func(command);}try{return editor.getDoc().queryCommandValue(command);}catch(ex){}};var addCommands=function addCommands(commandList,type){type=type||'exec';each$10(commandList,function(callback,command){each$10(command.toLowerCase().split(','),function(command){commands[type][command]=callback;});});};var addCommand=function addCommand(command,callback,scope){command=command.toLowerCase();commands.exec[command]=function(command,ui,value,args){return callback.call(scope||editor,ui,value,args);};};var queryCommandSupported=function queryCommandSupported(command){command=command.toLowerCase();if(commands.exec[command]){return true;}try{return editor.getDoc().queryCommandSupported(command);}catch(ex){}return false;};var addQueryStateHandler=function addQueryStateHandler(command,callback,scope){command=command.toLowerCase();commands.state[command]=function(){return callback.call(scope||editor);};};var addQueryValueHandler=function addQueryValueHandler(command,callback,scope){command=command.toLowerCase();commands.value[command]=function(){return callback.call(scope||editor);};};var hasCustomCommand=function hasCustomCommand(command){command=command.toLowerCase();return!!commands.exec[command];};extend$2(this,{execCommand:execCommand,queryCommandState:queryCommandState,queryCommandValue:queryCommandValue,queryCommandSupported:queryCommandSupported,addCommands:addCommands,addCommand:addCommand,addQueryStateHandler:addQueryStateHandler,addQueryValueHandler:addQueryValueHandler,hasCustomCommand:hasCustomCommand});var execNativeCommand=function execNativeCommand(command,ui,value){if(ui===undefined){ui=false;}if(value===undefined){value=null;}return editor.getDoc().execCommand(command,ui,value);};var isFormatMatch=function isFormatMatch(name){return formatter.match(name);};var toggleFormat=function toggleFormat(name,value){formatter.toggle(name,value?{value:value}:undefined);editor.nodeChanged();};var storeSelection=function storeSelection(type){bookmark=selection.getBookmark(type);};var restoreSelection=function restoreSelection(){selection.moveToBookmark(bookmark);};addCommands({'mceResetDesignMode,mceBeginUndoLevel':function mceResetDesignModeMceBeginUndoLevel(){},'mceEndUndoLevel,mceAddUndoLevel':function mceEndUndoLevelMceAddUndoLevel(){editor.undoManager.add();},'Cut,Copy,Paste':function CutCopyPaste(command){var doc=editor.getDoc();var failed;try{execNativeCommand(command);}catch(ex){failed=true;}if(command==='paste'&&!doc.queryCommandEnabled(command)){failed=true;}if(failed||!doc.queryCommandSupported(command)){var msg=editor.translate('Your browser doesn\'t support direct access to the clipboard. '+'Please use the Ctrl+X/C/V keyboard shortcuts instead.');if($_ef6mqpajk26xejm.mac){msg=msg.replace(/Ctrl\+/g,'\u2318+');}editor.notificationManager.open({text:msg,type:'error'});}},'unlink':function unlink(){if(selection.isCollapsed()){var elm=editor.dom.getParent(editor.selection.getStart(),'a');if(elm){editor.dom.remove(elm,true);}return;}formatter.remove('link');},'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone':function JustifyLeftJustifyCenterJustifyRightJustifyFullJustifyNone(command){var align=command.substring(7);if(align==='full'){align='justify';}each$10('left,center,right,justify'.split(','),function(name){if(align!==name){formatter.remove('align'+name);}});if(align!=='none'){toggleFormat('align'+align);}},'InsertUnorderedList,InsertOrderedList':function InsertUnorderedListInsertOrderedList(command){var listElm,listParent;execNativeCommand(command);listElm=dom.getParent(selection.getNode(),'ol,ul');if(listElm){listParent=listElm.parentNode;if(/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)){storeSelection();dom.split(listParent,listElm);restoreSelection();}}},'Bold,Italic,Underline,Strikethrough,Superscript,Subscript':function BoldItalicUnderlineStrikethroughSuperscriptSubscript(command){toggleFormat(command);},'ForeColor,HiliteColor':function ForeColorHiliteColor(command,ui,value){toggleFormat(command,value);},'FontName':function FontName(command,ui,value){fontNameAction(editor,value);},'FontSize':function FontSize(command,ui,value){fontSizeAction(editor,value);},'RemoveFormat':function RemoveFormat(command){formatter.remove(command);},'mceBlockQuote':function mceBlockQuote(){toggleFormat('blockquote');},'FormatBlock':function FormatBlock(command,ui,value){return toggleFormat(value||'p');},'mceCleanup':function mceCleanup(){var bookmark=selection.getBookmark();editor.setContent(editor.getContent());selection.moveToBookmark(bookmark);},'mceRemoveNode':function mceRemoveNode(command,ui,value){var node=value||selection.getNode();if(node!==editor.getBody()){storeSelection();editor.dom.remove(node,true);restoreSelection();}},'mceSelectNodeDepth':function mceSelectNodeDepth(command,ui,value){var counter=0;dom.getParent(selection.getNode(),function(node){if(node.nodeType===1&&counter++===value){selection.select(node);return false;}},editor.getBody());},'mceSelectNode':function mceSelectNode(command,ui,value){selection.select(value);},'mceInsertContent':function mceInsertContent(command,ui,value){$_4cdrcb3ijk26xfhi.insertAtCaret(editor,value);},'mceInsertRawHTML':function mceInsertRawHTML(command,ui,value){var content=editor.getContent();selection.setContent('tiny_mce_marker');editor.setContent(content.replace(/tiny_mce_marker/g,function(){return value;}));},'mceToggleFormat':function mceToggleFormat(command,ui,value){toggleFormat(value);},'mceSetContent':function mceSetContent(command,ui,value){editor.setContent(value);},'Indent,Outdent':function IndentOutdent(command){handle(editor,command);},'mceRepaint':function mceRepaint(){},'InsertHorizontalRule':function InsertHorizontalRule(){editor.execCommand('mceInsertContent',false,'<hr />');},'mceToggleVisualAid':function mceToggleVisualAid(){editor.hasVisual=!editor.hasVisual;editor.addVisual();},'mceReplaceContent':function mceReplaceContent(command,ui,value){editor.execCommand('mceInsertContent',false,value.replace(/\{\$selection\}/g,selection.getContent({format:'text'})));},'mceInsertLink':function mceInsertLink(command,ui,value){var anchor;if(typeof value==='string'){value={href:value};}anchor=dom.getParent(selection.getNode(),'a');value.href=value.href.replace(' ','%20');if(!anchor||!value.href){formatter.remove('link');}if(value.href){formatter.apply('link',value,anchor);}},'selectAll':function selectAll(){var editingHost=dom.getParent(selection.getStart(),$_fpgwqg1rjk26xf0n.isContentEditableTrue);if(editingHost){var rng=dom.createRng();rng.selectNodeContents(editingHost);selection.setRng(rng);}},'delete':function _delete(){$_3oehq63pjk26xfiv.deleteCommand(editor);},'forwardDelete':function forwardDelete(){$_3oehq63pjk26xfiv.forwardDeleteCommand(editor);},'mceNewDocument':function mceNewDocument(){editor.setContent('');},'InsertLineBreak':function InsertLineBreak(command,ui,value){$_e33zri4ijk26xfqa.insert(editor,value);return true;}});var alignStates=function alignStates(name){return function(){var nodes=selection.isCollapsed()?[dom.getParent(selection.getNode(),dom.isBlock)]:selection.getSelectedBlocks();var matches=map$3(nodes,function(node){return!!formatter.matchNode(node,name);});return inArray$2(matches,true)!==-1;};};addCommands({'JustifyLeft':alignStates('alignleft'),'JustifyCenter':alignStates('aligncenter'),'JustifyRight':alignStates('alignright'),'JustifyFull':alignStates('alignjustify'),'Bold,Italic,Underline,Strikethrough,Superscript,Subscript':function BoldItalicUnderlineStrikethroughSuperscriptSubscript(command){return isFormatMatch(command);},'mceBlockQuote':function mceBlockQuote(){return isFormatMatch('blockquote');},'Outdent':function Outdent(){var node;if(settings.inline_styles){if((node=dom.getParent(selection.getStart(),dom.isBlock))&&parseInt(node.style.paddingLeft,10)>0){return true;}if((node=dom.getParent(selection.getEnd(),dom.isBlock))&&parseInt(node.style.paddingLeft,10)>0){return true;}}return queryCommandState('InsertUnorderedList')||queryCommandState('InsertOrderedList')||!settings.inline_styles&&!!dom.getParent(selection.getNode(),'BLOCKQUOTE');},'InsertUnorderedList,InsertOrderedList':function InsertUnorderedListInsertOrderedList(command){var list=dom.getParent(selection.getNode(),'ul,ol');return list&&(command==='insertunorderedlist'&&list.tagName==='UL'||command==='insertorderedlist'&&list.tagName==='OL');}},'state');addCommands({Undo:function Undo(){editor.undoManager.undo();},Redo:function Redo(){editor.undoManager.redo();}});addQueryValueHandler('FontName',function(){return fontNameQuery(editor);},this);addQueryValueHandler('FontSize',function(){return fontSizeQuery(editor);},this);}var nativeEvents=$_2ytxahljk26xetf.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange '+'mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover '+'draggesture dragdrop drop drag submit '+'compositionstart compositionend compositionupdate touchstart touchmove touchend',' ');var Dispatcher=function Dispatcher(settings){var self=this;var scope,bindings={},toggleEvent;var returnFalse=function returnFalse(){return false;};var returnTrue=function returnTrue(){return true;};settings=settings||{};scope=settings.scope||self;toggleEvent=settings.toggleEvent||returnFalse;var fire=function fire(name,args){var handlers,i,l,callback;name=name.toLowerCase();args=args||{};args.type=name;if(!args.target){args.target=scope;}if(!args.preventDefault){args.preventDefault=function(){args.isDefaultPrevented=returnTrue;};args.stopPropagation=function(){args.isPropagationStopped=returnTrue;};args.stopImmediatePropagation=function(){args.isImmediatePropagationStopped=returnTrue;};args.isDefaultPrevented=returnFalse;args.isPropagationStopped=returnFalse;args.isImmediatePropagationStopped=returnFalse;}if(settings.beforeFire){settings.beforeFire(args);}handlers=bindings[name];if(handlers){for(i=0,l=handlers.length;i<l;i++){callback=handlers[i];if(callback.once){off(name,callback.func);}if(args.isImmediatePropagationStopped()){args.stopPropagation();return args;}if(callback.func.call(scope,args)===false){args.preventDefault();return args;}}}return args;};var on=function on(name,callback,prepend,extra){var handlers,names,i;if(callback===false){callback=returnFalse;}if(callback){callback={func:callback};if(extra){$_2ytxahljk26xetf.extend(callback,extra);}names=name.toLowerCase().split(' ');i=names.length;while(i--){name=names[i];handlers=bindings[name];if(!handlers){handlers=bindings[name]=[];toggleEvent(name,true);}if(prepend){handlers.unshift(callback);}else{handlers.push(callback);}}}return self;};var off=function off(name,callback){var i,handlers,bindingName,names,hi;if(name){names=name.toLowerCase().split(' ');i=names.length;while(i--){name=names[i];handlers=bindings[name];if(!name){for(bindingName in bindings){toggleEvent(bindingName,false);delete bindings[bindingName];}return self;}if(handlers){if(!callback){handlers.length=0;}else{hi=handlers.length;while(hi--){if(handlers[hi].func===callback){handlers=handlers.slice(0,hi).concat(handlers.slice(hi+1));bindings[name]=handlers;}}}if(!handlers.length){toggleEvent(name,false);delete bindings[name];}}}}else{for(name in bindings){toggleEvent(name,false);}bindings={};}return self;};var once=function once(name,callback,prepend){return on(name,callback,prepend,{once:true});};var has=function has(name){name=name.toLowerCase();return!(!bindings[name]||bindings[name].length===0);};self.fire=fire;self.on=on;self.off=off;self.once=once;self.has=has;};Dispatcher.isNative=function(name){return!!nativeEvents[name.toLowerCase()];};var getEventDispatcher=function getEventDispatcher(obj){if(!obj._eventDispatcher){obj._eventDispatcher=new Dispatcher({scope:obj,toggleEvent:function toggleEvent(name,state){if(Dispatcher.isNative(name)&&obj.toggleNativeEvent){obj.toggleNativeEvent(name,state);}}});}return obj._eventDispatcher;};var $_4d4jki4qjk26xfs1={fire:function fire(name,args,bubble){var self=this;if(self.removed&&name!=='remove'){return args;}args=getEventDispatcher(self).fire(name,args,bubble);if(bubble!==false&&self.parent){var parent=self.parent();while(parent&&!args.isPropagationStopped()){parent.fire(name,args,false);parent=parent.parent();}}return args;},on:function on(name,callback,prepend){return getEventDispatcher(this).on(name,callback,prepend);},off:function off(name,callback){return getEventDispatcher(this).off(name,callback);},once:function once(name,callback){return getEventDispatcher(this).once(name,callback);},hasEventListeners:function hasEventListeners(name){return getEventDispatcher(this).has(name);}};var firePreProcess=function firePreProcess(editor,args){return editor.fire('PreProcess',args);};var firePostProcess=function firePostProcess(editor,args){return editor.fire('PostProcess',args);};var fireRemove=function fireRemove(editor){return editor.fire('remove');};var fireSwitchMode=function fireSwitchMode(editor,mode){return editor.fire('SwitchMode',{mode:mode});};var fireObjectResizeStart=function fireObjectResizeStart(editor,target,width,height){editor.fire('ObjectResizeStart',{target:target,width:width,height:height});};var fireObjectResized=function fireObjectResized(editor,target,width,height){editor.fire('ObjectResized',{target:target,width:width,height:height});};var $_8y7e5d4tjk26xfsd={firePreProcess:firePreProcess,firePostProcess:firePostProcess,fireRemove:fireRemove,fireSwitchMode:fireSwitchMode,fireObjectResizeStart:fireObjectResizeStart,fireObjectResized:fireObjectResized};var setEditorCommandState=function setEditorCommandState(editor,cmd,state){try{editor.getDoc().execCommand(cmd,false,state);}catch(ex){}};var toggleClass=function toggleClass(elm,cls,state){if($_38pgzm23jk26xf42.has(elm,cls)&&state===false){$_38pgzm23jk26xf42.remove(elm,cls);}else if(state){$_38pgzm23jk26xf42.add(elm,cls);}};var toggleReadOnly=function toggleReadOnly(editor,state){toggleClass(Element$$1.fromDom(editor.getBody()),'mce-content-readonly',state);if(state){editor.selection.controlSelection.hideResizeRect();editor.readonly=true;editor.getBody().contentEditable='false';}else{editor.readonly=false;editor.getBody().contentEditable='true';setEditorCommandState(editor,'StyleWithCSS',false);setEditorCommandState(editor,'enableInlineTableEditing',false);setEditorCommandState(editor,'enableObjectResizing',false);editor.focus();editor.nodeChanged();}};var _setMode=function _setMode(editor,mode){if(mode===getMode(editor)){return;}if(editor.initialized){toggleReadOnly(editor,mode==='readonly');}else{editor.on('init',function(){toggleReadOnly(editor,mode==='readonly');});}$_8y7e5d4tjk26xfsd.fireSwitchMode(editor,mode);};var getMode=function getMode(editor){return editor.readonly?'readonly':'design';};var isReadOnly=function isReadOnly(editor){return editor.readonly===true;};var DOM$1=DOMUtils$1.DOM;var customEventRootDelegates;var getEventTarget=function getEventTarget(editor,eventName){if(eventName==='selectionchange'){return editor.getDoc();}if(!editor.inline&&/^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)){return editor.getDoc().documentElement;}if(editor.settings.event_root){if(!editor.eventRoot){editor.eventRoot=DOM$1.select(editor.settings.event_root)[0];}return editor.eventRoot;}return editor.getBody();};var isListening=function isListening(editor){return!editor.hidden&&!editor.readonly;};var fireEvent=function fireEvent(editor,eventName,e){if(isListening(editor)){editor.fire(eventName,e);}else if(isReadOnly(editor)){e.preventDefault();}};var bindEventDelegate=function bindEventDelegate(editor,eventName){var eventRootElm,delegate;if(!editor.delegates){editor.delegates={};}if(editor.delegates[eventName]||editor.removed){return;}eventRootElm=getEventTarget(editor,eventName);if(editor.settings.event_root){if(!customEventRootDelegates){customEventRootDelegates={};editor.editorManager.on('removeEditor',function(){var name;if(!editor.editorManager.activeEditor){if(customEventRootDelegates){for(name in customEventRootDelegates){editor.dom.unbind(getEventTarget(editor,name));}customEventRootDelegates=null;}}});}if(customEventRootDelegates[eventName]){return;}delegate=function delegate(e){var target=e.target;var editors=editor.editorManager.get();var i=editors.length;while(i--){var body=editors[i].getBody();if(body===target||DOM$1.isChildOf(target,body)){fireEvent(editors[i],eventName,e);}}};customEventRootDelegates[eventName]=delegate;DOM$1.bind(eventRootElm,eventName,delegate);}else{delegate=function delegate(e){fireEvent(editor,eventName,e);};DOM$1.bind(eventRootElm,eventName,delegate);editor.delegates[eventName]=delegate;}};var EditorObservable={bindPendingEventDelegates:function bindPendingEventDelegates(){var self=this;$_2ytxahljk26xetf.each(self._pendingNativeEvents,function(name){bindEventDelegate(self,name);});},toggleNativeEvent:function toggleNativeEvent(name,state){var self=this;if(name==='focus'||name==='blur'){return;}if(state){if(self.initialized){bindEventDelegate(self,name);}else{if(!self._pendingNativeEvents){self._pendingNativeEvents=[name];}else{self._pendingNativeEvents.push(name);}}}else if(self.initialized){self.dom.unbind(getEventTarget(self,name),name,self.delegates[name]);delete self.delegates[name];}},unbindAllNativeEvents:function unbindAllNativeEvents(){var self=this;var body=self.getBody();var dom=self.dom;var name;if(self.delegates){for(name in self.delegates){self.dom.unbind(getEventTarget(self,name),name,self.delegates[name]);}delete self.delegates;}if(!self.inline&&body&&dom){body.onload=null;dom.unbind(self.getWin());dom.unbind(self.getDoc());}if(dom){dom.unbind(body);dom.unbind(self.getContainer());}}};EditorObservable=$_2ytxahljk26xetf.extend({},$_4d4jki4qjk26xfs1,EditorObservable);var EditorObservable$1=EditorObservable;var each$11=$_2ytxahljk26xetf.each;var explode$2=$_2ytxahljk26xetf.explode;var keyCodeLookup={f9:120,f10:121,f11:122};var modifierNames=$_2ytxahljk26xetf.makeMap('alt,ctrl,shift,meta,access');function Shortcuts(editor){var self=this;var shortcuts={};var pendingPatterns=[];var parseShortcut=function parseShortcut(pattern){var id,key;var shortcut={};each$11(explode$2(pattern,'+'),function(value){if(value in modifierNames){shortcut[value]=true;}else{if(/^[0-9]{2,}$/.test(value)){shortcut.keyCode=parseInt(value,10);}else{shortcut.charCode=value.charCodeAt(0);shortcut.keyCode=keyCodeLookup[value]||value.toUpperCase().charCodeAt(0);}}});id=[shortcut.keyCode];for(key in modifierNames){if(shortcut[key]){id.push(key);}else{shortcut[key]=false;}}shortcut.id=id.join(',');if(shortcut.access){shortcut.alt=true;if($_ef6mqpajk26xejm.mac){shortcut.ctrl=true;}else{shortcut.shift=true;}}if(shortcut.meta){if($_ef6mqpajk26xejm.mac){shortcut.meta=true;}else{shortcut.ctrl=true;shortcut.meta=false;}}return shortcut;};var createShortcut=function createShortcut(pattern,desc,cmdFunc,scope){var shortcuts;shortcuts=$_2ytxahljk26xetf.map(explode$2(pattern,'>'),parseShortcut);shortcuts[shortcuts.length-1]=$_2ytxahljk26xetf.extend(shortcuts[shortcuts.length-1],{func:cmdFunc,scope:scope||editor});return $_2ytxahljk26xetf.extend(shortcuts[0],{desc:editor.translate(desc),subpatterns:shortcuts.slice(1)});};var hasModifier=function hasModifier(e){return e.altKey||e.ctrlKey||e.metaKey;};var isFunctionKey=function isFunctionKey(e){return e.type==='keydown'&&e.keyCode>=112&&e.keyCode<=123;};var matchShortcut=function matchShortcut(e,shortcut){if(!shortcut){return false;}if(shortcut.ctrl!==e.ctrlKey||shortcut.meta!==e.metaKey){return false;}if(shortcut.alt!==e.altKey||shortcut.shift!==e.shiftKey){return false;}if(e.keyCode===shortcut.keyCode||e.charCode&&e.charCode===shortcut.charCode){e.preventDefault();return true;}return false;};var executeShortcutAction=function executeShortcutAction(shortcut){return shortcut.func?shortcut.func.call(shortcut.scope):null;};editor.on('keyup keypress keydown',function(e){if((hasModifier(e)||isFunctionKey(e))&&!e.isDefaultPrevented()){each$11(shortcuts,function(shortcut){if(matchShortcut(e,shortcut)){pendingPatterns=shortcut.subpatterns.slice(0);if(e.type==='keydown'){executeShortcutAction(shortcut);}return true;}});if(matchShortcut(e,pendingPatterns[0])){if(pendingPatterns.length===1){if(e.type==='keydown'){executeShortcutAction(pendingPatterns[0]);}}pendingPatterns.shift();}}});self.add=function(pattern,desc,cmdFunc,scope){var cmd;cmd=cmdFunc;if(typeof cmdFunc==='string'){cmdFunc=function cmdFunc(){editor.execCommand(cmd,false,null);};}else if($_2ytxahljk26xetf.isArray(cmd)){cmdFunc=function cmdFunc(){editor.execCommand(cmd[0],cmd[1],cmd[2]);};}each$11(explode$2($_2ytxahljk26xetf.trim(pattern.toLowerCase())),function(pattern){var shortcut=createShortcut(pattern,desc,cmdFunc,scope);shortcuts[shortcut.id]=shortcut;});return true;};self.remove=function(pattern){var shortcut=createShortcut(pattern);if(shortcuts[shortcut.id]){delete shortcuts[shortcut.id];return true;}return false;};}var any$1=function any$1(predicate){return $_am0h6a2ajk26xf4w.first(predicate).isSome();};var ancestor$3=function ancestor$3(scope,predicate,isRoot){return $_am0h6a2ajk26xf4w.ancestor(scope,predicate,isRoot).isSome();};var closest$3=function closest$3(scope,predicate,isRoot){return $_am0h6a2ajk26xf4w.closest(scope,predicate,isRoot).isSome();};var sibling$4=function sibling$4(scope,predicate){return $_am0h6a2ajk26xf4w.sibling(scope,predicate).isSome();};var child$4=function child$4(scope,predicate){return $_am0h6a2ajk26xf4w.child(scope,predicate).isSome();};var descendant$3=function descendant$3(scope,predicate){return $_am0h6a2ajk26xf4w.descendant(scope,predicate).isSome();};var $_aa5q604xjk26xft2={any:any$1,ancestor:ancestor$3,closest:closest$3,sibling:sibling$4,child:child$4,descendant:descendant$3};var focus$$1=function focus$$1(element){element.dom().focus();};var blur$$1=function blur$$1(element){element.dom().blur();};var hasFocus=function hasFocus(element){var doc=$_2i1q6518jk26xexk.owner(element).dom();return element.dom()===doc.activeElement;};var active=function active(_doc){var doc=_doc!==undefined?_doc.dom():document;return Option.from(doc.activeElement).map(Element$$1.fromDom);};var focusInside=function focusInside(element){var doc=$_2i1q6518jk26xexk.owner(element);var inside=active(doc).filter(function(a){return $_aa5q604xjk26xft2.closest(a,curry($_dzedg81ejk26xeyh.eq,element));});inside.fold(function(){focus$$1(element);},noop);};var search=function search(element){return active($_2i1q6518jk26xexk.owner(element)).filter(function(e){return element.dom().contains(e.dom());});};var $_25lz5l4wjk26xfsv={hasFocus:hasFocus,focus:focus$$1,blur:blur$$1,active:active,search:search,focusInside:focusInside};var getContentEditableHost=function getContentEditableHost(editor,node){return editor.dom.getParent(node,function(node){return editor.dom.getContentEditable(node)==='true';});};var getCollapsedNode=function getCollapsedNode(rng){return rng.collapsed?Option.from(getNode(rng.startContainer,rng.startOffset)).map(Element$$1.fromDom):Option.none();};var getFocusInElement=function getFocusInElement(root,rng){return getCollapsedNode(rng).bind(function(node){if(isTableSection(node)){return Option.some(node);}else if($_dzedg81ejk26xeyh.contains(root,node)===false){return Option.some(root);}else{return Option.none();}});};var normalizeSelection=function normalizeSelection(editor,rng){getFocusInElement(Element$$1.fromDom(editor.getBody()),rng).bind(function(elm){return $_bwopbb2yjk26xf9h.firstPositionIn(elm.dom());}).fold(function(){editor.selection.normalize();return;},function(caretPos){return editor.selection.setRng(caretPos.toRange());});};var focusBody=function focusBody(body){if(body.setActive){try{body.setActive();}catch(ex){body.focus();}}else{body.focus();}};var hasElementFocus=function hasElementFocus(elm){return $_25lz5l4wjk26xfsv.hasFocus(elm)||$_25lz5l4wjk26xfsv.search(elm).isSome();};var hasIframeFocus=function hasIframeFocus(editor){return editor.iframeElement&&$_25lz5l4wjk26xfsv.hasFocus(Element$$1.fromDom(editor.iframeElement));};var hasInlineFocus=function hasInlineFocus(editor){var rawBody=editor.getBody();return rawBody&&hasElementFocus(Element$$1.fromDom(rawBody));};var hasFocus$1=function hasFocus$1(editor){return editor.inline?hasInlineFocus(editor):hasIframeFocus(editor);};var focusEditor=function focusEditor(editor){var selection=editor.selection,contentEditable=editor.settings.content_editable;var body=editor.getBody();var rng=selection.getRng();editor.quirks.refreshContentEditable();var contentEditableHost=getContentEditableHost(editor,selection.getNode());if(editor.$.contains(body,contentEditableHost)){focusBody(contentEditableHost);normalizeSelection(editor,rng);activateEditor(editor);return;}if(editor.bookmark!==undefined&&hasFocus$1(editor)===false){$_wwyx94ljk26xfqt.getRng(editor).each(function(bookmarkRng){editor.selection.setRng(bookmarkRng);rng=bookmarkRng;});}if(!contentEditable){if(!$_ef6mqpajk26xejm.opera){focusBody(body);}editor.getWin().focus();}if($_ef6mqpajk26xejm.gecko||contentEditable){focusBody(body);normalizeSelection(editor,rng);}activateEditor(editor);};var activateEditor=function activateEditor(editor){return editor.editorManager.setActive(editor);};var focus$1=function focus$1(editor,skipFocus){if(editor.removed){return;}skipFocus?activateEditor(editor):focusEditor(editor);};var $_3hu41a4vjk26xfsm={focus:focus$1,hasFocus:hasFocus$1};var getProp=function getProp(propName,elm){var rawElm=elm.dom();return rawElm[propName];};var getComputedSizeProp=function getComputedSizeProp(propName,elm){return parseInt($_15rddx13jk26xew4.get(elm,propName),10);};var getClientWidth=curry(getProp,'clientWidth');var getClientHeight=curry(getProp,'clientHeight');var getMarginTop=curry(getComputedSizeProp,'margin-top');var getMarginLeft=curry(getComputedSizeProp,'margin-left');var getBoundingClientRect$1=function getBoundingClientRect$1(elm){return elm.dom().getBoundingClientRect();};var isInsideElementContentArea=function isInsideElementContentArea(bodyElm,clientX,clientY){var clientWidth=getClientWidth(bodyElm);var clientHeight=getClientHeight(bodyElm);return clientX>=0&&clientY>=0&&clientX<=clientWidth&&clientY<=clientHeight;};var transpose=function transpose(inline,elm,clientX,clientY){var clientRect=getBoundingClientRect$1(elm);var deltaX=inline?clientRect.left+elm.dom().clientLeft+getMarginLeft(elm):0;var deltaY=inline?clientRect.top+elm.dom().clientTop+getMarginTop(elm):0;var x=clientX-deltaX;var y=clientY-deltaY;return{x:x,y:y};};var isXYInContentArea=function isXYInContentArea(editor,clientX,clientY){var bodyElm=Element$$1.fromDom(editor.getBody());var targetElm=editor.inline?bodyElm:$_2i1q6518jk26xexk.documentElement(bodyElm);var transposedPoint=transpose(editor.inline,targetElm,clientX,clientY);return isInsideElementContentArea(targetElm,transposedPoint.x,transposedPoint.y);};var fromDomSafe=function fromDomSafe(node){return Option.from(node).map(Element$$1.fromDom);};var isEditorAttachedToDom=function isEditorAttachedToDom(editor){var rawContainer=editor.inline?editor.getBody():editor.getContentAreaContainer();return fromDomSafe(rawContainer).map(function(container){return $_dzedg81ejk26xeyh.contains($_2i1q6518jk26xexk.owner(container),container);}).getOr(false);};var $_e6lkbw50jk26xftn={isXYInContentArea:isXYInContentArea,isEditorAttachedToDom:isEditorAttachedToDom};function NotificationManagerImpl(){var unimplemented=function unimplemented(){throw new Error('Theme did not provide a NotificationManager implementation.');};return{open:unimplemented,close:unimplemented,reposition:unimplemented,getArgs:unimplemented};}function NotificationManager(editor){var notifications=[];var getImplementation=function getImplementation(){var theme=editor.theme;return theme&&theme.getNotificationManagerImpl?theme.getNotificationManagerImpl():NotificationManagerImpl();};var getTopNotification=function getTopNotification(){return Option.from(notifications[0]);};var isEqual=function isEqual(a,b){return a.type===b.type&&a.text===b.text&&!a.progressBar&&!a.timeout&&!b.progressBar&&!b.timeout;};var reposition=function reposition(){if(notifications.length>0){getImplementation().reposition(notifications);}};var addNotification=function addNotification(notification){notifications.push(notification);};var closeNotification=function closeNotification(notification){findIndex(notifications,function(otherNotification){return otherNotification===notification;}).each(function(index){notifications.splice(index,1);});};var open=function open(args){if(editor.removed||!$_e6lkbw50jk26xftn.isEditorAttachedToDom(editor)){return;}return find(notifications,function(notification){return isEqual(getImplementation().getArgs(notification),args);}).getOrThunk(function(){editor.editorManager.setActive(editor);var notification=getImplementation().open(args,function(){closeNotification(notification);reposition();});addNotification(notification);reposition();return notification;});};var close=function close(){getTopNotification().each(function(notification){getImplementation().close(notification);closeNotification(notification);reposition();});};var getNotifications=function getNotifications(){return notifications;};var registerEvents=function registerEvents(editor){editor.on('SkinLoaded',function(){var serviceMessage=editor.settings.service_message;if(serviceMessage){open({text:serviceMessage,type:'warning',timeout:0,icon:''});}});editor.on('ResizeEditor ResizeWindow',function(){$_3a7ompijk26xer0.requestAnimationFrame(reposition);});editor.on('remove',function(){each(notifications,function(notification){getImplementation().close(notification);});});};registerEvents(editor);return{open:open,close:close,getNotifications:getNotifications};}function WindowManagerImpl(){var unimplemented=function unimplemented(){throw new Error('Theme did not provide a WindowManager implementation.');};return{open:unimplemented,alert:unimplemented,confirm:unimplemented,close:unimplemented,getParams:unimplemented,setParams:unimplemented};}function WindowManager(editor){var windows=[];var getImplementation=function getImplementation(){var theme=editor.theme;return theme&&theme.getWindowManagerImpl?theme.getWindowManagerImpl():WindowManagerImpl();};var funcBind=function funcBind(scope,f){return function(){return f?f.apply(scope,arguments):undefined;};};var fireOpenEvent=function fireOpenEvent(win){editor.fire('OpenWindow',{win:win});};var fireCloseEvent=function fireCloseEvent(win){editor.fire('CloseWindow',{win:win});};var addWindow=function addWindow(win){windows.push(win);fireOpenEvent(win);};var closeWindow=function closeWindow(win){findIndex(windows,function(otherWindow){return otherWindow===win;}).each(function(index){windows.splice(index,1);fireCloseEvent(win);if(windows.length===0){editor.focus();}});};var getTopWindow=function getTopWindow(){return Option.from(windows[windows.length-1]);};var open=function open(args,params){editor.editorManager.setActive(editor);$_wwyx94ljk26xfqt.store(editor);var win=getImplementation().open(args,params,closeWindow);addWindow(win);return win;};var alert=function alert(message,callback,scope){var win=getImplementation().alert(message,funcBind(scope?scope:this,callback),closeWindow);addWindow(win);};var confirm=function confirm(message,callback,scope){var win=getImplementation().confirm(message,funcBind(scope?scope:this,callback),closeWindow);addWindow(win);};var close=function close(){getTopWindow().each(function(win){getImplementation().close(win);closeWindow(win);});};var getParams=function getParams(){return getTopWindow().map(getImplementation().getParams).getOr(null);};var setParams=function setParams(params){getTopWindow().each(function(win){getImplementation().setParams(win,params);});};var getWindows=function getWindows(){return windows;};editor.on('remove',function(){each(windows.slice(0),function(win){getImplementation().close(win);});});return{windows:windows,open:open,alert:alert,confirm:confirm,close:close,getParams:getParams,setParams:setParams,getWindows:getWindows};}var PluginManager=AddOnManager.PluginManager;var resolvePluginName=function resolvePluginName(targetUrl,suffix){for(var name$$1 in PluginManager.urls){var matchUrl=PluginManager.urls[name$$1]+'/plugin'+suffix+'.js';if(matchUrl===targetUrl){return name$$1;}}return null;};var pluginUrlToMessage=function pluginUrlToMessage(editor,url){var plugin=resolvePluginName(url,editor.suffix);return plugin?'Failed to load plugin: '+plugin+' from url '+url:'Failed to load plugin url: '+url;};var displayNotification=function displayNotification(editor,message){editor.notificationManager.open({type:'error',text:message});};var displayError=function displayError(editor,message){if(editor._skinLoaded){displayNotification(editor,message);}else{editor.on('SkinLoaded',function(){displayNotification(editor,message);});}};var uploadError=function uploadError(editor,message){displayError(editor,'Failed to upload image: '+message);};var pluginLoadError=function pluginLoadError(editor,url){displayError(editor,pluginUrlToMessage(editor,url));};var initError=function initError(message){var x=[];for(var _i=1;_i<arguments.length;_i++){x[_i-1]=arguments[_i];}var console$$1=window.console;if(console$$1){if(console$$1.error){console$$1.error.apply(console$$1,arguments);}else{console$$1.log.apply(console$$1,arguments);}}};var $_3uguhq54jk26xfug={pluginLoadError:pluginLoadError,uploadError:uploadError,displayError:displayError,initError:initError};var PluginManager$1=AddOnManager.PluginManager;var ThemeManager=AddOnManager.ThemeManager;function XMLHttpRequest(){var f=$_6d4d2bcjk26xeju.getOrDie('XMLHttpRequest');return new f();}function Uploader(uploadStatus,settings){var pendingPromises={};var pathJoin=function pathJoin(path1,path2){if(path1){return path1.replace(/\/$/,'')+'/'+path2.replace(/^\//,'');}return path2;};var defaultHandler=function defaultHandler(blobInfo,success,failure,progress){var xhr,formData;xhr=new XMLHttpRequest();xhr.open('POST',settings.url);xhr.withCredentials=settings.credentials;xhr.upload.onprogress=function(e){progress(e.loaded/e.total*100);};xhr.onerror=function(){failure('Image upload failed due to a XHR Transport error. Code: '+xhr.status);};xhr.onload=function(){var json;if(xhr.status<200||xhr.status>=300){failure('HTTP Error: '+xhr.status);return;}json=JSON.parse(xhr.responseText);if(!json||typeof json.location!=='string'){failure('Invalid JSON: '+xhr.responseText);return;}success(pathJoin(settings.basePath,json.location));};formData=new FormData();formData.append('file',blobInfo.blob(),blobInfo.filename());xhr.send(formData);};var noUpload=function noUpload(){return new promiseObj(function(resolve){resolve([]);});};var handlerSuccess=function handlerSuccess(blobInfo,url){return{url:url,blobInfo:blobInfo,status:true};};var handlerFailure=function handlerFailure(blobInfo,error){return{url:'',blobInfo:blobInfo,status:false,error:error};};var resolvePending=function resolvePending(blobUri,result){$_2ytxahljk26xetf.each(pendingPromises[blobUri],function(resolve){resolve(result);});delete pendingPromises[blobUri];};var uploadBlobInfo=function uploadBlobInfo(blobInfo,handler,openNotification){uploadStatus.markPending(blobInfo.blobUri());return new promiseObj(function(resolve){var notification,progress;var noop=function noop(){};try{var closeNotification_1=function closeNotification_1(){if(notification){notification.close();progress=noop;}};var success=function success(url){closeNotification_1();uploadStatus.markUploaded(blobInfo.blobUri(),url);resolvePending(blobInfo.blobUri(),handlerSuccess(blobInfo,url));resolve(handlerSuccess(blobInfo,url));};var failure=function failure(error){closeNotification_1();uploadStatus.removeFailed(blobInfo.blobUri());resolvePending(blobInfo.blobUri(),handlerFailure(blobInfo,error));resolve(handlerFailure(blobInfo,error));};progress=function progress(percent){if(percent<0||percent>100){return;}if(!notification){notification=openNotification();}notification.progressBar.value(percent);};handler(blobInfo,success,failure,progress);}catch(ex){resolve(handlerFailure(blobInfo,ex.message));}});};var isDefaultHandler=function isDefaultHandler(handler){return handler===defaultHandler;};var pendingUploadBlobInfo=function pendingUploadBlobInfo(blobInfo){var blobUri=blobInfo.blobUri();return new promiseObj(function(resolve){pendingPromises[blobUri]=pendingPromises[blobUri]||[];pendingPromises[blobUri].push(resolve);});};var uploadBlobs=function uploadBlobs(blobInfos,openNotification){blobInfos=$_2ytxahljk26xetf.grep(blobInfos,function(blobInfo){return!uploadStatus.isUploaded(blobInfo.blobUri());});return promiseObj.all($_2ytxahljk26xetf.map(blobInfos,function(blobInfo){return uploadStatus.isPending(blobInfo.blobUri())?pendingUploadBlobInfo(blobInfo):uploadBlobInfo(blobInfo,settings.handler,openNotification);}));};var upload=function upload(blobInfos,openNotification){return!settings.url&&isDefaultHandler(settings.handler)?noUpload():uploadBlobs(blobInfos,openNotification);};settings=$_2ytxahljk26xetf.extend({credentials:false,handler:defaultHandler},settings);return{upload:upload};}function Blob(parts,properties){var f=$_6d4d2bcjk26xeju.getOrDie('Blob');return new f(parts,properties);}function FileReader(){var f=$_6d4d2bcjk26xeju.getOrDie('FileReader');return new f();}function Uint8Array(arr){var f=$_6d4d2bcjk26xeju.getOrDie('Uint8Array');return new f(arr);}var requestAnimationFrame$1=function requestAnimationFrame$1(callback){var f=$_6d4d2bcjk26xeju.getOrDie('requestAnimationFrame');f(callback);};var atob=function atob(base64){var f=$_6d4d2bcjk26xeju.getOrDie('atob');return f(base64);};var $_9t5c9p5hjk26xfw9={atob:atob,requestAnimationFrame:requestAnimationFrame$1};var blobUriToBlob=function blobUriToBlob(url){return new promiseObj(function(resolve,reject){var rejectWithError=function rejectWithError(){reject('Cannot convert '+url+' to Blob. Resource might not exist or is inaccessible.');};try{var xhr=new XMLHttpRequest();xhr.open('GET',url,true);xhr.responseType='blob';xhr.onload=function(){if(this.status===200){resolve(this.response);}else{rejectWithError();}};xhr.onerror=rejectWithError;xhr.send();}catch(ex){rejectWithError();}});};var parseDataUri=function parseDataUri(uri){var type,matches;uri=decodeURIComponent(uri).split(',');matches=/data:([^;]+)/.exec(uri[0]);if(matches){type=matches[1];}return{type:type,data:uri[1]};};var dataUriToBlob=function dataUriToBlob(uri){return new promiseObj(function(resolve){var str,arr,i;uri=parseDataUri(uri);try{str=$_9t5c9p5hjk26xfw9.atob(uri.data);}catch(e){resolve(new Blob([]));return;}arr=new Uint8Array(str.length);for(i=0;i<arr.length;i++){arr[i]=str.charCodeAt(i);}resolve(new Blob([arr],{type:uri.type}));});};var uriToBlob=function uriToBlob(url){if(url.indexOf('blob:')===0){return blobUriToBlob(url);}if(url.indexOf('data:')===0){return dataUriToBlob(url);}return null;};var blobToDataUri=function blobToDataUri(blob){return new promiseObj(function(resolve){var reader=new FileReader();reader.onloadend=function(){resolve(reader.result);};reader.readAsDataURL(blob);});};var $_74nwp85djk26xfvp={uriToBlob:uriToBlob,blobToDataUri:blobToDataUri,parseDataUri:parseDataUri};var count=0;var uniqueId=function uniqueId(prefix){return(prefix||'blobid')+count++;};var imageToBlobInfo=function imageToBlobInfo(blobCache,img,resolve,reject){var base64,blobInfo;if(img.src.indexOf('blob:')===0){blobInfo=blobCache.getByUri(img.src);if(blobInfo){resolve({image:img,blobInfo:blobInfo});}else{$_74nwp85djk26xfvp.uriToBlob(img.src).then(function(blob){$_74nwp85djk26xfvp.blobToDataUri(blob).then(function(dataUri){base64=$_74nwp85djk26xfvp.parseDataUri(dataUri).data;blobInfo=blobCache.create(uniqueId(),blob,base64);blobCache.add(blobInfo);resolve({image:img,blobInfo:blobInfo});});},function(err){reject(err);});}return;}base64=$_74nwp85djk26xfvp.parseDataUri(img.src).data;blobInfo=blobCache.findFirst(function(cachedBlobInfo){return cachedBlobInfo.base64()===base64;});if(blobInfo){resolve({image:img,blobInfo:blobInfo});}else{$_74nwp85djk26xfvp.uriToBlob(img.src).then(function(blob){blobInfo=blobCache.create(uniqueId(),blob,base64);blobCache.add(blobInfo);resolve({image:img,blobInfo:blobInfo});},function(err){reject(err);});}};var getAllImages=function getAllImages(elm){return elm?elm.getElementsByTagName('img'):[];};function ImageScanner(uploadStatus,blobCache){var cachedPromises={};var findAll=function findAll(elm,predicate){var images;if(!predicate){predicate=$_a86i182ljk26xf77.constant(true);}images=$_98exydmjk26xeto.filter(getAllImages(elm),function(img){var src=img.src;if(!$_ef6mqpajk26xejm.fileApi){return false;}if(img.hasAttribute('data-mce-bogus')){return false;}if(img.hasAttribute('data-mce-placeholder')){return false;}if(!src||src===$_ef6mqpajk26xejm.transparentSrc){return false;}if(src.indexOf('blob:')===0){return!uploadStatus.isUploaded(src);}if(src.indexOf('data:')===0){return predicate(img);}return false;});var promises=$_98exydmjk26xeto.map(images,function(img){if(cachedPromises[img.src]){return new promiseObj(function(resolve){cachedPromises[img.src].then(function(imageInfo){if(typeof imageInfo==='string'){return imageInfo;}resolve({image:img,blobInfo:imageInfo.blobInfo});});});}var newPromise=new promiseObj(function(resolve,reject){imageToBlobInfo(blobCache,img,resolve,reject);}).then(function(result){delete cachedPromises[result.image.src];return result;}).catch(function(error){delete cachedPromises[img.src];return error;});cachedPromises[img.src]=newPromise;return newPromise;});return promiseObj.all(promises);};return{findAll:findAll};}var count$1=0;var seed=function seed(){var rnd=function rnd(){return Math.round(Math.random()*4294967295).toString(36);};var now=new Date().getTime();return's'+now.toString(36)+rnd()+rnd()+rnd();};var uuid=function uuid(prefix){return prefix+count$1++ +seed();};var $_7xi2o55jjk26xfwg={uuid:uuid};function BlobCache(){var cache=[];var constant=$_a86i182ljk26xf77.constant;var mimeToExt=function mimeToExt(mime){var mimes={'image/jpeg':'jpg','image/jpg':'jpg','image/gif':'gif','image/png':'png'};return mimes[mime.toLowerCase()]||'dat';};var create=function create(o,blob,base64,filename){return(typeof o==='undefined'?'undefined':_typeof(o))==='object'?toBlobInfo(o):toBlobInfo({id:o,name:filename,blob:blob,base64:base64});};var toBlobInfo=function toBlobInfo(o){var id,name;if(!o.blob||!o.base64){throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');}id=o.id||$_7xi2o55jjk26xfwg.uuid('blobid');name=o.name||id;return{id:constant(id),name:constant(name),filename:constant(name+'.'+mimeToExt(o.blob.type)),blob:constant(o.blob),base64:constant(o.base64),blobUri:constant(o.blobUri||$_8l5cv7bjk26xejt.createObjectURL(o.blob)),uri:constant(o.uri)};};var add=function add(blobInfo){if(!get(blobInfo.id())){cache.push(blobInfo);}};var get=function get(id){return findFirst(function(cachedBlobInfo){return cachedBlobInfo.id()===id;});};var findFirst=function findFirst(predicate){return $_98exydmjk26xeto.filter(cache,predicate)[0];};var getByUri=function getByUri(blobUri){return findFirst(function(blobInfo){return blobInfo.blobUri()===blobUri;});};var removeByUri=function removeByUri(blobUri){cache=$_98exydmjk26xeto.filter(cache,function(blobInfo){if(blobInfo.blobUri()===blobUri){$_8l5cv7bjk26xejt.revokeObjectURL(blobInfo.blobUri());return false;}return true;});};var destroy=function destroy(){$_98exydmjk26xeto.each(cache,function(cachedBlobInfo){$_8l5cv7bjk26xejt.revokeObjectURL(cachedBlobInfo.blobUri());});cache=[];};return{create:create,add:add,get:get,getByUri:getByUri,findFirst:findFirst,removeByUri:removeByUri,destroy:destroy};}function UploadStatus(){var PENDING=1,UPLOADED=2;var blobUriStatuses={};var createStatus=function createStatus(status,resultUri){return{status:status,resultUri:resultUri};};var hasBlobUri=function hasBlobUri(blobUri){return blobUri in blobUriStatuses;};var getResultUri=function getResultUri(blobUri){var result=blobUriStatuses[blobUri];return result?result.resultUri:null;};var isPending=function isPending(blobUri){return hasBlobUri(blobUri)?blobUriStatuses[blobUri].status===PENDING:false;};var isUploaded=function isUploaded(blobUri){return hasBlobUri(blobUri)?blobUriStatuses[blobUri].status===UPLOADED:false;};var markPending=function markPending(blobUri){blobUriStatuses[blobUri]=createStatus(PENDING,null);};var markUploaded=function markUploaded(blobUri,resultUri){blobUriStatuses[blobUri]=createStatus(UPLOADED,resultUri);};var removeFailed=function removeFailed(blobUri){delete blobUriStatuses[blobUri];};var destroy=function destroy(){blobUriStatuses={};};return{hasBlobUri:hasBlobUri,getResultUri:getResultUri,isPending:isPending,isUploaded:isUploaded,markPending:markPending,markUploaded:markUploaded,removeFailed:removeFailed,destroy:destroy};}function EditorUpload(editor){var blobCache=BlobCache();var uploader,imageScanner;var settings=editor.settings;var uploadStatus=UploadStatus();var aliveGuard=function aliveGuard(callback){return function(result){if(editor.selection){return callback(result);}return[];};};var cacheInvalidator=function cacheInvalidator(){return'?'+new Date().getTime();};var replaceString=function replaceString(content,search,replace){var index=0;do{index=content.indexOf(search,index);if(index!==-1){content=content.substring(0,index)+replace+content.substr(index+search.length);index+=replace.length-search.length+1;}}while(index!==-1);return content;};var replaceImageUrl=function replaceImageUrl(content,targetUrl,replacementUrl){content=replaceString(content,'src="'+targetUrl+'"','src="'+replacementUrl+'"');content=replaceString(content,'data-mce-src="'+targetUrl+'"','data-mce-src="'+replacementUrl+'"');return content;};var replaceUrlInUndoStack=function replaceUrlInUndoStack(targetUrl,replacementUrl){$_98exydmjk26xeto.each(editor.undoManager.data,function(level){if(level.type==='fragmented'){level.fragments=$_98exydmjk26xeto.map(level.fragments,function(fragment){return replaceImageUrl(fragment,targetUrl,replacementUrl);});}else{level.content=replaceImageUrl(level.content,targetUrl,replacementUrl);}});};var openNotification=function openNotification(){return editor.notificationManager.open({text:editor.translate('Image uploading...'),type:'info',timeout:-1,progressBar:true});};var replaceImageUri=function replaceImageUri(image,resultUri){blobCache.removeByUri(image.src);replaceUrlInUndoStack(image.src,resultUri);editor.$(image).attr({'src':settings.images_reuse_filename?resultUri+cacheInvalidator():resultUri,'data-mce-src':editor.convertURL(resultUri,'src')});};var uploadImages=function uploadImages(callback){if(!uploader){uploader=Uploader(uploadStatus,{url:settings.images_upload_url,basePath:settings.images_upload_base_path,credentials:settings.images_upload_credentials,handler:settings.images_upload_handler});}return scanForImages().then(aliveGuard(function(imageInfos){var blobInfos;blobInfos=$_98exydmjk26xeto.map(imageInfos,function(imageInfo){return imageInfo.blobInfo;});return uploader.upload(blobInfos,openNotification).then(aliveGuard(function(result){var filteredResult=$_98exydmjk26xeto.map(result,function(uploadInfo,index){var image=imageInfos[index].image;if(uploadInfo.status&&editor.settings.images_replace_blob_uris!==false){replaceImageUri(image,uploadInfo.url);}else if(uploadInfo.error){$_3uguhq54jk26xfug.uploadError(editor,uploadInfo.error);}return{element:image,status:uploadInfo.status};});if(callback){callback(filteredResult);}return filteredResult;}));}));};var uploadImagesAuto=function uploadImagesAuto(callback){if(settings.automatic_uploads!==false){return uploadImages(callback);}};var isValidDataUriImage=function isValidDataUriImage(imgElm){return settings.images_dataimg_filter?settings.images_dataimg_filter(imgElm):true;};var scanForImages=function scanForImages(){if(!imageScanner){imageScanner=ImageScanner(uploadStatus,blobCache);}return imageScanner.findAll(editor.getBody(),isValidDataUriImage).then(aliveGuard(function(result){result=$_98exydmjk26xeto.filter(result,function(resultItem){if(typeof resultItem==='string'){$_3uguhq54jk26xfug.displayError(editor,resultItem);return false;}return true;});$_98exydmjk26xeto.each(result,function(resultItem){replaceUrlInUndoStack(resultItem.image.src,resultItem.blobInfo.blobUri());resultItem.image.src=resultItem.blobInfo.blobUri();resultItem.image.removeAttribute('data-mce-src');});return result;}));};var destroy=function destroy(){blobCache.destroy();uploadStatus.destroy();imageScanner=uploader=null;};var replaceBlobUris=function replaceBlobUris(content){return content.replace(/src="(blob:[^"]+)"/g,function(match,blobUri){var resultUri=uploadStatus.getResultUri(blobUri);if(resultUri){return'src="'+resultUri+'"';}var blobInfo=blobCache.getByUri(blobUri);if(!blobInfo){blobInfo=$_98exydmjk26xeto.reduce(editor.editorManager.get(),function(result,editor){return result||editor.editorUpload&&editor.editorUpload.blobCache.getByUri(blobUri);},null);}if(blobInfo){return'src="data:'+blobInfo.blob().type+';base64,'+blobInfo.base64()+'"';}return match;});};editor.on('setContent',function(){if(editor.settings.automatic_uploads!==false){uploadImagesAuto();}else{scanForImages();}});editor.on('RawSaveContent',function(e){e.content=replaceBlobUris(e.content);});editor.on('getContent',function(e){if(e.source_view||e.format==='raw'){return;}e.content=replaceBlobUris(e.content);});editor.on('PostRender',function(){editor.parser.addNodeFilter('img',function(images){$_98exydmjk26xeto.each(images,function(img){var src=img.attr('src');if(blobCache.getByUri(src)){return;}var resultUri=uploadStatus.getResultUri(src);if(resultUri){img.attr('src',resultUri);}});});});return{blobCache:blobCache,uploadImages:uploadImages,uploadImagesAuto:uploadImagesAuto,scanForImages:scanForImages,destroy:destroy};}var isBlockElement=function isBlockElement(blockElements,node){return blockElements.hasOwnProperty(node.nodeName);};var isValidTarget=function isValidTarget(blockElements,node){if($_fpgwqg1rjk26xf0n.isText(node)){return true;}else if($_fpgwqg1rjk26xf0n.isElement(node)){return!isBlockElement(blockElements,node)&&!$_2wdci52vjk26xf8r.isBookmarkNode(node);}else{return false;}};var hasBlockParent=function hasBlockParent(blockElements,root,node){return exists($_du4do23zjk26xfl5.parents(Element$$1.fromDom(node),Element$$1.fromDom(root)),function(elm){return isBlockElement(blockElements,elm.dom());});};var shouldRemoveTextNode=function shouldRemoveTextNode(blockElements,node){if($_fpgwqg1rjk26xf0n.isText(node)){if(node.nodeValue.length===0){return true;}else if(/^\s+$/.test(node.nodeValue)&&(!node.nextSibling||isBlockElement(blockElements,node.nextSibling))){return true;}}return false;};var addRootBlocks=function addRootBlocks(editor){var settings=editor.settings,dom=editor.dom,selection=editor.selection;var schema=editor.schema,blockElements=schema.getBlockElements();var node=selection.getStart();var rootNode=editor.getBody();var rng;var startContainer,startOffset,endContainer,endOffset,rootBlockNode;var tempNode,wrapped,restoreSelection;var rootNodeName,forcedRootBlock;forcedRootBlock=settings.forced_root_block;if(!node||!$_fpgwqg1rjk26xf0n.isElement(node)||!forcedRootBlock){return;}rootNodeName=rootNode.nodeName.toLowerCase();if(!schema.isValidChild(rootNodeName,forcedRootBlock.toLowerCase())||hasBlockParent(blockElements,rootNode,node)){return;}rng=selection.getRng();startContainer=rng.startContainer;startOffset=rng.startOffset;endContainer=rng.endContainer;endOffset=rng.endOffset;restoreSelection=$_3hu41a4vjk26xfsm.hasFocus(editor);node=rootNode.firstChild;while(node){if(isValidTarget(blockElements,node)){if(shouldRemoveTextNode(blockElements,node)){tempNode=node;node=node.nextSibling;dom.remove(tempNode);continue;}if(!rootBlockNode){rootBlockNode=dom.create(forcedRootBlock,editor.settings.forced_root_block_attrs);node.parentNode.insertBefore(rootBlockNode,node);wrapped=true;}tempNode=node;node=node.nextSibling;rootBlockNode.appendChild(tempNode);}else{rootBlockNode=null;node=node.nextSibling;}}if(wrapped&&restoreSelection){rng.setStart(startContainer,startOffset);rng.setEnd(endContainer,endOffset);selection.setRng(rng);editor.nodeChanged();}};var setup$2=function setup$2(editor){if(editor.settings.forced_root_block){editor.on('NodeChange',curry(addRootBlocks,editor));}};var $_2mzk445ljk26xfwk={setup:setup$2};var getStartNode=function getStartNode(rng){var sc=rng.startContainer,so=rng.startOffset;if($_fpgwqg1rjk26xf0n.isText(sc)){return so===0?Option.some(Element$$1.fromDom(sc)):Option.none();}else{return Option.from(sc.childNodes[so]).map(Element$$1.fromDom);}};var getEndNode=function getEndNode(rng){var ec=rng.endContainer,eo=rng.endOffset;if($_fpgwqg1rjk26xf0n.isText(ec)){return eo===ec.data.length?Option.some(Element$$1.fromDom(ec)):Option.none();}else{return Option.from(ec.childNodes[eo-1]).map(Element$$1.fromDom);}};var getFirstChildren=function getFirstChildren(node){return $_2i1q6518jk26xexk.firstChild(node).fold(constant([node]),function(child){return[node].concat(getFirstChildren(child));});};var getLastChildren$1=function getLastChildren$1(node){return $_2i1q6518jk26xexk.lastChild(node).fold(constant([node]),function(child){if($_cl4rr911jk26xevy.name(child)==='br'){return $_2i1q6518jk26xexk.prevSibling(child).map(function(sibling){return[node].concat(getLastChildren$1(sibling));}).getOr([]);}else{return[node].concat(getLastChildren$1(child));}});};var hasAllContentsSelected=function hasAllContentsSelected(elm,rng){return liftN([getStartNode(rng),getEndNode(rng)],function(startNode,endNode){var start=find(getFirstChildren(elm),curry($_dzedg81ejk26xeyh.eq,startNode));var end=find(getLastChildren$1(elm),curry($_dzedg81ejk26xeyh.eq,endNode));return start.isSome()&&end.isSome();}).getOr(false);};var moveEndPoint$1=function moveEndPoint$1(dom,rng,node,start){var root=node,walker=new TreeWalker(node,root);var nonEmptyElementsMap=dom.schema.getNonEmptyElements();do{if(node.nodeType===3&&$_2ytxahljk26xetf.trim(node.nodeValue).length!==0){if(start){rng.setStart(node,0);}else{rng.setEnd(node,node.nodeValue.length);}return;}if(nonEmptyElementsMap[node.nodeName]&&!/^(TD|TH)$/.test(node.nodeName)){if(start){rng.setStartBefore(node);}else{if(node.nodeName==='BR'){rng.setEndBefore(node);}else{rng.setEndAfter(node);}}return;}if($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<11&&dom.isBlock(node)&&dom.isEmpty(node)){if(start){rng.setStart(node,0);}else{rng.setEnd(node,0);}return;}}while(node=start?walker.next():walker.prev());if(root.nodeName==='BODY'){if(start){rng.setStart(root,0);}else{rng.setEnd(root,root.childNodes.length);}}};var hasAnyRanges=function hasAnyRanges(editor){var sel=editor.selection.getSel();return sel&&sel.rangeCount>0;};function NodeChange(editor){var lastRng,lastPath=[];var isSameElementPath=function isSameElementPath(startElm){var i,currentPath;currentPath=editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);if(currentPath.length===lastPath.length){for(i=currentPath.length;i>=0;i--){if(currentPath[i]!==lastPath[i]){break;}}if(i===-1){lastPath=currentPath;return true;}}lastPath=currentPath;return false;};if(!('onselectionchange'in editor.getDoc())){editor.on('NodeChange Click MouseUp KeyUp Focus',function(e){var nativeRng,fakeRng;nativeRng=editor.selection.getRng();fakeRng={startContainer:nativeRng.startContainer,startOffset:nativeRng.startOffset,endContainer:nativeRng.endContainer,endOffset:nativeRng.endOffset};if(e.type==='nodechange'||!$_5rlzpq4kjk26xfqr.isEq(fakeRng,lastRng)){editor.fire('SelectionChange');}lastRng=fakeRng;});}editor.on('contextmenu',function(){editor.fire('SelectionChange');});editor.on('SelectionChange',function(){var startElm=editor.selection.getStart(true);if(!startElm||!$_ef6mqpajk26xejm.range&&editor.selection.isCollapsed()){return;}if(hasAnyRanges(editor)&&!isSameElementPath(startElm)&&editor.dom.isChildOf(startElm,editor.getBody())){editor.nodeChanged({selectionChange:true});}});editor.on('MouseUp',function(e){if(!e.isDefaultPrevented()&&hasAnyRanges(editor)){if(editor.selection.getNode().nodeName==='IMG'){$_3a7ompijk26xer0.setEditorTimeout(editor,function(){editor.nodeChanged();});}else{editor.nodeChanged();}}});this.nodeChanged=function(args){var selection=editor.selection;var node,parents,root;if(editor.initialized&&selection&&!editor.settings.disable_nodechange&&!editor.readonly){root=editor.getBody();node=selection.getStart(true)||root;if(node.ownerDocument!==editor.getDoc()||!editor.dom.isChildOf(node,root)){node=root;}parents=[];editor.dom.getParent(node,function(node){if(node===root){return true;}parents.push(node);});args=args||{};args.element=node;args.parents=parents;editor.fire('NodeChange',args);}};}var getAbsolutePosition=function getAbsolutePosition(elm){var doc,docElem,win,clientRect;clientRect=elm.getBoundingClientRect();doc=elm.ownerDocument;docElem=doc.documentElement;win=doc.defaultView;return{top:clientRect.top+win.pageYOffset-docElem.clientTop,left:clientRect.left+win.pageXOffset-docElem.clientLeft};};var getBodyPosition=function getBodyPosition(editor){return editor.inline?getAbsolutePosition(editor.getBody()):{left:0,top:0};};var getScrollPosition=function getScrollPosition(editor){var body=editor.getBody();return editor.inline?{left:body.scrollLeft,top:body.scrollTop}:{left:0,top:0};};var getBodyScroll=function getBodyScroll(editor){var body=editor.getBody(),docElm=editor.getDoc().documentElement;var inlineScroll={left:body.scrollLeft,top:body.scrollTop};var iframeScroll={left:body.scrollLeft||docElm.scrollLeft,top:body.scrollTop||docElm.scrollTop};return editor.inline?inlineScroll:iframeScroll;};var getMousePosition=function getMousePosition(editor,event){if(event.target.ownerDocument!==editor.getDoc()){var iframePosition=getAbsolutePosition(editor.getContentAreaContainer());var scrollPosition=getBodyScroll(editor);return{left:event.pageX-iframePosition.left+scrollPosition.left,top:event.pageY-iframePosition.top+scrollPosition.top};}return{left:event.pageX,top:event.pageY};};var calculatePosition=function calculatePosition(bodyPosition,scrollPosition,mousePosition){return{pageX:mousePosition.left-bodyPosition.left+scrollPosition.left,pageY:mousePosition.top-bodyPosition.top+scrollPosition.top};};var calc=function calc(editor,event){return calculatePosition(getBodyPosition(editor),getScrollPosition(editor),getMousePosition(editor,event));};var $_4hlb6i5qjk26xfyh={calc:calc};var isContentEditableFalse$7=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isContentEditableTrue$4=$_fpgwqg1rjk26xf0n.isContentEditableTrue;var isDraggable=function isDraggable(rootElm,elm){return isContentEditableFalse$7(elm)&&elm!==rootElm;};var isValidDropTarget=function isValidDropTarget(editor,targetElement,dragElement){if(targetElement===dragElement||editor.dom.isChildOf(targetElement,dragElement)){return false;}if(isContentEditableFalse$7(targetElement)){return false;}return true;};var cloneElement=function cloneElement(elm){var cloneElm=elm.cloneNode(true);cloneElm.removeAttribute('data-mce-selected');return cloneElm;};var createGhost=function createGhost(editor,elm,width,height){var clonedElm=elm.cloneNode(true);editor.dom.setStyles(clonedElm,{width:width,height:height});editor.dom.setAttrib(clonedElm,'data-mce-selected',null);var ghostElm=editor.dom.create('div',{'class':'mce-drag-container','data-mce-bogus':'all','unselectable':'on','contenteditable':'false'});editor.dom.setStyles(ghostElm,{position:'absolute',opacity:0.5,overflow:'hidden',border:0,padding:0,margin:0,width:width,height:height});editor.dom.setStyles(clonedElm,{margin:0,boxSizing:'border-box'});ghostElm.appendChild(clonedElm);return ghostElm;};var appendGhostToBody=function appendGhostToBody(ghostElm,bodyElm){if(ghostElm.parentNode!==bodyElm){bodyElm.appendChild(ghostElm);}};var moveGhost=function moveGhost(ghostElm,position,width,height,maxX,maxY){var overflowX=0,overflowY=0;ghostElm.style.left=position.pageX+'px';ghostElm.style.top=position.pageY+'px';if(position.pageX+width>maxX){overflowX=position.pageX+width-maxX;}if(position.pageY+height>maxY){overflowY=position.pageY+height-maxY;}ghostElm.style.width=width-overflowX+'px';ghostElm.style.height=height-overflowY+'px';};var removeElement=function removeElement(elm){if(elm&&elm.parentNode){elm.parentNode.removeChild(elm);}};var isLeftMouseButtonPressed=function isLeftMouseButtonPressed(e){return e.button===0;};var hasDraggableElement=function hasDraggableElement(state){return state.element;};var applyRelPos=function applyRelPos(state,position){return{pageX:position.pageX-state.relX,pageY:position.pageY+5};};var start$1=function start$1(state,editor){return function(e){if(isLeftMouseButtonPressed(e)){var ceElm=$_98exydmjk26xeto.find(editor.dom.getParents(e.target),$_a86i182ljk26xf77.or(isContentEditableFalse$7,isContentEditableTrue$4));if(isDraggable(editor.getBody(),ceElm)){var elmPos=editor.dom.getPos(ceElm);var bodyElm=editor.getBody();var docElm=editor.getDoc().documentElement;state.element=ceElm;state.screenX=e.screenX;state.screenY=e.screenY;state.maxX=(editor.inline?bodyElm.scrollWidth:docElm.offsetWidth)-2;state.maxY=(editor.inline?bodyElm.scrollHeight:docElm.offsetHeight)-2;state.relX=e.pageX-elmPos.x;state.relY=e.pageY-elmPos.y;state.width=ceElm.offsetWidth;state.height=ceElm.offsetHeight;state.ghost=createGhost(editor,ceElm,state.width,state.height);}}};};var move$1=function move$1(state,editor){var throttledPlaceCaretAt=$_3a7ompijk26xer0.throttle(function(clientX,clientY){editor._selectionOverrides.hideFakeCaret();editor.selection.placeCaretAt(clientX,clientY);},0);return function(e){var movement=Math.max(Math.abs(e.screenX-state.screenX),Math.abs(e.screenY-state.screenY));if(hasDraggableElement(state)&&!state.dragging&&movement>10){var args=editor.fire('dragstart',{target:state.element});if(args.isDefaultPrevented()){return;}state.dragging=true;editor.focus();}if(state.dragging){var targetPos=applyRelPos(state,$_4hlb6i5qjk26xfyh.calc(editor,e));appendGhostToBody(state.ghost,editor.getBody());moveGhost(state.ghost,targetPos,state.width,state.height,state.maxX,state.maxY);throttledPlaceCaretAt(e.clientX,e.clientY);}};};var getRawTarget=function getRawTarget(selection){var rng=selection.getSel().getRangeAt(0);var startContainer=rng.startContainer;return startContainer.nodeType===3?startContainer.parentNode:startContainer;};var drop=function drop(state,editor){return function(e){if(state.dragging){if(isValidDropTarget(editor,getRawTarget(editor.selection),state.element)){var targetClone_1=cloneElement(state.element);var args=editor.fire('drop',{targetClone:targetClone_1,clientX:e.clientX,clientY:e.clientY});if(!args.isDefaultPrevented()){targetClone_1=args.targetClone;editor.undoManager.transact(function(){removeElement(state.element);editor.insertContent(editor.dom.getOuterHTML(targetClone_1));editor._selectionOverrides.hideFakeCaret();});}}}removeDragState(state);};};var stop$$1=function stop$$1(state,editor){return function(){if(state.dragging){editor.fire('dragend');}removeDragState(state);};};var removeDragState=function removeDragState(state){state.dragging=false;state.element=null;removeElement(state.ghost);};var bindFakeDragEvents=function bindFakeDragEvents(editor){var state={};var pageDom,dragStartHandler,dragHandler,dropHandler,dragEndHandler,rootDocument;pageDom=DOMUtils$1.DOM;rootDocument=document;dragStartHandler=start$1(state,editor);dragHandler=move$1(state,editor);dropHandler=drop(state,editor);dragEndHandler=stop$$1(state,editor);editor.on('mousedown',dragStartHandler);editor.on('mousemove',dragHandler);editor.on('mouseup',dropHandler);pageDom.bind(rootDocument,'mousemove',dragHandler);pageDom.bind(rootDocument,'mouseup',dragEndHandler);editor.on('remove',function(){pageDom.unbind(rootDocument,'mousemove',dragHandler);pageDom.unbind(rootDocument,'mouseup',dragEndHandler);});};var blockIeDrop=function blockIeDrop(editor){editor.on('drop',function(e){var realTarget=typeof e.clientX!=='undefined'?editor.getDoc().elementFromPoint(e.clientX,e.clientY):null;if(isContentEditableFalse$7(realTarget)||isContentEditableFalse$7(editor.dom.getContentEditableParent(realTarget))){e.preventDefault();}});};var init=function init(editor){bindFakeDragEvents(editor);blockIeDrop(editor);};var $_9bx6fl5pjk26xfy1={init:init};var getNodeClientRects=function getNodeClientRects(node){var toArrayWithNode=function toArrayWithNode(clientRects){return $_98exydmjk26xeto.map(clientRects,function(clientRect){clientRect=clone$2(clientRect);clientRect.node=node;return clientRect;});};if($_fpgwqg1rjk26xf0n.isElement(node)){return toArrayWithNode(node.getClientRects());}if($_fpgwqg1rjk26xf0n.isText(node)){var rng=node.ownerDocument.createRange();rng.setStart(node,0);rng.setEnd(node,node.data.length);return toArrayWithNode(rng.getClientRects());}};var getClientRects=function getClientRects(node){return $_98exydmjk26xeto.reduce(node,function(result,node){return result.concat(getNodeClientRects(node));},[]);};var VDirection;(function(VDirection){VDirection[VDirection['Up']=-1]='Up';VDirection[VDirection['Down']=1]='Down';})(VDirection||(VDirection={}));var findUntil=function findUntil(direction,root,predicateFn,node){while(node=findNode(node,direction,isEditableCaretCandidate,root)){if(predicateFn(node)){return;}}};var walkUntil=function walkUntil(direction,isAboveFn,isBeflowFn,root,predicateFn,caretPosition){var line=0,node;var result=[];var targetClientRect;var add=function add(node){var i,clientRect,clientRects;clientRects=getClientRects([node]);if(direction===-1){clientRects=clientRects.reverse();}for(i=0;i<clientRects.length;i++){clientRect=clientRects[i];if(isBeflowFn(clientRect,targetClientRect)){continue;}if(result.length>0&&isAboveFn(clientRect,$_98exydmjk26xeto.last(result))){line++;}clientRect.line=line;if(predicateFn(clientRect)){return true;}result.push(clientRect);}};targetClientRect=$_98exydmjk26xeto.last(caretPosition.getClientRects());if(!targetClientRect){return result;}node=caretPosition.getNode();add(node);findUntil(direction,root,add,node);return result;};var aboveLineNumber=function aboveLineNumber(lineNumber,clientRect){return clientRect.line>lineNumber;};var isLineNumber=function isLineNumber(lineNumber,clientRect){return clientRect.line===lineNumber;};var upUntil=curry(walkUntil,VDirection.Up,isAbove,isBelow);var downUntil=curry(walkUntil,VDirection.Down,isBelow,isAbove);var positionsUntil=function positionsUntil(direction,root,predicateFn,node){var caretWalker=CaretWalker(root);var walkFn,isBelowFn,isAboveFn,caretPosition;var result=[];var line=0,clientRect,targetClientRect;var getClientRect=function getClientRect(caretPosition){if(direction===1){return $_98exydmjk26xeto.last(caretPosition.getClientRects());}return $_98exydmjk26xeto.last(caretPosition.getClientRects());};if(direction===1){walkFn=caretWalker.next;isBelowFn=isBelow;isAboveFn=isAbove;caretPosition=CaretPosition$1.after(node);}else{walkFn=caretWalker.prev;isBelowFn=isAbove;isAboveFn=isBelow;caretPosition=CaretPosition$1.before(node);}targetClientRect=getClientRect(caretPosition);do{if(!caretPosition.isVisible()){continue;}clientRect=getClientRect(caretPosition);if(isAboveFn(clientRect,targetClientRect)){continue;}if(result.length>0&&isBelowFn(clientRect,$_98exydmjk26xeto.last(result))){line++;}clientRect=clone$2(clientRect);clientRect.position=caretPosition;clientRect.line=line;if(predicateFn(clientRect)){return result;}result.push(clientRect);}while(caretPosition=walkFn(caretPosition));return result;};var isAboveLine=function isAboveLine(lineNumber){return function(clientRect){return aboveLineNumber(lineNumber,clientRect);};};var isLine=function isLine(lineNumber){return function(clientRect){return isLineNumber(lineNumber,clientRect);};};var isContentEditableFalse$8=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var findNode$1=findNode;var distanceToRectLeft=function distanceToRectLeft(clientRect,clientX){return Math.abs(clientRect.left-clientX);};var distanceToRectRight=function distanceToRectRight(clientRect,clientX){return Math.abs(clientRect.right-clientX);};var isInside=function isInside(clientX,clientRect){return clientX>=clientRect.left&&clientX<=clientRect.right;};var findClosestClientRect=function findClosestClientRect(clientRects,clientX){return $_98exydmjk26xeto.reduce(clientRects,function(oldClientRect,clientRect){var oldDistance,newDistance;oldDistance=Math.min(distanceToRectLeft(oldClientRect,clientX),distanceToRectRight(oldClientRect,clientX));newDistance=Math.min(distanceToRectLeft(clientRect,clientX),distanceToRectRight(clientRect,clientX));if(isInside(clientX,clientRect)){return clientRect;}if(isInside(clientX,oldClientRect)){return oldClientRect;}if(newDistance===oldDistance&&isContentEditableFalse$8(clientRect.node)){return clientRect;}if(newDistance<oldDistance){return clientRect;}return oldClientRect;});};var walkUntil$1=function walkUntil$1(direction,root,predicateFn,node){while(node=findNode$1(node,direction,isEditableCaretCandidate,root)){if(predicateFn(node)){return;}}};var findLineNodeRects=function findLineNodeRects(root,targetNodeRect){var clientRects=[];var collect=function collect(checkPosFn,node){var lineRects;lineRects=$_98exydmjk26xeto.filter(getClientRects([node]),function(clientRect){return!checkPosFn(clientRect,targetNodeRect);});clientRects=clientRects.concat(lineRects);return lineRects.length===0;};clientRects.push(targetNodeRect);walkUntil$1(VDirection.Up,root,curry(collect,isAbove),targetNodeRect.node);walkUntil$1(VDirection.Down,root,curry(collect,isBelow),targetNodeRect.node);return clientRects;};var getFakeCaretTargets=function getFakeCaretTargets(root){return $_98exydmjk26xeto.filter($_98exydmjk26xeto.toArray(root.getElementsByTagName('*')),isFakeCaretTarget);};var caretInfo=function caretInfo(clientRect,clientX){return{node:clientRect.node,before:distanceToRectLeft(clientRect,clientX)<distanceToRectRight(clientRect,clientX)};};var closestCaret=function closestCaret(root,clientX,clientY){var closestNodeRect;var contentEditableFalseNodeRects=getClientRects(getFakeCaretTargets(root));var targetNodeRects=$_98exydmjk26xeto.filter(contentEditableFalseNodeRects,function(rect){return clientY>=rect.top&&clientY<=rect.bottom;});closestNodeRect=findClosestClientRect(targetNodeRects,clientX);if(closestNodeRect){closestNodeRect=findClosestClientRect(findLineNodeRects(root,closestNodeRect),clientX);if(closestNodeRect&&isFakeCaretTarget(closestNodeRect.node)){return caretInfo(closestNodeRect,clientX);}}return null;};var isXYWithinRange=function isXYWithinRange(clientX,clientY,range$$1){if(range$$1.collapsed){return false;}return foldl(range$$1.getClientRects(),function(state,rect){return state||containsXY(rect,clientX,clientY);},false);};var $_5vc3d45ujk26xfyx={isXYWithinRange:isXYWithinRange};var setup$3=function setup$3(editor){var renderFocusCaret=first$1(function(){if(!editor.removed){var rng=editor.selection.getRng();if(rng.collapsed){var caretRange=renderRangeCaret(editor,editor.selection.getRng(),false);editor.selection.setRng(caretRange);}}},0);editor.on('focus',function(){renderFocusCaret.throttle();});editor.on('blur',function(){renderFocusCaret.cancel();});};var $_at4wgg5vjk26xfz0={setup:setup$3};var $_o3p025wjk26xfz2={BACKSPACE:8,DELETE:46,DOWN:40,ENTER:13,LEFT:37,RIGHT:39,SPACEBAR:32,TAB:9,UP:38,modifierPressed:function modifierPressed(e){return e.shiftKey||e.ctrlKey||e.altKey||this.metaKeyPressed(e);},metaKeyPressed:function metaKeyPressed(e){return $_ef6mqpajk26xejm.mac?e.metaKey:e.ctrlKey&&!e.altKey;}};var isContentEditableTrue$5=$_fpgwqg1rjk26xf0n.isContentEditableTrue;var isContentEditableFalse$9=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isAfterContentEditableFalse$1=isAfterContentEditableFalse;var isBeforeContentEditableFalse$1=isBeforeContentEditableFalse;var getContentEditableRoot$1=function getContentEditableRoot$1(editor,node){var root=editor.getBody();while(node&&node!==root){if(isContentEditableTrue$5(node)||isContentEditableFalse$9(node)){return node;}node=node.parentNode;}return null;};var SelectionOverrides=function SelectionOverrides(editor){var isBlock=function isBlock(node){return editor.dom.isBlock(node);};var rootNode=editor.getBody();var fakeCaret=FakeCaret(editor.getBody(),isBlock,function(){return $_3hu41a4vjk26xfsm.hasFocus(editor);});var realSelectionId='sel-'+editor.dom.uniqueId();var selectedContentEditableNode;var isFakeSelectionElement=function isFakeSelectionElement(elm){return editor.dom.hasClass(elm,'mce-offscreen-selection');};var getRealSelectionElement=function getRealSelectionElement(){var container=editor.dom.get(realSelectionId);return container?container.getElementsByTagName('*')[0]:container;};var setRange=function setRange(range$$1){if(range$$1){editor.selection.setRng(range$$1);}};var getRange=function getRange(){return editor.selection.getRng();};var showCaret$$1=function showCaret$$1(direction,node,before,scrollIntoView){if(scrollIntoView===void 0){scrollIntoView=true;}var e;e=editor.fire('ShowCaret',{target:node,direction:direction,before:before});if(e.isDefaultPrevented()){return null;}if(scrollIntoView){editor.selection.scrollIntoView(node,direction===-1);}return fakeCaret.show(before,node);};var getNormalizedRangeEndPoint$$1=function getNormalizedRangeEndPoint$$1(direction,range$$1){range$$1=normalizeRange(direction,rootNode,range$$1);if(direction===-1){return CaretPosition$1.fromRangeStart(range$$1);}return CaretPosition$1.fromRangeEnd(range$$1);};var showBlockCaretContainer=function showBlockCaretContainer(blockCaretContainer){if(blockCaretContainer.hasAttribute('data-mce-caret')){showCaretContainerBlock(blockCaretContainer);setRange(getRange());editor.selection.scrollIntoView(blockCaretContainer[0]);}};var registerEvents=function registerEvents(){editor.on('mouseup',function(e){var range$$1=getRange();if(range$$1.collapsed&&$_e6lkbw50jk26xftn.isXYInContentArea(editor,e.clientX,e.clientY)){setRange(renderCaretAtRange(editor,range$$1,false));}});editor.on('click',function(e){var contentEditableRoot;contentEditableRoot=getContentEditableRoot$1(editor,e.target);if(contentEditableRoot){if(isContentEditableFalse$9(contentEditableRoot)){e.preventDefault();editor.focus();}if(isContentEditableTrue$5(contentEditableRoot)){if(editor.dom.isChildOf(contentEditableRoot,editor.selection.getNode())){removeContentEditableSelection();}}}});editor.on('blur NewBlock',function(){removeContentEditableSelection();});editor.on('ResizeWindow FullscreenStateChanged',function(){return fakeCaret.reposition();});var handleTouchSelect=function handleTouchSelect(editor){var moved=false;editor.on('touchstart',function(){moved=false;});editor.on('touchmove',function(){moved=true;});editor.on('touchend',function(e){var contentEditableRoot=getContentEditableRoot$1(editor,e.target);if(isContentEditableFalse$9(contentEditableRoot)){if(!moved){e.preventDefault();setContentEditableSelection(selectNode(editor,contentEditableRoot));}}});};var hasNormalCaretPosition=function hasNormalCaretPosition(elm){var caretWalker=CaretWalker(elm);if(!elm.firstChild){return false;}var startPos=CaretPosition$1.before(elm.firstChild);var newPos=caretWalker.next(startPos);return newPos&&!isBeforeContentEditableFalse$1(newPos)&&!isAfterContentEditableFalse$1(newPos);};var isInSameBlock$$1=function isInSameBlock$$1(node1,node2){var block1=editor.dom.getParent(node1,editor.dom.isBlock);var block2=editor.dom.getParent(node2,editor.dom.isBlock);return block1===block2;};var hasBetterMouseTarget=function hasBetterMouseTarget(targetNode,caretNode){var targetBlock=editor.dom.getParent(targetNode,editor.dom.isBlock);var caretBlock=editor.dom.getParent(caretNode,editor.dom.isBlock);if(targetBlock&&editor.dom.isChildOf(targetBlock,caretBlock)&&isContentEditableFalse$9(getContentEditableRoot$1(editor,targetBlock))===false){return true;}return targetBlock&&!isInSameBlock$$1(targetBlock,caretBlock)&&hasNormalCaretPosition(targetBlock);};handleTouchSelect(editor);editor.on('mousedown',function(e){var contentEditableRoot;var targetElm=e.target;if(targetElm!==rootNode&&targetElm.nodeName!=='HTML'&&!editor.dom.isChildOf(targetElm,rootNode)){return;}if($_e6lkbw50jk26xftn.isXYInContentArea(editor,e.clientX,e.clientY)===false){return;}contentEditableRoot=getContentEditableRoot$1(editor,targetElm);if(contentEditableRoot){if(isContentEditableFalse$9(contentEditableRoot)){e.preventDefault();setContentEditableSelection(selectNode(editor,contentEditableRoot));}else{removeContentEditableSelection();if(!(isContentEditableTrue$5(contentEditableRoot)&&e.shiftKey)&&!$_5vc3d45ujk26xfyx.isXYWithinRange(e.clientX,e.clientY,editor.selection.getRng())){hideFakeCaret();editor.selection.placeCaretAt(e.clientX,e.clientY);}}}else if(isFakeCaretTarget(targetElm)===false){removeContentEditableSelection();hideFakeCaret();var caretInfo=closestCaret(rootNode,e.clientX,e.clientY);if(caretInfo){if(!hasBetterMouseTarget(e.target,caretInfo.node)){e.preventDefault();var range$$1=showCaret$$1(1,caretInfo.node,caretInfo.before,false);editor.getBody().focus();setRange(range$$1);}}}});editor.on('keypress',function(e){if($_o3p025wjk26xfz2.modifierPressed(e)){return;}switch(e.keyCode){default:if(isContentEditableFalse$9(editor.selection.getNode())){e.preventDefault();}break;}});editor.on('getSelectionRange',function(e){var rng=e.range;if(selectedContentEditableNode){if(!selectedContentEditableNode.parentNode){selectedContentEditableNode=null;return;}rng=rng.cloneRange();rng.selectNode(selectedContentEditableNode);e.range=rng;}});editor.on('setSelectionRange',function(e){var rng;rng=setContentEditableSelection(e.range,e.forward);if(rng){e.range=rng;}});var isPasteBin=function isPasteBin(node){return node.id==='mcepastebin';};editor.on('AfterSetSelectionRange',function(e){var rng=e.range;if(!isRangeInCaretContainer(rng)&&!isPasteBin(rng.startContainer.parentNode)){hideFakeCaret();}if(!isFakeSelectionElement(rng.startContainer.parentNode)){removeContentEditableSelection();}});editor.on('copy',function(e){var clipboardData=e.clipboardData;if(!e.isDefaultPrevented()&&e.clipboardData&&!$_ef6mqpajk26xejm.ie){var realSelectionElement=getRealSelectionElement();if(realSelectionElement){e.preventDefault();clipboardData.clearData();clipboardData.setData('text/html',realSelectionElement.outerHTML);clipboardData.setData('text/plain',realSelectionElement.outerText);}}});$_9bx6fl5pjk26xfy1.init(editor);$_at4wgg5vjk26xfz0.setup(editor);};var addCss=function addCss(){var styles=editor.contentStyles,rootClass='.mce-content-body';styles.push(fakeCaret.getCss());styles.push(rootClass+' .mce-offscreen-selection {'+'position: absolute;'+'left: -9999999999px;'+'max-width: 1000000px;'+'}'+rootClass+' *[contentEditable=false] {'+'cursor: default;'+'}'+rootClass+' *[contentEditable=true] {'+'cursor: text;'+'}');};var isWithinCaretContainer=function isWithinCaretContainer(node){return isCaretContainer(node)||startsWithCaretContainer(node)||endsWithCaretContainer(node);};var isRangeInCaretContainer=function isRangeInCaretContainer(rng){return isWithinCaretContainer(rng.startContainer)||isWithinCaretContainer(rng.endContainer);};var setContentEditableSelection=function setContentEditableSelection(range$$1,forward){var node;var $=editor.$;var dom=editor.dom;var $realSelectionContainer,sel,startContainer,startOffset,endOffset,e,caretPosition,targetClone,origTargetClone;if(!range$$1){return null;}if(range$$1.collapsed){if(!isRangeInCaretContainer(range$$1)){if(forward===false){caretPosition=getNormalizedRangeEndPoint$$1(-1,range$$1);if(isFakeCaretTarget(caretPosition.getNode(true))){return showCaret$$1(-1,caretPosition.getNode(true),false,false);}if(isFakeCaretTarget(caretPosition.getNode())){return showCaret$$1(-1,caretPosition.getNode(),!caretPosition.isAtEnd(),false);}}else{caretPosition=getNormalizedRangeEndPoint$$1(1,range$$1);if(isFakeCaretTarget(caretPosition.getNode())){return showCaret$$1(1,caretPosition.getNode(),!caretPosition.isAtEnd(),false);}if(isFakeCaretTarget(caretPosition.getNode(true))){return showCaret$$1(1,caretPosition.getNode(true),false,false);}}}return null;}startContainer=range$$1.startContainer;startOffset=range$$1.startOffset;endOffset=range$$1.endOffset;if(startContainer.nodeType===3&&startOffset===0&&isContentEditableFalse$9(startContainer.parentNode)){startContainer=startContainer.parentNode;startOffset=dom.nodeIndex(startContainer);startContainer=startContainer.parentNode;}if(startContainer.nodeType!==1){return null;}if(endOffset===startOffset+1){node=startContainer.childNodes[startOffset];}if(!isContentEditableFalse$9(node)){return null;}targetClone=origTargetClone=node.cloneNode(true);e=editor.fire('ObjectSelected',{target:node,targetClone:targetClone});if(e.isDefaultPrevented()){return null;}$realSelectionContainer=$_dbgjqa29jk26xf4u.descendant(Element$$1.fromDom(editor.getBody()),'#'+realSelectionId).fold(function(){return $([]);},function(elm){return $([elm.dom()]);});targetClone=e.targetClone;if($realSelectionContainer.length===0){$realSelectionContainer=$('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id',realSelectionId);$realSelectionContainer.appendTo(editor.getBody());}range$$1=editor.dom.createRng();if(targetClone===origTargetClone&&$_ef6mqpajk26xejm.ie){$realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);range$$1.setStartAfter($realSelectionContainer[0].firstChild.firstChild);range$$1.setEndAfter(targetClone);}else{$realSelectionContainer.empty().append('\xA0').append(targetClone).append('\xA0');range$$1.setStart($realSelectionContainer[0].firstChild,1);range$$1.setEnd($realSelectionContainer[0].lastChild,0);}$realSelectionContainer.css({top:dom.getPos(node,editor.getBody()).y});$realSelectionContainer[0].focus();sel=editor.selection.getSel();sel.removeAllRanges();sel.addRange(range$$1);each($_bisgdu27jk26xf4o.descendants(Element$$1.fromDom(editor.getBody()),'*[data-mce-selected]'),function(elm){$_5xapbx15jk26xewz.remove(elm,'data-mce-selected');});node.setAttribute('data-mce-selected','1');selectedContentEditableNode=node;hideFakeCaret();return range$$1;};var removeContentEditableSelection=function removeContentEditableSelection(){if(selectedContentEditableNode){selectedContentEditableNode.removeAttribute('data-mce-selected');$_dbgjqa29jk26xf4u.descendant(Element$$1.fromDom(editor.getBody()),'#'+realSelectionId).each($_5ur14v1wjk26xf2q.remove);selectedContentEditableNode=null;}$_dbgjqa29jk26xf4u.descendant(Element$$1.fromDom(editor.getBody()),'#'+realSelectionId).each($_5ur14v1wjk26xf2q.remove);selectedContentEditableNode=null;};var destroy=function destroy(){fakeCaret.destroy();selectedContentEditableNode=null;};var hideFakeCaret=function hideFakeCaret(){fakeCaret.hide();};if($_ef6mqpajk26xejm.ceFalse){registerEvents();addCss();}return{showCaret:showCaret$$1,showBlockCaretContainer:showBlockCaretContainer,hideFakeCaret:hideFakeCaret,destroy:destroy};};var isValidPrefixAttrName=function isValidPrefixAttrName(name){return name.indexOf('data-')===0||name.indexOf('aria-')===0;};var trimComments=function trimComments(text){return text.replace(/<!--|-->/g,'');};var isInvalidUri=function isInvalidUri(settings,uri){if(settings.allow_html_data_urls){return false;}else if(/^data:image\//i.test(uri)){return settings.allow_svg_data_urls===false&&/^data:image\/svg\+xml/i.test(uri);}else{return /^data:/i.test(uri);}};var findEndTagIndex=function findEndTagIndex(schema,html,startIndex){var count=1,index,matches,tokenRegExp,shortEndedElements;shortEndedElements=schema.getShortEndedElements();tokenRegExp=/<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;tokenRegExp.lastIndex=index=startIndex;while(matches=tokenRegExp.exec(html)){index=tokenRegExp.lastIndex;if(matches[1]==='/'){count--;}else if(!matches[1]){if(matches[2]in shortEndedElements){continue;}count++;}if(count===0){break;}}return index;};function SaxParser(settings,schema){if(schema===void 0){schema=Schema();}var noop=function noop(){};settings=settings||{};if(settings.fix_self_closing!==false){settings.fix_self_closing=true;}var comment=settings.comment?settings.comment:noop;var cdata=settings.cdata?settings.cdata:noop;var text=settings.text?settings.text:noop;var start=settings.start?settings.start:noop;var end=settings.end?settings.end:noop;var pi=settings.pi?settings.pi:noop;var doctype=settings.doctype?settings.doctype:noop;var parse=function parse(html){var matches,index=0,value,endRegExp;var stack=[];var attrList,i,textData,name;var isInternalElement,removeInternalElements,shortEndedElements,fillAttrsMap,isShortEnded;var validate,elementRule,isValidElement,attr,attribsValue,validAttributesMap,validAttributePatterns;var attributesRequired,attributesDefault,attributesForced,processHtml;var anyAttributesRequired,selfClosing,tokenRegExp,attrRegExp,specialElements,attrValue,idCount=0;var decode=$_8udjtn1sjk26xf0t.decode;var fixSelfClosing;var filteredUrlAttrs=$_2ytxahljk26xetf.makeMap('src,href,data,background,formaction,poster,xlink:href');var scriptUriRegExp=/((java|vb)script|mhtml):/i;var processEndTag=function processEndTag(name){var pos,i;pos=stack.length;while(pos--){if(stack[pos].name===name){break;}}if(pos>=0){for(i=stack.length-1;i>=pos;i--){name=stack[i];if(name.valid){end(name.name);}}stack.length=pos;}};var parseAttribute=function parseAttribute(match,name,value,val2,val3){var attrRule,i;var trimRegExp=/[\s\u0000-\u001F]+/g;name=name.toLowerCase();value=name in fillAttrsMap?name:decode(value||val2||val3||'');if(validate&&!isInternalElement&&isValidPrefixAttrName(name)===false){attrRule=validAttributesMap[name];if(!attrRule&&validAttributePatterns){i=validAttributePatterns.length;while(i--){attrRule=validAttributePatterns[i];if(attrRule.pattern.test(name)){break;}}if(i===-1){attrRule=null;}}if(!attrRule){return;}if(attrRule.validValues&&!(value in attrRule.validValues)){return;}}if(filteredUrlAttrs[name]&&!settings.allow_script_urls){var uri=value.replace(trimRegExp,'');try{uri=decodeURIComponent(uri);}catch(ex){uri=unescape(uri);}if(scriptUriRegExp.test(uri)){return;}if(isInvalidUri(settings,uri)){return;}}if(isInternalElement&&(name in filteredUrlAttrs||name.indexOf('on')===0)){return;}attrList.map[name]=value;attrList.push({name:name,value:value});};tokenRegExp=new RegExp('<(?:'+'(?:!--([\\w\\W]*?)-->)|'+'(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|'+'(?:!DOCTYPE([\\w\\W]*?)>)|'+'(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|'+'(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|'+'(?:([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)'+')','g');attrRegExp=/([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;shortEndedElements=schema.getShortEndedElements();selfClosing=settings.self_closing_elements||schema.getSelfClosingElements();fillAttrsMap=schema.getBoolAttrs();validate=settings.validate;removeInternalElements=settings.remove_internals;fixSelfClosing=settings.fix_self_closing;specialElements=schema.getSpecialElements();processHtml=html+'>';while(matches=tokenRegExp.exec(processHtml)){if(index<matches.index){text(decode(html.substr(index,matches.index-index)));}if(value=matches[6]){value=value.toLowerCase();if(value.charAt(0)===':'){value=value.substr(1);}processEndTag(value);}else if(value=matches[7]){if(matches.index+matches[0].length>html.length){text(decode(html.substr(matches.index)));index=matches.index+matches[0].length;continue;}value=value.toLowerCase();if(value.charAt(0)===':'){value=value.substr(1);}isShortEnded=value in shortEndedElements;if(fixSelfClosing&&selfClosing[value]&&stack.length>0&&stack[stack.length-1].name===value){processEndTag(value);}if(!validate||(elementRule=schema.getElementRule(value))){isValidElement=true;if(validate){validAttributesMap=elementRule.attributes;validAttributePatterns=elementRule.attributePatterns;}if(attribsValue=matches[8]){isInternalElement=attribsValue.indexOf('data-mce-type')!==-1;if(isInternalElement&&removeInternalElements){isValidElement=false;}attrList=[];attrList.map={};attribsValue.replace(attrRegExp,parseAttribute);}else{attrList=[];attrList.map={};}if(validate&&!isInternalElement){attributesRequired=elementRule.attributesRequired;attributesDefault=elementRule.attributesDefault;attributesForced=elementRule.attributesForced;anyAttributesRequired=elementRule.removeEmptyAttrs;if(anyAttributesRequired&&!attrList.length){isValidElement=false;}if(attributesForced){i=attributesForced.length;while(i--){attr=attributesForced[i];name=attr.name;attrValue=attr.value;if(attrValue==='{$uid}'){attrValue='mce_'+idCount++;}attrList.map[name]=attrValue;attrList.push({name:name,value:attrValue});}}if(attributesDefault){i=attributesDefault.length;while(i--){attr=attributesDefault[i];name=attr.name;if(!(name in attrList.map)){attrValue=attr.value;if(attrValue==='{$uid}'){attrValue='mce_'+idCount++;}attrList.map[name]=attrValue;attrList.push({name:name,value:attrValue});}}}if(attributesRequired){i=attributesRequired.length;while(i--){if(attributesRequired[i]in attrList.map){break;}}if(i===-1){isValidElement=false;}}if(attr=attrList.map['data-mce-bogus']){if(attr==='all'){index=findEndTagIndex(schema,html,tokenRegExp.lastIndex);tokenRegExp.lastIndex=index;continue;}isValidElement=false;}}if(isValidElement){start(value,attrList,isShortEnded);}}else{isValidElement=false;}if(endRegExp=specialElements[value]){endRegExp.lastIndex=index=matches.index+matches[0].length;if(matches=endRegExp.exec(html)){if(isValidElement){textData=html.substr(index,matches.index-index);}index=matches.index+matches[0].length;}else{textData=html.substr(index);index=html.length;}if(isValidElement){if(textData.length>0){text(textData,true);}end(value);}tokenRegExp.lastIndex=index;continue;}if(!isShortEnded){if(!attribsValue||attribsValue.indexOf('/')!==attribsValue.length-1){stack.push({name:value,valid:isValidElement});}else if(isValidElement){end(value);}}}else if(value=matches[1]){if(value.charAt(0)==='>'){value=' '+value;}if(!settings.allow_conditional_comments&&value.substr(0,3).toLowerCase()==='[if'){value=' '+value;}comment(value);}else if(value=matches[2]){cdata(trimComments(value));}else if(value=matches[3]){doctype(value);}else if(value=matches[4]){pi(value,matches[5]);}index=matches.index+matches[0].length;}if(index<html.length){text(decode(html.substr(index)));}for(i=stack.length-1;i>=0;i--){value=stack[i];if(value.valid){end(value.name);}}};return{parse:parse};}(function(SaxParser){SaxParser.findEndTag=findEndTagIndex;})(SaxParser||(SaxParser={}));var SaxParser$1=SaxParser;var trimHtml=function trimHtml(tempAttrs,html){var trimContentRegExp=new RegExp(['\\s?('+tempAttrs.join('|')+')="[^"]+"'].join('|'),'gi');return html.replace(trimContentRegExp,'');};var trimInternal=function trimInternal(serializer,html){var content=html;var bogusAllRegExp=/<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;var endTagIndex,index,matchLength,matches,shortEndedElements;var schema=serializer.schema;content=trimHtml(serializer.getTempAttrs(),content);shortEndedElements=schema.getShortEndedElements();while(matches=bogusAllRegExp.exec(content)){index=bogusAllRegExp.lastIndex;matchLength=matches[0].length;if(shortEndedElements[matches[1]]){endTagIndex=index;}else{endTagIndex=SaxParser$1.findEndTag(schema,content,index);}content=content.substring(0,index-matchLength)+content.substring(endTagIndex);bogusAllRegExp.lastIndex=index-matchLength;}return $_4osibw2pjk26xf83.trim(content);};var trimExternal=trimInternal;var $_22a2nj5zjk26xfzo={trimExternal:trimExternal,trimInternal:trimInternal};var KEEP=0;var INSERT=1;var DELETE=2;var diff=function diff(left,right){var size=left.length+right.length+2;var vDown=new Array(size);var vUp=new Array(size);var snake=function snake(start,end,diag){return{start:start,end:end,diag:diag};};var buildScript=function buildScript(start1,end1,start2,end2,script){var middle=getMiddleSnake(start1,end1,start2,end2);if(middle===null||middle.start===end1&&middle.diag===end1-end2||middle.end===start1&&middle.diag===start1-start2){var i=start1;var j=start2;while(i<end1||j<end2){if(i<end1&&j<end2&&left[i]===right[j]){script.push([KEEP,left[i]]);++i;++j;}else{if(end1-start1>end2-start2){script.push([DELETE,left[i]]);++i;}else{script.push([INSERT,right[j]]);++j;}}}}else{buildScript(start1,middle.start,start2,middle.start-middle.diag,script);for(var i2=middle.start;i2<middle.end;++i2){script.push([KEEP,left[i2]]);}buildScript(middle.end,end1,middle.end-middle.diag,end2,script);}};var buildSnake=function buildSnake(start,diag,end1,end2){var end=start;while(end-diag<end2&&end<end1&&left[end]===right[end-diag]){++end;}return snake(start,end,diag);};var getMiddleSnake=function getMiddleSnake(start1,end1,start2,end2){var m=end1-start1;var n=end2-start2;if(m===0||n===0){return null;}var delta=m-n;var sum=n+m;var offset=(sum%2===0?sum:sum+1)/2;vDown[1+offset]=start1;vUp[1+offset]=end1+1;var d,k,i,x,y;for(d=0;d<=offset;++d){for(k=-d;k<=d;k+=2){i=k+offset;if(k===-d||k!==d&&vDown[i-1]<vDown[i+1]){vDown[i]=vDown[i+1];}else{vDown[i]=vDown[i-1]+1;}x=vDown[i];y=x-start1+start2-k;while(x<end1&&y<end2&&left[x]===right[y]){vDown[i]=++x;++y;}if(delta%2!==0&&delta-d<=k&&k<=delta+d){if(vUp[i-delta]<=vDown[i]){return buildSnake(vUp[i-delta],k+start1-start2,end1,end2);}}}for(k=delta-d;k<=delta+d;k+=2){i=k+offset-delta;if(k===delta-d||k!==delta+d&&vUp[i+1]<=vUp[i-1]){vUp[i]=vUp[i+1]-1;}else{vUp[i]=vUp[i-1];}x=vUp[i]-1;y=x-start1+start2-k;while(x>=start1&&y>=start2&&left[x]===right[y]){vUp[i]=x--;y--;}if(delta%2===0&&-d<=k&&k<=d){if(vUp[i]<=vDown[i+delta]){return buildSnake(vUp[i],k+start1-start2,end1,end2);}}}}};var script=[];buildScript(0,left.length,0,right.length,script);return script;};var $_474f6k62jk26xg07={KEEP:KEEP,DELETE:DELETE,INSERT:INSERT,diff:diff};var getOuterHtml=function getOuterHtml(elm){if($_fpgwqg1rjk26xf0n.isElement(elm)){return elm.outerHTML;}else if($_fpgwqg1rjk26xf0n.isText(elm)){return $_8udjtn1sjk26xf0t.encodeRaw(elm.data,false);}else if($_fpgwqg1rjk26xf0n.isComment(elm)){return'<!--'+elm.data+'-->';}return'';};var createFragment$1=function createFragment$1(html){var frag,node,container;container=document.createElement('div');frag=document.createDocumentFragment();if(html){container.innerHTML=html;}while(node=container.firstChild){frag.appendChild(node);}return frag;};var insertAt=function insertAt(elm,html,index){var fragment=createFragment$1(html);if(elm.hasChildNodes()&&index<elm.childNodes.length){var target=elm.childNodes[index];target.parentNode.insertBefore(fragment,target);}else{elm.appendChild(fragment);}};var removeAt=function removeAt(elm,index){if(elm.hasChildNodes()&&index<elm.childNodes.length){var target=elm.childNodes[index];target.parentNode.removeChild(target);}};var applyDiff=function applyDiff(diff,elm){var index=0;$_98exydmjk26xeto.each(diff,function(action){if(action[0]===$_474f6k62jk26xg07.KEEP){index++;}else if(action[0]===$_474f6k62jk26xg07.INSERT){insertAt(elm,action[1],index);index++;}else if(action[0]===$_474f6k62jk26xg07.DELETE){removeAt(elm,index);}});};var read$3=function read$3(elm){return $_98exydmjk26xeto.filter($_98exydmjk26xeto.map(elm.childNodes,getOuterHtml),function(item){return item.length>0;});};var write=function write(fragments,elm){var currentFragments=$_98exydmjk26xeto.map(elm.childNodes,getOuterHtml);applyDiff($_474f6k62jk26xg07.diff(currentFragments,fragments),elm);return elm;};var $_aotplp61jk26xg02={read:read$3,write:write};var fromHtml$1=function fromHtml$1(html,scope){var doc=scope||document;var div=doc.createElement('div');div.innerHTML=html;return $_2i1q6518jk26xexk.children(Element$$1.fromDom(div));};var fromTags=function fromTags(tags,scope){return map(tags,function(x){return Element$$1.fromTag(x,scope);});};var fromText$1=function fromText$1(texts,scope){return map(texts,function(x){return Element$$1.fromText(x,scope);});};var fromDom$1=function fromDom$1(nodes){return map(nodes,Element$$1.fromDom);};var $_5j11e264jk26xg0p={fromHtml:fromHtml$1,fromTags:fromTags,fromText:fromText$1,fromDom:fromDom$1};var get$6=function get$6(element){return element.dom().innerHTML;};var set$3=function set$3(element,content){var owner=$_2i1q6518jk26xexk.owner(element);var docDom=owner.dom();var fragment=Element$$1.fromDom(docDom.createDocumentFragment());var contentElements=$_5j11e264jk26xg0p.fromHtml(content,docDom);$_2ykrq21xjk26xf2x.append(fragment,contentElements);$_5ur14v1wjk26xf2q.empty(element);$_9t36rc1yjk26xf33.append(element,fragment);};var getOuter=function getOuter(element){var container=Element$$1.fromTag('div');var clone=Element$$1.fromDom(element.dom().cloneNode(true));$_9t36rc1yjk26xf33.append(container,clone);return get$6(container);};var $_586q8i63jk26xg0m={get:get$6,set:set$3,getOuter:getOuter};var undoLevelDocument=Cell(Option.none());var lazyTempDocument=function lazyTempDocument(){return undoLevelDocument.get().getOrThunk(function(){var doc=document.implementation.createHTMLDocument('undo');undoLevelDocument.set(Option.some(doc));return doc;});};var hasIframes=function hasIframes(html){return html.indexOf('</iframe>')!==-1;};var createFragmentedLevel=function createFragmentedLevel(fragments){return{type:'fragmented',fragments:fragments,content:'',bookmark:null,beforeBookmark:null};};var createCompleteLevel=function createCompleteLevel(content){return{type:'complete',fragments:null,content:content,bookmark:null,beforeBookmark:null};};var createFromEditor=function createFromEditor(editor){var fragments,content,trimmedFragments;fragments=$_aotplp61jk26xg02.read(editor.getBody());trimmedFragments=bind(fragments,function(html){var trimmed=$_22a2nj5zjk26xfzo.trimInternal(editor.serializer,html);return trimmed.length>0?[trimmed]:[];});content=trimmedFragments.join('');return hasIframes(content)?createFragmentedLevel(trimmedFragments):createCompleteLevel(content);};var applyToEditor=function applyToEditor(editor,level,before){if(level.type==='fragmented'){$_aotplp61jk26xg02.write(level.fragments,editor.getBody());}else{editor.setContent(level.content,{format:'raw'});}editor.selection.moveToBookmark(before?level.beforeBookmark:level.bookmark);};var getLevelContent=function getLevelContent(level){return level.type==='fragmented'?level.fragments.join(''):level.content;};var getCleanLevelContent=function getCleanLevelContent(level){var elm=Element$$1.fromTag('body',lazyTempDocument());$_586q8i63jk26xg0m.set(elm,getLevelContent(level));each($_bisgdu27jk26xf4o.descendants(elm,'*[data-mce-bogus]'),$_5ur14v1wjk26xf2q.unwrap);return $_586q8i63jk26xg0m.get(elm);};var hasEqualContent=function hasEqualContent(level1,level2){return getLevelContent(level1)===getLevelContent(level2);};var hasEqualCleanedContent=function hasEqualCleanedContent(level1,level2){return getCleanLevelContent(level1)===getCleanLevelContent(level2);};var isEq$3=function isEq$3(level1,level2){if(!level1||!level2){return false;}else if(hasEqualContent(level1,level2)){return true;}else{return hasEqualCleanedContent(level1,level2);}};var $_d2n2uu5yjk26xfzc={createFragmentedLevel:createFragmentedLevel,createCompleteLevel:createCompleteLevel,createFromEditor:createFromEditor,applyToEditor:applyToEditor,isEq:isEq$3};function UndoManager(editor){var self=this,index=0,data=[],beforeBookmark,isFirstTypedCharacter,locks=0;var isUnlocked=function isUnlocked(){return locks===0;};var setTyping=function setTyping(typing){if(isUnlocked()){self.typing=typing;}};var setDirty=function setDirty(state){editor.setDirty(state);};var addNonTypingUndoLevel=function addNonTypingUndoLevel(e){setTyping(false);self.add({},e);};var endTyping=function endTyping(){if(self.typing){setTyping(false);self.add();}};editor.on('init',function(){self.add();});editor.on('BeforeExecCommand',function(e){var cmd=e.command;if(cmd!=='Undo'&&cmd!=='Redo'&&cmd!=='mceRepaint'){endTyping();self.beforeChange();}});editor.on('ExecCommand',function(e){var cmd=e.command;if(cmd!=='Undo'&&cmd!=='Redo'&&cmd!=='mceRepaint'){addNonTypingUndoLevel(e);}});editor.on('ObjectResizeStart Cut',function(){self.beforeChange();});editor.on('SaveContent ObjectResized blur',addNonTypingUndoLevel);editor.on('DragEnd',addNonTypingUndoLevel);editor.on('KeyUp',function(e){var keyCode=e.keyCode;if(e.isDefaultPrevented()){return;}if(keyCode>=33&&keyCode<=36||keyCode>=37&&keyCode<=40||keyCode===45||e.ctrlKey){addNonTypingUndoLevel();editor.nodeChanged();}if(keyCode===46||keyCode===8){editor.nodeChanged();}if(isFirstTypedCharacter&&self.typing&&$_d2n2uu5yjk26xfzc.isEq($_d2n2uu5yjk26xfzc.createFromEditor(editor),data[0])===false){if(editor.isDirty()===false){setDirty(true);editor.fire('change',{level:data[0],lastLevel:null});}editor.fire('TypingUndo');isFirstTypedCharacter=false;editor.nodeChanged();}});editor.on('KeyDown',function(e){var keyCode=e.keyCode;if(e.isDefaultPrevented()){return;}if(keyCode>=33&&keyCode<=36||keyCode>=37&&keyCode<=40||keyCode===45){if(self.typing){addNonTypingUndoLevel(e);}return;}var modKey=e.ctrlKey&&!e.altKey||e.metaKey;if((keyCode<16||keyCode>20)&&keyCode!==224&&keyCode!==91&&!self.typing&&!modKey){self.beforeChange();setTyping(true);self.add({},e);isFirstTypedCharacter=true;}});editor.on('MouseDown',function(e){if(self.typing){addNonTypingUndoLevel(e);}});var isInsertReplacementText=function isInsertReplacementText(event){return event.inputType==='insertReplacementText';};var isInsertTextDataNull=function isInsertTextDataNull(event){return event.inputType==='insertText'&&event.data===null;};editor.on('input',function(e){if(e.inputType&&(isInsertReplacementText(e)||isInsertTextDataNull(e))){addNonTypingUndoLevel(e);}});editor.addShortcut('meta+z','','Undo');editor.addShortcut('meta+y,meta+shift+z','','Redo');editor.on('AddUndo Undo Redo ClearUndos',function(e){if(!e.isDefaultPrevented()){editor.nodeChanged();}});self={data:data,typing:false,beforeChange:function beforeChange(){if(isUnlocked()){beforeBookmark=$_ci8rza2jjk26xf6s.getUndoBookmark(editor.selection);}},add:function add(level,event){var i;var settings=editor.settings;var lastLevel,currentLevel;currentLevel=$_d2n2uu5yjk26xfzc.createFromEditor(editor);level=level||{};level=$_2ytxahljk26xetf.extend(level,currentLevel);if(isUnlocked()===false||editor.removed){return null;}lastLevel=data[index];if(editor.fire('BeforeAddUndo',{level:level,lastLevel:lastLevel,originalEvent:event}).isDefaultPrevented()){return null;}if(lastLevel&&$_d2n2uu5yjk26xfzc.isEq(lastLevel,level)){return null;}if(data[index]){data[index].beforeBookmark=beforeBookmark;}if(settings.custom_undo_redo_levels){if(data.length>settings.custom_undo_redo_levels){for(i=0;i<data.length-1;i++){data[i]=data[i+1];}data.length--;index=data.length;}}level.bookmark=$_ci8rza2jjk26xf6s.getUndoBookmark(editor.selection);if(index<data.length-1){data.length=index+1;}data.push(level);index=data.length-1;var args={level:level,lastLevel:lastLevel,originalEvent:event};editor.fire('AddUndo',args);if(index>0){setDirty(true);editor.fire('change',args);}return level;},undo:function undo(){var level;if(self.typing){self.add();self.typing=false;setTyping(false);}if(index>0){level=data[--index];$_d2n2uu5yjk26xfzc.applyToEditor(editor,level,true);setDirty(true);editor.fire('undo',{level:level});}return level;},redo:function redo(){var level;if(index<data.length-1){level=data[++index];$_d2n2uu5yjk26xfzc.applyToEditor(editor,level,false);setDirty(true);editor.fire('redo',{level:level});}return level;},clear:function clear(){data=[];index=0;self.typing=false;self.data=data;editor.fire('ClearUndos');},hasUndo:function hasUndo(){return index>0||self.typing&&data[0]&&!$_d2n2uu5yjk26xfzc.isEq($_d2n2uu5yjk26xfzc.createFromEditor(editor),data[0]);},hasRedo:function hasRedo(){return index<data.length-1&&!self.typing;},transact:function transact(callback){endTyping();self.beforeChange();self.ignore(callback);return self.add();},ignore:function ignore(callback){try{locks++;callback();}finally{locks--;}},extra:function extra(callback1,callback2){var lastLevel,bookmark;if(self.transact(callback1)){bookmark=data[index].bookmark;lastLevel=data[index-1];$_d2n2uu5yjk26xfzc.applyToEditor(editor,lastLevel,true);if(self.transact(callback2)){data[index-1].beforeBookmark=bookmark;}}}};return self;}function Experimental(editor){var annotator=Annotator(editor);var experimental={};Object.defineProperty(experimental,'annotator',{get:function get(){console.warn('Using experimental API: annotator');return annotator;}});return experimental;}var isEq$4=$_a0f3y13ajk26xfcc.isEq;var matchesUnInheritedFormatSelector=function matchesUnInheritedFormatSelector(ed,node,name){var formatList=ed.formatter.get(name);if(formatList){for(var i=0;i<formatList.length;i++){if(formatList[i].inherit===false&&ed.dom.is(node,formatList[i].selector)){return true;}}}return false;};var matchParents=function matchParents(editor,node,name,vars){var root=editor.dom.getRoot();if(node===root){return false;}node=editor.dom.getParent(node,function(node){if(matchesUnInheritedFormatSelector(editor,node,name)){return true;}return node.parentNode===root||!!matchNode(editor,node,name,vars,true);});return matchNode(editor,node,name,vars);};var matchName=function matchName(dom,node,format){if(isEq$4(node,format.inline)){return true;}if(isEq$4(node,format.block)){return true;}if(format.selector){return node.nodeType===1&&dom.is(node,format.selector);}};var matchItems=function matchItems(dom,node,format,itemName,similar,vars){var key,value;var items=format[itemName];var i;if(format.onmatch){return format.onmatch(node,format,itemName);}if(items){if(typeof items.length==='undefined'){for(key in items){if(items.hasOwnProperty(key)){if(itemName==='attributes'){value=dom.getAttrib(node,key);}else{value=$_a0f3y13ajk26xfcc.getStyle(dom,node,key);}if(similar&&!value&&!format.exact){return;}if((!similar||format.exact)&&!isEq$4(value,$_a0f3y13ajk26xfcc.normalizeStyleValue(dom,$_a0f3y13ajk26xfcc.replaceVars(items[key],vars),key))){return;}}}}else{for(i=0;i<items.length;i++){if(itemName==='attributes'?dom.getAttrib(node,items[i]):$_a0f3y13ajk26xfcc.getStyle(dom,node,items[i])){return format;}}}}return format;};var matchNode=function matchNode(ed,node,name,vars,similar){var formatList=ed.formatter.get(name);var format,i,x,classes;var dom=ed.dom;if(formatList&&node){for(i=0;i<formatList.length;i++){format=formatList[i];if(matchName(ed.dom,node,format)&&matchItems(dom,node,format,'attributes',similar,vars)&&matchItems(dom,node,format,'styles',similar,vars)){if(classes=format.classes){for(x=0;x<classes.length;x++){if(!ed.dom.hasClass(node,classes[x])){return;}}}return format;}}}};var match=function match(editor,name,vars,node){var startNode;if(node){return matchParents(editor,node,name,vars);}node=editor.selection.getNode();if(matchParents(editor,node,name,vars)){return true;}startNode=editor.selection.getStart();if(startNode!==node){if(matchParents(editor,startNode,name,vars)){return true;}}return false;};var matchAll=function matchAll(editor,names,vars){var startElement;var matchedFormatNames=[];var checkedMap={};startElement=editor.selection.getStart();editor.dom.getParent(startElement,function(node){var i,name;for(i=0;i<names.length;i++){name=names[i];if(!checkedMap[name]&&matchNode(editor,node,name,vars)){checkedMap[name]=true;matchedFormatNames.push(name);}}},editor.dom.getRoot());return matchedFormatNames;};var canApply=function canApply(editor,name){var formatList=editor.formatter.get(name);var startNode,parents,i,x,selector;var dom=editor.dom;if(formatList){startNode=editor.selection.getStart();parents=$_a0f3y13ajk26xfcc.getParents(dom,startNode);for(x=formatList.length-1;x>=0;x--){selector=formatList[x].selector;if(!selector||formatList[x].defaultBlock){return true;}for(i=parents.length-1;i>=0;i--){if(dom.is(parents[i],selector)){return true;}}}}return false;};var $_18trse69jk26xg1s={matchNode:matchNode,matchName:matchName,match:match,matchAll:matchAll,canApply:canApply,matchesUnInheritedFormatSelector:matchesUnInheritedFormatSelector};var splitText=function splitText(node,offset){return node.splitText(offset);};var split$1=function split$1(rng){var startContainer=rng.startContainer,startOffset=rng.startOffset,endContainer=rng.endContainer,endOffset=rng.endOffset;if(startContainer===endContainer&&$_fpgwqg1rjk26xf0n.isText(startContainer)){if(startOffset>0&&startOffset<startContainer.nodeValue.length){endContainer=splitText(startContainer,startOffset);startContainer=endContainer.previousSibling;if(endOffset>startOffset){endOffset=endOffset-startOffset;startContainer=endContainer=splitText(endContainer,endOffset).previousSibling;endOffset=endContainer.nodeValue.length;startOffset=0;}else{endOffset=0;}}}else{if($_fpgwqg1rjk26xf0n.isText(startContainer)&&startOffset>0&&startOffset<startContainer.nodeValue.length){startContainer=splitText(startContainer,startOffset);startOffset=0;}if($_fpgwqg1rjk26xf0n.isText(endContainer)&&endOffset>0&&endOffset<endContainer.nodeValue.length){endContainer=splitText(endContainer,endOffset).previousSibling;endOffset=endContainer.nodeValue.length;}}return{startContainer:startContainer,startOffset:startOffset,endContainer:endContainer,endOffset:endOffset};};var $_4q4ycg6ajk26xg1x={split:split$1};var ZWSP$1=$_4osibw2pjk26xf83.ZWSP;var CARET_ID$1='_mce_caret';var importNode=function importNode(ownerDocument,node){return ownerDocument.importNode(node,true);};var getEmptyCaretContainers=function getEmptyCaretContainers(node){var nodes=[];while(node){if(node.nodeType===3&&node.nodeValue!==ZWSP$1||node.childNodes.length>1){return[];}if(node.nodeType===1){nodes.push(node);}node=node.firstChild;}return nodes;};var isCaretContainerEmpty=function isCaretContainerEmpty(node){return getEmptyCaretContainers(node).length>0;};var findFirstTextNode=function findFirstTextNode(node){var walker;if(node){walker=new TreeWalker(node,node);for(node=walker.current();node;node=walker.next()){if(node.nodeType===3){return node;}}}return null;};var createCaretContainer=function createCaretContainer(fill){var caretContainer=Element$$1.fromTag('span');$_5xapbx15jk26xewz.setAll(caretContainer,{'id':CARET_ID$1,'data-mce-bogus':'1','data-mce-type':'format-caret'});if(fill){$_9t36rc1yjk26xf33.append(caretContainer,Element$$1.fromText(ZWSP$1));}return caretContainer;};var trimZwspFromCaretContainer=function trimZwspFromCaretContainer(caretContainerNode){var textNode=findFirstTextNode(caretContainerNode);if(textNode&&textNode.nodeValue.charAt(0)===ZWSP$1){textNode.deleteData(0,1);}return textNode;};var removeCaretContainerNode=function removeCaretContainerNode(dom,selection,node,moveCaret){var rng,block,textNode;rng=selection.getRng(true);block=dom.getParent(node,dom.isBlock);if(isCaretContainerEmpty(node)){if(moveCaret!==false){rng.setStartBefore(node);rng.setEndBefore(node);}dom.remove(node);}else{textNode=trimZwspFromCaretContainer(node);if(rng.startContainer===textNode&&rng.startOffset>0){rng.setStart(textNode,rng.startOffset-1);}if(rng.endContainer===textNode&&rng.endOffset>0){rng.setEnd(textNode,rng.endOffset-1);}dom.remove(node,true);}if(block&&dom.isEmpty(block)){$_bpbbqb3ljk26xfi6.fillWithPaddingBr(Element$$1.fromDom(block));}selection.setRng(rng);};var removeCaretContainer=function removeCaretContainer(body,dom,selection,node,moveCaret){if(!node){node=getParentCaretContainer(body,selection.getStart());if(!node){while(node=dom.get(CARET_ID$1)){removeCaretContainerNode(dom,selection,node,false);}}}else{removeCaretContainerNode(dom,selection,node,moveCaret);}};var insertCaretContainerNode=function insertCaretContainerNode(editor,caretContainer,formatNode){var dom=editor.dom,block=dom.getParent(formatNode,$_a86i182ljk26xf77.curry($_a0f3y13ajk26xfcc.isTextBlock,editor));if(block&&dom.isEmpty(block)){formatNode.parentNode.replaceChild(caretContainer,formatNode);}else{$_bpbbqb3ljk26xfi6.removeTrailingBr(Element$$1.fromDom(formatNode));if(dom.isEmpty(formatNode)){formatNode.parentNode.replaceChild(caretContainer,formatNode);}else{dom.insertAfter(caretContainer,formatNode);}}};var appendNode=function appendNode(parentNode,node){parentNode.appendChild(node);return node;};var insertFormatNodesIntoCaretContainer=function insertFormatNodesIntoCaretContainer(formatNodes,caretContainer){var innerMostFormatNode=foldr(formatNodes,function(parentNode,formatNode){return appendNode(parentNode,formatNode.cloneNode(false));},caretContainer);return appendNode(innerMostFormatNode,innerMostFormatNode.ownerDocument.createTextNode(ZWSP$1));};var applyCaretFormat=function applyCaretFormat(editor,name,vars){var rng,caretContainer,textNode,offset,bookmark,container,text;var selection=editor.selection;rng=selection.getRng(true);offset=rng.startOffset;container=rng.startContainer;text=container.nodeValue;caretContainer=getParentCaretContainer(editor.getBody(),selection.getStart());if(caretContainer){textNode=findFirstTextNode(caretContainer);}var wordcharRegex=/[^\s\u00a0\u00ad\u200b\ufeff]/;if(text&&offset>0&&offset<text.length&&wordcharRegex.test(text.charAt(offset))&&wordcharRegex.test(text.charAt(offset-1))){bookmark=selection.getBookmark();rng.collapse(true);rng=$_21lucf2ujk26xf8j.expandRng(editor,rng,editor.formatter.get(name));rng=$_4q4ycg6ajk26xg1x.split(rng);editor.formatter.apply(name,vars,rng);selection.moveToBookmark(bookmark);}else{if(!caretContainer||textNode.nodeValue!==ZWSP$1){caretContainer=importNode(editor.getDoc(),createCaretContainer(true).dom());textNode=caretContainer.firstChild;rng.insertNode(caretContainer);offset=1;editor.formatter.apply(name,vars,caretContainer);}else{editor.formatter.apply(name,vars,caretContainer);}selection.setCursorLocation(textNode,offset);}};var removeCaretFormat=function removeCaretFormat(editor,name,vars,similar){var dom=editor.dom,selection=editor.selection;var container,offset,bookmark;var hasContentAfter,node,formatNode;var parents=[],rng=selection.getRng();var caretContainer;container=rng.startContainer;offset=rng.startOffset;node=container;if(container.nodeType===3){if(offset!==container.nodeValue.length){hasContentAfter=true;}node=node.parentNode;}while(node){if($_18trse69jk26xg1s.matchNode(editor,node,name,vars,similar)){formatNode=node;break;}if(node.nextSibling){hasContentAfter=true;}parents.push(node);node=node.parentNode;}if(!formatNode){return;}if(hasContentAfter){bookmark=selection.getBookmark();rng.collapse(true);var expandedRng=$_21lucf2ujk26xf8j.expandRng(editor,rng,editor.formatter.get(name),true);expandedRng=$_4q4ycg6ajk26xg1x.split(expandedRng);editor.formatter.remove(name,vars,expandedRng);selection.moveToBookmark(bookmark);}else{caretContainer=getParentCaretContainer(editor.getBody(),formatNode);var newCaretContainer=createCaretContainer(false).dom();var caretNode=insertFormatNodesIntoCaretContainer(parents,newCaretContainer);if(caretContainer){insertCaretContainerNode(editor,newCaretContainer,caretContainer);}else{insertCaretContainerNode(editor,newCaretContainer,formatNode);}removeCaretContainerNode(dom,selection,caretContainer,false);selection.setCursorLocation(caretNode,1);if(dom.isEmpty(formatNode)){dom.remove(formatNode);}}};var disableCaretContainer=function disableCaretContainer(body,dom,selection,keyCode){removeCaretContainer(body,dom,selection,null,false);if(keyCode===8&&selection.isCollapsed()&&selection.getStart().innerHTML===ZWSP$1){removeCaretContainer(body,dom,selection,getParentCaretContainer(body,selection.getStart()));}if(keyCode===37||keyCode===39){removeCaretContainer(body,dom,selection,getParentCaretContainer(body,selection.getStart()));}};var setup$4=function setup$4(editor){var dom=editor.dom,selection=editor.selection;var body=editor.getBody();editor.on('mouseup keydown',function(e){disableCaretContainer(body,dom,selection,e.keyCode);});};var replaceWithCaretFormat=function replaceWithCaretFormat(targetNode,formatNodes){var caretContainer=createCaretContainer(false);var innerMost=insertFormatNodesIntoCaretContainer(formatNodes,caretContainer.dom());$_9t36rc1yjk26xf33.before(Element$$1.fromDom(targetNode),caretContainer);$_5ur14v1wjk26xf2q.remove(Element$$1.fromDom(targetNode));return CaretPosition$1(innerMost,0);};var isFormatElement=function isFormatElement(editor,element){var inlineElements=editor.schema.getTextInlineElements();return inlineElements.hasOwnProperty($_cl4rr911jk26xevy.name(element))&&!isCaretNode(element.dom())&&!$_fpgwqg1rjk26xf0n.isBogus(element.dom());};var postProcessHooks={};var filter$2=$_98exydmjk26xeto.filter;var each$12=$_98exydmjk26xeto.each;var addPostProcessHook=function addPostProcessHook(name,hook){var hooks=postProcessHooks[name];if(!hooks){postProcessHooks[name]=hooks=[];}postProcessHooks[name].push(hook);};var postProcess=function postProcess(name,editor){each$12(postProcessHooks[name],function(hook){hook(editor);});};addPostProcessHook('pre',function(editor){var rng=editor.selection.getRng();var isPre,blocks;var hasPreSibling=function hasPreSibling(pre){return isPre(pre.previousSibling)&&$_98exydmjk26xeto.indexOf(blocks,pre.previousSibling)!==-1;};var joinPre=function joinPre(pre1,pre2){DomQuery(pre2).remove();DomQuery(pre1).append('<br><br>').append(pre2.childNodes);};isPre=$_fpgwqg1rjk26xf0n.matchNodeNames('pre');if(!rng.collapsed){blocks=editor.selection.getSelectedBlocks();each$12(filter$2(filter$2(blocks,isPre),hasPreSibling),function(pre){joinPre(pre.previousSibling,pre);});}});var $_98c3ly6bjk26xg1z={postProcess:postProcess};var MCE_ATTR_RE=/^(src|href|style)$/;var each$13=$_2ytxahljk26xetf.each;var isEq$5=$_a0f3y13ajk26xfcc.isEq;var isTableCell$4=function isTableCell$4(node){return /^(TH|TD)$/.test(node.nodeName);};var getContainer=function getContainer(ed,rng,start){var container,offset,lastIdx;container=rng[start?'startContainer':'endContainer'];offset=rng[start?'startOffset':'endOffset'];if($_fpgwqg1rjk26xf0n.isElement(container)){lastIdx=container.childNodes.length-1;if(!start&&offset){offset--;}container=container.childNodes[offset>lastIdx?lastIdx:offset];}if($_fpgwqg1rjk26xf0n.isText(container)&&start&&offset>=container.nodeValue.length){container=new TreeWalker(container,ed.getBody()).next()||container;}if($_fpgwqg1rjk26xf0n.isText(container)&&!start&&offset===0){container=new TreeWalker(container,ed.getBody()).prev()||container;}return container;};var wrap$2=function wrap$2(dom,node,name,attrs){var wrapper=dom.create(name,attrs);node.parentNode.insertBefore(wrapper,node);wrapper.appendChild(node);return wrapper;};var matchName$1=function matchName$1(dom,node,format){if(isEq$5(node,format.inline)){return true;}if(isEq$5(node,format.block)){return true;}if(format.selector){return $_fpgwqg1rjk26xf0n.isElement(node)&&dom.is(node,format.selector);}};var isColorFormatAndAnchor=function isColorFormatAndAnchor(node,format){return format.links&&node.tagName==='A';};var find$4=function find$4(dom,node,next,inc){node=$_a0f3y13ajk26xfcc.getNonWhiteSpaceSibling(node,next,inc);return!node||node.nodeName==='BR'||dom.isBlock(node);};var removeNode$1=function removeNode$1(ed,node,format){var parentNode=node.parentNode;var rootBlockElm;var dom=ed.dom,forcedRootBlock=ed.settings.forced_root_block;if(format.block){if(!forcedRootBlock){if(dom.isBlock(node)&&!dom.isBlock(parentNode)){if(!find$4(dom,node,false)&&!find$4(dom,node.firstChild,true,1)){node.insertBefore(dom.create('br'),node.firstChild);}if(!find$4(dom,node,true)&&!find$4(dom,node.lastChild,false,1)){node.appendChild(dom.create('br'));}}}else{if(parentNode===dom.getRoot()){if(!format.list_block||!isEq$5(node,format.list_block)){each$13($_2ytxahljk26xetf.grep(node.childNodes),function(node){if($_a0f3y13ajk26xfcc.isValid(ed,forcedRootBlock,node.nodeName.toLowerCase())){if(!rootBlockElm){rootBlockElm=wrap$2(dom,node,forcedRootBlock);dom.setAttribs(rootBlockElm,ed.settings.forced_root_block_attrs);}else{rootBlockElm.appendChild(node);}}else{rootBlockElm=0;}});}}}}if(format.selector&&format.inline&&!isEq$5(format.inline,node)){return;}dom.remove(node,1);};var removeFormat=function removeFormat(ed,format,vars,node,compareNode){var i,attrs,stylesModified;var dom=ed.dom;if(!matchName$1(dom,node,format)&&!isColorFormatAndAnchor(node,format)){return false;}if(format.remove!=='all'){each$13(format.styles,function(value,name){value=$_a0f3y13ajk26xfcc.normalizeStyleValue(dom,$_a0f3y13ajk26xfcc.replaceVars(value,vars),name);if(typeof name==='number'){name=value;compareNode=0;}if(format.remove_similar||!compareNode||isEq$5($_a0f3y13ajk26xfcc.getStyle(dom,compareNode,name),value)){dom.setStyle(node,name,'');}stylesModified=1;});if(stylesModified&&dom.getAttrib(node,'style')===''){node.removeAttribute('style');node.removeAttribute('data-mce-style');}each$13(format.attributes,function(value,name){var valueOut;value=$_a0f3y13ajk26xfcc.replaceVars(value,vars);if(typeof name==='number'){name=value;compareNode=0;}if(!compareNode||isEq$5(dom.getAttrib(compareNode,name),value)){if(name==='class'){value=dom.getAttrib(node,name);if(value){valueOut='';each$13(value.split(/\s+/),function(cls){if(/mce\-\w+/.test(cls)){valueOut+=(valueOut?' ':'')+cls;}});if(valueOut){dom.setAttrib(node,name,valueOut);return;}}}if(name==='class'){node.removeAttribute('className');}if(MCE_ATTR_RE.test(name)){node.removeAttribute('data-mce-'+name);}node.removeAttribute(name);}});each$13(format.classes,function(value){value=$_a0f3y13ajk26xfcc.replaceVars(value,vars);if(!compareNode||dom.hasClass(compareNode,value)){dom.removeClass(node,value);}});attrs=dom.getAttribs(node);for(i=0;i<attrs.length;i++){var attrName=attrs[i].nodeName;if(attrName.indexOf('_')!==0&&attrName.indexOf('data-')!==0){return false;}}}if(format.remove!=='none'){removeNode$1(ed,node,format);return true;}};var findFormatRoot=function findFormatRoot(editor,container,name,vars,similar){var formatRoot;each$13($_a0f3y13ajk26xfcc.getParents(editor.dom,container.parentNode).reverse(),function(parent){var format;if(!formatRoot&&parent.id!=='_start'&&parent.id!=='_end'){format=$_18trse69jk26xg1s.matchNode(editor,parent,name,vars,similar);if(format&&format.split!==false){formatRoot=parent;}}});return formatRoot;};var wrapAndSplit=function wrapAndSplit(editor,formatList,formatRoot,container,target,split,format,vars){var parent,clone,lastClone,firstClone,i,formatRootParent;var dom=editor.dom;if(formatRoot){formatRootParent=formatRoot.parentNode;for(parent=container.parentNode;parent&&parent!==formatRootParent;parent=parent.parentNode){clone=dom.clone(parent,false);for(i=0;i<formatList.length;i++){if(removeFormat(editor,formatList[i],vars,clone,clone)){clone=0;break;}}if(clone){if(lastClone){clone.appendChild(lastClone);}if(!firstClone){firstClone=clone;}lastClone=clone;}}if(split&&(!format.mixed||!dom.isBlock(formatRoot))){container=dom.split(formatRoot,container);}if(lastClone){target.parentNode.insertBefore(lastClone,target);firstClone.appendChild(target);}}return container;};var remove$8=function remove$8(ed,name,vars,node,similar){var formatList=ed.formatter.get(name),format=formatList[0];var bookmark,rng,contentEditable=true;var dom=ed.dom;var selection=ed.selection;var splitToFormatRoot=function splitToFormatRoot(container){var formatRoot=findFormatRoot(ed,container,name,vars,similar);return wrapAndSplit(ed,formatList,formatRoot,container,container,true,format,vars);};var process=function process(node){var children,i,l,lastContentEditable,hasContentEditableState;if($_fpgwqg1rjk26xf0n.isElement(node)&&dom.getContentEditable(node)){lastContentEditable=contentEditable;contentEditable=dom.getContentEditable(node)==='true';hasContentEditableState=true;}children=$_2ytxahljk26xetf.grep(node.childNodes);if(contentEditable&&!hasContentEditableState){for(i=0,l=formatList.length;i<l;i++){if(removeFormat(ed,formatList[i],vars,node,node)){break;}}}if(format.deep){if(children.length){for(i=0,l=children.length;i<l;i++){process(children[i]);}if(hasContentEditableState){contentEditable=lastContentEditable;}}}};var unwrap=function unwrap(start){var node=dom.get(start?'_start':'_end');var out=node[start?'firstChild':'lastChild'];if($_2wdci52vjk26xf8r.isBookmarkNode(out)){out=out[start?'firstChild':'lastChild'];}if($_fpgwqg1rjk26xf0n.isText(out)&&out.data.length===0){out=start?node.previousSibling||node.nextSibling:node.nextSibling||node.previousSibling;}dom.remove(node,true);return out;};var removeRngStyle=function removeRngStyle(rng){var startContainer,endContainer;var commonAncestorContainer=rng.commonAncestorContainer;rng=$_21lucf2ujk26xf8j.expandRng(ed,rng,formatList,true);if(format.split){startContainer=getContainer(ed,rng,true);endContainer=getContainer(ed,rng);if(startContainer!==endContainer){if(/^(TR|TH|TD)$/.test(startContainer.nodeName)&&startContainer.firstChild){if(startContainer.nodeName==='TR'){startContainer=startContainer.firstChild.firstChild||startContainer;}else{startContainer=startContainer.firstChild||startContainer;}}if(commonAncestorContainer&&/^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName)&&isTableCell$4(endContainer)&&endContainer.firstChild){endContainer=endContainer.firstChild||endContainer;}if(dom.isChildOf(startContainer,endContainer)&&startContainer!==endContainer&&!dom.isBlock(endContainer)&&!isTableCell$4(startContainer)&&!isTableCell$4(endContainer)){startContainer=wrap$2(dom,startContainer,'span',{'id':'_start','data-mce-type':'bookmark'});splitToFormatRoot(startContainer);startContainer=unwrap(true);return;}startContainer=wrap$2(dom,startContainer,'span',{'id':'_start','data-mce-type':'bookmark'});endContainer=wrap$2(dom,endContainer,'span',{'id':'_end','data-mce-type':'bookmark'});splitToFormatRoot(startContainer);splitToFormatRoot(endContainer);startContainer=unwrap(true);endContainer=unwrap();}else{startContainer=endContainer=splitToFormatRoot(startContainer);}rng.startContainer=startContainer.parentNode?startContainer.parentNode:startContainer;rng.startOffset=dom.nodeIndex(startContainer);rng.endContainer=endContainer.parentNode?endContainer.parentNode:endContainer;rng.endOffset=dom.nodeIndex(endContainer)+1;}$_179pt43bjk26xfcg.walk(dom,rng,function(nodes){each$13(nodes,function(node){process(node);if($_fpgwqg1rjk26xf0n.isElement(node)&&ed.dom.getStyle(node,'text-decoration')==='underline'&&node.parentNode&&$_a0f3y13ajk26xfcc.getTextDecoration(dom,node.parentNode)==='underline'){removeFormat(ed,{deep:false,exact:true,inline:'span',styles:{textDecoration:'underline'}},null,node);}});});};if(node){if(node.nodeType){rng=dom.createRng();rng.setStartBefore(node);rng.setEndAfter(node);removeRngStyle(rng);}else{removeRngStyle(node);}return;}if(dom.getContentEditable(selection.getNode())==='false'){node=selection.getNode();for(var i=0,l=formatList.length;i<l;i++){if(formatList[i].ceFalseOverride){if(removeFormat(ed,formatList[i],vars,node,node)){break;}}}return;}if(!selection.isCollapsed()||!format.inline||dom.select('td[data-mce-selected],th[data-mce-selected]').length){bookmark=$_ci8rza2jjk26xf6s.getPersistentBookmark(ed.selection,true);removeRngStyle(selection.getRng());selection.moveToBookmark(bookmark);if(format.inline&&$_18trse69jk26xg1s.match(ed,name,vars,selection.getStart())){$_a0f3y13ajk26xfcc.moveStart(dom,selection,selection.getRng());}ed.nodeChanged();}else{removeCaretFormat(ed,name,vars,similar);}};var $_vtbk56djk26xg2b={removeFormat:removeFormat,remove:remove$8};var each$14=$_2ytxahljk26xetf.each;var isElementNode=function isElementNode(node){return node&&node.nodeType===1&&!$_2wdci52vjk26xf8r.isBookmarkNode(node)&&!isCaretNode(node)&&!$_fpgwqg1rjk26xf0n.isBogus(node);};var findElementSibling=function findElementSibling(node,siblingName){var sibling;for(sibling=node;sibling;sibling=sibling[siblingName]){if(sibling.nodeType===3&&sibling.nodeValue.length!==0){return node;}if(sibling.nodeType===1&&!$_2wdci52vjk26xf8r.isBookmarkNode(sibling)){return sibling;}}return node;};var mergeSiblingsNodes=function mergeSiblingsNodes(dom,prev,next){var sibling,tmpSibling;var elementUtils=new ElementUtils(dom);if(prev&&next){prev=findElementSibling(prev,'previousSibling');next=findElementSibling(next,'nextSibling');if(elementUtils.compare(prev,next)){for(sibling=prev.nextSibling;sibling&&sibling!==next;){tmpSibling=sibling;sibling=sibling.nextSibling;prev.appendChild(tmpSibling);}dom.remove(next);$_2ytxahljk26xetf.each($_2ytxahljk26xetf.grep(next.childNodes),function(node){prev.appendChild(node);});return prev;}}return next;};var processChildElements=function processChildElements(node,filter,process){each$14(node.childNodes,function(node){if(isElementNode(node)){if(filter(node)){process(node);}if(node.hasChildNodes()){processChildElements(node,filter,process);}}});};var hasStyle=function hasStyle(dom,name){return curry(function(name,node){return!!(node&&$_a0f3y13ajk26xfcc.getStyle(dom,node,name));},name);};var applyStyle=function applyStyle(dom,name,value){return curry(function(name,value,node){dom.setStyle(node,name,value);if(node.getAttribute('style')===''){node.removeAttribute('style');}unwrapEmptySpan(dom,node);},name,value);};var unwrapEmptySpan=function unwrapEmptySpan(dom,node){if(node.nodeName==='SPAN'&&dom.getAttribs(node).length===0){dom.remove(node,true);}};var processUnderlineAndColor=function processUnderlineAndColor(dom,node){var textDecoration;if(node.nodeType===1&&node.parentNode&&node.parentNode.nodeType===1){textDecoration=$_a0f3y13ajk26xfcc.getTextDecoration(dom,node.parentNode);if(dom.getStyle(node,'color')&&textDecoration){dom.setStyle(node,'text-decoration',textDecoration);}else if(dom.getStyle(node,'text-decoration')===textDecoration){dom.setStyle(node,'text-decoration',null);}}};var mergeUnderlineAndColor=function mergeUnderlineAndColor(dom,format,vars,node){if(format.styles.color||format.styles.textDecoration){$_2ytxahljk26xetf.walk(node,curry(processUnderlineAndColor,dom),'childNodes');processUnderlineAndColor(dom,node);}};var mergeBackgroundColorAndFontSize=function mergeBackgroundColorAndFontSize(dom,format,vars,node){if(format.styles&&format.styles.backgroundColor){processChildElements(node,hasStyle(dom,'fontSize'),applyStyle(dom,'backgroundColor',$_a0f3y13ajk26xfcc.replaceVars(format.styles.backgroundColor,vars)));}};var mergeSubSup=function mergeSubSup(dom,format,vars,node){if(format.inline==='sub'||format.inline==='sup'){processChildElements(node,hasStyle(dom,'fontSize'),applyStyle(dom,'fontSize',''));dom.remove(dom.select(format.inline==='sup'?'sub':'sup',node),true);}};var mergeSiblings=function mergeSiblings(dom,format,vars,node){if(node&&format.merge_siblings!==false){node=mergeSiblingsNodes(dom,$_a0f3y13ajk26xfcc.getNonWhiteSpaceSibling(node),node);node=mergeSiblingsNodes(dom,node,$_a0f3y13ajk26xfcc.getNonWhiteSpaceSibling(node,true));}};var clearChildStyles=function clearChildStyles(dom,format,node){if(format.clear_child_styles){var selector=format.links?'*:not(a)':'*';each$14(dom.select(selector,node),function(node){if(isElementNode(node)){each$14(format.styles,function(value,name){dom.setStyle(node,name,'');});}});}};var mergeWithChildren=function mergeWithChildren(editor,formatList,vars,node){each$14(formatList,function(format){each$14(editor.dom.select(format.inline,node),function(child){if(!isElementNode(child)){return;}$_vtbk56djk26xg2b.removeFormat(editor,format,vars,child,format.exact?child:null);});clearChildStyles(editor.dom,format,node);});};var mergeWithParents=function mergeWithParents(editor,format,name,vars,node){if($_18trse69jk26xg1s.matchNode(editor,node.parentNode,name,vars)){if($_vtbk56djk26xg2b.removeFormat(editor,format,vars,node)){return;}}if(format.merge_with_parents){editor.dom.getParent(node.parentNode,function(parent){if($_18trse69jk26xg1s.matchNode(editor,parent,name,vars)){$_vtbk56djk26xg2b.removeFormat(editor,format,vars,node);return true;}});}};var $_cj6f0c6cjk26xg22={mergeWithChildren:mergeWithChildren,mergeUnderlineAndColor:mergeUnderlineAndColor,mergeBackgroundColorAndFontSize:mergeBackgroundColorAndFontSize,mergeSubSup:mergeSubSup,mergeSiblings:mergeSiblings,mergeWithParents:mergeWithParents};var each$15=$_2ytxahljk26xetf.each;var isElementNode$1=function isElementNode$1(node){return node&&node.nodeType===1&&!$_2wdci52vjk26xf8r.isBookmarkNode(node)&&!isCaretNode(node)&&!$_fpgwqg1rjk26xf0n.isBogus(node);};var applyFormat=function applyFormat(ed,name,vars,node){var formatList=ed.formatter.get(name);var format=formatList[0];var bookmark,rng;var isCollapsed=!node&&ed.selection.isCollapsed();var dom=ed.dom,selection=ed.selection;var setElementFormat=function setElementFormat(elm,fmt){fmt=fmt||format;if(elm){if(fmt.onformat){fmt.onformat(elm,fmt,vars,node);}each$15(fmt.styles,function(value,name){dom.setStyle(elm,name,$_a0f3y13ajk26xfcc.replaceVars(value,vars));});if(fmt.styles){var styleVal=dom.getAttrib(elm,'style');if(styleVal){elm.setAttribute('data-mce-style',styleVal);}}each$15(fmt.attributes,function(value,name){dom.setAttrib(elm,name,$_a0f3y13ajk26xfcc.replaceVars(value,vars));});each$15(fmt.classes,function(value){value=$_a0f3y13ajk26xfcc.replaceVars(value,vars);if(!dom.hasClass(elm,value)){dom.addClass(elm,value);}});}};var applyNodeStyle=function applyNodeStyle(formatList,node){var found=false;if(!format.selector){return false;}each$15(formatList,function(format){if('collapsed'in format&&format.collapsed!==isCollapsed){return;}if(dom.is(node,format.selector)&&!isCaretNode(node)){setElementFormat(node,format);found=true;return false;}});return found;};var applyRngStyle=function applyRngStyle(dom,rng,bookmark,nodeSpecific){var newWrappers=[];var wrapName,wrapElm,contentEditable=true;wrapName=format.inline||format.block;wrapElm=dom.create(wrapName);setElementFormat(wrapElm);$_179pt43bjk26xfcg.walk(dom,rng,function(nodes){var currentWrapElm;var process=function process(node){var nodeName,parentName,hasContentEditableState,lastContentEditable;lastContentEditable=contentEditable;nodeName=node.nodeName.toLowerCase();parentName=node.parentNode.nodeName.toLowerCase();if(node.nodeType===1&&dom.getContentEditable(node)){lastContentEditable=contentEditable;contentEditable=dom.getContentEditable(node)==='true';hasContentEditableState=true;}if($_a0f3y13ajk26xfcc.isEq(nodeName,'br')){currentWrapElm=0;if(format.block){dom.remove(node);}return;}if(format.wrapper&&$_18trse69jk26xg1s.matchNode(ed,node,name,vars)){currentWrapElm=0;return;}if(contentEditable&&!hasContentEditableState&&format.block&&!format.wrapper&&$_a0f3y13ajk26xfcc.isTextBlock(ed,nodeName)&&$_a0f3y13ajk26xfcc.isValid(ed,parentName,wrapName)){node=dom.rename(node,wrapName);setElementFormat(node);newWrappers.push(node);currentWrapElm=0;return;}if(format.selector){var found=applyNodeStyle(formatList,node);if(!format.inline||found){currentWrapElm=0;return;}}if(contentEditable&&!hasContentEditableState&&$_a0f3y13ajk26xfcc.isValid(ed,wrapName,nodeName)&&$_a0f3y13ajk26xfcc.isValid(ed,parentName,wrapName)&&!(!nodeSpecific&&node.nodeType===3&&node.nodeValue.length===1&&node.nodeValue.charCodeAt(0)===65279)&&!isCaretNode(node)&&(!format.inline||!dom.isBlock(node))){if(!currentWrapElm){currentWrapElm=dom.clone(wrapElm,false);node.parentNode.insertBefore(currentWrapElm,node);newWrappers.push(currentWrapElm);}currentWrapElm.appendChild(node);}else{currentWrapElm=0;each$15($_2ytxahljk26xetf.grep(node.childNodes),process);if(hasContentEditableState){contentEditable=lastContentEditable;}currentWrapElm=0;}};each$15(nodes,process);});if(format.links===true){each$15(newWrappers,function(node){var process=function process(node){if(node.nodeName==='A'){setElementFormat(node,format);}each$15($_2ytxahljk26xetf.grep(node.childNodes),process);};process(node);});}each$15(newWrappers,function(node){var childCount;var getChildCount=function getChildCount(node){var count=0;each$15(node.childNodes,function(node){if(!$_a0f3y13ajk26xfcc.isWhiteSpaceNode(node)&&!$_2wdci52vjk26xf8r.isBookmarkNode(node)){count++;}});return count;};var getChildElementNode=function getChildElementNode(root){var child=false;each$15(root.childNodes,function(node){if(isElementNode$1(node)){child=node;return false;}});return child;};var mergeStyles=function mergeStyles(node){var child,clone;child=getChildElementNode(node);if(child&&!$_2wdci52vjk26xf8r.isBookmarkNode(child)&&$_18trse69jk26xg1s.matchName(dom,child,format)){clone=dom.clone(child,false);setElementFormat(clone);dom.replace(clone,node,true);dom.remove(child,1);}return clone||node;};childCount=getChildCount(node);if((newWrappers.length>1||!dom.isBlock(node))&&childCount===0){dom.remove(node,1);return;}if(format.inline||format.wrapper){if(!format.exact&&childCount===1){node=mergeStyles(node);}$_cj6f0c6cjk26xg22.mergeWithChildren(ed,formatList,vars,node);$_cj6f0c6cjk26xg22.mergeWithParents(ed,format,name,vars,node);$_cj6f0c6cjk26xg22.mergeBackgroundColorAndFontSize(dom,format,vars,node);$_cj6f0c6cjk26xg22.mergeSubSup(dom,format,vars,node);$_cj6f0c6cjk26xg22.mergeSiblings(dom,format,vars,node);}});};if(dom.getContentEditable(selection.getNode())==='false'){node=selection.getNode();for(var i=0,l=formatList.length;i<l;i++){if(formatList[i].ceFalseOverride&&dom.is(node,formatList[i].selector)){setElementFormat(node,formatList[i]);return;}}return;}if(format){if(node){if(node.nodeType){if(!applyNodeStyle(formatList,node)){rng=dom.createRng();rng.setStartBefore(node);rng.setEndAfter(node);applyRngStyle(dom,$_21lucf2ujk26xf8j.expandRng(ed,rng,formatList),null,true);}}else{applyRngStyle(dom,node,null,true);}}else{if(!isCollapsed||!format.inline||dom.select('td[data-mce-selected],th[data-mce-selected]').length){var curSelNode=ed.selection.getNode();if(!ed.settings.forced_root_block&&formatList[0].defaultBlock&&!dom.getParent(curSelNode,dom.isBlock)){applyFormat(ed,formatList[0].defaultBlock);}ed.selection.setRng($_9o204u3ojk26xfis.normalize(ed.selection.getRng()));bookmark=$_ci8rza2jjk26xf6s.getPersistentBookmark(ed.selection,true);applyRngStyle(dom,$_21lucf2ujk26xf8j.expandRng(ed,selection.getRng(),formatList),bookmark);if(format.styles){$_cj6f0c6cjk26xg22.mergeUnderlineAndColor(dom,format,vars,curSelNode);}selection.moveToBookmark(bookmark);$_a0f3y13ajk26xfcc.moveStart(dom,selection,selection.getRng());ed.nodeChanged();}else{applyCaretFormat(ed,name,vars);}}$_98c3ly6bjk26xg1z.postProcess(name,ed);}};var $_4is7hp67jk26xg14={applyFormat:applyFormat};var each$16=$_2ytxahljk26xetf.each;var setup$5=function setup$5(formatChangeData,editor){var currentFormats={};formatChangeData.set({});editor.on('NodeChange',function(e){var parents=$_a0f3y13ajk26xfcc.getParents(editor.dom,e.element);var matchedFormats={};parents=$_2ytxahljk26xetf.grep(parents,function(node){return node.nodeType===1&&!node.getAttribute('data-mce-bogus');});each$16(formatChangeData.get(),function(callbacks,format){each$16(parents,function(node){if(editor.formatter.matchNode(node,format,{},callbacks.similar)){if(!currentFormats[format]){each$16(callbacks,function(callback){callback(true,{node:node,format:format,parents:parents});});currentFormats[format]=callbacks;}matchedFormats[format]=callbacks;return false;}if($_18trse69jk26xg1s.matchesUnInheritedFormatSelector(editor,node,format)){return false;}});});each$16(currentFormats,function(callbacks,format){if(!matchedFormats[format]){delete currentFormats[format];each$16(callbacks,function(callback){callback(false,{node:e.element,format:format,parents:parents});});}});});};var addListeners=function addListeners(formatChangeData,formats,callback,similar){var formatChangeItems=formatChangeData.get();each$16(formats.split(','),function(format){if(!formatChangeItems[format]){formatChangeItems[format]=[];formatChangeItems[format].similar=similar;}formatChangeItems[format].push(callback);});formatChangeData.set(formatChangeItems);};var formatChanged=function formatChanged(editor,formatChangeState,formats,callback,similar){if(formatChangeState.get()===null){setup$5(formatChangeState,editor);}addListeners(formatChangeState,formats,callback,similar);};var $_5p8bqy6ejk26xg2w={formatChanged:formatChanged};var get$7=function get$7(dom){var formats={valigntop:[{selector:'td,th',styles:{verticalAlign:'top'}}],valignmiddle:[{selector:'td,th',styles:{verticalAlign:'middle'}}],valignbottom:[{selector:'td,th',styles:{verticalAlign:'bottom'}}],alignleft:[{selector:'figure.image',collapsed:false,classes:'align-left',ceFalseOverride:true,preview:'font-family font-size'},{selector:'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',styles:{textAlign:'left'},inherit:false,preview:false,defaultBlock:'div'},{selector:'img,table',collapsed:false,styles:{float:'left'},preview:'font-family font-size'}],aligncenter:[{selector:'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',styles:{textAlign:'center'},inherit:false,preview:'font-family font-size',defaultBlock:'div'},{selector:'figure.image',collapsed:false,classes:'align-center',ceFalseOverride:true,preview:'font-family font-size'},{selector:'img',collapsed:false,styles:{display:'block',marginLeft:'auto',marginRight:'auto'},preview:false},{selector:'table',collapsed:false,styles:{marginLeft:'auto',marginRight:'auto'},preview:'font-family font-size'}],alignright:[{selector:'figure.image',collapsed:false,classes:'align-right',ceFalseOverride:true,preview:'font-family font-size'},{selector:'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',styles:{textAlign:'right'},inherit:false,preview:'font-family font-size',defaultBlock:'div'},{selector:'img,table',collapsed:false,styles:{float:'right'},preview:'font-family font-size'}],alignjustify:[{selector:'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',styles:{textAlign:'justify'},inherit:false,defaultBlock:'div',preview:'font-family font-size'}],bold:[{inline:'strong',remove:'all'},{inline:'span',styles:{fontWeight:'bold'}},{inline:'b',remove:'all'}],italic:[{inline:'em',remove:'all'},{inline:'span',styles:{fontStyle:'italic'}},{inline:'i',remove:'all'}],underline:[{inline:'span',styles:{textDecoration:'underline'},exact:true},{inline:'u',remove:'all'}],strikethrough:[{inline:'span',styles:{textDecoration:'line-through'},exact:true},{inline:'strike',remove:'all'}],forecolor:{inline:'span',styles:{color:'%value'},links:true,remove_similar:true,clear_child_styles:true},hilitecolor:{inline:'span',styles:{backgroundColor:'%value'},links:true,remove_similar:true,clear_child_styles:true},fontname:{inline:'span',toggle:false,styles:{fontFamily:'%value'},clear_child_styles:true},fontsize:{inline:'span',toggle:false,styles:{fontSize:'%value'},clear_child_styles:true},fontsize_class:{inline:'span',attributes:{class:'%value'}},blockquote:{block:'blockquote',wrapper:1,remove:'all'},subscript:{inline:'sub'},superscript:{inline:'sup'},code:{inline:'code'},link:{inline:'a',selector:'a',remove:'all',split:true,deep:true,onmatch:function onmatch(){return true;},onformat:function onformat(elm,fmt,vars){$_2ytxahljk26xetf.each(vars,function(value,key){dom.setAttrib(elm,key,value);});}},removeformat:[{selector:'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',remove:'all',split:true,expand:false,block_expand:true,deep:true},{selector:'span',attributes:['style','class'],remove:'empty',split:true,expand:false,deep:true},{selector:'*',attributes:['style','class'],split:false,expand:false,deep:true}]};$_2ytxahljk26xetf.each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/),function(name){formats[name]={block:name,remove:'all'};});return formats;};var $_m63b26gjk26xg31={get:get$7};function FormatRegistry(editor){var formats={};var get=function get(name){return name?formats[name]:formats;};var register=function register(name,format){if(name){if(typeof name!=='string'){$_2ytxahljk26xetf.each(name,function(format,name){register(name,format);});}else{format=format.length?format:[format];$_2ytxahljk26xetf.each(format,function(format){if(typeof format.deep==='undefined'){format.deep=!format.selector;}if(typeof format.split==='undefined'){format.split=!format.selector||format.inline;}if(typeof format.remove==='undefined'&&format.selector&&!format.inline){format.remove='none';}if(format.selector&&format.inline){format.mixed=true;format.block_expand=true;}if(typeof format.classes==='string'){format.classes=format.classes.split(/\s+/);}});formats[name]=format;}}};var unregister=function unregister(name){if(name&&formats[name]){delete formats[name];}return formats;};register($_m63b26gjk26xg31.get(editor.dom));register(editor.settings.formats);return{get:get,register:register,unregister:unregister};}var each$17=$_2ytxahljk26xetf.each;var dom=DOMUtils$1.DOM;var parsedSelectorToHtml=function parsedSelectorToHtml(ancestry,editor){var elm,item,fragment;var schema=editor&&editor.schema||Schema({});var decorate=function decorate(elm,item){if(item.classes.length){dom.addClass(elm,item.classes.join(' '));}dom.setAttribs(elm,item.attrs);};var createElement=function createElement(sItem){var elm;item=typeof sItem==='string'?{name:sItem,classes:[],attrs:{}}:sItem;elm=dom.create(item.name);decorate(elm,item);return elm;};var getRequiredParent=function getRequiredParent(elm,candidate){var name=typeof elm!=='string'?elm.nodeName.toLowerCase():elm;var elmRule=schema.getElementRule(name);var parentsRequired=elmRule&&elmRule.parentsRequired;if(parentsRequired&&parentsRequired.length){return candidate&&$_2ytxahljk26xetf.inArray(parentsRequired,candidate)!==-1?candidate:parentsRequired[0];}else{return false;}};var wrapInHtml=function wrapInHtml(elm,ancestry,siblings){var parent,parentCandidate,parentRequired;var ancestor=ancestry.length>0&&ancestry[0];var ancestorName=ancestor&&ancestor.name;parentRequired=getRequiredParent(elm,ancestorName);if(parentRequired){if(ancestorName===parentRequired){parentCandidate=ancestry[0];ancestry=ancestry.slice(1);}else{parentCandidate=parentRequired;}}else if(ancestor){parentCandidate=ancestry[0];ancestry=ancestry.slice(1);}else if(!siblings){return elm;}if(parentCandidate){parent=createElement(parentCandidate);parent.appendChild(elm);}if(siblings){if(!parent){parent=dom.create('div');parent.appendChild(elm);}$_2ytxahljk26xetf.each(siblings,function(sibling){var siblingElm=createElement(sibling);parent.insertBefore(siblingElm,elm);});}return wrapInHtml(parent,ancestry,parentCandidate&&parentCandidate.siblings);};if(ancestry&&ancestry.length){item=ancestry[0];elm=createElement(item);fragment=dom.create('div');fragment.appendChild(wrapInHtml(elm,ancestry.slice(1),item.siblings));return fragment;}else{return'';}};var selectorToHtml=function selectorToHtml(selector,editor){return parsedSelectorToHtml(parseSelector(selector),editor);};var parseSelectorItem=function parseSelectorItem(item){var tagName;var obj={classes:[],attrs:{}};item=obj.selector=$_2ytxahljk26xetf.trim(item);if(item!=='*'){tagName=item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g,function($0,$1,$2,$3,$4){switch($1){case'#':obj.attrs.id=$2;break;case'.':obj.classes.push($2);break;case':':if($_2ytxahljk26xetf.inArray('checked disabled enabled read-only required'.split(' '),$2)!==-1){obj.attrs[$2]=$2;}break;}if($3==='['){var m=$4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);if(m){obj.attrs[m[1]]=m[2];}}return'';});}obj.name=tagName||'div';return obj;};var parseSelector=function parseSelector(selector){if(!selector||typeof selector!=='string'){return[];}selector=selector.split(/\s*,\s*/)[0];selector=selector.replace(/\s*(~\+|~|\+|>)\s*/g,'$1');return $_2ytxahljk26xetf.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/),function(item){var siblings=$_2ytxahljk26xetf.map(item.split(/(?:~\+|~|\+)/),parseSelectorItem);var obj=siblings.pop();if(siblings.length){obj.siblings=siblings;}return obj;}).reverse();};var getCssText=function getCssText(editor,format){var name,previewFrag,previewElm,items;var previewCss='',parentFontSize,previewStyles;previewStyles=editor.settings.preview_styles;if(previewStyles===false){return'';}if(typeof previewStyles!=='string'){previewStyles='font-family font-size font-weight font-style text-decoration '+'text-transform color background-color border border-radius outline text-shadow';}var removeVars=function removeVars(val){return val.replace(/%(\w+)/g,'');};if(typeof format==='string'){format=editor.formatter.get(format);if(!format){return;}format=format[0];}if('preview'in format){previewStyles=format.preview;if(previewStyles===false){return'';}}name=format.block||format.inline||'span';items=parseSelector(format.selector);if(items.length){if(!items[0].name){items[0].name=name;}name=format.selector;previewFrag=parsedSelectorToHtml(items,editor);}else{previewFrag=parsedSelectorToHtml([name],editor);}previewElm=dom.select(name,previewFrag)[0]||previewFrag.firstChild;each$17(format.styles,function(value,name){value=removeVars(value);if(value){dom.setStyle(previewElm,name,value);}});each$17(format.attributes,function(value,name){value=removeVars(value);if(value){dom.setAttrib(previewElm,name,value);}});each$17(format.classes,function(value){value=removeVars(value);if(!dom.hasClass(previewElm,value)){dom.addClass(previewElm,value);}});editor.fire('PreviewFormats');dom.setStyles(previewFrag,{position:'absolute',left:-65535});editor.getBody().appendChild(previewFrag);parentFontSize=dom.getStyle(editor.getBody(),'fontSize',true);parentFontSize=/px$/.test(parentFontSize)?parseInt(parentFontSize,10):0;each$17(previewStyles.split(' '),function(name){var value=dom.getStyle(previewElm,name,true);if(name==='background-color'&&/transparent|rgba\s*\([^)]+,\s*0\)/.test(value)){value=dom.getStyle(editor.getBody(),name,true);if(dom.toHex(value).toLowerCase()==='#ffffff'){return;}}if(name==='color'){if(dom.toHex(value).toLowerCase()==='#000000'){return;}}if(name==='font-size'){if(/em|%$/.test(value)){if(parentFontSize===0){return;}var numValue=parseFloat(value)/(/%$/.test(value)?100:1);value=numValue*parentFontSize+'px';}}if(name==='border'&&value){previewCss+='padding:0 2px;';}previewCss+=name+':'+value+';';});editor.fire('AfterPreviewFormats');dom.remove(previewFrag);return previewCss;};var $_fxudh86hjk26xg37={getCssText:getCssText,parseSelector:parseSelector,selectorToHtml:selectorToHtml};var toggle$3=function toggle$3(editor,formats,name,vars,node){var fmt=formats.get(name);if($_18trse69jk26xg1s.match(editor,name,vars,node)&&(!('toggle'in fmt[0])||fmt[0].toggle)){$_vtbk56djk26xg2b.remove(editor,name,vars,node);}else{$_4is7hp67jk26xg14.applyFormat(editor,name,vars,node);}};var $_99u6yl6ijk26xg3d={toggle:toggle$3};var setup$6=function setup$6(editor){editor.addShortcut('meta+b','','Bold');editor.addShortcut('meta+i','','Italic');editor.addShortcut('meta+u','','Underline');for(var i=1;i<=6;i++){editor.addShortcut('access+'+i,'',['FormatBlock',false,'h'+i]);}editor.addShortcut('access+7','',['FormatBlock',false,'p']);editor.addShortcut('access+8','',['FormatBlock',false,'div']);editor.addShortcut('access+9','',['FormatBlock',false,'address']);};var $_qed4z6jjk26xg3e={setup:setup$6};function Formatter(editor){var formats=FormatRegistry(editor);var formatChangeState=Cell(null);$_qed4z6jjk26xg3e.setup(editor);setup$4(editor);return{get:formats.get,register:formats.register,unregister:formats.unregister,apply:curry($_4is7hp67jk26xg14.applyFormat,editor),remove:curry($_vtbk56djk26xg2b.remove,editor),toggle:curry($_99u6yl6ijk26xg3d.toggle,editor,formats),match:curry($_18trse69jk26xg1s.match,editor),matchAll:curry($_18trse69jk26xg1s.matchAll,editor),matchNode:curry($_18trse69jk26xg1s.matchNode,editor),canApply:curry($_18trse69jk26xg1s.canApply,editor),formatChanged:curry($_5p8bqy6ejk26xg2w.formatChanged,editor,formatChangeState),getCssText:curry($_fxudh86hjk26xg37.getCssText,editor)};}var hasOwnProperty$1=Object.prototype.hasOwnProperty;var shallow$1=function shallow$1(old,nu){return nu;};var baseMerge=function baseMerge(merger){return function(){var objects=new Array(arguments.length);for(var i=0;i<objects.length;i++){objects[i]=arguments[i];}if(objects.length===0)throw new Error('Can\'t merge zero objects');var ret={};for(var j=0;j<objects.length;j++){var curObject=objects[j];for(var key in curObject){if(hasOwnProperty$1.call(curObject,key)){ret[key]=merger(ret[key],curObject[key]);}}}return ret;};};var merge=baseMerge(shallow$1);var register=function register(htmlParser,settings,dom){htmlParser.addAttributeFilter('data-mce-tabindex',function(nodes,name){var i=nodes.length,node;while(i--){node=nodes[i];node.attr('tabindex',node.attributes.map['data-mce-tabindex']);node.attr(name,null);}});htmlParser.addAttributeFilter('src,href,style',function(nodes,name){var i=nodes.length,node,value;var internalName='data-mce-'+name;var urlConverter=settings.url_converter;var urlConverterScope=settings.url_converter_scope;while(i--){node=nodes[i];value=node.attributes.map[internalName];if(value!==undefined){node.attr(name,value.length>0?value:null);node.attr(internalName,null);}else{value=node.attributes.map[name];if(name==='style'){value=dom.serializeStyle(dom.parseStyle(value),node.name);}else if(urlConverter){value=urlConverter.call(urlConverterScope,value,name,node.name);}node.attr(name,value.length>0?value:null);}}});htmlParser.addAttributeFilter('class',function(nodes){var i=nodes.length,node,value;while(i--){node=nodes[i];value=node.attr('class');if(value){value=node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g,'');node.attr('class',value.length>0?value:null);}}});htmlParser.addAttributeFilter('data-mce-type',function(nodes,name,args){var i=nodes.length,node;while(i--){node=nodes[i];if(node.attributes.map['data-mce-type']==='bookmark'&&!args.cleanup){node.remove();}}});htmlParser.addNodeFilter('noscript',function(nodes){var i=nodes.length,node;while(i--){node=nodes[i].firstChild;if(node){node.value=$_8udjtn1sjk26xf0t.decode(node.value);}}});htmlParser.addNodeFilter('script,style',function(nodes,name){var i=nodes.length,node,value,type;var trim=function trim(value){return value.replace(/(<!--\[CDATA\[|\]\]-->)/g,'\n').replace(/^[\r\n]*|[\r\n]*$/g,'').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi,'').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g,'');};while(i--){node=nodes[i];value=node.firstChild?node.firstChild.value:'';if(name==='script'){type=node.attr('type');if(type){node.attr('type',type==='mce-no/type'?null:type.replace(/^mce\-/,''));}if(settings.element_format==='xhtml'&&value.length>0){node.firstChild.value='// <![CDATA[\n'+trim(value)+'\n// ]]>';}}else{if(settings.element_format==='xhtml'&&value.length>0){node.firstChild.value='<!--\n'+trim(value)+'\n-->';}}}});htmlParser.addNodeFilter('#comment',function(nodes){var i=nodes.length,node;while(i--){node=nodes[i];if(node.value.indexOf('[CDATA[')===0){node.name='#cdata';node.type=4;node.value=node.value.replace(/^\[CDATA\[|\]\]$/g,'');}else if(node.value.indexOf('mce:protected ')===0){node.name='#text';node.type=3;node.raw=true;node.value=unescape(node.value).substr(14);}}});htmlParser.addNodeFilter('xml:namespace,input',function(nodes,name){var i=nodes.length,node;while(i--){node=nodes[i];if(node.type===7){node.remove();}else if(node.type===1){if(name==='input'&&!('type'in node.attributes.map)){node.attr('type','text');}}}});htmlParser.addAttributeFilter('data-mce-type',function(nodes){each(nodes,function(node){if(node.attr('data-mce-type')==='format-caret'){if(node.isEmpty(htmlParser.schema.getNonEmptyElements())){node.remove();}else{node.unwrap();}}});});htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,'+'data-mce-selected,data-mce-expando,'+'data-mce-type,data-mce-resize',function(nodes,name){var i=nodes.length;while(i--){nodes[i].attr(name,null);}});};var trimTrailingBr=function trimTrailingBr(rootNode){var brNode1,brNode2;var isBr=function isBr(node){return node&&node.name==='br';};brNode1=rootNode.lastChild;if(isBr(brNode1)){brNode2=brNode1.prev;if(isBr(brNode2)){brNode1.remove();brNode2.remove();}}};var $_f02y3l6njk26xg3r={register:register,trimTrailingBr:trimTrailingBr};var preProcess=function preProcess(editor,node,args){var impl,doc,oldDoc;var dom=editor.dom;node=node.cloneNode(true);impl=document.implementation;if(impl.createHTMLDocument){doc=impl.createHTMLDocument('');$_2ytxahljk26xetf.each(node.nodeName==='BODY'?node.childNodes:[node],function(node){doc.body.appendChild(doc.importNode(node,true));});if(node.nodeName!=='BODY'){node=doc.body.firstChild;}else{node=doc.body;}oldDoc=dom.doc;dom.doc=doc;}$_8y7e5d4tjk26xfsd.firePreProcess(editor,merge(args,{node:node}));if(oldDoc){dom.doc=oldDoc;}return node;};var shouldFireEvent=function shouldFireEvent(editor,args){return editor&&editor.hasEventListeners('PreProcess')&&!args.no_events;};var process=function process(editor,node,args){return shouldFireEvent(editor,args)?preProcess(editor,node,args):node;};var $_c9bynd6ojk26xg3z={process:process};var removeAttrs=function removeAttrs(node,names){each(names,function(name){node.attr(name,null);});};var addFontToSpansFilter=function addFontToSpansFilter(domParser,styles,fontSizes){domParser.addNodeFilter('font',function(nodes){each(nodes,function(node){var props=styles.parse(node.attr('style'));var color=node.attr('color');var face=node.attr('face');var size=node.attr('size');if(color){props.color=color;}if(face){props['font-family']=face;}if(size){props['font-size']=fontSizes[parseInt(node.attr('size'),10)-1];}node.name='span';node.attr('style',styles.serialize(props));removeAttrs(node,['color','face','size']);});});};var addStrikeToSpanFilter=function addStrikeToSpanFilter(domParser,styles){domParser.addNodeFilter('strike',function(nodes){each(nodes,function(node){var props=styles.parse(node.attr('style'));props['text-decoration']='line-through';node.name='span';node.attr('style',styles.serialize(props));});});};var addFilters=function addFilters(domParser,settings){var styles=Styles();if(settings.convert_fonts_to_spans){addFontToSpansFilter(domParser,styles,$_2ytxahljk26xetf.explode(settings.font_size_legacy_values));}addStrikeToSpanFilter(domParser,styles);};var register$1=function register$1(domParser,settings){if(settings.inline_styles){addFilters(domParser,settings);}};var $_bc3ifq6qjk26xg4u={register:register$1};var whiteSpaceRegExp$3=/^[ \t\r\n]*$/;var typeLookup={'#text':3,'#comment':8,'#cdata':4,'#pi':7,'#doctype':10,'#document-fragment':11};var walk$3=function walk$3(node,root,prev){var sibling;var parent;var startName=prev?'lastChild':'firstChild';var siblingName=prev?'prev':'next';if(node[startName]){return node[startName];}if(node!==root){sibling=node[siblingName];if(sibling){return sibling;}for(parent=node.parent;parent&&parent!==root;parent=parent.parent){sibling=parent[siblingName];if(sibling){return sibling;}}}};var Node$2=function(){function Node(name,type){this.name=name;this.type=type;if(type===1){this.attributes=[];this.attributes.map={};}}Node.create=function(name,attrs){var node,attrName;node=new Node(name,typeLookup[name]||1);if(attrs){for(attrName in attrs){node.attr(attrName,attrs[attrName]);}}return node;};Node.prototype.replace=function(node){var self=this;if(node.parent){node.remove();}self.insert(node,self);self.remove();return self;};Node.prototype.attr=function(name,value){var self=this;var attrs,i;if(typeof name!=='string'){for(i in name){self.attr(i,name[i]);}return self;}if(attrs=self.attributes){if(value!==undefined){if(value===null){if(name in attrs.map){delete attrs.map[name];i=attrs.length;while(i--){if(attrs[i].name===name){attrs=attrs.splice(i,1);return self;}}}return self;}if(name in attrs.map){i=attrs.length;while(i--){if(attrs[i].name===name){attrs[i].value=value;break;}}}else{attrs.push({name:name,value:value});}attrs.map[name]=value;return self;}return attrs.map[name];}};Node.prototype.clone=function(){var self=this;var clone=new Node(self.name,self.type);var i,l,selfAttrs,selfAttr,cloneAttrs;if(selfAttrs=self.attributes){cloneAttrs=[];cloneAttrs.map={};for(i=0,l=selfAttrs.length;i<l;i++){selfAttr=selfAttrs[i];if(selfAttr.name!=='id'){cloneAttrs[cloneAttrs.length]={name:selfAttr.name,value:selfAttr.value};cloneAttrs.map[selfAttr.name]=selfAttr.value;}}clone.attributes=cloneAttrs;}clone.value=self.value;clone.shortEnded=self.shortEnded;return clone;};Node.prototype.wrap=function(wrapper){var self=this;self.parent.insert(wrapper,self);wrapper.append(self);return self;};Node.prototype.unwrap=function(){var self=this;var node,next;for(node=self.firstChild;node;){next=node.next;self.insert(node,self,true);node=next;}self.remove();};Node.prototype.remove=function(){var self=this,parent=self.parent,next=self.next,prev=self.prev;if(parent){if(parent.firstChild===self){parent.firstChild=next;if(next){next.prev=null;}}else{prev.next=next;}if(parent.lastChild===self){parent.lastChild=prev;if(prev){prev.next=null;}}else{next.prev=prev;}self.parent=self.next=self.prev=null;}return self;};Node.prototype.append=function(node){var self=this;var last;if(node.parent){node.remove();}last=self.lastChild;if(last){last.next=node;node.prev=last;self.lastChild=node;}else{self.lastChild=self.firstChild=node;}node.parent=self;return node;};Node.prototype.insert=function(node,refNode,before){var parent;if(node.parent){node.remove();}parent=refNode.parent||this;if(before){if(refNode===parent.firstChild){parent.firstChild=node;}else{refNode.prev.next=node;}node.prev=refNode.prev;node.next=refNode;refNode.prev=node;}else{if(refNode===parent.lastChild){parent.lastChild=node;}else{refNode.next.prev=node;}node.next=refNode.next;node.prev=refNode;refNode.next=node;}node.parent=parent;return node;};Node.prototype.getAll=function(name){var self=this;var node;var collection=[];for(node=self.firstChild;node;node=walk$3(node,self)){if(node.name===name){collection.push(node);}}return collection;};Node.prototype.empty=function(){var self=this;var nodes,i,node;if(self.firstChild){nodes=[];for(node=self.firstChild;node;node=walk$3(node,self)){nodes.push(node);}i=nodes.length;while(i--){node=nodes[i];node.parent=node.firstChild=node.lastChild=node.next=node.prev=null;}}self.firstChild=self.lastChild=null;return self;};Node.prototype.isEmpty=function(elements,whitespace,predicate){var self=this;var node=self.firstChild,i,name;whitespace=whitespace||{};if(node){do{if(node.type===1){if(node.attributes.map['data-mce-bogus']){continue;}if(elements[node.name]){return false;}i=node.attributes.length;while(i--){name=node.attributes[i].name;if(name==='name'||name.indexOf('data-mce-bookmark')===0){return false;}}}if(node.type===8){return false;}if(node.type===3&&!whiteSpaceRegExp$3.test(node.value)){return false;}if(node.type===3&&node.parent&&whitespace[node.parent.name]&&whiteSpaceRegExp$3.test(node.value)){return false;}if(predicate&&predicate(node)){return false;}}while(node=walk$3(node,self));}return true;};Node.prototype.walk=function(prev){return walk$3(this,null,prev);};return Node;}();var paddEmptyNode=function paddEmptyNode(settings,args,blockElements,node){var brPreferred=settings.padd_empty_with_br||args.insert;if(brPreferred&&blockElements[node.name]){node.empty().append(new Node$2('br',1)).shortEnded=true;}else{node.empty().append(new Node$2('#text',3)).value='\xA0';}};var isPaddedWithNbsp=function isPaddedWithNbsp(node){return hasOnlyChild(node,'#text')&&node.firstChild.value==='\xA0';};var hasOnlyChild=function hasOnlyChild(node,name){return node&&node.firstChild&&node.firstChild===node.lastChild&&node.firstChild.name===name;};var isPadded=function isPadded(schema,node){var rule=schema.getElementRule(node.name);return rule&&rule.paddEmpty;};var isEmpty$2=function isEmpty$2(schema,nonEmptyElements,whitespaceElements,node){return node.isEmpty(nonEmptyElements,whitespaceElements,function(node){return isPadded(schema,node);});};var isLineBreakNode=function isLineBreakNode(node,blockElements){return node&&(blockElements[node.name]||node.name==='br');};var register$2=function register$2(parser,settings){var schema=parser.schema;if(settings.remove_trailing_brs){parser.addNodeFilter('br',function(nodes,_,args){var i;var l=nodes.length;var node;var blockElements=$_2ytxahljk26xetf.extend({},schema.getBlockElements());var nonEmptyElements=schema.getNonEmptyElements();var parent,lastParent,prev,prevName;var whiteSpaceElements=schema.getNonEmptyElements();var elementRule,textNode;blockElements.body=1;for(i=0;i<l;i++){node=nodes[i];parent=node.parent;if(blockElements[node.parent.name]&&node===parent.lastChild){prev=node.prev;while(prev){prevName=prev.name;if(prevName!=='span'||prev.attr('data-mce-type')!=='bookmark'){if(prevName!=='br'){break;}if(prevName==='br'){node=null;break;}}prev=prev.prev;}if(node){node.remove();if(isEmpty$2(schema,nonEmptyElements,whiteSpaceElements,parent)){elementRule=schema.getElementRule(parent.name);if(elementRule){if(elementRule.removeEmpty){parent.remove();}else if(elementRule.paddEmpty){paddEmptyNode(settings,args,blockElements,parent);}}}}}else{lastParent=node;while(parent&&parent.firstChild===lastParent&&parent.lastChild===lastParent){lastParent=parent;if(blockElements[parent.name]){break;}parent=parent.parent;}if(lastParent===parent&&settings.padd_empty_with_br!==true){textNode=new Node$2('#text',3);textNode.value='\xA0';node.replace(textNode);}}}});}parser.addAttributeFilter('href',function(nodes){var i=nodes.length,node;var appendRel=function appendRel(rel){var parts=rel.split(' ').filter(function(p){return p.length>0;});return parts.concat(['noopener']).sort().join(' ');};var addNoOpener=function addNoOpener(rel){var newRel=rel?$_2ytxahljk26xetf.trim(rel):'';if(!/\b(noopener)\b/g.test(newRel)){return appendRel(newRel);}else{return newRel;}};if(!settings.allow_unsafe_link_target){while(i--){node=nodes[i];if(node.name==='a'&&node.attr('target')==='_blank'){node.attr('rel',addNoOpener(node.attr('rel')));}}}});if(!settings.allow_html_in_named_anchor){parser.addAttributeFilter('id,name',function(nodes){var i=nodes.length,sibling,prevSibling,parent,node;while(i--){node=nodes[i];if(node.name==='a'&&node.firstChild&&!node.attr('href')){parent=node.parent;sibling=node.lastChild;do{prevSibling=sibling.prev;parent.insert(sibling,node);sibling=prevSibling;}while(sibling);}}});}if(settings.fix_list_elements){parser.addNodeFilter('ul,ol',function(nodes){var i=nodes.length,node,parentNode;while(i--){node=nodes[i];parentNode=node.parent;if(parentNode.name==='ul'||parentNode.name==='ol'){if(node.prev&&node.prev.name==='li'){node.prev.append(node);}else{var li=new Node$2('li',1);li.attr('style','list-style-type: none');node.wrap(li);}}}});}if(settings.validate&&schema.getValidClasses()){parser.addAttributeFilter('class',function(nodes){var i=nodes.length,node,classList,ci,className,classValue;var validClasses=schema.getValidClasses();var validClassesMap,valid;while(i--){node=nodes[i];classList=node.attr('class').split(' ');classValue='';for(ci=0;ci<classList.length;ci++){className=classList[ci];valid=false;validClassesMap=validClasses['*'];if(validClassesMap&&validClassesMap[className]){valid=true;}validClassesMap=validClasses[node.name];if(!valid&&validClassesMap&&validClassesMap[className]){valid=true;}if(valid){if(classValue){classValue+=' ';}classValue+=className;}}if(!classValue.length){classValue=null;}node.attr('class',classValue);}});}};var makeMap$4=$_2ytxahljk26xetf.makeMap;var each$18=$_2ytxahljk26xetf.each;var explode$3=$_2ytxahljk26xetf.explode;var extend$3=$_2ytxahljk26xetf.extend;function DomParser(settings,schema){if(schema===void 0){schema=Schema();}var nodeFilters={};var attributeFilters=[];var matchedNodes={};var matchedAttributes={};settings=settings||{};settings.validate='validate'in settings?settings.validate:true;settings.root_name=settings.root_name||'body';var fixInvalidChildren=function fixInvalidChildren(nodes){var ni,node,parent,parents,newParent,currentNode,tempNode,childNode,i;var nonEmptyElements,whitespaceElements,nonSplitableElements,textBlockElements,specialElements,sibling,nextNode;nonSplitableElements=makeMap$4('tr,td,th,tbody,thead,tfoot,table');nonEmptyElements=schema.getNonEmptyElements();whitespaceElements=schema.getWhiteSpaceElements();textBlockElements=schema.getTextBlockElements();specialElements=schema.getSpecialElements();for(ni=0;ni<nodes.length;ni++){node=nodes[ni];if(!node.parent||node.fixed){continue;}if(textBlockElements[node.name]&&node.parent.name==='li'){sibling=node.next;while(sibling){if(textBlockElements[sibling.name]){sibling.name='li';sibling.fixed=true;node.parent.insert(sibling,node.parent);}else{break;}sibling=sibling.next;}node.unwrap(node);continue;}parents=[node];for(parent=node.parent;parent&&!schema.isValidChild(parent.name,node.name)&&!nonSplitableElements[parent.name];parent=parent.parent){parents.push(parent);}if(parent&&parents.length>1){parents.reverse();newParent=currentNode=filterNode(parents[0].clone());for(i=0;i<parents.length-1;i++){if(schema.isValidChild(currentNode.name,parents[i].name)){tempNode=filterNode(parents[i].clone());currentNode.append(tempNode);}else{tempNode=currentNode;}for(childNode=parents[i].firstChild;childNode&&childNode!==parents[i+1];){nextNode=childNode.next;tempNode.append(childNode);childNode=nextNode;}currentNode=tempNode;}if(!isEmpty$2(schema,nonEmptyElements,whitespaceElements,newParent)){parent.insert(newParent,parents[0],true);parent.insert(node,newParent);}else{parent.insert(node,parents[0],true);}parent=parents[0];if(isEmpty$2(schema,nonEmptyElements,whitespaceElements,parent)||hasOnlyChild(parent,'br')){parent.empty().remove();}}else if(node.parent){if(node.name==='li'){sibling=node.prev;if(sibling&&(sibling.name==='ul'||sibling.name==='ul')){sibling.append(node);continue;}sibling=node.next;if(sibling&&(sibling.name==='ul'||sibling.name==='ul')){sibling.insert(node,sibling.firstChild,true);continue;}node.wrap(filterNode(new Node$2('ul',1)));continue;}if(schema.isValidChild(node.parent.name,'div')&&schema.isValidChild('div',node.name)){node.wrap(filterNode(new Node$2('div',1)));}else{if(specialElements[node.name]){node.empty().remove();}else{node.unwrap();}}}}};var filterNode=function filterNode(node){var i,name,list;if(name in nodeFilters){list=matchedNodes[name];if(list){list.push(node);}else{matchedNodes[name]=[node];}}i=attributeFilters.length;while(i--){name=attributeFilters[i].name;if(name in node.attributes.map){list=matchedAttributes[name];if(list){list.push(node);}else{matchedAttributes[name]=[node];}}}return node;};var addNodeFilter=function addNodeFilter(name,callback){each$18(explode$3(name),function(name){var list=nodeFilters[name];if(!list){nodeFilters[name]=list=[];}list.push(callback);});};var getNodeFilters=function getNodeFilters(){var out=[];for(var name in nodeFilters){if(nodeFilters.hasOwnProperty(name)){out.push({name:name,callbacks:nodeFilters[name]});}}return out;};var addAttributeFilter=function addAttributeFilter(name,callback){each$18(explode$3(name),function(name){var i;for(i=0;i<attributeFilters.length;i++){if(attributeFilters[i].name===name){attributeFilters[i].callbacks.push(callback);return;}}attributeFilters.push({name:name,callbacks:[callback]});});};var getAttributeFilters=function getAttributeFilters(){return[].concat(attributeFilters);};var parse=function parse(html,args){var parser,nodes,i,l,fi,fl,list,name;var blockElements;var invalidChildren=[];var isInWhiteSpacePreservedElement;var node;args=args||{};matchedNodes={};matchedAttributes={};blockElements=extend$3(makeMap$4('script,style,head,html,body,title,meta,param'),schema.getBlockElements());var nonEmptyElements=schema.getNonEmptyElements();var children=schema.children;var validate=settings.validate;var rootBlockName='forced_root_block'in args?args.forced_root_block:settings.forced_root_block;var whiteSpaceElements=schema.getWhiteSpaceElements();var startWhiteSpaceRegExp=/^[ \t\r\n]+/;var endWhiteSpaceRegExp=/[ \t\r\n]+$/;var allWhiteSpaceRegExp=/[ \t\r\n]+/g;var isAllWhiteSpaceRegExp=/^[ \t\r\n]+$/;isInWhiteSpacePreservedElement=whiteSpaceElements.hasOwnProperty(args.context)||whiteSpaceElements.hasOwnProperty(settings.root_name);var addRootBlocks=function addRootBlocks(){var node=rootNode.firstChild,next,rootBlockNode;var trim=function trim(rootBlockNode){if(rootBlockNode){node=rootBlockNode.firstChild;if(node&&node.type===3){node.value=node.value.replace(startWhiteSpaceRegExp,'');}node=rootBlockNode.lastChild;if(node&&node.type===3){node.value=node.value.replace(endWhiteSpaceRegExp,'');}}};if(!schema.isValidChild(rootNode.name,rootBlockName.toLowerCase())){return;}while(node){next=node.next;if(node.type===3||node.type===1&&node.name!=='p'&&!blockElements[node.name]&&!node.attr('data-mce-type')){if(!rootBlockNode){rootBlockNode=createNode(rootBlockName,1);rootBlockNode.attr(settings.forced_root_block_attrs);rootNode.insert(rootBlockNode,node);rootBlockNode.append(node);}else{rootBlockNode.append(node);}}else{trim(rootBlockNode);rootBlockNode=null;}node=next;}trim(rootBlockNode);};var createNode=function createNode(name,type){var node=new Node$2(name,type);var list;if(name in nodeFilters){list=matchedNodes[name];if(list){list.push(node);}else{matchedNodes[name]=[node];}}return node;};var removeWhitespaceBefore=function removeWhitespaceBefore(node){var textNode,textNodeNext,textVal,sibling;var blockElements=schema.getBlockElements();for(textNode=node.prev;textNode&&textNode.type===3;){textVal=textNode.value.replace(endWhiteSpaceRegExp,'');if(textVal.length>0){textNode.value=textVal;return;}textNodeNext=textNode.next;if(textNodeNext){if(textNodeNext.type===3&&textNodeNext.value.length){textNode=textNode.prev;continue;}if(!blockElements[textNodeNext.name]&&textNodeNext.name!=='script'&&textNodeNext.name!=='style'){textNode=textNode.prev;continue;}}sibling=textNode.prev;textNode.remove();textNode=sibling;}};var cloneAndExcludeBlocks=function cloneAndExcludeBlocks(input){var name;var output={};for(name in input){if(name!=='li'&&name!=='p'){output[name]=input[name];}}return output;};parser=SaxParser$1({validate:validate,allow_script_urls:settings.allow_script_urls,allow_conditional_comments:settings.allow_conditional_comments,self_closing_elements:cloneAndExcludeBlocks(schema.getSelfClosingElements()),cdata:function cdata(text){node.append(createNode('#cdata',4)).value=text;},text:function text(_text2,raw){var textNode;if(!isInWhiteSpacePreservedElement){_text2=_text2.replace(allWhiteSpaceRegExp,' ');if(isLineBreakNode(node.lastChild,blockElements)){_text2=_text2.replace(startWhiteSpaceRegExp,'');}}if(_text2.length!==0){textNode=createNode('#text',3);textNode.raw=!!raw;node.append(textNode).value=_text2;}},comment:function comment(text){node.append(createNode('#comment',8)).value=text;},pi:function pi(name,text){node.append(createNode(name,7)).value=text;removeWhitespaceBefore(node);},doctype:function doctype(text){var newNode;newNode=node.append(createNode('#doctype',10));newNode.value=text;removeWhitespaceBefore(node);},start:function start(name,attrs,empty){var newNode,attrFiltersLen,elementRule,attrName,parent;elementRule=validate?schema.getElementRule(name):{};if(elementRule){newNode=createNode(elementRule.outputName||name,1);newNode.attributes=attrs;newNode.shortEnded=empty;node.append(newNode);parent=children[node.name];if(parent&&children[newNode.name]&&!parent[newNode.name]){invalidChildren.push(newNode);}attrFiltersLen=attributeFilters.length;while(attrFiltersLen--){attrName=attributeFilters[attrFiltersLen].name;if(attrName in attrs.map){list=matchedAttributes[attrName];if(list){list.push(newNode);}else{matchedAttributes[attrName]=[newNode];}}}if(blockElements[name]){removeWhitespaceBefore(newNode);}if(!empty){node=newNode;}if(!isInWhiteSpacePreservedElement&&whiteSpaceElements[name]){isInWhiteSpacePreservedElement=true;}}},end:function end(name){var textNode,elementRule,text,sibling,tempNode;elementRule=validate?schema.getElementRule(name):{};if(elementRule){if(blockElements[name]){if(!isInWhiteSpacePreservedElement){textNode=node.firstChild;if(textNode&&textNode.type===3){text=textNode.value.replace(startWhiteSpaceRegExp,'');if(text.length>0){textNode.value=text;textNode=textNode.next;}else{sibling=textNode.next;textNode.remove();textNode=sibling;while(textNode&&textNode.type===3){text=textNode.value;sibling=textNode.next;if(text.length===0||isAllWhiteSpaceRegExp.test(text)){textNode.remove();textNode=sibling;}textNode=sibling;}}}textNode=node.lastChild;if(textNode&&textNode.type===3){text=textNode.value.replace(endWhiteSpaceRegExp,'');if(text.length>0){textNode.value=text;textNode=textNode.prev;}else{sibling=textNode.prev;textNode.remove();textNode=sibling;while(textNode&&textNode.type===3){text=textNode.value;sibling=textNode.prev;if(text.length===0||isAllWhiteSpaceRegExp.test(text)){textNode.remove();textNode=sibling;}textNode=sibling;}}}}}if(isInWhiteSpacePreservedElement&&whiteSpaceElements[name]){isInWhiteSpacePreservedElement=false;}if(elementRule.removeEmpty&&isEmpty$2(schema,nonEmptyElements,whiteSpaceElements,node)){if(!node.attributes.map.name&&!node.attr('id')){tempNode=node.parent;if(blockElements[node.name]){node.empty().remove();}else{node.unwrap();}node=tempNode;return;}}if(elementRule.paddEmpty&&(isPaddedWithNbsp(node)||isEmpty$2(schema,nonEmptyElements,whiteSpaceElements,node))){paddEmptyNode(settings,args,blockElements,node);}node=node.parent;}}},schema);var rootNode=node=new Node$2(args.context||settings.root_name,11);parser.parse(html);if(validate&&invalidChildren.length){if(!args.context){fixInvalidChildren(invalidChildren);}else{args.invalid=true;}}if(rootBlockName&&(rootNode.name==='body'||args.isRootContent)){addRootBlocks();}if(!args.invalid){for(name in matchedNodes){list=nodeFilters[name];nodes=matchedNodes[name];fi=nodes.length;while(fi--){if(!nodes[fi].parent){nodes.splice(fi,1);}}for(i=0,l=list.length;i<l;i++){list[i](nodes,name,args);}}for(i=0,l=attributeFilters.length;i<l;i++){list=attributeFilters[i];if(list.name in matchedAttributes){nodes=matchedAttributes[list.name];fi=nodes.length;while(fi--){if(!nodes[fi].parent){nodes.splice(fi,1);}}for(fi=0,fl=list.callbacks.length;fi<fl;fi++){list.callbacks[fi](nodes,list.name,args);}}}}return rootNode;};var exports={schema:schema,addAttributeFilter:addAttributeFilter,getAttributeFilters:getAttributeFilters,addNodeFilter:addNodeFilter,getNodeFilters:getNodeFilters,filterNode:filterNode,parse:parse};register$2(exports,settings);$_bc3ifq6qjk26xg4u.register(exports,settings);return exports;}var addTempAttr=function addTempAttr(htmlParser,tempAttrs,name){if($_2ytxahljk26xetf.inArray(tempAttrs,name)===-1){htmlParser.addAttributeFilter(name,function(nodes,name){var i=nodes.length;while(i--){nodes[i].attr(name,null);}});tempAttrs.push(name);}};var postProcess$1=function postProcess$1(editor,args,content){if(!args.no_events&&editor){var outArgs=$_8y7e5d4tjk26xfsd.firePostProcess(editor,merge(args,{content:content}));return outArgs.content;}else{return content;}};var getHtmlFromNode=function getHtmlFromNode(dom,node,args){var html=$_4osibw2pjk26xf83.trim(args.getInner?node.innerHTML:dom.getOuterHTML(node));return args.selection||isWsPreserveElement(Element$$1.fromDom(node))?html:$_2ytxahljk26xetf.trim(html);};var parseHtml=function parseHtml(htmlParser,html,args){var parserArgs=args.selection?merge({forced_root_block:false},args):args;var rootNode=htmlParser.parse(html,parserArgs);$_f02y3l6njk26xg3r.trimTrailingBr(rootNode);return rootNode;};var serializeNode=function serializeNode(settings,schema,node){var htmlSerializer=HtmlSerializer(settings,schema);return htmlSerializer.serialize(node);};var toHtml=function toHtml(editor,settings,schema,rootNode,args){var content=serializeNode(settings,schema,rootNode);return postProcess$1(editor,args,content);};function DomSerializer(settings,editor){var dom,schema,htmlParser;var tempAttrs=['data-mce-selected'];dom=editor&&editor.dom?editor.dom:DOMUtils$1.DOM;schema=editor&&editor.schema?editor.schema:Schema(settings);settings.entity_encoding=settings.entity_encoding||'named';settings.remove_trailing_brs='remove_trailing_brs'in settings?settings.remove_trailing_brs:true;htmlParser=DomParser(settings,schema);$_f02y3l6njk26xg3r.register(htmlParser,settings,dom);var serialize=function serialize(node,parserArgs){var args=merge({format:'html'},parserArgs?parserArgs:{});var targetNode=$_c9bynd6ojk26xg3z.process(editor,node,args);var html=getHtmlFromNode(dom,targetNode,args);var rootNode=parseHtml(htmlParser,html,args);return args.format==='tree'?rootNode:toHtml(editor,settings,schema,rootNode,args);};return{schema:schema,addNodeFilter:htmlParser.addNodeFilter,addAttributeFilter:htmlParser.addAttributeFilter,serialize:serialize,addRules:function addRules(rules){schema.addValidElements(rules);},setRules:function setRules(rules){schema.setValidElements(rules);},addTempAttr:curry(addTempAttr,htmlParser,tempAttrs),getTempAttrs:function getTempAttrs(){return tempAttrs;}};}function DomSerializer$1(settings,editor){var domSerializer=DomSerializer(settings,editor);return{schema:domSerializer.schema,addNodeFilter:domSerializer.addNodeFilter,addAttributeFilter:domSerializer.addAttributeFilter,serialize:domSerializer.serialize,addRules:domSerializer.addRules,setRules:domSerializer.setRules,addTempAttr:domSerializer.addTempAttr,getTempAttrs:domSerializer.getTempAttrs};}function BookmarkManager(selection){return{getBookmark:curry($_2wdci52vjk26xf8r.getBookmark,selection),moveToBookmark:curry($_2wdci52vjk26xf8r.moveToBookmark,selection)};}(function(BookmarkManager){BookmarkManager.isBookmarkNode=$_2wdci52vjk26xf8r.isBookmarkNode;})(BookmarkManager||(BookmarkManager={}));var BookmarkManager$1=BookmarkManager;var isContentEditableFalse$10=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var isContentEditableTrue$6=$_fpgwqg1rjk26xf0n.isContentEditableTrue;var getContentEditableRoot$2=function getContentEditableRoot$2(root,node){while(node&&node!==root){if(isContentEditableTrue$6(node)||isContentEditableFalse$10(node)){return node;}node=node.parentNode;}return null;};var ControlSelection=function ControlSelection(selection,editor){var dom=editor.dom,each=$_2ytxahljk26xetf.each;var selectedElm,selectedElmGhost,resizeHelper,resizeHandles,selectedHandle;var startX,startY,selectedElmX,selectedElmY,startW,startH,ratio,resizeStarted;var width,height;var editableDoc=editor.getDoc(),rootDocument=document;var abs=Math.abs,round=Math.round,rootElement=editor.getBody();var startScrollWidth,startScrollHeight;resizeHandles={nw:[0,0,-1,-1],ne:[1,0,1,-1],se:[1,1,1,1],sw:[0,1,-1,1]};var rootClass='.mce-content-body';editor.contentStyles.push(rootClass+' div.mce-resizehandle {'+'position: absolute;'+'border: 1px solid black;'+'box-sizing: content-box;'+'background: #FFF;'+'width: 7px;'+'height: 7px;'+'z-index: 10000'+'}'+rootClass+' .mce-resizehandle:hover {'+'background: #000'+'}'+rootClass+' img[data-mce-selected],'+rootClass+' hr[data-mce-selected] {'+'outline: 1px solid black;'+'resize: none'+'}'+rootClass+' .mce-clonedresizable {'+'position: absolute;'+($_ef6mqpajk26xejm.gecko?'':'outline: 1px dashed black;')+'opacity: .5;'+'filter: alpha(opacity=50);'+'z-index: 10000'+'}'+rootClass+' .mce-resize-helper {'+'background: #555;'+'background: rgba(0,0,0,0.75);'+'border-radius: 3px;'+'border: 1px;'+'color: white;'+'display: none;'+'font-family: sans-serif;'+'font-size: 12px;'+'white-space: nowrap;'+'line-height: 14px;'+'margin: 5px 10px;'+'padding: 5px;'+'position: absolute;'+'z-index: 10001'+'}');var isImage=function isImage(elm){return elm&&(elm.nodeName==='IMG'||editor.dom.is(elm,'figure.image'));};var isEventOnImageOutsideRange=function isEventOnImageOutsideRange(evt,range){return isImage(evt.target)&&!$_5vc3d45ujk26xfyx.isXYWithinRange(evt.clientX,evt.clientY,range);};var contextMenuSelectImage=function contextMenuSelectImage(evt){var target=evt.target;if(isEventOnImageOutsideRange(evt,editor.selection.getRng())&&!evt.isDefaultPrevented()){evt.preventDefault();editor.selection.select(target);}};var getResizeTarget=function getResizeTarget(elm){return editor.dom.is(elm,'figure.image')?elm.querySelector('img'):elm;};var isResizable=function isResizable(elm){var selector=editor.settings.object_resizing;if(selector===false||$_ef6mqpajk26xejm.iOS){return false;}if(typeof selector!=='string'){selector='table,img,figure.image,div';}if(elm.getAttribute('data-mce-resize')==='false'){return false;}if(elm===editor.getBody()){return false;}return $_95wtq21gjk26xeyv.is(Element$$1.fromDom(elm),selector);};var resizeGhostElement=function resizeGhostElement(e){var deltaX,deltaY,proportional;var resizeHelperX,resizeHelperY;deltaX=e.screenX-startX;deltaY=e.screenY-startY;width=deltaX*selectedHandle[2]+startW;height=deltaY*selectedHandle[3]+startH;width=width<5?5:width;height=height<5?5:height;if(isImage(selectedElm)&&editor.settings.resize_img_proportional!==false){proportional=!$_o3p025wjk26xfz2.modifierPressed(e);}else{proportional=$_o3p025wjk26xfz2.modifierPressed(e)||isImage(selectedElm)&&selectedHandle[2]*selectedHandle[3]!==0;}if(proportional){if(abs(deltaX)>abs(deltaY)){height=round(width*ratio);width=round(height/ratio);}else{width=round(height/ratio);height=round(width*ratio);}}dom.setStyles(getResizeTarget(selectedElmGhost),{width:width,height:height});resizeHelperX=selectedHandle.startPos.x+deltaX;resizeHelperY=selectedHandle.startPos.y+deltaY;resizeHelperX=resizeHelperX>0?resizeHelperX:0;resizeHelperY=resizeHelperY>0?resizeHelperY:0;dom.setStyles(resizeHelper,{left:resizeHelperX,top:resizeHelperY,display:'block'});resizeHelper.innerHTML=width+' &times; '+height;if(selectedHandle[2]<0&&selectedElmGhost.clientWidth<=width){dom.setStyle(selectedElmGhost,'left',selectedElmX+(startW-width));}if(selectedHandle[3]<0&&selectedElmGhost.clientHeight<=height){dom.setStyle(selectedElmGhost,'top',selectedElmY+(startH-height));}deltaX=rootElement.scrollWidth-startScrollWidth;deltaY=rootElement.scrollHeight-startScrollHeight;if(deltaX+deltaY!==0){dom.setStyles(resizeHelper,{left:resizeHelperX-deltaX,top:resizeHelperY-deltaY});}if(!resizeStarted){$_8y7e5d4tjk26xfsd.fireObjectResizeStart(editor,selectedElm,startW,startH);resizeStarted=true;}};var endGhostResize=function endGhostResize(){resizeStarted=false;var setSizeProp=function setSizeProp(name$$1,value){if(value){if(selectedElm.style[name$$1]||!editor.schema.isValid(selectedElm.nodeName.toLowerCase(),name$$1)){dom.setStyle(getResizeTarget(selectedElm),name$$1,value);}else{dom.setAttrib(getResizeTarget(selectedElm),name$$1,value);}}};setSizeProp('width',width);setSizeProp('height',height);dom.unbind(editableDoc,'mousemove',resizeGhostElement);dom.unbind(editableDoc,'mouseup',endGhostResize);if(rootDocument!==editableDoc){dom.unbind(rootDocument,'mousemove',resizeGhostElement);dom.unbind(rootDocument,'mouseup',endGhostResize);}dom.remove(selectedElmGhost);dom.remove(resizeHelper);showResizeRect(selectedElm);$_8y7e5d4tjk26xfsd.fireObjectResized(editor,selectedElm,width,height);dom.setAttrib(selectedElm,'style',dom.getAttrib(selectedElm,'style'));editor.nodeChanged();};var showResizeRect=function showResizeRect(targetElm){var position,targetWidth,targetHeight,e,rect;hideResizeRect();unbindResizeHandleEvents();position=dom.getPos(targetElm,rootElement);selectedElmX=position.x;selectedElmY=position.y;rect=targetElm.getBoundingClientRect();targetWidth=rect.width||rect.right-rect.left;targetHeight=rect.height||rect.bottom-rect.top;if(selectedElm!==targetElm){selectedElm=targetElm;width=height=0;}e=editor.fire('ObjectSelected',{target:targetElm});if(isResizable(targetElm)&&!e.isDefaultPrevented()){each(resizeHandles,function(handle,name$$1){var handleElm;var startDrag=function startDrag(e){startX=e.screenX;startY=e.screenY;startW=getResizeTarget(selectedElm).clientWidth;startH=getResizeTarget(selectedElm).clientHeight;ratio=startH/startW;selectedHandle=handle;handle.startPos={x:targetWidth*handle[0]+selectedElmX,y:targetHeight*handle[1]+selectedElmY};startScrollWidth=rootElement.scrollWidth;startScrollHeight=rootElement.scrollHeight;selectedElmGhost=selectedElm.cloneNode(true);dom.addClass(selectedElmGhost,'mce-clonedresizable');dom.setAttrib(selectedElmGhost,'data-mce-bogus','all');selectedElmGhost.contentEditable=false;selectedElmGhost.unSelectabe=true;dom.setStyles(selectedElmGhost,{left:selectedElmX,top:selectedElmY,margin:0});selectedElmGhost.removeAttribute('data-mce-selected');rootElement.appendChild(selectedElmGhost);dom.bind(editableDoc,'mousemove',resizeGhostElement);dom.bind(editableDoc,'mouseup',endGhostResize);if(rootDocument!==editableDoc){dom.bind(rootDocument,'mousemove',resizeGhostElement);dom.bind(rootDocument,'mouseup',endGhostResize);}resizeHelper=dom.add(rootElement,'div',{'class':'mce-resize-helper','data-mce-bogus':'all'},startW+' &times; '+startH);};handleElm=dom.get('mceResizeHandle'+name$$1);if(handleElm){dom.remove(handleElm);}handleElm=dom.add(rootElement,'div',{'id':'mceResizeHandle'+name$$1,'data-mce-bogus':'all','class':'mce-resizehandle','unselectable':true,'style':'cursor:'+name$$1+'-resize; margin:0; padding:0'});if($_ef6mqpajk26xejm.ie===11){handleElm.contentEditable=false;}dom.bind(handleElm,'mousedown',function(e){e.stopImmediatePropagation();e.preventDefault();startDrag(e);});handle.elm=handleElm;dom.setStyles(handleElm,{left:targetWidth*handle[0]+selectedElmX-handleElm.offsetWidth/2,top:targetHeight*handle[1]+selectedElmY-handleElm.offsetHeight/2});});}else{hideResizeRect();}selectedElm.setAttribute('data-mce-selected','1');};var hideResizeRect=function hideResizeRect(){var name$$1,handleElm;unbindResizeHandleEvents();if(selectedElm){selectedElm.removeAttribute('data-mce-selected');}for(name$$1 in resizeHandles){handleElm=dom.get('mceResizeHandle'+name$$1);if(handleElm){dom.unbind(handleElm);dom.remove(handleElm);}}};var updateResizeRect=function updateResizeRect(e){var startElm,controlElm;var isChildOrEqual=function isChildOrEqual(node,parent$$1){if(node){do{if(node===parent$$1){return true;}}while(node=node.parentNode);}};if(resizeStarted||editor.removed){return;}each(dom.select('img[data-mce-selected],hr[data-mce-selected]'),function(img){img.removeAttribute('data-mce-selected');});controlElm=e.type==='mousedown'?e.target:selection.getNode();controlElm=dom.$(controlElm).closest('table,img,figure.image,hr')[0];if(isChildOrEqual(controlElm,rootElement)){disableGeckoResize();startElm=selection.getStart(true);if(isChildOrEqual(startElm,controlElm)&&isChildOrEqual(selection.getEnd(true),controlElm)){showResizeRect(controlElm);return;}}hideResizeRect();};var isWithinContentEditableFalse=function isWithinContentEditableFalse(elm){return isContentEditableFalse$10(getContentEditableRoot$2(editor.getBody(),elm));};var unbindResizeHandleEvents=function unbindResizeHandleEvents(){for(var name$$1 in resizeHandles){var handle=resizeHandles[name$$1];if(handle.elm){dom.unbind(handle.elm);delete handle.elm;}}};var disableGeckoResize=function disableGeckoResize(){try{editor.getDoc().execCommand('enableObjectResizing',false,false);}catch(ex){}};editor.on('init',function(){disableGeckoResize();if($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie>=11){editor.on('mousedown click',function(e){var target=e.target,nodeName=target.nodeName;if(!resizeStarted&&/^(TABLE|IMG|HR)$/.test(nodeName)&&!isWithinContentEditableFalse(target)){if(e.button!==2){editor.selection.select(target,nodeName==='TABLE');}if(e.type==='mousedown'){editor.nodeChanged();}}});editor.dom.bind(rootElement,'mscontrolselect',function(e){var delayedSelect=function delayedSelect(node){$_3a7ompijk26xer0.setEditorTimeout(editor,function(){editor.selection.select(node);});};if(isWithinContentEditableFalse(e.target)){e.preventDefault();delayedSelect(e.target);return;}if(/^(TABLE|IMG|HR)$/.test(e.target.nodeName)){e.preventDefault();if(e.target.tagName==='IMG'){delayedSelect(e.target);}}});}var throttledUpdateResizeRect=$_3a7ompijk26xer0.throttle(function(e){if(!editor.composing){updateResizeRect(e);}});editor.on('nodechange ResizeEditor ResizeWindow drop FullscreenStateChanged',throttledUpdateResizeRect);editor.on('keyup compositionend',function(e){if(selectedElm&&selectedElm.nodeName==='TABLE'){throttledUpdateResizeRect(e);}});editor.on('hide blur',hideResizeRect);editor.on('contextmenu',contextMenuSelectImage);});editor.on('remove',unbindResizeHandleEvents);var destroy=function destroy(){selectedElm=selectedElmGhost=null;};return{isResizable:isResizable,showResizeRect:showResizeRect,hideResizeRect:hideResizeRect,updateResizeRect:updateResizeRect,destroy:destroy};};var hasCeProperty=function hasCeProperty(node){return $_fpgwqg1rjk26xf0n.isContentEditableTrue(node)||$_fpgwqg1rjk26xf0n.isContentEditableFalse(node);};var findParent$1=function findParent$1(node,rootNode,predicate){while(node&&node!==rootNode){if(predicate(node)){return node;}node=node.parentNode;}return null;};var findClosestIeRange=function findClosestIeRange(clientX,clientY,doc){var element,rng,rects;element=doc.elementFromPoint(clientX,clientY);rng=doc.body.createTextRange();if(!element||element.tagName==='HTML'){element=doc.body;}rng.moveToElementText(element);rects=$_2ytxahljk26xetf.toArray(rng.getClientRects());rects=rects.sort(function(a,b){a=Math.abs(Math.max(a.top-clientY,a.bottom-clientY));b=Math.abs(Math.max(b.top-clientY,b.bottom-clientY));return a-b;});if(rects.length>0){clientY=(rects[0].bottom+rects[0].top)/2;try{rng.moveToPoint(clientX,clientY);rng.collapse(true);return rng;}catch(ex){}}return null;};var moveOutOfContentEditableFalse=function moveOutOfContentEditableFalse(rng,rootNode){var parentElement=rng&&rng.parentElement?rng.parentElement():null;return $_fpgwqg1rjk26xf0n.isContentEditableFalse(findParent$1(parentElement,rootNode,hasCeProperty))?null:rng;};var fromPoint$1=function fromPoint$1(clientX,clientY,doc){var rng,point;var pointDoc=doc;if(pointDoc.caretPositionFromPoint){point=pointDoc.caretPositionFromPoint(clientX,clientY);if(point){rng=doc.createRange();rng.setStart(point.offsetNode,point.offset);rng.collapse(true);}}else if(doc.caretRangeFromPoint){rng=doc.caretRangeFromPoint(clientX,clientY);}else if(pointDoc.body.createTextRange){rng=pointDoc.body.createTextRange();try{rng.moveToPoint(clientX,clientY);rng.collapse(true);}catch(ex){rng=findClosestIeRange(clientX,clientY,doc);}return moveOutOfContentEditableFalse(rng,doc.body);}return rng;};var $_11ohb66xjk26xg6m={fromPoint:fromPoint$1};var processRanges=function processRanges(editor,ranges){return map(ranges,function(range$$1){var evt=editor.fire('GetSelectionRange',{range:range$$1});return evt.range!==range$$1?evt.range:range$$1;});};var $_d6zwjd6yjk26xg6o={processRanges:processRanges};var fromElements=function fromElements(elements,scope){var doc=scope||document;var fragment=doc.createDocumentFragment();each(elements,function(element){fragment.appendChild(element.dom());});return Element$$1.fromDom(fragment);};var $_evjgls71jk26xg7b={fromElements:fromElements};var tableModel=Immutable('element','width','rows');var tableRow=Immutable('element','cells');var cellPosition=Immutable('x','y');var getSpan=function getSpan(td,key){var value=parseInt($_5xapbx15jk26xewz.get(td,key),10);return isNaN(value)?1:value;};var fillout=function fillout(table,x,y,tr,td){var rowspan=getSpan(td,'rowspan');var colspan=getSpan(td,'colspan');var rows=table.rows();for(var y2=y;y2<y+rowspan;y2++){if(!rows[y2]){rows[y2]=tableRow($_39bcz42ijk26xf6i.deep(tr),[]);}for(var x2=x;x2<x+colspan;x2++){var cells=rows[y2].cells();cells[x2]=y2===y&&x2===x?td:$_39bcz42ijk26xf6i.shallow(td);}}};var cellExists=function cellExists(table,x,y){var rows=table.rows();var cells=rows[y]?rows[y].cells():[];return!!cells[x];};var skipCellsX=function skipCellsX(table,x,y){while(cellExists(table,x,y)){x++;}return x;};var getWidth=function getWidth(rows){return foldl(rows,function(acc,row){return row.cells().length>acc?row.cells().length:acc;},0);};var findElementPos=function findElementPos(table,element){var rows=table.rows();for(var y=0;y<rows.length;y++){var cells=rows[y].cells();for(var x=0;x<cells.length;x++){if($_dzedg81ejk26xeyh.eq(cells[x],element)){return Option.some(cellPosition(x,y));}}}return Option.none();};var extractRows=function extractRows(table,sx,sy,ex,ey){var newRows=[];var rows=table.rows();for(var y=sy;y<=ey;y++){var cells=rows[y].cells();var slice=sx<ex?cells.slice(sx,ex+1):cells.slice(ex,sx+1);newRows.push(tableRow(rows[y].element(),slice));}return newRows;};var subTable=function subTable(table,startPos,endPos){var sx=startPos.x(),sy=startPos.y();var ex=endPos.x(),ey=endPos.y();var newRows=sy<ey?extractRows(table,sx,sy,ex,ey):extractRows(table,sx,ey,ex,sy);return tableModel(table.element(),getWidth(newRows),newRows);};var createDomTable=function createDomTable(table,rows){var tableElement=$_39bcz42ijk26xf6i.shallow(table.element());var tableBody=Element$$1.fromTag('tbody');$_2ykrq21xjk26xf2x.append(tableBody,rows);$_9t36rc1yjk26xf33.append(tableElement,tableBody);return tableElement;};var modelRowsToDomRows=function modelRowsToDomRows(table){return map(table.rows(),function(row){var cells=map(row.cells(),function(cell){var td=$_39bcz42ijk26xf6i.deep(cell);$_5xapbx15jk26xewz.remove(td,'colspan');$_5xapbx15jk26xewz.remove(td,'rowspan');return td;});var tr=$_39bcz42ijk26xf6i.shallow(row.element());$_2ykrq21xjk26xf2x.append(tr,cells);return tr;});};var fromDom$2=function fromDom$2(tableElm){var table=tableModel($_39bcz42ijk26xf6i.shallow(tableElm),0,[]);each($_bisgdu27jk26xf4o.descendants(tableElm,'tr'),function(tr,y){each($_bisgdu27jk26xf4o.descendants(tr,'td,th'),function(td,x){fillout(table,skipCellsX(table,x,y),y,tr,td);});});return tableModel(table.element(),getWidth(table.rows()),table.rows());};var toDom=function toDom(table){return createDomTable(table,modelRowsToDomRows(table));};var subsection=function subsection(table,startElement,endElement){return findElementPos(table,startElement).bind(function(startPos){return findElementPos(table,endElement).map(function(endPos){return subTable(table,startPos,endPos);});});};var $_fa89ko72jk26xg7h={fromDom:fromDom$2,toDom:toDom,subsection:subsection};var findParentListContainer=function findParentListContainer(parents){return find(parents,function(elm){return $_cl4rr911jk26xevy.name(elm)==='ul'||$_cl4rr911jk26xevy.name(elm)==='ol';});};var getFullySelectedListWrappers=function getFullySelectedListWrappers(parents,rng){return find(parents,function(elm){return $_cl4rr911jk26xevy.name(elm)==='li'&&hasAllContentsSelected(elm,rng);}).fold(constant([]),function(li){return findParentListContainer(parents).map(function(listCont){return[Element$$1.fromTag('li'),Element$$1.fromTag($_cl4rr911jk26xevy.name(listCont))];}).getOr([]);});};var wrap$3=function wrap$3(innerElm,elms){var wrapped=foldl(elms,function(acc,elm){$_9t36rc1yjk26xf33.append(elm,acc);return elm;},innerElm);return elms.length>0?$_evjgls71jk26xg7b.fromElements([wrapped]):wrapped;};var directListWrappers=function directListWrappers(commonAnchorContainer){if(isListItem(commonAnchorContainer)){return $_2i1q6518jk26xexk.parent(commonAnchorContainer).filter(isList).fold(constant([]),function(listElm){return[commonAnchorContainer,listElm];});}else{return isList(commonAnchorContainer)?[commonAnchorContainer]:[];}};var getWrapElements=function getWrapElements(rootNode,rng){var commonAnchorContainer=Element$$1.fromDom(rng.commonAncestorContainer);var parents=$_du4do23zjk26xfl5.parentsAndSelf(commonAnchorContainer,rootNode);var wrapElements=filter(parents,function(elm){return isInline(elm)||isHeading(elm);});var listWrappers=getFullySelectedListWrappers(parents,rng);var allWrappers=wrapElements.concat(listWrappers.length?listWrappers:directListWrappers(commonAnchorContainer));return map(allWrappers,$_39bcz42ijk26xf6i.shallow);};var emptyFragment=function emptyFragment(){return $_evjgls71jk26xg7b.fromElements([]);};var getFragmentFromRange=function getFragmentFromRange(rootNode,rng){return wrap$3(Element$$1.fromDom(rng.cloneContents()),getWrapElements(rootNode,rng));};var getParentTable=function getParentTable(rootElm,cell){return $_dbgjqa29jk26xf4u.ancestor(cell,'table',curry($_dzedg81ejk26xeyh.eq,rootElm));};var getTableFragment=function getTableFragment(rootNode,selectedTableCells){return getParentTable(rootNode,selectedTableCells[0]).bind(function(tableElm){var firstCell=selectedTableCells[0];var lastCell=selectedTableCells[selectedTableCells.length-1];var fullTableModel=$_fa89ko72jk26xg7h.fromDom(tableElm);return $_fa89ko72jk26xg7h.subsection(fullTableModel,firstCell,lastCell).map(function(sectionedTableModel){return $_evjgls71jk26xg7b.fromElements([$_fa89ko72jk26xg7h.toDom(sectionedTableModel)]);});}).getOrThunk(emptyFragment);};var getSelectionFragment=function getSelectionFragment(rootNode,ranges){return ranges.length>0&&ranges[0].collapsed?emptyFragment():getFragmentFromRange(rootNode,ranges[0]);};var read$4=function read$4(rootNode,ranges){var selectedCells=$_d4teip4ejk26xfp9.getCellsFromElementOrRanges(ranges,rootNode);return selectedCells.length>0?getTableFragment(rootNode,selectedCells):getSelectionFragment(rootNode,ranges);};var $_axquuw70jk26xg6v={read:read$4};var getContent=function getContent(editor,args){var rng=editor.selection.getRng(),tmpElm=editor.dom.create('body');var sel=editor.selection.getSel();var fragment;var ranges=$_d6zwjd6yjk26xg6o.processRanges(editor,$_18b2474fjk26xfpg.getRanges(sel));args=args||{};args.get=true;args.format=args.format||'html';args.selection=true;args=editor.fire('BeforeGetContent',args);if(args.isDefaultPrevented()){editor.fire('GetContent',args);return args.content;}if(args.format==='text'){return editor.selection.isCollapsed()?'':$_4osibw2pjk26xf83.trim(rng.text||(sel.toString?sel.toString():''));}if(rng.cloneContents){fragment=args.contextual?$_axquuw70jk26xg6v.read(Element$$1.fromDom(editor.getBody()),ranges).dom():rng.cloneContents();if(fragment){tmpElm.appendChild(fragment);}}else if(rng.item!==undefined||rng.htmlText!==undefined){tmpElm.innerHTML='<br>'+(rng.item?rng.item(0).outerHTML:rng.htmlText);tmpElm.removeChild(tmpElm.firstChild);}else{tmpElm.innerHTML=rng.toString();}args.getInner=true;var content=editor.selection.serializer.serialize(tmpElm,args);if(args.format==='tree'){return content;}args.content=editor.selection.isCollapsed()?'':content;editor.fire('GetContent',args);return args.content;};var $_wnaer6zjk26xg6r={getContent:getContent};var setContent=function setContent(editor,content,args){var rng=editor.selection.getRng(),caretNode;var doc=editor.getDoc();var frag,temp;args=args||{format:'html'};args.set=true;args.selection=true;args.content=content;if(!args.no_events){args=editor.fire('BeforeSetContent',args);if(args.isDefaultPrevented()){editor.fire('SetContent',args);return;}}content=args.content;if(rng.insertNode){content+='<span id="__caret">_</span>';if(rng.startContainer===doc&&rng.endContainer===doc){doc.body.innerHTML=content;}else{rng.deleteContents();if(doc.body.childNodes.length===0){doc.body.innerHTML=content;}else{if(rng.createContextualFragment){rng.insertNode(rng.createContextualFragment(content));}else{frag=doc.createDocumentFragment();temp=doc.createElement('div');frag.appendChild(temp);temp.outerHTML=content;rng.insertNode(frag);}}}caretNode=editor.dom.get('__caret');rng=doc.createRange();rng.setStartBefore(caretNode);rng.setEndBefore(caretNode);editor.selection.setRng(rng);editor.dom.remove('__caret');try{editor.selection.setRng(rng);}catch(ex){}}else{if(rng.item){doc.execCommand('Delete',false,null);rng=editor.getRng();}if(/^\s+/.test(content)){rng.pasteHTML('<span id="__mce_tmp">_</span>'+content);editor.dom.remove('__mce_tmp');}else{rng.pasteHTML(content);}}if(!args.no_events){editor.fire('SetContent',args);}};var $_fn2y3b73jk26xg81={setContent:setContent};var getEndpointElement=function getEndpointElement(root,rng,start,real,resolve){var container=start?rng.startContainer:rng.endContainer;var offset=start?rng.startOffset:rng.endOffset;return Option.from(container).map(Element$$1.fromDom).map(function(elm){return!real||!rng.collapsed?$_2i1q6518jk26xexk.child(elm,resolve(elm,offset)).getOr(elm):elm;}).bind(function(elm){return $_cl4rr911jk26xevy.isElement(elm)?Option.some(elm):$_2i1q6518jk26xexk.parent(elm);}).map(function(elm){return elm.dom();}).getOr(root);};var getStart$2=function getStart$2(root,rng,real){return getEndpointElement(root,rng,true,real,function(elm,offset){return Math.min($_2i1q6518jk26xexk.childNodesCount(elm),offset);});};var getEnd=function getEnd(root,rng,real){return getEndpointElement(root,rng,false,real,function(elm,offset){return offset>0?offset-1:offset;});};var skipEmptyTextNodes=function skipEmptyTextNodes(node,forwards){var orig=node;while(node&&$_fpgwqg1rjk26xf0n.isText(node)&&node.length===0){node=forwards?node.nextSibling:node.previousSibling;}return node||orig;};var getNode$1=function getNode$1(root,rng){var elm,startContainer,endContainer,startOffset,endOffset;if(!rng){return root;}startContainer=rng.startContainer;endContainer=rng.endContainer;startOffset=rng.startOffset;endOffset=rng.endOffset;elm=rng.commonAncestorContainer;if(!rng.collapsed){if(startContainer===endContainer){if(endOffset-startOffset<2){if(startContainer.hasChildNodes()){elm=startContainer.childNodes[startOffset];}}}if(startContainer.nodeType===3&&endContainer.nodeType===3){if(startContainer.length===startOffset){startContainer=skipEmptyTextNodes(startContainer.nextSibling,true);}else{startContainer=startContainer.parentNode;}if(endOffset===0){endContainer=skipEmptyTextNodes(endContainer.previousSibling,false);}else{endContainer=endContainer.parentNode;}if(startContainer&&startContainer===endContainer){return startContainer;}}}if(elm&&elm.nodeType===3){return elm.parentNode;}return elm;};var getSelectedBlocks=function getSelectedBlocks(dom,rng,startElm,endElm){var node,root;var selectedBlocks=[];root=dom.getRoot();startElm=dom.getParent(startElm||getStart$2(root,rng,false),dom.isBlock);endElm=dom.getParent(endElm||getEnd(root,rng,false),dom.isBlock);if(startElm&&startElm!==root){selectedBlocks.push(startElm);}if(startElm&&endElm&&startElm!==endElm){node=startElm;var walker=new TreeWalker(startElm,root);while((node=walker.next())&&node!==endElm){if(dom.isBlock(node)){selectedBlocks.push(node);}}}if(endElm&&startElm!==endElm&&endElm!==root){selectedBlocks.push(endElm);}return selectedBlocks;};var select$1=function select$1(dom,node,content){return Option.from(node).map(function(node){var idx=dom.nodeIndex(node);var rng=dom.createRng();rng.setStart(node.parentNode,idx);rng.setEnd(node.parentNode,idx+1);if(content){moveEndPoint$1(dom,rng,node,true);moveEndPoint$1(dom,rng,node,false);}return rng;});};var each$19=$_2ytxahljk26xetf.each;var isNativeIeSelection=function isNativeIeSelection(rng){return!!rng.select;};var isAttachedToDom=function isAttachedToDom(node){return!!(node&&node.ownerDocument)&&$_dzedg81ejk26xeyh.contains(Element$$1.fromDom(node.ownerDocument),Element$$1.fromDom(node));};var isValidRange=function isValidRange(rng){if(!rng){return false;}else if(isNativeIeSelection(rng)){return true;}else{return isAttachedToDom(rng.startContainer)&&isAttachedToDom(rng.endContainer);}};var Selection$1=function Selection$1(dom,win,serializer,editor){var bookmarkManager,controlSelection;var selectedRange,explicitRange,selectorChangedData;var setCursorLocation=function setCursorLocation(node,offset){var rng=dom.createRng();if(!node){moveEndPoint$1(dom,rng,editor.getBody(),true);setRng(rng);}else{rng.setStart(node,offset);rng.setEnd(node,offset);setRng(rng);collapse(false);}};var getContent=function getContent(args){return $_wnaer6zjk26xg6r.getContent(editor,args);};var setContent=function setContent(content,args){return $_fn2y3b73jk26xg81.setContent(editor,content,args);};var getStart=function getStart(real){return getStart$2(editor.getBody(),getRng(),real);};var getEnd$$1=function getEnd$$1(real){return getEnd(editor.getBody(),getRng(),real);};var getBookmark=function getBookmark(type,normalized){return bookmarkManager.getBookmark(type,normalized);};var moveToBookmark=function moveToBookmark(bookmark){return bookmarkManager.moveToBookmark(bookmark);};var select=function select(node,content){select$1(dom,node,content).each(setRng);return node;};var isCollapsed=function isCollapsed(){var rng=getRng(),sel=getSel();if(!rng||rng.item){return false;}if(rng.compareEndPoints){return rng.compareEndPoints('StartToEnd',rng)===0;}return!sel||rng.collapsed;};var collapse=function collapse(toStart){var rng=getRng();rng.collapse(!!toStart);setRng(rng);};var getSel=function getSel(){return win.getSelection?win.getSelection():win.document.selection;};var getRng=function getRng(){var selection,rng,elm,doc;var tryCompareBoundaryPoints=function tryCompareBoundaryPoints(how,sourceRange,destinationRange){try{return sourceRange.compareBoundaryPoints(how,destinationRange);}catch(ex){return-1;}};if(!win){return null;}doc=win.document;if(typeof doc==='undefined'||doc===null){return null;}if(editor.bookmark!==undefined&&$_3hu41a4vjk26xfsm.hasFocus(editor)===false){var bookmark=$_wwyx94ljk26xfqt.getRng(editor);if(bookmark.isSome()){return bookmark.map(function(r){return $_d6zwjd6yjk26xg6o.processRanges(editor,[r])[0];}).getOr(doc.createRange());}}try{if(selection=getSel()){if(selection.rangeCount>0){rng=selection.getRangeAt(0);}else{rng=selection.createRange?selection.createRange():doc.createRange();}}}catch(ex){}rng=$_d6zwjd6yjk26xg6o.processRanges(editor,[rng])[0];if(!rng){rng=doc.createRange?doc.createRange():doc.body.createTextRange();}if(rng.setStart&&rng.startContainer.nodeType===9&&rng.collapsed){elm=dom.getRoot();rng.setStart(elm,0);rng.setEnd(elm,0);}if(selectedRange&&explicitRange){if(tryCompareBoundaryPoints(rng.START_TO_START,rng,selectedRange)===0&&tryCompareBoundaryPoints(rng.END_TO_END,rng,selectedRange)===0){rng=explicitRange;}else{selectedRange=null;explicitRange=null;}}return rng;};var setRng=function setRng(rng,forward){var sel,node,evt;if(!isValidRange(rng)){return;}var ieRange=isNativeIeSelection(rng)?rng:null;if(ieRange){explicitRange=null;try{ieRange.select();}catch(ex){}return;}sel=getSel();evt=editor.fire('SetSelectionRange',{range:rng,forward:forward});rng=evt.range;if(sel){explicitRange=rng;try{sel.removeAllRanges();sel.addRange(rng);}catch(ex){}if(forward===false&&sel.extend){sel.collapse(rng.endContainer,rng.endOffset);sel.extend(rng.startContainer,rng.startOffset);}selectedRange=sel.rangeCount>0?sel.getRangeAt(0):null;}if(!rng.collapsed&&rng.startContainer===rng.endContainer&&sel.setBaseAndExtent&&!$_ef6mqpajk26xejm.ie){if(rng.endOffset-rng.startOffset<2){if(rng.startContainer.hasChildNodes()){node=rng.startContainer.childNodes[rng.startOffset];if(node&&node.tagName==='IMG'){sel.setBaseAndExtent(rng.startContainer,rng.startOffset,rng.endContainer,rng.endOffset);if(sel.anchorNode!==rng.startContainer||sel.focusNode!==rng.endContainer){sel.setBaseAndExtent(node,0,node,1);}}}}}editor.fire('AfterSetSelectionRange',{range:rng,forward:forward});};var setNode=function setNode(elm){setContent(dom.getOuterHTML(elm));return elm;};var getNode=function getNode(){return getNode$1(editor.getBody(),getRng());};var getSelectedBlocks$$1=function getSelectedBlocks$$1(startElm,endElm){return getSelectedBlocks(dom,getRng(),startElm,endElm);};var isForward=function isForward(){var sel=getSel();var anchorRange,focusRange;if(!sel||!sel.anchorNode||!sel.focusNode){return true;}anchorRange=dom.createRng();anchorRange.setStart(sel.anchorNode,sel.anchorOffset);anchorRange.collapse(true);focusRange=dom.createRng();focusRange.setStart(sel.focusNode,sel.focusOffset);focusRange.collapse(true);return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START,focusRange)<=0;};var normalize=function normalize(){var rng=getRng();var sel=getSel();if(!$_18b2474fjk26xfpg.hasMultipleRanges(sel)&&hasAnyRanges(editor)){var normRng=$_c8c6ki4jjk26xfqk.normalize(dom,rng);normRng.each(function(normRng){setRng(normRng,isForward());});return normRng.getOr(rng);}return rng;};var selectorChanged=function selectorChanged(selector,callback){var currentSelectors;if(!selectorChangedData){selectorChangedData={};currentSelectors={};editor.on('NodeChange',function(e){var node=e.element,parents=dom.getParents(node,null,dom.getRoot()),matchedSelectors={};each$19(selectorChangedData,function(callbacks,selector){each$19(parents,function(node){if(dom.is(node,selector)){if(!currentSelectors[selector]){each$19(callbacks,function(callback){callback(true,{node:node,selector:selector,parents:parents});});currentSelectors[selector]=callbacks;}matchedSelectors[selector]=callbacks;return false;}});});each$19(currentSelectors,function(callbacks,selector){if(!matchedSelectors[selector]){delete currentSelectors[selector];each$19(callbacks,function(callback){callback(false,{node:node,selector:selector,parents:parents});});}});});}if(!selectorChangedData[selector]){selectorChangedData[selector]=[];}selectorChangedData[selector].push(callback);return exports;};var getScrollContainer=function getScrollContainer(){var scrollContainer;var node=dom.getRoot();while(node&&node.nodeName!=='BODY'){if(node.scrollHeight>node.clientHeight){scrollContainer=node;break;}node=node.parentNode;}return scrollContainer;};var scrollIntoView=function scrollIntoView(elm,alignToTop){return $_b4h82u37jk26xfc1.scrollElementIntoView(editor,elm,alignToTop);};var placeCaretAt=function placeCaretAt(clientX,clientY){return setRng($_11ohb66xjk26xg6m.fromPoint(clientX,clientY,editor.getDoc()));};var getBoundingClientRect=function getBoundingClientRect(){var rng=getRng();return rng.collapsed?CaretPosition$1.fromRangeStart(rng).getClientRects()[0]:rng.getBoundingClientRect();};var destroy=function destroy(){win=selectedRange=explicitRange=null;controlSelection.destroy();};var exports={bookmarkManager:null,controlSelection:null,dom:dom,win:win,serializer:serializer,editor:editor,collapse:collapse,setCursorLocation:setCursorLocation,getContent:getContent,setContent:setContent,getBookmark:getBookmark,moveToBookmark:moveToBookmark,select:select,isCollapsed:isCollapsed,isForward:isForward,setNode:setNode,getNode:getNode,getSel:getSel,setRng:setRng,getRng:getRng,getStart:getStart,getEnd:getEnd$$1,getSelectedBlocks:getSelectedBlocks$$1,normalize:normalize,selectorChanged:selectorChanged,getScrollContainer:getScrollContainer,scrollIntoView:scrollIntoView,placeCaretAt:placeCaretAt,getBoundingClientRect:getBoundingClientRect,destroy:destroy};bookmarkManager=BookmarkManager$1(exports);controlSelection=ControlSelection(exports,editor);exports.bookmarkManager=bookmarkManager;exports.controlSelection=controlSelection;return exports;};var isContentEditableFalse$11=$_fpgwqg1rjk26xf0n.isContentEditableFalse;var getSelectedNode$1=getSelectedNode;var isAfterContentEditableFalse$2=isAfterContentEditableFalse;var isBeforeContentEditableFalse$2=isBeforeContentEditableFalse;var getVisualCaretPosition=function getVisualCaretPosition(walkFn,caretPosition){while(caretPosition=walkFn(caretPosition)){if(caretPosition.isVisible()){return caretPosition;}}return caretPosition;};var isMoveInsideSameBlock=function isMoveInsideSameBlock(from,to){var inSameBlock=isInSameBlock(from,to);if(!inSameBlock&&$_fpgwqg1rjk26xf0n.isBr(from.getNode())){return true;}return inSameBlock;};var moveToCeFalseHorizontally=function moveToCeFalseHorizontally(direction,editor,getNextPosFn,range){var node,caretPosition,peekCaretPosition,rangeIsInContainerBlock;var forwards=direction===HDirection.Forwards;var isBeforeContentEditableFalseFn=forwards?isBeforeContentEditableFalse$2:isAfterContentEditableFalse$2;if(!range.collapsed){node=getSelectedNode$1(range);if(isContentEditableFalse$11(node)){return showCaret(direction,editor,node,direction===HDirection.Backwards,true);}}rangeIsInContainerBlock=isRangeInCaretContainerBlock(range);caretPosition=getNormalizedRangeEndPoint(direction,editor.getBody(),range);if(isBeforeContentEditableFalseFn(caretPosition)){return selectNode(editor,caretPosition.getNode(!forwards));}caretPosition=getNextPosFn(caretPosition);if(!caretPosition){if(rangeIsInContainerBlock){return range;}return null;}if(isBeforeContentEditableFalseFn(caretPosition)){return showCaret(direction,editor,caretPosition.getNode(!forwards),forwards,true);}peekCaretPosition=getNextPosFn(caretPosition);if(isBeforeContentEditableFalseFn(peekCaretPosition)){if(isMoveInsideSameBlock(caretPosition,peekCaretPosition)){return showCaret(direction,editor,peekCaretPosition.getNode(!forwards),forwards,true);}}if(rangeIsInContainerBlock){return renderRangeCaret(editor,caretPosition.toRange(),true);}return null;};var moveToCeFalseVertically=function moveToCeFalseVertically(direction,editor,walkerFn,range){var caretPosition,linePositions,nextLinePositions;var closestNextLineRect,caretClientRect,clientX;var dist1,dist2,contentEditableFalseNode;contentEditableFalseNode=getSelectedNode$1(range);caretPosition=getNormalizedRangeEndPoint(direction,editor.getBody(),range);linePositions=walkerFn(editor.getBody(),isAboveLine(1),caretPosition);nextLinePositions=$_98exydmjk26xeto.filter(linePositions,isLine(1));caretClientRect=$_98exydmjk26xeto.last(caretPosition.getClientRects());if(isBeforeContentEditableFalse$2(caretPosition)||isBeforeTable(caretPosition)){contentEditableFalseNode=caretPosition.getNode();}if(isAfterContentEditableFalse$2(caretPosition)||isAfterTable(caretPosition)){contentEditableFalseNode=caretPosition.getNode(true);}if(!caretClientRect){return null;}clientX=caretClientRect.left;closestNextLineRect=findClosestClientRect(nextLinePositions,clientX);if(closestNextLineRect){if(isContentEditableFalse$11(closestNextLineRect.node)){dist1=Math.abs(clientX-closestNextLineRect.left);dist2=Math.abs(clientX-closestNextLineRect.right);return showCaret(direction,editor,closestNextLineRect.node,dist1<dist2,true);}}if(contentEditableFalseNode){var caretPositions=positionsUntil(direction,editor.getBody(),isAboveLine(1),contentEditableFalseNode);closestNextLineRect=findClosestClientRect($_98exydmjk26xeto.filter(caretPositions,isLine(1)),clientX);if(closestNextLineRect){return renderRangeCaret(editor,closestNextLineRect.position.toRange(),true);}closestNextLineRect=$_98exydmjk26xeto.last($_98exydmjk26xeto.filter(caretPositions,isLine(0)));if(closestNextLineRect){return renderRangeCaret(editor,closestNextLineRect.position.toRange(),true);}}};var createTextBlock=function createTextBlock(editor){var textBlock=editor.dom.create(editor.settings.forced_root_block);if(!$_ef6mqpajk26xejm.ie||$_ef6mqpajk26xejm.ie>=11){textBlock.innerHTML='<br data-mce-bogus="1">';}return textBlock;};var exitPreBlock=function exitPreBlock(editor,direction,range){var pre,caretPos,newBlock;var caretWalker=CaretWalker(editor.getBody());var getNextVisualCaretPosition=$_a86i182ljk26xf77.curry(getVisualCaretPosition,caretWalker.next);var getPrevVisualCaretPosition=$_a86i182ljk26xf77.curry(getVisualCaretPosition,caretWalker.prev);if(range.collapsed&&editor.settings.forced_root_block){pre=editor.dom.getParent(range.startContainer,'PRE');if(!pre){return;}if(direction===1){caretPos=getNextVisualCaretPosition(CaretPosition$1.fromRangeStart(range));}else{caretPos=getPrevVisualCaretPosition(CaretPosition$1.fromRangeStart(range));}if(!caretPos){newBlock=createTextBlock(editor);if(direction===1){editor.$(pre).after(newBlock);}else{editor.$(pre).before(newBlock);}editor.selection.select(newBlock,true);editor.selection.collapse();}}};var getHorizontalRange=function getHorizontalRange(editor,forward){var caretWalker=CaretWalker(editor.getBody());var getNextVisualCaretPosition=$_a86i182ljk26xf77.curry(getVisualCaretPosition,caretWalker.next);var getPrevVisualCaretPosition=$_a86i182ljk26xf77.curry(getVisualCaretPosition,caretWalker.prev);var newRange;var direction=forward?HDirection.Forwards:HDirection.Backwards;var getNextPosFn=forward?getNextVisualCaretPosition:getPrevVisualCaretPosition;var range=editor.selection.getRng();newRange=moveToCeFalseHorizontally(direction,editor,getNextPosFn,range);if(newRange){return newRange;}newRange=exitPreBlock(editor,direction,range);if(newRange){return newRange;}return null;};var getVerticalRange=function getVerticalRange(editor,down){var newRange;var direction=down?1:-1;var walkerFn=down?downUntil:upUntil;var range=editor.selection.getRng();newRange=moveToCeFalseVertically(direction,editor,walkerFn,range);if(newRange){return newRange;}newRange=exitPreBlock(editor,direction,range);if(newRange){return newRange;}return null;};var moveH$1=function moveH$1(editor,forward){return function(){var newRng=getHorizontalRange(editor,forward);if(newRng){editor.selection.setRng(newRng);return true;}else{return false;}};};var moveV$1=function moveV$1(editor,down){return function(){var newRng=getVerticalRange(editor,down);if(newRng){editor.selection.setRng(newRng);return true;}else{return false;}};};var defaultPatterns=function defaultPatterns(patterns){return map(patterns,function(pattern){return merge({shiftKey:false,altKey:false,ctrlKey:false,metaKey:false,keyCode:0,action:noop},pattern);});};var matchesEvent=function matchesEvent(pattern,evt){return evt.keyCode===pattern.keyCode&&evt.shiftKey===pattern.shiftKey&&evt.altKey===pattern.altKey&&evt.ctrlKey===pattern.ctrlKey&&evt.metaKey===pattern.metaKey;};var match$1=function match$1(patterns,evt){return bind(defaultPatterns(patterns),function(pattern){return matchesEvent(pattern,evt)?[pattern]:[];});};var action=function action(f){var x=[];for(var _i=1;_i<arguments.length;_i++){x[_i-1]=arguments[_i];}var args=Array.prototype.slice.call(arguments,1);return function(){return f.apply(null,args);};};var execute=function execute(patterns,evt){return find(match$1(patterns,evt),function(pattern){return pattern.action();});};var $_c8auke78jk26xg92={match:match$1,action:action,execute:execute};var executeKeydownOverride=function executeKeydownOverride(editor,caret,evt){var os=$_8x4ci6ojk26xeuf.detect().os;$_c8auke78jk26xg92.execute([{keyCode:$_o3p025wjk26xfz2.RIGHT,action:moveH$1(editor,true)},{keyCode:$_o3p025wjk26xfz2.LEFT,action:moveH$1(editor,false)},{keyCode:$_o3p025wjk26xfz2.UP,action:moveV$1(editor,false)},{keyCode:$_o3p025wjk26xfz2.DOWN,action:moveV$1(editor,true)},{keyCode:$_o3p025wjk26xfz2.RIGHT,action:moveH(editor,true)},{keyCode:$_o3p025wjk26xfz2.LEFT,action:moveH(editor,false)},{keyCode:$_o3p025wjk26xfz2.UP,action:moveV(editor,false)},{keyCode:$_o3p025wjk26xfz2.DOWN,action:moveV(editor,true)},{keyCode:$_o3p025wjk26xfz2.RIGHT,action:$_74odh54ajk26xfo1.move(editor,caret,true)},{keyCode:$_o3p025wjk26xfz2.LEFT,action:$_74odh54ajk26xfo1.move(editor,caret,false)},{keyCode:$_o3p025wjk26xfz2.RIGHT,ctrlKey:!os.isOSX(),altKey:os.isOSX(),action:$_74odh54ajk26xfo1.moveNextWord(editor,caret)},{keyCode:$_o3p025wjk26xfz2.LEFT,ctrlKey:!os.isOSX(),altKey:os.isOSX(),action:$_74odh54ajk26xfo1.movePrevWord(editor,caret)}],evt).each(function(_){evt.preventDefault();});};var setup$7=function setup$7(editor,caret){editor.on('keydown',function(evt){if(evt.isDefaultPrevented()===false){executeKeydownOverride(editor,caret,evt);}});};var $_43f9k776jk26xg8q={setup:setup$7};var getParentInlines=function getParentInlines(rootElm,startElm){var parents=$_du4do23zjk26xfl5.parentsAndSelf(startElm,rootElm);return findIndex(parents,isBlock).fold(constant(parents),function(index){return parents.slice(0,index);});};var hasOnlyOneChild$1=function hasOnlyOneChild$1(elm){return $_2i1q6518jk26xexk.children(elm).length===1;};var deleteLastPosition=function deleteLastPosition(forward,editor,target,parentInlines){var isFormatElement$$1=curry(isFormatElement,editor);var formatNodes=map(filter(parentInlines,isFormatElement$$1),function(elm){return elm.dom();});if(formatNodes.length===0){$_eqel1x44jk26xfmg.deleteElement(editor,forward,target);}else{var pos=replaceWithCaretFormat(target.dom(),formatNodes);editor.selection.setRng(pos.toRange());}};var deleteCaret$1=function deleteCaret$1(editor,forward){var rootElm=Element$$1.fromDom(editor.getBody());var startElm=Element$$1.fromDom(editor.selection.getStart());var parentInlines=filter(getParentInlines(rootElm,startElm),hasOnlyOneChild$1);return last(parentInlines).map(function(target){var fromPos=CaretPosition$1.fromRangeStart(editor.selection.getRng());if($_pu1tq3sjk26xfjd.willDeleteLastPositionInElement(forward,fromPos,target.dom())){deleteLastPosition(forward,editor,target,parentInlines);return true;}else{return false;}}).getOr(false);};var backspaceDelete$5=function backspaceDelete$5(editor,forward){return editor.selection.isCollapsed()?deleteCaret$1(editor,forward):false;};var $_3lm1mf7ajk26xg9c={backspaceDelete:backspaceDelete$5};var executeKeydownOverride$1=function executeKeydownOverride$1(editor,caret,evt){$_c8auke78jk26xg92.execute([{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_94kdqm41jk26xfls.backspaceDelete,editor,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_94kdqm41jk26xfls.backspaceDelete,editor,true)},{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_e34aqn45jk26xfmy.backspaceDelete,editor,caret,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_e34aqn45jk26xfmy.backspaceDelete,editor,caret,true)},{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_9e12a34cjk26xfoe.backspaceDelete,editor,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_9e12a34cjk26xfoe.backspaceDelete,editor,true)},{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_7pr3gu40jk26xflb.backspaceDelete,editor,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_7pr3gu40jk26xflb.backspaceDelete,editor,true)},{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_45jqb13qjk26xfix.backspaceDelete,editor,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_45jqb13qjk26xfix.backspaceDelete,editor,true)},{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_3lm1mf7ajk26xg9c.backspaceDelete,editor,false)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_3lm1mf7ajk26xg9c.backspaceDelete,editor,true)}],evt).each(function(_){evt.preventDefault();});};var executeKeyupOverride=function executeKeyupOverride(editor,evt){$_c8auke78jk26xg92.execute([{keyCode:$_o3p025wjk26xfz2.BACKSPACE,action:$_c8auke78jk26xg92.action($_94kdqm41jk26xfls.paddEmptyElement,editor)},{keyCode:$_o3p025wjk26xfz2.DELETE,action:$_c8auke78jk26xg92.action($_94kdqm41jk26xfls.paddEmptyElement,editor)}],evt);};var setup$8=function setup$8(editor,caret){editor.on('keydown',function(evt){if(evt.isDefaultPrevented()===false){executeKeydownOverride$1(editor,caret,evt);}});editor.on('keyup',function(evt){if(evt.isDefaultPrevented()===false){executeKeyupOverride(editor,evt);}});};var $_64s7br79jk26xg99={setup:setup$8};var firstNonWhiteSpaceNodeSibling=function firstNonWhiteSpaceNodeSibling(node){while(node){if(node.nodeType===1||node.nodeType===3&&node.data&&/[\r\n\s]/.test(node.data)){return node;}node=node.nextSibling;}};var moveToCaretPosition=function moveToCaretPosition(editor,root){var walker,node,rng,lastNode=root,tempElm;var dom=editor.dom;var moveCaretBeforeOnEnterElementsMap=editor.schema.getMoveCaretBeforeOnEnterElements();if(!root){return;}if(/^(LI|DT|DD)$/.test(root.nodeName)){var firstChild=firstNonWhiteSpaceNodeSibling(root.firstChild);if(firstChild&&/^(UL|OL|DL)$/.test(firstChild.nodeName)){root.insertBefore(dom.doc.createTextNode('\xA0'),root.firstChild);}}rng=dom.createRng();root.normalize();if(root.hasChildNodes()){walker=new TreeWalker(root,root);while(node=walker.current()){if($_fpgwqg1rjk26xf0n.isText(node)){rng.setStart(node,0);rng.setEnd(node,0);break;}if(moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]){rng.setStartBefore(node);rng.setEndBefore(node);break;}lastNode=node;node=walker.next();}if(!node){rng.setStart(lastNode,0);rng.setEnd(lastNode,0);}}else{if($_fpgwqg1rjk26xf0n.isBr(root)){if(root.nextSibling&&dom.isBlock(root.nextSibling)){rng.setStartBefore(root);rng.setEndBefore(root);}else{rng.setStartAfter(root);rng.setEndAfter(root);}}else{rng.setStart(root,0);rng.setEnd(root,0);}}editor.selection.setRng(rng);dom.remove(tempElm);editor.selection.scrollIntoView(root);};var getEditableRoot=function getEditableRoot(dom,node){var root=dom.getRoot();var parent,editableRoot;parent=node;while(parent!==root&&dom.getContentEditable(parent)!=='false'){if(dom.getContentEditable(parent)==='true'){editableRoot=parent;}parent=parent.parentNode;}return parent!==root?editableRoot:root;};var getParentBlock$2=function getParentBlock$2(editor){return Option.from(editor.dom.getParent(editor.selection.getStart(true),editor.dom.isBlock));};var getParentBlockName=function getParentBlockName(editor){return getParentBlock$2(editor).fold(constant(''),function(parentBlock){return parentBlock.nodeName.toUpperCase();});};var isListItemParentBlock=function isListItemParentBlock(editor){return getParentBlock$2(editor).filter(function(elm){return isListItem(Element$$1.fromDom(elm));}).isSome();};var $_djhyrv7fjk26xgag={moveToCaretPosition:moveToCaretPosition,getEditableRoot:getEditableRoot,getParentBlock:getParentBlock$2,getParentBlockName:getParentBlockName,isListItemParentBlock:isListItemParentBlock};var hasFirstChild=function hasFirstChild(elm,name){return elm.firstChild&&elm.firstChild.nodeName===name;};var hasParent$1=function hasParent$1(elm,parentName){return elm&&elm.parentNode&&elm.parentNode.nodeName===parentName;};var isListBlock=function isListBlock(elm){return elm&&/^(OL|UL|LI)$/.test(elm.nodeName);};var isNestedList=function isNestedList(elm){return isListBlock(elm)&&isListBlock(elm.parentNode);};var getContainerBlock=function getContainerBlock(containerBlock){var containerBlockParent=containerBlock.parentNode;if(/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)){return containerBlockParent;}return containerBlock;};var isFirstOrLastLi=function isFirstOrLastLi(containerBlock,parentBlock,first){var node=containerBlock[first?'firstChild':'lastChild'];while(node){if($_fpgwqg1rjk26xf0n.isElement(node)){break;}node=node[first?'nextSibling':'previousSibling'];}return node===parentBlock;};var insert$1=function insert$1(editor,createNewBlock,containerBlock,parentBlock,newBlockName){var dom=editor.dom;var rng=editor.selection.getRng();if(containerBlock===editor.getBody()){return;}if(isNestedList(containerBlock)){newBlockName='LI';}var newBlock=newBlockName?createNewBlock(newBlockName):dom.create('BR');if(isFirstOrLastLi(containerBlock,parentBlock,true)&&isFirstOrLastLi(containerBlock,parentBlock,false)){if(hasParent$1(containerBlock,'LI')){dom.insertAfter(newBlock,getContainerBlock(containerBlock));}else{dom.replace(newBlock,containerBlock);}}else if(isFirstOrLastLi(containerBlock,parentBlock,true)){if(hasParent$1(containerBlock,'LI')){dom.insertAfter(newBlock,getContainerBlock(containerBlock));newBlock.appendChild(dom.doc.createTextNode(' '));newBlock.appendChild(containerBlock);}else{containerBlock.parentNode.insertBefore(newBlock,containerBlock);}}else if(isFirstOrLastLi(containerBlock,parentBlock,false)){dom.insertAfter(newBlock,getContainerBlock(containerBlock));}else{containerBlock=getContainerBlock(containerBlock);var tmpRng=rng.cloneRange();tmpRng.setStartAfter(parentBlock);tmpRng.setEndAfter(containerBlock);var fragment=tmpRng.extractContents();if(newBlockName==='LI'&&hasFirstChild(fragment,'LI')){newBlock=fragment.firstChild;dom.insertAfter(fragment,containerBlock);}else{dom.insertAfter(fragment,containerBlock);dom.insertAfter(newBlock,containerBlock);}}dom.remove(parentBlock);$_djhyrv7fjk26xgag.moveToCaretPosition(editor,newBlock);};var $_6mz5a97ejk26xgac={insert:insert$1};var isEmptyAnchor=function isEmptyAnchor(elm){return elm&&elm.nodeName==='A'&&$_2ytxahljk26xetf.trim($_4osibw2pjk26xf83.trim(elm.innerText||elm.textContent)).length===0;};var isTableCell$5=function isTableCell$5(node){return node&&/^(TD|TH|CAPTION)$/.test(node.nodeName);};var emptyBlock=function emptyBlock(elm){elm.innerHTML='<br data-mce-bogus="1">';};var containerAndSiblingName=function containerAndSiblingName(container,nodeName){return container.nodeName===nodeName||container.previousSibling&&container.previousSibling.nodeName===nodeName;};var canSplitBlock=function canSplitBlock(dom,node){return node&&dom.isBlock(node)&&!/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName)&&!/^(fixed|absolute)/i.test(node.style.position)&&dom.getContentEditable(node)!=='true';};var trimInlineElementsOnLeftSideOfBlock=function trimInlineElementsOnLeftSideOfBlock(dom,nonEmptyElementsMap,block){var node=block;var firstChilds=[];var i;if(!node){return;}while(node=node.firstChild){if(dom.isBlock(node)){return;}if($_fpgwqg1rjk26xf0n.isElement(node)&&!nonEmptyElementsMap[node.nodeName.toLowerCase()]){firstChilds.push(node);}}i=firstChilds.length;while(i--){node=firstChilds[i];if(!node.hasChildNodes()||node.firstChild===node.lastChild&&node.firstChild.nodeValue===''){dom.remove(node);}else{if(isEmptyAnchor(node)){dom.remove(node);}}}};var normalizeZwspOffset=function normalizeZwspOffset(start,container,offset){if($_fpgwqg1rjk26xf0n.isText(container)===false){return offset;}else if(start){return offset===1&&container.data.charAt(offset-1)===$_4osibw2pjk26xf83.ZWSP?0:offset;}else{return offset===container.data.length-1&&container.data.charAt(offset)===$_4osibw2pjk26xf83.ZWSP?container.data.length:offset;}};var includeZwspInRange=function includeZwspInRange(rng){var newRng=rng.cloneRange();newRng.setStart(rng.startContainer,normalizeZwspOffset(true,rng.startContainer,rng.startOffset));newRng.setEnd(rng.endContainer,normalizeZwspOffset(false,rng.endContainer,rng.endOffset));return newRng;};var trimLeadingLineBreaks=function trimLeadingLineBreaks(node){do{if($_fpgwqg1rjk26xf0n.isText(node)){node.nodeValue=node.nodeValue.replace(/^[\r\n]+/,'');}node=node.firstChild;}while(node);};var getEditableRoot$1=function getEditableRoot$1(dom,node){var root=dom.getRoot();var parent,editableRoot;parent=node;while(parent!==root&&dom.getContentEditable(parent)!=='false'){if(dom.getContentEditable(parent)==='true'){editableRoot=parent;}parent=parent.parentNode;}return parent!==root?editableRoot:root;};var setForcedBlockAttrs=function setForcedBlockAttrs(editor,node){var forcedRootBlockName=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);if(forcedRootBlockName&&forcedRootBlockName.toLowerCase()===node.tagName.toLowerCase()){editor.dom.setAttribs(node,$_8xhf1m38jk26xfc6.getForcedRootBlockAttrs(editor));}};var wrapSelfAndSiblingsInDefaultBlock=function wrapSelfAndSiblingsInDefaultBlock(editor,newBlockName,rng,container,offset){var newBlock,parentBlock,startNode,node,next,rootBlockName;var blockName=newBlockName||'P';var dom=editor.dom,editableRoot=getEditableRoot$1(dom,container);parentBlock=dom.getParent(container,dom.isBlock);if(!parentBlock||!canSplitBlock(dom,parentBlock)){parentBlock=parentBlock||editableRoot;if(parentBlock===editor.getBody()||isTableCell$5(parentBlock)){rootBlockName=parentBlock.nodeName.toLowerCase();}else{rootBlockName=parentBlock.parentNode.nodeName.toLowerCase();}if(!parentBlock.hasChildNodes()){newBlock=dom.create(blockName);setForcedBlockAttrs(editor,newBlock);parentBlock.appendChild(newBlock);rng.setStart(newBlock,0);rng.setEnd(newBlock,0);return newBlock;}node=container;while(node.parentNode!==parentBlock){node=node.parentNode;}while(node&&!dom.isBlock(node)){startNode=node;node=node.previousSibling;}if(startNode&&editor.schema.isValidChild(rootBlockName,blockName.toLowerCase())){newBlock=dom.create(blockName);setForcedBlockAttrs(editor,newBlock);startNode.parentNode.insertBefore(newBlock,startNode);node=startNode;while(node&&!dom.isBlock(node)){next=node.nextSibling;newBlock.appendChild(node);node=next;}rng.setStart(container,offset);rng.setEnd(container,offset);}}return container;};var addBrToBlockIfNeeded=function addBrToBlockIfNeeded(dom,block){var lastChild;block.normalize();lastChild=block.lastChild;if(!lastChild||/^(left|right)$/gi.test(dom.getStyle(lastChild,'float',true))){dom.add(block,'br');}};var insert$2=function insert$2(editor,evt){var tmpRng,editableRoot,container,offset,parentBlock,shiftKey;var newBlock,fragment,containerBlock,parentBlockName,containerBlockName,newBlockName,isAfterLastNodeInContainer;var dom=editor.dom;var schema=editor.schema,nonEmptyElementsMap=schema.getNonEmptyElements();var rng=editor.selection.getRng();var createNewBlock=function createNewBlock(name){var node=container,block,clonedNode,caretNode;var textInlineElements=schema.getTextInlineElements();if(name||parentBlockName==='TABLE'||parentBlockName==='HR'){block=dom.create(name||newBlockName);setForcedBlockAttrs(editor,block);}else{block=parentBlock.cloneNode(false);}caretNode=block;if($_8xhf1m38jk26xfc6.shouldKeepStyles(editor)===false){dom.setAttrib(block,'style',null);dom.setAttrib(block,'class',null);}else{do{if(textInlineElements[node.nodeName]){if(isCaretNode(node)){continue;}clonedNode=node.cloneNode(false);dom.setAttrib(clonedNode,'id','');if(block.hasChildNodes()){clonedNode.appendChild(block.firstChild);block.appendChild(clonedNode);}else{caretNode=clonedNode;block.appendChild(clonedNode);}}}while((node=node.parentNode)&&node!==editableRoot);}emptyBlock(caretNode);return block;};var isCaretAtStartOrEndOfBlock=function isCaretAtStartOrEndOfBlock(start){var walker,node,name,normalizedOffset;normalizedOffset=normalizeZwspOffset(start,container,offset);if($_fpgwqg1rjk26xf0n.isText(container)&&(start?normalizedOffset>0:normalizedOffset<container.nodeValue.length)){return false;}if(container.parentNode===parentBlock&&isAfterLastNodeInContainer&&!start){return true;}if(start&&$_fpgwqg1rjk26xf0n.isElement(container)&&container===parentBlock.firstChild){return true;}if(containerAndSiblingName(container,'TABLE')||containerAndSiblingName(container,'HR')){return isAfterLastNodeInContainer&&!start||!isAfterLastNodeInContainer&&start;}walker=new TreeWalker(container,parentBlock);if($_fpgwqg1rjk26xf0n.isText(container)){if(start&&normalizedOffset===0){walker.prev();}else if(!start&&normalizedOffset===container.nodeValue.length){walker.next();}}while(node=walker.current()){if($_fpgwqg1rjk26xf0n.isElement(node)){if(!node.getAttribute('data-mce-bogus')){name=node.nodeName.toLowerCase();if(nonEmptyElementsMap[name]&&name!=='br'){return false;}}}else if($_fpgwqg1rjk26xf0n.isText(node)&&!/^[ \t\r\n]*$/.test(node.nodeValue)){return false;}if(start){walker.prev();}else{walker.next();}}return true;};var insertNewBlockAfter=function insertNewBlockAfter(){if(/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName)&&containerBlockName!=='HGROUP'){newBlock=createNewBlock(newBlockName);}else{newBlock=createNewBlock();}if($_8xhf1m38jk26xfc6.shouldEndContainerOnEmptyBlock(editor)&&canSplitBlock(dom,containerBlock)&&dom.isEmpty(parentBlock)){newBlock=dom.split(containerBlock,parentBlock);}else{dom.insertAfter(newBlock,parentBlock);}$_djhyrv7fjk26xgag.moveToCaretPosition(editor,newBlock);};$_c8c6ki4jjk26xfqk.normalize(dom,rng).each(function(normRng){rng.setStart(normRng.startContainer,normRng.startOffset);rng.setEnd(normRng.endContainer,normRng.endOffset);});container=rng.startContainer;offset=rng.startOffset;newBlockName=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);shiftKey=evt.shiftKey;if($_fpgwqg1rjk26xf0n.isElement(container)&&container.hasChildNodes()){isAfterLastNodeInContainer=offset>container.childNodes.length-1;container=container.childNodes[Math.min(offset,container.childNodes.length-1)]||container;if(isAfterLastNodeInContainer&&$_fpgwqg1rjk26xf0n.isText(container)){offset=container.nodeValue.length;}else{offset=0;}}editableRoot=getEditableRoot$1(dom,container);if(!editableRoot){return;}if(newBlockName&&!shiftKey||!newBlockName&&shiftKey){container=wrapSelfAndSiblingsInDefaultBlock(editor,newBlockName,rng,container,offset);}parentBlock=dom.getParent(container,dom.isBlock);containerBlock=parentBlock?dom.getParent(parentBlock.parentNode,dom.isBlock):null;parentBlockName=parentBlock?parentBlock.nodeName.toUpperCase():'';containerBlockName=containerBlock?containerBlock.nodeName.toUpperCase():'';if(containerBlockName==='LI'&&!evt.ctrlKey){parentBlock=containerBlock;containerBlock=containerBlock.parentNode;parentBlockName=containerBlockName;}if(/^(LI|DT|DD)$/.test(parentBlockName)){if(dom.isEmpty(parentBlock)){$_6mz5a97ejk26xgac.insert(editor,createNewBlock,containerBlock,parentBlock,newBlockName);return;}}if(newBlockName&&parentBlock===editor.getBody()){return;}newBlockName=newBlockName||'P';if(isCaretContainerBlock(parentBlock)){newBlock=showCaretContainerBlock(parentBlock);if(dom.isEmpty(parentBlock)){emptyBlock(parentBlock);}$_djhyrv7fjk26xgag.moveToCaretPosition(editor,newBlock);}else if(isCaretAtStartOrEndOfBlock()){insertNewBlockAfter();}else if(isCaretAtStartOrEndOfBlock(true)){newBlock=parentBlock.parentNode.insertBefore(createNewBlock(),parentBlock);$_djhyrv7fjk26xgag.moveToCaretPosition(editor,containerAndSiblingName(parentBlock,'HR')?newBlock:parentBlock);}else{tmpRng=includeZwspInRange(rng).cloneRange();tmpRng.setEndAfter(parentBlock);fragment=tmpRng.extractContents();trimLeadingLineBreaks(fragment);newBlock=fragment.firstChild;dom.insertAfter(fragment,parentBlock);trimInlineElementsOnLeftSideOfBlock(dom,nonEmptyElementsMap,newBlock);addBrToBlockIfNeeded(dom,parentBlock);if(dom.isEmpty(parentBlock)){emptyBlock(parentBlock);}newBlock.normalize();if(dom.isEmpty(newBlock)){dom.remove(newBlock);insertNewBlockAfter();}else{$_djhyrv7fjk26xgag.moveToCaretPosition(editor,newBlock);}}dom.setAttrib(newBlock,'id','');editor.fire('NewBlock',{newBlock:newBlock});};var $_32blss7djk26xg9x={insert:insert$2};var matchesSelector=function matchesSelector(editor,selector){return $_djhyrv7fjk26xgag.getParentBlock(editor).filter(function(parentBlock){return selector.length>0&&$_95wtq21gjk26xeyv.is(Element$$1.fromDom(parentBlock),selector);}).isSome();};var shouldInsertBr=function shouldInsertBr(editor){return matchesSelector(editor,$_8xhf1m38jk26xfc6.getBrNewLineSelector(editor));};var shouldBlockNewLine=function shouldBlockNewLine(editor){return matchesSelector(editor,$_8xhf1m38jk26xfc6.getNoNewLineSelector(editor));};var $_7dw2ag7hjk26xgb1={shouldInsertBr:shouldInsertBr,shouldBlockNewLine:shouldBlockNewLine};var newLineAction=Adt.generate([{br:[]},{block:[]},{none:[]}]);var shouldBlockNewLine$1=function shouldBlockNewLine$1(editor,shiftKey){return $_7dw2ag7hjk26xgb1.shouldBlockNewLine(editor);};var isBrMode=function isBrMode(requiredState){return function(editor,shiftKey){var brMode=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor)==='';return brMode===requiredState;};};var inListBlock=function inListBlock(requiredState){return function(editor,shiftKey){return $_djhyrv7fjk26xgag.isListItemParentBlock(editor)===requiredState;};};var inBlock=function inBlock(blockName,requiredState){return function(editor,shiftKey){var state=$_djhyrv7fjk26xgag.getParentBlockName(editor)===blockName.toUpperCase();return state===requiredState;};};var inPreBlock=function inPreBlock(requiredState){return inBlock('pre',requiredState);};var inSummaryBlock=function inSummaryBlock(){return inBlock('summary',true);};var shouldPutBrInPre$1=function shouldPutBrInPre$1(requiredState){return function(editor,shiftKey){return $_8xhf1m38jk26xfc6.shouldPutBrInPre(editor)===requiredState;};};var inBrContext=function inBrContext(editor,shiftKey){return $_7dw2ag7hjk26xgb1.shouldInsertBr(editor);};var hasShiftKey=function hasShiftKey(editor,shiftKey){return shiftKey;};var canInsertIntoEditableRoot=function canInsertIntoEditableRoot(editor){var forcedRootBlock=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);var rootEditable=$_djhyrv7fjk26xgag.getEditableRoot(editor.dom,editor.selection.getStart());return rootEditable&&editor.schema.isValidChild(rootEditable.nodeName,forcedRootBlock?forcedRootBlock:'P');};var match$2=function match$2(predicates,action){return function(editor,shiftKey){var isMatch=foldl(predicates,function(res,p){return res&&p(editor,shiftKey);},true);return isMatch?Option.some(action):Option.none();};};var getAction$1=function getAction$1(editor,evt){return $_2e2q5t49jk26xfnx.evaluateUntil([match$2([shouldBlockNewLine$1],newLineAction.none()),match$2([inSummaryBlock()],newLineAction.br()),match$2([inPreBlock(true),shouldPutBrInPre$1(false),hasShiftKey],newLineAction.br()),match$2([inPreBlock(true),shouldPutBrInPre$1(false)],newLineAction.block()),match$2([inPreBlock(true),shouldPutBrInPre$1(true),hasShiftKey],newLineAction.block()),match$2([inPreBlock(true),shouldPutBrInPre$1(true)],newLineAction.br()),match$2([inListBlock(true),hasShiftKey],newLineAction.br()),match$2([inListBlock(true)],newLineAction.block()),match$2([isBrMode(true),hasShiftKey,canInsertIntoEditableRoot],newLineAction.block()),match$2([isBrMode(true)],newLineAction.br()),match$2([inBrContext],newLineAction.br()),match$2([isBrMode(false),hasShiftKey],newLineAction.br()),match$2([canInsertIntoEditableRoot],newLineAction.block())],[editor,evt.shiftKey]).getOr(newLineAction.none());};var $_7y6ulf7gjk26xgao={getAction:getAction$1};var insert$3=function insert$3(editor,evt){$_7y6ulf7gjk26xgao.getAction(editor,evt).fold(function(){$_e33zri4ijk26xfqa.insert(editor,evt);},function(){$_32blss7djk26xg9x.insert(editor,evt);},noop);};var $_f7zroa7cjk26xg9n={insert:insert$3};var endTypingLevel=function endTypingLevel(undoManager){if(undoManager.typing){undoManager.typing=false;undoManager.add();}};var handleEnterKeyEvent=function handleEnterKeyEvent(editor,event){if(event.isDefaultPrevented()){return;}event.preventDefault();endTypingLevel(editor.undoManager);editor.undoManager.transact(function(){if(editor.selection.isCollapsed()===false){editor.execCommand('Delete');}$_f7zroa7cjk26xg9n.insert(editor,event);});};var setup$9=function setup$9(editor){editor.on('keydown',function(event){if(event.keyCode===$_o3p025wjk26xfz2.ENTER){handleEnterKeyEvent(editor,event);}});};var $_a8zwcq7bjk26xg9m={setup:setup$9};var isValidInsertPoint=function isValidInsertPoint(location,caretPosition){return isAtStartOrEnd(location)&&$_fpgwqg1rjk26xf0n.isText(caretPosition.container());};var insertNbspAtPosition=function insertNbspAtPosition(editor,caretPosition){var container=caretPosition.container();var offset=caretPosition.offset();container.insertData(offset,'\xA0');editor.selection.setCursorLocation(container,offset+1);};var insertAtLocation=function insertAtLocation(editor,caretPosition,location){if(isValidInsertPoint(location,caretPosition)){insertNbspAtPosition(editor,caretPosition);return true;}else{return false;}};var insertAtCaret$2=function insertAtCaret$2(editor){var isInlineTarget=curry($_eegxt33tjk26xfjt.isInlineTarget,editor);var caretPosition=CaretPosition$1.fromRangeStart(editor.selection.getRng());var boundaryLocation=$_esp13i48jk26xfni.readLocation(isInlineTarget,editor.getBody(),caretPosition);return boundaryLocation.map(curry(insertAtLocation,editor,caretPosition)).getOr(false);};var isAtStartOrEnd=function isAtStartOrEnd(location){return location.fold(constant(false),constant(true),constant(true),constant(false));};var insertAtSelection=function insertAtSelection(editor){return editor.selection.isCollapsed()?insertAtCaret$2(editor):false;};var $_4g04ni7jjk26xgbb={insertAtSelection:insertAtSelection};var executeKeydownOverride$2=function executeKeydownOverride$2(editor,evt){$_c8auke78jk26xg92.execute([{keyCode:$_o3p025wjk26xfz2.SPACEBAR,action:$_c8auke78jk26xg92.action($_4g04ni7jjk26xgbb.insertAtSelection,editor)}],evt).each(function(_){evt.preventDefault();});};var setup$10=function setup$10(editor){editor.on('keydown',function(evt){if(evt.isDefaultPrevented()===false){executeKeydownOverride$2(editor,evt);}});};var $_35dc8k7ijk26xgb9={setup:setup$10};var findBlockCaretContainer=function findBlockCaretContainer(editor){return $_dbgjqa29jk26xf4u.descendant(Element$$1.fromDom(editor.getBody()),'*[data-mce-caret]').fold(constant(null),function(elm){return elm.dom();});};var removeIeControlRect=function removeIeControlRect(editor){editor.selection.setRng(editor.selection.getRng());};var showBlockCaretContainer=function showBlockCaretContainer(editor,blockCaretContainer){if(blockCaretContainer.hasAttribute('data-mce-caret')){showCaretContainerBlock(blockCaretContainer);removeIeControlRect(editor);editor.selection.scrollIntoView(blockCaretContainer);}};var handleBlockContainer=function handleBlockContainer(editor,e){var blockCaretContainer=findBlockCaretContainer(editor);if(!blockCaretContainer){return;}if(e.type==='compositionstart'){e.preventDefault();e.stopPropagation();showBlockCaretContainer(editor,blockCaretContainer);return;}if(hasContent(blockCaretContainer)){showBlockCaretContainer(editor,blockCaretContainer);editor.undoManager.add();}};var setup$11=function setup$11(editor){editor.on('keyup compositionstart',curry(handleBlockContainer,editor));};var $_55r4ps7kjk26xgbf={setup:setup$11};var setup$12=function setup$12(editor){var caret=$_74odh54ajk26xfo1.setupSelectedState(editor);$_55r4ps7kjk26xgbf.setup(editor);$_43f9k776jk26xg8q.setup(editor,caret);$_64s7br79jk26xg99.setup(editor,caret);$_a8zwcq7bjk26xg9m.setup(editor);$_35dc8k7ijk26xgb9.setup(editor);};var $_8opzj875jk26xg8o={setup:setup$12};function Quirks(editor){var each=$_2ytxahljk26xetf.each;var BACKSPACE=$_o3p025wjk26xfz2.BACKSPACE,DELETE=$_o3p025wjk26xfz2.DELETE,dom=editor.dom,selection=editor.selection,settings=editor.settings,parser=editor.parser;var isGecko=$_ef6mqpajk26xejm.gecko,isIE=$_ef6mqpajk26xejm.ie,isWebKit=$_ef6mqpajk26xejm.webkit;var mceInternalUrlPrefix='data:text/mce-internal,';var mceInternalDataType=isIE?'Text':'URL';var setEditorCommandState=function setEditorCommandState(cmd,state){try{editor.getDoc().execCommand(cmd,false,state);}catch(ex){}};var isDefaultPrevented=function isDefaultPrevented(e){return e.isDefaultPrevented();};var setMceInternalContent=function setMceInternalContent(e){var selectionHtml,internalContent;if(e.dataTransfer){if(editor.selection.isCollapsed()&&e.target.tagName==='IMG'){selection.select(e.target);}selectionHtml=editor.selection.getContent();if(selectionHtml.length>0){internalContent=mceInternalUrlPrefix+escape(editor.id)+','+escape(selectionHtml);e.dataTransfer.setData(mceInternalDataType,internalContent);}}};var getMceInternalContent=function getMceInternalContent(e){var internalContent;if(e.dataTransfer){internalContent=e.dataTransfer.getData(mceInternalDataType);if(internalContent&&internalContent.indexOf(mceInternalUrlPrefix)>=0){internalContent=internalContent.substr(mceInternalUrlPrefix.length).split(',');return{id:unescape(internalContent[0]),html:unescape(internalContent[1])};}}return null;};var insertClipboardContents=function insertClipboardContents(content,internal){if(editor.queryCommandSupported('mceInsertClipboardContent')){editor.execCommand('mceInsertClipboardContent',false,{content:content,internal:internal});}else{editor.execCommand('mceInsertContent',false,content);}};var emptyEditorWhenDeleting=function emptyEditorWhenDeleting(){var serializeRng=function serializeRng(rng){var body=dom.create('body');var contents=rng.cloneContents();body.appendChild(contents);return selection.serializer.serialize(body,{format:'html'});};var allContentsSelected=function allContentsSelected(rng){var selection=serializeRng(rng);var allRng=dom.createRng();allRng.selectNode(editor.getBody());var allSelection=serializeRng(allRng);return selection===allSelection;};editor.on('keydown',function(e){var keyCode=e.keyCode;var isCollapsed,body;if(!isDefaultPrevented(e)&&(keyCode===DELETE||keyCode===BACKSPACE)){isCollapsed=editor.selection.isCollapsed();body=editor.getBody();if(isCollapsed&&!dom.isEmpty(body)){return;}if(!isCollapsed&&!allContentsSelected(editor.selection.getRng())){return;}e.preventDefault();editor.setContent('');if(body.firstChild&&dom.isBlock(body.firstChild)){editor.selection.setCursorLocation(body.firstChild,0);}else{editor.selection.setCursorLocation(body,0);}editor.nodeChanged();}});};var selectAll=function selectAll(){editor.shortcuts.add('meta+a',null,'SelectAll');};var inputMethodFocus=function inputMethodFocus(){if(!editor.settings.content_editable){dom.bind(editor.getDoc(),'mousedown mouseup',function(e){var rng;if(e.target===editor.getDoc().documentElement){rng=selection.getRng();editor.getBody().focus();if(e.type==='mousedown'){if(isCaretContainer(rng.startContainer)){return;}selection.placeCaretAt(e.clientX,e.clientY);}else{selection.setRng(rng);}}});}};var removeHrOnBackspace=function removeHrOnBackspace(){editor.on('keydown',function(e){if(!isDefaultPrevented(e)&&e.keyCode===BACKSPACE){if(!editor.getBody().getElementsByTagName('hr').length){return;}if(selection.isCollapsed()&&selection.getRng().startOffset===0){var node=selection.getNode();var previousSibling=node.previousSibling;if(node.nodeName==='HR'){dom.remove(node);e.preventDefault();return;}if(previousSibling&&previousSibling.nodeName&&previousSibling.nodeName.toLowerCase()==='hr'){dom.remove(previousSibling);e.preventDefault();}}}});};var focusBody=function focusBody(){if(!Range.prototype.getClientRects){editor.on('mousedown',function(e){if(!isDefaultPrevented(e)&&e.target.nodeName==='HTML'){var body_1=editor.getBody();body_1.blur();$_3a7ompijk26xer0.setEditorTimeout(editor,function(){body_1.focus();});}});}};var selectControlElements=function selectControlElements(){editor.on('click',function(e){var target=e.target;if(/^(IMG|HR)$/.test(target.nodeName)&&dom.getContentEditableParent(target)!=='false'){e.preventDefault();editor.selection.select(target);editor.nodeChanged();}if(target.nodeName==='A'&&dom.hasClass(target,'mce-item-anchor')){e.preventDefault();selection.select(target);}});};var removeStylesWhenDeletingAcrossBlockElements=function removeStylesWhenDeletingAcrossBlockElements(){var getAttributeApplyFunction=function getAttributeApplyFunction(){var template=dom.getAttribs(selection.getStart().cloneNode(false));return function(){var target=selection.getStart();if(target!==editor.getBody()){dom.setAttrib(target,'style',null);each(template,function(attr){target.setAttributeNode(attr.cloneNode(true));});}};};var isSelectionAcrossElements=function isSelectionAcrossElements(){return!selection.isCollapsed()&&dom.getParent(selection.getStart(),dom.isBlock)!==dom.getParent(selection.getEnd(),dom.isBlock);};editor.on('keypress',function(e){var applyAttributes;if(!isDefaultPrevented(e)&&(e.keyCode===8||e.keyCode===46)&&isSelectionAcrossElements()){applyAttributes=getAttributeApplyFunction();editor.getDoc().execCommand('delete',false,null);applyAttributes();e.preventDefault();return false;}});dom.bind(editor.getDoc(),'cut',function(e){var applyAttributes;if(!isDefaultPrevented(e)&&isSelectionAcrossElements()){applyAttributes=getAttributeApplyFunction();$_3a7ompijk26xer0.setEditorTimeout(editor,function(){applyAttributes();});}});};var disableBackspaceIntoATable=function disableBackspaceIntoATable(){editor.on('keydown',function(e){if(!isDefaultPrevented(e)&&e.keyCode===BACKSPACE){if(selection.isCollapsed()&&selection.getRng().startOffset===0){var previousSibling=selection.getNode().previousSibling;if(previousSibling&&previousSibling.nodeName&&previousSibling.nodeName.toLowerCase()==='table'){e.preventDefault();return false;}}}});};var removeBlockQuoteOnBackSpace=function removeBlockQuoteOnBackSpace(){editor.on('keydown',function(e){var rng,container,offset,root,parent$$1;if(isDefaultPrevented(e)||e.keyCode!==$_o3p025wjk26xfz2.BACKSPACE){return;}rng=selection.getRng();container=rng.startContainer;offset=rng.startOffset;root=dom.getRoot();parent$$1=container;if(!rng.collapsed||offset!==0){return;}while(parent$$1&&parent$$1.parentNode&&parent$$1.parentNode.firstChild===parent$$1&&parent$$1.parentNode!==root){parent$$1=parent$$1.parentNode;}if(parent$$1.tagName==='BLOCKQUOTE'){editor.formatter.toggle('blockquote',null,parent$$1);rng=dom.createRng();rng.setStart(container,0);rng.setEnd(container,0);selection.setRng(rng);}});};var setGeckoEditingOptions=function setGeckoEditingOptions(){var setOpts=function setOpts(){setEditorCommandState('StyleWithCSS',false);setEditorCommandState('enableInlineTableEditing',false);if(!settings.object_resizing){setEditorCommandState('enableObjectResizing',false);}};if(!settings.readonly){editor.on('BeforeExecCommand MouseDown',setOpts);}};var addBrAfterLastLinks=function addBrAfterLastLinks(){var fixLinks=function fixLinks(){each(dom.select('a'),function(node){var parentNode=node.parentNode;var root=dom.getRoot();if(parentNode.lastChild===node){while(parentNode&&!dom.isBlock(parentNode)){if(parentNode.parentNode.lastChild!==parentNode||parentNode===root){return;}parentNode=parentNode.parentNode;}dom.add(parentNode,'br',{'data-mce-bogus':1});}});};editor.on('SetContent ExecCommand',function(e){if(e.type==='setcontent'||e.command==='mceInsertLink'){fixLinks();}});};var setDefaultBlockType=function setDefaultBlockType(){if(settings.forced_root_block){editor.on('init',function(){setEditorCommandState('DefaultParagraphSeparator',settings.forced_root_block);});}};var normalizeSelection=function normalizeSelection(){editor.on('keyup focusin mouseup',function(e){if(!$_o3p025wjk26xfz2.modifierPressed(e)){selection.normalize();}},true);};var showBrokenImageIcon=function showBrokenImageIcon(){editor.contentStyles.push('img:-moz-broken {'+'-moz-force-broken-image-icon:1;'+'min-width:24px;'+'min-height:24px'+'}');};var restoreFocusOnKeyDown=function restoreFocusOnKeyDown(){if(!editor.inline){editor.on('keydown',function(){if(document.activeElement===document.body){editor.getWin().focus();}});}};var bodyHeight=function bodyHeight(){if(!editor.inline){editor.contentStyles.push('body {min-height: 150px}');editor.on('click',function(e){var rng;if(e.target.nodeName==='HTML'){if($_ef6mqpajk26xejm.ie>11){editor.getBody().focus();return;}rng=editor.selection.getRng();editor.getBody().focus();editor.selection.setRng(rng);editor.selection.normalize();editor.nodeChanged();}});}};var blockCmdArrowNavigation=function blockCmdArrowNavigation(){if($_ef6mqpajk26xejm.mac){editor.on('keydown',function(e){if($_o3p025wjk26xfz2.metaKeyPressed(e)&&!e.shiftKey&&(e.keyCode===37||e.keyCode===39)){e.preventDefault();editor.selection.getSel().modify('move',e.keyCode===37?'backward':'forward','lineboundary');}});}};var disableAutoUrlDetect=function disableAutoUrlDetect(){setEditorCommandState('AutoUrlDetect',false);};var tapLinksAndImages=function tapLinksAndImages(){editor.on('click',function(e){var elm=e.target;do{if(elm.tagName==='A'){e.preventDefault();return;}}while(elm=elm.parentNode);});editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');};var blockFormSubmitInsideEditor=function blockFormSubmitInsideEditor(){editor.on('init',function(){editor.dom.bind(editor.getBody(),'submit',function(e){e.preventDefault();});});};var removeAppleInterchangeBrs=function removeAppleInterchangeBrs(){parser.addNodeFilter('br',function(nodes){var i=nodes.length;while(i--){if(nodes[i].attr('class')==='Apple-interchange-newline'){nodes[i].remove();}}});};var ieInternalDragAndDrop=function ieInternalDragAndDrop(){editor.on('dragstart',function(e){setMceInternalContent(e);});editor.on('drop',function(e){if(!isDefaultPrevented(e)){var internalContent=getMceInternalContent(e);if(internalContent&&internalContent.id!==editor.id){e.preventDefault();var rng=$_11ohb66xjk26xg6m.fromPoint(e.x,e.y,editor.getDoc());selection.setRng(rng);insertClipboardContents(internalContent.html,true);}}});};var refreshContentEditable=function refreshContentEditable(){};var isHidden=function isHidden(){var sel;if(!isGecko||editor.removed){return 0;}sel=editor.selection.getSel();return!sel||!sel.rangeCount||sel.rangeCount===0;};removeBlockQuoteOnBackSpace();emptyEditorWhenDeleting();if(!$_ef6mqpajk26xejm.windowsPhone){normalizeSelection();}if(isWebKit){inputMethodFocus();selectControlElements();setDefaultBlockType();blockFormSubmitInsideEditor();disableBackspaceIntoATable();removeAppleInterchangeBrs();if($_ef6mqpajk26xejm.iOS){restoreFocusOnKeyDown();bodyHeight();tapLinksAndImages();}else{selectAll();}}if($_ef6mqpajk26xejm.ie>=11){bodyHeight();disableBackspaceIntoATable();}if($_ef6mqpajk26xejm.ie){selectAll();disableAutoUrlDetect();ieInternalDragAndDrop();}if(isGecko){removeHrOnBackspace();focusBody();removeStylesWhenDeletingAcrossBlockElements();setGeckoEditingOptions();addBrAfterLastLinks();showBrokenImageIcon();blockCmdArrowNavigation();disableBackspaceIntoATable();}return{refreshContentEditable:refreshContentEditable,isHidden:isHidden};}var isTextBlockNode=function isTextBlockNode(node){return $_fpgwqg1rjk26xf0n.isElement(node)&&isTextBlock(Element$$1.fromDom(node));};var normalizeSelection$1=function normalizeSelection$1(editor){var rng=editor.selection.getRng();var startPos=CaretPosition.fromRangeStart(rng);var endPos=CaretPosition.fromRangeEnd(rng);if(CaretPosition.isElementPosition(startPos)){var container=startPos.container();if(isTextBlockNode(container)){$_bwopbb2yjk26xf9h.firstPositionIn(container).each(function(pos){return rng.setStart(pos.container(),pos.offset());});}}if(CaretPosition.isElementPosition(endPos)){var container=startPos.container();if(isTextBlockNode(container)){$_bwopbb2yjk26xf9h.lastPositionIn(container).each(function(pos){return rng.setEnd(pos.container(),pos.offset());});}}editor.selection.setRng($_9o204u3ojk26xfis.normalize(rng));};var setup$13=function setup$13(editor){editor.on('click',function(e){if(e.detail===3){normalizeSelection$1(editor);}});};var $_6u4rgq7mjk26xgbz={setup:setup$13};var preventSummaryToggle=function preventSummaryToggle(editor){editor.on('click',function(e){if(editor.dom.getParent(e.target,'details')){e.preventDefault();}});};var filterDetails=function filterDetails(editor){editor.parser.addNodeFilter('details',function(elms){each(elms,function(details){details.attr('data-mce-open',details.attr('open'));details.attr('open','open');});});editor.serializer.addNodeFilter('details',function(elms){each(elms,function(details){var open=details.attr('data-mce-open');details.attr('open',isString(open)?open:null);details.attr('data-mce-open',null);});});};var setup$14=function setup$14(editor){preventSummaryToggle(editor);filterDetails(editor);};var DOM$2=DOMUtils$1.DOM;var appendStyle=function appendStyle(editor,text){var head=Element$$1.fromDom(editor.getDoc().head);var tag=Element$$1.fromTag('style');$_5xapbx15jk26xewz.set(tag,'type','text/css');$_9t36rc1yjk26xf33.append(tag,Element$$1.fromText(text));$_9t36rc1yjk26xf33.append(head,tag);};var createParser=function createParser(editor){var parser=DomParser(editor.settings,editor.schema);parser.addAttributeFilter('src,href,style,tabindex',function(nodes,name$$1){var i=nodes.length,node;var dom=editor.dom;var value,internalName;while(i--){node=nodes[i];value=node.attr(name$$1);internalName='data-mce-'+name$$1;if(!node.attributes.map[internalName]){if(value.indexOf('data:')===0||value.indexOf('blob:')===0){continue;}if(name$$1==='style'){value=dom.serializeStyle(dom.parseStyle(value),node.name);if(!value.length){value=null;}node.attr(internalName,value);node.attr(name$$1,value);}else if(name$$1==='tabindex'){node.attr(internalName,value);node.attr(name$$1,null);}else{node.attr(internalName,editor.convertURL(value,name$$1,node.name));}}}});parser.addNodeFilter('script',function(nodes){var i=nodes.length,node,type;while(i--){node=nodes[i];type=node.attr('type')||'no/type';if(type.indexOf('mce-')!==0){node.attr('type','mce-'+type);}}});parser.addNodeFilter('#cdata',function(nodes){var i=nodes.length,node;while(i--){node=nodes[i];node.type=8;node.name='#comment';node.value='[CDATA['+node.value+']]';}});parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div',function(nodes){var i=nodes.length,node;var nonEmptyElements=editor.schema.getNonEmptyElements();while(i--){node=nodes[i];if(node.isEmpty(nonEmptyElements)&&node.getAll('br').length===0){node.append(new Node$2('br',1)).shortEnded=true;}}});return parser;};var autoFocus=function autoFocus(editor){if(editor.settings.auto_focus){$_3a7ompijk26xer0.setEditorTimeout(editor,function(){var focusEditor;if(editor.settings.auto_focus===true){focusEditor=editor;}else{focusEditor=editor.editorManager.get(editor.settings.auto_focus);}if(!focusEditor.destroyed){focusEditor.focus();}},100);}};var initEditor=function initEditor(editor){editor.bindPendingEventDelegates();editor.initialized=true;editor.fire('init');editor.focus(true);editor.nodeChanged({initial:true});editor.execCallback('init_instance_callback',editor);autoFocus(editor);};var getStyleSheetLoader=function getStyleSheetLoader(editor){return editor.inline?DOM$2.styleSheetLoader:editor.dom.styleSheetLoader;};var initContentBody=function initContentBody(editor,skipWrite){var settings=editor.settings;var targetElm=editor.getElement();var doc=editor.getDoc(),body,contentCssText;if(!settings.inline){editor.getElement().style.visibility=editor.orgVisibility;}if(!skipWrite&&!settings.content_editable){doc.open();doc.write(editor.iframeHTML);doc.close();}if(settings.content_editable){editor.on('remove',function(){var bodyEl=this.getBody();DOM$2.removeClass(bodyEl,'mce-content-body');DOM$2.removeClass(bodyEl,'mce-edit-focus');DOM$2.setAttrib(bodyEl,'contentEditable',null);});DOM$2.addClass(targetElm,'mce-content-body');editor.contentDocument=doc=settings.content_document||document;editor.contentWindow=settings.content_window||window;editor.bodyElement=targetElm;settings.content_document=settings.content_window=null;settings.root_name=targetElm.nodeName.toLowerCase();}body=editor.getBody();body.disabled=true;editor.readonly=settings.readonly;if(!editor.readonly){if(editor.inline&&DOM$2.getStyle(body,'position',true)==='static'){body.style.position='relative';}body.contentEditable=editor.getParam('content_editable_state',true);}body.disabled=false;editor.editorUpload=EditorUpload(editor);editor.schema=Schema(settings);editor.dom=DOMUtils$1(doc,{keep_values:true,url_converter:editor.convertURL,url_converter_scope:editor,hex_colors:settings.force_hex_style_colors,class_filter:settings.class_filter,update_styles:true,root_element:editor.inline?editor.getBody():null,collect:settings.content_editable,schema:editor.schema,onSetAttrib:function onSetAttrib(e){editor.fire('SetAttrib',e);}});editor.parser=createParser(editor);editor.serializer=DomSerializer$1(settings,editor);editor.selection=Selection$1(editor.dom,editor.getWin(),editor.serializer,editor);editor.experimental=Experimental(editor);editor.formatter=Formatter(editor);editor.undoManager=UndoManager(editor);editor._nodeChangeDispatcher=new NodeChange(editor);editor._selectionOverrides=SelectionOverrides(editor);setup$14(editor);$_6u4rgq7mjk26xgbz.setup(editor);$_8opzj875jk26xg8o.setup(editor);$_2mzk445ljk26xfwk.setup(editor);editor.fire('PreInit');if(!settings.browser_spellcheck&&!settings.gecko_spellcheck){doc.body.spellcheck=false;DOM$2.setAttrib(body,'spellcheck','false');}editor.quirks=Quirks(editor);editor.fire('PostRender');if(settings.directionality){body.dir=settings.directionality;}if(settings.nowrap){body.style.whiteSpace='nowrap';}if(settings.protect){editor.on('BeforeSetContent',function(e){$_2ytxahljk26xetf.each(settings.protect,function(pattern){e.content=e.content.replace(pattern,function(str){return'<!--mce:protected '+escape(str)+'-->';});});});}editor.on('SetContent',function(){editor.addVisual(editor.getBody());});editor.load({initial:true,format:'html'});editor.startContent=editor.getContent({format:'raw'});editor.on('compositionstart compositionend',function(e){editor.composing=e.type==='compositionstart';});if(editor.contentStyles.length>0){contentCssText='';$_2ytxahljk26xetf.each(editor.contentStyles,function(style){contentCssText+=style+'\r\n';});editor.dom.addStyle(contentCssText);}getStyleSheetLoader(editor).loadAll(editor.contentCSS,function(_){initEditor(editor);},function(urls){initEditor(editor);});if(settings.content_style){appendStyle(editor,settings.content_style);}};var $_7ics9z58jk26xfuu={initContentBody:initContentBody};var DOM$3=DOMUtils$1.DOM;var relaxDomain=function relaxDomain(editor,ifr){if(document.domain!==window.location.hostname&&$_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<12){var bodyUuid=$_7xi2o55jjk26xfwg.uuid('mce');editor[bodyUuid]=function(){$_7ics9z58jk26xfuu.initContentBody(editor);};var domainRelaxUrl='javascript:(function(){'+'document.open();document.domain="'+document.domain+'";'+'var ed = window.parent.tinymce.get("'+editor.id+'");document.write(ed.iframeHTML);'+'document.close();ed.'+bodyUuid+'(true);})()';DOM$3.setAttrib(ifr,'src',domainRelaxUrl);return true;}return false;};var normalizeHeight=function normalizeHeight(height){var normalizedHeight=typeof height==='number'?height+'px':height;return normalizedHeight?normalizedHeight:'';};var createIframeElement=function createIframeElement(id,title,height,customAttrs){var iframe=Element$$1.fromTag('iframe');$_5xapbx15jk26xewz.setAll(iframe,customAttrs);$_5xapbx15jk26xewz.setAll(iframe,{id:id+'_ifr',frameBorder:'0',allowTransparency:'true',title:title});$_15rddx13jk26xew4.setAll(iframe,{width:'100%',height:normalizeHeight(height),display:'block'});return iframe;};var getIframeHtml=function getIframeHtml(editor){var bodyId,bodyClass,iframeHTML;iframeHTML=$_8xhf1m38jk26xfc6.getDocType(editor)+'<html><head>';if($_8xhf1m38jk26xfc6.getDocumentBaseUrl(editor)!==editor.documentBaseUrl){iframeHTML+='<base href="'+editor.documentBaseURI.getURI()+'" />';}iframeHTML+='<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';bodyId=$_8xhf1m38jk26xfc6.getBodyId(editor);bodyClass=$_8xhf1m38jk26xfc6.getBodyClass(editor);if($_8xhf1m38jk26xfc6.getContentSecurityPolicy(editor)){iframeHTML+='<meta http-equiv="Content-Security-Policy" content="'+$_8xhf1m38jk26xfc6.getContentSecurityPolicy(editor)+'" />';}iframeHTML+='</head><body id="'+bodyId+'" class="mce-content-body '+bodyClass+'" data-id="'+editor.id+'"><br></body></html>';return iframeHTML;};var createIframe=function createIframe(editor,o){var title=editor.editorManager.translate('Rich Text Area. Press ALT-F9 for menu. '+'Press ALT-F10 for toolbar. Press ALT-0 for help');var ifr=createIframeElement(editor.id,title,o.height,$_8xhf1m38jk26xfc6.getIframeAttrs(editor)).dom();ifr.onload=function(){ifr.onload=null;editor.fire('load');};var isDomainRelaxed=relaxDomain(editor,ifr);editor.contentAreaContainer=o.iframeContainer;editor.iframeElement=ifr;editor.iframeHTML=getIframeHtml(editor);DOM$3.add(o.iframeContainer,ifr);return isDomainRelaxed;};var init$1=function init$1(editor,boxInfo){var isDomainRelaxed=createIframe(editor,boxInfo);if(boxInfo.editorContainer){DOM$3.get(boxInfo.editorContainer).style.display=editor.orgDisplay;editor.hidden=DOM$3.isHidden(boxInfo.editorContainer);}editor.getElement().style.display='none';DOM$3.setAttrib(editor.id,'aria-hidden','true');if(!isDomainRelaxed){$_7ics9z58jk26xfuu.initContentBody(editor);}};var $_cigv0e7ojk26xgc7={init:init$1};var DOM$4=DOMUtils$1.DOM;var initPlugin=function initPlugin(editor,initializedPlugins,plugin){var Plugin=PluginManager$1.get(plugin);var pluginUrl,pluginInstance;pluginUrl=PluginManager$1.urls[plugin]||editor.documentBaseUrl.replace(/\/$/,'');plugin=$_2ytxahljk26xetf.trim(plugin);if(Plugin&&$_2ytxahljk26xetf.inArray(initializedPlugins,plugin)===-1){$_2ytxahljk26xetf.each(PluginManager$1.dependencies(plugin),function(dep){initPlugin(editor,initializedPlugins,dep);});if(editor.plugins[plugin]){return;}pluginInstance=new Plugin(editor,pluginUrl,editor.$);editor.plugins[plugin]=pluginInstance;if(pluginInstance.init){pluginInstance.init(editor,pluginUrl);initializedPlugins.push(plugin);}}};var trimLegacyPrefix=function trimLegacyPrefix(name){return name.replace(/^\-/,'');};var initPlugins=function initPlugins(editor){var initializedPlugins=[];$_2ytxahljk26xetf.each(editor.settings.plugins.split(/[ ,]/),function(name){initPlugin(editor,initializedPlugins,trimLegacyPrefix(name));});};var initTheme=function initTheme(editor){var Theme;var theme=editor.settings.theme;if(isString(theme)){editor.settings.theme=trimLegacyPrefix(theme);Theme=ThemeManager.get(theme);editor.theme=new Theme(editor,ThemeManager.urls[theme]);if(editor.theme.init){editor.theme.init(editor,ThemeManager.urls[theme]||editor.documentBaseUrl.replace(/\/$/,''),editor.$);}}else{editor.theme={};}};var renderFromLoadedTheme=function renderFromLoadedTheme(editor){var w,h,minHeight,re,info;var settings=editor.settings;var elm=editor.getElement();w=settings.width||DOM$4.getStyle(elm,'width')||'100%';h=settings.height||DOM$4.getStyle(elm,'height')||elm.offsetHeight;minHeight=settings.min_height||100;re=/^[0-9\.]+(|px)$/i;if(re.test(''+w)){w=Math.max(parseInt(w,10),100);}if(re.test(''+h)){h=Math.max(parseInt(h,10),minHeight);}info=editor.theme.renderUI({targetNode:elm,width:w,height:h,deltaWidth:settings.delta_width,deltaHeight:settings.delta_height});if(!settings.content_editable){h=(info.iframeHeight||h)+(typeof h==='number'?info.deltaHeight||0:'');if(h<minHeight){h=minHeight;}}info.height=h;return info;};var renderFromThemeFunc=function renderFromThemeFunc(editor){var info;var elm=editor.getElement();info=editor.settings.theme(editor,elm);if(info.editorContainer.nodeType){info.editorContainer.id=info.editorContainer.id||editor.id+'_parent';}if(info.iframeContainer&&info.iframeContainer.nodeType){info.iframeContainer.id=info.iframeContainer.id||editor.id+'_iframecontainer';}info.height=info.iframeHeight?info.iframeHeight:elm.offsetHeight;return info;};var createThemeFalseResult=function createThemeFalseResult(element){return{editorContainer:element,iframeContainer:element};};var renderThemeFalseIframe=function renderThemeFalseIframe(targetElement){var iframeContainer=DOM$4.create('div');DOM$4.insertAfter(iframeContainer,targetElement);return createThemeFalseResult(iframeContainer);};var renderThemeFalse=function renderThemeFalse(editor){var targetElement=editor.getElement();return editor.inline?createThemeFalseResult(null):renderThemeFalseIframe(targetElement);};var renderThemeUi=function renderThemeUi(editor){var settings=editor.settings,elm=editor.getElement();editor.orgDisplay=elm.style.display;if(isString(settings.theme)){return renderFromLoadedTheme(editor);}else if(isFunction(settings.theme)){return renderFromThemeFunc(editor);}else{return renderThemeFalse(editor);}};var init$2=function init$2(editor){var settings=editor.settings;var elm=editor.getElement();var boxInfo;editor.rtl=settings.rtl_ui||editor.editorManager.i18n.rtl;editor.editorManager.i18n.setCode(settings.language);settings.aria_label=settings.aria_label||DOM$4.getAttrib(elm,'aria-label',editor.getLang('aria.rich_text_area'));editor.fire('ScriptsLoaded');initTheme(editor);initPlugins(editor);boxInfo=renderThemeUi(editor);editor.editorContainer=boxInfo.editorContainer?boxInfo.editorContainer:null;if(settings.content_css){$_2ytxahljk26xetf.each($_2ytxahljk26xetf.explode(settings.content_css),function(u){editor.contentCSS.push(editor.documentBaseURI.toAbsolute(u));});}if(settings.content_editable){return $_7ics9z58jk26xfuu.initContentBody(editor);}else{return $_cigv0e7ojk26xgc7.init(editor,boxInfo);}};var $_ipabn55jk26xfuk={init:init$2};var DOM$5=DOMUtils$1.DOM;var hasSkipLoadPrefix=function hasSkipLoadPrefix(name$$1){return name$$1.charAt(0)==='-';};var loadLanguage=function loadLanguage(scriptLoader,editor){var settings=editor.settings;if(settings.language&&settings.language!=='en'&&!settings.language_url){settings.language_url=editor.editorManager.baseURL+'/langs/'+settings.language+'.js';}if(settings.language_url&&!editor.editorManager.i18n.data[settings.language]){scriptLoader.add(settings.language_url);}};var loadTheme=function loadTheme(scriptLoader,editor,suffix,callback){var settings=editor.settings,theme=settings.theme;if(isString(theme)){if(!hasSkipLoadPrefix(theme)&&!ThemeManager.urls.hasOwnProperty(theme)){var themeUrl=settings.theme_url;if(themeUrl){ThemeManager.load(theme,editor.documentBaseURI.toAbsolute(themeUrl));}else{ThemeManager.load(theme,'themes/'+theme+'/theme'+suffix+'.js');}}scriptLoader.loadQueue(function(){ThemeManager.waitFor(theme,callback);});}else{callback();}};var loadPlugins=function loadPlugins(settings,suffix){if($_2ytxahljk26xetf.isArray(settings.plugins)){settings.plugins=settings.plugins.join(' ');}$_2ytxahljk26xetf.each(settings.external_plugins,function(url,name$$1){PluginManager$1.load(name$$1,url);settings.plugins+=' '+name$$1;});$_2ytxahljk26xetf.each(settings.plugins.split(/[ ,]/),function(plugin){plugin=$_2ytxahljk26xetf.trim(plugin);if(plugin&&!PluginManager$1.urls[plugin]){if(hasSkipLoadPrefix(plugin)){plugin=plugin.substr(1,plugin.length);var dependencies=PluginManager$1.dependencies(plugin);$_2ytxahljk26xetf.each(dependencies,function(dep){var defaultSettings={prefix:'plugins/',resource:dep,suffix:'/plugin'+suffix+'.js'};dep=PluginManager$1.createUrl(defaultSettings,dep);PluginManager$1.load(dep.resource,dep);});}else{PluginManager$1.load(plugin,{prefix:'plugins/',resource:plugin,suffix:'/plugin'+suffix+'.js'});}}});};var loadScripts=function loadScripts(editor,suffix){var scriptLoader=ScriptLoader.ScriptLoader;loadTheme(scriptLoader,editor,suffix,function(){loadLanguage(scriptLoader,editor);loadPlugins(editor.settings,suffix);scriptLoader.loadQueue(function(){if(!editor.removed){$_ipabn55jk26xfuk.init(editor);}},editor,function(urls){$_3uguhq54jk26xfug.pluginLoadError(editor,urls[0]);if(!editor.removed){$_ipabn55jk26xfuk.init(editor);}});});};var render=function render(editor){var settings=editor.settings,id=editor.id;var readyHandler=function readyHandler(){DOM$5.unbind(window,'ready',readyHandler);editor.render();};if(!EventUtils.Event.domLoaded){DOM$5.bind(window,'ready',readyHandler);return;}if(!editor.getElement()){return;}if(!$_ef6mqpajk26xejm.contentEditable){return;}if(!settings.inline){editor.orgVisibility=editor.getElement().style.visibility;editor.getElement().style.visibility='hidden';}else{editor.inline=true;}var form=editor.getElement().form||DOM$5.getParent(id,'form');if(form){editor.formElement=form;if(settings.hidden_input&&!/TEXTAREA|INPUT/i.test(editor.getElement().nodeName)){DOM$5.insertAfter(DOM$5.create('input',{type:'hidden',name:id}),id);editor.hasHiddenInput=true;}editor.formEventDelegate=function(e){editor.fire(e.type,e);};DOM$5.bind(form,'submit reset',editor.formEventDelegate);editor.on('reset',function(){editor.setContent(editor.startContent,{format:'raw'});});if(settings.submit_patch&&!form.submit.nodeType&&!form.submit.length&&!form._mceOldSubmit){form._mceOldSubmit=form.submit;form.submit=function(){editor.editorManager.triggerSave();editor.setDirty(false);return form._mceOldSubmit(form);};}}editor.windowManager=WindowManager(editor);editor.notificationManager=NotificationManager(editor);if(settings.encoding==='xml'){editor.on('GetContent',function(e){if(e.save){e.content=DOM$5.encode(e.content);}});}if(settings.add_form_submit_trigger){editor.on('submit',function(){if(editor.initialized){editor.save();}});}if(settings.add_unload_trigger){editor._beforeUnload=function(){if(editor.initialized&&!editor.destroyed&&!editor.isHidden()){editor.save({format:'raw',no_events:true,set_dirty:false});}};editor.editorManager.on('BeforeUnload',editor._beforeUnload);}editor.editorManager.add(editor);loadScripts(editor,editor.suffix);};var $_6d25b4yjk26xft7={render:render};var add$4=function add$4(editor,name,settings){var sidebars=editor.sidebars?editor.sidebars:[];sidebars.push({name:name,settings:settings});editor.sidebars=sidebars;};var $_d8v7r67pjk26xgcj={add:add$4};var each$20=$_2ytxahljk26xetf.each;var trim$4=$_2ytxahljk26xetf.trim;var queryParts='source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');var DEFAULT_PORTS={ftp:21,http:80,https:443,mailto:25};var URI=function URI(url,settings){var self$$1=this;var baseUri,baseUrl;url=trim$4(url);settings=self$$1.settings=settings||{};baseUri=settings.base_uri;if(/^([\w\-]+):([^\/]{2})/i.test(url)||/^\s*#/.test(url)){self$$1.source=url;return;}var isProtocolRelative=url.indexOf('//')===0;if(url.indexOf('/')===0&&!isProtocolRelative){url=(baseUri?baseUri.protocol||'http':'http')+'://mce_host'+url;}if(!/^[\w\-]*:?\/\//.test(url)){baseUrl=settings.base_uri?settings.base_uri.path:new URI(document.location.href).directory;if(settings.base_uri.protocol==''){url='//mce_host'+self$$1.toAbsPath(baseUrl,url);}else{url=/([^#?]*)([#?]?.*)/.exec(url);url=(baseUri&&baseUri.protocol||'http')+'://mce_host'+self$$1.toAbsPath(baseUrl,url[1])+url[2];}}url=url.replace(/@@/g,'(mce_at)');url=/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);each$20(queryParts,function(v,i){var part=url[i];if(part){part=part.replace(/\(mce_at\)/g,'@@');}self$$1[v]=part;});if(baseUri){if(!self$$1.protocol){self$$1.protocol=baseUri.protocol;}if(!self$$1.userInfo){self$$1.userInfo=baseUri.userInfo;}if(!self$$1.port&&self$$1.host==='mce_host'){self$$1.port=baseUri.port;}if(!self$$1.host||self$$1.host==='mce_host'){self$$1.host=baseUri.host;}self$$1.source='';}if(isProtocolRelative){self$$1.protocol='';}};URI.prototype={setPath:function setPath(path){var self$$1=this;path=/^(.*?)\/?(\w+)?$/.exec(path);self$$1.path=path[0];self$$1.directory=path[1];self$$1.file=path[2];self$$1.source='';self$$1.getURI();},toRelative:function toRelative(uri){var self$$1=this;var output;if(uri==='./'){return uri;}uri=new URI(uri,{base_uri:self$$1});if(uri.host!=='mce_host'&&self$$1.host!==uri.host&&uri.host||self$$1.port!==uri.port||self$$1.protocol!==uri.protocol&&uri.protocol!==''){return uri.getURI();}var tu=self$$1.getURI(),uu=uri.getURI();if(tu===uu||tu.charAt(tu.length-1)==='/'&&tu.substr(0,tu.length-1)===uu){return tu;}output=self$$1.toRelPath(self$$1.path,uri.path);if(uri.query){output+='?'+uri.query;}if(uri.anchor){output+='#'+uri.anchor;}return output;},toAbsolute:function toAbsolute(uri,noHost){uri=new URI(uri,{base_uri:this});return uri.getURI(noHost&&this.isSameOrigin(uri));},isSameOrigin:function isSameOrigin(uri){if(this.host==uri.host&&this.protocol==uri.protocol){if(this.port==uri.port){return true;}var defaultPort=DEFAULT_PORTS[this.protocol];if(defaultPort&&(this.port||defaultPort)==(uri.port||defaultPort)){return true;}}return false;},toRelPath:function toRelPath(base,path){var items,breakPoint=0,out='',i,l;base=base.substring(0,base.lastIndexOf('/'));base=base.split('/');items=path.split('/');if(base.length>=items.length){for(i=0,l=base.length;i<l;i++){if(i>=items.length||base[i]!==items[i]){breakPoint=i+1;break;}}}if(base.length<items.length){for(i=0,l=items.length;i<l;i++){if(i>=base.length||base[i]!==items[i]){breakPoint=i+1;break;}}}if(breakPoint===1){return path;}for(i=0,l=base.length-(breakPoint-1);i<l;i++){out+='../';}for(i=breakPoint-1,l=items.length;i<l;i++){if(i!==breakPoint-1){out+='/'+items[i];}else{out+=items[i];}}return out;},toAbsPath:function toAbsPath(base,path){var i,nb=0,o=[],tr,outPath;tr=/\/$/.test(path)?'/':'';base=base.split('/');path=path.split('/');each$20(base,function(k){if(k){o.push(k);}});base=o;for(i=path.length-1,o=[];i>=0;i--){if(path[i].length===0||path[i]==='.'){continue;}if(path[i]==='..'){nb++;continue;}if(nb>0){nb--;continue;}o.push(path[i]);}i=base.length-nb;if(i<=0){outPath=o.reverse().join('/');}else{outPath=base.slice(0,i).join('/')+'/'+o.reverse().join('/');}if(outPath.indexOf('/')!==0){outPath='/'+outPath;}if(tr&&outPath.lastIndexOf('/')!==outPath.length-1){outPath+=tr;}return outPath;},getURI:function getURI(noProtoHost){var s;var self$$1=this;if(!self$$1.source||noProtoHost){s='';if(!noProtoHost){if(self$$1.protocol){s+=self$$1.protocol+'://';}else{s+='//';}if(self$$1.userInfo){s+=self$$1.userInfo+'@';}if(self$$1.host){s+=self$$1.host;}if(self$$1.port){s+=':'+self$$1.port;}}if(self$$1.path){s+=self$$1.path;}if(self$$1.query){s+='?'+self$$1.query;}if(self$$1.anchor){s+='#'+self$$1.anchor;}self$$1.source=s;}return self$$1.source;}};URI.parseDataUri=function(uri){var type,matches;uri=decodeURIComponent(uri).split(',');matches=/data:([^;]+)/.exec(uri[0]);if(matches){type=matches[1];}return{type:type,data:uri[1]};};URI.getDocumentBaseUrl=function(loc){var baseUrl;if(loc.protocol.indexOf('http')!==0&&loc.protocol!=='file:'){baseUrl=loc.href;}else{baseUrl=loc.protocol+'//'+loc.host+loc.pathname;}if(/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)){baseUrl=baseUrl.replace(/[\?#].*$/,'').replace(/[\/\\][^\/]+$/,'');if(!/[\/\\]$/.test(baseUrl)){baseUrl+='/';}}return baseUrl;};var defaultFormat='html';var trimEmptyContents=function trimEmptyContents(editor,html){var blockName=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);var emptyRegExp=new RegExp('^(<'+blockName+'[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/'+blockName+'>[\r\n]*|<br \\/>[\r\n]*)$');return html.replace(emptyRegExp,'');};var getContentFromBody=function getContentFromBody(editor,args,body){var content;args.format=args.format?args.format:defaultFormat;args.get=true;args.getInner=true;if(!args.no_events){editor.fire('BeforeGetContent',args);}if(args.format==='raw'){content=$_2ytxahljk26xetf.trim($_22a2nj5zjk26xfzo.trimExternal(editor.serializer,body.innerHTML));}else if(args.format==='text'){content=$_4osibw2pjk26xf83.trim(body.innerText||body.textContent);}else if(args.format==='tree'){return editor.serializer.serialize(body,args);}else{content=trimEmptyContents(editor,editor.serializer.serialize(body,args));}if(args.format!=='text'&&!isWsPreserveElement(Element$$1.fromDom(body))){args.content=$_2ytxahljk26xetf.trim(content);}else{args.content=content;}if(!args.no_events){editor.fire('GetContent',args);}return args.content;};var getContent$1=function getContent$1(editor,args){if(args===void 0){args={};}return Option.from(editor.getBody()).fold(constant(args.format==='tree'?new Node$2('body',11):''),function(body){return getContentFromBody(editor,args,body);});};var traverse=function traverse(node,fn){fn(node);if(node.firstChild){traverse(node.firstChild,fn);}if(node.next){traverse(node.next,fn);}};var findMatchingNodes=function findMatchingNodes(nodeFilters,attributeFilters,node){var nodeMatches={};var attrMatches={};var matches=[];if(node.firstChild){traverse(node.firstChild,function(node){each(nodeFilters,function(filter$$1){if(filter$$1.name===node.name){if(nodeMatches[filter$$1.name]){nodeMatches[filter$$1.name].nodes.push(node);}else{nodeMatches[filter$$1.name]={filter:filter$$1,nodes:[node]};}}});each(attributeFilters,function(filter$$1){if(typeof node.attr(filter$$1.name)==='string'){if(attrMatches[filter$$1.name]){attrMatches[filter$$1.name].nodes.push(node);}else{attrMatches[filter$$1.name]={filter:filter$$1,nodes:[node]};}}});});}for(var name in nodeMatches){if(nodeMatches.hasOwnProperty(name)){matches.push(nodeMatches[name]);}}for(var name in attrMatches){if(attrMatches.hasOwnProperty(name)){matches.push(attrMatches[name]);}}return matches;};var filter$3=function filter$3(nodeFilters,attributeFilters,node){var matches=findMatchingNodes(nodeFilters,attributeFilters,node);each(matches,function(match){each(match.filter.callbacks,function(callback){callback(match.nodes,match.filter.name,{});});});};var defaultFormat$1='html';var isTreeNode=function isTreeNode(content){return content instanceof Node$2;};var moveSelection=function moveSelection(editor){if($_3hu41a4vjk26xfsm.hasFocus(editor)){$_bwopbb2yjk26xf9h.firstPositionIn(editor.getBody()).each(function(pos){var node=pos.getNode();var caretPos=$_fpgwqg1rjk26xf0n.isTable(node)?$_bwopbb2yjk26xf9h.firstPositionIn(node).getOr(pos):pos;editor.selection.setRng(caretPos.toRange());});}};var setEditorHtml=function setEditorHtml(editor,html){editor.dom.setHTML(editor.getBody(),html);moveSelection(editor);};var setContentString=function setContentString(editor,body,content,args){var forcedRootBlockName,padd;if(content.length===0||/^\s+$/.test(content)){padd='<br data-mce-bogus="1">';if(body.nodeName==='TABLE'){content='<tr><td>'+padd+'</td></tr>';}else if(/^(UL|OL)$/.test(body.nodeName)){content='<li>'+padd+'</li>';}forcedRootBlockName=$_8xhf1m38jk26xfc6.getForcedRootBlock(editor);if(forcedRootBlockName&&editor.schema.isValidChild(body.nodeName.toLowerCase(),forcedRootBlockName.toLowerCase())){content=padd;content=editor.dom.createHTML(forcedRootBlockName,editor.settings.forced_root_block_attrs,content);}else if(!content){content='<br data-mce-bogus="1">';}setEditorHtml(editor,content);editor.fire('SetContent',args);}else{if(args.format!=='raw'){content=HtmlSerializer({validate:editor.validate},editor.schema).serialize(editor.parser.parse(content,{isRootContent:true,insert:true}));}args.content=isWsPreserveElement(Element$$1.fromDom(body))?content:$_2ytxahljk26xetf.trim(content);setEditorHtml(editor,args.content);if(!args.no_events){editor.fire('SetContent',args);}}return args.content;};var setContentTree=function setContentTree(editor,body,content,args){filter$3(editor.parser.getNodeFilters(),editor.parser.getAttributeFilters(),content);var html=HtmlSerializer({validate:editor.validate},editor.schema).serialize(content);args.content=isWsPreserveElement(Element$$1.fromDom(body))?html:$_2ytxahljk26xetf.trim(html);setEditorHtml(editor,args.content);if(!args.no_events){editor.fire('SetContent',args);}return content;};var setContent$1=function setContent$1(editor,content,args){if(args===void 0){args={};}args.format=args.format?args.format:defaultFormat$1;args.set=true;args.content=isTreeNode(content)?'':content;if(!isTreeNode(content)&&!args.no_events){editor.fire('BeforeSetContent',args);content=args.content;}return Option.from(editor.getBody()).fold(constant(content),function(body){return isTreeNode(content)?setContentTree(editor,body,content,args):setContentString(editor,body,content,args);});};var DOM$6=DOMUtils$1.DOM;var restoreOriginalStyles=function restoreOriginalStyles(editor){DOM$6.setStyle(editor.id,'display',editor.orgDisplay);};var safeDestroy=function safeDestroy(x){return Option.from(x).each(function(x){return x.destroy();});};var clearDomReferences=function clearDomReferences(editor){editor.contentAreaContainer=editor.formElement=editor.container=editor.editorContainer=null;editor.bodyElement=editor.contentDocument=editor.contentWindow=null;editor.iframeElement=editor.targetElm=null;if(editor.selection){editor.selection=editor.selection.win=editor.selection.dom=editor.selection.dom.doc=null;}};var restoreForm=function restoreForm(editor){var form=editor.formElement;if(form){if(form._mceOldSubmit){form.submit=form._mceOldSubmit;form._mceOldSubmit=null;}DOM$6.unbind(form,'submit reset',editor.formEventDelegate);}};var remove$9=function remove$9(editor){if(!editor.removed){var _selectionOverrides=editor._selectionOverrides,editorUpload=editor.editorUpload;var body=editor.getBody();var element=editor.getElement();if(body){editor.save({is_removing:true});}editor.removed=true;editor.unbindAllNativeEvents();if(editor.hasHiddenInput&&element){DOM$6.remove(element.nextSibling);}if(!editor.inline&&body){restoreOriginalStyles(editor);}$_8y7e5d4tjk26xfsd.fireRemove(editor);editor.editorManager.remove(editor);DOM$6.remove(editor.getContainer());safeDestroy(_selectionOverrides);safeDestroy(editorUpload);editor.destroy();}};var _destroy=function _destroy(editor,automatic){var selection=editor.selection,dom=editor.dom;if(editor.destroyed){return;}if(!automatic&&!editor.removed){editor.remove();return;}if(!automatic){editor.editorManager.off('beforeunload',editor._beforeUnload);if(editor.theme&&editor.theme.destroy){editor.theme.destroy();}safeDestroy(selection);safeDestroy(dom);}restoreForm(editor);clearDomReferences(editor);editor.destroyed=true;};var DOM$7=DOMUtils$1.DOM;var extend$4=$_2ytxahljk26xetf.extend;var each$21=$_2ytxahljk26xetf.each;var resolve$4=$_2ytxahljk26xetf.resolve;var ie$2=$_ef6mqpajk26xejm.ie;var Editor=function Editor(id,settings,editorManager){var self=this;var documentBaseUrl=self.documentBaseUrl=editorManager.documentBaseURL;var baseUri=editorManager.baseURI;settings=getEditorSettings(self,id,documentBaseUrl,editorManager.defaultSettings,settings);self.settings=settings;AddOnManager.language=settings.language||'en';AddOnManager.languageLoad=settings.language_load;AddOnManager.baseURL=editorManager.baseURL;self.id=id;self.setDirty(false);self.plugins={};self.documentBaseURI=new URI(settings.document_base_url,{base_uri:baseUri});self.baseURI=baseUri;self.contentCSS=[];self.contentStyles=[];self.shortcuts=new Shortcuts(self);self.loadedCSS={};self.editorCommands=new EditorCommands(self);self.suffix=editorManager.suffix;self.editorManager=editorManager;self.inline=settings.inline;self.buttons={};self.menuItems={};if(settings.cache_suffix){$_ef6mqpajk26xejm.cacheSuffix=settings.cache_suffix.replace(/^[\?\&]+/,'');}if(settings.override_viewport===false){$_ef6mqpajk26xejm.overrideViewPort=false;}editorManager.fire('SetupEditor',{editor:self});self.execCallback('setup',self);self.$=DomQuery.overrideDefaults(function(){return{context:self.inline?self.getBody():self.getDoc(),element:self.getBody()};});};Editor.prototype={render:function render(){$_6d25b4yjk26xft7.render(this);},focus:function focus(skipFocus){$_3hu41a4vjk26xfsm.focus(this,skipFocus);},hasFocus:function hasFocus(){return $_3hu41a4vjk26xfsm.hasFocus(this);},execCallback:function execCallback(name){var x=[];for(var _i=1;_i<arguments.length;_i++){x[_i-1]=arguments[_i];}var self=this;var callback=self.settings[name],scope;if(!callback){return;}if(self.callbackLookup&&(scope=self.callbackLookup[name])){callback=scope.func;scope=scope.scope;}if(typeof callback==='string'){scope=callback.replace(/\.\w+$/,'');scope=scope?resolve$4(scope):0;callback=resolve$4(callback);self.callbackLookup=self.callbackLookup||{};self.callbackLookup[name]={func:callback,scope:scope};}return callback.apply(scope||self,Array.prototype.slice.call(arguments,1));},translate:function translate(text){if(text&&$_2ytxahljk26xetf.is(text,'string')){var lang_1=this.settings.language||'en',i18n_1=this.editorManager.i18n;text=i18n_1.data[lang_1+'.'+text]||text.replace(/\{\#([^\}]+)\}/g,function(a,b){return i18n_1.data[lang_1+'.'+b]||'{#'+b+'}';});}return this.editorManager.translate(text);},getLang:function getLang(name,defaultVal){return this.editorManager.i18n.data[(this.settings.language||'en')+'.'+name]||(defaultVal!==undefined?defaultVal:'{#'+name+'}');},getParam:function getParam(name,defaultVal,type){return _getParam(this,name,defaultVal,type);},nodeChanged:function nodeChanged(args){this._nodeChangeDispatcher.nodeChanged(args);},addButton:function addButton(name,settings){var self=this;if(settings.cmd){settings.onclick=function(){self.execCommand(settings.cmd);};}if(settings.stateSelector&&typeof settings.active==='undefined'){settings.active=false;}if(!settings.text&&!settings.icon){settings.icon=name;}self.buttons=self.buttons;settings.tooltip=settings.tooltip||settings.title;self.buttons[name]=settings;},addSidebar:function addSidebar(name,settings){return $_d8v7r67pjk26xgcj.add(this,name,settings);},addMenuItem:function addMenuItem(name,settings){var self=this;if(settings.cmd){settings.onclick=function(){self.execCommand(settings.cmd);};}self.menuItems=self.menuItems;self.menuItems[name]=settings;},addContextToolbar:function addContextToolbar(predicate,items){var self=this;var selector;self.contextToolbars=self.contextToolbars||[];if(typeof predicate==='string'){selector=predicate;predicate=function predicate(elm){return self.dom.is(elm,selector);};}self.contextToolbars.push({id:$_7xi2o55jjk26xfwg.uuid('mcet'),predicate:predicate,items:items});},addCommand:function addCommand(name,callback,scope){this.editorCommands.addCommand(name,callback,scope);},addQueryStateHandler:function addQueryStateHandler(name,callback,scope){this.editorCommands.addQueryStateHandler(name,callback,scope);},addQueryValueHandler:function addQueryValueHandler(name,callback,scope){this.editorCommands.addQueryValueHandler(name,callback,scope);},addShortcut:function addShortcut(pattern,desc,cmdFunc,scope){this.shortcuts.add(pattern,desc,cmdFunc,scope);},execCommand:function execCommand(cmd,ui,value,args){return this.editorCommands.execCommand(cmd,ui,value,args);},queryCommandState:function queryCommandState(cmd){return this.editorCommands.queryCommandState(cmd);},queryCommandValue:function queryCommandValue(cmd){return this.editorCommands.queryCommandValue(cmd);},queryCommandSupported:function queryCommandSupported(cmd){return this.editorCommands.queryCommandSupported(cmd);},show:function show(){var self=this;if(self.hidden){self.hidden=false;if(self.inline){self.getBody().contentEditable=true;}else{DOM$7.show(self.getContainer());DOM$7.hide(self.id);}self.load();self.fire('show');}},hide:function hide(){var self=this,doc=self.getDoc();if(!self.hidden){if(ie$2&&doc&&!self.inline){doc.execCommand('SelectAll');}self.save();if(self.inline){self.getBody().contentEditable=false;if(self===self.editorManager.focusedEditor){self.editorManager.focusedEditor=null;}}else{DOM$7.hide(self.getContainer());DOM$7.setStyle(self.id,'display',self.orgDisplay);}self.hidden=true;self.fire('hide');}},isHidden:function isHidden(){return!!this.hidden;},setProgressState:function setProgressState(state,time){this.fire('ProgressState',{state:state,time:time});},load:function load(args){var self=this;var elm=self.getElement(),html;if(self.removed){return'';}if(elm){args=args||{};args.load=true;html=self.setContent(elm.value!==undefined?elm.value:elm.innerHTML,args);args.element=elm;if(!args.no_events){self.fire('LoadContent',args);}args.element=elm=null;return html;}},save:function save(args){var self=this;var elm=self.getElement(),html,form;if(!elm||!self.initialized||self.removed){return;}args=args||{};args.save=true;args.element=elm;html=args.content=self.getContent(args);if(!args.no_events){self.fire('SaveContent',args);}if(args.format==='raw'){self.fire('RawSaveContent',args);}html=args.content;if(!/TEXTAREA|INPUT/i.test(elm.nodeName)){if(args.is_removing||!self.inline){elm.innerHTML=html;}if(form=DOM$7.getParent(self.id,'form')){each$21(form.elements,function(elm){if(elm.name===self.id){elm.value=html;return false;}});}}else{elm.value=html;}args.element=elm=null;if(args.set_dirty!==false){self.setDirty(false);}return html;},setContent:function setContent(content,args){return setContent$1(this,content,args);},getContent:function getContent(args){return getContent$1(this,args);},insertContent:function insertContent(content,args){if(args){content=extend$4({content:content},args);}this.execCommand('mceInsertContent',false,content);},isDirty:function isDirty(){return!this.isNotDirty;},setDirty:function setDirty(state){var oldState=!this.isNotDirty;this.isNotDirty=!state;if(state&&state!==oldState){this.fire('dirty');}},setMode:function setMode(mode){_setMode(this,mode);},getContainer:function getContainer(){var self=this;if(!self.container){self.container=DOM$7.get(self.editorContainer||self.id+'_parent');}return self.container;},getContentAreaContainer:function getContentAreaContainer(){return this.contentAreaContainer;},getElement:function getElement(){if(!this.targetElm){this.targetElm=DOM$7.get(this.id);}return this.targetElm;},getWin:function getWin(){var self=this;var elm;if(!self.contentWindow){elm=self.iframeElement;if(elm){self.contentWindow=elm.contentWindow;}}return self.contentWindow;},getDoc:function getDoc(){var self=this;var win;if(!self.contentDocument){win=self.getWin();if(win){self.contentDocument=win.document;}}return self.contentDocument;},getBody:function getBody(){var doc=this.getDoc();return this.bodyElement||(doc?doc.body:null);},convertURL:function convertURL(url,name,elm){var self=this,settings=self.settings;if(settings.urlconverter_callback){return self.execCallback('urlconverter_callback',url,elm,true,name);}if(!settings.convert_urls||elm&&elm.nodeName==='LINK'||url.indexOf('file:')===0||url.length===0){return url;}if(settings.relative_urls){return self.documentBaseURI.toRelative(url);}url=self.documentBaseURI.toAbsolute(url,settings.remove_script_host);return url;},addVisual:function addVisual(elm){var self=this;var settings=self.settings;var dom=self.dom;var cls;elm=elm||self.getBody();if(self.hasVisual===undefined){self.hasVisual=settings.visual;}each$21(dom.select('table,a',elm),function(elm){var value;switch(elm.nodeName){case'TABLE':cls=settings.visual_table_class||'mce-item-table';value=dom.getAttrib(elm,'border');if((!value||value==='0')&&self.hasVisual){dom.addClass(elm,cls);}else{dom.removeClass(elm,cls);}return;case'A':if(!dom.getAttrib(elm,'href')){value=dom.getAttrib(elm,'name')||elm.id;cls=settings.visual_anchor_class||'mce-item-anchor';if(value&&self.hasVisual){dom.addClass(elm,cls);}else{dom.removeClass(elm,cls);}}return;}});self.fire('VisualAid',{element:elm,hasVisual:self.hasVisual});},remove:function remove(){remove$9(this);},destroy:function destroy(automatic){_destroy(this,automatic);},uploadImages:function uploadImages(callback){return this.editorUpload.uploadImages(callback);},_scanForImages:function _scanForImages(){return this.editorUpload.scanForImages();}};extend$4(Editor.prototype,EditorObservable$1);var isEditorUIElement=function isEditorUIElement(elm){return elm.className.toString().indexOf('mce-')!==-1;};var $_6330h77yjk26xged={isEditorUIElement:isEditorUIElement};var isManualNodeChange=function isManualNodeChange(e){return e.type==='nodechange'&&e.selectionChange;};var registerPageMouseUp=function registerPageMouseUp(editor,throttledStore){var mouseUpPage=function mouseUpPage(){throttledStore.throttle();};DOMUtils$1.DOM.bind(document,'mouseup',mouseUpPage);editor.on('remove',function(){DOMUtils$1.DOM.unbind(document,'mouseup',mouseUpPage);});};var registerFocusOut=function registerFocusOut(editor){editor.on('focusout',function(){$_wwyx94ljk26xfqt.store(editor);});};var registerMouseUp=function registerMouseUp(editor,throttledStore){editor.on('mouseup touchend',function(e){throttledStore.throttle();});};var registerEditorEvents=function registerEditorEvents(editor,throttledStore){var browser=$_8x4ci6ojk26xeuf.detect().browser;if(browser.isIE()){registerFocusOut(editor);}else{registerMouseUp(editor,throttledStore);}editor.on('keyup nodechange',function(e){if(!isManualNodeChange(e)){$_wwyx94ljk26xfqt.store(editor);}});};var register$3=function register$3(editor){var throttledStore=first$1(function(){$_wwyx94ljk26xfqt.store(editor);},0);if(editor.inline){registerPageMouseUp(editor,throttledStore);}editor.on('init',function(){registerEditorEvents(editor,throttledStore);});editor.on('remove',function(){throttledStore.cancel();});};var $_cjisuk7zjk26xgee={register:register$3};var documentFocusInHandler;var DOM$8=DOMUtils$1.DOM;var isEditorUIElement$1=function isEditorUIElement$1(elm){return $_6330h77yjk26xged.isEditorUIElement(elm);};var isUIElement=function isUIElement(editor,elm){var customSelector=editor?editor.settings.custom_ui_selector:'';var parent$$1=DOM$8.getParent(elm,function(elm){return isEditorUIElement$1(elm)||(customSelector?editor.dom.is(elm,customSelector):false);});return parent$$1!==null;};var getActiveElement=function getActiveElement(){try{return document.activeElement;}catch(ex){return document.body;}};var registerEvents=function registerEvents(editorManager,e){var editor=e.editor;$_cjisuk7zjk26xgee.register(editor);editor.on('focusin',function(){var self$$1=this;var focusedEditor=editorManager.focusedEditor;if(focusedEditor!==self$$1){if(focusedEditor){focusedEditor.fire('blur',{focusedEditor:self$$1});}editorManager.setActive(self$$1);editorManager.focusedEditor=self$$1;self$$1.fire('focus',{blurredEditor:focusedEditor});self$$1.focus(true);}});editor.on('focusout',function(){var self$$1=this;$_3a7ompijk26xer0.setEditorTimeout(self$$1,function(){var focusedEditor=editorManager.focusedEditor;if(!isUIElement(self$$1,getActiveElement())&&focusedEditor===self$$1){self$$1.fire('blur',{focusedEditor:null});editorManager.focusedEditor=null;}});});if(!documentFocusInHandler){documentFocusInHandler=function documentFocusInHandler(e){var activeEditor=editorManager.activeEditor;var target;target=e.target;if(activeEditor&&target.ownerDocument===document){if(target!==document.body&&!isUIElement(activeEditor,target)&&editorManager.focusedEditor===activeEditor){activeEditor.fire('blur',{focusedEditor:null});editorManager.focusedEditor=null;}}};DOM$8.bind(document,'focusin',documentFocusInHandler);}};var unregisterDocumentEvents=function unregisterDocumentEvents(editorManager,e){if(editorManager.focusedEditor===e.editor){editorManager.focusedEditor=null;}if(!editorManager.activeEditor){DOM$8.unbind(document,'focusin',documentFocusInHandler);documentFocusInHandler=null;}};var setup$15=function setup$15(editorManager){editorManager.on('AddEditor',curry(registerEvents,editorManager));editorManager.on('RemoveEditor',curry(unregisterDocumentEvents,editorManager));};var $_9vngut7xjk26xge9={setup:setup$15,isEditorUIElement:isEditorUIElement$1,isUIElement:isUIElement};var data={};var code='en';var $_316z5k80jk26xgek={setCode:function setCode(newCode){if(newCode){code=newCode;this.rtl=this.data[newCode]?this.data[newCode]._dir==='rtl':false;}},getCode:function getCode(){return code;},rtl:false,add:function add(code,items){var langData=data[code];if(!langData){data[code]=langData={};}for(var name in items){langData[name]=items[name];}this.setCode(code);},translate:function translate(text){var langData=data[code]||{};var toString=function toString(obj){if($_2ytxahljk26xetf.is(obj,'function')){return Object.prototype.toString.call(obj);}return!isEmpty(obj)?''+obj:'';};var isEmpty=function isEmpty(text){return text===''||text===null||$_2ytxahljk26xetf.is(text,'undefined');};var getLangData=function getLangData(text){text=toString(text);return $_2ytxahljk26xetf.hasOwn(langData,text)?toString(langData[text]):text;};if(isEmpty(text)){return'';}if($_2ytxahljk26xetf.is(text,'object')&&$_2ytxahljk26xetf.hasOwn(text,'raw')){return toString(text.raw);}if($_2ytxahljk26xetf.is(text,'array')){var values_1=text.slice(1);text=getLangData(text[0]).replace(/\{([0-9]+)\}/g,function($1,$2){return $_2ytxahljk26xetf.hasOwn(values_1,$2)?toString(values_1[$2]):$1;});}return getLangData(text).replace(/{context:\w+}$/,'');},data:data};var DOM$9=DOMUtils$1.DOM;var explode$4=$_2ytxahljk26xetf.explode;var each$22=$_2ytxahljk26xetf.each;var extend$5=$_2ytxahljk26xetf.extend;var instanceCounter=0;var beforeUnloadDelegate;var EditorManager;var boundGlobalEvents=false;var legacyEditors=[];var editors=[];var isValidLegacyKey=function isValidLegacyKey(id){return id!=='length';};var globalEventDelegate=function globalEventDelegate(e){each$22(EditorManager.get(),function(editor){if(e.type==='scroll'){editor.fire('ScrollWindow',e);}else{editor.fire('ResizeWindow',e);}});};var toggleGlobalEvents=function toggleGlobalEvents(state){if(state!==boundGlobalEvents){if(state){DomQuery(window).on('resize scroll',globalEventDelegate);}else{DomQuery(window).off('resize scroll',globalEventDelegate);}boundGlobalEvents=state;}};var removeEditorFromList=function removeEditorFromList(targetEditor){var oldEditors=editors;delete legacyEditors[targetEditor.id];for(var i=0;i<legacyEditors.length;i++){if(legacyEditors[i]===targetEditor){legacyEditors.splice(i,1);break;}}editors=filter(editors,function(editor){return targetEditor!==editor;});if(EditorManager.activeEditor===targetEditor){EditorManager.activeEditor=editors.length>0?editors[0]:null;}if(EditorManager.focusedEditor===targetEditor){EditorManager.focusedEditor=null;}return oldEditors.length!==editors.length;};var purgeDestroyedEditor=function purgeDestroyedEditor(editor){if(editor&&editor.initialized&&!(editor.getContainer()||editor.getBody()).parentNode){removeEditorFromList(editor);editor.unbindAllNativeEvents();editor.destroy(true);editor.removed=true;editor=null;}return editor;};EditorManager={defaultSettings:{},$:DomQuery,majorVersion:'4',minorVersion:'8.1',releaseDate:'2018-07-26',editors:legacyEditors,i18n:$_316z5k80jk26xgek,activeEditor:null,settings:{},setup:function setup(){var self$$1=this;var baseURL,documentBaseURL,suffix='',preInit,src;documentBaseURL=URI.getDocumentBaseUrl(document.location);if(/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)){documentBaseURL=documentBaseURL.replace(/[\?#].*$/,'').replace(/[\/\\][^\/]+$/,'');if(!/[\/\\]$/.test(documentBaseURL)){documentBaseURL+='/';}}preInit=window.tinymce||window.tinyMCEPreInit;if(preInit){baseURL=preInit.base||preInit.baseURL;suffix=preInit.suffix;}else{var scripts=document.getElementsByTagName('script');for(var i=0;i<scripts.length;i++){src=scripts[i].src;var srcScript=src.substring(src.lastIndexOf('/'));if(/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)){if(srcScript.indexOf('.min')!==-1){suffix='.min';}baseURL=src.substring(0,src.lastIndexOf('/'));break;}}if(!baseURL&&document.currentScript){src=document.currentScript.src;if(src.indexOf('.min')!==-1){suffix='.min';}baseURL=src.substring(0,src.lastIndexOf('/'));}}self$$1.baseURL=new URI(documentBaseURL).toAbsolute(baseURL);self$$1.documentBaseURL=documentBaseURL;self$$1.baseURI=new URI(self$$1.baseURL);self$$1.suffix=suffix;$_9vngut7xjk26xge9.setup(self$$1);},overrideDefaults:function overrideDefaults(defaultSettings){var baseUrl,suffix;baseUrl=defaultSettings.base_url;if(baseUrl){this.baseURL=new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/,''));this.baseURI=new URI(this.baseURL);}suffix=defaultSettings.suffix;if(defaultSettings.suffix){this.suffix=suffix;}this.defaultSettings=defaultSettings;var pluginBaseUrls=defaultSettings.plugin_base_urls;for(var name$$1 in pluginBaseUrls){AddOnManager.PluginManager.urls[name$$1]=pluginBaseUrls[name$$1];}},init:function init(settings){var self$$1=this;var result,invalidInlineTargets;invalidInlineTargets=$_2ytxahljk26xetf.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track '+'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu',' ');var isInvalidInlineTarget=function isInvalidInlineTarget(settings,elm){return settings.inline&&elm.tagName.toLowerCase()in invalidInlineTargets;};var createId=function createId(elm){var id=elm.id;if(!id){id=elm.name;if(id&&!DOM$9.get(id)){id=elm.name;}else{id=DOM$9.uniqueId();}elm.setAttribute('id',id);}return id;};var execCallback=function execCallback(name$$1){var callback=settings[name$$1];if(!callback){return;}return callback.apply(self$$1,Array.prototype.slice.call(arguments,2));};var hasClass=function hasClass(elm,className){return className.constructor===RegExp?className.test(elm.className):DOM$9.hasClass(elm,className);};var findTargets=function findTargets(settings){var l,targets=[];if($_ef6mqpajk26xejm.ie&&$_ef6mqpajk26xejm.ie<11){$_3uguhq54jk26xfug.initError('TinyMCE does not support the browser you are using. For a list of supported'+' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');return[];}if(settings.types){each$22(settings.types,function(type){targets=targets.concat(DOM$9.select(type.selector));});return targets;}else if(settings.selector){return DOM$9.select(settings.selector);}else if(settings.target){return[settings.target];}switch(settings.mode){case'exact':l=settings.elements||'';if(l.length>0){each$22(explode$4(l),function(id){var elm;if(elm=DOM$9.get(id)){targets.push(elm);}else{each$22(document.forms,function(f){each$22(f.elements,function(e){if(e.name===id){id='mce_editor_'+instanceCounter++;DOM$9.setAttrib(e,'id',id);targets.push(e);}});});}});}break;case'textareas':case'specific_textareas':each$22(DOM$9.select('textarea'),function(elm){if(settings.editor_deselector&&hasClass(elm,settings.editor_deselector)){return;}if(!settings.editor_selector||hasClass(elm,settings.editor_selector)){targets.push(elm);}});break;}return targets;};var provideResults=function provideResults(editors){result=editors;};var initEditors=function initEditors(){var initCount=0;var editors=[];var targets;var createEditor=function createEditor(id,settings,targetElm){var editor=new Editor(id,settings,self$$1);editors.push(editor);editor.on('init',function(){if(++initCount===targets.length){provideResults(editors);}});editor.targetElm=editor.targetElm||targetElm;editor.render();};DOM$9.unbind(window,'ready',initEditors);execCallback('onpageload');targets=DomQuery.unique(findTargets(settings));if(settings.types){each$22(settings.types,function(type){$_2ytxahljk26xetf.each(targets,function(elm){if(DOM$9.is(elm,type.selector)){createEditor(createId(elm),extend$5({},settings,type),elm);return false;}return true;});});return;}$_2ytxahljk26xetf.each(targets,function(elm){purgeDestroyedEditor(self$$1.get(elm.id));});targets=$_2ytxahljk26xetf.grep(targets,function(elm){return!self$$1.get(elm.id);});if(targets.length===0){provideResults([]);}else{each$22(targets,function(elm){if(isInvalidInlineTarget(settings,elm)){$_3uguhq54jk26xfug.initError('Could not initialize inline editor on invalid inline target element',elm);}else{createEditor(createId(elm),settings,elm);}});}};self$$1.settings=settings;DOM$9.bind(window,'ready',initEditors);return new promiseObj(function(resolve){if(result){resolve(result);}else{provideResults=function provideResults(editors){resolve(editors);};}});},get:function get(id){if(arguments.length===0){return editors.slice(0);}else if(isString(id)){return find(editors,function(editor){return editor.id===id;}).getOr(null);}else if(isNumber(id)){return editors[id]?editors[id]:null;}else{return null;}},add:function add(editor){var self$$1=this;var existingEditor;existingEditor=legacyEditors[editor.id];if(existingEditor===editor){return editor;}if(self$$1.get(editor.id)===null){if(isValidLegacyKey(editor.id)){legacyEditors[editor.id]=editor;}legacyEditors.push(editor);editors.push(editor);}toggleGlobalEvents(true);self$$1.activeEditor=editor;self$$1.fire('AddEditor',{editor:editor});if(!beforeUnloadDelegate){beforeUnloadDelegate=function beforeUnloadDelegate(){self$$1.fire('BeforeUnload');};DOM$9.bind(window,'beforeunload',beforeUnloadDelegate);}return editor;},createEditor:function createEditor(id,settings){return this.add(new Editor(id,settings,this));},remove:function remove(selector){var self$$1=this;var i,editor;if(!selector){for(i=editors.length-1;i>=0;i--){self$$1.remove(editors[i]);}return;}if(isString(selector)){each$22(DOM$9.select(selector),function(elm){editor=self$$1.get(elm.id);if(editor){self$$1.remove(editor);}});return;}editor=selector;if(isNull(self$$1.get(editor.id))){return null;}if(removeEditorFromList(editor)){self$$1.fire('RemoveEditor',{editor:editor});}if(editors.length===0){DOM$9.unbind(window,'beforeunload',beforeUnloadDelegate);}editor.remove();toggleGlobalEvents(editors.length>0);return editor;},execCommand:function execCommand(cmd,ui,value){var self$$1=this,editor=self$$1.get(value);switch(cmd){case'mceAddEditor':if(!self$$1.get(value)){new Editor(value,self$$1.settings,self$$1).render();}return true;case'mceRemoveEditor':if(editor){editor.remove();}return true;case'mceToggleEditor':if(!editor){self$$1.execCommand('mceAddEditor',0,value);return true;}if(editor.isHidden()){editor.show();}else{editor.hide();}return true;}if(self$$1.activeEditor){return self$$1.activeEditor.execCommand(cmd,ui,value);}return false;},triggerSave:function triggerSave(){each$22(editors,function(editor){editor.save();});},addI18n:function addI18n(code,items){$_316z5k80jk26xgek.add(code,items);},translate:function translate(text){return $_316z5k80jk26xgek.translate(text);},setActive:function setActive(editor){var activeEditor=this.activeEditor;if(this.activeEditor!==editor){if(activeEditor){activeEditor.fire('deactivate',{relatedTarget:editor});}editor.fire('activate',{relatedTarget:activeEditor});}this.activeEditor=editor;}};extend$5(EditorManager,$_4d4jki4qjk26xfs1);EditorManager.setup();var EditorManager$1=EditorManager;function RangeUtils(dom){var walk=function walk(rng,callback){return $_179pt43bjk26xfcg.walk(dom,rng,callback);};var split=$_4q4ycg6ajk26xg1x.split;var normalize=function normalize(rng){return $_c8c6ki4jjk26xfqk.normalize(dom,rng).fold(constant(false),function(normalizedRng){rng.setStart(normalizedRng.startContainer,normalizedRng.startOffset);rng.setEnd(normalizedRng.endContainer,normalizedRng.endOffset);return true;});};return{walk:walk,split:split,normalize:normalize};}(function(RangeUtils){RangeUtils.compareRanges=$_5rlzpq4kjk26xfqr.isEq;RangeUtils.getCaretRangeFromPoint=$_11ohb66xjk26xg6m.fromPoint;RangeUtils.getSelectedNode=getSelectedNode;RangeUtils.getNode=getNode;})(RangeUtils||(RangeUtils={}));var RangeUtils$1=RangeUtils;var min=Math.min;var max=Math.max;var round$2=Math.round;var relativePosition=function relativePosition(rect,targetRect,rel){var x,y,w,h,targetW,targetH;x=targetRect.x;y=targetRect.y;w=rect.w;h=rect.h;targetW=targetRect.w;targetH=targetRect.h;rel=(rel||'').split('');if(rel[0]==='b'){y+=targetH;}if(rel[1]==='r'){x+=targetW;}if(rel[0]==='c'){y+=round$2(targetH/2);}if(rel[1]==='c'){x+=round$2(targetW/2);}if(rel[3]==='b'){y-=h;}if(rel[4]==='r'){x-=w;}if(rel[3]==='c'){y-=round$2(h/2);}if(rel[4]==='c'){x-=round$2(w/2);}return create$3(x,y,w,h);};var findBestRelativePosition=function findBestRelativePosition(rect,targetRect,constrainRect,rels){var pos,i;for(i=0;i<rels.length;i++){pos=relativePosition(rect,targetRect,rels[i]);if(pos.x>=constrainRect.x&&pos.x+pos.w<=constrainRect.w+constrainRect.x&&pos.y>=constrainRect.y&&pos.y+pos.h<=constrainRect.h+constrainRect.y){return rels[i];}}return null;};var inflate=function inflate(rect,w,h){return create$3(rect.x-w,rect.y-h,rect.w+w*2,rect.h+h*2);};var intersect=function intersect(rect,cropRect){var x1,y1,x2,y2;x1=max(rect.x,cropRect.x);y1=max(rect.y,cropRect.y);x2=min(rect.x+rect.w,cropRect.x+cropRect.w);y2=min(rect.y+rect.h,cropRect.y+cropRect.h);if(x2-x1<0||y2-y1<0){return null;}return create$3(x1,y1,x2-x1,y2-y1);};var clamp$1=function clamp$1(rect,clampRect,fixedSize){var underflowX1,underflowY1,overflowX2,overflowY2,x1,y1,x2,y2,cx2,cy2;x1=rect.x;y1=rect.y;x2=rect.x+rect.w;y2=rect.y+rect.h;cx2=clampRect.x+clampRect.w;cy2=clampRect.y+clampRect.h;underflowX1=max(0,clampRect.x-x1);underflowY1=max(0,clampRect.y-y1);overflowX2=max(0,x2-cx2);overflowY2=max(0,y2-cy2);x1+=underflowX1;y1+=underflowY1;if(fixedSize){x2+=underflowX1;y2+=underflowY1;x1-=overflowX2;y1-=overflowY2;}x2-=overflowX2;y2-=overflowY2;return create$3(x1,y1,x2-x1,y2-y1);};var create$3=function create$3(x,y,w,h){return{x:x,y:y,w:w,h:h};};var fromClientRect=function fromClientRect(clientRect){return create$3(clientRect.left,clientRect.top,clientRect.width,clientRect.height);};var $_evzslb82jk26xget={inflate:inflate,relativePosition:relativePosition,findBestRelativePosition:findBestRelativePosition,intersect:intersect,clamp:clamp$1,create:create$3,fromClientRect:fromClientRect};var types={};var $_ghbjul83jk26xgf7={add:function add(type,typeClass){types[type.toLowerCase()]=typeClass;},has:function has(type){return!!types[type.toLowerCase()];},get:function get(type){var lctype=type.toLowerCase();var controlType=types.hasOwnProperty(lctype)?types[lctype]:null;if(controlType===null){throw new Error('Could not find module for type: '+type);}return controlType;},create:function create(type,settings){var ControlType;if(typeof type==='string'){settings=settings||{};settings.type=type;}else{settings=type;type=settings.type;}type=type.toLowerCase();ControlType=types[type];if(!ControlType){throw new Error('Could not find control by type: '+type);}ControlType=new ControlType(settings);ControlType.type=type;return ControlType;}};var each$23=$_2ytxahljk26xetf.each;var extend$6=$_2ytxahljk26xetf.extend;var _extendClass;var initializing;var Class$1=function Class$1(){};Class$1.extend=_extendClass=function extendClass(prop){var self=this;var _super=self.prototype;var prototype,name,member;var Class=function Class(){var i,mixins,mixin;var self=this;if(!initializing){if(self.init){self.init.apply(self,arguments);}mixins=self.Mixins;if(mixins){i=mixins.length;while(i--){mixin=mixins[i];if(mixin.init){mixin.init.apply(self,arguments);}}}}};var dummy=function dummy(){return this;};var createMethod=function createMethod(name,fn){return function(){var self=this;var tmp=self._super;var ret;self._super=_super[name];ret=fn.apply(self,arguments);self._super=tmp;return ret;};};initializing=true;prototype=new self();initializing=false;if(prop.Mixins){each$23(prop.Mixins,function(mixin){for(var name_1 in mixin){if(name_1!=='init'){prop[name_1]=mixin[name_1];}}});if(_super.Mixins){prop.Mixins=_super.Mixins.concat(prop.Mixins);}}if(prop.Methods){each$23(prop.Methods.split(','),function(name){prop[name]=dummy;});}if(prop.Properties){each$23(prop.Properties.split(','),function(name){var fieldName='_'+name;prop[name]=function(value){var self=this;if(value!==undefined){self[fieldName]=value;return self;}return self[fieldName];};});}if(prop.Statics){each$23(prop.Statics,function(func,name){Class[name]=func;});}if(prop.Defaults&&_super.Defaults){prop.Defaults=extend$6({},_super.Defaults,prop.Defaults);}for(name in prop){member=prop[name];if(typeof member==='function'&&_super[name]){prototype[name]=createMethod(name,member);}else{prototype[name]=member;}}Class.prototype=prototype;Class.constructor=Class;Class.extend=_extendClass;return Class;};var min$1=Math.min;var max$1=Math.max;var round$3=Math.round;var Color=function Color(value){var self={};var r=0,g=0,b=0;var rgb2hsv=function rgb2hsv(r,g,b){var h,s,v,d,minRGB,maxRGB;h=0;s=0;v=0;r=r/255;g=g/255;b=b/255;minRGB=min$1(r,min$1(g,b));maxRGB=max$1(r,max$1(g,b));if(minRGB===maxRGB){v=minRGB;return{h:0,s:0,v:v*100};}d=r===minRGB?g-b:b===minRGB?r-g:b-r;h=r===minRGB?3:b===minRGB?1:5;h=60*(h-d/(maxRGB-minRGB));s=(maxRGB-minRGB)/maxRGB;v=maxRGB;return{h:round$3(h),s:round$3(s*100),v:round$3(v*100)};};var hsvToRgb=function hsvToRgb(hue,saturation,brightness){var side,chroma,x,match;hue=(parseInt(hue,10)||0)%360;saturation=parseInt(saturation,10)/100;brightness=parseInt(brightness,10)/100;saturation=max$1(0,min$1(saturation,1));brightness=max$1(0,min$1(brightness,1));if(saturation===0){r=g=b=round$3(255*brightness);return;}side=hue/60;chroma=brightness*saturation;x=chroma*(1-Math.abs(side%2-1));match=brightness-chroma;switch(Math.floor(side)){case 0:r=chroma;g=x;b=0;break;case 1:r=x;g=chroma;b=0;break;case 2:r=0;g=chroma;b=x;break;case 3:r=0;g=x;b=chroma;break;case 4:r=x;g=0;b=chroma;break;case 5:r=chroma;g=0;b=x;break;default:r=g=b=0;}r=round$3(255*(r+match));g=round$3(255*(g+match));b=round$3(255*(b+match));};var toHex=function toHex(){var hex=function hex(val){val=parseInt(val,10).toString(16);return val.length>1?val:'0'+val;};return'#'+hex(r)+hex(g)+hex(b);};var toRgb=function toRgb(){return{r:r,g:g,b:b};};var toHsv=function toHsv(){return rgb2hsv(r,g,b);};var parse=function parse(value){var matches;if((typeof value==='undefined'?'undefined':_typeof(value))==='object'){if('r'in value){r=value.r;g=value.g;b=value.b;}else if('v'in value){hsvToRgb(value.h,value.s,value.v);}}else{if(matches=/rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)){r=parseInt(matches[1],10);g=parseInt(matches[2],10);b=parseInt(matches[3],10);}else if(matches=/#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)){r=parseInt(matches[1],16);g=parseInt(matches[2],16);b=parseInt(matches[3],16);}else if(matches=/#([0-F])([0-F])([0-F])/gi.exec(value)){r=parseInt(matches[1]+matches[1],16);g=parseInt(matches[2]+matches[2],16);b=parseInt(matches[3]+matches[3],16);}}r=r<0?0:r>255?255:r;g=g<0?0:g>255?255:g;b=b<0?0:b>255?255:b;return self;};if(value){parse(value);}self.toRgb=toRgb;self.toHsv=toHsv;self.toHex=toHex;self.parse=parse;return self;};var serialize=function serialize(o,quote){var i,v,t,name;quote=quote||'"';if(o===null){return'null';}t=typeof o==='undefined'?'undefined':_typeof(o);if(t==='string'){v='\bb\tt\nn\ff\rr""\'\'\\\\';return quote+o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g,function(a,b){if(quote==='"'&&a==='\''){return a;}i=v.indexOf(b);if(i+1){return'\\'+v.charAt(i+1);}a=b.charCodeAt().toString(16);return'\\u'+'0000'.substring(a.length)+a;})+quote;}if(t==='object'){if(o.hasOwnProperty&&Object.prototype.toString.call(o)==='[object Array]'){for(i=0,v='[';i<o.length;i++){v+=(i>0?',':'')+serialize(o[i],quote);}return v+']';}v='{';for(name in o){if(o.hasOwnProperty(name)){v+=typeof o[name]!=='function'?(v.length>1?','+quote:quote)+name+quote+':'+serialize(o[name],quote):'';}}return v+'}';}return''+o;};var $_foj91x86jk26xgfh={serialize:serialize,parse:function parse(text){try{return JSON.parse(text);}catch(ex){}}};var $_6ue13l87jk26xgfk={callbacks:{},count:0,send:function send(settings){var self=this,dom=DOMUtils$1.DOM,count=settings.count!==undefined?settings.count:self.count;var id='tinymce_jsonp_'+count;self.callbacks[count]=function(json){dom.remove(id);delete self.callbacks[count];settings.callback(json);};dom.add(dom.doc.body,'script',{id:id,src:settings.url,type:'text/javascript'});self.count++;}};var XHR={send:function send(settings){var xhr,count=0;var ready=function ready(){if(!settings.async||xhr.readyState===4||count++>10000){if(settings.success&&count<10000&&xhr.status===200){settings.success.call(settings.success_scope,''+xhr.responseText,xhr,settings);}else if(settings.error){settings.error.call(settings.error_scope,count>10000?'TIMED_OUT':'GENERAL',xhr,settings);}xhr=null;}else{setTimeout(ready,10);}};settings.scope=settings.scope||this;settings.success_scope=settings.success_scope||settings.scope;settings.error_scope=settings.error_scope||settings.scope;settings.async=settings.async===false?false:true;settings.data=settings.data||'';XHR.fire('beforeInitialize',{settings:settings});xhr=new XMLHttpRequest();if(xhr){if(xhr.overrideMimeType){xhr.overrideMimeType(settings.content_type);}xhr.open(settings.type||(settings.data?'POST':'GET'),settings.url,settings.async);if(settings.crossDomain){xhr.withCredentials=true;}if(settings.content_type){xhr.setRequestHeader('Content-Type',settings.content_type);}if(settings.requestheaders){$_2ytxahljk26xetf.each(settings.requestheaders,function(header){xhr.setRequestHeader(header.key,header.value);});}xhr.setRequestHeader('X-Requested-With','XMLHttpRequest');xhr=XHR.fire('beforeSend',{xhr:xhr,settings:settings}).xhr;xhr.send(settings.data);if(!settings.async){return ready();}setTimeout(ready,10);}}};$_2ytxahljk26xetf.extend(XHR,$_4d4jki4qjk26xfs1);var extend$7=$_2ytxahljk26xetf.extend;var JSONRequest=function JSONRequest(settings){this.settings=extend$7({},settings);this.count=0;};JSONRequest.sendRPC=function(o){return new JSONRequest().send(o);};JSONRequest.prototype={send:function send(args){var ecb=args.error,scb=args.success;args=extend$7(this.settings,args);args.success=function(c,x){c=$_foj91x86jk26xgfh.parse(c);if(typeof c==='undefined'){c={error:'JSON Parse error.'};}if(c.error){ecb.call(args.error_scope||args.scope,c.error,x);}else{scb.call(args.success_scope||args.scope,c.result);}};args.error=function(ty,x){if(ecb){ecb.call(args.error_scope||args.scope,ty,x);}};args.data=$_foj91x86jk26xgfh.serialize({id:args.id||'c'+this.count++,method:args.method,params:args.params});args.content_type='application/json';XHR.send(args);}};var localStorage$$1;function checkLocalStorage(){try{window.localStorage;return true;}catch(error){return false;}}if(checkLocalStorage()){localStorage$$1=window.localStorage;}else{localStorage$$1={setItem:function setItem(){},getItem:function getItem(){},removeItem:function removeItem(){}};}var tinymce=EditorManager$1;var publicApi={geom:{Rect:$_evzslb82jk26xget},util:{Promise:promiseObj,Delay:$_3a7ompijk26xer0,Tools:$_2ytxahljk26xetf,VK:$_o3p025wjk26xfz2,URI:URI,Class:Class$1,EventDispatcher:Dispatcher,Observable:$_4d4jki4qjk26xfs1,I18n:$_316z5k80jk26xgek,XHR:XHR,JSON:$_foj91x86jk26xgfh,JSONRequest:JSONRequest,JSONP:$_6ue13l87jk26xgfk,LocalStorage:localStorage$$1,Color:Color},dom:{EventUtils:EventUtils,Sizzle:Sizzle,DomQuery:DomQuery,TreeWalker:TreeWalker,DOMUtils:DOMUtils$1,ScriptLoader:ScriptLoader,RangeUtils:RangeUtils$1,Serializer:DomSerializer$1,ControlSelection:ControlSelection,BookmarkManager:BookmarkManager$1,Selection:Selection$1,Event:EventUtils.Event},html:{Styles:Styles,Entities:$_8udjtn1sjk26xf0t,Node:Node$2,Schema:Schema,SaxParser:SaxParser$1,DomParser:DomParser,Writer:Writer,Serializer:HtmlSerializer},ui:{Factory:$_ghbjul83jk26xgf7},Env:$_ef6mqpajk26xejm,AddOnManager:AddOnManager,Annotator:Annotator,Formatter:Formatter,UndoManager:UndoManager,EditorCommands:EditorCommands,WindowManager:WindowManager,NotificationManager:NotificationManager,EditorObservable:EditorObservable$1,Shortcuts:Shortcuts,Editor:Editor,FocusManager:$_6330h77yjk26xged,EditorManager:EditorManager$1,DOM:DOMUtils$1.DOM,ScriptLoader:ScriptLoader.ScriptLoader,PluginManager:AddOnManager.PluginManager,ThemeManager:AddOnManager.ThemeManager,trim:$_2ytxahljk26xetf.trim,isArray:$_2ytxahljk26xetf.isArray,is:$_2ytxahljk26xetf.is,toArray:$_2ytxahljk26xetf.toArray,makeMap:$_2ytxahljk26xetf.makeMap,each:$_2ytxahljk26xetf.each,map:$_2ytxahljk26xetf.map,grep:$_2ytxahljk26xetf.grep,inArray:$_2ytxahljk26xetf.inArray,extend:$_2ytxahljk26xetf.extend,create:$_2ytxahljk26xetf.create,walk:$_2ytxahljk26xetf.walk,createNS:$_2ytxahljk26xetf.createNS,resolve:$_2ytxahljk26xetf.resolve,explode:$_2ytxahljk26xetf.explode,_addCacheSuffix:$_2ytxahljk26xetf._addCacheSuffix,isOpera:$_ef6mqpajk26xejm.opera,isWebKit:$_ef6mqpajk26xejm.webkit,isIE:$_ef6mqpajk26xejm.ie,isGecko:$_ef6mqpajk26xejm.gecko,isMac:$_ef6mqpajk26xejm.mac};tinymce=$_2ytxahljk26xetf.extend(tinymce,publicApi);var Tinymce=tinymce;var exportToModuleLoaders=function exportToModuleLoaders(tinymce){if(( false?'undefined':_typeof(module))==='object'){try{module.exports=tinymce;}catch(_){}}};var exportToWindowGlobal=function exportToWindowGlobal(tinymce){window.tinymce=tinymce;window.tinyMCE=tinymce;};exportToWindowGlobal(Tinymce);exportToModuleLoaders(Tinymce);})();})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../node_modules/timers-browserify/main.js */ 70).setImmediate, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/module.js */ 92)(module)))

/***/ }),
/* 952 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/themes/modern/theme.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var modern = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.ThemeManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.EditorManager');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var isBrandingEnabled = function isBrandingEnabled(editor) {
      return editor.getParam('branding', true, 'boolean');
    };
    var hasMenubar = function hasMenubar(editor) {
      return getMenubar(editor) !== false;
    };
    var getMenubar = function getMenubar(editor) {
      return editor.getParam('menubar');
    };
    var hasStatusbar = function hasStatusbar(editor) {
      return editor.getParam('statusbar', true, 'boolean');
    };
    var getToolbarSize = function getToolbarSize(editor) {
      return editor.getParam('toolbar_items_size');
    };
    var isReadOnly = function isReadOnly(editor) {
      return editor.getParam('readonly', false, 'boolean');
    };
    var getFixedToolbarContainer = function getFixedToolbarContainer(editor) {
      return editor.getParam('fixed_toolbar_container');
    };
    var getInlineToolbarPositionHandler = function getInlineToolbarPositionHandler(editor) {
      return editor.getParam('inline_toolbar_position_handler');
    };
    var getMenu = function getMenu(editor) {
      return editor.getParam('menu');
    };
    var getRemovedMenuItems = function getRemovedMenuItems(editor) {
      return editor.getParam('removed_menuitems', '');
    };
    var getMinWidth = function getMinWidth(editor) {
      return editor.getParam('min_width', 100, 'number');
    };
    var getMinHeight = function getMinHeight(editor) {
      return editor.getParam('min_height', 100, 'number');
    };
    var getMaxWidth = function getMaxWidth(editor) {
      return editor.getParam('max_width', 65535, 'number');
    };
    var getMaxHeight = function getMaxHeight(editor) {
      return editor.getParam('max_height', 65535, 'number');
    };
    var isSkinDisabled = function isSkinDisabled(editor) {
      return editor.settings.skin === false;
    };
    var isInline = function isInline(editor) {
      return editor.getParam('inline', false, 'boolean');
    };
    var getResize = function getResize(editor) {
      var resize = editor.getParam('resize', 'vertical');
      if (resize === false) {
        return 'none';
      } else if (resize === 'both') {
        return 'both';
      } else {
        return 'vertical';
      }
    };
    var getSkinUrl = function getSkinUrl(editor) {
      var settings = editor.settings;
      var skin = settings.skin;
      var skinUrl = settings.skin_url;
      if (skin !== false) {
        var skinName = skin ? skin : 'lightgray';
        if (skinUrl) {
          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
        } else {
          skinUrl = global$1.baseURL + '/skins/' + skinName;
        }
      }
      return skinUrl;
    };
    var getIndexedToolbars = function getIndexedToolbars(settings, defaultToolbar) {
      var toolbars = [];
      for (var i = 1; i < 10; i++) {
        var toolbar = settings['toolbar' + i];
        if (!toolbar) {
          break;
        }
        toolbars.push(toolbar);
      }
      var mainToolbar = settings.toolbar ? [settings.toolbar] : [defaultToolbar];
      return toolbars.length > 0 ? toolbars : mainToolbar;
    };
    var getToolbars = function getToolbars(editor) {
      var toolbar = editor.getParam('toolbar');
      var defaultToolbar = 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image';
      if (toolbar === false) {
        return [];
      } else if (global$2.isArray(toolbar)) {
        return global$2.grep(toolbar, function (toolbar) {
          return toolbar.length > 0;
        });
      } else {
        return getIndexedToolbars(editor.settings, defaultToolbar);
      }
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$4 = tinymce.util.Tools.resolve('tinymce.ui.Factory');

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var fireSkinLoaded = function fireSkinLoaded(editor) {
      return editor.fire('SkinLoaded');
    };
    var fireResizeEditor = function fireResizeEditor(editor) {
      return editor.fire('ResizeEditor');
    };
    var fireBeforeRenderUI = function fireBeforeRenderUI(editor) {
      return editor.fire('BeforeRenderUI');
    };
    var $_cueeiltzjk26xn2b = {
      fireSkinLoaded: fireSkinLoaded,
      fireResizeEditor: fireResizeEditor,
      fireBeforeRenderUI: fireBeforeRenderUI
    };

    var focus = function focus(panel, type) {
      return function () {
        var item = panel.find(type)[0];
        if (item) {
          item.focus(true);
        }
      };
    };
    var addKeys = function addKeys(editor, panel) {
      editor.shortcuts.add('Alt+F9', '', focus(panel, 'menubar'));
      editor.shortcuts.add('Alt+F10,F10', '', focus(panel, 'toolbar'));
      editor.shortcuts.add('Alt+F11', '', focus(panel, 'elementpath'));
      panel.on('cancel', function () {
        editor.focus();
      });
    };
    var $_999l6lu0jk26xn2h = { addKeys: addKeys };

    var global$6 = tinymce.util.Tools.resolve('tinymce.geom.Rect');

    var global$7 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var noop = function noop() {
      var x = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        x[_i] = arguments[_i];
      }
    };

    var compose = function compose(fa, fb) {
      return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        return fa(fb.apply(null, arguments));
      };
    };
    var constant = function constant(value) {
      return function () {
        return value;
      };
    };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };

    var never = constant(false);
    var always = constant(true);

    var never$1 = never;
    var always$1 = always;
    var none = function none() {
      return NONE;
    };
    var NONE = function () {
      var eq = function eq(o) {
        return o.isNone();
      };
      var call$$1 = function call$$1(thunk) {
        return thunk();
      };
      var id = function id(n) {
        return n;
      };
      var noop$$1 = function noop$$1() {};
      var nul = function nul() {
        return null;
      };
      var undef = function undef() {
        return undefined;
      };
      var me = {
        fold: function fold(n, s) {
          return n();
        },
        is: never$1,
        isSome: never$1,
        isNone: always$1,
        getOr: id,
        getOrThunk: call$$1,
        getOrDie: function getOrDie(msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: nul,
        getOrUndefined: undef,
        or: id,
        orThunk: call$$1,
        map: none,
        ap: none,
        each: noop$$1,
        bind: none,
        flatten: none,
        exists: never$1,
        forall: always$1,
        filter: none,
        equals: eq,
        equals_: eq,
        toArray: function toArray() {
          return [];
        },
        toString: constant('none()')
      };
      if (Object.freeze) Object.freeze(me);
      return me;
    }();
    var some = function some(a) {
      var constant_a = function constant_a() {
        return a;
      };
      var self = function self() {
        return me;
      };
      var map = function map(f) {
        return some(f(a));
      };
      var bind = function bind(f) {
        return f(a);
      };
      var me = {
        fold: function fold(n, s) {
          return s(a);
        },
        is: function is(v) {
          return a === v;
        },
        isSome: always$1,
        isNone: never$1,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: map,
        ap: function ap(optfab) {
          return optfab.fold(none, function (fab) {
            return some(fab(a));
          });
        },
        each: function each(f) {
          f(a);
        },
        bind: bind,
        flatten: constant_a,
        exists: bind,
        forall: bind,
        filter: function filter(f) {
          return f(a) ? me : NONE;
        },
        equals: function equals(o) {
          return o.is(a);
        },
        equals_: function equals_(o, elementEq) {
          return o.fold(never$1, function (b) {
            return elementEq(a, b);
          });
        },
        toArray: function toArray() {
          return [a];
        },
        toString: function toString() {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function from(value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Option = {
      some: some,
      none: none,
      from: from
    };

    var getUiContainerDelta = function getUiContainerDelta(ctrl) {
      var uiContainer = getUiContainer(ctrl);
      if (uiContainer && global$3.DOM.getStyle(uiContainer, 'position', true) !== 'static') {
        var containerPos = global$3.DOM.getPos(uiContainer);
        var dx = uiContainer.scrollLeft - containerPos.x;
        var dy = uiContainer.scrollTop - containerPos.y;
        return Option.some({
          x: dx,
          y: dy
        });
      } else {
        return Option.none();
      }
    };
    var setUiContainer = function setUiContainer(editor, ctrl) {
      var uiContainer = global$3.DOM.select(editor.settings.ui_container)[0];
      ctrl.getRoot().uiContainer = uiContainer;
    };
    var getUiContainer = function getUiContainer(ctrl) {
      return ctrl ? ctrl.getRoot().uiContainer : null;
    };
    var inheritUiContainer = function inheritUiContainer(fromCtrl, toCtrl) {
      return toCtrl.uiContainer = getUiContainer(fromCtrl);
    };
    var $_596xbmu4jk26xn2q = {
      getUiContainerDelta: getUiContainerDelta,
      setUiContainer: setUiContainer,
      getUiContainer: getUiContainer,
      inheritUiContainer: inheritUiContainer
    };

    var createToolbar = function createToolbar(editor, items, size) {
      var toolbarItems = [];
      var buttonGroup;
      if (!items) {
        return;
      }
      global$2.each(items.split(/[ ,]/), function (item) {
        var itemName;
        var bindSelectorChanged = function bindSelectorChanged() {
          var selection = editor.selection;
          if (item.settings.stateSelector) {
            selection.selectorChanged(item.settings.stateSelector, function (state) {
              item.active(state);
            }, true);
          }
          if (item.settings.disabledStateSelector) {
            selection.selectorChanged(item.settings.disabledStateSelector, function (state) {
              item.disabled(state);
            });
          }
        };
        if (item === '|') {
          buttonGroup = null;
        } else {
          if (!buttonGroup) {
            buttonGroup = {
              type: 'buttongroup',
              items: []
            };
            toolbarItems.push(buttonGroup);
          }
          if (editor.buttons[item]) {
            itemName = item;
            item = editor.buttons[itemName];
            if (typeof item === 'function') {
              item = item();
            }
            item.type = item.type || 'button';
            item.size = size;
            item = global$4.create(item);
            buttonGroup.items.push(item);
            if (editor.initialized) {
              bindSelectorChanged();
            } else {
              editor.on('init', bindSelectorChanged);
            }
          }
        }
      });
      return {
        type: 'toolbar',
        layout: 'flow',
        items: toolbarItems
      };
    };
    var createToolbars = function createToolbars(editor, size) {
      var toolbars = [];
      var addToolbar = function addToolbar(items) {
        if (items) {
          toolbars.push(createToolbar(editor, items, size));
        }
      };
      global$2.each(getToolbars(editor), function (toolbar) {
        addToolbar(toolbar);
      });
      if (toolbars.length) {
        return {
          type: 'panel',
          layout: 'stack',
          classes: 'toolbar-grp',
          ariaRoot: true,
          ariaRemember: true,
          items: toolbars
        };
      }
    };
    var $_deb7gou7jk26xn2z = {
      createToolbar: createToolbar,
      createToolbars: createToolbars
    };

    var DOM = global$3.DOM;
    var toClientRect = function toClientRect(geomRect) {
      return {
        left: geomRect.x,
        top: geomRect.y,
        width: geomRect.w,
        height: geomRect.h,
        right: geomRect.x + geomRect.w,
        bottom: geomRect.y + geomRect.h
      };
    };
    var hideAllFloatingPanels = function hideAllFloatingPanels(editor) {
      global$2.each(editor.contextToolbars, function (toolbar) {
        if (toolbar.panel) {
          toolbar.panel.hide();
        }
      });
    };
    var movePanelTo = function movePanelTo(panel, pos) {
      panel.moveTo(pos.left, pos.top);
    };
    var togglePositionClass = function togglePositionClass(panel, relPos, predicate) {
      relPos = relPos ? relPos.substr(0, 2) : '';
      global$2.each({
        t: 'down',
        b: 'up'
      }, function (cls, pos) {
        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
      });
      global$2.each({
        l: 'left',
        r: 'right'
      }, function (cls, pos) {
        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
      });
    };
    var userConstrain = function userConstrain(handler, x, y, elementRect, contentAreaRect, panelRect) {
      panelRect = toClientRect({
        x: x,
        y: y,
        w: panelRect.w,
        h: panelRect.h
      });
      if (handler) {
        panelRect = handler({
          elementRect: toClientRect(elementRect),
          contentAreaRect: toClientRect(contentAreaRect),
          panelRect: panelRect
        });
      }
      return panelRect;
    };
    var addContextualToolbars = function addContextualToolbars(editor) {
      var scrollContainer;
      var getContextToolbars = function getContextToolbars() {
        return editor.contextToolbars || [];
      };
      var getElementRect = function getElementRect(elm) {
        var pos, targetRect, root;
        pos = DOM.getPos(editor.getContentAreaContainer());
        targetRect = editor.dom.getRect(elm);
        root = editor.dom.getRoot();
        if (root.nodeName === 'BODY') {
          targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
          targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
        }
        targetRect.x += pos.x;
        targetRect.y += pos.y;
        return targetRect;
      };
      var reposition = function reposition(match, shouldShow) {
        var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
        var handler = getInlineToolbarPositionHandler(editor);
        if (editor.removed) {
          return;
        }
        if (!match || !match.toolbar.panel) {
          hideAllFloatingPanels(editor);
          return;
        }
        testPositions = ['bc-tc', 'tc-bc', 'tl-bl', 'bl-tl', 'tr-br', 'br-tr'];
        panel = match.toolbar.panel;
        if (shouldShow) {
          panel.show();
        }
        elementRect = getElementRect(match.element);
        panelRect = DOM.getRect(panel.getEl());
        contentAreaRect = DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
        var delta = $_596xbmu4jk26xn2q.getUiContainerDelta(panel).getOr({
          x: 0,
          y: 0
        });
        elementRect.x += delta.x;
        elementRect.y += delta.y;
        panelRect.x += delta.x;
        panelRect.y += delta.y;
        contentAreaRect.x += delta.x;
        contentAreaRect.y += delta.y;
        smallElementWidthThreshold = 25;
        if (DOM.getStyle(match.element, 'display', true) !== 'inline') {
          var clientRect = match.element.getBoundingClientRect();
          elementRect.w = clientRect.width;
          elementRect.h = clientRect.height;
        }
        if (!editor.inline) {
          contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
        }
        if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
          elementRect = global$6.inflate(elementRect, 0, 8);
        }
        relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
        elementRect = global$6.clamp(elementRect, contentAreaRect);
        if (relPos) {
          relRect = global$6.relativePosition(panelRect, elementRect, relPos);
          movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
        } else {
          contentAreaRect.h += panelRect.h;
          elementRect = global$6.intersect(contentAreaRect, elementRect);
          if (elementRect) {
            relPos = global$6.findBestRelativePosition(panelRect, elementRect, contentAreaRect, ['bc-tc', 'bl-tl', 'br-tr']);
            if (relPos) {
              relRect = global$6.relativePosition(panelRect, elementRect, relPos);
              movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
            } else {
              movePanelTo(panel, userConstrain(handler, elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
            }
          } else {
            panel.hide();
          }
        }
        togglePositionClass(panel, relPos, function (pos1, pos2) {
          return pos1 === pos2;
        });
      };
      var repositionHandler = function repositionHandler(show) {
        return function () {
          var execute = function execute() {
            if (editor.selection) {
              reposition(findFrontMostMatch(editor.selection.getNode()), show);
            }
          };
          global$7.requestAnimationFrame(execute);
        };
      };
      var bindScrollEvent = function bindScrollEvent(panel) {
        if (!scrollContainer) {
          var reposition_1 = repositionHandler(true);
          var uiContainer_1 = $_596xbmu4jk26xn2q.getUiContainer(panel);
          scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
          DOM.bind(scrollContainer, 'scroll', reposition_1);
          DOM.bind(uiContainer_1, 'scroll', reposition_1);
          editor.on('remove', function () {
            DOM.unbind(scrollContainer, 'scroll', reposition_1);
            DOM.unbind(uiContainer_1, 'scroll', reposition_1);
          });
        }
      };
      var showContextToolbar = function showContextToolbar(match) {
        var panel;
        if (match.toolbar.panel) {
          match.toolbar.panel.show();
          reposition(match);
          return;
        }
        panel = global$4.create({
          type: 'floatpanel',
          role: 'dialog',
          classes: 'tinymce tinymce-inline arrow',
          ariaLabel: 'Inline toolbar',
          layout: 'flex',
          direction: 'column',
          align: 'stretch',
          autohide: false,
          autofix: true,
          fixed: true,
          border: 1,
          items: $_deb7gou7jk26xn2z.createToolbar(editor, match.toolbar.items),
          oncancel: function oncancel() {
            editor.focus();
          }
        });
        $_596xbmu4jk26xn2q.setUiContainer(editor, panel);
        bindScrollEvent(panel);
        match.toolbar.panel = panel;
        panel.renderTo().reflow();
        reposition(match);
      };
      var hideAllContextToolbars = function hideAllContextToolbars() {
        global$2.each(getContextToolbars(), function (toolbar) {
          if (toolbar.panel) {
            toolbar.panel.hide();
          }
        });
      };
      var findFrontMostMatch = function findFrontMostMatch(targetElm) {
        var i, y, parentsAndSelf;
        var toolbars = getContextToolbars();
        parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
        for (i = parentsAndSelf.length - 1; i >= 0; i--) {
          for (y = toolbars.length - 1; y >= 0; y--) {
            if (toolbars[y].predicate(parentsAndSelf[i])) {
              return {
                toolbar: toolbars[y],
                element: parentsAndSelf[i]
              };
            }
          }
        }
        return null;
      };
      editor.on('click keyup setContent ObjectResized', function (e) {
        if (e.type === 'setcontent' && !e.selection) {
          return;
        }
        global$7.setEditorTimeout(editor, function () {
          var match;
          match = findFrontMostMatch(editor.selection.getNode());
          if (match) {
            hideAllContextToolbars();
            showContextToolbar(match);
          } else {
            hideAllContextToolbars();
          }
        });
      });
      editor.on('blur hide contextmenu', hideAllContextToolbars);
      editor.on('ObjectResizeStart', function () {
        var match = findFrontMostMatch(editor.selection.getNode());
        if (match && match.toolbar.panel) {
          match.toolbar.panel.hide();
        }
      });
      editor.on('ResizeEditor ResizeWindow', repositionHandler(true));
      editor.on('nodeChange', repositionHandler(false));
      editor.on('remove', function () {
        global$2.each(getContextToolbars(), function (toolbar) {
          if (toolbar.panel) {
            toolbar.panel.remove();
          }
        });
        editor.contextToolbars = {};
      });
      editor.shortcuts.add('ctrl+shift+e > ctrl+shift+p', '', function () {
        var match = findFrontMostMatch(editor.selection.getNode());
        if (match && match.toolbar.panel) {
          match.toolbar.panel.items()[0].focus();
        }
      });
    };
    var $_6w23vnu1jk26xn2k = { addContextualToolbars: addContextualToolbars };

    var typeOf = function typeOf(x) {
      if (x === null) return 'null';
      var t = typeof x === 'undefined' ? 'undefined' : _typeof(x);
      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
      return t;
    };
    var isType = function isType(type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };

    var isFunction = isType('function');
    var isNumber = isType('number');

    var rawIndexOf = function () {
      var pIndexOf = Array.prototype.indexOf;
      var fastIndex = function fastIndex(xs, x) {
        return pIndexOf.call(xs, x);
      };
      var slowIndex = function slowIndex(xs, x) {
        return slowIndexOf(xs, x);
      };
      return pIndexOf === undefined ? slowIndex : fastIndex;
    }();
    var indexOf = function indexOf(xs, x) {
      var r = rawIndexOf(xs, x);
      return r === -1 ? Option.none() : Option.some(r);
    };

    var exists = function exists(xs, pred) {
      return findIndex(xs, pred).isSome();
    };

    var map = function map(xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i, xs);
      }
      return r;
    };
    var each = function each(xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i, xs);
      }
    };

    var filter = function filter(xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          r.push(x);
        }
      }
      return r;
    };

    var foldl = function foldl(xs, f, acc) {
      each(xs, function (x) {
        acc = f(acc, x);
      });
      return acc;
    };
    var find = function find(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(x);
        }
      }
      return Option.none();
    };
    var findIndex = function findIndex(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(i);
        }
      }
      return Option.none();
    };
    var slowIndexOf = function slowIndexOf(xs, x) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    };
    var push = Array.prototype.push;
    var flatten = function flatten(xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!Array.prototype.isPrototypeOf(xs[i])) throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        push.apply(r, xs[i]);
      }
      return r;
    };

    var slice = Array.prototype.slice;
    var reverse = function reverse(xs) {
      var r = slice.call(xs, 0);
      r.reverse();
      return r;
    };

    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
      return slice.call(x);
    };

    var defaultMenus = {
      file: {
        title: 'File',
        items: 'newdocument restoredraft | preview | print'
      },
      edit: {
        title: 'Edit',
        items: 'undo redo | cut copy paste pastetext | selectall'
      },
      view: {
        title: 'View',
        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen'
      },
      insert: {
        title: 'Insert',
        items: 'image link media template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
      },
      format: {
        title: 'Format',
        items: 'bold italic underline strikethrough superscript subscript codeformat | blockformats align | removeformat'
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code'
      },
      table: { title: 'Table' },
      help: { title: 'Help' }
    };
    var delimiterMenuNamePair = function delimiterMenuNamePair() {
      return {
        name: '|',
        item: { text: '|' }
      };
    };
    var createMenuNameItemPair = function createMenuNameItemPair(name, item) {
      var menuItem = item ? {
        name: name,
        item: item
      } : null;
      return name === '|' ? delimiterMenuNamePair() : menuItem;
    };
    var hasItemName = function hasItemName(namedMenuItems, name) {
      return findIndex(namedMenuItems, function (namedMenuItem) {
        return namedMenuItem.name === name;
      }).isSome();
    };
    var isSeparator = function isSeparator(namedMenuItem) {
      return namedMenuItem && namedMenuItem.item.text === '|';
    };
    var cleanupMenu = function cleanupMenu(namedMenuItems, removedMenuItems) {
      var menuItemsPass1 = filter(namedMenuItems, function (namedMenuItem) {
        return removedMenuItems.hasOwnProperty(namedMenuItem.name) === false;
      });
      var menuItemsPass2 = filter(menuItemsPass1, function (namedMenuItem, i, namedMenuItems) {
        return !isSeparator(namedMenuItem) || !isSeparator(namedMenuItems[i - 1]);
      });
      return filter(menuItemsPass2, function (namedMenuItem, i, namedMenuItems) {
        return !isSeparator(namedMenuItem) || i > 0 && i < namedMenuItems.length - 1;
      });
    };
    var createMenu = function createMenu(editorMenuItems, menus, removedMenuItems, context) {
      var menuButton, menu, namedMenuItems, isUserDefined;
      if (menus) {
        menu = menus[context];
        isUserDefined = true;
      } else {
        menu = defaultMenus[context];
      }
      if (menu) {
        menuButton = { text: menu.title };
        namedMenuItems = [];
        global$2.each((menu.items || '').split(/[ ,]/), function (name) {
          var namedMenuItem = createMenuNameItemPair(name, editorMenuItems[name]);
          if (namedMenuItem) {
            namedMenuItems.push(namedMenuItem);
          }
        });
        if (!isUserDefined) {
          global$2.each(editorMenuItems, function (item, name) {
            if (item.context === context && !hasItemName(namedMenuItems, name)) {
              if (item.separator === 'before') {
                namedMenuItems.push(delimiterMenuNamePair());
              }
              if (item.prependToContext) {
                namedMenuItems.unshift(createMenuNameItemPair(name, item));
              } else {
                namedMenuItems.push(createMenuNameItemPair(name, item));
              }
              if (item.separator === 'after') {
                namedMenuItems.push(delimiterMenuNamePair());
              }
            }
          });
        }
        menuButton.menu = map(cleanupMenu(namedMenuItems, removedMenuItems), function (menuItem) {
          return menuItem.item;
        });
        if (!menuButton.menu.length) {
          return null;
        }
      }
      return menuButton;
    };
    var getDefaultMenubar = function getDefaultMenubar(editor) {
      var name;
      var defaultMenuBar = [];
      var menu = getMenu(editor);
      if (menu) {
        for (name in menu) {
          defaultMenuBar.push(name);
        }
      } else {
        for (name in defaultMenus) {
          defaultMenuBar.push(name);
        }
      }
      return defaultMenuBar;
    };
    var createMenuButtons = function createMenuButtons(editor) {
      var menuButtons = [];
      var defaultMenuBar = getDefaultMenubar(editor);
      var removedMenuItems = global$2.makeMap(getRemovedMenuItems(editor).split(/[ ,]/));
      var menubar = getMenubar(editor);
      var enabledMenuNames = typeof menubar === 'string' ? menubar.split(/[ ,]/) : defaultMenuBar;
      for (var i = 0; i < enabledMenuNames.length; i++) {
        var menuItems = enabledMenuNames[i];
        var menu = createMenu(editor.menuItems, getMenu(editor), removedMenuItems, menuItems);
        if (menu) {
          menuButtons.push(menu);
        }
      }
      return menuButtons;
    };
    var $_g65cxcu8jk26xn33 = { createMenuButtons: createMenuButtons };

    var DOM$1 = global$3.DOM;
    var getSize = function getSize(elm) {
      return {
        width: elm.clientWidth,
        height: elm.clientHeight
      };
    };
    var resizeTo = function resizeTo(editor, width, height) {
      var containerElm, iframeElm, containerSize, iframeSize;
      containerElm = editor.getContainer();
      iframeElm = editor.getContentAreaContainer().firstChild;
      containerSize = getSize(containerElm);
      iframeSize = getSize(iframeElm);
      if (width !== null) {
        width = Math.max(getMinWidth(editor), width);
        width = Math.min(getMaxWidth(editor), width);
        DOM$1.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
        DOM$1.setStyle(iframeElm, 'width', width);
      }
      height = Math.max(getMinHeight(editor), height);
      height = Math.min(getMaxHeight(editor), height);
      DOM$1.setStyle(iframeElm, 'height', height);
      $_cueeiltzjk26xn2b.fireResizeEditor(editor);
    };
    var resizeBy = function resizeBy(editor, dw, dh) {
      var elm = editor.getContentAreaContainer();
      resizeTo(editor, elm.clientWidth + dw, elm.clientHeight + dh);
    };
    var $_fowa4rubjk26xn3f = {
      resizeTo: resizeTo,
      resizeBy: resizeBy
    };

    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');

    var api = function api(elm) {
      return {
        element: function element() {
          return elm;
        }
      };
    };
    var trigger = function trigger(sidebar, panel, callbackName) {
      var callback = sidebar.settings[callbackName];
      if (callback) {
        callback(api(panel.getEl('body')));
      }
    };
    var hidePanels = function hidePanels(name, container, sidebars) {
      global$2.each(sidebars, function (sidebar) {
        var panel = container.items().filter('#' + sidebar.name)[0];
        if (panel && panel.visible() && sidebar.name !== name) {
          trigger(sidebar, panel, 'onhide');
          panel.visible(false);
        }
      });
    };
    var deactivateButtons = function deactivateButtons(toolbar) {
      toolbar.items().each(function (ctrl) {
        ctrl.active(false);
      });
    };
    var findSidebar = function findSidebar(sidebars, name) {
      return global$2.grep(sidebars, function (sidebar) {
        return sidebar.name === name;
      })[0];
    };
    var showPanel = function showPanel(editor, name, sidebars) {
      return function (e) {
        var btnCtrl = e.control;
        var container = btnCtrl.parents().filter('panel')[0];
        var panel = container.find('#' + name)[0];
        var sidebar = findSidebar(sidebars, name);
        hidePanels(name, container, sidebars);
        deactivateButtons(btnCtrl.parent());
        if (panel && panel.visible()) {
          trigger(sidebar, panel, 'onhide');
          panel.hide();
          btnCtrl.active(false);
        } else {
          if (panel) {
            panel.show();
            trigger(sidebar, panel, 'onshow');
          } else {
            panel = global$4.create({
              type: 'container',
              name: name,
              layout: 'stack',
              classes: 'sidebar-panel',
              html: ''
            });
            container.prepend(panel);
            trigger(sidebar, panel, 'onrender');
            trigger(sidebar, panel, 'onshow');
          }
          btnCtrl.active(true);
        }
        $_cueeiltzjk26xn2b.fireResizeEditor(editor);
      };
    };
    var isModernBrowser = function isModernBrowser() {
      return !global$8.ie || global$8.ie >= 11;
    };
    var hasSidebar = function hasSidebar(editor) {
      return isModernBrowser() && editor.sidebars ? editor.sidebars.length > 0 : false;
    };
    var createSidebar = function createSidebar(editor) {
      var buttons = global$2.map(editor.sidebars, function (sidebar) {
        var settings = sidebar.settings;
        return {
          type: 'button',
          icon: settings.icon,
          image: settings.image,
          tooltip: settings.tooltip,
          onclick: showPanel(editor, sidebar.name, editor.sidebars)
        };
      });
      return {
        type: 'panel',
        name: 'sidebar',
        layout: 'stack',
        classes: 'sidebar',
        items: [{
          type: 'toolbar',
          layout: 'stack',
          classes: 'sidebar-toolbar',
          items: buttons
        }]
      };
    };
    var $_67vfwvucjk26xn3i = {
      hasSidebar: hasSidebar,
      createSidebar: createSidebar
    };

    var fireSkinLoaded$1 = function fireSkinLoaded$1(editor) {
      var done = function done() {
        editor._skinLoaded = true;
        $_cueeiltzjk26xn2b.fireSkinLoaded(editor);
      };
      return function () {
        if (editor.initialized) {
          done();
        } else {
          editor.on('init', done);
        }
      };
    };
    var $_gj1v4juejk26xn3l = { fireSkinLoaded: fireSkinLoaded$1 };

    var DOM$2 = global$3.DOM;
    var switchMode = function switchMode(panel) {
      return function (e) {
        panel.find('*').disabled(e.mode === 'readonly');
      };
    };
    var editArea = function editArea(border) {
      return {
        type: 'panel',
        name: 'iframe',
        layout: 'stack',
        classes: 'edit-area',
        border: border,
        html: ''
      };
    };
    var editAreaContainer = function editAreaContainer(editor) {
      return {
        type: 'panel',
        layout: 'stack',
        classes: 'edit-aria-container',
        border: '1 0 0 0',
        items: [editArea('0'), $_67vfwvucjk26xn3i.createSidebar(editor)]
      };
    };
    var render = function render(editor, theme, args) {
      var panel, resizeHandleCtrl, startSize;
      if (isSkinDisabled(editor) === false && args.skinUiCss) {
        DOM$2.styleSheetLoader.load(args.skinUiCss, $_gj1v4juejk26xn3l.fireSkinLoaded(editor));
      } else {
        $_gj1v4juejk26xn3l.fireSkinLoaded(editor)();
      }
      panel = theme.panel = global$4.create({
        type: 'panel',
        role: 'application',
        classes: 'tinymce',
        style: 'visibility: hidden',
        layout: 'stack',
        border: 1,
        items: [{
          type: 'container',
          classes: 'top-part',
          items: [hasMenubar(editor) === false ? null : {
            type: 'menubar',
            border: '0 0 1 0',
            items: $_g65cxcu8jk26xn33.createMenuButtons(editor)
          }, $_deb7gou7jk26xn2z.createToolbars(editor, getToolbarSize(editor))]
        }, $_67vfwvucjk26xn3i.hasSidebar(editor) ? editAreaContainer(editor) : editArea('1 0 0 0')]
      });
      $_596xbmu4jk26xn2q.setUiContainer(editor, panel);
      if (getResize(editor) !== 'none') {
        resizeHandleCtrl = {
          type: 'resizehandle',
          direction: getResize(editor),
          onResizeStart: function onResizeStart() {
            var elm = editor.getContentAreaContainer().firstChild;
            startSize = {
              width: elm.clientWidth,
              height: elm.clientHeight
            };
          },
          onResize: function onResize(e) {
            if (getResize(editor) === 'both') {
              $_fowa4rubjk26xn3f.resizeTo(editor, startSize.width + e.deltaX, startSize.height + e.deltaY);
            } else {
              $_fowa4rubjk26xn3f.resizeTo(editor, null, startSize.height + e.deltaY);
            }
          }
        };
      }
      if (hasStatusbar(editor)) {
        var linkHtml = '<a href="https://www.tinymce.com/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce" rel="noopener" target="_blank" role="presentation" tabindex="-1">tinymce</a>';
        var html = global$5.translate(['Powered by {0}', linkHtml]);
        var brandingLabel = isBrandingEnabled(editor) ? {
          type: 'label',
          classes: 'branding',
          html: ' ' + html
        } : null;
        panel.add({
          type: 'panel',
          name: 'statusbar',
          classes: 'statusbar',
          layout: 'flow',
          border: '1 0 0 0',
          ariaRoot: true,
          items: [{
            type: 'elementpath',
            editor: editor
          }, resizeHandleCtrl, brandingLabel]
        });
      }
      $_cueeiltzjk26xn2b.fireBeforeRenderUI(editor);
      editor.on('SwitchMode', switchMode(panel));
      panel.renderBefore(args.targetNode).reflow();
      if (isReadOnly(editor)) {
        editor.setMode('readonly');
      }
      if (args.width) {
        DOM$2.setStyle(panel.getEl(), 'width', args.width);
      }
      editor.on('remove', function () {
        panel.remove();
        panel = null;
      });
      $_999l6lu0jk26xn2h.addKeys(editor, panel);
      $_6w23vnu1jk26xn2k.addContextualToolbars(editor);
      return {
        iframeContainer: panel.find('#iframe')[0].getEl(),
        editorContainer: panel.getEl()
      };
    };
    var $_1grd53tvjk26xn27 = { render: render };

    var global$9 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');

    var count = 0;
    var funcs = {
      id: function id() {
        return 'mceu_' + count++;
      },
      create: function create(name$$1, attrs, children) {
        var elm = document.createElement(name$$1);
        global$3.DOM.setAttribs(elm, attrs);
        if (typeof children === 'string') {
          elm.innerHTML = children;
        } else {
          global$2.each(children, function (child) {
            if (child.nodeType) {
              elm.appendChild(child);
            }
          });
        }
        return elm;
      },
      createFragment: function createFragment(html) {
        return global$3.DOM.createFragment(html);
      },
      getWindowSize: function getWindowSize() {
        return global$3.DOM.getViewPort();
      },
      getSize: function getSize(elm) {
        var width, height;
        if (elm.getBoundingClientRect) {
          var rect = elm.getBoundingClientRect();
          width = Math.max(rect.width || rect.right - rect.left, elm.offsetWidth);
          height = Math.max(rect.height || rect.bottom - rect.bottom, elm.offsetHeight);
        } else {
          width = elm.offsetWidth;
          height = elm.offsetHeight;
        }
        return {
          width: width,
          height: height
        };
      },
      getPos: function getPos(elm, root) {
        return global$3.DOM.getPos(elm, root || funcs.getContainer());
      },
      getContainer: function getContainer() {
        return global$8.container ? global$8.container : document.body;
      },
      getViewPort: function getViewPort(win) {
        return global$3.DOM.getViewPort(win);
      },
      get: function get(id) {
        return document.getElementById(id);
      },
      addClass: function addClass(elm, cls) {
        return global$3.DOM.addClass(elm, cls);
      },
      removeClass: function removeClass(elm, cls) {
        return global$3.DOM.removeClass(elm, cls);
      },
      hasClass: function hasClass(elm, cls) {
        return global$3.DOM.hasClass(elm, cls);
      },
      toggleClass: function toggleClass(elm, cls, state) {
        return global$3.DOM.toggleClass(elm, cls, state);
      },
      css: function css(elm, name$$1, value) {
        return global$3.DOM.setStyle(elm, name$$1, value);
      },
      getRuntimeStyle: function getRuntimeStyle(elm, name$$1) {
        return global$3.DOM.getStyle(elm, name$$1, true);
      },
      on: function on(target, name$$1, callback, scope) {
        return global$3.DOM.bind(target, name$$1, callback, scope);
      },
      off: function off(target, name$$1, callback) {
        return global$3.DOM.unbind(target, name$$1, callback);
      },
      fire: function fire(target, name$$1, args) {
        return global$3.DOM.fire(target, name$$1, args);
      },
      innerHtml: function innerHtml(elm, html) {
        global$3.DOM.setHTML(elm, html);
      }
    };

    var isStatic = function isStatic(elm) {
      return funcs.getRuntimeStyle(elm, 'position') === 'static';
    };
    var isFixed = function isFixed(ctrl) {
      return ctrl.state.get('fixed');
    };
    function calculateRelativePosition(ctrl, targetElm, rel) {
      var ctrlElm, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
      viewport = getWindowViewPort();
      pos = funcs.getPos(targetElm, $_596xbmu4jk26xn2q.getUiContainer(ctrl));
      x = pos.x;
      y = pos.y;
      if (isFixed(ctrl) && isStatic(document.body)) {
        x -= viewport.x;
        y -= viewport.y;
      }
      ctrlElm = ctrl.getEl();
      size = funcs.getSize(ctrlElm);
      selfW = size.width;
      selfH = size.height;
      size = funcs.getSize(targetElm);
      targetW = size.width;
      targetH = size.height;
      rel = (rel || '').split('');
      if (rel[0] === 'b') {
        y += targetH;
      }
      if (rel[1] === 'r') {
        x += targetW;
      }
      if (rel[0] === 'c') {
        y += Math.round(targetH / 2);
      }
      if (rel[1] === 'c') {
        x += Math.round(targetW / 2);
      }
      if (rel[3] === 'b') {
        y -= selfH;
      }
      if (rel[4] === 'r') {
        x -= selfW;
      }
      if (rel[3] === 'c') {
        y -= Math.round(selfH / 2);
      }
      if (rel[4] === 'c') {
        x -= Math.round(selfW / 2);
      }
      return {
        x: x,
        y: y,
        w: selfW,
        h: selfH
      };
    }
    var getUiContainerViewPort = function getUiContainerViewPort(customUiContainer) {
      return {
        x: 0,
        y: 0,
        w: customUiContainer.scrollWidth - 1,
        h: customUiContainer.scrollHeight - 1
      };
    };
    var getWindowViewPort = function getWindowViewPort() {
      var win = window;
      var x = Math.max(win.pageXOffset, document.body.scrollLeft, document.documentElement.scrollLeft);
      var y = Math.max(win.pageYOffset, document.body.scrollTop, document.documentElement.scrollTop);
      var w = win.innerWidth || document.documentElement.clientWidth;
      var h = win.innerHeight || document.documentElement.clientHeight;
      return {
        x: x,
        y: y,
        w: x + w,
        h: y + h
      };
    };
    var getViewPortRect = function getViewPortRect(ctrl) {
      var customUiContainer = $_596xbmu4jk26xn2q.getUiContainer(ctrl);
      return customUiContainer && !isFixed(ctrl) ? getUiContainerViewPort(customUiContainer) : getWindowViewPort();
    };
    var $_63b1h8ukjk26xn4v = {
      testMoveRel: function testMoveRel(elm, rels) {
        var viewPortRect = getViewPortRect(this);
        for (var i = 0; i < rels.length; i++) {
          var pos = calculateRelativePosition(this, elm, rels[i]);
          if (isFixed(this)) {
            if (pos.x > 0 && pos.x + pos.w < viewPortRect.w && pos.y > 0 && pos.y + pos.h < viewPortRect.h) {
              return rels[i];
            }
          } else {
            if (pos.x > viewPortRect.x && pos.x + pos.w < viewPortRect.w && pos.y > viewPortRect.y && pos.y + pos.h < viewPortRect.h) {
              return rels[i];
            }
          }
        }
        return rels[0];
      },
      moveRel: function moveRel(elm, rel) {
        if (typeof rel !== 'string') {
          rel = this.testMoveRel(elm, rel);
        }
        var pos = calculateRelativePosition(this, elm, rel);
        return this.moveTo(pos.x, pos.y);
      },
      moveBy: function moveBy(dx, dy) {
        var self$$1 = this,
            rect = self$$1.layoutRect();
        self$$1.moveTo(rect.x + dx, rect.y + dy);
        return self$$1;
      },
      moveTo: function moveTo(x, y) {
        var self$$1 = this;
        function constrain(value, max, size) {
          if (value < 0) {
            return 0;
          }
          if (value + size > max) {
            value = max - size;
            return value < 0 ? 0 : value;
          }
          return value;
        }
        if (self$$1.settings.constrainToViewport) {
          var viewPortRect = getViewPortRect(this);
          var layoutRect = self$$1.layoutRect();
          x = constrain(x, viewPortRect.w, layoutRect.w);
          y = constrain(y, viewPortRect.h, layoutRect.h);
        }
        var uiContainer = $_596xbmu4jk26xn2q.getUiContainer(self$$1);
        if (uiContainer && isStatic(uiContainer) && !isFixed(self$$1)) {
          x -= uiContainer.scrollLeft;
          y -= uiContainer.scrollTop;
        }
        if (uiContainer) {
          x += 1;
          y += 1;
        }
        if (self$$1.state.get('rendered')) {
          self$$1.layoutRect({
            x: x,
            y: y
          }).repaint();
        } else {
          self$$1.settings.x = x;
          self$$1.settings.y = y;
        }
        self$$1.fire('move', {
          x: x,
          y: y
        });
        return self$$1;
      }
    };

    var global$10 = tinymce.util.Tools.resolve('tinymce.util.Class');

    var global$11 = tinymce.util.Tools.resolve('tinymce.util.EventDispatcher');

    var $_atjwyuuqjk26xn5q = {
      parseBox: function parseBox(value) {
        var len;
        var radix = 10;
        if (!value) {
          return;
        }
        if (typeof value === 'number') {
          value = value || 0;
          return {
            top: value,
            left: value,
            bottom: value,
            right: value
          };
        }
        value = value.split(' ');
        len = value.length;
        if (len === 1) {
          value[1] = value[2] = value[3] = value[0];
        } else if (len === 2) {
          value[2] = value[0];
          value[3] = value[1];
        } else if (len === 3) {
          value[3] = value[1];
        }
        return {
          top: parseInt(value[0], radix) || 0,
          right: parseInt(value[1], radix) || 0,
          bottom: parseInt(value[2], radix) || 0,
          left: parseInt(value[3], radix) || 0
        };
      },
      measureBox: function measureBox(elm, prefix) {
        function getStyle(name) {
          var defaultView = elm.ownerDocument.defaultView;
          if (defaultView) {
            var computedStyle = defaultView.getComputedStyle(elm, null);
            if (computedStyle) {
              name = name.replace(/[A-Z]/g, function (a) {
                return '-' + a;
              });
              return computedStyle.getPropertyValue(name);
            } else {
              return null;
            }
          }
          return elm.currentStyle[name];
        }
        function getSide(name) {
          var val = parseFloat(getStyle(name));
          return isNaN(val) ? 0 : val;
        }
        return {
          top: getSide(prefix + 'TopWidth'),
          right: getSide(prefix + 'RightWidth'),
          bottom: getSide(prefix + 'BottomWidth'),
          left: getSide(prefix + 'LeftWidth')
        };
      }
    };

    function noop$1() {}
    function ClassList(onchange) {
      this.cls = [];
      this.cls._map = {};
      this.onchange = onchange || noop$1;
      this.prefix = '';
    }
    global$2.extend(ClassList.prototype, {
      add: function add(cls) {
        if (cls && !this.contains(cls)) {
          this.cls._map[cls] = true;
          this.cls.push(cls);
          this._change();
        }
        return this;
      },
      remove: function remove(cls) {
        if (this.contains(cls)) {
          var i = void 0;
          for (i = 0; i < this.cls.length; i++) {
            if (this.cls[i] === cls) {
              break;
            }
          }
          this.cls.splice(i, 1);
          delete this.cls._map[cls];
          this._change();
        }
        return this;
      },
      toggle: function toggle(cls, state) {
        var curState = this.contains(cls);
        if (curState !== state) {
          if (curState) {
            this.remove(cls);
          } else {
            this.add(cls);
          }
          this._change();
        }
        return this;
      },
      contains: function contains(cls) {
        return !!this.cls._map[cls];
      },
      _change: function _change() {
        delete this.clsValue;
        this.onchange.call(this);
      }
    });
    ClassList.prototype.toString = function () {
      var value;
      if (this.clsValue) {
        return this.clsValue;
      }
      value = '';
      for (var i = 0; i < this.cls.length; i++) {
        if (i > 0) {
          value += ' ';
        }
        value += this.prefix + this.cls[i];
      }
      return value;
    };

    function unique(array) {
      var uniqueItems = [];
      var i = array.length,
          item;
      while (i--) {
        item = array[i];
        if (!item.__checked) {
          uniqueItems.push(item);
          item.__checked = 1;
        }
      }
      i = uniqueItems.length;
      while (i--) {
        delete uniqueItems[i].__checked;
      }
      return uniqueItems;
    }
    var expression = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
    var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g;
    var whiteSpace = /^\s*|\s*$/g;
    var Collection;
    var Selector = global$10.extend({
      init: function init(selector) {
        var match = this.match;
        function compileNameFilter(name) {
          if (name) {
            name = name.toLowerCase();
            return function (item) {
              return name === '*' || item.type === name;
            };
          }
        }
        function compileIdFilter(id) {
          if (id) {
            return function (item) {
              return item._name === id;
            };
          }
        }
        function compileClassesFilter(classes) {
          if (classes) {
            classes = classes.split('.');
            return function (item) {
              var i = classes.length;
              while (i--) {
                if (!item.classes.contains(classes[i])) {
                  return false;
                }
              }
              return true;
            };
          }
        }
        function compileAttrFilter(name, cmp, check) {
          if (name) {
            return function (item) {
              var value = item[name] ? item[name]() : '';
              return !cmp ? !!check : cmp === '=' ? value === check : cmp === '*=' ? value.indexOf(check) >= 0 : cmp === '~=' ? (' ' + value + ' ').indexOf(' ' + check + ' ') >= 0 : cmp === '!=' ? value !== check : cmp === '^=' ? value.indexOf(check) === 0 : cmp === '$=' ? value.substr(value.length - check.length) === check : false;
            };
          }
        }
        function compilePsuedoFilter(name) {
          var notSelectors;
          if (name) {
            name = /(?:not\((.+)\))|(.+)/i.exec(name);
            if (!name[1]) {
              name = name[2];
              return function (item, index, length) {
                return name === 'first' ? index === 0 : name === 'last' ? index === length - 1 : name === 'even' ? index % 2 === 0 : name === 'odd' ? index % 2 === 1 : item[name] ? item[name]() : false;
              };
            }
            notSelectors = parseChunks(name[1], []);
            return function (item) {
              return !match(item, notSelectors);
            };
          }
        }
        function compile(selector, filters, direct) {
          var parts;
          function add(filter) {
            if (filter) {
              filters.push(filter);
            }
          }
          parts = expression.exec(selector.replace(whiteSpace, ''));
          add(compileNameFilter(parts[1]));
          add(compileIdFilter(parts[2]));
          add(compileClassesFilter(parts[3]));
          add(compileAttrFilter(parts[4], parts[5], parts[6]));
          add(compilePsuedoFilter(parts[7]));
          filters.pseudo = !!parts[7];
          filters.direct = direct;
          return filters;
        }
        function parseChunks(selector, selectors) {
          var parts = [];
          var extra, matches, i;
          do {
            chunker.exec('');
            matches = chunker.exec(selector);
            if (matches) {
              selector = matches[3];
              parts.push(matches[1]);
              if (matches[2]) {
                extra = matches[3];
                break;
              }
            }
          } while (matches);
          if (extra) {
            parseChunks(extra, selectors);
          }
          selector = [];
          for (i = 0; i < parts.length; i++) {
            if (parts[i] !== '>') {
              selector.push(compile(parts[i], [], parts[i - 1] === '>'));
            }
          }
          selectors.push(selector);
          return selectors;
        }
        this._selectors = parseChunks(selector, []);
      },
      match: function match(control, selectors) {
        var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
        selectors = selectors || this._selectors;
        for (i = 0, l = selectors.length; i < l; i++) {
          selector = selectors[i];
          sl = selector.length;
          item = control;
          count = 0;
          for (si = sl - 1; si >= 0; si--) {
            filters = selector[si];
            while (item) {
              if (filters.pseudo) {
                siblings = item.parent().items();
                index = length = siblings.length;
                while (index--) {
                  if (siblings[index] === item) {
                    break;
                  }
                }
              }
              for (fi = 0, fl = filters.length; fi < fl; fi++) {
                if (!filters[fi](item, index, length)) {
                  fi = fl + 1;
                  break;
                }
              }
              if (fi === fl) {
                count++;
                break;
              } else {
                if (si === sl - 1) {
                  break;
                }
              }
              item = item.parent();
            }
          }
          if (count === sl) {
            return true;
          }
        }
        return false;
      },
      find: function find(container) {
        var matches = [],
            i,
            l;
        var selectors = this._selectors;
        function collect(items, selector, index) {
          var i, l, fi, fl, item;
          var filters = selector[index];
          for (i = 0, l = items.length; i < l; i++) {
            item = items[i];
            for (fi = 0, fl = filters.length; fi < fl; fi++) {
              if (!filters[fi](item, i, l)) {
                fi = fl + 1;
                break;
              }
            }
            if (fi === fl) {
              if (index === selector.length - 1) {
                matches.push(item);
              } else {
                if (item.items) {
                  collect(item.items(), selector, index + 1);
                }
              }
            } else if (filters.direct) {
              return;
            }
            if (item.items) {
              collect(item.items(), selector, index);
            }
          }
        }
        if (container.items) {
          for (i = 0, l = selectors.length; i < l; i++) {
            collect(container.items(), selectors[i], 0);
          }
          if (l > 1) {
            matches = unique(matches);
          }
        }
        if (!Collection) {
          Collection = Selector.Collection;
        }
        return new Collection(matches);
      }
    });

    var Collection$1;
    var proto;
    var push$1 = Array.prototype.push;
    var slice$1 = Array.prototype.slice;
    proto = {
      length: 0,
      init: function init(items) {
        if (items) {
          this.add(items);
        }
      },
      add: function add(items) {
        var self = this;
        if (!global$2.isArray(items)) {
          if (items instanceof Collection$1) {
            self.add(items.toArray());
          } else {
            push$1.call(self, items);
          }
        } else {
          push$1.apply(self, items);
        }
        return self;
      },
      set: function set(items) {
        var self = this;
        var len = self.length;
        var i;
        self.length = 0;
        self.add(items);
        for (i = self.length; i < len; i++) {
          delete self[i];
        }
        return self;
      },
      filter: function filter(selector) {
        var self = this;
        var i, l;
        var matches = [];
        var item, match;
        if (typeof selector === 'string') {
          selector = new Selector(selector);
          match = function match(item) {
            return selector.match(item);
          };
        } else {
          match = selector;
        }
        for (i = 0, l = self.length; i < l; i++) {
          item = self[i];
          if (match(item)) {
            matches.push(item);
          }
        }
        return new Collection$1(matches);
      },
      slice: function slice() {
        return new Collection$1(slice$1.apply(this, arguments));
      },
      eq: function eq(index) {
        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
      },
      each: function each(callback) {
        global$2.each(this, callback);
        return this;
      },
      toArray: function toArray() {
        return global$2.toArray(this);
      },
      indexOf: function indexOf(ctrl) {
        var self = this;
        var i = self.length;
        while (i--) {
          if (self[i] === ctrl) {
            break;
          }
        }
        return i;
      },
      reverse: function reverse() {
        return new Collection$1(global$2.toArray(this).reverse());
      },
      hasClass: function hasClass(cls) {
        return this[0] ? this[0].classes.contains(cls) : false;
      },
      prop: function prop(name, value) {
        var self = this;
        var item;
        if (value !== undefined) {
          self.each(function (item) {
            if (item[name]) {
              item[name](value);
            }
          });
          return self;
        }
        item = self[0];
        if (item && item[name]) {
          return item[name]();
        }
      },
      exec: function exec(name) {
        var self = this,
            args = global$2.toArray(arguments).slice(1);
        self.each(function (item) {
          if (item[name]) {
            item[name].apply(item, args);
          }
        });
        return self;
      },
      remove: function remove() {
        var i = this.length;
        while (i--) {
          this[i].remove();
        }
        return this;
      },
      addClass: function addClass(cls) {
        return this.each(function (item) {
          item.classes.add(cls);
        });
      },
      removeClass: function removeClass(cls) {
        return this.each(function (item) {
          item.classes.remove(cls);
        });
      }
    };
    global$2.each('fire on off show hide append prepend before after reflow'.split(' '), function (name) {
      proto[name] = function () {
        var args = global$2.toArray(arguments);
        this.each(function (ctrl) {
          if (name in ctrl) {
            ctrl[name].apply(ctrl, args);
          }
        });
        return this;
      };
    });
    global$2.each('text name disabled active selected checked visible parent value data'.split(' '), function (name) {
      proto[name] = function (value) {
        return this.prop(name, value);
      };
    });
    Collection$1 = global$10.extend(proto);
    Selector.Collection = Collection$1;
    var Collection$2 = Collection$1;

    var Binding = function Binding(settings) {
      this.create = settings.create;
    };
    Binding.create = function (model, name) {
      return new Binding({
        create: function create(otherModel, otherName) {
          var bindings;
          var fromSelfToOther = function fromSelfToOther(e) {
            otherModel.set(otherName, e.value);
          };
          var fromOtherToSelf = function fromOtherToSelf(e) {
            model.set(name, e.value);
          };
          otherModel.on('change:' + otherName, fromOtherToSelf);
          model.on('change:' + name, fromSelfToOther);
          bindings = otherModel._bindings;
          if (!bindings) {
            bindings = otherModel._bindings = [];
            otherModel.on('destroy', function () {
              var i = bindings.length;
              while (i--) {
                bindings[i]();
              }
            });
          }
          bindings.push(function () {
            model.off('change:' + name, fromSelfToOther);
          });
          return model.get(name);
        }
      });
    };

    var global$12 = tinymce.util.Tools.resolve('tinymce.util.Observable');

    function isNode(node) {
      return node.nodeType > 0;
    }
    function isEqual(a, b) {
      var k, checked;
      if (a === b) {
        return true;
      }
      if (a === null || b === null) {
        return a === b;
      }
      if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== 'object') {
        return a === b;
      }
      if (global$2.isArray(b)) {
        if (a.length !== b.length) {
          return false;
        }
        k = a.length;
        while (k--) {
          if (!isEqual(a[k], b[k])) {
            return false;
          }
        }
      }
      if (isNode(a) || isNode(b)) {
        return a === b;
      }
      checked = {};
      for (k in b) {
        if (!isEqual(a[k], b[k])) {
          return false;
        }
        checked[k] = true;
      }
      for (k in a) {
        if (!checked[k] && !isEqual(a[k], b[k])) {
          return false;
        }
      }
      return true;
    }
    var ObservableObject = global$10.extend({
      Mixins: [global$12],
      init: function init(data) {
        var name, value;
        data = data || {};
        for (name in data) {
          value = data[name];
          if (value instanceof Binding) {
            data[name] = value.create(this, name);
          }
        }
        this.data = data;
      },
      set: function set(name, value) {
        var key, args;
        var oldValue = this.data[name];
        if (value instanceof Binding) {
          value = value.create(this, name);
        }
        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
          for (key in name) {
            this.set(key, name[key]);
          }
          return this;
        }
        if (!isEqual(oldValue, value)) {
          this.data[name] = value;
          args = {
            target: this,
            name: name,
            value: value,
            oldValue: oldValue
          };
          this.fire('change:' + name, args);
          this.fire('change', args);
        }
        return this;
      },
      get: function get(name) {
        return this.data[name];
      },
      has: function has(name) {
        return name in this.data;
      },
      bind: function bind(name) {
        return Binding.create(this, name);
      },
      destroy: function destroy() {
        this.fire('destroy');
      }
    });

    var dirtyCtrls = {};
    var animationFrameRequested;
    var $_6bivibuxjk26xn6n = {
      add: function add(ctrl) {
        var parent$$1 = ctrl.parent();
        if (parent$$1) {
          if (!parent$$1._layout || parent$$1._layout.isNative()) {
            return;
          }
          if (!dirtyCtrls[parent$$1._id]) {
            dirtyCtrls[parent$$1._id] = parent$$1;
          }
          if (!animationFrameRequested) {
            animationFrameRequested = true;
            global$7.requestAnimationFrame(function () {
              var id, ctrl;
              animationFrameRequested = false;
              for (id in dirtyCtrls) {
                ctrl = dirtyCtrls[id];
                if (ctrl.state.get('rendered')) {
                  ctrl.reflow();
                }
              }
              dirtyCtrls = {};
            }, document.body);
          }
        }
      },
      remove: function remove(ctrl) {
        if (dirtyCtrls[ctrl._id]) {
          delete dirtyCtrls[ctrl._id];
        }
      }
    };

    var hasMouseWheelEventSupport = 'onmousewheel' in document;
    var hasWheelEventSupport = false;
    var classPrefix = 'mce-';
    var Control;
    var idCounter = 0;
    var proto$1 = {
      Statics: { classPrefix: classPrefix },
      isRtl: function isRtl() {
        return Control.rtl;
      },
      classPrefix: classPrefix,
      init: function init(settings) {
        var self$$1 = this;
        var classes, defaultClasses;
        function applyClasses(classes) {
          var i;
          classes = classes.split(' ');
          for (i = 0; i < classes.length; i++) {
            self$$1.classes.add(classes[i]);
          }
        }
        self$$1.settings = settings = global$2.extend({}, self$$1.Defaults, settings);
        self$$1._id = settings.id || 'mceu_' + idCounter++;
        self$$1._aria = { role: settings.role };
        self$$1._elmCache = {};
        self$$1.$ = global$9;
        self$$1.state = new ObservableObject({
          visible: true,
          active: false,
          disabled: false,
          value: ''
        });
        self$$1.data = new ObservableObject(settings.data);
        self$$1.classes = new ClassList(function () {
          if (self$$1.state.get('rendered')) {
            self$$1.getEl().className = this.toString();
          }
        });
        self$$1.classes.prefix = self$$1.classPrefix;
        classes = settings.classes;
        if (classes) {
          if (self$$1.Defaults) {
            defaultClasses = self$$1.Defaults.classes;
            if (defaultClasses && classes !== defaultClasses) {
              applyClasses(defaultClasses);
            }
          }
          applyClasses(classes);
        }
        global$2.each('title text name visible disabled active value'.split(' '), function (name$$1) {
          if (name$$1 in settings) {
            self$$1[name$$1](settings[name$$1]);
          }
        });
        self$$1.on('click', function () {
          if (self$$1.disabled()) {
            return false;
          }
        });
        self$$1.settings = settings;
        self$$1.borderBox = $_atjwyuuqjk26xn5q.parseBox(settings.border);
        self$$1.paddingBox = $_atjwyuuqjk26xn5q.parseBox(settings.padding);
        self$$1.marginBox = $_atjwyuuqjk26xn5q.parseBox(settings.margin);
        if (settings.hidden) {
          self$$1.hide();
        }
      },
      Properties: 'parent,name',
      getContainerElm: function getContainerElm() {
        var uiContainer = $_596xbmu4jk26xn2q.getUiContainer(this);
        return uiContainer ? uiContainer : funcs.getContainer();
      },
      getParentCtrl: function getParentCtrl(elm) {
        var ctrl;
        var lookup = this.getRoot().controlIdLookup;
        while (elm && lookup) {
          ctrl = lookup[elm.id];
          if (ctrl) {
            break;
          }
          elm = elm.parentNode;
        }
        return ctrl;
      },
      initLayoutRect: function initLayoutRect() {
        var self$$1 = this;
        var settings = self$$1.settings;
        var borderBox, layoutRect;
        var elm = self$$1.getEl();
        var width, height, minWidth, minHeight, autoResize;
        var startMinWidth, startMinHeight, initialSize;
        borderBox = self$$1.borderBox = self$$1.borderBox || $_atjwyuuqjk26xn5q.measureBox(elm, 'border');
        self$$1.paddingBox = self$$1.paddingBox || $_atjwyuuqjk26xn5q.measureBox(elm, 'padding');
        self$$1.marginBox = self$$1.marginBox || $_atjwyuuqjk26xn5q.measureBox(elm, 'margin');
        initialSize = funcs.getSize(elm);
        startMinWidth = settings.minWidth;
        startMinHeight = settings.minHeight;
        minWidth = startMinWidth || initialSize.width;
        minHeight = startMinHeight || initialSize.height;
        width = settings.width;
        height = settings.height;
        autoResize = settings.autoResize;
        autoResize = typeof autoResize !== 'undefined' ? autoResize : !width && !height;
        width = width || minWidth;
        height = height || minHeight;
        var deltaW = borderBox.left + borderBox.right;
        var deltaH = borderBox.top + borderBox.bottom;
        var maxW = settings.maxWidth || 65535;
        var maxH = settings.maxHeight || 65535;
        self$$1._layoutRect = layoutRect = {
          x: settings.x || 0,
          y: settings.y || 0,
          w: width,
          h: height,
          deltaW: deltaW,
          deltaH: deltaH,
          contentW: width - deltaW,
          contentH: height - deltaH,
          innerW: width - deltaW,
          innerH: height - deltaH,
          startMinWidth: startMinWidth || 0,
          startMinHeight: startMinHeight || 0,
          minW: Math.min(minWidth, maxW),
          minH: Math.min(minHeight, maxH),
          maxW: maxW,
          maxH: maxH,
          autoResize: autoResize,
          scrollW: 0
        };
        self$$1._lastLayoutRect = {};
        return layoutRect;
      },
      layoutRect: function layoutRect(newRect) {
        var self$$1 = this;
        var curRect = self$$1._layoutRect,
            lastLayoutRect,
            size,
            deltaWidth,
            deltaHeight,
            repaintControls;
        if (!curRect) {
          curRect = self$$1.initLayoutRect();
        }
        if (newRect) {
          deltaWidth = curRect.deltaW;
          deltaHeight = curRect.deltaH;
          if (newRect.x !== undefined) {
            curRect.x = newRect.x;
          }
          if (newRect.y !== undefined) {
            curRect.y = newRect.y;
          }
          if (newRect.minW !== undefined) {
            curRect.minW = newRect.minW;
          }
          if (newRect.minH !== undefined) {
            curRect.minH = newRect.minH;
          }
          size = newRect.w;
          if (size !== undefined) {
            size = size < curRect.minW ? curRect.minW : size;
            size = size > curRect.maxW ? curRect.maxW : size;
            curRect.w = size;
            curRect.innerW = size - deltaWidth;
          }
          size = newRect.h;
          if (size !== undefined) {
            size = size < curRect.minH ? curRect.minH : size;
            size = size > curRect.maxH ? curRect.maxH : size;
            curRect.h = size;
            curRect.innerH = size - deltaHeight;
          }
          size = newRect.innerW;
          if (size !== undefined) {
            size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
            size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
            curRect.innerW = size;
            curRect.w = size + deltaWidth;
          }
          size = newRect.innerH;
          if (size !== undefined) {
            size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
            size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
            curRect.innerH = size;
            curRect.h = size + deltaHeight;
          }
          if (newRect.contentW !== undefined) {
            curRect.contentW = newRect.contentW;
          }
          if (newRect.contentH !== undefined) {
            curRect.contentH = newRect.contentH;
          }
          lastLayoutRect = self$$1._lastLayoutRect;
          if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y || lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
            repaintControls = Control.repaintControls;
            if (repaintControls) {
              if (repaintControls.map && !repaintControls.map[self$$1._id]) {
                repaintControls.push(self$$1);
                repaintControls.map[self$$1._id] = true;
              }
            }
            lastLayoutRect.x = curRect.x;
            lastLayoutRect.y = curRect.y;
            lastLayoutRect.w = curRect.w;
            lastLayoutRect.h = curRect.h;
          }
          return self$$1;
        }
        return curRect;
      },
      repaint: function repaint() {
        var self$$1 = this;
        var style, bodyStyle, bodyElm, rect, borderBox;
        var borderW, borderH, lastRepaintRect, round, value;
        round = !document.createRange ? Math.round : function (value) {
          return value;
        };
        style = self$$1.getEl().style;
        rect = self$$1._layoutRect;
        lastRepaintRect = self$$1._lastRepaintRect || {};
        borderBox = self$$1.borderBox;
        borderW = borderBox.left + borderBox.right;
        borderH = borderBox.top + borderBox.bottom;
        if (rect.x !== lastRepaintRect.x) {
          style.left = round(rect.x) + 'px';
          lastRepaintRect.x = rect.x;
        }
        if (rect.y !== lastRepaintRect.y) {
          style.top = round(rect.y) + 'px';
          lastRepaintRect.y = rect.y;
        }
        if (rect.w !== lastRepaintRect.w) {
          value = round(rect.w - borderW);
          style.width = (value >= 0 ? value : 0) + 'px';
          lastRepaintRect.w = rect.w;
        }
        if (rect.h !== lastRepaintRect.h) {
          value = round(rect.h - borderH);
          style.height = (value >= 0 ? value : 0) + 'px';
          lastRepaintRect.h = rect.h;
        }
        if (self$$1._hasBody && rect.innerW !== lastRepaintRect.innerW) {
          value = round(rect.innerW);
          bodyElm = self$$1.getEl('body');
          if (bodyElm) {
            bodyStyle = bodyElm.style;
            bodyStyle.width = (value >= 0 ? value : 0) + 'px';
          }
          lastRepaintRect.innerW = rect.innerW;
        }
        if (self$$1._hasBody && rect.innerH !== lastRepaintRect.innerH) {
          value = round(rect.innerH);
          bodyElm = bodyElm || self$$1.getEl('body');
          if (bodyElm) {
            bodyStyle = bodyStyle || bodyElm.style;
            bodyStyle.height = (value >= 0 ? value : 0) + 'px';
          }
          lastRepaintRect.innerH = rect.innerH;
        }
        self$$1._lastRepaintRect = lastRepaintRect;
        self$$1.fire('repaint', {}, false);
      },
      updateLayoutRect: function updateLayoutRect() {
        var self$$1 = this;
        self$$1.parent()._lastRect = null;
        funcs.css(self$$1.getEl(), {
          width: '',
          height: ''
        });
        self$$1._layoutRect = self$$1._lastRepaintRect = self$$1._lastLayoutRect = null;
        self$$1.initLayoutRect();
      },
      on: function on(name$$1, callback) {
        var self$$1 = this;
        function resolveCallbackName(name$$1) {
          var callback, scope;
          if (typeof name$$1 !== 'string') {
            return name$$1;
          }
          return function (e) {
            if (!callback) {
              self$$1.parentsAndSelf().each(function (ctrl) {
                var callbacks = ctrl.settings.callbacks;
                if (callbacks && (callback = callbacks[name$$1])) {
                  scope = ctrl;
                  return false;
                }
              });
            }
            if (!callback) {
              e.action = name$$1;
              this.fire('execute', e);
              return;
            }
            return callback.call(scope, e);
          };
        }
        getEventDispatcher(self$$1).on(name$$1, resolveCallbackName(callback));
        return self$$1;
      },
      off: function off(name$$1, callback) {
        getEventDispatcher(this).off(name$$1, callback);
        return this;
      },
      fire: function fire(name$$1, args, bubble) {
        var self$$1 = this;
        args = args || {};
        if (!args.control) {
          args.control = self$$1;
        }
        args = getEventDispatcher(self$$1).fire(name$$1, args);
        if (bubble !== false && self$$1.parent) {
          var parent$$1 = self$$1.parent();
          while (parent$$1 && !args.isPropagationStopped()) {
            parent$$1.fire(name$$1, args, false);
            parent$$1 = parent$$1.parent();
          }
        }
        return args;
      },
      hasEventListeners: function hasEventListeners(name$$1) {
        return getEventDispatcher(this).has(name$$1);
      },
      parents: function parents(selector) {
        var self$$1 = this;
        var ctrl,
            parents = new Collection$2();
        for (ctrl = self$$1.parent(); ctrl; ctrl = ctrl.parent()) {
          parents.add(ctrl);
        }
        if (selector) {
          parents = parents.filter(selector);
        }
        return parents;
      },
      parentsAndSelf: function parentsAndSelf(selector) {
        return new Collection$2(this).add(this.parents(selector));
      },
      next: function next() {
        var parentControls = this.parent().items();
        return parentControls[parentControls.indexOf(this) + 1];
      },
      prev: function prev() {
        var parentControls = this.parent().items();
        return parentControls[parentControls.indexOf(this) - 1];
      },
      innerHtml: function innerHtml(html) {
        this.$el.html(html);
        return this;
      },
      getEl: function getEl(suffix) {
        var id = suffix ? this._id + '-' + suffix : this._id;
        if (!this._elmCache[id]) {
          this._elmCache[id] = global$9('#' + id)[0];
        }
        return this._elmCache[id];
      },
      show: function show() {
        return this.visible(true);
      },
      hide: function hide() {
        return this.visible(false);
      },
      focus: function focus() {
        try {
          this.getEl().focus();
        } catch (ex) {}
        return this;
      },
      blur: function blur() {
        this.getEl().blur();
        return this;
      },
      aria: function aria(name$$1, value) {
        var self$$1 = this,
            elm = self$$1.getEl(self$$1.ariaTarget);
        if (typeof value === 'undefined') {
          return self$$1._aria[name$$1];
        }
        self$$1._aria[name$$1] = value;
        if (self$$1.state.get('rendered')) {
          elm.setAttribute(name$$1 === 'role' ? name$$1 : 'aria-' + name$$1, value);
        }
        return self$$1;
      },
      encode: function encode(text, translate) {
        if (translate !== false) {
          text = this.translate(text);
        }
        return (text || '').replace(/[&<>"]/g, function (match) {
          return '&#' + match.charCodeAt(0) + ';';
        });
      },
      translate: function translate(text) {
        return Control.translate ? Control.translate(text) : text;
      },
      before: function before(items) {
        var self$$1 = this,
            parent$$1 = self$$1.parent();
        if (parent$$1) {
          parent$$1.insert(items, parent$$1.items().indexOf(self$$1), true);
        }
        return self$$1;
      },
      after: function after(items) {
        var self$$1 = this,
            parent$$1 = self$$1.parent();
        if (parent$$1) {
          parent$$1.insert(items, parent$$1.items().indexOf(self$$1));
        }
        return self$$1;
      },
      remove: function remove() {
        var self$$1 = this;
        var elm = self$$1.getEl();
        var parent$$1 = self$$1.parent();
        var newItems, i;
        if (self$$1.items) {
          var controls = self$$1.items().toArray();
          i = controls.length;
          while (i--) {
            controls[i].remove();
          }
        }
        if (parent$$1 && parent$$1.items) {
          newItems = [];
          parent$$1.items().each(function (item) {
            if (item !== self$$1) {
              newItems.push(item);
            }
          });
          parent$$1.items().set(newItems);
          parent$$1._lastRect = null;
        }
        if (self$$1._eventsRoot && self$$1._eventsRoot === self$$1) {
          global$9(elm).off();
        }
        var lookup = self$$1.getRoot().controlIdLookup;
        if (lookup) {
          delete lookup[self$$1._id];
        }
        if (elm && elm.parentNode) {
          elm.parentNode.removeChild(elm);
        }
        self$$1.state.set('rendered', false);
        self$$1.state.destroy();
        self$$1.fire('remove');
        return self$$1;
      },
      renderBefore: function renderBefore(elm) {
        global$9(elm).before(this.renderHtml());
        this.postRender();
        return this;
      },
      renderTo: function renderTo(elm) {
        global$9(elm || this.getContainerElm()).append(this.renderHtml());
        this.postRender();
        return this;
      },
      preRender: function preRender() {},
      render: function render() {},
      renderHtml: function renderHtml() {
        return '<div id="' + this._id + '" class="' + this.classes + '"></div>';
      },
      postRender: function postRender() {
        var self$$1 = this;
        var settings = self$$1.settings;
        var elm, box, parent$$1, name$$1, parentEventsRoot;
        self$$1.$el = global$9(self$$1.getEl());
        self$$1.state.set('rendered', true);
        for (name$$1 in settings) {
          if (name$$1.indexOf('on') === 0) {
            self$$1.on(name$$1.substr(2), settings[name$$1]);
          }
        }
        if (self$$1._eventsRoot) {
          for (parent$$1 = self$$1.parent(); !parentEventsRoot && parent$$1; parent$$1 = parent$$1.parent()) {
            parentEventsRoot = parent$$1._eventsRoot;
          }
          if (parentEventsRoot) {
            for (name$$1 in parentEventsRoot._nativeEvents) {
              self$$1._nativeEvents[name$$1] = true;
            }
          }
        }
        bindPendingEvents(self$$1);
        if (settings.style) {
          elm = self$$1.getEl();
          if (elm) {
            elm.setAttribute('style', settings.style);
            elm.style.cssText = settings.style;
          }
        }
        if (self$$1.settings.border) {
          box = self$$1.borderBox;
          self$$1.$el.css({
            'border-top-width': box.top,
            'border-right-width': box.right,
            'border-bottom-width': box.bottom,
            'border-left-width': box.left
          });
        }
        var root = self$$1.getRoot();
        if (!root.controlIdLookup) {
          root.controlIdLookup = {};
        }
        root.controlIdLookup[self$$1._id] = self$$1;
        for (var key in self$$1._aria) {
          self$$1.aria(key, self$$1._aria[key]);
        }
        if (self$$1.state.get('visible') === false) {
          self$$1.getEl().style.display = 'none';
        }
        self$$1.bindStates();
        self$$1.state.on('change:visible', function (e) {
          var state = e.value;
          var parentCtrl;
          if (self$$1.state.get('rendered')) {
            self$$1.getEl().style.display = state === false ? 'none' : '';
            self$$1.getEl().getBoundingClientRect();
          }
          parentCtrl = self$$1.parent();
          if (parentCtrl) {
            parentCtrl._lastRect = null;
          }
          self$$1.fire(state ? 'show' : 'hide');
          $_6bivibuxjk26xn6n.add(self$$1);
        });
        self$$1.fire('postrender', {}, false);
      },
      bindStates: function bindStates() {},
      scrollIntoView: function scrollIntoView(align) {
        function getOffset(elm, rootElm) {
          var x,
              y,
              parent$$1 = elm;
          x = y = 0;
          while (parent$$1 && parent$$1 !== rootElm && parent$$1.nodeType) {
            x += parent$$1.offsetLeft || 0;
            y += parent$$1.offsetTop || 0;
            parent$$1 = parent$$1.offsetParent;
          }
          return {
            x: x,
            y: y
          };
        }
        var elm = this.getEl(),
            parentElm = elm.parentNode;
        var x, y, width, height, parentWidth, parentHeight;
        var pos = getOffset(elm, parentElm);
        x = pos.x;
        y = pos.y;
        width = elm.offsetWidth;
        height = elm.offsetHeight;
        parentWidth = parentElm.clientWidth;
        parentHeight = parentElm.clientHeight;
        if (align === 'end') {
          x -= parentWidth - width;
          y -= parentHeight - height;
        } else if (align === 'center') {
          x -= parentWidth / 2 - width / 2;
          y -= parentHeight / 2 - height / 2;
        }
        parentElm.scrollLeft = x;
        parentElm.scrollTop = y;
        return this;
      },
      getRoot: function getRoot() {
        var ctrl = this,
            rootControl;
        var parents = [];
        while (ctrl) {
          if (ctrl.rootControl) {
            rootControl = ctrl.rootControl;
            break;
          }
          parents.push(ctrl);
          rootControl = ctrl;
          ctrl = ctrl.parent();
        }
        if (!rootControl) {
          rootControl = this;
        }
        var i = parents.length;
        while (i--) {
          parents[i].rootControl = rootControl;
        }
        return rootControl;
      },
      reflow: function reflow() {
        $_6bivibuxjk26xn6n.remove(this);
        var parent$$1 = this.parent();
        if (parent$$1 && parent$$1._layout && !parent$$1._layout.isNative()) {
          parent$$1.reflow();
        }
        return this;
      }
    };
    global$2.each('text title visible disabled active value'.split(' '), function (name$$1) {
      proto$1[name$$1] = function (value) {
        if (arguments.length === 0) {
          return this.state.get(name$$1);
        }
        if (typeof value !== 'undefined') {
          this.state.set(name$$1, value);
        }
        return this;
      };
    });
    Control = global$10.extend(proto$1);
    function getEventDispatcher(obj) {
      if (!obj._eventDispatcher) {
        obj._eventDispatcher = new global$11({
          scope: obj,
          toggleEvent: function toggleEvent(name$$1, state) {
            if (state && global$11.isNative(name$$1)) {
              if (!obj._nativeEvents) {
                obj._nativeEvents = {};
              }
              obj._nativeEvents[name$$1] = true;
              if (obj.state.get('rendered')) {
                bindPendingEvents(obj);
              }
            }
          }
        });
      }
      return obj._eventDispatcher;
    }
    function bindPendingEvents(eventCtrl) {
      var i, l, parents, eventRootCtrl, nativeEvents, name$$1;
      function delegate(e) {
        var control = eventCtrl.getParentCtrl(e.target);
        if (control) {
          control.fire(e.type, e);
        }
      }
      function mouseLeaveHandler() {
        var ctrl = eventRootCtrl._lastHoverCtrl;
        if (ctrl) {
          ctrl.fire('mouseleave', { target: ctrl.getEl() });
          ctrl.parents().each(function (ctrl) {
            ctrl.fire('mouseleave', { target: ctrl.getEl() });
          });
          eventRootCtrl._lastHoverCtrl = null;
        }
      }
      function mouseEnterHandler(e) {
        var ctrl = eventCtrl.getParentCtrl(e.target),
            lastCtrl = eventRootCtrl._lastHoverCtrl,
            idx = 0,
            i,
            parents,
            lastParents;
        if (ctrl !== lastCtrl) {
          eventRootCtrl._lastHoverCtrl = ctrl;
          parents = ctrl.parents().toArray().reverse();
          parents.push(ctrl);
          if (lastCtrl) {
            lastParents = lastCtrl.parents().toArray().reverse();
            lastParents.push(lastCtrl);
            for (idx = 0; idx < lastParents.length; idx++) {
              if (parents[idx] !== lastParents[idx]) {
                break;
              }
            }
            for (i = lastParents.length - 1; i >= idx; i--) {
              lastCtrl = lastParents[i];
              lastCtrl.fire('mouseleave', { target: lastCtrl.getEl() });
            }
          }
          for (i = idx; i < parents.length; i++) {
            ctrl = parents[i];
            ctrl.fire('mouseenter', { target: ctrl.getEl() });
          }
        }
      }
      function fixWheelEvent(e) {
        e.preventDefault();
        if (e.type === 'mousewheel') {
          e.deltaY = -1 / 40 * e.wheelDelta;
          if (e.wheelDeltaX) {
            e.deltaX = -1 / 40 * e.wheelDeltaX;
          }
        } else {
          e.deltaX = 0;
          e.deltaY = e.detail;
        }
        e = eventCtrl.fire('wheel', e);
      }
      nativeEvents = eventCtrl._nativeEvents;
      if (nativeEvents) {
        parents = eventCtrl.parents().toArray();
        parents.unshift(eventCtrl);
        for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
          eventRootCtrl = parents[i]._eventsRoot;
        }
        if (!eventRootCtrl) {
          eventRootCtrl = parents[parents.length - 1] || eventCtrl;
        }
        eventCtrl._eventsRoot = eventRootCtrl;
        for (l = i, i = 0; i < l; i++) {
          parents[i]._eventsRoot = eventRootCtrl;
        }
        var eventRootDelegates = eventRootCtrl._delegates;
        if (!eventRootDelegates) {
          eventRootDelegates = eventRootCtrl._delegates = {};
        }
        for (name$$1 in nativeEvents) {
          if (!nativeEvents) {
            return false;
          }
          if (name$$1 === 'wheel' && !hasWheelEventSupport) {
            if (hasMouseWheelEventSupport) {
              global$9(eventCtrl.getEl()).on('mousewheel', fixWheelEvent);
            } else {
              global$9(eventCtrl.getEl()).on('DOMMouseScroll', fixWheelEvent);
            }
            continue;
          }
          if (name$$1 === 'mouseenter' || name$$1 === 'mouseleave') {
            if (!eventRootCtrl._hasMouseEnter) {
              global$9(eventRootCtrl.getEl()).on('mouseleave', mouseLeaveHandler).on('mouseover', mouseEnterHandler);
              eventRootCtrl._hasMouseEnter = 1;
            }
          } else if (!eventRootDelegates[name$$1]) {
            global$9(eventRootCtrl.getEl()).on(name$$1, delegate);
            eventRootDelegates[name$$1] = true;
          }
          nativeEvents[name$$1] = false;
        }
      }
    }
    var Control$1 = Control;

    var hasTabstopData = function hasTabstopData(elm) {
      return elm.getAttribute('data-mce-tabstop') ? true : false;
    };
    function KeyboardNavigation(settings) {
      var root = settings.root;
      var focusedElement, focusedControl;
      function isElement(node) {
        return node && node.nodeType === 1;
      }
      try {
        focusedElement = document.activeElement;
      } catch (ex) {
        focusedElement = document.body;
      }
      focusedControl = root.getParentCtrl(focusedElement);
      function getRole(elm) {
        elm = elm || focusedElement;
        if (isElement(elm)) {
          return elm.getAttribute('role');
        }
        return null;
      }
      function getParentRole(elm) {
        var role,
            parent$$1 = elm || focusedElement;
        while (parent$$1 = parent$$1.parentNode) {
          if (role = getRole(parent$$1)) {
            return role;
          }
        }
      }
      function getAriaProp(name$$1) {
        var elm = focusedElement;
        if (isElement(elm)) {
          return elm.getAttribute('aria-' + name$$1);
        }
      }
      function isTextInputElement(elm) {
        var tagName = elm.tagName.toUpperCase();
        return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT';
      }
      function canFocus(elm) {
        if (isTextInputElement(elm) && !elm.hidden) {
          return true;
        }
        if (hasTabstopData(elm)) {
          return true;
        }
        if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(elm))) {
          return true;
        }
        return false;
      }
      function getFocusElements(elm) {
        var elements = [];
        function collect(elm) {
          if (elm.nodeType !== 1 || elm.style.display === 'none' || elm.disabled) {
            return;
          }
          if (canFocus(elm)) {
            elements.push(elm);
          }
          for (var i = 0; i < elm.childNodes.length; i++) {
            collect(elm.childNodes[i]);
          }
        }
        collect(elm || root.getEl());
        return elements;
      }
      function getNavigationRoot(targetControl) {
        var navigationRoot, controls;
        targetControl = targetControl || focusedControl;
        controls = targetControl.parents().toArray();
        controls.unshift(targetControl);
        for (var i = 0; i < controls.length; i++) {
          navigationRoot = controls[i];
          if (navigationRoot.settings.ariaRoot) {
            break;
          }
        }
        return navigationRoot;
      }
      function focusFirst(targetControl) {
        var navigationRoot = getNavigationRoot(targetControl);
        var focusElements = getFocusElements(navigationRoot.getEl());
        if (navigationRoot.settings.ariaRemember && 'lastAriaIndex' in navigationRoot) {
          moveFocusToIndex(navigationRoot.lastAriaIndex, focusElements);
        } else {
          moveFocusToIndex(0, focusElements);
        }
      }
      function moveFocusToIndex(idx, elements) {
        if (idx < 0) {
          idx = elements.length - 1;
        } else if (idx >= elements.length) {
          idx = 0;
        }
        if (elements[idx]) {
          elements[idx].focus();
        }
        return idx;
      }
      function moveFocus(dir, elements) {
        var idx = -1;
        var navigationRoot = getNavigationRoot();
        elements = elements || getFocusElements(navigationRoot.getEl());
        for (var i = 0; i < elements.length; i++) {
          if (elements[i] === focusedElement) {
            idx = i;
          }
        }
        idx += dir;
        navigationRoot.lastAriaIndex = moveFocusToIndex(idx, elements);
      }
      function left() {
        var parentRole = getParentRole();
        if (parentRole === 'tablist') {
          moveFocus(-1, getFocusElements(focusedElement.parentNode));
        } else if (focusedControl.parent().submenu) {
          cancel();
        } else {
          moveFocus(-1);
        }
      }
      function right() {
        var role = getRole(),
            parentRole = getParentRole();
        if (parentRole === 'tablist') {
          moveFocus(1, getFocusElements(focusedElement.parentNode));
        } else if (role === 'menuitem' && parentRole === 'menu' && getAriaProp('haspopup')) {
          enter();
        } else {
          moveFocus(1);
        }
      }
      function up() {
        moveFocus(-1);
      }
      function down() {
        var role = getRole(),
            parentRole = getParentRole();
        if (role === 'menuitem' && parentRole === 'menubar') {
          enter();
        } else if (role === 'button' && getAriaProp('haspopup')) {
          enter({ key: 'down' });
        } else {
          moveFocus(1);
        }
      }
      function tab(e) {
        var parentRole = getParentRole();
        if (parentRole === 'tablist') {
          var elm = getFocusElements(focusedControl.getEl('body'))[0];
          if (elm) {
            elm.focus();
          }
        } else {
          moveFocus(e.shiftKey ? -1 : 1);
        }
      }
      function cancel() {
        focusedControl.fire('cancel');
      }
      function enter(aria) {
        aria = aria || {};
        focusedControl.fire('click', {
          target: focusedElement,
          aria: aria
        });
      }
      root.on('keydown', function (e) {
        function handleNonTabOrEscEvent(e, handler) {
          if (isTextInputElement(focusedElement) || hasTabstopData(focusedElement)) {
            return;
          }
          if (getRole(focusedElement) === 'slider') {
            return;
          }
          if (handler(e) !== false) {
            e.preventDefault();
          }
        }
        if (e.isDefaultPrevented()) {
          return;
        }
        switch (e.keyCode) {
          case 37:
            handleNonTabOrEscEvent(e, left);
            break;
          case 39:
            handleNonTabOrEscEvent(e, right);
            break;
          case 38:
            handleNonTabOrEscEvent(e, up);
            break;
          case 40:
            handleNonTabOrEscEvent(e, down);
            break;
          case 27:
            cancel();
            break;
          case 14:
          case 13:
          case 32:
            handleNonTabOrEscEvent(e, enter);
            break;
          case 9:
            tab(e);
            e.preventDefault();
            break;
        }
      });
      root.on('focusin', function (e) {
        focusedElement = e.target;
        focusedControl = e.control;
      });
      return { focusFirst: focusFirst };
    }

    var selectorCache = {};
    var Container = Control$1.extend({
      init: function init(settings) {
        var self = this;
        self._super(settings);
        settings = self.settings;
        if (settings.fixed) {
          self.state.set('fixed', true);
        }
        self._items = new Collection$2();
        if (self.isRtl()) {
          self.classes.add('rtl');
        }
        self.bodyClasses = new ClassList(function () {
          if (self.state.get('rendered')) {
            self.getEl('body').className = this.toString();
          }
        });
        self.bodyClasses.prefix = self.classPrefix;
        self.classes.add('container');
        self.bodyClasses.add('container-body');
        if (settings.containerCls) {
          self.classes.add(settings.containerCls);
        }
        self._layout = global$4.create((settings.layout || '') + 'layout');
        if (self.settings.items) {
          self.add(self.settings.items);
        } else {
          self.add(self.render());
        }
        self._hasBody = true;
      },
      items: function items() {
        return this._items;
      },
      find: function find(selector) {
        selector = selectorCache[selector] = selectorCache[selector] || new Selector(selector);
        return selector.find(this);
      },
      add: function add(items) {
        var self = this;
        self.items().add(self.create(items)).parent(self);
        return self;
      },
      focus: function focus(keyboard) {
        var self = this;
        var focusCtrl, keyboardNav, items;
        if (keyboard) {
          keyboardNav = self.keyboardNav || self.parents().eq(-1)[0].keyboardNav;
          if (keyboardNav) {
            keyboardNav.focusFirst(self);
            return;
          }
        }
        items = self.find('*');
        if (self.statusbar) {
          items.add(self.statusbar.items());
        }
        items.each(function (ctrl) {
          if (ctrl.settings.autofocus) {
            focusCtrl = null;
            return false;
          }
          if (ctrl.canFocus) {
            focusCtrl = focusCtrl || ctrl;
          }
        });
        if (focusCtrl) {
          focusCtrl.focus();
        }
        return self;
      },
      replace: function replace(oldItem, newItem) {
        var ctrlElm;
        var items = this.items();
        var i = items.length;
        while (i--) {
          if (items[i] === oldItem) {
            items[i] = newItem;
            break;
          }
        }
        if (i >= 0) {
          ctrlElm = newItem.getEl();
          if (ctrlElm) {
            ctrlElm.parentNode.removeChild(ctrlElm);
          }
          ctrlElm = oldItem.getEl();
          if (ctrlElm) {
            ctrlElm.parentNode.removeChild(ctrlElm);
          }
        }
        newItem.parent(this);
      },
      create: function create(items) {
        var self = this;
        var settings;
        var ctrlItems = [];
        if (!global$2.isArray(items)) {
          items = [items];
        }
        global$2.each(items, function (item) {
          if (item) {
            if (!(item instanceof Control$1)) {
              if (typeof item === 'string') {
                item = { type: item };
              }
              settings = global$2.extend({}, self.settings.defaults, item);
              item.type = settings.type = settings.type || item.type || self.settings.defaultType || (settings.defaults ? settings.defaults.type : null);
              item = global$4.create(settings);
            }
            ctrlItems.push(item);
          }
        });
        return ctrlItems;
      },
      renderNew: function renderNew() {
        var self = this;
        self.items().each(function (ctrl, index) {
          var containerElm;
          ctrl.parent(self);
          if (!ctrl.state.get('rendered')) {
            containerElm = self.getEl('body');
            if (containerElm.hasChildNodes() && index <= containerElm.childNodes.length - 1) {
              global$9(containerElm.childNodes[index]).before(ctrl.renderHtml());
            } else {
              global$9(containerElm).append(ctrl.renderHtml());
            }
            ctrl.postRender();
            $_6bivibuxjk26xn6n.add(ctrl);
          }
        });
        self._layout.applyClasses(self.items().filter(':visible'));
        self._lastRect = null;
        return self;
      },
      append: function append(items) {
        return this.add(items).renderNew();
      },
      prepend: function prepend(items) {
        var self = this;
        self.items().set(self.create(items).concat(self.items().toArray()));
        return self.renderNew();
      },
      insert: function insert(items, index, before) {
        var self = this;
        var curItems, beforeItems, afterItems;
        items = self.create(items);
        curItems = self.items();
        if (!before && index < curItems.length - 1) {
          index += 1;
        }
        if (index >= 0 && index < curItems.length) {
          beforeItems = curItems.slice(0, index).toArray();
          afterItems = curItems.slice(index).toArray();
          curItems.set(beforeItems.concat(items, afterItems));
        }
        return self.renderNew();
      },
      fromJSON: function fromJSON(data) {
        var self = this;
        for (var name in data) {
          self.find('#' + name).value(data[name]);
        }
        return self;
      },
      toJSON: function toJSON() {
        var self = this,
            data = {};
        self.find('*').each(function (ctrl) {
          var name = ctrl.name(),
              value = ctrl.value();
          if (name && typeof value !== 'undefined') {
            data[name] = value;
          }
        });
        return data;
      },
      renderHtml: function renderHtml() {
        var self = this,
            layout = self._layout,
            role = this.settings.role;
        self.preRender();
        layout.preRender(self);
        return '<div id="' + self._id + '" class="' + self.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
      },
      postRender: function postRender() {
        var self = this;
        var box;
        self.items().exec('postRender');
        self._super();
        self._layout.postRender(self);
        self.state.set('rendered', true);
        if (self.settings.style) {
          self.$el.css(self.settings.style);
        }
        if (self.settings.border) {
          box = self.borderBox;
          self.$el.css({
            'border-top-width': box.top,
            'border-right-width': box.right,
            'border-bottom-width': box.bottom,
            'border-left-width': box.left
          });
        }
        if (!self.parent()) {
          self.keyboardNav = KeyboardNavigation({ root: self });
        }
        return self;
      },
      initLayoutRect: function initLayoutRect() {
        var self = this,
            layoutRect = self._super();
        self._layout.recalc(self);
        return layoutRect;
      },
      recalc: function recalc() {
        var self = this;
        var rect = self._layoutRect;
        var lastRect = self._lastRect;
        if (!lastRect || lastRect.w !== rect.w || lastRect.h !== rect.h) {
          self._layout.recalc(self);
          rect = self.layoutRect();
          self._lastRect = {
            x: rect.x,
            y: rect.y,
            w: rect.w,
            h: rect.h
          };
          return true;
        }
      },
      reflow: function reflow() {
        var i;
        $_6bivibuxjk26xn6n.remove(this);
        if (this.visible()) {
          Control$1.repaintControls = [];
          Control$1.repaintControls.map = {};
          this.recalc();
          i = Control$1.repaintControls.length;
          while (i--) {
            Control$1.repaintControls[i].repaint();
          }
          if (this.settings.layout !== 'flow' && this.settings.layout !== 'stack') {
            this.repaint();
          }
          Control$1.repaintControls = [];
        }
        return this;
      }
    });

    function getDocumentSize(doc) {
      var documentElement, body, scrollWidth, clientWidth;
      var offsetWidth, scrollHeight, clientHeight, offsetHeight;
      var max = Math.max;
      documentElement = doc.documentElement;
      body = doc.body;
      scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
      clientWidth = max(documentElement.clientWidth, body.clientWidth);
      offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
      scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
      clientHeight = max(documentElement.clientHeight, body.clientHeight);
      offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
      return {
        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
      };
    }
    function updateWithTouchData(e) {
      var keys, i;
      if (e.changedTouches) {
        keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
        for (i = 0; i < keys.length; i++) {
          e[keys[i]] = e.changedTouches[0][keys[i]];
        }
      }
    }
    function DragHelper(id, settings) {
      var $eventOverlay;
      var doc = settings.document || document;
      var downButton;
      var start, _stop$$, drag, startX, startY;
      settings = settings || {};
      var handleElement = doc.getElementById(settings.handle || id);
      start = function start(e) {
        var docSize = getDocumentSize(doc);
        var handleElm, cursor;
        updateWithTouchData(e);
        e.preventDefault();
        downButton = e.button;
        handleElm = handleElement;
        startX = e.screenX;
        startY = e.screenY;
        if (window.getComputedStyle) {
          cursor = window.getComputedStyle(handleElm, null).getPropertyValue('cursor');
        } else {
          cursor = handleElm.runtimeStyle.cursor;
        }
        $eventOverlay = global$9('<div></div>').css({
          position: 'absolute',
          top: 0,
          left: 0,
          width: docSize.width,
          height: docSize.height,
          zIndex: 2147483647,
          opacity: 0.0001,
          cursor: cursor
        }).appendTo(doc.body);
        global$9(doc).on('mousemove touchmove', drag).on('mouseup touchend', _stop$$);
        settings.start(e);
      };
      drag = function drag(e) {
        updateWithTouchData(e);
        if (e.button !== downButton) {
          return _stop$$(e);
        }
        e.deltaX = e.screenX - startX;
        e.deltaY = e.screenY - startY;
        e.preventDefault();
        settings.drag(e);
      };
      _stop$$ = function stop$$1(e) {
        updateWithTouchData(e);
        global$9(doc).off('mousemove touchmove', drag).off('mouseup touchend', _stop$$);
        $eventOverlay.remove();
        if (settings.stop) {
          settings.stop(e);
        }
      };
      this.destroy = function () {
        global$9(handleElement).off();
      };
      global$9(handleElement).on('mousedown touchstart', start);
    }

    var $_g9fk2uuzjk26xn6v = {
      init: function init() {
        var self = this;
        self.on('repaint', self.renderScroll);
      },
      renderScroll: function renderScroll() {
        var self = this,
            margin = 2;
        function repaintScroll() {
          var hasScrollH, hasScrollV, bodyElm;
          function repaintAxis(axisName, posName, sizeName, contentSizeName, hasScroll, ax) {
            var containerElm, scrollBarElm, scrollThumbElm;
            var containerSize, scrollSize, ratio, rect;
            var posNameLower, sizeNameLower;
            scrollBarElm = self.getEl('scroll' + axisName);
            if (scrollBarElm) {
              posNameLower = posName.toLowerCase();
              sizeNameLower = sizeName.toLowerCase();
              global$9(self.getEl('absend')).css(posNameLower, self.layoutRect()[contentSizeName] - 1);
              if (!hasScroll) {
                global$9(scrollBarElm).css('display', 'none');
                return;
              }
              global$9(scrollBarElm).css('display', 'block');
              containerElm = self.getEl('body');
              scrollThumbElm = self.getEl('scroll' + axisName + 't');
              containerSize = containerElm['client' + sizeName] - margin * 2;
              containerSize -= hasScrollH && hasScrollV ? scrollBarElm['client' + ax] : 0;
              scrollSize = containerElm['scroll' + sizeName];
              ratio = containerSize / scrollSize;
              rect = {};
              rect[posNameLower] = containerElm['offset' + posName] + margin;
              rect[sizeNameLower] = containerSize;
              global$9(scrollBarElm).css(rect);
              rect = {};
              rect[posNameLower] = containerElm['scroll' + posName] * ratio;
              rect[sizeNameLower] = containerSize * ratio;
              global$9(scrollThumbElm).css(rect);
            }
          }
          bodyElm = self.getEl('body');
          hasScrollH = bodyElm.scrollWidth > bodyElm.clientWidth;
          hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
          repaintAxis('h', 'Left', 'Width', 'contentW', hasScrollH, 'Height');
          repaintAxis('v', 'Top', 'Height', 'contentH', hasScrollV, 'Width');
        }
        function addScroll() {
          function addScrollAxis(axisName, posName, sizeName, deltaPosName, ax) {
            var scrollStart;
            var axisId = self._id + '-scroll' + axisName,
                prefix = self.classPrefix;
            global$9(self.getEl()).append('<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + axisName + '">' + '<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' + '</div>');
            self.draghelper = new DragHelper(axisId + 't', {
              start: function start() {
                scrollStart = self.getEl('body')['scroll' + posName];
                global$9('#' + axisId).addClass(prefix + 'active');
              },
              drag: function drag(e) {
                var ratio, hasScrollH, hasScrollV, containerSize;
                var layoutRect = self.layoutRect();
                hasScrollH = layoutRect.contentW > layoutRect.innerW;
                hasScrollV = layoutRect.contentH > layoutRect.innerH;
                containerSize = self.getEl('body')['client' + sizeName] - margin * 2;
                containerSize -= hasScrollH && hasScrollV ? self.getEl('scroll' + axisName)['client' + ax] : 0;
                ratio = containerSize / self.getEl('body')['scroll' + sizeName];
                self.getEl('body')['scroll' + posName] = scrollStart + e['delta' + deltaPosName] / ratio;
              },
              stop: function stop() {
                global$9('#' + axisId).removeClass(prefix + 'active');
              }
            });
          }
          self.classes.add('scroll');
          addScrollAxis('v', 'Top', 'Height', 'Y', 'Width');
          addScrollAxis('h', 'Left', 'Width', 'X', 'Height');
        }
        if (self.settings.autoScroll) {
          if (!self._hasScroll) {
            self._hasScroll = true;
            addScroll();
            self.on('wheel', function (e) {
              var bodyEl = self.getEl('body');
              bodyEl.scrollLeft += (e.deltaX || 0) * 10;
              bodyEl.scrollTop += e.deltaY * 10;
              repaintScroll();
            });
            global$9(self.getEl('body')).on('scroll', repaintScroll);
          }
          repaintScroll();
        }
      }
    };

    var Panel = Container.extend({
      Defaults: {
        layout: 'fit',
        containerCls: 'panel'
      },
      Mixins: [$_g9fk2uuzjk26xn6v],
      renderHtml: function renderHtml() {
        var self = this;
        var layout = self._layout;
        var innerHtml = self.settings.html;
        self.preRender();
        layout.preRender(self);
        if (typeof innerHtml === 'undefined') {
          innerHtml = '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>';
        } else {
          if (typeof innerHtml === 'function') {
            innerHtml = innerHtml.call(self);
          }
          self._hasBody = false;
        }
        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1" role="group">' + (self._preBodyHtml || '') + innerHtml + '</div>';
      }
    });

    var $_cgv29mv1jk26xn72 = {
      resizeToContent: function resizeToContent() {
        this._layoutRect.autoResize = true;
        this._lastRect = null;
        this.reflow();
      },
      resizeTo: function resizeTo(w, h) {
        if (w <= 1 || h <= 1) {
          var rect = funcs.getWindowSize();
          w = w <= 1 ? w * rect.w : w;
          h = h <= 1 ? h * rect.h : h;
        }
        this._layoutRect.autoResize = false;
        return this.layoutRect({
          minW: w,
          minH: h,
          w: w,
          h: h
        }).reflow();
      },
      resizeBy: function resizeBy(dw, dh) {
        var self = this,
            rect = self.layoutRect();
        return self.resizeTo(rect.w + dw, rect.h + dh);
      }
    };

    var documentClickHandler;
    var documentScrollHandler;
    var windowResizeHandler;
    var visiblePanels = [];
    var zOrder = [];
    var hasModal;
    function isChildOf(ctrl, parent$$1) {
      while (ctrl) {
        if (ctrl === parent$$1) {
          return true;
        }
        ctrl = ctrl.parent();
      }
    }
    function skipOrHidePanels(e) {
      var i = visiblePanels.length;
      while (i--) {
        var panel = visiblePanels[i],
            clickCtrl = panel.getParentCtrl(e.target);
        if (panel.settings.autohide) {
          if (clickCtrl) {
            if (isChildOf(clickCtrl, panel) || panel.parent() === clickCtrl) {
              continue;
            }
          }
          e = panel.fire('autohide', { target: e.target });
          if (!e.isDefaultPrevented()) {
            panel.hide();
          }
        }
      }
    }
    function bindDocumentClickHandler() {
      if (!documentClickHandler) {
        documentClickHandler = function documentClickHandler(e) {
          if (e.button === 2) {
            return;
          }
          skipOrHidePanels(e);
        };
        global$9(document).on('click touchstart', documentClickHandler);
      }
    }
    function bindDocumentScrollHandler() {
      if (!documentScrollHandler) {
        documentScrollHandler = function documentScrollHandler() {
          var i;
          i = visiblePanels.length;
          while (i--) {
            repositionPanel(visiblePanels[i]);
          }
        };
        global$9(window).on('scroll', documentScrollHandler);
      }
    }
    function bindWindowResizeHandler() {
      if (!windowResizeHandler) {
        var docElm_1 = document.documentElement;
        var clientWidth_1 = docElm_1.clientWidth,
            clientHeight_1 = docElm_1.clientHeight;
        windowResizeHandler = function windowResizeHandler() {
          if (!document.all || clientWidth_1 !== docElm_1.clientWidth || clientHeight_1 !== docElm_1.clientHeight) {
            clientWidth_1 = docElm_1.clientWidth;
            clientHeight_1 = docElm_1.clientHeight;
            FloatPanel.hideAll();
          }
        };
        global$9(window).on('resize', windowResizeHandler);
      }
    }
    function repositionPanel(panel) {
      var scrollY$$1 = funcs.getViewPort().y;
      function toggleFixedChildPanels(fixed, deltaY) {
        var parent$$1;
        for (var i = 0; i < visiblePanels.length; i++) {
          if (visiblePanels[i] !== panel) {
            parent$$1 = visiblePanels[i].parent();
            while (parent$$1 && (parent$$1 = parent$$1.parent())) {
              if (parent$$1 === panel) {
                visiblePanels[i].fixed(fixed).moveBy(0, deltaY).repaint();
              }
            }
          }
        }
      }
      if (panel.settings.autofix) {
        if (!panel.state.get('fixed')) {
          panel._autoFixY = panel.layoutRect().y;
          if (panel._autoFixY < scrollY$$1) {
            panel.fixed(true).layoutRect({ y: 0 }).repaint();
            toggleFixedChildPanels(true, scrollY$$1 - panel._autoFixY);
          }
        } else {
          if (panel._autoFixY > scrollY$$1) {
            panel.fixed(false).layoutRect({ y: panel._autoFixY }).repaint();
            toggleFixedChildPanels(false, panel._autoFixY - scrollY$$1);
          }
        }
      }
    }
    function addRemove(add, ctrl) {
      var i,
          zIndex = FloatPanel.zIndex || 65535,
          topModal;
      if (add) {
        zOrder.push(ctrl);
      } else {
        i = zOrder.length;
        while (i--) {
          if (zOrder[i] === ctrl) {
            zOrder.splice(i, 1);
          }
        }
      }
      if (zOrder.length) {
        for (i = 0; i < zOrder.length; i++) {
          if (zOrder[i].modal) {
            zIndex++;
            topModal = zOrder[i];
          }
          zOrder[i].getEl().style.zIndex = zIndex;
          zOrder[i].zIndex = zIndex;
          zIndex++;
        }
      }
      var modalBlockEl = global$9('#' + ctrl.classPrefix + 'modal-block', ctrl.getContainerElm())[0];
      if (topModal) {
        global$9(modalBlockEl).css('z-index', topModal.zIndex - 1);
      } else if (modalBlockEl) {
        modalBlockEl.parentNode.removeChild(modalBlockEl);
        hasModal = false;
      }
      FloatPanel.currentZIndex = zIndex;
    }
    var FloatPanel = Panel.extend({
      Mixins: [$_63b1h8ukjk26xn4v, $_cgv29mv1jk26xn72],
      init: function init(settings) {
        var self$$1 = this;
        self$$1._super(settings);
        self$$1._eventsRoot = self$$1;
        self$$1.classes.add('floatpanel');
        if (settings.autohide) {
          bindDocumentClickHandler();
          bindWindowResizeHandler();
          visiblePanels.push(self$$1);
        }
        if (settings.autofix) {
          bindDocumentScrollHandler();
          self$$1.on('move', function () {
            repositionPanel(this);
          });
        }
        self$$1.on('postrender show', function (e) {
          if (e.control === self$$1) {
            var $modalBlockEl_1;
            var prefix_1 = self$$1.classPrefix;
            if (self$$1.modal && !hasModal) {
              $modalBlockEl_1 = global$9('#' + prefix_1 + 'modal-block', self$$1.getContainerElm());
              if (!$modalBlockEl_1[0]) {
                $modalBlockEl_1 = global$9('<div id="' + prefix_1 + 'modal-block" class="' + prefix_1 + 'reset ' + prefix_1 + 'fade"></div>').appendTo(self$$1.getContainerElm());
              }
              global$7.setTimeout(function () {
                $modalBlockEl_1.addClass(prefix_1 + 'in');
                global$9(self$$1.getEl()).addClass(prefix_1 + 'in');
              });
              hasModal = true;
            }
            addRemove(true, self$$1);
          }
        });
        self$$1.on('show', function () {
          self$$1.parents().each(function (ctrl) {
            if (ctrl.state.get('fixed')) {
              self$$1.fixed(true);
              return false;
            }
          });
        });
        if (settings.popover) {
          self$$1._preBodyHtml = '<div class="' + self$$1.classPrefix + 'arrow"></div>';
          self$$1.classes.add('popover').add('bottom').add(self$$1.isRtl() ? 'end' : 'start');
        }
        self$$1.aria('label', settings.ariaLabel);
        self$$1.aria('labelledby', self$$1._id);
        self$$1.aria('describedby', self$$1.describedBy || self$$1._id + '-none');
      },
      fixed: function fixed(state) {
        var self$$1 = this;
        if (self$$1.state.get('fixed') !== state) {
          if (self$$1.state.get('rendered')) {
            var viewport = funcs.getViewPort();
            if (state) {
              self$$1.layoutRect().y -= viewport.y;
            } else {
              self$$1.layoutRect().y += viewport.y;
            }
          }
          self$$1.classes.toggle('fixed', state);
          self$$1.state.set('fixed', state);
        }
        return self$$1;
      },
      show: function show() {
        var self$$1 = this;
        var i;
        var state = self$$1._super();
        i = visiblePanels.length;
        while (i--) {
          if (visiblePanels[i] === self$$1) {
            break;
          }
        }
        if (i === -1) {
          visiblePanels.push(self$$1);
        }
        return state;
      },
      hide: function hide() {
        removeVisiblePanel(this);
        addRemove(false, this);
        return this._super();
      },
      hideAll: function hideAll() {
        FloatPanel.hideAll();
      },
      close: function close() {
        var self$$1 = this;
        if (!self$$1.fire('close').isDefaultPrevented()) {
          self$$1.remove();
          addRemove(false, self$$1);
        }
        return self$$1;
      },
      remove: function remove() {
        removeVisiblePanel(this);
        this._super();
      },
      postRender: function postRender() {
        var self$$1 = this;
        if (self$$1.settings.bodyRole) {
          this.getEl('body').setAttribute('role', self$$1.settings.bodyRole);
        }
        return self$$1._super();
      }
    });
    FloatPanel.hideAll = function () {
      var i = visiblePanels.length;
      while (i--) {
        var panel = visiblePanels[i];
        if (panel && panel.settings.autohide) {
          panel.hide();
          visiblePanels.splice(i, 1);
        }
      }
    };
    function removeVisiblePanel(panel) {
      var i;
      i = visiblePanels.length;
      while (i--) {
        if (visiblePanels[i] === panel) {
          visiblePanels.splice(i, 1);
        }
      }
      i = zOrder.length;
      while (i--) {
        if (zOrder[i] === panel) {
          zOrder.splice(i, 1);
        }
      }
    }

    var isFixed$1 = function isFixed$1(inlineToolbarContainer, editor) {
      return !!(inlineToolbarContainer && !editor.settings.ui_container);
    };
    var render$1 = function render$1(editor, theme, args) {
      var panel, inlineToolbarContainer;
      var DOM = global$3.DOM;
      var fixedToolbarContainer = getFixedToolbarContainer(editor);
      if (fixedToolbarContainer) {
        inlineToolbarContainer = DOM.select(fixedToolbarContainer)[0];
      }
      var reposition = function reposition() {
        if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
          var scrollContainer = editor.selection.getScrollContainer(),
              body = editor.getBody();
          var deltaX = 0,
              deltaY = 0;
          if (scrollContainer) {
            var bodyPos = DOM.getPos(body),
                scrollContainerPos = DOM.getPos(scrollContainer);
            deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
            deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
          }
          panel.fixed(false).moveRel(body, editor.rtl ? ['tr-br', 'br-tr'] : ['tl-bl', 'bl-tl', 'tr-br']).moveBy(deltaX, deltaY);
        }
      };
      var show = function show() {
        if (panel) {
          panel.show();
          reposition();
          DOM.addClass(editor.getBody(), 'mce-edit-focus');
        }
      };
      var hide = function hide() {
        if (panel) {
          panel.hide();
          FloatPanel.hideAll();
          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
        }
      };
      var render = function render() {
        if (panel) {
          if (!panel.visible()) {
            show();
          }
          return;
        }
        panel = theme.panel = global$4.create({
          type: inlineToolbarContainer ? 'panel' : 'floatpanel',
          role: 'application',
          classes: 'tinymce tinymce-inline',
          layout: 'flex',
          direction: 'column',
          align: 'stretch',
          autohide: false,
          autofix: isFixed$1(inlineToolbarContainer, editor),
          fixed: isFixed$1(inlineToolbarContainer, editor),
          border: 1,
          items: [hasMenubar(editor) === false ? null : {
            type: 'menubar',
            border: '0 0 1 0',
            items: $_g65cxcu8jk26xn33.createMenuButtons(editor)
          }, $_deb7gou7jk26xn2z.createToolbars(editor, getToolbarSize(editor))]
        });
        $_596xbmu4jk26xn2q.setUiContainer(editor, panel);
        $_cueeiltzjk26xn2b.fireBeforeRenderUI(editor);
        if (inlineToolbarContainer) {
          panel.renderTo(inlineToolbarContainer).reflow();
        } else {
          panel.renderTo().reflow();
        }
        $_999l6lu0jk26xn2h.addKeys(editor, panel);
        show();
        $_6w23vnu1jk26xn2k.addContextualToolbars(editor);
        editor.on('nodeChange', reposition);
        editor.on('ResizeWindow', reposition);
        editor.on('activate', show);
        editor.on('deactivate', hide);
        editor.nodeChanged();
      };
      editor.settings.content_editable = true;
      editor.on('focus', function () {
        if (isSkinDisabled(editor) === false && args.skinUiCss) {
          DOM.styleSheetLoader.load(args.skinUiCss, render, render);
        } else {
          render();
        }
      });
      editor.on('blur hide', hide);
      editor.on('remove', function () {
        if (panel) {
          panel.remove();
          panel = null;
        }
      });
      if (isSkinDisabled(editor) === false && args.skinUiCss) {
        DOM.styleSheetLoader.load(args.skinUiCss, $_gj1v4juejk26xn3l.fireSkinLoaded(editor));
      } else {
        $_gj1v4juejk26xn3l.fireSkinLoaded(editor)();
      }
      return {};
    };
    var $_52k7awufjk26xn3n = { render: render$1 };

    function Throbber(elm, inline) {
      var self = this;
      var state;
      var classPrefix = Control$1.classPrefix;
      var timer;
      self.show = function (time, callback) {
        function render() {
          if (state) {
            global$9(elm).append('<div class="' + classPrefix + 'throbber' + (inline ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>');
            if (callback) {
              callback();
            }
          }
        }
        self.hide();
        state = true;
        if (time) {
          timer = global$7.setTimeout(render, time);
        } else {
          render();
        }
        return self;
      };
      self.hide = function () {
        var child = elm.lastChild;
        global$7.clearTimeout(timer);
        if (child && child.className.indexOf('throbber') !== -1) {
          child.parentNode.removeChild(child);
        }
        state = false;
        return self;
      };
    }

    var setup = function setup(editor, theme) {
      var throbber;
      editor.on('ProgressState', function (e) {
        throbber = throbber || new Throbber(theme.panel.getEl('body'));
        if (e.state) {
          throbber.show(e.time);
        } else {
          throbber.hide();
        }
      });
    };
    var $_dk4pojv2jk26xn74 = { setup: setup };

    var renderUI = function renderUI(editor, theme, args) {
      var skinUrl = getSkinUrl(editor);
      if (skinUrl) {
        args.skinUiCss = skinUrl + '/skin.min.css';
        editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
      }
      $_dk4pojv2jk26xn74.setup(editor, theme);
      return isInline(editor) ? $_52k7awufjk26xn3n.render(editor, theme, args) : $_1grd53tvjk26xn27.render(editor, theme, args);
    };
    var $_5bzl2atrjk26xn21 = { renderUI: renderUI };

    var Tooltip = Control$1.extend({
      Mixins: [$_63b1h8ukjk26xn4v],
      Defaults: { classes: 'widget tooltip tooltip-n' },
      renderHtml: function renderHtml() {
        var self = this,
            prefix = self.classPrefix;
        return '<div id="' + self._id + '" class="' + self.classes + '" role="presentation">' + '<div class="' + prefix + 'tooltip-arrow"></div>' + '<div class="' + prefix + 'tooltip-inner">' + self.encode(self.state.get('text')) + '</div>' + '</div>';
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:text', function (e) {
          self.getEl().lastChild.innerHTML = self.encode(e.value);
        });
        return self._super();
      },
      repaint: function repaint() {
        var self = this;
        var style, rect;
        style = self.getEl().style;
        rect = self._layoutRect;
        style.left = rect.x + 'px';
        style.top = rect.y + 'px';
        style.zIndex = 65535 + 65535;
      }
    });

    var Widget = Control$1.extend({
      init: function init(settings) {
        var self = this;
        self._super(settings);
        settings = self.settings;
        self.canFocus = true;
        if (settings.tooltip && Widget.tooltips !== false) {
          self.on('mouseenter', function (e) {
            var tooltip = self.tooltip().moveTo(-65535);
            if (e.control === self) {
              var rel = tooltip.text(settings.tooltip).show().testMoveRel(self.getEl(), ['bc-tc', 'bc-tl', 'bc-tr']);
              tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
              tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
              tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
              tooltip.moveRel(self.getEl(), rel);
            } else {
              tooltip.hide();
            }
          });
          self.on('mouseleave mousedown click', function () {
            self.tooltip().remove();
            self._tooltip = null;
          });
        }
        self.aria('label', settings.ariaLabel || settings.tooltip);
      },
      tooltip: function tooltip() {
        if (!this._tooltip) {
          this._tooltip = new Tooltip({ type: 'tooltip' });
          $_596xbmu4jk26xn2q.inheritUiContainer(this, this._tooltip);
          this._tooltip.renderTo();
        }
        return this._tooltip;
      },
      postRender: function postRender() {
        var self = this,
            settings = self.settings;
        self._super();
        if (!self.parent() && (settings.width || settings.height)) {
          self.initLayoutRect();
          self.repaint();
        }
        if (settings.autofocus) {
          self.focus();
        }
      },
      bindStates: function bindStates() {
        var self = this;
        function disable(state) {
          self.aria('disabled', state);
          self.classes.toggle('disabled', state);
        }
        function active(state) {
          self.aria('pressed', state);
          self.classes.toggle('active', state);
        }
        self.state.on('change:disabled', function (e) {
          disable(e.value);
        });
        self.state.on('change:active', function (e) {
          active(e.value);
        });
        if (self.state.get('disabled')) {
          disable(true);
        }
        if (self.state.get('active')) {
          active(true);
        }
        return self._super();
      },
      remove: function remove() {
        this._super();
        if (this._tooltip) {
          this._tooltip.remove();
          this._tooltip = null;
        }
      }
    });

    var Progress = Widget.extend({
      Defaults: { value: 0 },
      init: function init(settings) {
        var self = this;
        self._super(settings);
        self.classes.add('progress');
        if (!self.settings.filter) {
          self.settings.filter = function (value) {
            return Math.round(value);
          };
        }
      },
      renderHtml: function renderHtml() {
        var self = this,
            id = self._id,
            prefix = this.classPrefix;
        return '<div id="' + id + '" class="' + self.classes + '">' + '<div class="' + prefix + 'bar-container">' + '<div class="' + prefix + 'bar"></div>' + '</div>' + '<div class="' + prefix + 'text">0%</div>' + '</div>';
      },
      postRender: function postRender() {
        var self = this;
        self._super();
        self.value(self.settings.value);
        return self;
      },
      bindStates: function bindStates() {
        var self = this;
        function setValue(value) {
          value = self.settings.filter(value);
          self.getEl().lastChild.innerHTML = value + '%';
          self.getEl().firstChild.firstChild.style.width = value + '%';
        }
        self.state.on('change:value', function (e) {
          setValue(e.value);
        });
        setValue(self.state.get('value'));
        return self._super();
      }
    });

    var updateLiveRegion = function updateLiveRegion(ctx, text) {
      ctx.getEl().lastChild.textContent = text + (ctx.progressBar ? ' ' + ctx.progressBar.value() + '%' : '');
    };
    var Notification = Control$1.extend({
      Mixins: [$_63b1h8ukjk26xn4v],
      Defaults: { classes: 'widget notification' },
      init: function init(settings) {
        var self = this;
        self._super(settings);
        self.maxWidth = settings.maxWidth;
        if (settings.text) {
          self.text(settings.text);
        }
        if (settings.icon) {
          self.icon = settings.icon;
        }
        if (settings.color) {
          self.color = settings.color;
        }
        if (settings.type) {
          self.classes.add('notification-' + settings.type);
        }
        if (settings.timeout && (settings.timeout < 0 || settings.timeout > 0) && !settings.closeButton) {
          self.closeButton = false;
        } else {
          self.classes.add('has-close');
          self.closeButton = true;
        }
        if (settings.progressBar) {
          self.progressBar = new Progress();
        }
        self.on('click', function (e) {
          if (e.target.className.indexOf(self.classPrefix + 'close') !== -1) {
            self.close();
          }
        });
      },
      renderHtml: function renderHtml() {
        var self = this;
        var prefix = self.classPrefix;
        var icon = '',
            closeButton = '',
            progressBar = '',
            notificationStyle = '';
        if (self.icon) {
          icon = '<i class="' + prefix + 'ico' + ' ' + prefix + 'i-' + self.icon + '"></i>';
        }
        notificationStyle = ' style="max-width: ' + self.maxWidth + 'px;' + (self.color ? 'background-color: ' + self.color + ';"' : '"');
        if (self.closeButton) {
          closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">\xD7</button>';
        }
        if (self.progressBar) {
          progressBar = self.progressBar.renderHtml();
        }
        return '<div id="' + self._id + '" class="' + self.classes + '"' + notificationStyle + ' role="presentation">' + icon + '<div class="' + prefix + 'notification-inner">' + self.state.get('text') + '</div>' + progressBar + closeButton + '<div style="clip: rect(1px, 1px, 1px, 1px);height: 1px;overflow: hidden;position: absolute;width: 1px;"' + ' aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>' + '</div>';
      },
      postRender: function postRender() {
        var self = this;
        global$7.setTimeout(function () {
          self.$el.addClass(self.classPrefix + 'in');
          updateLiveRegion(self, self.state.get('text'));
        }, 100);
        return self._super();
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:text', function (e) {
          self.getEl().firstChild.innerHTML = e.value;
          updateLiveRegion(self, e.value);
        });
        if (self.progressBar) {
          self.progressBar.bindStates();
          self.progressBar.state.on('change:value', function (e) {
            updateLiveRegion(self, self.state.get('text'));
          });
        }
        return self._super();
      },
      close: function close() {
        var self = this;
        if (!self.fire('close').isDefaultPrevented()) {
          self.remove();
        }
        return self;
      },
      repaint: function repaint() {
        var self = this;
        var style, rect;
        style = self.getEl().style;
        rect = self._layoutRect;
        style.left = rect.x + 'px';
        style.top = rect.y + 'px';
        style.zIndex = 65535 - 1;
      }
    });

    function NotificationManagerImpl(editor) {
      var getEditorContainer = function getEditorContainer(editor) {
        return editor.inline ? editor.getElement() : editor.getContentAreaContainer();
      };
      var getContainerWidth = function getContainerWidth() {
        var container = getEditorContainer(editor);
        return funcs.getSize(container).width;
      };
      var prePositionNotifications = function prePositionNotifications(notifications) {
        each(notifications, function (notification) {
          notification.moveTo(0, 0);
        });
      };
      var positionNotifications = function positionNotifications(notifications) {
        if (notifications.length > 0) {
          var firstItem = notifications.slice(0, 1)[0];
          var container = getEditorContainer(editor);
          firstItem.moveRel(container, 'tc-tc');
          each(notifications, function (notification, index) {
            if (index > 0) {
              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
            }
          });
        }
      };
      var reposition = function reposition(notifications) {
        prePositionNotifications(notifications);
        positionNotifications(notifications);
      };
      var open = function open(args, closeCallback) {
        var extendedArgs = global$2.extend(args, { maxWidth: getContainerWidth() });
        var notif = new Notification(extendedArgs);
        notif.args = extendedArgs;
        if (extendedArgs.timeout > 0) {
          notif.timer = setTimeout(function () {
            notif.close();
            closeCallback();
          }, extendedArgs.timeout);
        }
        notif.on('close', function () {
          closeCallback();
        });
        notif.renderTo();
        return notif;
      };
      var close = function close(notification) {
        notification.close();
      };
      var getArgs = function getArgs(notification) {
        return notification.args;
      };
      return {
        open: open,
        close: close,
        reposition: reposition,
        getArgs: getArgs
      };
    }

    var windows = [];
    var oldMetaValue = '';
    function toggleFullScreenState(state) {
      var noScaleMetaValue = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0';
      var viewport = global$9('meta[name=viewport]')[0],
          contentValue;
      if (global$8.overrideViewPort === false) {
        return;
      }
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.setAttribute('name', 'viewport');
        document.getElementsByTagName('head')[0].appendChild(viewport);
      }
      contentValue = viewport.getAttribute('content');
      if (contentValue && typeof oldMetaValue !== 'undefined') {
        oldMetaValue = contentValue;
      }
      viewport.setAttribute('content', state ? noScaleMetaValue : oldMetaValue);
    }
    function toggleBodyFullScreenClasses(classPrefix, state) {
      if (checkFullscreenWindows() && state === false) {
        global$9([document.documentElement, document.body]).removeClass(classPrefix + 'fullscreen');
      }
    }
    function checkFullscreenWindows() {
      for (var i = 0; i < windows.length; i++) {
        if (windows[i]._fullscreen) {
          return true;
        }
      }
      return false;
    }
    function handleWindowResize() {
      if (!global$8.desktop) {
        var lastSize_1 = {
          w: window.innerWidth,
          h: window.innerHeight
        };
        global$7.setInterval(function () {
          var w = window.innerWidth,
              h = window.innerHeight;
          if (lastSize_1.w !== w || lastSize_1.h !== h) {
            lastSize_1 = {
              w: w,
              h: h
            };
            global$9(window).trigger('resize');
          }
        }, 100);
      }
      function reposition() {
        var i;
        var rect = funcs.getWindowSize();
        var layoutRect;
        for (i = 0; i < windows.length; i++) {
          layoutRect = windows[i].layoutRect();
          windows[i].moveTo(windows[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2), windows[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2));
        }
      }
      global$9(window).on('resize', reposition);
    }
    var Window$$1 = FloatPanel.extend({
      modal: true,
      Defaults: {
        border: 1,
        layout: 'flex',
        containerCls: 'panel',
        role: 'dialog',
        callbacks: {
          submit: function submit() {
            this.fire('submit', { data: this.toJSON() });
          },
          close: function close() {
            this.close();
          }
        }
      },
      init: function init(settings) {
        var self$$1 = this;
        self$$1._super(settings);
        if (self$$1.isRtl()) {
          self$$1.classes.add('rtl');
        }
        self$$1.classes.add('window');
        self$$1.bodyClasses.add('window-body');
        self$$1.state.set('fixed', true);
        if (settings.buttons) {
          self$$1.statusbar = new Panel({
            layout: 'flex',
            border: '1 0 0 0',
            spacing: 3,
            padding: 10,
            align: 'center',
            pack: self$$1.isRtl() ? 'start' : 'end',
            defaults: { type: 'button' },
            items: settings.buttons
          });
          self$$1.statusbar.classes.add('foot');
          self$$1.statusbar.parent(self$$1);
        }
        self$$1.on('click', function (e) {
          var closeClass = self$$1.classPrefix + 'close';
          if (funcs.hasClass(e.target, closeClass) || funcs.hasClass(e.target.parentNode, closeClass)) {
            self$$1.close();
          }
        });
        self$$1.on('cancel', function () {
          self$$1.close();
        });
        self$$1.on('move', function (e) {
          if (e.control === self$$1) {
            FloatPanel.hideAll();
          }
        });
        self$$1.aria('describedby', self$$1.describedBy || self$$1._id + '-none');
        self$$1.aria('label', settings.title);
        self$$1._fullscreen = false;
      },
      recalc: function recalc() {
        var self$$1 = this;
        var statusbar$$1 = self$$1.statusbar;
        var layoutRect, width, x, needsRecalc;
        if (self$$1._fullscreen) {
          self$$1.layoutRect(funcs.getWindowSize());
          self$$1.layoutRect().contentH = self$$1.layoutRect().innerH;
        }
        self$$1._super();
        layoutRect = self$$1.layoutRect();
        if (self$$1.settings.title && !self$$1._fullscreen) {
          width = layoutRect.headerW;
          if (width > layoutRect.w) {
            x = layoutRect.x - Math.max(0, width / 2);
            self$$1.layoutRect({
              w: width,
              x: x
            });
            needsRecalc = true;
          }
        }
        if (statusbar$$1) {
          statusbar$$1.layoutRect({ w: self$$1.layoutRect().innerW }).recalc();
          width = statusbar$$1.layoutRect().minW + layoutRect.deltaW;
          if (width > layoutRect.w) {
            x = layoutRect.x - Math.max(0, width - layoutRect.w);
            self$$1.layoutRect({
              w: width,
              x: x
            });
            needsRecalc = true;
          }
        }
        if (needsRecalc) {
          self$$1.recalc();
        }
      },
      initLayoutRect: function initLayoutRect() {
        var self$$1 = this;
        var layoutRect = self$$1._super();
        var deltaH = 0,
            headEl;
        if (self$$1.settings.title && !self$$1._fullscreen) {
          headEl = self$$1.getEl('head');
          var size = funcs.getSize(headEl);
          layoutRect.headerW = size.width;
          layoutRect.headerH = size.height;
          deltaH += layoutRect.headerH;
        }
        if (self$$1.statusbar) {
          deltaH += self$$1.statusbar.layoutRect().h;
        }
        layoutRect.deltaH += deltaH;
        layoutRect.minH += deltaH;
        layoutRect.h += deltaH;
        var rect = funcs.getWindowSize();
        layoutRect.x = self$$1.settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2);
        layoutRect.y = self$$1.settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2);
        return layoutRect;
      },
      renderHtml: function renderHtml() {
        var self$$1 = this,
            layout = self$$1._layout,
            id = self$$1._id,
            prefix = self$$1.classPrefix;
        var settings = self$$1.settings;
        var headerHtml = '',
            footerHtml = '',
            html = settings.html;
        self$$1.preRender();
        layout.preRender(self$$1);
        if (settings.title) {
          headerHtml = '<div id="' + id + '-head" class="' + prefix + 'window-head">' + '<div id="' + id + '-title" class="' + prefix + 'title">' + self$$1.encode(settings.title) + '</div>' + '<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' + '<button type="button" class="' + prefix + 'close" aria-hidden="true">' + '<i class="mce-ico mce-i-remove"></i>' + '</button>' + '</div>';
        }
        if (settings.url) {
          html = '<iframe src="' + settings.url + '" tabindex="-1"></iframe>';
        }
        if (typeof html === 'undefined') {
          html = layout.renderHtml(self$$1);
        }
        if (self$$1.statusbar) {
          footerHtml = self$$1.statusbar.renderHtml();
        }
        return '<div id="' + id + '" class="' + self$$1.classes + '" hidefocus="1">' + '<div class="' + self$$1.classPrefix + 'reset" role="application">' + headerHtml + '<div id="' + id + '-body" class="' + self$$1.bodyClasses + '">' + html + '</div>' + footerHtml + '</div>' + '</div>';
      },
      fullscreen: function fullscreen(state) {
        var self$$1 = this;
        var documentElement = document.documentElement;
        var slowRendering;
        var prefix = self$$1.classPrefix;
        var layoutRect;
        if (state !== self$$1._fullscreen) {
          global$9(window).on('resize', function () {
            var time;
            if (self$$1._fullscreen) {
              if (!slowRendering) {
                time = new Date().getTime();
                var rect = funcs.getWindowSize();
                self$$1.moveTo(0, 0).resizeTo(rect.w, rect.h);
                if (new Date().getTime() - time > 50) {
                  slowRendering = true;
                }
              } else {
                if (!self$$1._timer) {
                  self$$1._timer = global$7.setTimeout(function () {
                    var rect = funcs.getWindowSize();
                    self$$1.moveTo(0, 0).resizeTo(rect.w, rect.h);
                    self$$1._timer = 0;
                  }, 50);
                }
              }
            }
          });
          layoutRect = self$$1.layoutRect();
          self$$1._fullscreen = state;
          if (!state) {
            self$$1.borderBox = $_atjwyuuqjk26xn5q.parseBox(self$$1.settings.border);
            self$$1.getEl('head').style.display = '';
            layoutRect.deltaH += layoutRect.headerH;
            global$9([documentElement, document.body]).removeClass(prefix + 'fullscreen');
            self$$1.classes.remove('fullscreen');
            self$$1.moveTo(self$$1._initial.x, self$$1._initial.y).resizeTo(self$$1._initial.w, self$$1._initial.h);
          } else {
            self$$1._initial = {
              x: layoutRect.x,
              y: layoutRect.y,
              w: layoutRect.w,
              h: layoutRect.h
            };
            self$$1.borderBox = $_atjwyuuqjk26xn5q.parseBox('0');
            self$$1.getEl('head').style.display = 'none';
            layoutRect.deltaH -= layoutRect.headerH + 2;
            global$9([documentElement, document.body]).addClass(prefix + 'fullscreen');
            self$$1.classes.add('fullscreen');
            var rect = funcs.getWindowSize();
            self$$1.moveTo(0, 0).resizeTo(rect.w, rect.h);
          }
        }
        return self$$1.reflow();
      },
      postRender: function postRender() {
        var self$$1 = this;
        var startPos;
        setTimeout(function () {
          self$$1.classes.add('in');
          self$$1.fire('open');
        }, 0);
        self$$1._super();
        if (self$$1.statusbar) {
          self$$1.statusbar.postRender();
        }
        self$$1.focus();
        this.dragHelper = new DragHelper(self$$1._id + '-dragh', {
          start: function start() {
            startPos = {
              x: self$$1.layoutRect().x,
              y: self$$1.layoutRect().y
            };
          },
          drag: function drag(e) {
            self$$1.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY);
          }
        });
        self$$1.on('submit', function (e) {
          if (!e.isDefaultPrevented()) {
            self$$1.close();
          }
        });
        windows.push(self$$1);
        toggleFullScreenState(true);
      },
      submit: function submit() {
        return this.fire('submit', { data: this.toJSON() });
      },
      remove: function remove() {
        var self$$1 = this;
        var i;
        self$$1.dragHelper.destroy();
        self$$1._super();
        if (self$$1.statusbar) {
          this.statusbar.remove();
        }
        toggleBodyFullScreenClasses(self$$1.classPrefix, false);
        i = windows.length;
        while (i--) {
          if (windows[i] === self$$1) {
            windows.splice(i, 1);
          }
        }
        toggleFullScreenState(windows.length > 0);
      },
      getContentWindow: function getContentWindow() {
        var ifr = this.getEl().getElementsByTagName('iframe')[0];
        return ifr ? ifr.contentWindow : null;
      }
    });
    handleWindowResize();

    var MessageBox = Window$$1.extend({
      init: function init(settings) {
        settings = {
          border: 1,
          padding: 20,
          layout: 'flex',
          pack: 'center',
          align: 'center',
          containerCls: 'panel',
          autoScroll: true,
          buttons: {
            type: 'button',
            text: 'Ok',
            action: 'ok'
          },
          items: {
            type: 'label',
            multiline: true,
            maxWidth: 500,
            maxHeight: 200
          }
        };
        this._super(settings);
      },
      Statics: {
        OK: 1,
        OK_CANCEL: 2,
        YES_NO: 3,
        YES_NO_CANCEL: 4,
        msgBox: function msgBox(settings) {
          var buttons;
          var callback = settings.callback || function () {};
          function createButton(text, status$$1, primary) {
            return {
              type: 'button',
              text: text,
              subtype: primary ? 'primary' : '',
              onClick: function onClick(e) {
                e.control.parents()[1].close();
                callback(status$$1);
              }
            };
          }
          switch (settings.buttons) {
            case MessageBox.OK_CANCEL:
              buttons = [createButton('Ok', true, true), createButton('Cancel', false)];
              break;
            case MessageBox.YES_NO:
            case MessageBox.YES_NO_CANCEL:
              buttons = [createButton('Yes', 1, true), createButton('No', 0)];
              if (settings.buttons === MessageBox.YES_NO_CANCEL) {
                buttons.push(createButton('Cancel', -1));
              }
              break;
            default:
              buttons = [createButton('Ok', true, true)];
              break;
          }
          return new Window$$1({
            padding: 20,
            x: settings.x,
            y: settings.y,
            minWidth: 300,
            minHeight: 100,
            layout: 'flex',
            pack: 'center',
            align: 'center',
            buttons: buttons,
            title: settings.title,
            role: 'alertdialog',
            items: {
              type: 'label',
              multiline: true,
              maxWidth: 500,
              maxHeight: 200,
              text: settings.text
            },
            onPostRender: function onPostRender() {
              this.aria('describedby', this.items()[0]._id);
            },
            onClose: settings.onClose,
            onCancel: function onCancel() {
              callback(false);
            }
          }).renderTo(document.body).reflow();
        },
        alert: function alert(settings, callback) {
          if (typeof settings === 'string') {
            settings = { text: settings };
          }
          settings.callback = callback;
          return MessageBox.msgBox(settings);
        },
        confirm: function confirm(settings, callback) {
          if (typeof settings === 'string') {
            settings = { text: settings };
          }
          settings.callback = callback;
          settings.buttons = MessageBox.OK_CANCEL;
          return MessageBox.msgBox(settings);
        }
      }
    });

    function WindowManagerImpl(editor) {
      var open$$1 = function open$$1(args, params, closeCallback) {
        var win;
        args.title = args.title || ' ';
        args.url = args.url || args.file;
        if (args.url) {
          args.width = parseInt(args.width || 320, 10);
          args.height = parseInt(args.height || 240, 10);
        }
        if (args.body) {
          args.items = {
            defaults: args.defaults,
            type: args.bodyType || 'form',
            items: args.body,
            data: args.data,
            callbacks: args.commands
          };
        }
        if (!args.url && !args.buttons) {
          args.buttons = [{
            text: 'Ok',
            subtype: 'primary',
            onclick: function onclick() {
              win.find('form')[0].submit();
            }
          }, {
            text: 'Cancel',
            onclick: function onclick() {
              win.close();
            }
          }];
        }
        win = new Window$$1(args);
        win.on('close', function () {
          closeCallback(win);
        });
        if (args.data) {
          win.on('postRender', function () {
            this.find('*').each(function (ctrl) {
              var name$$1 = ctrl.name();
              if (name$$1 in args.data) {
                ctrl.value(args.data[name$$1]);
              }
            });
          });
        }
        win.features = args || {};
        win.params = params || {};
        win = win.renderTo(document.body).reflow();
        return win;
      };
      var alert$$1 = function alert$$1(message, choiceCallback, closeCallback) {
        var win;
        win = MessageBox.alert(message, function () {
          choiceCallback();
        });
        win.on('close', function () {
          closeCallback(win);
        });
        return win;
      };
      var confirm$$1 = function confirm$$1(message, choiceCallback, closeCallback) {
        var win;
        win = MessageBox.confirm(message, function (state) {
          choiceCallback(state);
        });
        win.on('close', function () {
          closeCallback(win);
        });
        return win;
      };
      var close$$1 = function close$$1(window$$1) {
        window$$1.close();
      };
      var getParams = function getParams(window$$1) {
        return window$$1.params;
      };
      var setParams = function setParams(window$$1, params) {
        window$$1.params = params;
      };
      return {
        open: open$$1,
        alert: alert$$1,
        confirm: confirm$$1,
        close: close$$1,
        getParams: getParams,
        setParams: setParams
      };
    }

    var get = function get(editor) {
      var renderUI = function renderUI(args) {
        return $_5bzl2atrjk26xn21.renderUI(editor, this, args);
      };
      var resizeTo = function resizeTo(w, h) {
        return $_fowa4rubjk26xn3f.resizeTo(editor, w, h);
      };
      var resizeBy = function resizeBy(dw, dh) {
        return $_fowa4rubjk26xn3f.resizeBy(editor, dw, dh);
      };
      var getNotificationManagerImpl = function getNotificationManagerImpl() {
        return NotificationManagerImpl(editor);
      };
      var getWindowManagerImpl = function getWindowManagerImpl() {
        return WindowManagerImpl(editor);
      };
      return {
        renderUI: renderUI,
        resizeTo: resizeTo,
        resizeBy: resizeBy,
        getNotificationManagerImpl: getNotificationManagerImpl,
        getWindowManagerImpl: getWindowManagerImpl
      };
    };
    var $_27tb2gtqjk26xn20 = { get: get };

    var Layout = global$10.extend({
      Defaults: {
        firstControlClass: 'first',
        lastControlClass: 'last'
      },
      init: function init(settings) {
        this.settings = global$2.extend({}, this.Defaults, settings);
      },
      preRender: function preRender(container) {
        container.bodyClasses.add(this.settings.containerClass);
      },
      applyClasses: function applyClasses(items) {
        var self = this;
        var settings = self.settings;
        var firstClass, lastClass, firstItem, lastItem;
        firstClass = settings.firstControlClass;
        lastClass = settings.lastControlClass;
        items.each(function (item) {
          item.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
          if (item.visible()) {
            if (!firstItem) {
              firstItem = item;
            }
            lastItem = item;
          }
        });
        if (firstItem) {
          firstItem.classes.add(firstClass);
        }
        if (lastItem) {
          lastItem.classes.add(lastClass);
        }
      },
      renderHtml: function renderHtml(container) {
        var self = this;
        var html = '';
        self.applyClasses(container.items());
        container.items().each(function (item) {
          html += item.renderHtml();
        });
        return html;
      },
      recalc: function recalc() {},
      postRender: function postRender() {},
      isNative: function isNative() {
        return false;
      }
    });

    var AbsoluteLayout = Layout.extend({
      Defaults: {
        containerClass: 'abs-layout',
        controlClass: 'abs-layout-item'
      },
      recalc: function recalc(container) {
        container.items().filter(':visible').each(function (ctrl) {
          var settings = ctrl.settings;
          ctrl.layoutRect({
            x: settings.x,
            y: settings.y,
            w: settings.w,
            h: settings.h
          });
          if (ctrl.recalc) {
            ctrl.recalc();
          }
        });
      },
      renderHtml: function renderHtml(container) {
        return '<div id="' + container._id + '-absend" class="' + container.classPrefix + 'abs-end"></div>' + this._super(container);
      }
    });

    var Button = Widget.extend({
      Defaults: {
        classes: 'widget btn',
        role: 'button'
      },
      init: function init(settings) {
        var self$$1 = this;
        var size;
        self$$1._super(settings);
        settings = self$$1.settings;
        size = self$$1.settings.size;
        self$$1.on('click mousedown', function (e) {
          e.preventDefault();
        });
        self$$1.on('touchstart', function (e) {
          self$$1.fire('click', e);
          e.preventDefault();
        });
        if (settings.subtype) {
          self$$1.classes.add(settings.subtype);
        }
        if (size) {
          self$$1.classes.add('btn-' + size);
        }
        if (settings.icon) {
          self$$1.icon(settings.icon);
        }
      },
      icon: function icon(_icon) {
        if (!arguments.length) {
          return this.state.get('icon');
        }
        this.state.set('icon', _icon);
        return this;
      },
      repaint: function repaint() {
        var btnElm = this.getEl().firstChild;
        var btnStyle;
        if (btnElm) {
          btnStyle = btnElm.style;
          btnStyle.width = btnStyle.height = '100%';
        }
        this._super();
      },
      renderHtml: function renderHtml() {
        var self$$1 = this,
            id = self$$1._id,
            prefix = self$$1.classPrefix;
        var icon = self$$1.state.get('icon'),
            image;
        var text = self$$1.state.get('text');
        var textHtml = '';
        var ariaPressed;
        var settings = self$$1.settings;
        image = settings.image;
        if (image) {
          icon = 'none';
          if (typeof image !== 'string') {
            image = window.getSelection ? image[0] : image[1];
          }
          image = ' style="background-image: url(\'' + image + '\')"';
        } else {
          image = '';
        }
        if (text) {
          self$$1.classes.add('btn-has-text');
          textHtml = '<span class="' + prefix + 'txt">' + self$$1.encode(text) + '</span>';
        }
        icon = icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
        return '<div id="' + id + '" class="' + self$$1.classes + '" tabindex="-1"' + ariaPressed + '>' + '<button id="' + id + '-button" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '</div>';
      },
      bindStates: function bindStates() {
        var self$$1 = this,
            $ = self$$1.$,
            textCls = self$$1.classPrefix + 'txt';
        function setButtonText(text) {
          var $span = $('span.' + textCls, self$$1.getEl());
          if (text) {
            if (!$span[0]) {
              $('button:first', self$$1.getEl()).append('<span class="' + textCls + '"></span>');
              $span = $('span.' + textCls, self$$1.getEl());
            }
            $span.html(self$$1.encode(text));
          } else {
            $span.remove();
          }
          self$$1.classes.toggle('btn-has-text', !!text);
        }
        self$$1.state.on('change:text', function (e) {
          setButtonText(e.value);
        });
        self$$1.state.on('change:icon', function (e) {
          var icon = e.value;
          var prefix = self$$1.classPrefix;
          self$$1.settings.icon = icon;
          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self$$1.settings.icon : '';
          var btnElm = self$$1.getEl().firstChild;
          var iconElm = btnElm.getElementsByTagName('i')[0];
          if (icon) {
            if (!iconElm || iconElm !== btnElm.firstChild) {
              iconElm = document.createElement('i');
              btnElm.insertBefore(iconElm, btnElm.firstChild);
            }
            iconElm.className = icon;
          } else if (iconElm) {
            btnElm.removeChild(iconElm);
          }
          setButtonText(self$$1.state.get('text'));
        });
        return self$$1._super();
      }
    });

    var BrowseButton = Button.extend({
      init: function init(settings) {
        var self = this;
        settings = global$2.extend({
          text: 'Browse...',
          multiple: false,
          accept: null
        }, settings);
        self._super(settings);
        self.classes.add('browsebutton');
        if (settings.multiple) {
          self.classes.add('multiple');
        }
      },
      postRender: function postRender() {
        var self = this;
        var input = funcs.create('input', {
          type: 'file',
          id: self._id + '-browse',
          accept: self.settings.accept
        });
        self._super();
        global$9(input).on('change', function (e) {
          var files = e.target.files;
          self.value = function () {
            if (!files.length) {
              return null;
            } else if (self.settings.multiple) {
              return files;
            } else {
              return files[0];
            }
          };
          e.preventDefault();
          if (files.length) {
            self.fire('change', e);
          }
        });
        global$9(input).on('click', function (e) {
          e.stopPropagation();
        });
        global$9(self.getEl('button')).on('click', function (e) {
          e.stopPropagation();
          input.click();
        });
        self.getEl().appendChild(input);
      },
      remove: function remove() {
        global$9(this.getEl('button')).off();
        global$9(this.getEl('input')).off();
        this._super();
      }
    });

    var ButtonGroup = Container.extend({
      Defaults: {
        defaultType: 'button',
        role: 'group'
      },
      renderHtml: function renderHtml() {
        var self = this,
            layout = self._layout;
        self.classes.add('btn-group');
        self.preRender();
        layout.preRender(self);
        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
      }
    });

    var Checkbox = Widget.extend({
      Defaults: {
        classes: 'checkbox',
        role: 'checkbox',
        checked: false
      },
      init: function init(settings) {
        var self$$1 = this;
        self$$1._super(settings);
        self$$1.on('click mousedown', function (e) {
          e.preventDefault();
        });
        self$$1.on('click', function (e) {
          e.preventDefault();
          if (!self$$1.disabled()) {
            self$$1.checked(!self$$1.checked());
          }
        });
        self$$1.checked(self$$1.settings.checked);
      },
      checked: function checked(state) {
        if (!arguments.length) {
          return this.state.get('checked');
        }
        this.state.set('checked', state);
        return this;
      },
      value: function value(state) {
        if (!arguments.length) {
          return this.checked();
        }
        return this.checked(state);
      },
      renderHtml: function renderHtml() {
        var self$$1 = this,
            id = self$$1._id,
            prefix = self$$1.classPrefix;
        return '<div id="' + id + '" class="' + self$$1.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' + '<span id="' + id + '-al" class="' + prefix + 'label">' + self$$1.encode(self$$1.state.get('text')) + '</span>' + '</div>';
      },
      bindStates: function bindStates() {
        var self$$1 = this;
        function checked(state) {
          self$$1.classes.toggle('checked', state);
          self$$1.aria('checked', state);
        }
        self$$1.state.on('change:text', function (e) {
          self$$1.getEl('al').firstChild.data = self$$1.translate(e.value);
        });
        self$$1.state.on('change:checked change:value', function (e) {
          self$$1.fire('change');
          checked(e.value);
        });
        self$$1.state.on('change:icon', function (e) {
          var icon = e.value;
          var prefix = self$$1.classPrefix;
          if (typeof icon === 'undefined') {
            return self$$1.settings.icon;
          }
          self$$1.settings.icon = icon;
          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self$$1.settings.icon : '';
          var btnElm = self$$1.getEl().firstChild;
          var iconElm = btnElm.getElementsByTagName('i')[0];
          if (icon) {
            if (!iconElm || iconElm !== btnElm.firstChild) {
              iconElm = document.createElement('i');
              btnElm.insertBefore(iconElm, btnElm.firstChild);
            }
            iconElm.className = icon;
          } else if (iconElm) {
            btnElm.removeChild(iconElm);
          }
        });
        if (self$$1.state.get('checked')) {
          checked(true);
        }
        return self$$1._super();
      }
    });

    var global$13 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var ComboBox = Widget.extend({
      init: function init(settings) {
        var self$$1 = this;
        self$$1._super(settings);
        settings = self$$1.settings;
        self$$1.classes.add('combobox');
        self$$1.subinput = true;
        self$$1.ariaTarget = 'inp';
        settings.menu = settings.menu || settings.values;
        if (settings.menu) {
          settings.icon = 'caret';
        }
        self$$1.on('click', function (e) {
          var elm = e.target;
          var root = self$$1.getEl();
          if (!global$9.contains(root, elm) && elm !== root) {
            return;
          }
          while (elm && elm !== root) {
            if (elm.id && elm.id.indexOf('-open') !== -1) {
              self$$1.fire('action');
              if (settings.menu) {
                self$$1.showMenu();
                if (e.aria) {
                  self$$1.menu.items()[0].focus();
                }
              }
            }
            elm = elm.parentNode;
          }
        });
        self$$1.on('keydown', function (e) {
          var rootControl;
          if (e.keyCode === 13 && e.target.nodeName === 'INPUT') {
            e.preventDefault();
            self$$1.parents().reverse().each(function (ctrl) {
              if (ctrl.toJSON) {
                rootControl = ctrl;
                return false;
              }
            });
            self$$1.fire('submit', { data: rootControl.toJSON() });
          }
        });
        self$$1.on('keyup', function (e) {
          if (e.target.nodeName === 'INPUT') {
            var oldValue = self$$1.state.get('value');
            var newValue = e.target.value;
            if (newValue !== oldValue) {
              self$$1.state.set('value', newValue);
              self$$1.fire('autocomplete', e);
            }
          }
        });
        self$$1.on('mouseover', function (e) {
          var tooltip = self$$1.tooltip().moveTo(-65535);
          if (self$$1.statusLevel() && e.target.className.indexOf(self$$1.classPrefix + 'status') !== -1) {
            var statusMessage = self$$1.statusMessage() || 'Ok';
            var rel = tooltip.text(statusMessage).show().testMoveRel(e.target, ['bc-tc', 'bc-tl', 'bc-tr']);
            tooltip.classes.toggle('tooltip-n', rel === 'bc-tc');
            tooltip.classes.toggle('tooltip-nw', rel === 'bc-tl');
            tooltip.classes.toggle('tooltip-ne', rel === 'bc-tr');
            tooltip.moveRel(e.target, rel);
          }
        });
      },
      statusLevel: function statusLevel(value) {
        if (arguments.length > 0) {
          this.state.set('statusLevel', value);
        }
        return this.state.get('statusLevel');
      },
      statusMessage: function statusMessage(value) {
        if (arguments.length > 0) {
          this.state.set('statusMessage', value);
        }
        return this.state.get('statusMessage');
      },
      showMenu: function showMenu() {
        var self$$1 = this;
        var settings = self$$1.settings;
        var menu;
        if (!self$$1.menu) {
          menu = settings.menu || [];
          if (menu.length) {
            menu = {
              type: 'menu',
              items: menu
            };
          } else {
            menu.type = menu.type || 'menu';
          }
          self$$1.menu = global$4.create(menu).parent(self$$1).renderTo(self$$1.getContainerElm());
          self$$1.fire('createmenu');
          self$$1.menu.reflow();
          self$$1.menu.on('cancel', function (e) {
            if (e.control === self$$1.menu) {
              self$$1.focus();
            }
          });
          self$$1.menu.on('show hide', function (e) {
            e.control.items().each(function (ctrl) {
              ctrl.active(ctrl.value() === self$$1.value());
            });
          }).fire('show');
          self$$1.menu.on('select', function (e) {
            self$$1.value(e.control.value());
          });
          self$$1.on('focusin', function (e) {
            if (e.target.tagName.toUpperCase() === 'INPUT') {
              self$$1.menu.hide();
            }
          });
          self$$1.aria('expanded', true);
        }
        self$$1.menu.show();
        self$$1.menu.layoutRect({ w: self$$1.layoutRect().w });
        self$$1.menu.moveRel(self$$1.getEl(), self$$1.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
      },
      focus: function focus() {
        this.getEl('inp').focus();
      },
      repaint: function repaint() {
        var self$$1 = this,
            elm = self$$1.getEl(),
            openElm = self$$1.getEl('open'),
            rect = self$$1.layoutRect();
        var width,
            lineHeight,
            innerPadding = 0;
        var inputElm = elm.firstChild;
        if (self$$1.statusLevel() && self$$1.statusLevel() !== 'none') {
          innerPadding = parseInt(funcs.getRuntimeStyle(inputElm, 'padding-right'), 10) - parseInt(funcs.getRuntimeStyle(inputElm, 'padding-left'), 10);
        }
        if (openElm) {
          width = rect.w - funcs.getSize(openElm).width - 10;
        } else {
          width = rect.w - 10;
        }
        var doc = document;
        if (doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
          lineHeight = self$$1.layoutRect().h - 2 + 'px';
        }
        global$9(inputElm).css({
          width: width - innerPadding,
          lineHeight: lineHeight
        });
        self$$1._super();
        return self$$1;
      },
      postRender: function postRender() {
        var self$$1 = this;
        global$9(this.getEl('inp')).on('change', function (e) {
          self$$1.state.set('value', e.target.value);
          self$$1.fire('change', e);
        });
        return self$$1._super();
      },
      renderHtml: function renderHtml() {
        var self$$1 = this,
            id = self$$1._id,
            settings = self$$1.settings,
            prefix = self$$1.classPrefix;
        var value = self$$1.state.get('value') || '';
        var icon,
            text,
            openBtnHtml = '',
            extraAttrs = '',
            statusHtml = '';
        if ('spellcheck' in settings) {
          extraAttrs += ' spellcheck="' + settings.spellcheck + '"';
        }
        if (settings.maxLength) {
          extraAttrs += ' maxlength="' + settings.maxLength + '"';
        }
        if (settings.size) {
          extraAttrs += ' size="' + settings.size + '"';
        }
        if (settings.subtype) {
          extraAttrs += ' type="' + settings.subtype + '"';
        }
        statusHtml = '<i id="' + id + '-status" class="mce-status mce-ico" style="display: none"></i>';
        if (self$$1.disabled()) {
          extraAttrs += ' disabled="disabled"';
        }
        icon = settings.icon;
        if (icon && icon !== 'caret') {
          icon = prefix + 'ico ' + prefix + 'i-' + settings.icon;
        }
        text = self$$1.state.get('text');
        if (icon || text) {
          openBtnHtml = '<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' + '<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' + (icon !== 'caret' ? '<i class="' + icon + '"></i>' : '<i class="' + prefix + 'caret"></i>') + (text ? (icon ? ' ' : '') + text : '') + '</button>' + '</div>';
          self$$1.classes.add('has-open');
        }
        return '<div id="' + id + '" class="' + self$$1.classes + '">' + '<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' + self$$1.encode(value, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' + self$$1.encode(settings.placeholder) + '" />' + statusHtml + openBtnHtml + '</div>';
      },
      value: function value(_value) {
        if (arguments.length) {
          this.state.set('value', _value);
          return this;
        }
        if (this.state.get('rendered')) {
          this.state.set('value', this.getEl('inp').value);
        }
        return this.state.get('value');
      },
      showAutoComplete: function showAutoComplete(items, term) {
        var self$$1 = this;
        if (items.length === 0) {
          self$$1.hideMenu();
          return;
        }
        var insert = function insert(value, title) {
          return function () {
            self$$1.fire('selectitem', {
              title: title,
              value: value
            });
          };
        };
        if (self$$1.menu) {
          self$$1.menu.items().remove();
        } else {
          self$$1.menu = global$4.create({
            type: 'menu',
            classes: 'combobox-menu',
            layout: 'flow'
          }).parent(self$$1).renderTo();
        }
        global$2.each(items, function (item) {
          self$$1.menu.add({
            text: item.title,
            url: item.previewUrl,
            match: term,
            classes: 'menu-item-ellipsis',
            onclick: insert(item.value, item.title)
          });
        });
        self$$1.menu.renderNew();
        self$$1.hideMenu();
        self$$1.menu.on('cancel', function (e) {
          if (e.control.parent() === self$$1.menu) {
            e.stopPropagation();
            self$$1.focus();
            self$$1.hideMenu();
          }
        });
        self$$1.menu.on('select', function () {
          self$$1.focus();
        });
        var maxW = self$$1.layoutRect().w;
        self$$1.menu.layoutRect({
          w: maxW,
          minW: 0,
          maxW: maxW
        });
        self$$1.menu.repaint();
        self$$1.menu.reflow();
        self$$1.menu.show();
        self$$1.menu.moveRel(self$$1.getEl(), self$$1.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
      },
      hideMenu: function hideMenu() {
        if (this.menu) {
          this.menu.hide();
        }
      },
      bindStates: function bindStates() {
        var self$$1 = this;
        self$$1.state.on('change:value', function (e) {
          if (self$$1.getEl('inp').value !== e.value) {
            self$$1.getEl('inp').value = e.value;
          }
        });
        self$$1.state.on('change:disabled', function (e) {
          self$$1.getEl('inp').disabled = e.value;
        });
        self$$1.state.on('change:statusLevel', function (e) {
          var statusIconElm = self$$1.getEl('status');
          var prefix = self$$1.classPrefix,
              value = e.value;
          funcs.css(statusIconElm, 'display', value === 'none' ? 'none' : '');
          funcs.toggleClass(statusIconElm, prefix + 'i-checkmark', value === 'ok');
          funcs.toggleClass(statusIconElm, prefix + 'i-warning', value === 'warn');
          funcs.toggleClass(statusIconElm, prefix + 'i-error', value === 'error');
          self$$1.classes.toggle('has-status', value !== 'none');
          self$$1.repaint();
        });
        funcs.on(self$$1.getEl('status'), 'mouseleave', function () {
          self$$1.tooltip().hide();
        });
        self$$1.on('cancel', function (e) {
          if (self$$1.menu && self$$1.menu.visible()) {
            e.stopPropagation();
            self$$1.hideMenu();
          }
        });
        var focusIdx = function focusIdx(idx, menu) {
          if (menu && menu.items().length > 0) {
            menu.items().eq(idx)[0].focus();
          }
        };
        self$$1.on('keydown', function (e) {
          var keyCode = e.keyCode;
          if (e.target.nodeName === 'INPUT') {
            if (keyCode === global$13.DOWN) {
              e.preventDefault();
              self$$1.fire('autocomplete');
              focusIdx(0, self$$1.menu);
            } else if (keyCode === global$13.UP) {
              e.preventDefault();
              focusIdx(-1, self$$1.menu);
            }
          }
        });
        return self$$1._super();
      },
      remove: function remove() {
        global$9(this.getEl('inp')).off();
        if (this.menu) {
          this.menu.remove();
        }
        this._super();
      }
    });

    var ColorBox = ComboBox.extend({
      init: function init(settings) {
        var self = this;
        settings.spellcheck = false;
        if (settings.onaction) {
          settings.icon = 'none';
        }
        self._super(settings);
        self.classes.add('colorbox');
        self.on('change keyup postrender', function () {
          self.repaintColor(self.value());
        });
      },
      repaintColor: function repaintColor(value) {
        var openElm = this.getEl('open');
        var elm = openElm ? openElm.getElementsByTagName('i')[0] : null;
        if (elm) {
          try {
            elm.style.background = value;
          } catch (ex) {}
        }
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:value', function (e) {
          if (self.state.get('rendered')) {
            self.repaintColor(e.value);
          }
        });
        return self._super();
      }
    });

    var PanelButton = Button.extend({
      showPanel: function showPanel() {
        var self = this,
            settings = self.settings;
        self.classes.add('opened');
        if (!self.panel) {
          var panelSettings = settings.panel;
          if (panelSettings.type) {
            panelSettings = {
              layout: 'grid',
              items: panelSettings
            };
          }
          panelSettings.role = panelSettings.role || 'dialog';
          panelSettings.popover = true;
          panelSettings.autohide = true;
          panelSettings.ariaRoot = true;
          self.panel = new FloatPanel(panelSettings).on('hide', function () {
            self.classes.remove('opened');
          }).on('cancel', function (e) {
            e.stopPropagation();
            self.focus();
            self.hidePanel();
          }).parent(self).renderTo(self.getContainerElm());
          self.panel.fire('show');
          self.panel.reflow();
        } else {
          self.panel.show();
        }
        var rtlRels = ['bc-tc', 'bc-tl', 'bc-tr'];
        var ltrRels = ['bc-tc', 'bc-tr', 'bc-tl', 'tc-bc', 'tc-br', 'tc-bl'];
        var rel = self.panel.testMoveRel(self.getEl(), settings.popoverAlign || (self.isRtl() ? rtlRels : ltrRels));
        self.panel.classes.toggle('start', rel.substr(-1) === 'l');
        self.panel.classes.toggle('end', rel.substr(-1) === 'r');
        var isTop = rel.substr(0, 1) === 't';
        self.panel.classes.toggle('bottom', !isTop);
        self.panel.classes.toggle('top', isTop);
        self.panel.moveRel(self.getEl(), rel);
      },
      hidePanel: function hidePanel() {
        var self = this;
        if (self.panel) {
          self.panel.hide();
        }
      },
      postRender: function postRender() {
        var self = this;
        self.aria('haspopup', true);
        self.on('click', function (e) {
          if (e.control === self) {
            if (self.panel && self.panel.visible()) {
              self.hidePanel();
            } else {
              self.showPanel();
              self.panel.focus(!!e.aria);
            }
          }
        });
        return self._super();
      },
      remove: function remove() {
        if (this.panel) {
          this.panel.remove();
          this.panel = null;
        }
        return this._super();
      }
    });

    var DOM$3 = global$3.DOM;
    var ColorButton = PanelButton.extend({
      init: function init(settings) {
        this._super(settings);
        this.classes.add('splitbtn');
        this.classes.add('colorbutton');
      },
      color: function color(_color) {
        if (_color) {
          this._color = _color;
          this.getEl('preview').style.backgroundColor = _color;
          return this;
        }
        return this._color;
      },
      resetColor: function resetColor() {
        this._color = null;
        this.getEl('preview').style.backgroundColor = null;
        return this;
      },
      renderHtml: function renderHtml() {
        var self = this,
            id = self._id,
            prefix = self.classPrefix,
            text = self.state.get('text');
        var icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
        var image = self.settings.image ? ' style="background-image: url(\'' + self.settings.image + '\')"' : '';
        var textHtml = '';
        if (text) {
          self.classes.add('btn-has-text');
          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
        }
        return '<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1" aria-haspopup="true">' + '<button role="presentation" hidefocus="1" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + '<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
      },
      postRender: function postRender() {
        var self = this,
            onClickHandler = self.settings.onclick;
        self.on('click', function (e) {
          if (e.aria && e.aria.key === 'down') {
            return;
          }
          if (e.control === self && !DOM$3.getParent(e.target, '.' + self.classPrefix + 'open')) {
            e.stopImmediatePropagation();
            onClickHandler.call(self, e);
          }
        });
        delete self.settings.onclick;
        return self._super();
      }
    });

    var global$14 = tinymce.util.Tools.resolve('tinymce.util.Color');

    var ColorPicker = Widget.extend({
      Defaults: { classes: 'widget colorpicker' },
      init: function init(settings) {
        this._super(settings);
      },
      postRender: function postRender() {
        var self = this;
        var color = self.color();
        var hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
        hueRootElm = self.getEl('h');
        huePointElm = self.getEl('hp');
        svRootElm = self.getEl('sv');
        svPointElm = self.getEl('svp');
        function getPos(elm, event) {
          var pos = funcs.getPos(elm);
          var x, y;
          x = event.pageX - pos.x;
          y = event.pageY - pos.y;
          x = Math.max(0, Math.min(x / elm.clientWidth, 1));
          y = Math.max(0, Math.min(y / elm.clientHeight, 1));
          return {
            x: x,
            y: y
          };
        }
        function updateColor(hsv, hueUpdate) {
          var hue = (360 - hsv.h) / 360;
          funcs.css(huePointElm, { top: hue * 100 + '%' });
          if (!hueUpdate) {
            funcs.css(svPointElm, {
              left: hsv.s + '%',
              top: 100 - hsv.v + '%'
            });
          }
          svRootElm.style.background = global$14({
            s: 100,
            v: 100,
            h: hsv.h
          }).toHex();
          self.color().parse({
            s: hsv.s,
            v: hsv.v,
            h: hsv.h
          });
        }
        function updateSaturationAndValue(e) {
          var pos;
          pos = getPos(svRootElm, e);
          hsv.s = pos.x * 100;
          hsv.v = (1 - pos.y) * 100;
          updateColor(hsv);
          self.fire('change');
        }
        function updateHue(e) {
          var pos;
          pos = getPos(hueRootElm, e);
          hsv = color.toHsv();
          hsv.h = (1 - pos.y) * 360;
          updateColor(hsv, true);
          self.fire('change');
        }
        self._repaint = function () {
          hsv = color.toHsv();
          updateColor(hsv);
        };
        self._super();
        self._svdraghelper = new DragHelper(self._id + '-sv', {
          start: updateSaturationAndValue,
          drag: updateSaturationAndValue
        });
        self._hdraghelper = new DragHelper(self._id + '-h', {
          start: updateHue,
          drag: updateHue
        });
        self._repaint();
      },
      rgb: function rgb() {
        return this.color().toRgb();
      },
      value: function value(_value2) {
        var self = this;
        if (arguments.length) {
          self.color().parse(_value2);
          if (self._rendered) {
            self._repaint();
          }
        } else {
          return self.color().toHex();
        }
      },
      color: function color() {
        if (!this._color) {
          this._color = global$14();
        }
        return this._color;
      },
      renderHtml: function renderHtml() {
        var self = this;
        var id = self._id;
        var prefix = self.classPrefix;
        var hueHtml;
        var stops = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';
        function getOldIeFallbackHtml() {
          var i,
              l,
              html = '',
              gradientPrefix,
              stopsList;
          gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
          stopsList = stops.split(',');
          for (i = 0, l = stopsList.length - 1; i < l; i++) {
            html += '<div class="' + prefix + 'colorpicker-h-chunk" style="' + 'height:' + 100 / l + '%;' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' + '-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' + '"></div>';
          }
          return html;
        }
        var gradientCssText = 'background: -ms-linear-gradient(top,' + stops + ');' + 'background: linear-gradient(to bottom,' + stops + ');';
        hueHtml = '<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + gradientCssText + '">' + getOldIeFallbackHtml() + '<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' + '</div>';
        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' + '<div class="' + prefix + 'colorpicker-overlay1">' + '<div class="' + prefix + 'colorpicker-overlay2">' + '<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' + '<div class="' + prefix + 'colorpicker-selector2"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + hueHtml + '</div>';
      }
    });

    var DropZone = Widget.extend({
      init: function init(settings) {
        var self = this;
        settings = global$2.extend({
          height: 100,
          text: 'Drop an image here',
          multiple: false,
          accept: null
        }, settings);
        self._super(settings);
        self.classes.add('dropzone');
        if (settings.multiple) {
          self.classes.add('multiple');
        }
      },
      renderHtml: function renderHtml() {
        var self = this;
        var attrs, elm;
        var cfg = self.settings;
        attrs = {
          id: self._id,
          hidefocus: '1'
        };
        elm = funcs.create('div', attrs, '<span>' + this.translate(cfg.text) + '</span>');
        if (cfg.height) {
          funcs.css(elm, 'height', cfg.height + 'px');
        }
        if (cfg.width) {
          funcs.css(elm, 'width', cfg.width + 'px');
        }
        elm.className = self.classes;
        return elm.outerHTML;
      },
      postRender: function postRender() {
        var self = this;
        var toggleDragClass = function toggleDragClass(e) {
          e.preventDefault();
          self.classes.toggle('dragenter');
          self.getEl().className = self.classes;
        };
        var filter = function filter(files) {
          var accept = self.settings.accept;
          if (typeof accept !== 'string') {
            return files;
          }
          var re = new RegExp('(' + accept.split(/\s*,\s*/).join('|') + ')$', 'i');
          return global$2.grep(files, function (file) {
            return re.test(file.name);
          });
        };
        self._super();
        self.$el.on('dragover', function (e) {
          e.preventDefault();
        });
        self.$el.on('dragenter', toggleDragClass);
        self.$el.on('dragleave', toggleDragClass);
        self.$el.on('drop', function (e) {
          e.preventDefault();
          if (self.state.get('disabled')) {
            return;
          }
          var files = filter(e.dataTransfer.files);
          self.value = function () {
            if (!files.length) {
              return null;
            } else if (self.settings.multiple) {
              return files;
            } else {
              return files[0];
            }
          };
          if (files.length) {
            self.fire('change', e);
          }
        });
      },
      remove: function remove() {
        this.$el.off();
        this._super();
      }
    });

    var Path = Widget.extend({
      init: function init(settings) {
        var self = this;
        if (!settings.delimiter) {
          settings.delimiter = '\xBB';
        }
        self._super(settings);
        self.classes.add('path');
        self.canFocus = true;
        self.on('click', function (e) {
          var index;
          var target = e.target;
          if (index = target.getAttribute('data-index')) {
            self.fire('select', {
              value: self.row()[index],
              index: index
            });
          }
        });
        self.row(self.settings.row);
      },
      focus: function focus() {
        var self = this;
        self.getEl().firstChild.focus();
        return self;
      },
      row: function row(_row) {
        if (!arguments.length) {
          return this.state.get('row');
        }
        this.state.set('row', _row);
        return this;
      },
      renderHtml: function renderHtml() {
        var self = this;
        return '<div id="' + self._id + '" class="' + self.classes + '">' + self._getDataPathHtml(self.state.get('row')) + '</div>';
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:row', function (e) {
          self.innerHtml(self._getDataPathHtml(e.value));
        });
        return self._super();
      },
      _getDataPathHtml: function _getDataPathHtml(data) {
        var self = this;
        var parts = data || [];
        var i,
            l,
            html = '';
        var prefix = self.classPrefix;
        for (i = 0, l = parts.length; i < l; i++) {
          html += (i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + self.settings.delimiter + ' </div>' : '') + '<div role="button" class="' + prefix + 'path-item' + (i === l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' + i + '" tabindex="-1" id="' + self._id + '-' + i + '" aria-level="' + (i + 1) + '">' + parts[i].name + '</div>';
        }
        if (!html) {
          html = '<div class="' + prefix + 'path-item">\xA0</div>';
        }
        return html;
      }
    });

    var ElementPath = Path.extend({
      postRender: function postRender() {
        var self = this,
            editor = self.settings.editor;
        function isHidden(elm) {
          if (elm.nodeType === 1) {
            if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
              return true;
            }
            if (elm.getAttribute('data-mce-type') === 'bookmark') {
              return true;
            }
          }
          return false;
        }
        if (editor.settings.elementpath !== false) {
          self.on('select', function (e) {
            editor.focus();
            editor.selection.select(this.row()[e.index].element);
            editor.nodeChanged();
          });
          editor.on('nodeChange', function (e) {
            var outParents = [];
            var parents = e.parents;
            var i = parents.length;
            while (i--) {
              if (parents[i].nodeType === 1 && !isHidden(parents[i])) {
                var args = editor.fire('ResolveName', {
                  name: parents[i].nodeName.toLowerCase(),
                  target: parents[i]
                });
                if (!args.isDefaultPrevented()) {
                  outParents.push({
                    name: args.name,
                    element: parents[i]
                  });
                }
                if (args.isPropagationStopped()) {
                  break;
                }
              }
            }
            self.row(outParents);
          });
        }
        return self._super();
      }
    });

    var FormItem = Container.extend({
      Defaults: {
        layout: 'flex',
        align: 'center',
        defaults: { flex: 1 }
      },
      renderHtml: function renderHtml() {
        var self = this,
            layout = self._layout,
            prefix = self.classPrefix;
        self.classes.add('formitem');
        layout.preRender(self);
        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<div id="' + self._id + '-title" class="' + prefix + 'title">' + self.settings.title + '</div>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</div>';
      }
    });

    var Form = Container.extend({
      Defaults: {
        containerCls: 'form',
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        flex: 1,
        padding: 15,
        labelGap: 30,
        spacing: 10,
        callbacks: {
          submit: function submit() {
            this.submit();
          }
        }
      },
      preRender: function preRender() {
        var self = this,
            items = self.items();
        if (!self.settings.formItemDefaults) {
          self.settings.formItemDefaults = {
            layout: 'flex',
            autoResize: 'overflow',
            defaults: { flex: 1 }
          };
        }
        items.each(function (ctrl) {
          var formItem;
          var label = ctrl.settings.label;
          if (label) {
            formItem = new FormItem(global$2.extend({
              items: {
                type: 'label',
                id: ctrl._id + '-l',
                text: label,
                flex: 0,
                forId: ctrl._id,
                disabled: ctrl.disabled()
              }
            }, self.settings.formItemDefaults));
            formItem.type = 'formitem';
            ctrl.aria('labelledby', ctrl._id + '-l');
            if (typeof ctrl.settings.flex === 'undefined') {
              ctrl.settings.flex = 1;
            }
            self.replace(ctrl, formItem);
            formItem.add(ctrl);
          }
        });
      },
      submit: function submit() {
        return this.fire('submit', { data: this.toJSON() });
      },
      postRender: function postRender() {
        var self = this;
        self._super();
        self.fromJSON(self.settings.data);
      },
      bindStates: function bindStates() {
        var self = this;
        self._super();
        function recalcLabels() {
          var maxLabelWidth = 0;
          var labels = [];
          var i, labelGap, items;
          if (self.settings.labelGapCalc === false) {
            return;
          }
          if (self.settings.labelGapCalc === 'children') {
            items = self.find('formitem');
          } else {
            items = self.items();
          }
          items.filter('formitem').each(function (item) {
            var labelCtrl = item.items()[0],
                labelWidth = labelCtrl.getEl().clientWidth;
            maxLabelWidth = labelWidth > maxLabelWidth ? labelWidth : maxLabelWidth;
            labels.push(labelCtrl);
          });
          labelGap = self.settings.labelGap || 0;
          i = labels.length;
          while (i--) {
            labels[i].settings.minWidth = maxLabelWidth + labelGap;
          }
        }
        self.on('show', recalcLabels);
        recalcLabels();
      }
    });

    var FieldSet = Form.extend({
      Defaults: {
        containerCls: 'fieldset',
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        flex: 1,
        padding: '25 15 5 15',
        labelGap: 30,
        spacing: 10,
        border: 1
      },
      renderHtml: function renderHtml() {
        var self = this,
            layout = self._layout,
            prefix = self.classPrefix;
        self.preRender();
        layout.preRender(self);
        return '<fieldset id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + (self.settings.title ? '<legend id="' + self._id + '-title" class="' + prefix + 'fieldset-title">' + self.settings.title + '</legend>' : '') + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + (self.settings.html || '') + layout.renderHtml(self) + '</div>' + '</fieldset>';
      }
    });

    var unique$1 = 0;
    var generate = function generate(prefix) {
      var date = new Date();
      var time = date.getTime();
      var random = Math.floor(Math.random() * 1000000000);
      unique$1++;
      return prefix + '_' + random + unique$1 + String(time);
    };

    var fromHtml = function fromHtml(html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw 'HTML must have a single root node';
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function fromTag(tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function fromText(text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function fromDom(node) {
      if (node === null || node === undefined) throw new Error('Node cannot be null or undefined');
      return { dom: constant(node) };
    };
    var fromPoint = function fromPoint(docElm, x, y) {
      var doc = docElm.dom();
      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
    };
    var Element$$1 = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    var cached = function cached(f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var $_5lbqbzw5jk26xnb4 = {
      ATTRIBUTE: Node.ATTRIBUTE_NODE,
      CDATA_SECTION: Node.CDATA_SECTION_NODE,
      COMMENT: Node.COMMENT_NODE,
      DOCUMENT: Node.DOCUMENT_NODE,
      DOCUMENT_TYPE: Node.DOCUMENT_TYPE_NODE,
      DOCUMENT_FRAGMENT: Node.DOCUMENT_FRAGMENT_NODE,
      ELEMENT: Node.ELEMENT_NODE,
      TEXT: Node.TEXT_NODE,
      PROCESSING_INSTRUCTION: Node.PROCESSING_INSTRUCTION_NODE,
      ENTITY_REFERENCE: Node.ENTITY_REFERENCE_NODE,
      ENTITY: Node.ENTITY_NODE,
      NOTATION: Node.NOTATION_NODE
    };

    var name = function name(element) {
      var r = element.dom().nodeName;
      return r.toLowerCase();
    };
    var type = function type(element) {
      return element.dom().nodeType;
    };
    var value = function value(element) {
      return element.dom().nodeValue;
    };
    var isType$1 = function isType$1(t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isComment = function isComment(element) {
      return type(element) === $_5lbqbzw5jk26xnb4.COMMENT || name(element) === '#comment';
    };
    var isElement = isType$1($_5lbqbzw5jk26xnb4.ELEMENT);
    var isText = isType$1($_5lbqbzw5jk26xnb4.TEXT);
    var isDocument = isType$1($_5lbqbzw5jk26xnb4.DOCUMENT);
    var $_5tyuv3w4jk26xnb3 = {
      name: name,
      type: type,
      value: value,
      isElement: isElement,
      isText: isText,
      isDocument: isDocument,
      isComment: isComment
    };

    var inBody = function inBody(element) {
      var dom = $_5tyuv3w4jk26xnb3.isText(element) ? element.dom().parentNode : element.dom();
      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
    };
    var body = cached(function () {
      return getBody(Element$$1.fromDom(document));
    });
    var getBody = function getBody(doc) {
      var body = doc.dom().body;
      if (body === null || body === undefined) throw 'Body is not available yet';
      return Element$$1.fromDom(body);
    };
    var $_bzb7a9w2jk26xnaz = {
      body: body,
      getBody: getBody,
      inBody: inBody
    };

    var Immutable = function Immutable() {
      var fields = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        fields[_i] = arguments[_i];
      }
      return function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          values[_i] = arguments[_i];
        }
        if (fields.length !== values.length) {
          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
        }
        var struct = {};
        each(fields, function (name, i) {
          struct[name] = constant(values[i]);
        });
        return struct;
      };
    };

    var toArray = function toArray(target, f) {
      var r = [];
      var recurse = function recurse(e) {
        r.push(e);
        return f(e);
      };
      var cur = f(target);
      do {
        cur = cur.bind(recurse);
      } while (cur.isSome());
      return r;
    };
    var $_a5t53kwcjk26xnc3 = { toArray: toArray };

    var Global = typeof window !== 'undefined' ? window : Function('return this;')();

    var path = function path(parts, scope) {
      var o = scope !== undefined && scope !== null ? scope : Global;
      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
        o = o[parts[i]];
      }return o;
    };
    var resolve = function resolve(p, scope) {
      var parts = p.split('.');
      return path(parts, scope);
    };

    var unsafe = function unsafe(name, scope) {
      return resolve(name, scope);
    };
    var getOrDie = function getOrDie(name, scope) {
      var actual = unsafe(name, scope);
      if (actual === undefined || actual === null) throw name + ' not available on this browser';
      return actual;
    };
    var $_3tmm2gwfjk26xncg = { getOrDie: getOrDie };

    var node = function node() {
      var f = $_3tmm2gwfjk26xncg.getOrDie('Node');
      return f;
    };
    var compareDocumentPosition = function compareDocumentPosition(a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionPreceding = function documentPositionPreceding(a, b) {
      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
    };
    var documentPositionContainedBy = function documentPositionContainedBy(a, b) {
      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
    };
    var $_71sgsmwejk26xncf = {
      documentPositionPreceding: documentPositionPreceding,
      documentPositionContainedBy: documentPositionContainedBy
    };

    var firstMatch = function firstMatch(regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) return x;
      }
      return undefined;
    };
    var find$2 = function find$2(regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) return {
        major: 0,
        minor: 0
      };
      var group = function group(i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu(group(1), group(2));
    };
    var detect = function detect(versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) return unknown();
      return find$2(versionRegexes, cleanedAgent);
    };
    var unknown = function unknown() {
      return nu(0, 0);
    };
    var nu = function nu(major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var $_f49rlwwljk26xncs = {
      nu: nu,
      detect: detect,
      unknown: unknown
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var isBrowser = function isBrowser(name, current) {
      return function () {
        return current === name;
      };
    };
    var unknown$1 = function unknown$1() {
      return nu$1({
        current: undefined,
        version: $_f49rlwwljk26xncs.unknown()
      });
    };
    var nu$1 = function nu$1(info) {
      var current = info.current;
      var version = info.version;
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge, current),
        isChrome: isBrowser(chrome, current),
        isIE: isBrowser(ie, current),
        isOpera: isBrowser(opera, current),
        isFirefox: isBrowser(firefox, current),
        isSafari: isBrowser(safari, current)
      };
    };
    var $_1sx3aywkjk26xncp = {
      unknown: unknown$1,
      nu: nu$1,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows$1 = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var isOS = function isOS(name, current) {
      return function () {
        return current === name;
      };
    };
    var unknown$2 = function unknown$2() {
      return nu$2({
        current: undefined,
        version: $_f49rlwwljk26xncs.unknown()
      });
    };
    var nu$2 = function nu$2(info) {
      var current = info.current;
      var version = info.version;
      return {
        current: current,
        version: version,
        isWindows: isOS(windows$1, current),
        isiOS: isOS(ios, current),
        isAndroid: isOS(android, current),
        isOSX: isOS(osx, current),
        isLinux: isOS(linux, current),
        isSolaris: isOS(solaris, current),
        isFreeBSD: isOS(freebsd, current)
      };
    };
    var $_3t94wgwmjk26xncu = {
      unknown: unknown$2,
      nu: nu$2,
      windows: constant(windows$1),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd)
    };

    function DeviceType(os, browser, userAgent) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isAndroid3 = os.isAndroid() && os.version.major === 3;
      var isAndroid4 = os.isAndroid() && os.version.major === 4;
      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
      var isTouch = os.isiOS() || os.isAndroid();
      var isPhone = isTouch && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview)
      };
    }

    var detect$1 = function detect$1(candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function detectBrowser(browsers, userAgent) {
      return detect$1(browsers, userAgent).map(function (browser) {
        var version = $_f49rlwwljk26xncs.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function detectOs(oses, userAgent) {
      return detect$1(oses, userAgent).map(function (os) {
        var version = $_f49rlwwljk26xncs.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };
    var $_70sycgwojk26xnd0 = {
      detectBrowser: detectBrowser,
      detectOs: detectOs
    };

    var contains$1 = function contains$1(str, substr) {
      return str.indexOf(substr) !== -1;
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function checkContains(target) {
      return function (uastring) {
        return contains$1(uastring, target);
      };
    };
    var browsers = [{
      name: 'Edge',
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function search(uastring) {
        var monstrosity = contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
        return monstrosity;
      }
    }, {
      name: 'Chrome',
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/, normalVersionRegex],
      search: function search(uastring) {
        return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
      }
    }, {
      name: 'IE',
      versionRegexes: [/.*?msie\ ?([0-9]+)\.([0-9]+).*/, /.*?rv:([0-9]+)\.([0-9]+).*/],
      search: function search(uastring) {
        return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
      }
    }, {
      name: 'Opera',
      versionRegexes: [normalVersionRegex, /.*?opera\/([0-9]+)\.([0-9]+).*/],
      search: checkContains('opera')
    }, {
      name: 'Firefox',
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: checkContains('firefox')
    }, {
      name: 'Safari',
      versionRegexes: [normalVersionRegex, /.*?cpu os ([0-9]+)_([0-9]+).*/],
      search: function search(uastring) {
        return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
      }
    }];
    var oses = [{
      name: 'Windows',
      search: checkContains('win'),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    }, {
      name: 'iOS',
      search: function search(uastring) {
        return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
      },
      versionRegexes: [/.*?version\/\ ?([0-9]+)\.([0-9]+).*/, /.*cpu os ([0-9]+)_([0-9]+).*/, /.*cpu iphone os ([0-9]+)_([0-9]+).*/]
    }, {
      name: 'Android',
      search: checkContains('android'),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    }, {
      name: 'OSX',
      search: checkContains('os x'),
      versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
    }, {
      name: 'Linux',
      search: checkContains('linux'),
      versionRegexes: []
    }, {
      name: 'Solaris',
      search: checkContains('sunos'),
      versionRegexes: []
    }, {
      name: 'FreeBSD',
      search: checkContains('freebsd'),
      versionRegexes: []
    }];
    var $_6ip3dqwpjk26xnd4 = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var detect$2 = function detect$2(userAgent) {
      var browsers = $_6ip3dqwpjk26xnd4.browsers();
      var oses = $_6ip3dqwpjk26xnd4.oses();
      var browser = $_70sycgwojk26xnd0.detectBrowser(browsers, userAgent).fold($_1sx3aywkjk26xncp.unknown, $_1sx3aywkjk26xncp.nu);
      var os = $_70sycgwojk26xnd0.detectOs(oses, userAgent).fold($_3t94wgwmjk26xncu.unknown, $_3t94wgwmjk26xncu.nu);
      var deviceType = DeviceType(os, browser, userAgent);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var $_1lyz8owjjk26xncn = { detect: detect$2 };

    var detect$3 = cached(function () {
      var userAgent = navigator.userAgent;
      return $_1lyz8owjjk26xncn.detect(userAgent);
    });
    var $_a9splfwijk26xncl = { detect: detect$3 };

    var ELEMENT = $_5lbqbzw5jk26xnb4.ELEMENT;
    var DOCUMENT = $_5lbqbzw5jk26xnb4.DOCUMENT;
    var is = function is(element, selector) {
      var elem = element.dom();
      if (elem.nodeType !== ELEMENT) return false;else if (elem.matches !== undefined) return elem.matches(selector);else if (elem.msMatchesSelector !== undefined) return elem.msMatchesSelector(selector);else if (elem.webkitMatchesSelector !== undefined) return elem.webkitMatchesSelector(selector);else if (elem.mozMatchesSelector !== undefined) return elem.mozMatchesSelector(selector);else throw new Error('Browser lacks native selectors');
    };
    var bypassSelector = function bypassSelector(dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT || dom.childElementCount === 0;
    };
    var all = function all(selector, scope) {
      var base = scope === undefined ? document : scope.dom();
      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element$$1.fromDom);
    };
    var one = function one(selector, scope) {
      var base = scope === undefined ? document : scope.dom();
      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element$$1.fromDom);
    };
    var $_dvwkndwtjk26xndf = {
      all: all,
      is: is,
      one: one
    };

    var eq = function eq(e1, e2) {
      return e1.dom() === e2.dom();
    };
    var isEqualNode = function isEqualNode(e1, e2) {
      return e1.dom().isEqualNode(e2.dom());
    };
    var member = function member(element, elements) {
      return exists(elements, curry(eq, element));
    };
    var regularContains = function regularContains(e1, e2) {
      var d1 = e1.dom(),
          d2 = e2.dom();
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function ieContains(e1, e2) {
      return $_71sgsmwejk26xncf.documentPositionContainedBy(e1.dom(), e2.dom());
    };
    var browser = $_a9splfwijk26xncl.detect().browser;
    var contains$2 = browser.isIE() ? ieContains : regularContains;
    var $_erd2qdwdjk26xnc5 = {
      eq: eq,
      isEqualNode: isEqualNode,
      member: member,
      contains: contains$2,
      is: $_dvwkndwtjk26xndf.is
    };

    var owner = function owner(element) {
      return Element$$1.fromDom(element.dom().ownerDocument);
    };
    var documentElement = function documentElement(element) {
      return Element$$1.fromDom(element.dom().ownerDocument.documentElement);
    };
    var defaultView = function defaultView(element) {
      var el = element.dom();
      var defaultView = el.ownerDocument.defaultView;
      return Element$$1.fromDom(defaultView);
    };
    var parent = function parent(element) {
      var dom = element.dom();
      return Option.from(dom.parentNode).map(Element$$1.fromDom);
    };
    var findIndex$1 = function findIndex$1(element) {
      return parent(element).bind(function (p) {
        var kin = children(p);
        return findIndex(kin, function (elem) {
          return $_erd2qdwdjk26xnc5.eq(element, elem);
        });
      });
    };
    var parents = function parents(element, isRoot) {
      var stop = isFunction(isRoot) ? isRoot : constant(false);
      var dom = element.dom();
      var ret = [];
      while (dom.parentNode !== null && dom.parentNode !== undefined) {
        var rawParent = dom.parentNode;
        var parent = Element$$1.fromDom(rawParent);
        ret.push(parent);
        if (stop(parent) === true) break;else dom = rawParent;
      }
      return ret;
    };
    var siblings = function siblings(element) {
      var filterSelf = function filterSelf(elements) {
        return filter(elements, function (x) {
          return !$_erd2qdwdjk26xnc5.eq(element, x);
        });
      };
      return parent(element).map(children).map(filterSelf).getOr([]);
    };
    var offsetParent = function offsetParent(element) {
      var dom = element.dom();
      return Option.from(dom.offsetParent).map(Element$$1.fromDom);
    };
    var prevSibling = function prevSibling(element) {
      var dom = element.dom();
      return Option.from(dom.previousSibling).map(Element$$1.fromDom);
    };
    var nextSibling = function nextSibling(element) {
      var dom = element.dom();
      return Option.from(dom.nextSibling).map(Element$$1.fromDom);
    };
    var prevSiblings = function prevSiblings(element) {
      return reverse($_a5t53kwcjk26xnc3.toArray(element, prevSibling));
    };
    var nextSiblings = function nextSiblings(element) {
      return $_a5t53kwcjk26xnc3.toArray(element, nextSibling);
    };
    var children = function children(element) {
      var dom = element.dom();
      return map(dom.childNodes, Element$$1.fromDom);
    };
    var child = function child(element, index) {
      var children = element.dom().childNodes;
      return Option.from(children[index]).map(Element$$1.fromDom);
    };
    var firstChild = function firstChild(element) {
      return child(element, 0);
    };
    var lastChild = function lastChild(element) {
      return child(element, element.dom().childNodes.length - 1);
    };
    var childNodesCount = function childNodesCount(element) {
      return element.dom().childNodes.length;
    };
    var hasChildNodes = function hasChildNodes(element) {
      return element.dom().hasChildNodes();
    };
    var spot = Immutable('element', 'offset');
    var leaf = function leaf(element, offset) {
      var cs = children(element);
      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
    };
    var $_bz9bk2w6jk26xnb7 = {
      owner: owner,
      defaultView: defaultView,
      documentElement: documentElement,
      parent: parent,
      findIndex: findIndex$1,
      parents: parents,
      siblings: siblings,
      prevSibling: prevSibling,
      offsetParent: offsetParent,
      prevSiblings: prevSiblings,
      nextSibling: nextSibling,
      nextSiblings: nextSiblings,
      children: children,
      child: child,
      firstChild: firstChild,
      lastChild: lastChild,
      childNodesCount: childNodesCount,
      hasChildNodes: hasChildNodes,
      leaf: leaf
    };

    var all$1 = function all$1(predicate) {
      return descendants($_bzb7a9w2jk26xnaz.body(), predicate);
    };
    var ancestors = function ancestors(scope, predicate, isRoot) {
      return filter($_bz9bk2w6jk26xnb7.parents(scope, isRoot), predicate);
    };
    var siblings$1 = function siblings$1(scope, predicate) {
      return filter($_bz9bk2w6jk26xnb7.siblings(scope), predicate);
    };
    var children$1 = function children$1(scope, predicate) {
      return filter($_bz9bk2w6jk26xnb7.children(scope), predicate);
    };
    var descendants = function descendants(scope, predicate) {
      var result = [];
      each($_bz9bk2w6jk26xnb7.children(scope), function (x) {
        if (predicate(x)) {
          result = result.concat([x]);
        }
        result = result.concat(descendants(x, predicate));
      });
      return result;
    };
    var $_1v5dlww1jk26xnav = {
      all: all$1,
      ancestors: ancestors,
      siblings: siblings$1,
      children: children$1,
      descendants: descendants
    };

    var all$2 = function all$2(selector) {
      return $_dvwkndwtjk26xndf.all(selector);
    };
    var ancestors$1 = function ancestors$1(scope, selector, isRoot) {
      return $_1v5dlww1jk26xnav.ancestors(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      }, isRoot);
    };
    var siblings$2 = function siblings$2(scope, selector) {
      return $_1v5dlww1jk26xnav.siblings(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      });
    };
    var children$2 = function children$2(scope, selector) {
      return $_1v5dlww1jk26xnav.children(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      });
    };
    var descendants$1 = function descendants$1(scope, selector) {
      return $_dvwkndwtjk26xndf.all(selector, scope);
    };
    var $_g3ve3zw0jk26xnau = {
      all: all$2,
      ancestors: ancestors$1,
      siblings: siblings$2,
      children: children$2,
      descendants: descendants$1
    };

    var trim$1 = global$2.trim;
    var hasContentEditableState = function hasContentEditableState(value) {
      return function (node) {
        if (node && node.nodeType === 1) {
          if (node.contentEditable === value) {
            return true;
          }
          if (node.getAttribute('data-mce-contenteditable') === value) {
            return true;
          }
        }
        return false;
      };
    };
    var isContentEditableTrue = hasContentEditableState('true');
    var isContentEditableFalse = hasContentEditableState('false');
    var create = function create(type, title, url, level, attach) {
      return {
        type: type,
        title: title,
        url: url,
        level: level,
        attach: attach
      };
    };
    var isChildOfContentEditableTrue = function isChildOfContentEditableTrue(node) {
      while (node = node.parentNode) {
        var value = node.contentEditable;
        if (value && value !== 'inherit') {
          return isContentEditableTrue(node);
        }
      }
      return false;
    };
    var select = function select(selector, root) {
      return map($_g3ve3zw0jk26xnau.descendants(Element$$1.fromDom(root), selector), function (element) {
        return element.dom();
      });
    };
    var getElementText = function getElementText(elm) {
      return elm.innerText || elm.textContent;
    };
    var getOrGenerateId = function getOrGenerateId(elm) {
      return elm.id ? elm.id : generate('h');
    };
    var isAnchor = function isAnchor(elm) {
      return elm && elm.nodeName === 'A' && (elm.id || elm.name);
    };
    var isValidAnchor = function isValidAnchor(elm) {
      return isAnchor(elm) && isEditable(elm);
    };
    var isHeader = function isHeader(elm) {
      return elm && /^(H[1-6])$/.test(elm.nodeName);
    };
    var isEditable = function isEditable(elm) {
      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
    };
    var isValidHeader = function isValidHeader(elm) {
      return isHeader(elm) && isEditable(elm);
    };
    var getLevel = function getLevel(elm) {
      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
    };
    var headerTarget = function headerTarget(elm) {
      var headerId = getOrGenerateId(elm);
      var attach = function attach() {
        elm.id = headerId;
      };
      return create('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
    };
    var anchorTarget = function anchorTarget(elm) {
      var anchorId = elm.id || elm.name;
      var anchorText = getElementText(elm);
      return create('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
    };
    var getHeaderTargets = function getHeaderTargets(elms) {
      return map(filter(elms, isValidHeader), headerTarget);
    };
    var getAnchorTargets = function getAnchorTargets(elms) {
      return map(filter(elms, isValidAnchor), anchorTarget);
    };
    var getTargetElements = function getTargetElements(elm) {
      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
      return elms;
    };
    var hasTitle = function hasTitle(target) {
      return trim$1(target.title).length > 0;
    };
    var find$3 = function find$3(elm) {
      var elms = getTargetElements(elm);
      return filter(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
    };
    var $_4llr0vxjk26xnab = { find: find$3 };

    var getActiveEditor = function getActiveEditor() {
      return window.tinymce ? window.tinymce.activeEditor : global$1.activeEditor;
    };
    var history = {};
    var HISTORY_LENGTH = 5;
    var clearHistory = function clearHistory() {
      history = {};
    };
    var toMenuItem = function toMenuItem(target) {
      return {
        title: target.title,
        value: {
          title: { raw: target.title },
          url: target.url,
          attach: target.attach
        }
      };
    };
    var toMenuItems = function toMenuItems(targets) {
      return global$2.map(targets, toMenuItem);
    };
    var staticMenuItem = function staticMenuItem(title, url) {
      return {
        title: title,
        value: {
          title: title,
          url: url,
          attach: noop
        }
      };
    };
    var isUniqueUrl = function isUniqueUrl(url, targets) {
      var foundTarget = exists(targets, function (target) {
        return target.url === url;
      });
      return !foundTarget;
    };
    var getSetting = function getSetting(editorSettings, name, defaultValue) {
      var value = name in editorSettings ? editorSettings[name] : defaultValue;
      return value === false ? null : value;
    };
    var createMenuItems = function createMenuItems(term, targets, fileType, editorSettings) {
      var separator = { title: '-' };
      var fromHistoryMenuItems = function fromHistoryMenuItems(history) {
        var historyItems = history.hasOwnProperty(fileType) ? history[fileType] : [];
        var uniqueHistory = filter(historyItems, function (url) {
          return isUniqueUrl(url, targets);
        });
        return global$2.map(uniqueHistory, function (url) {
          return {
            title: url,
            value: {
              title: url,
              url: url,
              attach: noop
            }
          };
        });
      };
      var fromMenuItems = function fromMenuItems(type) {
        var filteredTargets = filter(targets, function (target) {
          return target.type === type;
        });
        return toMenuItems(filteredTargets);
      };
      var anchorMenuItems = function anchorMenuItems() {
        var anchorMenuItems = fromMenuItems('anchor');
        var topAnchor = getSetting(editorSettings, 'anchor_top', '#top');
        var bottomAchor = getSetting(editorSettings, 'anchor_bottom', '#bottom');
        if (topAnchor !== null) {
          anchorMenuItems.unshift(staticMenuItem('<top>', topAnchor));
        }
        if (bottomAchor !== null) {
          anchorMenuItems.push(staticMenuItem('<bottom>', bottomAchor));
        }
        return anchorMenuItems;
      };
      var join = function join(items) {
        return foldl(items, function (a, b) {
          var bothEmpty = a.length === 0 || b.length === 0;
          return bothEmpty ? a.concat(b) : a.concat(separator, b);
        }, []);
      };
      if (editorSettings.typeahead_urls === false) {
        return [];
      }
      return fileType === 'file' ? join([filterByQuery(term, fromHistoryMenuItems(history)), filterByQuery(term, fromMenuItems('header')), filterByQuery(term, anchorMenuItems())]) : filterByQuery(term, fromHistoryMenuItems(history));
    };
    var addToHistory = function addToHistory(url, fileType) {
      var items = history[fileType];
      if (!/^https?/.test(url)) {
        return;
      }
      if (items) {
        if (indexOf(items, url).isNone()) {
          history[fileType] = items.slice(0, HISTORY_LENGTH).concat(url);
        }
      } else {
        history[fileType] = [url];
      }
    };
    var filterByQuery = function filterByQuery(term, menuItems) {
      var lowerCaseTerm = term.toLowerCase();
      var result = global$2.grep(menuItems, function (item) {
        return item.title.toLowerCase().indexOf(lowerCaseTerm) !== -1;
      });
      return result.length === 1 && result[0].title === term ? [] : result;
    };
    var getTitle = function getTitle(linkDetails) {
      var title = linkDetails.title;
      return title.raw ? title.raw : title;
    };
    var setupAutoCompleteHandler = function setupAutoCompleteHandler(ctrl, editorSettings, bodyElm, fileType) {
      var autocomplete = function autocomplete(term) {
        var linkTargets = $_4llr0vxjk26xnab.find(bodyElm);
        var menuItems = createMenuItems(term, linkTargets, fileType, editorSettings);
        ctrl.showAutoComplete(menuItems, term);
      };
      ctrl.on('autocomplete', function () {
        autocomplete(ctrl.value());
      });
      ctrl.on('selectitem', function (e) {
        var linkDetails = e.value;
        ctrl.value(linkDetails.url);
        var title = getTitle(linkDetails);
        if (fileType === 'image') {
          ctrl.fire('change', {
            meta: {
              alt: title,
              attach: linkDetails.attach
            }
          });
        } else {
          ctrl.fire('change', {
            meta: {
              text: title,
              attach: linkDetails.attach
            }
          });
        }
        ctrl.focus();
      });
      ctrl.on('click', function (e) {
        if (ctrl.value().length === 0 && e.target.nodeName === 'INPUT') {
          autocomplete('');
        }
      });
      ctrl.on('PostRender', function () {
        ctrl.getRoot().on('submit', function (e) {
          if (!e.isDefaultPrevented()) {
            addToHistory(ctrl.value(), fileType);
          }
        });
      });
    };
    var statusToUiState = function statusToUiState(result) {
      var status = result.status,
          message = result.message;
      if (status === 'valid') {
        return {
          status: 'ok',
          message: message
        };
      } else if (status === 'unknown') {
        return {
          status: 'warn',
          message: message
        };
      } else if (status === 'invalid') {
        return {
          status: 'warn',
          message: message
        };
      } else {
        return {
          status: 'none',
          message: ''
        };
      }
    };
    var setupLinkValidatorHandler = function setupLinkValidatorHandler(ctrl, editorSettings, fileType) {
      var validatorHandler = editorSettings.filepicker_validator_handler;
      if (validatorHandler) {
        var validateUrl_1 = function validateUrl_1(url) {
          if (url.length === 0) {
            ctrl.statusLevel('none');
            return;
          }
          validatorHandler({
            url: url,
            type: fileType
          }, function (result) {
            var uiState = statusToUiState(result);
            ctrl.statusMessage(uiState.message);
            ctrl.statusLevel(uiState.status);
          });
        };
        ctrl.state.on('change:value', function (e) {
          validateUrl_1(e.value);
        });
      }
    };
    var FilePicker = ComboBox.extend({
      Statics: { clearHistory: clearHistory },
      init: function init(settings) {
        var self = this,
            editor = getActiveEditor(),
            editorSettings = editor.settings;
        var actionCallback, fileBrowserCallback, fileBrowserCallbackTypes;
        var fileType = settings.filetype;
        settings.spellcheck = false;
        fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
        if (fileBrowserCallbackTypes) {
          fileBrowserCallbackTypes = global$2.makeMap(fileBrowserCallbackTypes, /[, ]/);
        }
        if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType]) {
          fileBrowserCallback = editorSettings.file_picker_callback;
          if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
            actionCallback = function actionCallback() {
              var meta = self.fire('beforecall').meta;
              meta = global$2.extend({ filetype: fileType }, meta);
              fileBrowserCallback.call(editor, function (value, meta) {
                self.value(value).fire('change', { meta: meta });
              }, self.value(), meta);
            };
          } else {
            fileBrowserCallback = editorSettings.file_browser_callback;
            if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
              actionCallback = function actionCallback() {
                fileBrowserCallback(self.getEl('inp').id, self.value(), fileType, window);
              };
            }
          }
        }
        if (actionCallback) {
          settings.icon = 'browse';
          settings.onaction = actionCallback;
        }
        self._super(settings);
        self.classes.add('filepicker');
        setupAutoCompleteHandler(self, editorSettings, editor.getBody(), fileType);
        setupLinkValidatorHandler(self, editorSettings, fileType);
      }
    });

    var FitLayout = AbsoluteLayout.extend({
      recalc: function recalc(container) {
        var contLayoutRect = container.layoutRect(),
            paddingBox = container.paddingBox;
        container.items().filter(':visible').each(function (ctrl) {
          ctrl.layoutRect({
            x: paddingBox.left,
            y: paddingBox.top,
            w: contLayoutRect.innerW - paddingBox.right - paddingBox.left,
            h: contLayoutRect.innerH - paddingBox.top - paddingBox.bottom
          });
          if (ctrl.recalc) {
            ctrl.recalc();
          }
        });
      }
    });

    var FlexLayout = AbsoluteLayout.extend({
      recalc: function recalc(container) {
        var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
        var ctrl, ctrlLayoutRect, ctrlSettings, flex;
        var maxSizeItems = [];
        var size, maxSize, ratio, rect, pos, maxAlignEndPos;
        var sizeName, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
        var alignAxisName, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
        var alignDeltaSizeName, alignContentSizeName;
        var max = Math.max,
            min = Math.min;
        items = container.items().filter(':visible');
        contLayoutRect = container.layoutRect();
        contPaddingBox = container.paddingBox;
        contSettings = container.settings;
        direction = container.isRtl() ? contSettings.direction || 'row-reversed' : contSettings.direction;
        align = contSettings.align;
        pack = container.isRtl() ? contSettings.pack || 'end' : contSettings.pack;
        spacing = contSettings.spacing || 0;
        if (direction === 'row-reversed' || direction === 'column-reverse') {
          items = items.set(items.toArray().reverse());
          direction = direction.split('-')[0];
        }
        if (direction === 'column') {
          posName = 'y';
          sizeName = 'h';
          minSizeName = 'minH';
          maxSizeName = 'maxH';
          innerSizeName = 'innerH';
          beforeName = 'top';
          deltaSizeName = 'deltaH';
          contentSizeName = 'contentH';
          alignBeforeName = 'left';
          alignSizeName = 'w';
          alignAxisName = 'x';
          alignInnerSizeName = 'innerW';
          alignMinSizeName = 'minW';
          alignAfterName = 'right';
          alignDeltaSizeName = 'deltaW';
          alignContentSizeName = 'contentW';
        } else {
          posName = 'x';
          sizeName = 'w';
          minSizeName = 'minW';
          maxSizeName = 'maxW';
          innerSizeName = 'innerW';
          beforeName = 'left';
          deltaSizeName = 'deltaW';
          contentSizeName = 'contentW';
          alignBeforeName = 'top';
          alignSizeName = 'h';
          alignAxisName = 'y';
          alignInnerSizeName = 'innerH';
          alignMinSizeName = 'minH';
          alignAfterName = 'bottom';
          alignDeltaSizeName = 'deltaH';
          alignContentSizeName = 'contentH';
        }
        availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
        maxAlignEndPos = totalFlex = 0;
        for (i = 0, l = items.length; i < l; i++) {
          ctrl = items[i];
          ctrlLayoutRect = ctrl.layoutRect();
          ctrlSettings = ctrl.settings;
          flex = ctrlSettings.flex;
          availableSpace -= i < l - 1 ? spacing : 0;
          if (flex > 0) {
            totalFlex += flex;
            if (ctrlLayoutRect[maxSizeName]) {
              maxSizeItems.push(ctrl);
            }
            ctrlLayoutRect.flex = flex;
          }
          availableSpace -= ctrlLayoutRect[minSizeName];
          size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
          if (size > maxAlignEndPos) {
            maxAlignEndPos = size;
          }
        }
        rect = {};
        if (availableSpace < 0) {
          rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName];
        } else {
          rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName];
        }
        rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[alignDeltaSizeName];
        rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
        rect[alignContentSizeName] = maxAlignEndPos;
        rect.minW = min(rect.minW, contLayoutRect.maxW);
        rect.minH = min(rect.minH, contLayoutRect.maxH);
        rect.minW = max(rect.minW, contLayoutRect.startMinWidth);
        rect.minH = max(rect.minH, contLayoutRect.startMinHeight);
        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
          rect.w = rect.minW;
          rect.h = rect.minH;
          container.layoutRect(rect);
          this.recalc(container);
          if (container._lastRect === null) {
            var parentCtrl = container.parent();
            if (parentCtrl) {
              parentCtrl._lastRect = null;
              parentCtrl.recalc();
            }
          }
          return;
        }
        ratio = availableSpace / totalFlex;
        for (i = 0, l = maxSizeItems.length; i < l; i++) {
          ctrl = maxSizeItems[i];
          ctrlLayoutRect = ctrl.layoutRect();
          maxSize = ctrlLayoutRect[maxSizeName];
          size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
          if (size > maxSize) {
            availableSpace -= ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName];
            totalFlex -= ctrlLayoutRect.flex;
            ctrlLayoutRect.flex = 0;
            ctrlLayoutRect.maxFlexSize = maxSize;
          } else {
            ctrlLayoutRect.maxFlexSize = 0;
          }
        }
        ratio = availableSpace / totalFlex;
        pos = contPaddingBox[beforeName];
        rect = {};
        if (totalFlex === 0) {
          if (pack === 'end') {
            pos = availableSpace + contPaddingBox[beforeName];
          } else if (pack === 'center') {
            pos = Math.round(contLayoutRect[innerSizeName] / 2 - (contLayoutRect[innerSizeName] - availableSpace) / 2) + contPaddingBox[beforeName];
            if (pos < 0) {
              pos = contPaddingBox[beforeName];
            }
          } else if (pack === 'justify') {
            pos = contPaddingBox[beforeName];
            spacing = Math.floor(availableSpace / (items.length - 1));
          }
        }
        rect[alignAxisName] = contPaddingBox[alignBeforeName];
        for (i = 0, l = items.length; i < l; i++) {
          ctrl = items[i];
          ctrlLayoutRect = ctrl.layoutRect();
          size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
          if (align === 'center') {
            rect[alignAxisName] = Math.round(contLayoutRect[alignInnerSizeName] / 2 - ctrlLayoutRect[alignSizeName] / 2);
          } else if (align === 'stretch') {
            rect[alignSizeName] = max(ctrlLayoutRect[alignMinSizeName] || 0, contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]);
            rect[alignAxisName] = contPaddingBox[alignBeforeName];
          } else if (align === 'end') {
            rect[alignAxisName] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top;
          }
          if (ctrlLayoutRect.flex > 0) {
            size += ctrlLayoutRect.flex * ratio;
          }
          rect[sizeName] = size;
          rect[posName] = pos;
          ctrl.layoutRect(rect);
          if (ctrl.recalc) {
            ctrl.recalc();
          }
          pos += size + spacing;
        }
      }
    });

    var FlowLayout = Layout.extend({
      Defaults: {
        containerClass: 'flow-layout',
        controlClass: 'flow-layout-item',
        endClass: 'break'
      },
      recalc: function recalc(container) {
        container.items().filter(':visible').each(function (ctrl) {
          if (ctrl.recalc) {
            ctrl.recalc();
          }
        });
      },
      isNative: function isNative() {
        return true;
      }
    });

    function ClosestOrAncestor(is, ancestor, scope, a, isRoot) {
      return is(scope, a) ? Option.some(scope) : isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
    }

    var first$1 = function first$1(predicate) {
      return descendant($_bzb7a9w2jk26xnaz.body(), predicate);
    };
    var ancestor = function ancestor(scope, predicate, isRoot) {
      var element = scope.dom();
      var stop = isFunction(isRoot) ? isRoot : constant(false);
      while (element.parentNode) {
        element = element.parentNode;
        var el = Element$$1.fromDom(element);
        if (predicate(el)) return Option.some(el);else if (stop(el)) break;
      }
      return Option.none();
    };
    var closest = function closest(scope, predicate, isRoot) {
      var is = function is(scope) {
        return predicate(scope);
      };
      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
    };
    var sibling = function sibling(scope, predicate) {
      var element = scope.dom();
      if (!element.parentNode) return Option.none();
      return child$1(Element$$1.fromDom(element.parentNode), function (x) {
        return !$_erd2qdwdjk26xnc5.eq(scope, x) && predicate(x);
      });
    };
    var child$1 = function child$1(scope, predicate) {
      var result = find(scope.dom().childNodes, compose(predicate, Element$$1.fromDom));
      return result.map(Element$$1.fromDom);
    };
    var descendant = function descendant(scope, predicate) {
      var descend = function descend(node) {
        for (var i = 0; i < node.childNodes.length; i++) {
          if (predicate(Element$$1.fromDom(node.childNodes[i]))) return Option.some(Element$$1.fromDom(node.childNodes[i]));
          var res = descend(node.childNodes[i]);
          if (res.isSome()) return res;
        }
        return Option.none();
      };
      return descend(scope.dom());
    };
    var $_firuvqwzjk26xne7 = {
      first: first$1,
      ancestor: ancestor,
      closest: closest,
      sibling: sibling,
      child: child$1,
      descendant: descendant
    };

    var first$2 = function first$2(selector) {
      return $_dvwkndwtjk26xndf.one(selector);
    };
    var ancestor$1 = function ancestor$1(scope, selector, isRoot) {
      return $_firuvqwzjk26xne7.ancestor(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      }, isRoot);
    };
    var sibling$1 = function sibling$1(scope, selector) {
      return $_firuvqwzjk26xne7.sibling(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      });
    };
    var child$2 = function child$2(scope, selector) {
      return $_firuvqwzjk26xne7.child(scope, function (e) {
        return $_dvwkndwtjk26xndf.is(e, selector);
      });
    };
    var descendant$1 = function descendant$1(scope, selector) {
      return $_dvwkndwtjk26xndf.one(selector, scope);
    };
    var closest$1 = function closest$1(scope, selector, isRoot) {
      return ClosestOrAncestor($_dvwkndwtjk26xndf.is, ancestor$1, scope, selector, isRoot);
    };
    var $_3h3tfwyjk26xne5 = {
      first: first$2,
      ancestor: ancestor$1,
      sibling: sibling$1,
      child: child$2,
      descendant: descendant$1,
      closest: closest$1
    };

    var toggleFormat = function toggleFormat(editor, fmt) {
      return function () {
        editor.execCommand('mceToggleFormat', false, fmt);
      };
    };
    var addFormatChangedListener = function addFormatChangedListener(editor, name, changed) {
      var handler = function handler(state) {
        changed(state, name);
      };
      if (editor.formatter) {
        editor.formatter.formatChanged(name, handler);
      } else {
        editor.on('init', function () {
          editor.formatter.formatChanged(name, handler);
        });
      }
    };
    var postRenderFormatToggle = function postRenderFormatToggle(editor, name) {
      return function (e) {
        addFormatChangedListener(editor, name, function (state) {
          e.control.active(state);
        });
      };
    };

    var register = function register(editor) {
      var alignFormats = ['alignleft', 'aligncenter', 'alignright', 'alignjustify'];
      var defaultAlign = 'alignleft';
      var alignMenuItems = [{
        text: 'Left',
        icon: 'alignleft',
        onclick: toggleFormat(editor, 'alignleft')
      }, {
        text: 'Center',
        icon: 'aligncenter',
        onclick: toggleFormat(editor, 'aligncenter')
      }, {
        text: 'Right',
        icon: 'alignright',
        onclick: toggleFormat(editor, 'alignright')
      }, {
        text: 'Justify',
        icon: 'alignjustify',
        onclick: toggleFormat(editor, 'alignjustify')
      }];
      editor.addMenuItem('align', {
        text: 'Align',
        menu: alignMenuItems
      });
      editor.addButton('align', {
        type: 'menubutton',
        icon: defaultAlign,
        menu: alignMenuItems,
        onShowMenu: function onShowMenu(e) {
          var menu = e.control.menu;
          global$2.each(alignFormats, function (formatName, idx) {
            menu.items().eq(idx).each(function (item) {
              return item.active(editor.formatter.match(formatName));
            });
          });
        },
        onPostRender: function onPostRender(e) {
          var ctrl = e.control;
          global$2.each(alignFormats, function (formatName, idx) {
            addFormatChangedListener(editor, formatName, function (state) {
              ctrl.icon(defaultAlign);
              if (state) {
                ctrl.icon(formatName);
              }
            });
          });
        }
      });
      global$2.each({
        alignleft: ['Align left', 'JustifyLeft'],
        aligncenter: ['Align center', 'JustifyCenter'],
        alignright: ['Align right', 'JustifyRight'],
        alignjustify: ['Justify', 'JustifyFull'],
        alignnone: ['No alignment', 'JustifyNone']
      }, function (item, name) {
        editor.addButton(name, {
          active: false,
          tooltip: item[0],
          cmd: item[1],
          onPostRender: postRenderFormatToggle(editor, name)
        });
      });
    };
    var $_bsyazgx1jk26xnem = { register: register };

    var getFirstFont = function getFirstFont(fontFamily) {
      return fontFamily ? fontFamily.split(',')[0] : '';
    };
    var findMatchingValue = function findMatchingValue(items, fontFamily) {
      var font = fontFamily ? fontFamily.toLowerCase() : '';
      var value;
      global$2.each(items, function (item) {
        if (item.value.toLowerCase() === font) {
          value = item.value;
        }
      });
      global$2.each(items, function (item) {
        if (!value && getFirstFont(item.value).toLowerCase() === getFirstFont(font).toLowerCase()) {
          value = item.value;
        }
      });
      return value;
    };
    var createFontNameListBoxChangeHandler = function createFontNameListBoxChangeHandler(editor, items) {
      return function () {
        var self = this;
        self.state.set('value', null);
        editor.on('init nodeChange', function (e) {
          var fontFamily = editor.queryCommandValue('FontName');
          var match = findMatchingValue(items, fontFamily);
          self.value(match ? match : null);
          if (!match && fontFamily) {
            self.text(getFirstFont(fontFamily));
          }
        });
      };
    };
    var createFormats = function createFormats(formats) {
      formats = formats.replace(/;$/, '').split(';');
      var i = formats.length;
      while (i--) {
        formats[i] = formats[i].split('=');
      }
      return formats;
    };
    var getFontItems = function getFontItems(editor) {
      var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
      var fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
      return global$2.map(fonts, function (font) {
        return {
          text: { raw: font[0] },
          value: font[1],
          textStyle: font[1].indexOf('dings') === -1 ? 'font-family:' + font[1] : ''
        };
      });
    };
    var registerButtons = function registerButtons(editor) {
      editor.addButton('fontselect', function () {
        var items = getFontItems(editor);
        return {
          type: 'listbox',
          text: 'Font Family',
          tooltip: 'Font Family',
          values: items,
          fixedWidth: true,
          onPostRender: createFontNameListBoxChangeHandler(editor, items),
          onselect: function onselect(e) {
            if (e.control.settings.value) {
              editor.execCommand('FontName', false, e.control.settings.value);
            }
          }
        };
      });
    };
    var register$1 = function register$1(editor) {
      registerButtons(editor);
    };
    var $_eh40gtx3jk26xnep = { register: register$1 };

    var round = function round(number, precision) {
      var factor = Math.pow(10, precision);
      return Math.round(number * factor) / factor;
    };
    var toPt = function toPt(fontSize, precision) {
      if (/[0-9.]+px$/.test(fontSize)) {
        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
      }
      return fontSize;
    };
    var findMatchingValue$1 = function findMatchingValue$1(items, pt, px) {
      var value;
      global$2.each(items, function (item) {
        if (item.value === px) {
          value = px;
        } else if (item.value === pt) {
          value = pt;
        }
      });
      return value;
    };
    var createFontSizeListBoxChangeHandler = function createFontSizeListBoxChangeHandler(editor, items) {
      return function () {
        var self = this;
        editor.on('init nodeChange', function (e) {
          var px, pt, precision, match;
          px = editor.queryCommandValue('FontSize');
          if (px) {
            for (precision = 3; !match && precision >= 0; precision--) {
              pt = toPt(px, precision);
              match = findMatchingValue$1(items, pt, px);
            }
          }
          self.value(match ? match : null);
          if (!match) {
            self.text(pt);
          }
        });
      };
    };
    var getFontSizeItems = function getFontSizeItems(editor) {
      var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
      var fontsizeFormats = editor.settings.fontsize_formats || defaultFontsizeFormats;
      return global$2.map(fontsizeFormats.split(' '), function (item) {
        var text = item,
            value = item;
        var values = item.split('=');
        if (values.length > 1) {
          text = values[0];
          value = values[1];
        }
        return {
          text: text,
          value: value
        };
      });
    };
    var registerButtons$1 = function registerButtons$1(editor) {
      editor.addButton('fontsizeselect', function () {
        var items = getFontSizeItems(editor);
        return {
          type: 'listbox',
          text: 'Font Sizes',
          tooltip: 'Font Sizes',
          values: items,
          fixedWidth: true,
          onPostRender: createFontSizeListBoxChangeHandler(editor, items),
          onclick: function onclick(e) {
            if (e.control.settings.value) {
              editor.execCommand('FontSize', false, e.control.settings.value);
            }
          }
        };
      });
    };
    var register$2 = function register$2(editor) {
      registerButtons$1(editor);
    };
    var $_6trubix4jk26xnes = { register: register$2 };

    var hideMenuObjects = function hideMenuObjects(editor, menu) {
      var count = menu.length;
      global$2.each(menu, function (item) {
        if (item.menu) {
          item.hidden = hideMenuObjects(editor, item.menu) === 0;
        }
        var formatName = item.format;
        if (formatName) {
          item.hidden = !editor.formatter.canApply(formatName);
        }
        if (item.hidden) {
          count--;
        }
      });
      return count;
    };
    var hideFormatMenuItems = function hideFormatMenuItems(editor, menu) {
      var count = menu.items().length;
      menu.items().each(function (item) {
        if (item.menu) {
          item.visible(hideFormatMenuItems(editor, item.menu) > 0);
        }
        if (!item.menu && item.settings.menu) {
          item.visible(hideMenuObjects(editor, item.settings.menu) > 0);
        }
        var formatName = item.settings.format;
        if (formatName) {
          item.visible(editor.formatter.canApply(formatName));
        }
        if (!item.visible()) {
          count--;
        }
      });
      return count;
    };
    var createFormatMenu = function createFormatMenu(editor) {
      var count = 0;
      var newFormats = [];
      var defaultStyleFormats = [{
        title: 'Headings',
        items: [{
          title: 'Heading 1',
          format: 'h1'
        }, {
          title: 'Heading 2',
          format: 'h2'
        }, {
          title: 'Heading 3',
          format: 'h3'
        }, {
          title: 'Heading 4',
          format: 'h4'
        }, {
          title: 'Heading 5',
          format: 'h5'
        }, {
          title: 'Heading 6',
          format: 'h6'
        }]
      }, {
        title: 'Inline',
        items: [{
          title: 'Bold',
          icon: 'bold',
          format: 'bold'
        }, {
          title: 'Italic',
          icon: 'italic',
          format: 'italic'
        }, {
          title: 'Underline',
          icon: 'underline',
          format: 'underline'
        }, {
          title: 'Strikethrough',
          icon: 'strikethrough',
          format: 'strikethrough'
        }, {
          title: 'Superscript',
          icon: 'superscript',
          format: 'superscript'
        }, {
          title: 'Subscript',
          icon: 'subscript',
          format: 'subscript'
        }, {
          title: 'Code',
          icon: 'code',
          format: 'code'
        }]
      }, {
        title: 'Blocks',
        items: [{
          title: 'Paragraph',
          format: 'p'
        }, {
          title: 'Blockquote',
          format: 'blockquote'
        }, {
          title: 'Div',
          format: 'div'
        }, {
          title: 'Pre',
          format: 'pre'
        }]
      }, {
        title: 'Alignment',
        items: [{
          title: 'Left',
          icon: 'alignleft',
          format: 'alignleft'
        }, {
          title: 'Center',
          icon: 'aligncenter',
          format: 'aligncenter'
        }, {
          title: 'Right',
          icon: 'alignright',
          format: 'alignright'
        }, {
          title: 'Justify',
          icon: 'alignjustify',
          format: 'alignjustify'
        }]
      }];
      var createMenu = function createMenu(formats) {
        var menu = [];
        if (!formats) {
          return;
        }
        global$2.each(formats, function (format) {
          var menuItem = {
            text: format.title,
            icon: format.icon
          };
          if (format.items) {
            menuItem.menu = createMenu(format.items);
          } else {
            var formatName = format.format || 'custom' + count++;
            if (!format.format) {
              format.name = formatName;
              newFormats.push(format);
            }
            menuItem.format = formatName;
            menuItem.cmd = format.cmd;
          }
          menu.push(menuItem);
        });
        return menu;
      };
      var createStylesMenu = function createStylesMenu() {
        var menu;
        if (editor.settings.style_formats_merge) {
          if (editor.settings.style_formats) {
            menu = createMenu(defaultStyleFormats.concat(editor.settings.style_formats));
          } else {
            menu = createMenu(defaultStyleFormats);
          }
        } else {
          menu = createMenu(editor.settings.style_formats || defaultStyleFormats);
        }
        return menu;
      };
      editor.on('init', function () {
        global$2.each(newFormats, function (format) {
          editor.formatter.register(format.name, format);
        });
      });
      return {
        type: 'menu',
        items: createStylesMenu(),
        onPostRender: function onPostRender(e) {
          editor.fire('renderFormatsMenu', { control: e.control });
        },
        itemDefaults: {
          preview: true,
          textStyle: function textStyle() {
            if (this.settings.format) {
              return editor.formatter.getCssText(this.settings.format);
            }
          },
          onPostRender: function onPostRender() {
            var self = this;
            self.parent().on('show', function () {
              var formatName, command;
              formatName = self.settings.format;
              if (formatName) {
                self.disabled(!editor.formatter.canApply(formatName));
                self.active(editor.formatter.match(formatName));
              }
              command = self.settings.cmd;
              if (command) {
                self.active(editor.queryCommandState(command));
              }
            });
          },
          onclick: function onclick() {
            if (this.settings.format) {
              toggleFormat(editor, this.settings.format)();
            }
            if (this.settings.cmd) {
              editor.execCommand(this.settings.cmd);
            }
          }
        }
      };
    };
    var registerMenuItems = function registerMenuItems(editor, formatMenu) {
      editor.addMenuItem('formats', {
        text: 'Formats',
        menu: formatMenu
      });
    };
    var registerButtons$2 = function registerButtons$2(editor, formatMenu) {
      editor.addButton('styleselect', {
        type: 'menubutton',
        text: 'Formats',
        menu: formatMenu,
        onShowMenu: function onShowMenu() {
          if (editor.settings.style_formats_autohide) {
            hideFormatMenuItems(editor, this.menu);
          }
        }
      });
    };
    var register$3 = function register$3(editor) {
      var formatMenu = createFormatMenu(editor);
      registerMenuItems(editor, formatMenu);
      registerButtons$2(editor, formatMenu);
    };
    var $_c89vutx5jk26xnew = { register: register$3 };

    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
    var createFormats$1 = function createFormats$1(formats) {
      formats = formats.replace(/;$/, '').split(';');
      var i = formats.length;
      while (i--) {
        formats[i] = formats[i].split('=');
      }
      return formats;
    };
    var createListBoxChangeHandler = function createListBoxChangeHandler(editor, items, formatName) {
      return function () {
        var self = this;
        editor.on('nodeChange', function (e) {
          var formatter = editor.formatter;
          var value = null;
          global$2.each(e.parents, function (node) {
            global$2.each(items, function (item) {
              if (formatName) {
                if (formatter.matchNode(node, formatName, { value: item.value })) {
                  value = item.value;
                }
              } else {
                if (formatter.matchNode(node, item.value)) {
                  value = item.value;
                }
              }
              if (value) {
                return false;
              }
            });
            if (value) {
              return false;
            }
          });
          self.value(value);
        });
      };
    };
    var lazyFormatSelectBoxItems = function lazyFormatSelectBoxItems(editor, blocks) {
      return function () {
        var items = [];
        global$2.each(blocks, function (block) {
          items.push({
            text: block[0],
            value: block[1],
            textStyle: function textStyle() {
              return editor.formatter.getCssText(block[1]);
            }
          });
        });
        return {
          type: 'listbox',
          text: blocks[0][0],
          values: items,
          fixedWidth: true,
          onselect: function onselect(e) {
            if (e.control) {
              var fmt = e.control.value();
              toggleFormat(editor, fmt)();
            }
          },
          onPostRender: createListBoxChangeHandler(editor, items)
        };
      };
    };
    var buildMenuItems = function buildMenuItems(editor, blocks) {
      return global$2.map(blocks, function (block) {
        return {
          text: block[0],
          onclick: toggleFormat(editor, block[1]),
          textStyle: function textStyle() {
            return editor.formatter.getCssText(block[1]);
          }
        };
      });
    };
    var register$4 = function register$4(editor) {
      var blocks = createFormats$1(editor.settings.block_formats || defaultBlocks);
      editor.addMenuItem('blockformats', {
        text: 'Blocks',
        menu: buildMenuItems(editor, blocks)
      });
      editor.addButton('formatselect', lazyFormatSelectBoxItems(editor, blocks));
    };
    var $_bfs9h0x6jk26xnf0 = { register: register$4 };

    var createCustomMenuItems = function createCustomMenuItems(editor, names) {
      var items, nameList;
      if (typeof names === 'string') {
        nameList = names.split(' ');
      } else if (global$2.isArray(names)) {
        return flatten(global$2.map(names, function (names) {
          return createCustomMenuItems(editor, names);
        }));
      }
      items = global$2.grep(nameList, function (name) {
        return name === '|' || name in editor.menuItems;
      });
      return global$2.map(items, function (name) {
        return name === '|' ? { text: '-' } : editor.menuItems[name];
      });
    };
    var isSeparator$1 = function isSeparator$1(menuItem) {
      return menuItem && menuItem.text === '-';
    };
    var trimMenuItems = function trimMenuItems(menuItems) {
      var menuItems2 = filter(menuItems, function (menuItem, i, menuItems) {
        return !isSeparator$1(menuItem) || !isSeparator$1(menuItems[i - 1]);
      });
      return filter(menuItems2, function (menuItem, i, menuItems) {
        return !isSeparator$1(menuItem) || i > 0 && i < menuItems.length - 1;
      });
    };
    var createContextMenuItems = function createContextMenuItems(editor, context) {
      var outputMenuItems = [{ text: '-' }];
      var menuItems = global$2.grep(editor.menuItems, function (menuItem) {
        return menuItem.context === context;
      });
      global$2.each(menuItems, function (menuItem) {
        if (menuItem.separator === 'before') {
          outputMenuItems.push({ text: '|' });
        }
        if (menuItem.prependToContext) {
          outputMenuItems.unshift(menuItem);
        } else {
          outputMenuItems.push(menuItem);
        }
        if (menuItem.separator === 'after') {
          outputMenuItems.push({ text: '|' });
        }
      });
      return outputMenuItems;
    };
    var createInsertMenu = function createInsertMenu(editor) {
      var insertButtonItems = editor.settings.insert_button_items;
      if (insertButtonItems) {
        return trimMenuItems(createCustomMenuItems(editor, insertButtonItems));
      } else {
        return trimMenuItems(createContextMenuItems(editor, 'insert'));
      }
    };
    var registerButtons$3 = function registerButtons$3(editor) {
      editor.addButton('insert', {
        type: 'menubutton',
        icon: 'insert',
        menu: [],
        oncreatemenu: function oncreatemenu() {
          this.menu.add(createInsertMenu(editor));
          this.menu.renderNew();
        }
      });
    };
    var register$5 = function register$5(editor) {
      registerButtons$3(editor);
    };
    var $_5a1ruax7jk26xnf3 = { register: register$5 };

    var registerFormatButtons = function registerFormatButtons(editor) {
      global$2.each({
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikethrough: 'Strikethrough',
        subscript: 'Subscript',
        superscript: 'Superscript'
      }, function (text, name) {
        editor.addButton(name, {
          active: false,
          tooltip: text,
          onPostRender: postRenderFormatToggle(editor, name),
          onclick: toggleFormat(editor, name)
        });
      });
    };
    var registerCommandButtons = function registerCommandButtons(editor) {
      global$2.each({
        outdent: ['Decrease indent', 'Outdent'],
        indent: ['Increase indent', 'Indent'],
        cut: ['Cut', 'Cut'],
        copy: ['Copy', 'Copy'],
        paste: ['Paste', 'Paste'],
        help: ['Help', 'mceHelp'],
        selectall: ['Select all', 'SelectAll'],
        visualaid: ['Visual aids', 'mceToggleVisualAid'],
        newdocument: ['New document', 'mceNewDocument'],
        removeformat: ['Clear formatting', 'RemoveFormat'],
        remove: ['Remove', 'Delete']
      }, function (item, name) {
        editor.addButton(name, {
          tooltip: item[0],
          cmd: item[1]
        });
      });
    };
    var registerCommandToggleButtons = function registerCommandToggleButtons(editor) {
      global$2.each({
        blockquote: ['Blockquote', 'mceBlockQuote'],
        subscript: ['Subscript', 'Subscript'],
        superscript: ['Superscript', 'Superscript']
      }, function (item, name) {
        editor.addButton(name, {
          active: false,
          tooltip: item[0],
          cmd: item[1],
          onPostRender: postRenderFormatToggle(editor, name)
        });
      });
    };
    var registerButtons$4 = function registerButtons$4(editor) {
      registerFormatButtons(editor);
      registerCommandButtons(editor);
      registerCommandToggleButtons(editor);
    };
    var registerMenuItems$1 = function registerMenuItems$1(editor) {
      global$2.each({
        bold: ['Bold', 'Bold', 'Meta+B'],
        italic: ['Italic', 'Italic', 'Meta+I'],
        underline: ['Underline', 'Underline', 'Meta+U'],
        strikethrough: ['Strikethrough', 'Strikethrough'],
        subscript: ['Subscript', 'Subscript'],
        superscript: ['Superscript', 'Superscript'],
        removeformat: ['Clear formatting', 'RemoveFormat'],
        newdocument: ['New document', 'mceNewDocument'],
        cut: ['Cut', 'Cut', 'Meta+X'],
        copy: ['Copy', 'Copy', 'Meta+C'],
        paste: ['Paste', 'Paste', 'Meta+V'],
        selectall: ['Select all', 'SelectAll', 'Meta+A']
      }, function (item, name) {
        editor.addMenuItem(name, {
          text: item[0],
          icon: name,
          shortcut: item[2],
          cmd: item[1]
        });
      });
      editor.addMenuItem('codeformat', {
        text: 'Code',
        icon: 'code',
        onclick: toggleFormat(editor, 'code')
      });
    };
    var register$6 = function register$6(editor) {
      registerButtons$4(editor);
      registerMenuItems$1(editor);
    };
    var $_927zdmx8jk26xnf7 = { register: register$6 };

    var toggleUndoRedoState = function toggleUndoRedoState(editor, type) {
      return function () {
        var self = this;
        var checkState = function checkState() {
          var typeFn = type === 'redo' ? 'hasRedo' : 'hasUndo';
          return editor.undoManager ? editor.undoManager[typeFn]() : false;
        };
        self.disabled(!checkState());
        editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function () {
          self.disabled(editor.readonly || !checkState());
        });
      };
    };
    var registerMenuItems$2 = function registerMenuItems$2(editor) {
      editor.addMenuItem('undo', {
        text: 'Undo',
        icon: 'undo',
        shortcut: 'Meta+Z',
        onPostRender: toggleUndoRedoState(editor, 'undo'),
        cmd: 'undo'
      });
      editor.addMenuItem('redo', {
        text: 'Redo',
        icon: 'redo',
        shortcut: 'Meta+Y',
        onPostRender: toggleUndoRedoState(editor, 'redo'),
        cmd: 'redo'
      });
    };
    var registerButtons$5 = function registerButtons$5(editor) {
      editor.addButton('undo', {
        tooltip: 'Undo',
        onPostRender: toggleUndoRedoState(editor, 'undo'),
        cmd: 'undo'
      });
      editor.addButton('redo', {
        tooltip: 'Redo',
        onPostRender: toggleUndoRedoState(editor, 'redo'),
        cmd: 'redo'
      });
    };
    var register$7 = function register$7(editor) {
      registerMenuItems$2(editor);
      registerButtons$5(editor);
    };
    var $_bddbujx9jk26xnfa = { register: register$7 };

    var toggleVisualAidState = function toggleVisualAidState(editor) {
      return function () {
        var self = this;
        editor.on('VisualAid', function (e) {
          self.active(e.hasVisual);
        });
        self.active(editor.hasVisual);
      };
    };
    var registerMenuItems$3 = function registerMenuItems$3(editor) {
      editor.addMenuItem('visualaid', {
        text: 'Visual aids',
        selectable: true,
        onPostRender: toggleVisualAidState(editor),
        cmd: 'mceToggleVisualAid'
      });
    };
    var register$8 = function register$8(editor) {
      registerMenuItems$3(editor);
    };
    var $_7kwpgcxajk26xnfb = { register: register$8 };

    var setupEnvironment = function setupEnvironment() {
      Widget.tooltips = !global$8.iOS;
      Control$1.translate = function (text) {
        return global$1.translate(text);
      };
    };
    var setupUiContainer = function setupUiContainer(editor) {
      if (editor.settings.ui_container) {
        global$8.container = $_3h3tfwyjk26xne5.descendant(Element$$1.fromDom(document.body), editor.settings.ui_container).fold(constant(null), function (elm) {
          return elm.dom();
        });
      }
    };
    var setupRtlMode = function setupRtlMode(editor) {
      if (editor.rtl) {
        Control$1.rtl = true;
      }
    };
    var setupHideFloatPanels = function setupHideFloatPanels(editor) {
      editor.on('mousedown', function () {
        FloatPanel.hideAll();
      });
    };
    var setup$1 = function setup$1(editor) {
      setupRtlMode(editor);
      setupHideFloatPanels(editor);
      setupUiContainer(editor);
      setupEnvironment();
      $_bfs9h0x6jk26xnf0.register(editor);
      $_bsyazgx1jk26xnem.register(editor);
      $_927zdmx8jk26xnf7.register(editor);
      $_bddbujx9jk26xnfa.register(editor);
      $_6trubix4jk26xnes.register(editor);
      $_eh40gtx3jk26xnep.register(editor);
      $_c89vutx5jk26xnew.register(editor);
      $_7kwpgcxajk26xnfb.register(editor);
      $_5a1ruax7jk26xnf3.register(editor);
    };
    var $_dytu03wxjk26xne0 = { setup: setup$1 };

    var GridLayout = AbsoluteLayout.extend({
      recalc: function recalc(container) {
        var settings, rows, cols, items, contLayoutRect, width, height, rect, ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY;
        var colWidths = [];
        var rowHeights = [];
        var ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
        settings = container.settings;
        items = container.items().filter(':visible');
        contLayoutRect = container.layoutRect();
        cols = settings.columns || Math.ceil(Math.sqrt(items.length));
        rows = Math.ceil(items.length / cols);
        spacingH = settings.spacingH || settings.spacing || 0;
        spacingV = settings.spacingV || settings.spacing || 0;
        alignH = settings.alignH || settings.align;
        alignV = settings.alignV || settings.align;
        contPaddingBox = container.paddingBox;
        reverseRows = 'reverseRows' in settings ? settings.reverseRows : container.isRtl();
        if (alignH && typeof alignH === 'string') {
          alignH = [alignH];
        }
        if (alignV && typeof alignV === 'string') {
          alignV = [alignV];
        }
        for (x = 0; x < cols; x++) {
          colWidths.push(0);
        }
        for (y = 0; y < rows; y++) {
          rowHeights.push(0);
        }
        for (y = 0; y < rows; y++) {
          for (x = 0; x < cols; x++) {
            ctrl = items[y * cols + x];
            if (!ctrl) {
              break;
            }
            ctrlLayoutRect = ctrl.layoutRect();
            ctrlMinWidth = ctrlLayoutRect.minW;
            ctrlMinHeight = ctrlLayoutRect.minH;
            colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
            rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y];
          }
        }
        availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
        for (maxX = 0, x = 0; x < cols; x++) {
          maxX += colWidths[x] + (x > 0 ? spacingH : 0);
          availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x];
        }
        availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
        for (maxY = 0, y = 0; y < rows; y++) {
          maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
          availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y];
        }
        maxX += contPaddingBox.left + contPaddingBox.right;
        maxY += contPaddingBox.top + contPaddingBox.bottom;
        rect = {};
        rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
        rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
        rect.contentW = rect.minW - contLayoutRect.deltaW;
        rect.contentH = rect.minH - contLayoutRect.deltaH;
        rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
        rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
        rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
        rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
        if (contLayoutRect.autoResize && (rect.minW !== contLayoutRect.minW || rect.minH !== contLayoutRect.minH)) {
          rect.w = rect.minW;
          rect.h = rect.minH;
          container.layoutRect(rect);
          this.recalc(container);
          if (container._lastRect === null) {
            var parentCtrl = container.parent();
            if (parentCtrl) {
              parentCtrl._lastRect = null;
              parentCtrl.recalc();
            }
          }
          return;
        }
        if (contLayoutRect.autoResize) {
          rect = container.layoutRect(rect);
          rect.contentW = rect.minW - contLayoutRect.deltaW;
          rect.contentH = rect.minH - contLayoutRect.deltaH;
        }
        var flexV;
        if (settings.packV === 'start') {
          flexV = 0;
        } else {
          flexV = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0;
        }
        var totalFlex = 0;
        var flexWidths = settings.flexWidths;
        if (flexWidths) {
          for (x = 0; x < flexWidths.length; x++) {
            totalFlex += flexWidths[x];
          }
        } else {
          totalFlex = cols;
        }
        var ratio = availableWidth / totalFlex;
        for (x = 0; x < cols; x++) {
          colWidths[x] += flexWidths ? flexWidths[x] * ratio : ratio;
        }
        posY = contPaddingBox.top;
        for (y = 0; y < rows; y++) {
          posX = contPaddingBox.left;
          height = rowHeights[y] + flexV;
          for (x = 0; x < cols; x++) {
            if (reverseRows) {
              idx = y * cols + cols - 1 - x;
            } else {
              idx = y * cols + x;
            }
            ctrl = items[idx];
            if (!ctrl) {
              break;
            }
            ctrlSettings = ctrl.settings;
            ctrlLayoutRect = ctrl.layoutRect();
            width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
            ctrlLayoutRect.x = posX;
            ctrlLayoutRect.y = posY;
            align = ctrlSettings.alignH || (alignH ? alignH[x] || alignH[0] : null);
            if (align === 'center') {
              ctrlLayoutRect.x = posX + width / 2 - ctrlLayoutRect.w / 2;
            } else if (align === 'right') {
              ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w;
            } else if (align === 'stretch') {
              ctrlLayoutRect.w = width;
            }
            align = ctrlSettings.alignV || (alignV ? alignV[x] || alignV[0] : null);
            if (align === 'center') {
              ctrlLayoutRect.y = posY + height / 2 - ctrlLayoutRect.h / 2;
            } else if (align === 'bottom') {
              ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h;
            } else if (align === 'stretch') {
              ctrlLayoutRect.h = height;
            }
            ctrl.layoutRect(ctrlLayoutRect);
            posX += width + spacingH;
            if (ctrl.recalc) {
              ctrl.recalc();
            }
          }
          posY += height + spacingV;
        }
      }
    });

    var Iframe$1 = Widget.extend({
      renderHtml: function renderHtml() {
        var self = this;
        self.classes.add('iframe');
        self.canFocus = false;
        return '<iframe id="' + self._id + '" class="' + self.classes + '" tabindex="-1" src="' + (self.settings.url || 'javascript:\'\'') + '" frameborder="0"></iframe>';
      },
      src: function src(_src) {
        this.getEl().src = _src;
      },
      html: function html(_html, callback) {
        var self = this,
            body = this.getEl().contentWindow.document.body;
        if (!body) {
          global$7.setTimeout(function () {
            self.html(_html);
          });
        } else {
          body.innerHTML = _html;
          if (callback) {
            callback();
          }
        }
        return this;
      }
    });

    var InfoBox = Widget.extend({
      init: function init(settings) {
        var self = this;
        self._super(settings);
        self.classes.add('widget').add('infobox');
        self.canFocus = false;
      },
      severity: function severity(level) {
        this.classes.remove('error');
        this.classes.remove('warning');
        this.classes.remove('success');
        this.classes.add(level);
      },
      help: function help(state) {
        this.state.set('help', state);
      },
      renderHtml: function renderHtml() {
        var self = this,
            prefix = self.classPrefix;
        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<div id="' + self._id + '-body">' + self.encode(self.state.get('text')) + '<button role="button" tabindex="-1">' + '<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' + '</button>' + '</div>' + '</div>';
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:text', function (e) {
          self.getEl('body').firstChild.data = self.encode(e.value);
          if (self.state.get('rendered')) {
            self.updateLayoutRect();
          }
        });
        self.state.on('change:help', function (e) {
          self.classes.toggle('has-help', e.value);
          if (self.state.get('rendered')) {
            self.updateLayoutRect();
          }
        });
        return self._super();
      }
    });

    var Label = Widget.extend({
      init: function init(settings) {
        var self = this;
        self._super(settings);
        self.classes.add('widget').add('label');
        self.canFocus = false;
        if (settings.multiline) {
          self.classes.add('autoscroll');
        }
        if (settings.strong) {
          self.classes.add('strong');
        }
      },
      initLayoutRect: function initLayoutRect() {
        var self = this,
            layoutRect = self._super();
        if (self.settings.multiline) {
          var size = funcs.getSize(self.getEl());
          if (size.width > layoutRect.maxW) {
            layoutRect.minW = layoutRect.maxW;
            self.classes.add('multiline');
          }
          self.getEl().style.width = layoutRect.minW + 'px';
          layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, funcs.getSize(self.getEl()).height);
        }
        return layoutRect;
      },
      repaint: function repaint() {
        var self = this;
        if (!self.settings.multiline) {
          self.getEl().style.lineHeight = self.layoutRect().h + 'px';
        }
        return self._super();
      },
      severity: function severity(level) {
        this.classes.remove('error');
        this.classes.remove('warning');
        this.classes.remove('success');
        this.classes.add(level);
      },
      renderHtml: function renderHtml() {
        var self = this;
        var targetCtrl,
            forName,
            forId = self.settings.forId;
        var text = self.settings.html ? self.settings.html : self.encode(self.state.get('text'));
        if (!forId && (forName = self.settings.forName)) {
          targetCtrl = self.getRoot().find('#' + forName)[0];
          if (targetCtrl) {
            forId = targetCtrl._id;
          }
        }
        if (forId) {
          return '<label id="' + self._id + '" class="' + self.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' + text + '</label>';
        }
        return '<span id="' + self._id + '" class="' + self.classes + '">' + text + '</span>';
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:text', function (e) {
          self.innerHtml(self.encode(e.value));
          if (self.state.get('rendered')) {
            self.updateLayoutRect();
          }
        });
        return self._super();
      }
    });

    var Toolbar$1 = Container.extend({
      Defaults: {
        role: 'toolbar',
        layout: 'flow'
      },
      init: function init(settings) {
        var self = this;
        self._super(settings);
        self.classes.add('toolbar');
      },
      postRender: function postRender() {
        var self = this;
        self.items().each(function (ctrl) {
          ctrl.classes.add('toolbar-item');
        });
        return self._super();
      }
    });

    var MenuBar = Toolbar$1.extend({
      Defaults: {
        role: 'menubar',
        containerCls: 'menubar',
        ariaRoot: true,
        defaults: { type: 'menubutton' }
      }
    });

    function isChildOf$1(node, parent$$1) {
      while (node) {
        if (parent$$1 === node) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }
    var MenuButton = Button.extend({
      init: function init(settings) {
        var self$$1 = this;
        self$$1._renderOpen = true;
        self$$1._super(settings);
        settings = self$$1.settings;
        self$$1.classes.add('menubtn');
        if (settings.fixedWidth) {
          self$$1.classes.add('fixed-width');
        }
        self$$1.aria('haspopup', true);
        self$$1.state.set('menu', settings.menu || self$$1.render());
      },
      showMenu: function showMenu(toggle) {
        var self$$1 = this;
        var menu;
        if (self$$1.menu && self$$1.menu.visible() && toggle !== false) {
          return self$$1.hideMenu();
        }
        if (!self$$1.menu) {
          menu = self$$1.state.get('menu') || [];
          self$$1.classes.add('opened');
          if (menu.length) {
            menu = {
              type: 'menu',
              animate: true,
              items: menu
            };
          } else {
            menu.type = menu.type || 'menu';
            menu.animate = true;
          }
          if (!menu.renderTo) {
            self$$1.menu = global$4.create(menu).parent(self$$1).renderTo();
          } else {
            self$$1.menu = menu.parent(self$$1).show().renderTo();
          }
          self$$1.fire('createmenu');
          self$$1.menu.reflow();
          self$$1.menu.on('cancel', function (e) {
            if (e.control.parent() === self$$1.menu) {
              e.stopPropagation();
              self$$1.focus();
              self$$1.hideMenu();
            }
          });
          self$$1.menu.on('select', function () {
            self$$1.focus();
          });
          self$$1.menu.on('show hide', function (e) {
            if (e.control === self$$1.menu) {
              self$$1.activeMenu(e.type === 'show');
              self$$1.classes.toggle('opened', e.type === 'show');
            }
            self$$1.aria('expanded', e.type === 'show');
          }).fire('show');
        }
        self$$1.menu.show();
        self$$1.menu.layoutRect({ w: self$$1.layoutRect().w });
        self$$1.menu.repaint();
        self$$1.menu.moveRel(self$$1.getEl(), self$$1.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
        self$$1.fire('showmenu');
      },
      hideMenu: function hideMenu() {
        var self$$1 = this;
        if (self$$1.menu) {
          self$$1.menu.items().each(function (item) {
            if (item.hideMenu) {
              item.hideMenu();
            }
          });
          self$$1.menu.hide();
        }
      },
      activeMenu: function activeMenu(state) {
        this.classes.toggle('active', state);
      },
      renderHtml: function renderHtml() {
        var self$$1 = this,
            id = self$$1._id,
            prefix = self$$1.classPrefix;
        var icon = self$$1.settings.icon,
            image;
        var text = self$$1.state.get('text');
        var textHtml = '';
        image = self$$1.settings.image;
        if (image) {
          icon = 'none';
          if (typeof image !== 'string') {
            image = window.getSelection ? image[0] : image[1];
          }
          image = ' style="background-image: url(\'' + image + '\')"';
        } else {
          image = '';
        }
        if (text) {
          self$$1.classes.add('btn-has-text');
          textHtml = '<span class="' + prefix + 'txt">' + self$$1.encode(text) + '</span>';
        }
        icon = self$$1.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
        self$$1.aria('role', self$$1.parent() instanceof MenuBar ? 'menuitem' : 'button');
        return '<div id="' + id + '" class="' + self$$1.classes + '" tabindex="-1" aria-labelledby="' + id + '">' + '<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
      },
      postRender: function postRender() {
        var self$$1 = this;
        self$$1.on('click', function (e) {
          if (e.control === self$$1 && isChildOf$1(e.target, self$$1.getEl())) {
            self$$1.focus();
            self$$1.showMenu(!e.aria);
            if (e.aria) {
              self$$1.menu.items().filter(':visible')[0].focus();
            }
          }
        });
        self$$1.on('mouseenter', function (e) {
          var overCtrl = e.control;
          var parent$$1 = self$$1.parent();
          var hasVisibleSiblingMenu;
          if (overCtrl && parent$$1 && overCtrl instanceof MenuButton && overCtrl.parent() === parent$$1) {
            parent$$1.items().filter('MenuButton').each(function (ctrl) {
              if (ctrl.hideMenu && ctrl !== overCtrl) {
                if (ctrl.menu && ctrl.menu.visible()) {
                  hasVisibleSiblingMenu = true;
                }
                ctrl.hideMenu();
              }
            });
            if (hasVisibleSiblingMenu) {
              overCtrl.focus();
              overCtrl.showMenu();
            }
          }
        });
        return self$$1._super();
      },
      bindStates: function bindStates() {
        var self$$1 = this;
        self$$1.state.on('change:menu', function () {
          if (self$$1.menu) {
            self$$1.menu.remove();
          }
          self$$1.menu = null;
        });
        return self$$1._super();
      },
      remove: function remove() {
        this._super();
        if (this.menu) {
          this.menu.remove();
        }
      }
    });

    var Menu = FloatPanel.extend({
      Defaults: {
        defaultType: 'menuitem',
        border: 1,
        layout: 'stack',
        role: 'application',
        bodyRole: 'menu',
        ariaRoot: true
      },
      init: function init(settings) {
        var self = this;
        settings.autohide = true;
        settings.constrainToViewport = true;
        if (typeof settings.items === 'function') {
          settings.itemsFactory = settings.items;
          settings.items = [];
        }
        if (settings.itemDefaults) {
          var items = settings.items;
          var i = items.length;
          while (i--) {
            items[i] = global$2.extend({}, settings.itemDefaults, items[i]);
          }
        }
        self._super(settings);
        self.classes.add('menu');
        if (settings.animate && global$8.ie !== 11) {
          self.classes.add('animate');
        }
      },
      repaint: function repaint() {
        this.classes.toggle('menu-align', true);
        this._super();
        this.getEl().style.height = '';
        this.getEl('body').style.height = '';
        return this;
      },
      cancel: function cancel() {
        var self = this;
        self.hideAll();
        self.fire('select');
      },
      load: function load() {
        var self = this;
        var time, factory;
        function hideThrobber() {
          if (self.throbber) {
            self.throbber.hide();
            self.throbber = null;
          }
        }
        factory = self.settings.itemsFactory;
        if (!factory) {
          return;
        }
        if (!self.throbber) {
          self.throbber = new Throbber(self.getEl('body'), true);
          if (self.items().length === 0) {
            self.throbber.show();
            self.fire('loading');
          } else {
            self.throbber.show(100, function () {
              self.items().remove();
              self.fire('loading');
            });
          }
          self.on('hide close', hideThrobber);
        }
        self.requestTime = time = new Date().getTime();
        self.settings.itemsFactory(function (items) {
          if (items.length === 0) {
            self.hide();
            return;
          }
          if (self.requestTime !== time) {
            return;
          }
          self.getEl().style.width = '';
          self.getEl('body').style.width = '';
          hideThrobber();
          self.items().remove();
          self.getEl('body').innerHTML = '';
          self.add(items);
          self.renderNew();
          self.fire('loaded');
        });
      },
      hideAll: function hideAll() {
        var self = this;
        this.find('menuitem').exec('hideMenu');
        return self._super();
      },
      preRender: function preRender() {
        var self = this;
        self.items().each(function (ctrl) {
          var settings = ctrl.settings;
          if (settings.icon || settings.image || settings.selectable) {
            self._hasIcons = true;
            return false;
          }
        });
        if (self.settings.itemsFactory) {
          self.on('postrender', function () {
            if (self.settings.itemsFactory) {
              self.load();
            }
          });
        }
        self.on('show hide', function (e) {
          if (e.control === self) {
            if (e.type === 'show') {
              global$7.setTimeout(function () {
                self.classes.add('in');
              }, 0);
            } else {
              self.classes.remove('in');
            }
          }
        });
        return self._super();
      }
    });

    var ListBox = MenuButton.extend({
      init: function init(settings) {
        var self = this;
        var values, selected, selectedText, lastItemCtrl;
        function setSelected(menuValues) {
          for (var i = 0; i < menuValues.length; i++) {
            selected = menuValues[i].selected || settings.value === menuValues[i].value;
            if (selected) {
              selectedText = selectedText || menuValues[i].text;
              self.state.set('value', menuValues[i].value);
              return true;
            }
            if (menuValues[i].menu) {
              if (setSelected(menuValues[i].menu)) {
                return true;
              }
            }
          }
        }
        self._super(settings);
        settings = self.settings;
        self._values = values = settings.values;
        if (values) {
          if (typeof settings.value !== 'undefined') {
            setSelected(values);
          }
          if (!selected && values.length > 0) {
            selectedText = values[0].text;
            self.state.set('value', values[0].value);
          }
          self.state.set('menu', values);
        }
        self.state.set('text', settings.text || selectedText);
        self.classes.add('listbox');
        self.on('select', function (e) {
          var ctrl = e.control;
          if (lastItemCtrl) {
            e.lastControl = lastItemCtrl;
          }
          if (settings.multiple) {
            ctrl.active(!ctrl.active());
          } else {
            self.value(e.control.value());
          }
          lastItemCtrl = ctrl;
        });
      },
      value: function value(_value3) {
        if (arguments.length === 0) {
          return this.state.get('value');
        }
        if (typeof _value3 === 'undefined') {
          return this;
        }
        if (this.settings.values) {
          var matchingValues = global$2.grep(this.settings.values, function (a) {
            return a.value === _value3;
          });
          if (matchingValues.length > 0) {
            this.state.set('value', _value3);
          } else if (_value3 === null) {
            this.state.set('value', null);
          }
        } else {
          this.state.set('value', _value3);
        }
        return this;
      },
      bindStates: function bindStates() {
        var self = this;
        function activateMenuItemsByValue(menu, value) {
          if (menu instanceof Menu) {
            menu.items().each(function (ctrl) {
              if (!ctrl.hasMenus()) {
                ctrl.active(ctrl.value() === value);
              }
            });
          }
        }
        function getSelectedItem(menuValues, value) {
          var selectedItem;
          if (!menuValues) {
            return;
          }
          for (var i = 0; i < menuValues.length; i++) {
            if (menuValues[i].value === value) {
              return menuValues[i];
            }
            if (menuValues[i].menu) {
              selectedItem = getSelectedItem(menuValues[i].menu, value);
              if (selectedItem) {
                return selectedItem;
              }
            }
          }
        }
        self.on('show', function (e) {
          activateMenuItemsByValue(e.control, self.value());
        });
        self.state.on('change:value', function (e) {
          var selectedItem = getSelectedItem(self.state.get('menu'), e.value);
          if (selectedItem) {
            self.text(selectedItem.text);
          } else {
            self.text(self.settings.text);
          }
        });
        return self._super();
      }
    });

    var toggleTextStyle = function toggleTextStyle(ctrl, state) {
      var textStyle = ctrl._textStyle;
      if (textStyle) {
        var textElm = ctrl.getEl('text');
        textElm.setAttribute('style', textStyle);
        if (state) {
          textElm.style.color = '';
          textElm.style.backgroundColor = '';
        }
      }
    };
    var MenuItem = Widget.extend({
      Defaults: {
        border: 0,
        role: 'menuitem'
      },
      init: function init(settings) {
        var self = this;
        var text;
        self._super(settings);
        settings = self.settings;
        self.classes.add('menu-item');
        if (settings.menu) {
          self.classes.add('menu-item-expand');
        }
        if (settings.preview) {
          self.classes.add('menu-item-preview');
        }
        text = self.state.get('text');
        if (text === '-' || text === '|') {
          self.classes.add('menu-item-sep');
          self.aria('role', 'separator');
          self.state.set('text', '-');
        }
        if (settings.selectable) {
          self.aria('role', 'menuitemcheckbox');
          self.classes.add('menu-item-checkbox');
          settings.icon = 'selected';
        }
        if (!settings.preview && !settings.selectable) {
          self.classes.add('menu-item-normal');
        }
        self.on('mousedown', function (e) {
          e.preventDefault();
        });
        if (settings.menu && !settings.ariaHideMenu) {
          self.aria('haspopup', true);
        }
      },
      hasMenus: function hasMenus() {
        return !!this.settings.menu;
      },
      showMenu: function showMenu() {
        var self = this;
        var settings = self.settings;
        var menu;
        var parent = self.parent();
        parent.items().each(function (ctrl) {
          if (ctrl !== self) {
            ctrl.hideMenu();
          }
        });
        if (settings.menu) {
          menu = self.menu;
          if (!menu) {
            menu = settings.menu;
            if (menu.length) {
              menu = {
                type: 'menu',
                items: menu
              };
            } else {
              menu.type = menu.type || 'menu';
            }
            if (parent.settings.itemDefaults) {
              menu.itemDefaults = parent.settings.itemDefaults;
            }
            menu = self.menu = global$4.create(menu).parent(self).renderTo();
            menu.reflow();
            menu.on('cancel', function (e) {
              e.stopPropagation();
              self.focus();
              menu.hide();
            });
            menu.on('show hide', function (e) {
              if (e.control.items) {
                e.control.items().each(function (ctrl) {
                  ctrl.active(ctrl.settings.selected);
                });
              }
            }).fire('show');
            menu.on('hide', function (e) {
              if (e.control === menu) {
                self.classes.remove('selected');
              }
            });
            menu.submenu = true;
          } else {
            menu.show();
          }
          menu._parentMenu = parent;
          menu.classes.add('menu-sub');
          var rel = menu.testMoveRel(self.getEl(), self.isRtl() ? ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'] : ['tr-tl', 'br-bl', 'tl-tr', 'bl-br']);
          menu.moveRel(self.getEl(), rel);
          menu.rel = rel;
          rel = 'menu-sub-' + rel;
          menu.classes.remove(menu._lastRel).add(rel);
          menu._lastRel = rel;
          self.classes.add('selected');
          self.aria('expanded', true);
        }
      },
      hideMenu: function hideMenu() {
        var self = this;
        if (self.menu) {
          self.menu.items().each(function (item) {
            if (item.hideMenu) {
              item.hideMenu();
            }
          });
          self.menu.hide();
          self.aria('expanded', false);
        }
        return self;
      },
      renderHtml: function renderHtml() {
        var self = this;
        var id = self._id;
        var settings = self.settings;
        var prefix = self.classPrefix;
        var text = self.state.get('text');
        var icon = self.settings.icon,
            image = '',
            shortcut = settings.shortcut;
        var url = self.encode(settings.url),
            iconHtml = '';
        function convertShortcut(shortcut) {
          var i,
              value,
              replace = {};
          if (global$8.mac) {
            replace = {
              alt: '&#x2325;',
              ctrl: '&#x2318;',
              shift: '&#x21E7;',
              meta: '&#x2318;'
            };
          } else {
            replace = { meta: 'Ctrl' };
          }
          shortcut = shortcut.split('+');
          for (i = 0; i < shortcut.length; i++) {
            value = replace[shortcut[i].toLowerCase()];
            if (value) {
              shortcut[i] = value;
            }
          }
          return shortcut.join('+');
        }
        function escapeRegExp(str) {
          return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }
        function markMatches(text) {
          var match = settings.match || '';
          return match ? text.replace(new RegExp(escapeRegExp(match), 'gi'), function (match) {
            return '!mce~match[' + match + ']mce~match!';
          }) : text;
        }
        function boldMatches(text) {
          return text.replace(new RegExp(escapeRegExp('!mce~match['), 'g'), '<b>').replace(new RegExp(escapeRegExp(']mce~match!'), 'g'), '</b>');
        }
        if (icon) {
          self.parent().classes.add('menu-has-icons');
        }
        if (settings.image) {
          image = ' style="background-image: url(\'' + settings.image + '\')"';
        }
        if (shortcut) {
          shortcut = convertShortcut(shortcut);
        }
        icon = prefix + 'ico ' + prefix + 'i-' + (self.settings.icon || 'none');
        iconHtml = text !== '-' ? '<i class="' + icon + '"' + image + '></i>\xA0' : '';
        text = boldMatches(self.encode(markMatches(text)));
        url = boldMatches(self.encode(markMatches(url)));
        return '<div id="' + id + '" class="' + self.classes + '" tabindex="-1">' + iconHtml + (text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') + (shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') + (settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') + (url ? '<div class="' + prefix + 'menu-item-link">' + url + '</div>' : '') + '</div>';
      },
      postRender: function postRender() {
        var self = this,
            settings = self.settings;
        var textStyle = settings.textStyle;
        if (typeof textStyle === 'function') {
          textStyle = textStyle.call(this);
        }
        if (textStyle) {
          var textElm = self.getEl('text');
          if (textElm) {
            textElm.setAttribute('style', textStyle);
            self._textStyle = textStyle;
          }
        }
        self.on('mouseenter click', function (e) {
          if (e.control === self) {
            if (!settings.menu && e.type === 'click') {
              self.fire('select');
              global$7.requestAnimationFrame(function () {
                self.parent().hideAll();
              });
            } else {
              self.showMenu();
              if (e.aria) {
                self.menu.focus(true);
              }
            }
          }
        });
        self._super();
        return self;
      },
      hover: function hover() {
        var self = this;
        self.parent().items().each(function (ctrl) {
          ctrl.classes.remove('selected');
        });
        self.classes.toggle('selected', true);
        return self;
      },
      active: function active(state) {
        toggleTextStyle(this, state);
        if (typeof state !== 'undefined') {
          this.aria('checked', state);
        }
        return this._super(state);
      },
      remove: function remove() {
        this._super();
        if (this.menu) {
          this.menu.remove();
        }
      }
    });

    var Radio = Checkbox.extend({
      Defaults: {
        classes: 'radio',
        role: 'radio'
      }
    });

    var ResizeHandle = Widget.extend({
      renderHtml: function renderHtml() {
        var self = this,
            prefix = self.classPrefix;
        self.classes.add('resizehandle');
        if (self.settings.direction === 'both') {
          self.classes.add('resizehandle-both');
        }
        self.canFocus = false;
        return '<div id="' + self._id + '" class="' + self.classes + '">' + '<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' + '</div>';
      },
      postRender: function postRender() {
        var self = this;
        self._super();
        self.resizeDragHelper = new DragHelper(this._id, {
          start: function start() {
            self.fire('ResizeStart');
          },
          drag: function drag(e) {
            if (self.settings.direction !== 'both') {
              e.deltaX = 0;
            }
            self.fire('Resize', e);
          },
          stop: function stop() {
            self.fire('ResizeEnd');
          }
        });
      },
      remove: function remove() {
        if (this.resizeDragHelper) {
          this.resizeDragHelper.destroy();
        }
        return this._super();
      }
    });

    function createOptions(options) {
      var strOptions = '';
      if (options) {
        for (var i = 0; i < options.length; i++) {
          strOptions += '<option value="' + options[i] + '">' + options[i] + '</option>';
        }
      }
      return strOptions;
    }
    var SelectBox = Widget.extend({
      Defaults: {
        classes: 'selectbox',
        role: 'selectbox',
        options: []
      },
      init: function init(settings) {
        var self = this;
        self._super(settings);
        if (self.settings.size) {
          self.size = self.settings.size;
        }
        if (self.settings.options) {
          self._options = self.settings.options;
        }
        self.on('keydown', function (e) {
          var rootControl;
          if (e.keyCode === 13) {
            e.preventDefault();
            self.parents().reverse().each(function (ctrl) {
              if (ctrl.toJSON) {
                rootControl = ctrl;
                return false;
              }
            });
            self.fire('submit', { data: rootControl.toJSON() });
          }
        });
      },
      options: function options(state) {
        if (!arguments.length) {
          return this.state.get('options');
        }
        this.state.set('options', state);
        return this;
      },
      renderHtml: function renderHtml() {
        var self = this;
        var options,
            size = '';
        options = createOptions(self._options);
        if (self.size) {
          size = ' size = "' + self.size + '"';
        }
        return '<select id="' + self._id + '" class="' + self.classes + '"' + size + '>' + options + '</select>';
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:options', function (e) {
          self.getEl().innerHTML = createOptions(e.value);
        });
        return self._super();
      }
    });

    function constrain(value, minVal, maxVal) {
      if (value < minVal) {
        value = minVal;
      }
      if (value > maxVal) {
        value = maxVal;
      }
      return value;
    }
    function setAriaProp(el, name, value) {
      el.setAttribute('aria-' + name, value);
    }
    function updateSliderHandle(ctrl, value) {
      var maxHandlePos, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
      if (ctrl.settings.orientation === 'v') {
        stylePosName = 'top';
        sizeName = 'height';
        shortSizeName = 'h';
      } else {
        stylePosName = 'left';
        sizeName = 'width';
        shortSizeName = 'w';
      }
      handleEl = ctrl.getEl('handle');
      maxHandlePos = (ctrl.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
      styleValue = maxHandlePos * ((value - ctrl._minValue) / (ctrl._maxValue - ctrl._minValue)) + 'px';
      handleEl.style[stylePosName] = styleValue;
      handleEl.style.height = ctrl.layoutRect().h + 'px';
      setAriaProp(handleEl, 'valuenow', value);
      setAriaProp(handleEl, 'valuetext', '' + ctrl.settings.previewFilter(value));
      setAriaProp(handleEl, 'valuemin', ctrl._minValue);
      setAriaProp(handleEl, 'valuemax', ctrl._maxValue);
    }
    var Slider = Widget.extend({
      init: function init(settings) {
        var self = this;
        if (!settings.previewFilter) {
          settings.previewFilter = function (value) {
            return Math.round(value * 100) / 100;
          };
        }
        self._super(settings);
        self.classes.add('slider');
        if (settings.orientation === 'v') {
          self.classes.add('vertical');
        }
        self._minValue = isNumber(settings.minValue) ? settings.minValue : 0;
        self._maxValue = isNumber(settings.maxValue) ? settings.maxValue : 100;
        self._initValue = self.state.get('value');
      },
      renderHtml: function renderHtml() {
        var self = this,
            id = self._id,
            prefix = self.classPrefix;
        return '<div id="' + id + '" class="' + self.classes + '">' + '<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' + '</div>';
      },
      reset: function reset() {
        this.value(this._initValue).repaint();
      },
      postRender: function postRender() {
        var self = this;
        var minValue, maxValue, screenCordName, stylePosName, sizeName, shortSizeName;
        function toFraction(min, max, val) {
          return (val + min) / (max - min);
        }
        function fromFraction(min, max, val) {
          return val * (max - min) - min;
        }
        function handleKeyboard(minValue, maxValue) {
          function alter(delta) {
            var value;
            value = self.value();
            value = fromFraction(minValue, maxValue, toFraction(minValue, maxValue, value) + delta * 0.05);
            value = constrain(value, minValue, maxValue);
            self.value(value);
            self.fire('dragstart', { value: value });
            self.fire('drag', { value: value });
            self.fire('dragend', { value: value });
          }
          self.on('keydown', function (e) {
            switch (e.keyCode) {
              case 37:
              case 38:
                alter(-1);
                break;
              case 39:
              case 40:
                alter(1);
                break;
            }
          });
        }
        function handleDrag(minValue, maxValue, handleEl) {
          var startPos, startHandlePos, maxHandlePos, handlePos, value;
          self._dragHelper = new DragHelper(self._id, {
            handle: self._id + '-handle',
            start: function start(e) {
              startPos = e[screenCordName];
              startHandlePos = parseInt(self.getEl('handle').style[stylePosName], 10);
              maxHandlePos = (self.layoutRect()[shortSizeName] || 100) - funcs.getSize(handleEl)[sizeName];
              self.fire('dragstart', { value: value });
            },
            drag: function drag(e) {
              var delta = e[screenCordName] - startPos;
              handlePos = constrain(startHandlePos + delta, 0, maxHandlePos);
              handleEl.style[stylePosName] = handlePos + 'px';
              value = minValue + handlePos / maxHandlePos * (maxValue - minValue);
              self.value(value);
              self.tooltip().text('' + self.settings.previewFilter(value)).show().moveRel(handleEl, 'bc tc');
              self.fire('drag', { value: value });
            },
            stop: function stop() {
              self.tooltip().hide();
              self.fire('dragend', { value: value });
            }
          });
        }
        minValue = self._minValue;
        maxValue = self._maxValue;
        if (self.settings.orientation === 'v') {
          screenCordName = 'screenY';
          stylePosName = 'top';
          sizeName = 'height';
          shortSizeName = 'h';
        } else {
          screenCordName = 'screenX';
          stylePosName = 'left';
          sizeName = 'width';
          shortSizeName = 'w';
        }
        self._super();
        handleKeyboard(minValue, maxValue);
        handleDrag(minValue, maxValue, self.getEl('handle'));
      },
      repaint: function repaint() {
        this._super();
        updateSliderHandle(this, this.value());
      },
      bindStates: function bindStates() {
        var self = this;
        self.state.on('change:value', function (e) {
          updateSliderHandle(self, e.value);
        });
        return self._super();
      }
    });

    var Spacer = Widget.extend({
      renderHtml: function renderHtml() {
        var self = this;
        self.classes.add('spacer');
        self.canFocus = false;
        return '<div id="' + self._id + '" class="' + self.classes + '"></div>';
      }
    });

    var SplitButton = MenuButton.extend({
      Defaults: {
        classes: 'widget btn splitbtn',
        role: 'button'
      },
      repaint: function repaint() {
        var self$$1 = this;
        var elm = self$$1.getEl();
        var rect = self$$1.layoutRect();
        var mainButtonElm, menuButtonElm;
        self$$1._super();
        mainButtonElm = elm.firstChild;
        menuButtonElm = elm.lastChild;
        global$9(mainButtonElm).css({
          width: rect.w - funcs.getSize(menuButtonElm).width,
          height: rect.h - 2
        });
        global$9(menuButtonElm).css({ height: rect.h - 2 });
        return self$$1;
      },
      activeMenu: function activeMenu(state) {
        var self$$1 = this;
        global$9(self$$1.getEl().lastChild).toggleClass(self$$1.classPrefix + 'active', state);
      },
      renderHtml: function renderHtml() {
        var self$$1 = this;
        var id = self$$1._id;
        var prefix = self$$1.classPrefix;
        var image;
        var icon = self$$1.state.get('icon');
        var text = self$$1.state.get('text');
        var settings = self$$1.settings;
        var textHtml = '',
            ariaPressed;
        image = settings.image;
        if (image) {
          icon = 'none';
          if (typeof image !== 'string') {
            image = window.getSelection ? image[0] : image[1];
          }
          image = ' style="background-image: url(\'' + image + '\')"';
        } else {
          image = '';
        }
        icon = settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
        if (text) {
          self$$1.classes.add('btn-has-text');
          textHtml = '<span class="' + prefix + 'txt">' + self$$1.encode(text) + '</span>';
        }
        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
        return '<div id="' + id + '" class="' + self$$1.classes + '" role="button"' + ariaPressed + ' tabindex="-1">' + '<button type="button" hidefocus="1" tabindex="-1">' + (icon ? '<i class="' + icon + '"' + image + '></i>' : '') + textHtml + '</button>' + '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' + (self$$1._menuBtnText ? (icon ? '\xA0' : '') + self$$1._menuBtnText : '') + ' <i class="' + prefix + 'caret"></i>' + '</button>' + '</div>';
      },
      postRender: function postRender() {
        var self$$1 = this,
            onClickHandler = self$$1.settings.onclick;
        self$$1.on('click', function (e) {
          var node = e.target;
          if (e.control === this) {
            while (node) {
              if (e.aria && e.aria.key !== 'down' || node.nodeName === 'BUTTON' && node.className.indexOf('open') === -1) {
                e.stopImmediatePropagation();
                if (onClickHandler) {
                  onClickHandler.call(this, e);
                }
                return;
              }
              node = node.parentNode;
            }
          }
        });
        delete self$$1.settings.onclick;
        return self$$1._super();
      }
    });

    var StackLayout = FlowLayout.extend({
      Defaults: {
        containerClass: 'stack-layout',
        controlClass: 'stack-layout-item',
        endClass: 'break'
      },
      isNative: function isNative() {
        return true;
      }
    });

    var TabPanel = Panel.extend({
      Defaults: {
        layout: 'absolute',
        defaults: { type: 'panel' }
      },
      activateTab: function activateTab(idx) {
        var activeTabElm;
        if (this.activeTabId) {
          activeTabElm = this.getEl(this.activeTabId);
          global$9(activeTabElm).removeClass(this.classPrefix + 'active');
          activeTabElm.setAttribute('aria-selected', 'false');
        }
        this.activeTabId = 't' + idx;
        activeTabElm = this.getEl('t' + idx);
        activeTabElm.setAttribute('aria-selected', 'true');
        global$9(activeTabElm).addClass(this.classPrefix + 'active');
        this.items()[idx].show().fire('showtab');
        this.reflow();
        this.items().each(function (item, i) {
          if (idx !== i) {
            item.hide();
          }
        });
      },
      renderHtml: function renderHtml() {
        var self = this;
        var layout = self._layout;
        var tabsHtml = '';
        var prefix = self.classPrefix;
        self.preRender();
        layout.preRender(self);
        self.items().each(function (ctrl, i) {
          var id = self._id + '-t' + i;
          ctrl.aria('role', 'tabpanel');
          ctrl.aria('labelledby', id);
          tabsHtml += '<div id="' + id + '" class="' + prefix + 'tab" ' + 'unselectable="on" role="tab" aria-controls="' + ctrl._id + '" aria-selected="false" tabIndex="-1">' + self.encode(ctrl.settings.title) + '</div>';
        });
        return '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' + '<div id="' + self._id + '-head" class="' + prefix + 'tabs" role="tablist">' + tabsHtml + '</div>' + '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' + layout.renderHtml(self) + '</div>' + '</div>';
      },
      postRender: function postRender() {
        var self = this;
        self._super();
        self.settings.activeTab = self.settings.activeTab || 0;
        self.activateTab(self.settings.activeTab);
        this.on('click', function (e) {
          var targetParent = e.target.parentNode;
          if (targetParent && targetParent.id === self._id + '-head') {
            var i = targetParent.childNodes.length;
            while (i--) {
              if (targetParent.childNodes[i] === e.target) {
                self.activateTab(i);
              }
            }
          }
        });
      },
      initLayoutRect: function initLayoutRect() {
        var self = this;
        var rect, minW, minH;
        minW = funcs.getSize(self.getEl('head')).width;
        minW = minW < 0 ? 0 : minW;
        minH = 0;
        self.items().each(function (item) {
          minW = Math.max(minW, item.layoutRect().minW);
          minH = Math.max(minH, item.layoutRect().minH);
        });
        self.items().each(function (ctrl) {
          ctrl.settings.x = 0;
          ctrl.settings.y = 0;
          ctrl.settings.w = minW;
          ctrl.settings.h = minH;
          ctrl.layoutRect({
            x: 0,
            y: 0,
            w: minW,
            h: minH
          });
        });
        var headH = funcs.getSize(self.getEl('head')).height;
        self.settings.minWidth = minW;
        self.settings.minHeight = minH + headH;
        rect = self._super();
        rect.deltaH += headH;
        rect.innerH = rect.h - rect.deltaH;
        return rect;
      }
    });

    var TextBox = Widget.extend({
      init: function init(settings) {
        var self$$1 = this;
        self$$1._super(settings);
        self$$1.classes.add('textbox');
        if (settings.multiline) {
          self$$1.classes.add('multiline');
        } else {
          self$$1.on('keydown', function (e) {
            var rootControl;
            if (e.keyCode === 13) {
              e.preventDefault();
              self$$1.parents().reverse().each(function (ctrl) {
                if (ctrl.toJSON) {
                  rootControl = ctrl;
                  return false;
                }
              });
              self$$1.fire('submit', { data: rootControl.toJSON() });
            }
          });
          self$$1.on('keyup', function (e) {
            self$$1.state.set('value', e.target.value);
          });
        }
      },
      repaint: function repaint() {
        var self$$1 = this;
        var style,
            rect,
            borderBox,
            borderW,
            borderH = 0,
            lastRepaintRect;
        style = self$$1.getEl().style;
        rect = self$$1._layoutRect;
        lastRepaintRect = self$$1._lastRepaintRect || {};
        var doc = document;
        if (!self$$1.settings.multiline && doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
          style.lineHeight = rect.h - borderH + 'px';
        }
        borderBox = self$$1.borderBox;
        borderW = borderBox.left + borderBox.right + 8;
        borderH = borderBox.top + borderBox.bottom + (self$$1.settings.multiline ? 8 : 0);
        if (rect.x !== lastRepaintRect.x) {
          style.left = rect.x + 'px';
          lastRepaintRect.x = rect.x;
        }
        if (rect.y !== lastRepaintRect.y) {
          style.top = rect.y + 'px';
          lastRepaintRect.y = rect.y;
        }
        if (rect.w !== lastRepaintRect.w) {
          style.width = rect.w - borderW + 'px';
          lastRepaintRect.w = rect.w;
        }
        if (rect.h !== lastRepaintRect.h) {
          style.height = rect.h - borderH + 'px';
          lastRepaintRect.h = rect.h;
        }
        self$$1._lastRepaintRect = lastRepaintRect;
        self$$1.fire('repaint', {}, false);
        return self$$1;
      },
      renderHtml: function renderHtml() {
        var self$$1 = this;
        var settings = self$$1.settings;
        var attrs, elm;
        attrs = {
          id: self$$1._id,
          hidefocus: '1'
        };
        global$2.each(['rows', 'spellcheck', 'maxLength', 'size', 'readonly', 'min', 'max', 'step', 'list', 'pattern', 'placeholder', 'required', 'multiple'], function (name$$1) {
          attrs[name$$1] = settings[name$$1];
        });
        if (self$$1.disabled()) {
          attrs.disabled = 'disabled';
        }
        if (settings.subtype) {
          attrs.type = settings.subtype;
        }
        elm = funcs.create(settings.multiline ? 'textarea' : 'input', attrs);
        elm.value = self$$1.state.get('value');
        elm.className = self$$1.classes.toString();
        return elm.outerHTML;
      },
      value: function value(_value4) {
        if (arguments.length) {
          this.state.set('value', _value4);
          return this;
        }
        if (this.state.get('rendered')) {
          this.state.set('value', this.getEl().value);
        }
        return this.state.get('value');
      },
      postRender: function postRender() {
        var self$$1 = this;
        self$$1.getEl().value = self$$1.state.get('value');
        self$$1._super();
        self$$1.$el.on('change', function (e) {
          self$$1.state.set('value', e.target.value);
          self$$1.fire('change', e);
        });
      },
      bindStates: function bindStates() {
        var self$$1 = this;
        self$$1.state.on('change:value', function (e) {
          if (self$$1.getEl().value !== e.value) {
            self$$1.getEl().value = e.value;
          }
        });
        self$$1.state.on('change:disabled', function (e) {
          self$$1.getEl().disabled = e.value;
        });
        return self$$1._super();
      },
      remove: function remove() {
        this.$el.off();
        this._super();
      }
    });

    var getApi = function getApi() {
      return {
        Selector: Selector,
        Collection: Collection$2,
        ReflowQueue: $_6bivibuxjk26xn6n,
        Control: Control$1,
        Factory: global$4,
        KeyboardNavigation: KeyboardNavigation,
        Container: Container,
        DragHelper: DragHelper,
        Scrollable: $_g9fk2uuzjk26xn6v,
        Panel: Panel,
        Movable: $_63b1h8ukjk26xn4v,
        Resizable: $_cgv29mv1jk26xn72,
        FloatPanel: FloatPanel,
        Window: Window$$1,
        MessageBox: MessageBox,
        Tooltip: Tooltip,
        Widget: Widget,
        Progress: Progress,
        Notification: Notification,
        Layout: Layout,
        AbsoluteLayout: AbsoluteLayout,
        Button: Button,
        ButtonGroup: ButtonGroup,
        Checkbox: Checkbox,
        ComboBox: ComboBox,
        ColorBox: ColorBox,
        PanelButton: PanelButton,
        ColorButton: ColorButton,
        ColorPicker: ColorPicker,
        Path: Path,
        ElementPath: ElementPath,
        FormItem: FormItem,
        Form: Form,
        FieldSet: FieldSet,
        FilePicker: FilePicker,
        FitLayout: FitLayout,
        FlexLayout: FlexLayout,
        FlowLayout: FlowLayout,
        FormatControls: $_dytu03wxjk26xne0,
        GridLayout: GridLayout,
        Iframe: Iframe$1,
        InfoBox: InfoBox,
        Label: Label,
        Toolbar: Toolbar$1,
        MenuBar: MenuBar,
        MenuButton: MenuButton,
        MenuItem: MenuItem,
        Throbber: Throbber,
        Menu: Menu,
        ListBox: ListBox,
        Radio: Radio,
        ResizeHandle: ResizeHandle,
        SelectBox: SelectBox,
        Slider: Slider,
        Spacer: Spacer,
        SplitButton: SplitButton,
        StackLayout: StackLayout,
        TabPanel: TabPanel,
        TextBox: TextBox,
        DropZone: DropZone,
        BrowseButton: BrowseButton
      };
    };
    var appendTo = function appendTo(target) {
      if (target.ui) {
        global$2.each(getApi(), function (ref, key) {
          target.ui[key] = ref;
        });
      } else {
        target.ui = getApi();
      }
    };
    var registerToFactory = function registerToFactory() {
      global$2.each(getApi(), function (ref, key) {
        global$4.add(key, ref);
      });
    };
    var Api = {
      appendTo: appendTo,
      registerToFactory: registerToFactory
    };

    Api.registerToFactory();
    Api.appendTo(window.tinymce ? window.tinymce : {});
    global.add('modern', function (editor) {
      $_dytu03wxjk26xne0.setup(editor);
      return $_27tb2gtqjk26xn20.get(editor);
    });
    function Theme() {}

    return Theme;
  }();
})();

/***/ }),
/* 953 */
/*!*******************************************************!*\
  !*** ./src/packages/tinymce/plugins/advlist/index.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "advlist" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/advlist')
//   ES2015:
//     import 'tinymce/plugins/advlist'
__webpack_require__(/*! ./plugin.js */ 954);

/***/ }),
/* 954 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/advlist/plugin.js ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var advlist = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var applyListFormat = function applyListFormat(editor, listName, styleValue) {
      var cmd = listName === 'UL' ? 'InsertUnorderedList' : 'InsertOrderedList';
      editor.execCommand(cmd, false, styleValue === false ? null : { 'list-style-type': styleValue });
    };
    var $_83t8k98fjk26xiop = { applyListFormat: applyListFormat };

    var register = function register(editor) {
      editor.addCommand('ApplyUnorderedListStyle', function (ui, value) {
        $_83t8k98fjk26xiop.applyListFormat(editor, 'UL', value['list-style-type']);
      });
      editor.addCommand('ApplyOrderedListStyle', function (ui, value) {
        $_83t8k98fjk26xiop.applyListFormat(editor, 'OL', value['list-style-type']);
      });
    };
    var $_ndnk68ejk26xioo = { register: register };

    var getNumberStyles = function getNumberStyles(editor) {
      var styles = editor.getParam('advlist_number_styles', 'default,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman');
      return styles ? styles.split(/[ ,]/) : [];
    };
    var getBulletStyles = function getBulletStyles(editor) {
      var styles = editor.getParam('advlist_bullet_styles', 'default,circle,disc,square');
      return styles ? styles.split(/[ ,]/) : [];
    };
    var $_59sq9k8hjk26xiou = {
      getNumberStyles: getNumberStyles,
      getBulletStyles: getBulletStyles
    };

    var isChildOfBody = function isChildOfBody(editor, elm) {
      return editor.$.contains(editor.getBody(), elm);
    };
    var isTableCellNode = function isTableCellNode(node) {
      return node && /^(TH|TD)$/.test(node.nodeName);
    };
    var isListNode = function isListNode(editor) {
      return function (node) {
        return node && /^(OL|UL|DL)$/.test(node.nodeName) && isChildOfBody(editor, node);
      };
    };
    var getSelectedStyleType = function getSelectedStyleType(editor) {
      var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
      return editor.dom.getStyle(listElm, 'listStyleType') || '';
    };
    var $_4043108ijk26xiov = {
      isTableCellNode: isTableCellNode,
      isListNode: isListNode,
      getSelectedStyleType: getSelectedStyleType
    };

    var styleValueToText = function styleValueToText(styleValue) {
      return styleValue.replace(/\-/g, ' ').replace(/\b\w/g, function (chr) {
        return chr.toUpperCase();
      });
    };
    var toMenuItems = function toMenuItems(styles) {
      return global$1.map(styles, function (styleValue) {
        var text = styleValueToText(styleValue);
        var data = styleValue === 'default' ? '' : styleValue;
        return {
          text: text,
          data: data
        };
      });
    };
    var $_6iui168jjk26xiow = { toMenuItems: toMenuItems };

    var findIndex = function findIndex(list, predicate) {
      for (var index = 0; index < list.length; index++) {
        var element = list[index];
        if (predicate(element)) {
          return index;
        }
      }
      return -1;
    };
    var listState = function listState(editor, listName) {
      return function (e) {
        var ctrl = e.control;
        editor.on('NodeChange', function (e) {
          var tableCellIndex = findIndex(e.parents, $_4043108ijk26xiov.isTableCellNode);
          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
          var lists = global$1.grep(parents, $_4043108ijk26xiov.isListNode(editor));
          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
        });
      };
    };
    var updateSelection = function updateSelection(editor) {
      return function (e) {
        var listStyleType = $_4043108ijk26xiov.getSelectedStyleType(editor);
        e.control.items().each(function (ctrl) {
          ctrl.active(ctrl.settings.data === listStyleType);
        });
      };
    };
    var addSplitButton = function addSplitButton(editor, id, tooltip, cmd, nodeName, styles) {
      editor.addButton(id, {
        active: false,
        type: 'splitbutton',
        tooltip: tooltip,
        menu: $_6iui168jjk26xiow.toMenuItems(styles),
        onPostRender: listState(editor, nodeName),
        onshow: updateSelection(editor),
        onselect: function onselect(e) {
          $_83t8k98fjk26xiop.applyListFormat(editor, nodeName, e.control.settings.data);
        },
        onclick: function onclick() {
          editor.execCommand(cmd);
        }
      });
    };
    var addButton = function addButton(editor, id, tooltip, cmd, nodeName, styles) {
      editor.addButton(id, {
        active: false,
        type: 'button',
        tooltip: tooltip,
        onPostRender: listState(editor, nodeName),
        onclick: function onclick() {
          editor.execCommand(cmd);
        }
      });
    };
    var addControl = function addControl(editor, id, tooltip, cmd, nodeName, styles) {
      if (styles.length > 0) {
        addSplitButton(editor, id, tooltip, cmd, nodeName, styles);
      } else {
        addButton(editor, id, tooltip, cmd, nodeName, styles);
      }
    };
    var register$1 = function register$1(editor) {
      addControl(editor, 'numlist', 'Numbered list', 'InsertOrderedList', 'OL', $_59sq9k8hjk26xiou.getNumberStyles(editor));
      addControl(editor, 'bullist', 'Bullet list', 'InsertUnorderedList', 'UL', $_59sq9k8hjk26xiou.getBulletStyles(editor));
    };
    var $_fgu3ro8gjk26xior = { register: register$1 };

    global.add('advlist', function (editor) {
      var hasPlugin = function hasPlugin(editor, plugin) {
        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
        return global$1.inArray(plugins.split(/[ ,]/), plugin) !== -1;
      };
      if (hasPlugin(editor, 'lists')) {
        $_fgu3ro8gjk26xior.register(editor);
        $_ndnk68ejk26xioo.register(editor);
      }
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 955 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/wordcount/index.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "wordcount" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/wordcount')
//   ES2015:
//     import 'tinymce/plugins/wordcount'
__webpack_require__(/*! ./plugin.js */ 956);

/***/ }),
/* 956 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/wordcount/plugin.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var wordcount = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var regExps = {
      aletter: '[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F3\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u10A0-\u10C5\u10D0-\u10FA\u10FC\u1100-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1A00-\u1A16\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BC0-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2D00-\u2D25\u2D30-\u2D65\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u303B\u303C\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790\uA791\uA7A0-\uA7A9\uA7FA-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]',
      midnumlet: '[-\'\\.\u2018\u2019\u2024\uFE52\uFF07\uFF0E]',
      midletter: '[:\xB7\xB7\u05F4\u2027\uFE13\uFE55\uFF1A]',
      midnum: '[\xB1+*/,;;\u0589\u060C\u060D\u066C\u07F8\u2044\uFE10\uFE14\uFE50\uFE54\uFF0C\uFF1B]',
      numeric: '[0-9\u0660-\u0669\u066B\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9]',
      cr: '\\r',
      lf: '\\n',
      newline: '[\x0B\f\x85\u2028\u2029]',
      extend: '[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C01-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D02\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B6-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u19B0-\u19C0\u19C8\u19C9\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAA\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2\u1DC0-\u1DE6\u1DFC-\u1DFF\u200C\u200D\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA67C\uA67D\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26\uFF9E\uFF9F]',
      format: '[\xAD\u0600-\u0603\u06DD\u070F\u17B4\u17B5\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F\uFEFF\uFFF9-\uFFFB]',
      katakana: '[\u3031-\u3035\u309B\u309C\u30A0-\u30FA\u30FC-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF9D]',
      extendnumlet: '[=_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F\u2200-\u22FF<>]',
      punctuation: '[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]'
    };
    var characterIndices = {
      ALETTER: 0,
      MIDNUMLET: 1,
      MIDLETTER: 2,
      MIDNUM: 3,
      NUMERIC: 4,
      CR: 5,
      LF: 6,
      NEWLINE: 7,
      EXTEND: 8,
      FORMAT: 9,
      KATAKANA: 10,
      EXTENDNUMLET: 11,
      AT: 12,
      OTHER: 13
    };
    var SETS = [new RegExp(regExps.aletter), new RegExp(regExps.midnumlet), new RegExp(regExps.midletter), new RegExp(regExps.midnum), new RegExp(regExps.numeric), new RegExp(regExps.cr), new RegExp(regExps.lf), new RegExp(regExps.newline), new RegExp(regExps.extend), new RegExp(regExps.format), new RegExp(regExps.katakana), new RegExp(regExps.extendnumlet), new RegExp('@')];
    var EMPTY_STRING = '';
    var PUNCTUATION = new RegExp('^' + regExps.punctuation + '$');
    var WHITESPACE = /^\s+$/;
    var $_v8tabthjk26xn0w = {
      characterIndices: characterIndices,
      SETS: SETS,
      EMPTY_STRING: EMPTY_STRING,
      PUNCTUATION: PUNCTUATION,
      WHITESPACE: WHITESPACE
    };

    var each = function each(o, cb, s) {
      var n, l;
      if (!o) {
        return 0;
      }
      s = s || o;
      if (o.length !== undefined) {
        for (n = 0, l = o.length; n < l; n++) {
          if (cb.call(s, o[n], n, o) === false) {
            return 0;
          }
        }
      } else {
        for (n in o) {
          if (o.hasOwnProperty(n)) {
            if (cb.call(s, o[n], n, o) === false) {
              return 0;
            }
          }
        }
      }
      return 1;
    };
    var map = function map(array, callback) {
      var out = [];
      each(array, function (item, index) {
        out.push(callback(item, index, array));
      });
      return out;
    };
    var $_6u5gkltjjk26xn15 = {
      each: each,
      map: map
    };

    var SETS$1 = $_v8tabthjk26xn0w.SETS;
    var OTHER = $_v8tabthjk26xn0w.characterIndices.OTHER;
    var getType = function getType(char) {
      var j,
          set,
          type = OTHER;
      var setsLength = SETS$1.length;
      for (j = 0; j < setsLength; ++j) {
        set = SETS$1[j];
        if (set && set.test(char)) {
          type = j;
          break;
        }
      }
      return type;
    };
    var memoize = function memoize(func) {
      var cache = {};
      return function (char) {
        if (cache[char]) {
          return cache[char];
        } else {
          var result = func(char);
          cache[char] = result;
          return result;
        }
      };
    };
    var classify = function classify(string) {
      var memoized = memoize(getType);
      return $_6u5gkltjjk26xn15.map(string.split(''), memoized);
    };
    var $_6bl6gutijk26xn14 = { classify: classify };

    var ci = $_v8tabthjk26xn0w.characterIndices;
    var isWordBoundary = function isWordBoundary(map, index) {
      var prevType;
      var type = map[index];
      var nextType = map[index + 1];
      var nextNextType;
      if (index < 0 || index > map.length - 1 && index !== 0) {
        return false;
      }
      if (type === ci.ALETTER && nextType === ci.ALETTER) {
        return false;
      }
      nextNextType = map[index + 2];
      if (type === ci.ALETTER && (nextType === ci.MIDLETTER || nextType === ci.MIDNUMLET || nextType === ci.AT) && nextNextType === ci.ALETTER) {
        return false;
      }
      prevType = map[index - 1];
      if ((type === ci.MIDLETTER || type === ci.MIDNUMLET || nextType === ci.AT) && nextType === ci.ALETTER && prevType === ci.ALETTER) {
        return false;
      }
      if ((type === ci.NUMERIC || type === ci.ALETTER) && (nextType === ci.NUMERIC || nextType === ci.ALETTER)) {
        return false;
      }
      if ((type === ci.MIDNUM || type === ci.MIDNUMLET) && nextType === ci.NUMERIC && prevType === ci.NUMERIC) {
        return false;
      }
      if (type === ci.NUMERIC && (nextType === ci.MIDNUM || nextType === ci.MIDNUMLET) && nextNextType === ci.NUMERIC) {
        return false;
      }
      if (type === ci.EXTEND || type === ci.FORMAT || prevType === ci.EXTEND || prevType === ci.FORMAT || nextType === ci.EXTEND || nextType === ci.FORMAT) {
        return false;
      }
      if (type === ci.CR && nextType === ci.LF) {
        return false;
      }
      if (type === ci.NEWLINE || type === ci.CR || type === ci.LF) {
        return true;
      }
      if (nextType === ci.NEWLINE || nextType === ci.CR || nextType === ci.LF) {
        return true;
      }
      if (type === ci.KATAKANA && nextType === ci.KATAKANA) {
        return false;
      }
      if (nextType === ci.EXTENDNUMLET && (type === ci.ALETTER || type === ci.NUMERIC || type === ci.KATAKANA || type === ci.EXTENDNUMLET)) {
        return false;
      }
      if (type === ci.EXTENDNUMLET && (nextType === ci.ALETTER || nextType === ci.NUMERIC || nextType === ci.KATAKANA)) {
        return false;
      }
      if (type === ci.AT) {
        return false;
      }
      return true;
    };
    var $_26agjitkjk26xn17 = { isWordBoundary: isWordBoundary };

    var EMPTY_STRING$1 = $_v8tabthjk26xn0w.EMPTY_STRING;
    var WHITESPACE$1 = $_v8tabthjk26xn0w.WHITESPACE;
    var PUNCTUATION$1 = $_v8tabthjk26xn0w.PUNCTUATION;
    var isProtocol = function isProtocol(word) {
      return word === 'http' || word === 'https';
    };
    var findWordEnd = function findWordEnd(str, index) {
      var i;
      for (i = index; i < str.length; ++i) {
        var chr = str.charAt(i);
        if (WHITESPACE$1.test(chr)) {
          break;
        }
      }
      return i;
    };
    var extractUrl = function extractUrl(word, str, index) {
      var endIndex = findWordEnd(str, index + 1);
      var peakedWord = str.substring(index + 1, endIndex);
      if (peakedWord.substr(0, 3) === '://') {
        return {
          word: word + peakedWord,
          index: endIndex
        };
      }
      return {
        word: word,
        index: index
      };
    };
    var doGetWords = function doGetWords(str, options) {
      var i = 0;
      var map = $_6bl6gutijk26xn14.classify(str);
      var len = map.length;
      var word = [];
      var words = [];
      var chr;
      var includePunctuation;
      var includeWhitespace;
      if (!options) {
        options = {};
      }
      if (options.ignoreCase) {
        str = str.toLowerCase();
      }
      includePunctuation = options.includePunctuation;
      includeWhitespace = options.includeWhitespace;
      for (; i < len; ++i) {
        chr = str.charAt(i);
        word.push(chr);
        if ($_26agjitkjk26xn17.isWordBoundary(map, i)) {
          word = word.join(EMPTY_STRING$1);
          if (word && (includeWhitespace || !WHITESPACE$1.test(word)) && (includePunctuation || !PUNCTUATION$1.test(word))) {
            if (isProtocol(word)) {
              var obj = extractUrl(word, str, i);
              words.push(obj.word);
              i = obj.index;
            } else {
              words.push(word);
            }
          }
          word = [];
        }
      }
      return words;
    };
    var getWords = function getWords(str, options) {
      return doGetWords(str.replace(/\ufeff/g, ''), options);
    };
    var $_3jhs29tgjk26xn0t = { getWords: getWords };

    var getTextContent = function getTextContent(editor) {
      return editor.removed ? '' : editor.getBody().innerText;
    };
    var getCount = function getCount(editor) {
      return $_3jhs29tgjk26xn0t.getWords(getTextContent(editor)).length;
    };
    var $_a9mh25tfjk26xn0r = { getCount: getCount };

    var get = function get(editor) {
      var getCount = function getCount() {
        return $_a9mh25tfjk26xn0r.getCount(editor);
      };
      return { getCount: getCount };
    };
    var $_fwjbdftejk26xn0q = { get: get };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var setup = function setup(editor) {
      var wordsToText = function wordsToText(editor) {
        return global$2.translate(['{0} words', $_a9mh25tfjk26xn0r.getCount(editor)]);
      };
      var update = function update() {
        editor.theme.panel.find('#wordcount').text(wordsToText(editor));
      };
      editor.on('init', function () {
        var statusbar = editor.theme.panel && editor.theme.panel.find('#statusbar')[0];
        var debouncedUpdate = global$1.debounce(update, 300);
        if (statusbar) {
          global$1.setEditorTimeout(editor, function () {
            statusbar.insert({
              type: 'label',
              name: 'wordcount',
              text: wordsToText(editor),
              classes: 'wordcount',
              disabled: editor.settings.readonly
            }, 0);
            editor.on('setcontent beforeaddundo undo redo keyup', debouncedUpdate);
          }, 0);
        }
      });
    };
    var $_ck8fsatljk26xn19 = { setup: setup };

    global.add('wordcount', function (editor) {
      $_ck8fsatljk26xn19.setup(editor);
      return $_fwjbdftejk26xn0q.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 957 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autolink/index.js ***!
  \********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "autolink" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autolink')
//   ES2015:
//     import 'tinymce/plugins/autolink'
__webpack_require__(/*! ./plugin.js */ 958);

/***/ }),
/* 958 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autolink/plugin.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var autolink = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var getAutoLinkPattern = function getAutoLinkPattern(editor) {
      return editor.getParam('autolink_pattern', /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.|(?:mailto:)?[A-Z0-9._%+\-]+@)(.+)$/i);
    };
    var getDefaultLinkTarget = function getDefaultLinkTarget(editor) {
      return editor.getParam('default_link_target', '');
    };
    var $_7w4e6t8vjk26xiq4 = {
      getAutoLinkPattern: getAutoLinkPattern,
      getDefaultLinkTarget: getDefaultLinkTarget
    };

    var rangeEqualsDelimiterOrSpace = function rangeEqualsDelimiterOrSpace(rangeString, delimiter) {
      return rangeString === delimiter || rangeString === ' ' || rangeString.charCodeAt(0) === 160;
    };
    var handleEclipse = function handleEclipse(editor) {
      parseCurrentLine(editor, -1, '(');
    };
    var handleSpacebar = function handleSpacebar(editor) {
      parseCurrentLine(editor, 0, '');
    };
    var handleEnter = function handleEnter(editor) {
      parseCurrentLine(editor, -1, '');
    };
    var scopeIndex = function scopeIndex(container, index) {
      if (index < 0) {
        index = 0;
      }
      if (container.nodeType === 3) {
        var len = container.data.length;
        if (index > len) {
          index = len;
        }
      }
      return index;
    };
    var setStart = function setStart(rng, container, offset) {
      if (container.nodeType !== 1 || container.hasChildNodes()) {
        rng.setStart(container, scopeIndex(container, offset));
      } else {
        rng.setStartBefore(container);
      }
    };
    var setEnd = function setEnd(rng, container, offset) {
      if (container.nodeType !== 1 || container.hasChildNodes()) {
        rng.setEnd(container, scopeIndex(container, offset));
      } else {
        rng.setEndAfter(container);
      }
    };
    var parseCurrentLine = function parseCurrentLine(editor, endOffset, delimiter) {
      var rng, end, start, endContainer, bookmark, text, matches, prev, len, rngText;
      var autoLinkPattern = $_7w4e6t8vjk26xiq4.getAutoLinkPattern(editor);
      var defaultLinkTarget = $_7w4e6t8vjk26xiq4.getDefaultLinkTarget(editor);
      if (editor.selection.getNode().tagName === 'A') {
        return;
      }
      rng = editor.selection.getRng(true).cloneRange();
      if (rng.startOffset < 5) {
        prev = rng.endContainer.previousSibling;
        if (!prev) {
          if (!rng.endContainer.firstChild || !rng.endContainer.firstChild.nextSibling) {
            return;
          }
          prev = rng.endContainer.firstChild.nextSibling;
        }
        len = prev.length;
        setStart(rng, prev, len);
        setEnd(rng, prev, len);
        if (rng.endOffset < 5) {
          return;
        }
        end = rng.endOffset;
        endContainer = prev;
      } else {
        endContainer = rng.endContainer;
        if (endContainer.nodeType !== 3 && endContainer.firstChild) {
          while (endContainer.nodeType !== 3 && endContainer.firstChild) {
            endContainer = endContainer.firstChild;
          }
          if (endContainer.nodeType === 3) {
            setStart(rng, endContainer, 0);
            setEnd(rng, endContainer, endContainer.nodeValue.length);
          }
        }
        if (rng.endOffset === 1) {
          end = 2;
        } else {
          end = rng.endOffset - 1 - endOffset;
        }
      }
      start = end;
      do {
        setStart(rng, endContainer, end >= 2 ? end - 2 : 0);
        setEnd(rng, endContainer, end >= 1 ? end - 1 : 0);
        end -= 1;
        rngText = rng.toString();
      } while (rngText !== ' ' && rngText !== '' && rngText.charCodeAt(0) !== 160 && end - 2 >= 0 && rngText !== delimiter);
      if (rangeEqualsDelimiterOrSpace(rng.toString(), delimiter)) {
        setStart(rng, endContainer, end);
        setEnd(rng, endContainer, start);
        end += 1;
      } else if (rng.startOffset === 0) {
        setStart(rng, endContainer, 0);
        setEnd(rng, endContainer, start);
      } else {
        setStart(rng, endContainer, end);
        setEnd(rng, endContainer, start);
      }
      text = rng.toString();
      if (text.charAt(text.length - 1) === '.') {
        setEnd(rng, endContainer, start - 1);
      }
      text = rng.toString().trim();
      matches = text.match(autoLinkPattern);
      if (matches) {
        if (matches[1] === 'www.') {
          matches[1] = 'http://www.';
        } else if (/@$/.test(matches[1]) && !/^mailto:/.test(matches[1])) {
          matches[1] = 'mailto:' + matches[1];
        }
        bookmark = editor.selection.getBookmark();
        editor.selection.setRng(rng);
        editor.execCommand('createlink', false, matches[1] + matches[2]);
        if (defaultLinkTarget) {
          editor.dom.setAttrib(editor.selection.getNode(), 'target', defaultLinkTarget);
        }
        editor.selection.moveToBookmark(bookmark);
        editor.nodeChanged();
      }
    };
    var setup = function setup(editor) {
      var autoUrlDetectState;
      editor.on('keydown', function (e) {
        if (e.keyCode === 13) {
          return handleEnter(editor);
        }
      });
      if (global$1.ie) {
        editor.on('focus', function () {
          if (!autoUrlDetectState) {
            autoUrlDetectState = true;
            try {
              editor.execCommand('AutoUrlDetect', false, true);
            } catch (ex) {}
          }
        });
        return;
      }
      editor.on('keypress', function (e) {
        if (e.keyCode === 41) {
          return handleEclipse(editor);
        }
      });
      editor.on('keyup', function (e) {
        if (e.keyCode === 32) {
          return handleSpacebar(editor);
        }
      });
    };
    var $_8v3z8q8tjk26xipz = { setup: setup };

    global.add('autolink', function (editor) {
      $_8v3z8q8tjk26xipz.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 959 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autosave/index.js ***!
  \********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "autosave" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autosave')
//   ES2015:
//     import 'tinymce/plugins/autosave'
__webpack_require__(/*! ./plugin.js */ 960);

/***/ }),
/* 960 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autosave/plugin.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var autosave = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.LocalStorage');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var fireRestoreDraft = function fireRestoreDraft(editor) {
      return editor.fire('RestoreDraft');
    };
    var fireStoreDraft = function fireStoreDraft(editor) {
      return editor.fire('StoreDraft');
    };
    var fireRemoveDraft = function fireRemoveDraft(editor) {
      return editor.fire('RemoveDraft');
    };
    var $_w1cm19bjk26xirm = {
      fireRestoreDraft: fireRestoreDraft,
      fireStoreDraft: fireStoreDraft,
      fireRemoveDraft: fireRemoveDraft
    };

    var parse = function parse(time, defaultTime) {
      var multiples = {
        s: 1000,
        m: 60000
      };
      time = /^(\d+)([ms]?)$/.exec('' + (time || defaultTime));
      return (time[2] ? multiples[time[2]] : 1) * parseInt(time, 10);
    };
    var $_fbzenn9djk26xirp = { parse: parse };

    var shouldAskBeforeUnload = function shouldAskBeforeUnload(editor) {
      return editor.getParam('autosave_ask_before_unload', true);
    };
    var getAutoSavePrefix = function getAutoSavePrefix(editor) {
      var prefix = editor.getParam('autosave_prefix', 'tinymce-autosave-{path}{query}{hash}-{id}-');
      prefix = prefix.replace(/\{path\}/g, document.location.pathname);
      prefix = prefix.replace(/\{query\}/g, document.location.search);
      prefix = prefix.replace(/\{hash\}/g, document.location.hash);
      prefix = prefix.replace(/\{id\}/g, editor.id);
      return prefix;
    };
    var shouldRestoreWhenEmpty = function shouldRestoreWhenEmpty(editor) {
      return editor.getParam('autosave_restore_when_empty', false);
    };
    var getAutoSaveInterval = function getAutoSaveInterval(editor) {
      return $_fbzenn9djk26xirp.parse(editor.settings.autosave_interval, '30s');
    };
    var getAutoSaveRetention = function getAutoSaveRetention(editor) {
      return $_fbzenn9djk26xirp.parse(editor.settings.autosave_retention, '20m');
    };
    var $_c9dhtx9cjk26xirn = {
      shouldAskBeforeUnload: shouldAskBeforeUnload,
      getAutoSavePrefix: getAutoSavePrefix,
      shouldRestoreWhenEmpty: shouldRestoreWhenEmpty,
      getAutoSaveInterval: getAutoSaveInterval,
      getAutoSaveRetention: getAutoSaveRetention
    };

    var isEmpty = function isEmpty(editor, html) {
      var forcedRootBlockName = editor.settings.forced_root_block;
      html = global$2.trim(typeof html === 'undefined' ? editor.getBody().innerHTML : html);
      return html === '' || new RegExp('^<' + forcedRootBlockName + '[^>]*>((\xA0|&nbsp;|[ \t]|<br[^>]*>)+?|)</' + forcedRootBlockName + '>|<br>$', 'i').test(html);
    };
    var hasDraft = function hasDraft(editor) {
      var time = parseInt(global$1.getItem($_c9dhtx9cjk26xirn.getAutoSavePrefix(editor) + 'time'), 10) || 0;
      if (new Date().getTime() - time > $_c9dhtx9cjk26xirn.getAutoSaveRetention(editor)) {
        removeDraft(editor, false);
        return false;
      }
      return true;
    };
    var removeDraft = function removeDraft(editor, fire) {
      var prefix = $_c9dhtx9cjk26xirn.getAutoSavePrefix(editor);
      global$1.removeItem(prefix + 'draft');
      global$1.removeItem(prefix + 'time');
      if (fire !== false) {
        $_w1cm19bjk26xirm.fireRemoveDraft(editor);
      }
    };
    var storeDraft = function storeDraft(editor) {
      var prefix = $_c9dhtx9cjk26xirn.getAutoSavePrefix(editor);
      if (!isEmpty(editor) && editor.isDirty()) {
        global$1.setItem(prefix + 'draft', editor.getContent({
          format: 'raw',
          no_events: true
        }));
        global$1.setItem(prefix + 'time', new Date().getTime().toString());
        $_w1cm19bjk26xirm.fireStoreDraft(editor);
      }
    };
    var restoreDraft = function restoreDraft(editor) {
      var prefix = $_c9dhtx9cjk26xirn.getAutoSavePrefix(editor);
      if (hasDraft(editor)) {
        editor.setContent(global$1.getItem(prefix + 'draft'), { format: 'raw' });
        $_w1cm19bjk26xirm.fireRestoreDraft(editor);
      }
    };
    var startStoreDraft = function startStoreDraft(editor, started) {
      var interval = $_c9dhtx9cjk26xirn.getAutoSaveInterval(editor);
      if (!started.get()) {
        setInterval(function () {
          if (!editor.removed) {
            storeDraft(editor);
          }
        }, interval);
        started.set(true);
      }
    };
    var restoreLastDraft = function restoreLastDraft(editor) {
      editor.undoManager.transact(function () {
        restoreDraft(editor);
        removeDraft(editor);
      });
      editor.focus();
    };
    var $_axrczh98jk26xiri = {
      isEmpty: isEmpty,
      hasDraft: hasDraft,
      removeDraft: removeDraft,
      storeDraft: storeDraft,
      restoreDraft: restoreDraft,
      startStoreDraft: startStoreDraft,
      restoreLastDraft: restoreLastDraft
    };

    var curry = function curry(f, editor) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return f.apply(null, [editor].concat(args));
      };
    };
    var get = function get(editor) {
      return {
        hasDraft: curry($_axrczh98jk26xiri.hasDraft, editor),
        storeDraft: curry($_axrczh98jk26xiri.storeDraft, editor),
        restoreDraft: curry($_axrczh98jk26xiri.restoreDraft, editor),
        removeDraft: curry($_axrczh98jk26xiri.removeDraft, editor),
        isEmpty: curry($_axrczh98jk26xiri.isEmpty, editor)
      };
    };
    var $_f4w8wn97jk26xirh = { get: get };

    var global$3 = tinymce.util.Tools.resolve('tinymce.EditorManager');

    global$3._beforeUnloadHandler = function () {
      var msg;
      global$2.each(global$3.get(), function (editor) {
        if (editor.plugins.autosave) {
          editor.plugins.autosave.storeDraft();
        }
        if (!msg && editor.isDirty() && $_c9dhtx9cjk26xirn.shouldAskBeforeUnload(editor)) {
          msg = editor.translate('You have unsaved changes are you sure you want to navigate away?');
        }
      });
      return msg;
    };
    var setup = function setup(editor) {
      window.onbeforeunload = global$3._beforeUnloadHandler;
    };
    var $_8cln7p9fjk26xis5 = { setup: setup };

    var postRender = function postRender(editor, started) {
      return function (e) {
        var ctrl = e.control;
        ctrl.disabled(!$_axrczh98jk26xiri.hasDraft(editor));
        editor.on('StoreDraft RestoreDraft RemoveDraft', function () {
          ctrl.disabled(!$_axrczh98jk26xiri.hasDraft(editor));
        });
        $_axrczh98jk26xiri.startStoreDraft(editor, started);
      };
    };
    var register = function register(editor, started) {
      editor.addButton('restoredraft', {
        title: 'Restore last draft',
        onclick: function onclick() {
          $_axrczh98jk26xiri.restoreLastDraft(editor);
        },
        onPostRender: postRender(editor, started)
      });
      editor.addMenuItem('restoredraft', {
        text: 'Restore last draft',
        onclick: function onclick() {
          $_axrczh98jk26xiri.restoreLastDraft(editor);
        },
        onPostRender: postRender(editor, started),
        context: 'file'
      });
    };
    var $_costmm9hjk26xis8 = { register: register };

    global.add('autosave', function (editor) {
      var started = Cell(false);
      $_8cln7p9fjk26xis5.setup(editor);
      $_costmm9hjk26xis8.register(editor, started);
      return $_f4w8wn97jk26xirh.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 961 */
/*!*******************************************************!*\
  !*** ./src/packages/tinymce/plugins/charmap/index.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "charmap" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/charmap')
//   ES2015:
//     import 'tinymce/plugins/charmap'
__webpack_require__(/*! ./plugin.js */ 962);

/***/ }),
/* 962 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/charmap/plugin.js ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var charmap = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var fireInsertCustomChar = function fireInsertCustomChar(editor, chr) {
      return editor.fire('insertCustomChar', { chr: chr });
    };
    var $_e7247a9qjk26xitz = { fireInsertCustomChar: fireInsertCustomChar };

    var insertChar = function insertChar(editor, chr) {
      var evtChr = $_e7247a9qjk26xitz.fireInsertCustomChar(editor, chr).chr;
      editor.execCommand('mceInsertContent', false, evtChr);
    };
    var $_explz69pjk26xity = { insertChar: insertChar };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getCharMap = function getCharMap(editor) {
      return editor.settings.charmap;
    };
    var getCharMapAppend = function getCharMapAppend(editor) {
      return editor.settings.charmap_append;
    };
    var $_b1hvs89tjk26xiu7 = {
      getCharMap: getCharMap,
      getCharMapAppend: getCharMapAppend
    };

    var isArray = global$1.isArray;
    var getDefaultCharMap = function getDefaultCharMap() {
      return [['160', 'no-break space'], ['173', 'soft hyphen'], ['34', 'quotation mark'], ['162', 'cent sign'], ['8364', 'euro sign'], ['163', 'pound sign'], ['165', 'yen sign'], ['169', 'copyright sign'], ['174', 'registered sign'], ['8482', 'trade mark sign'], ['8240', 'per mille sign'], ['181', 'micro sign'], ['183', 'middle dot'], ['8226', 'bullet'], ['8230', 'three dot leader'], ['8242', 'minutes / feet'], ['8243', 'seconds / inches'], ['167', 'section sign'], ['182', 'paragraph sign'], ['223', 'sharp s / ess-zed'], ['8249', 'single left-pointing angle quotation mark'], ['8250', 'single right-pointing angle quotation mark'], ['171', 'left pointing guillemet'], ['187', 'right pointing guillemet'], ['8216', 'left single quotation mark'], ['8217', 'right single quotation mark'], ['8220', 'left double quotation mark'], ['8221', 'right double quotation mark'], ['8218', 'single low-9 quotation mark'], ['8222', 'double low-9 quotation mark'], ['60', 'less-than sign'], ['62', 'greater-than sign'], ['8804', 'less-than or equal to'], ['8805', 'greater-than or equal to'], ['8211', 'en dash'], ['8212', 'em dash'], ['175', 'macron'], ['8254', 'overline'], ['164', 'currency sign'], ['166', 'broken bar'], ['168', 'diaeresis'], ['161', 'inverted exclamation mark'], ['191', 'turned question mark'], ['710', 'circumflex accent'], ['732', 'small tilde'], ['176', 'degree sign'], ['8722', 'minus sign'], ['177', 'plus-minus sign'], ['247', 'division sign'], ['8260', 'fraction slash'], ['215', 'multiplication sign'], ['185', 'superscript one'], ['178', 'superscript two'], ['179', 'superscript three'], ['188', 'fraction one quarter'], ['189', 'fraction one half'], ['190', 'fraction three quarters'], ['402', 'function / florin'], ['8747', 'integral'], ['8721', 'n-ary sumation'], ['8734', 'infinity'], ['8730', 'square root'], ['8764', 'similar to'], ['8773', 'approximately equal to'], ['8776', 'almost equal to'], ['8800', 'not equal to'], ['8801', 'identical to'], ['8712', 'element of'], ['8713', 'not an element of'], ['8715', 'contains as member'], ['8719', 'n-ary product'], ['8743', 'logical and'], ['8744', 'logical or'], ['172', 'not sign'], ['8745', 'intersection'], ['8746', 'union'], ['8706', 'partial differential'], ['8704', 'for all'], ['8707', 'there exists'], ['8709', 'diameter'], ['8711', 'backward difference'], ['8727', 'asterisk operator'], ['8733', 'proportional to'], ['8736', 'angle'], ['180', 'acute accent'], ['184', 'cedilla'], ['170', 'feminine ordinal indicator'], ['186', 'masculine ordinal indicator'], ['8224', 'dagger'], ['8225', 'double dagger'], ['192', 'A - grave'], ['193', 'A - acute'], ['194', 'A - circumflex'], ['195', 'A - tilde'], ['196', 'A - diaeresis'], ['197', 'A - ring above'], ['256', 'A - macron'], ['198', 'ligature AE'], ['199', 'C - cedilla'], ['200', 'E - grave'], ['201', 'E - acute'], ['202', 'E - circumflex'], ['203', 'E - diaeresis'], ['274', 'E - macron'], ['204', 'I - grave'], ['205', 'I - acute'], ['206', 'I - circumflex'], ['207', 'I - diaeresis'], ['298', 'I - macron'], ['208', 'ETH'], ['209', 'N - tilde'], ['210', 'O - grave'], ['211', 'O - acute'], ['212', 'O - circumflex'], ['213', 'O - tilde'], ['214', 'O - diaeresis'], ['216', 'O - slash'], ['332', 'O - macron'], ['338', 'ligature OE'], ['352', 'S - caron'], ['217', 'U - grave'], ['218', 'U - acute'], ['219', 'U - circumflex'], ['220', 'U - diaeresis'], ['362', 'U - macron'], ['221', 'Y - acute'], ['376', 'Y - diaeresis'], ['562', 'Y - macron'], ['222', 'THORN'], ['224', 'a - grave'], ['225', 'a - acute'], ['226', 'a - circumflex'], ['227', 'a - tilde'], ['228', 'a - diaeresis'], ['229', 'a - ring above'], ['257', 'a - macron'], ['230', 'ligature ae'], ['231', 'c - cedilla'], ['232', 'e - grave'], ['233', 'e - acute'], ['234', 'e - circumflex'], ['235', 'e - diaeresis'], ['275', 'e - macron'], ['236', 'i - grave'], ['237', 'i - acute'], ['238', 'i - circumflex'], ['239', 'i - diaeresis'], ['299', 'i - macron'], ['240', 'eth'], ['241', 'n - tilde'], ['242', 'o - grave'], ['243', 'o - acute'], ['244', 'o - circumflex'], ['245', 'o - tilde'], ['246', 'o - diaeresis'], ['248', 'o slash'], ['333', 'o macron'], ['339', 'ligature oe'], ['353', 's - caron'], ['249', 'u - grave'], ['250', 'u - acute'], ['251', 'u - circumflex'], ['252', 'u - diaeresis'], ['363', 'u - macron'], ['253', 'y - acute'], ['254', 'thorn'], ['255', 'y - diaeresis'], ['563', 'y - macron'], ['913', 'Alpha'], ['914', 'Beta'], ['915', 'Gamma'], ['916', 'Delta'], ['917', 'Epsilon'], ['918', 'Zeta'], ['919', 'Eta'], ['920', 'Theta'], ['921', 'Iota'], ['922', 'Kappa'], ['923', 'Lambda'], ['924', 'Mu'], ['925', 'Nu'], ['926', 'Xi'], ['927', 'Omicron'], ['928', 'Pi'], ['929', 'Rho'], ['931', 'Sigma'], ['932', 'Tau'], ['933', 'Upsilon'], ['934', 'Phi'], ['935', 'Chi'], ['936', 'Psi'], ['937', 'Omega'], ['945', 'alpha'], ['946', 'beta'], ['947', 'gamma'], ['948', 'delta'], ['949', 'epsilon'], ['950', 'zeta'], ['951', 'eta'], ['952', 'theta'], ['953', 'iota'], ['954', 'kappa'], ['955', 'lambda'], ['956', 'mu'], ['957', 'nu'], ['958', 'xi'], ['959', 'omicron'], ['960', 'pi'], ['961', 'rho'], ['962', 'final sigma'], ['963', 'sigma'], ['964', 'tau'], ['965', 'upsilon'], ['966', 'phi'], ['967', 'chi'], ['968', 'psi'], ['969', 'omega'], ['8501', 'alef symbol'], ['982', 'pi symbol'], ['8476', 'real part symbol'], ['978', 'upsilon - hook symbol'], ['8472', 'Weierstrass p'], ['8465', 'imaginary part'], ['8592', 'leftwards arrow'], ['8593', 'upwards arrow'], ['8594', 'rightwards arrow'], ['8595', 'downwards arrow'], ['8596', 'left right arrow'], ['8629', 'carriage return'], ['8656', 'leftwards double arrow'], ['8657', 'upwards double arrow'], ['8658', 'rightwards double arrow'], ['8659', 'downwards double arrow'], ['8660', 'left right double arrow'], ['8756', 'therefore'], ['8834', 'subset of'], ['8835', 'superset of'], ['8836', 'not a subset of'], ['8838', 'subset of or equal to'], ['8839', 'superset of or equal to'], ['8853', 'circled plus'], ['8855', 'circled times'], ['8869', 'perpendicular'], ['8901', 'dot operator'], ['8968', 'left ceiling'], ['8969', 'right ceiling'], ['8970', 'left floor'], ['8971', 'right floor'], ['9001', 'left-pointing angle bracket'], ['9002', 'right-pointing angle bracket'], ['9674', 'lozenge'], ['9824', 'black spade suit'], ['9827', 'black club suit'], ['9829', 'black heart suit'], ['9830', 'black diamond suit'], ['8194', 'en space'], ['8195', 'em space'], ['8201', 'thin space'], ['8204', 'zero width non-joiner'], ['8205', 'zero width joiner'], ['8206', 'left-to-right mark'], ['8207', 'right-to-left mark']];
    };
    var charmapFilter = function charmapFilter(charmap) {
      return global$1.grep(charmap, function (item) {
        return isArray(item) && item.length === 2;
      });
    };
    var getCharsFromSetting = function getCharsFromSetting(settingValue) {
      if (isArray(settingValue)) {
        return [].concat(charmapFilter(settingValue));
      }
      if (typeof settingValue === 'function') {
        return settingValue();
      }
      return [];
    };
    var extendCharMap = function extendCharMap(editor, charmap) {
      var userCharMap = $_b1hvs89tjk26xiu7.getCharMap(editor);
      if (userCharMap) {
        charmap = getCharsFromSetting(userCharMap);
      }
      var userCharMapAppend = $_b1hvs89tjk26xiu7.getCharMapAppend(editor);
      if (userCharMapAppend) {
        return [].concat(charmap).concat(getCharsFromSetting(userCharMapAppend));
      }
      return charmap;
    };
    var getCharMap$1 = function getCharMap$1(editor) {
      return extendCharMap(editor, getDefaultCharMap());
    };
    var $_c01sm49rjk26xiu1 = { getCharMap: getCharMap$1 };

    var get = function get(editor) {
      var getCharMap = function getCharMap() {
        return $_c01sm49rjk26xiu1.getCharMap(editor);
      };
      var insertChar = function insertChar(chr) {
        $_explz69pjk26xity.insertChar(editor, chr);
      };
      return {
        getCharMap: getCharMap,
        insertChar: insertChar
      };
    };
    var $_2w1mgm9ojk26xitv = { get: get };

    var getHtml = function getHtml(charmap) {
      var gridHtml, x, y;
      var width = Math.min(charmap.length, 25);
      var height = Math.ceil(charmap.length / width);
      gridHtml = '<table role="presentation" cellspacing="0" class="mce-charmap"><tbody>';
      for (y = 0; y < height; y++) {
        gridHtml += '<tr>';
        for (x = 0; x < width; x++) {
          var index = y * width + x;
          if (index < charmap.length) {
            var chr = charmap[index];
            var charCode = parseInt(chr[0], 10);
            var chrText = chr ? String.fromCharCode(charCode) : '&nbsp;';
            gridHtml += '<td title="' + chr[1] + '">' + '<div tabindex="-1" title="' + chr[1] + '" role="button" data-chr="' + charCode + '">' + chrText + '</div>' + '</td>';
          } else {
            gridHtml += '<td />';
          }
        }
        gridHtml += '</tr>';
      }
      gridHtml += '</tbody></table>';
      return gridHtml;
    };
    var $_etb8o69wjk26xiui = { getHtml: getHtml };

    var getParentTd = function getParentTd(elm) {
      while (elm) {
        if (elm.nodeName === 'TD') {
          return elm;
        }
        elm = elm.parentNode;
      }
    };
    var open = function open(editor) {
      var win;
      var charMapPanel = {
        type: 'container',
        html: $_etb8o69wjk26xiui.getHtml($_c01sm49rjk26xiu1.getCharMap(editor)),
        onclick: function onclick(e) {
          var target = e.target;
          if (/^(TD|DIV)$/.test(target.nodeName)) {
            var charDiv = getParentTd(target).firstChild;
            if (charDiv && charDiv.hasAttribute('data-chr')) {
              var charCodeString = charDiv.getAttribute('data-chr');
              var charCode = parseInt(charCodeString, 10);
              if (!isNaN(charCode)) {
                $_explz69pjk26xity.insertChar(editor, String.fromCharCode(charCode));
              }
              if (!e.ctrlKey) {
                win.close();
              }
            }
          }
        },
        onmouseover: function onmouseover(e) {
          var td = getParentTd(e.target);
          if (td && td.firstChild) {
            win.find('#preview').text(td.firstChild.firstChild.data);
            win.find('#previewTitle').text(td.title);
          } else {
            win.find('#preview').text(' ');
            win.find('#previewTitle').text(' ');
          }
        }
      };
      win = editor.windowManager.open({
        title: 'Special character',
        spacing: 10,
        padding: 10,
        items: [charMapPanel, {
          type: 'container',
          layout: 'flex',
          direction: 'column',
          align: 'center',
          spacing: 5,
          minWidth: 160,
          minHeight: 160,
          items: [{
            type: 'label',
            name: 'preview',
            text: ' ',
            style: 'font-size: 40px; text-align: center',
            border: 1,
            minWidth: 140,
            minHeight: 80
          }, {
            type: 'spacer',
            minHeight: 20
          }, {
            type: 'label',
            name: 'previewTitle',
            text: ' ',
            style: 'white-space: pre-wrap;',
            border: 1,
            minWidth: 140
          }]
        }],
        buttons: [{
          text: 'Close',
          onclick: function onclick() {
            win.close();
          }
        }]
      });
    };
    var $_fskos79vjk26xiu9 = { open: open };

    var register = function register(editor) {
      editor.addCommand('mceShowCharmap', function () {
        $_fskos79vjk26xiu9.open(editor);
      });
    };
    var $_18rdr29ujk26xiu8 = { register: register };

    var register$1 = function register$1(editor) {
      editor.addButton('charmap', {
        icon: 'charmap',
        tooltip: 'Special character',
        cmd: 'mceShowCharmap'
      });
      editor.addMenuItem('charmap', {
        icon: 'charmap',
        text: 'Special character',
        cmd: 'mceShowCharmap',
        context: 'insert'
      });
    };
    var $_5gbcyy9xjk26xiuj = { register: register$1 };

    global.add('charmap', function (editor) {
      $_18rdr29ujk26xiu8.register(editor);
      $_5gbcyy9xjk26xiuj.register(editor);
      return $_2w1mgm9ojk26xitv.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 963 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/codesample/index.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "codesample" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/codesample')
//   ES2015:
//     import 'tinymce/plugins/codesample'
__webpack_require__(/*! ./plugin.js */ 964);

/***/ }),
/* 964 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/codesample/plugin.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var codesample = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var getContentCss = function getContentCss(editor) {
      return editor.settings.codesample_content_css;
    };
    var getLanguages = function getLanguages(editor) {
      return editor.settings.codesample_languages;
    };
    var getDialogMinWidth = function getDialogMinWidth(editor) {
      return Math.min(global$1.DOM.getViewPort().w, editor.getParam('codesample_dialog_width', 800));
    };
    var getDialogMinHeight = function getDialogMinHeight(editor) {
      return Math.min(global$1.DOM.getViewPort().w, editor.getParam('codesample_dialog_height', 650));
    };
    var $_c1o0nmabjk26xivw = {
      getContentCss: getContentCss,
      getLanguages: getLanguages,
      getDialogMinWidth: getDialogMinWidth,
      getDialogMinHeight: getDialogMinHeight
    };

    var window$$1 = {};
    var global$2 = window$$1;
    var _self = typeof window$$1 !== 'undefined' ? window$$1 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self : {};
    var Prism = function () {
      var lang = /\blang(?:uage)?-(?!\*)(\w+)\b/i;
      var _ = _self.Prism = {
        util: {
          encode: function encode(tokens) {
            if (tokens instanceof Token) {
              return new Token(tokens.type, _.util.encode(tokens.content), tokens.alias);
            } else if (_.util.type(tokens) === 'Array') {
              return tokens.map(_.util.encode);
            } else {
              return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            }
          },
          type: function type(o) {
            return Object.prototype.toString.call(o).match(/\[object (\w+)\]/)[1];
          },
          clone: function clone(o) {
            var type = _.util.type(o);
            switch (type) {
              case 'Object':
                var clone = {};
                for (var key in o) {
                  if (o.hasOwnProperty(key)) {
                    clone[key] = _.util.clone(o[key]);
                  }
                }
                return clone;
              case 'Array':
                return o.map && o.map(function (v) {
                  return _.util.clone(v);
                });
            }
            return o;
          }
        },
        languages: {
          extend: function extend(id, redef) {
            var lang = _.util.clone(_.languages[id]);
            for (var key in redef) {
              lang[key] = redef[key];
            }
            return lang;
          },
          insertBefore: function insertBefore(inside, before, insert, root) {
            root = root || _.languages;
            var grammar = root[inside];
            if (arguments.length === 2) {
              insert = arguments[1];
              for (var newToken in insert) {
                if (insert.hasOwnProperty(newToken)) {
                  grammar[newToken] = insert[newToken];
                }
              }
              return grammar;
            }
            var ret = {};
            for (var token in grammar) {
              if (grammar.hasOwnProperty(token)) {
                if (token === before) {
                  for (var newToken in insert) {
                    if (insert.hasOwnProperty(newToken)) {
                      ret[newToken] = insert[newToken];
                    }
                  }
                }
                ret[token] = grammar[token];
              }
            }
            _.languages.DFS(_.languages, function (key, value) {
              if (value === root[inside] && key !== inside) {
                this[key] = ret;
              }
            });
            return root[inside] = ret;
          },
          DFS: function DFS(o, callback, type) {
            for (var i in o) {
              if (o.hasOwnProperty(i)) {
                callback.call(o, i, o[i], type || i);
                if (_.util.type(o[i]) === 'Object') {
                  _.languages.DFS(o[i], callback);
                } else if (_.util.type(o[i]) === 'Array') {
                  _.languages.DFS(o[i], callback, i);
                }
              }
            }
          }
        },
        plugins: {},
        highlightAll: function highlightAll(async, callback) {
          var elements = document.querySelectorAll('code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code');
          for (var i = 0, element = void 0; element = elements[i++];) {
            _.highlightElement(element, async === true, callback);
          }
        },
        highlightElement: function highlightElement(element, async, callback) {
          var language,
              grammar,
              parent$$1 = element;
          while (parent$$1 && !lang.test(parent$$1.className)) {
            parent$$1 = parent$$1.parentNode;
          }
          if (parent$$1) {
            language = (parent$$1.className.match(lang) || [, ''])[1];
            grammar = _.languages[language];
          }
          element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
          parent$$1 = element.parentNode;
          if (/pre/i.test(parent$$1.nodeName)) {
            parent$$1.className = parent$$1.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
          }
          var code = element.textContent;
          var env = {
            element: element,
            language: language,
            grammar: grammar,
            code: code
          };
          if (!code || !grammar) {
            _.hooks.run('complete', env);
            return;
          }
          _.hooks.run('before-highlight', env);
          if (async && _self.Worker) {
            var worker = new Worker(_.filename);
            worker.onmessage = function (evt) {
              env.highlightedCode = evt.data;
              _.hooks.run('before-insert', env);
              env.element.innerHTML = env.highlightedCode;
              if (callback) {
                callback.call(env.element);
              }
              _.hooks.run('after-highlight', env);
              _.hooks.run('complete', env);
            };
            worker.postMessage(JSON.stringify({
              language: env.language,
              code: env.code,
              immediateClose: true
            }));
          } else {
            env.highlightedCode = _.highlight(env.code, env.grammar, env.language);
            _.hooks.run('before-insert', env);
            env.element.innerHTML = env.highlightedCode;
            if (callback) {
              callback.call(element);
            }
            _.hooks.run('after-highlight', env);
            _.hooks.run('complete', env);
          }
        },
        highlight: function highlight(text, grammar, language) {
          var tokens = _.tokenize(text, grammar);
          return Token.stringify(_.util.encode(tokens), language);
        },
        tokenize: function tokenize(text, grammar, language) {
          var Token = _.Token;
          var strarr = [text];
          var rest = grammar.rest;
          if (rest) {
            for (var token in rest) {
              grammar[token] = rest[token];
            }
            delete grammar.rest;
          }
          tokenloop: for (var token in grammar) {
            if (!grammar.hasOwnProperty(token) || !grammar[token]) {
              continue;
            }
            var patterns = grammar[token];
            patterns = _.util.type(patterns) === 'Array' ? patterns : [patterns];
            for (var j = 0; j < patterns.length; ++j) {
              var pattern = patterns[j];
              var inside = pattern.inside;
              var lookbehind = !!pattern.lookbehind;
              var lookbehindLength = 0;
              var alias = pattern.alias;
              pattern = pattern.pattern || pattern;
              for (var i = 0; i < strarr.length; i++) {
                var str = strarr[i];
                if (strarr.length > text.length) {
                  break tokenloop;
                }
                if (str instanceof Token) {
                  continue;
                }
                pattern.lastIndex = 0;
                var match = pattern.exec(str);
                if (match) {
                  if (lookbehind) {
                    lookbehindLength = match[1].length;
                  }
                  var from = match.index - 1 + lookbehindLength;
                  match = match[0].slice(lookbehindLength);
                  var len = match.length,
                      to = from + len,
                      before = str.slice(0, from + 1),
                      after = str.slice(to + 1);
                  var args = [i, 1];
                  if (before) {
                    args.push(before);
                  }
                  var wrapped = new Token(token, inside ? _.tokenize(match, inside) : match, alias);
                  args.push(wrapped);
                  if (after) {
                    args.push(after);
                  }
                  Array.prototype.splice.apply(strarr, args);
                }
              }
            }
          }
          return strarr;
        },
        hooks: {
          all: {},
          add: function add(name$$1, callback) {
            var hooks = _.hooks.all;
            hooks[name$$1] = hooks[name$$1] || [];
            hooks[name$$1].push(callback);
          },
          run: function run(name$$1, env) {
            var callbacks = _.hooks.all[name$$1];
            if (!callbacks || !callbacks.length) {
              return;
            }
            for (var i = 0, callback = void 0; callback = callbacks[i++];) {
              callback(env);
            }
          }
        }
      };
      var Token = _.Token = function (type, content, alias) {
        this.type = type;
        this.content = content;
        this.alias = alias;
      };
      Token.stringify = function (o, language, parent$$1) {
        if (typeof o === 'string') {
          return o;
        }
        if (_.util.type(o) === 'Array') {
          return o.map(function (element) {
            return Token.stringify(element, language, o);
          }).join('');
        }
        var env = {
          type: o.type,
          content: Token.stringify(o.content, language, parent$$1),
          tag: 'span',
          classes: ['token', o.type],
          attributes: {},
          language: language,
          parent: parent$$1
        };
        if (env.type === 'comment') {
          env.attributes.spellcheck = 'true';
        }
        if (o.alias) {
          var aliases = _.util.type(o.alias) === 'Array' ? o.alias : [o.alias];
          Array.prototype.push.apply(env.classes, aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for (var name$$1 in env.attributes) {
          attributes += (attributes ? ' ' : '') + name$$1 + '="' + (env.attributes[name$$1] || '') + '"';
        }
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '" ' + attributes + '>' + env.content + '</' + env.tag + '>';
      };
      if (!_self.document) {
        if (!_self.addEventListener) {
          return _self.Prism;
        }
        _self.addEventListener('message', function (evt) {
          var message = JSON.parse(evt.data),
              lang = message.language,
              code = message.code,
              immediateClose = message.immediateClose;
          _self.postMessage(_.highlight(code, _.languages[lang], lang));
          if (immediateClose) {
            _self.close();
          }
        }, false);
        return _self.Prism;
      }
    }();
    if (typeof global$2 !== 'undefined') {
      global$2.Prism = Prism;
    }
    Prism.languages.markup = {
      comment: /<!--[\w\W]*?-->/,
      prolog: /<\?[\w\W]+?\?>/,
      doctype: /<!DOCTYPE[\w\W]+?>/,
      cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
      tag: {
        pattern: /<\/?[^\s>\/=.]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\\1|\\?(?!\1)[\w\W])*\1|[^\s'">=]+))?)*\s*\/?>/i,
        inside: {
          'tag': {
            pattern: /^<\/?[^\s>\/]+/i,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          'attr-value': {
            pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/i,
            inside: { punctuation: /[=>"']/ }
          },
          'punctuation': /\/?>/,
          'attr-name': {
            pattern: /[^\s>\/]+/,
            inside: { namespace: /^[^\s>\/:]+:/ }
          }
        }
      },
      entity: /&#?[\da-z]{1,8};/i
    };
    Prism.hooks.add('wrap', function (env) {
      if (env.type === 'entity') {
        env.attributes.title = env.content.replace(/&amp;/, '&');
      }
    });
    Prism.languages.xml = Prism.languages.markup;
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.css = {
      comment: /\/\*[\w\W]*?\*\//,
      atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*\{))/i,
        inside: { rule: /@[\w-]+/ }
      },
      url: /url\((?:(["'])(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
      selector: /[^\{\}\s][^\{\};]*?(?=\s*\{)/,
      string: /("|')(\\(?:\r\n|[\w\W])|(?!\1)[^\\\r\n])*\1/,
      property: /(\b|\B)[\w-]+(?=\s*:)/i,
      important: /\B!important\b/i,
      function: /[-a-z0-9]+(?=\()/i,
      punctuation: /[(){};:]/
    };
    Prism.languages.css.atrule.inside.rest = Prism.util.clone(Prism.languages.css);
    if (Prism.languages.markup) {
      Prism.languages.insertBefore('markup', 'tag', {
        style: {
          pattern: /<style[\w\W]*?>[\w\W]*?<\/style>/i,
          inside: {
            tag: {
              pattern: /<style[\w\W]*?>|<\/style>/i,
              inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.css
          },
          alias: 'language-css'
        }
      });
      Prism.languages.insertBefore('inside', 'attr-value', {
        'style-attr': {
          pattern: /\s*style=("|').*?\1/i,
          inside: {
            'attr-name': {
              pattern: /^\s*style/i,
              inside: Prism.languages.markup.tag.inside
            },
            'punctuation': /^\s*=\s*['"]|['"]\s*$/,
            'attr-value': {
              pattern: /.+/i,
              inside: Prism.languages.css
            }
          },
          alias: 'language-css'
        }
      }, Prism.languages.markup.tag);
    }
    Prism.languages.clike = {
      'comment': [{
        pattern: /(^|[^\\])\/\*[\w\W]*?\*\//,
        lookbehind: true
      }, {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true
      }],
      'string': /(["'])(\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      'class-name': {
        pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/i,
        lookbehind: true,
        inside: { punctuation: /(\.|\\)/ }
      },
      'keyword': /\b(if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
      'boolean': /\b(true|false)\b/,
      'function': /[a-z0-9_]+(?=\()/i,
      'number': /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)\b/i,
      'operator': /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
      'punctuation': /[{}[\];(),.:]/
    };
    Prism.languages.javascript = Prism.languages.extend('clike', {
      keyword: /\b(as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/,
      number: /\b-?(0x[\dA-Fa-f]+|0b[01]+|0o[0-7]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|Infinity)\b/,
      function: /[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*(?=\()/i
    });
    Prism.languages.insertBefore('javascript', 'keyword', {
      regex: {
        pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})]))/,
        lookbehind: true
      }
    });
    Prism.languages.insertBefore('javascript', 'class-name', {
      'template-string': {
        pattern: /`(?:\\`|\\?[^`])*`/,
        inside: {
          interpolation: {
            pattern: /\$\{[^}]+\}/,
            inside: {
              'interpolation-punctuation': {
                pattern: /^\$\{|\}$/,
                alias: 'punctuation'
              },
              'rest': Prism.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      }
    });
    if (Prism.languages.markup) {
      Prism.languages.insertBefore('markup', 'tag', {
        script: {
          pattern: /<script[\w\W]*?>[\w\W]*?<\/script>/i,
          inside: {
            tag: {
              pattern: /<script[\w\W]*?>|<\/script>/i,
              inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.javascript
          },
          alias: 'language-javascript'
        }
      });
    }
    Prism.languages.js = Prism.languages.javascript;
    Prism.languages.c = Prism.languages.extend('clike', {
      keyword: /\b(asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
      operator: /\-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|?\||[~^%?*\/]/,
      number: /\b-?(?:0x[\da-f]+|\d*\.?\d+(?:e[+-]?\d+)?)[ful]*\b/i
    });
    Prism.languages.insertBefore('c', 'string', {
      macro: {
        pattern: /(^\s*)#\s*[a-z]+([^\r\n\\]|\\.|\\(?:\r\n?|\n))*/im,
        lookbehind: true,
        alias: 'property',
        inside: {
          string: {
            pattern: /(#\s*include\s*)(<.+?>|("|')(\\?.)+?\3)/,
            lookbehind: true
          }
        }
      }
    });
    delete Prism.languages.c['class-name'];
    delete Prism.languages.c.boolean;
    Prism.languages.csharp = Prism.languages.extend('clike', {
      keyword: /\b(abstract|as|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|do|double|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|goto|if|implicit|in|int|interface|internal|is|lock|long|namespace|new|null|object|operator|out|override|params|private|protected|public|readonly|ref|return|sbyte|sealed|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|virtual|void|volatile|while|add|alias|ascending|async|await|descending|dynamic|from|get|global|group|into|join|let|orderby|partial|remove|select|set|value|var|where|yield)\b/,
      string: [/@("|')(\1\1|\\\1|\\?(?!\1)[\s\S])*\1/, /("|')(\\?.)*?\1/],
      number: /\b-?(0x[\da-f]+|\d*\.?\d+)\b/i
    });
    Prism.languages.insertBefore('csharp', 'keyword', {
      preprocessor: {
        pattern: /(^\s*)#.*/m,
        lookbehind: true
      }
    });
    Prism.languages.cpp = Prism.languages.extend('c', {
      keyword: /\b(alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
      boolean: /\b(true|false)\b/,
      operator: /[-+]{1,2}|!=?|<{1,2}=?|>{1,2}=?|\->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|?\||\?|\*|\/|\b(and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/
    });
    Prism.languages.insertBefore('cpp', 'keyword', {
      'class-name': {
        pattern: /(class\s+)[a-z0-9_]+/i,
        lookbehind: true
      }
    });
    Prism.languages.java = Prism.languages.extend('clike', {
      keyword: /\b(abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
      number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp\-]+\b|\b\d*\.?\d+(?:e[+-]?\d+)?[df]?\b/i,
      operator: {
        pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
        lookbehind: true
      }
    });
    Prism.languages.php = Prism.languages.extend('clike', {
      keyword: /\b(and|or|xor|array|as|break|case|cfunction|class|const|continue|declare|default|die|do|else|elseif|enddeclare|endfor|endforeach|endif|endswitch|endwhile|extends|for|foreach|function|include|include_once|global|if|new|return|static|switch|use|require|require_once|var|while|abstract|interface|public|implements|private|protected|parent|throw|null|echo|print|trait|namespace|final|yield|goto|instanceof|finally|try|catch)\b/i,
      constant: /\b[A-Z0-9_]{2,}\b/,
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\w\W]*?\*\/|\/\/.*)/,
        lookbehind: true
      }
    });
    Prism.languages.insertBefore('php', 'class-name', {
      'shell-comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        alias: 'comment'
      }
    });
    Prism.languages.insertBefore('php', 'keyword', {
      delimiter: /\?>|<\?(?:php)?/i,
      variable: /\$\w+\b/i,
      package: {
        pattern: /(\\|namespace\s+|use\s+)[\w\\]+/,
        lookbehind: true,
        inside: { punctuation: /\\/ }
      }
    });
    Prism.languages.insertBefore('php', 'operator', {
      property: {
        pattern: /(->)[\w]+/,
        lookbehind: true
      }
    });
    if (Prism.languages.markup) {
      Prism.hooks.add('before-highlight', function (env) {
        if (env.language !== 'php') {
          return;
        }
        env.tokenStack = [];
        env.backupCode = env.code;
        env.code = env.code.replace(/(?:<\?php|<\?)[\w\W]*?(?:\?>)/ig, function (match) {
          env.tokenStack.push(match);
          return '{{{PHP' + env.tokenStack.length + '}}}';
        });
      });
      Prism.hooks.add('before-insert', function (env) {
        if (env.language === 'php') {
          env.code = env.backupCode;
          delete env.backupCode;
        }
      });
      Prism.hooks.add('after-highlight', function (env) {
        if (env.language !== 'php') {
          return;
        }
        for (var i = 0, t = void 0; t = env.tokenStack[i]; i++) {
          env.highlightedCode = env.highlightedCode.replace('{{{PHP' + (i + 1) + '}}}', Prism.highlight(t, env.grammar, 'php').replace(/\$/g, '$$$$'));
        }
        env.element.innerHTML = env.highlightedCode;
      });
      Prism.hooks.add('wrap', function (env) {
        if (env.language === 'php' && env.type === 'markup') {
          env.content = env.content.replace(/(\{\{\{PHP[0-9]+\}\}\})/g, '<span class="token php">$1</span>');
        }
      });
      Prism.languages.insertBefore('php', 'comment', {
        markup: {
          pattern: /<[^?]\/?(.*?)>/,
          inside: Prism.languages.markup
        },
        php: /\{\{\{PHP[0-9]+\}\}\}/
      });
    }
    Prism.languages.python = {
      'comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true
      },
      'string': /"""[\s\S]+?"""|'''[\s\S]+?'''|("|')(?:\\?.)*?\1/,
      'function': {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_][a-zA-Z0-9_]*(?=\()/g,
        lookbehind: true
      },
      'class-name': {
        pattern: /(\bclass\s+)[a-z0-9_]+/i,
        lookbehind: true
      },
      'keyword': /\b(?:as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|pass|print|raise|return|try|while|with|yield)\b/,
      'boolean': /\b(?:True|False)\b/,
      'number': /\b-?(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*\.?\d*|\.\d+)(?:e[+-]?\d+)?j?\b/i,
      'operator': /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:or|and|not)\b/,
      'punctuation': /[{}[\];(),.:]/
    };
    (function (Prism) {
      Prism.languages.ruby = Prism.languages.extend('clike', {
        comment: /#(?!\{[^\r\n]*?\}).*/,
        keyword: /\b(alias|and|BEGIN|begin|break|case|class|def|define_method|defined|do|each|else|elsif|END|end|ensure|false|for|if|in|module|new|next|nil|not|or|raise|redo|require|rescue|retry|return|self|super|then|throw|true|undef|unless|until|when|while|yield)\b/
      });
      var interpolation = {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: 'tag'
          },
          rest: Prism.util.clone(Prism.languages.ruby)
        }
      };
      Prism.languages.insertBefore('ruby', 'keyword', {
        regex: [{
          pattern: /%r([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1[gim]{0,3}/,
          inside: { interpolation: interpolation }
        }, {
          pattern: /%r\((?:[^()\\]|\\[\s\S])*\)[gim]{0,3}/,
          inside: { interpolation: interpolation }
        }, {
          pattern: /%r\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}[gim]{0,3}/,
          inside: { interpolation: interpolation }
        }, {
          pattern: /%r\[(?:[^\[\]\\]|\\[\s\S])*\][gim]{0,3}/,
          inside: { interpolation: interpolation }
        }, {
          pattern: /%r<(?:[^<>\\]|\\[\s\S])*>[gim]{0,3}/,
          inside: { interpolation: interpolation }
        }, {
          pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\r\n])+\/[gim]{0,3}(?=\s*($|[\r\n,.;})]))/,
          lookbehind: true
        }],
        variable: /[@$]+[a-zA-Z_][a-zA-Z_0-9]*(?:[?!]|\b)/,
        symbol: /:[a-zA-Z_][a-zA-Z_0-9]*(?:[?!]|\b)/
      });
      Prism.languages.insertBefore('ruby', 'number', {
        builtin: /\b(Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Stat|File|Fixnum|Fload|Hash|Integer|IO|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|String|Struct|TMS|Symbol|ThreadGroup|Thread|Time|TrueClass)\b/,
        constant: /\b[A-Z][a-zA-Z_0-9]*(?:[?!]|\b)/
      });
      Prism.languages.ruby.string = [{
        pattern: /%[qQiIwWxs]?([^a-zA-Z0-9\s\{\(\[<])(?:[^\\]|\\[\s\S])*?\1/,
        inside: { interpolation: interpolation }
      }, {
        pattern: /%[qQiIwWxs]?\((?:[^()\\]|\\[\s\S])*\)/,
        inside: { interpolation: interpolation }
      }, {
        pattern: /%[qQiIwWxs]?\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/,
        inside: { interpolation: interpolation }
      }, {
        pattern: /%[qQiIwWxs]?\[(?:[^\[\]\\]|\\[\s\S])*\]/,
        inside: { interpolation: interpolation }
      }, {
        pattern: /%[qQiIwWxs]?<(?:[^<>\\]|\\[\s\S])*>/,
        inside: { interpolation: interpolation }
      }, {
        pattern: /("|')(#\{[^}]+\}|\\(?:\r?\n|\r)|\\?.)*?\1/,
        inside: { interpolation: interpolation }
      }];
    })(Prism);

    function isCodeSample(elm) {
      return elm && elm.nodeName === 'PRE' && elm.className.indexOf('language-') !== -1;
    }
    function trimArg(predicateFn) {
      return function (arg1, arg2) {
        return predicateFn(arg2);
      };
    }
    var $_7f16e0agjk26xixo = {
      isCodeSample: isCodeSample,
      trimArg: trimArg
    };

    var getSelectedCodeSample = function getSelectedCodeSample(editor) {
      var node = editor.selection.getNode();
      if ($_7f16e0agjk26xixo.isCodeSample(node)) {
        return node;
      }
      return null;
    };
    var insertCodeSample = function insertCodeSample(editor, language, code) {
      editor.undoManager.transact(function () {
        var node = getSelectedCodeSample(editor);
        code = global$1.DOM.encode(code);
        if (node) {
          editor.dom.setAttrib(node, 'class', 'language-' + language);
          node.innerHTML = code;
          Prism.highlightElement(node);
          editor.selection.select(node);
        } else {
          editor.insertContent('<pre id="__new" class="language-' + language + '">' + code + '</pre>');
          editor.selection.select(editor.$('#__new').removeAttr('id')[0]);
        }
      });
    };
    var getCurrentCode = function getCurrentCode(editor) {
      var node = getSelectedCodeSample(editor);
      if (node) {
        return node.textContent;
      }
      return '';
    };
    var $_1hlbg1adjk26xiw3 = {
      getSelectedCodeSample: getSelectedCodeSample,
      insertCodeSample: insertCodeSample,
      getCurrentCode: getCurrentCode
    };

    var getLanguages$1 = function getLanguages$1(editor) {
      var defaultLanguages = [{
        text: 'HTML/XML',
        value: 'markup'
      }, {
        text: 'JavaScript',
        value: 'javascript'
      }, {
        text: 'CSS',
        value: 'css'
      }, {
        text: 'PHP',
        value: 'php'
      }, {
        text: 'Ruby',
        value: 'ruby'
      }, {
        text: 'Python',
        value: 'python'
      }, {
        text: 'Java',
        value: 'java'
      }, {
        text: 'C',
        value: 'c'
      }, {
        text: 'C#',
        value: 'csharp'
      }, {
        text: 'C++',
        value: 'cpp'
      }];
      var customLanguages = $_c1o0nmabjk26xivw.getLanguages(editor);
      return customLanguages ? customLanguages : defaultLanguages;
    };
    var getCurrentLanguage = function getCurrentLanguage(editor) {
      var matches;
      var node = $_1hlbg1adjk26xiw3.getSelectedCodeSample(editor);
      if (node) {
        matches = node.className.match(/language-(\w+)/);
        return matches ? matches[1] : '';
      }
      return '';
    };
    var $_iab6lahjk26xixq = {
      getLanguages: getLanguages$1,
      getCurrentLanguage: getCurrentLanguage
    };

    var $_b7zprtaajk26xivv = {
      open: function open(editor) {
        var minWidth = $_c1o0nmabjk26xivw.getDialogMinWidth(editor);
        var minHeight = $_c1o0nmabjk26xivw.getDialogMinHeight(editor);
        var currentLanguage = $_iab6lahjk26xixq.getCurrentLanguage(editor);
        var currentLanguages = $_iab6lahjk26xixq.getLanguages(editor);
        var currentCode = $_1hlbg1adjk26xiw3.getCurrentCode(editor);
        editor.windowManager.open({
          title: 'Insert/Edit code sample',
          minWidth: minWidth,
          minHeight: minHeight,
          layout: 'flex',
          direction: 'column',
          align: 'stretch',
          body: [{
            type: 'listbox',
            name: 'language',
            label: 'Language',
            maxWidth: 200,
            value: currentLanguage,
            values: currentLanguages
          }, {
            type: 'textbox',
            name: 'code',
            multiline: true,
            spellcheck: false,
            ariaLabel: 'Code view',
            flex: 1,
            style: 'direction: ltr; text-align: left',
            classes: 'monospace',
            value: currentCode,
            autofocus: true
          }],
          onSubmit: function onSubmit(e) {
            $_1hlbg1adjk26xiw3.insertCodeSample(editor, e.data.language, e.data.code);
          }
        });
      }
    };

    var register = function register(editor) {
      editor.addCommand('codesample', function () {
        var node = editor.selection.getNode();
        if (editor.selection.isCollapsed() || $_7f16e0agjk26xixo.isCodeSample(node)) {
          $_b7zprtaajk26xivv.open(editor);
        } else {
          editor.formatter.toggle('code');
        }
      });
    };
    var $_83etvfa9jk26xivu = { register: register };

    var setup = function setup(editor) {
      var $ = editor.$;
      editor.on('PreProcess', function (e) {
        $('pre[contenteditable=false]', e.node).filter($_7f16e0agjk26xixo.trimArg($_7f16e0agjk26xixo.isCodeSample)).each(function (idx, elm) {
          var $elm = $(elm),
              code = elm.textContent;
          $elm.attr('class', $.trim($elm.attr('class')));
          $elm.removeAttr('contentEditable');
          $elm.empty().append($('<code></code>').each(function () {
            this.textContent = code;
          }));
        });
      });
      editor.on('SetContent', function () {
        var unprocessedCodeSamples = $('pre').filter($_7f16e0agjk26xixo.trimArg($_7f16e0agjk26xixo.isCodeSample)).filter(function (idx, elm) {
          return elm.contentEditable !== 'false';
        });
        if (unprocessedCodeSamples.length) {
          editor.undoManager.transact(function () {
            unprocessedCodeSamples.each(function (idx, elm) {
              $(elm).find('br').each(function (idx, elm) {
                elm.parentNode.replaceChild(editor.getDoc().createTextNode('\n'), elm);
              });
              elm.contentEditable = false;
              elm.innerHTML = editor.dom.encode(elm.textContent);
              Prism.highlightElement(elm);
              elm.className = $.trim(elm.className);
            });
          });
        }
      });
    };
    var $_btkyhhaijk26xixs = { setup: setup };

    var loadCss = function loadCss(editor, pluginUrl, addedInlineCss, addedCss) {
      var linkElm;
      var contentCss = $_c1o0nmabjk26xivw.getContentCss(editor);
      if (editor.inline && addedInlineCss.get()) {
        return;
      }
      if (!editor.inline && addedCss.get()) {
        return;
      }
      if (editor.inline) {
        addedInlineCss.set(true);
      } else {
        addedCss.set(true);
      }
      if (contentCss !== false) {
        linkElm = editor.dom.create('link', {
          rel: 'stylesheet',
          href: contentCss ? contentCss : pluginUrl + '/css/prism.css'
        });
        editor.getDoc().getElementsByTagName('head')[0].appendChild(linkElm);
      }
    };
    var $_fnwtqzajjk26xixu = { loadCss: loadCss };

    var register$1 = function register$1(editor) {
      editor.addButton('codesample', {
        cmd: 'codesample',
        title: 'Insert/Edit code sample'
      });
      editor.addMenuItem('codesample', {
        cmd: 'codesample',
        text: 'Code sample',
        icon: 'codesample'
      });
    };
    var $_130lrhakjk26xixv = { register: register$1 };

    var addedInlineCss = Cell(false);
    global.add('codesample', function (editor, pluginUrl) {
      var addedCss = Cell(false);
      $_btkyhhaijk26xixs.setup(editor);
      $_130lrhakjk26xixv.register(editor);
      $_83etvfa9jk26xivu.register(editor);
      editor.on('init', function () {
        $_fnwtqzajjk26xixu.loadCss(editor, pluginUrl, addedInlineCss, addedCss);
      });
      editor.on('dblclick', function (ev) {
        if ($_7f16e0agjk26xixo.isCodeSample(ev.target)) {
          $_b7zprtaajk26xivv.open(editor);
        }
      });
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 965 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/contextmenu/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "contextmenu" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/contextmenu')
//   ES2015:
//     import 'tinymce/plugins/contextmenu'
__webpack_require__(/*! ./plugin.js */ 966);

/***/ }),
/* 966 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/contextmenu/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var contextmenu = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var get = function get(visibleState) {
      var isContextMenuVisible = function isContextMenuVisible() {
        return visibleState.get();
      };
      return { isContextMenuVisible: isContextMenuVisible };
    };
    var $_1jqmujasjk26xj0c = { get: get };

    var shouldNeverUseNative = function shouldNeverUseNative(editor) {
      return editor.settings.contextmenu_never_use_native;
    };
    var getContextMenu = function getContextMenu(editor) {
      return editor.getParam('contextmenu', 'link openlink image inserttable | cell row column deletetable');
    };
    var $_914fysaujk26xj0f = {
      shouldNeverUseNative: shouldNeverUseNative,
      getContextMenu: getContextMenu
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var getUiContainer = function getUiContainer(editor) {
      return global$1.DOM.select(editor.settings.ui_container)[0];
    };

    var nu = function nu(x, y) {
      return {
        x: x,
        y: y
      };
    };
    var transpose = function transpose(pos, dx, dy) {
      return nu(pos.x + dx, pos.y + dy);
    };
    var fromPageXY = function fromPageXY(e) {
      return nu(e.pageX, e.pageY);
    };
    var fromClientXY = function fromClientXY(e) {
      return nu(e.clientX, e.clientY);
    };
    var transposeUiContainer = function transposeUiContainer(element, pos) {
      if (element && global$1.DOM.getStyle(element, 'position', true) !== 'static') {
        var containerPos = global$1.DOM.getPos(element);
        var dx = containerPos.x - element.scrollLeft;
        var dy = containerPos.y - element.scrollTop;
        return transpose(pos, -dx, -dy);
      } else {
        return transpose(pos, 0, 0);
      }
    };
    var transposeContentAreaContainer = function transposeContentAreaContainer(element, pos) {
      var containerPos = global$1.DOM.getPos(element);
      return transpose(pos, containerPos.x, containerPos.y);
    };
    var getPos = function getPos(editor, e) {
      if (editor.inline) {
        return transposeUiContainer(getUiContainer(editor), fromPageXY(e));
      } else {
        var iframePos = transposeContentAreaContainer(editor.getContentAreaContainer(), fromClientXY(e));
        return transposeUiContainer(getUiContainer(editor), iframePos);
      }
    };
    var $_ad6zk1avjk26xj0g = { getPos: getPos };

    var global$2 = tinymce.util.Tools.resolve('tinymce.ui.Factory');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var renderMenu = function renderMenu(editor, visibleState) {
      var menu, contextmenu;
      var items = [];
      contextmenu = $_914fysaujk26xj0f.getContextMenu(editor);
      global$3.each(contextmenu.split(/[ ,]/), function (name) {
        var item = editor.menuItems[name];
        if (name === '|') {
          item = { text: name };
        }
        if (item) {
          item.shortcut = '';
          items.push(item);
        }
      });
      for (var i = 0; i < items.length; i++) {
        if (items[i].text === '|') {
          if (i === 0 || i === items.length - 1) {
            items.splice(i, 1);
          }
        }
      }
      menu = global$2.create('menu', {
        items: items,
        context: 'contextmenu',
        classes: 'contextmenu'
      });
      menu.uiContainer = getUiContainer(editor);
      menu.renderTo(getUiContainer(editor));
      menu.on('hide', function (e) {
        if (e.control === this) {
          visibleState.set(false);
        }
      });
      editor.on('remove', function () {
        menu.remove();
        menu = null;
      });
      return menu;
    };
    var show = function show(editor, pos, visibleState, menu) {
      if (menu.get() === null) {
        menu.set(renderMenu(editor, visibleState));
      } else {
        menu.get().show();
      }
      menu.get().moveTo(pos.x, pos.y);
      visibleState.set(true);
    };
    var $_8vn3y5ayjk26xj0l = { show: show };

    var isNativeOverrideKeyEvent = function isNativeOverrideKeyEvent(editor, e) {
      return e.ctrlKey && !$_914fysaujk26xj0f.shouldNeverUseNative(editor);
    };
    var setup = function setup(editor, visibleState, menu) {
      editor.on('contextmenu', function (e) {
        if (isNativeOverrideKeyEvent(editor, e)) {
          return;
        }
        e.preventDefault();
        $_8vn3y5ayjk26xj0l.show(editor, $_ad6zk1avjk26xj0g.getPos(editor, e), visibleState, menu);
      });
    };
    var $_3spps9atjk26xj0d = { setup: setup };

    global.add('contextmenu', function (editor) {
      var menu = Cell(null),
          visibleState = Cell(false);
      $_3spps9atjk26xj0d.setup(editor, visibleState, menu);
      return $_1jqmujasjk26xj0c.get(visibleState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 967 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/emoticons/index.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "emoticons" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/emoticons')
//   ES2015:
//     import 'tinymce/plugins/emoticons'
__webpack_require__(/*! ./plugin.js */ 968);

/***/ }),
/* 968 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/emoticons/plugin.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var emoticons = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var emoticons = [['cool', 'cry', 'embarassed', 'foot-in-mouth'], ['frown', 'innocent', 'kiss', 'laughing'], ['money-mouth', 'sealed', 'smile', 'surprised'], ['tongue-out', 'undecided', 'wink', 'yell']];
    var getHtml = function getHtml(pluginUrl) {
      var emoticonsHtml;
      emoticonsHtml = '<table role="list" class="mce-grid">';
      global$1.each(emoticons, function (row) {
        emoticonsHtml += '<tr>';
        global$1.each(row, function (icon) {
          var emoticonUrl = pluginUrl + '/img/smiley-' + icon + '.gif';
          emoticonsHtml += '<td><a href="#" data-mce-url="' + emoticonUrl + '" data-mce-alt="' + icon + '" tabindex="-1" ' + 'role="option" aria-label="' + icon + '"><img src="' + emoticonUrl + '" style="width: 18px; height: 18px" role="presentation" /></a></td>';
        });
        emoticonsHtml += '</tr>';
      });
      emoticonsHtml += '</table>';
      return emoticonsHtml;
    };
    var $_1s9vvjbajk26xj1l = { getHtml: getHtml };

    var insertEmoticon = function insertEmoticon(editor, src, alt) {
      editor.insertContent(editor.dom.createHTML('img', {
        src: src,
        alt: alt
      }));
    };
    var register = function register(editor, pluginUrl) {
      var panelHtml = $_1s9vvjbajk26xj1l.getHtml(pluginUrl);
      editor.addButton('emoticons', {
        type: 'panelbutton',
        panel: {
          role: 'application',
          autohide: true,
          html: panelHtml,
          onclick: function onclick(e) {
            var linkElm = editor.dom.getParent(e.target, 'a');
            if (linkElm) {
              insertEmoticon(editor, linkElm.getAttribute('data-mce-url'), linkElm.getAttribute('data-mce-alt'));
              this.hide();
            }
          }
        },
        tooltip: 'Emoticons'
      });
    };
    var $_2tlvdwb9jk26xj1k = { register: register };

    global.add('emoticons', function (editor, pluginUrl) {
      $_2tlvdwb9jk26xj1k.register(editor, pluginUrl);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 969 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/fullscreen/index.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "fullscreen" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullscreen')
//   ES2015:
//     import 'tinymce/plugins/fullscreen'
__webpack_require__(/*! ./plugin.js */ 970);

/***/ }),
/* 970 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/fullscreen/plugin.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var fullscreen = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var get = function get(fullscreenState) {
      return {
        isFullscreen: function isFullscreen() {
          return fullscreenState.get() !== null;
        }
      };
    };
    var $_6y7x56cejk26xj7w = { get: get };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var fireFullscreenStateChanged = function fireFullscreenStateChanged(editor, state) {
      editor.fire('FullscreenStateChanged', { state: state });
    };
    var $_21u1x4cijk26xj81 = { fireFullscreenStateChanged: fireFullscreenStateChanged };

    var DOM = global$1.DOM;
    var getWindowSize = function getWindowSize() {
      var w;
      var h;
      var win = window;
      var doc = document;
      var body = doc.body;
      if (body.offsetWidth) {
        w = body.offsetWidth;
        h = body.offsetHeight;
      }
      if (win.innerWidth && win.innerHeight) {
        w = win.innerWidth;
        h = win.innerHeight;
      }
      return {
        w: w,
        h: h
      };
    };
    var getScrollPos = function getScrollPos() {
      var vp = DOM.getViewPort();
      return {
        x: vp.x,
        y: vp.y
      };
    };
    var setScrollPos = function setScrollPos(pos) {
      window.scrollTo(pos.x, pos.y);
    };
    var toggleFullscreen = function toggleFullscreen(editor, fullscreenState) {
      var body = document.body;
      var documentElement = document.documentElement;
      var editorContainerStyle;
      var editorContainer, iframe, iframeStyle;
      var fullscreenInfo = fullscreenState.get();
      var resize = function resize() {
        DOM.setStyle(iframe, 'height', getWindowSize().h - (editorContainer.clientHeight - iframe.clientHeight));
      };
      var removeResize = function removeResize() {
        DOM.unbind(window, 'resize', resize);
      };
      editorContainer = editor.getContainer();
      editorContainerStyle = editorContainer.style;
      iframe = editor.getContentAreaContainer().firstChild;
      iframeStyle = iframe.style;
      if (!fullscreenInfo) {
        var newFullScreenInfo = {
          scrollPos: getScrollPos(),
          containerWidth: editorContainerStyle.width,
          containerHeight: editorContainerStyle.height,
          iframeWidth: iframeStyle.width,
          iframeHeight: iframeStyle.height,
          resizeHandler: resize,
          removeHandler: removeResize
        };
        iframeStyle.width = iframeStyle.height = '100%';
        editorContainerStyle.width = editorContainerStyle.height = '';
        DOM.addClass(body, 'mce-fullscreen');
        DOM.addClass(documentElement, 'mce-fullscreen');
        DOM.addClass(editorContainer, 'mce-fullscreen');
        DOM.bind(window, 'resize', resize);
        editor.on('remove', removeResize);
        resize();
        fullscreenState.set(newFullScreenInfo);
        $_21u1x4cijk26xj81.fireFullscreenStateChanged(editor, true);
      } else {
        iframeStyle.width = fullscreenInfo.iframeWidth;
        iframeStyle.height = fullscreenInfo.iframeHeight;
        if (fullscreenInfo.containerWidth) {
          editorContainerStyle.width = fullscreenInfo.containerWidth;
        }
        if (fullscreenInfo.containerHeight) {
          editorContainerStyle.height = fullscreenInfo.containerHeight;
        }
        DOM.removeClass(body, 'mce-fullscreen');
        DOM.removeClass(documentElement, 'mce-fullscreen');
        DOM.removeClass(editorContainer, 'mce-fullscreen');
        setScrollPos(fullscreenInfo.scrollPos);
        DOM.unbind(window, 'resize', fullscreenInfo.resizeHandler);
        editor.off('remove', fullscreenInfo.removeHandler);
        fullscreenState.set(null);
        $_21u1x4cijk26xj81.fireFullscreenStateChanged(editor, false);
      }
    };
    var $_3c5dyccgjk26xj7y = { toggleFullscreen: toggleFullscreen };

    var register = function register(editor, fullscreenState) {
      editor.addCommand('mceFullScreen', function () {
        $_3c5dyccgjk26xj7y.toggleFullscreen(editor, fullscreenState);
      });
    };
    var $_aplep0cfjk26xj7w = { register: register };

    var postRender = function postRender(editor) {
      return function (e) {
        var ctrl = e.control;
        editor.on('FullscreenStateChanged', function (e) {
          ctrl.active(e.state);
        });
      };
    };
    var register$1 = function register$1(editor) {
      editor.addMenuItem('fullscreen', {
        text: 'Fullscreen',
        shortcut: 'Ctrl+Shift+F',
        selectable: true,
        cmd: 'mceFullScreen',
        onPostRender: postRender(editor),
        context: 'view'
      });
      editor.addButton('fullscreen', {
        active: false,
        tooltip: 'Fullscreen',
        cmd: 'mceFullScreen',
        onPostRender: postRender(editor)
      });
    };
    var $_13ec7eckjk26xj8j = { register: register$1 };

    global.add('fullscreen', function (editor) {
      var fullscreenState = Cell(null);
      if (editor.settings.inline) {
        return $_6y7x56cejk26xj7w.get(fullscreenState);
      }
      $_aplep0cfjk26xj7w.register(editor, fullscreenState);
      $_13ec7eckjk26xj8j.register(editor);
      editor.addShortcut('Ctrl+Shift+F', '', 'mceFullScreen');
      return $_6y7x56cejk26xj7w.get(fullscreenState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 971 */
/*!**************************************************!*\
  !*** ./src/packages/tinymce/plugins/hr/index.js ***!
  \**************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "hr" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/hr')
//   ES2015:
//     import 'tinymce/plugins/hr'
__webpack_require__(/*! ./plugin.js */ 972);

/***/ }),
/* 972 */
/*!***************************************************!*\
  !*** ./src/packages/tinymce/plugins/hr/plugin.js ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var hr = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var register = function register(editor) {
      editor.addCommand('InsertHorizontalRule', function () {
        editor.execCommand('mceInsertContent', false, '<hr />');
      });
    };
    var $_c8b6blcnjk26xj9f = { register: register };

    var register$1 = function register$1(editor) {
      editor.addButton('hr', {
        icon: 'hr',
        tooltip: 'Horizontal line',
        cmd: 'InsertHorizontalRule'
      });
      editor.addMenuItem('hr', {
        icon: 'hr',
        text: 'Horizontal line',
        cmd: 'InsertHorizontalRule',
        context: 'insert'
      });
    };
    var $_54bkewcojk26xj9g = { register: register$1 };

    global.add('hr', function (editor) {
      $_c8b6blcnjk26xj9f.register(editor);
      $_54bkewcojk26xj9g.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 973 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/imagetools/index.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "imagetools" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/imagetools')
//   ES2015:
//     import 'tinymce/plugins/imagetools'
__webpack_require__(/*! ./plugin.js */ 974);

/***/ }),
/* 974 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/imagetools/plugin.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var imagetools = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    function create(width, height) {
      return resize(document.createElement('canvas'), width, height);
    }
    function clone(canvas) {
      var tCanvas, ctx;
      tCanvas = create(canvas.width, canvas.height);
      ctx = get2dContext(tCanvas);
      ctx.drawImage(canvas, 0, 0);
      return tCanvas;
    }
    function get2dContext(canvas) {
      return canvas.getContext('2d');
    }
    function get3dContext(canvas) {
      var gl = null;
      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      } catch (e) {}
      if (!gl) {
        gl = null;
      }
      return gl;
    }
    function resize(canvas, width, height) {
      canvas.width = width;
      canvas.height = height;
      return canvas;
    }
    var $_dnf8gydrjk26xjgs = {
      create: create,
      clone: clone,
      resize: resize,
      get2dContext: get2dContext,
      get3dContext: get3dContext
    };

    function getWidth(image) {
      return image.naturalWidth || image.width;
    }
    function getHeight(image) {
      return image.naturalHeight || image.height;
    }
    var $_73mnywdsjk26xjgu = {
      getWidth: getWidth,
      getHeight: getHeight
    };

    var promise = function promise() {
      var Promise = function Promise(fn) {
        if (_typeof(this) !== 'object') throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = null;
        this._value = null;
        this._deferreds = [];
        doResolve(fn, bind(resolve, this), bind(reject, this));
      };
      var asap = Promise.immediateFn || typeof setImmediate === 'function' && setImmediate || function (fn) {
        setTimeout(fn, 1);
      };
      function bind(fn, thisArg) {
        return function () {
          fn.apply(thisArg, arguments);
        };
      }
      var isArray = Array.isArray || function (value) {
        return Object.prototype.toString.call(value) === '[object Array]';
      };
      function handle(deferred) {
        var me = this;
        if (this._state === null) {
          this._deferreds.push(deferred);
          return;
        }
        asap(function () {
          var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
          if (cb === null) {
            (me._state ? deferred.resolve : deferred.reject)(me._value);
            return;
          }
          var ret;
          try {
            ret = cb(me._value);
          } catch (e) {
            deferred.reject(e);
            return;
          }
          deferred.resolve(ret);
        });
      }
      function resolve(newValue) {
        try {
          if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
          if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (typeof then === 'function') {
              doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
              return;
            }
          }
          this._state = true;
          this._value = newValue;
          finale.call(this);
        } catch (e) {
          reject.call(this, e);
        }
      }
      function reject(newValue) {
        this._state = false;
        this._value = newValue;
        finale.call(this);
      }
      function finale() {
        for (var i = 0, len = this._deferreds.length; i < len; i++) {
          handle.call(this, this._deferreds[i]);
        }
        this._deferreds = null;
      }
      function Handler(onFulfilled, onRejected, resolve, reject) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.resolve = resolve;
        this.reject = reject;
      }
      function doResolve(fn, onFulfilled, onRejected) {
        var done = false;
        try {
          fn(function (value) {
            if (done) return;
            done = true;
            onFulfilled(value);
          }, function (reason) {
            if (done) return;
            done = true;
            onRejected(reason);
          });
        } catch (ex) {
          if (done) return;
          done = true;
          onRejected(ex);
        }
      }
      Promise.prototype['catch'] = function (onRejected) {
        return this.then(null, onRejected);
      };
      Promise.prototype.then = function (onFulfilled, onRejected) {
        var me = this;
        return new Promise(function (resolve, reject) {
          handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
        });
      };
      Promise.all = function () {
        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
        return new Promise(function (resolve, reject) {
          if (args.length === 0) return resolve([]);
          var remaining = args.length;
          function res(i, val) {
            try {
              if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                  then.call(val, function (val) {
                    res(i, val);
                  }, reject);
                  return;
                }
              }
              args[i] = val;
              if (--remaining === 0) {
                resolve(args);
              }
            } catch (ex) {
              reject(ex);
            }
          }
          for (var i = 0; i < args.length; i++) {
            res(i, args[i]);
          }
        });
      };
      Promise.resolve = function (value) {
        if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
          return value;
        }
        return new Promise(function (resolve) {
          resolve(value);
        });
      };
      Promise.reject = function (value) {
        return new Promise(function (resolve, reject) {
          reject(value);
        });
      };
      Promise.race = function (values) {
        return new Promise(function (resolve, reject) {
          for (var i = 0, len = values.length; i < len; i++) {
            values[i].then(resolve, reject);
          }
        });
      };
      return Promise;
    };
    var Promise = window.Promise ? window.Promise : promise();

    var constant = function constant(value) {
      return function () {
        return value;
      };
    };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };

    var never = constant(false);
    var always = constant(true);

    var never$1 = never;
    var always$1 = always;
    var none = function none() {
      return NONE;
    };
    var NONE = function () {
      var eq = function eq(o) {
        return o.isNone();
      };
      var call$$1 = function call$$1(thunk) {
        return thunk();
      };
      var id = function id(n) {
        return n;
      };
      var noop$$1 = function noop$$1() {};
      var nul = function nul() {
        return null;
      };
      var undef = function undef() {
        return undefined;
      };
      var me = {
        fold: function fold(n, s) {
          return n();
        },
        is: never$1,
        isSome: never$1,
        isNone: always$1,
        getOr: id,
        getOrThunk: call$$1,
        getOrDie: function getOrDie(msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: nul,
        getOrUndefined: undef,
        or: id,
        orThunk: call$$1,
        map: none,
        ap: none,
        each: noop$$1,
        bind: none,
        flatten: none,
        exists: never$1,
        forall: always$1,
        filter: none,
        equals: eq,
        equals_: eq,
        toArray: function toArray() {
          return [];
        },
        toString: constant('none()')
      };
      if (Object.freeze) Object.freeze(me);
      return me;
    }();
    var some = function some(a) {
      var constant_a = function constant_a() {
        return a;
      };
      var self = function self() {
        return me;
      };
      var map = function map(f) {
        return some(f(a));
      };
      var bind = function bind(f) {
        return f(a);
      };
      var me = {
        fold: function fold(n, s) {
          return s(a);
        },
        is: function is(v) {
          return a === v;
        },
        isSome: always$1,
        isNone: never$1,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: map,
        ap: function ap(optfab) {
          return optfab.fold(none, function (fab) {
            return some(fab(a));
          });
        },
        each: function each(f) {
          f(a);
        },
        bind: bind,
        flatten: constant_a,
        exists: bind,
        forall: bind,
        filter: function filter(f) {
          return f(a) ? me : NONE;
        },
        equals: function equals(o) {
          return o.is(a);
        },
        equals_: function equals_(o, elementEq) {
          return o.fold(never$1, function (b) {
            return elementEq(a, b);
          });
        },
        toArray: function toArray() {
          return [a];
        },
        toString: function toString() {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function from(value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Option = {
      some: some,
      none: none,
      from: from
    };

    var Global = typeof window !== 'undefined' ? window : Function('return this;')();

    var path = function path(parts, scope) {
      var o = scope !== undefined && scope !== null ? scope : Global;
      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
        o = o[parts[i]];
      }return o;
    };
    var resolve = function resolve(p, scope) {
      var parts = p.split('.');
      return path(parts, scope);
    };

    var unsafe = function unsafe(name, scope) {
      return resolve(name, scope);
    };
    var getOrDie = function getOrDie(name, scope) {
      var actual = unsafe(name, scope);
      if (actual === undefined || actual === null) throw name + ' not available on this browser';
      return actual;
    };
    var $_chncyqdxjk26xjha = { getOrDie: getOrDie };

    function Blob(parts, properties) {
      var f = $_chncyqdxjk26xjha.getOrDie('Blob');
      return new f(parts, properties);
    }

    function FileReader() {
      var f = $_chncyqdxjk26xjha.getOrDie('FileReader');
      return new f();
    }

    function Uint8Array(arr) {
      var f = $_chncyqdxjk26xjha.getOrDie('Uint8Array');
      return new f(arr);
    }

    var requestAnimationFrame = function requestAnimationFrame(callback) {
      var f = $_chncyqdxjk26xjha.getOrDie('requestAnimationFrame');
      f(callback);
    };
    var atob = function atob(base64) {
      var f = $_chncyqdxjk26xjha.getOrDie('atob');
      return f(base64);
    };
    var $_ai4b41e2jk26xjhh = {
      atob: atob,
      requestAnimationFrame: requestAnimationFrame
    };

    function imageToBlob(image) {
      var src = image.src;
      if (src.indexOf('data:') === 0) {
        return dataUriToBlob(src);
      }
      return anyUriToBlob(src);
    }
    function blobToImage(blob) {
      return new Promise(function (resolve, reject) {
        var blobUrl = URL.createObjectURL(blob);
        var image = new Image();
        var removeListeners = function removeListeners() {
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', error);
        };
        function loaded() {
          removeListeners();
          resolve(image);
        }
        function error() {
          removeListeners();
          reject('Unable to load data of type ' + blob.type + ': ' + blobUrl);
        }
        image.addEventListener('load', loaded);
        image.addEventListener('error', error);
        image.src = blobUrl;
        if (image.complete) {
          loaded();
        }
      });
    }
    function anyUriToBlob(url) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          }
        };
        xhr.onerror = function () {
          var _this = this;
          var corsError = function corsError() {
            var obj = new Error('No access to download image');
            obj.code = 18;
            obj.name = 'SecurityError';
            return obj;
          };
          var genericError = function genericError() {
            return new Error('Error ' + _this.status + ' downloading image');
          };
          reject(this.status === 0 ? corsError() : genericError());
        };
        xhr.send();
      });
    }
    function dataUriToBlobSync(uri) {
      var data = uri.split(',');
      var matches = /data:([^;]+)/.exec(data[0]);
      if (!matches) return Option.none();
      var mimetype = matches[1];
      var base64 = data[1];
      var sliceSize = 1024;
      var byteCharacters = $_ai4b41e2jk26xjhh.atob(base64);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);
      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = Uint8Array(bytes);
      }
      return Option.some(Blob(byteArrays, { type: mimetype }));
    }
    function dataUriToBlob(uri) {
      return new Promise(function (resolve, reject) {
        dataUriToBlobSync(uri).fold(function () {
          reject('uri is not base64: ' + uri);
        }, resolve);
      });
    }
    function uriToBlob(url) {
      if (url.indexOf('blob:') === 0) {
        return anyUriToBlob(url);
      }
      if (url.indexOf('data:') === 0) {
        return dataUriToBlob(url);
      }
      return null;
    }
    function canvasToBlob(canvas, type, quality) {
      type = type || 'image/png';
      if (HTMLCanvasElement.prototype.toBlob) {
        return new Promise(function (resolve) {
          canvas.toBlob(function (blob) {
            resolve(blob);
          }, type, quality);
        });
      } else {
        return dataUriToBlob(canvas.toDataURL(type, quality));
      }
    }
    function canvasToDataURL(getCanvas, type, quality) {
      type = type || 'image/png';
      return getCanvas.then(function (canvas) {
        return canvas.toDataURL(type, quality);
      });
    }
    function blobToCanvas(blob) {
      return blobToImage(blob).then(function (image) {
        revokeImageUrl(image);
        var context, canvas;
        canvas = $_dnf8gydrjk26xjgs.create($_73mnywdsjk26xjgu.getWidth(image), $_73mnywdsjk26xjgu.getHeight(image));
        context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
        context.drawImage(image, 0, 0);
        return canvas;
      });
    }
    function blobToDataUri(blob) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      });
    }
    function blobToArrayBuffer(blob) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsArrayBuffer(blob);
      });
    }
    function blobToBase64(blob) {
      return blobToDataUri(blob).then(function (dataUri) {
        return dataUri.split(',')[1];
      });
    }
    function revokeImageUrl(image) {
      URL.revokeObjectURL(image.src);
    }
    var $_bllwpldqjk26xjgd = {
      blobToImage: blobToImage,
      imageToBlob: imageToBlob,
      blobToArrayBuffer: blobToArrayBuffer,
      blobToDataUri: blobToDataUri,
      blobToBase64: blobToBase64,
      dataUriToBlobSync: dataUriToBlobSync,
      canvasToBlob: canvasToBlob,
      canvasToDataURL: canvasToDataURL,
      blobToCanvas: blobToCanvas,
      uriToBlob: uriToBlob
    };

    var blobToImage$1 = function blobToImage$1(image) {
      return $_bllwpldqjk26xjgd.blobToImage(image);
    };
    var imageToBlob$1 = function imageToBlob$1(blob) {
      return $_bllwpldqjk26xjgd.imageToBlob(blob);
    };
    var blobToDataUri$1 = function blobToDataUri$1(blob) {
      return $_bllwpldqjk26xjgd.blobToDataUri(blob);
    };
    var blobToBase64$1 = function blobToBase64$1(blob) {
      return $_bllwpldqjk26xjgd.blobToBase64(blob);
    };
    var dataUriToBlobSync$1 = function dataUriToBlobSync$1(uri) {
      return $_bllwpldqjk26xjgd.dataUriToBlobSync(uri);
    };
    var uriToBlob$1 = function uriToBlob$1(uri) {
      return Option.from($_bllwpldqjk26xjgd.uriToBlob(uri));
    };
    var $_8sw7dddpjk26xjg5 = {
      blobToImage: blobToImage$1,
      imageToBlob: imageToBlob$1,
      blobToDataUri: blobToDataUri$1,
      blobToBase64: blobToBase64$1,
      dataUriToBlobSync: dataUriToBlobSync$1,
      uriToBlob: uriToBlob$1
    };

    function create$1(getCanvas, blob, uri) {
      var initialType = blob.type;
      var getType = constant(initialType);
      function toBlob() {
        return Promise.resolve(blob);
      }
      function toDataURL() {
        return uri;
      }
      function toBase64() {
        return uri.split(',')[1];
      }
      function toAdjustedBlob(type, quality) {
        return getCanvas.then(function (canvas) {
          return $_bllwpldqjk26xjgd.canvasToBlob(canvas, type, quality);
        });
      }
      function toAdjustedDataURL(type, quality) {
        return getCanvas.then(function (canvas) {
          return $_bllwpldqjk26xjgd.canvasToDataURL(canvas, type, quality);
        });
      }
      function toAdjustedBase64(type, quality) {
        return toAdjustedDataURL(type, quality).then(function (dataurl) {
          return dataurl.split(',')[1];
        });
      }
      function toCanvas() {
        return getCanvas.then($_dnf8gydrjk26xjgs.clone);
      }
      return {
        getType: getType,
        toBlob: toBlob,
        toDataURL: toDataURL,
        toBase64: toBase64,
        toAdjustedBlob: toAdjustedBlob,
        toAdjustedDataURL: toAdjustedDataURL,
        toAdjustedBase64: toAdjustedBase64,
        toCanvas: toCanvas
      };
    }
    function fromBlob(blob) {
      return $_bllwpldqjk26xjgd.blobToDataUri(blob).then(function (uri) {
        return create$1($_bllwpldqjk26xjgd.blobToCanvas(blob), blob, uri);
      });
    }
    function fromCanvas(canvas, type) {
      return $_bllwpldqjk26xjgd.canvasToBlob(canvas, type).then(function (blob) {
        return create$1(Promise.resolve(canvas), blob, canvas.toDataURL());
      });
    }
    function fromImage(image) {
      return $_bllwpldqjk26xjgd.imageToBlob(image).then(function (blob) {
        return fromBlob(blob);
      });
    }
    var fromBlobAndUrlSync = function fromBlobAndUrlSync(blob, url) {
      return create$1($_bllwpldqjk26xjgd.blobToCanvas(blob), blob, url);
    };
    var $_2bjwrwe5jk26xjht = {
      fromBlob: fromBlob,
      fromCanvas: fromCanvas,
      fromImage: fromImage,
      fromBlobAndUrlSync: fromBlobAndUrlSync
    };

    function clamp(value, min, max) {
      value = parseFloat(value);
      if (value > max) {
        value = max;
      } else if (value < min) {
        value = min;
      }
      return value;
    }
    function identity$1() {
      return [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
    }
    var DELTA_INDEX = [0, 0.01, 0.02, 0.04, 0.05, 0.06, 0.07, 0.08, 0.1, 0.11, 0.12, 0.14, 0.15, 0.16, 0.17, 0.18, 0.2, 0.21, 0.22, 0.24, 0.25, 0.27, 0.28, 0.3, 0.32, 0.34, 0.36, 0.38, 0.4, 0.42, 0.44, 0.46, 0.48, 0.5, 0.53, 0.56, 0.59, 0.62, 0.65, 0.68, 0.71, 0.74, 0.77, 0.8, 0.83, 0.86, 0.89, 0.92, 0.95, 0.98, 1, 1.06, 1.12, 1.18, 1.24, 1.3, 1.36, 1.42, 1.48, 1.54, 1.6, 1.66, 1.72, 1.78, 1.84, 1.9, 1.96, 2, 2.12, 2.25, 2.37, 2.5, 2.62, 2.75, 2.87, 3, 3.2, 3.4, 3.6, 3.8, 4, 4.3, 4.7, 4.9, 5, 5.5, 6, 6.5, 6.8, 7, 7.3, 7.5, 7.8, 8, 8.4, 8.7, 9, 9.4, 9.6, 9.8, 10];
    function multiply(matrix1, matrix2) {
      var i,
          j,
          k,
          val,
          col = [],
          out = new Array(10);
      for (i = 0; i < 5; i++) {
        for (j = 0; j < 5; j++) {
          col[j] = matrix2[j + i * 5];
        }
        for (j = 0; j < 5; j++) {
          val = 0;
          for (k = 0; k < 5; k++) {
            val += matrix1[j + k * 5] * col[k];
          }
          out[j + i * 5] = val;
        }
      }
      return out;
    }
    function adjust(matrix, adjustValue) {
      adjustValue = clamp(adjustValue, 0, 1);
      return matrix.map(function (value, index) {
        if (index % 6 === 0) {
          value = 1 - (1 - value) * adjustValue;
        } else {
          value *= adjustValue;
        }
        return clamp(value, 0, 1);
      });
    }
    function adjustContrast(matrix, value) {
      var x;
      value = clamp(value, -1, 1);
      value *= 100;
      if (value < 0) {
        x = 127 + value / 100 * 127;
      } else {
        x = value % 1;
        if (x === 0) {
          x = DELTA_INDEX[value];
        } else {
          x = DELTA_INDEX[Math.floor(value)] * (1 - x) + DELTA_INDEX[Math.floor(value) + 1] * x;
        }
        x = x * 127 + 127;
      }
      return multiply(matrix, [x / 127, 0, 0, 0, 0.5 * (127 - x), 0, x / 127, 0, 0, 0.5 * (127 - x), 0, 0, x / 127, 0, 0.5 * (127 - x), 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function adjustSaturation(matrix, value) {
      var x, lumR, lumG, lumB;
      value = clamp(value, -1, 1);
      x = 1 + (value > 0 ? 3 * value : value);
      lumR = 0.3086;
      lumG = 0.6094;
      lumB = 0.082;
      return multiply(matrix, [lumR * (1 - x) + x, lumG * (1 - x), lumB * (1 - x), 0, 0, lumR * (1 - x), lumG * (1 - x) + x, lumB * (1 - x), 0, 0, lumR * (1 - x), lumG * (1 - x), lumB * (1 - x) + x, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function adjustHue(matrix, angle) {
      var cosVal, sinVal, lumR, lumG, lumB;
      angle = clamp(angle, -180, 180) / 180 * Math.PI;
      cosVal = Math.cos(angle);
      sinVal = Math.sin(angle);
      lumR = 0.213;
      lumG = 0.715;
      lumB = 0.072;
      return multiply(matrix, [lumR + cosVal * (1 - lumR) + sinVal * -lumR, lumG + cosVal * -lumG + sinVal * -lumG, lumB + cosVal * -lumB + sinVal * (1 - lumB), 0, 0, lumR + cosVal * -lumR + sinVal * 0.143, lumG + cosVal * (1 - lumG) + sinVal * 0.14, lumB + cosVal * -lumB + sinVal * -0.283, 0, 0, lumR + cosVal * -lumR + sinVal * -(1 - lumR), lumG + cosVal * -lumG + sinVal * lumG, lumB + cosVal * (1 - lumB) + sinVal * lumB, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function adjustBrightness(matrix, value) {
      value = clamp(255 * value, -255, 255);
      return multiply(matrix, [1, 0, 0, 0, value, 0, 1, 0, 0, value, 0, 0, 1, 0, value, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function adjustColors(matrix, adjustR, adjustG, adjustB) {
      adjustR = clamp(adjustR, 0, 2);
      adjustG = clamp(adjustG, 0, 2);
      adjustB = clamp(adjustB, 0, 2);
      return multiply(matrix, [adjustR, 0, 0, 0, 0, 0, adjustG, 0, 0, 0, 0, 0, adjustB, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
    }
    function adjustSepia(matrix, value) {
      value = clamp(value, 0, 1);
      return multiply(matrix, adjust([0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], value));
    }
    function adjustGrayscale(matrix, value) {
      value = clamp(value, 0, 1);
      return multiply(matrix, adjust([0.33, 0.34, 0.33, 0, 0, 0.33, 0.34, 0.33, 0, 0, 0.33, 0.34, 0.33, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1], value));
    }
    var $_2k63gbe6jk26xjhy = {
      identity: identity$1,
      adjust: adjust,
      multiply: multiply,
      adjustContrast: adjustContrast,
      adjustBrightness: adjustBrightness,
      adjustSaturation: adjustSaturation,
      adjustHue: adjustHue,
      adjustColors: adjustColors,
      adjustSepia: adjustSepia,
      adjustGrayscale: adjustGrayscale
    };

    function colorFilter(ir, matrix) {
      return ir.toCanvas().then(function (canvas) {
        return applyColorFilter(canvas, ir.getType(), matrix);
      });
    }
    function applyColorFilter(canvas, type, matrix) {
      var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
      var pixels;
      function applyMatrix(pixels, m) {
        var d = pixels.data,
            r,
            g,
            b,
            a,
            i,
            m0 = m[0],
            m1 = m[1],
            m2 = m[2],
            m3 = m[3],
            m4 = m[4],
            m5 = m[5],
            m6 = m[6],
            m7 = m[7],
            m8 = m[8],
            m9 = m[9],
            m10 = m[10],
            m11 = m[11],
            m12 = m[12],
            m13 = m[13],
            m14 = m[14],
            m15 = m[15],
            m16 = m[16],
            m17 = m[17],
            m18 = m[18],
            m19 = m[19];
        for (i = 0; i < d.length; i += 4) {
          r = d[i];
          g = d[i + 1];
          b = d[i + 2];
          a = d[i + 3];
          d[i] = r * m0 + g * m1 + b * m2 + a * m3 + m4;
          d[i + 1] = r * m5 + g * m6 + b * m7 + a * m8 + m9;
          d[i + 2] = r * m10 + g * m11 + b * m12 + a * m13 + m14;
          d[i + 3] = r * m15 + g * m16 + b * m17 + a * m18 + m19;
        }
        return pixels;
      }
      pixels = applyMatrix(context.getImageData(0, 0, canvas.width, canvas.height), matrix);
      context.putImageData(pixels, 0, 0);
      return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
    }
    function convoluteFilter(ir, matrix) {
      return ir.toCanvas().then(function (canvas) {
        return applyConvoluteFilter(canvas, ir.getType(), matrix);
      });
    }
    function applyConvoluteFilter(canvas, type, matrix) {
      var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
      var pixelsIn, pixelsOut;
      function applyMatrix(pixelsIn, pixelsOut, matrix) {
        var rgba, drgba, side, halfSide, x, y, r, g, b, cx, cy, scx, scy, offset, wt, w, h;
        function clamp(value, min, max) {
          if (value > max) {
            value = max;
          } else if (value < min) {
            value = min;
          }
          return value;
        }
        side = Math.round(Math.sqrt(matrix.length));
        halfSide = Math.floor(side / 2);
        rgba = pixelsIn.data;
        drgba = pixelsOut.data;
        w = pixelsIn.width;
        h = pixelsIn.height;
        for (y = 0; y < h; y++) {
          for (x = 0; x < w; x++) {
            r = g = b = 0;
            for (cy = 0; cy < side; cy++) {
              for (cx = 0; cx < side; cx++) {
                scx = clamp(x + cx - halfSide, 0, w - 1);
                scy = clamp(y + cy - halfSide, 0, h - 1);
                offset = (scy * w + scx) * 4;
                wt = matrix[cy * side + cx];
                r += rgba[offset] * wt;
                g += rgba[offset + 1] * wt;
                b += rgba[offset + 2] * wt;
              }
            }
            offset = (y * w + x) * 4;
            drgba[offset] = clamp(r, 0, 255);
            drgba[offset + 1] = clamp(g, 0, 255);
            drgba[offset + 2] = clamp(b, 0, 255);
          }
        }
        return pixelsOut;
      }
      pixelsIn = context.getImageData(0, 0, canvas.width, canvas.height);
      pixelsOut = context.getImageData(0, 0, canvas.width, canvas.height);
      pixelsOut = applyMatrix(pixelsIn, pixelsOut, matrix);
      context.putImageData(pixelsOut, 0, 0);
      return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
    }
    function functionColorFilter(colorFn) {
      var filterImpl = function filterImpl(canvas, type, value) {
        var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
        var pixels,
            i,
            lookup = new Array(256);
        function applyLookup(pixels, lookup) {
          var d = pixels.data,
              i;
          for (i = 0; i < d.length; i += 4) {
            d[i] = lookup[d[i]];
            d[i + 1] = lookup[d[i + 1]];
            d[i + 2] = lookup[d[i + 2]];
          }
          return pixels;
        }
        for (i = 0; i < lookup.length; i++) {
          lookup[i] = colorFn(i, value);
        }
        pixels = applyLookup(context.getImageData(0, 0, canvas.width, canvas.height), lookup);
        context.putImageData(pixels, 0, 0);
        return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
      };
      return function (ir, value) {
        return ir.toCanvas().then(function (canvas) {
          return filterImpl(canvas, ir.getType(), value);
        });
      };
    }
    function complexAdjustableColorFilter(matrixAdjustFn) {
      return function (ir, adjust) {
        return colorFilter(ir, matrixAdjustFn($_2k63gbe6jk26xjhy.identity(), adjust));
      };
    }
    function basicColorFilter(matrix) {
      return function (ir) {
        return colorFilter(ir, matrix);
      };
    }
    function basicConvolutionFilter(kernel) {
      return function (ir) {
        return convoluteFilter(ir, kernel);
      };
    }
    var $_fqhs8re4jk26xjhn = {
      invert: basicColorFilter([-1, 0, 0, 0, 255, 0, -1, 0, 0, 255, 0, 0, -1, 0, 255, 0, 0, 0, 1, 0]),
      brightness: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustBrightness),
      hue: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustHue),
      saturate: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustSaturation),
      contrast: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustContrast),
      grayscale: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustGrayscale),
      sepia: complexAdjustableColorFilter($_2k63gbe6jk26xjhy.adjustSepia),
      colorize: function colorize(ir, adjustR, adjustG, adjustB) {
        return colorFilter(ir, $_2k63gbe6jk26xjhy.adjustColors($_2k63gbe6jk26xjhy.identity(), adjustR, adjustG, adjustB));
      },
      sharpen: basicConvolutionFilter([0, -1, 0, -1, 5, -1, 0, -1, 0]),
      emboss: basicConvolutionFilter([-2, -1, 0, -1, 1, 1, 0, 1, 2]),
      gamma: functionColorFilter(function (color, value) {
        return Math.pow(color / 255, 1 - value) * 255;
      }),
      exposure: functionColorFilter(function (color, value) {
        return 255 * (1 - Math.exp(-(color / 255) * value));
      }),
      colorFilter: colorFilter,
      convoluteFilter: convoluteFilter
    };

    function scale(image, dW, dH) {
      var sW = $_73mnywdsjk26xjgu.getWidth(image);
      var sH = $_73mnywdsjk26xjgu.getHeight(image);
      var wRatio = dW / sW;
      var hRatio = dH / sH;
      var scaleCapped = false;
      if (wRatio < 0.5 || wRatio > 2) {
        wRatio = wRatio < 0.5 ? 0.5 : 2;
        scaleCapped = true;
      }
      if (hRatio < 0.5 || hRatio > 2) {
        hRatio = hRatio < 0.5 ? 0.5 : 2;
        scaleCapped = true;
      }
      var scaled = _scale(image, wRatio, hRatio);
      return !scaleCapped ? scaled : scaled.then(function (tCanvas) {
        return scale(tCanvas, dW, dH);
      });
    }
    function _scale(image, wRatio, hRatio) {
      return new Promise(function (resolve) {
        var sW = $_73mnywdsjk26xjgu.getWidth(image);
        var sH = $_73mnywdsjk26xjgu.getHeight(image);
        var dW = Math.floor(sW * wRatio);
        var dH = Math.floor(sH * hRatio);
        var canvas = $_dnf8gydrjk26xjgs.create(dW, dH);
        var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
        context.drawImage(image, 0, 0, sW, sH, 0, 0, dW, dH);
        resolve(canvas);
      });
    }
    var $_b8c7ofe8jk26xji7 = { scale: scale };

    function rotate(ir, angle) {
      return ir.toCanvas().then(function (canvas) {
        return applyRotate(canvas, ir.getType(), angle);
      });
    }
    function applyRotate(image, type, angle) {
      var canvas = $_dnf8gydrjk26xjgs.create(image.width, image.height);
      var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
      var translateX = 0,
          translateY = 0;
      angle = angle < 0 ? 360 + angle : angle;
      if (angle == 90 || angle == 270) {
        $_dnf8gydrjk26xjgs.resize(canvas, canvas.height, canvas.width);
      }
      if (angle == 90 || angle == 180) {
        translateX = canvas.width;
      }
      if (angle == 270 || angle == 180) {
        translateY = canvas.height;
      }
      context.translate(translateX, translateY);
      context.rotate(angle * Math.PI / 180);
      context.drawImage(image, 0, 0);
      return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
    }
    function flip(ir, axis) {
      return ir.toCanvas().then(function (canvas) {
        return applyFlip(canvas, ir.getType(), axis);
      });
    }
    function applyFlip(image, type, axis) {
      var canvas = $_dnf8gydrjk26xjgs.create(image.width, image.height);
      var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
      if (axis == 'v') {
        context.scale(1, -1);
        context.drawImage(image, 0, -canvas.height);
      } else {
        context.scale(-1, 1);
        context.drawImage(image, -canvas.width, 0);
      }
      return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
    }
    function crop(ir, x, y, w, h) {
      return ir.toCanvas().then(function (canvas) {
        return applyCrop(canvas, ir.getType(), x, y, w, h);
      });
    }
    function applyCrop(image, type, x, y, w, h) {
      var canvas = $_dnf8gydrjk26xjgs.create(w, h);
      var context = $_dnf8gydrjk26xjgs.get2dContext(canvas);
      context.drawImage(image, -x, -y);
      return $_2bjwrwe5jk26xjht.fromCanvas(canvas, type);
    }
    function resize$1(ir, w, h) {
      return ir.toCanvas().then(function (canvas) {
        return $_b8c7ofe8jk26xji7.scale(canvas, w, h).then(function (newCanvas) {
          return $_2bjwrwe5jk26xjht.fromCanvas(newCanvas, ir.getType());
        });
      });
    }
    var $_2nyv9oe7jk26xji4 = {
      rotate: rotate,
      flip: flip,
      crop: crop,
      resize: resize$1
    };

    var BinaryReader = function () {
      function BinaryReader(ar) {
        this.littleEndian = false;
        this._dv = new DataView(ar);
      }
      BinaryReader.prototype.readByteAt = function (idx) {
        return this._dv.getUint8(idx);
      };
      BinaryReader.prototype.read = function (idx, size) {
        if (idx + size > this.length()) {
          return null;
        }
        var mv = this.littleEndian ? 0 : -8 * (size - 1);
        for (var i = 0, sum = 0; i < size; i++) {
          sum |= this.readByteAt(idx + i) << Math.abs(mv + i * 8);
        }
        return sum;
      };
      BinaryReader.prototype.BYTE = function (idx) {
        return this.read(idx, 1);
      };
      BinaryReader.prototype.SHORT = function (idx) {
        return this.read(idx, 2);
      };
      BinaryReader.prototype.LONG = function (idx) {
        return this.read(idx, 4);
      };
      BinaryReader.prototype.SLONG = function (idx) {
        var num = this.read(idx, 4);
        return num > 2147483647 ? num - 4294967296 : num;
      };
      BinaryReader.prototype.CHAR = function (idx) {
        return String.fromCharCode(this.read(idx, 1));
      };
      BinaryReader.prototype.STRING = function (idx, count) {
        return this.asArray('CHAR', idx, count).join('');
      };
      BinaryReader.prototype.SEGMENT = function (idx, size) {
        var ar = this._dv.buffer;
        switch (arguments.length) {
          case 2:
            return ar.slice(idx, idx + size);
          case 1:
            return ar.slice(idx);
          default:
            return ar;
        }
      };
      BinaryReader.prototype.asArray = function (type, idx, count) {
        var values = [];
        for (var i = 0; i < count; i++) {
          values[i] = this[type](idx + i);
        }
        return values;
      };
      BinaryReader.prototype.length = function () {
        return this._dv ? this._dv.byteLength : 0;
      };
      return BinaryReader;
    }();

    var tags = {
      tiff: {
        274: 'Orientation',
        270: 'ImageDescription',
        271: 'Make',
        272: 'Model',
        305: 'Software',
        34665: 'ExifIFDPointer',
        34853: 'GPSInfoIFDPointer'
      },
      exif: {
        36864: 'ExifVersion',
        40961: 'ColorSpace',
        40962: 'PixelXDimension',
        40963: 'PixelYDimension',
        36867: 'DateTimeOriginal',
        33434: 'ExposureTime',
        33437: 'FNumber',
        34855: 'ISOSpeedRatings',
        37377: 'ShutterSpeedValue',
        37378: 'ApertureValue',
        37383: 'MeteringMode',
        37384: 'LightSource',
        37385: 'Flash',
        37386: 'FocalLength',
        41986: 'ExposureMode',
        41987: 'WhiteBalance',
        41990: 'SceneCaptureType',
        41988: 'DigitalZoomRatio',
        41992: 'Contrast',
        41993: 'Saturation',
        41994: 'Sharpness'
      },
      gps: {
        0: 'GPSVersionID',
        1: 'GPSLatitudeRef',
        2: 'GPSLatitude',
        3: 'GPSLongitudeRef',
        4: 'GPSLongitude'
      },
      thumb: {
        513: 'JPEGInterchangeFormat',
        514: 'JPEGInterchangeFormatLength'
      }
    };
    var tagDescs = {
      'ColorSpace': {
        1: 'sRGB',
        0: 'Uncalibrated'
      },
      'MeteringMode': {
        0: 'Unknown',
        1: 'Average',
        2: 'CenterWeightedAverage',
        3: 'Spot',
        4: 'MultiSpot',
        5: 'Pattern',
        6: 'Partial',
        255: 'Other'
      },
      'LightSource': {
        1: 'Daylight',
        2: 'Fliorescent',
        3: 'Tungsten',
        4: 'Flash',
        9: 'Fine weather',
        10: 'Cloudy weather',
        11: 'Shade',
        12: 'Daylight fluorescent (D 5700 - 7100K)',
        13: 'Day white fluorescent (N 4600 -5400K)',
        14: 'Cool white fluorescent (W 3900 - 4500K)',
        15: 'White fluorescent (WW 3200 - 3700K)',
        17: 'Standard light A',
        18: 'Standard light B',
        19: 'Standard light C',
        20: 'D55',
        21: 'D65',
        22: 'D75',
        23: 'D50',
        24: 'ISO studio tungsten',
        255: 'Other'
      },
      'Flash': {
        0: 'Flash did not fire',
        1: 'Flash fired',
        5: 'Strobe return light not detected',
        7: 'Strobe return light detected',
        9: 'Flash fired, compulsory flash mode',
        13: 'Flash fired, compulsory flash mode, return light not detected',
        15: 'Flash fired, compulsory flash mode, return light detected',
        16: 'Flash did not fire, compulsory flash mode',
        24: 'Flash did not fire, auto mode',
        25: 'Flash fired, auto mode',
        29: 'Flash fired, auto mode, return light not detected',
        31: 'Flash fired, auto mode, return light detected',
        32: 'No flash function',
        65: 'Flash fired, red-eye reduction mode',
        69: 'Flash fired, red-eye reduction mode, return light not detected',
        71: 'Flash fired, red-eye reduction mode, return light detected',
        73: 'Flash fired, compulsory flash mode, red-eye reduction mode',
        77: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
        79: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
        89: 'Flash fired, auto mode, red-eye reduction mode',
        93: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
        95: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
      },
      'ExposureMode': {
        0: 'Auto exposure',
        1: 'Manual exposure',
        2: 'Auto bracket'
      },
      'WhiteBalance': {
        0: 'Auto white balance',
        1: 'Manual white balance'
      },
      'SceneCaptureType': {
        0: 'Standard',
        1: 'Landscape',
        2: 'Portrait',
        3: 'Night scene'
      },
      'Contrast': {
        0: 'Normal',
        1: 'Soft',
        2: 'Hard'
      },
      'Saturation': {
        0: 'Normal',
        1: 'Low saturation',
        2: 'High saturation'
      },
      'Sharpness': {
        0: 'Normal',
        1: 'Soft',
        2: 'Hard'
      },
      'GPSLatitudeRef': {
        N: 'North latitude',
        S: 'South latitude'
      },
      'GPSLongitudeRef': {
        E: 'East longitude',
        W: 'West longitude'
      }
    };
    var ExifReader = function () {
      function ExifReader(ar) {
        this._offsets = {
          tiffHeader: 10,
          IFD0: null,
          IFD1: null,
          exifIFD: null,
          gpsIFD: null
        };
        this._tiffTags = {};
        var self = this;
        self._reader = new BinaryReader(ar);
        self._idx = self._offsets.tiffHeader;
        if (self.SHORT(0) !== 65505 || self.STRING(4, 5).toUpperCase() !== 'EXIF\0') {
          throw new Error('Exif data cannot be read or not available.');
        }
        self._reader.littleEndian = self.SHORT(self._idx) == 18761;
        if (self.SHORT(self._idx += 2) !== 42) {
          throw new Error('Invalid Exif data.');
        }
        self._offsets.IFD0 = self._offsets.tiffHeader + self.LONG(self._idx += 2);
        self._tiffTags = self.extractTags(self._offsets.IFD0, tags.tiff);
        if ('ExifIFDPointer' in self._tiffTags) {
          self._offsets.exifIFD = self._offsets.tiffHeader + self._tiffTags.ExifIFDPointer;
          delete self._tiffTags.ExifIFDPointer;
        }
        if ('GPSInfoIFDPointer' in self._tiffTags) {
          self._offsets.gpsIFD = self._offsets.tiffHeader + self._tiffTags.GPSInfoIFDPointer;
          delete self._tiffTags.GPSInfoIFDPointer;
        }
        var IFD1Offset = self.LONG(self._offsets.IFD0 + self.SHORT(self._offsets.IFD0) * 12 + 2);
        if (IFD1Offset) {
          self._offsets.IFD1 = self._offsets.tiffHeader + IFD1Offset;
        }
      }
      ExifReader.prototype.BYTE = function (idx) {
        return this._reader.BYTE(idx);
      };
      ExifReader.prototype.SHORT = function (idx) {
        return this._reader.SHORT(idx);
      };
      ExifReader.prototype.LONG = function (idx) {
        return this._reader.LONG(idx);
      };
      ExifReader.prototype.SLONG = function (idx) {
        return this._reader.SLONG(idx);
      };
      ExifReader.prototype.CHAR = function (idx) {
        return this._reader.CHAR(idx);
      };
      ExifReader.prototype.STRING = function (idx, count) {
        return this._reader.STRING(idx, count);
      };
      ExifReader.prototype.SEGMENT = function (idx, size) {
        return this._reader.SEGMENT(idx, size);
      };
      ExifReader.prototype.asArray = function (type, idx, count) {
        var values = [];
        for (var i = 0; i < count; i++) {
          values[i] = this[type](idx + i);
        }
        return values;
      };
      ExifReader.prototype.length = function () {
        return this._reader.length();
      };
      ExifReader.prototype.UNDEFINED = function () {
        return this.BYTE.apply(this, arguments);
      };
      ExifReader.prototype.RATIONAL = function (idx) {
        return this.LONG(idx) / this.LONG(idx + 4);
      };
      ExifReader.prototype.SRATIONAL = function (idx) {
        return this.SLONG(idx) / this.SLONG(idx + 4);
      };
      ExifReader.prototype.ASCII = function (idx) {
        return this.CHAR(idx);
      };
      ExifReader.prototype.TIFF = function () {
        return this._tiffTags;
      };
      ExifReader.prototype.EXIF = function () {
        var self = this;
        var Exif = null;
        if (self._offsets.exifIFD) {
          try {
            Exif = self.extractTags(self._offsets.exifIFD, tags.exif);
          } catch (ex) {
            return null;
          }
          if (Exif.ExifVersion && Array.isArray(Exif.ExifVersion)) {
            for (var i = 0, exifVersion = ''; i < Exif.ExifVersion.length; i++) {
              exifVersion += String.fromCharCode(Exif.ExifVersion[i]);
            }
            Exif.ExifVersion = exifVersion;
          }
        }
        return Exif;
      };
      ExifReader.prototype.GPS = function () {
        var self = this;
        var GPS = null;
        if (self._offsets.gpsIFD) {
          try {
            GPS = self.extractTags(self._offsets.gpsIFD, tags.gps);
          } catch (ex) {
            return null;
          }
          if (GPS.GPSVersionID && Array.isArray(GPS.GPSVersionID)) {
            GPS.GPSVersionID = GPS.GPSVersionID.join('.');
          }
        }
        return GPS;
      };
      ExifReader.prototype.thumb = function () {
        var self = this;
        if (self._offsets.IFD1) {
          try {
            var IFD1Tags = self.extractTags(self._offsets.IFD1, tags.thumb);
            if ('JPEGInterchangeFormat' in IFD1Tags) {
              return self.SEGMENT(self._offsets.tiffHeader + IFD1Tags.JPEGInterchangeFormat, IFD1Tags.JPEGInterchangeFormatLength);
            }
          } catch (ex) {}
        }
        return null;
      };
      ExifReader.prototype.extractTags = function (IFD_offset, tags2extract) {
        var self = this;
        var length,
            i,
            tag,
            type,
            count,
            size,
            offset,
            value,
            values = [],
            hash = {};
        var types = {
          1: 'BYTE',
          7: 'UNDEFINED',
          2: 'ASCII',
          3: 'SHORT',
          4: 'LONG',
          5: 'RATIONAL',
          9: 'SLONG',
          10: 'SRATIONAL'
        };
        var sizes = {
          'BYTE': 1,
          'UNDEFINED': 1,
          'ASCII': 1,
          'SHORT': 2,
          'LONG': 4,
          'RATIONAL': 8,
          'SLONG': 4,
          'SRATIONAL': 8
        };
        length = self.SHORT(IFD_offset);
        for (i = 0; i < length; i++) {
          values = [];
          offset = IFD_offset + 2 + i * 12;
          tag = tags2extract[self.SHORT(offset)];
          if (tag === undefined) {
            continue;
          }
          type = types[self.SHORT(offset += 2)];
          count = self.LONG(offset += 2);
          size = sizes[type];
          if (!size) {
            throw new Error('Invalid Exif data.');
          }
          offset += 4;
          if (size * count > 4) {
            offset = self.LONG(offset) + self._offsets.tiffHeader;
          }
          if (offset + size * count >= self.length()) {
            throw new Error('Invalid Exif data.');
          }
          if (type === 'ASCII') {
            hash[tag] = self.STRING(offset, count).replace(/\0$/, '').trim();
            continue;
          } else {
            values = self.asArray(type, offset, count);
            value = count == 1 ? values[0] : values;
            if (tagDescs.hasOwnProperty(tag) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) != 'object') {
              hash[tag] = tagDescs[tag][value];
            } else {
              hash[tag] = value;
            }
          }
        }
        return hash;
      };
      return ExifReader;
    }();

    var extractFrom = function extractFrom(blob) {
      return $_bllwpldqjk26xjgd.blobToArrayBuffer(blob).then(function (ar) {
        try {
          var br = new BinaryReader(ar);
          if (br.SHORT(0) === 65496) {
            var headers = extractHeaders(br);
            var app1 = headers.filter(function (header) {
              return header.name === 'APP1';
            });
            var meta = {};
            if (app1.length) {
              var exifReader = new ExifReader(app1[0].segment);
              meta = {
                tiff: exifReader.TIFF(),
                exif: exifReader.EXIF(),
                gps: exifReader.GPS(),
                thumb: exifReader.thumb()
              };
            } else {
              return Promise.reject('Headers did not include required information');
            }
            meta.rawHeaders = headers;
            return meta;
          }
          return Promise.reject('Image was not a jpeg');
        } catch (ex) {
          return Promise.reject('Unsupported format or not an image: ' + blob.type + ' (Exception: ' + ex.message + ')');
        }
      });
    };
    var extractHeaders = function extractHeaders(br) {
      var headers = [],
          idx,
          marker,
          length = 0;
      idx = 2;
      while (idx <= br.length()) {
        marker = br.SHORT(idx);
        if (marker >= 65488 && marker <= 65495) {
          idx += 2;
          continue;
        }
        if (marker === 65498 || marker === 65497) {
          break;
        }
        length = br.SHORT(idx + 2) + 2;
        if (marker >= 65505 && marker <= 65519) {
          headers.push({
            hex: marker,
            name: 'APP' + (marker & 15),
            start: idx,
            length: length,
            segment: br.SEGMENT(idx, length)
          });
        }
        idx += length;
      }
      return headers;
    };
    var $_4f46cce9jk26xji9 = { extractFrom: extractFrom };

    var invert = function invert(ir) {
      return $_fqhs8re4jk26xjhn.invert(ir);
    };
    var sharpen = function sharpen(ir) {
      return $_fqhs8re4jk26xjhn.sharpen(ir);
    };
    var emboss = function emboss(ir) {
      return $_fqhs8re4jk26xjhn.emboss(ir);
    };
    var gamma = function gamma(ir, value) {
      return $_fqhs8re4jk26xjhn.gamma(ir, value);
    };
    var exposure = function exposure(ir, value) {
      return $_fqhs8re4jk26xjhn.exposure(ir, value);
    };
    var colorize = function colorize(ir, adjustR, adjustG, adjustB) {
      return $_fqhs8re4jk26xjhn.colorize(ir, adjustR, adjustG, adjustB);
    };
    var brightness = function brightness(ir, adjust) {
      return $_fqhs8re4jk26xjhn.brightness(ir, adjust);
    };
    var hue = function hue(ir, adjust) {
      return $_fqhs8re4jk26xjhn.hue(ir, adjust);
    };
    var saturate = function saturate(ir, adjust) {
      return $_fqhs8re4jk26xjhn.saturate(ir, adjust);
    };
    var contrast = function contrast(ir, adjust) {
      return $_fqhs8re4jk26xjhn.contrast(ir, adjust);
    };
    var grayscale = function grayscale(ir, adjust) {
      return $_fqhs8re4jk26xjhn.grayscale(ir, adjust);
    };
    var sepia = function sepia(ir, adjust) {
      return $_fqhs8re4jk26xjhn.sepia(ir, adjust);
    };
    var flip$1 = function flip$1(ir, axis) {
      return $_2nyv9oe7jk26xji4.flip(ir, axis);
    };
    var crop$1 = function crop$1(ir, x, y, w, h) {
      return $_2nyv9oe7jk26xji4.crop(ir, x, y, w, h);
    };
    var resize$2 = function resize$2(ir, w, h) {
      return $_2nyv9oe7jk26xji4.resize(ir, w, h);
    };
    var rotate$1 = function rotate$1(ir, angle) {
      return $_2nyv9oe7jk26xji4.rotate(ir, angle);
    };
    var exifRotate = function exifRotate(ir) {
      var ROTATE_90 = 6;
      var ROTATE_180 = 3;
      var ROTATE_270 = 8;
      var checkRotation = function checkRotation(data) {
        var orientation = data.tiff.Orientation;
        switch (orientation) {
          case ROTATE_90:
            return rotate$1(ir, 90);
          case ROTATE_180:
            return rotate$1(ir, 180);
          case ROTATE_270:
            return rotate$1(ir, 270);
          default:
            return ir;
        }
      };
      var notJpeg = function notJpeg() {
        return ir;
      };
      return ir.toBlob().then($_4f46cce9jk26xji9.extractFrom).then(checkRotation, notJpeg);
    };
    var $_cfu01e3jk26xjhj = {
      invert: invert,
      sharpen: sharpen,
      emboss: emboss,
      brightness: brightness,
      hue: hue,
      saturate: saturate,
      contrast: contrast,
      grayscale: grayscale,
      sepia: sepia,
      colorize: colorize,
      gamma: gamma,
      exposure: exposure,
      flip: flip$1,
      crop: crop$1,
      resize: resize$2,
      rotate: rotate$1,
      exifRotate: exifRotate
    };

    var blobToImageResult = function blobToImageResult(blob) {
      return $_2bjwrwe5jk26xjht.fromBlob(blob);
    };
    var fromBlobAndUrlSync$1 = function fromBlobAndUrlSync$1(blob, uri) {
      return $_2bjwrwe5jk26xjht.fromBlobAndUrlSync(blob, uri);
    };
    var imageToImageResult = function imageToImageResult(image) {
      return $_2bjwrwe5jk26xjht.fromImage(image);
    };
    var imageResultToBlob = function imageResultToBlob(ir, type, quality) {
      if (type === undefined && quality === undefined) {
        return imageResultToOriginalBlob(ir);
      } else {
        return ir.toAdjustedBlob(type, quality);
      }
    };
    var imageResultToOriginalBlob = function imageResultToOriginalBlob(ir) {
      return ir.toBlob();
    };
    var imageResultToDataURL = function imageResultToDataURL(ir) {
      return ir.toDataURL();
    };
    var $_cvbd8gecjk26xjiu = {
      blobToImageResult: blobToImageResult,
      fromBlobAndUrlSync: fromBlobAndUrlSync$1,
      imageToImageResult: imageToImageResult,
      imageResultToBlob: imageResultToBlob,
      imageResultToOriginalBlob: imageResultToOriginalBlob,
      imageResultToDataURL: imageResultToDataURL
    };

    var url = function url() {
      return $_chncyqdxjk26xjha.getOrDie('URL');
    };
    var createObjectURL = function createObjectURL(blob) {
      return url().createObjectURL(blob);
    };
    var revokeObjectURL = function revokeObjectURL(u) {
      url().revokeObjectURL(u);
    };
    var $_1huwkedjk26xjiw = {
      createObjectURL: createObjectURL,
      revokeObjectURL: revokeObjectURL
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.URI');

    var getToolbarItems = function getToolbarItems(editor) {
      return editor.getParam('imagetools_toolbar', 'rotateleft rotateright | flipv fliph | crop editimage imageoptions');
    };
    var getProxyUrl = function getProxyUrl(editor) {
      return editor.getParam('imagetools_proxy');
    };
    var getCorsHosts = function getCorsHosts(editor) {
      return editor.getParam('imagetools_cors_hosts', [], 'string[]');
    };
    var getCredentialsHosts = function getCredentialsHosts(editor) {
      return editor.getParam('imagetools_credentials_hosts', [], 'string[]');
    };
    var getApiKey = function getApiKey(editor) {
      return editor.getParam('api_key', editor.getParam('imagetools_api_key', '', 'string'), 'string');
    };
    var getUploadTimeout = function getUploadTimeout(editor) {
      return editor.getParam('images_upload_timeout', 30000, 'number');
    };
    var shouldReuseFilename = function shouldReuseFilename(editor) {
      return editor.getParam('images_reuse_filename', false, 'boolean');
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$6 = tinymce.util.Tools.resolve('tinymce.ui.Factory');

    function UndoStack() {
      var data = [];
      var index = -1;
      function add(state) {
        var removed;
        removed = data.splice(++index);
        data.push(state);
        return {
          state: state,
          removed: removed
        };
      }
      function undo() {
        if (canUndo()) {
          return data[--index];
        }
      }
      function redo() {
        if (canRedo()) {
          return data[++index];
        }
      }
      function canUndo() {
        return index > 0;
      }
      function canRedo() {
        return index !== -1 && index < data.length - 1;
      }
      return {
        data: data,
        add: add,
        undo: undo,
        redo: redo,
        canUndo: canUndo,
        canRedo: canRedo
      };
    }

    var global$7 = tinymce.util.Tools.resolve('tinymce.geom.Rect');

    var loadImage$1 = function loadImage$1(image) {
      return new global$3(function (resolve) {
        var loaded = function loaded() {
          image.removeEventListener('load', loaded);
          resolve(image);
        };
        if (image.complete) {
          resolve(image);
        } else {
          image.addEventListener('load', loaded);
        }
      });
    };
    var $_cijn2deojk26xjju = { loadImage: loadImage$1 };

    var global$8 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');

    var global$9 = tinymce.util.Tools.resolve('tinymce.util.Observable');

    var global$10 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var count = 0;
    function CropRect(currentRect, viewPortRect, clampRect, containerElm, action) {
      var instance;
      var handles;
      var dragHelpers;
      var blockers;
      var prefix = 'mce-';
      var id = prefix + 'crid-' + count++;
      handles = [{
        name: 'move',
        xMul: 0,
        yMul: 0,
        deltaX: 1,
        deltaY: 1,
        deltaW: 0,
        deltaH: 0,
        label: 'Crop Mask'
      }, {
        name: 'nw',
        xMul: 0,
        yMul: 0,
        deltaX: 1,
        deltaY: 1,
        deltaW: -1,
        deltaH: -1,
        label: 'Top Left Crop Handle'
      }, {
        name: 'ne',
        xMul: 1,
        yMul: 0,
        deltaX: 0,
        deltaY: 1,
        deltaW: 1,
        deltaH: -1,
        label: 'Top Right Crop Handle'
      }, {
        name: 'sw',
        xMul: 0,
        yMul: 1,
        deltaX: 1,
        deltaY: 0,
        deltaW: -1,
        deltaH: 1,
        label: 'Bottom Left Crop Handle'
      }, {
        name: 'se',
        xMul: 1,
        yMul: 1,
        deltaX: 0,
        deltaY: 0,
        deltaW: 1,
        deltaH: 1,
        label: 'Bottom Right Crop Handle'
      }];
      blockers = ['top', 'right', 'bottom', 'left'];
      function getAbsoluteRect(outerRect, relativeRect) {
        return {
          x: relativeRect.x + outerRect.x,
          y: relativeRect.y + outerRect.y,
          w: relativeRect.w,
          h: relativeRect.h
        };
      }
      function getRelativeRect(outerRect, innerRect) {
        return {
          x: innerRect.x - outerRect.x,
          y: innerRect.y - outerRect.y,
          w: innerRect.w,
          h: innerRect.h
        };
      }
      function getInnerRect() {
        return getRelativeRect(clampRect, currentRect);
      }
      function moveRect(handle, startRect, deltaX, deltaY) {
        var x, y, w, h, rect;
        x = startRect.x;
        y = startRect.y;
        w = startRect.w;
        h = startRect.h;
        x += deltaX * handle.deltaX;
        y += deltaY * handle.deltaY;
        w += deltaX * handle.deltaW;
        h += deltaY * handle.deltaH;
        if (w < 20) {
          w = 20;
        }
        if (h < 20) {
          h = 20;
        }
        rect = currentRect = global$7.clamp({
          x: x,
          y: y,
          w: w,
          h: h
        }, clampRect, handle.name === 'move');
        rect = getRelativeRect(clampRect, rect);
        instance.fire('updateRect', { rect: rect });
        setInnerRect(rect);
      }
      function render() {
        function createDragHelper(handle) {
          var startRect;
          var DragHelper = global$6.get('DragHelper');
          return new DragHelper(id, {
            document: containerElm.ownerDocument,
            handle: id + '-' + handle.name,
            start: function start() {
              startRect = currentRect;
            },
            drag: function drag(e) {
              moveRect(handle, startRect, e.deltaX, e.deltaY);
            }
          });
        }
        global$8('<div id="' + id + '" class="' + prefix + 'croprect-container"' + ' role="grid" aria-dropeffect="execute">').appendTo(containerElm);
        global$1.each(blockers, function (blocker) {
          global$8('#' + id, containerElm).append('<div id="' + id + '-' + blocker + '"class="' + prefix + 'croprect-block" style="display: none" data-mce-bogus="all">');
        });
        global$1.each(handles, function (handle) {
          global$8('#' + id, containerElm).append('<div id="' + id + '-' + handle.name + '" class="' + prefix + 'croprect-handle ' + prefix + 'croprect-handle-' + handle.name + '"' + 'style="display: none" data-mce-bogus="all" role="gridcell" tabindex="-1"' + ' aria-label="' + handle.label + '" aria-grabbed="false">');
        });
        dragHelpers = global$1.map(handles, createDragHelper);
        repaint(currentRect);
        global$8(containerElm).on('focusin focusout', function (e) {
          global$8(e.target).attr('aria-grabbed', e.type === 'focus');
        });
        global$8(containerElm).on('keydown', function (e) {
          var activeHandle;
          global$1.each(handles, function (handle) {
            if (e.target.id === id + '-' + handle.name) {
              activeHandle = handle;
              return false;
            }
          });
          function moveAndBlock(evt, handle, startRect, deltaX, deltaY) {
            evt.stopPropagation();
            evt.preventDefault();
            moveRect(activeHandle, startRect, deltaX, deltaY);
          }
          switch (e.keyCode) {
            case global$10.LEFT:
              moveAndBlock(e, activeHandle, currentRect, -10, 0);
              break;
            case global$10.RIGHT:
              moveAndBlock(e, activeHandle, currentRect, 10, 0);
              break;
            case global$10.UP:
              moveAndBlock(e, activeHandle, currentRect, 0, -10);
              break;
            case global$10.DOWN:
              moveAndBlock(e, activeHandle, currentRect, 0, 10);
              break;
            case global$10.ENTER:
            case global$10.SPACEBAR:
              e.preventDefault();
              action();
              break;
          }
        });
      }
      function toggleVisibility(state) {
        var selectors;
        selectors = global$1.map(handles, function (handle) {
          return '#' + id + '-' + handle.name;
        }).concat(global$1.map(blockers, function (blocker) {
          return '#' + id + '-' + blocker;
        })).join(',');
        if (state) {
          global$8(selectors, containerElm).show();
        } else {
          global$8(selectors, containerElm).hide();
        }
      }
      function repaint(rect) {
        function updateElementRect(name, rect) {
          if (rect.h < 0) {
            rect.h = 0;
          }
          if (rect.w < 0) {
            rect.w = 0;
          }
          global$8('#' + id + '-' + name, containerElm).css({
            left: rect.x,
            top: rect.y,
            width: rect.w,
            height: rect.h
          });
        }
        global$1.each(handles, function (handle) {
          global$8('#' + id + '-' + handle.name, containerElm).css({
            left: rect.w * handle.xMul + rect.x,
            top: rect.h * handle.yMul + rect.y
          });
        });
        updateElementRect('top', {
          x: viewPortRect.x,
          y: viewPortRect.y,
          w: viewPortRect.w,
          h: rect.y - viewPortRect.y
        });
        updateElementRect('right', {
          x: rect.x + rect.w,
          y: rect.y,
          w: viewPortRect.w - rect.x - rect.w + viewPortRect.x,
          h: rect.h
        });
        updateElementRect('bottom', {
          x: viewPortRect.x,
          y: rect.y + rect.h,
          w: viewPortRect.w,
          h: viewPortRect.h - rect.y - rect.h + viewPortRect.y
        });
        updateElementRect('left', {
          x: viewPortRect.x,
          y: rect.y,
          w: rect.x - viewPortRect.x,
          h: rect.h
        });
        updateElementRect('move', rect);
      }
      function setRect(rect) {
        currentRect = rect;
        repaint(currentRect);
      }
      function setViewPortRect(rect) {
        viewPortRect = rect;
        repaint(currentRect);
      }
      function setInnerRect(rect) {
        setRect(getAbsoluteRect(clampRect, rect));
      }
      function setClampRect(rect) {
        clampRect = rect;
        repaint(currentRect);
      }
      function destroy() {
        global$1.each(dragHelpers, function (helper) {
          helper.destroy();
        });
        dragHelpers = [];
      }
      render();
      instance = global$1.extend({
        toggleVisibility: toggleVisibility,
        setClampRect: setClampRect,
        setRect: setRect,
        getInnerRect: getInnerRect,
        setInnerRect: setInnerRect,
        setViewPortRect: setViewPortRect,
        destroy: destroy
      }, global$9);
      return instance;
    }

    var create$2 = function create$2(settings) {
      var Control = global$6.get('Control');
      var ImagePanel = Control.extend({
        Defaults: { classes: 'imagepanel' },
        selection: function selection(rect) {
          if (arguments.length) {
            this.state.set('rect', rect);
            return this;
          }
          return this.state.get('rect');
        },
        imageSize: function imageSize() {
          var viewRect = this.state.get('viewRect');
          return {
            w: viewRect.w,
            h: viewRect.h
          };
        },
        toggleCropRect: function toggleCropRect(state) {
          this.state.set('cropEnabled', state);
        },
        imageSrc: function imageSrc(url) {
          var self$$1 = this,
              img = new Image();
          img.src = url;
          $_cijn2deojk26xjju.loadImage(img).then(function () {
            var rect, $img;
            var lastRect = self$$1.state.get('viewRect');
            $img = self$$1.$el.find('img');
            if ($img[0]) {
              $img.replaceWith(img);
            } else {
              var bg = document.createElement('div');
              bg.className = 'mce-imagepanel-bg';
              self$$1.getEl().appendChild(bg);
              self$$1.getEl().appendChild(img);
            }
            rect = {
              x: 0,
              y: 0,
              w: img.naturalWidth,
              h: img.naturalHeight
            };
            self$$1.state.set('viewRect', rect);
            self$$1.state.set('rect', global$7.inflate(rect, -20, -20));
            if (!lastRect || lastRect.w !== rect.w || lastRect.h !== rect.h) {
              self$$1.zoomFit();
            }
            self$$1.repaintImage();
            self$$1.fire('load');
          });
        },
        zoom: function zoom(value) {
          if (arguments.length) {
            this.state.set('zoom', value);
            return this;
          }
          return this.state.get('zoom');
        },
        postRender: function postRender() {
          this.imageSrc(this.settings.imageSrc);
          return this._super();
        },
        zoomFit: function zoomFit() {
          var self$$1 = this;
          var $img, pw, ph, w, h, zoom, padding;
          padding = 10;
          $img = self$$1.$el.find('img');
          pw = self$$1.getEl().clientWidth;
          ph = self$$1.getEl().clientHeight;
          w = $img[0].naturalWidth;
          h = $img[0].naturalHeight;
          zoom = Math.min((pw - padding) / w, (ph - padding) / h);
          if (zoom >= 1) {
            zoom = 1;
          }
          self$$1.zoom(zoom);
        },
        repaintImage: function repaintImage() {
          var x, y, w, h, pw, ph, $img, $bg, zoom, rect, elm;
          elm = this.getEl();
          zoom = this.zoom();
          rect = this.state.get('rect');
          $img = this.$el.find('img');
          $bg = this.$el.find('.mce-imagepanel-bg');
          pw = elm.offsetWidth;
          ph = elm.offsetHeight;
          w = $img[0].naturalWidth * zoom;
          h = $img[0].naturalHeight * zoom;
          x = Math.max(0, pw / 2 - w / 2);
          y = Math.max(0, ph / 2 - h / 2);
          $img.css({
            left: x,
            top: y,
            width: w,
            height: h
          });
          $bg.css({
            left: x,
            top: y,
            width: w,
            height: h
          });
          if (this.cropRect) {
            this.cropRect.setRect({
              x: rect.x * zoom + x,
              y: rect.y * zoom + y,
              w: rect.w * zoom,
              h: rect.h * zoom
            });
            this.cropRect.setClampRect({
              x: x,
              y: y,
              w: w,
              h: h
            });
            this.cropRect.setViewPortRect({
              x: 0,
              y: 0,
              w: pw,
              h: ph
            });
          }
        },
        bindStates: function bindStates() {
          var self$$1 = this;
          function setupCropRect(rect) {
            self$$1.cropRect = CropRect(rect, self$$1.state.get('viewRect'), self$$1.state.get('viewRect'), self$$1.getEl(), function () {
              self$$1.fire('crop');
            });
            self$$1.cropRect.on('updateRect', function (e) {
              var rect = e.rect;
              var zoom = self$$1.zoom();
              rect = {
                x: Math.round(rect.x / zoom),
                y: Math.round(rect.y / zoom),
                w: Math.round(rect.w / zoom),
                h: Math.round(rect.h / zoom)
              };
              self$$1.state.set('rect', rect);
            });
            self$$1.on('remove', self$$1.cropRect.destroy);
          }
          self$$1.state.on('change:cropEnabled', function (e) {
            self$$1.cropRect.toggleVisibility(e.value);
            self$$1.repaintImage();
          });
          self$$1.state.on('change:zoom', function () {
            self$$1.repaintImage();
          });
          self$$1.state.on('change:rect', function (e) {
            var rect = e.value;
            if (!self$$1.cropRect) {
              setupCropRect(rect);
            }
            self$$1.cropRect.setRect(rect);
          });
        }
      });
      return new ImagePanel(settings);
    };
    var $_bue6fremjk26xjjq = { create: create$2 };

    function createState(blob) {
      return {
        blob: blob,
        url: $_1huwkedjk26xjiw.createObjectURL(blob)
      };
    }
    function destroyState(state) {
      if (state) {
        $_1huwkedjk26xjiw.revokeObjectURL(state.url);
      }
    }
    function destroyStates(states) {
      global$1.each(states, destroyState);
    }
    function open(editor, currentState, resolve, reject) {
      var win,
          undoStack = UndoStack(),
          mainPanel,
          filtersPanel,
          tempState,
          cropPanel,
          resizePanel,
          flipRotatePanel,
          imagePanel,
          sidePanel,
          mainViewContainer,
          invertPanel,
          brightnessPanel,
          huePanel,
          saturatePanel,
          contrastPanel,
          grayscalePanel,
          sepiaPanel,
          colorizePanel,
          sharpenPanel,
          embossPanel,
          gammaPanel,
          exposurePanel,
          panels,
          width,
          height,
          ratioW,
          ratioH;
      var reverseIfRtl = function reverseIfRtl(items) {
        return editor.rtl ? items.reverse() : items;
      };
      function recalcSize(e) {
        var widthCtrl, heightCtrl, newWidth, newHeight;
        widthCtrl = win.find('#w')[0];
        heightCtrl = win.find('#h')[0];
        newWidth = parseInt(widthCtrl.value(), 10);
        newHeight = parseInt(heightCtrl.value(), 10);
        if (win.find('#constrain')[0].checked() && width && height && newWidth && newHeight) {
          if (e.control.settings.name === 'w') {
            newHeight = Math.round(newWidth * ratioW);
            heightCtrl.value(newHeight);
          } else {
            newWidth = Math.round(newHeight * ratioH);
            widthCtrl.value(newWidth);
          }
        }
        width = newWidth;
        height = newHeight;
      }
      function floatToPercent(value) {
        return Math.round(value * 100) + '%';
      }
      function updateButtonUndoStates() {
        win.find('#undo').disabled(!undoStack.canUndo());
        win.find('#redo').disabled(!undoStack.canRedo());
        win.statusbar.find('#save').disabled(!undoStack.canUndo());
      }
      function disableUndoRedo() {
        win.find('#undo').disabled(true);
        win.find('#redo').disabled(true);
      }
      function displayState(state) {
        if (state) {
          imagePanel.imageSrc(state.url);
        }
      }
      function switchPanel(targetPanel) {
        return function () {
          var hidePanels = global$1.grep(panels, function (panel) {
            return panel.settings.name !== targetPanel;
          });
          global$1.each(hidePanels, function (panel) {
            panel.hide();
          });
          targetPanel.show();
          targetPanel.focus();
        };
      }
      function addTempState(blob) {
        tempState = createState(blob);
        displayState(tempState);
      }
      function addBlobState(blob) {
        currentState = createState(blob);
        displayState(currentState);
        destroyStates(undoStack.add(currentState).removed);
        updateButtonUndoStates();
      }
      function crop() {
        var rect = imagePanel.selection();
        $_cvbd8gecjk26xjiu.blobToImageResult(currentState.blob).then(function (ir) {
          $_cfu01e3jk26xjhj.crop(ir, rect.x, rect.y, rect.w, rect.h).then(imageResultToBlob).then(function (blob) {
            addBlobState(blob);
            cancel();
          });
        });
      }
      var tempAction = function tempAction(fn) {
        var args = [].slice.call(arguments, 1);
        return function () {
          var state = tempState || currentState;
          $_cvbd8gecjk26xjiu.blobToImageResult(state.blob).then(function (ir) {
            fn.apply(this, [ir].concat(args)).then(imageResultToBlob).then(addTempState);
          });
        };
      };
      function action(fn) {
        var arg = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          arg[_i - 1] = arguments[_i];
        }
        var args = [].slice.call(arguments, 1);
        return function () {
          $_cvbd8gecjk26xjiu.blobToImageResult(currentState.blob).then(function (ir) {
            fn.apply(this, [ir].concat(args)).then(imageResultToBlob).then(addBlobState);
          });
        };
      }
      function cancel() {
        displayState(currentState);
        destroyState(tempState);
        switchPanel(mainPanel)();
        updateButtonUndoStates();
      }
      function waitForTempState(times, applyCall) {
        if (tempState) {
          applyCall();
        } else {
          setTimeout(function () {
            if (times-- > 0) {
              waitForTempState(times, applyCall);
            } else {
              editor.windowManager.alert('Error: failed to apply image operation.');
            }
          }, 10);
        }
      }
      function applyTempState() {
        if (tempState) {
          addBlobState(tempState.blob);
          cancel();
        } else {
          waitForTempState(100, applyTempState);
        }
      }
      function zoomIn() {
        var zoom = imagePanel.zoom();
        if (zoom < 2) {
          zoom += 0.1;
        }
        imagePanel.zoom(zoom);
      }
      function zoomOut() {
        var zoom = imagePanel.zoom();
        if (zoom > 0.1) {
          zoom -= 0.1;
        }
        imagePanel.zoom(zoom);
      }
      function undo() {
        currentState = undoStack.undo();
        displayState(currentState);
        updateButtonUndoStates();
      }
      function redo() {
        currentState = undoStack.redo();
        displayState(currentState);
        updateButtonUndoStates();
      }
      function save() {
        resolve(currentState.blob);
        win.close();
      }
      function createPanel(items) {
        return global$6.create('Form', {
          layout: 'flex',
          direction: 'row',
          labelGap: 5,
          border: '0 0 1 0',
          align: 'center',
          pack: 'center',
          padding: '0 10 0 10',
          spacing: 5,
          flex: 0,
          minHeight: 60,
          defaults: {
            classes: 'imagetool',
            type: 'button'
          },
          items: items
        });
      }
      var imageResultToBlob = function imageResultToBlob(ir) {
        return ir.toBlob();
      };
      function createFilterPanel(title, filter) {
        return createPanel(reverseIfRtl([{
          text: 'Back',
          onclick: cancel
        }, {
          type: 'spacer',
          flex: 1
        }, {
          text: 'Apply',
          subtype: 'primary',
          onclick: applyTempState
        }])).hide().on('show', function () {
          disableUndoRedo();
          $_cvbd8gecjk26xjiu.blobToImageResult(currentState.blob).then(function (ir) {
            return filter(ir);
          }).then(imageResultToBlob).then(function (blob) {
            var newTempState = createState(blob);
            displayState(newTempState);
            destroyState(tempState);
            tempState = newTempState;
          });
        });
      }
      function createVariableFilterPanel(title, filter, value, min, max) {
        function update(value) {
          $_cvbd8gecjk26xjiu.blobToImageResult(currentState.blob).then(function (ir) {
            return filter(ir, value);
          }).then(imageResultToBlob).then(function (blob) {
            var newTempState = createState(blob);
            displayState(newTempState);
            destroyState(tempState);
            tempState = newTempState;
          });
        }
        return createPanel(reverseIfRtl([{
          text: 'Back',
          onclick: cancel
        }, {
          type: 'spacer',
          flex: 1
        }, {
          type: 'slider',
          flex: 1,
          ondragend: function ondragend(e) {
            update(e.value);
          },
          minValue: editor.rtl ? max : min,
          maxValue: editor.rtl ? min : max,
          value: value,
          previewFilter: floatToPercent
        }, {
          type: 'spacer',
          flex: 1
        }, {
          text: 'Apply',
          subtype: 'primary',
          onclick: applyTempState
        }])).hide().on('show', function () {
          this.find('slider').value(value);
          disableUndoRedo();
        });
      }
      function createRgbFilterPanel(title, filter) {
        function update() {
          var r, g, b;
          r = win.find('#r')[0].value();
          g = win.find('#g')[0].value();
          b = win.find('#b')[0].value();
          $_cvbd8gecjk26xjiu.blobToImageResult(currentState.blob).then(function (ir) {
            return filter(ir, r, g, b);
          }).then(imageResultToBlob).then(function (blob) {
            var newTempState = createState(blob);
            displayState(newTempState);
            destroyState(tempState);
            tempState = newTempState;
          });
        }
        var min = editor.rtl ? 2 : 0;
        var max = editor.rtl ? 0 : 2;
        return createPanel(reverseIfRtl([{
          text: 'Back',
          onclick: cancel
        }, {
          type: 'spacer',
          flex: 1
        }, {
          type: 'slider',
          label: 'R',
          name: 'r',
          minValue: min,
          value: 1,
          maxValue: max,
          ondragend: update,
          previewFilter: floatToPercent
        }, {
          type: 'slider',
          label: 'G',
          name: 'g',
          minValue: min,
          value: 1,
          maxValue: max,
          ondragend: update,
          previewFilter: floatToPercent
        }, {
          type: 'slider',
          label: 'B',
          name: 'b',
          minValue: min,
          value: 1,
          maxValue: max,
          ondragend: update,
          previewFilter: floatToPercent
        }, {
          type: 'spacer',
          flex: 1
        }, {
          text: 'Apply',
          subtype: 'primary',
          onclick: applyTempState
        }])).hide().on('show', function () {
          win.find('#r,#g,#b').value(1);
          disableUndoRedo();
        });
      }
      cropPanel = createPanel(reverseIfRtl([{
        text: 'Back',
        onclick: cancel
      }, {
        type: 'spacer',
        flex: 1
      }, {
        text: 'Apply',
        subtype: 'primary',
        onclick: crop
      }])).hide().on('show hide', function (e) {
        imagePanel.toggleCropRect(e.type === 'show');
      }).on('show', disableUndoRedo);
      function toggleConstrain(e) {
        if (e.control.value() === true) {
          ratioW = height / width;
          ratioH = width / height;
        }
      }
      resizePanel = createPanel(reverseIfRtl([{
        text: 'Back',
        onclick: cancel
      }, {
        type: 'spacer',
        flex: 1
      }, {
        type: 'textbox',
        name: 'w',
        label: 'Width',
        size: 4,
        onkeyup: recalcSize
      }, {
        type: 'textbox',
        name: 'h',
        label: 'Height',
        size: 4,
        onkeyup: recalcSize
      }, {
        type: 'checkbox',
        name: 'constrain',
        text: 'Constrain proportions',
        checked: true,
        onchange: toggleConstrain
      }, {
        type: 'spacer',
        flex: 1
      }, {
        text: 'Apply',
        subtype: 'primary',
        onclick: 'submit'
      }])).hide().on('submit', function (e) {
        var width = parseInt(win.find('#w').value(), 10),
            height = parseInt(win.find('#h').value(), 10);
        e.preventDefault();
        action($_cfu01e3jk26xjhj.resize, width, height)();
        cancel();
      }).on('show', disableUndoRedo);
      flipRotatePanel = createPanel(reverseIfRtl([{
        text: 'Back',
        onclick: cancel
      }, {
        type: 'spacer',
        flex: 1
      }, {
        icon: 'fliph',
        tooltip: 'Flip horizontally',
        onclick: tempAction($_cfu01e3jk26xjhj.flip, 'h')
      }, {
        icon: 'flipv',
        tooltip: 'Flip vertically',
        onclick: tempAction($_cfu01e3jk26xjhj.flip, 'v')
      }, {
        icon: 'rotateleft',
        tooltip: 'Rotate counterclockwise',
        onclick: tempAction($_cfu01e3jk26xjhj.rotate, -90)
      }, {
        icon: 'rotateright',
        tooltip: 'Rotate clockwise',
        onclick: tempAction($_cfu01e3jk26xjhj.rotate, 90)
      }, {
        type: 'spacer',
        flex: 1
      }, {
        text: 'Apply',
        subtype: 'primary',
        onclick: applyTempState
      }])).hide().on('show', disableUndoRedo);
      invertPanel = createFilterPanel('Invert', $_cfu01e3jk26xjhj.invert);
      sharpenPanel = createFilterPanel('Sharpen', $_cfu01e3jk26xjhj.sharpen);
      embossPanel = createFilterPanel('Emboss', $_cfu01e3jk26xjhj.emboss);
      brightnessPanel = createVariableFilterPanel('Brightness', $_cfu01e3jk26xjhj.brightness, 0, -1, 1);
      huePanel = createVariableFilterPanel('Hue', $_cfu01e3jk26xjhj.hue, 180, 0, 360);
      saturatePanel = createVariableFilterPanel('Saturate', $_cfu01e3jk26xjhj.saturate, 0, -1, 1);
      contrastPanel = createVariableFilterPanel('Contrast', $_cfu01e3jk26xjhj.contrast, 0, -1, 1);
      grayscalePanel = createVariableFilterPanel('Grayscale', $_cfu01e3jk26xjhj.grayscale, 0, 0, 1);
      sepiaPanel = createVariableFilterPanel('Sepia', $_cfu01e3jk26xjhj.sepia, 0, 0, 1);
      colorizePanel = createRgbFilterPanel('Colorize', $_cfu01e3jk26xjhj.colorize);
      gammaPanel = createVariableFilterPanel('Gamma', $_cfu01e3jk26xjhj.gamma, 0, -1, 1);
      exposurePanel = createVariableFilterPanel('Exposure', $_cfu01e3jk26xjhj.exposure, 1, 0, 2);
      filtersPanel = createPanel(reverseIfRtl([{
        text: 'Back',
        onclick: cancel
      }, {
        type: 'spacer',
        flex: 1
      }, {
        text: 'hue',
        icon: 'hue',
        onclick: switchPanel(huePanel)
      }, {
        text: 'saturate',
        icon: 'saturate',
        onclick: switchPanel(saturatePanel)
      }, {
        text: 'sepia',
        icon: 'sepia',
        onclick: switchPanel(sepiaPanel)
      }, {
        text: 'emboss',
        icon: 'emboss',
        onclick: switchPanel(embossPanel)
      }, {
        text: 'exposure',
        icon: 'exposure',
        onclick: switchPanel(exposurePanel)
      }, {
        type: 'spacer',
        flex: 1
      }])).hide();
      mainPanel = createPanel(reverseIfRtl([{
        tooltip: 'Crop',
        icon: 'crop',
        onclick: switchPanel(cropPanel)
      }, {
        tooltip: 'Resize',
        icon: 'resize2',
        onclick: switchPanel(resizePanel)
      }, {
        tooltip: 'Orientation',
        icon: 'orientation',
        onclick: switchPanel(flipRotatePanel)
      }, {
        tooltip: 'Brightness',
        icon: 'sun',
        onclick: switchPanel(brightnessPanel)
      }, {
        tooltip: 'Sharpen',
        icon: 'sharpen',
        onclick: switchPanel(sharpenPanel)
      }, {
        tooltip: 'Contrast',
        icon: 'contrast',
        onclick: switchPanel(contrastPanel)
      }, {
        tooltip: 'Color levels',
        icon: 'drop',
        onclick: switchPanel(colorizePanel)
      }, {
        tooltip: 'Gamma',
        icon: 'gamma',
        onclick: switchPanel(gammaPanel)
      }, {
        tooltip: 'Invert',
        icon: 'invert',
        onclick: switchPanel(invertPanel)
      }]));
      imagePanel = $_bue6fremjk26xjjq.create({
        flex: 1,
        imageSrc: currentState.url
      });
      sidePanel = global$6.create('Container', {
        layout: 'flex',
        direction: 'column',
        pack: 'start',
        border: '0 1 0 0',
        padding: 5,
        spacing: 5,
        items: [{
          type: 'button',
          icon: 'undo',
          tooltip: 'Undo',
          name: 'undo',
          onclick: undo
        }, {
          type: 'button',
          icon: 'redo',
          tooltip: 'Redo',
          name: 'redo',
          onclick: redo
        }, {
          type: 'button',
          icon: 'zoomin',
          tooltip: 'Zoom in',
          onclick: zoomIn
        }, {
          type: 'button',
          icon: 'zoomout',
          tooltip: 'Zoom out',
          onclick: zoomOut
        }]
      });
      mainViewContainer = global$6.create('Container', {
        type: 'container',
        layout: 'flex',
        direction: 'row',
        align: 'stretch',
        flex: 1,
        items: reverseIfRtl([sidePanel, imagePanel])
      });
      panels = [mainPanel, cropPanel, resizePanel, flipRotatePanel, filtersPanel, invertPanel, brightnessPanel, huePanel, saturatePanel, contrastPanel, grayscalePanel, sepiaPanel, colorizePanel, sharpenPanel, embossPanel, gammaPanel, exposurePanel];
      win = editor.windowManager.open({
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        minWidth: Math.min(global$5.DOM.getViewPort().w, 800),
        minHeight: Math.min(global$5.DOM.getViewPort().h, 650),
        title: 'Edit image',
        items: panels.concat([mainViewContainer]),
        buttons: reverseIfRtl([{
          text: 'Save',
          name: 'save',
          subtype: 'primary',
          onclick: save
        }, {
          text: 'Cancel',
          onclick: 'close'
        }])
      });
      win.on('close', function () {
        reject();
        destroyStates(undoStack.data);
        undoStack = null;
        tempState = null;
      });
      undoStack.add(currentState);
      updateButtonUndoStates();
      imagePanel.on('load', function () {
        width = imagePanel.imageSize().w;
        height = imagePanel.imageSize().h;
        ratioW = height / width;
        ratioH = width / height;
        win.find('#w').value(width);
        win.find('#h').value(height);
      });
      imagePanel.on('crop', crop);
    }
    function edit(editor, imageResult) {
      return new global$3(function (resolve, reject) {
        return imageResult.toBlob().then(function (blob) {
          open(editor, createState(blob), resolve, reject);
        });
      });
    }
    var $_1o2z5ceijk26xjj4 = { edit: edit };

    function getImageSize(img) {
      var width, height;
      function isPxValue(value) {
        return (/^[0-9\.]+px$/.test(value)
        );
      }
      width = img.style.width;
      height = img.style.height;
      if (width || height) {
        if (isPxValue(width) && isPxValue(height)) {
          return {
            w: parseInt(width, 10),
            h: parseInt(height, 10)
          };
        }
        return null;
      }
      width = img.width;
      height = img.height;
      if (width && height) {
        return {
          w: parseInt(width, 10),
          h: parseInt(height, 10)
        };
      }
      return null;
    }
    function setImageSize(img, size) {
      var width, height;
      if (size) {
        width = img.style.width;
        height = img.style.height;
        if (width || height) {
          img.style.width = size.w + 'px';
          img.style.height = size.h + 'px';
          img.removeAttribute('data-mce-style');
        }
        width = img.width;
        height = img.height;
        if (width || height) {
          img.setAttribute('width', size.w);
          img.setAttribute('height', size.h);
        }
      }
    }
    function getNaturalImageSize(img) {
      return {
        w: img.naturalWidth,
        h: img.naturalHeight
      };
    }
    var $_bntzezeujk26xjkr = {
      getImageSize: getImageSize,
      setImageSize: setImageSize,
      getNaturalImageSize: getNaturalImageSize
    };

    var typeOf = function typeOf(x) {
      if (x === null) return 'null';
      var t = typeof x === 'undefined' ? 'undefined' : _typeof(x);
      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
      return t;
    };
    var isType = function isType(type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };

    var isFunction = isType('function');

    var find = function find(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(x);
        }
      }
      return Option.none();
    };

    var slice = Array.prototype.slice;

    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
      return slice.call(x);
    };

    function XMLHttpRequest$1() {
      var f = $_chncyqdxjk26xjha.getOrDie('XMLHttpRequest');
      return new f();
    }

    var isValue = function isValue(obj) {
      return obj !== null && obj !== undefined;
    };
    var traverse = function traverse(json, path) {
      var value;
      value = path.reduce(function (result, key) {
        return isValue(result) ? result[key] : undefined;
      }, json);
      return isValue(value) ? value : null;
    };
    var requestUrlAsBlob = function requestUrlAsBlob(url, headers, withCredentials) {
      return new global$3(function (resolve) {
        var xhr;
        xhr = new XMLHttpRequest$1();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            resolve({
              status: xhr.status,
              blob: this.response
            });
          }
        };
        xhr.open('GET', url, true);
        xhr.withCredentials = withCredentials;
        global$1.each(headers, function (value, key) {
          xhr.setRequestHeader(key, value);
        });
        xhr.responseType = 'blob';
        xhr.send();
      });
    };
    var readBlob = function readBlob(blob) {
      return new global$3(function (resolve) {
        var fr = new FileReader();
        fr.onload = function (e) {
          var data = e.target;
          resolve(data.result);
        };
        fr.readAsText(blob);
      });
    };
    var parseJson = function parseJson(text) {
      var json;
      try {
        json = JSON.parse(text);
      } catch (ex) {}
      return json;
    };
    var $_n4g9rezjk26xjlb = {
      traverse: traverse,
      readBlob: readBlob,
      requestUrlAsBlob: requestUrlAsBlob,
      parseJson: parseJson
    };

    var friendlyHttpErrors = [{
      code: 404,
      message: 'Could not find Image Proxy'
    }, {
      code: 403,
      message: 'Rejected request'
    }, {
      code: 0,
      message: 'Incorrect Image Proxy URL'
    }];
    var friendlyServiceErrors = [{
      type: 'key_missing',
      message: 'The request did not include an api key.'
    }, {
      type: 'key_not_found',
      message: 'The provided api key could not be found.'
    }, {
      type: 'domain_not_trusted',
      message: 'The api key is not valid for the request origins.'
    }];
    var isServiceErrorCode = function isServiceErrorCode(code) {
      return code === 400 || code === 403 || code === 500;
    };
    var getHttpErrorMsg = function getHttpErrorMsg(status) {
      var message = find(friendlyHttpErrors, function (error) {
        return status === error.code;
      }).fold(constant('Unknown ImageProxy error'), function (error) {
        return error.message;
      });
      return 'ImageProxy HTTP error: ' + message;
    };
    var handleHttpError = function handleHttpError(status) {
      var message = getHttpErrorMsg(status);
      return global$3.reject(message);
    };
    var getServiceErrorMsg = function getServiceErrorMsg(type) {
      return find(friendlyServiceErrors, function (error) {
        return error.type === type;
      }).fold(constant('Unknown service error'), function (error) {
        return error.message;
      });
    };
    var getServiceError = function getServiceError(text) {
      var serviceError = $_n4g9rezjk26xjlb.parseJson(text);
      var errorType = $_n4g9rezjk26xjlb.traverse(serviceError, ['error', 'type']);
      var errorMsg = errorType ? getServiceErrorMsg(errorType) : 'Invalid JSON in service error message';
      return 'ImageProxy Service error: ' + errorMsg;
    };
    var handleServiceError = function handleServiceError(status, blob) {
      return $_n4g9rezjk26xjlb.readBlob(blob).then(function (text) {
        var serviceError = getServiceError(text);
        return global$3.reject(serviceError);
      });
    };
    var handleServiceErrorResponse = function handleServiceErrorResponse(status, blob) {
      return isServiceErrorCode(status) ? handleServiceError(status, blob) : handleHttpError(status);
    };
    var $_8xtfp6ewjk26xjkw = {
      handleServiceErrorResponse: handleServiceErrorResponse,
      handleHttpError: handleHttpError,
      getHttpErrorMsg: getHttpErrorMsg,
      getServiceErrorMsg: getServiceErrorMsg
    };

    var appendApiKey = function appendApiKey(url, apiKey) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      if (/[?&]apiKey=/.test(url) || !apiKey) {
        return url;
      } else {
        return url + separator + 'apiKey=' + encodeURIComponent(apiKey);
      }
    };
    var requestServiceBlob = function requestServiceBlob(url, apiKey) {
      var headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'tiny-api-key': apiKey
      };
      return $_n4g9rezjk26xjlb.requestUrlAsBlob(appendApiKey(url, apiKey), headers, false).then(function (result) {
        return result.status < 200 || result.status >= 300 ? $_8xtfp6ewjk26xjkw.handleServiceErrorResponse(result.status, result.blob) : global$3.resolve(result.blob);
      });
    };
    function requestBlob(url, withCredentials) {
      return $_n4g9rezjk26xjlb.requestUrlAsBlob(url, {}, withCredentials).then(function (result) {
        return result.status < 200 || result.status >= 300 ? $_8xtfp6ewjk26xjkw.handleHttpError(result.status) : global$3.resolve(result.blob);
      });
    }
    var getUrl = function getUrl(url, apiKey, withCredentials) {
      return apiKey ? requestServiceBlob(url, apiKey) : requestBlob(url, withCredentials);
    };
    var $_ruve6evjk26xjkt = { getUrl: getUrl };

    var count$1 = 0;
    var isEditableImage = function isEditableImage(editor, img) {
      var selectorMatched = editor.dom.is(img, 'img:not([data-mce-object],[data-mce-placeholder])');
      return selectorMatched && (isLocalImage(editor, img) || isCorsImage(editor, img) || editor.settings.imagetools_proxy);
    };
    var displayError = function displayError(editor, error) {
      editor.notificationManager.open({
        text: error,
        type: 'error'
      });
    };
    var getSelectedImage = function getSelectedImage(editor) {
      return editor.selection.getNode();
    };
    var extractFilename = function extractFilename(editor, url) {
      var m = url.match(/\/([^\/\?]+)?\.(?:jpeg|jpg|png|gif)(?:\?|$)/i);
      if (m) {
        return editor.dom.encode(m[1]);
      }
      return null;
    };
    var createId = function createId() {
      return 'imagetools' + count$1++;
    };
    var isLocalImage = function isLocalImage(editor, img) {
      var url = img.src;
      return url.indexOf('data:') === 0 || url.indexOf('blob:') === 0 || new global$4(url).host === editor.documentBaseURI.host;
    };
    var isCorsImage = function isCorsImage(editor, img) {
      return global$1.inArray(getCorsHosts(editor), new global$4(img.src).host) !== -1;
    };
    var isCorsWithCredentialsImage = function isCorsWithCredentialsImage(editor, img) {
      return global$1.inArray(getCredentialsHosts(editor), new global$4(img.src).host) !== -1;
    };
    var imageToBlob$2 = function imageToBlob$2(editor, img) {
      var src = img.src,
          apiKey;
      if (isCorsImage(editor, img)) {
        return $_ruve6evjk26xjkt.getUrl(img.src, null, isCorsWithCredentialsImage(editor, img));
      }
      if (!isLocalImage(editor, img)) {
        src = getProxyUrl(editor);
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'url=' + encodeURIComponent(img.src);
        apiKey = getApiKey(editor);
        return $_ruve6evjk26xjkt.getUrl(src, apiKey, false);
      }
      return $_8sw7dddpjk26xjg5.imageToBlob(img);
    };
    var findSelectedBlob = function findSelectedBlob(editor) {
      var blobInfo;
      blobInfo = editor.editorUpload.blobCache.getByUri(getSelectedImage(editor).src);
      if (blobInfo) {
        return global$3.resolve(blobInfo.blob());
      }
      return imageToBlob$2(editor, getSelectedImage(editor));
    };
    var startTimedUpload = function startTimedUpload(editor, imageUploadTimerState) {
      var imageUploadTimer = global$2.setEditorTimeout(editor, function () {
        editor.editorUpload.uploadImagesAuto();
      }, getUploadTimeout(editor));
      imageUploadTimerState.set(imageUploadTimer);
    };
    var cancelTimedUpload = function cancelTimedUpload(imageUploadTimerState) {
      clearTimeout(imageUploadTimerState.get());
    };
    var updateSelectedImage = function updateSelectedImage(editor, ir, uploadImmediately, imageUploadTimerState, size) {
      return ir.toBlob().then(function (blob) {
        var uri, name, blobCache, blobInfo, selectedImage;
        blobCache = editor.editorUpload.blobCache;
        selectedImage = getSelectedImage(editor);
        uri = selectedImage.src;
        if (shouldReuseFilename(editor)) {
          blobInfo = blobCache.getByUri(uri);
          if (blobInfo) {
            uri = blobInfo.uri();
            name = blobInfo.name();
          } else {
            name = extractFilename(editor, uri);
          }
        }
        blobInfo = blobCache.create({
          id: createId(),
          blob: blob,
          base64: ir.toBase64(),
          uri: uri,
          name: name
        });
        blobCache.add(blobInfo);
        editor.undoManager.transact(function () {
          function imageLoadedHandler() {
            editor.$(selectedImage).off('load', imageLoadedHandler);
            editor.nodeChanged();
            if (uploadImmediately) {
              editor.editorUpload.uploadImagesAuto();
            } else {
              cancelTimedUpload(imageUploadTimerState);
              startTimedUpload(editor, imageUploadTimerState);
            }
          }
          editor.$(selectedImage).on('load', imageLoadedHandler);
          if (size) {
            editor.$(selectedImage).attr({
              width: size.w,
              height: size.h
            });
          }
          editor.$(selectedImage).attr({ src: blobInfo.blobUri() }).removeAttr('data-mce-src');
        });
        return blobInfo;
      });
    };
    var selectedImageOperation = function selectedImageOperation(editor, imageUploadTimerState, fn, size) {
      return function () {
        return editor._scanForImages().then(curry(findSelectedBlob, editor)).then($_cvbd8gecjk26xjiu.blobToImageResult).then(fn).then(function (imageResult) {
          return updateSelectedImage(editor, imageResult, false, imageUploadTimerState, size);
        }, function (error) {
          displayError(editor, error);
        });
      };
    };
    var rotate$2 = function rotate$2(editor, imageUploadTimerState, angle) {
      return function () {
        var size = $_bntzezeujk26xjkr.getImageSize(getSelectedImage(editor));
        var flippedSize = size ? {
          w: size.h,
          h: size.w
        } : null;
        return selectedImageOperation(editor, imageUploadTimerState, function (imageResult) {
          return $_cfu01e3jk26xjhj.rotate(imageResult, angle);
        }, flippedSize)();
      };
    };
    var flip$2 = function flip$2(editor, imageUploadTimerState, axis) {
      return function () {
        return selectedImageOperation(editor, imageUploadTimerState, function (imageResult) {
          return $_cfu01e3jk26xjhj.flip(imageResult, axis);
        })();
      };
    };
    var editImageDialog = function editImageDialog(editor, imageUploadTimerState) {
      return function () {
        var img = getSelectedImage(editor),
            originalSize = $_bntzezeujk26xjkr.getNaturalImageSize(img);
        var handleDialogBlob = function handleDialogBlob(blob) {
          return new global$3(function (resolve) {
            $_8sw7dddpjk26xjg5.blobToImage(blob).then(function (newImage) {
              var newSize = $_bntzezeujk26xjkr.getNaturalImageSize(newImage);
              if (originalSize.w !== newSize.w || originalSize.h !== newSize.h) {
                if ($_bntzezeujk26xjkr.getImageSize(img)) {
                  $_bntzezeujk26xjkr.setImageSize(img, newSize);
                }
              }
              $_1huwkedjk26xjiw.revokeObjectURL(newImage.src);
              resolve(blob);
            });
          });
        };
        var openDialog = function openDialog(editor, imageResult) {
          return $_1o2z5ceijk26xjj4.edit(editor, imageResult).then(handleDialogBlob).then($_cvbd8gecjk26xjiu.blobToImageResult).then(function (imageResult) {
            return updateSelectedImage(editor, imageResult, true, imageUploadTimerState);
          }, function () {});
        };
        findSelectedBlob(editor).then($_cvbd8gecjk26xjiu.blobToImageResult).then(curry(openDialog, editor), function (error) {
          displayError(editor, error);
        });
      };
    };
    var $_9sb1nzdojk26xjfn = {
      rotate: rotate$2,
      flip: flip$2,
      editImageDialog: editImageDialog,
      isEditableImage: isEditableImage,
      cancelTimedUpload: cancelTimedUpload
    };

    var register = function register(editor, imageUploadTimerState) {
      global$1.each({
        mceImageRotateLeft: $_9sb1nzdojk26xjfn.rotate(editor, imageUploadTimerState, -90),
        mceImageRotateRight: $_9sb1nzdojk26xjfn.rotate(editor, imageUploadTimerState, 90),
        mceImageFlipVertical: $_9sb1nzdojk26xjfn.flip(editor, imageUploadTimerState, 'v'),
        mceImageFlipHorizontal: $_9sb1nzdojk26xjfn.flip(editor, imageUploadTimerState, 'h'),
        mceEditImage: $_9sb1nzdojk26xjfn.editImageDialog(editor, imageUploadTimerState)
      }, function (fn, cmd) {
        editor.addCommand(cmd, fn);
      });
    };
    var $_fxp48qdmjk26xjfj = { register: register };

    var setup = function setup(editor, imageUploadTimerState, lastSelectedImageState) {
      editor.on('NodeChange', function (e) {
        var lastSelectedImage = lastSelectedImageState.get();
        if (lastSelectedImage && lastSelectedImage.src !== e.element.src) {
          $_9sb1nzdojk26xjfn.cancelTimedUpload(imageUploadTimerState);
          editor.editorUpload.uploadImagesAuto();
          lastSelectedImageState.set(null);
        }
        if ($_9sb1nzdojk26xjfn.isEditableImage(editor, e.element)) {
          lastSelectedImageState.set(e.element);
        }
      });
    };
    var $_71v2sdf1jk26xjlh = { setup: setup };

    var register$1 = function register$1(editor) {
      editor.addButton('rotateleft', {
        title: 'Rotate counterclockwise',
        cmd: 'mceImageRotateLeft'
      });
      editor.addButton('rotateright', {
        title: 'Rotate clockwise',
        cmd: 'mceImageRotateRight'
      });
      editor.addButton('flipv', {
        title: 'Flip vertically',
        cmd: 'mceImageFlipVertical'
      });
      editor.addButton('fliph', {
        title: 'Flip horizontally',
        cmd: 'mceImageFlipHorizontal'
      });
      editor.addButton('editimage', {
        title: 'Edit image',
        cmd: 'mceEditImage'
      });
      editor.addButton('imageoptions', {
        title: 'Image options',
        icon: 'options',
        cmd: 'mceImage'
      });
    };
    var $_6ps1qyf2jk26xjli = { register: register$1 };

    var register$2 = function register$2(editor) {
      editor.addContextToolbar(curry($_9sb1nzdojk26xjfn.isEditableImage, editor), getToolbarItems(editor));
    };
    var $_d22gy0f3jk26xjlj = { register: register$2 };

    global.add('imagetools', function (editor) {
      var imageUploadTimerState = Cell(0);
      var lastSelectedImageState = Cell(null);
      $_fxp48qdmjk26xjfj.register(editor, imageUploadTimerState);
      $_6ps1qyf2jk26xjli.register(editor);
      $_d22gy0f3jk26xjlj.register(editor);
      $_71v2sdf1jk26xjlh.setup(editor, imageUploadTimerState, lastSelectedImageState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../../../node_modules/timers-browserify/main.js */ 70).setImmediate))

/***/ }),
/* 975 */
/*!**************************************************************!*\
  !*** ./src/packages/tinymce/plugins/insertdatetime/index.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "insertdatetime" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/insertdatetime')
//   ES2015:
//     import 'tinymce/plugins/insertdatetime'
__webpack_require__(/*! ./plugin.js */ 976);

/***/ }),
/* 976 */
/*!***************************************************************!*\
  !*** ./src/packages/tinymce/plugins/insertdatetime/plugin.js ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var insertdatetime = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var getDateFormat = function getDateFormat(editor) {
      return editor.getParam('insertdatetime_dateformat', editor.translate('%Y-%m-%d'));
    };
    var getTimeFormat = function getTimeFormat(editor) {
      return editor.getParam('insertdatetime_timeformat', editor.translate('%H:%M:%S'));
    };
    var getFormats = function getFormats(editor) {
      return editor.getParam('insertdatetime_formats', ['%H:%M:%S', '%Y-%m-%d', '%I:%M:%S %p', '%D']);
    };
    var getDefaultDateTime = function getDefaultDateTime(editor) {
      var formats = getFormats(editor);
      return formats.length > 0 ? formats[0] : getTimeFormat(editor);
    };
    var shouldInsertTimeElement = function shouldInsertTimeElement(editor) {
      return editor.getParam('insertdatetime_element', false);
    };
    var $_fyguewfhjk26xjug = {
      getDateFormat: getDateFormat,
      getTimeFormat: getTimeFormat,
      getFormats: getFormats,
      getDefaultDateTime: getDefaultDateTime,
      shouldInsertTimeElement: shouldInsertTimeElement
    };

    var daysShort = 'Sun Mon Tue Wed Thu Fri Sat Sun'.split(' ');
    var daysLong = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday'.split(' ');
    var monthsShort = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
    var monthsLong = 'January February March April May June July August September October November December'.split(' ');
    var addZeros = function addZeros(value, len) {
      value = '' + value;
      if (value.length < len) {
        for (var i = 0; i < len - value.length; i++) {
          value = '0' + value;
        }
      }
      return value;
    };
    var getDateTime = function getDateTime(editor, fmt, date) {
      date = date || new Date();
      fmt = fmt.replace('%D', '%m/%d/%Y');
      fmt = fmt.replace('%r', '%I:%M:%S %p');
      fmt = fmt.replace('%Y', '' + date.getFullYear());
      fmt = fmt.replace('%y', '' + date.getYear());
      fmt = fmt.replace('%m', addZeros(date.getMonth() + 1, 2));
      fmt = fmt.replace('%d', addZeros(date.getDate(), 2));
      fmt = fmt.replace('%H', '' + addZeros(date.getHours(), 2));
      fmt = fmt.replace('%M', '' + addZeros(date.getMinutes(), 2));
      fmt = fmt.replace('%S', '' + addZeros(date.getSeconds(), 2));
      fmt = fmt.replace('%I', '' + ((date.getHours() + 11) % 12 + 1));
      fmt = fmt.replace('%p', '' + (date.getHours() < 12 ? 'AM' : 'PM'));
      fmt = fmt.replace('%B', '' + editor.translate(monthsLong[date.getMonth()]));
      fmt = fmt.replace('%b', '' + editor.translate(monthsShort[date.getMonth()]));
      fmt = fmt.replace('%A', '' + editor.translate(daysLong[date.getDay()]));
      fmt = fmt.replace('%a', '' + editor.translate(daysShort[date.getDay()]));
      fmt = fmt.replace('%%', '%');
      return fmt;
    };
    var updateElement = function updateElement(editor, timeElm, computerTime, userTime) {
      var newTimeElm = editor.dom.create('time', { datetime: computerTime }, userTime);
      timeElm.parentNode.insertBefore(newTimeElm, timeElm);
      editor.dom.remove(timeElm);
      editor.selection.select(newTimeElm, true);
      editor.selection.collapse(false);
    };
    var insertDateTime = function insertDateTime(editor, format) {
      if ($_fyguewfhjk26xjug.shouldInsertTimeElement(editor)) {
        var userTime = getDateTime(editor, format);
        var computerTime = void 0;
        if (/%[HMSIp]/.test(format)) {
          computerTime = getDateTime(editor, '%Y-%m-%dT%H:%M');
        } else {
          computerTime = getDateTime(editor, '%Y-%m-%d');
        }
        var timeElm = editor.dom.getParent(editor.selection.getStart(), 'time');
        if (timeElm) {
          updateElement(editor, timeElm, computerTime, userTime);
        } else {
          editor.insertContent('<time datetime="' + computerTime + '">' + userTime + '</time>');
        }
      } else {
        editor.insertContent(getDateTime(editor, format));
      }
    };
    var $_dif1eofijk26xjui = {
      insertDateTime: insertDateTime,
      getDateTime: getDateTime
    };

    var register = function register(editor) {
      editor.addCommand('mceInsertDate', function () {
        $_dif1eofijk26xjui.insertDateTime(editor, $_fyguewfhjk26xjug.getDateFormat(editor));
      });
      editor.addCommand('mceInsertTime', function () {
        $_dif1eofijk26xjui.insertDateTime(editor, $_fyguewfhjk26xjug.getTimeFormat(editor));
      });
    };
    var $_d60otqfgjk26xjuf = { register: register };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var createMenuItems = function createMenuItems(editor, lastFormatState) {
      var formats = $_fyguewfhjk26xjug.getFormats(editor);
      return global$1.map(formats, function (fmt) {
        return {
          text: $_dif1eofijk26xjui.getDateTime(editor, fmt),
          onclick: function onclick() {
            lastFormatState.set(fmt);
            $_dif1eofijk26xjui.insertDateTime(editor, fmt);
          }
        };
      });
    };
    var register$1 = function register$1(editor, lastFormatState) {
      var menuItems = createMenuItems(editor, lastFormatState);
      editor.addButton('insertdatetime', {
        type: 'splitbutton',
        title: 'Insert date/time',
        menu: menuItems,
        onclick: function onclick() {
          var lastFormat = lastFormatState.get();
          $_dif1eofijk26xjui.insertDateTime(editor, lastFormat ? lastFormat : $_fyguewfhjk26xjug.getDefaultDateTime(editor));
        }
      });
      editor.addMenuItem('insertdatetime', {
        icon: 'date',
        text: 'Date/time',
        menu: menuItems,
        context: 'insert'
      });
    };
    var $_7qiq1efjjk26xjul = { register: register$1 };

    global.add('insertdatetime', function (editor) {
      var lastFormatState = Cell(null);
      $_d60otqfgjk26xjuf.register(editor);
      $_7qiq1efjjk26xjul.register(editor, lastFormatState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 977 */
/*!****************************************************!*\
  !*** ./src/packages/tinymce/plugins/link/index.js ***!
  \****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "link" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/link')
//   ES2015:
//     import 'tinymce/plugins/link'
__webpack_require__(/*! ./plugin.js */ 978);

/***/ }),
/* 978 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/link/plugin.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var link = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var assumeExternalTargets = function assumeExternalTargets(editorSettings) {
      return typeof editorSettings.link_assume_external_targets === 'boolean' ? editorSettings.link_assume_external_targets : false;
    };
    var hasContextToolbar = function hasContextToolbar(editorSettings) {
      return typeof editorSettings.link_context_toolbar === 'boolean' ? editorSettings.link_context_toolbar : false;
    };
    var getLinkList = function getLinkList(editorSettings) {
      return editorSettings.link_list;
    };
    var hasDefaultLinkTarget = function hasDefaultLinkTarget(editorSettings) {
      return typeof editorSettings.default_link_target === 'string';
    };
    var getDefaultLinkTarget = function getDefaultLinkTarget(editorSettings) {
      return editorSettings.default_link_target;
    };
    var getTargetList = function getTargetList(editorSettings) {
      return editorSettings.target_list;
    };
    var setTargetList = function setTargetList(editor, list) {
      editor.settings.target_list = list;
    };
    var shouldShowTargetList = function shouldShowTargetList(editorSettings) {
      return getTargetList(editorSettings) !== false;
    };
    var getRelList = function getRelList(editorSettings) {
      return editorSettings.rel_list;
    };
    var hasRelList = function hasRelList(editorSettings) {
      return getRelList(editorSettings) !== undefined;
    };
    var getLinkClassList = function getLinkClassList(editorSettings) {
      return editorSettings.link_class_list;
    };
    var hasLinkClassList = function hasLinkClassList(editorSettings) {
      return getLinkClassList(editorSettings) !== undefined;
    };
    var shouldShowLinkTitle = function shouldShowLinkTitle(editorSettings) {
      return editorSettings.link_title !== false;
    };
    var allowUnsafeLinkTarget = function allowUnsafeLinkTarget(editorSettings) {
      return typeof editorSettings.allow_unsafe_link_target === 'boolean' ? editorSettings.allow_unsafe_link_target : false;
    };
    var $_d7x253fvjk26xjvu = {
      assumeExternalTargets: assumeExternalTargets,
      hasContextToolbar: hasContextToolbar,
      getLinkList: getLinkList,
      hasDefaultLinkTarget: hasDefaultLinkTarget,
      getDefaultLinkTarget: getDefaultLinkTarget,
      getTargetList: getTargetList,
      setTargetList: setTargetList,
      shouldShowTargetList: shouldShowTargetList,
      getRelList: getRelList,
      hasRelList: hasRelList,
      getLinkClassList: getLinkClassList,
      hasLinkClassList: hasLinkClassList,
      shouldShowLinkTitle: shouldShowLinkTitle,
      allowUnsafeLinkTarget: allowUnsafeLinkTarget
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');

    var appendClickRemove = function appendClickRemove(link, evt) {
      document.body.appendChild(link);
      link.dispatchEvent(evt);
      document.body.removeChild(link);
    };
    var open$$1 = function open$$1(url) {
      if (!global$3.ie || global$3.ie > 10) {
        var link = document.createElement('a');
        link.target = '_blank';
        link.href = url;
        link.rel = 'noreferrer noopener';
        var evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        appendClickRemove(link, evt);
      } else {
        var win = window.open('', '_blank');
        if (win) {
          win.opener = null;
          var doc = win.document;
          doc.open();
          doc.write('<meta http-equiv="refresh" content="0; url=' + global$2.DOM.encode(url) + '">');
          doc.close();
        }
      }
    };
    var $_5npv42fwjk26xjvw = { open: open$$1 };

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var toggleTargetRules = function toggleTargetRules(rel, isUnsafe) {
      var rules = ['noopener'];
      var newRel = rel ? rel.split(/\s+/) : [];
      var toString = function toString(rel) {
        return global$4.trim(rel.sort().join(' '));
      };
      var addTargetRules = function addTargetRules(rel) {
        rel = removeTargetRules(rel);
        return rel.length ? rel.concat(rules) : rules;
      };
      var removeTargetRules = function removeTargetRules(rel) {
        return rel.filter(function (val) {
          return global$4.inArray(rules, val) === -1;
        });
      };
      newRel = isUnsafe ? addTargetRules(newRel) : removeTargetRules(newRel);
      return newRel.length ? toString(newRel) : null;
    };
    var trimCaretContainers = function trimCaretContainers(text) {
      return text.replace(/\uFEFF/g, '');
    };
    var getAnchorElement = function getAnchorElement(editor, selectedElm) {
      selectedElm = selectedElm || editor.selection.getNode();
      if (isImageFigure(selectedElm)) {
        return editor.dom.select('a[href]', selectedElm)[0];
      } else {
        return editor.dom.getParent(selectedElm, 'a[href]');
      }
    };
    var getAnchorText = function getAnchorText(selection, anchorElm) {
      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
      return trimCaretContainers(text);
    };
    var isLink = function isLink(elm) {
      return elm && elm.nodeName === 'A' && elm.href;
    };
    var hasLinks = function hasLinks(elements) {
      return global$4.grep(elements, isLink).length > 0;
    };
    var isOnlyTextSelected = function isOnlyTextSelected(html) {
      if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') === -1)) {
        return false;
      }
      return true;
    };
    var isImageFigure = function isImageFigure(node) {
      return node && node.nodeName === 'FIGURE' && /\bimage\b/i.test(node.className);
    };
    var link = function link(editor, attachState) {
      return function (data) {
        editor.undoManager.transact(function () {
          var selectedElm = editor.selection.getNode();
          var anchorElm = getAnchorElement(editor, selectedElm);
          var linkAttrs = {
            href: data.href,
            target: data.target ? data.target : null,
            rel: data.rel ? data.rel : null,
            class: data.class ? data.class : null,
            title: data.title ? data.title : null
          };
          if (!$_d7x253fvjk26xjvu.hasRelList(editor.settings) && $_d7x253fvjk26xjvu.allowUnsafeLinkTarget(editor.settings) === false) {
            linkAttrs.rel = toggleTargetRules(linkAttrs.rel, linkAttrs.target === '_blank');
          }
          if (data.href === attachState.href) {
            attachState.attach();
            attachState = {};
          }
          if (anchorElm) {
            editor.focus();
            if (data.hasOwnProperty('text')) {
              if ('innerText' in anchorElm) {
                anchorElm.innerText = data.text;
              } else {
                anchorElm.textContent = data.text;
              }
            }
            editor.dom.setAttribs(anchorElm, linkAttrs);
            editor.selection.select(anchorElm);
            editor.undoManager.add();
          } else {
            if (isImageFigure(selectedElm)) {
              linkImageFigure(editor, selectedElm, linkAttrs);
            } else if (data.hasOwnProperty('text')) {
              editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(data.text)));
            } else {
              editor.execCommand('mceInsertLink', false, linkAttrs);
            }
          }
        });
      };
    };
    var unlink = function unlink(editor) {
      return function () {
        editor.undoManager.transact(function () {
          var node = editor.selection.getNode();
          if (isImageFigure(node)) {
            unlinkImageFigure(editor, node);
          } else {
            editor.execCommand('unlink');
          }
        });
      };
    };
    var unlinkImageFigure = function unlinkImageFigure(editor, fig) {
      var a, img;
      img = editor.dom.select('img', fig)[0];
      if (img) {
        a = editor.dom.getParents(img, 'a[href]', fig)[0];
        if (a) {
          a.parentNode.insertBefore(img, a);
          editor.dom.remove(a);
        }
      }
    };
    var linkImageFigure = function linkImageFigure(editor, fig, attrs) {
      var a, img;
      img = editor.dom.select('img', fig)[0];
      if (img) {
        a = editor.dom.create('a', attrs);
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
      }
    };
    var $_eh110jg0jk26xjwd = {
      link: link,
      unlink: unlink,
      isLink: isLink,
      hasLinks: hasLinks,
      isOnlyTextSelected: isOnlyTextSelected,
      getAnchorElement: getAnchorElement,
      getAnchorText: getAnchorText,
      toggleTargetRules: toggleTargetRules
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$6 = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var attachState = {};
    var createLinkList = function createLinkList(editor, callback) {
      var linkList = $_d7x253fvjk26xjvu.getLinkList(editor.settings);
      if (typeof linkList === 'string') {
        global$6.send({
          url: linkList,
          success: function success(text) {
            callback(editor, JSON.parse(text));
          }
        });
      } else if (typeof linkList === 'function') {
        linkList(function (list) {
          callback(editor, list);
        });
      } else {
        callback(editor, linkList);
      }
    };
    var buildListItems = function buildListItems(inputList, itemCallback, startItems) {
      var appendItems = function appendItems(values, output) {
        output = output || [];
        global$4.each(values, function (item) {
          var menuItem = { text: item.text || item.title };
          if (item.menu) {
            menuItem.menu = appendItems(item.menu);
          } else {
            menuItem.value = item.value;
            if (itemCallback) {
              itemCallback(menuItem);
            }
          }
          output.push(menuItem);
        });
        return output;
      };
      return appendItems(inputList, startItems || []);
    };
    var delayedConfirm = function delayedConfirm(editor, message, callback) {
      var rng = editor.selection.getRng();
      global$5.setEditorTimeout(editor, function () {
        editor.windowManager.confirm(message, function (state) {
          editor.selection.setRng(rng);
          callback(state);
        });
      });
    };
    var showDialog = function showDialog(editor, linkList) {
      var data = {};
      var selection = editor.selection;
      var dom = editor.dom;
      var anchorElm, initialText;
      var win, onlyText, textListCtrl, linkListCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;
      var linkListChangeHandler = function linkListChangeHandler(e) {
        var textCtrl = win.find('#text');
        if (!textCtrl.value() || e.lastControl && textCtrl.value() === e.lastControl.text()) {
          textCtrl.value(e.control.text());
        }
        win.find('#href').value(e.control.value());
      };
      var buildAnchorListControl = function buildAnchorListControl(url) {
        var anchorList = [];
        global$4.each(editor.dom.select('a:not([href])'), function (anchor) {
          var id = anchor.name || anchor.id;
          if (id) {
            anchorList.push({
              text: id,
              value: '#' + id,
              selected: url.indexOf('#' + id) !== -1
            });
          }
        });
        if (anchorList.length) {
          anchorList.unshift({
            text: 'None',
            value: ''
          });
          return {
            name: 'anchor',
            type: 'listbox',
            label: 'Anchors',
            values: anchorList,
            onselect: linkListChangeHandler
          };
        }
      };
      var updateText = function updateText() {
        if (!initialText && onlyText && !data.text) {
          this.parent().parent().find('#text')[0].value(this.value());
        }
      };
      var urlChange = function urlChange(e) {
        var meta = e.meta || {};
        if (linkListCtrl) {
          linkListCtrl.value(editor.convertURL(this.value(), 'href'));
        }
        global$4.each(e.meta, function (value, key) {
          var inp = win.find('#' + key);
          if (key === 'text') {
            if (initialText.length === 0) {
              inp.value(value);
              data.text = value;
            }
          } else {
            inp.value(value);
          }
        });
        if (meta.attach) {
          attachState = {
            href: this.value(),
            attach: meta.attach
          };
        }
        if (!meta.text) {
          updateText.call(this);
        }
      };
      var onBeforeCall = function onBeforeCall(e) {
        e.meta = win.toJSON();
      };
      onlyText = $_eh110jg0jk26xjwd.isOnlyTextSelected(selection.getContent());
      anchorElm = $_eh110jg0jk26xjwd.getAnchorElement(editor);
      data.text = initialText = $_eh110jg0jk26xjwd.getAnchorText(editor.selection, anchorElm);
      data.href = anchorElm ? dom.getAttrib(anchorElm, 'href') : '';
      if (anchorElm) {
        data.target = dom.getAttrib(anchorElm, 'target');
      } else if ($_d7x253fvjk26xjvu.hasDefaultLinkTarget(editor.settings)) {
        data.target = $_d7x253fvjk26xjvu.getDefaultLinkTarget(editor.settings);
      }
      if (value = dom.getAttrib(anchorElm, 'rel')) {
        data.rel = value;
      }
      if (value = dom.getAttrib(anchorElm, 'class')) {
        data.class = value;
      }
      if (value = dom.getAttrib(anchorElm, 'title')) {
        data.title = value;
      }
      if (onlyText) {
        textListCtrl = {
          name: 'text',
          type: 'textbox',
          size: 40,
          label: 'Text to display',
          onchange: function onchange() {
            data.text = this.value();
          }
        };
      }
      if (linkList) {
        linkListCtrl = {
          type: 'listbox',
          label: 'Link list',
          values: buildListItems(linkList, function (item) {
            item.value = editor.convertURL(item.value || item.url, 'href');
          }, [{
            text: 'None',
            value: ''
          }]),
          onselect: linkListChangeHandler,
          value: editor.convertURL(data.href, 'href'),
          onPostRender: function onPostRender() {
            linkListCtrl = this;
          }
        };
      }
      if ($_d7x253fvjk26xjvu.shouldShowTargetList(editor.settings)) {
        if ($_d7x253fvjk26xjvu.getTargetList(editor.settings) === undefined) {
          $_d7x253fvjk26xjvu.setTargetList(editor, [{
            text: 'None',
            value: ''
          }, {
            text: 'New window',
            value: '_blank'
          }]);
        }
        targetListCtrl = {
          name: 'target',
          type: 'listbox',
          label: 'Target',
          values: buildListItems($_d7x253fvjk26xjvu.getTargetList(editor.settings))
        };
      }
      if ($_d7x253fvjk26xjvu.hasRelList(editor.settings)) {
        relListCtrl = {
          name: 'rel',
          type: 'listbox',
          label: 'Rel',
          values: buildListItems($_d7x253fvjk26xjvu.getRelList(editor.settings), function (item) {
            if ($_d7x253fvjk26xjvu.allowUnsafeLinkTarget(editor.settings) === false) {
              item.value = $_eh110jg0jk26xjwd.toggleTargetRules(item.value, data.target === '_blank');
            }
          })
        };
      }
      if ($_d7x253fvjk26xjvu.hasLinkClassList(editor.settings)) {
        classListCtrl = {
          name: 'class',
          type: 'listbox',
          label: 'Class',
          values: buildListItems($_d7x253fvjk26xjvu.getLinkClassList(editor.settings), function (item) {
            if (item.value) {
              item.textStyle = function () {
                return editor.formatter.getCssText({
                  inline: 'a',
                  classes: [item.value]
                });
              };
            }
          })
        };
      }
      if ($_d7x253fvjk26xjvu.shouldShowLinkTitle(editor.settings)) {
        linkTitleCtrl = {
          name: 'title',
          type: 'textbox',
          label: 'Title',
          value: data.title
        };
      }
      win = editor.windowManager.open({
        title: 'Insert link',
        data: data,
        body: [{
          name: 'href',
          type: 'filepicker',
          filetype: 'file',
          size: 40,
          autofocus: true,
          label: 'Url',
          onchange: urlChange,
          onkeyup: updateText,
          onpaste: updateText,
          onbeforecall: onBeforeCall
        }, textListCtrl, linkTitleCtrl, buildAnchorListControl(data.href), linkListCtrl, relListCtrl, targetListCtrl, classListCtrl],
        onSubmit: function onSubmit(e) {
          var assumeExternalTargets = $_d7x253fvjk26xjvu.assumeExternalTargets(editor.settings);
          var insertLink = $_eh110jg0jk26xjwd.link(editor, attachState);
          var removeLink = $_eh110jg0jk26xjwd.unlink(editor);
          var resultData = global$4.extend({}, data, e.data);
          var href = resultData.href;
          if (!href) {
            removeLink();
            return;
          }
          if (!onlyText || resultData.text === initialText) {
            delete resultData.text;
          }
          if (href.indexOf('@') > 0 && href.indexOf('//') === -1 && href.indexOf('mailto:') === -1) {
            delayedConfirm(editor, 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?', function (state) {
              if (state) {
                resultData.href = 'mailto:' + href;
              }
              insertLink(resultData);
            });
            return;
          }
          if (assumeExternalTargets === true && !/^\w+:/i.test(href) || assumeExternalTargets === false && /^\s*www[\.|\d\.]/i.test(href)) {
            delayedConfirm(editor, 'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?', function (state) {
              if (state) {
                resultData.href = 'http://' + href;
              }
              insertLink(resultData);
            });
            return;
          }
          insertLink(resultData);
        }
      });
    };
    var open$1 = function open$1(editor) {
      createLinkList(editor, showDialog);
    };
    var $_bhrct4g2jk26xjwl = { open: open$1 };

    var getLink = function getLink(editor, elm) {
      return editor.dom.getParent(elm, 'a[href]');
    };
    var getSelectedLink = function getSelectedLink(editor) {
      return getLink(editor, editor.selection.getStart());
    };
    var getHref = function getHref(elm) {
      var href = elm.getAttribute('data-mce-href');
      return href ? href : elm.getAttribute('href');
    };
    var isContextMenuVisible = function isContextMenuVisible(editor) {
      var contextmenu = editor.plugins.contextmenu;
      return contextmenu ? contextmenu.isContextMenuVisible() : false;
    };
    var hasOnlyAltModifier = function hasOnlyAltModifier(e) {
      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
    };
    var gotoLink = function gotoLink(editor, a) {
      if (a) {
        var href = getHref(a);
        if (/^#/.test(href)) {
          var targetEl = editor.$(href);
          if (targetEl.length) {
            editor.selection.scrollIntoView(targetEl[0], true);
          }
        } else {
          $_5npv42fwjk26xjvw.open(a.href);
        }
      }
    };
    var openDialog = function openDialog(editor) {
      return function () {
        $_bhrct4g2jk26xjwl.open(editor);
      };
    };
    var gotoSelectedLink = function gotoSelectedLink(editor) {
      return function () {
        gotoLink(editor, getSelectedLink(editor));
      };
    };
    var leftClickedOnAHref = function leftClickedOnAHref(editor) {
      return function (elm) {
        var sel, rng, node;
        if ($_d7x253fvjk26xjvu.hasContextToolbar(editor.settings) && !isContextMenuVisible(editor) && $_eh110jg0jk26xjwd.isLink(elm)) {
          sel = editor.selection;
          rng = sel.getRng();
          node = rng.startContainer;
          if (node.nodeType === 3 && sel.isCollapsed() && rng.startOffset > 0 && rng.startOffset < node.data.length) {
            return true;
          }
        }
        return false;
      };
    };
    var setupGotoLinks = function setupGotoLinks(editor) {
      editor.on('click', function (e) {
        var link = getLink(editor, e.target);
        if (link && global$1.metaKeyPressed(e)) {
          e.preventDefault();
          gotoLink(editor, link);
        }
      });
      editor.on('keydown', function (e) {
        var link = getSelectedLink(editor);
        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
          e.preventDefault();
          gotoLink(editor, link);
        }
      });
    };
    var toggleActiveState = function toggleActiveState(editor) {
      return function () {
        var self = this;
        editor.on('nodechange', function (e) {
          self.active(!editor.readonly && !!$_eh110jg0jk26xjwd.getAnchorElement(editor, e.element));
        });
      };
    };
    var toggleViewLinkState = function toggleViewLinkState(editor) {
      return function () {
        var self = this;
        var toggleVisibility = function toggleVisibility(e) {
          if ($_eh110jg0jk26xjwd.hasLinks(e.parents)) {
            self.show();
          } else {
            self.hide();
          }
        };
        if (!$_eh110jg0jk26xjwd.hasLinks(editor.dom.getParents(editor.selection.getStart()))) {
          self.hide();
        }
        editor.on('nodechange', toggleVisibility);
        self.on('remove', function () {
          editor.off('nodechange', toggleVisibility);
        });
      };
    };
    var $_11xp25ftjk26xjvp = {
      openDialog: openDialog,
      gotoSelectedLink: gotoSelectedLink,
      leftClickedOnAHref: leftClickedOnAHref,
      setupGotoLinks: setupGotoLinks,
      toggleActiveState: toggleActiveState,
      toggleViewLinkState: toggleViewLinkState
    };

    var register = function register(editor) {
      editor.addCommand('mceLink', $_11xp25ftjk26xjvp.openDialog(editor));
    };
    var $_lmabpfsjk26xjvo = { register: register };

    var setup = function setup(editor) {
      editor.addShortcut('Meta+K', '', $_11xp25ftjk26xjvp.openDialog(editor));
    };
    var $_afp9b2g5jk26xjws = { setup: setup };

    var setupButtons = function setupButtons(editor) {
      editor.addButton('link', {
        active: false,
        icon: 'link',
        tooltip: 'Insert/edit link',
        onclick: $_11xp25ftjk26xjvp.openDialog(editor),
        onpostrender: $_11xp25ftjk26xjvp.toggleActiveState(editor)
      });
      editor.addButton('unlink', {
        active: false,
        icon: 'unlink',
        tooltip: 'Remove link',
        onclick: $_eh110jg0jk26xjwd.unlink(editor),
        onpostrender: $_11xp25ftjk26xjvp.toggleActiveState(editor)
      });
      if (editor.addContextToolbar) {
        editor.addButton('openlink', {
          icon: 'newtab',
          tooltip: 'Open link',
          onclick: $_11xp25ftjk26xjvp.gotoSelectedLink(editor)
        });
      }
    };
    var setupMenuItems = function setupMenuItems(editor) {
      editor.addMenuItem('openlink', {
        text: 'Open link',
        icon: 'newtab',
        onclick: $_11xp25ftjk26xjvp.gotoSelectedLink(editor),
        onPostRender: $_11xp25ftjk26xjvp.toggleViewLinkState(editor),
        prependToContext: true
      });
      editor.addMenuItem('link', {
        icon: 'link',
        text: 'Link',
        shortcut: 'Meta+K',
        onclick: $_11xp25ftjk26xjvp.openDialog(editor),
        stateSelector: 'a[href]',
        context: 'insert',
        prependToContext: true
      });
      editor.addMenuItem('unlink', {
        icon: 'unlink',
        text: 'Remove link',
        onclick: $_eh110jg0jk26xjwd.unlink(editor),
        stateSelector: 'a[href]'
      });
    };
    var setupContextToolbars = function setupContextToolbars(editor) {
      if (editor.addContextToolbar) {
        editor.addContextToolbar($_11xp25ftjk26xjvp.leftClickedOnAHref(editor), 'openlink | link unlink');
      }
    };
    var $_7u0w3dg6jk26xjwt = {
      setupButtons: setupButtons,
      setupMenuItems: setupMenuItems,
      setupContextToolbars: setupContextToolbars
    };

    global.add('link', function (editor) {
      $_7u0w3dg6jk26xjwt.setupButtons(editor);
      $_7u0w3dg6jk26xjwt.setupMenuItems(editor);
      $_7u0w3dg6jk26xjwt.setupContextToolbars(editor);
      $_11xp25ftjk26xjvp.setupGotoLinks(editor);
      $_lmabpfsjk26xjvo.register(editor);
      $_afp9b2g5jk26xjws.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 979 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/media/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "media" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/media')
//   ES2015:
//     import 'tinymce/plugins/media'
__webpack_require__(/*! ./plugin.js */ 980);

/***/ }),
/* 980 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/media/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var media = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getScripts = function getScripts(editor) {
      return editor.getParam('media_scripts');
    };
    var getAudioTemplateCallback = function getAudioTemplateCallback(editor) {
      return editor.getParam('audio_template_callback');
    };
    var getVideoTemplateCallback = function getVideoTemplateCallback(editor) {
      return editor.getParam('video_template_callback');
    };
    var hasLiveEmbeds = function hasLiveEmbeds(editor) {
      return editor.getParam('media_live_embeds', true);
    };
    var shouldFilterHtml = function shouldFilterHtml(editor) {
      return editor.getParam('media_filter_html', true);
    };
    var getUrlResolver = function getUrlResolver(editor) {
      return editor.getParam('media_url_resolver');
    };
    var hasAltSource = function hasAltSource(editor) {
      return editor.getParam('media_alt_source', true);
    };
    var hasPoster = function hasPoster(editor) {
      return editor.getParam('media_poster', true);
    };
    var hasDimensions = function hasDimensions(editor) {
      return editor.getParam('media_dimensions', true);
    };
    var $_9lilich3jk26xk2d = {
      getScripts: getScripts,
      getAudioTemplateCallback: getAudioTemplateCallback,
      getVideoTemplateCallback: getVideoTemplateCallback,
      hasLiveEmbeds: hasLiveEmbeds,
      shouldFilterHtml: shouldFilterHtml,
      getUrlResolver: getUrlResolver,
      hasAltSource: hasAltSource,
      hasPoster: hasPoster,
      hasDimensions: hasDimensions
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.html.SaxParser');

    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var getVideoScriptMatch = function getVideoScriptMatch(prefixes, src) {
      if (prefixes) {
        for (var i = 0; i < prefixes.length; i++) {
          if (src.indexOf(prefixes[i].filter) !== -1) {
            return prefixes[i];
          }
        }
      }
    };
    var $_8tv6muh7jk26xk2i = { getVideoScriptMatch: getVideoScriptMatch };

    var trimPx = function trimPx(value) {
      return value.replace(/px$/, '');
    };
    var addPx = function addPx(value) {
      return (/^[0-9.]+$/.test(value) ? value + 'px' : value
      );
    };
    var getSize = function getSize(name) {
      return function (elm) {
        return elm ? trimPx(elm.style[name]) : '';
      };
    };
    var setSize = function setSize(name) {
      return function (elm, value) {
        if (elm) {
          elm.style[name] = addPx(value);
        }
      };
    };
    var $_jt4ohh8jk26xk2j = {
      getMaxWidth: getSize('maxWidth'),
      getMaxHeight: getSize('maxHeight'),
      setMaxWidth: setSize('maxWidth'),
      setMaxHeight: setSize('maxHeight')
    };

    var DOM = global$4.DOM;
    var getEphoxEmbedIri = function getEphoxEmbedIri(elm) {
      return DOM.getAttrib(elm, 'data-ephox-embed-iri');
    };
    var isEphoxEmbed = function isEphoxEmbed(html) {
      var fragment = DOM.createFragment(html);
      return getEphoxEmbedIri(fragment.firstChild) !== '';
    };
    var htmlToDataSax = function htmlToDataSax(prefixes, html) {
      var data = {};
      global$3({
        validate: false,
        allow_conditional_comments: true,
        special: 'script,noscript',
        start: function start(name, attrs) {
          if (!data.source1 && name === 'param') {
            data.source1 = attrs.map.movie;
          }
          if (name === 'iframe' || name === 'object' || name === 'embed' || name === 'video' || name === 'audio') {
            if (!data.type) {
              data.type = name;
            }
            data = global$2.extend(attrs.map, data);
          }
          if (name === 'script') {
            var videoScript = $_8tv6muh7jk26xk2i.getVideoScriptMatch(prefixes, attrs.map.src);
            if (!videoScript) {
              return;
            }
            data = {
              type: 'script',
              source1: attrs.map.src,
              width: videoScript.width,
              height: videoScript.height
            };
          }
          if (name === 'source') {
            if (!data.source1) {
              data.source1 = attrs.map.src;
            } else if (!data.source2) {
              data.source2 = attrs.map.src;
            }
          }
          if (name === 'img' && !data.poster) {
            data.poster = attrs.map.src;
          }
        }
      }).parse(html);
      data.source1 = data.source1 || data.src || data.data;
      data.source2 = data.source2 || '';
      data.poster = data.poster || '';
      return data;
    };
    var ephoxEmbedHtmlToData = function ephoxEmbedHtmlToData(html) {
      var fragment = DOM.createFragment(html);
      var div = fragment.firstChild;
      return {
        type: 'ephox-embed-iri',
        source1: getEphoxEmbedIri(div),
        source2: '',
        poster: '',
        width: $_jt4ohh8jk26xk2j.getMaxWidth(div),
        height: $_jt4ohh8jk26xk2j.getMaxHeight(div)
      };
    };
    var htmlToData = function htmlToData(prefixes, html) {
      return isEphoxEmbed(html) ? ephoxEmbedHtmlToData(html) : htmlToDataSax(prefixes, html);
    };
    var $_aw2fzlh4jk26xk2e = { htmlToData: htmlToData };

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var guess = function guess(url) {
      var mimes = {
        mp3: 'audio/mpeg',
        wav: 'audio/wav',
        mp4: 'video/mp4',
        webm: 'video/webm',
        ogg: 'video/ogg',
        swf: 'application/x-shockwave-flash'
      };
      var fileEnd = url.toLowerCase().split('.').pop();
      var mime = mimes[fileEnd];
      return mime ? mime : '';
    };
    var $_da2j2hcjk26xk2v = { guess: guess };

    var global$6 = tinymce.util.Tools.resolve('tinymce.html.Writer');

    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Schema');

    var DOM$1 = global$4.DOM;
    var setAttributes = function setAttributes(attrs, updatedAttrs) {
      var name;
      var i;
      var value;
      var attr;
      for (name in updatedAttrs) {
        value = '' + updatedAttrs[name];
        if (attrs.map[name]) {
          i = attrs.length;
          while (i--) {
            attr = attrs[i];
            if (attr.name === name) {
              if (value) {
                attrs.map[name] = value;
                attr.value = value;
              } else {
                delete attrs.map[name];
                attrs.splice(i, 1);
              }
            }
          }
        } else if (value) {
          attrs.push({
            name: name,
            value: value
          });
          attrs.map[name] = value;
        }
      }
    };
    var normalizeHtml = function normalizeHtml(html) {
      var writer = global$6();
      var parser = global$3(writer);
      parser.parse(html);
      return writer.getContent();
    };
    var updateHtmlSax = function updateHtmlSax(html, data, updateAll) {
      var writer = global$6();
      var sourceCount = 0;
      var hasImage;
      global$3({
        validate: false,
        allow_conditional_comments: true,
        special: 'script,noscript',
        comment: function comment(text) {
          writer.comment(text);
        },
        cdata: function cdata(text) {
          writer.cdata(text);
        },
        text: function text(_text, raw) {
          writer.text(_text, raw);
        },
        start: function start(name, attrs, empty) {
          switch (name) {
            case 'video':
            case 'object':
            case 'embed':
            case 'img':
            case 'iframe':
              if (data.height !== undefined && data.width !== undefined) {
                setAttributes(attrs, {
                  width: data.width,
                  height: data.height
                });
              }
              break;
          }
          if (updateAll) {
            switch (name) {
              case 'video':
                setAttributes(attrs, {
                  poster: data.poster,
                  src: ''
                });
                if (data.source2) {
                  setAttributes(attrs, { src: '' });
                }
                break;
              case 'iframe':
                setAttributes(attrs, { src: data.source1 });
                break;
              case 'source':
                sourceCount++;
                if (sourceCount <= 2) {
                  setAttributes(attrs, {
                    src: data['source' + sourceCount],
                    type: data['source' + sourceCount + 'mime']
                  });
                  if (!data['source' + sourceCount]) {
                    return;
                  }
                }
                break;
              case 'img':
                if (!data.poster) {
                  return;
                }
                hasImage = true;
                break;
            }
          }
          writer.start(name, attrs, empty);
        },
        end: function end(name) {
          if (name === 'video' && updateAll) {
            for (var index = 1; index <= 2; index++) {
              if (data['source' + index]) {
                var attrs = [];
                attrs.map = {};
                if (sourceCount < index) {
                  setAttributes(attrs, {
                    src: data['source' + index],
                    type: data['source' + index + 'mime']
                  });
                  writer.start('source', attrs, true);
                }
              }
            }
          }
          if (data.poster && name === 'object' && updateAll && !hasImage) {
            var imgAttrs = [];
            imgAttrs.map = {};
            setAttributes(imgAttrs, {
              src: data.poster,
              width: data.width,
              height: data.height
            });
            writer.start('img', imgAttrs, true);
          }
          writer.end(name);
        }
      }, global$7({})).parse(html);
      return writer.getContent();
    };
    var isEphoxEmbed$1 = function isEphoxEmbed$1(html) {
      var fragment = DOM$1.createFragment(html);
      return DOM$1.getAttrib(fragment.firstChild, 'data-ephox-embed-iri') !== '';
    };
    var updateEphoxEmbed = function updateEphoxEmbed(html, data) {
      var fragment = DOM$1.createFragment(html);
      var div = fragment.firstChild;
      $_jt4ohh8jk26xk2j.setMaxWidth(div, data.width);
      $_jt4ohh8jk26xk2j.setMaxHeight(div, data.height);
      return normalizeHtml(div.outerHTML);
    };
    var updateHtml = function updateHtml(html, data, updateAll) {
      return isEphoxEmbed$1(html) ? updateEphoxEmbed(html, data) : updateHtmlSax(html, data, updateAll);
    };
    var $_dgt9r6hdjk26xk2x = { updateHtml: updateHtml };

    var urlPatterns = [{
      regex: /youtu\.be\/([\w\-_\?&=.]+)/i,
      type: 'iframe',
      w: 560,
      h: 314,
      url: '//www.youtube.com/embed/$1',
      allowFullscreen: true
    }, {
      regex: /youtube\.com(.+)v=([^&]+)(&([a-z0-9&=\-_]+))?/i,
      type: 'iframe',
      w: 560,
      h: 314,
      url: '//www.youtube.com/embed/$2?$4',
      allowFullscreen: true
    }, {
      regex: /youtube.com\/embed\/([a-z0-9\?&=\-_]+)/i,
      type: 'iframe',
      w: 560,
      h: 314,
      url: '//www.youtube.com/embed/$1',
      allowFullscreen: true
    }, {
      regex: /vimeo\.com\/([0-9]+)/,
      type: 'iframe',
      w: 425,
      h: 350,
      url: '//player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc',
      allowFullscreen: true
    }, {
      regex: /vimeo\.com\/(.*)\/([0-9]+)/,
      type: 'iframe',
      w: 425,
      h: 350,
      url: '//player.vimeo.com/video/$2?title=0&amp;byline=0',
      allowFullscreen: true
    }, {
      regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/,
      type: 'iframe',
      w: 425,
      h: 350,
      url: '//maps.google.com/maps/ms?msid=$2&output=embed"',
      allowFullscreen: false
    }, {
      regex: /dailymotion\.com\/video\/([^_]+)/,
      type: 'iframe',
      w: 480,
      h: 270,
      url: '//www.dailymotion.com/embed/video/$1',
      allowFullscreen: true
    }, {
      regex: /dai\.ly\/([^_]+)/,
      type: 'iframe',
      w: 480,
      h: 270,
      url: '//www.dailymotion.com/embed/video/$1',
      allowFullscreen: true
    }];
    var getUrl = function getUrl(pattern, url) {
      var match = pattern.regex.exec(url);
      var newUrl = pattern.url;
      var _loop_1 = function _loop_1(i) {
        newUrl = newUrl.replace('$' + i, function () {
          return match[i] ? match[i] : '';
        });
      };
      for (var i = 0; i < match.length; i++) {
        _loop_1(i);
      }
      return newUrl.replace(/\?$/, '');
    };
    var matchPattern = function matchPattern(url) {
      var pattern = urlPatterns.filter(function (pattern) {
        return pattern.regex.test(url);
      });
      if (pattern.length > 0) {
        return global$2.extend({}, pattern[0], { url: getUrl(pattern[0], url) });
      } else {
        return null;
      }
    };

    var getIframeHtml = function getIframeHtml(data) {
      var allowFullscreen = data.allowFullscreen ? ' allowFullscreen="1"' : '';
      return '<iframe src="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
    };
    var getFlashHtml = function getFlashHtml(data) {
      var html = '<object data="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
      if (data.poster) {
        html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
      }
      html += '</object>';
      return html;
    };
    var getAudioHtml = function getAudioHtml(data, audioTemplateCallback) {
      if (audioTemplateCallback) {
        return audioTemplateCallback(data);
      } else {
        return '<audio controls="controls" src="' + data.source1 + '">' + (data.source2 ? '\n<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</audio>';
      }
    };
    var getVideoHtml = function getVideoHtml(data, videoTemplateCallback) {
      if (videoTemplateCallback) {
        return videoTemplateCallback(data);
      } else {
        return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
      }
    };
    var getScriptHtml = function getScriptHtml(data) {
      return '<script src="' + data.source1 + '"></script>';
    };
    var dataToHtml = function dataToHtml(editor, dataIn) {
      var data = global$2.extend({}, dataIn);
      if (!data.source1) {
        global$2.extend(data, $_aw2fzlh4jk26xk2e.htmlToData($_9lilich3jk26xk2d.getScripts(editor), data.embed));
        if (!data.source1) {
          return '';
        }
      }
      if (!data.source2) {
        data.source2 = '';
      }
      if (!data.poster) {
        data.poster = '';
      }
      data.source1 = editor.convertURL(data.source1, 'source');
      data.source2 = editor.convertURL(data.source2, 'source');
      data.source1mime = $_da2j2hcjk26xk2v.guess(data.source1);
      data.source2mime = $_da2j2hcjk26xk2v.guess(data.source2);
      data.poster = editor.convertURL(data.poster, 'poster');
      var pattern = matchPattern(data.source1);
      if (pattern) {
        data.source1 = pattern.url;
        data.type = pattern.type;
        data.allowFullscreen = pattern.allowFullscreen;
        data.width = data.width || pattern.w;
        data.height = data.height || pattern.h;
      }
      if (data.embed) {
        return $_dgt9r6hdjk26xk2x.updateHtml(data.embed, data, true);
      } else {
        var videoScript = $_8tv6muh7jk26xk2i.getVideoScriptMatch($_9lilich3jk26xk2d.getScripts(editor), data.source1);
        if (videoScript) {
          data.type = 'script';
          data.width = videoScript.width;
          data.height = videoScript.height;
        }
        var audioTemplateCallback = $_9lilich3jk26xk2d.getAudioTemplateCallback(editor);
        var videoTemplateCallback = $_9lilich3jk26xk2d.getVideoTemplateCallback(editor);
        data.width = data.width || 300;
        data.height = data.height || 150;
        global$2.each(data, function (value, key) {
          data[key] = editor.dom.encode(value);
        });
        if (data.type === 'iframe') {
          return getIframeHtml(data);
        } else if (data.source1mime === 'application/x-shockwave-flash') {
          return getFlashHtml(data);
        } else if (data.source1mime.indexOf('audio') !== -1) {
          return getAudioHtml(data, audioTemplateCallback);
        } else if (data.type === 'script') {
          return getScriptHtml(data);
        } else {
          return getVideoHtml(data, videoTemplateCallback);
        }
      }
    };
    var $_f7q54phbjk26xk2s = { dataToHtml: dataToHtml };

    var cache = {};
    var embedPromise = function embedPromise(data, dataToHtml, handler) {
      return new global$5(function (res, rej) {
        var wrappedResolve = function wrappedResolve(response) {
          if (response.html) {
            cache[data.source1] = response;
          }
          return res({
            url: data.source1,
            html: response.html ? response.html : dataToHtml(data)
          });
        };
        if (cache[data.source1]) {
          wrappedResolve(cache[data.source1]);
        } else {
          handler({ url: data.source1 }, wrappedResolve, rej);
        }
      });
    };
    var defaultPromise = function defaultPromise(data, dataToHtml) {
      return new global$5(function (res) {
        res({
          html: dataToHtml(data),
          url: data.source1
        });
      });
    };
    var loadedData = function loadedData(editor) {
      return function (data) {
        return $_f7q54phbjk26xk2s.dataToHtml(editor, data);
      };
    };
    var getEmbedHtml = function getEmbedHtml(editor, data) {
      var embedHandler = $_9lilich3jk26xk2d.getUrlResolver(editor);
      return embedHandler ? embedPromise(data, loadedData(editor), embedHandler) : defaultPromise(data, loadedData(editor));
    };
    var isCached = function isCached(url) {
      return cache.hasOwnProperty(url);
    };
    var $_b38xiwh9jk26xk2k = {
      getEmbedHtml: getEmbedHtml,
      isCached: isCached
    };

    var doSyncSize = function doSyncSize(widthCtrl, heightCtrl) {
      widthCtrl.state.set('oldVal', widthCtrl.value());
      heightCtrl.state.set('oldVal', heightCtrl.value());
    };
    var doSizeControls = function doSizeControls(win, f) {
      var widthCtrl = win.find('#width')[0];
      var heightCtrl = win.find('#height')[0];
      var constrained = win.find('#constrain')[0];
      if (widthCtrl && heightCtrl && constrained) {
        f(widthCtrl, heightCtrl, constrained.checked());
      }
    };
    var doUpdateSize = function doUpdateSize(widthCtrl, heightCtrl, isContrained) {
      var oldWidth = widthCtrl.state.get('oldVal');
      var oldHeight = heightCtrl.state.get('oldVal');
      var newWidth = widthCtrl.value();
      var newHeight = heightCtrl.value();
      if (isContrained && oldWidth && oldHeight && newWidth && newHeight) {
        if (newWidth !== oldWidth) {
          newHeight = Math.round(newWidth / oldWidth * newHeight);
          if (!isNaN(newHeight)) {
            heightCtrl.value(newHeight);
          }
        } else {
          newWidth = Math.round(newHeight / oldHeight * newWidth);
          if (!isNaN(newWidth)) {
            widthCtrl.value(newWidth);
          }
        }
      }
      doSyncSize(widthCtrl, heightCtrl);
    };
    var syncSize = function syncSize(win) {
      doSizeControls(win, doSyncSize);
    };
    var updateSize = function updateSize(win) {
      doSizeControls(win, doUpdateSize);
    };
    var createUi = function createUi(onChange) {
      var recalcSize = function recalcSize() {
        onChange(function (win) {
          updateSize(win);
        });
      };
      return {
        type: 'container',
        label: 'Dimensions',
        layout: 'flex',
        align: 'center',
        spacing: 5,
        items: [{
          name: 'width',
          type: 'textbox',
          maxLength: 5,
          size: 5,
          onchange: recalcSize,
          ariaLabel: 'Width'
        }, {
          type: 'label',
          text: 'x'
        }, {
          name: 'height',
          type: 'textbox',
          maxLength: 5,
          size: 5,
          onchange: recalcSize,
          ariaLabel: 'Height'
        }, {
          name: 'constrain',
          type: 'checkbox',
          checked: true,
          text: 'Constrain proportions'
        }]
      };
    };
    var $_gboytjhhjk26xk37 = {
      createUi: createUi,
      syncSize: syncSize,
      updateSize: updateSize
    };

    var embedChange = global$1.ie && global$1.ie <= 8 ? 'onChange' : 'onInput';
    var handleError = function handleError(editor) {
      return function (error) {
        var errorMessage = error && error.msg ? 'Media embed handler error: ' + error.msg : 'Media embed handler threw unknown error.';
        editor.notificationManager.open({
          type: 'error',
          text: errorMessage
        });
      };
    };
    var getData = function getData(editor) {
      var element = editor.selection.getNode();
      var dataEmbed = element.getAttribute('data-ephox-embed-iri');
      if (dataEmbed) {
        return {
          'source1': dataEmbed,
          'data-ephox-embed-iri': dataEmbed,
          'width': $_jt4ohh8jk26xk2j.getMaxWidth(element),
          'height': $_jt4ohh8jk26xk2j.getMaxHeight(element)
        };
      }
      return element.getAttribute('data-mce-object') ? $_aw2fzlh4jk26xk2e.htmlToData($_9lilich3jk26xk2d.getScripts(editor), editor.serializer.serialize(element, { selection: true })) : {};
    };
    var getSource = function getSource(editor) {
      var elm = editor.selection.getNode();
      if (elm.getAttribute('data-mce-object') || elm.getAttribute('data-ephox-embed-iri')) {
        return editor.selection.getContent();
      }
    };
    var addEmbedHtml = function addEmbedHtml(win, editor) {
      return function (response) {
        var html = response.html;
        var embed = win.find('#embed')[0];
        var data = global$2.extend($_aw2fzlh4jk26xk2e.htmlToData($_9lilich3jk26xk2d.getScripts(editor), html), { source1: response.url });
        win.fromJSON(data);
        if (embed) {
          embed.value(html);
          $_gboytjhhjk26xk37.updateSize(win);
        }
      };
    };
    var selectPlaceholder = function selectPlaceholder(editor, beforeObjects) {
      var i;
      var y;
      var afterObjects = editor.dom.select('img[data-mce-object]');
      for (i = 0; i < beforeObjects.length; i++) {
        for (y = afterObjects.length - 1; y >= 0; y--) {
          if (beforeObjects[i] === afterObjects[y]) {
            afterObjects.splice(y, 1);
          }
        }
      }
      editor.selection.select(afterObjects[0]);
    };
    var handleInsert = function handleInsert(editor, html) {
      var beforeObjects = editor.dom.select('img[data-mce-object]');
      editor.insertContent(html);
      selectPlaceholder(editor, beforeObjects);
      editor.nodeChanged();
    };
    var submitForm = function submitForm(win, editor) {
      var data = win.toJSON();
      data.embed = $_dgt9r6hdjk26xk2x.updateHtml(data.embed, data);
      if (data.embed && $_b38xiwh9jk26xk2k.isCached(data.source1)) {
        handleInsert(editor, data.embed);
      } else {
        $_b38xiwh9jk26xk2k.getEmbedHtml(editor, data).then(function (response) {
          handleInsert(editor, response.html);
        }).catch(handleError(editor));
      }
    };
    var populateMeta = function populateMeta(win, meta) {
      global$2.each(meta, function (value, key) {
        win.find('#' + key).value(value);
      });
    };
    var showDialog = function showDialog(editor) {
      var win;
      var data;
      var generalFormItems = [{
        name: 'source1',
        type: 'filepicker',
        filetype: 'media',
        size: 40,
        autofocus: true,
        label: 'Source',
        onpaste: function onpaste() {
          setTimeout(function () {
            $_b38xiwh9jk26xk2k.getEmbedHtml(editor, win.toJSON()).then(addEmbedHtml(win, editor)).catch(handleError(editor));
          }, 1);
        },
        onchange: function onchange(e) {
          $_b38xiwh9jk26xk2k.getEmbedHtml(editor, win.toJSON()).then(addEmbedHtml(win, editor)).catch(handleError(editor));
          populateMeta(win, e.meta);
        },
        onbeforecall: function onbeforecall(e) {
          e.meta = win.toJSON();
        }
      }];
      var advancedFormItems = [];
      var reserialise = function reserialise(update) {
        update(win);
        data = win.toJSON();
        win.find('#embed').value($_dgt9r6hdjk26xk2x.updateHtml(data.embed, data));
      };
      if ($_9lilich3jk26xk2d.hasAltSource(editor)) {
        advancedFormItems.push({
          name: 'source2',
          type: 'filepicker',
          filetype: 'media',
          size: 40,
          label: 'Alternative source'
        });
      }
      if ($_9lilich3jk26xk2d.hasPoster(editor)) {
        advancedFormItems.push({
          name: 'poster',
          type: 'filepicker',
          filetype: 'image',
          size: 40,
          label: 'Poster'
        });
      }
      if ($_9lilich3jk26xk2d.hasDimensions(editor)) {
        var control = $_gboytjhhjk26xk37.createUi(reserialise);
        generalFormItems.push(control);
      }
      data = getData(editor);
      var embedTextBox = {
        id: 'mcemediasource',
        type: 'textbox',
        flex: 1,
        name: 'embed',
        value: getSource(editor),
        multiline: true,
        rows: 5,
        label: 'Source'
      };
      var updateValueOnChange = function updateValueOnChange() {
        data = global$2.extend({}, $_aw2fzlh4jk26xk2e.htmlToData($_9lilich3jk26xk2d.getScripts(editor), this.value()));
        this.parent().parent().fromJSON(data);
      };
      embedTextBox[embedChange] = updateValueOnChange;
      var body = [{
        title: 'General',
        type: 'form',
        items: generalFormItems
      }, {
        title: 'Embed',
        type: 'container',
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        padding: 10,
        spacing: 10,
        items: [{
          type: 'label',
          text: 'Paste your embed code below:',
          forId: 'mcemediasource'
        }, embedTextBox]
      }];
      if (advancedFormItems.length > 0) {
        body.push({
          title: 'Advanced',
          type: 'form',
          items: advancedFormItems
        });
      }
      win = editor.windowManager.open({
        title: 'Insert/edit media',
        data: data,
        bodyType: 'tabpanel',
        body: body,
        onSubmit: function onSubmit() {
          $_gboytjhhjk26xk37.updateSize(win);
          submitForm(win, editor);
        }
      });
      $_gboytjhhjk26xk37.syncSize(win);
    };
    var $_4xtfe8h0jk26xk27 = { showDialog: showDialog };

    var get = function get(editor) {
      var showDialog = function showDialog() {
        $_4xtfe8h0jk26xk27.showDialog(editor);
      };
      return { showDialog: showDialog };
    };
    var $_4cpme2gzjk26xk25 = { get: get };

    var register = function register(editor) {
      var showDialog = function showDialog() {
        $_4xtfe8h0jk26xk27.showDialog(editor);
      };
      editor.addCommand('mceMedia', showDialog);
    };
    var $_ftmpjfhijk26xk39 = { register: register };

    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Node');

    var sanitize = function sanitize(editor, html) {
      if ($_9lilich3jk26xk2d.shouldFilterHtml(editor) === false) {
        return html;
      }
      var writer = global$6();
      var blocked;
      global$3({
        validate: false,
        allow_conditional_comments: false,
        special: 'script,noscript',
        comment: function comment(text) {
          writer.comment(text);
        },
        cdata: function cdata(text) {
          writer.cdata(text);
        },
        text: function text(_text2, raw) {
          writer.text(_text2, raw);
        },
        start: function start(name, attrs, empty) {
          blocked = true;
          if (name === 'script' || name === 'noscript') {
            return;
          }
          for (var i = 0; i < attrs.length; i++) {
            if (attrs[i].name.indexOf('on') === 0) {
              return;
            }
            if (attrs[i].name === 'style') {
              attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
            }
          }
          writer.start(name, attrs, empty);
          blocked = false;
        },
        end: function end(name) {
          if (blocked) {
            return;
          }
          writer.end(name);
        }
      }, global$7({})).parse(html);
      return writer.getContent();
    };
    var $_e2brhmjk26xk3i = { sanitize: sanitize };

    var createPlaceholderNode = function createPlaceholderNode(editor, node) {
      var placeHolder;
      var name = node.name;
      placeHolder = new global$8('img', 1);
      placeHolder.shortEnded = true;
      retainAttributesAndInnerHtml(editor, node, placeHolder);
      placeHolder.attr({
        'width': node.attr('width') || '300',
        'height': node.attr('height') || (name === 'audio' ? '30' : '150'),
        'style': node.attr('style'),
        'src': global$1.transparentSrc,
        'data-mce-object': name,
        'class': 'mce-object mce-object-' + name
      });
      return placeHolder;
    };
    var createPreviewIframeNode = function createPreviewIframeNode(editor, node) {
      var previewWrapper;
      var previewNode;
      var shimNode;
      var name = node.name;
      previewWrapper = new global$8('span', 1);
      previewWrapper.attr({
        'contentEditable': 'false',
        'style': node.attr('style'),
        'data-mce-object': name,
        'class': 'mce-preview-object mce-object-' + name
      });
      retainAttributesAndInnerHtml(editor, node, previewWrapper);
      previewNode = new global$8(name, 1);
      previewNode.attr({
        src: node.attr('src'),
        allowfullscreen: node.attr('allowfullscreen'),
        style: node.attr('style'),
        class: node.attr('class'),
        width: node.attr('width'),
        height: node.attr('height'),
        frameborder: '0'
      });
      shimNode = new global$8('span', 1);
      shimNode.attr('class', 'mce-shim');
      previewWrapper.append(previewNode);
      previewWrapper.append(shimNode);
      return previewWrapper;
    };
    var retainAttributesAndInnerHtml = function retainAttributesAndInnerHtml(editor, sourceNode, targetNode) {
      var attrName;
      var attrValue;
      var attribs;
      var ai;
      var innerHtml;
      attribs = sourceNode.attributes;
      ai = attribs.length;
      while (ai--) {
        attrName = attribs[ai].name;
        attrValue = attribs[ai].value;
        if (attrName !== 'width' && attrName !== 'height' && attrName !== 'style') {
          if (attrName === 'data' || attrName === 'src') {
            attrValue = editor.convertURL(attrValue, attrName);
          }
          targetNode.attr('data-mce-p-' + attrName, attrValue);
        }
      }
      innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
      if (innerHtml) {
        targetNode.attr('data-mce-html', escape($_e2brhmjk26xk3i.sanitize(editor, innerHtml)));
        targetNode.firstChild = null;
      }
    };
    var isWithinEphoxEmbed = function isWithinEphoxEmbed(node) {
      while (node = node.parent) {
        if (node.attr('data-ephox-embed-iri')) {
          return true;
        }
      }
      return false;
    };
    var placeHolderConverter = function placeHolderConverter(editor) {
      return function (nodes) {
        var i = nodes.length;
        var node;
        var videoScript;
        while (i--) {
          node = nodes[i];
          if (!node.parent) {
            continue;
          }
          if (node.parent.attr('data-mce-object')) {
            continue;
          }
          if (node.name === 'script') {
            videoScript = $_8tv6muh7jk26xk2i.getVideoScriptMatch($_9lilich3jk26xk2d.getScripts(editor), node.attr('src'));
            if (!videoScript) {
              continue;
            }
          }
          if (videoScript) {
            if (videoScript.width) {
              node.attr('width', videoScript.width.toString());
            }
            if (videoScript.height) {
              node.attr('height', videoScript.height.toString());
            }
          }
          if (node.name === 'iframe' && $_9lilich3jk26xk2d.hasLiveEmbeds(editor) && global$1.ceFalse) {
            if (!isWithinEphoxEmbed(node)) {
              node.replace(createPreviewIframeNode(editor, node));
            }
          } else {
            if (!isWithinEphoxEmbed(node)) {
              node.replace(createPlaceholderNode(editor, node));
            }
          }
        }
      };
    };
    var $_5d1lgthljk26xk3e = {
      createPreviewIframeNode: createPreviewIframeNode,
      createPlaceholderNode: createPlaceholderNode,
      placeHolderConverter: placeHolderConverter
    };

    var setup = function setup(editor) {
      editor.on('preInit', function () {
        var specialElements = editor.schema.getSpecialElements();
        global$2.each('video audio iframe object'.split(' '), function (name) {
          specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
        });
        var boolAttrs = editor.schema.getBoolAttrs();
        global$2.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
          boolAttrs[name] = {};
        });
        editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', $_5d1lgthljk26xk3e.placeHolderConverter(editor));
        editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
          var i = nodes.length;
          var node;
          var realElm;
          var ai;
          var attribs;
          var innerHtml;
          var innerNode;
          var realElmName;
          var className;
          while (i--) {
            node = nodes[i];
            if (!node.parent) {
              continue;
            }
            realElmName = node.attr(name);
            realElm = new global$8(realElmName, 1);
            if (realElmName !== 'audio' && realElmName !== 'script') {
              className = node.attr('class');
              if (className && className.indexOf('mce-preview-object') !== -1) {
                realElm.attr({
                  width: node.firstChild.attr('width'),
                  height: node.firstChild.attr('height')
                });
              } else {
                realElm.attr({
                  width: node.attr('width'),
                  height: node.attr('height')
                });
              }
            }
            realElm.attr({ style: node.attr('style') });
            attribs = node.attributes;
            ai = attribs.length;
            while (ai--) {
              var attrName = attribs[ai].name;
              if (attrName.indexOf('data-mce-p-') === 0) {
                realElm.attr(attrName.substr(11), attribs[ai].value);
              }
            }
            if (realElmName === 'script') {
              realElm.attr('type', 'text/javascript');
            }
            innerHtml = node.attr('data-mce-html');
            if (innerHtml) {
              innerNode = new global$8('#text', 3);
              innerNode.raw = true;
              innerNode.value = $_e2brhmjk26xk3i.sanitize(editor, unescape(innerHtml));
              realElm.append(innerNode);
            }
            node.replace(realElm);
          }
        });
      });
      editor.on('setContent', function () {
        editor.$('span.mce-preview-object').each(function (index, elm) {
          var $elm = editor.$(elm);
          if ($elm.find('span.mce-shim', elm).length === 0) {
            $elm.append('<span class="mce-shim"></span>');
          }
        });
      });
    };
    var $_fbynhrhjjk26xk3b = { setup: setup };

    var setup$1 = function setup$1(editor) {
      editor.on('ResolveName', function (e) {
        var name;
        if (e.target.nodeType === 1 && (name = e.target.getAttribute('data-mce-object'))) {
          e.name = name;
        }
      });
    };
    var $_f3j7rbhnjk26xk3k = { setup: setup$1 };

    var setup$2 = function setup$2(editor) {
      editor.on('click keyup', function () {
        var selectedNode = editor.selection.getNode();
        if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
          if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
            selectedNode.setAttribute('data-mce-selected', '2');
          }
        }
      });
      editor.on('ObjectSelected', function (e) {
        var objectType = e.target.getAttribute('data-mce-object');
        if (objectType === 'audio' || objectType === 'script') {
          e.preventDefault();
        }
      });
      editor.on('objectResized', function (e) {
        var target = e.target;
        var html;
        if (target.getAttribute('data-mce-object')) {
          html = target.getAttribute('data-mce-html');
          if (html) {
            html = unescape(html);
            target.setAttribute('data-mce-html', escape($_dgt9r6hdjk26xk2x.updateHtml(html, {
              width: e.width,
              height: e.height
            })));
          }
        }
      });
    };
    var $_82d563hojk26xk3l = { setup: setup$2 };

    var register$1 = function register$1(editor) {
      editor.addButton('media', {
        tooltip: 'Insert/edit media',
        cmd: 'mceMedia',
        stateSelector: ['img[data-mce-object]', 'span[data-mce-object]', 'div[data-ephox-embed-iri]']
      });
      editor.addMenuItem('media', {
        icon: 'media',
        text: 'Media',
        cmd: 'mceMedia',
        context: 'insert',
        prependToContext: true
      });
    };
    var $_ahov5yhpjk26xk3n = { register: register$1 };

    global.add('media', function (editor) {
      $_ftmpjfhijk26xk39.register(editor);
      $_ahov5yhpjk26xk3n.register(editor);
      $_f3j7rbhnjk26xk3k.setup(editor);
      $_fbynhrhjjk26xk3b.setup(editor);
      $_82d563hojk26xk3l.setup(editor);
      return $_4cpme2gzjk26xk25.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 981 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/noneditable/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "noneditable" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/noneditable')
//   ES2015:
//     import 'tinymce/plugins/noneditable'
__webpack_require__(/*! ./plugin.js */ 982);

/***/ }),
/* 982 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/noneditable/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var noneditable = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getNonEditableClass = function getNonEditableClass(editor) {
      return editor.getParam('noneditable_noneditable_class', 'mceNonEditable');
    };
    var getEditableClass = function getEditableClass(editor) {
      return editor.getParam('noneditable_editable_class', 'mceEditable');
    };
    var getNonEditableRegExps = function getNonEditableRegExps(editor) {
      var nonEditableRegExps = editor.getParam('noneditable_regexp', []);
      if (nonEditableRegExps && nonEditableRegExps.constructor === RegExp) {
        return [nonEditableRegExps];
      } else {
        return nonEditableRegExps;
      }
    };
    var $_134debi2jk26xk6k = {
      getNonEditableClass: getNonEditableClass,
      getEditableClass: getEditableClass,
      getNonEditableRegExps: getNonEditableRegExps
    };

    var hasClass = function hasClass(checkClassName) {
      return function (node) {
        return (' ' + node.attr('class') + ' ').indexOf(checkClassName) !== -1;
      };
    };
    var replaceMatchWithSpan = function replaceMatchWithSpan(editor, content, cls) {
      return function (match) {
        var args = arguments,
            index = args[args.length - 2];
        var prevChar = index > 0 ? content.charAt(index - 1) : '';
        if (prevChar === '"') {
          return match;
        }
        if (prevChar === '>') {
          var findStartTagIndex = content.lastIndexOf('<', index);
          if (findStartTagIndex !== -1) {
            var tagHtml = content.substring(findStartTagIndex, index);
            if (tagHtml.indexOf('contenteditable="false"') !== -1) {
              return match;
            }
          }
        }
        return '<span class="' + cls + '" data-mce-content="' + editor.dom.encode(args[0]) + '">' + editor.dom.encode(typeof args[1] === 'string' ? args[1] : args[0]) + '</span>';
      };
    };
    var convertRegExpsToNonEditable = function convertRegExpsToNonEditable(editor, nonEditableRegExps, e) {
      var i = nonEditableRegExps.length,
          content = e.content;
      if (e.format === 'raw') {
        return;
      }
      while (i--) {
        content = content.replace(nonEditableRegExps[i], replaceMatchWithSpan(editor, content, $_134debi2jk26xk6k.getNonEditableClass(editor)));
      }
      e.content = content;
    };
    var setup = function setup(editor) {
      var editClass, nonEditClass;
      var contentEditableAttrName = 'contenteditable';
      editClass = ' ' + global$1.trim($_134debi2jk26xk6k.getEditableClass(editor)) + ' ';
      nonEditClass = ' ' + global$1.trim($_134debi2jk26xk6k.getNonEditableClass(editor)) + ' ';
      var hasEditClass = hasClass(editClass);
      var hasNonEditClass = hasClass(nonEditClass);
      var nonEditableRegExps = $_134debi2jk26xk6k.getNonEditableRegExps(editor);
      editor.on('PreInit', function () {
        if (nonEditableRegExps.length > 0) {
          editor.on('BeforeSetContent', function (e) {
            convertRegExpsToNonEditable(editor, nonEditableRegExps, e);
          });
        }
        editor.parser.addAttributeFilter('class', function (nodes) {
          var i = nodes.length,
              node;
          while (i--) {
            node = nodes[i];
            if (hasEditClass(node)) {
              node.attr(contentEditableAttrName, 'true');
            } else if (hasNonEditClass(node)) {
              node.attr(contentEditableAttrName, 'false');
            }
          }
        });
        editor.serializer.addAttributeFilter(contentEditableAttrName, function (nodes) {
          var i = nodes.length,
              node;
          while (i--) {
            node = nodes[i];
            if (!hasEditClass(node) && !hasNonEditClass(node)) {
              continue;
            }
            if (nonEditableRegExps.length > 0 && node.attr('data-mce-content')) {
              node.name = '#text';
              node.type = 3;
              node.raw = true;
              node.value = node.attr('data-mce-content');
            } else {
              node.attr(contentEditableAttrName, null);
            }
          }
        });
      });
    };
    var $_3cuz4ci0jk26xk6g = { setup: setup };

    global.add('noneditable', function (editor) {
      $_3cuz4ci0jk26xk6g.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 983 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/paste/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "paste" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/paste')
//   ES2015:
//     import 'tinymce/plugins/paste'
__webpack_require__(/*! ./plugin.js */ 984);

/***/ }),
/* 984 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/paste/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var paste = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var hasProPlugin = function hasProPlugin(editor) {
      if (/(^|[ ,])powerpaste([, ]|$)/.test(editor.settings.plugins) && global.get('powerpaste')) {
        if (typeof window.console !== 'undefined' && window.console.log) {
          window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
        }
        return true;
      } else {
        return false;
      }
    };
    var $_cp3dn7iejk26xk7n = { hasProPlugin: hasProPlugin };

    var get = function get(clipboard, quirks) {
      return {
        clipboard: clipboard,
        quirks: quirks
      };
    };
    var $_aqz0cligjk26xk80 = { get: get };

    var firePastePreProcess = function firePastePreProcess(editor, html, internal, isWordHtml) {
      return editor.fire('PastePreProcess', {
        content: html,
        internal: internal,
        wordContent: isWordHtml
      });
    };
    var firePastePostProcess = function firePastePostProcess(editor, node, internal, isWordHtml) {
      return editor.fire('PastePostProcess', {
        node: node,
        internal: internal,
        wordContent: isWordHtml
      });
    };
    var firePastePlainTextToggle = function firePastePlainTextToggle(editor, state) {
      return editor.fire('PastePlainTextToggle', { state: state });
    };
    var firePaste = function firePaste(editor, ieFake) {
      return editor.fire('paste', { ieFake: ieFake });
    };
    var $_3ukak2ijjk26xk85 = {
      firePastePreProcess: firePastePreProcess,
      firePastePostProcess: firePastePostProcess,
      firePastePlainTextToggle: firePastePlainTextToggle,
      firePaste: firePaste
    };

    var shouldPlainTextInform = function shouldPlainTextInform(editor) {
      return editor.getParam('paste_plaintext_inform', true);
    };
    var shouldBlockDrop = function shouldBlockDrop(editor) {
      return editor.getParam('paste_block_drop', false);
    };
    var shouldPasteDataImages = function shouldPasteDataImages(editor) {
      return editor.getParam('paste_data_images', false);
    };
    var shouldFilterDrop = function shouldFilterDrop(editor) {
      return editor.getParam('paste_filter_drop', true);
    };
    var getPreProcess = function getPreProcess(editor) {
      return editor.getParam('paste_preprocess');
    };
    var getPostProcess = function getPostProcess(editor) {
      return editor.getParam('paste_postprocess');
    };
    var getWebkitStyles = function getWebkitStyles(editor) {
      return editor.getParam('paste_webkit_styles');
    };
    var shouldRemoveWebKitStyles = function shouldRemoveWebKitStyles(editor) {
      return editor.getParam('paste_remove_styles_if_webkit', true);
    };
    var shouldMergeFormats = function shouldMergeFormats(editor) {
      return editor.getParam('paste_merge_formats', true);
    };
    var isSmartPasteEnabled = function isSmartPasteEnabled(editor) {
      return editor.getParam('smart_paste', true);
    };
    var isPasteAsTextEnabled = function isPasteAsTextEnabled(editor) {
      return editor.getParam('paste_as_text', false);
    };
    var getRetainStyleProps = function getRetainStyleProps(editor) {
      return editor.getParam('paste_retain_style_properties');
    };
    var getWordValidElements = function getWordValidElements(editor) {
      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
      return editor.getParam('paste_word_valid_elements', defaultValidElements);
    };
    var shouldConvertWordFakeLists = function shouldConvertWordFakeLists(editor) {
      return editor.getParam('paste_convert_word_fake_lists', true);
    };
    var shouldUseDefaultFilters = function shouldUseDefaultFilters(editor) {
      return editor.getParam('paste_enable_default_filters', true);
    };
    var $_7zjrh5ikjk26xk87 = {
      shouldPlainTextInform: shouldPlainTextInform,
      shouldBlockDrop: shouldBlockDrop,
      shouldPasteDataImages: shouldPasteDataImages,
      shouldFilterDrop: shouldFilterDrop,
      getPreProcess: getPreProcess,
      getPostProcess: getPostProcess,
      getWebkitStyles: getWebkitStyles,
      shouldRemoveWebKitStyles: shouldRemoveWebKitStyles,
      shouldMergeFormats: shouldMergeFormats,
      isSmartPasteEnabled: isSmartPasteEnabled,
      isPasteAsTextEnabled: isPasteAsTextEnabled,
      getRetainStyleProps: getRetainStyleProps,
      getWordValidElements: getWordValidElements,
      shouldConvertWordFakeLists: shouldConvertWordFakeLists,
      shouldUseDefaultFilters: shouldUseDefaultFilters
    };

    var shouldInformUserAboutPlainText = function shouldInformUserAboutPlainText(editor, userIsInformedState) {
      return userIsInformedState.get() === false && $_7zjrh5ikjk26xk87.shouldPlainTextInform(editor);
    };
    var displayNotification = function displayNotification(editor, message) {
      editor.notificationManager.open({
        text: editor.translate(message),
        type: 'info'
      });
    };
    var togglePlainTextPaste = function togglePlainTextPaste(editor, clipboard, userIsInformedState) {
      if (clipboard.pasteFormat.get() === 'text') {
        clipboard.pasteFormat.set('html');
        $_3ukak2ijjk26xk85.firePastePlainTextToggle(editor, false);
      } else {
        clipboard.pasteFormat.set('text');
        $_3ukak2ijjk26xk85.firePastePlainTextToggle(editor, true);
        if (shouldInformUserAboutPlainText(editor, userIsInformedState)) {
          displayNotification(editor, 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.');
          userIsInformedState.set(true);
        }
      }
      editor.focus();
    };
    var $_q1zeoiijk26xk84 = { togglePlainTextPaste: togglePlainTextPaste };

    var register = function register(editor, clipboard, userIsInformedState) {
      editor.addCommand('mceTogglePlainTextPaste', function () {
        $_q1zeoiijk26xk84.togglePlainTextPaste(editor, clipboard, userIsInformedState);
      });
      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
        if (value.content) {
          clipboard.pasteHtml(value.content, value.internal);
        }
        if (value.text) {
          clipboard.pasteText(value.text);
        }
      });
    };
    var $_15lprrihjk26xk82 = { register: register };

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var internalMimeType = 'x-tinymce/html';
    var internalMark = '<!-- ' + internalMimeType + ' -->';
    var mark = function mark(html) {
      return internalMark + html;
    };
    var unmark = function unmark(html) {
      return html.replace(internalMark, '');
    };
    var isMarked = function isMarked(html) {
      return html.indexOf(internalMark) !== -1;
    };
    var $_4anf80irjk26xk8m = {
      mark: mark,
      unmark: unmark,
      isMarked: isMarked,
      internalHtmlMime: function internalHtmlMime() {
        return internalMimeType;
      }
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.html.Entities');

    var isPlainText = function isPlainText(text) {
      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
    };
    var toBRs = function toBRs(text) {
      return text.replace(/\r?\n/g, '<br>');
    };
    var openContainer = function openContainer(rootTag, rootAttrs) {
      var key;
      var attrs = [];
      var tag = '<' + rootTag;
      if ((typeof rootAttrs === 'undefined' ? 'undefined' : _typeof(rootAttrs)) === 'object') {
        for (key in rootAttrs) {
          if (rootAttrs.hasOwnProperty(key)) {
            attrs.push(key + '="' + global$5.encodeAllRaw(rootAttrs[key]) + '"');
          }
        }
        if (attrs.length) {
          tag += ' ' + attrs.join(' ');
        }
      }
      return tag + '>';
    };
    var toBlockElements = function toBlockElements(text, rootTag, rootAttrs) {
      var blocks = text.split(/\n\n/);
      var tagOpen = openContainer(rootTag, rootAttrs);
      var tagClose = '</' + rootTag + '>';
      var paragraphs = global$3.map(blocks, function (p) {
        return p.split(/\n/).join('<br />');
      });
      var stitch = function stitch(p) {
        return tagOpen + p + tagClose;
      };
      return paragraphs.length === 1 ? paragraphs[0] : global$3.map(paragraphs, stitch).join('');
    };
    var convert = function convert(text, rootTag, rootAttrs) {
      return rootTag ? toBlockElements(text, rootTag, rootAttrs) : toBRs(text);
    };
    var $_ebbecuisjk26xk8o = {
      isPlainText: isPlainText,
      convert: convert,
      toBRs: toBRs,
      toBlockElements: toBlockElements
    };

    var global$6 = tinymce.util.Tools.resolve('tinymce.html.DomParser');

    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Node');

    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Schema');

    var global$9 = tinymce.util.Tools.resolve('tinymce.html.Serializer');

    function filter(content, items) {
      global$3.each(items, function (v) {
        if (v.constructor === RegExp) {
          content = content.replace(v, '');
        } else {
          content = content.replace(v[0], v[1]);
        }
      });
      return content;
    }
    function innerText(html) {
      var schema = global$8();
      var domParser = global$6({}, schema);
      var text = '';
      var shortEndedElements = schema.getShortEndedElements();
      var ignoreElements = global$3.makeMap('script noscript style textarea video audio iframe object', ' ');
      var blockElements = schema.getBlockElements();
      function walk(node) {
        var name$$1 = node.name,
            currentNode = node;
        if (name$$1 === 'br') {
          text += '\n';
          return;
        }
        if (shortEndedElements[name$$1]) {
          text += ' ';
        }
        if (ignoreElements[name$$1]) {
          text += ' ';
          return;
        }
        if (node.type === 3) {
          text += node.value;
        }
        if (!node.shortEnded) {
          if (node = node.firstChild) {
            do {
              walk(node);
            } while (node = node.next);
          }
        }
        if (blockElements[name$$1] && currentNode.next) {
          text += '\n';
          if (name$$1 === 'p') {
            text += '\n';
          }
        }
      }
      html = filter(html, [/<!\[[^\]]+\]>/g]);
      walk(domParser.parse(html));
      return text;
    }
    function trimHtml(html) {
      function trimSpaces(all, s1, s2) {
        if (!s1 && !s2) {
          return ' ';
        }
        return '\xA0';
      }
      html = filter(html, [/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig, /<!--StartFragment-->|<!--EndFragment-->/g, [/( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g, trimSpaces], /<br class="Apple-interchange-newline">/g, /<br>$/i]);
      return html;
    }
    function createIdGenerator(prefix) {
      var count = 0;
      return function () {
        return prefix + count++;
      };
    }
    var isMsEdge = function isMsEdge() {
      return navigator.userAgent.indexOf(' Edge/') !== -1;
    };
    var $_av49jwj0jk26xk96 = {
      filter: filter,
      innerText: innerText,
      trimHtml: trimHtml,
      createIdGenerator: createIdGenerator,
      isMsEdge: isMsEdge
    };

    function isWordContent(content) {
      return (/<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content)
      );
    }
    function isNumericList(text) {
      var found, patterns;
      patterns = [/^[IVXLMCD]{1,2}\.[ \u00a0]/, /^[ivxlmcd]{1,2}\.[ \u00a0]/, /^[a-z]{1,2}[\.\)][ \u00a0]/, /^[A-Z]{1,2}[\.\)][ \u00a0]/, /^[0-9]+\.[ \u00a0]/, /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/, /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/];
      text = text.replace(/^[\u00a0 ]+/, '');
      global$3.each(patterns, function (pattern) {
        if (pattern.test(text)) {
          found = true;
          return false;
        }
      });
      return found;
    }
    function isBulletList(text) {
      return (/^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text)
      );
    }
    function convertFakeListsToProperLists(node) {
      var currentListNode,
          prevListNode,
          lastLevel = 1;
      function getText(node) {
        var txt = '';
        if (node.type === 3) {
          return node.value;
        }
        if (node = node.firstChild) {
          do {
            txt += getText(node);
          } while (node = node.next);
        }
        return txt;
      }
      function trimListStart(node, regExp) {
        if (node.type === 3) {
          if (regExp.test(node.value)) {
            node.value = node.value.replace(regExp, '');
            return false;
          }
        }
        if (node = node.firstChild) {
          do {
            if (!trimListStart(node, regExp)) {
              return false;
            }
          } while (node = node.next);
        }
        return true;
      }
      function removeIgnoredNodes(node) {
        if (node._listIgnore) {
          node.remove();
          return;
        }
        if (node = node.firstChild) {
          do {
            removeIgnoredNodes(node);
          } while (node = node.next);
        }
      }
      function convertParagraphToLi(paragraphNode, listName, start) {
        var level = paragraphNode._listLevel || lastLevel;
        if (level !== lastLevel) {
          if (level < lastLevel) {
            if (currentListNode) {
              currentListNode = currentListNode.parent.parent;
            }
          } else {
            prevListNode = currentListNode;
            currentListNode = null;
          }
        }
        if (!currentListNode || currentListNode.name !== listName) {
          prevListNode = prevListNode || currentListNode;
          currentListNode = new global$7(listName, 1);
          if (start > 1) {
            currentListNode.attr('start', '' + start);
          }
          paragraphNode.wrap(currentListNode);
        } else {
          currentListNode.append(paragraphNode);
        }
        paragraphNode.name = 'li';
        if (level > lastLevel && prevListNode) {
          prevListNode.lastChild.append(currentListNode);
        }
        lastLevel = level;
        removeIgnoredNodes(paragraphNode);
        trimListStart(paragraphNode, /^\u00a0+/);
        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
        trimListStart(paragraphNode, /^\u00a0+/);
      }
      var elements = [];
      var child = node.firstChild;
      while (typeof child !== 'undefined' && child !== null) {
        elements.push(child);
        child = child.walk();
        if (child !== null) {
          while (typeof child !== 'undefined' && child.parent !== node) {
            child = child.walk();
          }
        }
      }
      for (var i = 0; i < elements.length; i++) {
        node = elements[i];
        if (node.name === 'p' && node.firstChild) {
          var nodeText = getText(node);
          if (isBulletList(nodeText)) {
            convertParagraphToLi(node, 'ul');
            continue;
          }
          if (isNumericList(nodeText)) {
            var matches = /([0-9]+)\./.exec(nodeText);
            var start = 1;
            if (matches) {
              start = parseInt(matches[1], 10);
            }
            convertParagraphToLi(node, 'ol', start);
            continue;
          }
          if (node._listLevel) {
            convertParagraphToLi(node, 'ul', 1);
            continue;
          }
          currentListNode = null;
        } else {
          prevListNode = currentListNode;
          currentListNode = null;
        }
      }
    }
    function filterStyles(editor, validStyles, node, styleValue) {
      var outputStyles = {},
          matches;
      var styles = editor.dom.parseStyle(styleValue);
      global$3.each(styles, function (value, name) {
        switch (name) {
          case 'mso-list':
            matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
            if (matches) {
              node._listLevel = parseInt(matches[1], 10);
            }
            if (/Ignore/i.test(value) && node.firstChild) {
              node._listIgnore = true;
              node.firstChild._listIgnore = true;
            }
            break;
          case 'horiz-align':
            name = 'text-align';
            break;
          case 'vert-align':
            name = 'vertical-align';
            break;
          case 'font-color':
          case 'mso-foreground':
            name = 'color';
            break;
          case 'mso-background':
          case 'mso-highlight':
            name = 'background';
            break;
          case 'font-weight':
          case 'font-style':
            if (value !== 'normal') {
              outputStyles[name] = value;
            }
            return;
          case 'mso-element':
            if (/^(comment|comment-list)$/i.test(value)) {
              node.remove();
              return;
            }
            break;
        }
        if (name.indexOf('mso-comment') === 0) {
          node.remove();
          return;
        }
        if (name.indexOf('mso-') === 0) {
          return;
        }
        if ($_7zjrh5ikjk26xk87.getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
          outputStyles[name] = value;
        }
      });
      if (/(bold)/i.test(outputStyles['font-weight'])) {
        delete outputStyles['font-weight'];
        node.wrap(new global$7('b', 1));
      }
      if (/(italic)/i.test(outputStyles['font-style'])) {
        delete outputStyles['font-style'];
        node.wrap(new global$7('i', 1));
      }
      outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
      if (outputStyles) {
        return outputStyles;
      }
      return null;
    }
    var filterWordContent = function filterWordContent(editor, content) {
      var retainStyleProperties, validStyles;
      retainStyleProperties = $_7zjrh5ikjk26xk87.getRetainStyleProps(editor);
      if (retainStyleProperties) {
        validStyles = global$3.makeMap(retainStyleProperties.split(/[, ]/));
      }
      content = $_av49jwj0jk26xk96.filter(content, [/<br class="?Apple-interchange-newline"?>/gi, /<b[^>]+id="?docs-internal-[^>]*>/gi, /<!--[\s\S]+?-->/gi, /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi, [/<(\/?)s>/gi, '<$1strike>'], [/&nbsp;/gi, '\xA0'], [/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi, function (str, spaces) {
        return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join('\xA0') : '';
      }]]);
      var validElements = $_7zjrh5ikjk26xk87.getWordValidElements(editor);
      var schema = global$8({
        valid_elements: validElements,
        valid_children: '-li[p]'
      });
      global$3.each(schema.elements, function (rule) {
        if (!rule.attributes.class) {
          rule.attributes.class = {};
          rule.attributesOrder.push('class');
        }
        if (!rule.attributes.style) {
          rule.attributes.style = {};
          rule.attributesOrder.push('style');
        }
      });
      var domParser = global$6({}, schema);
      domParser.addAttributeFilter('style', function (nodes) {
        var i = nodes.length,
            node;
        while (i--) {
          node = nodes[i];
          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
          if (node.name === 'span' && node.parent && !node.attributes.length) {
            node.unwrap();
          }
        }
      });
      domParser.addAttributeFilter('class', function (nodes) {
        var i = nodes.length,
            node,
            className;
        while (i--) {
          node = nodes[i];
          className = node.attr('class');
          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
            node.remove();
          }
          node.attr('class', null);
        }
      });
      domParser.addNodeFilter('del', function (nodes) {
        var i = nodes.length;
        while (i--) {
          nodes[i].remove();
        }
      });
      domParser.addNodeFilter('a', function (nodes) {
        var i = nodes.length,
            node,
            href,
            name;
        while (i--) {
          node = nodes[i];
          href = node.attr('href');
          name = node.attr('name');
          if (href && href.indexOf('#_msocom_') !== -1) {
            node.remove();
            continue;
          }
          if (href && href.indexOf('file://') === 0) {
            href = href.split('#')[1];
            if (href) {
              href = '#' + href;
            }
          }
          if (!href && !name) {
            node.unwrap();
          } else {
            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
              node.unwrap();
              continue;
            }
            node.attr({
              href: href,
              name: name
            });
          }
        }
      });
      var rootNode = domParser.parse(content);
      if ($_7zjrh5ikjk26xk87.shouldConvertWordFakeLists(editor)) {
        convertFakeListsToProperLists(rootNode);
      }
      content = global$9({ validate: editor.settings.validate }, schema).serialize(rootNode);
      return content;
    };
    var preProcess = function preProcess(editor, content) {
      return $_7zjrh5ikjk26xk87.shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
    };
    var $_211w24ivjk26xk8w = {
      preProcess: preProcess,
      isWordContent: isWordContent
    };

    var processResult = function processResult(content, cancelled) {
      return {
        content: content,
        cancelled: cancelled
      };
    };
    var postProcessFilter = function postProcessFilter(editor, html, internal, isWordHtml) {
      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
      var postProcessArgs = $_3ukak2ijjk26xk85.firePastePostProcess(editor, tempBody, internal, isWordHtml);
      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
    };
    var filterContent = function filterContent(editor, content, internal, isWordHtml) {
      var preProcessArgs = $_3ukak2ijjk26xk85.firePastePreProcess(editor, content, internal, isWordHtml);
      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
        return postProcessFilter(editor, preProcessArgs.content, internal, isWordHtml);
      } else {
        return processResult(preProcessArgs.content, preProcessArgs.isDefaultPrevented());
      }
    };
    var process = function process(editor, html, internal) {
      var isWordHtml = $_211w24ivjk26xk8w.isWordContent(html);
      var content = isWordHtml ? $_211w24ivjk26xk8w.preProcess(editor, html) : html;
      return filterContent(editor, content, internal, isWordHtml);
    };
    var $_e8nux1iujk26xk8s = { process: process };

    var pasteHtml = function pasteHtml(editor, html) {
      editor.insertContent(html, {
        merge: $_7zjrh5ikjk26xk87.shouldMergeFormats(editor),
        paste: true
      });
      return true;
    };
    var isAbsoluteUrl = function isAbsoluteUrl(url) {
      return (/^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url)
      );
    };
    var isImageUrl = function isImageUrl(url) {
      return isAbsoluteUrl(url) && /.(gif|jpe?g|png)$/.test(url);
    };
    var createImage = function createImage(editor, url, pasteHtmlFn) {
      editor.undoManager.extra(function () {
        pasteHtmlFn(editor, url);
      }, function () {
        editor.insertContent('<img src="' + url + '">');
      });
      return true;
    };
    var createLink = function createLink(editor, url, pasteHtmlFn) {
      editor.undoManager.extra(function () {
        pasteHtmlFn(editor, url);
      }, function () {
        editor.execCommand('mceInsertLink', false, url);
      });
      return true;
    };
    var linkSelection = function linkSelection(editor, html, pasteHtmlFn) {
      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
    };
    var insertImage = function insertImage(editor, html, pasteHtmlFn) {
      return isImageUrl(html) ? createImage(editor, html, pasteHtmlFn) : false;
    };
    var smartInsertContent = function smartInsertContent(editor, html) {
      global$3.each([linkSelection, insertImage, pasteHtml], function (action) {
        return action(editor, html, pasteHtml) !== true;
      });
    };
    var insertContent = function insertContent(editor, html) {
      if ($_7zjrh5ikjk26xk87.isSmartPasteEnabled(editor) === false) {
        pasteHtml(editor, html);
      } else {
        smartInsertContent(editor, html);
      }
    };
    var $_a1c8zlj1jk26xk99 = {
      isImageUrl: isImageUrl,
      isAbsoluteUrl: isAbsoluteUrl,
      insertContent: insertContent
    };

    var pasteHtml$1 = function pasteHtml$1(editor, html, internalFlag) {
      var internal = internalFlag ? internalFlag : $_4anf80irjk26xk8m.isMarked(html);
      var args = $_e8nux1iujk26xk8s.process(editor, $_4anf80irjk26xk8m.unmark(html), internal);
      if (args.cancelled === false) {
        $_a1c8zlj1jk26xk99.insertContent(editor, args.content);
      }
    };
    var _pasteText = function _pasteText(editor, text) {
      text = editor.dom.encode(text).replace(/\r\n/g, '\n');
      text = $_ebbecuisjk26xk8o.convert(text, editor.settings.forced_root_block, editor.settings.forced_root_block_attrs);
      pasteHtml$1(editor, text, false);
    };
    var getDataTransferItems = function getDataTransferItems(dataTransfer) {
      var items = {};
      var mceInternalUrlPrefix = 'data:text/mce-internal,';
      if (dataTransfer) {
        if (dataTransfer.getData) {
          var legacyText = dataTransfer.getData('Text');
          if (legacyText && legacyText.length > 0) {
            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
              items['text/plain'] = legacyText;
            }
          }
        }
        if (dataTransfer.types) {
          for (var i = 0; i < dataTransfer.types.length; i++) {
            var contentType = dataTransfer.types[i];
            try {
              items[contentType] = dataTransfer.getData(contentType);
            } catch (ex) {
              items[contentType] = '';
            }
          }
        }
      }
      return items;
    };
    var getClipboardContent = function getClipboardContent(editor, clipboardEvent) {
      var content = getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
      return $_av49jwj0jk26xk96.isMsEdge() ? global$3.extend(content, { 'text/html': '' }) : content;
    };
    var hasContentType = function hasContentType(clipboardContent, mimeType) {
      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
    };
    var hasHtmlOrText = function hasHtmlOrText(content) {
      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
    };
    var getBase64FromUri = function getBase64FromUri(uri) {
      var idx;
      idx = uri.indexOf(',');
      if (idx !== -1) {
        return uri.substr(idx + 1);
      }
      return null;
    };
    var isValidDataUriImage = function isValidDataUriImage(settings, imgElm) {
      return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
    };
    var extractFilename = function extractFilename(editor, str) {
      var m = str.match(/([\s\S]+?)\.(?:jpeg|jpg|png|gif)$/i);
      return m ? editor.dom.encode(m[1]) : null;
    };
    var uniqueId = $_av49jwj0jk26xk96.createIdGenerator('mceclip');
    var pasteImage = function pasteImage(editor, rng, reader, blob) {
      if (rng) {
        editor.selection.setRng(rng);
        rng = null;
      }
      var dataUri = reader.result;
      var base64 = getBase64FromUri(dataUri);
      var id = uniqueId();
      var name$$1 = editor.settings.images_reuse_filename && blob.name ? extractFilename(editor, blob.name) : id;
      var img = new Image();
      img.src = dataUri;
      if (isValidDataUriImage(editor.settings, img)) {
        var blobCache = editor.editorUpload.blobCache;
        var blobInfo = void 0,
            existingBlobInfo = void 0;
        existingBlobInfo = blobCache.findFirst(function (cachedBlobInfo) {
          return cachedBlobInfo.base64() === base64;
        });
        if (!existingBlobInfo) {
          blobInfo = blobCache.create(id, blob, base64, name$$1);
          blobCache.add(blobInfo);
        } else {
          blobInfo = existingBlobInfo;
        }
        pasteHtml$1(editor, '<img src="' + blobInfo.blobUri() + '">', false);
      } else {
        pasteHtml$1(editor, '<img src="' + dataUri + '">', false);
      }
    };
    var isClipboardEvent = function isClipboardEvent(event$$1) {
      return event$$1.type === 'paste';
    };
    var _pasteImageData = function _pasteImageData(editor, e, rng) {
      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
      function processItems(items) {
        var i,
            item,
            reader,
            hadImage = false;
        if (items) {
          for (i = 0; i < items.length; i++) {
            item = items[i];
            if (/^image\/(jpeg|png|gif|bmp)$/.test(item.type)) {
              var blob = item.getAsFile ? item.getAsFile() : item;
              reader = new window.FileReader();
              reader.onload = pasteImage.bind(null, editor, rng, reader, blob);
              reader.readAsDataURL(blob);
              e.preventDefault();
              hadImage = true;
            }
          }
        }
        return hadImage;
      }
      if (editor.settings.paste_data_images && dataTransfer) {
        return processItems(dataTransfer.items) || processItems(dataTransfer.files);
      }
    };
    var isBrokenAndroidClipboardEvent = function isBrokenAndroidClipboardEvent(e) {
      var clipboardData = e.clipboardData;
      return navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
    };
    var isKeyboardPasteEvent = function isKeyboardPasteEvent(e) {
      return global$4.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
    };
    var registerEventHandlers = function registerEventHandlers(editor, pasteBin, pasteFormat) {
      var keyboardPasteTimeStamp = 0;
      var keyboardPastePlainTextState;
      editor.on('keydown', function (e) {
        function removePasteBinOnKeyUp(e) {
          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
            pasteBin.remove();
          }
        }
        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
          if (keyboardPastePlainTextState && global$1.webkit && navigator.userAgent.indexOf('Version/') !== -1) {
            return;
          }
          e.stopImmediatePropagation();
          keyboardPasteTimeStamp = new Date().getTime();
          if (global$1.ie && keyboardPastePlainTextState) {
            e.preventDefault();
            $_3ukak2ijjk26xk85.firePaste(editor, true);
            return;
          }
          pasteBin.remove();
          pasteBin.create();
          editor.once('keyup', removePasteBinOnKeyUp);
          editor.once('paste', function () {
            editor.off('keyup', removePasteBinOnKeyUp);
          });
        }
      });
      function insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
        var content, isPlainTextHtml;
        if (hasContentType(clipboardContent, 'text/html')) {
          content = clipboardContent['text/html'];
        } else {
          content = pasteBin.getHtml();
          internal = internal ? internal : $_4anf80irjk26xk8m.isMarked(content);
          if (pasteBin.isDefaultContent(content)) {
            plainTextMode = true;
          }
        }
        content = $_av49jwj0jk26xk96.trimHtml(content);
        pasteBin.remove();
        isPlainTextHtml = internal === false && $_ebbecuisjk26xk8o.isPlainText(content);
        if (!content.length || isPlainTextHtml) {
          plainTextMode = true;
        }
        if (plainTextMode) {
          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
            content = clipboardContent['text/plain'];
          } else {
            content = $_av49jwj0jk26xk96.innerText(content);
          }
        }
        if (pasteBin.isDefaultContent(content)) {
          if (!isKeyBoardPaste) {
            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
          }
          return;
        }
        if (plainTextMode) {
          _pasteText(editor, content);
        } else {
          pasteHtml$1(editor, content, internal);
        }
      }
      var getLastRng = function getLastRng() {
        return pasteBin.getLastRng() || editor.selection.getRng();
      };
      editor.on('paste', function (e) {
        var clipboardTimer = new Date().getTime();
        var clipboardContent = getClipboardContent(editor, e);
        var clipboardDelay = new Date().getTime() - clipboardTimer;
        var isKeyBoardPaste = new Date().getTime() - keyboardPasteTimeStamp - clipboardDelay < 1000;
        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
        var internal = hasContentType(clipboardContent, $_4anf80irjk26xk8m.internalHtmlMime());
        keyboardPastePlainTextState = false;
        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
          pasteBin.remove();
          return;
        }
        if (!hasHtmlOrText(clipboardContent) && _pasteImageData(editor, e, getLastRng())) {
          pasteBin.remove();
          return;
        }
        if (!isKeyBoardPaste) {
          e.preventDefault();
        }
        if (global$1.ie && (!isKeyBoardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
          pasteBin.create();
          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
            e.stopPropagation();
          });
          editor.getDoc().execCommand('Paste', false, null);
          clipboardContent['text/html'] = pasteBin.getHtml();
        }
        if (hasContentType(clipboardContent, 'text/html')) {
          e.preventDefault();
          if (!internal) {
            internal = $_4anf80irjk26xk8m.isMarked(clipboardContent['text/html']);
          }
          insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
        } else {
          global$2.setEditorTimeout(editor, function () {
            insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
          }, 0);
        }
      });
    };
    var registerEventsAndFilters = function registerEventsAndFilters(editor, pasteBin, pasteFormat) {
      registerEventHandlers(editor, pasteBin, pasteFormat);
      var src;
      editor.parser.addNodeFilter('img', function (nodes, name$$1, args) {
        var isPasteInsert = function isPasteInsert(args) {
          return args.data && args.data.paste === true;
        };
        var remove = function remove(node) {
          if (!node.attr('data-mce-object') && src !== global$1.transparentSrc) {
            node.remove();
          }
        };
        var isWebKitFakeUrl = function isWebKitFakeUrl(src) {
          return src.indexOf('webkit-fake-url') === 0;
        };
        var isDataUri = function isDataUri(src) {
          return src.indexOf('data:') === 0;
        };
        if (!editor.settings.paste_data_images && isPasteInsert(args)) {
          var i = nodes.length;
          while (i--) {
            src = nodes[i].attributes.map.src;
            if (!src) {
              continue;
            }
            if (isWebKitFakeUrl(src)) {
              remove(nodes[i]);
            } else if (!editor.settings.allow_html_data_urls && isDataUri(src)) {
              remove(nodes[i]);
            }
          }
        }
      });
    };

    var getPasteBinParent = function getPasteBinParent(editor) {
      return global$1.ie && editor.inline ? document.body : editor.getBody();
    };
    var isExternalPasteBin = function isExternalPasteBin(editor) {
      return getPasteBinParent(editor) !== editor.getBody();
    };
    var delegatePasteEvents = function delegatePasteEvents(editor, pasteBinElm) {
      if (isExternalPasteBin(editor)) {
        editor.dom.bind(pasteBinElm, 'paste keyup', function (e) {
          setTimeout(function () {
            editor.fire('paste');
          }, 0);
        });
      }
    };
    var _create = function _create(editor, lastRngCell, pasteBinDefaultContent) {
      var dom = editor.dom,
          body = editor.getBody();
      var pasteBinElm;
      lastRngCell.set(editor.selection.getRng());
      pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
        'id': 'mcepastebin',
        'class': 'mce-pastebin',
        'contentEditable': true,
        'data-mce-bogus': 'all',
        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
      }, pasteBinDefaultContent);
      if (global$1.ie || global$1.gecko) {
        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
      }
      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
        e.stopPropagation();
      });
      delegatePasteEvents(editor, pasteBinElm);
      pasteBinElm.focus();
      editor.selection.select(pasteBinElm, true);
    };
    var _remove = function _remove(editor, lastRngCell) {
      if (_getEl(editor)) {
        var pasteBinClone = void 0;
        var lastRng = lastRngCell.get();
        while (pasteBinClone = editor.dom.get('mcepastebin')) {
          editor.dom.remove(pasteBinClone);
          editor.dom.unbind(pasteBinClone);
        }
        if (lastRng) {
          editor.selection.setRng(lastRng);
        }
      }
      lastRngCell.set(null);
    };
    var _getEl = function _getEl(editor) {
      return editor.dom.get('mcepastebin');
    };
    var _getHtml = function _getHtml(editor) {
      var pasteBinElm, pasteBinClones, i, dirtyWrappers, cleanWrapper;
      var copyAndRemove = function copyAndRemove(toElm, fromElm) {
        toElm.appendChild(fromElm);
        editor.dom.remove(fromElm, true);
      };
      pasteBinClones = global$3.grep(getPasteBinParent(editor).childNodes, function (elm) {
        return elm.id === 'mcepastebin';
      });
      pasteBinElm = pasteBinClones.shift();
      global$3.each(pasteBinClones, function (pasteBinClone) {
        copyAndRemove(pasteBinElm, pasteBinClone);
      });
      dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
      for (i = dirtyWrappers.length - 1; i >= 0; i--) {
        cleanWrapper = editor.dom.create('div');
        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
      }
      return pasteBinElm ? pasteBinElm.innerHTML : '';
    };
    var _getLastRng = function _getLastRng(lastRng) {
      return lastRng.get();
    };
    var _isDefaultContent = function _isDefaultContent(pasteBinDefaultContent, content) {
      return content === pasteBinDefaultContent;
    };
    var isPasteBin = function isPasteBin(elm) {
      return elm && elm.id === 'mcepastebin';
    };
    var _isDefault = function _isDefault(editor, pasteBinDefaultContent) {
      var pasteBinElm = _getEl(editor);
      return isPasteBin(pasteBinElm) && _isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
    };
    var PasteBin = function PasteBin(editor) {
      var lastRng = Cell(null);
      var pasteBinDefaultContent = '%MCEPASTEBIN%';
      return {
        create: function create() {
          return _create(editor, lastRng, pasteBinDefaultContent);
        },
        remove: function remove() {
          return _remove(editor, lastRng);
        },
        getEl: function getEl() {
          return _getEl(editor);
        },
        getHtml: function getHtml() {
          return _getHtml(editor);
        },
        getLastRng: function getLastRng() {
          return _getLastRng(lastRng);
        },
        isDefault: function isDefault() {
          return _isDefault(editor, pasteBinDefaultContent);
        },
        isDefaultContent: function isDefaultContent(content) {
          return _isDefaultContent(pasteBinDefaultContent, content);
        }
      };
    };

    var Clipboard = function Clipboard(editor, pasteFormat) {
      var pasteBin = PasteBin(editor);
      editor.on('preInit', function () {
        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
      });
      return {
        pasteFormat: pasteFormat,
        pasteHtml: function pasteHtml(html, internalFlag) {
          return pasteHtml$1(editor, html, internalFlag);
        },
        pasteText: function pasteText(text) {
          return _pasteText(editor, text);
        },
        pasteImageData: function pasteImageData(e, rng) {
          return _pasteImageData(editor, e, rng);
        },
        getDataTransferItems: getDataTransferItems,
        hasHtmlOrText: hasHtmlOrText,
        hasContentType: hasContentType
      };
    };

    var noop = function noop() {};
    var hasWorkingClipboardApi = function hasWorkingClipboardApi(clipboardData) {
      return global$1.iOS === false && clipboardData !== undefined && typeof clipboardData.setData === 'function' && $_av49jwj0jk26xk96.isMsEdge() !== true;
    };
    var setHtml5Clipboard = function setHtml5Clipboard(clipboardData, html, text) {
      if (hasWorkingClipboardApi(clipboardData)) {
        try {
          clipboardData.clearData();
          clipboardData.setData('text/html', html);
          clipboardData.setData('text/plain', text);
          clipboardData.setData($_4anf80irjk26xk8m.internalHtmlMime(), html);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };
    var setClipboardData = function setClipboardData(evt, data, fallback, done) {
      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
        evt.preventDefault();
        done();
      } else {
        fallback(data.html, done);
      }
    };
    var fallback = function fallback(editor) {
      return function (html, done) {
        var markedHtml = $_4anf80irjk26xk8m.mark(html);
        var outer = editor.dom.create('div', {
          'contenteditable': 'false',
          'data-mce-bogus': 'all'
        });
        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
        editor.dom.setStyles(outer, {
          position: 'fixed',
          top: '0',
          left: '-3000px',
          width: '1000px',
          overflow: 'hidden'
        });
        outer.appendChild(inner);
        editor.dom.add(editor.getBody(), outer);
        var range = editor.selection.getRng();
        inner.focus();
        var offscreenRange = editor.dom.createRng();
        offscreenRange.selectNodeContents(inner);
        editor.selection.setRng(offscreenRange);
        setTimeout(function () {
          editor.selection.setRng(range);
          outer.parentNode.removeChild(outer);
          done();
        }, 0);
      };
    };
    var getData = function getData(editor) {
      return {
        html: editor.selection.getContent({ contextual: true }),
        text: editor.selection.getContent({ format: 'text' })
      };
    };
    var cut = function cut(editor) {
      return function (evt) {
        if (editor.selection.isCollapsed() === false) {
          setClipboardData(evt, getData(editor), fallback(editor), function () {
            setTimeout(function () {
              editor.execCommand('Delete');
            }, 0);
          });
        }
      };
    };
    var copy = function copy(editor) {
      return function (evt) {
        if (editor.selection.isCollapsed() === false) {
          setClipboardData(evt, getData(editor), fallback(editor), noop);
        }
      };
    };
    var register$1 = function register$1(editor) {
      editor.on('cut', cut(editor));
      editor.on('copy', copy(editor));
    };
    var $_98lo45j3jk26xk9r = { register: register$1 };

    var global$10 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');

    var getCaretRangeFromEvent = function getCaretRangeFromEvent(editor, e) {
      return global$10.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
    };
    var isPlainTextFileUrl = function isPlainTextFileUrl(content) {
      var plainTextContent = content['text/plain'];
      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
    };
    var setFocusedRange = function setFocusedRange(editor, rng) {
      editor.focus();
      editor.selection.setRng(rng);
    };
    var setup = function setup(editor, clipboard, draggingInternallyState) {
      if ($_7zjrh5ikjk26xk87.shouldBlockDrop(editor)) {
        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
      if (!$_7zjrh5ikjk26xk87.shouldPasteDataImages(editor)) {
        editor.on('drop', function (e) {
          var dataTransfer = e.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.preventDefault();
          }
        });
      }
      editor.on('drop', function (e) {
        var dropContent, rng;
        rng = getCaretRangeFromEvent(editor, e);
        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
          return;
        }
        dropContent = clipboard.getDataTransferItems(e.dataTransfer);
        var internal = clipboard.hasContentType(dropContent, $_4anf80irjk26xk8m.internalHtmlMime());
        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
          return;
        }
        if (rng && $_7zjrh5ikjk26xk87.shouldFilterDrop(editor)) {
          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
          if (content_1) {
            e.preventDefault();
            global$2.setEditorTimeout(editor, function () {
              editor.undoManager.transact(function () {
                if (dropContent['mce-internal']) {
                  editor.execCommand('Delete');
                }
                setFocusedRange(editor, rng);
                content_1 = $_av49jwj0jk26xk96.trimHtml(content_1);
                if (!dropContent['text/html']) {
                  clipboard.pasteText(content_1);
                } else {
                  clipboard.pasteHtml(content_1, internal);
                }
              });
            });
          }
        }
      });
      editor.on('dragstart', function (e) {
        draggingInternallyState.set(true);
      });
      editor.on('dragover dragend', function (e) {
        if ($_7zjrh5ikjk26xk87.shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
          e.preventDefault();
          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
        }
        if (e.type === 'dragend') {
          draggingInternallyState.set(false);
        }
      });
    };
    var $_6syf5uj4jk26xk9u = { setup: setup };

    var setup$1 = function setup$1(editor) {
      var plugin = editor.plugins.paste;
      var preProcess = $_7zjrh5ikjk26xk87.getPreProcess(editor);
      if (preProcess) {
        editor.on('PastePreProcess', function (e) {
          preProcess.call(plugin, plugin, e);
        });
      }
      var postProcess = $_7zjrh5ikjk26xk87.getPostProcess(editor);
      if (postProcess) {
        editor.on('PastePostProcess', function (e) {
          postProcess.call(plugin, plugin, e);
        });
      }
    };
    var $_4wmbltj6jk26xk9y = { setup: setup$1 };

    function addPreProcessFilter(editor, filterFunc) {
      editor.on('PastePreProcess', function (e) {
        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
      });
    }
    function addPostProcessFilter(editor, filterFunc) {
      editor.on('PastePostProcess', function (e) {
        filterFunc(editor, e.node);
      });
    }
    function removeExplorerBrElementsAfterBlocks(editor, html) {
      if (!$_211w24ivjk26xk8w.isWordContent(html)) {
        return html;
      }
      var blockElements = [];
      global$3.each(editor.schema.getBlockElements(), function (block, blockName) {
        blockElements.push(blockName);
      });
      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
      html = $_av49jwj0jk26xk96.filter(html, [[explorerBlocksRegExp, '$1']]);
      html = $_av49jwj0jk26xk96.filter(html, [[/<br><br>/g, '<BR><BR>'], [/<br>/g, ' '], [/<BR><BR>/g, '<br>']]);
      return html;
    }
    function removeWebKitStyles(editor, content, internal, isWordHtml) {
      if (isWordHtml || internal) {
        return content;
      }
      var webKitStylesSetting = $_7zjrh5ikjk26xk87.getWebkitStyles(editor);
      var webKitStyles;
      if ($_7zjrh5ikjk26xk87.shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
        return content;
      }
      if (webKitStylesSetting) {
        webKitStyles = webKitStylesSetting.split(/[, ]/);
      }
      if (webKitStyles) {
        var dom_1 = editor.dom,
            node_1 = editor.selection.getNode();
        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
          var outputStyles = {};
          if (webKitStyles === 'none') {
            return before + after;
          }
          for (var i = 0; i < webKitStyles.length; i++) {
            var inputValue = inputStyles[webKitStyles[i]],
                currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
            if (/color/.test(webKitStyles[i])) {
              inputValue = dom_1.toHex(inputValue);
              currentValue = dom_1.toHex(currentValue);
            }
            if (currentValue !== inputValue) {
              outputStyles[webKitStyles[i]] = inputValue;
            }
          }
          outputStyles = dom_1.serializeStyle(outputStyles, 'span');
          if (outputStyles) {
            return before + ' style="' + outputStyles + '"' + after;
          }
          return before + after;
        });
      } else {
        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
      }
      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
        return before + ' style="' + value + '"' + after;
      });
      return content;
    }
    function removeUnderlineAndFontInAnchor(editor, root) {
      editor.$('a', root).find('font,u').each(function (i, node) {
        editor.dom.remove(node, true);
      });
    }
    var setup$2 = function setup$2(editor) {
      if (global$1.webkit) {
        addPreProcessFilter(editor, removeWebKitStyles);
      }
      if (global$1.ie) {
        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
      }
    };
    var $_f2akyoj7jk26xka0 = { setup: setup$2 };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };

    var stateChange = function stateChange(editor, clipboard, e) {
      var ctrl = e.control;
      ctrl.active(clipboard.pasteFormat.get() === 'text');
      editor.on('PastePlainTextToggle', function (e) {
        ctrl.active(e.state);
      });
    };
    var register$2 = function register$2(editor, clipboard) {
      var postRender = curry(stateChange, editor, clipboard);
      editor.addButton('pastetext', {
        active: false,
        icon: 'pastetext',
        tooltip: 'Paste as text',
        cmd: 'mceTogglePlainTextPaste',
        onPostRender: postRender
      });
      editor.addMenuItem('pastetext', {
        text: 'Paste as text',
        selectable: true,
        active: clipboard.pasteFormat,
        cmd: 'mceTogglePlainTextPaste',
        onPostRender: postRender
      });
    };
    var $_g2kqqmj8jk26xka4 = { register: register$2 };

    global.add('paste', function (editor) {
      if ($_cp3dn7iejk26xk7n.hasProPlugin(editor) === false) {
        var userIsInformedState = Cell(false);
        var draggingInternallyState = Cell(false);
        var pasteFormat = Cell($_7zjrh5ikjk26xk87.isPasteAsTextEnabled(editor) ? 'text' : 'html');
        var clipboard = Clipboard(editor, pasteFormat);
        var quirks = $_f2akyoj7jk26xka0.setup(editor);
        $_g2kqqmj8jk26xka4.register(editor, clipboard);
        $_15lprrihjk26xk82.register(editor, clipboard, userIsInformedState);
        $_4wmbltj6jk26xk9y.setup(editor);
        $_98lo45j3jk26xk9r.register(editor);
        $_6syf5uj4jk26xk9u.setup(editor, clipboard, draggingInternallyState);
        return $_aqz0cligjk26xk80.get(clipboard, quirks);
      }
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 985 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/print/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "print" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/print')
//   ES2015:
//     import 'tinymce/plugins/print'
__webpack_require__(/*! ./plugin.js */ 986);

/***/ }),
/* 986 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/print/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var print = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var register = function register(editor) {
      editor.addCommand('mcePrint', function () {
        editor.getWin().print();
      });
    };
    var $_6795qpjljk26xkek = { register: register };

    var register$1 = function register$1(editor) {
      editor.addButton('print', {
        title: 'Print',
        cmd: 'mcePrint'
      });
      editor.addMenuItem('print', {
        text: 'Print',
        cmd: 'mcePrint',
        icon: 'print'
      });
    };
    var $_b2j1tkjmjk26xkel = { register: register$1 };

    global.add('print', function (editor) {
      $_6795qpjljk26xkek.register(editor);
      $_b2j1tkjmjk26xkel.register(editor);
      editor.addShortcut('Meta+P', '', 'mcePrint');
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 987 */
/*!*************************************************************!*\
  !*** ./src/packages/tinymce/plugins/searchreplace/index.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "searchreplace" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/searchreplace')
//   ES2015:
//     import 'tinymce/plugins/searchreplace'
__webpack_require__(/*! ./plugin.js */ 988);

/***/ }),
/* 988 */
/*!**************************************************************!*\
  !*** ./src/packages/tinymce/plugins/searchreplace/plugin.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var searchreplace = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    function isContentEditableFalse(node) {
      return node && node.nodeType === 1 && node.contentEditable === 'false';
    }
    function findAndReplaceDOMText(regex, node, replacementNode, captureGroup, schema) {
      var m;
      var matches = [];
      var text,
          count = 0,
          doc;
      var blockElementsMap, hiddenTextElementsMap, shortEndedElementsMap;
      doc = node.ownerDocument;
      blockElementsMap = schema.getBlockElements();
      hiddenTextElementsMap = schema.getWhiteSpaceElements();
      shortEndedElementsMap = schema.getShortEndedElements();
      function getMatchIndexes(m, captureGroup) {
        captureGroup = captureGroup || 0;
        if (!m[0]) {
          throw new Error('findAndReplaceDOMText cannot handle zero-length matches');
        }
        var index = m.index;
        if (captureGroup > 0) {
          var cg = m[captureGroup];
          if (!cg) {
            throw new Error('Invalid capture group');
          }
          index += m[0].indexOf(cg);
          m[0] = cg;
        }
        return [index, index + m[0].length, [m[0]]];
      }
      function getText(node) {
        var txt;
        if (node.nodeType === 3) {
          return node.data;
        }
        if (hiddenTextElementsMap[node.nodeName] && !blockElementsMap[node.nodeName]) {
          return '';
        }
        txt = '';
        if (isContentEditableFalse(node)) {
          return '\n';
        }
        if (blockElementsMap[node.nodeName] || shortEndedElementsMap[node.nodeName]) {
          txt += '\n';
        }
        if (node = node.firstChild) {
          do {
            txt += getText(node);
          } while (node = node.nextSibling);
        }
        return txt;
      }
      function stepThroughMatches(node, matches, replaceFn) {
        var startNode,
            endNode,
            startNodeIndex,
            endNodeIndex,
            innerNodes = [],
            atIndex = 0,
            curNode = node,
            matchLocation = matches.shift(),
            matchIndex = 0;
        out: while (true) {
          if (blockElementsMap[curNode.nodeName] || shortEndedElementsMap[curNode.nodeName] || isContentEditableFalse(curNode)) {
            atIndex++;
          }
          if (curNode.nodeType === 3) {
            if (!endNode && curNode.length + atIndex >= matchLocation[1]) {
              endNode = curNode;
              endNodeIndex = matchLocation[1] - atIndex;
            } else if (startNode) {
              innerNodes.push(curNode);
            }
            if (!startNode && curNode.length + atIndex > matchLocation[0]) {
              startNode = curNode;
              startNodeIndex = matchLocation[0] - atIndex;
            }
            atIndex += curNode.length;
          }
          if (startNode && endNode) {
            curNode = replaceFn({
              startNode: startNode,
              startNodeIndex: startNodeIndex,
              endNode: endNode,
              endNodeIndex: endNodeIndex,
              innerNodes: innerNodes,
              match: matchLocation[2],
              matchIndex: matchIndex
            });
            atIndex -= endNode.length - endNodeIndex;
            startNode = null;
            endNode = null;
            innerNodes = [];
            matchLocation = matches.shift();
            matchIndex++;
            if (!matchLocation) {
              break;
            }
          } else if ((!hiddenTextElementsMap[curNode.nodeName] || blockElementsMap[curNode.nodeName]) && curNode.firstChild) {
            if (!isContentEditableFalse(curNode)) {
              curNode = curNode.firstChild;
              continue;
            }
          } else if (curNode.nextSibling) {
            curNode = curNode.nextSibling;
            continue;
          }
          while (true) {
            if (curNode.nextSibling) {
              curNode = curNode.nextSibling;
              break;
            } else if (curNode.parentNode !== node) {
              curNode = curNode.parentNode;
            } else {
              break out;
            }
          }
        }
      }
      function genReplacer(nodeName) {
        var makeReplacementNode;
        if (typeof nodeName !== 'function') {
          var stencilNode_1 = nodeName.nodeType ? nodeName : doc.createElement(nodeName);
          makeReplacementNode = function makeReplacementNode(fill, matchIndex) {
            var clone = stencilNode_1.cloneNode(false);
            clone.setAttribute('data-mce-index', matchIndex);
            if (fill) {
              clone.appendChild(doc.createTextNode(fill));
            }
            return clone;
          };
        } else {
          makeReplacementNode = nodeName;
        }
        return function (range) {
          var before;
          var after;
          var parentNode;
          var startNode = range.startNode;
          var endNode = range.endNode;
          var matchIndex = range.matchIndex;
          if (startNode === endNode) {
            var node_1 = startNode;
            parentNode = node_1.parentNode;
            if (range.startNodeIndex > 0) {
              before = doc.createTextNode(node_1.data.substring(0, range.startNodeIndex));
              parentNode.insertBefore(before, node_1);
            }
            var el = makeReplacementNode(range.match[0], matchIndex);
            parentNode.insertBefore(el, node_1);
            if (range.endNodeIndex < node_1.length) {
              after = doc.createTextNode(node_1.data.substring(range.endNodeIndex));
              parentNode.insertBefore(after, node_1);
            }
            node_1.parentNode.removeChild(node_1);
            return el;
          }
          before = doc.createTextNode(startNode.data.substring(0, range.startNodeIndex));
          after = doc.createTextNode(endNode.data.substring(range.endNodeIndex));
          var elA = makeReplacementNode(startNode.data.substring(range.startNodeIndex), matchIndex);
          var innerEls = [];
          for (var i = 0, l = range.innerNodes.length; i < l; ++i) {
            var innerNode = range.innerNodes[i];
            var innerEl = makeReplacementNode(innerNode.data, matchIndex);
            innerNode.parentNode.replaceChild(innerEl, innerNode);
            innerEls.push(innerEl);
          }
          var elB = makeReplacementNode(endNode.data.substring(0, range.endNodeIndex), matchIndex);
          parentNode = startNode.parentNode;
          parentNode.insertBefore(before, startNode);
          parentNode.insertBefore(elA, startNode);
          parentNode.removeChild(startNode);
          parentNode = endNode.parentNode;
          parentNode.insertBefore(elB, endNode);
          parentNode.insertBefore(after, endNode);
          parentNode.removeChild(endNode);
          return elB;
        };
      }
      text = getText(node);
      if (!text) {
        return;
      }
      if (regex.global) {
        while (m = regex.exec(text)) {
          matches.push(getMatchIndexes(m, captureGroup));
        }
      } else {
        m = text.match(regex);
        matches.push(getMatchIndexes(m, captureGroup));
      }
      if (matches.length) {
        count = matches.length;
        stepThroughMatches(node, matches, genReplacer(replacementNode));
      }
      return count;
    }
    var $_7rh07k1jk26xkfn = { findAndReplaceDOMText: findAndReplaceDOMText };

    var getElmIndex = function getElmIndex(elm) {
      var value = elm.getAttribute('data-mce-index');
      if (typeof value === 'number') {
        return '' + value;
      }
      return value;
    };
    var markAllMatches = function markAllMatches(editor, currentIndexState, regex) {
      var node, marker;
      marker = editor.dom.create('span', { 'data-mce-bogus': 1 });
      marker.className = 'mce-match-marker';
      node = editor.getBody();
      done(editor, currentIndexState, false);
      return $_7rh07k1jk26xkfn.findAndReplaceDOMText(regex, node, marker, false, editor.schema);
    };
    var unwrap = function unwrap(node) {
      var parentNode = node.parentNode;
      if (node.firstChild) {
        parentNode.insertBefore(node.firstChild, node);
      }
      node.parentNode.removeChild(node);
    };
    var findSpansByIndex = function findSpansByIndex(editor, index) {
      var nodes;
      var spans = [];
      nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
      if (nodes.length) {
        for (var i = 0; i < nodes.length; i++) {
          var nodeIndex = getElmIndex(nodes[i]);
          if (nodeIndex === null || !nodeIndex.length) {
            continue;
          }
          if (nodeIndex === index.toString()) {
            spans.push(nodes[i]);
          }
        }
      }
      return spans;
    };
    var moveSelection = function moveSelection(editor, currentIndexState, forward) {
      var testIndex = currentIndexState.get();
      var dom = editor.dom;
      forward = forward !== false;
      if (forward) {
        testIndex++;
      } else {
        testIndex--;
      }
      dom.removeClass(findSpansByIndex(editor, currentIndexState.get()), 'mce-match-marker-selected');
      var spans = findSpansByIndex(editor, testIndex);
      if (spans.length) {
        dom.addClass(findSpansByIndex(editor, testIndex), 'mce-match-marker-selected');
        editor.selection.scrollIntoView(spans[0]);
        return testIndex;
      }
      return -1;
    };
    var removeNode = function removeNode(dom, node) {
      var parent = node.parentNode;
      dom.remove(node);
      if (dom.isEmpty(parent)) {
        dom.remove(parent);
      }
    };
    var find = function find(editor, currentIndexState, text, matchCase, wholeWord) {
      text = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      text = text.replace(/\s/g, '\\s');
      text = wholeWord ? '\\b' + text + '\\b' : text;
      var count = markAllMatches(editor, currentIndexState, new RegExp(text, matchCase ? 'g' : 'gi'));
      if (count) {
        currentIndexState.set(-1);
        currentIndexState.set(moveSelection(editor, currentIndexState, true));
      }
      return count;
    };
    var next = function next(editor, currentIndexState) {
      var index = moveSelection(editor, currentIndexState, true);
      if (index !== -1) {
        currentIndexState.set(index);
      }
    };
    var prev = function prev(editor, currentIndexState) {
      var index = moveSelection(editor, currentIndexState, false);
      if (index !== -1) {
        currentIndexState.set(index);
      }
    };
    var isMatchSpan = function isMatchSpan(node) {
      var matchIndex = getElmIndex(node);
      return matchIndex !== null && matchIndex.length > 0;
    };
    var replace = function replace(editor, currentIndexState, text, forward, all) {
      var i,
          nodes,
          node,
          matchIndex,
          currentMatchIndex,
          nextIndex = currentIndexState.get(),
          hasMore;
      forward = forward !== false;
      node = editor.getBody();
      nodes = global$1.grep(global$1.toArray(node.getElementsByTagName('span')), isMatchSpan);
      for (i = 0; i < nodes.length; i++) {
        var nodeIndex = getElmIndex(nodes[i]);
        matchIndex = currentMatchIndex = parseInt(nodeIndex, 10);
        if (all || matchIndex === currentIndexState.get()) {
          if (text.length) {
            nodes[i].firstChild.nodeValue = text;
            unwrap(nodes[i]);
          } else {
            removeNode(editor.dom, nodes[i]);
          }
          while (nodes[++i]) {
            matchIndex = parseInt(getElmIndex(nodes[i]), 10);
            if (matchIndex === currentMatchIndex) {
              removeNode(editor.dom, nodes[i]);
            } else {
              i--;
              break;
            }
          }
          if (forward) {
            nextIndex--;
          }
        } else if (currentMatchIndex > currentIndexState.get()) {
          nodes[i].setAttribute('data-mce-index', currentMatchIndex - 1);
        }
      }
      currentIndexState.set(nextIndex);
      if (forward) {
        hasMore = hasNext(editor, currentIndexState);
        next(editor, currentIndexState);
      } else {
        hasMore = hasPrev(editor, currentIndexState);
        prev(editor, currentIndexState);
      }
      return !all && hasMore;
    };
    var done = function done(editor, currentIndexState, keepEditorSelection) {
      var i, nodes, startContainer, endContainer;
      nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
      for (i = 0; i < nodes.length; i++) {
        var nodeIndex = getElmIndex(nodes[i]);
        if (nodeIndex !== null && nodeIndex.length) {
          if (nodeIndex === currentIndexState.get().toString()) {
            if (!startContainer) {
              startContainer = nodes[i].firstChild;
            }
            endContainer = nodes[i].firstChild;
          }
          unwrap(nodes[i]);
        }
      }
      if (startContainer && endContainer) {
        var rng = editor.dom.createRng();
        rng.setStart(startContainer, 0);
        rng.setEnd(endContainer, endContainer.data.length);
        if (keepEditorSelection !== false) {
          editor.selection.setRng(rng);
        }
        return rng;
      }
    };
    var hasNext = function hasNext(editor, currentIndexState) {
      return findSpansByIndex(editor, currentIndexState.get() + 1).length > 0;
    };
    var hasPrev = function hasPrev(editor, currentIndexState) {
      return findSpansByIndex(editor, currentIndexState.get() - 1).length > 0;
    };
    var $_6b28psjzjk26xkfh = {
      done: done,
      find: find,
      next: next,
      prev: prev,
      replace: replace,
      hasNext: hasNext,
      hasPrev: hasPrev
    };

    var get = function get(editor, currentIndexState) {
      var done = function done(keepEditorSelection) {
        return $_6b28psjzjk26xkfh.done(editor, currentIndexState, keepEditorSelection);
      };
      var find = function find(text, matchCase, wholeWord) {
        return $_6b28psjzjk26xkfh.find(editor, currentIndexState, text, matchCase, wholeWord);
      };
      var next = function next() {
        return $_6b28psjzjk26xkfh.next(editor, currentIndexState);
      };
      var prev = function prev() {
        return $_6b28psjzjk26xkfh.prev(editor, currentIndexState);
      };
      var replace = function replace(text, forward, all) {
        return $_6b28psjzjk26xkfh.replace(editor, currentIndexState, text, forward, all);
      };
      return {
        done: done,
        find: find,
        next: next,
        prev: prev,
        replace: replace
      };
    };
    var $_k7y3vjyjk26xkff = { get: get };

    var open = function open(editor, currentIndexState) {
      var last = {},
          selectedText;
      editor.undoManager.add();
      selectedText = global$1.trim(editor.selection.getContent({ format: 'text' }));
      function updateButtonStates() {
        win.statusbar.find('#next').disabled($_6b28psjzjk26xkfh.hasNext(editor, currentIndexState) === false);
        win.statusbar.find('#prev').disabled($_6b28psjzjk26xkfh.hasPrev(editor, currentIndexState) === false);
      }
      function notFoundAlert() {
        editor.windowManager.alert('Could not find the specified string.', function () {
          win.find('#find')[0].focus();
        });
      }
      var win = editor.windowManager.open({
        layout: 'flex',
        pack: 'center',
        align: 'center',
        onClose: function onClose() {
          editor.focus();
          $_6b28psjzjk26xkfh.done(editor, currentIndexState);
          editor.undoManager.add();
        },
        onSubmit: function onSubmit(e) {
          var count, caseState, text, wholeWord;
          e.preventDefault();
          caseState = win.find('#case').checked();
          wholeWord = win.find('#words').checked();
          text = win.find('#find').value();
          if (!text.length) {
            $_6b28psjzjk26xkfh.done(editor, currentIndexState, false);
            win.statusbar.items().slice(1).disabled(true);
            return;
          }
          if (last.text === text && last.caseState === caseState && last.wholeWord === wholeWord) {
            if (!$_6b28psjzjk26xkfh.hasNext(editor, currentIndexState)) {
              notFoundAlert();
              return;
            }
            $_6b28psjzjk26xkfh.next(editor, currentIndexState);
            updateButtonStates();
            return;
          }
          count = $_6b28psjzjk26xkfh.find(editor, currentIndexState, text, caseState, wholeWord);
          if (!count) {
            notFoundAlert();
          }
          win.statusbar.items().slice(1).disabled(count === 0);
          updateButtonStates();
          last = {
            text: text,
            caseState: caseState,
            wholeWord: wholeWord
          };
        },
        buttons: [{
          text: 'Find',
          subtype: 'primary',
          onclick: function onclick() {
            win.submit();
          }
        }, {
          text: 'Replace',
          disabled: true,
          onclick: function onclick() {
            if (!$_6b28psjzjk26xkfh.replace(editor, currentIndexState, win.find('#replace').value())) {
              win.statusbar.items().slice(1).disabled(true);
              currentIndexState.set(-1);
              last = {};
            }
          }
        }, {
          text: 'Replace all',
          disabled: true,
          onclick: function onclick() {
            $_6b28psjzjk26xkfh.replace(editor, currentIndexState, win.find('#replace').value(), true, true);
            win.statusbar.items().slice(1).disabled(true);
            last = {};
          }
        }, {
          type: 'spacer',
          flex: 1
        }, {
          text: 'Prev',
          name: 'prev',
          disabled: true,
          onclick: function onclick() {
            $_6b28psjzjk26xkfh.prev(editor, currentIndexState);
            updateButtonStates();
          }
        }, {
          text: 'Next',
          name: 'next',
          disabled: true,
          onclick: function onclick() {
            $_6b28psjzjk26xkfh.next(editor, currentIndexState);
            updateButtonStates();
          }
        }],
        title: 'Find and replace',
        items: {
          type: 'form',
          padding: 20,
          labelGap: 30,
          spacing: 10,
          items: [{
            type: 'textbox',
            name: 'find',
            size: 40,
            label: 'Find',
            value: selectedText
          }, {
            type: 'textbox',
            name: 'replace',
            size: 40,
            label: 'Replace with'
          }, {
            type: 'checkbox',
            name: 'case',
            text: 'Match case',
            label: ' '
          }, {
            type: 'checkbox',
            name: 'words',
            text: 'Whole words',
            label: ' '
          }]
        }
      });
    };
    var $_1tui85k3jk26xkft = { open: open };

    var register = function register(editor, currentIndexState) {
      editor.addCommand('SearchReplace', function () {
        $_1tui85k3jk26xkft.open(editor, currentIndexState);
      });
    };
    var $_8yw9lok2jk26xkfs = { register: register };

    var showDialog = function showDialog(editor, currentIndexState) {
      return function () {
        $_1tui85k3jk26xkft.open(editor, currentIndexState);
      };
    };
    var register$1 = function register$1(editor, currentIndexState) {
      editor.addMenuItem('searchreplace', {
        text: 'Find and replace',
        shortcut: 'Meta+F',
        onclick: showDialog(editor, currentIndexState),
        separator: 'before',
        context: 'edit'
      });
      editor.addButton('searchreplace', {
        tooltip: 'Find and replace',
        onclick: showDialog(editor, currentIndexState)
      });
      editor.shortcuts.add('Meta+F', '', showDialog(editor, currentIndexState));
    };
    var $_vo6bxk4jk26xkg1 = { register: register$1 };

    global.add('searchreplace', function (editor) {
      var currentIndexState = Cell(-1);
      $_8yw9lok2jk26xkfs.register(editor, currentIndexState);
      $_vo6bxk4jk26xkg1.register(editor, currentIndexState);
      return $_k7y3vjyjk26xkff.get(editor, currentIndexState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 989 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/tabfocus/index.js ***!
  \********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "tabfocus" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/tabfocus')
//   ES2015:
//     import 'tinymce/plugins/tabfocus'
__webpack_require__(/*! ./plugin.js */ 990);

/***/ }),
/* 990 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/tabfocus/plugin.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var tabfocus = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.EditorManager');

    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$6 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var getTabFocusElements = function getTabFocusElements(editor) {
      return editor.getParam('tabfocus_elements', ':prev,:next');
    };
    var getTabFocus = function getTabFocus(editor) {
      return editor.getParam('tab_focus', getTabFocusElements(editor));
    };
    var $_95v23kwjk26xkk9 = { getTabFocus: getTabFocus };

    var DOM = global$1.DOM;
    var tabCancel = function tabCancel(e) {
      if (e.keyCode === global$6.TAB && !e.ctrlKey && !e.altKey && !e.metaKey) {
        e.preventDefault();
      }
    };
    var setup = function setup(editor) {
      function tabHandler(e) {
        var x, el, v, i;
        if (e.keyCode !== global$6.TAB || e.ctrlKey || e.altKey || e.metaKey || e.isDefaultPrevented()) {
          return;
        }
        function find(direction) {
          el = DOM.select(':input:enabled,*[tabindex]:not(iframe)');
          function canSelectRecursive(e) {
            return e.nodeName === 'BODY' || e.type !== 'hidden' && e.style.display !== 'none' && e.style.visibility !== 'hidden' && canSelectRecursive(e.parentNode);
          }
          function canSelect(el) {
            return (/INPUT|TEXTAREA|BUTTON/.test(el.tagName) && global$2.get(e.id) && el.tabIndex !== -1 && canSelectRecursive(el)
            );
          }
          global$5.each(el, function (e, i) {
            if (e.id === editor.id) {
              x = i;
              return false;
            }
          });
          if (direction > 0) {
            for (i = x + 1; i < el.length; i++) {
              if (canSelect(el[i])) {
                return el[i];
              }
            }
          } else {
            for (i = x - 1; i >= 0; i--) {
              if (canSelect(el[i])) {
                return el[i];
              }
            }
          }
          return null;
        }
        v = global$5.explode($_95v23kwjk26xkk9.getTabFocus(editor));
        if (v.length === 1) {
          v[1] = v[0];
          v[0] = ':prev';
        }
        if (e.shiftKey) {
          if (v[0] === ':prev') {
            el = find(-1);
          } else {
            el = DOM.get(v[0]);
          }
        } else {
          if (v[1] === ':next') {
            el = find(1);
          } else {
            el = DOM.get(v[1]);
          }
        }
        if (el) {
          var focusEditor = global$2.get(el.id || el.name);
          if (el.id && focusEditor) {
            focusEditor.focus();
          } else {
            global$4.setTimeout(function () {
              if (!global$3.webkit) {
                window.focus();
              }
              el.focus();
            }, 10);
          }
          e.preventDefault();
        }
      }
      editor.on('init', function () {
        if (editor.inline) {
          DOM.setAttrib(editor.getBody(), 'tabIndex', null);
        }
        editor.on('keyup', tabCancel);
        if (global$3.gecko) {
          editor.on('keypress keydown', tabHandler);
        } else {
          editor.on('keydown', tabHandler);
        }
      });
    };
    var $_blz928kpjk26xkk4 = { setup: setup };

    global.add('tabfocus', function (editor) {
      $_blz928kpjk26xkk4.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 991 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/template/index.js ***!
  \********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "template" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/template')
//   ES2015:
//     import 'tinymce/plugins/template'
__webpack_require__(/*! ./plugin.js */ 992);

/***/ }),
/* 992 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/template/plugin.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var template = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var getCreationDateClasses = function getCreationDateClasses(editor) {
      return editor.getParam('template_cdate_classes', 'cdate');
    };
    var getModificationDateClasses = function getModificationDateClasses(editor) {
      return editor.getParam('template_mdate_classes', 'mdate');
    };
    var getSelectedContentClasses = function getSelectedContentClasses(editor) {
      return editor.getParam('template_selected_content_classes', 'selcontent');
    };
    var getPreviewReplaceValues = function getPreviewReplaceValues(editor) {
      return editor.getParam('template_preview_replace_values');
    };
    var getTemplateReplaceValues = function getTemplateReplaceValues(editor) {
      return editor.getParam('template_replace_values');
    };
    var getTemplates = function getTemplates(editorSettings) {
      return editorSettings.templates;
    };
    var getCdateFormat = function getCdateFormat(editor) {
      return editor.getParam('template_cdate_format', editor.getLang('template.cdate_format'));
    };
    var getMdateFormat = function getMdateFormat(editor) {
      return editor.getParam('template_mdate_format', editor.getLang('template.mdate_format'));
    };
    var getDialogWidth = function getDialogWidth(editor) {
      return editor.getParam('template_popup_width', 600);
    };
    var getDialogHeight = function getDialogHeight(editor) {
      return Math.min(global$3.DOM.getViewPort().h, editor.getParam('template_popup_height', 500));
    };
    var $_6umapdr9jk26xmr3 = {
      getCreationDateClasses: getCreationDateClasses,
      getModificationDateClasses: getModificationDateClasses,
      getSelectedContentClasses: getSelectedContentClasses,
      getPreviewReplaceValues: getPreviewReplaceValues,
      getTemplateReplaceValues: getTemplateReplaceValues,
      getTemplates: getTemplates,
      getCdateFormat: getCdateFormat,
      getMdateFormat: getMdateFormat,
      getDialogWidth: getDialogWidth,
      getDialogHeight: getDialogHeight
    };

    var addZeros = function addZeros(value, len) {
      value = '' + value;
      if (value.length < len) {
        for (var i = 0; i < len - value.length; i++) {
          value = '0' + value;
        }
      }
      return value;
    };
    var getDateTime = function getDateTime(editor, fmt, date) {
      var daysShort = 'Sun Mon Tue Wed Thu Fri Sat Sun'.split(' ');
      var daysLong = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday'.split(' ');
      var monthsShort = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
      var monthsLong = 'January February March April May June July August September October November December'.split(' ');
      date = date || new Date();
      fmt = fmt.replace('%D', '%m/%d/%Y');
      fmt = fmt.replace('%r', '%I:%M:%S %p');
      fmt = fmt.replace('%Y', '' + date.getFullYear());
      fmt = fmt.replace('%y', '' + date.getYear());
      fmt = fmt.replace('%m', addZeros(date.getMonth() + 1, 2));
      fmt = fmt.replace('%d', addZeros(date.getDate(), 2));
      fmt = fmt.replace('%H', '' + addZeros(date.getHours(), 2));
      fmt = fmt.replace('%M', '' + addZeros(date.getMinutes(), 2));
      fmt = fmt.replace('%S', '' + addZeros(date.getSeconds(), 2));
      fmt = fmt.replace('%I', '' + ((date.getHours() + 11) % 12 + 1));
      fmt = fmt.replace('%p', '' + (date.getHours() < 12 ? 'AM' : 'PM'));
      fmt = fmt.replace('%B', '' + editor.translate(monthsLong[date.getMonth()]));
      fmt = fmt.replace('%b', '' + editor.translate(monthsShort[date.getMonth()]));
      fmt = fmt.replace('%A', '' + editor.translate(daysLong[date.getDay()]));
      fmt = fmt.replace('%a', '' + editor.translate(daysShort[date.getDay()]));
      fmt = fmt.replace('%%', '%');
      return fmt;
    };
    var $_bopocyrbjk26xmr5 = { getDateTime: getDateTime };

    var createTemplateList = function createTemplateList(editorSettings, callback) {
      return function () {
        var templateList = $_6umapdr9jk26xmr3.getTemplates(editorSettings);
        if (typeof templateList === 'function') {
          templateList(callback);
          return;
        }
        if (typeof templateList === 'string') {
          global$2.send({
            url: templateList,
            success: function success(text) {
              callback(JSON.parse(text));
            }
          });
        } else {
          callback(templateList);
        }
      };
    };
    var replaceTemplateValues = function replaceTemplateValues(editor, html, templateValues) {
      global$1.each(templateValues, function (v, k) {
        if (typeof v === 'function') {
          v = v(k);
        }
        html = html.replace(new RegExp('\\{\\$' + k + '\\}', 'g'), v);
      });
      return html;
    };
    var replaceVals = function replaceVals(editor, e) {
      var dom = editor.dom,
          vl = $_6umapdr9jk26xmr3.getTemplateReplaceValues(editor);
      global$1.each(dom.select('*', e), function (e) {
        global$1.each(vl, function (v, k) {
          if (dom.hasClass(e, k)) {
            if (typeof vl[k] === 'function') {
              vl[k](e);
            }
          }
        });
      });
    };
    var hasClass = function hasClass(n, c) {
      return new RegExp('\\b' + c + '\\b', 'g').test(n.className);
    };
    var insertTemplate = function insertTemplate(editor, ui, html) {
      var el;
      var n;
      var dom = editor.dom;
      var sel = editor.selection.getContent();
      html = replaceTemplateValues(editor, html, $_6umapdr9jk26xmr3.getTemplateReplaceValues(editor));
      el = dom.create('div', null, html);
      n = dom.select('.mceTmpl', el);
      if (n && n.length > 0) {
        el = dom.create('div', null);
        el.appendChild(n[0].cloneNode(true));
      }
      global$1.each(dom.select('*', el), function (n) {
        if (hasClass(n, $_6umapdr9jk26xmr3.getCreationDateClasses(editor).replace(/\s+/g, '|'))) {
          n.innerHTML = $_bopocyrbjk26xmr5.getDateTime(editor, $_6umapdr9jk26xmr3.getCdateFormat(editor));
        }
        if (hasClass(n, $_6umapdr9jk26xmr3.getModificationDateClasses(editor).replace(/\s+/g, '|'))) {
          n.innerHTML = $_bopocyrbjk26xmr5.getDateTime(editor, $_6umapdr9jk26xmr3.getMdateFormat(editor));
        }
        if (hasClass(n, $_6umapdr9jk26xmr3.getSelectedContentClasses(editor).replace(/\s+/g, '|'))) {
          n.innerHTML = sel;
        }
      });
      replaceVals(editor, el);
      editor.execCommand('mceInsertContent', false, el.innerHTML);
      editor.addVisual();
    };
    var $_a1x6hwr6jk26xmr0 = {
      createTemplateList: createTemplateList,
      replaceTemplateValues: replaceTemplateValues,
      replaceVals: replaceVals,
      insertTemplate: insertTemplate
    };

    var register = function register(editor) {
      editor.addCommand('mceInsertTemplate', curry($_a1x6hwr6jk26xmr0.insertTemplate, editor));
    };
    var $_91oh4jr4jk26xmqs = { register: register };

    var setup = function setup(editor) {
      editor.on('PreProcess', function (o) {
        var dom = editor.dom,
            dateFormat = $_6umapdr9jk26xmr3.getMdateFormat(editor);
        global$1.each(dom.select('div', o.node), function (e) {
          if (dom.hasClass(e, 'mceTmpl')) {
            global$1.each(dom.select('*', e), function (e) {
              if (dom.hasClass(e, editor.getParam('template_mdate_classes', 'mdate').replace(/\s+/g, '|'))) {
                e.innerHTML = $_bopocyrbjk26xmr5.getDateTime(editor, dateFormat);
              }
            });
            $_a1x6hwr6jk26xmr0.replaceVals(editor, e);
          }
        });
      });
    };
    var $_7lfk72rcjk26xmr7 = { setup: setup };

    var insertIframeHtml = function insertIframeHtml(editor, win, html) {
      if (html.indexOf('<html>') === -1) {
        var contentCssLinks_1 = '';
        global$1.each(editor.contentCSS, function (url) {
          contentCssLinks_1 += '<link type="text/css" rel="stylesheet" href="' + editor.documentBaseURI.toAbsolute(url) + '">';
        });
        var bodyClass = editor.settings.body_class || '';
        if (bodyClass.indexOf('=') !== -1) {
          bodyClass = editor.getParam('body_class', '', 'hash');
          bodyClass = bodyClass[editor.id] || '';
        }
        html = '<!DOCTYPE html>' + '<html>' + '<head>' + contentCssLinks_1 + '</head>' + '<body class="' + bodyClass + '">' + html + '</body>' + '</html>';
      }
      html = $_a1x6hwr6jk26xmr0.replaceTemplateValues(editor, html, $_6umapdr9jk26xmr3.getPreviewReplaceValues(editor));
      var doc = win.find('iframe')[0].getEl().contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    };
    var open = function open(editor, templateList) {
      var win;
      var values = [];
      var templateHtml;
      if (!templateList || templateList.length === 0) {
        var message = editor.translate('No templates defined.');
        editor.notificationManager.open({
          text: message,
          type: 'info'
        });
        return;
      }
      global$1.each(templateList, function (template) {
        values.push({
          selected: !values.length,
          text: template.title,
          value: {
            url: template.url,
            content: template.content,
            description: template.description
          }
        });
      });
      var onSelectTemplate = function onSelectTemplate(e) {
        var value = e.control.value();
        if (value.url) {
          global$2.send({
            url: value.url,
            success: function success(html) {
              templateHtml = html;
              insertIframeHtml(editor, win, templateHtml);
            }
          });
        } else {
          templateHtml = value.content;
          insertIframeHtml(editor, win, templateHtml);
        }
        win.find('#description')[0].text(e.control.value().description);
      };
      win = editor.windowManager.open({
        title: 'Insert template',
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        padding: 15,
        spacing: 10,
        items: [{
          type: 'form',
          flex: 0,
          padding: 0,
          items: [{
            type: 'container',
            label: 'Templates',
            items: {
              type: 'listbox',
              label: 'Templates',
              name: 'template',
              values: values,
              onselect: onSelectTemplate
            }
          }]
        }, {
          type: 'label',
          name: 'description',
          label: 'Description',
          text: '\xA0'
        }, {
          type: 'iframe',
          flex: 1,
          border: 1
        }],
        onsubmit: function onsubmit() {
          $_a1x6hwr6jk26xmr0.insertTemplate(editor, false, templateHtml);
        },
        minWidth: $_6umapdr9jk26xmr3.getDialogWidth(editor),
        minHeight: $_6umapdr9jk26xmr3.getDialogHeight(editor)
      });
      win.find('listbox')[0].fire('select');
    };
    var $_ej0i39rejk26xmra = { open: open };

    var showDialog = function showDialog(editor) {
      return function (templates) {
        $_ej0i39rejk26xmra.open(editor, templates);
      };
    };
    var register$1 = function register$1(editor) {
      editor.addButton('template', {
        title: 'Insert template',
        onclick: $_a1x6hwr6jk26xmr0.createTemplateList(editor.settings, showDialog(editor))
      });
      editor.addMenuItem('template', {
        text: 'Template',
        onclick: $_a1x6hwr6jk26xmr0.createTemplateList(editor.settings, showDialog(editor)),
        icon: 'template',
        context: 'insert'
      });
    };
    var $_feplhyrdjk26xmr9 = { register: register$1 };

    global.add('template', function (editor) {
      $_feplhyrdjk26xmr9.register(editor);
      $_91oh4jr4jk26xmqs.register(editor);
      $_7lfk72rcjk26xmr7.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 993 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/textpattern/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "textpattern" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/textpattern')
//   ES2015:
//     import 'tinymce/plugins/textpattern'
__webpack_require__(/*! ./plugin.js */ 994);

/***/ }),
/* 994 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/textpattern/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var textpattern = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var get = function get(patternsState) {
      var setPatterns = function setPatterns(newPatterns) {
        patternsState.set(newPatterns);
      };
      var getPatterns = function getPatterns() {
        return patternsState.get();
      };
      return {
        setPatterns: setPatterns,
        getPatterns: getPatterns
      };
    };
    var $_57i5zzrsjk26xmta = { get: get };

    var defaultPatterns = [{
      start: '*',
      end: '*',
      format: 'italic'
    }, {
      start: '**',
      end: '**',
      format: 'bold'
    }, {
      start: '***',
      end: '***',
      format: ['bold', 'italic']
    }, {
      start: '#',
      format: 'h1'
    }, {
      start: '##',
      format: 'h2'
    }, {
      start: '###',
      format: 'h3'
    }, {
      start: '####',
      format: 'h4'
    }, {
      start: '#####',
      format: 'h5'
    }, {
      start: '######',
      format: 'h6'
    }, {
      start: '1. ',
      cmd: 'InsertOrderedList'
    }, {
      start: '* ',
      cmd: 'InsertUnorderedList'
    }, {
      start: '- ',
      cmd: 'InsertUnorderedList'
    }];
    var getPatterns = function getPatterns(editorSettings) {
      return editorSettings.textpattern_patterns !== undefined ? editorSettings.textpattern_patterns : defaultPatterns;
    };
    var $_55ui6nrtjk26xmtb = { getPatterns: getPatterns };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var sortPatterns = function sortPatterns(patterns) {
      return patterns.sort(function (a, b) {
        if (a.start.length > b.start.length) {
          return -1;
        }
        if (a.start.length < b.start.length) {
          return 1;
        }
        return 0;
      });
    };
    var findPattern = function findPattern(patterns, text) {
      for (var i = 0; i < patterns.length; i++) {
        if (text.indexOf(patterns[i].start) !== 0) {
          continue;
        }
        if (patterns[i].end && text.lastIndexOf(patterns[i].end) !== text.length - patterns[i].end.length) {
          continue;
        }
        return patterns[i];
      }
    };
    var isMatchingPattern = function isMatchingPattern(pattern, text, offset, delta) {
      var textEnd = text.substr(offset - pattern.end.length - delta, pattern.end.length);
      return textEnd === pattern.end;
    };
    var hasContent = function hasContent(offset, delta, pattern) {
      return offset - delta - pattern.end.length - pattern.start.length > 0;
    };
    var findEndPattern = function findEndPattern(patterns, text, offset, delta) {
      var pattern, i;
      var sortedPatterns = sortPatterns(patterns);
      for (i = 0; i < sortedPatterns.length; i++) {
        pattern = sortedPatterns[i];
        if (pattern.end !== undefined && isMatchingPattern(pattern, text, offset, delta) && hasContent(offset, delta, pattern)) {
          return pattern;
        }
      }
    };
    var $_5ywuexs1jk26xmto = {
      findPattern: findPattern,
      findEndPattern: findEndPattern
    };

    var splitContainer = function splitContainer(container, pattern, endOffset, startOffset, space) {
      container = startOffset > 0 ? container.splitText(startOffset) : container;
      container.splitText(endOffset - startOffset + pattern.end.length);
      container.deleteData(0, pattern.start.length);
      container.deleteData(container.data.length - pattern.end.length, pattern.end.length);
      return container;
    };
    var patternFromRng = function patternFromRng(patterns, rng, space) {
      if (rng.collapsed === false) {
        return;
      }
      var container = rng.startContainer;
      var text = container.data;
      var delta = space === true ? 1 : 0;
      if (container.nodeType !== 3) {
        return;
      }
      var endPattern = $_5ywuexs1jk26xmto.findEndPattern(patterns, text, rng.startOffset, delta);
      if (endPattern === undefined) {
        return;
      }
      var endOffset = text.lastIndexOf(endPattern.end, rng.startOffset - delta);
      var startOffset = text.lastIndexOf(endPattern.start, endOffset - endPattern.end.length);
      endOffset = text.indexOf(endPattern.end, startOffset + endPattern.start.length);
      if (startOffset === -1) {
        return;
      }
      var patternRng = document.createRange();
      patternRng.setStart(container, startOffset);
      patternRng.setEnd(container, endOffset + endPattern.end.length);
      var startPattern = $_5ywuexs1jk26xmto.findPattern(patterns, patternRng.toString());
      if (endPattern === undefined || startPattern !== endPattern || container.data.length <= endPattern.start.length + endPattern.end.length) {
        return;
      }
      return {
        pattern: endPattern,
        startOffset: startOffset,
        endOffset: endOffset
      };
    };
    var splitAndApply = function splitAndApply(editor, container, found, space) {
      var formatArray = global$4.isArray(found.pattern.format) ? found.pattern.format : [found.pattern.format];
      var validFormats = global$4.grep(formatArray, function (formatName) {
        var format = editor.formatter.get(formatName);
        return format && format[0].inline;
      });
      if (validFormats.length !== 0) {
        editor.undoManager.transact(function () {
          container = splitContainer(container, found.pattern, found.endOffset, found.startOffset, space);
          formatArray.forEach(function (format) {
            editor.formatter.apply(format, {}, container);
          });
        });
        return container;
      }
    };
    var doApplyInlineFormat = function doApplyInlineFormat(editor, patterns, space) {
      var rng = editor.selection.getRng(true);
      var foundPattern = patternFromRng(patterns, rng, space);
      if (foundPattern) {
        return splitAndApply(editor, rng.startContainer, foundPattern, space);
      }
    };
    var applyInlineFormatSpace = function applyInlineFormatSpace(editor, patterns) {
      return doApplyInlineFormat(editor, patterns, true);
    };
    var applyInlineFormatEnter = function applyInlineFormatEnter(editor, patterns) {
      return doApplyInlineFormat(editor, patterns, false);
    };
    var applyBlockFormat = function applyBlockFormat(editor, patterns) {
      var selection, dom, container, firstTextNode, node, format, textBlockElm, pattern, walker, rng, offset;
      selection = editor.selection;
      dom = editor.dom;
      if (!selection.isCollapsed()) {
        return;
      }
      textBlockElm = dom.getParent(selection.getStart(), 'p');
      if (textBlockElm) {
        walker = new global$3(textBlockElm, textBlockElm);
        while (node = walker.next()) {
          if (node.nodeType === 3) {
            firstTextNode = node;
            break;
          }
        }
        if (firstTextNode) {
          pattern = $_5ywuexs1jk26xmto.findPattern(patterns, firstTextNode.data);
          if (!pattern) {
            return;
          }
          rng = selection.getRng(true);
          container = rng.startContainer;
          offset = rng.startOffset;
          if (firstTextNode === container) {
            offset = Math.max(0, offset - pattern.start.length);
          }
          if (global$4.trim(firstTextNode.data).length === pattern.start.length) {
            return;
          }
          if (pattern.format) {
            format = editor.formatter.get(pattern.format);
            if (format && format[0].block) {
              firstTextNode.deleteData(0, pattern.start.length);
              editor.formatter.apply(pattern.format, {}, firstTextNode);
              rng.setStart(container, offset);
              rng.collapse(true);
              selection.setRng(rng);
            }
          }
          if (pattern.cmd) {
            editor.undoManager.transact(function () {
              firstTextNode.deleteData(0, pattern.start.length);
              editor.execCommand(pattern.cmd);
            });
          }
        }
      }
    };
    var $_cu0pjuryjk26xmti = {
      patternFromRng: patternFromRng,
      applyInlineFormatSpace: applyInlineFormatSpace,
      applyInlineFormatEnter: applyInlineFormatEnter,
      applyBlockFormat: applyBlockFormat
    };

    function handleEnter(editor, patterns) {
      var wrappedTextNode, rng;
      wrappedTextNode = $_cu0pjuryjk26xmti.applyInlineFormatEnter(editor, patterns);
      if (wrappedTextNode) {
        rng = editor.dom.createRng();
        rng.setStart(wrappedTextNode, wrappedTextNode.data.length);
        rng.setEnd(wrappedTextNode, wrappedTextNode.data.length);
        editor.selection.setRng(rng);
      }
      $_cu0pjuryjk26xmti.applyBlockFormat(editor, patterns);
    }
    function handleInlineKey(editor, patterns) {
      var wrappedTextNode, lastChar, lastCharNode, rng, dom;
      wrappedTextNode = $_cu0pjuryjk26xmti.applyInlineFormatSpace(editor, patterns);
      if (wrappedTextNode) {
        dom = editor.dom;
        lastChar = wrappedTextNode.data.slice(-1);
        if (/[\u00a0 ]/.test(lastChar)) {
          wrappedTextNode.deleteData(wrappedTextNode.data.length - 1, 1);
          lastCharNode = dom.doc.createTextNode(lastChar);
          dom.insertAfter(lastCharNode, wrappedTextNode.parentNode);
          rng = dom.createRng();
          rng.setStart(lastCharNode, 1);
          rng.setEnd(lastCharNode, 1);
          editor.selection.setRng(rng);
        }
      }
    }
    var checkKeyEvent = function checkKeyEvent(codes, event, predicate) {
      for (var i = 0; i < codes.length; i++) {
        if (predicate(codes[i], event)) {
          return true;
        }
      }
    };
    var checkKeyCode = function checkKeyCode(codes, event) {
      return checkKeyEvent(codes, event, function (code, event) {
        return code === event.keyCode && global$2.modifierPressed(event) === false;
      });
    };
    var checkCharCode = function checkCharCode(chars, event) {
      return checkKeyEvent(chars, event, function (chr, event) {
        return chr.charCodeAt(0) === event.charCode;
      });
    };
    var $_4eghm4rxjk26xmtf = {
      handleEnter: handleEnter,
      handleInlineKey: handleInlineKey,
      checkCharCode: checkCharCode,
      checkKeyCode: checkKeyCode
    };

    var setup = function setup(editor, patternsState) {
      var charCodes = [',', '.', ';', ':', '!', '?'];
      var keyCodes = [32];
      editor.on('keydown', function (e) {
        if (e.keyCode === 13 && !global$2.modifierPressed(e)) {
          $_4eghm4rxjk26xmtf.handleEnter(editor, patternsState.get());
        }
      }, true);
      editor.on('keyup', function (e) {
        if ($_4eghm4rxjk26xmtf.checkKeyCode(keyCodes, e)) {
          $_4eghm4rxjk26xmtf.handleInlineKey(editor, patternsState.get());
        }
      });
      editor.on('keypress', function (e) {
        if ($_4eghm4rxjk26xmtf.checkCharCode(charCodes, e)) {
          global$1.setEditorTimeout(editor, function () {
            $_4eghm4rxjk26xmtf.handleInlineKey(editor, patternsState.get());
          });
        }
      });
    };
    var $_aqx1bsrujk26xmtc = { setup: setup };

    global.add('textpattern', function (editor) {
      var patternsState = Cell($_55ui6nrtjk26xmtb.getPatterns(editor.settings));
      $_aqx1bsrujk26xmtc.setup(editor, patternsState);
      return $_57i5zzrsjk26xmta.get(patternsState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 995 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/visualblocks/index.js ***!
  \************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "visualblocks" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/visualblocks')
//   ES2015:
//     import 'tinymce/plugins/visualblocks'
__webpack_require__(/*! ./plugin.js */ 996);

/***/ }),
/* 996 */
/*!*************************************************************!*\
  !*** ./src/packages/tinymce/plugins/visualblocks/plugin.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var visualblocks = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var fireVisualBlocks = function fireVisualBlocks(editor, state) {
      editor.fire('VisualBlocks', { state: state });
    };
    var $_cqv52dsjjk26xmwd = { fireVisualBlocks: fireVisualBlocks };

    var isEnabledByDefault = function isEnabledByDefault(editor) {
      return editor.getParam('visualblocks_default_state', false);
    };
    var getContentCss = function getContentCss(editor) {
      return editor.settings.visualblocks_content_css;
    };
    var $_8wc6sgskjk26xmwe = {
      isEnabledByDefault: isEnabledByDefault,
      getContentCss: getContentCss
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var cssId = global$1.DOM.uniqueId();
    var load = function load(doc, url) {
      var linkElements = global$2.toArray(doc.getElementsByTagName('link'));
      var matchingLinkElms = global$2.grep(linkElements, function (head) {
        return head.id === cssId;
      });
      if (matchingLinkElms.length === 0) {
        var linkElm = global$1.DOM.create('link', {
          id: cssId,
          rel: 'stylesheet',
          href: url
        });
        doc.getElementsByTagName('head')[0].appendChild(linkElm);
      }
    };
    var $_4rvx3jsljk26xmwf = { load: load };

    var toggleVisualBlocks = function toggleVisualBlocks(editor, pluginUrl, enabledState) {
      var dom = editor.dom;
      var contentCss = $_8wc6sgskjk26xmwe.getContentCss(editor);
      $_4rvx3jsljk26xmwf.load(editor.getDoc(), contentCss ? contentCss : pluginUrl + '/css/visualblocks.css');
      dom.toggleClass(editor.getBody(), 'mce-visualblocks');
      enabledState.set(!enabledState.get());
      $_cqv52dsjjk26xmwd.fireVisualBlocks(editor, enabledState.get());
    };
    var $_8ckj98sijk26xmwc = { toggleVisualBlocks: toggleVisualBlocks };

    var register = function register(editor, pluginUrl, enabledState) {
      editor.addCommand('mceVisualBlocks', function () {
        $_8ckj98sijk26xmwc.toggleVisualBlocks(editor, pluginUrl, enabledState);
      });
    };
    var $_cfk29zshjk26xmwb = { register: register };

    var setup = function setup(editor, pluginUrl, enabledState) {
      editor.on('PreviewFormats AfterPreviewFormats', function (e) {
        if (enabledState.get()) {
          editor.dom.toggleClass(editor.getBody(), 'mce-visualblocks', e.type === 'afterpreviewformats');
        }
      });
      editor.on('init', function () {
        if ($_8wc6sgskjk26xmwe.isEnabledByDefault(editor)) {
          $_8ckj98sijk26xmwc.toggleVisualBlocks(editor, pluginUrl, enabledState);
        }
      });
      editor.on('remove', function () {
        editor.dom.removeClass(editor.getBody(), 'mce-visualblocks');
      });
    };
    var $_9cpk0wsojk26xmwg = { setup: setup };

    var toggleActiveState = function toggleActiveState(editor, enabledState) {
      return function (e) {
        var ctrl = e.control;
        ctrl.active(enabledState.get());
        editor.on('VisualBlocks', function (e) {
          ctrl.active(e.state);
        });
      };
    };
    var register$1 = function register$1(editor, enabledState) {
      editor.addButton('visualblocks', {
        active: false,
        title: 'Show blocks',
        cmd: 'mceVisualBlocks',
        onPostRender: toggleActiveState(editor, enabledState)
      });
      editor.addMenuItem('visualblocks', {
        text: 'Show blocks',
        cmd: 'mceVisualBlocks',
        onPostRender: toggleActiveState(editor, enabledState),
        selectable: true,
        context: 'view',
        prependToContext: true
      });
    };
    var $_7uxof5spjk26xmwi = { register: register$1 };

    global.add('visualblocks', function (editor, pluginUrl) {
      var enabledState = Cell(false);
      $_cfk29zshjk26xmwb.register(editor, pluginUrl, enabledState);
      $_7uxof5spjk26xmwi.register(editor, enabledState);
      $_9cpk0wsojk26xmwg.setup(editor, pluginUrl, enabledState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 997 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/anchor/index.js ***!
  \******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "anchor" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/anchor')
//   ES2015:
//     import 'tinymce/plugins/anchor'
__webpack_require__(/*! ./plugin.js */ 998);

/***/ }),
/* 998 */
/*!*******************************************************!*\
  !*** ./src/packages/tinymce/plugins/anchor/plugin.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var anchor = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var isValidId = function isValidId(id) {
      return (/^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id)
      );
    };
    var getId = function getId(editor) {
      var selectedNode = editor.selection.getNode();
      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
      return isAnchor ? selectedNode.id || selectedNode.name : '';
    };
    var insert = function insert(editor, id) {
      var selectedNode = editor.selection.getNode();
      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
      if (isAnchor) {
        selectedNode.removeAttribute('name');
        selectedNode.id = id;
        editor.undoManager.add();
      } else {
        editor.focus();
        editor.selection.collapse(true);
        editor.execCommand('mceInsertContent', false, editor.dom.createHTML('a', { id: id }));
      }
    };
    var $_bgr5kt8ojk26xipg = {
      isValidId: isValidId,
      getId: getId,
      insert: insert
    };

    var insertAnchor = function insertAnchor(editor, newId) {
      if (!$_bgr5kt8ojk26xipg.isValidId(newId)) {
        editor.windowManager.alert('Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.');
        return true;
      } else {
        $_bgr5kt8ojk26xipg.insert(editor, newId);
        return false;
      }
    };
    var open = function open(editor) {
      var currentId = $_bgr5kt8ojk26xipg.getId(editor);
      editor.windowManager.open({
        title: 'Anchor',
        body: {
          type: 'textbox',
          name: 'id',
          size: 40,
          label: 'Id',
          value: currentId
        },
        onsubmit: function onsubmit(e) {
          var newId = e.data.id;
          if (insertAnchor(editor, newId)) {
            e.preventDefault();
          }
        }
      });
    };
    var $_fth2zb8njk26xipe = { open: open };

    var register = function register(editor) {
      editor.addCommand('mceAnchor', function () {
        $_fth2zb8njk26xipe.open(editor);
      });
    };
    var $_chmnre8mjk26xipd = { register: register };

    var isAnchorNode = function isAnchorNode(node) {
      return !node.attr('href') && (node.attr('id') || node.attr('name')) && !node.firstChild;
    };
    var setContentEditable = function setContentEditable(state) {
      return function (nodes) {
        for (var i = 0; i < nodes.length; i++) {
          if (isAnchorNode(nodes[i])) {
            nodes[i].attr('contenteditable', state);
          }
        }
      };
    };
    var setup = function setup(editor) {
      editor.on('PreInit', function () {
        editor.parser.addNodeFilter('a', setContentEditable('false'));
        editor.serializer.addNodeFilter('a', setContentEditable(null));
      });
    };
    var $_2bkf878pjk26xipi = { setup: setup };

    var register$1 = function register$1(editor) {
      editor.addButton('anchor', {
        icon: 'anchor',
        tooltip: 'Anchor',
        cmd: 'mceAnchor',
        stateSelector: 'a:not([href])'
      });
      editor.addMenuItem('anchor', {
        icon: 'anchor',
        text: 'Anchor',
        context: 'insert',
        cmd: 'mceAnchor'
      });
    };
    var $_dqhk4r8qjk26xipj = { register: register$1 };

    global.add('anchor', function (editor) {
      $_2bkf878pjk26xipi.setup(editor);
      $_chmnre8mjk26xipd.register(editor);
      $_dqhk4r8qjk26xipj.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 999 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autoresize/index.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "autoresize" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autoresize')
//   ES2015:
//     import 'tinymce/plugins/autoresize'
__webpack_require__(/*! ./plugin.js */ 1000);

/***/ }),
/* 1000 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/autoresize/plugin.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var autoresize = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var getAutoResizeMinHeight = function getAutoResizeMinHeight(editor) {
      return parseInt(editor.getParam('autoresize_min_height', editor.getElement().offsetHeight), 10);
    };
    var getAutoResizeMaxHeight = function getAutoResizeMaxHeight(editor) {
      return parseInt(editor.getParam('autoresize_max_height', 0), 10);
    };
    var getAutoResizeOverflowPadding = function getAutoResizeOverflowPadding(editor) {
      return editor.getParam('autoresize_overflow_padding', 1);
    };
    var getAutoResizeBottomMargin = function getAutoResizeBottomMargin(editor) {
      return editor.getParam('autoresize_bottom_margin', 50);
    };
    var shouldAutoResizeOnInit = function shouldAutoResizeOnInit(editor) {
      return editor.getParam('autoresize_on_init', true);
    };
    var $_3rx7y893jk26xiqt = {
      getAutoResizeMinHeight: getAutoResizeMinHeight,
      getAutoResizeMaxHeight: getAutoResizeMaxHeight,
      getAutoResizeOverflowPadding: getAutoResizeOverflowPadding,
      getAutoResizeBottomMargin: getAutoResizeBottomMargin,
      shouldAutoResizeOnInit: shouldAutoResizeOnInit
    };

    var isFullscreen = function isFullscreen(editor) {
      return editor.plugins.fullscreen && editor.plugins.fullscreen.isFullscreen();
    };
    var wait = function wait(editor, oldSize, times, interval, callback) {
      global$2.setEditorTimeout(editor, function () {
        resize(editor, oldSize);
        if (times--) {
          wait(editor, oldSize, times, interval, callback);
        } else if (callback) {
          callback();
        }
      }, interval);
    };
    var toggleScrolling = function toggleScrolling(editor, state) {
      var body = editor.getBody();
      if (body) {
        body.style.overflowY = state ? '' : 'hidden';
        if (!state) {
          body.scrollTop = 0;
        }
      }
    };
    var resize = function resize(editor, oldSize) {
      var deltaSize, doc, body, resizeHeight, myHeight;
      var marginTop, marginBottom, paddingTop, paddingBottom, borderTop, borderBottom;
      var dom = editor.dom;
      doc = editor.getDoc();
      if (!doc) {
        return;
      }
      if (isFullscreen(editor)) {
        toggleScrolling(editor, true);
        return;
      }
      body = doc.body;
      resizeHeight = $_3rx7y893jk26xiqt.getAutoResizeMinHeight(editor);
      marginTop = dom.getStyle(body, 'margin-top', true);
      marginBottom = dom.getStyle(body, 'margin-bottom', true);
      paddingTop = dom.getStyle(body, 'padding-top', true);
      paddingBottom = dom.getStyle(body, 'padding-bottom', true);
      borderTop = dom.getStyle(body, 'border-top-width', true);
      borderBottom = dom.getStyle(body, 'border-bottom-width', true);
      myHeight = body.offsetHeight + parseInt(marginTop, 10) + parseInt(marginBottom, 10) + parseInt(paddingTop, 10) + parseInt(paddingBottom, 10) + parseInt(borderTop, 10) + parseInt(borderBottom, 10);
      if (isNaN(myHeight) || myHeight <= 0) {
        myHeight = global$1.ie ? body.scrollHeight : global$1.webkit && body.clientHeight === 0 ? 0 : body.offsetHeight;
      }
      if (myHeight > $_3rx7y893jk26xiqt.getAutoResizeMinHeight(editor)) {
        resizeHeight = myHeight;
      }
      var maxHeight = $_3rx7y893jk26xiqt.getAutoResizeMaxHeight(editor);
      if (maxHeight && myHeight > maxHeight) {
        resizeHeight = maxHeight;
        toggleScrolling(editor, true);
      } else {
        toggleScrolling(editor, false);
      }
      if (resizeHeight !== oldSize.get()) {
        deltaSize = resizeHeight - oldSize.get();
        dom.setStyle(editor.iframeElement, 'height', resizeHeight + 'px');
        oldSize.set(resizeHeight);
        if (global$1.webkit && deltaSize < 0) {
          resize(editor, oldSize);
        }
      }
    };
    var setup = function setup(editor, oldSize) {
      editor.on('init', function () {
        var overflowPadding, bottomMargin;
        var dom = editor.dom;
        overflowPadding = $_3rx7y893jk26xiqt.getAutoResizeOverflowPadding(editor);
        bottomMargin = $_3rx7y893jk26xiqt.getAutoResizeBottomMargin(editor);
        if (overflowPadding !== false) {
          dom.setStyles(editor.getBody(), {
            paddingLeft: overflowPadding,
            paddingRight: overflowPadding
          });
        }
        if (bottomMargin !== false) {
          dom.setStyles(editor.getBody(), { paddingBottom: bottomMargin });
        }
      });
      editor.on('nodechange setcontent keyup FullscreenStateChanged', function (e) {
        resize(editor, oldSize);
      });
      if ($_3rx7y893jk26xiqt.shouldAutoResizeOnInit(editor)) {
        editor.on('init', function () {
          wait(editor, oldSize, 20, 100, function () {
            wait(editor, oldSize, 5, 1000);
          });
        });
      }
    };
    var $_bh638y90jk26xiqp = {
      setup: setup,
      resize: resize
    };

    var register = function register(editor, oldSize) {
      editor.addCommand('mceAutoResize', function () {
        $_bh638y90jk26xiqp.resize(editor, oldSize);
      });
    };
    var $_dspxuf8zjk26xiqn = { register: register };

    global.add('autoresize', function (editor) {
      if (!editor.inline) {
        var oldSize = Cell(0);
        $_dspxuf8zjk26xiqn.register(editor, oldSize);
        $_bh638y90jk26xiqp.setup(editor, oldSize);
      }
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1001 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/bbcode/index.js ***!
  \******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "bbcode" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/bbcode')
//   ES2015:
//     import 'tinymce/plugins/bbcode'
__webpack_require__(/*! ./plugin.js */ 1002);

/***/ }),
/* 1002 */
/*!*******************************************************!*\
  !*** ./src/packages/tinymce/plugins/bbcode/plugin.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var bbcode = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var html2bbcode = function html2bbcode(s) {
      s = global$1.trim(s);
      var rep = function rep(re, str) {
        s = s.replace(re, str);
      };
      rep(/<a.*?href=\"(.*?)\".*?>(.*?)<\/a>/gi, '[url=$1]$2[/url]');
      rep(/<font.*?color=\"(.*?)\".*?class=\"codeStyle\".*?>(.*?)<\/font>/gi, '[code][color=$1]$2[/color][/code]');
      rep(/<font.*?color=\"(.*?)\".*?class=\"quoteStyle\".*?>(.*?)<\/font>/gi, '[quote][color=$1]$2[/color][/quote]');
      rep(/<font.*?class=\"codeStyle\".*?color=\"(.*?)\".*?>(.*?)<\/font>/gi, '[code][color=$1]$2[/color][/code]');
      rep(/<font.*?class=\"quoteStyle\".*?color=\"(.*?)\".*?>(.*?)<\/font>/gi, '[quote][color=$1]$2[/color][/quote]');
      rep(/<span style=\"color: ?(.*?);\">(.*?)<\/span>/gi, '[color=$1]$2[/color]');
      rep(/<font.*?color=\"(.*?)\".*?>(.*?)<\/font>/gi, '[color=$1]$2[/color]');
      rep(/<span style=\"font-size:(.*?);\">(.*?)<\/span>/gi, '[size=$1]$2[/size]');
      rep(/<font>(.*?)<\/font>/gi, '$1');
      rep(/<img.*?src=\"(.*?)\".*?\/>/gi, '[img]$1[/img]');
      rep(/<span class=\"codeStyle\">(.*?)<\/span>/gi, '[code]$1[/code]');
      rep(/<span class=\"quoteStyle\">(.*?)<\/span>/gi, '[quote]$1[/quote]');
      rep(/<strong class=\"codeStyle\">(.*?)<\/strong>/gi, '[code][b]$1[/b][/code]');
      rep(/<strong class=\"quoteStyle\">(.*?)<\/strong>/gi, '[quote][b]$1[/b][/quote]');
      rep(/<em class=\"codeStyle\">(.*?)<\/em>/gi, '[code][i]$1[/i][/code]');
      rep(/<em class=\"quoteStyle\">(.*?)<\/em>/gi, '[quote][i]$1[/i][/quote]');
      rep(/<u class=\"codeStyle\">(.*?)<\/u>/gi, '[code][u]$1[/u][/code]');
      rep(/<u class=\"quoteStyle\">(.*?)<\/u>/gi, '[quote][u]$1[/u][/quote]');
      rep(/<\/(strong|b)>/gi, '[/b]');
      rep(/<(strong|b)>/gi, '[b]');
      rep(/<\/(em|i)>/gi, '[/i]');
      rep(/<(em|i)>/gi, '[i]');
      rep(/<\/u>/gi, '[/u]');
      rep(/<span style=\"text-decoration: ?underline;\">(.*?)<\/span>/gi, '[u]$1[/u]');
      rep(/<u>/gi, '[u]');
      rep(/<blockquote[^>]*>/gi, '[quote]');
      rep(/<\/blockquote>/gi, '[/quote]');
      rep(/<br \/>/gi, '\n');
      rep(/<br\/>/gi, '\n');
      rep(/<br>/gi, '\n');
      rep(/<p>/gi, '');
      rep(/<\/p>/gi, '\n');
      rep(/&nbsp;|\u00a0/gi, ' ');
      rep(/&quot;/gi, '"');
      rep(/&lt;/gi, '<');
      rep(/&gt;/gi, '>');
      rep(/&amp;/gi, '&');
      return s;
    };
    var bbcode2html = function bbcode2html(s) {
      s = global$1.trim(s);
      var rep = function rep(re, str) {
        s = s.replace(re, str);
      };
      rep(/\n/gi, '<br />');
      rep(/\[b\]/gi, '<strong>');
      rep(/\[\/b\]/gi, '</strong>');
      rep(/\[i\]/gi, '<em>');
      rep(/\[\/i\]/gi, '</em>');
      rep(/\[u\]/gi, '<u>');
      rep(/\[\/u\]/gi, '</u>');
      rep(/\[url=([^\]]+)\](.*?)\[\/url\]/gi, '<a href="$1">$2</a>');
      rep(/\[url\](.*?)\[\/url\]/gi, '<a href="$1">$1</a>');
      rep(/\[img\](.*?)\[\/img\]/gi, '<img src="$1" />');
      rep(/\[color=(.*?)\](.*?)\[\/color\]/gi, '<font color="$1">$2</font>');
      rep(/\[code\](.*?)\[\/code\]/gi, '<span class="codeStyle">$1</span>&nbsp;');
      rep(/\[quote.*?\](.*?)\[\/quote\]/gi, '<span class="quoteStyle">$1</span>&nbsp;');
      return s;
    };
    var $_5wbj8o9kjk26xith = {
      html2bbcode: html2bbcode,
      bbcode2html: bbcode2html
    };

    global.add('bbcode', function () {
      return {
        init: function init(editor) {
          editor.on('beforeSetContent', function (e) {
            e.content = $_5wbj8o9kjk26xith.bbcode2html(e.content);
          });
          editor.on('postProcess', function (e) {
            if (e.set) {
              e.content = $_5wbj8o9kjk26xith.bbcode2html(e.content);
            }
            if (e.get) {
              e.content = $_5wbj8o9kjk26xith.html2bbcode(e.content);
            }
          });
        }
      };
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1003 */
/*!****************************************************!*\
  !*** ./src/packages/tinymce/plugins/code/index.js ***!
  \****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "code" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/code')
//   ES2015:
//     import 'tinymce/plugins/code'
__webpack_require__(/*! ./plugin.js */ 1004);

/***/ }),
/* 1004 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/code/plugin.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var code = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var getMinWidth = function getMinWidth(editor) {
      return editor.getParam('code_dialog_width', 600);
    };
    var getMinHeight = function getMinHeight(editor) {
      return editor.getParam('code_dialog_height', Math.min(global$1.DOM.getViewPort().h - 200, 500));
    };
    var $_byxbroa2jk26xivd = {
      getMinWidth: getMinWidth,
      getMinHeight: getMinHeight
    };

    var setContent = function setContent(editor, html) {
      editor.focus();
      editor.undoManager.transact(function () {
        editor.setContent(html);
      });
      editor.selection.setCursorLocation();
      editor.nodeChanged();
    };
    var getContent = function getContent(editor) {
      return editor.getContent({ source_view: true });
    };
    var $_8bd43oa4jk26xivf = {
      setContent: setContent,
      getContent: getContent
    };

    var open = function open(editor) {
      var minWidth = $_byxbroa2jk26xivd.getMinWidth(editor);
      var minHeight = $_byxbroa2jk26xivd.getMinHeight(editor);
      var win = editor.windowManager.open({
        title: 'Source code',
        body: {
          type: 'textbox',
          name: 'code',
          multiline: true,
          minWidth: minWidth,
          minHeight: minHeight,
          spellcheck: false,
          style: 'direction: ltr; text-align: left'
        },
        onSubmit: function onSubmit(e) {
          $_8bd43oa4jk26xivf.setContent(editor, e.data.code);
        }
      });
      win.find('#code').value($_8bd43oa4jk26xivf.getContent(editor));
    };
    var $_3lhnq3a1jk26xiva = { open: open };

    var register = function register(editor) {
      editor.addCommand('mceCodeEditor', function () {
        $_3lhnq3a1jk26xiva.open(editor);
      });
    };
    var $_76xvz9a0jk26xiv9 = { register: register };

    var register$1 = function register$1(editor) {
      editor.addButton('code', {
        icon: 'code',
        tooltip: 'Source code',
        onclick: function onclick() {
          $_3lhnq3a1jk26xiva.open(editor);
        }
      });
      editor.addMenuItem('code', {
        icon: 'code',
        text: 'Source code',
        onclick: function onclick() {
          $_3lhnq3a1jk26xiva.open(editor);
        }
      });
    };
    var $_7q69y6a5jk26xivg = { register: register$1 };

    global.add('code', function (editor) {
      $_76xvz9a0jk26xiv9.register(editor);
      $_7q69y6a5jk26xivg.register(editor);
      return {};
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1005 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/colorpicker/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "colorpicker" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/colorpicker')
//   ES2015:
//     import 'tinymce/plugins/colorpicker'
__webpack_require__(/*! ./plugin.js */ 1006);

/***/ }),
/* 1006 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/colorpicker/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var colorpicker = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Color');

    var showPreview = function showPreview(win, hexColor) {
      win.find('#preview')[0].getEl().style.background = hexColor;
    };
    var setColor = function setColor(win, value) {
      var color = global$1(value),
          rgb = color.toRgb();
      win.fromJSON({
        r: rgb.r,
        g: rgb.g,
        b: rgb.b,
        hex: color.toHex().substr(1)
      });
      showPreview(win, color.toHex());
    };
    var open = function open(editor, callback, value) {
      var win = editor.windowManager.open({
        title: 'Color',
        items: {
          type: 'container',
          layout: 'flex',
          direction: 'row',
          align: 'stretch',
          padding: 5,
          spacing: 10,
          items: [{
            type: 'colorpicker',
            value: value,
            onchange: function onchange() {
              var rgb = this.rgb();
              if (win) {
                win.find('#r').value(rgb.r);
                win.find('#g').value(rgb.g);
                win.find('#b').value(rgb.b);
                win.find('#hex').value(this.value().substr(1));
                showPreview(win, this.value());
              }
            }
          }, {
            type: 'form',
            padding: 0,
            labelGap: 5,
            defaults: {
              type: 'textbox',
              size: 7,
              value: '0',
              flex: 1,
              spellcheck: false,
              onchange: function onchange() {
                var colorPickerCtrl = win.find('colorpicker')[0];
                var name, value;
                name = this.name();
                value = this.value();
                if (name === 'hex') {
                  value = '#' + value;
                  setColor(win, value);
                  colorPickerCtrl.value(value);
                  return;
                }
                value = {
                  r: win.find('#r').value(),
                  g: win.find('#g').value(),
                  b: win.find('#b').value()
                };
                colorPickerCtrl.value(value);
                setColor(win, value);
              }
            },
            items: [{
              name: 'r',
              label: 'R',
              autofocus: 1
            }, {
              name: 'g',
              label: 'G'
            }, {
              name: 'b',
              label: 'B'
            }, {
              name: 'hex',
              label: '#',
              value: '000000'
            }, {
              name: 'preview',
              type: 'container',
              border: 1
            }]
          }]
        },
        onSubmit: function onSubmit() {
          callback('#' + win.toJSON().hex);
        }
      });
      setColor(win, value);
    };
    var $_kyp25anjk26xizs = { open: open };

    global.add('colorpicker', function (editor) {
      if (!editor.settings.color_picker_callback) {
        editor.settings.color_picker_callback = function (callback, value) {
          $_kyp25anjk26xizs.open(editor, callback, value);
        };
      }
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1007 */
/*!**************************************************************!*\
  !*** ./src/packages/tinymce/plugins/directionality/index.js ***!
  \**************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "directionality" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/directionality')
//   ES2015:
//     import 'tinymce/plugins/directionality'
__webpack_require__(/*! ./plugin.js */ 1008);

/***/ }),
/* 1008 */
/*!***************************************************************!*\
  !*** ./src/packages/tinymce/plugins/directionality/plugin.js ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var directionality = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var setDir = function setDir(editor, dir) {
      var dom = editor.dom;
      var curDir;
      var blocks = editor.selection.getSelectedBlocks();
      if (blocks.length) {
        curDir = dom.getAttrib(blocks[0], 'dir');
        global$1.each(blocks, function (block) {
          if (!dom.getParent(block.parentNode, '*[dir="' + dir + '"]', dom.getRoot())) {
            dom.setAttrib(block, 'dir', curDir !== dir ? dir : null);
          }
        });
        editor.nodeChanged();
      }
    };
    var $_a3fuqb4jk26xj18 = { setDir: setDir };

    var register = function register(editor) {
      editor.addCommand('mceDirectionLTR', function () {
        $_a3fuqb4jk26xj18.setDir(editor, 'ltr');
      });
      editor.addCommand('mceDirectionRTL', function () {
        $_a3fuqb4jk26xj18.setDir(editor, 'rtl');
      });
    };
    var $_e0o7db3jk26xj17 = { register: register };

    var generateSelector = function generateSelector(dir) {
      var selector = [];
      global$1.each('h1 h2 h3 h4 h5 h6 div p'.split(' '), function (name) {
        selector.push(name + '[dir=' + dir + ']');
      });
      return selector.join(',');
    };
    var register$1 = function register$1(editor) {
      editor.addButton('ltr', {
        title: 'Left to right',
        cmd: 'mceDirectionLTR',
        stateSelector: generateSelector('ltr')
      });
      editor.addButton('rtl', {
        title: 'Right to left',
        cmd: 'mceDirectionRTL',
        stateSelector: generateSelector('rtl')
      });
    };
    var $_e6f6e1b6jk26xj1a = { register: register$1 };

    global.add('directionality', function (editor) {
      $_e0o7db3jk26xj17.register(editor);
      $_e6f6e1b6jk26xj1a.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1009 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/fullpage/index.js ***!
  \********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "fullpage" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullpage')
//   ES2015:
//     import 'tinymce/plugins/fullpage'
__webpack_require__(/*! ./plugin.js */ 1010);

/***/ }),
/* 1010 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/fullpage/plugin.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var fullpage = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$2 = tinymce.util.Tools.resolve('tinymce.html.DomParser');

    var global$3 = tinymce.util.Tools.resolve('tinymce.html.Node');

    var global$4 = tinymce.util.Tools.resolve('tinymce.html.Serializer');

    var shouldHideInSourceView = function shouldHideInSourceView(editor) {
      return editor.getParam('fullpage_hide_in_source_view');
    };
    var getDefaultXmlPi = function getDefaultXmlPi(editor) {
      return editor.getParam('fullpage_default_xml_pi');
    };
    var getDefaultEncoding = function getDefaultEncoding(editor) {
      return editor.getParam('fullpage_default_encoding');
    };
    var getDefaultFontFamily = function getDefaultFontFamily(editor) {
      return editor.getParam('fullpage_default_font_family');
    };
    var getDefaultFontSize = function getDefaultFontSize(editor) {
      return editor.getParam('fullpage_default_font_size');
    };
    var getDefaultTextColor = function getDefaultTextColor(editor) {
      return editor.getParam('fullpage_default_text_color');
    };
    var getDefaultTitle = function getDefaultTitle(editor) {
      return editor.getParam('fullpage_default_title');
    };
    var getDefaultDocType = function getDefaultDocType(editor) {
      return editor.getParam('fullpage_default_doctype', '<!DOCTYPE html>');
    };
    var $_76yo7oc7jk26xj6p = {
      shouldHideInSourceView: shouldHideInSourceView,
      getDefaultXmlPi: getDefaultXmlPi,
      getDefaultEncoding: getDefaultEncoding,
      getDefaultFontFamily: getDefaultFontFamily,
      getDefaultFontSize: getDefaultFontSize,
      getDefaultTextColor: getDefaultTextColor,
      getDefaultTitle: getDefaultTitle,
      getDefaultDocType: getDefaultDocType
    };

    var parseHeader = function parseHeader(head) {
      return global$2({
        validate: false,
        root_name: '#document'
      }).parse(head);
    };
    var htmlToData = function htmlToData(editor, head) {
      var headerFragment = parseHeader(head);
      var data = {};
      var elm, matches;
      function getAttr(elm, name) {
        var value = elm.attr(name);
        return value || '';
      }
      data.fontface = $_76yo7oc7jk26xj6p.getDefaultFontFamily(editor);
      data.fontsize = $_76yo7oc7jk26xj6p.getDefaultFontSize(editor);
      elm = headerFragment.firstChild;
      if (elm.type === 7) {
        data.xml_pi = true;
        matches = /encoding="([^"]+)"/.exec(elm.value);
        if (matches) {
          data.docencoding = matches[1];
        }
      }
      elm = headerFragment.getAll('#doctype')[0];
      if (elm) {
        data.doctype = '<!DOCTYPE' + elm.value + '>';
      }
      elm = headerFragment.getAll('title')[0];
      if (elm && elm.firstChild) {
        data.title = elm.firstChild.value;
      }
      global$1.each(headerFragment.getAll('meta'), function (meta) {
        var name = meta.attr('name');
        var httpEquiv = meta.attr('http-equiv');
        var matches;
        if (name) {
          data[name.toLowerCase()] = meta.attr('content');
        } else if (httpEquiv === 'Content-Type') {
          matches = /charset\s*=\s*(.*)\s*/gi.exec(meta.attr('content'));
          if (matches) {
            data.docencoding = matches[1];
          }
        }
      });
      elm = headerFragment.getAll('html')[0];
      if (elm) {
        data.langcode = getAttr(elm, 'lang') || getAttr(elm, 'xml:lang');
      }
      data.stylesheets = [];
      global$1.each(headerFragment.getAll('link'), function (link) {
        if (link.attr('rel') === 'stylesheet') {
          data.stylesheets.push(link.attr('href'));
        }
      });
      elm = headerFragment.getAll('body')[0];
      if (elm) {
        data.langdir = getAttr(elm, 'dir');
        data.style = getAttr(elm, 'style');
        data.visited_color = getAttr(elm, 'vlink');
        data.link_color = getAttr(elm, 'link');
        data.active_color = getAttr(elm, 'alink');
      }
      return data;
    };
    var dataToHtml = function dataToHtml(editor, data, head) {
      var headerFragment, headElement, html, elm, value;
      var dom = editor.dom;
      function setAttr(elm, name, value) {
        elm.attr(name, value ? value : undefined);
      }
      function addHeadNode(node) {
        if (headElement.firstChild) {
          headElement.insert(node, headElement.firstChild);
        } else {
          headElement.append(node);
        }
      }
      headerFragment = parseHeader(head);
      headElement = headerFragment.getAll('head')[0];
      if (!headElement) {
        elm = headerFragment.getAll('html')[0];
        headElement = new global$3('head', 1);
        if (elm.firstChild) {
          elm.insert(headElement, elm.firstChild, true);
        } else {
          elm.append(headElement);
        }
      }
      elm = headerFragment.firstChild;
      if (data.xml_pi) {
        value = 'version="1.0"';
        if (data.docencoding) {
          value += ' encoding="' + data.docencoding + '"';
        }
        if (elm.type !== 7) {
          elm = new global$3('xml', 7);
          headerFragment.insert(elm, headerFragment.firstChild, true);
        }
        elm.value = value;
      } else if (elm && elm.type === 7) {
        elm.remove();
      }
      elm = headerFragment.getAll('#doctype')[0];
      if (data.doctype) {
        if (!elm) {
          elm = new global$3('#doctype', 10);
          if (data.xml_pi) {
            headerFragment.insert(elm, headerFragment.firstChild);
          } else {
            addHeadNode(elm);
          }
        }
        elm.value = data.doctype.substring(9, data.doctype.length - 1);
      } else if (elm) {
        elm.remove();
      }
      elm = null;
      global$1.each(headerFragment.getAll('meta'), function (meta) {
        if (meta.attr('http-equiv') === 'Content-Type') {
          elm = meta;
        }
      });
      if (data.docencoding) {
        if (!elm) {
          elm = new global$3('meta', 1);
          elm.attr('http-equiv', 'Content-Type');
          elm.shortEnded = true;
          addHeadNode(elm);
        }
        elm.attr('content', 'text/html; charset=' + data.docencoding);
      } else if (elm) {
        elm.remove();
      }
      elm = headerFragment.getAll('title')[0];
      if (data.title) {
        if (!elm) {
          elm = new global$3('title', 1);
          addHeadNode(elm);
        } else {
          elm.empty();
        }
        elm.append(new global$3('#text', 3)).value = data.title;
      } else if (elm) {
        elm.remove();
      }
      global$1.each('keywords,description,author,copyright,robots'.split(','), function (name) {
        var nodes = headerFragment.getAll('meta');
        var i, meta;
        var value = data[name];
        for (i = 0; i < nodes.length; i++) {
          meta = nodes[i];
          if (meta.attr('name') === name) {
            if (value) {
              meta.attr('content', value);
            } else {
              meta.remove();
            }
            return;
          }
        }
        if (value) {
          elm = new global$3('meta', 1);
          elm.attr('name', name);
          elm.attr('content', value);
          elm.shortEnded = true;
          addHeadNode(elm);
        }
      });
      var currentStyleSheetsMap = {};
      global$1.each(headerFragment.getAll('link'), function (stylesheet) {
        if (stylesheet.attr('rel') === 'stylesheet') {
          currentStyleSheetsMap[stylesheet.attr('href')] = stylesheet;
        }
      });
      global$1.each(data.stylesheets, function (stylesheet) {
        if (!currentStyleSheetsMap[stylesheet]) {
          elm = new global$3('link', 1);
          elm.attr({
            rel: 'stylesheet',
            text: 'text/css',
            href: stylesheet
          });
          elm.shortEnded = true;
          addHeadNode(elm);
        }
        delete currentStyleSheetsMap[stylesheet];
      });
      global$1.each(currentStyleSheetsMap, function (stylesheet) {
        stylesheet.remove();
      });
      elm = headerFragment.getAll('body')[0];
      if (elm) {
        setAttr(elm, 'dir', data.langdir);
        setAttr(elm, 'style', data.style);
        setAttr(elm, 'vlink', data.visited_color);
        setAttr(elm, 'link', data.link_color);
        setAttr(elm, 'alink', data.active_color);
        dom.setAttribs(editor.getBody(), {
          style: data.style,
          dir: data.dir,
          vLink: data.visited_color,
          link: data.link_color,
          aLink: data.active_color
        });
      }
      elm = headerFragment.getAll('html')[0];
      if (elm) {
        setAttr(elm, 'lang', data.langcode);
        setAttr(elm, 'xml:lang', data.langcode);
      }
      if (!headElement.firstChild) {
        headElement.remove();
      }
      html = global$4({
        validate: false,
        indent: true,
        apply_source_formatting: true,
        indent_before: 'head,html,body,meta,title,script,link,style',
        indent_after: 'head,html,body,meta,title,script,link,style'
      }).serialize(headerFragment);
      return html.substring(0, html.indexOf('</body>'));
    };
    var $_fbhptfc3jk26xj6i = {
      parseHeader: parseHeader,
      htmlToData: htmlToData,
      dataToHtml: dataToHtml
    };

    var open = function open(editor, headState) {
      var data = $_fbhptfc3jk26xj6i.htmlToData(editor, headState.get());
      editor.windowManager.open({
        title: 'Document properties',
        data: data,
        defaults: {
          type: 'textbox',
          size: 40
        },
        body: [{
          name: 'title',
          label: 'Title'
        }, {
          name: 'keywords',
          label: 'Keywords'
        }, {
          name: 'description',
          label: 'Description'
        }, {
          name: 'robots',
          label: 'Robots'
        }, {
          name: 'author',
          label: 'Author'
        }, {
          name: 'docencoding',
          label: 'Encoding'
        }],
        onSubmit: function onSubmit(e) {
          var headHtml = $_fbhptfc3jk26xj6i.dataToHtml(editor, global$1.extend(data, e.data), headState.get());
          headState.set(headHtml);
        }
      });
    };
    var $_cka2qbc1jk26xj6f = { open: open };

    var register = function register(editor, headState) {
      editor.addCommand('mceFullPageProperties', function () {
        $_cka2qbc1jk26xj6f.open(editor, headState);
      });
    };
    var $_bxxfmbc0jk26xj6e = { register: register };

    var protectHtml = function protectHtml(protect, html) {
      global$1.each(protect, function (pattern) {
        html = html.replace(pattern, function (str) {
          return '<!--mce:protected ' + escape(str) + '-->';
        });
      });
      return html;
    };
    var unprotectHtml = function unprotectHtml(html) {
      return html.replace(/<!--mce:protected ([\s\S]*?)-->/g, function (a, m) {
        return unescape(m);
      });
    };
    var $_90yty9c9jk26xj6w = {
      protectHtml: protectHtml,
      unprotectHtml: unprotectHtml
    };

    var each = global$1.each;
    var low = function low(s) {
      return s.replace(/<\/?[A-Z]+/g, function (a) {
        return a.toLowerCase();
      });
    };
    var handleSetContent = function handleSetContent(editor, headState, footState, evt) {
      var startPos,
          endPos,
          content,
          headerFragment,
          styles = '';
      var dom = editor.dom;
      var elm;
      if (evt.selection) {
        return;
      }
      content = $_90yty9c9jk26xj6w.protectHtml(editor.settings.protect, evt.content);
      if (evt.format === 'raw' && headState.get()) {
        return;
      }
      if (evt.source_view && $_76yo7oc7jk26xj6p.shouldHideInSourceView(editor)) {
        return;
      }
      if (content.length === 0 && !evt.source_view) {
        content = global$1.trim(headState.get()) + '\n' + global$1.trim(content) + '\n' + global$1.trim(footState.get());
      }
      content = content.replace(/<(\/?)BODY/gi, '<$1body');
      startPos = content.indexOf('<body');
      if (startPos !== -1) {
        startPos = content.indexOf('>', startPos);
        headState.set(low(content.substring(0, startPos + 1)));
        endPos = content.indexOf('</body', startPos);
        if (endPos === -1) {
          endPos = content.length;
        }
        evt.content = global$1.trim(content.substring(startPos + 1, endPos));
        footState.set(low(content.substring(endPos)));
      } else {
        headState.set(getDefaultHeader(editor));
        footState.set('\n</body>\n</html>');
      }
      headerFragment = $_fbhptfc3jk26xj6i.parseHeader(headState.get());
      each(headerFragment.getAll('style'), function (node) {
        if (node.firstChild) {
          styles += node.firstChild.value;
        }
      });
      elm = headerFragment.getAll('body')[0];
      if (elm) {
        dom.setAttribs(editor.getBody(), {
          style: elm.attr('style') || '',
          dir: elm.attr('dir') || '',
          vLink: elm.attr('vlink') || '',
          link: elm.attr('link') || '',
          aLink: elm.attr('alink') || ''
        });
      }
      dom.remove('fullpage_styles');
      var headElm = editor.getDoc().getElementsByTagName('head')[0];
      if (styles) {
        dom.add(headElm, 'style', { id: 'fullpage_styles' }, styles);
        elm = dom.get('fullpage_styles');
        if (elm.styleSheet) {
          elm.styleSheet.cssText = styles;
        }
      }
      var currentStyleSheetsMap = {};
      global$1.each(headElm.getElementsByTagName('link'), function (stylesheet) {
        if (stylesheet.rel === 'stylesheet' && stylesheet.getAttribute('data-mce-fullpage')) {
          currentStyleSheetsMap[stylesheet.href] = stylesheet;
        }
      });
      global$1.each(headerFragment.getAll('link'), function (stylesheet) {
        var href = stylesheet.attr('href');
        if (!href) {
          return true;
        }
        if (!currentStyleSheetsMap[href] && stylesheet.attr('rel') === 'stylesheet') {
          dom.add(headElm, 'link', {
            'rel': 'stylesheet',
            'text': 'text/css',
            'href': href,
            'data-mce-fullpage': '1'
          });
        }
        delete currentStyleSheetsMap[href];
      });
      global$1.each(currentStyleSheetsMap, function (stylesheet) {
        stylesheet.parentNode.removeChild(stylesheet);
      });
    };
    var getDefaultHeader = function getDefaultHeader(editor) {
      var header = '',
          value,
          styles = '';
      if ($_76yo7oc7jk26xj6p.getDefaultXmlPi(editor)) {
        var piEncoding = $_76yo7oc7jk26xj6p.getDefaultEncoding(editor);
        header += '<?xml version="1.0" encoding="' + (piEncoding ? piEncoding : 'ISO-8859-1') + '" ?>\n';
      }
      header += $_76yo7oc7jk26xj6p.getDefaultDocType(editor);
      header += '\n<html>\n<head>\n';
      if (value = $_76yo7oc7jk26xj6p.getDefaultTitle(editor)) {
        header += '<title>' + value + '</title>\n';
      }
      if (value = $_76yo7oc7jk26xj6p.getDefaultEncoding(editor)) {
        header += '<meta http-equiv="Content-Type" content="text/html; charset=' + value + '" />\n';
      }
      if (value = $_76yo7oc7jk26xj6p.getDefaultFontFamily(editor)) {
        styles += 'font-family: ' + value + ';';
      }
      if (value = $_76yo7oc7jk26xj6p.getDefaultFontSize(editor)) {
        styles += 'font-size: ' + value + ';';
      }
      if (value = $_76yo7oc7jk26xj6p.getDefaultTextColor(editor)) {
        styles += 'color: ' + value + ';';
      }
      header += '</head>\n<body' + (styles ? ' style="' + styles + '"' : '') + '>\n';
      return header;
    };
    var handleGetContent = function handleGetContent(editor, head, foot, evt) {
      if (!evt.selection && (!evt.source_view || !$_76yo7oc7jk26xj6p.shouldHideInSourceView(editor))) {
        evt.content = $_90yty9c9jk26xj6w.unprotectHtml(global$1.trim(head) + '\n' + global$1.trim(evt.content) + '\n' + global$1.trim(foot));
      }
    };
    var setup = function setup(editor, headState, footState) {
      editor.on('BeforeSetContent', function (evt) {
        handleSetContent(editor, headState, footState, evt);
      });
      editor.on('GetContent', function (evt) {
        handleGetContent(editor, headState.get(), footState.get(), evt);
      });
    };
    var $_8ai2tfc8jk26xj6s = { setup: setup };

    var register$1 = function register$1(editor) {
      editor.addButton('fullpage', {
        title: 'Document properties',
        cmd: 'mceFullPageProperties'
      });
      editor.addMenuItem('fullpage', {
        text: 'Document properties',
        cmd: 'mceFullPageProperties',
        context: 'file'
      });
    };
    var $_fktut4cajk26xj6y = { register: register$1 };

    global.add('fullpage', function (editor) {
      var headState = Cell(''),
          footState = Cell('');
      $_bxxfmbc0jk26xj6e.register(editor, headState);
      $_fktut4cajk26xj6y.register(editor);
      $_8ai2tfc8jk26xj6s.setup(editor, headState, footState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1011 */
/*!****************************************************!*\
  !*** ./src/packages/tinymce/plugins/help/index.js ***!
  \****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "help" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/help')
//   ES2015:
//     import 'tinymce/plugins/help'
__webpack_require__(/*! ./plugin.js */ 1012);

/***/ }),
/* 1012 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/help/plugin.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var help = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var constant = function constant(value) {
      return function () {
        return value;
      };
    };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };
    var not = function not(f) {
      return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        return !f.apply(null, arguments);
      };
    };

    var never = constant(false);
    var always = constant(true);

    var never$1 = never;
    var always$1 = always;
    var none = function none() {
      return NONE;
    };
    var NONE = function () {
      var eq = function eq(o) {
        return o.isNone();
      };
      var call$$1 = function call$$1(thunk) {
        return thunk();
      };
      var id = function id(n) {
        return n;
      };
      var noop$$1 = function noop$$1() {};
      var nul = function nul() {
        return null;
      };
      var undef = function undef() {
        return undefined;
      };
      var me = {
        fold: function fold(n, s) {
          return n();
        },
        is: never$1,
        isSome: never$1,
        isNone: always$1,
        getOr: id,
        getOrThunk: call$$1,
        getOrDie: function getOrDie(msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: nul,
        getOrUndefined: undef,
        or: id,
        orThunk: call$$1,
        map: none,
        ap: none,
        each: noop$$1,
        bind: none,
        flatten: none,
        exists: never$1,
        forall: always$1,
        filter: none,
        equals: eq,
        equals_: eq,
        toArray: function toArray() {
          return [];
        },
        toString: constant('none()')
      };
      if (Object.freeze) Object.freeze(me);
      return me;
    }();
    var some = function some(a) {
      var constant_a = function constant_a() {
        return a;
      };
      var self = function self() {
        return me;
      };
      var map = function map(f) {
        return some(f(a));
      };
      var bind = function bind(f) {
        return f(a);
      };
      var me = {
        fold: function fold(n, s) {
          return s(a);
        },
        is: function is(v) {
          return a === v;
        },
        isSome: always$1,
        isNone: never$1,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: map,
        ap: function ap(optfab) {
          return optfab.fold(none, function (fab) {
            return some(fab(a));
          });
        },
        each: function each(f) {
          f(a);
        },
        bind: bind,
        flatten: constant_a,
        exists: bind,
        forall: bind,
        filter: function filter(f) {
          return f(a) ? me : NONE;
        },
        equals: function equals(o) {
          return o.is(a);
        },
        equals_: function equals_(o, elementEq) {
          return o.fold(never$1, function (b) {
            return elementEq(a, b);
          });
        },
        toArray: function toArray() {
          return [a];
        },
        toString: function toString() {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function from(value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Option = {
      some: some,
      none: none,
      from: from
    };

    var typeOf = function typeOf(x) {
      if (x === null) return 'null';
      var t = typeof x === 'undefined' ? 'undefined' : _typeof(x);
      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
      return t;
    };
    var isType = function isType(type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };

    var isFunction = isType('function');

    var rawIndexOf = function () {
      var pIndexOf = Array.prototype.indexOf;
      var fastIndex = function fastIndex(xs, x) {
        return pIndexOf.call(xs, x);
      };
      var slowIndex = function slowIndex(xs, x) {
        return slowIndexOf(xs, x);
      };
      return pIndexOf === undefined ? slowIndex : fastIndex;
    }();

    var contains = function contains(xs, x) {
      return rawIndexOf(xs, x) > -1;
    };

    var map = function map(xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i, xs);
      }
      return r;
    };

    var filter = function filter(xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          r.push(x);
        }
      }
      return r;
    };

    var find = function find(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(x);
        }
      }
      return Option.none();
    };

    var slowIndexOf = function slowIndexOf(xs, x) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    };

    var slice = Array.prototype.slice;

    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
      return slice.call(x);
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');

    var meta = global$2.mac ? '\u2318' : 'Ctrl';
    var access = global$2.mac ? 'Ctrl + Alt' : 'Shift + Alt';
    var shortcuts = [{
      shortcut: meta + ' + B',
      action: 'Bold'
    }, {
      shortcut: meta + ' + I',
      action: 'Italic'
    }, {
      shortcut: meta + ' + U',
      action: 'Underline'
    }, {
      shortcut: meta + ' + A',
      action: 'Select all'
    }, {
      shortcut: meta + ' + Y or ' + meta + ' + Shift + Z',
      action: 'Redo'
    }, {
      shortcut: meta + ' + Z',
      action: 'Undo'
    }, {
      shortcut: access + ' + 1',
      action: 'Header 1'
    }, {
      shortcut: access + ' + 2',
      action: 'Header 2'
    }, {
      shortcut: access + ' + 3',
      action: 'Header 3'
    }, {
      shortcut: access + ' + 4',
      action: 'Header 4'
    }, {
      shortcut: access + ' + 5',
      action: 'Header 5'
    }, {
      shortcut: access + ' + 6',
      action: 'Header 6'
    }, {
      shortcut: access + ' + 7',
      action: 'Paragraph'
    }, {
      shortcut: access + ' + 8',
      action: 'Div'
    }, {
      shortcut: access + ' + 9',
      action: 'Address'
    }, {
      shortcut: 'Alt + F9',
      action: 'Focus to menubar'
    }, {
      shortcut: 'Alt + F10',
      action: 'Focus to toolbar'
    }, {
      shortcut: 'Alt + F11',
      action: 'Focus to element path'
    }, {
      shortcut: 'Ctrl + Shift + P > Ctrl + Shift + P',
      action: 'Focus to contextual toolbar'
    }, {
      shortcut: meta + ' + K',
      action: 'Insert link (if link plugin activated)'
    }, {
      shortcut: meta + ' + S',
      action: 'Save (if save plugin activated)'
    }, {
      shortcut: meta + ' + F',
      action: 'Find (if searchreplace plugin activated)'
    }];
    var $_ajtplmbmjk26xj36 = { shortcuts: shortcuts };

    var makeTab = function makeTab() {
      var makeAriaLabel = function makeAriaLabel(shortcut) {
        return 'aria-label="Action: ' + shortcut.action + ', Shortcut: ' + shortcut.shortcut.replace(/Ctrl/g, 'Control') + '"';
      };
      var shortcutLisString = map($_ajtplmbmjk26xj36.shortcuts, function (shortcut) {
        return '<tr data-mce-tabstop="1" tabindex="-1" ' + makeAriaLabel(shortcut) + '>' + '<td>' + global$1.translate(shortcut.action) + '</td>' + '<td>' + shortcut.shortcut + '</td>' + '</tr>';
      }).join('');
      return {
        title: 'Handy Shortcuts',
        type: 'container',
        style: 'overflow-y: auto; overflow-x: hidden; max-height: 250px',
        items: [{
          type: 'container',
          html: '<div>' + '<table class="mce-table-striped">' + '<thead>' + '<th>' + global$1.translate('Action') + '</th>' + '<th>' + global$1.translate('Shortcut') + '</th>' + '</thead>' + shortcutLisString + '</table>' + '</div>'
        }]
      };
    };
    var $_d2efcbbgjk26xj1x = { makeTab: makeTab };

    var keys = Object.keys;

    var supplant = function supplant(str, obj) {
      var isStringOrNumber = function isStringOrNumber(a) {
        var t = typeof a === 'undefined' ? 'undefined' : _typeof(a);
        return t === 'string' || t === 'number';
      };
      return str.replace(/\$\{([^{}]*)\}/g, function (fullMatch, key) {
        var value = obj[key];
        return isStringOrNumber(value) ? value.toString() : fullMatch;
      });
    };

    var urls = [{
      key: 'advlist',
      name: 'Advanced List'
    }, {
      key: 'anchor',
      name: 'Anchor'
    }, {
      key: 'autolink',
      name: 'Autolink'
    }, {
      key: 'autoresize',
      name: 'Autoresize'
    }, {
      key: 'autosave',
      name: 'Autosave'
    }, {
      key: 'bbcode',
      name: 'BBCode'
    }, {
      key: 'charmap',
      name: 'Character Map'
    }, {
      key: 'code',
      name: 'Code'
    }, {
      key: 'codesample',
      name: 'Code Sample'
    }, {
      key: 'colorpicker',
      name: 'Color Picker'
    }, {
      key: 'compat3x',
      name: '3.x Compatibility'
    }, {
      key: 'contextmenu',
      name: 'Context Menu'
    }, {
      key: 'directionality',
      name: 'Directionality'
    }, {
      key: 'emoticons',
      name: 'Emoticons'
    }, {
      key: 'fullpage',
      name: 'Full Page'
    }, {
      key: 'fullscreen',
      name: 'Full Screen'
    }, {
      key: 'help',
      name: 'Help'
    }, {
      key: 'hr',
      name: 'Horizontal Rule'
    }, {
      key: 'image',
      name: 'Image'
    }, {
      key: 'imagetools',
      name: 'Image Tools'
    }, {
      key: 'importcss',
      name: 'Import CSS'
    }, {
      key: 'insertdatetime',
      name: 'Insert Date/Time'
    }, {
      key: 'legacyoutput',
      name: 'Legacy Output'
    }, {
      key: 'link',
      name: 'Link'
    }, {
      key: 'lists',
      name: 'Lists'
    }, {
      key: 'media',
      name: 'Media'
    }, {
      key: 'nonbreaking',
      name: 'Nonbreaking'
    }, {
      key: 'noneditable',
      name: 'Noneditable'
    }, {
      key: 'pagebreak',
      name: 'Page Break'
    }, {
      key: 'paste',
      name: 'Paste'
    }, {
      key: 'preview',
      name: 'Preview'
    }, {
      key: 'print',
      name: 'Print'
    }, {
      key: 'save',
      name: 'Save'
    }, {
      key: 'searchreplace',
      name: 'Search and Replace'
    }, {
      key: 'spellchecker',
      name: 'Spell Checker'
    }, {
      key: 'tabfocus',
      name: 'Tab Focus'
    }, {
      key: 'table',
      name: 'Table'
    }, {
      key: 'template',
      name: 'Template'
    }, {
      key: 'textcolor',
      name: 'Text Color'
    }, {
      key: 'textpattern',
      name: 'Text Pattern'
    }, {
      key: 'toc',
      name: 'Table of Contents'
    }, {
      key: 'visualblocks',
      name: 'Visual Blocks'
    }, {
      key: 'visualchars',
      name: 'Visual Characters'
    }, {
      key: 'wordcount',
      name: 'Word Count'
    }];
    var $_9mlanabtjk26xj3x = { urls: urls };

    var makeLink = curry(supplant, '<a href="${url}" target="_blank" rel="noopener">${name}</a>');
    var maybeUrlize = function maybeUrlize(editor, key) {
      return find($_9mlanabtjk26xj3x.urls, function (x) {
        return x.key === key;
      }).fold(function () {
        var getMetadata = editor.plugins[key].getMetadata;
        return typeof getMetadata === 'function' ? makeLink(getMetadata()) : key;
      }, function (x) {
        return makeLink({
          name: x.name,
          url: 'https://www.tinymce.com/docs/plugins/' + x.key
        });
      });
    };
    var getPluginKeys = function getPluginKeys(editor) {
      var keys$$1 = keys(editor.plugins);
      return editor.settings.forced_plugins === undefined ? keys$$1 : filter(keys$$1, not(curry(contains, editor.settings.forced_plugins)));
    };
    var pluginLister = function pluginLister(editor) {
      var pluginKeys = getPluginKeys(editor);
      var pluginLis = map(pluginKeys, function (key) {
        return '<li>' + maybeUrlize(editor, key) + '</li>';
      });
      var count = pluginLis.length;
      var pluginsString = pluginLis.join('');
      return '<p><b>' + global$1.translate(['Plugins installed ({0}):', count]) + '</b></p>' + '<ul>' + pluginsString + '</ul>';
    };
    var installedPlugins = function installedPlugins(editor) {
      return {
        type: 'container',
        html: '<div style="overflow-y: auto; overflow-x: hidden; max-height: 230px; height: 230px;" data-mce-tabstop="1" tabindex="-1">' + pluginLister(editor) + '</div>',
        flex: 1
      };
    };
    var availablePlugins = function availablePlugins() {
      return {
        type: 'container',
        html: '<div style="padding: 10px; background: #e3e7f4; height: 100%;" data-mce-tabstop="1" tabindex="-1">' + '<p><b>' + global$1.translate('Premium plugins:') + '</b></p>' + '<ul>' + '<li>PowerPaste</li>' + '<li>Spell Checker Pro</li>' + '<li>Accessibility Checker</li>' + '<li>Advanced Code Editor</li>' + '<li>Enhanced Media Embed</li>' + '<li>Link Checker</li>' + '</ul><br />' + '<p style="float: right;"><a href="https://www.tinymce.com/pricing/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">' + global$1.translate('Learn more...') + '</a></p>' + '</div>',
        flex: 1
      };
    };
    var makeTab$1 = function makeTab$1(editor) {
      return {
        title: 'Plugins',
        type: 'container',
        style: 'overflow-y: auto; overflow-x: hidden;',
        layout: 'flex',
        padding: 10,
        spacing: 10,
        items: [installedPlugins(editor), availablePlugins()]
      };
    };
    var $_cmv6mbojk26xj3a = { makeTab: makeTab$1 };

    var global$3 = tinymce.util.Tools.resolve('tinymce.EditorManager');

    var getVersion = function getVersion(major, minor) {
      return major.indexOf('@') === 0 ? 'X.X.X' : major + '.' + minor;
    };
    var makeRow = function makeRow() {
      var version = getVersion(global$3.majorVersion, global$3.minorVersion);
      var changeLogLink = '<a href="https://www.tinymce.com/docs/changelog/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">TinyMCE ' + version + '</a>';
      return [{
        type: 'label',
        html: global$1.translate(['You are using {0}', changeLogLink])
      }, {
        type: 'spacer',
        flex: 1
      }, {
        text: 'Close',
        onclick: function onclick() {
          this.parent().parent().close();
        }
      }];
    };
    var $_81enrubujk26xj45 = { makeRow: makeRow };

    var open = function open(editor, pluginUrl) {
      return function () {
        editor.windowManager.open({
          title: 'Help',
          bodyType: 'tabpanel',
          layout: 'flex',
          body: [$_d2efcbbgjk26xj1x.makeTab(), $_cmv6mbojk26xj3a.makeTab(editor)],
          buttons: $_81enrubujk26xj45.makeRow(),
          onPostRender: function onPostRender() {
            var title = this.getEl('title');
            title.innerHTML = '<img src="' + pluginUrl + '/img/logo.png" alt="TinyMCE Logo" style="display: inline-block; width: 200px; height: 50px">';
          }
        });
      };
    };
    var $_141eeqbfjk26xj1w = { open: open };

    var register = function register(editor, pluginUrl) {
      editor.addCommand('mceHelp', $_141eeqbfjk26xj1w.open(editor, pluginUrl));
    };
    var $_b0dxlzbejk26xj1v = { register: register };

    var register$1 = function register$1(editor, pluginUrl) {
      editor.addButton('help', {
        icon: 'help',
        onclick: $_141eeqbfjk26xj1w.open(editor, pluginUrl)
      });
      editor.addMenuItem('help', {
        text: 'Help',
        icon: 'help',
        context: 'help',
        onclick: $_141eeqbfjk26xj1w.open(editor, pluginUrl)
      });
    };
    var $_axczprbwjk26xj49 = { register: register$1 };

    global.add('help', function (editor, pluginUrl) {
      $_axczprbwjk26xj49.register(editor, pluginUrl);
      $_b0dxlzbejk26xj1v.register(editor, pluginUrl);
      editor.shortcuts.add('Alt+0', 'Open help dialog', 'mceHelp');
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1013 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/image/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "image" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/image')
//   ES2015:
//     import 'tinymce/plugins/image'
__webpack_require__(/*! ./plugin.js */ 1014);

/***/ }),
/* 1014 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/image/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var image = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var hasDimensions = function hasDimensions(editor) {
      return editor.settings.image_dimensions === false ? false : true;
    };
    var hasAdvTab = function hasAdvTab(editor) {
      return editor.settings.image_advtab === true ? true : false;
    };
    var getPrependUrl = function getPrependUrl(editor) {
      return editor.getParam('image_prepend_url', '');
    };
    var getClassList = function getClassList(editor) {
      return editor.getParam('image_class_list');
    };
    var hasDescription = function hasDescription(editor) {
      return editor.settings.image_description === false ? false : true;
    };
    var hasImageTitle = function hasImageTitle(editor) {
      return editor.settings.image_title === true ? true : false;
    };
    var hasImageCaption = function hasImageCaption(editor) {
      return editor.settings.image_caption === true ? true : false;
    };
    var getImageList = function getImageList(editor) {
      return editor.getParam('image_list', false);
    };
    var hasUploadUrl = function hasUploadUrl(editor) {
      return editor.getParam('images_upload_url', false);
    };
    var hasUploadHandler = function hasUploadHandler(editor) {
      return editor.getParam('images_upload_handler', false);
    };
    var getUploadUrl = function getUploadUrl(editor) {
      return editor.getParam('images_upload_url');
    };
    var getUploadHandler = function getUploadHandler(editor) {
      return editor.getParam('images_upload_handler');
    };
    var getUploadBasePath = function getUploadBasePath(editor) {
      return editor.getParam('images_upload_base_path');
    };
    var getUploadCredentials = function getUploadCredentials(editor) {
      return editor.getParam('images_upload_credentials');
    };
    var $_85qkz8ctjk26xj9v = {
      hasDimensions: hasDimensions,
      hasAdvTab: hasAdvTab,
      getPrependUrl: getPrependUrl,
      getClassList: getClassList,
      hasDescription: hasDescription,
      hasImageTitle: hasImageTitle,
      hasImageCaption: hasImageCaption,
      getImageList: getImageList,
      hasUploadUrl: hasUploadUrl,
      hasUploadHandler: hasUploadHandler,
      getUploadUrl: getUploadUrl,
      getUploadHandler: getUploadHandler,
      getUploadBasePath: getUploadBasePath,
      getUploadCredentials: getUploadCredentials
    };

    var Global = typeof window !== 'undefined' ? window : Function('return this;')();

    var path = function path(parts, scope) {
      var o = scope !== undefined && scope !== null ? scope : Global;
      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
        o = o[parts[i]];
      }return o;
    };
    var resolve = function resolve(p, scope) {
      var parts = p.split('.');
      return path(parts, scope);
    };

    var unsafe = function unsafe(name, scope) {
      return resolve(name, scope);
    };
    var getOrDie = function getOrDie(name, scope) {
      var actual = unsafe(name, scope);
      if (actual === undefined || actual === null) throw name + ' not available on this browser';
      return actual;
    };
    var $_9av8srcwjk26xja5 = { getOrDie: getOrDie };

    function FileReader() {
      var f = $_9av8srcwjk26xja5.getOrDie('FileReader');
      return new f();
    }

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var parseIntAndGetMax = function parseIntAndGetMax(val1, val2) {
      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
    };
    var getImageSize = function getImageSize(url, callback) {
      var img = document.createElement('img');
      function done(width, height) {
        if (img.parentNode) {
          img.parentNode.removeChild(img);
        }
        callback({
          width: width,
          height: height
        });
      }
      img.onload = function () {
        var width = parseIntAndGetMax(img.width, img.clientWidth);
        var height = parseIntAndGetMax(img.height, img.clientHeight);
        done(width, height);
      };
      img.onerror = function () {
        done(0, 0);
      };
      var style = img.style;
      style.visibility = 'hidden';
      style.position = 'fixed';
      style.bottom = style.left = '0px';
      style.width = style.height = 'auto';
      document.body.appendChild(img);
      img.src = url;
    };
    var buildListItems = function buildListItems(inputList, itemCallback, startItems) {
      function appendItems(values, output) {
        output = output || [];
        global$2.each(values, function (item) {
          var menuItem = { text: item.text || item.title };
          if (item.menu) {
            menuItem.menu = appendItems(item.menu);
          } else {
            menuItem.value = item.value;
            itemCallback(menuItem);
          }
          output.push(menuItem);
        });
        return output;
      }
      return appendItems(inputList, startItems || []);
    };
    var removePixelSuffix = function removePixelSuffix(value) {
      if (value) {
        value = value.replace(/px$/, '');
      }
      return value;
    };
    var addPixelSuffix = function addPixelSuffix(value) {
      if (value.length > 0 && /^[0-9]+$/.test(value)) {
        value += 'px';
      }
      return value;
    };
    var mergeMargins = function mergeMargins(css) {
      if (css.margin) {
        var splitMargin = css.margin.split(' ');
        switch (splitMargin.length) {
          case 1:
            css['margin-top'] = css['margin-top'] || splitMargin[0];
            css['margin-right'] = css['margin-right'] || splitMargin[0];
            css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
            css['margin-left'] = css['margin-left'] || splitMargin[0];
            break;
          case 2:
            css['margin-top'] = css['margin-top'] || splitMargin[0];
            css['margin-right'] = css['margin-right'] || splitMargin[1];
            css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
            css['margin-left'] = css['margin-left'] || splitMargin[1];
            break;
          case 3:
            css['margin-top'] = css['margin-top'] || splitMargin[0];
            css['margin-right'] = css['margin-right'] || splitMargin[1];
            css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
            css['margin-left'] = css['margin-left'] || splitMargin[1];
            break;
          case 4:
            css['margin-top'] = css['margin-top'] || splitMargin[0];
            css['margin-right'] = css['margin-right'] || splitMargin[1];
            css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
            css['margin-left'] = css['margin-left'] || splitMargin[3];
        }
        delete css.margin;
      }
      return css;
    };
    var createImageList = function createImageList(editor, callback) {
      var imageList = $_85qkz8ctjk26xj9v.getImageList(editor);
      if (typeof imageList === 'string') {
        global$3.send({
          url: imageList,
          success: function success(text) {
            callback(JSON.parse(text));
          }
        });
      } else if (typeof imageList === 'function') {
        imageList(callback);
      } else {
        callback(imageList);
      }
    };
    var waitLoadImage = function waitLoadImage(editor, data, imgElm) {
      function selectImage() {
        imgElm.onload = imgElm.onerror = null;
        if (editor.selection) {
          editor.selection.select(imgElm);
          editor.nodeChanged();
        }
      }
      imgElm.onload = function () {
        if (!data.width && !data.height && $_85qkz8ctjk26xj9v.hasDimensions(editor)) {
          editor.dom.setAttribs(imgElm, {
            width: imgElm.clientWidth,
            height: imgElm.clientHeight
          });
        }
        selectImage();
      };
      imgElm.onerror = selectImage;
    };
    var blobToDataUri = function blobToDataUri(blob) {
      return new global$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function () {
          reject(FileReader.error.message);
        };
        reader.readAsDataURL(blob);
      });
    };
    var $_dwfej2cujk26xj9y = {
      getImageSize: getImageSize,
      buildListItems: buildListItems,
      removePixelSuffix: removePixelSuffix,
      addPixelSuffix: addPixelSuffix,
      mergeMargins: mergeMargins,
      createImageList: createImageList,
      waitLoadImage: waitLoadImage,
      blobToDataUri: blobToDataUri
    };

    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var shallow = function shallow(old, nu) {
      return nu;
    };
    var baseMerge = function baseMerge(merger) {
      return function () {
        var objects = new Array(arguments.length);
        for (var i = 0; i < objects.length; i++) {
          objects[i] = arguments[i];
        }if (objects.length === 0) throw new Error('Can\'t merge zero objects');
        var ret = {};
        for (var j = 0; j < objects.length; j++) {
          var curObject = objects[j];
          for (var key in curObject) {
            if (hasOwnProperty.call(curObject, key)) {
              ret[key] = merger(ret[key], curObject[key]);
            }
          }
        }
        return ret;
      };
    };

    var merge = baseMerge(shallow);

    var DOM = global$4.DOM;
    var getHspace = function getHspace(image) {
      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
        return $_dwfej2cujk26xj9y.removePixelSuffix(image.style.marginLeft);
      } else {
        return '';
      }
    };
    var getVspace = function getVspace(image) {
      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
        return $_dwfej2cujk26xj9y.removePixelSuffix(image.style.marginTop);
      } else {
        return '';
      }
    };
    var getBorder = function getBorder(image) {
      if (image.style.borderWidth) {
        return $_dwfej2cujk26xj9y.removePixelSuffix(image.style.borderWidth);
      } else {
        return '';
      }
    };
    var getAttrib = function getAttrib(image, name$$1) {
      if (image.hasAttribute(name$$1)) {
        return image.getAttribute(name$$1);
      } else {
        return '';
      }
    };
    var getStyle = function getStyle(image, name$$1) {
      return image.style[name$$1] ? image.style[name$$1] : '';
    };
    var hasCaption = function hasCaption(image) {
      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
    };
    var setAttrib = function setAttrib(image, name$$1, value) {
      image.setAttribute(name$$1, value);
    };
    var wrapInFigure = function wrapInFigure(image) {
      var figureElm = DOM.create('figure', { class: 'image' });
      DOM.insertAfter(figureElm, image);
      figureElm.appendChild(image);
      figureElm.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
      figureElm.contentEditable = 'false';
    };
    var removeFigure = function removeFigure(image) {
      var figureElm = image.parentNode;
      DOM.insertAfter(image, figureElm);
      DOM.remove(figureElm);
    };
    var toggleCaption = function toggleCaption(image) {
      if (hasCaption(image)) {
        removeFigure(image);
      } else {
        wrapInFigure(image);
      }
    };
    var normalizeStyle = function normalizeStyle(image, normalizeCss) {
      var attrValue = image.getAttribute('style');
      var value = normalizeCss(attrValue !== null ? attrValue : '');
      if (value.length > 0) {
        image.setAttribute('style', value);
        image.setAttribute('data-mce-style', value);
      } else {
        image.removeAttribute('style');
      }
    };
    var setSize = function setSize(name$$1, normalizeCss) {
      return function (image, name$$1, value) {
        if (image.style[name$$1]) {
          image.style[name$$1] = $_dwfej2cujk26xj9y.addPixelSuffix(value);
          normalizeStyle(image, normalizeCss);
        } else {
          setAttrib(image, name$$1, value);
        }
      };
    };
    var getSize = function getSize(image, name$$1) {
      if (image.style[name$$1]) {
        return $_dwfej2cujk26xj9y.removePixelSuffix(image.style[name$$1]);
      } else {
        return getAttrib(image, name$$1);
      }
    };
    var setHspace = function setHspace(image, value) {
      var pxValue = $_dwfej2cujk26xj9y.addPixelSuffix(value);
      image.style.marginLeft = pxValue;
      image.style.marginRight = pxValue;
    };
    var setVspace = function setVspace(image, value) {
      var pxValue = $_dwfej2cujk26xj9y.addPixelSuffix(value);
      image.style.marginTop = pxValue;
      image.style.marginBottom = pxValue;
    };
    var setBorder = function setBorder(image, value) {
      var pxValue = $_dwfej2cujk26xj9y.addPixelSuffix(value);
      image.style.borderWidth = pxValue;
    };
    var setBorderStyle = function setBorderStyle(image, value) {
      image.style.borderStyle = value;
    };
    var getBorderStyle = function getBorderStyle(image) {
      return getStyle(image, 'borderStyle');
    };
    var isFigure = function isFigure(elm) {
      return elm.nodeName === 'FIGURE';
    };
    var defaultData = function defaultData() {
      return {
        src: '',
        alt: '',
        title: '',
        width: '',
        height: '',
        class: '',
        style: '',
        caption: false,
        hspace: '',
        vspace: '',
        border: '',
        borderStyle: ''
      };
    };
    var getStyleValue = function getStyleValue(normalizeCss, data) {
      var image = document.createElement('img');
      setAttrib(image, 'style', data.style);
      if (getHspace(image) || data.hspace !== '') {
        setHspace(image, data.hspace);
      }
      if (getVspace(image) || data.vspace !== '') {
        setVspace(image, data.vspace);
      }
      if (getBorder(image) || data.border !== '') {
        setBorder(image, data.border);
      }
      if (getBorderStyle(image) || data.borderStyle !== '') {
        setBorderStyle(image, data.borderStyle);
      }
      return normalizeCss(image.getAttribute('style'));
    };
    var create = function create(normalizeCss, data) {
      var image = document.createElement('img');
      write(normalizeCss, merge(data, { caption: false }), image);
      setAttrib(image, 'alt', data.alt);
      if (data.caption) {
        var figure = DOM.create('figure', { class: 'image' });
        figure.appendChild(image);
        figure.appendChild(DOM.create('figcaption', { contentEditable: true }, 'Caption'));
        figure.contentEditable = 'false';
        return figure;
      } else {
        return image;
      }
    };
    var read = function read(normalizeCss, image) {
      return {
        src: getAttrib(image, 'src'),
        alt: getAttrib(image, 'alt'),
        title: getAttrib(image, 'title'),
        width: getSize(image, 'width'),
        height: getSize(image, 'height'),
        class: getAttrib(image, 'class'),
        style: normalizeCss(getAttrib(image, 'style')),
        caption: hasCaption(image),
        hspace: getHspace(image),
        vspace: getVspace(image),
        border: getBorder(image),
        borderStyle: getStyle(image, 'borderStyle')
      };
    };
    var updateProp = function updateProp(image, oldData, newData, name$$1, set) {
      if (newData[name$$1] !== oldData[name$$1]) {
        set(image, name$$1, newData[name$$1]);
      }
    };
    var normalized = function normalized(set, normalizeCss) {
      return function (image, name$$1, value) {
        set(image, value);
        normalizeStyle(image, normalizeCss);
      };
    };
    var write = function write(normalizeCss, newData, image) {
      var oldData = read(normalizeCss, image);
      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
        return toggleCaption(image);
      });
      updateProp(image, oldData, newData, 'src', setAttrib);
      updateProp(image, oldData, newData, 'alt', setAttrib);
      updateProp(image, oldData, newData, 'title', setAttrib);
      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
      updateProp(image, oldData, newData, 'class', setAttrib);
      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
        return setAttrib(image, 'style', value);
      }, normalizeCss));
      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
    };

    var normalizeCss = function normalizeCss(editor, cssText) {
      var css = editor.dom.styles.parse(cssText);
      var mergedCss = $_dwfej2cujk26xj9y.mergeMargins(css);
      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
      return editor.dom.styles.serialize(compressed);
    };
    var getSelectedImage = function getSelectedImage(editor) {
      var imgElm = editor.selection.getNode();
      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
      if (figureElm) {
        return editor.dom.select('img', figureElm)[0];
      }
      if (imgElm && (imgElm.nodeName !== 'IMG' || imgElm.getAttribute('data-mce-object') || imgElm.getAttribute('data-mce-placeholder'))) {
        return null;
      }
      return imgElm;
    };
    var splitTextBlock = function splitTextBlock(editor, figure) {
      var dom = editor.dom;
      var textBlock = dom.getParent(figure.parentNode, function (node) {
        return editor.schema.getTextBlockElements()[node.nodeName];
      });
      if (textBlock) {
        return dom.split(textBlock, figure);
      } else {
        return figure;
      }
    };
    var readImageDataFromSelection = function readImageDataFromSelection(editor) {
      var image = getSelectedImage(editor);
      return image ? read(function (css) {
        return normalizeCss(editor, css);
      }, image) : defaultData();
    };
    var insertImageAtCaret = function insertImageAtCaret(editor, data) {
      var elm = create(function (css) {
        return normalizeCss(editor, css);
      }, data);
      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
      editor.focus();
      editor.selection.setContent(elm.outerHTML);
      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
      if (isFigure(insertedElm)) {
        var figure = splitTextBlock(editor, insertedElm);
        editor.selection.select(figure);
      } else {
        editor.selection.select(insertedElm);
      }
    };
    var syncSrcAttr = function syncSrcAttr(editor, image) {
      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
    };
    var deleteImage = function deleteImage(editor, image) {
      if (image) {
        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
        editor.dom.remove(elm);
        editor.focus();
        editor.nodeChanged();
        if (editor.dom.isEmpty(editor.getBody())) {
          editor.setContent('');
          editor.selection.setCursorLocation();
        }
      }
    };
    var writeImageDataToSelection = function writeImageDataToSelection(editor, data) {
      var image = getSelectedImage(editor);
      write(function (css) {
        return normalizeCss(editor, css);
      }, data, image);
      syncSrcAttr(editor, image);
      if (isFigure(image.parentNode)) {
        var figure = image.parentNode;
        splitTextBlock(editor, figure);
        editor.selection.select(image.parentNode);
      } else {
        editor.selection.select(image);
        $_dwfej2cujk26xj9y.waitLoadImage(editor, data, image);
      }
    };
    var insertOrUpdateImage = function insertOrUpdateImage(editor, data) {
      var image = getSelectedImage(editor);
      if (image) {
        if (data.src) {
          writeImageDataToSelection(editor, data);
        } else {
          deleteImage(editor, image);
        }
      } else if (data.src) {
        insertImageAtCaret(editor, data);
      }
    };

    var updateVSpaceHSpaceBorder = function updateVSpaceHSpaceBorder(editor) {
      return function (evt) {
        var dom = editor.dom;
        var rootControl = evt.control.rootControl;
        if (!$_85qkz8ctjk26xj9v.hasAdvTab(editor)) {
          return;
        }
        var data = rootControl.toJSON();
        var css = dom.parseStyle(data.style);
        rootControl.find('#vspace').value('');
        rootControl.find('#hspace').value('');
        css = $_dwfej2cujk26xj9y.mergeMargins(css);
        if (css['margin-top'] && css['margin-bottom'] || css['margin-right'] && css['margin-left']) {
          if (css['margin-top'] === css['margin-bottom']) {
            rootControl.find('#vspace').value($_dwfej2cujk26xj9y.removePixelSuffix(css['margin-top']));
          } else {
            rootControl.find('#vspace').value('');
          }
          if (css['margin-right'] === css['margin-left']) {
            rootControl.find('#hspace').value($_dwfej2cujk26xj9y.removePixelSuffix(css['margin-right']));
          } else {
            rootControl.find('#hspace').value('');
          }
        }
        if (css['border-width']) {
          rootControl.find('#border').value($_dwfej2cujk26xj9y.removePixelSuffix(css['border-width']));
        } else {
          rootControl.find('#border').value('');
        }
        if (css['border-style']) {
          rootControl.find('#borderStyle').value(css['border-style']);
        } else {
          rootControl.find('#borderStyle').value('');
        }
        rootControl.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
      };
    };
    var updateStyle = function updateStyle(editor, win) {
      win.find('#style').each(function (ctrl) {
        var value = getStyleValue(function (css) {
          return normalizeCss(editor, css);
        }, merge(defaultData(), win.toJSON()));
        ctrl.value(value);
      });
    };
    var makeTab = function makeTab(editor) {
      return {
        title: 'Advanced',
        type: 'form',
        pack: 'start',
        items: [{
          label: 'Style',
          name: 'style',
          type: 'textbox',
          onchange: updateVSpaceHSpaceBorder(editor)
        }, {
          type: 'form',
          layout: 'grid',
          packV: 'start',
          columns: 2,
          padding: 0,
          defaults: {
            type: 'textbox',
            maxWidth: 50,
            onchange: function onchange(evt) {
              updateStyle(editor, evt.control.rootControl);
            }
          },
          items: [{
            label: 'Vertical space',
            name: 'vspace'
          }, {
            label: 'Border width',
            name: 'border'
          }, {
            label: 'Horizontal space',
            name: 'hspace'
          }, {
            label: 'Border style',
            type: 'listbox',
            name: 'borderStyle',
            width: 90,
            maxWidth: 90,
            onselect: function onselect(evt) {
              updateStyle(editor, evt.control.rootControl);
            },
            values: [{
              text: 'Select...',
              value: ''
            }, {
              text: 'Solid',
              value: 'solid'
            }, {
              text: 'Dotted',
              value: 'dotted'
            }, {
              text: 'Dashed',
              value: 'dashed'
            }, {
              text: 'Double',
              value: 'double'
            }, {
              text: 'Groove',
              value: 'groove'
            }, {
              text: 'Ridge',
              value: 'ridge'
            }, {
              text: 'Inset',
              value: 'inset'
            }, {
              text: 'Outset',
              value: 'outset'
            }, {
              text: 'None',
              value: 'none'
            }, {
              text: 'Hidden',
              value: 'hidden'
            }]
          }]
        }]
      };
    };
    var $_e21hfkd3jk26xjb1 = { makeTab: makeTab };

    var doSyncSize = function doSyncSize(widthCtrl, heightCtrl) {
      widthCtrl.state.set('oldVal', widthCtrl.value());
      heightCtrl.state.set('oldVal', heightCtrl.value());
    };
    var doSizeControls = function doSizeControls(win, f) {
      var widthCtrl = win.find('#width')[0];
      var heightCtrl = win.find('#height')[0];
      var constrained = win.find('#constrain')[0];
      if (widthCtrl && heightCtrl && constrained) {
        f(widthCtrl, heightCtrl, constrained.checked());
      }
    };
    var doUpdateSize = function doUpdateSize(widthCtrl, heightCtrl, isContrained) {
      var oldWidth = widthCtrl.state.get('oldVal');
      var oldHeight = heightCtrl.state.get('oldVal');
      var newWidth = widthCtrl.value();
      var newHeight = heightCtrl.value();
      if (isContrained && oldWidth && oldHeight && newWidth && newHeight) {
        if (newWidth !== oldWidth) {
          newHeight = Math.round(newWidth / oldWidth * newHeight);
          if (!isNaN(newHeight)) {
            heightCtrl.value(newHeight);
          }
        } else {
          newWidth = Math.round(newHeight / oldHeight * newWidth);
          if (!isNaN(newWidth)) {
            widthCtrl.value(newWidth);
          }
        }
      }
      doSyncSize(widthCtrl, heightCtrl);
    };
    var syncSize = function syncSize(win) {
      doSizeControls(win, doSyncSize);
    };
    var updateSize = function updateSize(win) {
      doSizeControls(win, doUpdateSize);
    };
    var createUi = function createUi() {
      var recalcSize = function recalcSize(evt) {
        updateSize(evt.control.rootControl);
      };
      return {
        type: 'container',
        label: 'Dimensions',
        layout: 'flex',
        align: 'center',
        spacing: 5,
        items: [{
          name: 'width',
          type: 'textbox',
          maxLength: 5,
          size: 5,
          onchange: recalcSize,
          ariaLabel: 'Width'
        }, {
          type: 'label',
          text: 'x'
        }, {
          name: 'height',
          type: 'textbox',
          maxLength: 5,
          size: 5,
          onchange: recalcSize,
          ariaLabel: 'Height'
        }, {
          name: 'constrain',
          type: 'checkbox',
          checked: true,
          text: 'Constrain proportions'
        }]
      };
    };
    var $_feokj8dajk26xjbs = {
      createUi: createUi,
      syncSize: syncSize,
      updateSize: updateSize
    };

    var onSrcChange = function onSrcChange(evt, editor) {
      var srcURL, prependURL, absoluteURLPattern;
      var meta = evt.meta || {};
      var control = evt.control;
      var rootControl = control.rootControl;
      var imageListCtrl = rootControl.find('#image-list')[0];
      if (imageListCtrl) {
        imageListCtrl.value(editor.convertURL(control.value(), 'src'));
      }
      global$2.each(meta, function (value, key) {
        rootControl.find('#' + key).value(value);
      });
      if (!meta.width && !meta.height) {
        srcURL = editor.convertURL(control.value(), 'src');
        prependURL = $_85qkz8ctjk26xj9v.getPrependUrl(editor);
        absoluteURLPattern = new RegExp('^(?:[a-z]+:)?//', 'i');
        if (prependURL && !absoluteURLPattern.test(srcURL) && srcURL.substring(0, prependURL.length) !== prependURL) {
          srcURL = prependURL + srcURL;
        }
        control.value(srcURL);
        $_dwfej2cujk26xj9y.getImageSize(editor.documentBaseURI.toAbsolute(control.value()), function (data) {
          if (data.width && data.height && $_85qkz8ctjk26xj9v.hasDimensions(editor)) {
            rootControl.find('#width').value(data.width);
            rootControl.find('#height').value(data.height);
            $_feokj8dajk26xjbs.syncSize(rootControl);
          }
        });
      }
    };
    var onBeforeCall = function onBeforeCall(evt) {
      evt.meta = evt.control.rootControl.toJSON();
    };
    var getGeneralItems = function getGeneralItems(editor, imageListCtrl) {
      var generalFormItems = [{
        name: 'src',
        type: 'filepicker',
        filetype: 'image',
        label: 'Source',
        autofocus: true,
        onchange: function onchange(evt) {
          onSrcChange(evt, editor);
        },
        onbeforecall: onBeforeCall
      }, imageListCtrl];
      if ($_85qkz8ctjk26xj9v.hasDescription(editor)) {
        generalFormItems.push({
          name: 'alt',
          type: 'textbox',
          label: 'Image description'
        });
      }
      if ($_85qkz8ctjk26xj9v.hasImageTitle(editor)) {
        generalFormItems.push({
          name: 'title',
          type: 'textbox',
          label: 'Image Title'
        });
      }
      if ($_85qkz8ctjk26xj9v.hasDimensions(editor)) {
        generalFormItems.push($_feokj8dajk26xjbs.createUi());
      }
      if ($_85qkz8ctjk26xj9v.getClassList(editor)) {
        generalFormItems.push({
          name: 'class',
          type: 'listbox',
          label: 'Class',
          values: $_dwfej2cujk26xj9y.buildListItems($_85qkz8ctjk26xj9v.getClassList(editor), function (item) {
            if (item.value) {
              item.textStyle = function () {
                return editor.formatter.getCssText({
                  inline: 'img',
                  classes: [item.value]
                });
              };
            }
          })
        });
      }
      if ($_85qkz8ctjk26xj9v.hasImageCaption(editor)) {
        generalFormItems.push({
          name: 'caption',
          type: 'checkbox',
          label: 'Caption'
        });
      }
      return generalFormItems;
    };
    var makeTab$1 = function makeTab$1(editor, imageListCtrl) {
      return {
        title: 'General',
        type: 'form',
        items: getGeneralItems(editor, imageListCtrl)
      };
    };
    var $_eq9xb7d9jk26xjbp = {
      makeTab: makeTab$1,
      getGeneralItems: getGeneralItems
    };

    var url = function url() {
      return $_9av8srcwjk26xja5.getOrDie('URL');
    };
    var createObjectURL = function createObjectURL(blob) {
      return url().createObjectURL(blob);
    };
    var revokeObjectURL = function revokeObjectURL(u) {
      url().revokeObjectURL(u);
    };
    var $_adyzh4dcjk26xjby = {
      createObjectURL: createObjectURL,
      revokeObjectURL: revokeObjectURL
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.ui.Factory');

    function XMLHttpRequest() {
      var f = $_9av8srcwjk26xja5.getOrDie('XMLHttpRequest');
      return new f();
    }

    var noop = function noop() {};
    var pathJoin = function pathJoin(path1, path2) {
      if (path1) {
        return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
      }
      return path2;
    };
    function Uploader(settings) {
      var defaultHandler = function defaultHandler(blobInfo, success, failure, progress) {
        var xhr, formData;
        xhr = new XMLHttpRequest();
        xhr.open('POST', settings.url);
        xhr.withCredentials = settings.credentials;
        xhr.upload.onprogress = function (e) {
          progress(e.loaded / e.total * 100);
        };
        xhr.onerror = function () {
          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
        };
        xhr.onload = function () {
          var json;
          if (xhr.status < 200 || xhr.status >= 300) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }
          json = JSON.parse(xhr.responseText);
          if (!json || typeof json.location !== 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }
          success(pathJoin(settings.basePath, json.location));
        };
        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      };
      var uploadBlob = function uploadBlob(blobInfo, handler) {
        return new global$1(function (resolve, reject) {
          try {
            handler(blobInfo, resolve, reject, noop);
          } catch (ex) {
            reject(ex.message);
          }
        });
      };
      var isDefaultHandler = function isDefaultHandler(handler) {
        return handler === defaultHandler;
      };
      var upload = function upload(blobInfo) {
        return !settings.url && isDefaultHandler(settings.handler) ? global$1.reject('Upload url missing from the settings.') : uploadBlob(blobInfo, settings.handler);
      };
      settings = global$2.extend({
        credentials: false,
        handler: defaultHandler
      }, settings);
      return { upload: upload };
    }

    var onFileInput = function onFileInput(editor) {
      return function (evt) {
        var Throbber = global$5.get('Throbber');
        var rootControl = evt.control.rootControl;
        var throbber = new Throbber(rootControl.getEl());
        var file = evt.control.value();
        var blobUri = $_adyzh4dcjk26xjby.createObjectURL(file);
        var uploader = Uploader({
          url: $_85qkz8ctjk26xj9v.getUploadUrl(editor),
          basePath: $_85qkz8ctjk26xj9v.getUploadBasePath(editor),
          credentials: $_85qkz8ctjk26xj9v.getUploadCredentials(editor),
          handler: $_85qkz8ctjk26xj9v.getUploadHandler(editor)
        });
        var finalize = function finalize() {
          throbber.hide();
          $_adyzh4dcjk26xjby.revokeObjectURL(blobUri);
        };
        throbber.show();
        return $_dwfej2cujk26xj9y.blobToDataUri(file).then(function (dataUrl) {
          var blobInfo = editor.editorUpload.blobCache.create({
            blob: file,
            blobUri: blobUri,
            name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
            base64: dataUrl.split(',')[1]
          });
          return uploader.upload(blobInfo).then(function (url) {
            var src = rootControl.find('#src');
            src.value(url);
            rootControl.find('tabpanel')[0].activateTab(0);
            src.fire('change');
            finalize();
            return url;
          });
        }).catch(function (err) {
          editor.windowManager.alert(err);
          finalize();
        });
      };
    };
    var acceptExts = '.jpg,.jpeg,.png,.gif';
    var makeTab$2 = function makeTab$2(editor) {
      return {
        title: 'Upload',
        type: 'form',
        layout: 'flex',
        direction: 'column',
        align: 'stretch',
        padding: '20 20 20 20',
        items: [{
          type: 'container',
          layout: 'flex',
          direction: 'column',
          align: 'center',
          spacing: 10,
          items: [{
            text: 'Browse for an image',
            type: 'browsebutton',
            accept: acceptExts,
            onchange: onFileInput(editor)
          }, {
            text: 'OR',
            type: 'label'
          }]
        }, {
          text: 'Drop an image here',
          type: 'dropzone',
          accept: acceptExts,
          height: 100,
          onchange: onFileInput(editor)
        }]
      };
    };
    var $_8ans1ndbjk26xjbv = { makeTab: makeTab$2 };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };

    var submitForm = function submitForm(editor, evt) {
      var win = evt.control.getRoot();
      $_feokj8dajk26xjbs.updateSize(win);
      editor.undoManager.transact(function () {
        var data = merge(readImageDataFromSelection(editor), win.toJSON());
        insertOrUpdateImage(editor, data);
      });
      editor.editorUpload.uploadImagesAuto();
    };
    function Dialog(editor) {
      function showDialog(imageList) {
        var data = readImageDataFromSelection(editor);
        var win, imageListCtrl;
        if (imageList) {
          imageListCtrl = {
            type: 'listbox',
            label: 'Image list',
            name: 'image-list',
            values: $_dwfej2cujk26xj9y.buildListItems(imageList, function (item) {
              item.value = editor.convertURL(item.value || item.url, 'src');
            }, [{
              text: 'None',
              value: ''
            }]),
            value: data.src && editor.convertURL(data.src, 'src'),
            onselect: function onselect(e) {
              var altCtrl = win.find('#alt');
              if (!altCtrl.value() || e.lastControl && altCtrl.value() === e.lastControl.text()) {
                altCtrl.value(e.control.text());
              }
              win.find('#src').value(e.control.value()).fire('change');
            },
            onPostRender: function onPostRender() {
              imageListCtrl = this;
            }
          };
        }
        if ($_85qkz8ctjk26xj9v.hasAdvTab(editor) || $_85qkz8ctjk26xj9v.hasUploadUrl(editor) || $_85qkz8ctjk26xj9v.hasUploadHandler(editor)) {
          var body = [$_eq9xb7d9jk26xjbp.makeTab(editor, imageListCtrl)];
          if ($_85qkz8ctjk26xj9v.hasAdvTab(editor)) {
            body.push($_e21hfkd3jk26xjb1.makeTab(editor));
          }
          if ($_85qkz8ctjk26xj9v.hasUploadUrl(editor) || $_85qkz8ctjk26xj9v.hasUploadHandler(editor)) {
            body.push($_8ans1ndbjk26xjbv.makeTab(editor));
          }
          win = editor.windowManager.open({
            title: 'Insert/edit image',
            data: data,
            bodyType: 'tabpanel',
            body: body,
            onSubmit: curry(submitForm, editor)
          });
        } else {
          win = editor.windowManager.open({
            title: 'Insert/edit image',
            data: data,
            body: $_eq9xb7d9jk26xjbp.getGeneralItems(editor, imageListCtrl),
            onSubmit: curry(submitForm, editor)
          });
        }
        $_feokj8dajk26xjbs.syncSize(win);
      }
      function open() {
        $_dwfej2cujk26xj9y.createImageList(editor, showDialog);
      }
      return { open: open };
    }

    var register = function register(editor) {
      editor.addCommand('mceImage', Dialog(editor).open);
    };
    var $_d6ilcmcrjk26xj9n = { register: register };

    var hasImageClass = function hasImageClass(node) {
      var className = node.attr('class');
      return className && /\bimage\b/.test(className);
    };
    var toggleContentEditableState = function toggleContentEditableState(state) {
      return function (nodes) {
        var i = nodes.length,
            node;
        var toggleContentEditable = function toggleContentEditable(node) {
          node.attr('contenteditable', state ? 'true' : null);
        };
        while (i--) {
          node = nodes[i];
          if (hasImageClass(node)) {
            node.attr('contenteditable', state ? 'false' : null);
            global$2.each(node.getAll('figcaption'), toggleContentEditable);
          }
        }
      };
    };
    var setup = function setup(editor) {
      editor.on('preInit', function () {
        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
      });
    };
    var $_5ofh34dhjk26xjca = { setup: setup };

    var register$1 = function register$1(editor) {
      editor.addButton('image', {
        icon: 'image',
        tooltip: 'Insert/edit image',
        onclick: Dialog(editor).open,
        stateSelector: 'img:not([data-mce-object],[data-mce-placeholder]),figure.image'
      });
      editor.addMenuItem('image', {
        icon: 'image',
        text: 'Image',
        onclick: Dialog(editor).open,
        context: 'insert',
        prependToContext: true
      });
    };
    var $_3e7bp1dijk26xjcc = { register: register$1 };

    global.add('image', function (editor) {
      $_5ofh34dhjk26xjca.setup(editor);
      $_3e7bp1dijk26xjcc.register(editor);
      $_d6ilcmcrjk26xj9n.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1015 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/importcss/index.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "importcss" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/importcss')
//   ES2015:
//     import 'tinymce/plugins/importcss'
__webpack_require__(/*! ./plugin.js */ 1016);

/***/ }),
/* 1016 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/importcss/plugin.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var importcss = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.EditorManager');

    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var shouldMergeClasses = function shouldMergeClasses(editor) {
      return editor.getParam('importcss_merge_classes');
    };
    var shouldImportExclusive = function shouldImportExclusive(editor) {
      return editor.getParam('importcss_exclusive');
    };
    var getSelectorConverter = function getSelectorConverter(editor) {
      return editor.getParam('importcss_selector_converter');
    };
    var getSelectorFilter = function getSelectorFilter(editor) {
      return editor.getParam('importcss_selector_filter');
    };
    var getCssGroups = function getCssGroups(editor) {
      return editor.getParam('importcss_groups');
    };
    var shouldAppend = function shouldAppend(editor) {
      return editor.getParam('importcss_append');
    };
    var getFileFilter = function getFileFilter(editor) {
      return editor.getParam('importcss_file_filter');
    };
    var $_fv0ztlfcjk26xjtu = {
      shouldMergeClasses: shouldMergeClasses,
      shouldImportExclusive: shouldImportExclusive,
      getSelectorConverter: getSelectorConverter,
      getSelectorFilter: getSelectorFilter,
      getCssGroups: getCssGroups,
      shouldAppend: shouldAppend,
      getFileFilter: getFileFilter
    };

    var removeCacheSuffix = function removeCacheSuffix(url) {
      var cacheSuffix = global$3.cacheSuffix;
      if (typeof url === 'string') {
        url = url.replace('?' + cacheSuffix, '').replace('&' + cacheSuffix, '');
      }
      return url;
    };
    var isSkinContentCss = function isSkinContentCss(editor, href) {
      var settings = editor.settings,
          skin = settings.skin !== false ? settings.skin || 'lightgray' : false;
      if (skin) {
        var skinUrl = settings.skin_url ? editor.documentBaseURI.toAbsolute(settings.skin_url) : global$2.baseURL + '/skins/' + skin;
        return href === skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css';
      }
      return false;
    };
    var compileFilter = function compileFilter(filter) {
      if (typeof filter === 'string') {
        return function (value) {
          return value.indexOf(filter) !== -1;
        };
      } else if (filter instanceof RegExp) {
        return function (value) {
          return filter.test(value);
        };
      }
      return filter;
    };
    var getSelectors = function getSelectors(editor, doc, fileFilter) {
      var selectors = [],
          contentCSSUrls = {};
      function append(styleSheet, imported) {
        var href = styleSheet.href,
            rules;
        href = removeCacheSuffix(href);
        if (!href || !fileFilter(href, imported) || isSkinContentCss(editor, href)) {
          return;
        }
        global$4.each(styleSheet.imports, function (styleSheet) {
          append(styleSheet, true);
        });
        try {
          rules = styleSheet.cssRules || styleSheet.rules;
        } catch (e) {}
        global$4.each(rules, function (cssRule) {
          if (cssRule.styleSheet) {
            append(cssRule.styleSheet, true);
          } else if (cssRule.selectorText) {
            global$4.each(cssRule.selectorText.split(','), function (selector) {
              selectors.push(global$4.trim(selector));
            });
          }
        });
      }
      global$4.each(editor.contentCSS, function (url) {
        contentCSSUrls[url] = true;
      });
      if (!fileFilter) {
        fileFilter = function fileFilter(href, imported) {
          return imported || contentCSSUrls[href];
        };
      }
      try {
        global$4.each(doc.styleSheets, function (styleSheet) {
          append(styleSheet);
        });
      } catch (e) {}
      return selectors;
    };
    var defaultConvertSelectorToFormat = function defaultConvertSelectorToFormat(editor, selectorText) {
      var format;
      var selector = /^(?:([a-z0-9\-_]+))?(\.[a-z0-9_\-\.]+)$/i.exec(selectorText);
      if (!selector) {
        return;
      }
      var elementName = selector[1];
      var classes = selector[2].substr(1).split('.').join(' ');
      var inlineSelectorElements = global$4.makeMap('a,img');
      if (selector[1]) {
        format = { title: selectorText };
        if (editor.schema.getTextBlockElements()[elementName]) {
          format.block = elementName;
        } else if (editor.schema.getBlockElements()[elementName] || inlineSelectorElements[elementName.toLowerCase()]) {
          format.selector = elementName;
        } else {
          format.inline = elementName;
        }
      } else if (selector[2]) {
        format = {
          inline: 'span',
          title: selectorText.substr(1),
          classes: classes
        };
      }
      if ($_fv0ztlfcjk26xjtu.shouldMergeClasses(editor) !== false) {
        format.classes = classes;
      } else {
        format.attributes = { class: classes };
      }
      return format;
    };
    var getGroupsBySelector = function getGroupsBySelector(groups, selector) {
      return global$4.grep(groups, function (group) {
        return !group.filter || group.filter(selector);
      });
    };
    var compileUserDefinedGroups = function compileUserDefinedGroups(groups) {
      return global$4.map(groups, function (group) {
        return global$4.extend({}, group, {
          original: group,
          selectors: {},
          filter: compileFilter(group.filter),
          item: {
            text: group.title,
            menu: []
          }
        });
      });
    };
    var isExclusiveMode = function isExclusiveMode(editor, group) {
      return group === null || $_fv0ztlfcjk26xjtu.shouldImportExclusive(editor) !== false;
    };
    var isUniqueSelector = function isUniqueSelector(editor, selector, group, globallyUniqueSelectors) {
      return !(isExclusiveMode(editor, group) ? selector in globallyUniqueSelectors : selector in group.selectors);
    };
    var markUniqueSelector = function markUniqueSelector(editor, selector, group, globallyUniqueSelectors) {
      if (isExclusiveMode(editor, group)) {
        globallyUniqueSelectors[selector] = true;
      } else {
        group.selectors[selector] = true;
      }
    };
    var convertSelectorToFormat = function convertSelectorToFormat(editor, plugin, selector, group) {
      var selectorConverter;
      if (group && group.selector_converter) {
        selectorConverter = group.selector_converter;
      } else if ($_fv0ztlfcjk26xjtu.getSelectorConverter(editor)) {
        selectorConverter = $_fv0ztlfcjk26xjtu.getSelectorConverter(editor);
      } else {
        selectorConverter = function selectorConverter() {
          return defaultConvertSelectorToFormat(editor, selector);
        };
      }
      return selectorConverter.call(plugin, selector, group);
    };
    var setup = function setup(editor) {
      editor.on('renderFormatsMenu', function (e) {
        var globallyUniqueSelectors = {};
        var selectorFilter = compileFilter($_fv0ztlfcjk26xjtu.getSelectorFilter(editor)),
            ctrl = e.control;
        var groups = compileUserDefinedGroups($_fv0ztlfcjk26xjtu.getCssGroups(editor));
        var processSelector = function processSelector(selector, group) {
          if (isUniqueSelector(editor, selector, group, globallyUniqueSelectors)) {
            markUniqueSelector(editor, selector, group, globallyUniqueSelectors);
            var format = convertSelectorToFormat(editor, editor.plugins.importcss, selector, group);
            if (format) {
              var formatName = format.name || global$1.DOM.uniqueId();
              editor.formatter.register(formatName, format);
              return global$4.extend({}, ctrl.settings.itemDefaults, {
                text: format.title,
                format: formatName
              });
            }
          }
          return null;
        };
        if (!$_fv0ztlfcjk26xjtu.shouldAppend(editor)) {
          ctrl.items().remove();
        }
        global$4.each(getSelectors(editor, e.doc || editor.getDoc(), compileFilter($_fv0ztlfcjk26xjtu.getFileFilter(editor))), function (selector) {
          if (selector.indexOf('.mce-') === -1) {
            if (!selectorFilter || selectorFilter(selector)) {
              var selectorGroups = getGroupsBySelector(groups, selector);
              if (selectorGroups.length > 0) {
                global$4.each(selectorGroups, function (group) {
                  var menuItem = processSelector(selector, group);
                  if (menuItem) {
                    group.item.menu.push(menuItem);
                  }
                });
              } else {
                var menuItem = processSelector(selector, null);
                if (menuItem) {
                  ctrl.add(menuItem);
                }
              }
            }
          }
        });
        global$4.each(groups, function (group) {
          if (group.item.menu.length > 0) {
            ctrl.add(group.item);
          }
        });
        e.control.renderNew();
      });
    };
    var $_d5ze7nf7jk26xjtn = {
      defaultConvertSelectorToFormat: defaultConvertSelectorToFormat,
      setup: setup
    };

    var get = function get(editor) {
      var convertSelectorToFormat = function convertSelectorToFormat(selectorText) {
        return $_d5ze7nf7jk26xjtn.defaultConvertSelectorToFormat(editor, selectorText);
      };
      return { convertSelectorToFormat: convertSelectorToFormat };
    };
    var $_93jblwf6jk26xjtl = { get: get };

    global.add('importcss', function (editor) {
      $_d5ze7nf7jk26xjtn.setup(editor);
      return $_93jblwf6jk26xjtl.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1017 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/legacyoutput/index.js ***!
  \************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "legacyoutput" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/legacyoutput')
//   ES2015:
//     import 'tinymce/plugins/legacyoutput'
__webpack_require__(/*! ./plugin.js */ 1018);

/***/ }),
/* 1018 */
/*!*************************************************************!*\
  !*** ./src/packages/tinymce/plugins/legacyoutput/plugin.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var legacyoutput = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var overrideFormats = function overrideFormats(editor) {
      var alignElements = 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img',
          fontSizes = global$1.explode(editor.settings.font_size_style_values),
          schema = editor.schema;
      editor.formatter.register({
        alignleft: {
          selector: alignElements,
          attributes: { align: 'left' }
        },
        aligncenter: {
          selector: alignElements,
          attributes: { align: 'center' }
        },
        alignright: {
          selector: alignElements,
          attributes: { align: 'right' }
        },
        alignjustify: {
          selector: alignElements,
          attributes: { align: 'justify' }
        },
        bold: [{
          inline: 'b',
          remove: 'all'
        }, {
          inline: 'strong',
          remove: 'all'
        }, {
          inline: 'span',
          styles: { fontWeight: 'bold' }
        }],
        italic: [{
          inline: 'i',
          remove: 'all'
        }, {
          inline: 'em',
          remove: 'all'
        }, {
          inline: 'span',
          styles: { fontStyle: 'italic' }
        }],
        underline: [{
          inline: 'u',
          remove: 'all'
        }, {
          inline: 'span',
          styles: { textDecoration: 'underline' },
          exact: true
        }],
        strikethrough: [{
          inline: 'strike',
          remove: 'all'
        }, {
          inline: 'span',
          styles: { textDecoration: 'line-through' },
          exact: true
        }],
        fontname: {
          inline: 'font',
          attributes: { face: '%value' }
        },
        fontsize: {
          inline: 'font',
          attributes: {
            size: function size(vars) {
              return global$1.inArray(fontSizes, vars.value) + 1;
            }
          }
        },
        forecolor: {
          inline: 'font',
          attributes: { color: '%value' }
        },
        hilitecolor: {
          inline: 'font',
          styles: { backgroundColor: '%value' }
        }
      });
      global$1.each('b,i,u,strike'.split(','), function (name) {
        schema.addValidElements(name + '[*]');
      });
      if (!schema.getElementRule('font')) {
        schema.addValidElements('font[face|size|color|style]');
      }
      global$1.each(alignElements.split(','), function (name) {
        var rule = schema.getElementRule(name);
        if (rule) {
          if (!rule.attributes.align) {
            rule.attributes.align = {};
            rule.attributesOrder.push('align');
          }
        }
      });
    };
    var setup = function setup(editor) {
      editor.settings.inline_styles = false;
      editor.on('init', function () {
        overrideFormats(editor);
      });
    };
    var $_al9v9kfnjk26xjv1 = { setup: setup };

    var register = function register(editor) {
      editor.addButton('fontsizeselect', function () {
        var items = [],
            defaultFontsizeFormats = '8pt=1 10pt=2 12pt=3 14pt=4 18pt=5 24pt=6 36pt=7';
        var fontsizeFormats = editor.settings.fontsizeFormats || defaultFontsizeFormats;
        editor.$.each(fontsizeFormats.split(' '), function (i, item) {
          var text = item,
              value = item;
          var values = item.split('=');
          if (values.length > 1) {
            text = values[0];
            value = values[1];
          }
          items.push({
            text: text,
            value: value
          });
        });
        return {
          type: 'listbox',
          text: 'Font Sizes',
          tooltip: 'Font Sizes',
          values: items,
          fixedWidth: true,
          onPostRender: function onPostRender() {
            var self = this;
            editor.on('NodeChange', function () {
              var fontElm;
              fontElm = editor.dom.getParent(editor.selection.getNode(), 'font');
              if (fontElm) {
                self.value(fontElm.size);
              } else {
                self.value('');
              }
            });
          },
          onclick: function onclick(e) {
            if (e.control.settings.value) {
              editor.execCommand('FontSize', false, e.control.settings.value);
            }
          }
        };
      });
      editor.addButton('fontselect', function () {
        function createFormats(formats) {
          formats = formats.replace(/;$/, '').split(';');
          var i = formats.length;
          while (i--) {
            formats[i] = formats[i].split('=');
          }
          return formats;
        }
        var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
        var items = [],
            fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
        editor.$.each(fonts, function (i, font) {
          items.push({
            text: { raw: font[0] },
            value: font[1],
            textStyle: font[1].indexOf('dings') === -1 ? 'font-family:' + font[1] : ''
          });
        });
        return {
          type: 'listbox',
          text: 'Font Family',
          tooltip: 'Font Family',
          values: items,
          fixedWidth: true,
          onPostRender: function onPostRender() {
            var self = this;
            editor.on('NodeChange', function () {
              var fontElm;
              fontElm = editor.dom.getParent(editor.selection.getNode(), 'font');
              if (fontElm) {
                self.value(fontElm.face);
              } else {
                self.value('');
              }
            });
          },
          onselect: function onselect(e) {
            if (e.control.settings.value) {
              editor.execCommand('FontName', false, e.control.settings.value);
            }
          }
        };
      });
    };
    var $_a7axapfpjk26xjv4 = { register: register };

    global.add('legacyoutput', function (editor) {
      $_al9v9kfnjk26xjv1.setup(editor);
      $_a7axapfpjk26xjv4.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1019 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/lists/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "lists" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/lists')
//   ES2015:
//     import 'tinymce/plugins/lists'
__webpack_require__(/*! ./plugin.js */ 1020);

/***/ }),
/* 1020 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/lists/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var lists = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.BookmarkManager');

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$6 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var isTextNode = function isTextNode(node) {
      return node && node.nodeType === 3;
    };
    var isListNode = function isListNode(node) {
      return node && /^(OL|UL|DL)$/.test(node.nodeName);
    };
    var isListItemNode = function isListItemNode(node) {
      return node && /^(LI|DT|DD)$/.test(node.nodeName);
    };
    var isTableCellNode = function isTableCellNode(node) {
      return node && /^(TH|TD)$/.test(node.nodeName);
    };
    var isBr = function isBr(node) {
      return node && node.nodeName === 'BR';
    };
    var isFirstChild = function isFirstChild(node) {
      return node.parentNode.firstChild === node;
    };
    var isLastChild = function isLastChild(node) {
      return node.parentNode.lastChild === node;
    };
    var isTextBlock = function isTextBlock(editor, node) {
      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
    };
    var isBlock = function isBlock(node, blockElements) {
      return node && node.nodeName in blockElements;
    };
    var isBogusBr = function isBogusBr(dom, node) {
      if (!isBr(node)) {
        return false;
      }
      if (dom.isBlock(node.nextSibling) && !isBr(node.previousSibling)) {
        return true;
      }
      return false;
    };
    var isEmpty = function isEmpty(dom, elm, keepBookmarks) {
      var empty = dom.isEmpty(elm);
      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
        return false;
      }
      return empty;
    };
    var isChildOfBody = function isChildOfBody(dom, elm) {
      return dom.isChildOf(elm, dom.getRoot());
    };
    var $_d57y6rgljk26xjze = {
      isTextNode: isTextNode,
      isListNode: isListNode,
      isListItemNode: isListItemNode,
      isTableCellNode: isTableCellNode,
      isBr: isBr,
      isFirstChild: isFirstChild,
      isLastChild: isLastChild,
      isTextBlock: isTextBlock,
      isBlock: isBlock,
      isBogusBr: isBogusBr,
      isEmpty: isEmpty,
      isChildOfBody: isChildOfBody
    };

    var getNormalizedEndPoint = function getNormalizedEndPoint(container, offset) {
      var node = global$1.getNode(container, offset);
      if ($_d57y6rgljk26xjze.isListItemNode(container) && $_d57y6rgljk26xjze.isTextNode(node)) {
        var textNodeOffset = offset >= container.childNodes.length ? node.data.length : 0;
        return {
          container: node,
          offset: textNodeOffset
        };
      }
      return {
        container: container,
        offset: offset
      };
    };
    var normalizeRange = function normalizeRange(rng) {
      var outRng = rng.cloneRange();
      var rangeStart = getNormalizedEndPoint(rng.startContainer, rng.startOffset);
      outRng.setStart(rangeStart.container, rangeStart.offset);
      var rangeEnd = getNormalizedEndPoint(rng.endContainer, rng.endOffset);
      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
      return outRng;
    };
    var $_3aa7p1gkjk26xjzd = {
      getNormalizedEndPoint: getNormalizedEndPoint,
      normalizeRange: normalizeRange
    };

    var DOM = global$6.DOM;
    var createBookmark = function createBookmark(rng) {
      var bookmark = {};
      var setupEndPoint = function setupEndPoint(start) {
        var offsetNode, container, offset;
        container = rng[start ? 'startContainer' : 'endContainer'];
        offset = rng[start ? 'startOffset' : 'endOffset'];
        if (container.nodeType === 1) {
          offsetNode = DOM.create('span', { 'data-mce-type': 'bookmark' });
          if (container.hasChildNodes()) {
            offset = Math.min(offset, container.childNodes.length - 1);
            if (start) {
              container.insertBefore(offsetNode, container.childNodes[offset]);
            } else {
              DOM.insertAfter(offsetNode, container.childNodes[offset]);
            }
          } else {
            container.appendChild(offsetNode);
          }
          container = offsetNode;
          offset = 0;
        }
        bookmark[start ? 'startContainer' : 'endContainer'] = container;
        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
      };
      setupEndPoint(true);
      if (!rng.collapsed) {
        setupEndPoint();
      }
      return bookmark;
    };
    var resolveBookmark = function resolveBookmark(bookmark) {
      function restoreEndPoint(start) {
        var container, offset, node;
        var nodeIndex = function nodeIndex(container) {
          var node = container.parentNode.firstChild,
              idx = 0;
          while (node) {
            if (node === container) {
              return idx;
            }
            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
              idx++;
            }
            node = node.nextSibling;
          }
          return -1;
        };
        container = node = bookmark[start ? 'startContainer' : 'endContainer'];
        offset = bookmark[start ? 'startOffset' : 'endOffset'];
        if (!container) {
          return;
        }
        if (container.nodeType === 1) {
          offset = nodeIndex(container);
          container = container.parentNode;
          DOM.remove(node);
          if (!container.hasChildNodes() && DOM.isBlock(container)) {
            container.appendChild(DOM.create('br'));
          }
        }
        bookmark[start ? 'startContainer' : 'endContainer'] = container;
        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
      }
      restoreEndPoint(true);
      restoreEndPoint();
      var rng = DOM.createRng();
      rng.setStart(bookmark.startContainer, bookmark.startOffset);
      if (bookmark.endContainer) {
        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
      }
      return $_3aa7p1gkjk26xjzd.normalizeRange(rng);
    };
    var $_aqcyy4gjjk26xjza = {
      createBookmark: createBookmark,
      resolveBookmark: resolveBookmark
    };

    var DOM$1 = global$6.DOM;
    var normalizeList = function normalizeList(dom, ul) {
      var sibling;
      var parentNode = ul.parentNode;
      if (parentNode.nodeName === 'LI' && parentNode.firstChild === ul) {
        sibling = parentNode.previousSibling;
        if (sibling && sibling.nodeName === 'LI') {
          sibling.appendChild(ul);
          if ($_d57y6rgljk26xjze.isEmpty(dom, parentNode)) {
            DOM$1.remove(parentNode);
          }
        } else {
          DOM$1.setStyle(parentNode, 'listStyleType', 'none');
        }
      }
      if ($_d57y6rgljk26xjze.isListNode(parentNode)) {
        sibling = parentNode.previousSibling;
        if (sibling && sibling.nodeName === 'LI') {
          sibling.appendChild(ul);
        }
      }
    };
    var normalizeLists = function normalizeLists(dom, element) {
      global$5.each(global$5.grep(dom.select('ol,ul', element)), function (ul) {
        normalizeList(dom, ul);
      });
    };
    var $_2mcwg8gmjk26xjzi = {
      normalizeList: normalizeList,
      normalizeLists: normalizeLists
    };

    var global$7 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');

    var getParentList = function getParentList(editor) {
      var selectionStart = editor.selection.getStart(true);
      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
    };
    var isParentListSelected = function isParentListSelected(parentList, selectedBlocks) {
      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
    };
    var findSubLists = function findSubLists(parentList) {
      return global$5.grep(parentList.querySelectorAll('ol,ul,dl'), function (elm) {
        return $_d57y6rgljk26xjze.isListNode(elm);
      });
    };
    var getSelectedSubLists = function getSelectedSubLists(editor) {
      var parentList = getParentList(editor);
      var selectedBlocks = editor.selection.getSelectedBlocks();
      if (isParentListSelected(parentList, selectedBlocks)) {
        return findSubLists(parentList);
      } else {
        return global$5.grep(selectedBlocks, function (elm) {
          return $_d57y6rgljk26xjze.isListNode(elm) && parentList !== elm;
        });
      }
    };
    var findParentListItemsNodes = function findParentListItemsNodes(editor, elms) {
      var listItemsElms = global$5.map(elms, function (elm) {
        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
        return parentLi ? parentLi : elm;
      });
      return global$7.unique(listItemsElms);
    };
    var getSelectedListItems = function getSelectedListItems(editor) {
      var selectedBlocks = editor.selection.getSelectedBlocks();
      return global$5.grep(findParentListItemsNodes(editor, selectedBlocks), function (block) {
        return $_d57y6rgljk26xjze.isListItemNode(block);
      });
    };
    var getClosestListRootElm = function getClosestListRootElm(editor, elm) {
      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
      var root = parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
      return root;
    };
    var $_69b1t0gnjk26xjzj = {
      getParentList: getParentList,
      getSelectedSubLists: getSelectedSubLists,
      getSelectedListItems: getSelectedListItems,
      getClosestListRootElm: getClosestListRootElm
    };

    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');

    var DOM$2 = global$6.DOM;
    var createNewTextBlock = function createNewTextBlock(editor, contentNode, blockName) {
      var node, textBlock;
      var fragment = DOM$2.createFragment();
      var hasContentNode;
      var blockElements = editor.schema.getBlockElements();
      if (editor.settings.forced_root_block) {
        blockName = blockName || editor.settings.forced_root_block;
      }
      if (blockName) {
        textBlock = DOM$2.create(blockName);
        if (textBlock.tagName === editor.settings.forced_root_block) {
          DOM$2.setAttribs(textBlock, editor.settings.forced_root_block_attrs);
        }
        if (!$_d57y6rgljk26xjze.isBlock(contentNode.firstChild, blockElements)) {
          fragment.appendChild(textBlock);
        }
      }
      if (contentNode) {
        while (node = contentNode.firstChild) {
          var nodeName = node.nodeName;
          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
            hasContentNode = true;
          }
          if ($_d57y6rgljk26xjze.isBlock(node, blockElements)) {
            fragment.appendChild(node);
            textBlock = null;
          } else {
            if (blockName) {
              if (!textBlock) {
                textBlock = DOM$2.create(blockName);
                fragment.appendChild(textBlock);
              }
              textBlock.appendChild(node);
            } else {
              fragment.appendChild(node);
            }
          }
        }
      }
      if (!editor.settings.forced_root_block) {
        fragment.appendChild(DOM$2.create('br'));
      } else {
        if (!hasContentNode && (!global$8.ie || global$8.ie > 10)) {
          textBlock.appendChild(DOM$2.create('br', { 'data-mce-bogus': '1' }));
        }
      }
      return fragment;
    };
    var $_1pi3u7gqjk26xjzq = { createNewTextBlock: createNewTextBlock };

    var DOM$3 = global$6.DOM;
    var splitList = function splitList(editor, ul, li, newBlock) {
      var tmpRng, fragment, bookmarks, node;
      var removeAndKeepBookmarks = function removeAndKeepBookmarks(targetNode) {
        global$5.each(bookmarks, function (node) {
          targetNode.parentNode.insertBefore(node, li.parentNode);
        });
        DOM$3.remove(targetNode);
      };
      bookmarks = DOM$3.select('span[data-mce-type="bookmark"]', ul);
      newBlock = newBlock || $_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li);
      tmpRng = DOM$3.createRng();
      tmpRng.setStartAfter(li);
      tmpRng.setEndAfter(ul);
      fragment = tmpRng.extractContents();
      for (node = fragment.firstChild; node; node = node.firstChild) {
        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
          DOM$3.remove(node);
          break;
        }
      }
      if (!editor.dom.isEmpty(fragment)) {
        DOM$3.insertAfter(fragment, ul);
      }
      DOM$3.insertAfter(newBlock, ul);
      if ($_d57y6rgljk26xjze.isEmpty(editor.dom, li.parentNode)) {
        removeAndKeepBookmarks(li.parentNode);
      }
      DOM$3.remove(li);
      if ($_d57y6rgljk26xjze.isEmpty(editor.dom, ul)) {
        DOM$3.remove(ul);
      }
    };
    var $_5uz1txgpjk26xjzm = { splitList: splitList };

    var DOM$4 = global$6.DOM;
    var removeEmptyLi = function removeEmptyLi(dom, li) {
      if ($_d57y6rgljk26xjze.isEmpty(dom, li)) {
        DOM$4.remove(li);
      }
    };
    var outdent = function outdent(editor, li) {
      var ul = li.parentNode;
      var ulParent, newBlock;
      if (ul) {
        ulParent = ul.parentNode;
      } else {
        removeEmptyLi(editor.dom, li);
        return true;
      }
      if (ul === editor.getBody()) {
        return true;
      }
      if (li.nodeName === 'DD') {
        DOM$4.rename(li, 'DT');
        return true;
      }
      if ($_d57y6rgljk26xjze.isFirstChild(li) && $_d57y6rgljk26xjze.isLastChild(li)) {
        if (ulParent.nodeName === 'LI') {
          DOM$4.insertAfter(li, ulParent);
          removeEmptyLi(editor.dom, ulParent);
          DOM$4.remove(ul);
        } else if ($_d57y6rgljk26xjze.isListNode(ulParent)) {
          DOM$4.remove(ul, true);
        } else {
          ulParent.insertBefore($_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li), ul);
          DOM$4.remove(ul);
        }
        return true;
      } else if ($_d57y6rgljk26xjze.isFirstChild(li)) {
        if (ulParent.nodeName === 'LI') {
          DOM$4.insertAfter(li, ulParent);
          li.appendChild(ul);
          removeEmptyLi(editor.dom, ulParent);
        } else if ($_d57y6rgljk26xjze.isListNode(ulParent)) {
          ulParent.insertBefore(li, ul);
        } else {
          ulParent.insertBefore($_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li), ul);
          DOM$4.remove(li);
        }
        return true;
      } else if ($_d57y6rgljk26xjze.isLastChild(li)) {
        if (ulParent.nodeName === 'LI') {
          DOM$4.insertAfter(li, ulParent);
        } else if ($_d57y6rgljk26xjze.isListNode(ulParent)) {
          DOM$4.insertAfter(li, ul);
        } else {
          DOM$4.insertAfter($_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li), ul);
          DOM$4.remove(li);
        }
        return true;
      }
      if (ulParent.nodeName === 'LI') {
        ul = ulParent;
        newBlock = $_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li, 'LI');
      } else if ($_d57y6rgljk26xjze.isListNode(ulParent)) {
        newBlock = $_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li, 'LI');
      } else {
        newBlock = $_1pi3u7gqjk26xjzq.createNewTextBlock(editor, li);
      }
      $_5uz1txgpjk26xjzm.splitList(editor, ul, li, newBlock);
      $_2mcwg8gmjk26xjzi.normalizeLists(editor.dom, ul.parentNode);
      return true;
    };
    var outdentSelection = function outdentSelection(editor) {
      var listElements = $_69b1t0gnjk26xjzj.getSelectedListItems(editor);
      if (listElements.length) {
        var bookmark = $_aqcyy4gjjk26xjza.createBookmark(editor.selection.getRng());
        var i = void 0,
            y = void 0;
        var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, editor.selection.getStart(true));
        i = listElements.length;
        while (i--) {
          var node = listElements[i].parentNode;
          while (node && node !== root) {
            y = listElements.length;
            while (y--) {
              if (listElements[y] === node) {
                listElements.splice(i, 1);
                break;
              }
            }
            node = node.parentNode;
          }
        }
        for (i = 0; i < listElements.length; i++) {
          if (!outdent(editor, listElements[i]) && i === 0) {
            break;
          }
        }
        editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
        editor.nodeChanged();
        return true;
      }
    };
    var $_djsp7vghjk26xjz6 = {
      outdent: outdent,
      outdentSelection: outdentSelection
    };

    var updateListStyle = function updateListStyle(dom, el, detail) {
      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
      dom.setStyle(el, 'list-style-type', type);
    };
    var setAttribs = function setAttribs(elm, attrs) {
      global$5.each(attrs, function (value, key) {
        elm.setAttribute(key, value);
      });
    };
    var updateListAttrs = function updateListAttrs(dom, el, detail) {
      setAttribs(el, detail['list-attributes']);
      global$5.each(dom.select('li', el), function (li) {
        setAttribs(li, detail['list-item-attributes']);
      });
    };
    var updateListWithDetails = function updateListWithDetails(dom, el, detail) {
      updateListStyle(dom, el, detail);
      updateListAttrs(dom, el, detail);
    };
    var removeStyles = function removeStyles(dom, element, styles) {
      global$5.each(styles, function (style) {
        var _a;
        return dom.setStyle(element, (_a = {}, _a[style] = '', _a));
      });
    };
    var getEndPointNode = function getEndPointNode(editor, rng, start, root) {
      var container, offset;
      container = rng[start ? 'startContainer' : 'endContainer'];
      offset = rng[start ? 'startOffset' : 'endOffset'];
      if (container.nodeType === 1) {
        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
      }
      if (!start && $_d57y6rgljk26xjze.isBr(container.nextSibling)) {
        container = container.nextSibling;
      }
      while (container.parentNode !== root) {
        if ($_d57y6rgljk26xjze.isTextBlock(editor, container)) {
          return container;
        }
        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
          return container;
        }
        container = container.parentNode;
      }
      return container;
    };
    var getSelectedTextBlocks = function getSelectedTextBlocks(editor, rng, root) {
      var textBlocks = [],
          dom = editor.dom;
      var startNode = getEndPointNode(editor, rng, true, root);
      var endNode = getEndPointNode(editor, rng, false, root);
      var block;
      var siblings = [];
      for (var node = startNode; node; node = node.nextSibling) {
        siblings.push(node);
        if (node === endNode) {
          break;
        }
      }
      global$5.each(siblings, function (node) {
        if ($_d57y6rgljk26xjze.isTextBlock(editor, node)) {
          textBlocks.push(node);
          block = null;
          return;
        }
        if (dom.isBlock(node) || $_d57y6rgljk26xjze.isBr(node)) {
          if ($_d57y6rgljk26xjze.isBr(node)) {
            dom.remove(node);
          }
          block = null;
          return;
        }
        var nextSibling = node.nextSibling;
        if (global$4.isBookmarkNode(node)) {
          if ($_d57y6rgljk26xjze.isTextBlock(editor, nextSibling) || !nextSibling && node.parentNode === root) {
            block = null;
            return;
          }
        }
        if (!block) {
          block = dom.create('p');
          node.parentNode.insertBefore(block, node);
          textBlocks.push(block);
        }
        block.appendChild(node);
      });
      return textBlocks;
    };
    var hasCompatibleStyle = function hasCompatibleStyle(dom, sib, detail) {
      var sibStyle = dom.getStyle(sib, 'list-style-type');
      var detailStyle = detail ? detail['list-style-type'] : '';
      detailStyle = detailStyle === null ? '' : detailStyle;
      return sibStyle === detailStyle;
    };
    var applyList = function applyList(editor, listName, detail) {
      if (detail === void 0) {
        detail = {};
      }
      var rng = editor.selection.getRng(true);
      var bookmark;
      var listItemName = 'LI';
      var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, editor.selection.getStart(true));
      var dom = editor.dom;
      if (dom.getContentEditable(editor.selection.getNode()) === 'false') {
        return;
      }
      listName = listName.toUpperCase();
      if (listName === 'DL') {
        listItemName = 'DT';
      }
      bookmark = $_aqcyy4gjjk26xjza.createBookmark(rng);
      global$5.each(getSelectedTextBlocks(editor, rng, root), function (block) {
        var listBlock, sibling;
        sibling = block.previousSibling;
        if (sibling && $_d57y6rgljk26xjze.isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
          listBlock = sibling;
          block = dom.rename(block, listItemName);
          sibling.appendChild(block);
        } else {
          listBlock = dom.create(listName);
          block.parentNode.insertBefore(listBlock, block);
          listBlock.appendChild(block);
          block = dom.rename(block, listItemName);
        }
        removeStyles(dom, block, ['margin', 'margin-right', 'margin-bottom', 'margin-left', 'margin-top', 'padding', 'padding-right', 'padding-bottom', 'padding-left', 'padding-top']);
        updateListWithDetails(dom, listBlock, detail);
        mergeWithAdjacentLists(editor.dom, listBlock);
      });
      editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
    };
    var removeList = function removeList(editor) {
      var bookmark = $_aqcyy4gjjk26xjza.createBookmark(editor.selection.getRng(true));
      var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, editor.selection.getStart(true));
      var listItems = $_69b1t0gnjk26xjzj.getSelectedListItems(editor);
      var emptyListItems = global$5.grep(listItems, function (li) {
        return editor.dom.isEmpty(li);
      });
      listItems = global$5.grep(listItems, function (li) {
        return !editor.dom.isEmpty(li);
      });
      global$5.each(emptyListItems, function (li) {
        if ($_d57y6rgljk26xjze.isEmpty(editor.dom, li)) {
          $_djsp7vghjk26xjz6.outdent(editor, li);
          return;
        }
      });
      global$5.each(listItems, function (li) {
        var node, rootList;
        if (li.parentNode === editor.getBody()) {
          return;
        }
        for (node = li; node && node !== root; node = node.parentNode) {
          if ($_d57y6rgljk26xjze.isListNode(node)) {
            rootList = node;
          }
        }
        $_5uz1txgpjk26xjzm.splitList(editor, rootList, li);
        $_2mcwg8gmjk26xjzi.normalizeLists(editor.dom, rootList.parentNode);
      });
      editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
    };
    var isValidLists = function isValidLists(list1, list2) {
      return list1 && list2 && $_d57y6rgljk26xjze.isListNode(list1) && list1.nodeName === list2.nodeName;
    };
    var hasSameListStyle = function hasSameListStyle(dom, list1, list2) {
      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
      var style = dom.getStyle(list2, 'list-style-type', true);
      return targetStyle === style;
    };
    var hasSameClasses = function hasSameClasses(elm1, elm2) {
      return elm1.className === elm2.className;
    };
    var shouldMerge = function shouldMerge(dom, list1, list2) {
      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
    };
    var mergeWithAdjacentLists = function mergeWithAdjacentLists(dom, listBlock) {
      var sibling, node;
      sibling = listBlock.nextSibling;
      if (shouldMerge(dom, listBlock, sibling)) {
        while (node = sibling.firstChild) {
          listBlock.appendChild(node);
        }
        dom.remove(sibling);
      }
      sibling = listBlock.previousSibling;
      if (shouldMerge(dom, listBlock, sibling)) {
        while (node = sibling.lastChild) {
          listBlock.insertBefore(node, listBlock.firstChild);
        }
        dom.remove(sibling);
      }
    };
    var updateList = function updateList(dom, list, listName, detail) {
      if (list.nodeName !== listName) {
        var newList = dom.rename(list, listName);
        updateListWithDetails(dom, newList, detail);
      } else {
        updateListWithDetails(dom, list, detail);
      }
    };
    var toggleMultipleLists = function toggleMultipleLists(editor, parentList, lists, listName, detail) {
      if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
        removeList(editor);
      } else {
        var bookmark = $_aqcyy4gjjk26xjza.createBookmark(editor.selection.getRng(true));
        global$5.each([parentList].concat(lists), function (elm) {
          updateList(editor.dom, elm, listName, detail);
        });
        editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
      }
    };
    var hasListStyleDetail = function hasListStyleDetail(detail) {
      return 'list-style-type' in detail;
    };
    var toggleSingleList = function toggleSingleList(editor, parentList, listName, detail) {
      if (parentList === editor.getBody()) {
        return;
      }
      if (parentList) {
        if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
          removeList(editor);
        } else {
          var bookmark = $_aqcyy4gjjk26xjza.createBookmark(editor.selection.getRng(true));
          updateListWithDetails(editor.dom, parentList, detail);
          mergeWithAdjacentLists(editor.dom, editor.dom.rename(parentList, listName));
          editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
        }
      } else {
        applyList(editor, listName, detail);
      }
    };
    var toggleList = function toggleList(editor, listName, detail) {
      var parentList = $_69b1t0gnjk26xjzj.getParentList(editor);
      var selectedSubLists = $_69b1t0gnjk26xjzj.getSelectedSubLists(editor);
      detail = detail ? detail : {};
      if (parentList && selectedSubLists.length > 0) {
        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
      } else {
        toggleSingleList(editor, parentList, listName, detail);
      }
    };
    var $_dwoyf8gejk26xjyz = {
      toggleList: toggleList,
      removeList: removeList,
      mergeWithAdjacentLists: mergeWithAdjacentLists
    };

    var findNextCaretContainer = function findNextCaretContainer(editor, rng, isForward, root) {
      var node = rng.startContainer;
      var offset = rng.startOffset;
      var nonEmptyBlocks, walker;
      if (node.nodeType === 3 && (isForward ? offset < node.data.length : offset > 0)) {
        return node;
      }
      nonEmptyBlocks = editor.schema.getNonEmptyElements();
      if (node.nodeType === 1) {
        node = global$1.getNode(node, offset);
      }
      walker = new global$2(node, root);
      if (isForward) {
        if ($_d57y6rgljk26xjze.isBogusBr(editor.dom, node)) {
          walker.next();
        }
      }
      while (node = walker[isForward ? 'next' : 'prev2']()) {
        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
          return node;
        }
        if (nonEmptyBlocks[node.nodeName]) {
          return node;
        }
        if (node.nodeType === 3 && node.data.length > 0) {
          return node;
        }
      }
    };
    var hasOnlyOneBlockChild = function hasOnlyOneBlockChild(dom, elm) {
      var childNodes = elm.childNodes;
      return childNodes.length === 1 && !$_d57y6rgljk26xjze.isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
    };
    var unwrapSingleBlockChild = function unwrapSingleBlockChild(dom, elm) {
      if (hasOnlyOneBlockChild(dom, elm)) {
        dom.remove(elm.firstChild, true);
      }
    };
    var moveChildren = function moveChildren(dom, fromElm, toElm) {
      var node, targetElm;
      targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
      unwrapSingleBlockChild(dom, fromElm);
      if (!$_d57y6rgljk26xjze.isEmpty(dom, fromElm, true)) {
        while (node = fromElm.firstChild) {
          targetElm.appendChild(node);
        }
      }
    };
    var mergeLiElements = function mergeLiElements(dom, fromElm, toElm) {
      var node, listNode;
      var ul = fromElm.parentNode;
      if (!$_d57y6rgljk26xjze.isChildOfBody(dom, fromElm) || !$_d57y6rgljk26xjze.isChildOfBody(dom, toElm)) {
        return;
      }
      if ($_d57y6rgljk26xjze.isListNode(toElm.lastChild)) {
        listNode = toElm.lastChild;
      }
      if (ul === toElm.lastChild) {
        if ($_d57y6rgljk26xjze.isBr(ul.previousSibling)) {
          dom.remove(ul.previousSibling);
        }
      }
      node = toElm.lastChild;
      if (node && $_d57y6rgljk26xjze.isBr(node) && fromElm.hasChildNodes()) {
        dom.remove(node);
      }
      if ($_d57y6rgljk26xjze.isEmpty(dom, toElm, true)) {
        dom.$(toElm).empty();
      }
      moveChildren(dom, fromElm, toElm);
      if (listNode) {
        toElm.appendChild(listNode);
      }
      dom.remove(fromElm);
      if ($_d57y6rgljk26xjze.isEmpty(dom, ul) && ul !== dom.getRoot()) {
        dom.remove(ul);
      }
    };
    var mergeIntoEmptyLi = function mergeIntoEmptyLi(editor, fromLi, toLi) {
      editor.dom.$(toLi).empty();
      mergeLiElements(editor.dom, fromLi, toLi);
      editor.selection.setCursorLocation(toLi);
    };
    var mergeForward = function mergeForward(editor, rng, fromLi, toLi) {
      var dom = editor.dom;
      if (dom.isEmpty(toLi)) {
        mergeIntoEmptyLi(editor, fromLi, toLi);
      } else {
        var bookmark = $_aqcyy4gjjk26xjza.createBookmark(rng);
        mergeLiElements(dom, fromLi, toLi);
        editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
      }
    };
    var mergeBackward = function mergeBackward(editor, rng, fromLi, toLi) {
      var bookmark = $_aqcyy4gjjk26xjza.createBookmark(rng);
      mergeLiElements(editor.dom, fromLi, toLi);
      var resolvedBookmark = $_aqcyy4gjjk26xjza.resolveBookmark(bookmark);
      editor.selection.setRng(resolvedBookmark);
    };
    var backspaceDeleteFromListToListCaret = function backspaceDeleteFromListToListCaret(editor, isForward) {
      var dom = editor.dom,
          selection = editor.selection;
      var selectionStartElm = selection.getStart();
      var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, selectionStartElm);
      var li = dom.getParent(selection.getStart(), 'LI', root);
      var ul, rng, otherLi;
      if (li) {
        ul = li.parentNode;
        if (ul === editor.getBody() && $_d57y6rgljk26xjze.isEmpty(dom, ul)) {
          return true;
        }
        rng = $_3aa7p1gkjk26xjzd.normalizeRange(selection.getRng(true));
        otherLi = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
        if (otherLi && otherLi !== li) {
          if (isForward) {
            mergeForward(editor, rng, otherLi, li);
          } else {
            mergeBackward(editor, rng, li, otherLi);
          }
          return true;
        } else if (!otherLi) {
          if (!isForward && $_dwoyf8gejk26xjyz.removeList(editor)) {
            return true;
          }
        }
      }
      return false;
    };
    var removeBlock = function removeBlock(dom, block, root) {
      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
      dom.remove(block);
      if (parentBlock && dom.isEmpty(parentBlock)) {
        dom.remove(parentBlock);
      }
    };
    var backspaceDeleteIntoListCaret = function backspaceDeleteIntoListCaret(editor, isForward) {
      var dom = editor.dom;
      var selectionStartElm = editor.selection.getStart();
      var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, selectionStartElm);
      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
      if (block && dom.isEmpty(block)) {
        var rng = $_3aa7p1gkjk26xjzd.normalizeRange(editor.selection.getRng(true));
        var otherLi_1 = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
        if (otherLi_1) {
          editor.undoManager.transact(function () {
            removeBlock(dom, block, root);
            $_dwoyf8gejk26xjyz.mergeWithAdjacentLists(dom, otherLi_1.parentNode);
            editor.selection.select(otherLi_1, true);
            editor.selection.collapse(isForward);
          });
          return true;
        }
      }
      return false;
    };
    var backspaceDeleteCaret = function backspaceDeleteCaret(editor, isForward) {
      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
    };
    var backspaceDeleteRange = function backspaceDeleteRange(editor) {
      var selectionStartElm = editor.selection.getStart();
      var root = $_69b1t0gnjk26xjzj.getClosestListRootElm(editor, selectionStartElm);
      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
      if (startListParent || $_69b1t0gnjk26xjzj.getSelectedListItems(editor).length > 0) {
        editor.undoManager.transact(function () {
          editor.execCommand('Delete');
          $_2mcwg8gmjk26xjzi.normalizeLists(editor.dom, editor.getBody());
        });
        return true;
      }
      return false;
    };
    var backspaceDelete = function backspaceDelete(editor, isForward) {
      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
    };
    var setup = function setup(editor) {
      editor.on('keydown', function (e) {
        if (e.keyCode === global$3.BACKSPACE) {
          if (backspaceDelete(editor, false)) {
            e.preventDefault();
          }
        } else if (e.keyCode === global$3.DELETE) {
          if (backspaceDelete(editor, true)) {
            e.preventDefault();
          }
        }
      });
    };
    var $_f4h1u7gajk26xjyp = {
      setup: setup,
      backspaceDelete: backspaceDelete
    };

    var get = function get(editor) {
      return {
        backspaceDelete: function backspaceDelete(isForward) {
          $_f4h1u7gajk26xjyp.backspaceDelete(editor, isForward);
        }
      };
    };
    var $_anep83g9jk26xjyn = { get: get };

    var DOM$5 = global$6.DOM;
    var mergeLists = function mergeLists(from, to) {
      var node;
      if ($_d57y6rgljk26xjze.isListNode(from)) {
        while (node = from.firstChild) {
          to.appendChild(node);
        }
        DOM$5.remove(from);
      }
    };
    var indent = function indent(li) {
      var sibling, newList, listStyle;
      if (li.nodeName === 'DT') {
        DOM$5.rename(li, 'DD');
        return true;
      }
      sibling = li.previousSibling;
      if (sibling && $_d57y6rgljk26xjze.isListNode(sibling)) {
        sibling.appendChild(li);
        return true;
      }
      if (sibling && sibling.nodeName === 'LI' && $_d57y6rgljk26xjze.isListNode(sibling.lastChild)) {
        sibling.lastChild.appendChild(li);
        mergeLists(li.lastChild, sibling.lastChild);
        return true;
      }
      sibling = li.nextSibling;
      if (sibling && $_d57y6rgljk26xjze.isListNode(sibling)) {
        sibling.insertBefore(li, sibling.firstChild);
        return true;
      }
      sibling = li.previousSibling;
      if (sibling && sibling.nodeName === 'LI') {
        newList = DOM$5.create(li.parentNode.nodeName);
        listStyle = DOM$5.getStyle(li.parentNode, 'listStyleType');
        if (listStyle) {
          DOM$5.setStyle(newList, 'listStyleType', listStyle);
        }
        sibling.appendChild(newList);
        newList.appendChild(li);
        mergeLists(li.lastChild, newList);
        return true;
      }
      return false;
    };
    var indentSelection = function indentSelection(editor) {
      var listElements = $_69b1t0gnjk26xjzj.getSelectedListItems(editor);
      if (listElements.length) {
        var bookmark = $_aqcyy4gjjk26xjza.createBookmark(editor.selection.getRng(true));
        for (var i = 0; i < listElements.length; i++) {
          if (!indent(listElements[i]) && i === 0) {
            break;
          }
        }
        editor.selection.setRng($_aqcyy4gjjk26xjza.resolveBookmark(bookmark));
        editor.nodeChanged();
        return true;
      }
    };
    var $_6fmw52gtjk26xjzx = { indentSelection: indentSelection };

    var queryListCommandState = function queryListCommandState(editor, listName) {
      return function () {
        var parentList = editor.dom.getParent(editor.selection.getStart(), 'UL,OL,DL');
        return parentList && parentList.nodeName === listName;
      };
    };
    var register = function register(editor) {
      editor.on('BeforeExecCommand', function (e) {
        var cmd = e.command.toLowerCase();
        var isHandled;
        if (cmd === 'indent') {
          if ($_6fmw52gtjk26xjzx.indentSelection(editor)) {
            isHandled = true;
          }
        } else if (cmd === 'outdent') {
          if ($_djsp7vghjk26xjz6.outdentSelection(editor)) {
            isHandled = true;
          }
        }
        if (isHandled) {
          editor.fire('ExecCommand', { command: e.command });
          e.preventDefault();
          return true;
        }
      });
      editor.addCommand('InsertUnorderedList', function (ui, detail) {
        $_dwoyf8gejk26xjyz.toggleList(editor, 'UL', detail);
      });
      editor.addCommand('InsertOrderedList', function (ui, detail) {
        $_dwoyf8gejk26xjyz.toggleList(editor, 'OL', detail);
      });
      editor.addCommand('InsertDefinitionList', function (ui, detail) {
        $_dwoyf8gejk26xjyz.toggleList(editor, 'DL', detail);
      });
      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
    };
    var $_56orsrgsjk26xjzv = { register: register };

    var shouldIndentOnTab = function shouldIndentOnTab(editor) {
      return editor.getParam('lists_indent_on_tab', true);
    };
    var $_dbqwf1gvjk26xk08 = { shouldIndentOnTab: shouldIndentOnTab };

    var setupTabKey = function setupTabKey(editor) {
      editor.on('keydown', function (e) {
        if (e.keyCode !== global$3.TAB || global$3.metaKeyPressed(e)) {
          return;
        }
        if (editor.dom.getParent(editor.selection.getStart(), 'LI,DT,DD')) {
          e.preventDefault();
          if (e.shiftKey) {
            $_djsp7vghjk26xjz6.outdentSelection(editor);
          } else {
            $_6fmw52gtjk26xjzx.indentSelection(editor);
          }
        }
      });
    };
    var setup$1 = function setup$1(editor) {
      if ($_dbqwf1gvjk26xk08.shouldIndentOnTab(editor)) {
        setupTabKey(editor);
      }
      $_f4h1u7gajk26xjyp.setup(editor);
    };
    var $_1087ztgujk26xk05 = { setup: setup$1 };

    var findIndex = function findIndex(list, predicate) {
      for (var index = 0; index < list.length; index++) {
        var element = list[index];
        if (predicate(element)) {
          return index;
        }
      }
      return -1;
    };
    var listState = function listState(editor, listName) {
      return function (e) {
        var ctrl = e.control;
        editor.on('NodeChange', function (e) {
          var tableCellIndex = findIndex(e.parents, $_d57y6rgljk26xjze.isTableCellNode);
          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
          var lists = global$5.grep(parents, $_d57y6rgljk26xjze.isListNode);
          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
        });
      };
    };
    var indentPostRender = function indentPostRender(editor) {
      return function (e) {
        var ctrl = e.control;
        editor.on('nodechange', function () {
          var listItemBlocks = $_69b1t0gnjk26xjzj.getSelectedListItems(editor);
          var disable = listItemBlocks.length > 0 && $_d57y6rgljk26xjze.isFirstChild(listItemBlocks[0]);
          ctrl.disabled(disable);
        });
      };
    };
    var register$1 = function register$1(editor) {
      var hasPlugin = function hasPlugin(editor, plugin) {
        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
        return global$5.inArray(plugins.split(/[ ,]/), plugin) !== -1;
      };
      if (!hasPlugin(editor, 'advlist')) {
        editor.addButton('numlist', {
          active: false,
          title: 'Numbered list',
          cmd: 'InsertOrderedList',
          onPostRender: listState(editor, 'OL')
        });
        editor.addButton('bullist', {
          active: false,
          title: 'Bullet list',
          cmd: 'InsertUnorderedList',
          onPostRender: listState(editor, 'UL')
        });
      }
      editor.addButton('indent', {
        icon: 'indent',
        title: 'Increase indent',
        cmd: 'Indent',
        onPostRender: indentPostRender(editor)
      });
    };
    var $_fw4h17gwjk26xk09 = { register: register$1 };

    global.add('lists', function (editor) {
      $_1087ztgujk26xk05.setup(editor);
      $_fw4h17gwjk26xk09.register(editor);
      $_56orsrgsjk26xjzv.register(editor);
      return $_anep83g9jk26xjyn.get(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1021 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/nonbreaking/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "nonbreaking" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/nonbreaking')
//   ES2015:
//     import 'tinymce/plugins/nonbreaking'
__webpack_require__(/*! ./plugin.js */ 1022);

/***/ }),
/* 1022 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/nonbreaking/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var nonbreaking = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var stringRepeat = function stringRepeat(string, repeats) {
      var str = '';
      for (var index = 0; index < repeats; index++) {
        str += string;
      }
      return str;
    };
    var isVisualCharsEnabled = function isVisualCharsEnabled(editor) {
      return editor.plugins.visualchars ? editor.plugins.visualchars.isEnabled() : false;
    };
    var insertNbsp = function insertNbsp(editor, times) {
      var nbsp = isVisualCharsEnabled(editor) ? '<span class="mce-nbsp">&nbsp;</span>' : '&nbsp;';
      editor.insertContent(stringRepeat(nbsp, times));
      editor.dom.setAttrib(editor.dom.select('span.mce-nbsp'), 'data-mce-bogus', '1');
    };
    var $_d14d34htjk26xk61 = { insertNbsp: insertNbsp };

    var register = function register(editor) {
      editor.addCommand('mceNonBreaking', function () {
        $_d14d34htjk26xk61.insertNbsp(editor, 1);
      });
    };
    var $_e75wuyhsjk26xk60 = { register: register };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var getKeyboardSpaces = function getKeyboardSpaces(editor) {
      var spaces = editor.getParam('nonbreaking_force_tab', 0);
      if (typeof spaces === 'boolean') {
        return spaces === true ? 3 : 0;
      } else {
        return spaces;
      }
    };
    var $_4txpe8hwjk26xk64 = { getKeyboardSpaces: getKeyboardSpaces };

    var setup = function setup(editor) {
      var spaces = $_4txpe8hwjk26xk64.getKeyboardSpaces(editor);
      if (spaces > 0) {
        editor.on('keydown', function (e) {
          if (e.keyCode === global$1.TAB && !e.isDefaultPrevented()) {
            if (e.shiftKey) {
              return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            $_d14d34htjk26xk61.insertNbsp(editor, spaces);
          }
        });
      }
    };
    var $_18wnpwhujk26xk62 = { setup: setup };

    var register$1 = function register$1(editor) {
      editor.addButton('nonbreaking', {
        title: 'Nonbreaking space',
        cmd: 'mceNonBreaking'
      });
      editor.addMenuItem('nonbreaking', {
        icon: 'nonbreaking',
        text: 'Nonbreaking space',
        cmd: 'mceNonBreaking',
        context: 'insert'
      });
    };
    var $_chg55shxjk26xk65 = { register: register$1 };

    global.add('nonbreaking', function (editor) {
      $_e75wuyhsjk26xk60.register(editor);
      $_chg55shxjk26xk65.register(editor);
      $_18wnpwhujk26xk62.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1023 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/pagebreak/index.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "pagebreak" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/pagebreak')
//   ES2015:
//     import 'tinymce/plugins/pagebreak'
__webpack_require__(/*! ./plugin.js */ 1024);

/***/ }),
/* 1024 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/pagebreak/plugin.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var pagebreak = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var getSeparatorHtml = function getSeparatorHtml(editor) {
      return editor.getParam('pagebreak_separator', '<!-- pagebreak -->');
    };
    var shouldSplitBlock = function shouldSplitBlock(editor) {
      return editor.getParam('pagebreak_split_block', false);
    };
    var $_c9s0jwi8jk26xk6z = {
      getSeparatorHtml: getSeparatorHtml,
      shouldSplitBlock: shouldSplitBlock
    };

    var getPageBreakClass = function getPageBreakClass() {
      return 'mce-pagebreak';
    };
    var getPlaceholderHtml = function getPlaceholderHtml() {
      return '<img src="' + global$1.transparentSrc + '" class="' + getPageBreakClass() + '" data-mce-resize="false" data-mce-placeholder />';
    };
    var setup = function setup(editor) {
      var separatorHtml = $_c9s0jwi8jk26xk6z.getSeparatorHtml(editor);
      var pageBreakSeparatorRegExp = new RegExp(separatorHtml.replace(/[\?\.\*\[\]\(\)\{\}\+\^\$\:]/g, function (a) {
        return '\\' + a;
      }), 'gi');
      editor.on('BeforeSetContent', function (e) {
        e.content = e.content.replace(pageBreakSeparatorRegExp, getPlaceholderHtml());
      });
      editor.on('PreInit', function () {
        editor.serializer.addNodeFilter('img', function (nodes) {
          var i = nodes.length,
              node,
              className;
          while (i--) {
            node = nodes[i];
            className = node.attr('class');
            if (className && className.indexOf('mce-pagebreak') !== -1) {
              var parentNode = node.parent;
              if (editor.schema.getBlockElements()[parentNode.name] && $_c9s0jwi8jk26xk6z.shouldSplitBlock(editor)) {
                parentNode.type = 3;
                parentNode.value = separatorHtml;
                parentNode.raw = true;
                node.remove();
                continue;
              }
              node.type = 3;
              node.value = separatorHtml;
              node.raw = true;
            }
          }
        });
      });
    };
    var $_cgljy0i6jk26xk6x = {
      setup: setup,
      getPlaceholderHtml: getPlaceholderHtml,
      getPageBreakClass: getPageBreakClass
    };

    var register = function register(editor) {
      editor.addCommand('mcePageBreak', function () {
        if (editor.settings.pagebreak_split_block) {
          editor.insertContent('<p>' + $_cgljy0i6jk26xk6x.getPlaceholderHtml() + '</p>');
        } else {
          editor.insertContent($_cgljy0i6jk26xk6x.getPlaceholderHtml());
        }
      });
    };
    var $_lwqiyi5jk26xk6v = { register: register };

    var setup$1 = function setup$1(editor) {
      editor.on('ResolveName', function (e) {
        if (e.target.nodeName === 'IMG' && editor.dom.hasClass(e.target, $_cgljy0i6jk26xk6x.getPageBreakClass())) {
          e.name = 'pagebreak';
        }
      });
    };
    var $_bnn75si9jk26xk70 = { setup: setup$1 };

    var register$1 = function register$1(editor) {
      editor.addButton('pagebreak', {
        title: 'Page break',
        cmd: 'mcePageBreak'
      });
      editor.addMenuItem('pagebreak', {
        text: 'Page break',
        icon: 'pagebreak',
        cmd: 'mcePageBreak',
        context: 'insert'
      });
    };
    var $_1sepciajk26xk71 = { register: register$1 };

    global.add('pagebreak', function (editor) {
      $_lwqiyi5jk26xk6v.register(editor);
      $_1sepciajk26xk71.register(editor);
      $_cgljy0i6jk26xk6x.setup(editor);
      $_bnn75si9jk26xk70.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1025 */
/*!*******************************************************!*\
  !*** ./src/packages/tinymce/plugins/preview/index.js ***!
  \*******************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "preview" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/preview')
//   ES2015:
//     import 'tinymce/plugins/preview'
__webpack_require__(/*! ./plugin.js */ 1026);

/***/ }),
/* 1026 */
/*!********************************************************!*\
  !*** ./src/packages/tinymce/plugins/preview/plugin.js ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var preview = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var getPreviewDialogWidth = function getPreviewDialogWidth(editor) {
      return parseInt(editor.getParam('plugin_preview_width', '650'), 10);
    };
    var getPreviewDialogHeight = function getPreviewDialogHeight(editor) {
      return parseInt(editor.getParam('plugin_preview_height', '500'), 10);
    };
    var getContentStyle = function getContentStyle(editor) {
      return editor.getParam('content_style', '');
    };
    var $_bswclpjfjk26xke1 = {
      getPreviewDialogWidth: getPreviewDialogWidth,
      getPreviewDialogHeight: getPreviewDialogHeight,
      getContentStyle: getContentStyle
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getPreviewHtml = function getPreviewHtml(editor) {
      var previewHtml;
      var headHtml = '';
      var encode = editor.dom.encode;
      var contentStyle = $_bswclpjfjk26xke1.getContentStyle(editor);
      headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">';
      if (contentStyle) {
        headHtml += '<style type="text/css">' + contentStyle + '</style>';
      }
      global$2.each(editor.contentCSS, function (url) {
        headHtml += '<link type="text/css" rel="stylesheet" href="' + encode(editor.documentBaseURI.toAbsolute(url)) + '">';
      });
      var bodyId = editor.settings.body_id || 'tinymce';
      if (bodyId.indexOf('=') !== -1) {
        bodyId = editor.getParam('body_id', '', 'hash');
        bodyId = bodyId[editor.id] || bodyId;
      }
      var bodyClass = editor.settings.body_class || '';
      if (bodyClass.indexOf('=') !== -1) {
        bodyClass = editor.getParam('body_class', '', 'hash');
        bodyClass = bodyClass[editor.id] || '';
      }
      var preventClicksOnLinksScript = '<script>' + 'document.addEventListener && document.addEventListener("click", function(e) {' + 'for (var elm = e.target; elm; elm = elm.parentNode) {' + 'if (elm.nodeName === "A") {' + 'e.preventDefault();' + '}' + '}' + '}, false);' + '</script> ';
      var dirAttr = editor.settings.directionality ? ' dir="' + editor.settings.directionality + '"' : '';
      previewHtml = '<!DOCTYPE html>' + '<html>' + '<head>' + headHtml + '</head>' + '<body id="' + encode(bodyId) + '" class="mce-content-body ' + encode(bodyClass) + '"' + encode(dirAttr) + '>' + editor.getContent() + preventClicksOnLinksScript + '</body>' + '</html>';
      return previewHtml;
    };
    var injectIframeContent = function injectIframeContent(editor, iframe, sandbox) {
      var previewHtml = getPreviewHtml(editor);
      if (!sandbox) {
        var doc = iframe.contentWindow.document;
        doc.open();
        doc.write(previewHtml);
        doc.close();
      } else {
        iframe.src = 'data:text/html;charset=utf-8,' + encodeURIComponent(previewHtml);
      }
    };
    var $_8hkhffjgjk26xke2 = {
      getPreviewHtml: getPreviewHtml,
      injectIframeContent: injectIframeContent
    };

    var open = function open(editor) {
      var sandbox = !global$1.ie;
      var dialogHtml = '<iframe src="" frameborder="0"' + (sandbox ? ' sandbox="allow-scripts"' : '') + '></iframe>';
      var dialogWidth = $_bswclpjfjk26xke1.getPreviewDialogWidth(editor);
      var dialogHeight = $_bswclpjfjk26xke1.getPreviewDialogHeight(editor);
      editor.windowManager.open({
        title: 'Preview',
        width: dialogWidth,
        height: dialogHeight,
        html: dialogHtml,
        buttons: {
          text: 'Close',
          onclick: function onclick(e) {
            e.control.parent().parent().close();
          }
        },
        onPostRender: function onPostRender(e) {
          var iframeElm = e.control.getEl('body').firstChild;
          $_8hkhffjgjk26xke2.injectIframeContent(editor, iframeElm, sandbox);
        }
      });
    };
    var $_cjl9fzjdjk26xkdz = { open: open };

    var register = function register(editor) {
      editor.addCommand('mcePreview', function () {
        $_cjl9fzjdjk26xkdz.open(editor);
      });
    };
    var $_f4scp7jcjk26xkdy = { register: register };

    var register$1 = function register$1(editor) {
      editor.addButton('preview', {
        title: 'Preview',
        cmd: 'mcePreview'
      });
      editor.addMenuItem('preview', {
        text: 'Preview',
        cmd: 'mcePreview',
        context: 'view'
      });
    };
    var $_6uganfjijk26xke6 = { register: register$1 };

    global.add('preview', function (editor) {
      $_f4scp7jcjk26xkdy.register(editor);
      $_6uganfjijk26xke6.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1027 */
/*!****************************************************!*\
  !*** ./src/packages/tinymce/plugins/save/index.js ***!
  \****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "save" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/save')
//   ES2015:
//     import 'tinymce/plugins/save'
__webpack_require__(/*! ./plugin.js */ 1028);

/***/ }),
/* 1028 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/save/plugin.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var save = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var enableWhenDirty = function enableWhenDirty(editor) {
      return editor.getParam('save_enablewhendirty', true);
    };
    var hasOnSaveCallback = function hasOnSaveCallback(editor) {
      return !!editor.getParam('save_onsavecallback');
    };
    var hasOnCancelCallback = function hasOnCancelCallback(editor) {
      return !!editor.getParam('save_oncancelcallback');
    };
    var $_2z3khtjtjk26xkez = {
      enableWhenDirty: enableWhenDirty,
      hasOnSaveCallback: hasOnSaveCallback,
      hasOnCancelCallback: hasOnCancelCallback
    };

    var displayErrorMessage = function displayErrorMessage(editor, message) {
      editor.notificationManager.open({
        text: editor.translate(message),
        type: 'error'
      });
    };
    var save = function save(editor) {
      var formObj;
      formObj = global$1.DOM.getParent(editor.id, 'form');
      if ($_2z3khtjtjk26xkez.enableWhenDirty(editor) && !editor.isDirty()) {
        return;
      }
      editor.save();
      if ($_2z3khtjtjk26xkez.hasOnSaveCallback(editor)) {
        editor.execCallback('save_onsavecallback', editor);
        editor.nodeChanged();
        return;
      }
      if (formObj) {
        editor.setDirty(false);
        if (!formObj.onsubmit || formObj.onsubmit()) {
          if (typeof formObj.submit === 'function') {
            formObj.submit();
          } else {
            displayErrorMessage(editor, 'Error: Form submit field collision.');
          }
        }
        editor.nodeChanged();
      } else {
        displayErrorMessage(editor, 'Error: No form element found.');
      }
    };
    var cancel = function cancel(editor) {
      var h = global$2.trim(editor.startContent);
      if ($_2z3khtjtjk26xkez.hasOnCancelCallback(editor)) {
        editor.execCallback('save_oncancelcallback', editor);
        return;
      }
      editor.setContent(h);
      editor.undoManager.clear();
      editor.nodeChanged();
    };
    var $_5hrrhxjqjk26xkew = {
      save: save,
      cancel: cancel
    };

    var register = function register(editor) {
      editor.addCommand('mceSave', function () {
        $_5hrrhxjqjk26xkew.save(editor);
      });
      editor.addCommand('mceCancel', function () {
        $_5hrrhxjqjk26xkew.cancel(editor);
      });
    };
    var $_7dia1ljpjk26xkev = { register: register };

    var stateToggle = function stateToggle(editor) {
      return function (e) {
        var ctrl = e.control;
        editor.on('nodeChange dirty', function () {
          ctrl.disabled($_2z3khtjtjk26xkez.enableWhenDirty(editor) && !editor.isDirty());
        });
      };
    };
    var register$1 = function register$1(editor) {
      editor.addButton('save', {
        icon: 'save',
        text: 'Save',
        cmd: 'mceSave',
        disabled: true,
        onPostRender: stateToggle(editor)
      });
      editor.addButton('cancel', {
        text: 'Cancel',
        icon: false,
        cmd: 'mceCancel',
        disabled: true,
        onPostRender: stateToggle(editor)
      });
      editor.addShortcut('Meta+S', '', 'mceSave');
    };
    var $_8q9r2cjujk26xkf0 = { register: register$1 };

    global.add('save', function (editor) {
      $_8q9r2cjujk26xkf0.register(editor);
      $_7dia1ljpjk26xkev.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1029 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/spellchecker/index.js ***!
  \************************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "spellchecker" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/spellchecker')
//   ES2015:
//     import 'tinymce/plugins/spellchecker'
__webpack_require__(/*! ./plugin.js */ 1030);

/***/ }),
/* 1030 */
/*!*************************************************************!*\
  !*** ./src/packages/tinymce/plugins/spellchecker/plugin.js ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var spellchecker = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var hasProPlugin = function hasProPlugin(editor) {
      if (/(^|[ ,])tinymcespellchecker([, ]|$)/.test(editor.settings.plugins) && global.get('tinymcespellchecker')) {
        if (typeof window.console !== 'undefined' && window.console.log) {
          window.console.log('Spell Checker Pro is incompatible with Spell Checker plugin! ' + 'Remove \'spellchecker\' from the \'plugins\' option.');
        }
        return true;
      } else {
        return false;
      }
    };
    var $_ctl9gik8jk26xkh0 = { hasProPlugin: hasProPlugin };

    var getLanguages = function getLanguages(editor) {
      var defaultLanguages = 'English=en,Danish=da,Dutch=nl,Finnish=fi,French=fr_FR,German=de,Italian=it,Polish=pl,Portuguese=pt_BR,Spanish=es,Swedish=sv';
      return editor.getParam('spellchecker_languages', defaultLanguages);
    };
    var getLanguage = function getLanguage(editor) {
      var defaultLanguage = editor.getParam('language', 'en');
      return editor.getParam('spellchecker_language', defaultLanguage);
    };
    var getRpcUrl = function getRpcUrl(editor) {
      return editor.getParam('spellchecker_rpc_url');
    };
    var getSpellcheckerCallback = function getSpellcheckerCallback(editor) {
      return editor.getParam('spellchecker_callback');
    };
    var getSpellcheckerWordcharPattern = function getSpellcheckerWordcharPattern(editor) {
      var defaultPattern = new RegExp('[^' + '\\s!"#$%&()*+,-./:;<=>?@[\\]^_{|}`' + '\xA7\xA9\xAB\xAE\xB1\xB6\xB7\xB8\xBB' + '\xBC\xBD\xBE\xBF\xD7\xF7\xA4\u201D\u201C\u201E\xA0\u2002\u2003\u2009' + ']+', 'g');
      return editor.getParam('spellchecker_wordchar_pattern', defaultPattern);
    };
    var $_ontahkbjk26xkhm = {
      getLanguages: getLanguages,
      getLanguage: getLanguage,
      getRpcUrl: getRpcUrl,
      getSpellcheckerCallback: getSpellcheckerCallback,
      getSpellcheckerWordcharPattern: getSpellcheckerWordcharPattern
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.URI');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var fireSpellcheckStart = function fireSpellcheckStart(editor) {
      return editor.fire('SpellcheckStart');
    };
    var fireSpellcheckEnd = function fireSpellcheckEnd(editor) {
      return editor.fire('SpellcheckEnd');
    };
    var $_1undfdkgjk26xkhu = {
      fireSpellcheckStart: fireSpellcheckStart,
      fireSpellcheckEnd: fireSpellcheckEnd
    };

    function isContentEditableFalse(node) {
      return node && node.nodeType === 1 && node.contentEditable === 'false';
    }
    var DomTextMatcher = function DomTextMatcher(node, editor) {
      var m,
          matches = [],
          text;
      var dom = editor.dom;
      var blockElementsMap, hiddenTextElementsMap, shortEndedElementsMap;
      blockElementsMap = editor.schema.getBlockElements();
      hiddenTextElementsMap = editor.schema.getWhiteSpaceElements();
      shortEndedElementsMap = editor.schema.getShortEndedElements();
      function createMatch(m, data) {
        if (!m[0]) {
          throw new Error('findAndReplaceDOMText cannot handle zero-length matches');
        }
        return {
          start: m.index,
          end: m.index + m[0].length,
          text: m[0],
          data: data
        };
      }
      function getText(node) {
        var txt;
        if (node.nodeType === 3) {
          return node.data;
        }
        if (hiddenTextElementsMap[node.nodeName] && !blockElementsMap[node.nodeName]) {
          return '';
        }
        if (isContentEditableFalse(node)) {
          return '\n';
        }
        txt = '';
        if (blockElementsMap[node.nodeName] || shortEndedElementsMap[node.nodeName]) {
          txt += '\n';
        }
        if (node = node.firstChild) {
          do {
            txt += getText(node);
          } while (node = node.nextSibling);
        }
        return txt;
      }
      function stepThroughMatches(node, matches, replaceFn) {
        var startNode,
            endNode,
            startNodeIndex,
            endNodeIndex,
            innerNodes = [],
            atIndex = 0,
            curNode = node,
            matchLocation,
            matchIndex = 0;
        matches = matches.slice(0);
        matches.sort(function (a, b) {
          return a.start - b.start;
        });
        matchLocation = matches.shift();
        out: while (true) {
          if (blockElementsMap[curNode.nodeName] || shortEndedElementsMap[curNode.nodeName] || isContentEditableFalse(curNode)) {
            atIndex++;
          }
          if (curNode.nodeType === 3) {
            if (!endNode && curNode.length + atIndex >= matchLocation.end) {
              endNode = curNode;
              endNodeIndex = matchLocation.end - atIndex;
            } else if (startNode) {
              innerNodes.push(curNode);
            }
            if (!startNode && curNode.length + atIndex > matchLocation.start) {
              startNode = curNode;
              startNodeIndex = matchLocation.start - atIndex;
            }
            atIndex += curNode.length;
          }
          if (startNode && endNode) {
            curNode = replaceFn({
              startNode: startNode,
              startNodeIndex: startNodeIndex,
              endNode: endNode,
              endNodeIndex: endNodeIndex,
              innerNodes: innerNodes,
              match: matchLocation.text,
              matchIndex: matchIndex
            });
            atIndex -= endNode.length - endNodeIndex;
            startNode = null;
            endNode = null;
            innerNodes = [];
            matchLocation = matches.shift();
            matchIndex++;
            if (!matchLocation) {
              break;
            }
          } else if ((!hiddenTextElementsMap[curNode.nodeName] || blockElementsMap[curNode.nodeName]) && curNode.firstChild) {
            if (!isContentEditableFalse(curNode)) {
              curNode = curNode.firstChild;
              continue;
            }
          } else if (curNode.nextSibling) {
            curNode = curNode.nextSibling;
            continue;
          }
          while (true) {
            if (curNode.nextSibling) {
              curNode = curNode.nextSibling;
              break;
            } else if (curNode.parentNode !== node) {
              curNode = curNode.parentNode;
            } else {
              break out;
            }
          }
        }
      }
      function genReplacer(callback) {
        function makeReplacementNode(fill, matchIndex) {
          var match = matches[matchIndex];
          if (!match.stencil) {
            match.stencil = callback(match);
          }
          var clone = match.stencil.cloneNode(false);
          clone.setAttribute('data-mce-index', matchIndex);
          if (fill) {
            clone.appendChild(dom.doc.createTextNode(fill));
          }
          return clone;
        }
        return function (range) {
          var before;
          var after;
          var parentNode;
          var startNode = range.startNode;
          var endNode = range.endNode;
          var matchIndex = range.matchIndex;
          var doc = dom.doc;
          if (startNode === endNode) {
            var node_1 = startNode;
            parentNode = node_1.parentNode;
            if (range.startNodeIndex > 0) {
              before = doc.createTextNode(node_1.data.substring(0, range.startNodeIndex));
              parentNode.insertBefore(before, node_1);
            }
            var el = makeReplacementNode(range.match, matchIndex);
            parentNode.insertBefore(el, node_1);
            if (range.endNodeIndex < node_1.length) {
              after = doc.createTextNode(node_1.data.substring(range.endNodeIndex));
              parentNode.insertBefore(after, node_1);
            }
            node_1.parentNode.removeChild(node_1);
            return el;
          }
          before = doc.createTextNode(startNode.data.substring(0, range.startNodeIndex));
          after = doc.createTextNode(endNode.data.substring(range.endNodeIndex));
          var elA = makeReplacementNode(startNode.data.substring(range.startNodeIndex), matchIndex);
          var innerEls = [];
          for (var i = 0, l = range.innerNodes.length; i < l; ++i) {
            var innerNode = range.innerNodes[i];
            var innerEl = makeReplacementNode(innerNode.data, matchIndex);
            innerNode.parentNode.replaceChild(innerEl, innerNode);
            innerEls.push(innerEl);
          }
          var elB = makeReplacementNode(endNode.data.substring(0, range.endNodeIndex), matchIndex);
          parentNode = startNode.parentNode;
          parentNode.insertBefore(before, startNode);
          parentNode.insertBefore(elA, startNode);
          parentNode.removeChild(startNode);
          parentNode = endNode.parentNode;
          parentNode.insertBefore(elB, endNode);
          parentNode.insertBefore(after, endNode);
          parentNode.removeChild(endNode);
          return elB;
        };
      }
      function unwrapElement(element) {
        var parentNode = element.parentNode;
        parentNode.insertBefore(element.firstChild, element);
        element.parentNode.removeChild(element);
      }
      function hasClass(elm) {
        return elm.className.indexOf('mce-spellchecker-word') !== -1;
      }
      function getWrappersByIndex(index) {
        var elements = node.getElementsByTagName('*'),
            wrappers = [];
        index = typeof index === 'number' ? '' + index : null;
        for (var i = 0; i < elements.length; i++) {
          var element = elements[i],
              dataIndex = element.getAttribute('data-mce-index');
          if (dataIndex !== null && dataIndex.length && hasClass(element)) {
            if (dataIndex === index || index === null) {
              wrappers.push(element);
            }
          }
        }
        return wrappers;
      }
      function indexOf(match) {
        var i = matches.length;
        while (i--) {
          if (matches[i] === match) {
            return i;
          }
        }
        return -1;
      }
      function filter(callback) {
        var filteredMatches = [];
        each(function (match, i) {
          if (callback(match, i)) {
            filteredMatches.push(match);
          }
        });
        matches = filteredMatches;
        return this;
      }
      function each(callback) {
        for (var i = 0, l = matches.length; i < l; i++) {
          if (callback(matches[i], i) === false) {
            break;
          }
        }
        return this;
      }
      function wrap(callback) {
        if (matches.length) {
          stepThroughMatches(node, matches, genReplacer(callback));
        }
        return this;
      }
      function find(regex, data) {
        if (text && regex.global) {
          while (m = regex.exec(text)) {
            matches.push(createMatch(m, data));
          }
        }
        return this;
      }
      function unwrap(match) {
        var i;
        var elements = getWrappersByIndex(match ? indexOf(match) : null);
        i = elements.length;
        while (i--) {
          unwrapElement(elements[i]);
        }
        return this;
      }
      function matchFromElement(element) {
        return matches[element.getAttribute('data-mce-index')];
      }
      function elementFromMatch(match) {
        return getWrappersByIndex(indexOf(match))[0];
      }
      function add(start, length, data) {
        matches.push({
          start: start,
          end: start + length,
          text: text.substr(start, length),
          data: data
        });
        return this;
      }
      function rangeFromMatch(match) {
        var wrappers = getWrappersByIndex(indexOf(match));
        var rng = editor.dom.createRng();
        rng.setStartBefore(wrappers[0]);
        rng.setEndAfter(wrappers[wrappers.length - 1]);
        return rng;
      }
      function replace(match, text) {
        var rng = rangeFromMatch(match);
        rng.deleteContents();
        if (text.length > 0) {
          rng.insertNode(editor.dom.doc.createTextNode(text));
        }
        return rng;
      }
      function reset() {
        matches.splice(0, matches.length);
        unwrap();
        return this;
      }
      text = getText(node);
      return {
        text: text,
        matches: matches,
        each: each,
        filter: filter,
        reset: reset,
        matchFromElement: matchFromElement,
        elementFromMatch: elementFromMatch,
        find: find,
        add: add,
        wrap: wrap,
        unwrap: unwrap,
        replace: replace,
        rangeFromMatch: rangeFromMatch,
        indexOf: indexOf
      };
    };

    var getTextMatcher = function getTextMatcher(editor, textMatcherState) {
      if (!textMatcherState.get()) {
        var textMatcher = DomTextMatcher(editor.getBody(), editor);
        textMatcherState.set(textMatcher);
      }
      return textMatcherState.get();
    };
    var isEmpty = function isEmpty(obj) {
      for (var _ in obj) {
        return false;
      }
      return true;
    };
    var defaultSpellcheckCallback = function defaultSpellcheckCallback(editor, pluginUrl, currentLanguageState) {
      return function (method, text, doneCallback, errorCallback) {
        var data = {
          method: method,
          lang: currentLanguageState.get()
        };
        var postData = '';
        data[method === 'addToDictionary' ? 'word' : 'text'] = text;
        global$1.each(data, function (value, key) {
          if (postData) {
            postData += '&';
          }
          postData += key + '=' + encodeURIComponent(value);
        });
        global$3.send({
          url: new global$2(pluginUrl).toAbsolute($_ontahkbjk26xkhm.getRpcUrl(editor)),
          type: 'post',
          content_type: 'application/x-www-form-urlencoded',
          data: postData,
          success: function success(result) {
            result = JSON.parse(result);
            if (!result) {
              var message = editor.translate('Server response wasn\'t proper JSON.');
              errorCallback(message);
            } else if (result.error) {
              errorCallback(result.error);
            } else {
              doneCallback(result);
            }
          },
          error: function error() {
            var message = editor.translate('The spelling service was not found: (') + $_ontahkbjk26xkhm.getRpcUrl(editor) + editor.translate(')');
            errorCallback(message);
          }
        });
      };
    };
    var sendRpcCall = function sendRpcCall(editor, pluginUrl, currentLanguageState, name, data, successCallback, errorCallback) {
      var userSpellcheckCallback = $_ontahkbjk26xkhm.getSpellcheckerCallback(editor);
      var spellCheckCallback = userSpellcheckCallback ? userSpellcheckCallback : defaultSpellcheckCallback(editor, pluginUrl, currentLanguageState);
      spellCheckCallback.call(editor.plugins.spellchecker, name, data, successCallback, errorCallback);
    };
    var spellcheck = function spellcheck(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState) {
      if (finish(editor, startedState, textMatcherState)) {
        return;
      }
      var errorCallback = function errorCallback(message) {
        editor.notificationManager.open({
          text: message,
          type: 'error'
        });
        editor.setProgressState(false);
        finish(editor, startedState, textMatcherState);
      };
      var successCallback = function successCallback(data) {
        markErrors(editor, startedState, textMatcherState, lastSuggestionsState, data);
      };
      editor.setProgressState(true);
      sendRpcCall(editor, pluginUrl, currentLanguageState, 'spellcheck', getTextMatcher(editor, textMatcherState).text, successCallback, errorCallback);
      editor.focus();
    };
    var checkIfFinished = function checkIfFinished(editor, startedState, textMatcherState) {
      if (!editor.dom.select('span.mce-spellchecker-word').length) {
        finish(editor, startedState, textMatcherState);
      }
    };
    var addToDictionary = function addToDictionary(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, word, spans) {
      editor.setProgressState(true);
      sendRpcCall(editor, pluginUrl, currentLanguageState, 'addToDictionary', word, function () {
        editor.setProgressState(false);
        editor.dom.remove(spans, true);
        checkIfFinished(editor, startedState, textMatcherState);
      }, function (message) {
        editor.notificationManager.open({
          text: message,
          type: 'error'
        });
        editor.setProgressState(false);
      });
    };
    var ignoreWord = function ignoreWord(editor, startedState, textMatcherState, word, spans, all) {
      editor.selection.collapse();
      if (all) {
        global$1.each(editor.dom.select('span.mce-spellchecker-word'), function (span) {
          if (span.getAttribute('data-mce-word') === word) {
            editor.dom.remove(span, true);
          }
        });
      } else {
        editor.dom.remove(spans, true);
      }
      checkIfFinished(editor, startedState, textMatcherState);
    };
    var finish = function finish(editor, startedState, textMatcherState) {
      getTextMatcher(editor, textMatcherState).reset();
      textMatcherState.set(null);
      if (startedState.get()) {
        startedState.set(false);
        $_1undfdkgjk26xkhu.fireSpellcheckEnd(editor);
        return true;
      }
    };
    var getElmIndex = function getElmIndex(elm) {
      var value = elm.getAttribute('data-mce-index');
      if (typeof value === 'number') {
        return '' + value;
      }
      return value;
    };
    var findSpansByIndex = function findSpansByIndex(editor, index) {
      var nodes;
      var spans = [];
      nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
      if (nodes.length) {
        for (var i = 0; i < nodes.length; i++) {
          var nodeIndex = getElmIndex(nodes[i]);
          if (nodeIndex === null || !nodeIndex.length) {
            continue;
          }
          if (nodeIndex === index.toString()) {
            spans.push(nodes[i]);
          }
        }
      }
      return spans;
    };
    var markErrors = function markErrors(editor, startedState, textMatcherState, lastSuggestionsState, data) {
      var suggestions, hasDictionarySupport;
      if (typeof data !== 'string' && data.words) {
        hasDictionarySupport = !!data.dictionary;
        suggestions = data.words;
      } else {
        suggestions = data;
      }
      editor.setProgressState(false);
      if (isEmpty(suggestions)) {
        var message = editor.translate('No misspellings found.');
        editor.notificationManager.open({
          text: message,
          type: 'info'
        });
        startedState.set(false);
        return;
      }
      lastSuggestionsState.set({
        suggestions: suggestions,
        hasDictionarySupport: hasDictionarySupport
      });
      getTextMatcher(editor, textMatcherState).find($_ontahkbjk26xkhm.getSpellcheckerWordcharPattern(editor)).filter(function (match) {
        return !!suggestions[match.text];
      }).wrap(function (match) {
        return editor.dom.create('span', {
          'class': 'mce-spellchecker-word',
          'data-mce-bogus': 1,
          'data-mce-word': match.text
        });
      });
      startedState.set(true);
      $_1undfdkgjk26xkhu.fireSpellcheckStart(editor);
    };
    var $_5h534gkcjk26xkho = {
      spellcheck: spellcheck,
      checkIfFinished: checkIfFinished,
      addToDictionary: addToDictionary,
      ignoreWord: ignoreWord,
      findSpansByIndex: findSpansByIndex,
      getElmIndex: getElmIndex,
      markErrors: markErrors
    };

    var get = function get(editor, startedState, lastSuggestionsState, textMatcherState, currentLanguageState, url) {
      var getLanguage = function getLanguage() {
        return currentLanguageState.get();
      };
      var getWordCharPattern = function getWordCharPattern() {
        return $_ontahkbjk26xkhm.getSpellcheckerWordcharPattern(editor);
      };
      var markErrors = function markErrors(data) {
        $_5h534gkcjk26xkho.markErrors(editor, startedState, textMatcherState, lastSuggestionsState, data);
      };
      var getTextMatcher = function getTextMatcher() {
        return textMatcherState.get();
      };
      return {
        getTextMatcher: getTextMatcher,
        getWordCharPattern: getWordCharPattern,
        markErrors: markErrors,
        getLanguage: getLanguage
      };
    };
    var $_5h552akajk26xkhl = { get: get };

    var register = function register(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState) {
      editor.addCommand('mceSpellCheck', function () {
        $_5h534gkcjk26xkho.spellcheck(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
      });
    };
    var $_9mgcu6kijk26xki2 = { register: register };

    var buildMenuItems = function buildMenuItems(listName, languageValues) {
      var items = [];
      global$1.each(languageValues, function (languageValue) {
        items.push({
          selectable: true,
          text: languageValue.name,
          data: languageValue.value
        });
      });
      return items;
    };
    var updateSelection = function updateSelection(editor, currentLanguageState) {
      return function (e) {
        var selectedLanguage = currentLanguageState.get();
        e.control.items().each(function (ctrl) {
          ctrl.active(ctrl.settings.data === selectedLanguage);
        });
      };
    };
    var getItems = function getItems(editor) {
      return global$1.map($_ontahkbjk26xkhm.getLanguages(editor).split(','), function (langPair) {
        langPair = langPair.split('=');
        return {
          name: langPair[0],
          value: langPair[1]
        };
      });
    };
    var register$1 = function register$1(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, lastSuggestionsState) {
      var languageMenuItems = buildMenuItems('Language', getItems(editor));
      var startSpellchecking = function startSpellchecking() {
        $_5h534gkcjk26xkho.spellcheck(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
      };
      var buttonArgs = {
        tooltip: 'Spellcheck',
        onclick: startSpellchecking,
        onPostRender: function onPostRender(e) {
          var ctrl = e.control;
          editor.on('SpellcheckStart SpellcheckEnd', function () {
            ctrl.active(startedState.get());
          });
        }
      };
      if (languageMenuItems.length > 1) {
        buttonArgs.type = 'splitbutton';
        buttonArgs.menu = languageMenuItems;
        buttonArgs.onshow = updateSelection(editor, currentLanguageState);
        buttonArgs.onselect = function (e) {
          currentLanguageState.set(e.control.settings.data);
        };
      }
      editor.addButton('spellchecker', buttonArgs);
      editor.addMenuItem('spellchecker', {
        text: 'Spellcheck',
        context: 'tools',
        onclick: startSpellchecking,
        selectable: true,
        onPostRender: function onPostRender() {
          var self = this;
          self.active(startedState.get());
          editor.on('SpellcheckStart SpellcheckEnd', function () {
            self.active(startedState.get());
          });
        }
      });
    };
    var $_fwenq1kjjk26xki4 = { register: register$1 };

    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$5 = tinymce.util.Tools.resolve('tinymce.ui.Factory');

    var suggestionsMenu;
    var showSuggestions = function showSuggestions(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState, word, spans) {
      var items = [],
          suggestions = lastSuggestionsState.get().suggestions[word];
      global$1.each(suggestions, function (suggestion) {
        items.push({
          text: suggestion,
          onclick: function onclick() {
            editor.insertContent(editor.dom.encode(suggestion));
            editor.dom.remove(spans);
            $_5h534gkcjk26xkho.checkIfFinished(editor, startedState, textMatcherState);
          }
        });
      });
      items.push({ text: '-' });
      var hasDictionarySupport = lastSuggestionsState.get().hasDictionarySupport;
      if (hasDictionarySupport) {
        items.push({
          text: 'Add to Dictionary',
          onclick: function onclick() {
            $_5h534gkcjk26xkho.addToDictionary(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, word, spans);
          }
        });
      }
      items.push.apply(items, [{
        text: 'Ignore',
        onclick: function onclick() {
          $_5h534gkcjk26xkho.ignoreWord(editor, startedState, textMatcherState, word, spans);
        }
      }, {
        text: 'Ignore all',
        onclick: function onclick() {
          $_5h534gkcjk26xkho.ignoreWord(editor, startedState, textMatcherState, word, spans, true);
        }
      }]);
      suggestionsMenu = global$5.create('menu', {
        items: items,
        context: 'contextmenu',
        onautohide: function onautohide(e) {
          if (e.target.className.indexOf('spellchecker') !== -1) {
            e.preventDefault();
          }
        },
        onhide: function onhide() {
          suggestionsMenu.remove();
          suggestionsMenu = null;
        }
      });
      suggestionsMenu.renderTo(document.body);
      var pos = global$4.DOM.getPos(editor.getContentAreaContainer());
      var targetPos = editor.dom.getPos(spans[0]);
      var root = editor.dom.getRoot();
      if (root.nodeName === 'BODY') {
        targetPos.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
        targetPos.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
      } else {
        targetPos.x -= root.scrollLeft;
        targetPos.y -= root.scrollTop;
      }
      pos.x += targetPos.x;
      pos.y += targetPos.y;
      suggestionsMenu.moveTo(pos.x, pos.y + spans[0].offsetHeight);
    };
    var setup = function setup(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState) {
      editor.on('click', function (e) {
        var target = e.target;
        if (target.className === 'mce-spellchecker-word') {
          e.preventDefault();
          var spans = $_5h534gkcjk26xkho.findSpansByIndex(editor, $_5h534gkcjk26xkho.getElmIndex(target));
          if (spans.length > 0) {
            var rng = editor.dom.createRng();
            rng.setStartBefore(spans[0]);
            rng.setEndAfter(spans[spans.length - 1]);
            editor.selection.setRng(rng);
            showSuggestions(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState, target.getAttribute('data-mce-word'), spans);
          }
        }
      });
    };
    var $_bj4749kkjk26xki7 = { setup: setup };

    global.add('spellchecker', function (editor, pluginUrl) {
      if ($_ctl9gik8jk26xkh0.hasProPlugin(editor) === false) {
        var startedState = Cell(false);
        var currentLanguageState = Cell($_ontahkbjk26xkhm.getLanguage(editor));
        var textMatcherState = Cell(null);
        var lastSuggestionsState = Cell(null);
        $_fwenq1kjjk26xki4.register(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, lastSuggestionsState);
        $_bj4749kkjk26xki7.setup(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState);
        $_9mgcu6kijk26xki2.register(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
        return $_5h552akajk26xkhl.get(editor, startedState, lastSuggestionsState, textMatcherState, currentLanguageState, pluginUrl);
      }
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1031 */
/*!*****************************************************!*\
  !*** ./src/packages/tinymce/plugins/table/index.js ***!
  \*****************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "table" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/table')
//   ES2015:
//     import 'tinymce/plugins/table'
__webpack_require__(/*! ./plugin.js */ 1032);

/***/ }),
/* 1032 */
/*!******************************************************!*\
  !*** ./src/packages/tinymce/plugins/table/plugin.js ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var table = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var noop = function noop() {
      var x = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        x[_i] = arguments[_i];
      }
    };

    var compose = function compose(fa, fb) {
      return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        return fa(fb.apply(null, arguments));
      };
    };
    var constant = function constant(value) {
      return function () {
        return value;
      };
    };
    var identity = function identity(x) {
      return x;
    };

    var curry = function curry(f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var args = new Array(arguments.length - 1);
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        var newArgs = new Array(arguments.length);
        for (var j = 0; j < newArgs.length; j++) {
          newArgs[j] = arguments[j];
        }var all = args.concat(newArgs);
        return f.apply(null, all);
      };
    };
    var not = function not(f) {
      return function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          x[_i] = arguments[_i];
        }
        return !f.apply(null, arguments);
      };
    };
    var die = function die(msg) {
      return function () {
        throw new Error(msg);
      };
    };
    var apply = function apply(f) {
      return f();
    };

    var never = constant(false);
    var always = constant(true);

    var never$1 = never;
    var always$1 = always;
    var none = function none() {
      return NONE;
    };
    var NONE = function () {
      var eq = function eq(o) {
        return o.isNone();
      };
      var call$$1 = function call$$1(thunk) {
        return thunk();
      };
      var id = function id(n) {
        return n;
      };
      var noop$$1 = function noop$$1() {};
      var nul = function nul() {
        return null;
      };
      var undef = function undef() {
        return undefined;
      };
      var me = {
        fold: function fold(n, s) {
          return n();
        },
        is: never$1,
        isSome: never$1,
        isNone: always$1,
        getOr: id,
        getOrThunk: call$$1,
        getOrDie: function getOrDie(msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: nul,
        getOrUndefined: undef,
        or: id,
        orThunk: call$$1,
        map: none,
        ap: none,
        each: noop$$1,
        bind: none,
        flatten: none,
        exists: never$1,
        forall: always$1,
        filter: none,
        equals: eq,
        equals_: eq,
        toArray: function toArray() {
          return [];
        },
        toString: constant('none()')
      };
      if (Object.freeze) Object.freeze(me);
      return me;
    }();
    var some = function some(a) {
      var constant_a = function constant_a() {
        return a;
      };
      var self = function self() {
        return me;
      };
      var map = function map(f) {
        return some(f(a));
      };
      var bind = function bind(f) {
        return f(a);
      };
      var me = {
        fold: function fold(n, s) {
          return s(a);
        },
        is: function is(v) {
          return a === v;
        },
        isSome: always$1,
        isNone: never$1,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: map,
        ap: function ap(optfab) {
          return optfab.fold(none, function (fab) {
            return some(fab(a));
          });
        },
        each: function each(f) {
          f(a);
        },
        bind: bind,
        flatten: constant_a,
        exists: bind,
        forall: bind,
        filter: function filter(f) {
          return f(a) ? me : NONE;
        },
        equals: function equals(o) {
          return o.is(a);
        },
        equals_: function equals_(o, elementEq) {
          return o.fold(never$1, function (b) {
            return elementEq(a, b);
          });
        },
        toArray: function toArray() {
          return [a];
        },
        toString: function toString() {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function from(value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Option = {
      some: some,
      none: none,
      from: from
    };

    var typeOf = function typeOf(x) {
      if (x === null) return 'null';
      var t = typeof x === 'undefined' ? 'undefined' : _typeof(x);
      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
      return t;
    };
    var isType = function isType(type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isString = isType('string');

    var isArray = isType('array');

    var isBoolean = isType('boolean');

    var isFunction = isType('function');
    var isNumber = isType('number');

    var rawIndexOf = function () {
      var pIndexOf = Array.prototype.indexOf;
      var fastIndex = function fastIndex(xs, x) {
        return pIndexOf.call(xs, x);
      };
      var slowIndex = function slowIndex(xs, x) {
        return slowIndexOf(xs, x);
      };
      return pIndexOf === undefined ? slowIndex : fastIndex;
    }();

    var contains = function contains(xs, x) {
      return rawIndexOf(xs, x) > -1;
    };
    var exists = function exists(xs, pred) {
      return findIndex(xs, pred).isSome();
    };

    var map = function map(xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i, xs);
      }
      return r;
    };
    var each = function each(xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i, xs);
      }
    };
    var eachr = function eachr(xs, f) {
      for (var i = xs.length - 1; i >= 0; i--) {
        var x = xs[i];
        f(x, i, xs);
      }
    };

    var filter = function filter(xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          r.push(x);
        }
      }
      return r;
    };

    var foldr = function foldr(xs, f, acc) {
      eachr(xs, function (x) {
        acc = f(acc, x);
      });
      return acc;
    };
    var foldl = function foldl(xs, f, acc) {
      each(xs, function (x) {
        acc = f(acc, x);
      });
      return acc;
    };
    var find = function find(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(x);
        }
      }
      return Option.none();
    };
    var findIndex = function findIndex(xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i, xs)) {
          return Option.some(i);
        }
      }
      return Option.none();
    };
    var slowIndexOf = function slowIndexOf(xs, x) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    };
    var push = Array.prototype.push;
    var flatten = function flatten(xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!Array.prototype.isPrototypeOf(xs[i])) throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        push.apply(r, xs[i]);
      }
      return r;
    };
    var bind = function bind(xs, f) {
      var output = map(xs, f);
      return flatten(output);
    };
    var forall = function forall(xs, pred) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        var x = xs[i];
        if (pred(x, i, xs) !== true) {
          return false;
        }
      }
      return true;
    };

    var slice = Array.prototype.slice;
    var reverse = function reverse(xs) {
      var r = slice.call(xs, 0);
      r.reverse();
      return r;
    };

    var last = function last(xs) {
      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
    };
    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
      return slice.call(x);
    };

    var keys = Object.keys;
    var each$1 = function each$1(obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i, obj);
      }
    };
    var map$1 = function map$1(obj, f) {
      return tupleMap(obj, function (x, i, obj) {
        return {
          k: i,
          v: f(x, i, obj)
        };
      });
    };
    var tupleMap = function tupleMap(obj, f) {
      var r = {};
      each$1(obj, function (x, i) {
        var tuple = f(x, i, obj);
        r[tuple.k] = tuple.v;
      });
      return r;
    };

    var Immutable = function Immutable() {
      var fields = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        fields[_i] = arguments[_i];
      }
      return function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          values[_i] = arguments[_i];
        }
        if (fields.length !== values.length) {
          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
        }
        var struct = {};
        each(fields, function (name, i) {
          struct[name] = constant(values[i]);
        });
        return struct;
      };
    };

    var sort$1 = function sort$1(arr) {
      return arr.slice(0).sort();
    };
    var reqMessage = function reqMessage(required, keys) {
      throw new Error('All required keys (' + sort$1(required).join(', ') + ') were not specified. Specified keys were: ' + sort$1(keys).join(', ') + '.');
    };
    var unsuppMessage = function unsuppMessage(unsupported) {
      throw new Error('Unsupported keys for object: ' + sort$1(unsupported).join(', '));
    };
    var validateStrArr = function validateStrArr(label, array) {
      if (!isArray(array)) throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
      each(array, function (a) {
        if (!isString(a)) throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
      });
    };
    var invalidTypeMessage = function invalidTypeMessage(incorrect, type) {
      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort$1(incorrect).join(', ') + ') were not.');
    };
    var checkDupes = function checkDupes(everything) {
      var sorted = sort$1(everything);
      var dupe = find(sorted, function (s, i) {
        return i < sorted.length - 1 && s === sorted[i + 1];
      });
      dupe.each(function (d) {
        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
      });
    };

    var MixedBag = function MixedBag(required, optional) {
      var everything = required.concat(optional);
      if (everything.length === 0) throw new Error('You must specify at least one required or optional field.');
      validateStrArr('required', required);
      validateStrArr('optional', optional);
      checkDupes(everything);
      return function (obj) {
        var keys$$1 = keys(obj);
        var allReqd = forall(required, function (req) {
          return contains(keys$$1, req);
        });
        if (!allReqd) reqMessage(required, keys$$1);
        var unsupported = filter(keys$$1, function (key) {
          return !contains(everything, key);
        });
        if (unsupported.length > 0) unsuppMessage(unsupported);
        var r = {};
        each(required, function (req) {
          r[req] = constant(obj[req]);
        });
        each(optional, function (opt) {
          r[opt] = constant(Object.prototype.hasOwnProperty.call(obj, opt) ? Option.some(obj[opt]) : Option.none());
        });
        return r;
      };
    };

    var dimensions = Immutable('width', 'height');
    var grid = Immutable('rows', 'columns');
    var address = Immutable('row', 'column');
    var coords = Immutable('x', 'y');
    var detail = Immutable('element', 'rowspan', 'colspan');
    var detailnew = Immutable('element', 'rowspan', 'colspan', 'isNew');
    var extended = Immutable('element', 'rowspan', 'colspan', 'row', 'column');
    var rowdata = Immutable('element', 'cells', 'section');
    var elementnew = Immutable('element', 'isNew');
    var rowdatanew = Immutable('element', 'cells', 'section', 'isNew');
    var rowcells = Immutable('cells', 'section');
    var rowdetails = Immutable('details', 'section');
    var bounds = Immutable('startRow', 'startCol', 'finishRow', 'finishCol');
    var $_g9pyg7lcjk26xknq = {
      dimensions: dimensions,
      grid: grid,
      address: address,
      coords: coords,
      extended: extended,
      detail: detail,
      detailnew: detailnew,
      rowdata: rowdata,
      elementnew: elementnew,
      rowdatanew: rowdatanew,
      rowcells: rowcells,
      rowdetails: rowdetails,
      bounds: bounds
    };

    var fromHtml = function fromHtml(html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw 'HTML must have a single root node';
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function fromTag(tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function fromText(text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function fromDom(node) {
      if (node === null || node === undefined) throw new Error('Node cannot be null or undefined');
      return { dom: constant(node) };
    };
    var fromPoint = function fromPoint(docElm, x, y) {
      var doc = docElm.dom();
      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
    };
    var Element$$1 = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    var $_6ukhhilijk26xkph = {
      ATTRIBUTE: Node.ATTRIBUTE_NODE,
      CDATA_SECTION: Node.CDATA_SECTION_NODE,
      COMMENT: Node.COMMENT_NODE,
      DOCUMENT: Node.DOCUMENT_NODE,
      DOCUMENT_TYPE: Node.DOCUMENT_TYPE_NODE,
      DOCUMENT_FRAGMENT: Node.DOCUMENT_FRAGMENT_NODE,
      ELEMENT: Node.ELEMENT_NODE,
      TEXT: Node.TEXT_NODE,
      PROCESSING_INSTRUCTION: Node.PROCESSING_INSTRUCTION_NODE,
      ENTITY_REFERENCE: Node.ENTITY_REFERENCE_NODE,
      ENTITY: Node.ENTITY_NODE,
      NOTATION: Node.NOTATION_NODE
    };

    var ELEMENT = $_6ukhhilijk26xkph.ELEMENT;
    var DOCUMENT = $_6ukhhilijk26xkph.DOCUMENT;
    var is = function is(element, selector) {
      var elem = element.dom();
      if (elem.nodeType !== ELEMENT) return false;else if (elem.matches !== undefined) return elem.matches(selector);else if (elem.msMatchesSelector !== undefined) return elem.msMatchesSelector(selector);else if (elem.webkitMatchesSelector !== undefined) return elem.webkitMatchesSelector(selector);else if (elem.mozMatchesSelector !== undefined) return elem.mozMatchesSelector(selector);else throw new Error('Browser lacks native selectors');
    };
    var bypassSelector = function bypassSelector(dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT || dom.childElementCount === 0;
    };
    var all = function all(selector, scope) {
      var base = scope === undefined ? document : scope.dom();
      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), Element$$1.fromDom);
    };
    var one = function one(selector, scope) {
      var base = scope === undefined ? document : scope.dom();
      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element$$1.fromDom);
    };
    var $_1asaomlfjk26xkos = {
      all: all,
      is: is,
      one: one
    };

    var toArray = function toArray(target, f) {
      var r = [];
      var recurse = function recurse(e) {
        r.push(e);
        return f(e);
      };
      var cur = f(target);
      do {
        cur = cur.bind(recurse);
      } while (cur.isSome());
      return r;
    };
    var $_94flkhlkjk26xkq2 = { toArray: toArray };

    var Global = typeof window !== 'undefined' ? window : Function('return this;')();

    var path = function path(parts, scope) {
      var o = scope !== undefined && scope !== null ? scope : Global;
      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i) {
        o = o[parts[i]];
      }return o;
    };
    var resolve = function resolve(p, scope) {
      var parts = p.split('.');
      return path(parts, scope);
    };

    var unsafe = function unsafe(name, scope) {
      return resolve(name, scope);
    };
    var getOrDie = function getOrDie(name, scope) {
      var actual = unsafe(name, scope);
      if (actual === undefined || actual === null) throw name + ' not available on this browser';
      return actual;
    };
    var $_4nwxvslnjk26xkqe = { getOrDie: getOrDie };

    var node = function node() {
      var f = $_4nwxvslnjk26xkqe.getOrDie('Node');
      return f;
    };
    var compareDocumentPosition = function compareDocumentPosition(a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionPreceding = function documentPositionPreceding(a, b) {
      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
    };
    var documentPositionContainedBy = function documentPositionContainedBy(a, b) {
      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
    };
    var $_e07qc9lmjk26xkqd = {
      documentPositionPreceding: documentPositionPreceding,
      documentPositionContainedBy: documentPositionContainedBy
    };

    var cached = function cached(f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var firstMatch = function firstMatch(regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) return x;
      }
      return undefined;
    };
    var find$2 = function find$2(regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) return {
        major: 0,
        minor: 0
      };
      var group = function group(i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu(group(1), group(2));
    };
    var detect = function detect(versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) return unknown();
      return find$2(versionRegexes, cleanedAgent);
    };
    var unknown = function unknown() {
      return nu(0, 0);
    };
    var nu = function nu(major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var $_g3h4zolujk26xkqu = {
      nu: nu,
      detect: detect,
      unknown: unknown
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var isBrowser = function isBrowser(name, current) {
      return function () {
        return current === name;
      };
    };
    var unknown$1 = function unknown$1() {
      return nu$1({
        current: undefined,
        version: $_g3h4zolujk26xkqu.unknown()
      });
    };
    var nu$1 = function nu$1(info) {
      var current = info.current;
      var version = info.version;
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge, current),
        isChrome: isBrowser(chrome, current),
        isIE: isBrowser(ie, current),
        isOpera: isBrowser(opera, current),
        isFirefox: isBrowser(firefox, current),
        isSafari: isBrowser(safari, current)
      };
    };
    var $_2lcg5bltjk26xkqq = {
      unknown: unknown$1,
      nu: nu$1,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var isOS = function isOS(name, current) {
      return function () {
        return current === name;
      };
    };
    var unknown$2 = function unknown$2() {
      return nu$2({
        current: undefined,
        version: $_g3h4zolujk26xkqu.unknown()
      });
    };
    var nu$2 = function nu$2(info) {
      var current = info.current;
      var version = info.version;
      return {
        current: current,
        version: version,
        isWindows: isOS(windows, current),
        isiOS: isOS(ios, current),
        isAndroid: isOS(android, current),
        isOSX: isOS(osx, current),
        isLinux: isOS(linux, current),
        isSolaris: isOS(solaris, current),
        isFreeBSD: isOS(freebsd, current)
      };
    };
    var $_3xq8snlvjk26xkqw = {
      unknown: unknown$2,
      nu: nu$2,
      windows: constant(windows),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd)
    };

    function DeviceType(os, browser, userAgent) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isAndroid3 = os.isAndroid() && os.version.major === 3;
      var isAndroid4 = os.isAndroid() && os.version.major === 4;
      var isTablet = isiPad || isAndroid3 || isAndroid4 && /mobile/i.test(userAgent) === true;
      var isTouch = os.isiOS() || os.isAndroid();
      var isPhone = isTouch && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview)
      };
    }

    var detect$1 = function detect$1(candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function detectBrowser(browsers, userAgent) {
      return detect$1(browsers, userAgent).map(function (browser) {
        var version = $_g3h4zolujk26xkqu.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function detectOs(oses, userAgent) {
      return detect$1(oses, userAgent).map(function (os) {
        var version = $_g3h4zolujk26xkqu.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };
    var $_augcbilxjk26xkr2 = {
      detectBrowser: detectBrowser,
      detectOs: detectOs
    };

    var checkRange = function checkRange(str, substr, start) {
      if (substr === '') return true;
      if (str.length < substr.length) return false;
      var x = str.substr(start, start + substr.length);
      return x === substr;
    };

    var contains$1 = function contains$1(str, substr) {
      return str.indexOf(substr) !== -1;
    };

    var endsWith = function endsWith(str, suffix) {
      return checkRange(str, suffix, str.length - suffix.length);
    };
    var trim = function trim(str) {
      return str.replace(/^\s+|\s+$/g, '');
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function checkContains(target) {
      return function (uastring) {
        return contains$1(uastring, target);
      };
    };
    var browsers = [{
      name: 'Edge',
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function search(uastring) {
        var monstrosity = contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
        return monstrosity;
      }
    }, {
      name: 'Chrome',
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/, normalVersionRegex],
      search: function search(uastring) {
        return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
      }
    }, {
      name: 'IE',
      versionRegexes: [/.*?msie\ ?([0-9]+)\.([0-9]+).*/, /.*?rv:([0-9]+)\.([0-9]+).*/],
      search: function search(uastring) {
        return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
      }
    }, {
      name: 'Opera',
      versionRegexes: [normalVersionRegex, /.*?opera\/([0-9]+)\.([0-9]+).*/],
      search: checkContains('opera')
    }, {
      name: 'Firefox',
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: checkContains('firefox')
    }, {
      name: 'Safari',
      versionRegexes: [normalVersionRegex, /.*?cpu os ([0-9]+)_([0-9]+).*/],
      search: function search(uastring) {
        return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
      }
    }];
    var oses = [{
      name: 'Windows',
      search: checkContains('win'),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    }, {
      name: 'iOS',
      search: function search(uastring) {
        return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
      },
      versionRegexes: [/.*?version\/\ ?([0-9]+)\.([0-9]+).*/, /.*cpu os ([0-9]+)_([0-9]+).*/, /.*cpu iphone os ([0-9]+)_([0-9]+).*/]
    }, {
      name: 'Android',
      search: checkContains('android'),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    }, {
      name: 'OSX',
      search: checkContains('os x'),
      versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
    }, {
      name: 'Linux',
      search: checkContains('linux'),
      versionRegexes: []
    }, {
      name: 'Solaris',
      search: checkContains('sunos'),
      versionRegexes: []
    }, {
      name: 'FreeBSD',
      search: checkContains('freebsd'),
      versionRegexes: []
    }];
    var $_bahdp6lyjk26xkr6 = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var detect$2 = function detect$2(userAgent) {
      var browsers = $_bahdp6lyjk26xkr6.browsers();
      var oses = $_bahdp6lyjk26xkr6.oses();
      var browser = $_augcbilxjk26xkr2.detectBrowser(browsers, userAgent).fold($_2lcg5bltjk26xkqq.unknown, $_2lcg5bltjk26xkqq.nu);
      var os = $_augcbilxjk26xkr2.detectOs(oses, userAgent).fold($_3xq8snlvjk26xkqw.unknown, $_3xq8snlvjk26xkqw.nu);
      var deviceType = DeviceType(os, browser, userAgent);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var $_5b1v6vlsjk26xkqp = { detect: detect$2 };

    var detect$3 = cached(function () {
      var userAgent = navigator.userAgent;
      return $_5b1v6vlsjk26xkqp.detect(userAgent);
    });
    var $_aj4ie4lqjk26xkqk = { detect: detect$3 };

    var eq = function eq(e1, e2) {
      return e1.dom() === e2.dom();
    };
    var isEqualNode = function isEqualNode(e1, e2) {
      return e1.dom().isEqualNode(e2.dom());
    };
    var member = function member(element, elements) {
      return exists(elements, curry(eq, element));
    };
    var regularContains = function regularContains(e1, e2) {
      var d1 = e1.dom(),
          d2 = e2.dom();
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function ieContains(e1, e2) {
      return $_e07qc9lmjk26xkqd.documentPositionContainedBy(e1.dom(), e2.dom());
    };
    var browser = $_aj4ie4lqjk26xkqk.detect().browser;
    var contains$2 = browser.isIE() ? ieContains : regularContains;
    var $_5m7qbqlljk26xkq3 = {
      eq: eq,
      isEqualNode: isEqualNode,
      member: member,
      contains: contains$2,
      is: $_1asaomlfjk26xkos.is
    };

    var owner = function owner(element) {
      return Element$$1.fromDom(element.dom().ownerDocument);
    };
    var documentElement = function documentElement(element) {
      return Element$$1.fromDom(element.dom().ownerDocument.documentElement);
    };
    var defaultView = function defaultView(element) {
      var el = element.dom();
      var defaultView = el.ownerDocument.defaultView;
      return Element$$1.fromDom(defaultView);
    };
    var parent = function parent(element) {
      var dom = element.dom();
      return Option.from(dom.parentNode).map(Element$$1.fromDom);
    };
    var findIndex$1 = function findIndex$1(element) {
      return parent(element).bind(function (p) {
        var kin = children(p);
        return findIndex(kin, function (elem) {
          return $_5m7qbqlljk26xkq3.eq(element, elem);
        });
      });
    };
    var parents = function parents(element, isRoot) {
      var stop = isFunction(isRoot) ? isRoot : constant(false);
      var dom = element.dom();
      var ret = [];
      while (dom.parentNode !== null && dom.parentNode !== undefined) {
        var rawParent = dom.parentNode;
        var parent = Element$$1.fromDom(rawParent);
        ret.push(parent);
        if (stop(parent) === true) break;else dom = rawParent;
      }
      return ret;
    };
    var siblings = function siblings(element) {
      var filterSelf = function filterSelf(elements) {
        return filter(elements, function (x) {
          return !$_5m7qbqlljk26xkq3.eq(element, x);
        });
      };
      return parent(element).map(children).map(filterSelf).getOr([]);
    };
    var offsetParent = function offsetParent(element) {
      var dom = element.dom();
      return Option.from(dom.offsetParent).map(Element$$1.fromDom);
    };
    var prevSibling = function prevSibling(element) {
      var dom = element.dom();
      return Option.from(dom.previousSibling).map(Element$$1.fromDom);
    };
    var nextSibling = function nextSibling(element) {
      var dom = element.dom();
      return Option.from(dom.nextSibling).map(Element$$1.fromDom);
    };
    var prevSiblings = function prevSiblings(element) {
      return reverse($_94flkhlkjk26xkq2.toArray(element, prevSibling));
    };
    var nextSiblings = function nextSiblings(element) {
      return $_94flkhlkjk26xkq2.toArray(element, nextSibling);
    };
    var children = function children(element) {
      var dom = element.dom();
      return map(dom.childNodes, Element$$1.fromDom);
    };
    var child = function child(element, index) {
      var children = element.dom().childNodes;
      return Option.from(children[index]).map(Element$$1.fromDom);
    };
    var firstChild = function firstChild(element) {
      return child(element, 0);
    };
    var lastChild = function lastChild(element) {
      return child(element, element.dom().childNodes.length - 1);
    };
    var childNodesCount = function childNodesCount(element) {
      return element.dom().childNodes.length;
    };
    var hasChildNodes = function hasChildNodes(element) {
      return element.dom().hasChildNodes();
    };
    var spot = Immutable('element', 'offset');
    var leaf = function leaf(element, offset) {
      var cs = children(element);
      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
    };
    var $_4uy46mljjk26xkpk = {
      owner: owner,
      defaultView: defaultView,
      documentElement: documentElement,
      parent: parent,
      findIndex: findIndex$1,
      parents: parents,
      siblings: siblings,
      prevSibling: prevSibling,
      offsetParent: offsetParent,
      prevSiblings: prevSiblings,
      nextSibling: nextSibling,
      nextSiblings: nextSiblings,
      children: children,
      child: child,
      firstChild: firstChild,
      lastChild: lastChild,
      childNodesCount: childNodesCount,
      hasChildNodes: hasChildNodes,
      leaf: leaf
    };

    var firstLayer = function firstLayer(scope, selector) {
      return filterFirstLayer(scope, selector, constant(true));
    };
    var filterFirstLayer = function filterFirstLayer(scope, selector, predicate) {
      return bind($_4uy46mljjk26xkpk.children(scope), function (x) {
        return $_1asaomlfjk26xkos.is(x, selector) ? predicate(x) ? [x] : [] : filterFirstLayer(x, selector, predicate);
      });
    };
    var $_2q1s9zlejk26xkoj = {
      firstLayer: firstLayer,
      filterFirstLayer: filterFirstLayer
    };

    var name = function name(element) {
      var r = element.dom().nodeName;
      return r.toLowerCase();
    };
    var type = function type(element) {
      return element.dom().nodeType;
    };
    var value = function value(element) {
      return element.dom().nodeValue;
    };
    var isType$1 = function isType$1(t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isComment = function isComment(element) {
      return type(element) === $_6ukhhilijk26xkph.COMMENT || name(element) === '#comment';
    };
    var isElement = isType$1($_6ukhhilijk26xkph.ELEMENT);
    var isText = isType$1($_6ukhhilijk26xkph.TEXT);
    var isDocument = isType$1($_6ukhhilijk26xkph.DOCUMENT);
    var $_89mq4qm3jk26xkrq = {
      name: name,
      type: type,
      value: value,
      isElement: isElement,
      isText: isText,
      isDocument: isDocument,
      isComment: isComment
    };

    var rawSet = function rawSet(dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set = function set(element, key, value) {
      rawSet(element.dom(), key, value);
    };
    var setAll = function setAll(element, attrs) {
      var dom = element.dom();
      each$1(attrs, function (v, k) {
        rawSet(dom, k, v);
      });
    };
    var get = function get(element, key) {
      var v = element.dom().getAttribute(key);
      return v === null ? undefined : v;
    };
    var has = function has(element, key) {
      var dom = element.dom();
      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
    };
    var remove = function remove(element, key) {
      element.dom().removeAttribute(key);
    };
    var hasNone = function hasNone(element) {
      var attrs = element.dom().attributes;
      return attrs === undefined || attrs === null || attrs.length === 0;
    };
    var clone = function clone(element) {
      return foldl(element.dom().attributes, function (acc, attr) {
        acc[attr.name] = attr.value;
        return acc;
      }, {});
    };
    var transferOne = function transferOne(source, destination, attr) {
      if (has(source, attr) && !has(destination, attr)) set(destination, attr, get(source, attr));
    };
    var transfer = function transfer(source, destination, attrs) {
      if (!$_89mq4qm3jk26xkrq.isElement(source) || !$_89mq4qm3jk26xkrq.isElement(destination)) return;
      each(attrs, function (attr) {
        transferOne(source, destination, attr);
      });
    };
    var $_8icsmim2jk26xkrh = {
      clone: clone,
      set: set,
      setAll: setAll,
      get: get,
      has: has,
      remove: remove,
      hasNone: hasNone,
      transfer: transfer
    };

    var inBody = function inBody(element) {
      var dom = $_89mq4qm3jk26xkrq.isText(element) ? element.dom().parentNode : element.dom();
      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
    };
    var body = cached(function () {
      return getBody(Element$$1.fromDom(document));
    });
    var getBody = function getBody(doc) {
      var body = doc.dom().body;
      if (body === null || body === undefined) throw 'Body is not available yet';
      return Element$$1.fromDom(body);
    };
    var $_9gbjzvm6jk26xkrx = {
      body: body,
      getBody: getBody,
      inBody: inBody
    };

    var all$1 = function all$1(predicate) {
      return descendants($_9gbjzvm6jk26xkrx.body(), predicate);
    };
    var ancestors = function ancestors(scope, predicate, isRoot) {
      return filter($_4uy46mljjk26xkpk.parents(scope, isRoot), predicate);
    };
    var siblings$1 = function siblings$1(scope, predicate) {
      return filter($_4uy46mljjk26xkpk.siblings(scope), predicate);
    };
    var children$1 = function children$1(scope, predicate) {
      return filter($_4uy46mljjk26xkpk.children(scope), predicate);
    };
    var descendants = function descendants(scope, predicate) {
      var result = [];
      each($_4uy46mljjk26xkpk.children(scope), function (x) {
        if (predicate(x)) {
          result = result.concat([x]);
        }
        result = result.concat(descendants(x, predicate));
      });
      return result;
    };
    var $_cail48m5jk26xkru = {
      all: all$1,
      ancestors: ancestors,
      siblings: siblings$1,
      children: children$1,
      descendants: descendants
    };

    var all$2 = function all$2(selector) {
      return $_1asaomlfjk26xkos.all(selector);
    };
    var ancestors$1 = function ancestors$1(scope, selector, isRoot) {
      return $_cail48m5jk26xkru.ancestors(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      }, isRoot);
    };
    var siblings$2 = function siblings$2(scope, selector) {
      return $_cail48m5jk26xkru.siblings(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      });
    };
    var children$2 = function children$2(scope, selector) {
      return $_cail48m5jk26xkru.children(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      });
    };
    var descendants$1 = function descendants$1(scope, selector) {
      return $_1asaomlfjk26xkos.all(selector, scope);
    };
    var $_bkrvmvm4jk26xkrt = {
      all: all$2,
      ancestors: ancestors$1,
      siblings: siblings$2,
      children: children$2,
      descendants: descendants$1
    };

    function ClosestOrAncestor(is, ancestor, scope, a, isRoot) {
      return is(scope, a) ? Option.some(scope) : isFunction(isRoot) && isRoot(scope) ? Option.none() : ancestor(scope, a, isRoot);
    }

    var first$1 = function first$1(predicate) {
      return descendant($_9gbjzvm6jk26xkrx.body(), predicate);
    };
    var ancestor = function ancestor(scope, predicate, isRoot) {
      var element = scope.dom();
      var stop = isFunction(isRoot) ? isRoot : constant(false);
      while (element.parentNode) {
        element = element.parentNode;
        var el = Element$$1.fromDom(element);
        if (predicate(el)) return Option.some(el);else if (stop(el)) break;
      }
      return Option.none();
    };
    var closest = function closest(scope, predicate, isRoot) {
      var is = function is(scope) {
        return predicate(scope);
      };
      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
    };
    var sibling = function sibling(scope, predicate) {
      var element = scope.dom();
      if (!element.parentNode) return Option.none();
      return child$1(Element$$1.fromDom(element.parentNode), function (x) {
        return !$_5m7qbqlljk26xkq3.eq(scope, x) && predicate(x);
      });
    };
    var child$1 = function child$1(scope, predicate) {
      var result = find(scope.dom().childNodes, compose(predicate, Element$$1.fromDom));
      return result.map(Element$$1.fromDom);
    };
    var descendant = function descendant(scope, predicate) {
      var descend = function descend(node) {
        for (var i = 0; i < node.childNodes.length; i++) {
          if (predicate(Element$$1.fromDom(node.childNodes[i]))) return Option.some(Element$$1.fromDom(node.childNodes[i]));
          var res = descend(node.childNodes[i]);
          if (res.isSome()) return res;
        }
        return Option.none();
      };
      return descend(scope.dom());
    };
    var $_3kidmom8jk26xks9 = {
      first: first$1,
      ancestor: ancestor,
      closest: closest,
      sibling: sibling,
      child: child$1,
      descendant: descendant
    };

    var first$2 = function first$2(selector) {
      return $_1asaomlfjk26xkos.one(selector);
    };
    var ancestor$1 = function ancestor$1(scope, selector, isRoot) {
      return $_3kidmom8jk26xks9.ancestor(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      }, isRoot);
    };
    var sibling$1 = function sibling$1(scope, selector) {
      return $_3kidmom8jk26xks9.sibling(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      });
    };
    var child$2 = function child$2(scope, selector) {
      return $_3kidmom8jk26xks9.child(scope, function (e) {
        return $_1asaomlfjk26xkos.is(e, selector);
      });
    };
    var descendant$1 = function descendant$1(scope, selector) {
      return $_1asaomlfjk26xkos.one(selector, scope);
    };
    var closest$1 = function closest$1(scope, selector, isRoot) {
      return ClosestOrAncestor($_1asaomlfjk26xkos.is, ancestor$1, scope, selector, isRoot);
    };
    var $_at9vkhm7jk26xks8 = {
      first: first$2,
      ancestor: ancestor$1,
      sibling: sibling$1,
      child: child$2,
      descendant: descendant$1,
      closest: closest$1
    };

    var lookup = function lookup(tags, element, _isRoot) {
      var isRoot = _isRoot !== undefined ? _isRoot : constant(false);
      if (isRoot(element)) return Option.none();
      if (contains(tags, $_89mq4qm3jk26xkrq.name(element))) return Option.some(element);
      var isRootOrUpperTable = function isRootOrUpperTable(element) {
        return $_1asaomlfjk26xkos.is(element, 'table') || isRoot(element);
      };
      return $_at9vkhm7jk26xks8.ancestor(element, tags.join(','), isRootOrUpperTable);
    };
    var cell = function cell(element, isRoot) {
      return lookup(['td', 'th'], element, isRoot);
    };
    var cells = function cells(ancestor) {
      return $_2q1s9zlejk26xkoj.firstLayer(ancestor, 'th,td');
    };
    var notCell = function notCell(element, isRoot) {
      return lookup(['caption', 'tr', 'tbody', 'tfoot', 'thead'], element, isRoot);
    };
    var neighbours = function neighbours(selector, element) {
      return $_4uy46mljjk26xkpk.parent(element).map(function (parent) {
        return $_bkrvmvm4jk26xkrt.children(parent, selector);
      });
    };
    var neighbourCells = curry(neighbours, 'th,td');
    var neighbourRows = curry(neighbours, 'tr');
    var firstCell = function firstCell(ancestor) {
      return $_at9vkhm7jk26xks8.descendant(ancestor, 'th,td');
    };
    var table = function table(element, isRoot) {
      return $_at9vkhm7jk26xks8.closest(element, 'table', isRoot);
    };
    var row = function row(element, isRoot) {
      return lookup(['tr'], element, isRoot);
    };
    var rows = function rows(ancestor) {
      return $_2q1s9zlejk26xkoj.firstLayer(ancestor, 'tr');
    };
    var attr = function attr(element, property) {
      return parseInt($_8icsmim2jk26xkrh.get(element, property), 10);
    };
    var grid$1 = function grid$1(element, rowProp, colProp) {
      var rows = attr(element, rowProp);
      var cols = attr(element, colProp);
      return $_g9pyg7lcjk26xknq.grid(rows, cols);
    };
    var $_3gdghfldjk26xknu = {
      cell: cell,
      firstCell: firstCell,
      cells: cells,
      neighbourCells: neighbourCells,
      table: table,
      row: row,
      rows: rows,
      notCell: notCell,
      neighbourRows: neighbourRows,
      attr: attr,
      grid: grid$1
    };

    var fromTable = function fromTable(table) {
      var rows = $_3gdghfldjk26xknu.rows(table);
      return map(rows, function (row) {
        var element = row;
        var parent = $_4uy46mljjk26xkpk.parent(element);
        var parentSection = parent.map(function (parent) {
          var parentName = $_89mq4qm3jk26xkrq.name(parent);
          return parentName === 'tfoot' || parentName === 'thead' || parentName === 'tbody' ? parentName : 'tbody';
        }).getOr('tbody');
        var cells = map($_3gdghfldjk26xknu.cells(row), function (cell) {
          var rowspan = $_8icsmim2jk26xkrh.has(cell, 'rowspan') ? parseInt($_8icsmim2jk26xkrh.get(cell, 'rowspan'), 10) : 1;
          var colspan = $_8icsmim2jk26xkrh.has(cell, 'colspan') ? parseInt($_8icsmim2jk26xkrh.get(cell, 'colspan'), 10) : 1;
          return $_g9pyg7lcjk26xknq.detail(cell, rowspan, colspan);
        });
        return $_g9pyg7lcjk26xknq.rowdata(element, cells, parentSection);
      });
    };
    var fromPastedRows = function fromPastedRows(rows, example) {
      return map(rows, function (row) {
        var cells = map($_3gdghfldjk26xknu.cells(row), function (cell) {
          var rowspan = $_8icsmim2jk26xkrh.has(cell, 'rowspan') ? parseInt($_8icsmim2jk26xkrh.get(cell, 'rowspan'), 10) : 1;
          var colspan = $_8icsmim2jk26xkrh.has(cell, 'colspan') ? parseInt($_8icsmim2jk26xkrh.get(cell, 'colspan'), 10) : 1;
          return $_g9pyg7lcjk26xknq.detail(cell, rowspan, colspan);
        });
        return $_g9pyg7lcjk26xknq.rowdata(row, cells, example.section());
      });
    };
    var $_aihceulbjk26xkng = {
      fromTable: fromTable,
      fromPastedRows: fromPastedRows
    };

    var key = function key(row, column) {
      return row + ',' + column;
    };
    var getAt = function getAt(warehouse, row, column) {
      var raw = warehouse.access()[key(row, column)];
      return raw !== undefined ? Option.some(raw) : Option.none();
    };
    var findItem = function findItem(warehouse, item, comparator) {
      var filtered = filterItems(warehouse, function (detail) {
        return comparator(item, detail.element());
      });
      return filtered.length > 0 ? Option.some(filtered[0]) : Option.none();
    };
    var filterItems = function filterItems(warehouse, predicate) {
      var all = bind(warehouse.all(), function (r) {
        return r.cells();
      });
      return filter(all, predicate);
    };
    var generate = function generate(list) {
      var access = {};
      var cells = [];
      var maxRows = list.length;
      var maxColumns = 0;
      each(list, function (details, r) {
        var currentRow = [];
        each(details.cells(), function (detail, c) {
          var start = 0;
          while (access[key(r, start)] !== undefined) {
            start++;
          }
          var current = $_g9pyg7lcjk26xknq.extended(detail.element(), detail.rowspan(), detail.colspan(), r, start);
          for (var i = 0; i < detail.colspan(); i++) {
            for (var j = 0; j < detail.rowspan(); j++) {
              var cr = r + j;
              var cc = start + i;
              var newpos = key(cr, cc);
              access[newpos] = current;
              maxColumns = Math.max(maxColumns, cc + 1);
            }
          }
          currentRow.push(current);
        });
        cells.push($_g9pyg7lcjk26xknq.rowdata(details.element(), currentRow, details.section()));
      });
      var grid = $_g9pyg7lcjk26xknq.grid(maxRows, maxColumns);
      return {
        grid: constant(grid),
        access: constant(access),
        all: constant(cells)
      };
    };
    var justCells = function justCells(warehouse) {
      var rows = map(warehouse.all(), function (w) {
        return w.cells();
      });
      return flatten(rows);
    };
    var $_7tsw5majk26xksp = {
      generate: generate,
      getAt: getAt,
      findItem: findItem,
      filterItems: filterItems,
      justCells: justCells
    };

    var isSupported = function isSupported(dom) {
      return dom.style !== undefined;
    };
    var $_lq021mcjk26xktd = { isSupported: isSupported };

    var internalSet = function internalSet(dom, property, value) {
      if (!isString(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if ($_lq021mcjk26xktd.isSupported(dom)) dom.style.setProperty(property, value);
    };
    var internalRemove = function internalRemove(dom, property) {
      if ($_lq021mcjk26xktd.isSupported(dom)) dom.style.removeProperty(property);
    };
    var set$1 = function set$1(element, property, value) {
      var dom = element.dom();
      internalSet(dom, property, value);
    };
    var setAll$1 = function setAll$1(element, css) {
      var dom = element.dom();
      each$1(css, function (v, k) {
        internalSet(dom, k, v);
      });
    };
    var setOptions = function setOptions(element, css) {
      var dom = element.dom();
      each$1(css, function (v, k) {
        v.fold(function () {
          internalRemove(dom, k);
        }, function (value) {
          internalSet(dom, k, value);
        });
      });
    };
    var get$1 = function get$1(element, property) {
      var dom = element.dom();
      var styles = window.getComputedStyle(dom);
      var r = styles.getPropertyValue(property);
      var v = r === '' && !$_9gbjzvm6jk26xkrx.inBody(element) ? getUnsafeProperty(dom, property) : r;
      return v === null ? undefined : v;
    };
    var getUnsafeProperty = function getUnsafeProperty(dom, property) {
      return $_lq021mcjk26xktd.isSupported(dom) ? dom.style.getPropertyValue(property) : '';
    };
    var getRaw = function getRaw(element, property) {
      var dom = element.dom();
      var raw = getUnsafeProperty(dom, property);
      return Option.from(raw).filter(function (r) {
        return r.length > 0;
      });
    };
    var getAllRaw = function getAllRaw(element) {
      var css = {};
      var dom = element.dom();
      if ($_lq021mcjk26xktd.isSupported(dom)) {
        for (var i = 0; i < dom.style.length; i++) {
          var ruleName = dom.style.item(i);
          css[ruleName] = dom.style[ruleName];
        }
      }
      return css;
    };
    var isValidValue = function isValidValue(tag, property, value) {
      var element = Element$$1.fromTag(tag);
      set$1(element, property, value);
      var style = getRaw(element, property);
      return style.isSome();
    };
    var remove$1 = function remove$1(element, property) {
      var dom = element.dom();
      internalRemove(dom, property);
      if ($_8icsmim2jk26xkrh.has(element, 'style') && trim($_8icsmim2jk26xkrh.get(element, 'style')) === '') {
        $_8icsmim2jk26xkrh.remove(element, 'style');
      }
    };
    var preserve = function preserve(element, f) {
      var oldStyles = $_8icsmim2jk26xkrh.get(element, 'style');
      var result = f(element);
      var restore = oldStyles === undefined ? $_8icsmim2jk26xkrh.remove : $_8icsmim2jk26xkrh.set;
      restore(element, 'style', oldStyles);
      return result;
    };
    var copy = function copy(source, target) {
      var sourceDom = source.dom();
      var targetDom = target.dom();
      if ($_lq021mcjk26xktd.isSupported(sourceDom) && $_lq021mcjk26xktd.isSupported(targetDom)) {
        targetDom.style.cssText = sourceDom.style.cssText;
      }
    };
    var reflow = function reflow(e) {
      return e.dom().offsetWidth;
    };
    var transferOne$1 = function transferOne$1(source, destination, style) {
      getRaw(source, style).each(function (value) {
        if (getRaw(destination, style).isNone()) set$1(destination, style, value);
      });
    };
    var transfer$1 = function transfer$1(source, destination, styles) {
      if (!$_89mq4qm3jk26xkrq.isElement(source) || !$_89mq4qm3jk26xkrq.isElement(destination)) return;
      each(styles, function (style) {
        transferOne$1(source, destination, style);
      });
    };
    var $_4ift9ombjk26xksz = {
      copy: copy,
      set: set$1,
      preserve: preserve,
      setAll: setAll$1,
      setOptions: setOptions,
      remove: remove$1,
      get: get$1,
      getRaw: getRaw,
      getAllRaw: getAllRaw,
      isValidValue: isValidValue,
      reflow: reflow,
      transfer: transfer$1
    };

    var before = function before(marker, element) {
      var parent = $_4uy46mljjk26xkpk.parent(marker);
      parent.each(function (v) {
        v.dom().insertBefore(element.dom(), marker.dom());
      });
    };
    var after = function after(marker, element) {
      var sibling = $_4uy46mljjk26xkpk.nextSibling(marker);
      sibling.fold(function () {
        var parent = $_4uy46mljjk26xkpk.parent(marker);
        parent.each(function (v) {
          append(v, element);
        });
      }, function (v) {
        before(v, element);
      });
    };
    var prepend = function prepend(parent, element) {
      var firstChild = $_4uy46mljjk26xkpk.firstChild(parent);
      firstChild.fold(function () {
        append(parent, element);
      }, function (v) {
        parent.dom().insertBefore(element.dom(), v.dom());
      });
    };
    var append = function append(parent, element) {
      parent.dom().appendChild(element.dom());
    };
    var appendAt = function appendAt(parent, element, index) {
      $_4uy46mljjk26xkpk.child(parent, index).fold(function () {
        append(parent, element);
      }, function (v) {
        before(v, element);
      });
    };
    var wrap = function wrap(element, wrapper) {
      before(element, wrapper);
      append(wrapper, element);
    };
    var $_aao88dmdjk26xkte = {
      before: before,
      after: after,
      prepend: prepend,
      append: append,
      appendAt: appendAt,
      wrap: wrap
    };

    var before$1 = function before$1(marker, elements) {
      each(elements, function (x) {
        $_aao88dmdjk26xkte.before(marker, x);
      });
    };
    var after$1 = function after$1(marker, elements) {
      each(elements, function (x, i) {
        var e = i === 0 ? marker : elements[i - 1];
        $_aao88dmdjk26xkte.after(e, x);
      });
    };
    var prepend$1 = function prepend$1(parent, elements) {
      each(elements.slice().reverse(), function (x) {
        $_aao88dmdjk26xkte.prepend(parent, x);
      });
    };
    var append$1 = function append$1(parent, elements) {
      each(elements, function (x) {
        $_aao88dmdjk26xkte.append(parent, x);
      });
    };
    var $_bsj3f1mfjk26xktj = {
      before: before$1,
      after: after$1,
      prepend: prepend$1,
      append: append$1
    };

    var empty = function empty(element) {
      element.dom().textContent = '';
      each($_4uy46mljjk26xkpk.children(element), function (rogue) {
        remove$2(rogue);
      });
    };
    var remove$2 = function remove$2(element) {
      var dom = element.dom();
      if (dom.parentNode !== null) dom.parentNode.removeChild(dom);
    };
    var unwrap = function unwrap(wrapper) {
      var children = $_4uy46mljjk26xkpk.children(wrapper);
      if (children.length > 0) $_bsj3f1mfjk26xktj.before(wrapper, children);
      remove$2(wrapper);
    };
    var $_lmq2lmejk26xktg = {
      empty: empty,
      remove: remove$2,
      unwrap: unwrap
    };

    var stats = Immutable('minRow', 'minCol', 'maxRow', 'maxCol');
    var findSelectedStats = function findSelectedStats(house, isSelected) {
      var totalColumns = house.grid().columns();
      var totalRows = house.grid().rows();
      var minRow = totalRows;
      var minCol = totalColumns;
      var maxRow = 0;
      var maxCol = 0;
      each$1(house.access(), function (detail) {
        if (isSelected(detail)) {
          var startRow = detail.row();
          var endRow = startRow + detail.rowspan() - 1;
          var startCol = detail.column();
          var endCol = startCol + detail.colspan() - 1;
          if (startRow < minRow) minRow = startRow;else if (endRow > maxRow) maxRow = endRow;
          if (startCol < minCol) minCol = startCol;else if (endCol > maxCol) maxCol = endCol;
        }
      });
      return stats(minRow, minCol, maxRow, maxCol);
    };
    var makeCell = function makeCell(list, seenSelected, rowIndex) {
      var row = list[rowIndex].element();
      var td = Element$$1.fromTag('td');
      $_aao88dmdjk26xkte.append(td, Element$$1.fromTag('br'));
      var f = seenSelected ? $_aao88dmdjk26xkte.append : $_aao88dmdjk26xkte.prepend;
      f(row, td);
    };
    var fillInGaps = function fillInGaps(list, house, stats, isSelected) {
      var totalColumns = house.grid().columns();
      var totalRows = house.grid().rows();
      for (var i = 0; i < totalRows; i++) {
        var seenSelected = false;
        for (var j = 0; j < totalColumns; j++) {
          if (!(i < stats.minRow() || i > stats.maxRow() || j < stats.minCol() || j > stats.maxCol())) {
            var needCell = $_7tsw5majk26xksp.getAt(house, i, j).filter(isSelected).isNone();
            if (needCell) makeCell(list, seenSelected, i);else seenSelected = true;
          }
        }
      }
    };
    var clean = function clean(table, stats) {
      var emptyRows = filter($_2q1s9zlejk26xkoj.firstLayer(table, 'tr'), function (row) {
        return row.dom().childElementCount === 0;
      });
      each(emptyRows, $_lmq2lmejk26xktg.remove);
      if (stats.minCol() === stats.maxCol() || stats.minRow() === stats.maxRow()) {
        each($_2q1s9zlejk26xkoj.firstLayer(table, 'th,td'), function (cell) {
          $_8icsmim2jk26xkrh.remove(cell, 'rowspan');
          $_8icsmim2jk26xkrh.remove(cell, 'colspan');
        });
      }
      $_8icsmim2jk26xkrh.remove(table, 'width');
      $_8icsmim2jk26xkrh.remove(table, 'height');
      $_4ift9ombjk26xksz.remove(table, 'width');
      $_4ift9ombjk26xksz.remove(table, 'height');
    };
    var extract = function extract(table, selectedSelector) {
      var isSelected = function isSelected(detail) {
        return $_1asaomlfjk26xkos.is(detail.element(), selectedSelector);
      };
      var list = $_aihceulbjk26xkng.fromTable(table);
      var house = $_7tsw5majk26xksp.generate(list);
      var stats = findSelectedStats(house, isSelected);
      var selector = 'th:not(' + selectedSelector + ')' + ',td:not(' + selectedSelector + ')';
      var unselectedCells = $_2q1s9zlejk26xkoj.filterFirstLayer(table, 'th,td', function (cell) {
        return $_1asaomlfjk26xkos.is(cell, selector);
      });
      each(unselectedCells, $_lmq2lmejk26xktg.remove);
      fillInGaps(list, house, stats, isSelected);
      clean(table, stats);
      return table;
    };
    var $_ldmecl5jk26xkmk = { extract: extract };

    var clone$1 = function clone$1(original, deep) {
      return Element$$1.fromDom(original.dom().cloneNode(deep));
    };
    var shallow = function shallow(original) {
      return clone$1(original, false);
    };
    var deep = function deep(original) {
      return clone$1(original, true);
    };
    var shallowAs = function shallowAs(original, tag) {
      var nu = Element$$1.fromTag(tag);
      var attributes = $_8icsmim2jk26xkrh.clone(original);
      $_8icsmim2jk26xkrh.setAll(nu, attributes);
      return nu;
    };
    var copy$1 = function copy$1(original, tag) {
      var nu = shallowAs(original, tag);
      var cloneChildren = $_4uy46mljjk26xkpk.children(deep(original));
      $_bsj3f1mfjk26xktj.append(nu, cloneChildren);
      return nu;
    };
    var mutate = function mutate(original, tag) {
      var nu = shallowAs(original, tag);
      $_aao88dmdjk26xkte.before(original, nu);
      var children = $_4uy46mljjk26xkpk.children(original);
      $_bsj3f1mfjk26xktj.append(nu, children);
      $_lmq2lmejk26xktg.remove(original);
      return nu;
    };
    var $_e74daamhjk26xkuk = {
      shallow: shallow,
      shallowAs: shallowAs,
      deep: deep,
      copy: copy$1,
      mutate: mutate
    };

    function NodeValue(is, name) {
      var get = function get(element) {
        if (!is(element)) throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
        return getOption(element).getOr('');
      };
      var getOptionIE10 = function getOptionIE10(element) {
        try {
          return getOptionSafe(element);
        } catch (e) {
          return Option.none();
        }
      };
      var getOptionSafe = function getOptionSafe(element) {
        return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
      };
      var browser = $_aj4ie4lqjk26xkqk.detect().browser;
      var getOption = browser.isIE() && browser.version.major === 10 ? getOptionIE10 : getOptionSafe;
      var set = function set(element, value) {
        if (!is(element)) throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
        element.dom().nodeValue = value;
      };
      return {
        get: get,
        getOption: getOption,
        set: set
      };
    }

    var api = NodeValue($_89mq4qm3jk26xkrq.isText, 'text');
    var get$2 = function get$2(element) {
      return api.get(element);
    };
    var getOption = function getOption(element) {
      return api.getOption(element);
    };
    var set$2 = function set$2(element, value) {
      api.set(element, value);
    };
    var $_2rujnemkjk26xkuu = {
      get: get$2,
      getOption: getOption,
      set: set$2
    };

    var getEnd = function getEnd(element) {
      return $_89mq4qm3jk26xkrq.name(element) === 'img' ? 1 : $_2rujnemkjk26xkuu.getOption(element).fold(function () {
        return $_4uy46mljjk26xkpk.children(element).length;
      }, function (v) {
        return v.length;
      });
    };
    var isEnd = function isEnd(element, offset) {
      return getEnd(element) === offset;
    };
    var isStart = function isStart(element, offset) {
      return offset === 0;
    };
    var NBSP = '\xA0';
    var isTextNodeWithCursorPosition = function isTextNodeWithCursorPosition(el) {
      return $_2rujnemkjk26xkuu.getOption(el).filter(function (text) {
        return text.trim().length !== 0 || text.indexOf(NBSP) > -1;
      }).isSome();
    };
    var elementsWithCursorPosition = ['img', 'br'];
    var isCursorPosition = function isCursorPosition(elem) {
      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
      return hasCursorPosition || contains(elementsWithCursorPosition, $_89mq4qm3jk26xkrq.name(elem));
    };
    var $_v3k82mjjk26xkuq = {
      getEnd: getEnd,
      isEnd: isEnd,
      isStart: isStart,
      isCursorPosition: isCursorPosition
    };

    var first$3 = function first$3(element) {
      return $_3kidmom8jk26xks9.descendant(element, $_v3k82mjjk26xkuq.isCursorPosition);
    };
    var last$2 = function last$2(element) {
      return descendantRtl(element, $_v3k82mjjk26xkuq.isCursorPosition);
    };
    var descendantRtl = function descendantRtl(scope, predicate) {
      var descend = function descend(element) {
        var children = $_4uy46mljjk26xkpk.children(element);
        for (var i = children.length - 1; i >= 0; i--) {
          var child = children[i];
          if (predicate(child)) return Option.some(child);
          var res = descend(child);
          if (res.isSome()) return res;
        }
        return Option.none();
      };
      return descend(scope);
    };
    var $_bqyx5vmijk26xkun = {
      first: first$3,
      last: last$2
    };

    var cell$1 = function cell$1() {
      var td = Element$$1.fromTag('td');
      $_aao88dmdjk26xkte.append(td, Element$$1.fromTag('br'));
      return td;
    };
    var replace = function replace(cell, tag, attrs) {
      var replica = $_e74daamhjk26xkuk.copy(cell, tag);
      each$1(attrs, function (v, k) {
        if (v === null) $_8icsmim2jk26xkrh.remove(replica, k);else $_8icsmim2jk26xkrh.set(replica, k, v);
      });
      return replica;
    };
    var pasteReplace = function pasteReplace(cellContent) {
      return cellContent;
    };
    var newRow = function newRow(doc) {
      return function () {
        return Element$$1.fromTag('tr', doc.dom());
      };
    };
    var cloneFormats = function cloneFormats(oldCell, newCell, formats) {
      var first = $_bqyx5vmijk26xkun.first(oldCell);
      return first.map(function (firstText) {
        var formatSelector = formats.join(',');
        var parents = $_bkrvmvm4jk26xkrt.ancestors(firstText, formatSelector, function (element) {
          return $_5m7qbqlljk26xkq3.eq(element, oldCell);
        });
        return foldr(parents, function (last$$1, parent) {
          var clonedFormat = $_e74daamhjk26xkuk.shallow(parent);
          $_8icsmim2jk26xkrh.remove(clonedFormat, 'contenteditable');
          $_aao88dmdjk26xkte.append(last$$1, clonedFormat);
          return clonedFormat;
        }, newCell);
      }).getOr(newCell);
    };
    var cellOperations = function cellOperations(mutate, doc, formatsToClone) {
      var newCell = function newCell(prev) {
        var doc = $_4uy46mljjk26xkpk.owner(prev.element());
        var td = Element$$1.fromTag($_89mq4qm3jk26xkrq.name(prev.element()), doc.dom());
        var formats = formatsToClone.getOr(['strong', 'em', 'b', 'i', 'span', 'font', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div']);
        var lastNode = formats.length > 0 ? cloneFormats(prev.element(), td, formats) : td;
        $_aao88dmdjk26xkte.append(lastNode, Element$$1.fromTag('br'));
        $_4ift9ombjk26xksz.copy(prev.element(), td);
        $_4ift9ombjk26xksz.remove(td, 'height');
        if (prev.colspan() !== 1) $_4ift9ombjk26xksz.remove(prev.element(), 'width');
        mutate(prev.element(), td);
        return td;
      };
      return {
        row: newRow(doc),
        cell: newCell,
        replace: replace,
        gap: cell$1
      };
    };
    var paste = function paste(doc) {
      return {
        row: newRow(doc),
        cell: cell$1,
        replace: pasteReplace,
        gap: cell$1
      };
    };
    var $_cek5a8mgjk26xkto = {
      cellOperations: cellOperations,
      paste: paste
    };

    var fromHtml$1 = function fromHtml$1(html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      return $_4uy46mljjk26xkpk.children(Element$$1.fromDom(div));
    };
    var fromTags = function fromTags(tags, scope) {
      return map(tags, function (x) {
        return Element$$1.fromTag(x, scope);
      });
    };
    var fromText$1 = function fromText$1(texts, scope) {
      return map(texts, function (x) {
        return Element$$1.fromText(x, scope);
      });
    };
    var fromDom$1 = function fromDom$1(nodes) {
      return map(nodes, Element$$1.fromDom);
    };
    var $_cm84yrmmjk26xkv1 = {
      fromHtml: fromHtml$1,
      fromTags: fromTags,
      fromText: fromText$1,
      fromDom: fromDom$1
    };

    var TagBoundaries = ['body', 'p', 'div', 'article', 'aside', 'figcaption', 'figure', 'footer', 'header', 'nav', 'section', 'ol', 'ul', 'li', 'table', 'thead', 'tbody', 'tfoot', 'caption', 'tr', 'td', 'th', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'address'];

    function DomUniverse() {
      var clone = function clone(element) {
        return Element$$1.fromDom(element.dom().cloneNode(false));
      };
      var isBoundary = function isBoundary(element) {
        if (!$_89mq4qm3jk26xkrq.isElement(element)) return false;
        if ($_89mq4qm3jk26xkrq.name(element) === 'body') return true;
        return contains(TagBoundaries, $_89mq4qm3jk26xkrq.name(element));
      };
      var isEmptyTag = function isEmptyTag(element) {
        if (!$_89mq4qm3jk26xkrq.isElement(element)) return false;
        return contains(['br', 'img', 'hr', 'input'], $_89mq4qm3jk26xkrq.name(element));
      };
      var comparePosition = function comparePosition(element, other) {
        return element.dom().compareDocumentPosition(other.dom());
      };
      var copyAttributesTo = function copyAttributesTo(source, destination) {
        var as = $_8icsmim2jk26xkrh.clone(source);
        $_8icsmim2jk26xkrh.setAll(destination, as);
      };
      return {
        up: constant({
          selector: $_at9vkhm7jk26xks8.ancestor,
          closest: $_at9vkhm7jk26xks8.closest,
          predicate: $_3kidmom8jk26xks9.ancestor,
          all: $_4uy46mljjk26xkpk.parents
        }),
        down: constant({
          selector: $_bkrvmvm4jk26xkrt.descendants,
          predicate: $_cail48m5jk26xkru.descendants
        }),
        styles: constant({
          get: $_4ift9ombjk26xksz.get,
          getRaw: $_4ift9ombjk26xksz.getRaw,
          set: $_4ift9ombjk26xksz.set,
          remove: $_4ift9ombjk26xksz.remove
        }),
        attrs: constant({
          get: $_8icsmim2jk26xkrh.get,
          set: $_8icsmim2jk26xkrh.set,
          remove: $_8icsmim2jk26xkrh.remove,
          copyTo: copyAttributesTo
        }),
        insert: constant({
          before: $_aao88dmdjk26xkte.before,
          after: $_aao88dmdjk26xkte.after,
          afterAll: $_bsj3f1mfjk26xktj.after,
          append: $_aao88dmdjk26xkte.append,
          appendAll: $_bsj3f1mfjk26xktj.append,
          prepend: $_aao88dmdjk26xkte.prepend,
          wrap: $_aao88dmdjk26xkte.wrap
        }),
        remove: constant({
          unwrap: $_lmq2lmejk26xktg.unwrap,
          remove: $_lmq2lmejk26xktg.remove
        }),
        create: constant({
          nu: Element$$1.fromTag,
          clone: clone,
          text: Element$$1.fromText
        }),
        query: constant({
          comparePosition: comparePosition,
          prevSibling: $_4uy46mljjk26xkpk.prevSibling,
          nextSibling: $_4uy46mljjk26xkpk.nextSibling
        }),
        property: constant({
          children: $_4uy46mljjk26xkpk.children,
          name: $_89mq4qm3jk26xkrq.name,
          parent: $_4uy46mljjk26xkpk.parent,
          isText: $_89mq4qm3jk26xkrq.isText,
          isComment: $_89mq4qm3jk26xkrq.isComment,
          isElement: $_89mq4qm3jk26xkrq.isElement,
          getText: $_2rujnemkjk26xkuu.get,
          setText: $_2rujnemkjk26xkuu.set,
          isBoundary: isBoundary,
          isEmptyTag: isEmptyTag
        }),
        eq: $_5m7qbqlljk26xkq3.eq,
        is: $_5m7qbqlljk26xkq3.is
      };
    }

    var leftRight = Immutable('left', 'right');
    var bisect = function bisect(universe, parent, child) {
      var children = universe.property().children(parent);
      var index = findIndex(children, curry(universe.eq, child));
      return index.map(function (ind) {
        return {
          before: constant(children.slice(0, ind)),
          after: constant(children.slice(ind + 1))
        };
      });
    };
    var breakToRight = function breakToRight(universe, parent, child) {
      return bisect(universe, parent, child).map(function (parts) {
        var second = universe.create().clone(parent);
        universe.insert().appendAll(second, parts.after());
        universe.insert().after(parent, second);
        return leftRight(parent, second);
      });
    };
    var breakToLeft = function breakToLeft(universe, parent, child) {
      return bisect(universe, parent, child).map(function (parts) {
        var prior = universe.create().clone(parent);
        universe.insert().appendAll(prior, parts.before().concat([child]));
        universe.insert().appendAll(parent, parts.after());
        universe.insert().before(parent, prior);
        return leftRight(prior, parent);
      });
    };
    var breakPath = function breakPath(universe, item, isTop, breaker) {
      var result = Immutable('first', 'second', 'splits');
      var next = function next(child, group, splits) {
        var fallback = result(child, Option.none(), splits);
        if (isTop(child)) return result(child, group, splits);else {
          return universe.property().parent(child).bind(function (parent) {
            return breaker(universe, parent, child).map(function (breakage) {
              var extra = [{
                first: breakage.left,
                second: breakage.right
              }];
              var nextChild = isTop(parent) ? parent : breakage.left();
              return next(nextChild, Option.some(breakage.right()), splits.concat(extra));
            }).getOr(fallback);
          });
        }
      };
      return next(item, Option.none(), []);
    };
    var $_f6as3xmvjk26xkxz = {
      breakToLeft: breakToLeft,
      breakToRight: breakToRight,
      breakPath: breakPath
    };

    var all$3 = function all$3(universe, look, elements, f) {
      var head$$1 = elements[0];
      var tail = elements.slice(1);
      return f(universe, look, head$$1, tail);
    };
    var oneAll = function oneAll(universe, look, elements) {
      return elements.length > 0 ? all$3(universe, look, elements, unsafeOne) : Option.none();
    };
    var unsafeOne = function unsafeOne(universe, look, head$$1, tail) {
      var start = look(universe, head$$1);
      return foldr(tail, function (b, a) {
        var current = look(universe, a);
        return commonElement(universe, b, current);
      }, start);
    };
    var commonElement = function commonElement(universe, start, end) {
      return start.bind(function (s) {
        return end.filter(curry(universe.eq, s));
      });
    };
    var $_8zn117mwjk26xky9 = { oneAll: oneAll };

    var eq$1 = function eq$1(universe, item) {
      return curry(universe.eq, item);
    };
    var unsafeSubset = function unsafeSubset(universe, common, ps1, ps2) {
      var children = universe.property().children(common);
      if (universe.eq(common, ps1[0])) return Option.some([ps1[0]]);
      if (universe.eq(common, ps2[0])) return Option.some([ps2[0]]);
      var finder = function finder(ps) {
        var topDown = reverse(ps);
        var index = findIndex(topDown, eq$1(universe, common)).getOr(-1);
        var item = index < topDown.length - 1 ? topDown[index + 1] : topDown[index];
        return findIndex(children, eq$1(universe, item));
      };
      var startIndex = finder(ps1);
      var endIndex = finder(ps2);
      return startIndex.bind(function (sIndex) {
        return endIndex.map(function (eIndex) {
          var first = Math.min(sIndex, eIndex);
          var last$$1 = Math.max(sIndex, eIndex);
          return children.slice(first, last$$1 + 1);
        });
      });
    };
    var ancestors$2 = function ancestors$2(universe, start, end, _isRoot) {
      var isRoot = _isRoot !== undefined ? _isRoot : constant(false);
      var ps1 = [start].concat(universe.up().all(start));
      var ps2 = [end].concat(universe.up().all(end));
      var prune = function prune(path) {
        var index = findIndex(path, isRoot);
        return index.fold(function () {
          return path;
        }, function (ind) {
          return path.slice(0, ind + 1);
        });
      };
      var pruned1 = prune(ps1);
      var pruned2 = prune(ps2);
      var shared = find(pruned1, function (x) {
        return exists(pruned2, eq$1(universe, x));
      });
      return {
        firstpath: constant(pruned1),
        secondpath: constant(pruned2),
        shared: constant(shared)
      };
    };
    var subset = function subset(universe, start, end) {
      var ancs = ancestors$2(universe, start, end);
      return ancs.shared().bind(function (shared) {
        return unsafeSubset(universe, shared, ancs.firstpath(), ancs.secondpath());
      });
    };
    var $_cbpws6mxjk26xkyh = {
      subset: subset,
      ancestors: ancestors$2
    };

    var sharedOne = function sharedOne(universe, look, elements) {
      return $_8zn117mwjk26xky9.oneAll(universe, look, elements);
    };
    var subset$1 = function subset$1(universe, start, finish) {
      return $_cbpws6mxjk26xkyh.subset(universe, start, finish);
    };
    var ancestors$3 = function ancestors$3(universe, start, finish, _isRoot) {
      return $_cbpws6mxjk26xkyh.ancestors(universe, start, finish, _isRoot);
    };
    var breakToLeft$1 = function breakToLeft$1(universe, parent, child) {
      return $_f6as3xmvjk26xkxz.breakToLeft(universe, parent, child);
    };
    var breakToRight$1 = function breakToRight$1(universe, parent, child) {
      return $_f6as3xmvjk26xkxz.breakToRight(universe, parent, child);
    };
    var breakPath$1 = function breakPath$1(universe, child, isTop, breaker) {
      return $_f6as3xmvjk26xkxz.breakPath(universe, child, isTop, breaker);
    };
    var $_g32xozmujk26xkxx = {
      sharedOne: sharedOne,
      subset: subset$1,
      ancestors: ancestors$3,
      breakToLeft: breakToLeft$1,
      breakToRight: breakToRight$1,
      breakPath: breakPath$1
    };

    var universe = DomUniverse();
    var sharedOne$1 = function sharedOne$1(look, elements) {
      return $_g32xozmujk26xkxx.sharedOne(universe, function (universe, element) {
        return look(element);
      }, elements);
    };
    var subset$2 = function subset$2(start, finish) {
      return $_g32xozmujk26xkxx.subset(universe, start, finish);
    };
    var ancestors$4 = function ancestors$4(start, finish, _isRoot) {
      return $_g32xozmujk26xkxx.ancestors(universe, start, finish, _isRoot);
    };
    var breakToLeft$2 = function breakToLeft$2(parent, child) {
      return $_g32xozmujk26xkxx.breakToLeft(universe, parent, child);
    };
    var breakToRight$2 = function breakToRight$2(parent, child) {
      return $_g32xozmujk26xkxx.breakToRight(universe, parent, child);
    };
    var breakPath$2 = function breakPath$2(child, isTop, breaker) {
      return $_g32xozmujk26xkxx.breakPath(universe, child, isTop, function (u, p, c) {
        return breaker(p, c);
      });
    };
    var $_daslkcmrjk26xkwr = {
      sharedOne: sharedOne$1,
      subset: subset$2,
      ancestors: ancestors$4,
      breakToLeft: breakToLeft$2,
      breakToRight: breakToRight$2,
      breakPath: breakPath$2
    };

    var inSelection = function inSelection(bounds, detail) {
      var leftEdge = detail.column();
      var rightEdge = detail.column() + detail.colspan() - 1;
      var topEdge = detail.row();
      var bottomEdge = detail.row() + detail.rowspan() - 1;
      return leftEdge <= bounds.finishCol() && rightEdge >= bounds.startCol() && topEdge <= bounds.finishRow() && bottomEdge >= bounds.startRow();
    };
    var isWithin = function isWithin(bounds, detail) {
      return detail.column() >= bounds.startCol() && detail.column() + detail.colspan() - 1 <= bounds.finishCol() && detail.row() >= bounds.startRow() && detail.row() + detail.rowspan() - 1 <= bounds.finishRow();
    };
    var isRectangular = function isRectangular(warehouse, bounds) {
      var isRect = true;
      var detailIsWithin = curry(isWithin, bounds);
      for (var i = bounds.startRow(); i <= bounds.finishRow(); i++) {
        for (var j = bounds.startCol(); j <= bounds.finishCol(); j++) {
          isRect = isRect && $_7tsw5majk26xksp.getAt(warehouse, i, j).exists(detailIsWithin);
        }
      }
      return isRect ? Option.some(bounds) : Option.none();
    };
    var $_5nixsan0jk26xkz1 = {
      inSelection: inSelection,
      isWithin: isWithin,
      isRectangular: isRectangular
    };

    var getBounds = function getBounds(detailA, detailB) {
      return $_g9pyg7lcjk26xknq.bounds(Math.min(detailA.row(), detailB.row()), Math.min(detailA.column(), detailB.column()), Math.max(detailA.row() + detailA.rowspan() - 1, detailB.row() + detailB.rowspan() - 1), Math.max(detailA.column() + detailA.colspan() - 1, detailB.column() + detailB.colspan() - 1));
    };
    var getAnyBox = function getAnyBox(warehouse, startCell, finishCell) {
      var startCoords = $_7tsw5majk26xksp.findItem(warehouse, startCell, $_5m7qbqlljk26xkq3.eq);
      var finishCoords = $_7tsw5majk26xksp.findItem(warehouse, finishCell, $_5m7qbqlljk26xkq3.eq);
      return startCoords.bind(function (sc) {
        return finishCoords.map(function (fc) {
          return getBounds(sc, fc);
        });
      });
    };
    var getBox = function getBox(warehouse, startCell, finishCell) {
      return getAnyBox(warehouse, startCell, finishCell).bind(function (bounds) {
        return $_5nixsan0jk26xkz1.isRectangular(warehouse, bounds);
      });
    };
    var $_1e93ssn1jk26xkz7 = {
      getAnyBox: getAnyBox,
      getBox: getBox
    };

    var moveBy = function moveBy(warehouse, cell, row, column) {
      return $_7tsw5majk26xksp.findItem(warehouse, cell, $_5m7qbqlljk26xkq3.eq).bind(function (detail) {
        var startRow = row > 0 ? detail.row() + detail.rowspan() - 1 : detail.row();
        var startCol = column > 0 ? detail.column() + detail.colspan() - 1 : detail.column();
        var dest = $_7tsw5majk26xksp.getAt(warehouse, startRow + row, startCol + column);
        return dest.map(function (d) {
          return d.element();
        });
      });
    };
    var intercepts = function intercepts(warehouse, start, finish) {
      return $_1e93ssn1jk26xkz7.getAnyBox(warehouse, start, finish).map(function (bounds) {
        var inside = $_7tsw5majk26xksp.filterItems(warehouse, curry($_5nixsan0jk26xkz1.inSelection, bounds));
        return map(inside, function (detail) {
          return detail.element();
        });
      });
    };
    var parentCell = function parentCell(warehouse, innerCell) {
      var isContainedBy = function isContainedBy(c1, c2) {
        return $_5m7qbqlljk26xkq3.contains(c2, c1);
      };
      return $_7tsw5majk26xksp.findItem(warehouse, innerCell, isContainedBy).bind(function (detail) {
        return detail.element();
      });
    };
    var $_dlvyfgmzjk26xkyu = {
      moveBy: moveBy,
      intercepts: intercepts,
      parentCell: parentCell
    };

    var moveBy$1 = function moveBy$1(cell, deltaRow, deltaColumn) {
      return $_3gdghfldjk26xknu.table(cell).bind(function (table) {
        var warehouse = getWarehouse(table);
        return $_dlvyfgmzjk26xkyu.moveBy(warehouse, cell, deltaRow, deltaColumn);
      });
    };
    var intercepts$1 = function intercepts$1(table, first, last) {
      var warehouse = getWarehouse(table);
      return $_dlvyfgmzjk26xkyu.intercepts(warehouse, first, last);
    };
    var nestedIntercepts = function nestedIntercepts(table, first, firstTable, last, lastTable) {
      var warehouse = getWarehouse(table);
      var startCell = $_5m7qbqlljk26xkq3.eq(table, firstTable) ? first : $_dlvyfgmzjk26xkyu.parentCell(warehouse, first);
      var lastCell = $_5m7qbqlljk26xkq3.eq(table, lastTable) ? last : $_dlvyfgmzjk26xkyu.parentCell(warehouse, last);
      return $_dlvyfgmzjk26xkyu.intercepts(warehouse, startCell, lastCell);
    };
    var getBox$1 = function getBox$1(table, first, last) {
      var warehouse = getWarehouse(table);
      return $_1e93ssn1jk26xkz7.getBox(warehouse, first, last);
    };
    var getWarehouse = function getWarehouse(table) {
      var list = $_aihceulbjk26xkng.fromTable(table);
      return $_7tsw5majk26xksp.generate(list);
    };
    var $_bilw58myjk26xkyq = {
      moveBy: moveBy$1,
      intercepts: intercepts$1,
      nestedIntercepts: nestedIntercepts,
      getBox: getBox$1
    };

    var lookupTable = function lookupTable(container, isRoot) {
      return $_at9vkhm7jk26xks8.ancestor(container, 'table');
    };
    var identified = MixedBag(['boxes', 'start', 'finish'], []);
    var identify = function identify(start, finish, isRoot) {
      var getIsRoot = function getIsRoot(rootTable) {
        return function (element) {
          return isRoot(element) || $_5m7qbqlljk26xkq3.eq(element, rootTable);
        };
      };
      if ($_5m7qbqlljk26xkq3.eq(start, finish)) {
        return Option.some(identified({
          boxes: Option.some([start]),
          start: start,
          finish: finish
        }));
      } else {
        return lookupTable(start, isRoot).bind(function (startTable) {
          return lookupTable(finish, isRoot).bind(function (finishTable) {
            if ($_5m7qbqlljk26xkq3.eq(startTable, finishTable)) {
              return Option.some(identified({
                boxes: $_bilw58myjk26xkyq.intercepts(startTable, start, finish),
                start: start,
                finish: finish
              }));
            } else if ($_5m7qbqlljk26xkq3.contains(startTable, finishTable)) {
              var ancestorCells = $_bkrvmvm4jk26xkrt.ancestors(finish, 'td,th', getIsRoot(startTable));
              var finishCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : finish;
              return Option.some(identified({
                boxes: $_bilw58myjk26xkyq.nestedIntercepts(startTable, start, startTable, finish, finishTable),
                start: start,
                finish: finishCell
              }));
            } else if ($_5m7qbqlljk26xkq3.contains(finishTable, startTable)) {
              var ancestorCells = $_bkrvmvm4jk26xkrt.ancestors(start, 'td,th', getIsRoot(finishTable));
              var startCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : start;
              return Option.some(identified({
                boxes: $_bilw58myjk26xkyq.nestedIntercepts(finishTable, start, startTable, finish, finishTable),
                start: start,
                finish: startCell
              }));
            } else {
              return $_daslkcmrjk26xkwr.ancestors(start, finish).shared().bind(function (lca) {
                return $_at9vkhm7jk26xks8.closest(lca, 'table', isRoot).bind(function (lcaTable) {
                  var finishAncestorCells = $_bkrvmvm4jk26xkrt.ancestors(finish, 'td,th', getIsRoot(lcaTable));
                  var finishCell = finishAncestorCells.length > 0 ? finishAncestorCells[finishAncestorCells.length - 1] : finish;
                  var startAncestorCells = $_bkrvmvm4jk26xkrt.ancestors(start, 'td,th', getIsRoot(lcaTable));
                  var startCell = startAncestorCells.length > 0 ? startAncestorCells[startAncestorCells.length - 1] : start;
                  return Option.some(identified({
                    boxes: $_bilw58myjk26xkyq.nestedIntercepts(lcaTable, start, startTable, finish, finishTable),
                    start: startCell,
                    finish: finishCell
                  }));
                });
              });
            }
          });
        });
      }
    };
    var retrieve = function retrieve(container, selector) {
      var sels = $_bkrvmvm4jk26xkrt.descendants(container, selector);
      return sels.length > 0 ? Option.some(sels) : Option.none();
    };
    var getLast = function getLast(boxes, lastSelectedSelector) {
      return find(boxes, function (box) {
        return $_1asaomlfjk26xkos.is(box, lastSelectedSelector);
      });
    };
    var getEdges = function getEdges(container, firstSelectedSelector, lastSelectedSelector) {
      return $_at9vkhm7jk26xks8.descendant(container, firstSelectedSelector).bind(function (first) {
        return $_at9vkhm7jk26xks8.descendant(container, lastSelectedSelector).bind(function (last$$1) {
          return $_daslkcmrjk26xkwr.sharedOne(lookupTable, [first, last$$1]).map(function (tbl) {
            return {
              first: constant(first),
              last: constant(last$$1),
              table: constant(tbl)
            };
          });
        });
      });
    };
    var expandTo = function expandTo(finish, firstSelectedSelector) {
      return $_at9vkhm7jk26xks8.ancestor(finish, 'table').bind(function (table) {
        return $_at9vkhm7jk26xks8.descendant(table, firstSelectedSelector).bind(function (start) {
          return identify(start, finish).bind(function (identified) {
            return identified.boxes().map(function (boxes) {
              return {
                boxes: constant(boxes),
                start: constant(identified.start()),
                finish: constant(identified.finish())
              };
            });
          });
        });
      });
    };
    var shiftSelection = function shiftSelection(boxes, deltaRow, deltaColumn, firstSelectedSelector, lastSelectedSelector) {
      return getLast(boxes, lastSelectedSelector).bind(function (last$$1) {
        return $_bilw58myjk26xkyq.moveBy(last$$1, deltaRow, deltaColumn).bind(function (finish) {
          return expandTo(finish, firstSelectedSelector);
        });
      });
    };
    var $_5a1ieomqjk26xkw2 = {
      identify: identify,
      retrieve: retrieve,
      shiftSelection: shiftSelection,
      getEdges: getEdges
    };

    var retrieve$1 = function retrieve$1(container, selector) {
      return $_5a1ieomqjk26xkw2.retrieve(container, selector);
    };
    var retrieveBox = function retrieveBox(container, firstSelectedSelector, lastSelectedSelector) {
      return $_5a1ieomqjk26xkw2.getEdges(container, firstSelectedSelector, lastSelectedSelector).bind(function (edges) {
        var isRoot = function isRoot(ancestor) {
          return $_5m7qbqlljk26xkq3.eq(container, ancestor);
        };
        var firstAncestor = $_at9vkhm7jk26xks8.ancestor(edges.first(), 'thead,tfoot,tbody,table', isRoot);
        var lastAncestor = $_at9vkhm7jk26xks8.ancestor(edges.last(), 'thead,tfoot,tbody,table', isRoot);
        return firstAncestor.bind(function (fA) {
          return lastAncestor.bind(function (lA) {
            return $_5m7qbqlljk26xkq3.eq(fA, lA) ? $_bilw58myjk26xkyq.getBox(edges.table(), edges.first(), edges.last()) : Option.none();
          });
        });
      });
    };
    var $_aorrykmpjk26xkvn = {
      retrieve: retrieve$1,
      retrieveBox: retrieveBox
    };

    var selected = 'data-mce-selected';
    var selectedSelector = 'td[' + selected + '],th[' + selected + ']';
    var attributeSelector = '[' + selected + ']';
    var firstSelected = 'data-mce-first-selected';
    var firstSelectedSelector = 'td[' + firstSelected + '],th[' + firstSelected + ']';
    var lastSelected = 'data-mce-last-selected';
    var lastSelectedSelector = 'td[' + lastSelected + '],th[' + lastSelected + ']';
    var $_dmfr5on2jk26xkzd = {
      selected: constant(selected),
      selectedSelector: constant(selectedSelector),
      attributeSelector: constant(attributeSelector),
      firstSelected: constant(firstSelected),
      firstSelectedSelector: constant(firstSelectedSelector),
      lastSelected: constant(lastSelected),
      lastSelectedSelector: constant(lastSelectedSelector)
    };

    var generate$1 = function generate$1(cases) {
      if (!isArray(cases)) {
        throw new Error('cases must be an array');
      }
      if (cases.length === 0) {
        throw new Error('there must be at least one case');
      }
      var constructors = [];
      var adt = {};
      each(cases, function (acase, count) {
        var keys$$1 = keys(acase);
        if (keys$$1.length !== 1) {
          throw new Error('one and only one name per case');
        }
        var key = keys$$1[0];
        var value = acase[key];
        if (adt[key] !== undefined) {
          throw new Error('duplicate key detected:' + key);
        } else if (key === 'cata') {
          throw new Error('cannot have a case named cata (sorry)');
        } else if (!isArray(value)) {
          throw new Error('case arguments must be an array');
        }
        constructors.push(key);
        adt[key] = function () {
          var argLength = arguments.length;
          if (argLength !== value.length) {
            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
          }
          var args = new Array(argLength);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }var match = function match(branches) {
            var branchKeys = keys(branches);
            if (constructors.length !== branchKeys.length) {
              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
            }
            var allReqd = forall(constructors, function (reqKey) {
              return contains(branchKeys, reqKey);
            });
            if (!allReqd) throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
            return branches[key].apply(null, args);
          };
          return {
            fold: function fold() {
              if (arguments.length !== cases.length) {
                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
              }
              var target = arguments[count];
              return target.apply(null, args);
            },
            match: match,
            log: function log(label) {
              console.log(label, {
                constructors: constructors,
                constructor: key,
                params: args
              });
            }
          };
        };
      });
      return adt;
    };
    var Adt = { generate: generate$1 };

    var type$1 = Adt.generate([{ none: [] }, { multiple: ['elements'] }, { single: ['selection'] }]);
    var cata = function cata(subject, onNone, onMultiple, onSingle) {
      return subject.fold(onNone, onMultiple, onSingle);
    };
    var $_csneo2n3jk26xkzf = {
      cata: cata,
      none: type$1.none,
      multiple: type$1.multiple,
      single: type$1.single
    };

    var selection = function selection(cell, selections) {
      return $_csneo2n3jk26xkzf.cata(selections.get(), constant([]), identity, constant([cell]));
    };
    var unmergable = function unmergable(cell, selections) {
      var hasSpan = function hasSpan(elem) {
        return $_8icsmim2jk26xkrh.has(elem, 'rowspan') && parseInt($_8icsmim2jk26xkrh.get(elem, 'rowspan'), 10) > 1 || $_8icsmim2jk26xkrh.has(elem, 'colspan') && parseInt($_8icsmim2jk26xkrh.get(elem, 'colspan'), 10) > 1;
      };
      var candidates = selection(cell, selections);
      return candidates.length > 0 && forall(candidates, hasSpan) ? Option.some(candidates) : Option.none();
    };
    var mergable = function mergable(table, selections) {
      return $_csneo2n3jk26xkzf.cata(selections.get(), Option.none, function (cells, _env) {
        if (cells.length === 0) {
          return Option.none();
        }
        return $_aorrykmpjk26xkvn.retrieveBox(table, $_dmfr5on2jk26xkzd.firstSelectedSelector(), $_dmfr5on2jk26xkzd.lastSelectedSelector()).bind(function (bounds) {
          return cells.length > 1 ? Option.some({
            bounds: constant(bounds),
            cells: constant(cells)
          }) : Option.none();
        });
      }, Option.none);
    };
    var $_g8gebsmojk26xkvc = {
      mergable: mergable,
      unmergable: unmergable,
      selection: selection
    };

    var noMenu = function noMenu(cell) {
      return {
        element: constant(cell),
        mergable: Option.none,
        unmergable: Option.none,
        selection: constant([cell])
      };
    };
    var forMenu = function forMenu(selections, table, cell) {
      return {
        element: constant(cell),
        mergable: constant($_g8gebsmojk26xkvc.mergable(table, selections)),
        unmergable: constant($_g8gebsmojk26xkvc.unmergable(cell, selections)),
        selection: constant($_g8gebsmojk26xkvc.selection(cell, selections))
      };
    };
    var notCell$1 = function notCell$1(element) {
      return noMenu(element);
    };
    var paste$1 = Immutable('element', 'clipboard', 'generators');
    var pasteRows = function pasteRows(selections, table, cell, clipboard, generators) {
      return {
        element: constant(cell),
        mergable: Option.none,
        unmergable: Option.none,
        selection: constant($_g8gebsmojk26xkvc.selection(cell, selections)),
        clipboard: constant(clipboard),
        generators: constant(generators)
      };
    };
    var $_bzk3jsmnjk26xkv6 = {
      noMenu: noMenu,
      forMenu: forMenu,
      notCell: notCell$1,
      paste: paste$1,
      pasteRows: pasteRows
    };

    var extractSelected = function extractSelected(cells) {
      return $_3gdghfldjk26xknu.table(cells[0]).map($_e74daamhjk26xkuk.deep).map(function (replica) {
        return [$_ldmecl5jk26xkmk.extract(replica, $_dmfr5on2jk26xkzd.attributeSelector())];
      });
    };
    var serializeElement = function serializeElement(editor, elm) {
      return editor.selection.serializer.serialize(elm.dom(), {});
    };
    var registerEvents = function registerEvents(editor, selections, actions, cellSelection) {
      editor.on('BeforeGetContent', function (e) {
        var multiCellContext = function multiCellContext(cells) {
          e.preventDefault();
          extractSelected(cells).each(function (elements) {
            e.content = map(elements, function (elm) {
              return serializeElement(editor, elm);
            }).join('');
          });
        };
        if (e.selection === true) {
          $_csneo2n3jk26xkzf.cata(selections.get(), noop, multiCellContext, noop);
        }
      });
      editor.on('BeforeSetContent', function (e) {
        if (e.selection === true && e.paste === true) {
          var cellOpt = Option.from(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
          cellOpt.each(function (domCell) {
            var cell = Element$$1.fromDom(domCell);
            var table = $_3gdghfldjk26xknu.table(cell);
            table.bind(function (table) {
              var elements = filter($_cm84yrmmjk26xkv1.fromHtml(e.content), function (content) {
                return $_89mq4qm3jk26xkrq.name(content) !== 'meta';
              });
              if (elements.length === 1 && $_89mq4qm3jk26xkrq.name(elements[0]) === 'table') {
                e.preventDefault();
                var doc = Element$$1.fromDom(editor.getDoc());
                var generators = $_cek5a8mgjk26xkto.paste(doc);
                var targets = $_bzk3jsmnjk26xkv6.paste(cell, elements[0], generators);
                actions.pasteCells(table, targets).each(function (rng) {
                  editor.selection.setRng(rng);
                  editor.focus();
                  cellSelection.clear(table);
                });
              }
            });
          });
        }
      });
    };
    var $_usmm6l0jk26xklg = { registerEvents: registerEvents };

    function Dimension(name, getOffset) {
      var set = function set(element, h) {
        if (!isNumber(h) && !h.match(/^[0-9]+$/)) throw name + '.set accepts only positive integer values. Value was ' + h;
        var dom = element.dom();
        if ($_lq021mcjk26xktd.isSupported(dom)) dom.style[name] = h + 'px';
      };
      var get = function get(element) {
        var r = getOffset(element);
        if (r <= 0 || r === null) {
          var css = $_4ift9ombjk26xksz.get(element, name);
          return parseFloat(css) || 0;
        }
        return r;
      };
      var getOuter = get;
      var aggregate = function aggregate(element, properties) {
        return foldl(properties, function (acc, property) {
          var val = $_4ift9ombjk26xksz.get(element, property);
          var value = val === undefined ? 0 : parseInt(val, 10);
          return isNaN(value) ? acc : acc + value;
        }, 0);
      };
      var max = function max(element, value, properties) {
        var cumulativeInclusions = aggregate(element, properties);
        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
        return absoluteMax;
      };
      return {
        set: set,
        get: get,
        getOuter: getOuter,
        aggregate: aggregate,
        max: max
      };
    }

    var api$1 = Dimension('height', function (element) {
      var dom = element.dom();
      return $_9gbjzvm6jk26xkrx.inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
    });
    var set$3 = function set$3(element, h) {
      api$1.set(element, h);
    };
    var get$3 = function get$3(element) {
      return api$1.get(element);
    };
    var getOuter = function getOuter(element) {
      return api$1.getOuter(element);
    };
    var setMax = function setMax(element, value) {
      var inclusions = ['margin-top', 'border-top-width', 'padding-top', 'padding-bottom', 'border-bottom-width', 'margin-bottom'];
      var absMax = api$1.max(element, value, inclusions);
      $_4ift9ombjk26xksz.set(element, 'max-height', absMax + 'px');
    };
    var $_60e1qun9jk26xl11 = {
      set: set$3,
      get: get$3,
      getOuter: getOuter,
      setMax: setMax
    };

    var api$2 = Dimension('width', function (element) {
      return element.dom().offsetWidth;
    });
    var set$4 = function set$4(element, h) {
      api$2.set(element, h);
    };
    var get$4 = function get$4(element) {
      return api$2.get(element);
    };
    var getOuter$1 = function getOuter$1(element) {
      return api$2.getOuter(element);
    };
    var setMax$1 = function setMax$1(element, value) {
      var inclusions = ['margin-left', 'border-left-width', 'padding-left', 'padding-right', 'border-right-width', 'margin-right'];
      var absMax = api$2.max(element, value, inclusions);
      $_4ift9ombjk26xksz.set(element, 'max-width', absMax + 'px');
    };
    var $_736uoenbjk26xl19 = {
      set: set$4,
      get: get$4,
      getOuter: getOuter$1,
      setMax: setMax$1
    };

    var platform = $_aj4ie4lqjk26xkqk.detect();
    var needManualCalc = function needManualCalc() {
      return platform.browser.isIE() || platform.browser.isEdge();
    };
    var toNumber = function toNumber(px, fallback) {
      var num = parseFloat(px);
      return isNaN(num) ? fallback : num;
    };
    var getProp = function getProp(elm, name, fallback) {
      return toNumber($_4ift9ombjk26xksz.get(elm, name), fallback);
    };
    var getCalculatedHeight = function getCalculatedHeight(cell) {
      var paddingTop = getProp(cell, 'padding-top', 0);
      var paddingBottom = getProp(cell, 'padding-bottom', 0);
      var borderTop = getProp(cell, 'border-top-width', 0);
      var borderBottom = getProp(cell, 'border-bottom-width', 0);
      var height = cell.dom().getBoundingClientRect().height;
      var boxSizing = $_4ift9ombjk26xksz.get(cell, 'box-sizing');
      var borders = borderTop + borderBottom;
      return boxSizing === 'border-box' ? height : height - paddingTop - paddingBottom - borders;
    };
    var getWidth = function getWidth(cell) {
      return getProp(cell, 'width', $_736uoenbjk26xl19.get(cell));
    };
    var getHeight = function getHeight(cell) {
      return needManualCalc() ? getCalculatedHeight(cell) : getProp(cell, 'height', $_60e1qun9jk26xl11.get(cell));
    };
    var $_1dugcxn8jk26xl0s = {
      getWidth: getWidth,
      getHeight: getHeight
    };

    var genericSizeRegex = /(\d+(\.\d+)?)(\w|%)*/;
    var percentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
    var pixelBasedSizeRegex = /(\d+(\.\d+)?)px|em/;
    var setPixelWidth = function setPixelWidth(cell, amount) {
      $_4ift9ombjk26xksz.set(cell, 'width', amount + 'px');
    };
    var setPercentageWidth = function setPercentageWidth(cell, amount) {
      $_4ift9ombjk26xksz.set(cell, 'width', amount + '%');
    };
    var setHeight = function setHeight(cell, amount) {
      $_4ift9ombjk26xksz.set(cell, 'height', amount + 'px');
    };
    var getHeightValue = function getHeightValue(cell) {
      return $_4ift9ombjk26xksz.getRaw(cell, 'height').getOrThunk(function () {
        return $_1dugcxn8jk26xl0s.getHeight(cell) + 'px';
      });
    };
    var convert = function convert(cell, number, getter, setter) {
      var newSize = $_3gdghfldjk26xknu.table(cell).map(function (table) {
        var total = getter(table);
        return Math.floor(number / 100 * total);
      }).getOr(number);
      setter(cell, newSize);
      return newSize;
    };
    var normalizePixelSize = function normalizePixelSize(value, cell, getter, setter) {
      var number = parseInt(value, 10);
      return endsWith(value, '%') && $_89mq4qm3jk26xkrq.name(cell) !== 'table' ? convert(cell, number, getter, setter) : number;
    };
    var getTotalHeight = function getTotalHeight(cell) {
      var value = getHeightValue(cell);
      if (!value) return $_60e1qun9jk26xl11.get(cell);
      return normalizePixelSize(value, cell, $_60e1qun9jk26xl11.get, setHeight);
    };
    var get$5 = function get$5(cell, type, f) {
      var v = f(cell);
      var span = getSpan(cell, type);
      return v / span;
    };
    var getSpan = function getSpan(cell, type) {
      return $_8icsmim2jk26xkrh.has(cell, type) ? parseInt($_8icsmim2jk26xkrh.get(cell, type), 10) : 1;
    };
    var getRawWidth = function getRawWidth(element) {
      var cssWidth = $_4ift9ombjk26xksz.getRaw(element, 'width');
      return cssWidth.fold(function () {
        return Option.from($_8icsmim2jk26xkrh.get(element, 'width'));
      }, function (width) {
        return Option.some(width);
      });
    };
    var normalizePercentageWidth = function normalizePercentageWidth(cellWidth, tableSize) {
      return cellWidth / tableSize.pixelWidth() * 100;
    };
    var choosePercentageSize = function choosePercentageSize(element, width, tableSize) {
      if (percentageBasedSizeRegex.test(width)) {
        var percentMatch = percentageBasedSizeRegex.exec(width);
        return parseFloat(percentMatch[1]);
      } else {
        var intWidth = $_736uoenbjk26xl19.get(element);
        return normalizePercentageWidth(intWidth, tableSize);
      }
    };
    var getPercentageWidth = function getPercentageWidth(cell, tableSize) {
      var width = getRawWidth(cell);
      return width.fold(function () {
        var intWidth = $_736uoenbjk26xl19.get(cell);
        return normalizePercentageWidth(intWidth, tableSize);
      }, function (width) {
        return choosePercentageSize(cell, width, tableSize);
      });
    };
    var normalizePixelWidth = function normalizePixelWidth(cellWidth, tableSize) {
      return cellWidth / 100 * tableSize.pixelWidth();
    };
    var choosePixelSize = function choosePixelSize(element, width, tableSize) {
      if (pixelBasedSizeRegex.test(width)) {
        var pixelMatch = pixelBasedSizeRegex.exec(width);
        return parseInt(pixelMatch[1], 10);
      } else if (percentageBasedSizeRegex.test(width)) {
        var percentMatch = percentageBasedSizeRegex.exec(width);
        var floatWidth = parseFloat(percentMatch[1]);
        return normalizePixelWidth(floatWidth, tableSize);
      } else {
        return $_736uoenbjk26xl19.get(element);
      }
    };
    var getPixelWidth = function getPixelWidth(cell, tableSize) {
      var width = getRawWidth(cell);
      return width.fold(function () {
        return $_736uoenbjk26xl19.get(cell);
      }, function (width) {
        return choosePixelSize(cell, width, tableSize);
      });
    };
    var getHeight$1 = function getHeight$1(cell) {
      return get$5(cell, 'rowspan', getTotalHeight);
    };
    var getGenericWidth = function getGenericWidth(cell) {
      var width = getRawWidth(cell);
      return width.bind(function (width) {
        if (genericSizeRegex.test(width)) {
          var match = genericSizeRegex.exec(width);
          return Option.some({
            width: constant(match[1]),
            unit: constant(match[3])
          });
        } else {
          return Option.none();
        }
      });
    };
    var setGenericWidth = function setGenericWidth(cell, amount, unit) {
      $_4ift9ombjk26xksz.set(cell, 'width', amount + unit);
    };
    var $_4khph0n7jk26xl09 = {
      percentageBasedSizeRegex: constant(percentageBasedSizeRegex),
      pixelBasedSizeRegex: constant(pixelBasedSizeRegex),
      setPixelWidth: setPixelWidth,
      setPercentageWidth: setPercentageWidth,
      setHeight: setHeight,
      getPixelWidth: getPixelWidth,
      getPercentageWidth: getPercentageWidth,
      getGenericWidth: getGenericWidth,
      setGenericWidth: setGenericWidth,
      getHeight: getHeight$1,
      getRawWidth: getRawWidth
    };

    var halve = function halve(main, other) {
      var width = $_4khph0n7jk26xl09.getGenericWidth(main);
      width.each(function (width) {
        var newWidth = width.width() / 2;
        $_4khph0n7jk26xl09.setGenericWidth(main, newWidth, width.unit());
        $_4khph0n7jk26xl09.setGenericWidth(other, newWidth, width.unit());
      });
    };
    var $_4lzdh1n6jk26xl06 = { halve: halve };

    var attached = function attached(element, scope) {
      var doc = scope || Element$$1.fromDom(document.documentElement);
      return $_3kidmom8jk26xks9.ancestor(element, curry($_5m7qbqlljk26xkq3.eq, doc)).isSome();
    };
    var windowOf = function windowOf(element) {
      var dom = element.dom();
      if (dom === dom.window && element instanceof Window) return element;
      return $_89mq4qm3jk26xkrq.isDocument(element) ? dom.defaultView || dom.parentWindow : null;
    };
    var $_a12bu9ngjk26xl1y = {
      attached: attached,
      windowOf: windowOf
    };

    var r = function r(left, top) {
      var translate = function translate(x, y) {
        return r(left + x, top + y);
      };
      return {
        left: constant(left),
        top: constant(top),
        translate: translate
      };
    };
    var Position = r;

    var boxPosition = function boxPosition(dom) {
      var box = dom.getBoundingClientRect();
      return Position(box.left, box.top);
    };
    var firstDefinedOrZero = function firstDefinedOrZero(a, b) {
      return a !== undefined ? a : b !== undefined ? b : 0;
    };
    var absolute = function absolute(element) {
      var doc = element.dom().ownerDocument;
      var body = doc.body;
      var win = $_a12bu9ngjk26xl1y.windowOf(Element$$1.fromDom(doc));
      var html = doc.documentElement;
      var scrollTop = firstDefinedOrZero(win.pageYOffset, html.scrollTop);
      var scrollLeft = firstDefinedOrZero(win.pageXOffset, html.scrollLeft);
      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
    };
    var relative = function relative(element) {
      var dom = element.dom();
      return Position(dom.offsetLeft, dom.offsetTop);
    };
    var viewport = function viewport(element) {
      var dom = element.dom();
      var doc = dom.ownerDocument;
      var body = doc.body;
      var html = Element$$1.fromDom(doc.documentElement);
      if (body === dom) return Position(body.offsetLeft, body.offsetTop);
      if (!$_a12bu9ngjk26xl1y.attached(element, html)) return Position(0, 0);
      return boxPosition(dom);
    };
    var $_f7fwegnfjk26xl1w = {
      absolute: absolute,
      relative: relative,
      viewport: viewport
    };

    var rowInfo = Immutable('row', 'y');
    var colInfo = Immutable('col', 'x');
    var rtlEdge = function rtlEdge(cell) {
      var pos = $_f7fwegnfjk26xl1w.absolute(cell);
      return pos.left() + $_736uoenbjk26xl19.getOuter(cell);
    };
    var ltrEdge = function ltrEdge(cell) {
      return $_f7fwegnfjk26xl1w.absolute(cell).left();
    };
    var getLeftEdge = function getLeftEdge(index, cell) {
      return colInfo(index, ltrEdge(cell));
    };
    var getRightEdge = function getRightEdge(index, cell) {
      return colInfo(index, rtlEdge(cell));
    };
    var getTop = function getTop(cell) {
      return $_f7fwegnfjk26xl1w.absolute(cell).top();
    };
    var getTopEdge = function getTopEdge(index, cell) {
      return rowInfo(index, getTop(cell));
    };
    var getBottomEdge = function getBottomEdge(index, cell) {
      return rowInfo(index, getTop(cell) + $_60e1qun9jk26xl11.getOuter(cell));
    };
    var findPositions = function findPositions(getInnerEdge, getOuterEdge, array) {
      if (array.length === 0) return [];
      var lines = map(array.slice(1), function (cellOption, index) {
        return cellOption.map(function (cell) {
          return getInnerEdge(index, cell);
        });
      });
      var lastLine = array[array.length - 1].map(function (cell) {
        return getOuterEdge(array.length - 1, cell);
      });
      return lines.concat([lastLine]);
    };
    var negate = function negate(step, _table) {
      return -step;
    };
    var height = {
      delta: identity,
      positions: curry(findPositions, getTopEdge, getBottomEdge),
      edge: getTop
    };
    var ltr = {
      delta: identity,
      edge: ltrEdge,
      positions: curry(findPositions, getLeftEdge, getRightEdge)
    };
    var rtl = {
      delta: negate,
      edge: rtlEdge,
      positions: curry(findPositions, getRightEdge, getLeftEdge)
    };
    var $_eofvgnejk26xl1e = {
      height: height,
      rtl: rtl,
      ltr: ltr
    };

    var $_6qfbqsndjk26xl1c = {
      ltr: $_eofvgnejk26xl1e.ltr,
      rtl: $_eofvgnejk26xl1e.rtl
    };

    function TableDirection(directionAt) {
      var auto = function auto(table) {
        return directionAt(table).isRtl() ? $_6qfbqsndjk26xl1c.rtl : $_6qfbqsndjk26xl1c.ltr;
      };
      var delta = function delta(amount, table) {
        return auto(table).delta(amount, table);
      };
      var positions = function positions(cols, table) {
        return auto(table).positions(cols, table);
      };
      var edge = function edge(cell) {
        return auto(cell).edge(cell);
      };
      return {
        delta: delta,
        edge: edge,
        positions: positions
      };
    }

    var getGridSize = function getGridSize(table) {
      var input = $_aihceulbjk26xkng.fromTable(table);
      var warehouse = $_7tsw5majk26xksp.generate(input);
      return warehouse.grid();
    };
    var $_cki6bsnijk26xl26 = { getGridSize: getGridSize };

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var base = function base(handleUnsupported, required) {
      return baseWith(handleUnsupported, required, {
        validate: isFunction,
        label: 'function'
      });
    };
    var baseWith = function baseWith(handleUnsupported, required, pred) {
      if (required.length === 0) throw new Error('You must specify at least one required field.');
      validateStrArr('required', required);
      checkDupes(required);
      return function (obj) {
        var keys$$1 = keys(obj);
        var allReqd = forall(required, function (req) {
          return contains(keys$$1, req);
        });
        if (!allReqd) reqMessage(required, keys$$1);
        handleUnsupported(required, keys$$1);
        var invalidKeys = filter(required, function (key) {
          return !pred.validate(obj[key], key);
        });
        if (invalidKeys.length > 0) invalidTypeMessage(invalidKeys, pred.label);
        return obj;
      };
    };
    var handleExact = function handleExact(required, keys$$1) {
      var unsupported = filter(keys$$1, function (key) {
        return !contains(required, key);
      });
      if (unsupported.length > 0) unsuppMessage(unsupported);
    };
    var exactly = function exactly(required) {
      return base(handleExact, required);
    };

    var elementToData = function elementToData(element) {
      var colspan = $_8icsmim2jk26xkrh.has(element, 'colspan') ? parseInt($_8icsmim2jk26xkrh.get(element, 'colspan'), 10) : 1;
      var rowspan = $_8icsmim2jk26xkrh.has(element, 'rowspan') ? parseInt($_8icsmim2jk26xkrh.get(element, 'rowspan'), 10) : 1;
      return {
        element: constant(element),
        colspan: constant(colspan),
        rowspan: constant(rowspan)
      };
    };
    var modification = function modification(generators, _toData) {
      contract(generators);
      var position = Cell(Option.none());
      var toData = _toData !== undefined ? _toData : elementToData;
      var nu = function nu(data) {
        return generators.cell(data);
      };
      var nuFrom = function nuFrom(element) {
        var data = toData(element);
        return nu(data);
      };
      var add = function add(element) {
        var replacement = nuFrom(element);
        if (position.get().isNone()) position.set(Option.some(replacement));
        recent = Option.some({
          item: element,
          replacement: replacement
        });
        return replacement;
      };
      var recent = Option.none();
      var getOrInit = function getOrInit(element, comparator) {
        return recent.fold(function () {
          return add(element);
        }, function (p) {
          return comparator(element, p.item) ? p.replacement : add(element);
        });
      };
      return {
        getOrInit: getOrInit,
        cursor: position.get
      };
    };
    var transform = function transform(scope, tag) {
      return function (generators) {
        var position = Cell(Option.none());
        contract(generators);
        var list = [];
        var find$$1 = function find$$1(element, comparator) {
          return find(list, function (x) {
            return comparator(x.item, element);
          });
        };
        var makeNew = function makeNew(element) {
          var cell = generators.replace(element, tag, { scope: scope });
          list.push({
            item: element,
            sub: cell
          });
          if (position.get().isNone()) position.set(Option.some(cell));
          return cell;
        };
        var replaceOrInit = function replaceOrInit(element, comparator) {
          return find$$1(element, comparator).fold(function () {
            return makeNew(element);
          }, function (p) {
            return comparator(element, p.item) ? p.sub : makeNew(element);
          });
        };
        return {
          replaceOrInit: replaceOrInit,
          cursor: position.get
        };
      };
    };
    var merging = function merging(generators) {
      contract(generators);
      var position = Cell(Option.none());
      var combine = function combine(cell) {
        if (position.get().isNone()) position.set(Option.some(cell));
        return function () {
          var raw = generators.cell({
            element: constant(cell),
            colspan: constant(1),
            rowspan: constant(1)
          });
          $_4ift9ombjk26xksz.remove(raw, 'width');
          $_4ift9ombjk26xksz.remove(cell, 'width');
          return raw;
        };
      };
      return {
        combine: combine,
        cursor: position.get
      };
    };
    var contract = exactly(['cell', 'row', 'replace', 'gap']);
    var $_3nsoa6nkjk26xl2s = {
      modification: modification,
      transform: transform,
      merging: merging
    };

    var blockList = ['body', 'p', 'div', 'article', 'aside', 'figcaption', 'figure', 'footer', 'header', 'nav', 'section', 'ol', 'ul', 'table', 'thead', 'tfoot', 'tbody', 'caption', 'tr', 'td', 'th', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'address'];
    var isList = function isList(universe, item) {
      var tagName = universe.property().name(item);
      return contains(['ol', 'ul'], tagName);
    };
    var isBlock = function isBlock(universe, item) {
      var tagName = universe.property().name(item);
      return contains(blockList, tagName);
    };
    var isFormatting = function isFormatting(universe, item) {
      var tagName = universe.property().name(item);
      return contains(['address', 'pre', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'], tagName);
    };
    var isHeading = function isHeading(universe, item) {
      var tagName = universe.property().name(item);
      return contains(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], tagName);
    };
    var isContainer = function isContainer(universe, item) {
      return contains(['div', 'li', 'td', 'th', 'blockquote', 'body', 'caption'], universe.property().name(item));
    };
    var isEmptyTag = function isEmptyTag(universe, item) {
      return contains(['br', 'img', 'hr', 'input'], universe.property().name(item));
    };
    var isFrame = function isFrame(universe, item) {
      return universe.property().name(item) === 'iframe';
    };
    var isInline = function isInline(universe, item) {
      return !(isBlock(universe, item) || isEmptyTag(universe, item)) && universe.property().name(item) !== 'li';
    };
    var $_9c48uinpjk26xl49 = {
      isBlock: isBlock,
      isList: isList,
      isFormatting: isFormatting,
      isHeading: isHeading,
      isContainer: isContainer,
      isEmptyTag: isEmptyTag,
      isFrame: isFrame,
      isInline: isInline
    };

    var universe$1 = DomUniverse();
    var isBlock$1 = function isBlock$1(element) {
      return $_9c48uinpjk26xl49.isBlock(universe$1, element);
    };
    var isList$1 = function isList$1(element) {
      return $_9c48uinpjk26xl49.isList(universe$1, element);
    };
    var isFormatting$1 = function isFormatting$1(element) {
      return $_9c48uinpjk26xl49.isFormatting(universe$1, element);
    };
    var isHeading$1 = function isHeading$1(element) {
      return $_9c48uinpjk26xl49.isHeading(universe$1, element);
    };
    var isContainer$1 = function isContainer$1(element) {
      return $_9c48uinpjk26xl49.isContainer(universe$1, element);
    };
    var isEmptyTag$1 = function isEmptyTag$1(element) {
      return $_9c48uinpjk26xl49.isEmptyTag(universe$1, element);
    };
    var isFrame$1 = function isFrame$1(element) {
      return $_9c48uinpjk26xl49.isFrame(universe$1, element);
    };
    var isInline$1 = function isInline$1(element) {
      return $_9c48uinpjk26xl49.isInline(universe$1, element);
    };
    var $_8rjnpznojk26xl46 = {
      isBlock: isBlock$1,
      isList: isList$1,
      isFormatting: isFormatting$1,
      isHeading: isHeading$1,
      isContainer: isContainer$1,
      isEmptyTag: isEmptyTag$1,
      isFrame: isFrame$1,
      isInline: isInline$1
    };

    var merge = function merge(cells) {
      var isBr = function isBr(el) {
        return $_89mq4qm3jk26xkrq.name(el) === 'br';
      };
      var advancedBr = function advancedBr(children) {
        return forall(children, function (c) {
          return isBr(c) || $_89mq4qm3jk26xkrq.isText(c) && $_2rujnemkjk26xkuu.get(c).trim().length === 0;
        });
      };
      var isListItem = function isListItem(el) {
        return $_89mq4qm3jk26xkrq.name(el) === 'li' || $_3kidmom8jk26xks9.ancestor(el, $_8rjnpznojk26xl46.isList).isSome();
      };
      var siblingIsBlock = function siblingIsBlock(el) {
        return $_4uy46mljjk26xkpk.nextSibling(el).map(function (rightSibling) {
          if ($_8rjnpznojk26xl46.isBlock(rightSibling)) return true;
          if ($_8rjnpznojk26xl46.isEmptyTag(rightSibling)) {
            return $_89mq4qm3jk26xkrq.name(rightSibling) === 'img' ? false : true;
          }
        }).getOr(false);
      };
      var markCell = function markCell(cell) {
        return $_bqyx5vmijk26xkun.last(cell).bind(function (rightEdge) {
          var rightSiblingIsBlock = siblingIsBlock(rightEdge);
          return $_4uy46mljjk26xkpk.parent(rightEdge).map(function (parent) {
            return rightSiblingIsBlock === true || isListItem(parent) || isBr(rightEdge) || $_8rjnpznojk26xl46.isBlock(parent) && !$_5m7qbqlljk26xkq3.eq(cell, parent) ? [] : [Element$$1.fromTag('br')];
          });
        }).getOr([]);
      };
      var markContent = function markContent() {
        var content = bind(cells, function (cell) {
          var children = $_4uy46mljjk26xkpk.children(cell);
          return advancedBr(children) ? [] : children.concat(markCell(cell));
        });
        return content.length === 0 ? [Element$$1.fromTag('br')] : content;
      };
      var contents = markContent();
      $_lmq2lmejk26xktg.empty(cells[0]);
      $_bsj3f1mfjk26xktj.append(cells[0], contents);
    };
    var $_8g5l2pnnjk26xl3h = { merge: merge };

    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var shallow$1 = function shallow$1(old, nu) {
      return nu;
    };
    var baseMerge = function baseMerge(merger) {
      return function () {
        var objects = new Array(arguments.length);
        for (var i = 0; i < objects.length; i++) {
          objects[i] = arguments[i];
        }if (objects.length === 0) throw new Error('Can\'t merge zero objects');
        var ret = {};
        for (var j = 0; j < objects.length; j++) {
          var curObject = objects[j];
          for (var key in curObject) {
            if (hasOwnProperty.call(curObject, key)) {
              ret[key] = merger(ret[key], curObject[key]);
            }
          }
        }
        return ret;
      };
    };

    var merge$1 = baseMerge(shallow$1);

    var cat = function cat(arr) {
      var r = [];
      var push = function push(x) {
        r.push(x);
      };
      for (var i = 0; i < arr.length; i++) {
        arr[i].each(push);
      }
      return r;
    };
    var findMap = function findMap(arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Option.none();
    };

    var addCell = function addCell(gridRow, index, cell) {
      var cells = gridRow.cells();
      var before = cells.slice(0, index);
      var after = cells.slice(index);
      var newCells = before.concat([cell]).concat(after);
      return setCells(gridRow, newCells);
    };
    var mutateCell = function mutateCell(gridRow, index, cell) {
      var cells = gridRow.cells();
      cells[index] = cell;
    };
    var setCells = function setCells(gridRow, cells) {
      return $_g9pyg7lcjk26xknq.rowcells(cells, gridRow.section());
    };
    var mapCells = function mapCells(gridRow, f) {
      var cells = gridRow.cells();
      var r = map(cells, f);
      return $_g9pyg7lcjk26xknq.rowcells(r, gridRow.section());
    };
    var getCell = function getCell(gridRow, index) {
      return gridRow.cells()[index];
    };
    var getCellElement = function getCellElement(gridRow, index) {
      return getCell(gridRow, index).element();
    };
    var cellLength = function cellLength(gridRow) {
      return gridRow.cells().length;
    };
    var $_f6p73xnvjk26xl5e = {
      addCell: addCell,
      setCells: setCells,
      mutateCell: mutateCell,
      getCell: getCell,
      getCellElement: getCellElement,
      mapCells: mapCells,
      cellLength: cellLength
    };

    var getColumn = function getColumn(grid, index) {
      return map(grid, function (row) {
        return $_f6p73xnvjk26xl5e.getCell(row, index);
      });
    };
    var getRow = function getRow(grid, index) {
      return grid[index];
    };
    var findDiff = function findDiff(xs, comp) {
      if (xs.length === 0) return 0;
      var first = xs[0];
      var index = findIndex(xs, function (x) {
        return !comp(first.element(), x.element());
      });
      return index.fold(function () {
        return xs.length;
      }, function (ind) {
        return ind;
      });
    };
    var subgrid = function subgrid(grid, row, column, comparator) {
      var restOfRow = getRow(grid, row).cells().slice(column);
      var endColIndex = findDiff(restOfRow, comparator);
      var restOfColumn = getColumn(grid, column).slice(row);
      var endRowIndex = findDiff(restOfColumn, comparator);
      return {
        colspan: constant(endColIndex),
        rowspan: constant(endRowIndex)
      };
    };
    var $_7l3mkenujk26xl59 = { subgrid: subgrid };

    var toDetails = function toDetails(grid, comparator) {
      var seen = map(grid, function (row, ri) {
        return map(row.cells(), function (col, ci) {
          return false;
        });
      });
      var updateSeen = function updateSeen(ri, ci, rowspan, colspan) {
        for (var r = ri; r < ri + rowspan; r++) {
          for (var c = ci; c < ci + colspan; c++) {
            seen[r][c] = true;
          }
        }
      };
      return map(grid, function (row, ri) {
        var details = bind(row.cells(), function (cell, ci) {
          if (seen[ri][ci] === false) {
            var result = $_7l3mkenujk26xl59.subgrid(grid, ri, ci, comparator);
            updateSeen(ri, ci, result.rowspan(), result.colspan());
            return [$_g9pyg7lcjk26xknq.detailnew(cell.element(), result.rowspan(), result.colspan(), cell.isNew())];
          } else {
            return [];
          }
        });
        return $_g9pyg7lcjk26xknq.rowdetails(details, row.section());
      });
    };
    var toGrid = function toGrid(warehouse, generators, isNew) {
      var grid = [];
      for (var i = 0; i < warehouse.grid().rows(); i++) {
        var rowCells = [];
        for (var j = 0; j < warehouse.grid().columns(); j++) {
          var element = $_7tsw5majk26xksp.getAt(warehouse, i, j).map(function (item) {
            return $_g9pyg7lcjk26xknq.elementnew(item.element(), isNew);
          }).getOrThunk(function () {
            return $_g9pyg7lcjk26xknq.elementnew(generators.gap(), true);
          });
          rowCells.push(element);
        }
        var row = $_g9pyg7lcjk26xknq.rowcells(rowCells, warehouse.all()[i].section());
        grid.push(row);
      }
      return grid;
    };
    var $_78zj4cntjk26xl4z = {
      toDetails: toDetails,
      toGrid: toGrid
    };

    var setIfNot = function setIfNot(element, property, value, ignore) {
      if (value === ignore) $_8icsmim2jk26xkrh.remove(element, property);else $_8icsmim2jk26xkrh.set(element, property, value);
    };
    var render = function render(table, grid) {
      var newRows = [];
      var newCells = [];
      var renderSection = function renderSection(gridSection, sectionName) {
        var section = $_at9vkhm7jk26xks8.child(table, sectionName).getOrThunk(function () {
          var tb = Element$$1.fromTag(sectionName, $_4uy46mljjk26xkpk.owner(table).dom());
          $_aao88dmdjk26xkte.append(table, tb);
          return tb;
        });
        $_lmq2lmejk26xktg.empty(section);
        var rows = map(gridSection, function (row) {
          if (row.isNew()) {
            newRows.push(row.element());
          }
          var tr = row.element();
          $_lmq2lmejk26xktg.empty(tr);
          each(row.cells(), function (cell) {
            if (cell.isNew()) {
              newCells.push(cell.element());
            }
            setIfNot(cell.element(), 'colspan', cell.colspan(), 1);
            setIfNot(cell.element(), 'rowspan', cell.rowspan(), 1);
            $_aao88dmdjk26xkte.append(tr, cell.element());
          });
          return tr;
        });
        $_bsj3f1mfjk26xktj.append(section, rows);
      };
      var removeSection = function removeSection(sectionName) {
        $_at9vkhm7jk26xks8.child(table, sectionName).each($_lmq2lmejk26xktg.remove);
      };
      var renderOrRemoveSection = function renderOrRemoveSection(gridSection, sectionName) {
        if (gridSection.length > 0) {
          renderSection(gridSection, sectionName);
        } else {
          removeSection(sectionName);
        }
      };
      var headSection = [];
      var bodySection = [];
      var footSection = [];
      each(grid, function (row) {
        switch (row.section()) {
          case 'thead':
            headSection.push(row);
            break;
          case 'tbody':
            bodySection.push(row);
            break;
          case 'tfoot':
            footSection.push(row);
            break;
        }
      });
      renderOrRemoveSection(headSection, 'thead');
      renderOrRemoveSection(bodySection, 'tbody');
      renderOrRemoveSection(footSection, 'tfoot');
      return {
        newRows: constant(newRows),
        newCells: constant(newCells)
      };
    };
    var copy$2 = function copy$2(grid) {
      var rows = map(grid, function (row) {
        var tr = $_e74daamhjk26xkuk.shallow(row.element());
        each(row.cells(), function (cell) {
          var clonedCell = $_e74daamhjk26xkuk.deep(cell.element());
          setIfNot(clonedCell, 'colspan', cell.colspan(), 1);
          setIfNot(clonedCell, 'rowspan', cell.rowspan(), 1);
          $_aao88dmdjk26xkte.append(tr, clonedCell);
        });
        return tr;
      });
      return rows;
    };
    var $_7f9qw8nwjk26xl5j = {
      render: render,
      copy: copy$2
    };

    var repeat = function repeat(repititions, f) {
      var r = [];
      for (var i = 0; i < repititions; i++) {
        r.push(f(i));
      }
      return r;
    };
    var range$1 = function range$1(start, end) {
      var r = [];
      for (var i = start; i < end; i++) {
        r.push(i);
      }
      return r;
    };
    var unique = function unique(xs, comparator) {
      var result = [];
      each(xs, function (x, i) {
        if (i < xs.length - 1 && !comparator(x, xs[i + 1])) {
          result.push(x);
        } else if (i === xs.length - 1) {
          result.push(x);
        }
      });
      return result;
    };
    var deduce = function deduce(xs, index) {
      if (index < 0 || index >= xs.length - 1) return Option.none();
      var current = xs[index].fold(function () {
        var rest = reverse(xs.slice(0, index));
        return findMap(rest, function (a, i) {
          return a.map(function (aa) {
            return {
              value: aa,
              delta: i + 1
            };
          });
        });
      }, function (c) {
        return Option.some({
          value: c,
          delta: 0
        });
      });
      var next = xs[index + 1].fold(function () {
        var rest = xs.slice(index + 1);
        return findMap(rest, function (a, i) {
          return a.map(function (aa) {
            return {
              value: aa,
              delta: i + 1
            };
          });
        });
      }, function (n) {
        return Option.some({
          value: n,
          delta: 1
        });
      });
      return current.bind(function (c) {
        return next.map(function (n) {
          var extras = n.delta + c.delta;
          return Math.abs(n.value - c.value) / extras;
        });
      });
    };
    var $_9bxdwanzjk26xl71 = {
      repeat: repeat,
      range: range$1,
      unique: unique,
      deduce: deduce
    };

    var columns = function columns(warehouse) {
      var grid = warehouse.grid();
      var cols = $_9bxdwanzjk26xl71.range(0, grid.columns());
      var rows = $_9bxdwanzjk26xl71.range(0, grid.rows());
      return map(cols, function (col) {
        var getBlock = function getBlock() {
          return bind(rows, function (r) {
            return $_7tsw5majk26xksp.getAt(warehouse, r, col).filter(function (detail) {
              return detail.column() === col;
            }).fold(constant([]), function (detail) {
              return [detail];
            });
          });
        };
        var isSingle = function isSingle(detail) {
          return detail.colspan() === 1;
        };
        var getFallback = function getFallback() {
          return $_7tsw5majk26xksp.getAt(warehouse, 0, col);
        };
        return decide(getBlock, isSingle, getFallback);
      });
    };
    var decide = function decide(getBlock, isSingle, getFallback) {
      var inBlock = getBlock();
      var singleInBlock = find(inBlock, isSingle);
      var detailOption = singleInBlock.orThunk(function () {
        return Option.from(inBlock[0]).orThunk(getFallback);
      });
      return detailOption.map(function (detail) {
        return detail.element();
      });
    };
    var rows$1 = function rows$1(warehouse) {
      var grid = warehouse.grid();
      var rows = $_9bxdwanzjk26xl71.range(0, grid.rows());
      var cols = $_9bxdwanzjk26xl71.range(0, grid.columns());
      return map(rows, function (row) {
        var getBlock = function getBlock() {
          return bind(cols, function (c) {
            return $_7tsw5majk26xksp.getAt(warehouse, row, c).filter(function (detail) {
              return detail.row() === row;
            }).fold(constant([]), function (detail) {
              return [detail];
            });
          });
        };
        var isSingle = function isSingle(detail) {
          return detail.rowspan() === 1;
        };
        var getFallback = function getFallback() {
          return $_7tsw5majk26xksp.getAt(warehouse, row, 0);
        };
        return decide(getBlock, isSingle, getFallback);
      });
    };
    var $_esl8p6nyjk26xl6p = {
      columns: columns,
      rows: rows$1
    };

    var col = function col(column, x, y, w, h) {
      var blocker = Element$$1.fromTag('div');
      $_4ift9ombjk26xksz.setAll(blocker, {
        position: 'absolute',
        left: x - w / 2 + 'px',
        top: y + 'px',
        height: h + 'px',
        width: w + 'px'
      });
      $_8icsmim2jk26xkrh.setAll(blocker, {
        'data-column': column,
        'role': 'presentation'
      });
      return blocker;
    };
    var row$1 = function row$1(row, x, y, w, h) {
      var blocker = Element$$1.fromTag('div');
      $_4ift9ombjk26xksz.setAll(blocker, {
        position: 'absolute',
        left: x + 'px',
        top: y - h / 2 + 'px',
        height: h + 'px',
        width: w + 'px'
      });
      $_8icsmim2jk26xkrh.setAll(blocker, {
        'data-row': row,
        'role': 'presentation'
      });
      return blocker;
    };
    var $_dr3i66o0jk26xl79 = {
      col: col,
      row: row$1
    };

    var css = function css(namespace) {
      var dashNamespace = namespace.replace(/\./g, '-');
      var resolve = function resolve(str) {
        return dashNamespace + '-' + str;
      };
      return { resolve: resolve };
    };

    var styles = css('ephox-snooker');
    var $_8c4u96o1jk26xl7h = { resolve: styles.resolve };

    function Toggler(turnOff, turnOn, initial) {
      var active = initial || false;
      var on = function on() {
        turnOn();
        active = true;
      };
      var off = function off() {
        turnOff();
        active = false;
      };
      var toggle = function toggle() {
        var f = active ? off : on;
        f();
      };
      var isOn = function isOn() {
        return active;
      };
      return {
        on: on,
        off: off,
        toggle: toggle,
        isOn: isOn
      };
    }

    var read = function read(element, attr) {
      var value = $_8icsmim2jk26xkrh.get(element, attr);
      return value === undefined || value === '' ? [] : value.split(' ');
    };
    var add = function add(element, attr, id) {
      var old = read(element, attr);
      var nu = old.concat([id]);
      $_8icsmim2jk26xkrh.set(element, attr, nu.join(' '));
      return true;
    };
    var remove$3 = function remove$3(element, attr, id) {
      var nu = filter(read(element, attr), function (v) {
        return v !== id;
      });
      if (nu.length > 0) $_8icsmim2jk26xkrh.set(element, attr, nu.join(' '));else $_8icsmim2jk26xkrh.remove(element, attr);
      return false;
    };
    var $_67isdeo6jk26xl7s = {
      read: read,
      add: add,
      remove: remove$3
    };

    var supports = function supports(element) {
      return element.dom().classList !== undefined;
    };
    var get$6 = function get$6(element) {
      return $_67isdeo6jk26xl7s.read(element, 'class');
    };
    var add$1 = function add$1(element, clazz) {
      return $_67isdeo6jk26xl7s.add(element, 'class', clazz);
    };
    var remove$4 = function remove$4(element, clazz) {
      return $_67isdeo6jk26xl7s.remove(element, 'class', clazz);
    };
    var toggle = function toggle(element, clazz) {
      if (contains(get$6(element), clazz)) {
        return remove$4(element, clazz);
      } else {
        return add$1(element, clazz);
      }
    };
    var $_1dpcrko5jk26xl7o = {
      get: get$6,
      add: add$1,
      remove: remove$4,
      toggle: toggle,
      supports: supports
    };

    var add$2 = function add$2(element, clazz) {
      if ($_1dpcrko5jk26xl7o.supports(element)) element.dom().classList.add(clazz);else $_1dpcrko5jk26xl7o.add(element, clazz);
    };
    var cleanClass = function cleanClass(element) {
      var classList = $_1dpcrko5jk26xl7o.supports(element) ? element.dom().classList : $_1dpcrko5jk26xl7o.get(element);
      if (classList.length === 0) {
        $_8icsmim2jk26xkrh.remove(element, 'class');
      }
    };
    var remove$5 = function remove$5(element, clazz) {
      if ($_1dpcrko5jk26xl7o.supports(element)) {
        var classList = element.dom().classList;
        classList.remove(clazz);
      } else $_1dpcrko5jk26xl7o.remove(element, clazz);
      cleanClass(element);
    };
    var toggle$1 = function toggle$1(element, clazz) {
      return $_1dpcrko5jk26xl7o.supports(element) ? element.dom().classList.toggle(clazz) : $_1dpcrko5jk26xl7o.toggle(element, clazz);
    };
    var toggler = function toggler(element, clazz) {
      var hasClasslist = $_1dpcrko5jk26xl7o.supports(element);
      var classList = element.dom().classList;
      var off = function off() {
        if (hasClasslist) classList.remove(clazz);else $_1dpcrko5jk26xl7o.remove(element, clazz);
      };
      var on = function on() {
        if (hasClasslist) classList.add(clazz);else $_1dpcrko5jk26xl7o.add(element, clazz);
      };
      return Toggler(off, on, has$1(element, clazz));
    };
    var has$1 = function has$1(element, clazz) {
      return $_1dpcrko5jk26xl7o.supports(element) && element.dom().classList.contains(clazz);
    };
    var $_6e2uko3jk26xl7l = {
      add: add$2,
      remove: remove$5,
      toggle: toggle$1,
      toggler: toggler,
      has: has$1
    };

    var resizeBar = $_8c4u96o1jk26xl7h.resolve('resizer-bar');
    var resizeRowBar = $_8c4u96o1jk26xl7h.resolve('resizer-rows');
    var resizeColBar = $_8c4u96o1jk26xl7h.resolve('resizer-cols');
    var BAR_THICKNESS = 7;
    var clear = function clear(wire) {
      var previous = $_bkrvmvm4jk26xkrt.descendants(wire.parent(), '.' + resizeBar);
      each(previous, $_lmq2lmejk26xktg.remove);
    };
    var drawBar = function drawBar(wire, positions, create) {
      var origin = wire.origin();
      each(positions, function (cpOption, i) {
        cpOption.each(function (cp) {
          var bar = create(origin, cp);
          $_6e2uko3jk26xl7l.add(bar, resizeBar);
          $_aao88dmdjk26xkte.append(wire.parent(), bar);
        });
      });
    };
    var refreshCol = function refreshCol(wire, colPositions, position, tableHeight) {
      drawBar(wire, colPositions, function (origin, cp) {
        var colBar = $_dr3i66o0jk26xl79.col(cp.col(), cp.x() - origin.left(), position.top() - origin.top(), BAR_THICKNESS, tableHeight);
        $_6e2uko3jk26xl7l.add(colBar, resizeColBar);
        return colBar;
      });
    };
    var refreshRow = function refreshRow(wire, rowPositions, position, tableWidth) {
      drawBar(wire, rowPositions, function (origin, cp) {
        var rowBar = $_dr3i66o0jk26xl79.row(cp.row(), position.left() - origin.left(), cp.y() - origin.top(), tableWidth, BAR_THICKNESS);
        $_6e2uko3jk26xl7l.add(rowBar, resizeRowBar);
        return rowBar;
      });
    };
    var refreshGrid = function refreshGrid(wire, table, rows, cols, hdirection, vdirection) {
      var position = $_f7fwegnfjk26xl1w.absolute(table);
      var rowPositions = rows.length > 0 ? hdirection.positions(rows, table) : [];
      refreshRow(wire, rowPositions, position, $_736uoenbjk26xl19.getOuter(table));
      var colPositions = cols.length > 0 ? vdirection.positions(cols, table) : [];
      refreshCol(wire, colPositions, position, $_60e1qun9jk26xl11.getOuter(table));
    };
    var refresh = function refresh(wire, table, hdirection, vdirection) {
      clear(wire);
      var list = $_aihceulbjk26xkng.fromTable(table);
      var warehouse = $_7tsw5majk26xksp.generate(list);
      var rows = $_esl8p6nyjk26xl6p.rows(warehouse);
      var cols = $_esl8p6nyjk26xl6p.columns(warehouse);
      refreshGrid(wire, table, rows, cols, hdirection, vdirection);
    };
    var each$2 = function each$2(wire, f) {
      var bars = $_bkrvmvm4jk26xkrt.descendants(wire.parent(), '.' + resizeBar);
      each(bars, f);
    };
    var hide = function hide(wire) {
      each$2(wire, function (bar) {
        $_4ift9ombjk26xksz.set(bar, 'display', 'none');
      });
    };
    var show = function show(wire) {
      each$2(wire, function (bar) {
        $_4ift9ombjk26xksz.set(bar, 'display', 'block');
      });
    };
    var isRowBar = function isRowBar(element) {
      return $_6e2uko3jk26xl7l.has(element, resizeRowBar);
    };
    var isColBar = function isColBar(element) {
      return $_6e2uko3jk26xl7l.has(element, resizeColBar);
    };
    var $_6p8wqgnxjk26xl66 = {
      refresh: refresh,
      hide: hide,
      show: show,
      destroy: clear,
      isRowBar: isRowBar,
      isColBar: isColBar
    };

    var fromWarehouse = function fromWarehouse(warehouse, generators) {
      return $_78zj4cntjk26xl4z.toGrid(warehouse, generators, false);
    };
    var deriveRows = function deriveRows(rendered, generators) {
      var findRow = function findRow(details) {
        var rowOfCells = findMap(details, function (detail) {
          return $_4uy46mljjk26xkpk.parent(detail.element()).map(function (row) {
            var isNew = $_4uy46mljjk26xkpk.parent(row).isNone();
            return $_g9pyg7lcjk26xknq.elementnew(row, isNew);
          });
        });
        return rowOfCells.getOrThunk(function () {
          return $_g9pyg7lcjk26xknq.elementnew(generators.row(), true);
        });
      };
      return map(rendered, function (details) {
        var row = findRow(details.details());
        return $_g9pyg7lcjk26xknq.rowdatanew(row.element(), details.details(), details.section(), row.isNew());
      });
    };
    var toDetailList = function toDetailList(grid, generators) {
      var rendered = $_78zj4cntjk26xl4z.toDetails(grid, $_5m7qbqlljk26xkq3.eq);
      return deriveRows(rendered, generators);
    };
    var findInWarehouse = function findInWarehouse(warehouse, element) {
      var all = flatten(map(warehouse.all(), function (r) {
        return r.cells();
      }));
      return find(all, function (e) {
        return $_5m7qbqlljk26xkq3.eq(element, e.element());
      });
    };
    var run = function run(operation, extract, adjustment, postAction, genWrappers) {
      return function (wire, table, target, generators, direction) {
        var input = $_aihceulbjk26xkng.fromTable(table);
        var warehouse = $_7tsw5majk26xksp.generate(input);
        var output = extract(warehouse, target).map(function (info) {
          var model = fromWarehouse(warehouse, generators);
          var result = operation(model, info, $_5m7qbqlljk26xkq3.eq, genWrappers(generators));
          var grid = toDetailList(result.grid(), generators);
          return {
            grid: constant(grid),
            cursor: result.cursor
          };
        });
        return output.fold(function () {
          return Option.none();
        }, function (out) {
          var newElements = $_7f9qw8nwjk26xl5j.render(table, out.grid());
          adjustment(table, out.grid(), direction);
          postAction(table);
          $_6p8wqgnxjk26xl66.refresh(wire, table, $_eofvgnejk26xl1e.height, direction);
          return Option.some({
            cursor: out.cursor,
            newRows: newElements.newRows,
            newCells: newElements.newCells
          });
        });
      };
    };
    var onCell = function onCell(warehouse, target) {
      return $_3gdghfldjk26xknu.cell(target.element()).bind(function (cell) {
        return findInWarehouse(warehouse, cell);
      });
    };
    var onPaste = function onPaste(warehouse, target) {
      return $_3gdghfldjk26xknu.cell(target.element()).bind(function (cell) {
        return findInWarehouse(warehouse, cell).map(function (details) {
          return merge$1(details, {
            generators: target.generators,
            clipboard: target.clipboard
          });
        });
      });
    };
    var onPasteRows = function onPasteRows(warehouse, target) {
      var details = map(target.selection(), function (cell) {
        return $_3gdghfldjk26xknu.cell(cell).bind(function (lc) {
          return findInWarehouse(warehouse, lc);
        });
      });
      var cells = cat(details);
      return cells.length > 0 ? Option.some(merge$1({ cells: cells }, {
        generators: target.generators,
        clipboard: target.clipboard
      })) : Option.none();
    };
    var onMergable = function onMergable(warehouse, target) {
      return target.mergable();
    };
    var onUnmergable = function onUnmergable(warehouse, target) {
      return target.unmergable();
    };
    var onCells = function onCells(warehouse, target) {
      var details = map(target.selection(), function (cell) {
        return $_3gdghfldjk26xknu.cell(cell).bind(function (lc) {
          return findInWarehouse(warehouse, lc);
        });
      });
      var cells = cat(details);
      return cells.length > 0 ? Option.some(cells) : Option.none();
    };
    var $_5kge3mnqjk26xl4f = {
      run: run,
      toDetailList: toDetailList,
      onCell: onCell,
      onCells: onCells,
      onPaste: onPaste,
      onPasteRows: onPasteRows,
      onMergable: onMergable,
      onUnmergable: onUnmergable
    };

    var value$1 = function value$1(o) {
      var is = function is(v) {
        return o === v;
      };
      var or = function or(opt) {
        return value$1(o);
      };
      var orThunk = function orThunk(f) {
        return value$1(o);
      };
      var map = function map(f) {
        return value$1(f(o));
      };
      var each = function each(f) {
        f(o);
      };
      var bind = function bind(f) {
        return f(o);
      };
      var fold = function fold(_, onValue) {
        return onValue(o);
      };
      var exists = function exists(f) {
        return f(o);
      };
      var forall = function forall(f) {
        return f(o);
      };
      var toOption = function toOption() {
        return Option.some(o);
      };
      return {
        is: is,
        isValue: always,
        isError: never,
        getOr: constant(o),
        getOrThunk: constant(o),
        getOrDie: constant(o),
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        each: each,
        bind: bind,
        exists: exists,
        forall: forall,
        toOption: toOption
      };
    };
    var error = function error(message) {
      var getOrThunk = function getOrThunk(f) {
        return f();
      };
      var getOrDie = function getOrDie() {
        return die(String(message))();
      };
      var or = function or(opt) {
        return opt;
      };
      var orThunk = function orThunk(f) {
        return f();
      };
      var map = function map(f) {
        return error(message);
      };
      var bind = function bind(f) {
        return error(message);
      };
      var fold = function fold(onError, _) {
        return onError(message);
      };
      return {
        is: never,
        isValue: never,
        isError: always,
        getOr: identity,
        getOrThunk: getOrThunk,
        getOrDie: getOrDie,
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        each: noop,
        bind: bind,
        exists: never,
        forall: always,
        toOption: Option.none
      };
    };
    var Result = {
      value: value$1,
      error: error
    };

    var measure = function measure(startAddress, gridA, gridB) {
      if (startAddress.row() >= gridA.length || startAddress.column() > $_f6p73xnvjk26xl5e.cellLength(gridA[0])) return Result.error('invalid start address out of table bounds, row: ' + startAddress.row() + ', column: ' + startAddress.column());
      var rowRemainder = gridA.slice(startAddress.row());
      var colRemainder = rowRemainder[0].cells().slice(startAddress.column());
      var colRequired = $_f6p73xnvjk26xl5e.cellLength(gridB[0]);
      var rowRequired = gridB.length;
      return Result.value({
        rowDelta: constant(rowRemainder.length - rowRequired),
        colDelta: constant(colRemainder.length - colRequired)
      });
    };
    var measureWidth = function measureWidth(gridA, gridB) {
      var colLengthA = $_f6p73xnvjk26xl5e.cellLength(gridA[0]);
      var colLengthB = $_f6p73xnvjk26xl5e.cellLength(gridB[0]);
      return {
        rowDelta: constant(0),
        colDelta: constant(colLengthA - colLengthB)
      };
    };
    var fill = function fill(cells, generator) {
      return map(cells, function () {
        return $_g9pyg7lcjk26xknq.elementnew(generator.cell(), true);
      });
    };
    var rowFill = function rowFill(grid, amount, generator) {
      return grid.concat($_9bxdwanzjk26xl71.repeat(amount, function (_row) {
        return $_f6p73xnvjk26xl5e.setCells(grid[grid.length - 1], fill(grid[grid.length - 1].cells(), generator));
      }));
    };
    var colFill = function colFill(grid, amount, generator) {
      return map(grid, function (row) {
        return $_f6p73xnvjk26xl5e.setCells(row, row.cells().concat(fill($_9bxdwanzjk26xl71.range(0, amount), generator)));
      });
    };
    var tailor = function tailor(gridA, delta, generator) {
      var fillCols = delta.colDelta() < 0 ? colFill : identity;
      var fillRows = delta.rowDelta() < 0 ? rowFill : identity;
      var modifiedCols = fillCols(gridA, Math.abs(delta.colDelta()), generator);
      var tailoredGrid = fillRows(modifiedCols, Math.abs(delta.rowDelta()), generator);
      return tailoredGrid;
    };
    var $_8sgdubo8jk26xl82 = {
      measure: measure,
      measureWidth: measureWidth,
      tailor: tailor
    };

    var merge$2 = function merge$2(grid, bounds, comparator, substitution) {
      if (grid.length === 0) return grid;
      for (var i = bounds.startRow(); i <= bounds.finishRow(); i++) {
        for (var j = bounds.startCol(); j <= bounds.finishCol(); j++) {
          $_f6p73xnvjk26xl5e.mutateCell(grid[i], j, $_g9pyg7lcjk26xknq.elementnew(substitution(), false));
        }
      }
      return grid;
    };
    var unmerge = function unmerge(grid, target, comparator, substitution) {
      var first = true;
      for (var i = 0; i < grid.length; i++) {
        for (var j = 0; j < $_f6p73xnvjk26xl5e.cellLength(grid[0]); j++) {
          var current = $_f6p73xnvjk26xl5e.getCellElement(grid[i], j);
          var isToReplace = comparator(current, target);
          if (isToReplace === true && first === false) {
            $_f6p73xnvjk26xl5e.mutateCell(grid[i], j, $_g9pyg7lcjk26xknq.elementnew(substitution(), true));
          } else if (isToReplace === true) {
            first = false;
          }
        }
      }
      return grid;
    };
    var uniqueCells = function uniqueCells(row, comparator) {
      return foldl(row, function (rest, cell) {
        return exists(rest, function (currentCell) {
          return comparator(currentCell.element(), cell.element());
        }) ? rest : rest.concat([cell]);
      }, []);
    };
    var splitRows = function splitRows(grid, index, comparator, substitution) {
      if (index > 0 && index < grid.length) {
        var rowPrevCells = grid[index - 1].cells();
        var cells = uniqueCells(rowPrevCells, comparator);
        each(cells, function (cell) {
          var replacement = Option.none();
          for (var i = index; i < grid.length; i++) {
            for (var j = 0; j < $_f6p73xnvjk26xl5e.cellLength(grid[0]); j++) {
              var current = grid[i].cells()[j];
              var isToReplace = comparator(current.element(), cell.element());
              if (isToReplace) {
                if (replacement.isNone()) {
                  replacement = Option.some(substitution());
                }
                replacement.each(function (sub) {
                  $_f6p73xnvjk26xl5e.mutateCell(grid[i], j, $_g9pyg7lcjk26xknq.elementnew(sub, true));
                });
              }
            }
          }
        });
      }
      return grid;
    };
    var $_e7r5bgoajk26xl8d = {
      merge: merge$2,
      unmerge: unmerge,
      splitRows: splitRows
    };

    var isSpanning = function isSpanning(grid, row, col, comparator) {
      var candidate = $_f6p73xnvjk26xl5e.getCell(grid[row], col);
      var matching = curry(comparator, candidate.element());
      var currentRow = grid[row];
      return grid.length > 1 && $_f6p73xnvjk26xl5e.cellLength(currentRow) > 1 && (col > 0 && matching($_f6p73xnvjk26xl5e.getCellElement(currentRow, col - 1)) || col < currentRow.length - 1 && matching($_f6p73xnvjk26xl5e.getCellElement(currentRow, col + 1)) || row > 0 && matching($_f6p73xnvjk26xl5e.getCellElement(grid[row - 1], col)) || row < grid.length - 1 && matching($_f6p73xnvjk26xl5e.getCellElement(grid[row + 1], col)));
    };
    var mergeTables = function mergeTables(startAddress, gridA, gridB, generator, comparator) {
      var startRow = startAddress.row();
      var startCol = startAddress.column();
      var mergeHeight = gridB.length;
      var mergeWidth = $_f6p73xnvjk26xl5e.cellLength(gridB[0]);
      var endRow = startRow + mergeHeight;
      var endCol = startCol + mergeWidth;
      for (var r = startRow; r < endRow; r++) {
        for (var c = startCol; c < endCol; c++) {
          if (isSpanning(gridA, r, c, comparator)) {
            $_e7r5bgoajk26xl8d.unmerge(gridA, $_f6p73xnvjk26xl5e.getCellElement(gridA[r], c), comparator, generator.cell);
          }
          var newCell = $_f6p73xnvjk26xl5e.getCellElement(gridB[r - startRow], c - startCol);
          var replacement = generator.replace(newCell);
          $_f6p73xnvjk26xl5e.mutateCell(gridA[r], c, $_g9pyg7lcjk26xknq.elementnew(replacement, true));
        }
      }
      return gridA;
    };
    var merge$3 = function merge$3(startAddress, gridA, gridB, generator, comparator) {
      var result = $_8sgdubo8jk26xl82.measure(startAddress, gridA, gridB);
      return result.map(function (delta) {
        var fittedGrid = $_8sgdubo8jk26xl82.tailor(gridA, delta, generator);
        return mergeTables(startAddress, fittedGrid, gridB, generator, comparator);
      });
    };
    var insert = function insert(index, gridA, gridB, generator, comparator) {
      $_e7r5bgoajk26xl8d.splitRows(gridA, index, comparator, generator.cell);
      var delta = $_8sgdubo8jk26xl82.measureWidth(gridB, gridA);
      var fittedNewGrid = $_8sgdubo8jk26xl82.tailor(gridB, delta, generator);
      var secondDelta = $_8sgdubo8jk26xl82.measureWidth(gridA, fittedNewGrid);
      var fittedOldGrid = $_8sgdubo8jk26xl82.tailor(gridA, secondDelta, generator);
      return fittedOldGrid.slice(0, index).concat(fittedNewGrid).concat(fittedOldGrid.slice(index, fittedOldGrid.length));
    };
    var $_4zzecpo7jk26xl7w = {
      merge: merge$3,
      insert: insert
    };

    var insertRowAt = function insertRowAt(grid, index, example, comparator, substitution) {
      var before = grid.slice(0, index);
      var after = grid.slice(index);
      var between = $_f6p73xnvjk26xl5e.mapCells(grid[example], function (ex, c) {
        var withinSpan = index > 0 && index < grid.length && comparator($_f6p73xnvjk26xl5e.getCellElement(grid[index - 1], c), $_f6p73xnvjk26xl5e.getCellElement(grid[index], c));
        var ret = withinSpan ? $_f6p73xnvjk26xl5e.getCell(grid[index], c) : $_g9pyg7lcjk26xknq.elementnew(substitution(ex.element(), comparator), true);
        return ret;
      });
      return before.concat([between]).concat(after);
    };
    var insertColumnAt = function insertColumnAt(grid, index, example, comparator, substitution) {
      return map(grid, function (row) {
        var withinSpan = index > 0 && index < $_f6p73xnvjk26xl5e.cellLength(row) && comparator($_f6p73xnvjk26xl5e.getCellElement(row, index - 1), $_f6p73xnvjk26xl5e.getCellElement(row, index));
        var sub = withinSpan ? $_f6p73xnvjk26xl5e.getCell(row, index) : $_g9pyg7lcjk26xknq.elementnew(substitution($_f6p73xnvjk26xl5e.getCellElement(row, example), comparator), true);
        return $_f6p73xnvjk26xl5e.addCell(row, index, sub);
      });
    };
    var splitCellIntoColumns = function splitCellIntoColumns(grid, exampleRow, exampleCol, comparator, substitution) {
      var index = exampleCol + 1;
      return map(grid, function (row, i) {
        var isTargetCell = i === exampleRow;
        var sub = isTargetCell ? $_g9pyg7lcjk26xknq.elementnew(substitution($_f6p73xnvjk26xl5e.getCellElement(row, exampleCol), comparator), true) : $_f6p73xnvjk26xl5e.getCell(row, exampleCol);
        return $_f6p73xnvjk26xl5e.addCell(row, index, sub);
      });
    };
    var splitCellIntoRows = function splitCellIntoRows(grid, exampleRow, exampleCol, comparator, substitution) {
      var index = exampleRow + 1;
      var before = grid.slice(0, index);
      var after = grid.slice(index);
      var between = $_f6p73xnvjk26xl5e.mapCells(grid[exampleRow], function (ex, i) {
        var isTargetCell = i === exampleCol;
        return isTargetCell ? $_g9pyg7lcjk26xknq.elementnew(substitution(ex.element(), comparator), true) : ex;
      });
      return before.concat([between]).concat(after);
    };
    var deleteColumnsAt = function deleteColumnsAt(grid, start, finish) {
      var rows = map(grid, function (row) {
        var cells = row.cells().slice(0, start).concat(row.cells().slice(finish + 1));
        return $_g9pyg7lcjk26xknq.rowcells(cells, row.section());
      });
      return filter(rows, function (row) {
        return row.cells().length > 0;
      });
    };
    var deleteRowsAt = function deleteRowsAt(grid, start, finish) {
      return grid.slice(0, start).concat(grid.slice(finish + 1));
    };
    var $_6i24mnobjk26xl8k = {
      insertRowAt: insertRowAt,
      insertColumnAt: insertColumnAt,
      splitCellIntoColumns: splitCellIntoColumns,
      splitCellIntoRows: splitCellIntoRows,
      deleteRowsAt: deleteRowsAt,
      deleteColumnsAt: deleteColumnsAt
    };

    var replaceIn = function replaceIn(grid, targets, comparator, substitution) {
      var isTarget = function isTarget(cell) {
        return exists(targets, function (target) {
          return comparator(cell.element(), target.element());
        });
      };
      return map(grid, function (row) {
        return $_f6p73xnvjk26xl5e.mapCells(row, function (cell) {
          return isTarget(cell) ? $_g9pyg7lcjk26xknq.elementnew(substitution(cell.element(), comparator), true) : cell;
        });
      });
    };
    var notStartRow = function notStartRow(grid, rowIndex, colIndex, comparator) {
      return $_f6p73xnvjk26xl5e.getCellElement(grid[rowIndex], colIndex) !== undefined && rowIndex > 0 && comparator($_f6p73xnvjk26xl5e.getCellElement(grid[rowIndex - 1], colIndex), $_f6p73xnvjk26xl5e.getCellElement(grid[rowIndex], colIndex));
    };
    var notStartColumn = function notStartColumn(row, index, comparator) {
      return index > 0 && comparator($_f6p73xnvjk26xl5e.getCellElement(row, index - 1), $_f6p73xnvjk26xl5e.getCellElement(row, index));
    };
    var replaceColumn = function replaceColumn(grid, index, comparator, substitution) {
      var targets = bind(grid, function (row, i) {
        var alreadyAdded = notStartRow(grid, i, index, comparator) || notStartColumn(row, index, comparator);
        return alreadyAdded ? [] : [$_f6p73xnvjk26xl5e.getCell(row, index)];
      });
      return replaceIn(grid, targets, comparator, substitution);
    };
    var replaceRow = function replaceRow(grid, index, comparator, substitution) {
      var targetRow = grid[index];
      var targets = bind(targetRow.cells(), function (item, i) {
        var alreadyAdded = notStartRow(grid, index, i, comparator) || notStartColumn(targetRow, i, comparator);
        return alreadyAdded ? [] : [item];
      });
      return replaceIn(grid, targets, comparator, substitution);
    };
    var $_3uegeocjk26xl8p = {
      replaceColumn: replaceColumn,
      replaceRow: replaceRow
    };

    var none$1 = function none$1() {
      return folder(function (n, o, l, m, r) {
        return n();
      });
    };
    var only = function only(index) {
      return folder(function (n, o, l, m, r) {
        return o(index);
      });
    };
    var left = function left(index, next) {
      return folder(function (n, o, l, m, r) {
        return l(index, next);
      });
    };
    var middle = function middle(prev, index, next) {
      return folder(function (n, o, l, m, r) {
        return m(prev, index, next);
      });
    };
    var right = function right(prev, index) {
      return folder(function (n, o, l, m, r) {
        return r(prev, index);
      });
    };
    var folder = function folder(fold) {
      return { fold: fold };
    };
    var $_6q6vpbofjk26xl9a = {
      none: none$1,
      only: only,
      left: left,
      middle: middle,
      right: right
    };

    var neighbours$1 = function neighbours$1(input, index) {
      if (input.length === 0) return $_6q6vpbofjk26xl9a.none();
      if (input.length === 1) return $_6q6vpbofjk26xl9a.only(0);
      if (index === 0) return $_6q6vpbofjk26xl9a.left(0, 1);
      if (index === input.length - 1) return $_6q6vpbofjk26xl9a.right(index - 1, index);
      if (index > 0 && index < input.length - 1) return $_6q6vpbofjk26xl9a.middle(index - 1, index, index + 1);
      return $_6q6vpbofjk26xl9a.none();
    };
    var determine = function determine(input, column, step, tableSize) {
      var result = input.slice(0);
      var context = neighbours$1(input, column);
      var zero = function zero(array) {
        return map(array, constant(0));
      };
      var onNone = constant(zero(result));
      var onOnly = function onOnly(index) {
        return tableSize.singleColumnWidth(result[index], step);
      };
      var onChange = function onChange(index, next) {
        if (step >= 0) {
          var newNext = Math.max(tableSize.minCellWidth(), result[next] - step);
          return zero(result.slice(0, index)).concat([step, newNext - result[next]]).concat(zero(result.slice(next + 1)));
        } else {
          var newThis = Math.max(tableSize.minCellWidth(), result[index] + step);
          var diffx = result[index] - newThis;
          return zero(result.slice(0, index)).concat([newThis - result[index], diffx]).concat(zero(result.slice(next + 1)));
        }
      };
      var onLeft = onChange;
      var onMiddle = function onMiddle(prev, index, next) {
        return onChange(index, next);
      };
      var onRight = function onRight(prev, index) {
        if (step >= 0) {
          return zero(result.slice(0, index)).concat([step]);
        } else {
          var size = Math.max(tableSize.minCellWidth(), result[index] + step);
          return zero(result.slice(0, index)).concat([size - result[index]]);
        }
      };
      return context.fold(onNone, onOnly, onLeft, onMiddle, onRight);
    };
    var $_2tee85oejk26xl94 = { determine: determine };

    var getSpan$1 = function getSpan$1(cell, type) {
      return $_8icsmim2jk26xkrh.has(cell, type) && parseInt($_8icsmim2jk26xkrh.get(cell, type), 10) > 1;
    };
    var hasColspan = function hasColspan(cell) {
      return getSpan$1(cell, 'colspan');
    };
    var hasRowspan = function hasRowspan(cell) {
      return getSpan$1(cell, 'rowspan');
    };
    var getInt = function getInt(element, property) {
      return parseInt($_4ift9ombjk26xksz.get(element, property), 10);
    };
    var $_8rs5cuohjk26xl9k = {
      hasColspan: hasColspan,
      hasRowspan: hasRowspan,
      minWidth: constant(10),
      minHeight: constant(10),
      getInt: getInt
    };

    var getRaw$1 = function getRaw$1(cell, property, getter) {
      return $_4ift9ombjk26xksz.getRaw(cell, property).fold(function () {
        return getter(cell) + 'px';
      }, function (raw) {
        return raw;
      });
    };
    var getRawW = function getRawW(cell) {
      return getRaw$1(cell, 'width', $_4khph0n7jk26xl09.getPixelWidth);
    };
    var getRawH = function getRawH(cell) {
      return getRaw$1(cell, 'height', $_4khph0n7jk26xl09.getHeight);
    };
    var getWidthFrom = function getWidthFrom(warehouse, direction, getWidth, fallback, tableSize) {
      var columns = $_esl8p6nyjk26xl6p.columns(warehouse);
      var backups = map(columns, function (cellOption) {
        return cellOption.map(direction.edge);
      });
      return map(columns, function (cellOption, c) {
        var columnCell = cellOption.filter(not($_8rs5cuohjk26xl9k.hasColspan));
        return columnCell.fold(function () {
          var deduced = $_9bxdwanzjk26xl71.deduce(backups, c);
          return fallback(deduced);
        }, function (cell) {
          return getWidth(cell, tableSize);
        });
      });
    };
    var getDeduced = function getDeduced(deduced) {
      return deduced.map(function (d) {
        return d + 'px';
      }).getOr('');
    };
    var getRawWidths = function getRawWidths(warehouse, direction) {
      return getWidthFrom(warehouse, direction, getRawW, getDeduced);
    };
    var getPercentageWidths = function getPercentageWidths(warehouse, direction, tableSize) {
      return getWidthFrom(warehouse, direction, $_4khph0n7jk26xl09.getPercentageWidth, function (deduced) {
        return deduced.fold(function () {
          return tableSize.minCellWidth();
        }, function (cellWidth) {
          return cellWidth / tableSize.pixelWidth() * 100;
        });
      }, tableSize);
    };
    var getPixelWidths = function getPixelWidths(warehouse, direction, tableSize) {
      return getWidthFrom(warehouse, direction, $_4khph0n7jk26xl09.getPixelWidth, function (deduced) {
        return deduced.getOrThunk(tableSize.minCellWidth);
      }, tableSize);
    };
    var getHeightFrom = function getHeightFrom(warehouse, direction, getHeight, fallback) {
      var rows = $_esl8p6nyjk26xl6p.rows(warehouse);
      var backups = map(rows, function (cellOption) {
        return cellOption.map(direction.edge);
      });
      return map(rows, function (cellOption, c) {
        var rowCell = cellOption.filter(not($_8rs5cuohjk26xl9k.hasRowspan));
        return rowCell.fold(function () {
          var deduced = $_9bxdwanzjk26xl71.deduce(backups, c);
          return fallback(deduced);
        }, function (cell) {
          return getHeight(cell);
        });
      });
    };
    var getPixelHeights = function getPixelHeights(warehouse, direction) {
      return getHeightFrom(warehouse, direction, $_4khph0n7jk26xl09.getHeight, function (deduced) {
        return deduced.getOrThunk($_8rs5cuohjk26xl9k.minHeight);
      });
    };
    var getRawHeights = function getRawHeights(warehouse, direction) {
      return getHeightFrom(warehouse, direction, getRawH, getDeduced);
    };
    var $_8ra6ologjk26xl9c = {
      getRawWidths: getRawWidths,
      getPixelWidths: getPixelWidths,
      getPercentageWidths: getPercentageWidths,
      getPixelHeights: getPixelHeights,
      getRawHeights: getRawHeights
    };

    var total = function total(start, end, measures) {
      var r = 0;
      for (var i = start; i < end; i++) {
        r += measures[i] !== undefined ? measures[i] : 0;
      }
      return r;
    };
    var recalculateWidth = function recalculateWidth(warehouse, widths) {
      var all = $_7tsw5majk26xksp.justCells(warehouse);
      return map(all, function (cell) {
        var width = total(cell.column(), cell.column() + cell.colspan(), widths);
        return {
          element: cell.element,
          width: constant(width),
          colspan: cell.colspan
        };
      });
    };
    var recalculateHeight = function recalculateHeight(warehouse, heights) {
      var all = $_7tsw5majk26xksp.justCells(warehouse);
      return map(all, function (cell) {
        var height = total(cell.row(), cell.row() + cell.rowspan(), heights);
        return {
          element: cell.element,
          height: constant(height),
          rowspan: cell.rowspan
        };
      });
    };
    var matchRowHeight = function matchRowHeight(warehouse, heights) {
      return map(warehouse.all(), function (row, i) {
        return {
          element: row.element,
          height: constant(heights[i])
        };
      });
    };
    var $_2f7ioroijk26xl9s = {
      recalculateWidth: recalculateWidth,
      recalculateHeight: recalculateHeight,
      matchRowHeight: matchRowHeight
    };

    var percentageSize = function percentageSize(width, element) {
      var floatWidth = parseFloat(width);
      var pixelWidth = $_736uoenbjk26xl19.get(element);
      var getCellDelta = function getCellDelta(delta) {
        return delta / pixelWidth * 100;
      };
      var singleColumnWidth = function singleColumnWidth(width, _delta) {
        return [100 - width];
      };
      var minCellWidth = function minCellWidth() {
        return $_8rs5cuohjk26xl9k.minWidth() / pixelWidth * 100;
      };
      var setTableWidth = function setTableWidth(table, _newWidths, delta) {
        var total = floatWidth + delta;
        $_4khph0n7jk26xl09.setPercentageWidth(table, total);
      };
      return {
        width: constant(floatWidth),
        pixelWidth: constant(pixelWidth),
        getWidths: $_8ra6ologjk26xl9c.getPercentageWidths,
        getCellDelta: getCellDelta,
        singleColumnWidth: singleColumnWidth,
        minCellWidth: minCellWidth,
        setElementWidth: $_4khph0n7jk26xl09.setPercentageWidth,
        setTableWidth: setTableWidth
      };
    };
    var pixelSize = function pixelSize(width) {
      var intWidth = parseInt(width, 10);
      var getCellDelta = identity;
      var singleColumnWidth = function singleColumnWidth(width, delta) {
        var newNext = Math.max($_8rs5cuohjk26xl9k.minWidth(), width + delta);
        return [newNext - width];
      };
      var setTableWidth = function setTableWidth(table, newWidths, _delta) {
        var total = foldr(newWidths, function (b, a) {
          return b + a;
        }, 0);
        $_4khph0n7jk26xl09.setPixelWidth(table, total);
      };
      return {
        width: constant(intWidth),
        pixelWidth: constant(intWidth),
        getWidths: $_8ra6ologjk26xl9c.getPixelWidths,
        getCellDelta: getCellDelta,
        singleColumnWidth: singleColumnWidth,
        minCellWidth: $_8rs5cuohjk26xl9k.minWidth,
        setElementWidth: $_4khph0n7jk26xl09.setPixelWidth,
        setTableWidth: setTableWidth
      };
    };
    var chooseSize = function chooseSize(element, width) {
      if ($_4khph0n7jk26xl09.percentageBasedSizeRegex().test(width)) {
        var percentMatch = $_4khph0n7jk26xl09.percentageBasedSizeRegex().exec(width);
        return percentageSize(percentMatch[1], element);
      } else if ($_4khph0n7jk26xl09.pixelBasedSizeRegex().test(width)) {
        var pixelMatch = $_4khph0n7jk26xl09.pixelBasedSizeRegex().exec(width);
        return pixelSize(pixelMatch[1]);
      } else {
        var fallbackWidth = $_736uoenbjk26xl19.get(element);
        return pixelSize(fallbackWidth);
      }
    };
    var getTableSize = function getTableSize(element) {
      var width = $_4khph0n7jk26xl09.getRawWidth(element);
      return width.fold(function () {
        var fallbackWidth = $_736uoenbjk26xl19.get(element);
        return pixelSize(fallbackWidth);
      }, function (width) {
        return chooseSize(element, width);
      });
    };
    var $_gg5jc9ojjk26xl9z = { getTableSize: getTableSize };

    var getWarehouse$1 = function getWarehouse$1(list) {
      return $_7tsw5majk26xksp.generate(list);
    };
    var sumUp = function sumUp(newSize) {
      return foldr(newSize, function (b, a) {
        return b + a;
      }, 0);
    };
    var getTableWarehouse = function getTableWarehouse(table) {
      var list = $_aihceulbjk26xkng.fromTable(table);
      return getWarehouse$1(list);
    };
    var adjustWidth = function adjustWidth(table, delta, index, direction) {
      var tableSize = $_gg5jc9ojjk26xl9z.getTableSize(table);
      var step = tableSize.getCellDelta(delta);
      var warehouse = getTableWarehouse(table);
      var widths = tableSize.getWidths(warehouse, direction, tableSize);
      var deltas = $_2tee85oejk26xl94.determine(widths, index, step, tableSize);
      var newWidths = map(deltas, function (dx, i) {
        return dx + widths[i];
      });
      var newSizes = $_2f7ioroijk26xl9s.recalculateWidth(warehouse, newWidths);
      each(newSizes, function (cell) {
        tableSize.setElementWidth(cell.element(), cell.width());
      });
      if (index === warehouse.grid().columns() - 1) {
        tableSize.setTableWidth(table, newWidths, step);
      }
    };
    var adjustHeight = function adjustHeight(table, delta, index, direction) {
      var warehouse = getTableWarehouse(table);
      var heights = $_8ra6ologjk26xl9c.getPixelHeights(warehouse, direction);
      var newHeights = map(heights, function (dy, i) {
        return index === i ? Math.max(delta + dy, $_8rs5cuohjk26xl9k.minHeight()) : dy;
      });
      var newCellSizes = $_2f7ioroijk26xl9s.recalculateHeight(warehouse, newHeights);
      var newRowSizes = $_2f7ioroijk26xl9s.matchRowHeight(warehouse, newHeights);
      each(newRowSizes, function (row) {
        $_4khph0n7jk26xl09.setHeight(row.element(), row.height());
      });
      each(newCellSizes, function (cell) {
        $_4khph0n7jk26xl09.setHeight(cell.element(), cell.height());
      });
      var total = sumUp(newHeights);
      $_4khph0n7jk26xl09.setHeight(table, total);
    };
    var adjustWidthTo = function adjustWidthTo(table, list, direction) {
      var tableSize = $_gg5jc9ojjk26xl9z.getTableSize(table);
      var warehouse = getWarehouse$1(list);
      var widths = tableSize.getWidths(warehouse, direction, tableSize);
      var newSizes = $_2f7ioroijk26xl9s.recalculateWidth(warehouse, widths);
      each(newSizes, function (cell) {
        tableSize.setElementWidth(cell.element(), cell.width());
      });
      var total = foldr(widths, function (b, a) {
        return a + b;
      }, 0);
      if (newSizes.length > 0) {
        tableSize.setElementWidth(table, total);
      }
    };
    var $_dc1u2godjk26xl8z = {
      adjustWidth: adjustWidth,
      adjustHeight: adjustHeight,
      adjustWidthTo: adjustWidthTo
    };

    var prune = function prune(table) {
      var cells = $_3gdghfldjk26xknu.cells(table);
      if (cells.length === 0) $_lmq2lmejk26xktg.remove(table);
    };
    var outcome = Immutable('grid', 'cursor');
    var elementFromGrid = function elementFromGrid(grid, row, column) {
      return findIn(grid, row, column).orThunk(function () {
        return findIn(grid, 0, 0);
      });
    };
    var findIn = function findIn(grid, row, column) {
      return Option.from(grid[row]).bind(function (r) {
        return Option.from(r.cells()[column]).bind(function (c) {
          return Option.from(c.element());
        });
      });
    };
    var bundle = function bundle(grid, row, column) {
      return outcome(grid, findIn(grid, row, column));
    };
    var uniqueRows = function uniqueRows(details) {
      return foldl(details, function (rest, detail) {
        return exists(rest, function (currentDetail) {
          return currentDetail.row() === detail.row();
        }) ? rest : rest.concat([detail]);
      }, []).sort(function (detailA, detailB) {
        return detailA.row() - detailB.row();
      });
    };
    var uniqueColumns = function uniqueColumns(details) {
      return foldl(details, function (rest, detail) {
        return exists(rest, function (currentDetail) {
          return currentDetail.column() === detail.column();
        }) ? rest : rest.concat([detail]);
      }, []).sort(function (detailA, detailB) {
        return detailA.column() - detailB.column();
      });
    };
    var insertRowBefore = function insertRowBefore(grid, detail, comparator, genWrappers) {
      var example = detail.row();
      var targetIndex = detail.row();
      var newGrid = $_6i24mnobjk26xl8k.insertRowAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
      return bundle(newGrid, targetIndex, detail.column());
    };
    var insertRowsBefore = function insertRowsBefore(grid, details, comparator, genWrappers) {
      var example = details[0].row();
      var targetIndex = details[0].row();
      var rows = uniqueRows(details);
      var newGrid = foldl(rows, function (newGrid, _row) {
        return $_6i24mnobjk26xl8k.insertRowAt(newGrid, targetIndex, example, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, targetIndex, details[0].column());
    };
    var insertRowAfter = function insertRowAfter(grid, detail, comparator, genWrappers) {
      var example = detail.row();
      var targetIndex = detail.row() + detail.rowspan();
      var newGrid = $_6i24mnobjk26xl8k.insertRowAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
      return bundle(newGrid, targetIndex, detail.column());
    };
    var insertRowsAfter = function insertRowsAfter(grid, details, comparator, genWrappers) {
      var rows = uniqueRows(details);
      var example = rows[rows.length - 1].row();
      var targetIndex = rows[rows.length - 1].row() + rows[rows.length - 1].rowspan();
      var newGrid = foldl(rows, function (newGrid, _row) {
        return $_6i24mnobjk26xl8k.insertRowAt(newGrid, targetIndex, example, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, targetIndex, details[0].column());
    };
    var insertColumnBefore = function insertColumnBefore(grid, detail, comparator, genWrappers) {
      var example = detail.column();
      var targetIndex = detail.column();
      var newGrid = $_6i24mnobjk26xl8k.insertColumnAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
      return bundle(newGrid, detail.row(), targetIndex);
    };
    var insertColumnsBefore = function insertColumnsBefore(grid, details, comparator, genWrappers) {
      var columns = uniqueColumns(details);
      var example = columns[0].column();
      var targetIndex = columns[0].column();
      var newGrid = foldl(columns, function (newGrid, _row) {
        return $_6i24mnobjk26xl8k.insertColumnAt(newGrid, targetIndex, example, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, details[0].row(), targetIndex);
    };
    var insertColumnAfter = function insertColumnAfter(grid, detail, comparator, genWrappers) {
      var example = detail.column();
      var targetIndex = detail.column() + detail.colspan();
      var newGrid = $_6i24mnobjk26xl8k.insertColumnAt(grid, targetIndex, example, comparator, genWrappers.getOrInit);
      return bundle(newGrid, detail.row(), targetIndex);
    };
    var insertColumnsAfter = function insertColumnsAfter(grid, details, comparator, genWrappers) {
      var example = details[details.length - 1].column();
      var targetIndex = details[details.length - 1].column() + details[details.length - 1].colspan();
      var columns = uniqueColumns(details);
      var newGrid = foldl(columns, function (newGrid, _row) {
        return $_6i24mnobjk26xl8k.insertColumnAt(newGrid, targetIndex, example, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, details[0].row(), targetIndex);
    };
    var makeRowHeader = function makeRowHeader(grid, detail, comparator, genWrappers) {
      var newGrid = $_3uegeocjk26xl8p.replaceRow(grid, detail.row(), comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var makeColumnHeader = function makeColumnHeader(grid, detail, comparator, genWrappers) {
      var newGrid = $_3uegeocjk26xl8p.replaceColumn(grid, detail.column(), comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var unmakeRowHeader = function unmakeRowHeader(grid, detail, comparator, genWrappers) {
      var newGrid = $_3uegeocjk26xl8p.replaceRow(grid, detail.row(), comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var unmakeColumnHeader = function unmakeColumnHeader(grid, detail, comparator, genWrappers) {
      var newGrid = $_3uegeocjk26xl8p.replaceColumn(grid, detail.column(), comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var splitCellIntoColumns$1 = function splitCellIntoColumns$1(grid, detail, comparator, genWrappers) {
      var newGrid = $_6i24mnobjk26xl8k.splitCellIntoColumns(grid, detail.row(), detail.column(), comparator, genWrappers.getOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var splitCellIntoRows$1 = function splitCellIntoRows$1(grid, detail, comparator, genWrappers) {
      var newGrid = $_6i24mnobjk26xl8k.splitCellIntoRows(grid, detail.row(), detail.column(), comparator, genWrappers.getOrInit);
      return bundle(newGrid, detail.row(), detail.column());
    };
    var eraseColumns = function eraseColumns(grid, details, comparator, _genWrappers) {
      var columns = uniqueColumns(details);
      var newGrid = $_6i24mnobjk26xl8k.deleteColumnsAt(grid, columns[0].column(), columns[columns.length - 1].column());
      var cursor = elementFromGrid(newGrid, details[0].row(), details[0].column());
      return outcome(newGrid, cursor);
    };
    var eraseRows = function eraseRows(grid, details, comparator, _genWrappers) {
      var rows = uniqueRows(details);
      var newGrid = $_6i24mnobjk26xl8k.deleteRowsAt(grid, rows[0].row(), rows[rows.length - 1].row());
      var cursor = elementFromGrid(newGrid, details[0].row(), details[0].column());
      return outcome(newGrid, cursor);
    };
    var mergeCells = function mergeCells(grid, mergable, comparator, _genWrappers) {
      var cells = mergable.cells();
      $_8g5l2pnnjk26xl3h.merge(cells);
      var newGrid = $_e7r5bgoajk26xl8d.merge(grid, mergable.bounds(), comparator, constant(cells[0]));
      return outcome(newGrid, Option.from(cells[0]));
    };
    var unmergeCells = function unmergeCells(grid, unmergable, comparator, genWrappers) {
      var newGrid = foldr(unmergable, function (b, cell) {
        return $_e7r5bgoajk26xl8d.unmerge(b, cell, comparator, genWrappers.combine(cell));
      }, grid);
      return outcome(newGrid, Option.from(unmergable[0]));
    };
    var pasteCells = function pasteCells(grid, pasteDetails, comparator, genWrappers) {
      var gridify = function gridify(table, generators) {
        var list = $_aihceulbjk26xkng.fromTable(table);
        var wh = $_7tsw5majk26xksp.generate(list);
        return $_78zj4cntjk26xl4z.toGrid(wh, generators, true);
      };
      var gridB = gridify(pasteDetails.clipboard(), pasteDetails.generators());
      var startAddress = $_g9pyg7lcjk26xknq.address(pasteDetails.row(), pasteDetails.column());
      var mergedGrid = $_4zzecpo7jk26xl7w.merge(startAddress, grid, gridB, pasteDetails.generators(), comparator);
      return mergedGrid.fold(function () {
        return outcome(grid, Option.some(pasteDetails.element()));
      }, function (nuGrid) {
        var cursor = elementFromGrid(nuGrid, pasteDetails.row(), pasteDetails.column());
        return outcome(nuGrid, cursor);
      });
    };
    var gridifyRows = function gridifyRows(rows, generators, example) {
      var pasteDetails = $_aihceulbjk26xkng.fromPastedRows(rows, example);
      var wh = $_7tsw5majk26xksp.generate(pasteDetails);
      return $_78zj4cntjk26xl4z.toGrid(wh, generators, true);
    };
    var pasteRowsBefore = function pasteRowsBefore(grid, pasteDetails, comparator, genWrappers) {
      var example = grid[pasteDetails.cells[0].row()];
      var index = pasteDetails.cells[0].row();
      var gridB = gridifyRows(pasteDetails.clipboard(), pasteDetails.generators(), example);
      var mergedGrid = $_4zzecpo7jk26xl7w.insert(index, grid, gridB, pasteDetails.generators(), comparator);
      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row(), pasteDetails.cells[0].column());
      return outcome(mergedGrid, cursor);
    };
    var pasteRowsAfter = function pasteRowsAfter(grid, pasteDetails, comparator, genWrappers) {
      var example = grid[pasteDetails.cells[0].row()];
      var index = pasteDetails.cells[pasteDetails.cells.length - 1].row() + pasteDetails.cells[pasteDetails.cells.length - 1].rowspan();
      var gridB = gridifyRows(pasteDetails.clipboard(), pasteDetails.generators(), example);
      var mergedGrid = $_4zzecpo7jk26xl7w.insert(index, grid, gridB, pasteDetails.generators(), comparator);
      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row(), pasteDetails.cells[0].column());
      return outcome(mergedGrid, cursor);
    };
    var resize = $_dc1u2godjk26xl8z.adjustWidthTo;
    var $_ghwkz3njjk26xl29 = {
      insertRowBefore: $_5kge3mnqjk26xl4f.run(insertRowBefore, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      insertRowsBefore: $_5kge3mnqjk26xl4f.run(insertRowsBefore, $_5kge3mnqjk26xl4f.onCells, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      insertRowAfter: $_5kge3mnqjk26xl4f.run(insertRowAfter, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      insertRowsAfter: $_5kge3mnqjk26xl4f.run(insertRowsAfter, $_5kge3mnqjk26xl4f.onCells, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      insertColumnBefore: $_5kge3mnqjk26xl4f.run(insertColumnBefore, $_5kge3mnqjk26xl4f.onCell, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      insertColumnsBefore: $_5kge3mnqjk26xl4f.run(insertColumnsBefore, $_5kge3mnqjk26xl4f.onCells, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      insertColumnAfter: $_5kge3mnqjk26xl4f.run(insertColumnAfter, $_5kge3mnqjk26xl4f.onCell, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      insertColumnsAfter: $_5kge3mnqjk26xl4f.run(insertColumnsAfter, $_5kge3mnqjk26xl4f.onCells, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      splitCellIntoColumns: $_5kge3mnqjk26xl4f.run(splitCellIntoColumns$1, $_5kge3mnqjk26xl4f.onCell, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      splitCellIntoRows: $_5kge3mnqjk26xl4f.run(splitCellIntoRows$1, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      eraseColumns: $_5kge3mnqjk26xl4f.run(eraseColumns, $_5kge3mnqjk26xl4f.onCells, resize, prune, $_3nsoa6nkjk26xl2s.modification),
      eraseRows: $_5kge3mnqjk26xl4f.run(eraseRows, $_5kge3mnqjk26xl4f.onCells, noop, prune, $_3nsoa6nkjk26xl2s.modification),
      makeColumnHeader: $_5kge3mnqjk26xl4f.run(makeColumnHeader, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.transform('row', 'th')),
      unmakeColumnHeader: $_5kge3mnqjk26xl4f.run(unmakeColumnHeader, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.transform(null, 'td')),
      makeRowHeader: $_5kge3mnqjk26xl4f.run(makeRowHeader, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.transform('col', 'th')),
      unmakeRowHeader: $_5kge3mnqjk26xl4f.run(unmakeRowHeader, $_5kge3mnqjk26xl4f.onCell, noop, noop, $_3nsoa6nkjk26xl2s.transform(null, 'td')),
      mergeCells: $_5kge3mnqjk26xl4f.run(mergeCells, $_5kge3mnqjk26xl4f.onMergable, noop, noop, $_3nsoa6nkjk26xl2s.merging),
      unmergeCells: $_5kge3mnqjk26xl4f.run(unmergeCells, $_5kge3mnqjk26xl4f.onUnmergable, resize, noop, $_3nsoa6nkjk26xl2s.merging),
      pasteCells: $_5kge3mnqjk26xl4f.run(pasteCells, $_5kge3mnqjk26xl4f.onPaste, resize, noop, $_3nsoa6nkjk26xl2s.modification),
      pasteRowsBefore: $_5kge3mnqjk26xl4f.run(pasteRowsBefore, $_5kge3mnqjk26xl4f.onPasteRows, noop, noop, $_3nsoa6nkjk26xl2s.modification),
      pasteRowsAfter: $_5kge3mnqjk26xl4f.run(pasteRowsAfter, $_5kge3mnqjk26xl4f.onPasteRows, noop, noop, $_3nsoa6nkjk26xl2s.modification)
    };

    var getBody$1 = function getBody$1(editor) {
      return Element$$1.fromDom(editor.getBody());
    };
    var getPixelWidth$1 = function getPixelWidth$1(elm) {
      return elm.getBoundingClientRect().width;
    };
    var getPixelHeight = function getPixelHeight(elm) {
      return elm.getBoundingClientRect().height;
    };
    var getIsRoot = function getIsRoot(editor) {
      return function (element) {
        return $_5m7qbqlljk26xkq3.eq(element, getBody$1(editor));
      };
    };
    var removePxSuffix = function removePxSuffix(size) {
      return size ? size.replace(/px$/, '') : '';
    };
    var addSizeSuffix = function addSizeSuffix(size) {
      if (/^[0-9]+$/.test(size)) {
        size += 'px';
      }
      return size;
    };
    var removeDataStyle = function removeDataStyle(table) {
      var dataStyleCells = $_bkrvmvm4jk26xkrt.descendants(table, 'td[data-mce-style],th[data-mce-style]');
      $_8icsmim2jk26xkrh.remove(table, 'data-mce-style');
      each(dataStyleCells, function (cell) {
        $_8icsmim2jk26xkrh.remove(cell, 'data-mce-style');
      });
    };

    var onDirection = function onDirection(isLtr, isRtl) {
      return function (element) {
        return getDirection(element) === 'rtl' ? isRtl : isLtr;
      };
    };
    var getDirection = function getDirection(element) {
      return $_4ift9ombjk26xksz.get(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
    };
    var $_2bm9wpomjk26xlam = {
      onDirection: onDirection,
      getDirection: getDirection
    };

    var ltr$1 = { isRtl: constant(false) };
    var rtl$1 = { isRtl: constant(true) };
    var directionAt = function directionAt(element) {
      var dir = $_2bm9wpomjk26xlam.getDirection(element);
      return dir === 'rtl' ? rtl$1 : ltr$1;
    };
    var $_cwid1voljk26xlai = { directionAt: directionAt };

    var defaultTableToolbar = ['tableprops', 'tabledelete', '|', 'tableinsertrowbefore', 'tableinsertrowafter', 'tabledeleterow', '|', 'tableinsertcolbefore', 'tableinsertcolafter', 'tabledeletecol'];
    var defaultStyles = {
      'border-collapse': 'collapse',
      'width': '100%'
    };
    var defaultAttributes = { border: '1' };
    var getDefaultAttributes = function getDefaultAttributes(editor) {
      return editor.getParam('table_default_attributes', defaultAttributes, 'object');
    };
    var getDefaultStyles = function getDefaultStyles(editor) {
      return editor.getParam('table_default_styles', defaultStyles, 'object');
    };
    var hasTableResizeBars = function hasTableResizeBars(editor) {
      return editor.getParam('table_resize_bars', true, 'boolean');
    };
    var hasTabNavigation = function hasTabNavigation(editor) {
      return editor.getParam('table_tab_navigation', true, 'boolean');
    };
    var hasAdvancedCellTab = function hasAdvancedCellTab(editor) {
      return editor.getParam('table_cell_advtab', true, 'boolean');
    };
    var hasAdvancedRowTab = function hasAdvancedRowTab(editor) {
      return editor.getParam('table_row_advtab', true, 'boolean');
    };
    var hasAdvancedTableTab = function hasAdvancedTableTab(editor) {
      return editor.getParam('table_advtab', true, 'boolean');
    };
    var hasAppearanceOptions = function hasAppearanceOptions(editor) {
      return editor.getParam('table_appearance_options', true, 'boolean');
    };
    var hasTableGrid = function hasTableGrid(editor) {
      return editor.getParam('table_grid', true, 'boolean');
    };
    var shouldStyleWithCss = function shouldStyleWithCss(editor) {
      return editor.getParam('table_style_by_css', false, 'boolean');
    };
    var getCellClassList = function getCellClassList(editor) {
      return editor.getParam('table_cell_class_list', [], 'array');
    };
    var getRowClassList = function getRowClassList(editor) {
      return editor.getParam('table_row_class_list', [], 'array');
    };
    var getTableClassList = function getTableClassList(editor) {
      return editor.getParam('table_class_list', [], 'array');
    };
    var getColorPickerCallback = function getColorPickerCallback(editor) {
      return editor.getParam('color_picker_callback');
    };
    var isPixelsForced = function isPixelsForced(editor) {
      return editor.getParam('table_responsive_width') === false;
    };
    var getCloneElements = function getCloneElements(editor) {
      var cloneElements = editor.getParam('table_clone_elements');
      if (isString(cloneElements)) {
        return Option.some(cloneElements.split(/[ ,]/));
      } else if (Array.isArray(cloneElements)) {
        return Option.some(cloneElements);
      } else {
        return Option.none();
      }
    };
    var hasObjectResizing = function hasObjectResizing(editor) {
      var objectResizing = editor.getParam('object_resizing', true);
      return objectResizing === 'table' || objectResizing;
    };
    var getToolbar = function getToolbar(editor) {
      var toolbar = editor.getParam('table_toolbar', defaultTableToolbar);
      if (toolbar === '' || toolbar === false) {
        return [];
      } else if (isString(toolbar)) {
        return toolbar.split(/[ ,]/);
      } else if (isArray(toolbar)) {
        return toolbar;
      } else {
        return [];
      }
    };

    var fireNewRow = function fireNewRow(editor, row) {
      return editor.fire('newrow', { node: row });
    };
    var fireNewCell = function fireNewCell(editor, cell) {
      return editor.fire('newcell', { node: cell });
    };
    var fireObjectResizeStart = function fireObjectResizeStart(editor, target, width, height) {
      editor.fire('ObjectResizeStart', {
        target: target,
        width: width,
        height: height
      });
    };
    var fireObjectResized = function fireObjectResized(editor, target, width, height) {
      editor.fire('ObjectResized', {
        target: target,
        width: width,
        height: height
      });
    };

    var TableActions = function TableActions(editor, lazyWire) {
      var isTableBody = function isTableBody(editor) {
        return $_89mq4qm3jk26xkrq.name(getBody$1(editor)) === 'table';
      };
      var lastRowGuard = function lastRowGuard(table) {
        var size = $_cki6bsnijk26xl26.getGridSize(table);
        return isTableBody(editor) === false || size.rows() > 1;
      };
      var lastColumnGuard = function lastColumnGuard(table) {
        var size = $_cki6bsnijk26xl26.getGridSize(table);
        return isTableBody(editor) === false || size.columns() > 1;
      };
      var cloneFormats = getCloneElements(editor);
      var execute = function execute(operation, guard, mutate, lazyWire) {
        return function (table, target) {
          removeDataStyle(table);
          var wire = lazyWire();
          var doc = Element$$1.fromDom(editor.getDoc());
          var direction = TableDirection($_cwid1voljk26xlai.directionAt);
          var generators = $_cek5a8mgjk26xkto.cellOperations(mutate, doc, cloneFormats);
          return guard(table) ? operation(wire, table, target, generators, direction).bind(function (result) {
            each(result.newRows(), function (row) {
              fireNewRow(editor, row.dom());
            });
            each(result.newCells(), function (cell) {
              fireNewCell(editor, cell.dom());
            });
            return result.cursor().map(function (cell) {
              var rng = editor.dom.createRng();
              rng.setStart(cell.dom(), 0);
              rng.setEnd(cell.dom(), 0);
              return rng;
            });
          }) : Option.none();
        };
      };
      var deleteRow = execute($_ghwkz3njjk26xl29.eraseRows, lastRowGuard, noop, lazyWire);
      var deleteColumn = execute($_ghwkz3njjk26xl29.eraseColumns, lastColumnGuard, noop, lazyWire);
      var insertRowsBefore = execute($_ghwkz3njjk26xl29.insertRowsBefore, always, noop, lazyWire);
      var insertRowsAfter = execute($_ghwkz3njjk26xl29.insertRowsAfter, always, noop, lazyWire);
      var insertColumnsBefore = execute($_ghwkz3njjk26xl29.insertColumnsBefore, always, $_4lzdh1n6jk26xl06.halve, lazyWire);
      var insertColumnsAfter = execute($_ghwkz3njjk26xl29.insertColumnsAfter, always, $_4lzdh1n6jk26xl06.halve, lazyWire);
      var mergeCells = execute($_ghwkz3njjk26xl29.mergeCells, always, noop, lazyWire);
      var unmergeCells = execute($_ghwkz3njjk26xl29.unmergeCells, always, noop, lazyWire);
      var pasteRowsBefore = execute($_ghwkz3njjk26xl29.pasteRowsBefore, always, noop, lazyWire);
      var pasteRowsAfter = execute($_ghwkz3njjk26xl29.pasteRowsAfter, always, noop, lazyWire);
      var pasteCells = execute($_ghwkz3njjk26xl29.pasteCells, always, noop, lazyWire);
      return {
        deleteRow: deleteRow,
        deleteColumn: deleteColumn,
        insertRowsBefore: insertRowsBefore,
        insertRowsAfter: insertRowsAfter,
        insertColumnsBefore: insertColumnsBefore,
        insertColumnsAfter: insertColumnsAfter,
        mergeCells: mergeCells,
        unmergeCells: unmergeCells,
        pasteRowsBefore: pasteRowsBefore,
        pasteRowsAfter: pasteRowsAfter,
        pasteCells: pasteCells
      };
    };

    var copyRows = function copyRows(table, target, generators) {
      var list = $_aihceulbjk26xkng.fromTable(table);
      var house = $_7tsw5majk26xksp.generate(list);
      var details = $_5kge3mnqjk26xl4f.onCells(house, target);
      return details.map(function (selectedCells) {
        var grid = $_78zj4cntjk26xl4z.toGrid(house, generators, false);
        var slicedGrid = grid.slice(selectedCells[0].row(), selectedCells[selectedCells.length - 1].row() + selectedCells[selectedCells.length - 1].rowspan());
        var slicedDetails = $_5kge3mnqjk26xl4f.toDetailList(slicedGrid, generators);
        return $_7f9qw8nwjk26xl5j.copy(slicedDetails);
      });
    };
    var $_dl1snroqjk26xlbk = { copyRows: copyRows };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getTDTHOverallStyle = function getTDTHOverallStyle(dom, elm, name) {
      var cells = dom.select('td,th', elm);
      var firstChildStyle;
      var checkChildren = function checkChildren(firstChildStyle, elms) {
        for (var i = 0; i < elms.length; i++) {
          var currentStyle = dom.getStyle(elms[i], name);
          if (typeof firstChildStyle === 'undefined') {
            firstChildStyle = currentStyle;
          }
          if (firstChildStyle !== currentStyle) {
            return '';
          }
        }
        return firstChildStyle;
      };
      firstChildStyle = checkChildren(firstChildStyle, cells);
      return firstChildStyle;
    };
    var applyAlign = function applyAlign(editor, elm, name) {
      if (name) {
        editor.formatter.apply('align' + name, {}, elm);
      }
    };
    var applyVAlign = function applyVAlign(editor, elm, name) {
      if (name) {
        editor.formatter.apply('valign' + name, {}, elm);
      }
    };
    var unApplyAlign = function unApplyAlign(editor, elm) {
      global$1.each('left center right'.split(' '), function (name) {
        editor.formatter.remove('align' + name, {}, elm);
      });
    };
    var unApplyVAlign = function unApplyVAlign(editor, elm) {
      global$1.each('top middle bottom'.split(' '), function (name) {
        editor.formatter.remove('valign' + name, {}, elm);
      });
    };
    var $_5l8az7otjk26xlbv = {
      applyAlign: applyAlign,
      applyVAlign: applyVAlign,
      unApplyAlign: unApplyAlign,
      unApplyVAlign: unApplyVAlign,
      getTDTHOverallStyle: getTDTHOverallStyle
    };

    var buildListItems = function buildListItems(inputList, itemCallback, startItems) {
      var appendItems = function appendItems(values, output) {
        output = output || [];
        global$1.each(values, function (item) {
          var menuItem = { text: item.text || item.title };
          if (item.menu) {
            menuItem.menu = appendItems(item.menu);
          } else {
            menuItem.value = item.value;
            if (itemCallback) {
              itemCallback(menuItem);
            }
          }
          output.push(menuItem);
        });
        return output;
      };
      return appendItems(inputList, startItems || []);
    };
    function styleFieldHasFocus(e) {
      return e.control.rootControl.find('#style')[0].getEl().isEqualNode(document.activeElement);
    }
    var syncAdvancedStyleFields = function syncAdvancedStyleFields(editor, evt) {
      if (styleFieldHasFocus(evt)) {
        updateAdvancedFields(editor, evt);
      } else {
        updateStyleField(editor, evt);
      }
    };
    var updateStyleField = function updateStyleField(editor, evt) {
      var dom = editor.dom;
      var rootControl = evt.control.rootControl;
      var data = rootControl.toJSON();
      var css = dom.parseStyle(data.style);
      css['border-style'] = data.borderStyle;
      css['border-color'] = data.borderColor;
      css['background-color'] = data.backgroundColor;
      css.width = data.width ? addSizeSuffix(data.width) : '';
      css.height = data.height ? addSizeSuffix(data.height) : '';
      rootControl.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
    };
    var updateAdvancedFields = function updateAdvancedFields(editor, evt) {
      var dom = editor.dom;
      var rootControl = evt.control.rootControl;
      var data = rootControl.toJSON();
      var css = dom.parseStyle(data.style);
      rootControl.find('#borderStyle').value(css['border-style'] || '');
      rootControl.find('#borderColor').value(css['border-color'] || '');
      rootControl.find('#backgroundColor').value(css['background-color'] || '');
      rootControl.find('#width').value(css.width || '');
      rootControl.find('#height').value(css.height || '');
    };
    var extractAdvancedStyles = function extractAdvancedStyles(dom, elm) {
      var css = dom.parseStyle(dom.getAttrib(elm, 'style'));
      var data = {};
      if (css['border-style']) {
        data.borderStyle = css['border-style'];
      }
      if (css['border-color']) {
        data.borderColor = css['border-color'];
      }
      if (css['background-color']) {
        data.backgroundColor = css['background-color'];
      }
      data.style = dom.serializeStyle(css);
      return data;
    };
    var createStyleForm = function createStyleForm(editor) {
      var createColorPickAction = function createColorPickAction() {
        var colorPickerCallback = getColorPickerCallback(editor);
        if (colorPickerCallback) {
          return function (evt) {
            return colorPickerCallback.call(editor, function (value) {
              evt.control.value(value).fire('change');
            }, evt.control.value());
          };
        }
      };
      return {
        title: 'Advanced',
        type: 'form',
        defaults: { onchange: curry(updateStyleField, editor) },
        items: [{
          label: 'Style',
          name: 'style',
          type: 'textbox',
          onchange: curry(updateAdvancedFields, editor)
        }, {
          type: 'form',
          padding: 0,
          formItemDefaults: {
            layout: 'grid',
            alignH: ['start', 'right']
          },
          defaults: { size: 7 },
          items: [{
            label: 'Border style',
            type: 'listbox',
            name: 'borderStyle',
            width: 90,
            onselect: curry(updateStyleField, editor),
            values: [{
              text: 'Select...',
              value: ''
            }, {
              text: 'Solid',
              value: 'solid'
            }, {
              text: 'Dotted',
              value: 'dotted'
            }, {
              text: 'Dashed',
              value: 'dashed'
            }, {
              text: 'Double',
              value: 'double'
            }, {
              text: 'Groove',
              value: 'groove'
            }, {
              text: 'Ridge',
              value: 'ridge'
            }, {
              text: 'Inset',
              value: 'inset'
            }, {
              text: 'Outset',
              value: 'outset'
            }, {
              text: 'None',
              value: 'none'
            }, {
              text: 'Hidden',
              value: 'hidden'
            }]
          }, {
            label: 'Border color',
            type: 'colorbox',
            name: 'borderColor',
            onaction: createColorPickAction()
          }, {
            label: 'Background color',
            type: 'colorbox',
            name: 'backgroundColor',
            onaction: createColorPickAction()
          }]
        }]
      };
    };
    var $_a7s7fkoujk26xlby = {
      createStyleForm: createStyleForm,
      buildListItems: buildListItems,
      updateStyleField: updateStyleField,
      extractAdvancedStyles: extractAdvancedStyles,
      updateAdvancedFields: updateAdvancedFields,
      syncAdvancedStyleFields: syncAdvancedStyleFields
    };

    var updateStyles = function updateStyles(elm, cssText) {
      delete elm.dataset.mceStyle;
      elm.style.cssText += ';' + cssText;
    };
    var extractDataFromElement = function extractDataFromElement(editor, elm) {
      var dom = editor.dom;
      var data = {
        width: dom.getStyle(elm, 'width') || dom.getAttrib(elm, 'width'),
        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
        scope: dom.getAttrib(elm, 'scope'),
        class: dom.getAttrib(elm, 'class'),
        type: elm.nodeName.toLowerCase(),
        style: '',
        align: '',
        valign: ''
      };
      global$1.each('left center right'.split(' '), function (name) {
        if (editor.formatter.matchNode(elm, 'align' + name)) {
          data.align = name;
        }
      });
      global$1.each('top middle bottom'.split(' '), function (name) {
        if (editor.formatter.matchNode(elm, 'valign' + name)) {
          data.valign = name;
        }
      });
      if (hasAdvancedCellTab(editor)) {
        global$1.extend(data, $_a7s7fkoujk26xlby.extractAdvancedStyles(dom, elm));
      }
      return data;
    };
    var onSubmitCellForm = function onSubmitCellForm(editor, cells, evt) {
      var dom = editor.dom;
      var data;
      function setAttrib(elm, name, value) {
        if (cells.length === 1 || value) {
          dom.setAttrib(elm, name, value);
        }
      }
      function setStyle(elm, name, value) {
        if (cells.length === 1 || value) {
          dom.setStyle(elm, name, value);
        }
      }
      if (hasAdvancedCellTab(editor)) {
        $_a7s7fkoujk26xlby.syncAdvancedStyleFields(editor, evt);
      }
      data = evt.control.rootControl.toJSON();
      editor.undoManager.transact(function () {
        global$1.each(cells, function (cellElm) {
          setAttrib(cellElm, 'scope', data.scope);
          if (cells.length === 1) {
            setAttrib(cellElm, 'style', data.style);
          } else {
            updateStyles(cellElm, data.style);
          }
          setAttrib(cellElm, 'class', data.class);
          setStyle(cellElm, 'width', addSizeSuffix(data.width));
          setStyle(cellElm, 'height', addSizeSuffix(data.height));
          if (data.type && cellElm.nodeName.toLowerCase() !== data.type) {
            cellElm = dom.rename(cellElm, data.type);
          }
          if (cells.length === 1) {
            $_5l8az7otjk26xlbv.unApplyAlign(editor, cellElm);
            $_5l8az7otjk26xlbv.unApplyVAlign(editor, cellElm);
          }
          if (data.align) {
            $_5l8az7otjk26xlbv.applyAlign(editor, cellElm, data.align);
          }
          if (data.valign) {
            $_5l8az7otjk26xlbv.applyVAlign(editor, cellElm, data.valign);
          }
        });
        editor.focus();
      });
    };
    var open = function open(editor) {
      var cellElm,
          data,
          classListCtrl,
          cells = [];
      cells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
      cellElm = editor.dom.getParent(editor.selection.getStart(), 'td,th');
      if (!cells.length && cellElm) {
        cells.push(cellElm);
      }
      cellElm = cellElm || cells[0];
      if (!cellElm) {
        return;
      }
      if (cells.length > 1) {
        data = {
          width: '',
          height: '',
          scope: '',
          class: '',
          align: '',
          valign: '',
          style: '',
          type: cellElm.nodeName.toLowerCase()
        };
      } else {
        data = extractDataFromElement(editor, cellElm);
      }
      if (getCellClassList(editor).length > 0) {
        classListCtrl = {
          name: 'class',
          type: 'listbox',
          label: 'Class',
          values: $_a7s7fkoujk26xlby.buildListItems(getCellClassList(editor), function (item) {
            if (item.value) {
              item.textStyle = function () {
                return editor.formatter.getCssText({
                  block: 'td',
                  classes: [item.value]
                });
              };
            }
          })
        };
      }
      var generalCellForm = {
        type: 'form',
        layout: 'flex',
        direction: 'column',
        labelGapCalc: 'children',
        padding: 0,
        items: [{
          type: 'form',
          layout: 'grid',
          columns: 2,
          labelGapCalc: false,
          padding: 0,
          defaults: {
            type: 'textbox',
            maxWidth: 50
          },
          items: [{
            label: 'Width',
            name: 'width',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }, {
            label: 'Height',
            name: 'height',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }, {
            label: 'Cell type',
            name: 'type',
            type: 'listbox',
            text: 'None',
            minWidth: 90,
            maxWidth: null,
            values: [{
              text: 'Cell',
              value: 'td'
            }, {
              text: 'Header cell',
              value: 'th'
            }]
          }, {
            label: 'Scope',
            name: 'scope',
            type: 'listbox',
            text: 'None',
            minWidth: 90,
            maxWidth: null,
            values: [{
              text: 'None',
              value: ''
            }, {
              text: 'Row',
              value: 'row'
            }, {
              text: 'Column',
              value: 'col'
            }, {
              text: 'Row group',
              value: 'rowgroup'
            }, {
              text: 'Column group',
              value: 'colgroup'
            }]
          }, {
            label: 'H Align',
            name: 'align',
            type: 'listbox',
            text: 'None',
            minWidth: 90,
            maxWidth: null,
            values: [{
              text: 'None',
              value: ''
            }, {
              text: 'Left',
              value: 'left'
            }, {
              text: 'Center',
              value: 'center'
            }, {
              text: 'Right',
              value: 'right'
            }]
          }, {
            label: 'V Align',
            name: 'valign',
            type: 'listbox',
            text: 'None',
            minWidth: 90,
            maxWidth: null,
            values: [{
              text: 'None',
              value: ''
            }, {
              text: 'Top',
              value: 'top'
            }, {
              text: 'Middle',
              value: 'middle'
            }, {
              text: 'Bottom',
              value: 'bottom'
            }]
          }]
        }, classListCtrl]
      };
      if (hasAdvancedCellTab(editor)) {
        editor.windowManager.open({
          title: 'Cell properties',
          bodyType: 'tabpanel',
          data: data,
          body: [{
            title: 'General',
            type: 'form',
            items: generalCellForm
          }, $_a7s7fkoujk26xlby.createStyleForm(editor)],
          onsubmit: curry(onSubmitCellForm, editor, cells)
        });
      } else {
        editor.windowManager.open({
          title: 'Cell properties',
          data: data,
          body: generalCellForm,
          onsubmit: curry(onSubmitCellForm, editor, cells)
        });
      }
    };
    var $_2mj5woosjk26xlbo = { open: open };

    var extractDataFromElement$1 = function extractDataFromElement$1(editor, elm) {
      var dom = editor.dom;
      var data = {
        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
        scope: dom.getAttrib(elm, 'scope'),
        class: dom.getAttrib(elm, 'class'),
        align: '',
        style: '',
        type: elm.parentNode.nodeName.toLowerCase()
      };
      global$1.each('left center right'.split(' '), function (name) {
        if (editor.formatter.matchNode(elm, 'align' + name)) {
          data.align = name;
        }
      });
      if (hasAdvancedRowTab(editor)) {
        global$1.extend(data, $_a7s7fkoujk26xlby.extractAdvancedStyles(dom, elm));
      }
      return data;
    };
    var switchRowType = function switchRowType(dom, rowElm, toType) {
      var tableElm = dom.getParent(rowElm, 'table');
      var oldParentElm = rowElm.parentNode;
      var parentElm = dom.select(toType, tableElm)[0];
      if (!parentElm) {
        parentElm = dom.create(toType);
        if (tableElm.firstChild) {
          if (tableElm.firstChild.nodeName === 'CAPTION') {
            dom.insertAfter(parentElm, tableElm.firstChild);
          } else {
            tableElm.insertBefore(parentElm, tableElm.firstChild);
          }
        } else {
          tableElm.appendChild(parentElm);
        }
      }
      parentElm.appendChild(rowElm);
      if (!oldParentElm.hasChildNodes()) {
        dom.remove(oldParentElm);
      }
    };
    function onSubmitRowForm(editor, rows, oldData, evt) {
      var dom = editor.dom;
      function setAttrib(elm, name, value) {
        if (rows.length === 1 || value) {
          dom.setAttrib(elm, name, value);
        }
      }
      function setStyle(elm, name, value) {
        if (rows.length === 1 || value) {
          dom.setStyle(elm, name, value);
        }
      }
      if (hasAdvancedRowTab(editor)) {
        $_a7s7fkoujk26xlby.syncAdvancedStyleFields(editor, evt);
      }
      var data = evt.control.rootControl.toJSON();
      editor.undoManager.transact(function () {
        global$1.each(rows, function (rowElm) {
          setAttrib(rowElm, 'scope', data.scope);
          setAttrib(rowElm, 'style', data.style);
          setAttrib(rowElm, 'class', data.class);
          setStyle(rowElm, 'height', addSizeSuffix(data.height));
          if (data.type !== rowElm.parentNode.nodeName.toLowerCase()) {
            switchRowType(editor.dom, rowElm, data.type);
          }
          if (data.align !== oldData.align) {
            $_5l8az7otjk26xlbv.unApplyAlign(editor, rowElm);
            $_5l8az7otjk26xlbv.applyAlign(editor, rowElm, data.align);
          }
        });
        editor.focus();
      });
    }
    var open$1 = function open$1(editor) {
      var dom = editor.dom;
      var tableElm, cellElm, rowElm, classListCtrl, data;
      var rows = [];
      var generalRowForm;
      tableElm = dom.getParent(editor.selection.getStart(), 'table');
      cellElm = dom.getParent(editor.selection.getStart(), 'td,th');
      global$1.each(tableElm.rows, function (row) {
        global$1.each(row.cells, function (cell) {
          if (dom.getAttrib(cell, 'data-mce-selected') || cell === cellElm) {
            rows.push(row);
            return false;
          }
        });
      });
      rowElm = rows[0];
      if (!rowElm) {
        return;
      }
      if (rows.length > 1) {
        data = {
          height: '',
          scope: '',
          style: '',
          class: '',
          align: '',
          type: rowElm.parentNode.nodeName.toLowerCase()
        };
      } else {
        data = extractDataFromElement$1(editor, rowElm);
      }
      if (getRowClassList(editor).length > 0) {
        classListCtrl = {
          name: 'class',
          type: 'listbox',
          label: 'Class',
          values: $_a7s7fkoujk26xlby.buildListItems(getRowClassList(editor), function (item) {
            if (item.value) {
              item.textStyle = function () {
                return editor.formatter.getCssText({
                  block: 'tr',
                  classes: [item.value]
                });
              };
            }
          })
        };
      }
      generalRowForm = {
        type: 'form',
        columns: 2,
        padding: 0,
        defaults: { type: 'textbox' },
        items: [{
          type: 'listbox',
          name: 'type',
          label: 'Row type',
          text: 'Header',
          maxWidth: null,
          values: [{
            text: 'Header',
            value: 'thead'
          }, {
            text: 'Body',
            value: 'tbody'
          }, {
            text: 'Footer',
            value: 'tfoot'
          }]
        }, {
          type: 'listbox',
          name: 'align',
          label: 'Alignment',
          text: 'None',
          maxWidth: null,
          values: [{
            text: 'None',
            value: ''
          }, {
            text: 'Left',
            value: 'left'
          }, {
            text: 'Center',
            value: 'center'
          }, {
            text: 'Right',
            value: 'right'
          }]
        }, {
          label: 'Height',
          name: 'height'
        }, classListCtrl]
      };
      if (hasAdvancedRowTab(editor)) {
        editor.windowManager.open({
          title: 'Row properties',
          data: data,
          bodyType: 'tabpanel',
          body: [{
            title: 'General',
            type: 'form',
            items: generalRowForm
          }, $_a7s7fkoujk26xlby.createStyleForm(editor)],
          onsubmit: curry(onSubmitRowForm, editor, rows, data)
        });
      } else {
        editor.windowManager.open({
          title: 'Row properties',
          data: data,
          body: generalRowForm,
          onsubmit: curry(onSubmitRowForm, editor, rows, data)
        });
      }
    };
    var $_7e1z5wovjk26xlc7 = { open: open$1 };

    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');

    var DefaultRenderOptions = {
      styles: {
        'border-collapse': 'collapse',
        width: '100%'
      },
      attributes: { border: '1' },
      percentages: true
    };
    var makeTable = function makeTable() {
      return Element$$1.fromTag('table');
    };
    var tableBody = function tableBody() {
      return Element$$1.fromTag('tbody');
    };
    var tableRow = function tableRow() {
      return Element$$1.fromTag('tr');
    };
    var tableHeaderCell = function tableHeaderCell() {
      return Element$$1.fromTag('th');
    };
    var tableCell = function tableCell() {
      return Element$$1.fromTag('td');
    };
    var render$1 = function render$1(rows, columns, rowHeaders, columnHeaders, renderOpts) {
      if (renderOpts === void 0) {
        renderOpts = DefaultRenderOptions;
      }
      var table = makeTable();
      $_4ift9ombjk26xksz.setAll(table, renderOpts.styles);
      $_8icsmim2jk26xkrh.setAll(table, renderOpts.attributes);
      var tbody = tableBody();
      $_aao88dmdjk26xkte.append(table, tbody);
      var trs = [];
      for (var i = 0; i < rows; i++) {
        var tr = tableRow();
        for (var j = 0; j < columns; j++) {
          var td = i < rowHeaders || j < columnHeaders ? tableHeaderCell() : tableCell();
          if (j < columnHeaders) {
            $_8icsmim2jk26xkrh.set(td, 'scope', 'row');
          }
          if (i < rowHeaders) {
            $_8icsmim2jk26xkrh.set(td, 'scope', 'col');
          }
          $_aao88dmdjk26xkte.append(td, Element$$1.fromTag('br'));
          if (renderOpts.percentages) {
            $_4ift9ombjk26xksz.set(td, 'width', 100 / columns + '%');
          }
          $_aao88dmdjk26xkte.append(tr, td);
        }
        trs.push(tr);
      }
      $_bsj3f1mfjk26xktj.append(tbody, trs);
      return table;
    };

    var get$7 = function get$7(element) {
      return element.dom().innerHTML;
    };
    var set$5 = function set$5(element, content) {
      var owner = $_4uy46mljjk26xkpk.owner(element);
      var docDom = owner.dom();
      var fragment = Element$$1.fromDom(docDom.createDocumentFragment());
      var contentElements = $_cm84yrmmjk26xkv1.fromHtml(content, docDom);
      $_bsj3f1mfjk26xktj.append(fragment, contentElements);
      $_lmq2lmejk26xktg.empty(element);
      $_aao88dmdjk26xkte.append(element, fragment);
    };
    var getOuter$2 = function getOuter$2(element) {
      var container = Element$$1.fromTag('div');
      var clone = Element$$1.fromDom(element.dom().cloneNode(true));
      $_aao88dmdjk26xkte.append(container, clone);
      return get$7(container);
    };
    var $_eeo0j9p1jk26xldl = {
      get: get$7,
      set: set$5,
      getOuter: getOuter$2
    };

    var placeCaretInCell = function placeCaretInCell(editor, cell) {
      editor.selection.select(cell.dom(), true);
      editor.selection.collapse(true);
    };
    var selectFirstCellInTable = function selectFirstCellInTable(editor, tableElm) {
      $_at9vkhm7jk26xks8.descendant(tableElm, 'td,th').each(curry(placeCaretInCell, editor));
    };
    var fireEvents = function fireEvents(editor, table) {
      each($_bkrvmvm4jk26xkrt.descendants(table, 'tr'), function (row) {
        fireNewRow(editor, row.dom());
        each($_bkrvmvm4jk26xkrt.descendants(row, 'th,td'), function (cell) {
          fireNewCell(editor, cell.dom());
        });
      });
    };
    var isPercentage = function isPercentage(width) {
      return isString(width) && width.indexOf('%') !== -1;
    };
    var insert$1 = function insert$1(editor, columns, rows) {
      var defaultStyles = getDefaultStyles(editor);
      var options = {
        styles: defaultStyles,
        attributes: getDefaultAttributes(editor),
        percentages: isPercentage(defaultStyles.width) && !isPixelsForced(editor)
      };
      var table = render$1(rows, columns, 0, 0, options);
      $_8icsmim2jk26xkrh.set(table, 'data-mce-id', '__mce');
      var html = $_eeo0j9p1jk26xldl.getOuter(table);
      editor.insertContent(html);
      return $_at9vkhm7jk26xks8.descendant(getBody$1(editor), 'table[data-mce-id="__mce"]').map(function (table) {
        if (isPixelsForced(editor)) {
          $_4ift9ombjk26xksz.set(table, 'width', $_4ift9ombjk26xksz.get(table, 'width'));
        }
        $_8icsmim2jk26xkrh.remove(table, 'data-mce-id');
        fireEvents(editor, table);
        selectFirstCellInTable(editor, table);
        return table.dom();
      }).getOr(null);
    };
    var $_9ivoqjoyjk26xlcs = { insert: insert$1 };

    function styleTDTH(dom, elm, name, value) {
      if (elm.tagName === 'TD' || elm.tagName === 'TH') {
        dom.setStyle(elm, name, value);
      } else {
        if (elm.children) {
          for (var i = 0; i < elm.children.length; i++) {
            styleTDTH(dom, elm.children[i], name, value);
          }
        }
      }
    }
    var extractDataFromElement$2 = function extractDataFromElement$2(editor, tableElm) {
      var dom = editor.dom;
      var data = {
        width: dom.getStyle(tableElm, 'width') || dom.getAttrib(tableElm, 'width'),
        height: dom.getStyle(tableElm, 'height') || dom.getAttrib(tableElm, 'height'),
        cellspacing: dom.getStyle(tableElm, 'border-spacing') || dom.getAttrib(tableElm, 'cellspacing'),
        cellpadding: dom.getAttrib(tableElm, 'data-mce-cell-padding') || dom.getAttrib(tableElm, 'cellpadding') || $_5l8az7otjk26xlbv.getTDTHOverallStyle(editor.dom, tableElm, 'padding'),
        border: dom.getAttrib(tableElm, 'data-mce-border') || dom.getAttrib(tableElm, 'border') || $_5l8az7otjk26xlbv.getTDTHOverallStyle(editor.dom, tableElm, 'border'),
        borderColor: dom.getAttrib(tableElm, 'data-mce-border-color'),
        caption: !!dom.select('caption', tableElm)[0],
        class: dom.getAttrib(tableElm, 'class')
      };
      global$1.each('left center right'.split(' '), function (name) {
        if (editor.formatter.matchNode(tableElm, 'align' + name)) {
          data.align = name;
        }
      });
      if (hasAdvancedTableTab(editor)) {
        global$1.extend(data, $_a7s7fkoujk26xlby.extractAdvancedStyles(dom, tableElm));
      }
      return data;
    };
    var applyDataToElement = function applyDataToElement(editor, tableElm, data) {
      var dom = editor.dom;
      var attrs = {};
      var styles = {};
      attrs.class = data.class;
      styles.height = addSizeSuffix(data.height);
      if (dom.getAttrib(tableElm, 'width') && !shouldStyleWithCss(editor)) {
        attrs.width = removePxSuffix(data.width);
      } else {
        styles.width = addSizeSuffix(data.width);
      }
      if (shouldStyleWithCss(editor)) {
        styles['border-width'] = addSizeSuffix(data.border);
        styles['border-spacing'] = addSizeSuffix(data.cellspacing);
        global$1.extend(attrs, {
          'data-mce-border-color': data.borderColor,
          'data-mce-cell-padding': data.cellpadding,
          'data-mce-border': data.border
        });
      } else {
        global$1.extend(attrs, {
          border: data.border,
          cellpadding: data.cellpadding,
          cellspacing: data.cellspacing
        });
      }
      if (shouldStyleWithCss(editor)) {
        if (tableElm.children) {
          for (var i = 0; i < tableElm.children.length; i++) {
            styleTDTH(dom, tableElm.children[i], {
              'border-width': addSizeSuffix(data.border),
              'border-color': data.borderColor,
              'padding': addSizeSuffix(data.cellpadding)
            });
          }
        }
      }
      if (data.style) {
        global$1.extend(styles, dom.parseStyle(data.style));
      } else {
        styles = global$1.extend({}, dom.parseStyle(dom.getAttrib(tableElm, 'style')), styles);
      }
      attrs.style = dom.serializeStyle(styles);
      dom.setAttribs(tableElm, attrs);
    };
    var onSubmitTableForm = function onSubmitTableForm(editor, tableElm, evt) {
      var dom = editor.dom;
      var captionElm;
      var data;
      if (hasAdvancedTableTab(editor)) {
        $_a7s7fkoujk26xlby.syncAdvancedStyleFields(editor, evt);
      }
      data = evt.control.rootControl.toJSON();
      if (data.class === false) {
        delete data.class;
      }
      editor.undoManager.transact(function () {
        if (!tableElm) {
          tableElm = $_9ivoqjoyjk26xlcs.insert(editor, data.cols || 1, data.rows || 1);
        }
        applyDataToElement(editor, tableElm, data);
        captionElm = dom.select('caption', tableElm)[0];
        if (captionElm && !data.caption) {
          dom.remove(captionElm);
        }
        if (!captionElm && data.caption) {
          captionElm = dom.create('caption');
          captionElm.innerHTML = !global$2.ie ? '<br data-mce-bogus="1"/>' : '\xA0';
          tableElm.insertBefore(captionElm, tableElm.firstChild);
        }
        $_5l8az7otjk26xlbv.unApplyAlign(editor, tableElm);
        if (data.align) {
          $_5l8az7otjk26xlbv.applyAlign(editor, tableElm, data.align);
        }
        editor.focus();
        editor.addVisual();
      });
    };
    var open$2 = function open$2(editor, isProps) {
      var dom = editor.dom;
      var tableElm,
          colsCtrl,
          rowsCtrl,
          classListCtrl,
          data = {},
          generalTableForm;
      if (isProps === true) {
        tableElm = dom.getParent(editor.selection.getStart(), 'table');
        if (tableElm) {
          data = extractDataFromElement$2(editor, tableElm);
        }
      } else {
        colsCtrl = {
          label: 'Cols',
          name: 'cols'
        };
        rowsCtrl = {
          label: 'Rows',
          name: 'rows'
        };
      }
      if (getTableClassList(editor).length > 0) {
        if (data.class) {
          data.class = data.class.replace(/\s*mce\-item\-table\s*/g, '');
        }
        classListCtrl = {
          name: 'class',
          type: 'listbox',
          label: 'Class',
          values: $_a7s7fkoujk26xlby.buildListItems(getTableClassList(editor), function (item) {
            if (item.value) {
              item.textStyle = function () {
                return editor.formatter.getCssText({
                  block: 'table',
                  classes: [item.value]
                });
              };
            }
          })
        };
      }
      generalTableForm = {
        type: 'form',
        layout: 'flex',
        direction: 'column',
        labelGapCalc: 'children',
        padding: 0,
        items: [{
          type: 'form',
          labelGapCalc: false,
          padding: 0,
          layout: 'grid',
          columns: 2,
          defaults: {
            type: 'textbox',
            maxWidth: 50
          },
          items: hasAppearanceOptions(editor) ? [colsCtrl, rowsCtrl, {
            label: 'Width',
            name: 'width',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }, {
            label: 'Height',
            name: 'height',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }, {
            label: 'Cell spacing',
            name: 'cellspacing'
          }, {
            label: 'Cell padding',
            name: 'cellpadding'
          }, {
            label: 'Border',
            name: 'border'
          }, {
            label: 'Caption',
            name: 'caption',
            type: 'checkbox'
          }] : [colsCtrl, rowsCtrl, {
            label: 'Width',
            name: 'width',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }, {
            label: 'Height',
            name: 'height',
            onchange: curry($_a7s7fkoujk26xlby.updateStyleField, editor)
          }]
        }, {
          label: 'Alignment',
          name: 'align',
          type: 'listbox',
          text: 'None',
          values: [{
            text: 'None',
            value: ''
          }, {
            text: 'Left',
            value: 'left'
          }, {
            text: 'Center',
            value: 'center'
          }, {
            text: 'Right',
            value: 'right'
          }]
        }, classListCtrl]
      };
      if (hasAdvancedTableTab(editor)) {
        editor.windowManager.open({
          title: 'Table properties',
          data: data,
          bodyType: 'tabpanel',
          body: [{
            title: 'General',
            type: 'form',
            items: generalTableForm
          }, $_a7s7fkoujk26xlby.createStyleForm(editor)],
          onsubmit: curry(onSubmitTableForm, editor, tableElm)
        });
      } else {
        editor.windowManager.open({
          title: 'Table properties',
          data: data,
          body: generalTableForm,
          onsubmit: curry(onSubmitTableForm, editor, tableElm)
        });
      }
    };
    var $_5lw1sjowjk26xlce = { open: open$2 };

    var each$3 = global$1.each;
    var registerCommands = function registerCommands(editor, actions, cellSelection, selections, clipboardRows) {
      var isRoot = getIsRoot(editor);
      var eraseTable = function eraseTable() {
        var cell = Element$$1.fromDom(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
        var table = $_3gdghfldjk26xknu.table(cell, isRoot);
        table.filter(not(isRoot)).each(function (table) {
          var cursor = Element$$1.fromText('');
          $_aao88dmdjk26xkte.after(table, cursor);
          $_lmq2lmejk26xktg.remove(table);
          var rng = editor.dom.createRng();
          rng.setStart(cursor.dom(), 0);
          rng.setEnd(cursor.dom(), 0);
          editor.selection.setRng(rng);
        });
      };
      var getSelectionStartCell = function getSelectionStartCell() {
        return Element$$1.fromDom(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
      };
      var getTableFromCell = function getTableFromCell(cell) {
        return $_3gdghfldjk26xknu.table(cell, isRoot);
      };
      var getSize = function getSize(table) {
        return {
          width: getPixelWidth$1(table.dom()),
          height: getPixelWidth$1(table.dom())
        };
      };
      var resizeChange = function resizeChange(editor, oldSize, table) {
        var newSize = getSize(table);
        if (oldSize.width !== newSize.width || oldSize.height !== newSize.height) {
          fireObjectResizeStart(editor, table.dom(), oldSize.width, oldSize.height);
          fireObjectResized(editor, table.dom(), newSize.width, newSize.height);
        }
      };
      var actOnSelection = function actOnSelection(execute) {
        var cell = getSelectionStartCell();
        var table = getTableFromCell(cell);
        table.each(function (table) {
          var targets = $_bzk3jsmnjk26xkv6.forMenu(selections, table, cell);
          var beforeSize = getSize(table);
          execute(table, targets).each(function (rng) {
            resizeChange(editor, beforeSize, table);
            editor.selection.setRng(rng);
            editor.focus();
            cellSelection.clear(table);
            removeDataStyle(table);
          });
        });
      };
      var copyRowSelection = function copyRowSelection(execute) {
        var cell = getSelectionStartCell();
        var table = getTableFromCell(cell);
        return table.bind(function (table) {
          var doc = Element$$1.fromDom(editor.getDoc());
          var targets = $_bzk3jsmnjk26xkv6.forMenu(selections, table, cell);
          var generators = $_cek5a8mgjk26xkto.cellOperations(noop, doc, Option.none());
          return $_dl1snroqjk26xlbk.copyRows(table, targets, generators);
        });
      };
      var pasteOnSelection = function pasteOnSelection(execute) {
        clipboardRows.get().each(function (rows) {
          var clonedRows = map(rows, function (row) {
            return $_e74daamhjk26xkuk.deep(row);
          });
          var cell = getSelectionStartCell();
          var table = getTableFromCell(cell);
          table.bind(function (table) {
            var doc = Element$$1.fromDom(editor.getDoc());
            var generators = $_cek5a8mgjk26xkto.paste(doc);
            var targets = $_bzk3jsmnjk26xkv6.pasteRows(selections, table, cell, clonedRows, generators);
            execute(table, targets).each(function (rng) {
              editor.selection.setRng(rng);
              editor.focus();
              cellSelection.clear(table);
            });
          });
        });
      };
      each$3({
        mceTableSplitCells: function mceTableSplitCells() {
          actOnSelection(actions.unmergeCells);
        },
        mceTableMergeCells: function mceTableMergeCells() {
          actOnSelection(actions.mergeCells);
        },
        mceTableInsertRowBefore: function mceTableInsertRowBefore() {
          actOnSelection(actions.insertRowsBefore);
        },
        mceTableInsertRowAfter: function mceTableInsertRowAfter() {
          actOnSelection(actions.insertRowsAfter);
        },
        mceTableInsertColBefore: function mceTableInsertColBefore() {
          actOnSelection(actions.insertColumnsBefore);
        },
        mceTableInsertColAfter: function mceTableInsertColAfter() {
          actOnSelection(actions.insertColumnsAfter);
        },
        mceTableDeleteCol: function mceTableDeleteCol() {
          actOnSelection(actions.deleteColumn);
        },
        mceTableDeleteRow: function mceTableDeleteRow() {
          actOnSelection(actions.deleteRow);
        },
        mceTableCutRow: function mceTableCutRow(grid) {
          clipboardRows.set(copyRowSelection());
          actOnSelection(actions.deleteRow);
        },
        mceTableCopyRow: function mceTableCopyRow(grid) {
          clipboardRows.set(copyRowSelection());
        },
        mceTablePasteRowBefore: function mceTablePasteRowBefore(grid) {
          pasteOnSelection(actions.pasteRowsBefore);
        },
        mceTablePasteRowAfter: function mceTablePasteRowAfter(grid) {
          pasteOnSelection(actions.pasteRowsAfter);
        },
        mceTableDelete: eraseTable
      }, function (func, name) {
        editor.addCommand(name, func);
      });
      each$3({
        mceInsertTable: curry($_5lw1sjowjk26xlce.open, editor),
        mceTableProps: curry($_5lw1sjowjk26xlce.open, editor, true),
        mceTableRowProps: curry($_7e1z5wovjk26xlc7.open, editor),
        mceTableCellProps: curry($_2mj5woosjk26xlbo.open, editor)
      }, function (func, name) {
        editor.addCommand(name, function (ui, val) {
          func(val);
        });
      });
    };
    var $_35wdkdopjk26xlb2 = { registerCommands: registerCommands };

    var only$1 = function only$1(element) {
      var parent = Option.from(element.dom().documentElement).map(Element$$1.fromDom).getOr(element);
      return {
        parent: constant(parent),
        view: constant(element),
        origin: constant(Position(0, 0))
      };
    };
    var detached = function detached(editable, chrome) {
      var origin = curry($_f7fwegnfjk26xl1w.absolute, chrome);
      return {
        parent: constant(chrome),
        view: constant(editable),
        origin: origin
      };
    };
    var body$1 = function body$1(editable, chrome) {
      return {
        parent: constant(chrome),
        view: constant(editable),
        origin: constant(Position(0, 0))
      };
    };
    var $_3fn9dyp3jk26xldz = {
      only: only$1,
      detached: detached,
      body: body$1
    };

    function Event(fields) {
      var struct = Immutable.apply(null, fields);
      var handlers = [];
      var bind$$1 = function bind$$1(handler) {
        if (handler === undefined) {
          throw 'Event bind error: undefined handler';
        }
        handlers.push(handler);
      };
      var unbind = function unbind(handler) {
        handlers = filter(handlers, function (h) {
          return h !== handler;
        });
      };
      var trigger = function trigger() {
        var event = struct.apply(null, arguments);
        each(handlers, function (handler) {
          handler(event);
        });
      };
      return {
        bind: bind$$1,
        unbind: unbind,
        trigger: trigger
      };
    }

    var create = function create(typeDefs) {
      var registry = map$1(typeDefs, function (event) {
        return {
          bind: event.bind,
          unbind: event.unbind
        };
      });
      var trigger = map$1(typeDefs, function (event) {
        return event.trigger;
      });
      return {
        registry: registry,
        trigger: trigger
      };
    };
    var $_9xqxebp6jk26xler = { create: create };

    var mode = exactly(['compare', 'extract', 'mutate', 'sink']);
    var sink = exactly(['element', 'start', 'stop', 'destroy']);
    var api$3 = exactly(['forceDrop', 'drop', 'move', 'delayDrop']);
    var $_153xqopajk26xlg3 = {
      mode: mode,
      sink: sink,
      api: api$3
    };

    var styles$1 = css('ephox-dragster');
    var $_co7boipcjk26xlgm = { resolve: styles$1.resolve };

    function Blocker(options) {
      var settings = merge$1({ 'layerClass': $_co7boipcjk26xlgm.resolve('blocker') }, options);
      var div = Element$$1.fromTag('div');
      $_8icsmim2jk26xkrh.set(div, 'role', 'presentation');
      $_4ift9ombjk26xksz.setAll(div, {
        position: 'fixed',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%'
      });
      $_6e2uko3jk26xl7l.add(div, $_co7boipcjk26xlgm.resolve('blocker'));
      $_6e2uko3jk26xl7l.add(div, settings.layerClass);
      var element = function element() {
        return div;
      };
      var destroy = function destroy() {
        $_lmq2lmejk26xktg.remove(div);
      };
      return {
        element: element,
        destroy: destroy
      };
    }

    var mkEvent = function mkEvent(target, x, y, stop, prevent, kill, raw) {
      return {
        'target': constant(target),
        'x': constant(x),
        'y': constant(y),
        'stop': stop,
        'prevent': prevent,
        'kill': kill,
        'raw': constant(raw)
      };
    };
    var handle = function handle(filter, handler) {
      return function (rawEvent) {
        if (!filter(rawEvent)) return;
        var target = Element$$1.fromDom(rawEvent.target);
        var stop = function stop() {
          rawEvent.stopPropagation();
        };
        var prevent = function prevent() {
          rawEvent.preventDefault();
        };
        var kill = compose(prevent, stop);
        var evt = mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
        handler(evt);
      };
    };
    var binder = function binder(element, event, filter, handler, useCapture) {
      var wrapped = handle(filter, handler);
      element.dom().addEventListener(event, wrapped, useCapture);
      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
    };
    var bind$1 = function bind$1(element, event, filter, handler) {
      return binder(element, event, filter, handler, false);
    };
    var capture = function capture(element, event, filter, handler) {
      return binder(element, event, filter, handler, true);
    };
    var unbind = function unbind(element, event, handler, useCapture) {
      element.dom().removeEventListener(event, handler, useCapture);
    };
    var $_axk7vapejk26xlgt = {
      bind: bind$1,
      capture: capture
    };

    var filter$1 = constant(true);
    var bind$2 = function bind$2(element, event, handler) {
      return $_axk7vapejk26xlgt.bind(element, event, filter$1, handler);
    };
    var capture$1 = function capture$1(element, event, handler) {
      return $_axk7vapejk26xlgt.capture(element, event, filter$1, handler);
    };
    var $_bztktfpdjk26xlgp = {
      bind: bind$2,
      capture: capture$1
    };

    var compare = function compare(old, nu) {
      return Position(nu.left() - old.left(), nu.top() - old.top());
    };
    var extract$1 = function extract$1(event) {
      return Option.some(Position(event.x(), event.y()));
    };
    var mutate$1 = function mutate$1(mutation, info) {
      mutation.mutate(info.left(), info.top());
    };
    var sink$1 = function sink$1(dragApi, settings) {
      var blocker = Blocker(settings);
      var mdown = $_bztktfpdjk26xlgp.bind(blocker.element(), 'mousedown', dragApi.forceDrop);
      var mup = $_bztktfpdjk26xlgp.bind(blocker.element(), 'mouseup', dragApi.drop);
      var mmove = $_bztktfpdjk26xlgp.bind(blocker.element(), 'mousemove', dragApi.move);
      var mout = $_bztktfpdjk26xlgp.bind(blocker.element(), 'mouseout', dragApi.delayDrop);
      var destroy = function destroy() {
        blocker.destroy();
        mup.unbind();
        mmove.unbind();
        mout.unbind();
        mdown.unbind();
      };
      var start = function start(parent) {
        $_aao88dmdjk26xkte.append(parent, blocker.element());
      };
      var stop = function stop() {
        $_lmq2lmejk26xktg.remove(blocker.element());
      };
      return $_153xqopajk26xlg3.sink({
        element: blocker.element,
        start: start,
        stop: stop,
        destroy: destroy
      });
    };
    var MouseDrag = $_153xqopajk26xlg3.mode({
      compare: compare,
      extract: extract$1,
      sink: sink$1,
      mutate: mutate$1
    });

    function InDrag() {
      var previous = Option.none();
      var reset = function reset() {
        previous = Option.none();
      };
      var update = function update(mode, nu) {
        var result = previous.map(function (old) {
          return mode.compare(old, nu);
        });
        previous = Option.some(nu);
        return result;
      };
      var onEvent = function onEvent(event, mode) {
        var dataOption = mode.extract(event);
        dataOption.each(function (data) {
          var offset = update(mode, data);
          offset.each(function (d) {
            events.trigger.move(d);
          });
        });
      };
      var events = $_9xqxebp6jk26xler.create({ move: Event(['info']) });
      return {
        onEvent: onEvent,
        reset: reset,
        events: events.registry
      };
    }

    function NoDrag(anchor) {
      var onEvent = function onEvent(event, mode) {};
      return {
        onEvent: onEvent,
        reset: noop
      };
    }

    function Movement() {
      var noDragState = NoDrag();
      var inDragState = InDrag();
      var dragState = noDragState;
      var on = function on() {
        dragState.reset();
        dragState = inDragState;
      };
      var off = function off() {
        dragState.reset();
        dragState = noDragState;
      };
      var onEvent = function onEvent(event, mode) {
        dragState.onEvent(event, mode);
      };
      var isOn = function isOn() {
        return dragState === inDragState;
      };
      return {
        on: on,
        off: off,
        isOn: isOn,
        onEvent: onEvent,
        events: inDragState.events
      };
    }

    var last$3 = function last$3(fn, rate) {
      var timer = null;
      var cancel = function cancel() {
        if (timer !== null) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function throttle() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (timer !== null) clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(null, args);
          timer = null;
        }, rate);
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };

    var setup = function setup(mutation, mode, settings) {
      var active = false;
      var events = $_9xqxebp6jk26xler.create({
        start: Event([]),
        stop: Event([])
      });
      var movement = Movement();
      var drop = function drop() {
        sink.stop();
        if (movement.isOn()) {
          movement.off();
          events.trigger.stop();
        }
      };
      var throttledDrop = last$3(drop, 200);
      var go = function go(parent) {
        sink.start(parent);
        movement.on();
        events.trigger.start();
      };
      var mousemove = function mousemove(event, ui) {
        throttledDrop.cancel();
        movement.onEvent(event, mode);
      };
      movement.events.move.bind(function (event) {
        mode.mutate(mutation, event.info());
      });
      var on = function on() {
        active = true;
      };
      var off = function off() {
        active = false;
      };
      var runIfActive = function runIfActive(f) {
        return function () {
          var args = Array.prototype.slice.call(arguments, 0);
          if (active) {
            return f.apply(null, args);
          }
        };
      };
      var sink = mode.sink($_153xqopajk26xlg3.api({
        forceDrop: drop,
        drop: runIfActive(drop),
        move: runIfActive(mousemove),
        delayDrop: runIfActive(throttledDrop.throttle)
      }), settings);
      var destroy = function destroy() {
        sink.destroy();
      };
      return {
        element: sink.element,
        go: go,
        on: on,
        off: off,
        destroy: destroy,
        events: events.registry
      };
    };
    var $_9yd8jdpfjk26xlgx = { setup: setup };

    var transform$1 = function transform$1(mutation, options) {
      var settings = options !== undefined ? options : {};
      var mode = settings.mode !== undefined ? settings.mode : MouseDrag;
      return $_9yd8jdpfjk26xlgx.setup(mutation, mode, options);
    };
    var $_448lusp8jk26xlfp = { transform: transform$1 };

    function Mutation() {
      var events = $_9xqxebp6jk26xler.create({
        'drag': Event(['xDelta', 'yDelta'])
      });
      var mutate = function mutate(x, y) {
        events.trigger.drag(x, y);
      };
      return {
        mutate: mutate,
        events: events.registry
      };
    }

    function BarMutation() {
      var events = $_9xqxebp6jk26xler.create({
        drag: Event(['xDelta', 'yDelta', 'target'])
      });
      var target = Option.none();
      var delegate = Mutation();
      delegate.events.drag.bind(function (event) {
        target.each(function (t) {
          events.trigger.drag(event.xDelta(), event.yDelta(), t);
        });
      });
      var assign = function assign(t) {
        target = Option.some(t);
      };
      var get = function get() {
        return target;
      };
      return {
        assign: assign,
        get: get,
        mutate: delegate.mutate,
        events: events.registry
      };
    }

    var any = function any(selector) {
      return $_at9vkhm7jk26xks8.first(selector).isSome();
    };
    var ancestor$2 = function ancestor$2(scope, selector, isRoot) {
      return $_at9vkhm7jk26xks8.ancestor(scope, selector, isRoot).isSome();
    };
    var sibling$2 = function sibling$2(scope, selector) {
      return $_at9vkhm7jk26xks8.sibling(scope, selector).isSome();
    };
    var child$3 = function child$3(scope, selector) {
      return $_at9vkhm7jk26xks8.child(scope, selector).isSome();
    };
    var descendant$2 = function descendant$2(scope, selector) {
      return $_at9vkhm7jk26xks8.descendant(scope, selector).isSome();
    };
    var closest$2 = function closest$2(scope, selector, isRoot) {
      return $_at9vkhm7jk26xks8.closest(scope, selector, isRoot).isSome();
    };
    var $_7x70wpmjk26xlhx = {
      any: any,
      ancestor: ancestor$2,
      sibling: sibling$2,
      child: child$3,
      descendant: descendant$2,
      closest: closest$2
    };

    var resizeBarDragging = $_8c4u96o1jk26xl7h.resolve('resizer-bar-dragging');
    function BarManager(wire, direction, hdirection) {
      var mutation = BarMutation();
      var resizing = $_448lusp8jk26xlfp.transform(mutation, {});
      var hoverTable = Option.none();
      var getResizer = function getResizer(element, type) {
        return Option.from($_8icsmim2jk26xkrh.get(element, type));
      };
      mutation.events.drag.bind(function (event) {
        getResizer(event.target(), 'data-row').each(function (_dataRow) {
          var currentRow = $_8rs5cuohjk26xl9k.getInt(event.target(), 'top');
          $_4ift9ombjk26xksz.set(event.target(), 'top', currentRow + event.yDelta() + 'px');
        });
        getResizer(event.target(), 'data-column').each(function (_dataCol) {
          var currentCol = $_8rs5cuohjk26xl9k.getInt(event.target(), 'left');
          $_4ift9ombjk26xksz.set(event.target(), 'left', currentCol + event.xDelta() + 'px');
        });
      });
      var getDelta = function getDelta(target, direction) {
        var newX = $_8rs5cuohjk26xl9k.getInt(target, direction);
        var oldX = parseInt($_8icsmim2jk26xkrh.get(target, 'data-initial-' + direction), 10);
        return newX - oldX;
      };
      resizing.events.stop.bind(function () {
        mutation.get().each(function (target) {
          hoverTable.each(function (table) {
            getResizer(target, 'data-row').each(function (row) {
              var delta = getDelta(target, 'top');
              $_8icsmim2jk26xkrh.remove(target, 'data-initial-top');
              events.trigger.adjustHeight(table, delta, parseInt(row, 10));
            });
            getResizer(target, 'data-column').each(function (column) {
              var delta = getDelta(target, 'left');
              $_8icsmim2jk26xkrh.remove(target, 'data-initial-left');
              events.trigger.adjustWidth(table, delta, parseInt(column, 10));
            });
            $_6p8wqgnxjk26xl66.refresh(wire, table, hdirection, direction);
          });
        });
      });
      var handler = function handler(target, direction) {
        events.trigger.startAdjust();
        mutation.assign(target);
        $_8icsmim2jk26xkrh.set(target, 'data-initial-' + direction, parseInt($_4ift9ombjk26xksz.get(target, direction), 10));
        $_6e2uko3jk26xl7l.add(target, resizeBarDragging);
        $_4ift9ombjk26xksz.set(target, 'opacity', '0.2');
        resizing.go(wire.parent());
      };
      var mousedown = $_bztktfpdjk26xlgp.bind(wire.parent(), 'mousedown', function (event) {
        if ($_6p8wqgnxjk26xl66.isRowBar(event.target())) handler(event.target(), 'top');
        if ($_6p8wqgnxjk26xl66.isColBar(event.target())) handler(event.target(), 'left');
      });
      var isRoot = function isRoot(e) {
        return $_5m7qbqlljk26xkq3.eq(e, wire.view());
      };
      var mouseover = $_bztktfpdjk26xlgp.bind(wire.view(), 'mouseover', function (event) {
        if ($_89mq4qm3jk26xkrq.name(event.target()) === 'table' || $_7x70wpmjk26xlhx.closest(event.target(), 'table', isRoot)) {
          hoverTable = $_89mq4qm3jk26xkrq.name(event.target()) === 'table' ? Option.some(event.target()) : $_at9vkhm7jk26xks8.ancestor(event.target(), 'table', isRoot);
          hoverTable.each(function (ht) {
            $_6p8wqgnxjk26xl66.refresh(wire, ht, hdirection, direction);
          });
        } else if ($_9gbjzvm6jk26xkrx.inBody(event.target())) {
          $_6p8wqgnxjk26xl66.destroy(wire);
        }
      });
      var destroy = function destroy() {
        mousedown.unbind();
        mouseover.unbind();
        resizing.destroy();
        $_6p8wqgnxjk26xl66.destroy(wire);
      };
      var refresh = function refresh(tbl) {
        $_6p8wqgnxjk26xl66.refresh(wire, tbl, hdirection, direction);
      };
      var events = $_9xqxebp6jk26xler.create({
        adjustHeight: Event(['table', 'delta', 'row']),
        adjustWidth: Event(['table', 'delta', 'column']),
        startAdjust: Event([])
      });
      return {
        destroy: destroy,
        refresh: refresh,
        on: resizing.on,
        off: resizing.off,
        hideBars: curry($_6p8wqgnxjk26xl66.hide, wire),
        showBars: curry($_6p8wqgnxjk26xl66.show, wire),
        events: events.registry
      };
    }

    function TableResize(wire, vdirection) {
      var hdirection = $_eofvgnejk26xl1e.height;
      var manager = BarManager(wire, vdirection, hdirection);
      var events = $_9xqxebp6jk26xler.create({
        beforeResize: Event(['table']),
        afterResize: Event(['table']),
        startDrag: Event([])
      });
      manager.events.adjustHeight.bind(function (event) {
        events.trigger.beforeResize(event.table());
        var delta = hdirection.delta(event.delta(), event.table());
        $_dc1u2godjk26xl8z.adjustHeight(event.table(), delta, event.row(), hdirection);
        events.trigger.afterResize(event.table());
      });
      manager.events.startAdjust.bind(function (event) {
        events.trigger.startDrag();
      });
      manager.events.adjustWidth.bind(function (event) {
        events.trigger.beforeResize(event.table());
        var delta = vdirection.delta(event.delta(), event.table());
        $_dc1u2godjk26xl8z.adjustWidth(event.table(), delta, event.column(), vdirection);
        events.trigger.afterResize(event.table());
      });
      return {
        on: manager.on,
        off: manager.off,
        hideBars: manager.hideBars,
        showBars: manager.showBars,
        destroy: manager.destroy,
        events: events.registry
      };
    }

    var createContainer = function createContainer() {
      var container = Element$$1.fromTag('div');
      $_4ift9ombjk26xksz.setAll(container, {
        position: 'static',
        height: '0',
        width: '0',
        padding: '0',
        margin: '0',
        border: '0'
      });
      $_aao88dmdjk26xkte.append($_9gbjzvm6jk26xkrx.body(), container);
      return container;
    };
    var get$8 = function get$8(editor, container) {
      return editor.inline ? $_3fn9dyp3jk26xldz.body(getBody$1(editor), createContainer()) : $_3fn9dyp3jk26xldz.only(Element$$1.fromDom(editor.getDoc()));
    };
    var remove$6 = function remove$6(editor, wire) {
      if (editor.inline) {
        $_lmq2lmejk26xktg.remove(wire.parent());
      }
    };
    var $_dpb2fgpnjk26xlhy = {
      get: get$8,
      remove: remove$6
    };

    var ResizeHandler = function ResizeHandler(editor) {
      var selectionRng = Option.none();
      var resize = Option.none();
      var wire = Option.none();
      var percentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
      var startW, startRawW;
      var isTable = function isTable(elm) {
        return elm.nodeName === 'TABLE';
      };
      var getRawWidth = function getRawWidth(elm) {
        return editor.dom.getStyle(elm, 'width') || editor.dom.getAttrib(elm, 'width');
      };
      var lazyResize = function lazyResize() {
        return resize;
      };
      var lazyWire = function lazyWire() {
        return wire.getOr($_3fn9dyp3jk26xldz.only(Element$$1.fromDom(editor.getBody())));
      };
      var destroy = function destroy() {
        resize.each(function (sz) {
          sz.destroy();
        });
        wire.each(function (w) {
          $_dpb2fgpnjk26xlhy.remove(editor, w);
        });
      };
      editor.on('init', function () {
        var direction = TableDirection($_cwid1voljk26xlai.directionAt);
        var rawWire = $_dpb2fgpnjk26xlhy.get(editor);
        wire = Option.some(rawWire);
        if (hasObjectResizing(editor) && hasTableResizeBars(editor)) {
          var sz = TableResize(rawWire, direction);
          sz.on();
          sz.events.startDrag.bind(function (event) {
            selectionRng = Option.some(editor.selection.getRng());
          });
          sz.events.beforeResize.bind(function (event) {
            var rawTable = event.table().dom();
            fireObjectResizeStart(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable));
          });
          sz.events.afterResize.bind(function (event) {
            var table = event.table();
            var rawTable = table.dom();
            removeDataStyle(table);
            selectionRng.each(function (rng) {
              editor.selection.setRng(rng);
              editor.focus();
            });
            fireObjectResized(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable));
            editor.undoManager.add();
          });
          resize = Option.some(sz);
        }
      });
      editor.on('ObjectResizeStart', function (e) {
        var targetElm = e.target;
        if (isTable(targetElm)) {
          startW = e.width;
          startRawW = getRawWidth(targetElm);
        }
      });
      editor.on('ObjectResized', function (e) {
        var targetElm = e.target;
        if (isTable(targetElm)) {
          var table = targetElm;
          if (percentageBasedSizeRegex.test(startRawW)) {
            var percentW = parseFloat(percentageBasedSizeRegex.exec(startRawW)[1]);
            var targetPercentW = e.width * percentW / startW;
            editor.dom.setStyle(table, 'width', targetPercentW + '%');
          } else {
            var newCellSizes_1 = [];
            global$1.each(table.rows, function (row) {
              global$1.each(row.cells, function (cell) {
                var width = editor.dom.getStyle(cell, 'width', true);
                newCellSizes_1.push({
                  cell: cell,
                  width: width
                });
              });
            });
            global$1.each(newCellSizes_1, function (newCellSize) {
              editor.dom.setStyle(newCellSize.cell, 'width', newCellSize.width);
              editor.dom.setAttrib(newCellSize.cell, 'width', null);
            });
          }
        }
      });
      return {
        lazyResize: lazyResize,
        lazyWire: lazyWire,
        destroy: destroy
      };
    };

    var none$2 = function none$2(current) {
      return folder$1(function (n, f, m, l) {
        return n(current);
      });
    };
    var first$5 = function first$5(current) {
      return folder$1(function (n, f, m, l) {
        return f(current);
      });
    };
    var middle$1 = function middle$1(current, target) {
      return folder$1(function (n, f, m, l) {
        return m(current, target);
      });
    };
    var last$4 = function last$4(current) {
      return folder$1(function (n, f, m, l) {
        return l(current);
      });
    };
    var folder$1 = function folder$1(fold) {
      return { fold: fold };
    };
    var $_afchp9pqjk26xlj5 = {
      none: none$2,
      first: first$5,
      middle: middle$1,
      last: last$4
    };

    var detect$4 = function detect$4(current, isRoot) {
      return $_3gdghfldjk26xknu.table(current, isRoot).bind(function (table) {
        var all = $_3gdghfldjk26xknu.cells(table);
        var index = findIndex(all, function (x) {
          return $_5m7qbqlljk26xkq3.eq(current, x);
        });
        return index.map(function (ind) {
          return {
            index: constant(ind),
            all: constant(all)
          };
        });
      });
    };
    var next = function next(current, isRoot) {
      var detection = detect$4(current, isRoot);
      return detection.fold(function () {
        return $_afchp9pqjk26xlj5.none(current);
      }, function (info) {
        return info.index() + 1 < info.all().length ? $_afchp9pqjk26xlj5.middle(current, info.all()[info.index() + 1]) : $_afchp9pqjk26xlj5.last(current);
      });
    };
    var prev = function prev(current, isRoot) {
      var detection = detect$4(current, isRoot);
      return detection.fold(function () {
        return $_afchp9pqjk26xlj5.none();
      }, function (info) {
        return info.index() - 1 >= 0 ? $_afchp9pqjk26xlj5.middle(current, info.all()[info.index() - 1]) : $_afchp9pqjk26xlj5.first(current);
      });
    };
    var $_2j7ckhppjk26xlix = {
      next: next,
      prev: prev
    };

    var adt = Adt.generate([{ 'before': ['element'] }, {
      'on': ['element', 'offset']
    }, { after: ['element'] }]);
    var cata$1 = function cata$1(subject, onBefore, onOn, onAfter) {
      return subject.fold(onBefore, onOn, onAfter);
    };
    var getStart = function getStart(situ) {
      return situ.fold(identity, identity, identity);
    };
    var $_cwkyrepsjk26xljd = {
      before: adt.before,
      on: adt.on,
      after: adt.after,
      cata: cata$1,
      getStart: getStart
    };

    var type$2 = Adt.generate([{ domRange: ['rng'] }, {
      relative: ['startSitu', 'finishSitu']
    }, {
      exact: ['start', 'soffset', 'finish', 'foffset']
    }]);
    var range$2 = Immutable('start', 'soffset', 'finish', 'foffset');
    var exactFromRange = function exactFromRange(simRange) {
      return type$2.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
    };
    var getStart$1 = function getStart$1(selection) {
      return selection.match({
        domRange: function domRange(rng) {
          return Element$$1.fromDom(rng.startContainer);
        },
        relative: function relative(startSitu, finishSitu) {
          return $_cwkyrepsjk26xljd.getStart(startSitu);
        },
        exact: function exact(start, soffset, finish, foffset) {
          return start;
        }
      });
    };
    var getWin = function getWin(selection) {
      var start = getStart$1(selection);
      return $_4uy46mljjk26xkpk.defaultView(start);
    };
    var $_g5okmvprjk26xlj7 = {
      domRange: type$2.domRange,
      relative: type$2.relative,
      exact: type$2.exact,
      exactFromRange: exactFromRange,
      range: range$2,
      getWin: getWin
    };

    var makeRange = function makeRange(start, soffset, finish, foffset) {
      var doc = $_4uy46mljjk26xkpk.owner(start);
      var rng = doc.dom().createRange();
      rng.setStart(start.dom(), soffset);
      rng.setEnd(finish.dom(), foffset);
      return rng;
    };
    var commonAncestorContainer = function commonAncestorContainer(start, soffset, finish, foffset) {
      var r = makeRange(start, soffset, finish, foffset);
      return Element$$1.fromDom(r.commonAncestorContainer);
    };
    var after$2 = function after$2(start, soffset, finish, foffset) {
      var r = makeRange(start, soffset, finish, foffset);
      var same = $_5m7qbqlljk26xkq3.eq(start, finish) && soffset === foffset;
      return r.collapsed && !same;
    };
    var $_dygaitpujk26xljp = {
      after: after$2,
      commonAncestorContainer: commonAncestorContainer
    };

    var fromElements = function fromElements(elements, scope) {
      var doc = scope || document;
      var fragment = doc.createDocumentFragment();
      each(elements, function (element) {
        fragment.appendChild(element.dom());
      });
      return Element$$1.fromDom(fragment);
    };
    var $_7z4dj1pvjk26xljr = { fromElements: fromElements };

    var selectNodeContents = function selectNodeContents(win, element) {
      var rng = win.document.createRange();
      selectNodeContentsUsing(rng, element);
      return rng;
    };
    var selectNodeContentsUsing = function selectNodeContentsUsing(rng, element) {
      rng.selectNodeContents(element.dom());
    };
    var isWithin$1 = function isWithin$1(outerRange, innerRange) {
      return innerRange.compareBoundaryPoints(outerRange.END_TO_START, outerRange) < 1 && innerRange.compareBoundaryPoints(outerRange.START_TO_END, outerRange) > -1;
    };
    var create$1 = function create$1(win) {
      return win.document.createRange();
    };
    var setStart = function setStart(rng, situ) {
      situ.fold(function (e) {
        rng.setStartBefore(e.dom());
      }, function (e, o) {
        rng.setStart(e.dom(), o);
      }, function (e) {
        rng.setStartAfter(e.dom());
      });
    };
    var setFinish = function setFinish(rng, situ) {
      situ.fold(function (e) {
        rng.setEndBefore(e.dom());
      }, function (e, o) {
        rng.setEnd(e.dom(), o);
      }, function (e) {
        rng.setEndAfter(e.dom());
      });
    };
    var replaceWith = function replaceWith(rng, fragment) {
      deleteContents(rng);
      rng.insertNode(fragment.dom());
    };
    var relativeToNative = function relativeToNative(win, startSitu, finishSitu) {
      var range = win.document.createRange();
      setStart(range, startSitu);
      setFinish(range, finishSitu);
      return range;
    };
    var exactToNative = function exactToNative(win, start, soffset, finish, foffset) {
      var rng = win.document.createRange();
      rng.setStart(start.dom(), soffset);
      rng.setEnd(finish.dom(), foffset);
      return rng;
    };
    var deleteContents = function deleteContents(rng) {
      rng.deleteContents();
    };
    var cloneFragment = function cloneFragment(rng) {
      var fragment = rng.cloneContents();
      return Element$$1.fromDom(fragment);
    };
    var toRect = function toRect(rect) {
      return {
        left: constant(rect.left),
        top: constant(rect.top),
        right: constant(rect.right),
        bottom: constant(rect.bottom),
        width: constant(rect.width),
        height: constant(rect.height)
      };
    };
    var getFirstRect = function getFirstRect(rng) {
      var rects = rng.getClientRects();
      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 ? Option.some(rect).map(toRect) : Option.none();
    };
    var getBounds$1 = function getBounds$1(rng) {
      var rect = rng.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 ? Option.some(rect).map(toRect) : Option.none();
    };
    var toString = function toString(rng) {
      return rng.toString();
    };
    var $_7sp7hepwjk26xljw = {
      create: create$1,
      replaceWith: replaceWith,
      selectNodeContents: selectNodeContents,
      selectNodeContentsUsing: selectNodeContentsUsing,
      relativeToNative: relativeToNative,
      exactToNative: exactToNative,
      deleteContents: deleteContents,
      cloneFragment: cloneFragment,
      getFirstRect: getFirstRect,
      getBounds: getBounds$1,
      isWithin: isWithin$1,
      toString: toString
    };

    var adt$1 = Adt.generate([{
      ltr: ['start', 'soffset', 'finish', 'foffset']
    }, {
      rtl: ['start', 'soffset', 'finish', 'foffset']
    }]);
    var fromRange = function fromRange(win, type, range) {
      return type(Element$$1.fromDom(range.startContainer), range.startOffset, Element$$1.fromDom(range.endContainer), range.endOffset);
    };
    var getRanges = function getRanges(win, selection) {
      return selection.match({
        domRange: function domRange(rng) {
          return {
            ltr: constant(rng),
            rtl: Option.none
          };
        },
        relative: function relative(startSitu, finishSitu) {
          return {
            ltr: cached(function () {
              return $_7sp7hepwjk26xljw.relativeToNative(win, startSitu, finishSitu);
            }),
            rtl: cached(function () {
              return Option.some($_7sp7hepwjk26xljw.relativeToNative(win, finishSitu, startSitu));
            })
          };
        },
        exact: function exact(start, soffset, finish, foffset) {
          return {
            ltr: cached(function () {
              return $_7sp7hepwjk26xljw.exactToNative(win, start, soffset, finish, foffset);
            }),
            rtl: cached(function () {
              return Option.some($_7sp7hepwjk26xljw.exactToNative(win, finish, foffset, start, soffset));
            })
          };
        }
      });
    };
    var doDiagnose = function doDiagnose(win, ranges) {
      var rng = ranges.ltr();
      if (rng.collapsed) {
        var reversed = ranges.rtl().filter(function (rev) {
          return rev.collapsed === false;
        });
        return reversed.map(function (rev) {
          return adt$1.rtl(Element$$1.fromDom(rev.endContainer), rev.endOffset, Element$$1.fromDom(rev.startContainer), rev.startOffset);
        }).getOrThunk(function () {
          return fromRange(win, adt$1.ltr, rng);
        });
      } else {
        return fromRange(win, adt$1.ltr, rng);
      }
    };
    var diagnose = function diagnose(win, selection) {
      var ranges = getRanges(win, selection);
      return doDiagnose(win, ranges);
    };
    var asLtrRange = function asLtrRange(win, selection) {
      var diagnosis = diagnose(win, selection);
      return diagnosis.match({
        ltr: function ltr(start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(start.dom(), soffset);
          rng.setEnd(finish.dom(), foffset);
          return rng;
        },
        rtl: function rtl(start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(finish.dom(), foffset);
          rng.setEnd(start.dom(), soffset);
          return rng;
        }
      });
    };
    var $_1lyg6bpxjk26xlk5 = {
      ltr: adt$1.ltr,
      rtl: adt$1.rtl,
      diagnose: diagnose,
      asLtrRange: asLtrRange
    };

    var searchForPoint = function searchForPoint(rectForOffset, x, y, maxX, length) {
      if (length === 0) return 0;else if (x === maxX) return length - 1;
      var xDelta = maxX;
      for (var i = 1; i < length; i++) {
        var rect = rectForOffset(i);
        var curDeltaX = Math.abs(x - rect.left);
        if (y <= rect.bottom) {
          if (y < rect.top || curDeltaX > xDelta) {
            return i - 1;
          } else {
            xDelta = curDeltaX;
          }
        }
      }
      return 0;
    };
    var inRect = function inRect(rect, x, y) {
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    };
    var $_3jcpzbq0jk26xlkx = {
      inRect: inRect,
      searchForPoint: searchForPoint
    };

    var locateOffset = function locateOffset(doc, textnode, x, y, rect) {
      var rangeForOffset = function rangeForOffset(offset) {
        var r = doc.dom().createRange();
        r.setStart(textnode.dom(), offset);
        r.collapse(true);
        return r;
      };
      var rectForOffset = function rectForOffset(offset) {
        var r = rangeForOffset(offset);
        return r.getBoundingClientRect();
      };
      var length = $_2rujnemkjk26xkuu.get(textnode).length;
      var offset = $_3jcpzbq0jk26xlkx.searchForPoint(rectForOffset, x, y, rect.right, length);
      return rangeForOffset(offset);
    };
    var locate = function locate(doc, node, x, y) {
      var r = doc.dom().createRange();
      r.selectNode(node.dom());
      var rects = r.getClientRects();
      var foundRect = findMap(rects, function (rect) {
        return $_3jcpzbq0jk26xlkx.inRect(rect, x, y) ? Option.some(rect) : Option.none();
      });
      return foundRect.map(function (rect) {
        return locateOffset(doc, node, x, y, rect);
      });
    };
    var $_be4kfmq1jk26xlky = { locate: locate };

    var searchInChildren = function searchInChildren(doc, node, x, y) {
      var r = doc.dom().createRange();
      var nodes = $_4uy46mljjk26xkpk.children(node);
      return findMap(nodes, function (n) {
        r.selectNode(n.dom());
        return $_3jcpzbq0jk26xlkx.inRect(r.getBoundingClientRect(), x, y) ? locateNode(doc, n, x, y) : Option.none();
      });
    };
    var locateNode = function locateNode(doc, node, x, y) {
      var locator = $_89mq4qm3jk26xkrq.isText(node) ? $_be4kfmq1jk26xlky.locate : searchInChildren;
      return locator(doc, node, x, y);
    };
    var locate$1 = function locate$1(doc, node, x, y) {
      var r = doc.dom().createRange();
      r.selectNode(node.dom());
      var rect = r.getBoundingClientRect();
      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
      return locateNode(doc, node, boundedX, boundedY);
    };
    var $_2os3oepzjk26xlkq = { locate: locate$1 };

    var COLLAPSE_TO_LEFT = true;
    var COLLAPSE_TO_RIGHT = false;
    var getCollapseDirection = function getCollapseDirection(rect, x) {
      return x - rect.left < rect.right - x ? COLLAPSE_TO_LEFT : COLLAPSE_TO_RIGHT;
    };
    var createCollapsedNode = function createCollapsedNode(doc, target, collapseDirection) {
      var r = doc.dom().createRange();
      r.selectNode(target.dom());
      r.collapse(collapseDirection);
      return r;
    };
    var locateInElement = function locateInElement(doc, node, x) {
      var cursorRange = doc.dom().createRange();
      cursorRange.selectNode(node.dom());
      var rect = cursorRange.getBoundingClientRect();
      var collapseDirection = getCollapseDirection(rect, x);
      var f = collapseDirection === COLLAPSE_TO_LEFT ? $_bqyx5vmijk26xkun.first : $_bqyx5vmijk26xkun.last;
      return f(node).map(function (target) {
        return createCollapsedNode(doc, target, collapseDirection);
      });
    };
    var locateInEmpty = function locateInEmpty(doc, node, x) {
      var rect = node.dom().getBoundingClientRect();
      var collapseDirection = getCollapseDirection(rect, x);
      return Option.some(createCollapsedNode(doc, node, collapseDirection));
    };
    var search = function search(doc, node, x) {
      var f = $_4uy46mljjk26xkpk.children(node).length === 0 ? locateInEmpty : locateInElement;
      return f(doc, node, x);
    };
    var $_6mrs7wq2jk26xll5 = { search: search };

    var caretPositionFromPoint = function caretPositionFromPoint(doc, x, y) {
      return Option.from(doc.dom().caretPositionFromPoint(x, y)).bind(function (pos) {
        if (pos.offsetNode === null) return Option.none();
        var r = doc.dom().createRange();
        r.setStart(pos.offsetNode, pos.offset);
        r.collapse();
        return Option.some(r);
      });
    };
    var caretRangeFromPoint = function caretRangeFromPoint(doc, x, y) {
      return Option.from(doc.dom().caretRangeFromPoint(x, y));
    };
    var searchTextNodes = function searchTextNodes(doc, node, x, y) {
      var r = doc.dom().createRange();
      r.selectNode(node.dom());
      var rect = r.getBoundingClientRect();
      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
      return $_2os3oepzjk26xlkq.locate(doc, node, boundedX, boundedY);
    };
    var searchFromPoint = function searchFromPoint(doc, x, y) {
      return Element$$1.fromPoint(doc, x, y).bind(function (elem) {
        var fallback = function fallback() {
          return $_6mrs7wq2jk26xll5.search(doc, elem, x);
        };
        return $_4uy46mljjk26xkpk.children(elem).length === 0 ? fallback() : searchTextNodes(doc, elem, x, y).orThunk(fallback);
      });
    };
    var availableSearch = document.caretPositionFromPoint ? caretPositionFromPoint : document.caretRangeFromPoint ? caretRangeFromPoint : searchFromPoint;
    var fromPoint$1 = function fromPoint$1(win, x, y) {
      var doc = Element$$1.fromDom(win.document);
      return availableSearch(doc, x, y).map(function (rng) {
        return $_g5okmvprjk26xlj7.range(Element$$1.fromDom(rng.startContainer), rng.startOffset, Element$$1.fromDom(rng.endContainer), rng.endOffset);
      });
    };
    var $_dacvddpyjk26xlkm = { fromPoint: fromPoint$1 };

    var withinContainer = function withinContainer(win, ancestor, outerRange, selector) {
      var innerRange = $_7sp7hepwjk26xljw.create(win);
      var self = $_1asaomlfjk26xkos.is(ancestor, selector) ? [ancestor] : [];
      var elements = self.concat($_bkrvmvm4jk26xkrt.descendants(ancestor, selector));
      return filter(elements, function (elem) {
        $_7sp7hepwjk26xljw.selectNodeContentsUsing(innerRange, elem);
        return $_7sp7hepwjk26xljw.isWithin(outerRange, innerRange);
      });
    };
    var find$3 = function find$3(win, selection, selector) {
      var outerRange = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      var ancestor = Element$$1.fromDom(outerRange.commonAncestorContainer);
      return $_89mq4qm3jk26xkrq.isElement(ancestor) ? withinContainer(win, ancestor, outerRange, selector) : [];
    };
    var $_50fa53q3jk26xll9 = { find: find$3 };

    var beforeSpecial = function beforeSpecial(element, offset) {
      var name = $_89mq4qm3jk26xkrq.name(element);
      if ('input' === name) return $_cwkyrepsjk26xljd.after(element);else if (!contains(['br', 'img'], name)) return $_cwkyrepsjk26xljd.on(element, offset);else return offset === 0 ? $_cwkyrepsjk26xljd.before(element) : $_cwkyrepsjk26xljd.after(element);
    };
    var preprocessRelative = function preprocessRelative(startSitu, finishSitu) {
      var start = startSitu.fold($_cwkyrepsjk26xljd.before, beforeSpecial, $_cwkyrepsjk26xljd.after);
      var finish = finishSitu.fold($_cwkyrepsjk26xljd.before, beforeSpecial, $_cwkyrepsjk26xljd.after);
      return $_g5okmvprjk26xlj7.relative(start, finish);
    };
    var preprocessExact = function preprocessExact(start, soffset, finish, foffset) {
      var startSitu = beforeSpecial(start, soffset);
      var finishSitu = beforeSpecial(finish, foffset);
      return $_g5okmvprjk26xlj7.relative(startSitu, finishSitu);
    };
    var preprocess = function preprocess(selection) {
      return selection.match({
        domRange: function domRange(rng) {
          var start = Element$$1.fromDom(rng.startContainer);
          var finish = Element$$1.fromDom(rng.endContainer);
          return preprocessExact(start, rng.startOffset, finish, rng.endOffset);
        },
        relative: preprocessRelative,
        exact: preprocessExact
      });
    };
    var $_9omanpq4jk26xlle = {
      beforeSpecial: beforeSpecial,
      preprocess: preprocess,
      preprocessRelative: preprocessRelative,
      preprocessExact: preprocessExact
    };

    var doSetNativeRange = function doSetNativeRange(win, rng) {
      Option.from(win.getSelection()).each(function (selection) {
        selection.removeAllRanges();
        selection.addRange(rng);
      });
    };
    var doSetRange = function doSetRange(win, start, soffset, finish, foffset) {
      var rng = $_7sp7hepwjk26xljw.exactToNative(win, start, soffset, finish, foffset);
      doSetNativeRange(win, rng);
    };
    var findWithin = function findWithin(win, selection, selector) {
      return $_50fa53q3jk26xll9.find(win, selection, selector);
    };
    var setLegacyRtlRange = function setLegacyRtlRange(win, selection, start, soffset, finish, foffset) {
      selection.collapse(start.dom(), soffset);
      selection.extend(finish.dom(), foffset);
    };
    var setRangeFromRelative = function setRangeFromRelative(win, relative) {
      return $_1lyg6bpxjk26xlk5.diagnose(win, relative).match({
        ltr: function ltr(start, soffset, finish, foffset) {
          doSetRange(win, start, soffset, finish, foffset);
        },
        rtl: function rtl(start, soffset, finish, foffset) {
          var selection = win.getSelection();
          if (selection.setBaseAndExtent) {
            selection.setBaseAndExtent(start.dom(), soffset, finish.dom(), foffset);
          } else if (selection.extend) {
            try {
              setLegacyRtlRange(win, selection, start, soffset, finish, foffset);
            } catch (e) {
              doSetRange(win, finish, foffset, start, soffset);
            }
          } else {
            doSetRange(win, finish, foffset, start, soffset);
          }
        }
      });
    };
    var setExact = function setExact(win, start, soffset, finish, foffset) {
      var relative = $_9omanpq4jk26xlle.preprocessExact(start, soffset, finish, foffset);
      setRangeFromRelative(win, relative);
    };
    var setRelative = function setRelative(win, startSitu, finishSitu) {
      var relative = $_9omanpq4jk26xlle.preprocessRelative(startSitu, finishSitu);
      setRangeFromRelative(win, relative);
    };
    var toNative = function toNative(selection) {
      var win = $_g5okmvprjk26xlj7.getWin(selection).dom();
      var getDomRange = function getDomRange(start, soffset, finish, foffset) {
        return $_7sp7hepwjk26xljw.exactToNative(win, start, soffset, finish, foffset);
      };
      var filtered = $_9omanpq4jk26xlle.preprocess(selection);
      return $_1lyg6bpxjk26xlk5.diagnose(win, filtered).match({
        ltr: getDomRange,
        rtl: getDomRange
      });
    };
    var readRange = function readRange(selection) {
      if (selection.rangeCount > 0) {
        var firstRng = selection.getRangeAt(0);
        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
        return Option.some($_g5okmvprjk26xlj7.range(Element$$1.fromDom(firstRng.startContainer), firstRng.startOffset, Element$$1.fromDom(lastRng.endContainer), lastRng.endOffset));
      } else {
        return Option.none();
      }
    };
    var doGetExact = function doGetExact(selection) {
      var anchorNode = Element$$1.fromDom(selection.anchorNode);
      var focusNode = Element$$1.fromDom(selection.focusNode);
      return $_dygaitpujk26xljp.after(anchorNode, selection.anchorOffset, focusNode, selection.focusOffset) ? Option.some($_g5okmvprjk26xlj7.range(Element$$1.fromDom(selection.anchorNode), selection.anchorOffset, Element$$1.fromDom(selection.focusNode), selection.focusOffset)) : readRange(selection);
    };
    var setToElement = function setToElement(win, element) {
      var rng = $_7sp7hepwjk26xljw.selectNodeContents(win, element);
      doSetNativeRange(win, rng);
    };
    var forElement = function forElement(win, element) {
      var rng = $_7sp7hepwjk26xljw.selectNodeContents(win, element);
      return $_g5okmvprjk26xlj7.range(Element$$1.fromDom(rng.startContainer), rng.startOffset, Element$$1.fromDom(rng.endContainer), rng.endOffset);
    };
    var getExact = function getExact(win) {
      return Option.from(win.getSelection()).filter(function (sel) {
        return sel.rangeCount > 0;
      }).bind(doGetExact);
    };
    var get$9 = function get$9(win) {
      return getExact(win).map(function (range) {
        return $_g5okmvprjk26xlj7.exact(range.start(), range.soffset(), range.finish(), range.foffset());
      });
    };
    var getFirstRect$1 = function getFirstRect$1(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      return $_7sp7hepwjk26xljw.getFirstRect(rng);
    };
    var getBounds$2 = function getBounds$2(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      return $_7sp7hepwjk26xljw.getBounds(rng);
    };
    var getAtPoint = function getAtPoint(win, x, y) {
      return $_dacvddpyjk26xlkm.fromPoint(win, x, y);
    };
    var getAsString = function getAsString(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      return $_7sp7hepwjk26xljw.toString(rng);
    };
    var clear$1 = function clear$1(win) {
      var selection = win.getSelection();
      selection.removeAllRanges();
    };
    var clone$2 = function clone$2(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      return $_7sp7hepwjk26xljw.cloneFragment(rng);
    };
    var replace$1 = function replace$1(win, selection, elements) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      var fragment = $_7z4dj1pvjk26xljr.fromElements(elements, win.document);
      $_7sp7hepwjk26xljw.replaceWith(rng, fragment);
    };
    var deleteAt = function deleteAt(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      $_7sp7hepwjk26xljw.deleteContents(rng);
    };
    var isCollapsed = function isCollapsed(start, soffset, finish, foffset) {
      return $_5m7qbqlljk26xkq3.eq(start, finish) && soffset === foffset;
    };
    var $_tnmtyptjk26xljj = {
      setExact: setExact,
      getExact: getExact,
      get: get$9,
      setRelative: setRelative,
      toNative: toNative,
      setToElement: setToElement,
      clear: clear$1,
      clone: clone$2,
      replace: replace$1,
      deleteAt: deleteAt,
      forElement: forElement,
      getFirstRect: getFirstRect$1,
      getBounds: getBounds$2,
      getAtPoint: getAtPoint,
      findWithin: findWithin,
      getAsString: getAsString,
      isCollapsed: isCollapsed
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var forward = function forward(editor, isRoot, cell, lazyWire) {
      return go(editor, isRoot, $_2j7ckhppjk26xlix.next(cell), lazyWire);
    };
    var backward = function backward(editor, isRoot, cell, lazyWire) {
      return go(editor, isRoot, $_2j7ckhppjk26xlix.prev(cell), lazyWire);
    };
    var getCellFirstCursorPosition = function getCellFirstCursorPosition(editor, cell) {
      var selection = $_g5okmvprjk26xlj7.exact(cell, 0, cell, 0);
      return $_tnmtyptjk26xljj.toNative(selection);
    };
    var getNewRowCursorPosition = function getNewRowCursorPosition(editor, table) {
      var rows = $_bkrvmvm4jk26xkrt.descendants(table, 'tr');
      return last(rows).bind(function (last$$1) {
        return $_at9vkhm7jk26xks8.descendant(last$$1, 'td,th').map(function (first) {
          return getCellFirstCursorPosition(editor, first);
        });
      });
    };
    var go = function go(editor, isRoot, cell, actions, lazyWire) {
      return cell.fold(Option.none, Option.none, function (current, next) {
        return $_bqyx5vmijk26xkun.first(next).map(function (cell) {
          return getCellFirstCursorPosition(editor, cell);
        });
      }, function (current) {
        return $_3gdghfldjk26xknu.table(current, isRoot).bind(function (table) {
          var targets = $_bzk3jsmnjk26xkv6.noMenu(current);
          editor.undoManager.transact(function () {
            actions.insertRowsAfter(table, targets);
          });
          return getNewRowCursorPosition(editor, table);
        });
      });
    };
    var rootElements = ['table', 'li', 'dl'];
    var handle$1 = function handle$1(event, editor, actions, lazyWire) {
      if (event.keyCode === global$3.TAB) {
        var body_1 = getBody$1(editor);
        var isRoot_1 = function isRoot_1(element) {
          var name = $_89mq4qm3jk26xkrq.name(element);
          return $_5m7qbqlljk26xkq3.eq(element, body_1) || contains(rootElements, name);
        };
        var rng = editor.selection.getRng();
        if (rng.collapsed) {
          var start = Element$$1.fromDom(rng.startContainer);
          $_3gdghfldjk26xknu.cell(start, isRoot_1).each(function (cell) {
            event.preventDefault();
            var navigation = event.shiftKey ? backward : forward;
            var rng = navigation(editor, isRoot_1, cell, actions, lazyWire);
            rng.each(function (range$$1) {
              editor.selection.setRng(range$$1);
            });
          });
        }
      }
    };
    var $_8kfcsipojk26xlid = { handle: handle$1 };

    var response = Immutable('selection', 'kill');
    var $_50rco2q8jk26xlms = { response: response };

    var isKey = function isKey(key) {
      return function (keycode) {
        return keycode === key;
      };
    };
    var isUp = isKey(38);
    var isDown = isKey(40);
    var isNavigation = function isNavigation(keycode) {
      return keycode >= 37 && keycode <= 40;
    };
    var $_co3ifpq9jk26xlmv = {
      ltr: {
        isBackward: isKey(37),
        isForward: isKey(39)
      },
      rtl: {
        isBackward: isKey(39),
        isForward: isKey(37)
      },
      isUp: isUp,
      isDown: isDown,
      isNavigation: isNavigation
    };

    var convertToRange = function convertToRange(win, selection) {
      var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, selection);
      return {
        start: constant(Element$$1.fromDom(rng.startContainer)),
        soffset: constant(rng.startOffset),
        finish: constant(Element$$1.fromDom(rng.endContainer)),
        foffset: constant(rng.endOffset)
      };
    };
    var makeSitus = function makeSitus(start, soffset, finish, foffset) {
      return {
        start: constant($_cwkyrepsjk26xljd.on(start, soffset)),
        finish: constant($_cwkyrepsjk26xljd.on(finish, foffset))
      };
    };
    var $_ag2gpeqbjk26xlnc = {
      convertToRange: convertToRange,
      makeSitus: makeSitus
    };

    var isSafari = $_aj4ie4lqjk26xkqk.detect().browser.isSafari();
    var get$10 = function get$10(_doc) {
      var doc = _doc !== undefined ? _doc.dom() : document;
      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
      return Position(x, y);
    };
    var to = function to(x, y, _doc) {
      var doc = _doc !== undefined ? _doc.dom() : document;
      var win = doc.defaultView;
      win.scrollTo(x, y);
    };
    var by = function by(x, y, _doc) {
      var doc = _doc !== undefined ? _doc.dom() : document;
      var win = doc.defaultView;
      win.scrollBy(x, y);
    };
    var setToElement$1 = function setToElement$1(win, element) {
      var pos = $_f7fwegnfjk26xl1w.absolute(element);
      var doc = Element$$1.fromDom(win.document);
      to(pos.left(), pos.top(), doc);
    };
    var preserve$1 = function preserve$1(doc, f) {
      var before = get$10(doc);
      f();
      var after = get$10(doc);
      if (before.top() !== after.top() || before.left() !== after.left()) {
        to(before.left(), before.top(), doc);
      }
    };
    var capture$2 = function capture$2(doc) {
      var previous = Option.none();
      var save = function save() {
        previous = Option.some(get$10(doc));
      };
      var restore = function restore() {
        previous.each(function (p) {
          to(p.left(), p.top(), doc);
        });
      };
      save();
      return {
        save: save,
        restore: restore
      };
    };
    var intoView = function intoView(element, alignToTop) {
      if (isSafari && isFunction(element.dom().scrollIntoViewIfNeeded)) {
        element.dom().scrollIntoViewIfNeeded(false);
      } else {
        element.dom().scrollIntoView(alignToTop);
      }
    };
    var intoViewIfNeeded = function intoViewIfNeeded(element, container) {
      var containerBox = container.dom().getBoundingClientRect();
      var elementBox = element.dom().getBoundingClientRect();
      if (elementBox.top < containerBox.top) {
        intoView(element, true);
      } else if (elementBox.bottom > containerBox.bottom) {
        intoView(element, false);
      }
    };
    var scrollBarWidth = function scrollBarWidth() {
      var scrollDiv = Element$$1.fromHtml('<div style="width: 100px; height: 100px; overflow: scroll; position: absolute; top: -9999px;"></div>');
      $_aao88dmdjk26xkte.after($_9gbjzvm6jk26xkrx.body(), scrollDiv);
      var w = scrollDiv.dom().offsetWidth - scrollDiv.dom().clientWidth;
      $_lmq2lmejk26xktg.remove(scrollDiv);
      return w;
    };
    var $_391tpkqcjk26xlnl = {
      get: get$10,
      to: to,
      by: by,
      preserve: preserve$1,
      capture: capture$2,
      intoView: intoView,
      intoViewIfNeeded: intoViewIfNeeded,
      setToElement: setToElement$1,
      scrollBarWidth: scrollBarWidth
    };

    function WindowBridge(win) {
      var elementFromPoint = function elementFromPoint(x, y) {
        return Element$$1.fromPoint(Element$$1.fromDom(win.document), x, y);
      };
      var getRect = function getRect(element) {
        return element.dom().getBoundingClientRect();
      };
      var getRangedRect = function getRangedRect(start, soffset, finish, foffset) {
        var sel = $_g5okmvprjk26xlj7.exact(start, soffset, finish, foffset);
        return $_tnmtyptjk26xljj.getFirstRect(win, sel).map(function (structRect) {
          return map$1(structRect, apply);
        });
      };
      var getSelection = function getSelection() {
        return $_tnmtyptjk26xljj.get(win).map(function (exactAdt) {
          return $_ag2gpeqbjk26xlnc.convertToRange(win, exactAdt);
        });
      };
      var fromSitus = function fromSitus(situs) {
        var relative = $_g5okmvprjk26xlj7.relative(situs.start(), situs.finish());
        return $_ag2gpeqbjk26xlnc.convertToRange(win, relative);
      };
      var situsFromPoint = function situsFromPoint(x, y) {
        return $_tnmtyptjk26xljj.getAtPoint(win, x, y).map(function (exact) {
          return {
            start: constant($_cwkyrepsjk26xljd.on(exact.start(), exact.soffset())),
            finish: constant($_cwkyrepsjk26xljd.on(exact.finish(), exact.foffset()))
          };
        });
      };
      var clearSelection = function clearSelection() {
        $_tnmtyptjk26xljj.clear(win);
      };
      var selectContents = function selectContents(element) {
        $_tnmtyptjk26xljj.setToElement(win, element);
      };
      var setSelection = function setSelection(sel) {
        $_tnmtyptjk26xljj.setExact(win, sel.start(), sel.soffset(), sel.finish(), sel.foffset());
      };
      var setRelativeSelection = function setRelativeSelection(start, finish) {
        $_tnmtyptjk26xljj.setRelative(win, start, finish);
      };
      var getInnerHeight = function getInnerHeight() {
        return win.innerHeight;
      };
      var getScrollY = function getScrollY() {
        var pos = $_391tpkqcjk26xlnl.get(Element$$1.fromDom(win.document));
        return pos.top();
      };
      var scrollBy = function scrollBy(x, y) {
        $_391tpkqcjk26xlnl.by(x, y, Element$$1.fromDom(win.document));
      };
      return {
        elementFromPoint: elementFromPoint,
        getRect: getRect,
        getRangedRect: getRangedRect,
        getSelection: getSelection,
        fromSitus: fromSitus,
        situsFromPoint: situsFromPoint,
        clearSelection: clearSelection,
        setSelection: setSelection,
        setRelativeSelection: setRelativeSelection,
        selectContents: selectContents,
        getInnerHeight: getInnerHeight,
        getScrollY: getScrollY,
        scrollBy: scrollBy
      };
    }

    var sync = function sync(container, isRoot, start, soffset, finish, foffset, selectRange) {
      if (!($_5m7qbqlljk26xkq3.eq(start, finish) && soffset === foffset)) {
        return $_at9vkhm7jk26xks8.closest(start, 'td,th', isRoot).bind(function (s) {
          return $_at9vkhm7jk26xks8.closest(finish, 'td,th', isRoot).bind(function (f) {
            return detect$5(container, isRoot, s, f, selectRange);
          });
        });
      } else {
        return Option.none();
      }
    };
    var detect$5 = function detect$5(container, isRoot, start, finish, selectRange) {
      if (!$_5m7qbqlljk26xkq3.eq(start, finish)) {
        return $_5a1ieomqjk26xkw2.identify(start, finish, isRoot).bind(function (cellSel) {
          var boxes = cellSel.boxes().getOr([]);
          if (boxes.length > 0) {
            selectRange(container, boxes, cellSel.start(), cellSel.finish());
            return Option.some($_50rco2q8jk26xlms.response(Option.some($_ag2gpeqbjk26xlnc.makeSitus(start, 0, start, $_v3k82mjjk26xkuq.getEnd(start))), true));
          } else {
            return Option.none();
          }
        });
      } else {
        return Option.none();
      }
    };
    var update = function update(rows, columns, container, selected, annotations) {
      var updateSelection = function updateSelection(newSels) {
        annotations.clear(container);
        annotations.selectRange(container, newSels.boxes(), newSels.start(), newSels.finish());
        return newSels.boxes();
      };
      return $_5a1ieomqjk26xkw2.shiftSelection(selected, rows, columns, annotations.firstSelectedSelector(), annotations.lastSelectedSelector()).map(updateSelection);
    };
    var $_30l16tqdjk26xlnw = {
      sync: sync,
      detect: detect$5,
      update: update
    };

    var nu$3 = MixedBag(['left', 'top', 'right', 'bottom'], []);
    var moveDown = function moveDown(caret, amount) {
      return nu$3({
        left: caret.left(),
        top: caret.top() + amount,
        right: caret.right(),
        bottom: caret.bottom() + amount
      });
    };
    var moveUp = function moveUp(caret, amount) {
      return nu$3({
        left: caret.left(),
        top: caret.top() - amount,
        right: caret.right(),
        bottom: caret.bottom() - amount
      });
    };
    var moveBottomTo = function moveBottomTo(caret, bottom) {
      var height = caret.bottom() - caret.top();
      return nu$3({
        left: caret.left(),
        top: bottom - height,
        right: caret.right(),
        bottom: bottom
      });
    };
    var moveTopTo = function moveTopTo(caret, top) {
      var height = caret.bottom() - caret.top();
      return nu$3({
        left: caret.left(),
        top: top,
        right: caret.right(),
        bottom: top + height
      });
    };
    var translate = function translate(caret, xDelta, yDelta) {
      return nu$3({
        left: caret.left() + xDelta,
        top: caret.top() + yDelta,
        right: caret.right() + xDelta,
        bottom: caret.bottom() + yDelta
      });
    };
    var getTop$1 = function getTop$1(caret) {
      return caret.top();
    };
    var getBottom = function getBottom(caret) {
      return caret.bottom();
    };
    var toString$1 = function toString$1(caret) {
      return '(' + caret.left() + ', ' + caret.top() + ') -> (' + caret.right() + ', ' + caret.bottom() + ')';
    };
    var $_6sfahnqgjk26xlpd = {
      nu: nu$3,
      moveUp: moveUp,
      moveDown: moveDown,
      moveBottomTo: moveBottomTo,
      moveTopTo: moveTopTo,
      getTop: getTop$1,
      getBottom: getBottom,
      translate: translate,
      toString: toString$1
    };

    var getPartialBox = function getPartialBox(bridge, element, offset) {
      if (offset >= 0 && offset < $_v3k82mjjk26xkuq.getEnd(element)) return bridge.getRangedRect(element, offset, element, offset + 1);else if (offset > 0) return bridge.getRangedRect(element, offset - 1, element, offset);
      return Option.none();
    };
    var toCaret = function toCaret(rect) {
      return $_6sfahnqgjk26xlpd.nu({
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom
      });
    };
    var getElemBox = function getElemBox(bridge, element) {
      return Option.some(bridge.getRect(element));
    };
    var getBoxAt = function getBoxAt(bridge, element, offset) {
      if ($_89mq4qm3jk26xkrq.isElement(element)) return getElemBox(bridge, element).map(toCaret);else if ($_89mq4qm3jk26xkrq.isText(element)) return getPartialBox(bridge, element, offset).map(toCaret);else return Option.none();
    };
    var getEntireBox = function getEntireBox(bridge, element) {
      if ($_89mq4qm3jk26xkrq.isElement(element)) return getElemBox(bridge, element).map(toCaret);else if ($_89mq4qm3jk26xkrq.isText(element)) return bridge.getRangedRect(element, 0, element, $_v3k82mjjk26xkuq.getEnd(element)).map(toCaret);else return Option.none();
    };
    var $_9rono5qhjk26xlph = {
      getBoxAt: getBoxAt,
      getEntireBox: getEntireBox
    };

    var traverse = Immutable('item', 'mode');
    var backtrack = function backtrack(universe, item, direction, _transition) {
      var transition = _transition !== undefined ? _transition : sidestep;
      return universe.property().parent(item).map(function (p) {
        return traverse(p, transition);
      });
    };
    var sidestep = function sidestep(universe, item, direction, _transition) {
      var transition = _transition !== undefined ? _transition : advance;
      return direction.sibling(universe, item).map(function (p) {
        return traverse(p, transition);
      });
    };
    var advance = function advance(universe, item, direction, _transition) {
      var transition = _transition !== undefined ? _transition : advance;
      var children = universe.property().children(item);
      var result = direction.first(children);
      return result.map(function (r) {
        return traverse(r, transition);
      });
    };
    var successors = [{
      current: backtrack,
      next: sidestep,
      fallback: Option.none()
    }, {
      current: sidestep,
      next: advance,
      fallback: Option.some(backtrack)
    }, {
      current: advance,
      next: advance,
      fallback: Option.some(sidestep)
    }];
    var go$1 = function go$1(universe, item, mode, direction, rules) {
      var rules = rules !== undefined ? rules : successors;
      var ruleOpt = find(rules, function (succ) {
        return succ.current === mode;
      });
      return ruleOpt.bind(function (rule) {
        return rule.current(universe, item, direction, rule.next).orThunk(function () {
          return rule.fallback.bind(function (fb) {
            return go$1(universe, item, fb, direction);
          });
        });
      });
    };
    var $_budoneqmjk26xlqq = {
      backtrack: backtrack,
      sidestep: sidestep,
      advance: advance,
      go: go$1
    };

    var left$1 = function left$1() {
      var sibling = function sibling(universe, item) {
        return universe.query().prevSibling(item);
      };
      var first = function first(children) {
        return children.length > 0 ? Option.some(children[children.length - 1]) : Option.none();
      };
      return {
        sibling: sibling,
        first: first
      };
    };
    var right$1 = function right$1() {
      var sibling = function sibling(universe, item) {
        return universe.query().nextSibling(item);
      };
      var first = function first(children) {
        return children.length > 0 ? Option.some(children[0]) : Option.none();
      };
      return {
        sibling: sibling,
        first: first
      };
    };
    var $_3ak11qqnjk26xlqx = {
      left: left$1,
      right: right$1
    };

    var hone = function hone(universe, item, predicate, mode, direction, isRoot) {
      var next = $_budoneqmjk26xlqq.go(universe, item, mode, direction);
      return next.bind(function (n) {
        if (isRoot(n.item())) return Option.none();else return predicate(n.item()) ? Option.some(n.item()) : hone(universe, n.item(), predicate, n.mode(), direction, isRoot);
      });
    };
    var left$2 = function left$2(universe, item, predicate, isRoot) {
      return hone(universe, item, predicate, $_budoneqmjk26xlqq.sidestep, $_3ak11qqnjk26xlqx.left(), isRoot);
    };
    var right$2 = function right$2(universe, item, predicate, isRoot) {
      return hone(universe, item, predicate, $_budoneqmjk26xlqq.sidestep, $_3ak11qqnjk26xlqx.right(), isRoot);
    };
    var $_96tpjuqljk26xlqm = {
      left: left$2,
      right: right$2
    };

    var isLeaf = function isLeaf(universe, element) {
      return universe.property().children(element).length === 0;
    };
    var before$2 = function before$2(universe, item, isRoot) {
      return seekLeft(universe, item, curry(isLeaf, universe), isRoot);
    };
    var after$3 = function after$3(universe, item, isRoot) {
      return seekRight(universe, item, curry(isLeaf, universe), isRoot);
    };
    var seekLeft = function seekLeft(universe, item, predicate, isRoot) {
      return $_96tpjuqljk26xlqm.left(universe, item, predicate, isRoot);
    };
    var seekRight = function seekRight(universe, item, predicate, isRoot) {
      return $_96tpjuqljk26xlqm.right(universe, item, predicate, isRoot);
    };
    var walkers = function walkers() {
      return {
        left: $_3ak11qqnjk26xlqx.left,
        right: $_3ak11qqnjk26xlqx.right
      };
    };
    var walk = function walk(universe, item, mode, direction, _rules) {
      return $_budoneqmjk26xlqq.go(universe, item, mode, direction, _rules);
    };
    var $_fmp7yoqkjk26xlqi = {
      before: before$2,
      after: after$3,
      seekLeft: seekLeft,
      seekRight: seekRight,
      walkers: walkers,
      walk: walk,
      backtrack: $_budoneqmjk26xlqq.backtrack,
      sidestep: $_budoneqmjk26xlqq.sidestep,
      advance: $_budoneqmjk26xlqq.advance
    };

    var universe$2 = DomUniverse();
    var gather = function gather(element, prune, transform) {
      return $_fmp7yoqkjk26xlqi.gather(universe$2, element, prune, transform);
    };
    var before$3 = function before$3(element, isRoot) {
      return $_fmp7yoqkjk26xlqi.before(universe$2, element, isRoot);
    };
    var after$4 = function after$4(element, isRoot) {
      return $_fmp7yoqkjk26xlqi.after(universe$2, element, isRoot);
    };
    var seekLeft$1 = function seekLeft$1(element, predicate, isRoot) {
      return $_fmp7yoqkjk26xlqi.seekLeft(universe$2, element, predicate, isRoot);
    };
    var seekRight$1 = function seekRight$1(element, predicate, isRoot) {
      return $_fmp7yoqkjk26xlqi.seekRight(universe$2, element, predicate, isRoot);
    };
    var walkers$1 = function walkers$1() {
      return $_fmp7yoqkjk26xlqi.walkers();
    };
    var walk$1 = function walk$1(item, mode, direction, _rules) {
      return $_fmp7yoqkjk26xlqi.walk(universe$2, item, mode, direction, _rules);
    };
    var $_92et45qjjk26xlqf = {
      gather: gather,
      before: before$3,
      after: after$4,
      seekLeft: seekLeft$1,
      seekRight: seekRight$1,
      walkers: walkers$1,
      walk: walk$1
    };

    var JUMP_SIZE = 5;
    var NUM_RETRIES = 100;
    var adt$2 = Adt.generate([{ 'none': [] }, { 'retry': ['caret'] }]);
    var isOutside = function isOutside(caret, box) {
      return caret.left() < box.left() || Math.abs(box.right() - caret.left()) < 1 || caret.left() > box.right();
    };
    var inOutsideBlock = function inOutsideBlock(bridge, element, caret) {
      return $_3kidmom8jk26xks9.closest(element, $_8rjnpznojk26xl46.isBlock).fold(constant(false), function (cell) {
        return $_9rono5qhjk26xlph.getEntireBox(bridge, cell).exists(function (box) {
          return isOutside(caret, box);
        });
      });
    };
    var adjustDown = function adjustDown(bridge, element, guessBox, original, caret) {
      var lowerCaret = $_6sfahnqgjk26xlpd.moveDown(caret, JUMP_SIZE);
      if (Math.abs(guessBox.bottom() - original.bottom()) < 1) return adt$2.retry(lowerCaret);else if (guessBox.top() > caret.bottom()) return adt$2.retry(lowerCaret);else if (guessBox.top() === caret.bottom()) return adt$2.retry($_6sfahnqgjk26xlpd.moveDown(caret, 1));else return inOutsideBlock(bridge, element, caret) ? adt$2.retry($_6sfahnqgjk26xlpd.translate(lowerCaret, JUMP_SIZE, 0)) : adt$2.none();
    };
    var adjustUp = function adjustUp(bridge, element, guessBox, original, caret) {
      var higherCaret = $_6sfahnqgjk26xlpd.moveUp(caret, JUMP_SIZE);
      if (Math.abs(guessBox.top() - original.top()) < 1) return adt$2.retry(higherCaret);else if (guessBox.bottom() < caret.top()) return adt$2.retry(higherCaret);else if (guessBox.bottom() === caret.top()) return adt$2.retry($_6sfahnqgjk26xlpd.moveUp(caret, 1));else return inOutsideBlock(bridge, element, caret) ? adt$2.retry($_6sfahnqgjk26xlpd.translate(higherCaret, JUMP_SIZE, 0)) : adt$2.none();
    };
    var upMovement = {
      point: $_6sfahnqgjk26xlpd.getTop,
      adjuster: adjustUp,
      move: $_6sfahnqgjk26xlpd.moveUp,
      gather: $_92et45qjjk26xlqf.before
    };
    var downMovement = {
      point: $_6sfahnqgjk26xlpd.getBottom,
      adjuster: adjustDown,
      move: $_6sfahnqgjk26xlpd.moveDown,
      gather: $_92et45qjjk26xlqf.after
    };
    var isAtTable = function isAtTable(bridge, x, y) {
      return bridge.elementFromPoint(x, y).filter(function (elm) {
        return $_89mq4qm3jk26xkrq.name(elm) === 'table';
      }).isSome();
    };
    var adjustForTable = function adjustForTable(bridge, movement, original, caret, numRetries) {
      return adjustTil(bridge, movement, original, movement.move(caret, JUMP_SIZE), numRetries);
    };
    var adjustTil = function adjustTil(bridge, movement, original, caret, numRetries) {
      if (numRetries === 0) return Option.some(caret);
      if (isAtTable(bridge, caret.left(), movement.point(caret))) return adjustForTable(bridge, movement, original, caret, numRetries - 1);
      return bridge.situsFromPoint(caret.left(), movement.point(caret)).bind(function (guess) {
        return guess.start().fold(Option.none, function (element, offset) {
          return $_9rono5qhjk26xlph.getEntireBox(bridge, element, offset).bind(function (guessBox) {
            return movement.adjuster(bridge, element, guessBox, original, caret).fold(Option.none, function (newCaret) {
              return adjustTil(bridge, movement, original, newCaret, numRetries - 1);
            });
          }).orThunk(function () {
            return Option.some(caret);
          });
        }, Option.none);
      });
    };
    var ieTryDown = function ieTryDown(bridge, caret) {
      return bridge.situsFromPoint(caret.left(), caret.bottom() + JUMP_SIZE);
    };
    var ieTryUp = function ieTryUp(bridge, caret) {
      return bridge.situsFromPoint(caret.left(), caret.top() - JUMP_SIZE);
    };
    var checkScroll = function checkScroll(movement, adjusted, bridge) {
      if (movement.point(adjusted) > bridge.getInnerHeight()) return Option.some(movement.point(adjusted) - bridge.getInnerHeight());else if (movement.point(adjusted) < 0) return Option.some(-movement.point(adjusted));else return Option.none();
    };
    var retry = function retry(movement, bridge, caret) {
      var moved = movement.move(caret, JUMP_SIZE);
      var adjusted = adjustTil(bridge, movement, caret, moved, NUM_RETRIES).getOr(moved);
      return checkScroll(movement, adjusted, bridge).fold(function () {
        return bridge.situsFromPoint(adjusted.left(), movement.point(adjusted));
      }, function (delta) {
        bridge.scrollBy(0, delta);
        return bridge.situsFromPoint(adjusted.left(), movement.point(adjusted) - delta);
      });
    };
    var $_9hgcvvqijk26xlpq = {
      tryUp: curry(retry, upMovement),
      tryDown: curry(retry, downMovement),
      ieTryUp: ieTryUp,
      ieTryDown: ieTryDown,
      getJumpSize: constant(JUMP_SIZE)
    };

    var adt$3 = Adt.generate([{ 'none': ['message'] }, { 'success': [] }, { 'failedUp': ['cell'] }, { 'failedDown': ['cell'] }]);
    var isOverlapping = function isOverlapping(bridge, before, after) {
      var beforeBounds = bridge.getRect(before);
      var afterBounds = bridge.getRect(after);
      return afterBounds.right > beforeBounds.left && afterBounds.left < beforeBounds.right;
    };
    var verify = function verify(bridge, before, beforeOffset, after, afterOffset, failure, isRoot) {
      return $_at9vkhm7jk26xks8.closest(after, 'td,th', isRoot).bind(function (afterCell) {
        return $_at9vkhm7jk26xks8.closest(before, 'td,th', isRoot).map(function (beforeCell) {
          if (!$_5m7qbqlljk26xkq3.eq(afterCell, beforeCell)) {
            return $_daslkcmrjk26xkwr.sharedOne(isRow, [afterCell, beforeCell]).fold(function () {
              return isOverlapping(bridge, beforeCell, afterCell) ? adt$3.success() : failure(beforeCell);
            }, function (sharedRow) {
              return failure(beforeCell);
            });
          } else {
            return $_5m7qbqlljk26xkq3.eq(after, afterCell) && $_v3k82mjjk26xkuq.getEnd(afterCell) === afterOffset ? failure(beforeCell) : adt$3.none('in same cell');
          }
        });
      }).getOr(adt$3.none('default'));
    };
    var isRow = function isRow(elem) {
      return $_at9vkhm7jk26xks8.closest(elem, 'tr');
    };
    var cata$2 = function cata$2(subject, onNone, onSuccess, onFailedUp, onFailedDown) {
      return subject.fold(onNone, onSuccess, onFailedUp, onFailedDown);
    };
    var $_aryy47qojk26xlr1 = {
      verify: verify,
      cata: cata$2,
      adt: adt$3
    };

    var point = Immutable('element', 'offset');
    var delta = Immutable('element', 'deltaOffset');
    var range$3 = Immutable('element', 'start', 'finish');
    var points = Immutable('begin', 'end');
    var text = Immutable('element', 'text');
    var $_967wftqqjk26xlrz = {
      point: point,
      delta: delta,
      range: range$3,
      points: points,
      text: text
    };

    var inAncestor = Immutable('ancestor', 'descendants', 'element', 'index');
    var inParent = Immutable('parent', 'children', 'element', 'index');
    var childOf = function childOf(element, ancestor) {
      return $_3kidmom8jk26xks9.closest(element, function (elem) {
        return $_4uy46mljjk26xkpk.parent(elem).exists(function (parent) {
          return $_5m7qbqlljk26xkq3.eq(parent, ancestor);
        });
      });
    };
    var indexInParent = function indexInParent(element) {
      return $_4uy46mljjk26xkpk.parent(element).bind(function (parent) {
        var children = $_4uy46mljjk26xkpk.children(parent);
        return indexOf$1(children, element).map(function (index) {
          return inParent(parent, children, element, index);
        });
      });
    };
    var indexOf$1 = function indexOf$1(elements, element) {
      return findIndex(elements, curry($_5m7qbqlljk26xkq3.eq, element));
    };
    var selectorsInParent = function selectorsInParent(element, selector) {
      return $_4uy46mljjk26xkpk.parent(element).bind(function (parent) {
        var children = $_bkrvmvm4jk26xkrt.children(parent, selector);
        return indexOf$1(children, element).map(function (index) {
          return inParent(parent, children, element, index);
        });
      });
    };
    var descendantsInAncestor = function descendantsInAncestor(element, ancestorSelector, descendantSelector) {
      return $_at9vkhm7jk26xks8.closest(element, ancestorSelector).bind(function (ancestor) {
        var descendants = $_bkrvmvm4jk26xkrt.descendants(ancestor, descendantSelector);
        return indexOf$1(descendants, element).map(function (index) {
          return inAncestor(ancestor, descendants, element, index);
        });
      });
    };
    var $_bzwwfwqrjk26xls3 = {
      childOf: childOf,
      indexOf: indexOf$1,
      indexInParent: indexInParent,
      selectorsInParent: selectorsInParent,
      descendantsInAncestor: descendantsInAncestor
    };

    var isBr = function isBr(elem) {
      return $_89mq4qm3jk26xkrq.name(elem) === 'br';
    };
    var gatherer = function gatherer(cand, gather, isRoot) {
      return gather(cand, isRoot).bind(function (target) {
        return $_89mq4qm3jk26xkrq.isText(target) && $_2rujnemkjk26xkuu.get(target).trim().length === 0 ? gatherer(target, gather, isRoot) : Option.some(target);
      });
    };
    var handleBr = function handleBr(isRoot, element, direction) {
      return direction.traverse(element).orThunk(function () {
        return gatherer(element, direction.gather, isRoot);
      }).map(direction.relative);
    };
    var findBr = function findBr(element, offset) {
      return $_4uy46mljjk26xkpk.child(element, offset).filter(isBr).orThunk(function () {
        return $_4uy46mljjk26xkpk.child(element, offset - 1).filter(isBr);
      });
    };
    var handleParent = function handleParent(isRoot, element, offset, direction) {
      return findBr(element, offset).bind(function (br) {
        return direction.traverse(br).fold(function () {
          return gatherer(br, direction.gather, isRoot).map(direction.relative);
        }, function (adjacent) {
          return $_bzwwfwqrjk26xls3.indexInParent(adjacent).map(function (info) {
            return $_cwkyrepsjk26xljd.on(info.parent(), info.index());
          });
        });
      });
    };
    var tryBr = function tryBr(isRoot, element, offset, direction) {
      var target = isBr(element) ? handleBr(isRoot, element, direction) : handleParent(isRoot, element, offset, direction);
      return target.map(function (tgt) {
        return {
          start: constant(tgt),
          finish: constant(tgt)
        };
      });
    };
    var process = function process(analysis) {
      return $_aryy47qojk26xlr1.cata(analysis, function (message) {
        return Option.none();
      }, function () {
        return Option.none();
      }, function (cell) {
        return Option.some($_967wftqqjk26xlrz.point(cell, 0));
      }, function (cell) {
        return Option.some($_967wftqqjk26xlrz.point(cell, $_v3k82mjjk26xkuq.getEnd(cell)));
      });
    };
    var $_9tkb5zqpjk26xlrd = {
      tryBr: tryBr,
      process: process
    };

    var MAX_RETRIES = 20;
    var platform$1 = $_aj4ie4lqjk26xkqk.detect();
    var findSpot = function findSpot(bridge, isRoot, direction) {
      return bridge.getSelection().bind(function (sel) {
        return $_9tkb5zqpjk26xlrd.tryBr(isRoot, sel.finish(), sel.foffset(), direction).fold(function () {
          return Option.some($_967wftqqjk26xlrz.point(sel.finish(), sel.foffset()));
        }, function (brNeighbour) {
          var range = bridge.fromSitus(brNeighbour);
          var analysis = $_aryy47qojk26xlr1.verify(bridge, sel.finish(), sel.foffset(), range.finish(), range.foffset(), direction.failure, isRoot);
          return $_9tkb5zqpjk26xlrd.process(analysis);
        });
      });
    };
    var scan = function scan(bridge, isRoot, element, offset, direction, numRetries) {
      if (numRetries === 0) return Option.none();
      return tryCursor(bridge, isRoot, element, offset, direction).bind(function (situs) {
        var range = bridge.fromSitus(situs);
        var analysis = $_aryy47qojk26xlr1.verify(bridge, element, offset, range.finish(), range.foffset(), direction.failure, isRoot);
        return $_aryy47qojk26xlr1.cata(analysis, function () {
          return Option.none();
        }, function () {
          return Option.some(situs);
        }, function (cell) {
          if ($_5m7qbqlljk26xkq3.eq(element, cell) && offset === 0) return tryAgain(bridge, element, offset, $_6sfahnqgjk26xlpd.moveUp, direction);else return scan(bridge, isRoot, cell, 0, direction, numRetries - 1);
        }, function (cell) {
          if ($_5m7qbqlljk26xkq3.eq(element, cell) && offset === $_v3k82mjjk26xkuq.getEnd(cell)) return tryAgain(bridge, element, offset, $_6sfahnqgjk26xlpd.moveDown, direction);else return scan(bridge, isRoot, cell, $_v3k82mjjk26xkuq.getEnd(cell), direction, numRetries - 1);
        });
      });
    };
    var tryAgain = function tryAgain(bridge, element, offset, move, direction) {
      return $_9rono5qhjk26xlph.getBoxAt(bridge, element, offset).bind(function (box) {
        return tryAt(bridge, direction, move(box, $_9hgcvvqijk26xlpq.getJumpSize()));
      });
    };
    var tryAt = function tryAt(bridge, direction, box) {
      if (platform$1.browser.isChrome() || platform$1.browser.isSafari() || platform$1.browser.isFirefox() || platform$1.browser.isEdge()) return direction.otherRetry(bridge, box);else if (platform$1.browser.isIE()) return direction.ieRetry(bridge, box);else return Option.none();
    };
    var tryCursor = function tryCursor(bridge, isRoot, element, offset, direction) {
      return $_9rono5qhjk26xlph.getBoxAt(bridge, element, offset).bind(function (box) {
        return tryAt(bridge, direction, box);
      });
    };
    var handle$2 = function handle$2(bridge, isRoot, direction) {
      return findSpot(bridge, isRoot, direction).bind(function (spot) {
        return scan(bridge, isRoot, spot.element(), spot.offset(), direction, MAX_RETRIES).map(bridge.fromSitus);
      });
    };
    var $_5fuvmzqfjk26xlp1 = { handle: handle$2 };

    var any$1 = function any$1(predicate) {
      return $_3kidmom8jk26xks9.first(predicate).isSome();
    };
    var ancestor$3 = function ancestor$3(scope, predicate, isRoot) {
      return $_3kidmom8jk26xks9.ancestor(scope, predicate, isRoot).isSome();
    };
    var closest$3 = function closest$3(scope, predicate, isRoot) {
      return $_3kidmom8jk26xks9.closest(scope, predicate, isRoot).isSome();
    };
    var sibling$3 = function sibling$3(scope, predicate) {
      return $_3kidmom8jk26xks9.sibling(scope, predicate).isSome();
    };
    var child$4 = function child$4(scope, predicate) {
      return $_3kidmom8jk26xks9.child(scope, predicate).isSome();
    };
    var descendant$3 = function descendant$3(scope, predicate) {
      return $_3kidmom8jk26xks9.descendant(scope, predicate).isSome();
    };
    var $_vrkcuqsjk26xlsc = {
      any: any$1,
      ancestor: ancestor$3,
      closest: closest$3,
      sibling: sibling$3,
      child: child$4,
      descendant: descendant$3
    };

    var detection = $_aj4ie4lqjk26xkqk.detect();
    var inSameTable = function inSameTable(elem, table) {
      return $_vrkcuqsjk26xlsc.ancestor(elem, function (e) {
        return $_4uy46mljjk26xkpk.parent(e).exists(function (p) {
          return $_5m7qbqlljk26xkq3.eq(p, table);
        });
      });
    };

    var simulate = function simulate(bridge, isRoot, direction, initial, anchor) {
      return $_at9vkhm7jk26xks8.closest(initial, 'td,th', isRoot).bind(function (start) {
        return $_at9vkhm7jk26xks8.closest(start, 'table', isRoot).bind(function (table) {
          if (!inSameTable(anchor, table)) return Option.none();
          return $_5fuvmzqfjk26xlp1.handle(bridge, isRoot, direction).bind(function (range) {
            return $_at9vkhm7jk26xks8.closest(range.finish(), 'td,th', isRoot).map(function (finish) {
              return {
                start: constant(start),
                finish: constant(finish),
                range: constant(range)
              };
            });
          });
        });
      });
    };
    var navigate = function navigate(bridge, isRoot, direction, initial, anchor, precheck) {
      if (detection.browser.isIE()) {
        return Option.none();
      } else {
        return precheck(initial, isRoot).orThunk(function () {
          return simulate(bridge, isRoot, direction, initial, anchor).map(function (info) {
            var range = info.range();
            return $_50rco2q8jk26xlms.response(Option.some($_ag2gpeqbjk26xlnc.makeSitus(range.start(), range.soffset(), range.finish(), range.foffset())), true);
          });
        });
      }
    };
    var firstUpCheck = function firstUpCheck(initial, isRoot) {
      return $_at9vkhm7jk26xks8.closest(initial, 'tr', isRoot).bind(function (startRow) {
        return $_at9vkhm7jk26xks8.closest(startRow, 'table', isRoot).bind(function (table) {
          var rows = $_bkrvmvm4jk26xkrt.descendants(table, 'tr');
          if ($_5m7qbqlljk26xkq3.eq(startRow, rows[0])) {
            return $_92et45qjjk26xlqf.seekLeft(table, function (element) {
              return $_bqyx5vmijk26xkun.last(element).isSome();
            }, isRoot).map(function (last) {
              var lastOffset = $_v3k82mjjk26xkuq.getEnd(last);
              return $_50rco2q8jk26xlms.response(Option.some($_ag2gpeqbjk26xlnc.makeSitus(last, lastOffset, last, lastOffset)), true);
            });
          } else {
            return Option.none();
          }
        });
      });
    };
    var lastDownCheck = function lastDownCheck(initial, isRoot) {
      return $_at9vkhm7jk26xks8.closest(initial, 'tr', isRoot).bind(function (startRow) {
        return $_at9vkhm7jk26xks8.closest(startRow, 'table', isRoot).bind(function (table) {
          var rows = $_bkrvmvm4jk26xkrt.descendants(table, 'tr');
          if ($_5m7qbqlljk26xkq3.eq(startRow, rows[rows.length - 1])) {
            return $_92et45qjjk26xlqf.seekRight(table, function (element) {
              return $_bqyx5vmijk26xkun.first(element).isSome();
            }, isRoot).map(function (first) {
              return $_50rco2q8jk26xlms.response(Option.some($_ag2gpeqbjk26xlnc.makeSitus(first, 0, first, 0)), true);
            });
          } else {
            return Option.none();
          }
        });
      });
    };
    var select = function select(bridge, container, isRoot, direction, initial, anchor, selectRange) {
      return simulate(bridge, isRoot, direction, initial, anchor).bind(function (info) {
        return $_30l16tqdjk26xlnw.detect(container, isRoot, info.start(), info.finish(), selectRange);
      });
    };
    var $_4n83xeqejk26xlob = {
      navigate: navigate,
      select: select,
      firstUpCheck: firstUpCheck,
      lastDownCheck: lastDownCheck
    };

    var findCell = function findCell(target, isRoot) {
      return $_at9vkhm7jk26xks8.closest(target, 'td,th', isRoot);
    };
    function MouseSelection(bridge, container, isRoot, annotations) {
      var cursor = Option.none();
      var clearState = function clearState() {
        cursor = Option.none();
      };
      var mousedown = function mousedown(event) {
        annotations.clear(container);
        cursor = findCell(event.target(), isRoot);
      };
      var mouseover = function mouseover(event) {
        cursor.each(function (start) {
          annotations.clear(container);
          findCell(event.target(), isRoot).each(function (finish) {
            $_5a1ieomqjk26xkw2.identify(start, finish, isRoot).each(function (cellSel) {
              var boxes = cellSel.boxes().getOr([]);
              if (boxes.length > 1 || boxes.length === 1 && !$_5m7qbqlljk26xkq3.eq(start, finish)) {
                annotations.selectRange(container, boxes, cellSel.start(), cellSel.finish());
                bridge.selectContents(finish);
              }
            });
          });
        });
      };
      var mouseup = function mouseup() {
        cursor.each(clearState);
      };
      return {
        mousedown: mousedown,
        mouseover: mouseover,
        mouseup: mouseup
      };
    }

    var $_82evv8qujk26xlsm = {
      down: {
        traverse: $_4uy46mljjk26xkpk.nextSibling,
        gather: $_92et45qjjk26xlqf.after,
        relative: $_cwkyrepsjk26xljd.before,
        otherRetry: $_9hgcvvqijk26xlpq.tryDown,
        ieRetry: $_9hgcvvqijk26xlpq.ieTryDown,
        failure: $_aryy47qojk26xlr1.adt.failedDown
      },
      up: {
        traverse: $_4uy46mljjk26xkpk.prevSibling,
        gather: $_92et45qjjk26xlqf.before,
        relative: $_cwkyrepsjk26xljd.before,
        otherRetry: $_9hgcvvqijk26xlpq.tryUp,
        ieRetry: $_9hgcvvqijk26xlpq.ieTryUp,
        failure: $_aryy47qojk26xlr1.adt.failedUp
      }
    };

    var rc = Immutable('rows', 'cols');
    var mouse = function mouse(win, container, isRoot, annotations) {
      var bridge = WindowBridge(win);
      var handlers = MouseSelection(bridge, container, isRoot, annotations);
      return {
        mousedown: handlers.mousedown,
        mouseover: handlers.mouseover,
        mouseup: handlers.mouseup
      };
    };
    var keyboard = function keyboard(win, container, isRoot, annotations) {
      var bridge = WindowBridge(win);
      var clearToNavigate = function clearToNavigate() {
        annotations.clear(container);
        return Option.none();
      };
      var keydown = function keydown(event, start, soffset, finish, foffset, direction) {
        var keycode = event.raw().which;
        var shiftKey = event.raw().shiftKey === true;
        var handler = $_5a1ieomqjk26xkw2.retrieve(container, annotations.selectedSelector()).fold(function () {
          if ($_co3ifpq9jk26xlmv.isDown(keycode) && shiftKey) {
            return curry($_4n83xeqejk26xlob.select, bridge, container, isRoot, $_82evv8qujk26xlsm.down, finish, start, annotations.selectRange);
          } else if ($_co3ifpq9jk26xlmv.isUp(keycode) && shiftKey) {
            return curry($_4n83xeqejk26xlob.select, bridge, container, isRoot, $_82evv8qujk26xlsm.up, finish, start, annotations.selectRange);
          } else if ($_co3ifpq9jk26xlmv.isDown(keycode)) {
            return curry($_4n83xeqejk26xlob.navigate, bridge, isRoot, $_82evv8qujk26xlsm.down, finish, start, $_4n83xeqejk26xlob.lastDownCheck);
          } else if ($_co3ifpq9jk26xlmv.isUp(keycode)) {
            return curry($_4n83xeqejk26xlob.navigate, bridge, isRoot, $_82evv8qujk26xlsm.up, finish, start, $_4n83xeqejk26xlob.firstUpCheck);
          } else {
            return Option.none;
          }
        }, function (selected) {
          var update = function update(attempts) {
            return function () {
              var navigation = findMap(attempts, function (delta) {
                return $_30l16tqdjk26xlnw.update(delta.rows(), delta.cols(), container, selected, annotations);
              });
              return navigation.fold(function () {
                return $_5a1ieomqjk26xkw2.getEdges(container, annotations.firstSelectedSelector(), annotations.lastSelectedSelector()).map(function (edges) {
                  var relative = $_co3ifpq9jk26xlmv.isDown(keycode) || direction.isForward(keycode) ? $_cwkyrepsjk26xljd.after : $_cwkyrepsjk26xljd.before;
                  bridge.setRelativeSelection($_cwkyrepsjk26xljd.on(edges.first(), 0), relative(edges.table()));
                  annotations.clear(container);
                  return $_50rco2q8jk26xlms.response(Option.none(), true);
                });
              }, function (_) {
                return Option.some($_50rco2q8jk26xlms.response(Option.none(), true));
              });
            };
          };
          if ($_co3ifpq9jk26xlmv.isDown(keycode) && shiftKey) return update([rc(+1, 0)]);else if ($_co3ifpq9jk26xlmv.isUp(keycode) && shiftKey) return update([rc(-1, 0)]);else if (direction.isBackward(keycode) && shiftKey) return update([rc(0, -1), rc(-1, 0)]);else if (direction.isForward(keycode) && shiftKey) return update([rc(0, +1), rc(+1, 0)]);else if ($_co3ifpq9jk26xlmv.isNavigation(keycode) && shiftKey === false) return clearToNavigate;else return Option.none;
        });
        return handler();
      };
      var keyup = function keyup(event, start, soffset, finish, foffset) {
        return $_5a1ieomqjk26xkw2.retrieve(container, annotations.selectedSelector()).fold(function () {
          var keycode = event.raw().which;
          var shiftKey = event.raw().shiftKey === true;
          if (shiftKey === false) return Option.none();
          if ($_co3ifpq9jk26xlmv.isNavigation(keycode)) return $_30l16tqdjk26xlnw.sync(container, isRoot, start, soffset, finish, foffset, annotations.selectRange);else return Option.none();
        }, Option.none);
      };
      return {
        keydown: keydown,
        keyup: keyup
      };
    };
    var $_3l6j0uq7jk26xlme = {
      mouse: mouse,
      keyboard: keyboard
    };

    var add$3 = function add$3(element, classes) {
      each(classes, function (x) {
        $_6e2uko3jk26xl7l.add(element, x);
      });
    };
    var remove$7 = function remove$7(element, classes) {
      each(classes, function (x) {
        $_6e2uko3jk26xl7l.remove(element, x);
      });
    };
    var toggle$2 = function toggle$2(element, classes) {
      each(classes, function (x) {
        $_6e2uko3jk26xl7l.toggle(element, x);
      });
    };
    var hasAll = function hasAll(element, classes) {
      return forall(classes, function (clazz) {
        return $_6e2uko3jk26xl7l.has(element, clazz);
      });
    };
    var hasAny = function hasAny(element, classes) {
      return exists(classes, function (clazz) {
        return $_6e2uko3jk26xl7l.has(element, clazz);
      });
    };
    var getNative = function getNative(element) {
      var classList = element.dom().classList;
      var r = new Array(classList.length);
      for (var i = 0; i < classList.length; i++) {
        r[i] = classList.item(i);
      }
      return r;
    };
    var get$11 = function get$11(element) {
      return $_1dpcrko5jk26xl7o.supports(element) ? getNative(element) : $_1dpcrko5jk26xl7o.get(element);
    };
    var $_cp1trvqxjk26xlt6 = {
      add: add$3,
      remove: remove$7,
      toggle: toggle$2,
      hasAll: hasAll,
      hasAny: hasAny,
      get: get$11
    };

    var addClass = function addClass(clazz) {
      return function (element) {
        $_6e2uko3jk26xl7l.add(element, clazz);
      };
    };
    var removeClass = function removeClass(clazz) {
      return function (element) {
        $_6e2uko3jk26xl7l.remove(element, clazz);
      };
    };
    var removeClasses = function removeClasses(classes) {
      return function (element) {
        $_cp1trvqxjk26xlt6.remove(element, classes);
      };
    };
    var hasClass = function hasClass(clazz) {
      return function (element) {
        return $_6e2uko3jk26xl7l.has(element, clazz);
      };
    };
    var $_ci6wreqwjk26xlt5 = {
      addClass: addClass,
      removeClass: removeClass,
      removeClasses: removeClasses,
      hasClass: hasClass
    };

    var byClass = function byClass(ephemera) {
      var addSelectionClass = $_ci6wreqwjk26xlt5.addClass(ephemera.selected());
      var removeSelectionClasses = $_ci6wreqwjk26xlt5.removeClasses([ephemera.selected(), ephemera.lastSelected(), ephemera.firstSelected()]);
      var clear = function clear(container) {
        var sels = $_bkrvmvm4jk26xkrt.descendants(container, ephemera.selectedSelector());
        each(sels, removeSelectionClasses);
      };
      var selectRange = function selectRange(container, cells, start, finish) {
        clear(container);
        each(cells, addSelectionClass);
        $_6e2uko3jk26xl7l.add(start, ephemera.firstSelected());
        $_6e2uko3jk26xl7l.add(finish, ephemera.lastSelected());
      };
      return {
        clear: clear,
        selectRange: selectRange,
        selectedSelector: ephemera.selectedSelector,
        firstSelectedSelector: ephemera.firstSelectedSelector,
        lastSelectedSelector: ephemera.lastSelectedSelector
      };
    };
    var byAttr = function byAttr(ephemera) {
      var removeSelectionAttributes = function removeSelectionAttributes(element) {
        $_8icsmim2jk26xkrh.remove(element, ephemera.selected());
        $_8icsmim2jk26xkrh.remove(element, ephemera.firstSelected());
        $_8icsmim2jk26xkrh.remove(element, ephemera.lastSelected());
      };
      var addSelectionAttribute = function addSelectionAttribute(element) {
        $_8icsmim2jk26xkrh.set(element, ephemera.selected(), '1');
      };
      var clear = function clear(container) {
        var sels = $_bkrvmvm4jk26xkrt.descendants(container, ephemera.selectedSelector());
        each(sels, removeSelectionAttributes);
      };
      var selectRange = function selectRange(container, cells, start, finish) {
        clear(container);
        each(cells, addSelectionAttribute);
        $_8icsmim2jk26xkrh.set(start, ephemera.firstSelected(), '1');
        $_8icsmim2jk26xkrh.set(finish, ephemera.lastSelected(), '1');
      };
      return {
        clear: clear,
        selectRange: selectRange,
        selectedSelector: ephemera.selectedSelector,
        firstSelectedSelector: ephemera.firstSelectedSelector,
        lastSelectedSelector: ephemera.lastSelectedSelector
      };
    };
    var $_aofo9oqvjk26xlst = {
      byClass: byClass,
      byAttr: byAttr
    };

    var hasInternalTarget = function hasInternalTarget(e) {
      return $_6e2uko3jk26xl7l.has(Element$$1.fromDom(e.target), 'ephox-snooker-resizer-bar') === false;
    };
    function CellSelection$1(editor, lazyResize) {
      var handlerStruct = MixedBag(['mousedown', 'mouseover', 'mouseup', 'keyup', 'keydown'], []);
      var handlers = Option.none();
      var annotations = $_aofo9oqvjk26xlst.byAttr($_dmfr5on2jk26xkzd);
      editor.on('init', function (e) {
        var win = editor.getWin();
        var body = getBody$1(editor);
        var isRoot = getIsRoot(editor);
        var syncSelection = function syncSelection() {
          var sel = editor.selection;
          var start = Element$$1.fromDom(sel.getStart());
          var end = Element$$1.fromDom(sel.getEnd());
          var shared = $_daslkcmrjk26xkwr.sharedOne($_3gdghfldjk26xknu.table, [start, end]);
          shared.fold(function () {
            annotations.clear(body);
          }, noop);
        };
        var mouseHandlers = $_3l6j0uq7jk26xlme.mouse(win, body, isRoot, annotations);
        var keyHandlers = $_3l6j0uq7jk26xlme.keyboard(win, body, isRoot, annotations);
        var hasShiftKey = function hasShiftKey(event) {
          return event.raw().shiftKey === true;
        };
        var handleResponse = function handleResponse(event, response) {
          if (!hasShiftKey(event)) {
            return;
          }
          if (response.kill()) {
            event.kill();
          }
          response.selection().each(function (ns) {
            var relative = $_g5okmvprjk26xlj7.relative(ns.start(), ns.finish());
            var rng = $_1lyg6bpxjk26xlk5.asLtrRange(win, relative);
            editor.selection.setRng(rng);
          });
        };
        var keyup = function keyup(event) {
          var wrappedEvent = wrapEvent(event);
          if (wrappedEvent.raw().shiftKey && $_co3ifpq9jk26xlmv.isNavigation(wrappedEvent.raw().which)) {
            var rng = editor.selection.getRng();
            var start = Element$$1.fromDom(rng.startContainer);
            var end = Element$$1.fromDom(rng.endContainer);
            keyHandlers.keyup(wrappedEvent, start, rng.startOffset, end, rng.endOffset).each(function (response) {
              handleResponse(wrappedEvent, response);
            });
          }
        };
        var keydown = function keydown(event) {
          var wrappedEvent = wrapEvent(event);
          lazyResize().each(function (resize) {
            resize.hideBars();
          });
          var rng = editor.selection.getRng();
          var startContainer = Element$$1.fromDom(editor.selection.getStart());
          var start = Element$$1.fromDom(rng.startContainer);
          var end = Element$$1.fromDom(rng.endContainer);
          var direction = $_cwid1voljk26xlai.directionAt(startContainer).isRtl() ? $_co3ifpq9jk26xlmv.rtl : $_co3ifpq9jk26xlmv.ltr;
          keyHandlers.keydown(wrappedEvent, start, rng.startOffset, end, rng.endOffset, direction).each(function (response) {
            handleResponse(wrappedEvent, response);
          });
          lazyResize().each(function (resize) {
            resize.showBars();
          });
        };
        var isMouseEvent = function isMouseEvent(event) {
          return event.hasOwnProperty('x') && event.hasOwnProperty('y');
        };
        var wrapEvent = function wrapEvent(event) {
          var target = Element$$1.fromDom(event.target);
          var stop = function stop() {
            event.stopPropagation();
          };
          var prevent = function prevent() {
            event.preventDefault();
          };
          var kill = compose(prevent, stop);
          return {
            target: constant(target),
            x: constant(isMouseEvent(event) ? event.x : null),
            y: constant(isMouseEvent(event) ? event.y : null),
            stop: stop,
            prevent: prevent,
            kill: kill,
            raw: constant(event)
          };
        };
        var isLeftMouse = function isLeftMouse(raw) {
          return raw.button === 0;
        };
        var isLeftButtonPressed = function isLeftButtonPressed(raw) {
          if (raw.buttons === undefined) {
            return true;
          }
          return (raw.buttons & 1) !== 0;
        };
        var mouseDown = function mouseDown(e) {
          if (isLeftMouse(e) && hasInternalTarget(e)) {
            mouseHandlers.mousedown(wrapEvent(e));
          }
        };
        var mouseOver = function mouseOver(e) {
          if (isLeftButtonPressed(e) && hasInternalTarget(e)) {
            mouseHandlers.mouseover(wrapEvent(e));
          }
        };
        var mouseUp = function mouseUp(e) {
          if (isLeftMouse(e) && hasInternalTarget(e)) {
            mouseHandlers.mouseup(wrapEvent(e));
          }
        };
        editor.on('mousedown', mouseDown);
        editor.on('mouseover', mouseOver);
        editor.on('mouseup', mouseUp);
        editor.on('keyup', keyup);
        editor.on('keydown', keydown);
        editor.on('nodechange', syncSelection);
        handlers = Option.some(handlerStruct({
          mousedown: mouseDown,
          mouseover: mouseOver,
          mouseup: mouseUp,
          keyup: keyup,
          keydown: keydown
        }));
      });
      var destroy = function destroy() {
        handlers.each(function (handlers) {});
      };
      return {
        clear: annotations.clear,
        destroy: destroy
      };
    }

    var Selections = function Selections(editor) {
      var get = function get() {
        var body = getBody$1(editor);
        return $_aorrykmpjk26xkvn.retrieve(body, $_dmfr5on2jk26xkzd.selectedSelector()).fold(function () {
          if (editor.selection.getStart() === undefined) {
            return $_csneo2n3jk26xkzf.none();
          } else {
            return $_csneo2n3jk26xkzf.single(editor.selection);
          }
        }, function (cells) {
          return $_csneo2n3jk26xkzf.multiple(cells);
        });
      };
      return { get: get };
    };

    var each$4 = global$1.each;
    var addButtons = function addButtons(editor) {
      var menuItems = [];
      each$4('inserttable tableprops deletetable | cell row column'.split(' '), function (name) {
        if (name === '|') {
          menuItems.push({ text: '-' });
        } else {
          menuItems.push(editor.menuItems[name]);
        }
      });
      editor.addButton('table', {
        type: 'menubutton',
        title: 'Table',
        menu: menuItems
      });
      function cmd(command) {
        return function () {
          editor.execCommand(command);
        };
      }
      editor.addButton('tableprops', {
        title: 'Table properties',
        onclick: cmd('mceTableProps'),
        icon: 'table'
      });
      editor.addButton('tabledelete', {
        title: 'Delete table',
        onclick: cmd('mceTableDelete')
      });
      editor.addButton('tablecellprops', {
        title: 'Cell properties',
        onclick: cmd('mceTableCellProps')
      });
      editor.addButton('tablemergecells', {
        title: 'Merge cells',
        onclick: cmd('mceTableMergeCells')
      });
      editor.addButton('tablesplitcells', {
        title: 'Split cell',
        onclick: cmd('mceTableSplitCells')
      });
      editor.addButton('tableinsertrowbefore', {
        title: 'Insert row before',
        onclick: cmd('mceTableInsertRowBefore')
      });
      editor.addButton('tableinsertrowafter', {
        title: 'Insert row after',
        onclick: cmd('mceTableInsertRowAfter')
      });
      editor.addButton('tabledeleterow', {
        title: 'Delete row',
        onclick: cmd('mceTableDeleteRow')
      });
      editor.addButton('tablerowprops', {
        title: 'Row properties',
        onclick: cmd('mceTableRowProps')
      });
      editor.addButton('tablecutrow', {
        title: 'Cut row',
        onclick: cmd('mceTableCutRow')
      });
      editor.addButton('tablecopyrow', {
        title: 'Copy row',
        onclick: cmd('mceTableCopyRow')
      });
      editor.addButton('tablepasterowbefore', {
        title: 'Paste row before',
        onclick: cmd('mceTablePasteRowBefore')
      });
      editor.addButton('tablepasterowafter', {
        title: 'Paste row after',
        onclick: cmd('mceTablePasteRowAfter')
      });
      editor.addButton('tableinsertcolbefore', {
        title: 'Insert column before',
        onclick: cmd('mceTableInsertColBefore')
      });
      editor.addButton('tableinsertcolafter', {
        title: 'Insert column after',
        onclick: cmd('mceTableInsertColAfter')
      });
      editor.addButton('tabledeletecol', {
        title: 'Delete column',
        onclick: cmd('mceTableDeleteCol')
      });
    };
    var addToolbars = function addToolbars(editor) {
      var isTable = function isTable(table) {
        var selectorMatched = editor.dom.is(table, 'table') && editor.getBody().contains(table);
        return selectorMatched;
      };
      var toolbar = getToolbar(editor);
      if (toolbar.length > 0) {
        editor.addContextToolbar(isTable, toolbar.join(' '));
      }
    };
    var $_ak3zosqzjk26xltf = {
      addButtons: addButtons,
      addToolbars: addToolbars
    };

    var addMenuItems = function addMenuItems(editor, selections) {
      var targets = Option.none();
      var tableCtrls = [];
      var cellCtrls = [];
      var mergeCtrls = [];
      var unmergeCtrls = [];
      var noTargetDisable = function noTargetDisable(ctrl) {
        ctrl.disabled(true);
      };
      var ctrlEnable = function ctrlEnable(ctrl) {
        ctrl.disabled(false);
      };
      var pushTable = function pushTable() {
        var self = this;
        tableCtrls.push(self);
        targets.fold(function () {
          noTargetDisable(self);
        }, function (targets) {
          ctrlEnable(self);
        });
      };
      var pushCell = function pushCell() {
        var self = this;
        cellCtrls.push(self);
        targets.fold(function () {
          noTargetDisable(self);
        }, function (targets) {
          ctrlEnable(self);
        });
      };
      var pushMerge = function pushMerge() {
        var self = this;
        mergeCtrls.push(self);
        targets.fold(function () {
          noTargetDisable(self);
        }, function (targets) {
          self.disabled(targets.mergable().isNone());
        });
      };
      var pushUnmerge = function pushUnmerge() {
        var self = this;
        unmergeCtrls.push(self);
        targets.fold(function () {
          noTargetDisable(self);
        }, function (targets) {
          self.disabled(targets.unmergable().isNone());
        });
      };
      var setDisabledCtrls = function setDisabledCtrls() {
        targets.fold(function () {
          each(tableCtrls, noTargetDisable);
          each(cellCtrls, noTargetDisable);
          each(mergeCtrls, noTargetDisable);
          each(unmergeCtrls, noTargetDisable);
        }, function (targets) {
          each(tableCtrls, ctrlEnable);
          each(cellCtrls, ctrlEnable);
          each(mergeCtrls, function (mergeCtrl) {
            mergeCtrl.disabled(targets.mergable().isNone());
          });
          each(unmergeCtrls, function (unmergeCtrl) {
            unmergeCtrl.disabled(targets.unmergable().isNone());
          });
        });
      };
      editor.on('init', function () {
        editor.on('nodechange', function (e) {
          var cellOpt = Option.from(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
          targets = cellOpt.bind(function (cellDom) {
            var cell = Element$$1.fromDom(cellDom);
            var table = $_3gdghfldjk26xknu.table(cell);
            return table.map(function (table) {
              return $_bzk3jsmnjk26xkv6.forMenu(selections, table, cell);
            });
          });
          setDisabledCtrls();
        });
      });
      var generateTableGrid = function generateTableGrid() {
        var html = '';
        html = '<table role="grid" class="mce-grid mce-grid-border" aria-readonly="true">';
        for (var y = 0; y < 10; y++) {
          html += '<tr>';
          for (var x = 0; x < 10; x++) {
            html += '<td role="gridcell" tabindex="-1"><a id="mcegrid' + (y * 10 + x) + '" href="#" ' + 'data-mce-x="' + x + '" data-mce-y="' + y + '"></a></td>';
          }
          html += '</tr>';
        }
        html += '</table>';
        html += '<div class="mce-text-center" role="presentation">1 x 1</div>';
        return html;
      };
      var selectGrid = function selectGrid(editor, tx, ty, control) {
        var table = control.getEl().getElementsByTagName('table')[0];
        var x, y, focusCell, cell, active;
        var rtl = control.isRtl() || control.parent().rel === 'tl-tr';
        table.nextSibling.innerHTML = tx + 1 + ' x ' + (ty + 1);
        if (rtl) {
          tx = 9 - tx;
        }
        for (y = 0; y < 10; y++) {
          for (x = 0; x < 10; x++) {
            cell = table.rows[y].childNodes[x].firstChild;
            active = (rtl ? x >= tx : x <= tx) && y <= ty;
            editor.dom.toggleClass(cell, 'mce-active', active);
            if (active) {
              focusCell = cell;
            }
          }
        }
        return focusCell.parentNode;
      };
      var insertTable = hasTableGrid(editor) === false ? {
        text: 'Table',
        icon: 'table',
        context: 'table',
        onclick: cmd('mceInsertTable')
      } : {
        text: 'Table',
        icon: 'table',
        context: 'table',
        ariaHideMenu: true,
        onclick: function onclick(e) {
          if (e.aria) {
            this.parent().hideAll();
            e.stopImmediatePropagation();
            editor.execCommand('mceInsertTable');
          }
        },
        onshow: function onshow() {
          selectGrid(editor, 0, 0, this.menu.items()[0]);
        },
        onhide: function onhide() {
          var elements = this.menu.items()[0].getEl().getElementsByTagName('a');
          editor.dom.removeClass(elements, 'mce-active');
          editor.dom.addClass(elements[0], 'mce-active');
        },
        menu: [{
          type: 'container',
          html: generateTableGrid(),
          onPostRender: function onPostRender() {
            this.lastX = this.lastY = 0;
          },
          onmousemove: function onmousemove(e) {
            var target = e.target;
            var x, y;
            if (target.tagName.toUpperCase() === 'A') {
              x = parseInt(target.getAttribute('data-mce-x'), 10);
              y = parseInt(target.getAttribute('data-mce-y'), 10);
              if (this.isRtl() || this.parent().rel === 'tl-tr') {
                x = 9 - x;
              }
              if (x !== this.lastX || y !== this.lastY) {
                selectGrid(editor, x, y, e.control);
                this.lastX = x;
                this.lastY = y;
              }
            }
          },
          onclick: function onclick(e) {
            var self = this;
            if (e.target.tagName.toUpperCase() === 'A') {
              e.preventDefault();
              e.stopPropagation();
              self.parent().cancel();
              editor.undoManager.transact(function () {
                $_9ivoqjoyjk26xlcs.insert(editor, self.lastX + 1, self.lastY + 1);
              });
              editor.addVisual();
            }
          }
        }]
      };
      function cmd(command) {
        return function () {
          editor.execCommand(command);
        };
      }
      var tableProperties = {
        text: 'Table properties',
        context: 'table',
        onPostRender: pushTable,
        onclick: cmd('mceTableProps')
      };
      var deleteTable = {
        text: 'Delete table',
        context: 'table',
        onPostRender: pushTable,
        cmd: 'mceTableDelete'
      };
      var row = {
        text: 'Row',
        context: 'table',
        menu: [{
          text: 'Insert row before',
          onclick: cmd('mceTableInsertRowBefore'),
          onPostRender: pushCell
        }, {
          text: 'Insert row after',
          onclick: cmd('mceTableInsertRowAfter'),
          onPostRender: pushCell
        }, {
          text: 'Delete row',
          onclick: cmd('mceTableDeleteRow'),
          onPostRender: pushCell
        }, {
          text: 'Row properties',
          onclick: cmd('mceTableRowProps'),
          onPostRender: pushCell
        }, { text: '-' }, {
          text: 'Cut row',
          onclick: cmd('mceTableCutRow'),
          onPostRender: pushCell
        }, {
          text: 'Copy row',
          onclick: cmd('mceTableCopyRow'),
          onPostRender: pushCell
        }, {
          text: 'Paste row before',
          onclick: cmd('mceTablePasteRowBefore'),
          onPostRender: pushCell
        }, {
          text: 'Paste row after',
          onclick: cmd('mceTablePasteRowAfter'),
          onPostRender: pushCell
        }]
      };
      var column = {
        text: 'Column',
        context: 'table',
        menu: [{
          text: 'Insert column before',
          onclick: cmd('mceTableInsertColBefore'),
          onPostRender: pushCell
        }, {
          text: 'Insert column after',
          onclick: cmd('mceTableInsertColAfter'),
          onPostRender: pushCell
        }, {
          text: 'Delete column',
          onclick: cmd('mceTableDeleteCol'),
          onPostRender: pushCell
        }]
      };
      var cell = {
        separator: 'before',
        text: 'Cell',
        context: 'table',
        menu: [{
          text: 'Cell properties',
          onclick: cmd('mceTableCellProps'),
          onPostRender: pushCell
        }, {
          text: 'Merge cells',
          onclick: cmd('mceTableMergeCells'),
          onPostRender: pushMerge
        }, {
          text: 'Split cell',
          onclick: cmd('mceTableSplitCells'),
          onPostRender: pushUnmerge
        }]
      };
      editor.addMenuItem('inserttable', insertTable);
      editor.addMenuItem('tableprops', tableProperties);
      editor.addMenuItem('deletetable', deleteTable);
      editor.addMenuItem('row', row);
      editor.addMenuItem('column', column);
      editor.addMenuItem('cell', cell);
    };
    var $_6fjcijr0jk26xltj = { addMenuItems: addMenuItems };

    var _getClipboardRows = function _getClipboardRows(clipboardRows) {
      return clipboardRows.get().fold(function () {
        return;
      }, function (rows) {
        return map(rows, function (row) {
          return row.dom();
        });
      });
    };
    var _setClipboardRows = function _setClipboardRows(rows, clipboardRows) {
      var sugarRows = map(rows, Element$$1.fromDom);
      clipboardRows.set(Option.from(sugarRows));
    };
    var getApi = function getApi(editor, clipboardRows) {
      return {
        insertTable: function insertTable(columns, rows) {
          return $_9ivoqjoyjk26xlcs.insert(editor, columns, rows);
        },
        setClipboardRows: function setClipboardRows(rows) {
          return _setClipboardRows(rows, clipboardRows);
        },
        getClipboardRows: function getClipboardRows() {
          return _getClipboardRows(clipboardRows);
        }
      };
    };

    function Plugin(editor) {
      var resizeHandler = ResizeHandler(editor);
      var cellSelection = CellSelection$1(editor, resizeHandler.lazyResize);
      var actions = TableActions(editor, resizeHandler.lazyWire);
      var selections = Selections(editor);
      var clipboardRows = Cell(Option.none());
      $_35wdkdopjk26xlb2.registerCommands(editor, actions, cellSelection, selections, clipboardRows);
      $_usmm6l0jk26xklg.registerEvents(editor, selections, actions, cellSelection);
      $_6fjcijr0jk26xltj.addMenuItems(editor, selections);
      $_ak3zosqzjk26xltf.addButtons(editor);
      $_ak3zosqzjk26xltf.addToolbars(editor);
      editor.on('PreInit', function () {
        editor.serializer.addTempAttr($_dmfr5on2jk26xkzd.firstSelected());
        editor.serializer.addTempAttr($_dmfr5on2jk26xkzd.lastSelected());
      });
      if (hasTabNavigation(editor)) {
        editor.on('keydown', function (e) {
          $_8kfcsipojk26xlid.handle(e, editor, actions, resizeHandler.lazyWire);
        });
      }
      editor.on('remove', function () {
        resizeHandler.destroy();
        cellSelection.destroy();
      });
      return getApi(editor, clipboardRows);
    }
    global.add('table', Plugin);
    function Plugin$1() {}

    return Plugin$1;
  }();
})();

/***/ }),
/* 1033 */
/*!*********************************************************!*\
  !*** ./src/packages/tinymce/plugins/textcolor/index.js ***!
  \*********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "textcolor" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/textcolor')
//   ES2015:
//     import 'tinymce/plugins/textcolor'
__webpack_require__(/*! ./plugin.js */ 1034);

/***/ }),
/* 1034 */
/*!**********************************************************!*\
  !*** ./src/packages/tinymce/plugins/textcolor/plugin.js ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var textcolor = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var getCurrentColor = function getCurrentColor(editor, format) {
      var color;
      editor.dom.getParents(editor.selection.getStart(), function (elm) {
        var value;
        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
          color = value;
        }
      });
      return color;
    };
    var mapColors = function mapColors(colorMap) {
      var i;
      var colors = [];
      for (i = 0; i < colorMap.length; i += 2) {
        colors.push({
          text: colorMap[i + 1],
          color: '#' + colorMap[i]
        });
      }
      return colors;
    };
    var applyFormat = function applyFormat(editor, format, value) {
      editor.undoManager.transact(function () {
        editor.focus();
        editor.formatter.apply(format, { value: value });
        editor.nodeChanged();
      });
    };
    var removeFormat = function removeFormat(editor, format) {
      editor.undoManager.transact(function () {
        editor.focus();
        editor.formatter.remove(format, { value: null }, null, true);
        editor.nodeChanged();
      });
    };
    var $_7w2zi2rijk26xms7 = {
      getCurrentColor: getCurrentColor,
      mapColors: mapColors,
      applyFormat: applyFormat,
      removeFormat: removeFormat
    };

    var register = function register(editor) {
      editor.addCommand('mceApplyTextcolor', function (format, value) {
        $_7w2zi2rijk26xms7.applyFormat(editor, format, value);
      });
      editor.addCommand('mceRemoveTextcolor', function (format) {
        $_7w2zi2rijk26xms7.removeFormat(editor, format);
      });
    };
    var $_bqntn9rhjk26xms5 = { register: register };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var defaultColorMap = ['000000', 'Black', '993300', 'Burnt orange', '333300', 'Dark olive', '003300', 'Dark green', '003366', 'Dark azure', '000080', 'Navy Blue', '333399', 'Indigo', '333333', 'Very dark gray', '800000', 'Maroon', 'FF6600', 'Orange', '808000', 'Olive', '008000', 'Green', '008080', 'Teal', '0000FF', 'Blue', '666699', 'Grayish blue', '808080', 'Gray', 'FF0000', 'Red', 'FF9900', 'Amber', '99CC00', 'Yellow green', '339966', 'Sea green', '33CCCC', 'Turquoise', '3366FF', 'Royal blue', '800080', 'Purple', '999999', 'Medium gray', 'FF00FF', 'Magenta', 'FFCC00', 'Gold', 'FFFF00', 'Yellow', '00FF00', 'Lime', '00FFFF', 'Aqua', '00CCFF', 'Sky blue', '993366', 'Red violet', 'FFFFFF', 'White', 'FF99CC', 'Pink', 'FFCC99', 'Peach', 'FFFF99', 'Light yellow', 'CCFFCC', 'Pale green', 'CCFFFF', 'Pale cyan', '99CCFF', 'Light sky blue', 'CC99FF', 'Plum'];
    var getTextColorMap = function getTextColorMap(editor) {
      return editor.getParam('textcolor_map', defaultColorMap);
    };
    var getForeColorMap = function getForeColorMap(editor) {
      return editor.getParam('forecolor_map', getTextColorMap(editor));
    };
    var getBackColorMap = function getBackColorMap(editor) {
      return editor.getParam('backcolor_map', getTextColorMap(editor));
    };
    var getTextColorRows = function getTextColorRows(editor) {
      return editor.getParam('textcolor_rows', 5);
    };
    var getTextColorCols = function getTextColorCols(editor) {
      return editor.getParam('textcolor_cols', 8);
    };
    var getForeColorRows = function getForeColorRows(editor) {
      return editor.getParam('forecolor_rows', getTextColorRows(editor));
    };
    var getBackColorRows = function getBackColorRows(editor) {
      return editor.getParam('backcolor_rows', getTextColorRows(editor));
    };
    var getForeColorCols = function getForeColorCols(editor) {
      return editor.getParam('forecolor_cols', getTextColorCols(editor));
    };
    var getBackColorCols = function getBackColorCols(editor) {
      return editor.getParam('backcolor_cols', getTextColorCols(editor));
    };
    var getColorPickerCallback = function getColorPickerCallback(editor) {
      return editor.getParam('color_picker_callback', null);
    };
    var hasColorPicker = function hasColorPicker(editor) {
      return typeof getColorPickerCallback(editor) === 'function';
    };
    var $_b33y5grmjk26xmse = {
      getForeColorMap: getForeColorMap,
      getBackColorMap: getBackColorMap,
      getForeColorRows: getForeColorRows,
      getBackColorRows: getBackColorRows,
      getForeColorCols: getForeColorCols,
      getBackColorCols: getBackColorCols,
      getColorPickerCallback: getColorPickerCallback,
      hasColorPicker: hasColorPicker
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var getHtml = function getHtml(cols, rows, colorMap, hasColorPicker) {
      var colors,
          color,
          html,
          last,
          x,
          y,
          i,
          count = 0;
      var id = global$1.DOM.uniqueId('mcearia');
      var getColorCellHtml = function getColorCellHtml(color, title) {
        var isNoColor = color === 'transparent';
        return '<td class="mce-grid-cell' + (isNoColor ? ' mce-colorbtn-trans' : '') + '">' + '<div id="' + id + '-' + count++ + '"' + ' data-mce-color="' + (color ? color : '') + '"' + ' role="option"' + ' tabIndex="-1"' + ' style="' + (color ? 'background-color: ' + color : '') + '"' + ' title="' + global$3.translate(title) + '">' + (isNoColor ? '&#215;' : '') + '</div>' + '</td>';
      };
      colors = $_7w2zi2rijk26xms7.mapColors(colorMap);
      colors.push({
        text: global$3.translate('No color'),
        color: 'transparent'
      });
      html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
      last = colors.length - 1;
      for (y = 0; y < rows; y++) {
        html += '<tr>';
        for (x = 0; x < cols; x++) {
          i = y * cols + x;
          if (i > last) {
            html += '<td></td>';
          } else {
            color = colors[i];
            html += getColorCellHtml(color.color, color.text);
          }
        }
        html += '</tr>';
      }
      if (hasColorPicker) {
        html += '<tr>' + '<td colspan="' + cols + '" class="mce-custom-color-btn">' + '<div id="' + id + '-c" class="mce-widget mce-btn mce-btn-small mce-btn-flat" ' + 'role="button" tabindex="-1" aria-labelledby="' + id + '-c" style="width: 100%">' + '<button type="button" role="presentation" tabindex="-1">' + global$3.translate('Custom...') + '</button>' + '</div>' + '</td>' + '</tr>';
        html += '<tr>';
        for (x = 0; x < cols; x++) {
          html += getColorCellHtml('', 'Custom color');
        }
        html += '</tr>';
      }
      html += '</tbody></table>';
      return html;
    };
    var $_8jtw2crnjk26xmsg = { getHtml: getHtml };

    var setDivColor = function setDivColor(div, value) {
      div.style.background = value;
      div.setAttribute('data-mce-color', value);
    };
    var onButtonClick = function onButtonClick(editor) {
      return function (e) {
        var ctrl = e.control;
        if (ctrl._color) {
          editor.execCommand('mceApplyTextcolor', ctrl.settings.format, ctrl._color);
        } else {
          editor.execCommand('mceRemoveTextcolor', ctrl.settings.format);
        }
      };
    };
    var onPanelClick = function onPanelClick(editor, cols) {
      return function (e) {
        var buttonCtrl = this.parent();
        var value;
        var currentColor = $_7w2zi2rijk26xms7.getCurrentColor(editor, buttonCtrl.settings.format);
        var selectColor = function selectColor(value) {
          editor.execCommand('mceApplyTextcolor', buttonCtrl.settings.format, value);
          buttonCtrl.hidePanel();
          buttonCtrl.color(value);
        };
        var resetColor = function resetColor() {
          editor.execCommand('mceRemoveTextcolor', buttonCtrl.settings.format);
          buttonCtrl.hidePanel();
          buttonCtrl.resetColor();
        };
        if (global$1.DOM.getParent(e.target, '.mce-custom-color-btn')) {
          buttonCtrl.hidePanel();
          var colorPickerCallback = $_b33y5grmjk26xmse.getColorPickerCallback(editor);
          colorPickerCallback.call(editor, function (value) {
            var tableElm = buttonCtrl.panel.getEl().getElementsByTagName('table')[0];
            var customColorCells, div, i;
            customColorCells = global$2.map(tableElm.rows[tableElm.rows.length - 1].childNodes, function (elm) {
              return elm.firstChild;
            });
            for (i = 0; i < customColorCells.length; i++) {
              div = customColorCells[i];
              if (!div.getAttribute('data-mce-color')) {
                break;
              }
            }
            if (i === cols) {
              for (i = 0; i < cols - 1; i++) {
                setDivColor(customColorCells[i], customColorCells[i + 1].getAttribute('data-mce-color'));
              }
            }
            setDivColor(div, value);
            selectColor(value);
          }, currentColor);
        }
        value = e.target.getAttribute('data-mce-color');
        if (value) {
          if (this.lastId) {
            global$1.DOM.get(this.lastId).setAttribute('aria-selected', 'false');
          }
          e.target.setAttribute('aria-selected', true);
          this.lastId = e.target.id;
          if (value === 'transparent') {
            resetColor();
          } else {
            selectColor(value);
          }
        } else if (value !== null) {
          buttonCtrl.hidePanel();
        }
      };
    };
    var renderColorPicker = function renderColorPicker(editor, foreColor) {
      return function () {
        var cols = foreColor ? $_b33y5grmjk26xmse.getForeColorCols(editor) : $_b33y5grmjk26xmse.getBackColorCols(editor);
        var rows = foreColor ? $_b33y5grmjk26xmse.getForeColorRows(editor) : $_b33y5grmjk26xmse.getBackColorRows(editor);
        var colorMap = foreColor ? $_b33y5grmjk26xmse.getForeColorMap(editor) : $_b33y5grmjk26xmse.getBackColorMap(editor);
        var hasColorPicker = $_b33y5grmjk26xmse.hasColorPicker(editor);
        return $_8jtw2crnjk26xmsg.getHtml(cols, rows, colorMap, hasColorPicker);
      };
    };
    var register$1 = function register$1(editor) {
      editor.addButton('forecolor', {
        type: 'colorbutton',
        tooltip: 'Text color',
        format: 'forecolor',
        panel: {
          role: 'application',
          ariaRemember: true,
          html: renderColorPicker(editor, true),
          onclick: onPanelClick(editor, $_b33y5grmjk26xmse.getForeColorCols(editor))
        },
        onclick: onButtonClick(editor)
      });
      editor.addButton('backcolor', {
        type: 'colorbutton',
        tooltip: 'Background color',
        format: 'hilitecolor',
        panel: {
          role: 'application',
          ariaRemember: true,
          html: renderColorPicker(editor, false),
          onclick: onPanelClick(editor, $_b33y5grmjk26xmse.getBackColorCols(editor))
        },
        onclick: onButtonClick(editor)
      });
    };
    var $_dcra9erjjk26xms9 = { register: register$1 };

    global.add('textcolor', function (editor) {
      $_bqntn9rhjk26xms5.register(editor);
      $_dcra9erjjk26xms9.register(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1035 */
/*!***************************************************!*\
  !*** ./src/packages/tinymce/plugins/toc/index.js ***!
  \***************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "toc" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/toc')
//   ES2015:
//     import 'tinymce/plugins/toc'
__webpack_require__(/*! ./plugin.js */ 1036);

/***/ }),
/* 1036 */
/*!****************************************************!*\
  !*** ./src/packages/tinymce/plugins/toc/plugin.js ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

(function () {
  var toc = function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getTocClass = function getTocClass(editor) {
      return editor.getParam('toc_class', 'mce-toc');
    };
    var getTocHeader = function getTocHeader(editor) {
      var tagName = editor.getParam('toc_header', 'h2');
      return (/^h[1-6]$/.test(tagName) ? tagName : 'h2'
      );
    };
    var getTocDepth = function getTocDepth(editor) {
      var depth = parseInt(editor.getParam('toc_depth', '3'), 10);
      return depth >= 1 && depth <= 9 ? depth : 3;
    };
    var $_6z8396sajk26xmvm = {
      getTocClass: getTocClass,
      getTocHeader: getTocHeader,
      getTocDepth: getTocDepth
    };

    var create = function create(prefix) {
      var counter = 0;
      return function () {
        var guid = new Date().getTime().toString(32);
        return prefix + guid + (counter++).toString(32);
      };
    };
    var $_2ry274sbjk26xmvn = { create: create };

    var tocId = $_2ry274sbjk26xmvn.create('mcetoc_');
    var generateSelector = function generateSelector(depth) {
      var i;
      var selector = [];
      for (i = 1; i <= depth; i++) {
        selector.push('h' + i);
      }
      return selector.join(',');
    };
    var hasHeaders = function hasHeaders(editor) {
      return readHeaders(editor).length > 0;
    };
    var readHeaders = function readHeaders(editor) {
      var tocClass = $_6z8396sajk26xmvm.getTocClass(editor);
      var headerTag = $_6z8396sajk26xmvm.getTocHeader(editor);
      var selector = generateSelector($_6z8396sajk26xmvm.getTocDepth(editor));
      var headers = editor.$(selector);
      if (headers.length && /^h[1-9]$/i.test(headerTag)) {
        headers = headers.filter(function (i, el) {
          return !editor.dom.hasClass(el.parentNode, tocClass);
        });
      }
      return global$3.map(headers, function (h) {
        return {
          id: h.id ? h.id : tocId(),
          level: parseInt(h.nodeName.replace(/^H/i, ''), 10),
          title: editor.$.text(h),
          element: h
        };
      });
    };
    var getMinLevel = function getMinLevel(headers) {
      var i,
          minLevel = 9;
      for (i = 0; i < headers.length; i++) {
        if (headers[i].level < minLevel) {
          minLevel = headers[i].level;
        }
        if (minLevel === 1) {
          return minLevel;
        }
      }
      return minLevel;
    };
    var generateTitle = function generateTitle(tag, title) {
      var openTag = '<' + tag + ' contenteditable="true">';
      var closeTag = '</' + tag + '>';
      return openTag + global$1.DOM.encode(title) + closeTag;
    };
    var generateTocHtml = function generateTocHtml(editor) {
      var html = generateTocContentHtml(editor);
      return '<div class="' + editor.dom.encode($_6z8396sajk26xmvm.getTocClass(editor)) + '" contenteditable="false">' + html + '</div>';
    };
    var generateTocContentHtml = function generateTocContentHtml(editor) {
      var html = '';
      var headers = readHeaders(editor);
      var prevLevel = getMinLevel(headers) - 1;
      var i, ii, h, nextLevel;
      if (!headers.length) {
        return '';
      }
      html += generateTitle($_6z8396sajk26xmvm.getTocHeader(editor), global$2.translate('Table of Contents'));
      for (i = 0; i < headers.length; i++) {
        h = headers[i];
        h.element.id = h.id;
        nextLevel = headers[i + 1] && headers[i + 1].level;
        if (prevLevel === h.level) {
          html += '<li>';
        } else {
          for (ii = prevLevel; ii < h.level; ii++) {
            html += '<ul><li>';
          }
        }
        html += '<a href="#' + h.id + '">' + h.title + '</a>';
        if (nextLevel === h.level || !nextLevel) {
          html += '</li>';
          if (!nextLevel) {
            html += '</ul>';
          }
        } else {
          for (ii = h.level; ii > nextLevel; ii--) {
            html += '</li></ul><li>';
          }
        }
        prevLevel = h.level;
      }
      return html;
    };
    var isEmptyOrOffscren = function isEmptyOrOffscren(editor, nodes) {
      return !nodes.length || editor.dom.getParents(nodes[0], '.mce-offscreen-selection').length > 0;
    };
    var insertToc = function insertToc(editor) {
      var tocClass = $_6z8396sajk26xmvm.getTocClass(editor);
      var $tocElm = editor.$('.' + tocClass);
      if (isEmptyOrOffscren(editor, $tocElm)) {
        editor.insertContent(generateTocHtml(editor));
      } else {
        updateToc(editor);
      }
    };
    var updateToc = function updateToc(editor) {
      var tocClass = $_6z8396sajk26xmvm.getTocClass(editor);
      var $tocElm = editor.$('.' + tocClass);
      if ($tocElm.length) {
        editor.undoManager.transact(function () {
          $tocElm.html(generateTocContentHtml(editor));
        });
      }
    };
    var $_de45fds6jk26xmvh = {
      hasHeaders: hasHeaders,
      insertToc: insertToc,
      updateToc: updateToc
    };

    var register = function register(editor) {
      editor.addCommand('mceInsertToc', function () {
        $_de45fds6jk26xmvh.insertToc(editor);
      });
      editor.addCommand('mceUpdateToc', function () {
        $_de45fds6jk26xmvh.updateToc(editor);
      });
    };
    var $_6ds1xgs5jk26xmvg = { register: register };

    var setup = function setup(editor) {
      var $ = editor.$,
          tocClass = $_6z8396sajk26xmvm.getTocClass(editor);
      editor.on('PreProcess', function (e) {
        var $tocElm = $('.' + tocClass, e.node);
        if ($tocElm.length) {
          $tocElm.removeAttr('contentEditable');
          $tocElm.find('[contenteditable]').removeAttr('contentEditable');
        }
      });
      editor.on('SetContent', function () {
        var $tocElm = $('.' + tocClass);
        if ($tocElm.length) {
          $tocElm.attr('contentEditable', false);
          $tocElm.children(':first-child').attr('contentEditable', true);
        }
      });
    };
    var $_f54mbfscjk26xmvo = { setup: setup };

    var toggleState = function toggleState(editor) {
      return function (e) {
        var ctrl = e.control;
        editor.on('LoadContent SetContent change', function () {
          ctrl.disabled(editor.readonly || !$_de45fds6jk26xmvh.hasHeaders(editor));
        });
      };
    };
    var isToc = function isToc(editor) {
      return function (elm) {
        return elm && editor.dom.is(elm, '.' + $_6z8396sajk26xmvm.getTocClass(editor)) && editor.getBody().contains(elm);
      };
    };
    var register$1 = function register$1(editor) {
      editor.addButton('toc', {
        tooltip: 'Table of Contents',
        cmd: 'mceInsertToc',
        icon: 'toc',
        onPostRender: toggleState(editor)
      });
      editor.addButton('tocupdate', {
        tooltip: 'Update',
        cmd: 'mceUpdateToc',
        icon: 'reload'
      });
      editor.addMenuItem('toc', {
        text: 'Table of Contents',
        context: 'insert',
        cmd: 'mceInsertToc',
        onPostRender: toggleState(editor)
      });
      editor.addContextToolbar(isToc(editor), 'tocupdate');
    };
    var $_7bo36msdjk26xmvp = { register: register$1 };

    global.add('toc', function (editor) {
      $_6ds1xgs5jk26xmvg.register(editor);
      $_7bo36msdjk26xmvp.register(editor);
      $_f54mbfscjk26xmvo.setup(editor);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1037 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/plugins/visualchars/index.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "visualchars" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/visualchars')
//   ES2015:
//     import 'tinymce/plugins/visualchars'
__webpack_require__(/*! ./plugin.js */ 1038);

/***/ }),
/* 1038 */
/*!************************************************************!*\
  !*** ./src/packages/tinymce/plugins/visualchars/plugin.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  var visualchars = function () {
    'use strict';

    var Cell = function Cell(initial) {
      var value = initial;
      var get = function get() {
        return value;
      };
      var set = function set(v) {
        value = v;
      };
      var clone = function clone() {
        return Cell(get());
      };
      return {
        get: get,
        set: set,
        clone: clone
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var get = function get(toggleState) {
      var isEnabled = function isEnabled() {
        return toggleState.get();
      };
      return { isEnabled: isEnabled };
    };
    var $_9gvd73stjk26xmx2 = { get: get };

    var fireVisualChars = function fireVisualChars(editor, state) {
      return editor.fire('VisualChars', { state: state });
    };
    var $_9jbxa1swjk26xmx5 = { fireVisualChars: fireVisualChars };

    var charMap = {
      '\xA0': 'nbsp',
      '\xAD': 'shy'
    };
    var charMapToRegExp = function charMapToRegExp(charMap, global) {
      var key,
          regExp = '';
      for (key in charMap) {
        regExp += key;
      }
      return new RegExp('[' + regExp + ']', global ? 'g' : '');
    };
    var charMapToSelector = function charMapToSelector(charMap) {
      var key,
          selector = '';
      for (key in charMap) {
        if (selector) {
          selector += ',';
        }
        selector += 'span.mce-' + charMap[key];
      }
      return selector;
    };
    var $_ad6e6isyjk26xmxc = {
      charMap: charMap,
      regExp: charMapToRegExp(charMap),
      regExpGlobal: charMapToRegExp(charMap, true),
      selector: charMapToSelector(charMap),
      charMapToRegExp: charMapToRegExp,
      charMapToSelector: charMapToSelector
    };

    var constant = function constant(value) {
      return function () {
        return value;
      };
    };

    var never = constant(false);
    var always = constant(true);

    var never$1 = never;
    var always$1 = always;
    var none = function none() {
      return NONE;
    };
    var NONE = function () {
      var eq = function eq(o) {
        return o.isNone();
      };
      var call$$1 = function call$$1(thunk) {
        return thunk();
      };
      var id = function id(n) {
        return n;
      };
      var noop$$1 = function noop$$1() {};
      var nul = function nul() {
        return null;
      };
      var undef = function undef() {
        return undefined;
      };
      var me = {
        fold: function fold(n, s) {
          return n();
        },
        is: never$1,
        isSome: never$1,
        isNone: always$1,
        getOr: id,
        getOrThunk: call$$1,
        getOrDie: function getOrDie(msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: nul,
        getOrUndefined: undef,
        or: id,
        orThunk: call$$1,
        map: none,
        ap: none,
        each: noop$$1,
        bind: none,
        flatten: none,
        exists: never$1,
        forall: always$1,
        filter: none,
        equals: eq,
        equals_: eq,
        toArray: function toArray() {
          return [];
        },
        toString: constant('none()')
      };
      if (Object.freeze) Object.freeze(me);
      return me;
    }();
    var some = function some(a) {
      var constant_a = function constant_a() {
        return a;
      };
      var self = function self() {
        return me;
      };
      var map = function map(f) {
        return some(f(a));
      };
      var bind = function bind(f) {
        return f(a);
      };
      var me = {
        fold: function fold(n, s) {
          return s(a);
        },
        is: function is(v) {
          return a === v;
        },
        isSome: always$1,
        isNone: never$1,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: map,
        ap: function ap(optfab) {
          return optfab.fold(none, function (fab) {
            return some(fab(a));
          });
        },
        each: function each(f) {
          f(a);
        },
        bind: bind,
        flatten: constant_a,
        exists: bind,
        forall: bind,
        filter: function filter(f) {
          return f(a) ? me : NONE;
        },
        equals: function equals(o) {
          return o.is(a);
        },
        equals_: function equals_(o, elementEq) {
          return o.fold(never$1, function (b) {
            return elementEq(a, b);
          });
        },
        toArray: function toArray() {
          return [a];
        },
        toString: function toString() {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function from(value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Option = {
      some: some,
      none: none,
      from: from
    };

    var typeOf = function typeOf(x) {
      if (x === null) return 'null';
      var t = typeof x === 'undefined' ? 'undefined' : _typeof(x);
      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
      return t;
    };
    var isType = function isType(type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };

    var isFunction = isType('function');

    var map = function map(xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i, xs);
      }
      return r;
    };
    var each = function each(xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i, xs);
      }
    };

    var slice = Array.prototype.slice;

    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
      return slice.call(x);
    };

    var fromHtml = function fromHtml(html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw 'HTML must have a single root node';
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function fromTag(tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function fromText(text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function fromDom(node) {
      if (node === null || node === undefined) throw new Error('Node cannot be null or undefined');
      return { dom: constant(node) };
    };
    var fromPoint = function fromPoint(docElm, x, y) {
      var doc = docElm.dom();
      return Option.from(doc.elementFromPoint(x, y)).map(fromDom);
    };
    var Element$$1 = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    var $_7s3ecat7jk26xmyj = {
      ATTRIBUTE: Node.ATTRIBUTE_NODE,
      CDATA_SECTION: Node.CDATA_SECTION_NODE,
      COMMENT: Node.COMMENT_NODE,
      DOCUMENT: Node.DOCUMENT_NODE,
      DOCUMENT_TYPE: Node.DOCUMENT_TYPE_NODE,
      DOCUMENT_FRAGMENT: Node.DOCUMENT_FRAGMENT_NODE,
      ELEMENT: Node.ELEMENT_NODE,
      TEXT: Node.TEXT_NODE,
      PROCESSING_INSTRUCTION: Node.PROCESSING_INSTRUCTION_NODE,
      ENTITY_REFERENCE: Node.ENTITY_REFERENCE_NODE,
      ENTITY: Node.ENTITY_NODE,
      NOTATION: Node.NOTATION_NODE
    };

    var name = function name(element) {
      var r = element.dom().nodeName;
      return r.toLowerCase();
    };
    var type = function type(element) {
      return element.dom().nodeType;
    };
    var value = function value(element) {
      return element.dom().nodeValue;
    };
    var isType$1 = function isType$1(t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isComment = function isComment(element) {
      return type(element) === $_7s3ecat7jk26xmyj.COMMENT || name(element) === '#comment';
    };
    var isElement = isType$1($_7s3ecat7jk26xmyj.ELEMENT);
    var isText = isType$1($_7s3ecat7jk26xmyj.TEXT);
    var isDocument = isType$1($_7s3ecat7jk26xmyj.DOCUMENT);
    var $_8kkttzt6jk26xmyh = {
      name: name,
      type: type,
      value: value,
      isElement: isElement,
      isText: isText,
      isDocument: isDocument,
      isComment: isComment
    };

    var wrapCharWithSpan = function wrapCharWithSpan(value) {
      return '<span data-mce-bogus="1" class="mce-' + $_ad6e6isyjk26xmxc.charMap[value] + '">' + value + '</span>';
    };
    var $_2zg8yxt8jk26xmyk = { wrapCharWithSpan: wrapCharWithSpan };

    var isMatch = function isMatch(n) {
      return $_8kkttzt6jk26xmyh.isText(n) && $_8kkttzt6jk26xmyh.value(n) !== undefined && $_ad6e6isyjk26xmxc.regExp.test($_8kkttzt6jk26xmyh.value(n));
    };
    var filterDescendants = function filterDescendants(scope, predicate) {
      var result = [];
      var dom = scope.dom();
      var children = map(dom.childNodes, Element$$1.fromDom);
      each(children, function (x) {
        if (predicate(x)) {
          result = result.concat([x]);
        }
        result = result.concat(filterDescendants(x, predicate));
      });
      return result;
    };
    var findParentElm = function findParentElm(elm, rootElm) {
      while (elm.parentNode) {
        if (elm.parentNode === rootElm) {
          return elm;
        }
        elm = elm.parentNode;
      }
    };
    var replaceWithSpans = function replaceWithSpans(html) {
      return html.replace($_ad6e6isyjk26xmxc.regExpGlobal, $_2zg8yxt8jk26xmyk.wrapCharWithSpan);
    };
    var $_40cen8szjk26xmxe = {
      isMatch: isMatch,
      filterDescendants: filterDescendants,
      findParentElm: findParentElm,
      replaceWithSpans: replaceWithSpans
    };

    var show = function show(editor, rootElm) {
      var node, div;
      var nodeList = $_40cen8szjk26xmxe.filterDescendants(Element$$1.fromDom(rootElm), $_40cen8szjk26xmxe.isMatch);
      each(nodeList, function (n) {
        var withSpans = $_40cen8szjk26xmxe.replaceWithSpans($_8kkttzt6jk26xmyh.value(n));
        div = editor.dom.create('div', null, withSpans);
        while (node = div.lastChild) {
          editor.dom.insertAfter(node, n.dom());
        }
        editor.dom.remove(n.dom());
      });
    };
    var hide = function hide(editor, body) {
      var nodeList = editor.dom.select($_ad6e6isyjk26xmxc.selector, body);
      each(nodeList, function (node) {
        editor.dom.remove(node, 1);
      });
    };
    var toggle = function toggle(editor) {
      var body = editor.getBody();
      var bookmark = editor.selection.getBookmark();
      var parentNode = $_40cen8szjk26xmxe.findParentElm(editor.selection.getNode(), body);
      parentNode = parentNode !== undefined ? parentNode : body;
      hide(editor, parentNode);
      show(editor, parentNode);
      editor.selection.moveToBookmark(bookmark);
    };
    var $_aqrlrtsxjk26xmx5 = {
      show: show,
      hide: hide,
      toggle: toggle
    };

    var toggleVisualChars = function toggleVisualChars(editor, toggleState) {
      var body = editor.getBody();
      var selection = editor.selection;
      var bookmark;
      toggleState.set(!toggleState.get());
      $_9jbxa1swjk26xmx5.fireVisualChars(editor, toggleState.get());
      bookmark = selection.getBookmark();
      if (toggleState.get() === true) {
        $_aqrlrtsxjk26xmx5.show(editor, body);
      } else {
        $_aqrlrtsxjk26xmx5.hide(editor, body);
      }
      selection.moveToBookmark(bookmark);
    };
    var $_6oxd2zsvjk26xmx4 = { toggleVisualChars: toggleVisualChars };

    var register = function register(editor, toggleState) {
      editor.addCommand('mceVisualChars', function () {
        $_6oxd2zsvjk26xmx4.toggleVisualChars(editor, toggleState);
      });
    };
    var $_8d8ofpsujk26xmx3 = { register: register };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var setup = function setup(editor, toggleState) {
      var debouncedToggle = global$1.debounce(function () {
        $_aqrlrtsxjk26xmx5.toggle(editor);
      }, 300);
      if (editor.settings.forced_root_block !== false) {
        editor.on('keydown', function (e) {
          if (toggleState.get() === true) {
            e.keyCode === 13 ? $_aqrlrtsxjk26xmx5.toggle(editor) : debouncedToggle();
          }
        });
      }
    };
    var $_32vi77t9jk26xmyt = { setup: setup };

    var toggleActiveState = function toggleActiveState(editor) {
      return function (e) {
        var ctrl = e.control;
        editor.on('VisualChars', function (e) {
          ctrl.active(e.state);
        });
      };
    };
    var register$1 = function register$1(editor) {
      editor.addButton('visualchars', {
        active: false,
        title: 'Show invisible characters',
        cmd: 'mceVisualChars',
        onPostRender: toggleActiveState(editor)
      });
      editor.addMenuItem('visualchars', {
        text: 'Show invisible characters',
        cmd: 'mceVisualChars',
        onPostRender: toggleActiveState(editor),
        selectable: true,
        context: 'view',
        prependToContext: true
      });
    };

    global.add('visualchars', function (editor) {
      var toggleState = Cell(false);
      $_8d8ofpsujk26xmx3.register(editor, toggleState);
      register$1(editor);
      $_32vi77t9jk26xmyt.setup(editor, toggleState);
      return $_9gvd73stjk26xmx2.get(toggleState);
    });
    function Plugin() {}

    return Plugin;
  }();
})();

/***/ }),
/* 1039 */
/*!***********************************************************!*\
  !*** ./src/packages/tinymce/skins/lightgray/skin.min.css ***!
  \***********************************************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7670660b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/vue-tinymce-editor/src/components/TinymceVue.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1041 */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225f273e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseWysiwyg.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-wysiwyg",class:_vm.className},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('tinymce',_vm._g({attrs:{"id":String(_vm.id),"other_options":_vm.options},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}},_vm.listeners)),_vm._v(" "),(_vm.hint)?_c('TypographyInputHint',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.meta)?_c('TypographyMeta',{domProps:{"innerHTML":_vm._s(_vm.meta)}}):_vm._e(),_vm._v(" "),(_vm.hasErrors)?_c('TypographyInputError',[_vm._v(_vm._s(_vm.errors.first(_vm.$attrs.name)))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/*!********************************************!*\
  !*** ./src/components/typography/index.js ***!
  \********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




// https://webpack.js.org/guides/dependency-management/#require-context
var requireComponent = __webpack_require__(/*! . */ 1043);

requireComponent.keys().forEach(function (fileName) {
  // Get component config
  var componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  var componentName = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["upperFirst"])(Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["camelCase"])(
  // Strip the leading `'./` and extension from the filename
  fileName.replace(/^\.\/(.*)\.\w+$/, '$1')));

  // Register component globally
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component(componentName,
  // Look for the component options on `.default`, which will
  // exist if the component was exported with `export default`,
  // otherwise fall back to module's root.
  componentConfig.default || componentConfig);
});

/***/ }),
/* 1043 */
/*!***************************************************************************!*\
  !*** ./src/components/typography nonrecursive Typography[A-Z]\w+\.(vue)$ ***!
  \***************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./TypographyInputError.vue": 1044,
	"./TypographyInputHint.vue": 1047,
	"./TypographyMeta.vue": 1050
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1043;

/***/ }),
/* 1044 */
/*!************************************************************!*\
  !*** ./src/components/typography/TypographyInputError.vue ***!
  \************************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyInputError_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TypographyInputError.vue */ 367);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780617d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyInputError_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-780617d0","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TypographyInputError.vue */ 1046);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-780617d0","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TypographyInputError.vue */ 1045)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyInputError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780617d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyInputError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1045 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-780617d0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/typography/TypographyInputError.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780617d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typography/TypographyInputError.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"TypographyInputError",attrs:{"id":_vm.id}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1047 */
/*!***********************************************************!*\
  !*** ./src/components/typography/TypographyInputHint.vue ***!
  \***********************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyInputHint_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TypographyInputHint.vue */ 368);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d20e2f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyInputHint_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-49d20e2f","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TypographyInputHint.vue */ 1049);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-49d20e2f","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TypographyInputHint.vue */ 1048)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyInputHint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d20e2f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyInputHint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1048 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49d20e2f","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/typography/TypographyInputHint.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d20e2f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typography/TypographyInputHint.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"TypographyInputHint",class:_vm.className,attrs:{"id":_vm.id}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1050 */
/*!******************************************************!*\
  !*** ./src/components/typography/TypographyMeta.vue ***!
  \******************************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyMeta_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/dominikbarcikowski/orca/workspaces/air-fields-shopify-frontend/charybdis/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TypographyMeta.vue */ 369);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7c03c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyMeta_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8c7c03c8","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TypographyMeta.vue */ 1052);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8c7c03c8","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TypographyMeta.vue */ 1051)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_dominikbarcikowski_orca_workspaces_air_fields_shopify_frontend_charybdis_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TypographyMeta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7c03c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypographyMeta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1051 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c7c03c8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/typography/TypographyMeta.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c7c03c8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typography/TypographyMeta.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"TypographyMeta"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[370]);


// WEBPACK FOOTER //
// assets/client.1bf8d30783aebeab9ea1.js